var _asyncToGenerator = require("/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _regeneratorRuntime = require("/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/regenerator");

var _inherits = require("/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf2 = require("/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _toArray = require("/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/toArray");

var _taggedTemplateLiteral = require("/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _classCallCheck = require("/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass2 = require("/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/createClass");

var _toConsumableArray = require("/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/toConsumableArray");

var _slicedToArray = require("/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/slicedToArray");

var _defineProperty = require("/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/defineProperty");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray2(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e35) { throw _e35; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e36) { didErr = true; err = _e36; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray2(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray2(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray2(o, minLen); }

function _arrayLikeToArray2(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct2(); return function _createSuperInternal() { var Super = _getPrototypeOf2(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf2(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct2() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

require("core-js/modules/esnext.global-this.js");

require("core-js/modules/es.array.flat-map.js");

require("core-js/modules/es.array.unscopables.flat-map.js");

require("core-js/modules/es.string.trim-end.js");

require("core-js/modules/es.string.trim-start.js");

(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('react'), require('react/jsx-runtime'), require('react-dom')) : typeof define === 'function' && define.amd ? define(['exports', 'react', 'react/jsx-runtime', 'react-dom'], factory) : (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global["@tf/design-system-react"] = {}, global.React, global.jsxRuntime, global.ReactDOM));
})(this, function (exports, React, jsxRuntime$1, ReactDOM) {
  'use strict';

  var _styled$;

  function _interopDefaultLegacy(e) {
    return e && typeof e === 'object' && 'default' in e ? e : {
      'default': e
    };
  }

  function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);

    if (e) {
      Object.keys(e).forEach(function (k) {
        if (k !== 'default') {
          var d = Object.getOwnPropertyDescriptor(e, k);
          Object.defineProperty(n, k, d.get ? d : {
            enumerable: true,
            get: function get() {
              return e[k];
            }
          });
        }
      });
    }

    n["default"] = e;
    return Object.freeze(n);
  }

  var React__namespace = /*#__PURE__*/_interopNamespace(React);

  var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

  var ReactDOM__namespace = /*#__PURE__*/_interopNamespace(ReactDOM);

  var ReactDOM__default = /*#__PURE__*/_interopDefaultLegacy(ReactDOM);
  /*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
    Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** */


  var _assign2 = function __assign() {
    _assign2 = Object.assign || function __assign(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];

        for (var p in s) {
          if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
      }

      return t;
    };

    return _assign2.apply(this, arguments);
  };

  function __rest$1(s, e) {
    var t = {};

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }

    if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
  }

  function _objectWithoutPropertiesLoose$6(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }

  function _extends$c() {
    _extends$c = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends$c.apply(this, arguments);
  }

  var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

  function getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
  }

  function getAugmentedNamespace(n) {
    if (n.__esModule) return n;
    var a = Object.defineProperty({}, '__esModule', {
      value: true
    });
    Object.keys(n).forEach(function (k) {
      var d = Object.getOwnPropertyDescriptor(n, k);
      Object.defineProperty(a, k, d.get ? d : {
        enumerable: true,
        get: function get() {
          return n[k];
        }
      });
    });
    return a;
  }

  var propTypes = {
    exports: {}
  };
  var reactIs$3 = {
    exports: {}
  };
  var reactIs_production_min$2 = {};
  /** @license React v16.13.1
   * react-is.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  var b$2 = "function" === typeof Symbol && Symbol.for,
      c$2 = b$2 ? Symbol.for("react.element") : 60103,
      d$2 = b$2 ? Symbol.for("react.portal") : 60106,
      e$2 = b$2 ? Symbol.for("react.fragment") : 60107,
      f$3 = b$2 ? Symbol.for("react.strict_mode") : 60108,
      g$3 = b$2 ? Symbol.for("react.profiler") : 60114,
      h$3 = b$2 ? Symbol.for("react.provider") : 60109,
      k$2 = b$2 ? Symbol.for("react.context") : 60110,
      l$3 = b$2 ? Symbol.for("react.async_mode") : 60111,
      m$3 = b$2 ? Symbol.for("react.concurrent_mode") : 60111,
      n$4 = b$2 ? Symbol.for("react.forward_ref") : 60112,
      p$4 = b$2 ? Symbol.for("react.suspense") : 60113,
      q$5 = b$2 ? Symbol.for("react.suspense_list") : 60120,
      r$4 = b$2 ? Symbol.for("react.memo") : 60115,
      t$3 = b$2 ? Symbol.for("react.lazy") : 60116,
      v$3 = b$2 ? Symbol.for("react.block") : 60121,
      w$3 = b$2 ? Symbol.for("react.fundamental") : 60117,
      x$3 = b$2 ? Symbol.for("react.responder") : 60118,
      y$3 = b$2 ? Symbol.for("react.scope") : 60119;

  function z$4(a) {
    if ("object" === typeof a && null !== a) {
      var u = a.$$typeof;

      switch (u) {
        case c$2:
          switch (a = a.type, a) {
            case l$3:
            case m$3:
            case e$2:
            case g$3:
            case f$3:
            case p$4:
              return a;

            default:
              switch (a = a && a.$$typeof, a) {
                case k$2:
                case n$4:
                case t$3:
                case r$4:
                case h$3:
                  return a;

                default:
                  return u;
              }

          }

        case d$2:
          return u;
      }
    }
  }

  function A$4(a) {
    return z$4(a) === m$3;
  }

  reactIs_production_min$2.AsyncMode = l$3;
  reactIs_production_min$2.ConcurrentMode = m$3;
  reactIs_production_min$2.ContextConsumer = k$2;
  reactIs_production_min$2.ContextProvider = h$3;
  reactIs_production_min$2.Element = c$2;
  reactIs_production_min$2.ForwardRef = n$4;
  reactIs_production_min$2.Fragment = e$2;
  reactIs_production_min$2.Lazy = t$3;
  reactIs_production_min$2.Memo = r$4;
  reactIs_production_min$2.Portal = d$2;
  reactIs_production_min$2.Profiler = g$3;
  reactIs_production_min$2.StrictMode = f$3;
  reactIs_production_min$2.Suspense = p$4;

  reactIs_production_min$2.isAsyncMode = function (a) {
    return A$4(a) || z$4(a) === l$3;
  };

  reactIs_production_min$2.isConcurrentMode = A$4;

  reactIs_production_min$2.isContextConsumer = function (a) {
    return z$4(a) === k$2;
  };

  reactIs_production_min$2.isContextProvider = function (a) {
    return z$4(a) === h$3;
  };

  reactIs_production_min$2.isElement = function (a) {
    return "object" === typeof a && null !== a && a.$$typeof === c$2;
  };

  reactIs_production_min$2.isForwardRef = function (a) {
    return z$4(a) === n$4;
  };

  reactIs_production_min$2.isFragment = function (a) {
    return z$4(a) === e$2;
  };

  reactIs_production_min$2.isLazy = function (a) {
    return z$4(a) === t$3;
  };

  reactIs_production_min$2.isMemo = function (a) {
    return z$4(a) === r$4;
  };

  reactIs_production_min$2.isPortal = function (a) {
    return z$4(a) === d$2;
  };

  reactIs_production_min$2.isProfiler = function (a) {
    return z$4(a) === g$3;
  };

  reactIs_production_min$2.isStrictMode = function (a) {
    return z$4(a) === f$3;
  };

  reactIs_production_min$2.isSuspense = function (a) {
    return z$4(a) === p$4;
  };

  reactIs_production_min$2.isValidElementType = function (a) {
    return "string" === typeof a || "function" === typeof a || a === e$2 || a === m$3 || a === g$3 || a === f$3 || a === p$4 || a === q$5 || "object" === typeof a && null !== a && (a.$$typeof === t$3 || a.$$typeof === r$4 || a.$$typeof === h$3 || a.$$typeof === k$2 || a.$$typeof === n$4 || a.$$typeof === w$3 || a.$$typeof === x$3 || a.$$typeof === y$3 || a.$$typeof === v$3);
  };

  reactIs_production_min$2.typeOf = z$4;
  var reactIs_development$2 = {};
  /** @license React v16.13.1
   * react-is.development.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  if (process.env.NODE_ENV !== "production") {
    (function () {
      // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
      // nor polyfill, then a plain number is used for performance.
      var hasSymbol = typeof Symbol === 'function' && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
      // (unstable) APIs that have been removed. Can we remove the symbols?

      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

      function isValidElementType(type) {
        return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
      }

      function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
          var $$typeof = object.$$typeof;

          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;

              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;

                default:
                  var $$typeofType = type && type.$$typeof;

                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;

                    default:
                      return $$typeof;
                  }

              }

            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }

        return undefined;
      } // AsyncMode is deprecated along with isAsyncMode


      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

            console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
          }
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }

      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }

      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }

      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }

      function isElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }

      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }

      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }

      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }

      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }

      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }

      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }

      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }

      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }

      reactIs_development$2.AsyncMode = AsyncMode;
      reactIs_development$2.ConcurrentMode = ConcurrentMode;
      reactIs_development$2.ContextConsumer = ContextConsumer;
      reactIs_development$2.ContextProvider = ContextProvider;
      reactIs_development$2.Element = Element;
      reactIs_development$2.ForwardRef = ForwardRef;
      reactIs_development$2.Fragment = Fragment;
      reactIs_development$2.Lazy = Lazy;
      reactIs_development$2.Memo = Memo;
      reactIs_development$2.Portal = Portal;
      reactIs_development$2.Profiler = Profiler;
      reactIs_development$2.StrictMode = StrictMode;
      reactIs_development$2.Suspense = Suspense;
      reactIs_development$2.isAsyncMode = isAsyncMode;
      reactIs_development$2.isConcurrentMode = isConcurrentMode;
      reactIs_development$2.isContextConsumer = isContextConsumer;
      reactIs_development$2.isContextProvider = isContextProvider;
      reactIs_development$2.isElement = isElement;
      reactIs_development$2.isForwardRef = isForwardRef;
      reactIs_development$2.isFragment = isFragment;
      reactIs_development$2.isLazy = isLazy;
      reactIs_development$2.isMemo = isMemo;
      reactIs_development$2.isPortal = isPortal;
      reactIs_development$2.isProfiler = isProfiler;
      reactIs_development$2.isStrictMode = isStrictMode;
      reactIs_development$2.isSuspense = isSuspense;
      reactIs_development$2.isValidElementType = isValidElementType;
      reactIs_development$2.typeOf = typeOf;
    })();
  }

  if (process.env.NODE_ENV === 'production') {
    reactIs$3.exports = reactIs_production_min$2;
  } else {
    reactIs$3.exports = reactIs_development$2;
  }
  /*
  object-assign
  (c) Sindre Sorhus
  @license MIT
  */

  /* eslint-disable no-unused-vars */


  var getOwnPropertySymbols = Object.getOwnPropertySymbols;
  var hasOwnProperty$e = Object.prototype.hasOwnProperty;
  var propIsEnumerable = Object.prototype.propertyIsEnumerable;

  function toObject(val) {
    if (val === null || val === undefined) {
      throw new TypeError('Object.assign cannot be called with null or undefined');
    }

    return Object(val);
  }

  function shouldUseNative() {
    try {
      if (!Object.assign) {
        return false;
      } // Detect buggy property enumeration order in older V8 versions.
      // https://bugs.chromium.org/p/v8/issues/detail?id=4118


      var test1 = new String('abc'); // eslint-disable-line no-new-wrappers

      test1[5] = 'de';

      if (Object.getOwnPropertyNames(test1)[0] === '5') {
        return false;
      } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


      var test2 = {};

      for (var i = 0; i < 10; i++) {
        test2['_' + String.fromCharCode(i)] = i;
      }

      var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
        return test2[n];
      });

      if (order2.join('') !== '0123456789') {
        return false;
      } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


      var test3 = {};
      'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
        test3[letter] = letter;
      });

      if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
        return false;
      }

      return true;
    } catch (err) {
      // We don't expect any of the above to throw, but better to be safe.
      return false;
    }
  }

  var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
    var from;
    var to = toObject(target);
    var symbols;

    for (var s = 1; s < arguments.length; s++) {
      from = Object(arguments[s]);

      for (var key in from) {
        if (hasOwnProperty$e.call(from, key)) {
          to[key] = from[key];
        }
      }

      if (getOwnPropertySymbols) {
        symbols = getOwnPropertySymbols(from);

        for (var i = 0; i < symbols.length; i++) {
          if (propIsEnumerable.call(from, symbols[i])) {
            to[symbols[i]] = from[symbols[i]];
          }
        }
      }
    }

    return to;
  };
  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  var ReactPropTypesSecret$3 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
  var ReactPropTypesSecret_1 = ReactPropTypesSecret$3;
  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  var printWarning$1 = function printWarning$1() {};

  if (process.env.NODE_ENV !== 'production') {
    var ReactPropTypesSecret$2 = ReactPropTypesSecret_1;
    var loggedTypeFailures = {};
    var has$2 = Function.call.bind(Object.prototype.hasOwnProperty);

    printWarning$1 = function printWarning$1(text) {
      var message = 'Warning: ' + text;

      if (typeof console !== 'undefined') {
        console.error(message);
      }

      try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (x) {}
    };
  }
  /**
   * Assert that the values match with the type specs.
   * Error messages are memorized and will only be shown once.
   *
   * @param {object} typeSpecs Map of name to a ReactPropType
   * @param {object} values Runtime values that need to be type-checked
   * @param {string} location e.g. "prop", "context", "child context"
   * @param {string} componentName Name of the component for error messages.
   * @param {?Function} getStack Returns the component stack.
   * @private
   */


  function checkPropTypes$1(typeSpecs, values, location, componentName, getStack) {
    if (process.env.NODE_ENV !== 'production') {
      for (var typeSpecName in typeSpecs) {
        if (has$2(typeSpecs, typeSpecName)) {
          var error; // Prop type validation may throw. In case they do, we don't want to
          // fail the render phase where it didn't fail before. So we log it.
          // After these have been cleaned up, we'll let them throw.

          try {
            // This is intentionally an invariant that gets caught. It's the same
            // behavior as without this statement except with a better message.
            if (typeof typeSpecs[typeSpecName] !== 'function') {
              var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.');
              err.name = 'Invariant Violation';
              throw err;
            }

            error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$2);
          } catch (ex) {
            error = ex;
          }

          if (error && !(error instanceof Error)) {
            printWarning$1((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
          }

          if (error instanceof Error && !(error.message in loggedTypeFailures)) {
            // Only monitor this failure once because there tends to be a lot of the
            // same error.
            loggedTypeFailures[error.message] = true;
            var stack = getStack ? getStack() : '';
            printWarning$1('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
          }
        }
      }
    }
  }
  /**
   * Resets warning cache when testing.
   *
   * @private
   */


  checkPropTypes$1.resetWarningCache = function () {
    if (process.env.NODE_ENV !== 'production') {
      loggedTypeFailures = {};
    }
  };

  var checkPropTypes_1 = checkPropTypes$1;
  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  var ReactIs$1 = reactIs$3.exports;
  var assign$1 = objectAssign;
  var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
  var checkPropTypes = checkPropTypes_1;
  var has$1 = Function.call.bind(Object.prototype.hasOwnProperty);

  var printWarning = function printWarning() {};

  if (process.env.NODE_ENV !== 'production') {
    printWarning = function printWarning(text) {
      var message = 'Warning: ' + text;

      if (typeof console !== 'undefined') {
        console.error(message);
      }

      try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (x) {}
    };
  }

  function emptyFunctionThatReturnsNull() {
    return null;
  }

  var factoryWithTypeCheckers = function factoryWithTypeCheckers(isValidElement, throwOnDirectAccess) {
    /* global Symbol */
    var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

    /**
     * Returns the iterator method function contained on the iterable object.
     *
     * Be sure to invoke the function with the iterable as context:
     *
     *     var iteratorFn = getIteratorFn(myIterable);
     *     if (iteratorFn) {
     *       var iterator = iteratorFn.call(myIterable);
     *       ...
     *     }
     *
     * @param {?object} maybeIterable
     * @return {?function}
     */

    function getIteratorFn(maybeIterable) {
      var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);

      if (typeof iteratorFn === 'function') {
        return iteratorFn;
      }
    }
    /**
     * Collection of methods that allow declaration and validation of props that are
     * supplied to React components. Example usage:
     *
     *   var Props = require('ReactPropTypes');
     *   var MyArticle = React.createClass({
     *     propTypes: {
     *       // An optional string prop named "description".
     *       description: Props.string,
     *
     *       // A required enum prop named "category".
     *       category: Props.oneOf(['News','Photos']).isRequired,
     *
     *       // A prop named "dialog" that requires an instance of Dialog.
     *       dialog: Props.instanceOf(Dialog).isRequired
     *     },
     *     render: function() { ... }
     *   });
     *
     * A more formal specification of how these methods are used:
     *
     *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
     *   decl := ReactPropTypes.{type}(.isRequired)?
     *
     * Each and every declaration produces a function with the same signature. This
     * allows the creation of custom validation functions. For example:
     *
     *  var MyLink = React.createClass({
     *    propTypes: {
     *      // An optional string or URI prop named "href".
     *      href: function(props, propName, componentName) {
     *        var propValue = props[propName];
     *        if (propValue != null && typeof propValue !== 'string' &&
     *            !(propValue instanceof URI)) {
     *          return new Error(
     *            'Expected a string or an URI for ' + propName + ' in ' +
     *            componentName
     *          );
     *        }
     *      }
     *    },
     *    render: function() {...}
     *  });
     *
     * @internal
     */


    var ANONYMOUS = '<<anonymous>>'; // Important!
    // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.

    var ReactPropTypes = {
      array: createPrimitiveTypeChecker('array'),
      bool: createPrimitiveTypeChecker('boolean'),
      func: createPrimitiveTypeChecker('function'),
      number: createPrimitiveTypeChecker('number'),
      object: createPrimitiveTypeChecker('object'),
      string: createPrimitiveTypeChecker('string'),
      symbol: createPrimitiveTypeChecker('symbol'),
      any: createAnyTypeChecker(),
      arrayOf: createArrayOfTypeChecker,
      element: createElementTypeChecker(),
      elementType: createElementTypeTypeChecker(),
      instanceOf: createInstanceTypeChecker,
      node: createNodeChecker(),
      objectOf: createObjectOfTypeChecker,
      oneOf: createEnumTypeChecker,
      oneOfType: createUnionTypeChecker,
      shape: createShapeTypeChecker,
      exact: createStrictShapeTypeChecker
    };
    /**
     * inlined Object.is polyfill to avoid requiring consumers ship their own
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
     */

    /*eslint-disable no-self-compare*/

    function is(x, y) {
      // SameValue algorithm
      if (x === y) {
        // Steps 1-5, 7-10
        // Steps 6.b-6.e: +0 != -0
        return x !== 0 || 1 / x === 1 / y;
      } else {
        // Step 6.a: NaN == NaN
        return x !== x && y !== y;
      }
    }
    /*eslint-enable no-self-compare*/

    /**
     * We use an Error-like object for backward compatibility as people may call
     * PropTypes directly and inspect their output. However, we don't use real
     * Errors anymore. We don't inspect their stack anyway, and creating them
     * is prohibitively expensive if they are created too often, such as what
     * happens in oneOfType() for any type before the one that matched.
     */


    function PropTypeError(message) {
      this.message = message;
      this.stack = '';
    } // Make `instanceof Error` still work for returned errors.


    PropTypeError.prototype = Error.prototype;

    function createChainableTypeChecker(validate) {
      if (process.env.NODE_ENV !== 'production') {
        var manualPropTypeCallCache = {};
        var manualPropTypeWarningCount = 0;
      }

      function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
        componentName = componentName || ANONYMOUS;
        propFullName = propFullName || propName;

        if (secret !== ReactPropTypesSecret$1) {
          if (throwOnDirectAccess) {
            // New behavior only for users of `prop-types` package
            var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
            err.name = 'Invariant Violation';
            throw err;
          } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
            // Old behavior for people using React.PropTypes
            var cacheKey = componentName + ':' + propName;

            if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3) {
              printWarning('You are manually calling a React.PropTypes validation ' + 'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
              manualPropTypeCallCache[cacheKey] = true;
              manualPropTypeWarningCount++;
            }
          }
        }

        if (props[propName] == null) {
          if (isRequired) {
            if (props[propName] === null) {
              return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
            }

            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
          }

          return null;
        } else {
          return validate(props, propName, componentName, location, propFullName);
        }
      }

      var chainedCheckType = checkType.bind(null, false);
      chainedCheckType.isRequired = checkType.bind(null, true);
      return chainedCheckType;
    }

    function createPrimitiveTypeChecker(expectedType) {
      function validate(props, propName, componentName, location, propFullName, secret) {
        var propValue = props[propName];
        var propType = getPropType(propValue);

        if (propType !== expectedType) {
          // `propValue` being instance of, say, date/regexp, pass the 'object'
          // check, but we can offer a more precise error message here rather than
          // 'of type `object`'.
          var preciseType = getPreciseType(propValue);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
        }

        return null;
      }

      return createChainableTypeChecker(validate);
    }

    function createAnyTypeChecker() {
      return createChainableTypeChecker(emptyFunctionThatReturnsNull);
    }

    function createArrayOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== 'function') {
          return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
        }

        var propValue = props[propName];

        if (!Array.isArray(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
        }

        for (var i = 0; i < propValue.length; i++) {
          var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret$1);

          if (error instanceof Error) {
            return error;
          }
        }

        return null;
      }

      return createChainableTypeChecker(validate);
    }

    function createElementTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];

        if (!isValidElement(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
        }

        return null;
      }

      return createChainableTypeChecker(validate);
    }

    function createElementTypeTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];

        if (!ReactIs$1.isValidElementType(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
        }

        return null;
      }

      return createChainableTypeChecker(validate);
    }

    function createInstanceTypeChecker(expectedClass) {
      function validate(props, propName, componentName, location, propFullName) {
        if (!(props[propName] instanceof expectedClass)) {
          var expectedClassName = expectedClass.name || ANONYMOUS;
          var actualClassName = getClassName(props[propName]);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
        }

        return null;
      }

      return createChainableTypeChecker(validate);
    }

    function createEnumTypeChecker(expectedValues) {
      if (!Array.isArray(expectedValues)) {
        if (process.env.NODE_ENV !== 'production') {
          if (arguments.length > 1) {
            printWarning('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
          } else {
            printWarning('Invalid argument supplied to oneOf, expected an array.');
          }
        }

        return emptyFunctionThatReturnsNull;
      }

      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];

        for (var i = 0; i < expectedValues.length; i++) {
          if (is(propValue, expectedValues[i])) {
            return null;
          }
        }

        var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
          var type = getPreciseType(value);

          if (type === 'symbol') {
            return String(value);
          }

          return value;
        });
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
      }

      return createChainableTypeChecker(validate);
    }

    function createObjectOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== 'function') {
          return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
        }

        var propValue = props[propName];
        var propType = getPropType(propValue);

        if (propType !== 'object') {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
        }

        for (var key in propValue) {
          if (has$1(propValue, key)) {
            var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);

            if (error instanceof Error) {
              return error;
            }
          }
        }

        return null;
      }

      return createChainableTypeChecker(validate);
    }

    function createUnionTypeChecker(arrayOfTypeCheckers) {
      if (!Array.isArray(arrayOfTypeCheckers)) {
        process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
        return emptyFunctionThatReturnsNull;
      }

      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];

        if (typeof checker !== 'function') {
          printWarning('Invalid argument supplied to oneOfType. Expected an array of check functions, but ' + 'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
          return emptyFunctionThatReturnsNull;
        }
      }

      function validate(props, propName, componentName, location, propFullName) {
        for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
          var checker = arrayOfTypeCheckers[i];

          if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret$1) == null) {
            return null;
          }
        }

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
      }

      return createChainableTypeChecker(validate);
    }

    function createNodeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        if (!isNode(props[propName])) {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
        }

        return null;
      }

      return createChainableTypeChecker(validate);
    }

    function createShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);

        if (propType !== 'object') {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
        }

        for (var key in shapeTypes) {
          var checker = shapeTypes[key];

          if (!checker) {
            continue;
          }

          var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);

          if (error) {
            return error;
          }
        }

        return null;
      }

      return createChainableTypeChecker(validate);
    }

    function createStrictShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);

        if (propType !== 'object') {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
        } // We need to check all keys in case some are required but missing from
        // props.


        var allKeys = assign$1({}, props[propName], shapeTypes);

        for (var key in allKeys) {
          var checker = shapeTypes[key];

          if (!checker) {
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
          }

          var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);

          if (error) {
            return error;
          }
        }

        return null;
      }

      return createChainableTypeChecker(validate);
    }

    function isNode(propValue) {
      switch (typeof propValue) {
        case 'number':
        case 'string':
        case 'undefined':
          return true;

        case 'boolean':
          return !propValue;

        case 'object':
          if (Array.isArray(propValue)) {
            return propValue.every(isNode);
          }

          if (propValue === null || isValidElement(propValue)) {
            return true;
          }

          var iteratorFn = getIteratorFn(propValue);

          if (iteratorFn) {
            var iterator = iteratorFn.call(propValue);
            var step;

            if (iteratorFn !== propValue.entries) {
              while (!(step = iterator.next()).done) {
                if (!isNode(step.value)) {
                  return false;
                }
              }
            } else {
              // Iterator will provide entry [k,v] tuples rather than values.
              while (!(step = iterator.next()).done) {
                var entry = step.value;

                if (entry) {
                  if (!isNode(entry[1])) {
                    return false;
                  }
                }
              }
            }
          } else {
            return false;
          }

          return true;

        default:
          return false;
      }
    }

    function isSymbol(propType, propValue) {
      // Native Symbol.
      if (propType === 'symbol') {
        return true;
      } // falsy value can't be a Symbol


      if (!propValue) {
        return false;
      } // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'


      if (propValue['@@toStringTag'] === 'Symbol') {
        return true;
      } // Fallback for non-spec compliant Symbols which are polyfilled.


      if (typeof Symbol === 'function' && propValue instanceof Symbol) {
        return true;
      }

      return false;
    } // Equivalent of `typeof` but with special handling for array and regexp.


    function getPropType(propValue) {
      var propType = typeof propValue;

      if (Array.isArray(propValue)) {
        return 'array';
      }

      if (propValue instanceof RegExp) {
        // Old webkits (at least until Android 4.0) return 'function' rather than
        // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
        // passes PropTypes.object.
        return 'object';
      }

      if (isSymbol(propType, propValue)) {
        return 'symbol';
      }

      return propType;
    } // This handles more types than `getPropType`. Only used for error messages.
    // See `createPrimitiveTypeChecker`.


    function getPreciseType(propValue) {
      if (typeof propValue === 'undefined' || propValue === null) {
        return '' + propValue;
      }

      var propType = getPropType(propValue);

      if (propType === 'object') {
        if (propValue instanceof Date) {
          return 'date';
        } else if (propValue instanceof RegExp) {
          return 'regexp';
        }
      }

      return propType;
    } // Returns a string that is postfixed to a warning about an invalid type.
    // For example, "undefined" or "of type array"


    function getPostfixForTypeWarning(value) {
      var type = getPreciseType(value);

      switch (type) {
        case 'array':
        case 'object':
          return 'an ' + type;

        case 'boolean':
        case 'date':
        case 'regexp':
          return 'a ' + type;

        default:
          return type;
      }
    } // Returns class name of the object, if any.


    function getClassName(propValue) {
      if (!propValue.constructor || !propValue.constructor.name) {
        return ANONYMOUS;
      }

      return propValue.constructor.name;
    }

    ReactPropTypes.checkPropTypes = checkPropTypes;
    ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */


  var ReactPropTypesSecret = ReactPropTypesSecret_1;

  function emptyFunction() {}

  function emptyFunctionWithReset() {}

  emptyFunctionWithReset.resetWarningCache = emptyFunction;

  var factoryWithThrowingShims = function factoryWithThrowingShims() {
    function shim(props, propName, componentName, location, propFullName, secret) {
      if (secret === ReactPropTypesSecret) {
        // It is still safe when called from React.
        return;
      }

      var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
      err.name = 'Invariant Violation';
      throw err;
    }

    shim.isRequired = shim;

    function getShim() {
      return shim;
    } // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.


    var ReactPropTypes = {
      array: shim,
      bool: shim,
      func: shim,
      number: shim,
      object: shim,
      string: shim,
      symbol: shim,
      any: shim,
      arrayOf: getShim,
      element: shim,
      elementType: shim,
      instanceOf: getShim,
      node: shim,
      objectOf: getShim,
      oneOf: getShim,
      oneOfType: getShim,
      shape: getShim,
      exact: getShim,
      checkPropTypes: emptyFunctionWithReset,
      resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */


  if (process.env.NODE_ENV !== 'production') {
    var ReactIs = reactIs$3.exports; // By explicitly using `prop-types` you are opting into new development behavior.
    // http://fb.me/prop-types-in-prod

    var throwOnDirectAccess = true;
    propTypes.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
  } else {
    // By explicitly using `prop-types` you are opting into new production behavior.
    // http://fb.me/prop-types-in-prod
    propTypes.exports = factoryWithThrowingShims();
  }

  var PropTypes = propTypes.exports;

  function toVal(mix) {
    var k,
        y,
        str = '';

    if (typeof mix === 'string' || typeof mix === 'number') {
      str += mix;
    } else if (typeof mix === 'object') {
      if (Array.isArray(mix)) {
        for (k = 0; k < mix.length; k++) {
          if (mix[k]) {
            if (y = toVal(mix[k])) {
              str && (str += ' ');
              str += y;
            }
          }
        }
      } else {
        for (k in mix) {
          if (mix[k]) {
            str && (str += ' ');
            str += k;
          }
        }
      }
    }

    return str;
  }

  function clsx() {
    var i = 0,
        tmp,
        x,
        str = '';

    while (i < arguments.length) {
      if (tmp = arguments[i++]) {
        if (x = toVal(tmp)) {
          str && (str += ' ');
          str += x;
        }
      }
    }

    return str;
  }

  function _extends$b() {
    _extends$b = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends$b.apply(this, arguments);
  }
  /**
   * Determines if a given element is a DOM element name (i.e. not a React component).
   */


  function isHostComponent(element) {
    return typeof element === 'string';
  }
  /**
   * Appends the ownerState object to the props, merging with the existing one if necessary.
   *
   * @param elementType Type of the element that owns the `existingProps`. If the element is a DOM node, `ownerState` are not applied.
   * @param existingProps Props of the element.
   * @param ownerState
   */


  function appendOwnerState(elementType) {
    var existingProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var ownerState = arguments.length > 2 ? arguments[2] : undefined;

    if (isHostComponent(elementType)) {
      return existingProps;
    }

    return _extends$b({}, existingProps, {
      ownerState: _extends$b({}, existingProps.ownerState, ownerState)
    });
  }

  function chainPropTypes(propType1, propType2) {
    if (process.env.NODE_ENV === 'production') {
      return function () {
        return null;
      };
    }

    return function validate() {
      return propType1.apply(void 0, arguments) || propType2.apply(void 0, arguments);
    };
  }

  function _extends$a() {
    _extends$a = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends$a.apply(this, arguments);
  }

  function isPlainObject(item) {
    return item !== null && typeof item === 'object' && item.constructor === Object;
  }

  function deepmerge(target, source) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
      clone: true
    };
    var output = options.clone ? _extends$a({}, target) : target;

    if (isPlainObject(target) && isPlainObject(source)) {
      Object.keys(source).forEach(function (key) {
        // Avoid prototype pollution
        if (key === '__proto__') {
          return;
        }

        if (isPlainObject(source[key]) && key in target && isPlainObject(target[key])) {
          // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
          output[key] = deepmerge(target[key], source[key], options);
        } else {
          output[key] = source[key];
        }
      });
    }

    return output;
  }

  function isClassComponent$1(elementType) {
    // elementType.prototype?.isReactComponent
    var _elementType$prototyp = elementType.prototype,
        prototype = _elementType$prototyp === void 0 ? {} : _elementType$prototyp;
    return Boolean(prototype.isReactComponent);
  }

  function acceptingRef(props, propName, componentName, location, propFullName) {
    var element = props[propName];
    var safePropName = propFullName || propName;

    if (element == null || // When server-side rendering React doesn't warn either.
    // This is not an accurate check for SSR.
    // This is only in place for emotion compat.
    // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
    typeof window === 'undefined') {
      return null;
    }

    var warningHint;
    var elementType = element.type;
    /**
     * Blacklisting instead of whitelisting
     *
     * Blacklisting will miss some components, such as React.Fragment. Those will at least
     * trigger a warning in React.
     * We can't whitelist because there is no safe way to detect React.forwardRef
     * or class components. "Safe" means there's no public API.
     *
     */

    if (typeof elementType === 'function' && !isClassComponent$1(elementType)) {
      warningHint = 'Did you accidentally use a plain function component for an element instead?';
    }

    if (warningHint !== undefined) {
      return new Error("Invalid ".concat(location, " `").concat(safePropName, "` supplied to `").concat(componentName, "`. ") + "Expected an element that can hold a ref. ".concat(warningHint, " ") + 'For more information see https://mui.com/r/caveat-with-refs-guide');
    }

    return null;
  }

  var elementAcceptingRef = chainPropTypes(PropTypes.element, acceptingRef);
  elementAcceptingRef.isRequired = chainPropTypes(PropTypes.element.isRequired, acceptingRef);
  var elementAcceptingRef$1 = elementAcceptingRef;

  function isClassComponent(elementType) {
    // elementType.prototype?.isReactComponent
    var _elementType$prototyp2 = elementType.prototype,
        prototype = _elementType$prototyp2 === void 0 ? {} : _elementType$prototyp2;
    return Boolean(prototype.isReactComponent);
  }

  function elementTypeAcceptingRef(props, propName, componentName, location, propFullName) {
    var propValue = props[propName];
    var safePropName = propFullName || propName;

    if (propValue == null || // When server-side rendering React doesn't warn either.
    // This is not an accurate check for SSR.
    // This is only in place for emotion compat.
    // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
    typeof window === 'undefined') {
      return null;
    }

    var warningHint;
    /**
     * Blacklisting instead of whitelisting
     *
     * Blacklisting will miss some components, such as React.Fragment. Those will at least
     * trigger a warning in React.
     * We can't whitelist because there is no safe way to detect React.forwardRef
     * or class components. "Safe" means there's no public API.
     *
     */

    if (typeof propValue === 'function' && !isClassComponent(propValue)) {
      warningHint = 'Did you accidentally provide a plain function component instead?';
    }

    if (warningHint !== undefined) {
      return new Error("Invalid ".concat(location, " `").concat(safePropName, "` supplied to `").concat(componentName, "`. ") + "Expected an element type that can hold a ref. ".concat(warningHint, " ") + 'For more information see https://mui.com/r/caveat-with-refs-guide');
    }

    return null;
  }

  var elementTypeAcceptingRef$1 = chainPropTypes(PropTypes.elementType, elementTypeAcceptingRef); // This module is based on https://github.com/airbnb/prop-types-exact repository.
  // However, in order to reduce the number of dependencies and to remove some extra safe checks
  // the module was forked.

  var specialProperty = "exact-prop: \u200B";

  function exactProp(propTypes) {
    if (process.env.NODE_ENV === 'production') {
      return propTypes;
    }

    return _extends$a({}, propTypes, _defineProperty({}, specialProperty, function (props) {
      var unsupportedProps = Object.keys(props).filter(function (prop) {
        return !propTypes.hasOwnProperty(prop);
      });

      if (unsupportedProps.length > 0) {
        return new Error("The following props are not supported: ".concat(unsupportedProps.map(function (prop) {
          return "`".concat(prop, "`");
        }).join(', '), ". Please remove them."));
      }

      return null;
    }));
  }
  /**
   * WARNING: Don't import this directly.
   * Use `MuiError` from `@mui/utils/macros/MuiError.macro` instead.
   * @param {number} code
   */


  function formatMuiErrorMessage(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe iff we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose

    /* eslint-disable prefer-template */
    var url = 'https://mui.com/production-error/?code=' + code;

    for (var i = 1; i < arguments.length; i += 1) {
      // rest params over-transpile for this case
      // eslint-disable-next-line prefer-rest-params
      url += '&args[]=' + encodeURIComponent(arguments[i]);
    }

    return 'Minified MUI error #' + code + '; visit ' + url + ' for the full message.';
    /* eslint-enable prefer-template */
  }

  var reactIs$2 = {
    exports: {}
  };
  var reactIs_production_min$1 = {};
  /** @license React v17.0.2
   * react-is.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  var b$1 = 60103,
      c$1 = 60106,
      d$1 = 60107,
      e$1 = 60108,
      f$2 = 60114,
      g$2 = 60109,
      h$2 = 60110,
      k$1 = 60112,
      l$2 = 60113,
      m$2 = 60120,
      n$3 = 60115,
      p$3 = 60116,
      q$4 = 60121,
      r$3 = 60122,
      u$1 = 60117,
      v$2 = 60129,
      w$2 = 60131;

  if ("function" === typeof Symbol && Symbol.for) {
    var x$2 = Symbol.for;
    b$1 = x$2("react.element");
    c$1 = x$2("react.portal");
    d$1 = x$2("react.fragment");
    e$1 = x$2("react.strict_mode");
    f$2 = x$2("react.profiler");
    g$2 = x$2("react.provider");
    h$2 = x$2("react.context");
    k$1 = x$2("react.forward_ref");
    l$2 = x$2("react.suspense");
    m$2 = x$2("react.suspense_list");
    n$3 = x$2("react.memo");
    p$3 = x$2("react.lazy");
    q$4 = x$2("react.block");
    r$3 = x$2("react.server.block");
    u$1 = x$2("react.fundamental");
    v$2 = x$2("react.debug_trace_mode");
    w$2 = x$2("react.legacy_hidden");
  }

  function y$2(a) {
    if ("object" === typeof a && null !== a) {
      var t = a.$$typeof;

      switch (t) {
        case b$1:
          switch (a = a.type, a) {
            case d$1:
            case f$2:
            case e$1:
            case l$2:
            case m$2:
              return a;

            default:
              switch (a = a && a.$$typeof, a) {
                case h$2:
                case k$1:
                case p$3:
                case n$3:
                case g$2:
                  return a;

                default:
                  return t;
              }

          }

        case c$1:
          return t;
      }
    }
  }

  var z$3 = g$2,
      A$3 = b$1,
      B$1 = k$1,
      C$1 = d$1,
      D$2 = p$3,
      E$2 = n$3,
      F$1 = c$1,
      G$1 = f$2,
      H$1 = e$1,
      I$1 = l$2;
  reactIs_production_min$1.ContextConsumer = h$2;
  reactIs_production_min$1.ContextProvider = z$3;
  reactIs_production_min$1.Element = A$3;
  reactIs_production_min$1.ForwardRef = B$1;
  reactIs_production_min$1.Fragment = C$1;
  reactIs_production_min$1.Lazy = D$2;
  reactIs_production_min$1.Memo = E$2;
  reactIs_production_min$1.Portal = F$1;
  reactIs_production_min$1.Profiler = G$1;
  reactIs_production_min$1.StrictMode = H$1;
  reactIs_production_min$1.Suspense = I$1;

  reactIs_production_min$1.isAsyncMode = function () {
    return !1;
  };

  reactIs_production_min$1.isConcurrentMode = function () {
    return !1;
  };

  reactIs_production_min$1.isContextConsumer = function (a) {
    return y$2(a) === h$2;
  };

  reactIs_production_min$1.isContextProvider = function (a) {
    return y$2(a) === g$2;
  };

  reactIs_production_min$1.isElement = function (a) {
    return "object" === typeof a && null !== a && a.$$typeof === b$1;
  };

  reactIs_production_min$1.isForwardRef = function (a) {
    return y$2(a) === k$1;
  };

  reactIs_production_min$1.isFragment = function (a) {
    return y$2(a) === d$1;
  };

  reactIs_production_min$1.isLazy = function (a) {
    return y$2(a) === p$3;
  };

  reactIs_production_min$1.isMemo = function (a) {
    return y$2(a) === n$3;
  };

  reactIs_production_min$1.isPortal = function (a) {
    return y$2(a) === c$1;
  };

  reactIs_production_min$1.isProfiler = function (a) {
    return y$2(a) === f$2;
  };

  reactIs_production_min$1.isStrictMode = function (a) {
    return y$2(a) === e$1;
  };

  reactIs_production_min$1.isSuspense = function (a) {
    return y$2(a) === l$2;
  };

  reactIs_production_min$1.isValidElementType = function (a) {
    return "string" === typeof a || "function" === typeof a || a === d$1 || a === f$2 || a === v$2 || a === e$1 || a === l$2 || a === m$2 || a === w$2 || "object" === typeof a && null !== a && (a.$$typeof === p$3 || a.$$typeof === n$3 || a.$$typeof === g$2 || a.$$typeof === h$2 || a.$$typeof === k$1 || a.$$typeof === u$1 || a.$$typeof === q$4 || a[0] === r$3) ? !0 : !1;
  };

  reactIs_production_min$1.typeOf = y$2;
  var reactIs_development$1 = {};
  /** @license React v17.0.2
   * react-is.development.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  if (process.env.NODE_ENV !== "production") {
    (function () {
      // ATTENTION
      // When adding new symbols to this file,
      // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
      // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
      // nor polyfill, then a plain number is used for performance.
      var REACT_ELEMENT_TYPE = 0xeac7;
      var REACT_PORTAL_TYPE = 0xeaca;
      var REACT_FRAGMENT_TYPE = 0xeacb;
      var REACT_STRICT_MODE_TYPE = 0xeacc;
      var REACT_PROFILER_TYPE = 0xead2;
      var REACT_PROVIDER_TYPE = 0xeacd;
      var REACT_CONTEXT_TYPE = 0xeace;
      var REACT_FORWARD_REF_TYPE = 0xead0;
      var REACT_SUSPENSE_TYPE = 0xead1;
      var REACT_SUSPENSE_LIST_TYPE = 0xead8;
      var REACT_MEMO_TYPE = 0xead3;
      var REACT_LAZY_TYPE = 0xead4;
      var REACT_BLOCK_TYPE = 0xead9;
      var REACT_SERVER_BLOCK_TYPE = 0xeada;
      var REACT_FUNDAMENTAL_TYPE = 0xead5;
      var REACT_DEBUG_TRACING_MODE_TYPE = 0xeae1;
      var REACT_LEGACY_HIDDEN_TYPE = 0xeae3;

      if (typeof Symbol === 'function' && Symbol.for) {
        var symbolFor = Symbol.for;
        REACT_ELEMENT_TYPE = symbolFor('react.element');
        REACT_PORTAL_TYPE = symbolFor('react.portal');
        REACT_FRAGMENT_TYPE = symbolFor('react.fragment');
        REACT_STRICT_MODE_TYPE = symbolFor('react.strict_mode');
        REACT_PROFILER_TYPE = symbolFor('react.profiler');
        REACT_PROVIDER_TYPE = symbolFor('react.provider');
        REACT_CONTEXT_TYPE = symbolFor('react.context');
        REACT_FORWARD_REF_TYPE = symbolFor('react.forward_ref');
        REACT_SUSPENSE_TYPE = symbolFor('react.suspense');
        REACT_SUSPENSE_LIST_TYPE = symbolFor('react.suspense_list');
        REACT_MEMO_TYPE = symbolFor('react.memo');
        REACT_LAZY_TYPE = symbolFor('react.lazy');
        REACT_BLOCK_TYPE = symbolFor('react.block');
        REACT_SERVER_BLOCK_TYPE = symbolFor('react.server.block');
        REACT_FUNDAMENTAL_TYPE = symbolFor('react.fundamental');
        symbolFor('react.scope');
        symbolFor('react.opaque.id');
        REACT_DEBUG_TRACING_MODE_TYPE = symbolFor('react.debug_trace_mode');
        symbolFor('react.offscreen');
        REACT_LEGACY_HIDDEN_TYPE = symbolFor('react.legacy_hidden');
      } // Filter certain DOM attributes (e.g. src, href) if their values are empty strings.


      var enableScopeAPI = false; // Experimental Create Event Handle API.

      function isValidElementType(type) {
        if (typeof type === 'string' || typeof type === 'function') {
          return true;
        } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).


        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || type === REACT_DEBUG_TRACING_MODE_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_LEGACY_HIDDEN_TYPE || enableScopeAPI) {
          return true;
        }

        if (typeof type === 'object' && type !== null) {
          if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_BLOCK_TYPE || type[0] === REACT_SERVER_BLOCK_TYPE) {
            return true;
          }
        }

        return false;
      }

      function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
          var $$typeof = object.$$typeof;

          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;

              switch (type) {
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                case REACT_SUSPENSE_LIST_TYPE:
                  return type;

                default:
                  var $$typeofType = type && type.$$typeof;

                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;

                    default:
                      return $$typeof;
                  }

              }

            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }

        return undefined;
      }

      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false;
      var hasWarnedAboutDeprecatedIsConcurrentMode = false; // AsyncMode should be deprecated

      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

            console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
          }
        }
        return false;
      }

      function isConcurrentMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsConcurrentMode) {
            hasWarnedAboutDeprecatedIsConcurrentMode = true; // Using console['warn'] to evade Babel and ESLint

            console['warn']('The ReactIs.isConcurrentMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
          }
        }
        return false;
      }

      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }

      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }

      function isElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }

      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }

      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }

      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }

      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }

      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }

      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }

      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }

      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }

      reactIs_development$1.ContextConsumer = ContextConsumer;
      reactIs_development$1.ContextProvider = ContextProvider;
      reactIs_development$1.Element = Element;
      reactIs_development$1.ForwardRef = ForwardRef;
      reactIs_development$1.Fragment = Fragment;
      reactIs_development$1.Lazy = Lazy;
      reactIs_development$1.Memo = Memo;
      reactIs_development$1.Portal = Portal;
      reactIs_development$1.Profiler = Profiler;
      reactIs_development$1.StrictMode = StrictMode;
      reactIs_development$1.Suspense = Suspense;
      reactIs_development$1.isAsyncMode = isAsyncMode;
      reactIs_development$1.isConcurrentMode = isConcurrentMode;
      reactIs_development$1.isContextConsumer = isContextConsumer;
      reactIs_development$1.isContextProvider = isContextProvider;
      reactIs_development$1.isElement = isElement;
      reactIs_development$1.isForwardRef = isForwardRef;
      reactIs_development$1.isFragment = isFragment;
      reactIs_development$1.isLazy = isLazy;
      reactIs_development$1.isMemo = isMemo;
      reactIs_development$1.isPortal = isPortal;
      reactIs_development$1.isProfiler = isProfiler;
      reactIs_development$1.isStrictMode = isStrictMode;
      reactIs_development$1.isSuspense = isSuspense;
      reactIs_development$1.isValidElementType = isValidElementType;
      reactIs_development$1.typeOf = typeOf;
    })();
  }

  if (process.env.NODE_ENV === 'production') {
    reactIs$2.exports = reactIs_production_min$1;
  } else {
    reactIs$2.exports = reactIs_development$1;
  } // https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3


  var fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;

  function getFunctionName(fn) {
    var match = "".concat(fn).match(fnNameMatchRegex);
    var name = match && match[1];
    return name || '';
  }

  function getFunctionComponentName(Component) {
    var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return Component.displayName || Component.name || getFunctionName(Component) || fallback;
  }

  function getWrappedName(outerType, innerType, wrapperName) {
    var functionName = getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== '' ? "".concat(wrapperName, "(").concat(functionName, ")") : wrapperName);
  }
  /**
   * cherry-pick from
   * https://github.com/facebook/react/blob/769b1f270e1251d9dbdce0fcbd9e92e502d059b8/packages/shared/getComponentName.js
   * originally forked from recompose/getDisplayName with added IE11 support
   */


  function getDisplayName(Component) {
    if (Component == null) {
      return undefined;
    }

    if (typeof Component === 'string') {
      return Component;
    }

    if (typeof Component === 'function') {
      return getFunctionComponentName(Component, 'Component');
    } // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`


    if (typeof Component === 'object') {
      switch (Component.$$typeof) {
        case reactIs$2.exports.ForwardRef:
          return getWrappedName(Component, Component.render, 'ForwardRef');

        case reactIs$2.exports.Memo:
          return getWrappedName(Component, Component.type, 'memo');

        default:
          return undefined;
      }
    }

    return undefined;
  }

  function HTMLElementType(props, propName, componentName, location, propFullName) {
    if (process.env.NODE_ENV === 'production') {
      return null;
    }

    var propValue = props[propName];
    var safePropName = propFullName || propName;

    if (propValue == null) {
      return null;
    }

    if (propValue && propValue.nodeType !== 1) {
      return new Error("Invalid ".concat(location, " `").concat(safePropName, "` supplied to `").concat(componentName, "`. ") + "Expected an HTMLElement.");
    }

    return null;
  }

  var refType = PropTypes.oneOfType([PropTypes.func, PropTypes.object]);
  var refType$1 = refType; // It should to be noted that this function isn't equivalent to `text-transform: capitalize`.
  //
  // A strict capitalization should uppercase the first letter of each word in the sentence.
  // We only handle the first word.

  function capitalize$1(string) {
    if (typeof string !== 'string') {
      throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `capitalize(string)` expects a string argument." : formatMuiErrorMessage(7));
    }

    return string.charAt(0).toUpperCase() + string.slice(1);
  }
  /**
   * Safe chained function.
   *
   * Will only create a new function if needed,
   * otherwise will pass back existing functions or null.
   */


  function createChainedFunction() {
    for (var _len7 = arguments.length, funcs = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
      funcs[_key7] = arguments[_key7];
    }

    return funcs.reduce(function (acc, func) {
      if (func == null) {
        return acc;
      }

      return function chainedFunction() {
        for (var _len8 = arguments.length, args = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
          args[_key8] = arguments[_key8];
        }

        acc.apply(this, args);
        func.apply(this, args);
      };
    }, function () {});
  } // Corresponds to 10 frames at 60 Hz.
  // A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.


  function debounce$1(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 166;
    var timeout;

    function debounced() {
      var _this5 = this;

      for (var _len10 = arguments.length, args = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
        args[_key10] = arguments[_key10];
      }

      var later = function later() {
        func.apply(_this5, args);
      };

      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    }

    debounced.clear = function () {
      clearTimeout(timeout);
    };

    return debounced;
  }

  function deprecatedPropType(validator, reason) {
    if (process.env.NODE_ENV === 'production') {
      return function () {
        return null;
      };
    }

    return function (props, propName, componentName, location, propFullName) {
      var componentNameSafe = componentName || '<<anonymous>>';
      var propFullNameSafe = propFullName || propName;

      if (typeof props[propName] !== 'undefined') {
        return new Error("The ".concat(location, " `").concat(propFullNameSafe, "` of ") + "`".concat(componentNameSafe, "` is deprecated. ").concat(reason));
      }

      return null;
    };
  }

  function isMuiElement(element, muiNames) {
    return /*#__PURE__*/React__namespace.isValidElement(element) && muiNames.indexOf(element.type.muiName) !== -1;
  }

  function ownerDocument(node) {
    return node && node.ownerDocument || document;
  }

  function ownerWindow(node) {
    var doc = ownerDocument(node);
    return doc.defaultView || window;
  }

  function requirePropFactory(componentNameInError, Component) {
    if (process.env.NODE_ENV === 'production') {
      return function () {
        return null;
      };
    } // eslint-disable-next-line react/forbid-foreign-prop-types


    var prevPropTypes = Component ? _extends$a({}, Component.propTypes) : null;

    var requireProp = function requireProp(requiredProp) {
      return function (props, propName, componentName, location, propFullName) {
        var propFullNameSafe = propFullName || propName;
        var defaultTypeChecker = prevPropTypes == null ? void 0 : prevPropTypes[propFullNameSafe];

        if (defaultTypeChecker) {
          for (var _len11 = arguments.length, args = new Array(_len11 > 5 ? _len11 - 5 : 0), _key11 = 5; _key11 < _len11; _key11++) {
            args[_key11 - 5] = arguments[_key11];
          }

          var typeCheckerResult = defaultTypeChecker.apply(void 0, [props, propName, componentName, location, propFullName].concat(args));

          if (typeCheckerResult) {
            return typeCheckerResult;
          }
        }

        if (typeof props[propName] !== 'undefined' && !props[requiredProp]) {
          return new Error("The prop `".concat(propFullNameSafe, "` of ") + "`".concat(componentNameInError, "` can only be used together with the `").concat(requiredProp, "` prop."));
        }

        return null;
      };
    };

    return requireProp;
  }
  /**
   * TODO v5: consider making it private
   *
   * passes {value} to {ref}
   *
   * WARNING: Be sure to only call this inside a callback that is passed as a ref.
   * Otherwise, make sure to cleanup the previous {ref} if it changes. See
   * https://github.com/mui-org/material-ui/issues/13539
   *
   * Useful if you want to expose the ref of an inner component to the public API
   * while still using it inside the component.
   * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
   */


  function setRef(ref, value) {
    if (typeof ref === 'function') {
      ref(value);
    } else if (ref) {
      ref.current = value;
    }
  }

  var useEnhancedEffect = typeof window !== 'undefined' ? React__namespace.useLayoutEffect : React__namespace.useEffect;
  var useEnhancedEffect$1 = useEnhancedEffect;
  var globalId = 0;

  function useId(idOverride) {
    var _React__namespace$use = React__namespace.useState(idOverride),
        _React__namespace$use2 = _slicedToArray(_React__namespace$use, 2),
        defaultId = _React__namespace$use2[0],
        setDefaultId = _React__namespace$use2[1];

    var id = idOverride || defaultId;
    React__namespace.useEffect(function () {
      if (defaultId == null) {
        // Fallback to this default id when possible.
        // Use the incrementing value for client-side rendering only.
        // We can't use it server-side.
        // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
        globalId += 1;
        setDefaultId("mui-".concat(globalId));
      }
    }, [defaultId]);
    return id;
  }

  function unsupportedProp(props, propName, componentName, location, propFullName) {
    if (process.env.NODE_ENV === 'production') {
      return null;
    }

    var propFullNameSafe = propFullName || propName;

    if (typeof props[propName] !== 'undefined') {
      return new Error("The prop `".concat(propFullNameSafe, "` is not supported. Please remove it."));
    }

    return null;
  }
  /* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */


  function useControlled(_ref5) {
    var controlled = _ref5.controlled,
        defaultProp = _ref5.default,
        name = _ref5.name,
        _ref5$state = _ref5.state,
        state = _ref5$state === void 0 ? 'value' : _ref5$state;

    // isControlled is ignored in the hook dependency lists as it should never change.
    var _React__namespace$use3 = React__namespace.useRef(controlled !== undefined),
        isControlled = _React__namespace$use3.current;

    var _React__namespace$use4 = React__namespace.useState(defaultProp),
        _React__namespace$use5 = _slicedToArray(_React__namespace$use4, 2),
        valueState = _React__namespace$use5[0],
        setValue = _React__namespace$use5[1];

    var value = isControlled ? controlled : valueState;

    if (process.env.NODE_ENV !== 'production') {
      React__namespace.useEffect(function () {
        if (isControlled !== (controlled !== undefined)) {
          console.error(["MUI: A component is changing the ".concat(isControlled ? '' : 'un', "controlled ").concat(state, " state of ").concat(name, " to be ").concat(isControlled ? 'un' : '', "controlled."), 'Elements should not switch from uncontrolled to controlled (or vice versa).', "Decide between using a controlled or uncontrolled ".concat(name, " ") + 'element for the lifetime of the component.', "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", 'More info: https://fb.me/react-controlled-components'].join('\n'));
        }
      }, [state, name, controlled]);

      var _React__namespace$use6 = React__namespace.useRef(defaultProp),
          defaultValue = _React__namespace$use6.current;

      React__namespace.useEffect(function () {
        if (!isControlled && defaultValue !== defaultProp) {
          console.error(["MUI: A component is changing the default ".concat(state, " state of an uncontrolled ").concat(name, " after being initialized. ") + "To suppress this warning opt to use a controlled ".concat(name, ".")].join('\n'));
        }
      }, [JSON.stringify(defaultProp)]);
    }

    var setValueIfUncontrolled = React__namespace.useCallback(function (newValue) {
      if (!isControlled) {
        setValue(newValue);
      }
    }, []);
    return [value, setValueIfUncontrolled];
  }
  /**
   * https://github.com/facebook/react/issues/14099#issuecomment-440013892
   */


  function useEventCallback(fn) {
    var ref = React__namespace.useRef(fn);
    useEnhancedEffect$1(function () {
      ref.current = fn;
    });
    return React__namespace.useCallback(function () {
      return (// @ts-expect-error hide `this`
        // tslint:disable-next-line:ban-comma-operator
        (0, ref.current).apply(void 0, arguments)
      );
    }, []);
  }

  function useForkRef(refA, refB) {
    /**
     * This will create a new function if the ref props change and are defined.
     * This means react will call the old forkRef with `null` and the new forkRef
     * with the ref. Cleanup naturally emerges from this behavior.
     */
    return React__namespace.useMemo(function () {
      if (refA == null && refB == null) {
        return null;
      }

      return function (refValue) {
        setRef(refA, refValue);
        setRef(refB, refValue);
      };
    }, [refA, refB]);
  } // based on https://github.com/WICG/focus-visible/blob/v4.1.5/src/focus-visible.js


  var hadKeyboardEvent = true;
  var hadFocusVisibleRecently = false;
  var hadFocusVisibleRecentlyTimeout;
  var inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    'datetime-local': true
  };
  /**
   * Computes whether the given element should automatically trigger the
   * `focus-visible` class being added, i.e. whether it should always match
   * `:focus-visible` when focused.
   * @param {Element} node
   * @returns {boolean}
   */

  function focusTriggersKeyboardModality(node) {
    var type = node.type,
        tagName = node.tagName;

    if (tagName === 'INPUT' && inputTypesWhitelist[type] && !node.readOnly) {
      return true;
    }

    if (tagName === 'TEXTAREA' && !node.readOnly) {
      return true;
    }

    if (node.isContentEditable) {
      return true;
    }

    return false;
  }
  /**
   * Keep track of our keyboard modality state with `hadKeyboardEvent`.
   * If the most recent user interaction was via the keyboard;
   * and the key press did not include a meta, alt/option, or control key;
   * then the modality is keyboard. Otherwise, the modality is not keyboard.
   * @param {KeyboardEvent} event
   */


  function handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) {
      return;
    }

    hadKeyboardEvent = true;
  }
  /**
   * If at any point a user clicks with a pointing device, ensure that we change
   * the modality away from keyboard.
   * This avoids the situation where a user presses a key on an already focused
   * element, and then clicks on a different element, focusing it with a
   * pointing device, while we still think we're in keyboard modality.
   */


  function handlePointerDown() {
    hadKeyboardEvent = false;
  }

  function handleVisibilityChange() {
    if (this.visibilityState === 'hidden') {
      // If the tab becomes active again, the browser will handle calling focus
      // on the element (Safari actually calls it twice).
      // If this tab change caused a blur on an element with focus-visible,
      // re-apply the class when the user switches back to the tab.
      if (hadFocusVisibleRecently) {
        hadKeyboardEvent = true;
      }
    }
  }

  function prepare(doc) {
    doc.addEventListener('keydown', handleKeyDown, true);
    doc.addEventListener('mousedown', handlePointerDown, true);
    doc.addEventListener('pointerdown', handlePointerDown, true);
    doc.addEventListener('touchstart', handlePointerDown, true);
    doc.addEventListener('visibilitychange', handleVisibilityChange, true);
  }

  function isFocusVisible(event) {
    var target = event.target;

    try {
      return target.matches(':focus-visible');
    } catch (error) {// Browsers not implementing :focus-visible will throw a SyntaxError.
      // We use our own heuristic for those browsers.
      // Rethrow might be better if it's not the expected error but do we really
      // want to crash if focus-visible malfunctioned?
    } // No need for validFocusTarget check. The user does that by attaching it to
    // focusable events only.


    return hadKeyboardEvent || focusTriggersKeyboardModality(target);
  }

  function useIsFocusVisible() {
    var ref = React__namespace.useCallback(function (node) {
      if (node != null) {
        prepare(node.ownerDocument);
      }
    }, []);
    var isFocusVisibleRef = React__namespace.useRef(false);
    /**
     * Should be called if a blur event is fired
     */

    function handleBlurVisible() {
      // checking against potential state variable does not suffice if we focus and blur synchronously.
      // React wouldn't have time to trigger a re-render so `focusVisible` would be stale.
      // Ideally we would adjust `isFocusVisible(event)` to look at `relatedTarget` for blur events.
      // This doesn't work in IE11 due to https://github.com/facebook/react/issues/3751
      // TODO: check again if React releases their internal changes to focus event handling (https://github.com/facebook/react/pull/19186).
      if (isFocusVisibleRef.current) {
        // To detect a tab/window switch, we look for a blur event followed
        // rapidly by a visibility change.
        // If we don't see a visibility change within 100ms, it's probably a
        // regular focus change.
        hadFocusVisibleRecently = true;
        window.clearTimeout(hadFocusVisibleRecentlyTimeout);
        hadFocusVisibleRecentlyTimeout = window.setTimeout(function () {
          hadFocusVisibleRecently = false;
        }, 100);
        isFocusVisibleRef.current = false;
        return true;
      }

      return false;
    }
    /**
     * Should be called if a blur event is fired
     */


    function handleFocusVisible(event) {
      if (isFocusVisible(event)) {
        isFocusVisibleRef.current = true;
        return true;
      }

      return false;
    }

    return {
      isFocusVisibleRef: isFocusVisibleRef,
      onFocus: handleFocusVisible,
      onBlur: handleBlurVisible,
      ref: ref
    };
  } // A change of the browser zoom change the scrollbar size.
  // Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18


  function getScrollbarSize(doc) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    var documentWidth = doc.documentElement.clientWidth;
    return Math.abs(window.innerWidth - documentWidth);
  }

  var usePreviousProps = function usePreviousProps(value) {
    var ref = React__namespace.useRef({});
    React__namespace.useEffect(function () {
      ref.current = value;
    });
    return ref.current;
  };

  var usePreviousProps$1 = usePreviousProps;

  function getTypeByValue(value) {
    var valueType = typeof value;

    switch (valueType) {
      case 'number':
        if (Number.isNaN(value)) {
          return 'NaN';
        }

        if (!Number.isFinite(value)) {
          return 'Infinity';
        }

        if (value !== Math.floor(value)) {
          return 'float';
        }

        return 'number';

      case 'object':
        if (value === null) {
          return 'null';
        }

        return value.constructor.name;

      default:
        return valueType;
    }
  } // IE 11 support


  function ponyfillIsInteger(x) {
    // eslint-disable-next-line no-restricted-globals
    return typeof x === 'number' && isFinite(x) && Math.floor(x) === x;
  }

  var isInteger = Number.isInteger || ponyfillIsInteger;

  function requiredInteger(props, propName, componentName, location) {
    var propValue = props[propName];

    if (propValue == null || !isInteger(propValue)) {
      var propType = getTypeByValue(propValue);
      return new RangeError("Invalid ".concat(location, " `").concat(propName, "` of type `").concat(propType, "` supplied to `").concat(componentName, "`, expected `integer`."));
    }

    return null;
  }

  function validator(props, propName) {
    var propValue = props[propName];

    if (propValue === undefined) {
      return null;
    }

    for (var _len12 = arguments.length, other = new Array(_len12 > 2 ? _len12 - 2 : 0), _key12 = 2; _key12 < _len12; _key12++) {
      other[_key12 - 2] = arguments[_key12];
    }

    return requiredInteger.apply(void 0, [props, propName].concat(other));
  }

  function validatorNoop() {
    return null;
  }

  validator.isRequired = requiredInteger;
  validatorNoop.isRequired = validatorNoop;
  var integerPropType = process.env.NODE_ENV === 'production' ? validatorNoop : validator;
  /**
   * Add keys, values of `defaultProps` that does not exist in `props`
   * @param {object} defaultProps
   * @param {object} props
   * @returns {object} resolved props
   */

  function resolveProps(defaultProps, props) {
    var output = _extends$a({}, props);

    Object.keys(defaultProps).forEach(function (propName) {
      if (output[propName] === undefined) {
        output[propName] = defaultProps[propName];
      }
    });
    return output;
  } // Give up on IE11 support for this feature


  function stripDiacritics(string) {
    return typeof string.normalize !== 'undefined' ? string.normalize('NFD').replace(/[\u0300-\u036f]/g, '') : string;
  }

  function createFilterOptions() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _config$ignoreAccents = config.ignoreAccents,
        ignoreAccents = _config$ignoreAccents === void 0 ? true : _config$ignoreAccents,
        _config$ignoreCase = config.ignoreCase,
        ignoreCase = _config$ignoreCase === void 0 ? true : _config$ignoreCase,
        limit = config.limit,
        _config$matchFrom = config.matchFrom,
        matchFrom = _config$matchFrom === void 0 ? 'any' : _config$matchFrom,
        stringify = config.stringify,
        _config$trim = config.trim,
        trim = _config$trim === void 0 ? false : _config$trim;
    return function (options, _ref6) {
      var inputValue = _ref6.inputValue,
          getOptionLabel = _ref6.getOptionLabel;
      var input = trim ? inputValue.trim() : inputValue;

      if (ignoreCase) {
        input = input.toLowerCase();
      }

      if (ignoreAccents) {
        input = stripDiacritics(input);
      }

      var filteredOptions = options.filter(function (option) {
        var candidate = (stringify || getOptionLabel)(option);

        if (ignoreCase) {
          candidate = candidate.toLowerCase();
        }

        if (ignoreAccents) {
          candidate = stripDiacritics(candidate);
        }

        return matchFrom === 'start' ? candidate.indexOf(input) === 0 : candidate.indexOf(input) > -1;
      });
      return typeof limit === 'number' ? filteredOptions.slice(0, limit) : filteredOptions;
    };
  } // To replace with .findIndex() once we stop IE11 support.


  function findIndex$2(array, comp) {
    for (var i = 0; i < array.length; i += 1) {
      if (comp(array[i])) {
        return i;
      }
    }

    return -1;
  }

  var defaultFilterOptions = createFilterOptions(); // Number of options to jump in list box when pageup and pagedown keys are used.

  var pageSize = 5;

  function useAutocomplete(props) {
    var _props$autoComplete = props.autoComplete,
        autoComplete = _props$autoComplete === void 0 ? false : _props$autoComplete,
        _props$autoHighlight = props.autoHighlight,
        autoHighlight = _props$autoHighlight === void 0 ? false : _props$autoHighlight,
        _props$autoSelect = props.autoSelect,
        autoSelect = _props$autoSelect === void 0 ? false : _props$autoSelect,
        _props$blurOnSelect = props.blurOnSelect,
        blurOnSelect = _props$blurOnSelect === void 0 ? false : _props$blurOnSelect,
        disabledProp = props.disabled,
        _props$clearOnBlur = props.clearOnBlur,
        clearOnBlur = _props$clearOnBlur === void 0 ? !props.freeSolo : _props$clearOnBlur,
        _props$clearOnEscape = props.clearOnEscape,
        clearOnEscape = _props$clearOnEscape === void 0 ? false : _props$clearOnEscape,
        _props$componentName = props.componentName,
        componentName = _props$componentName === void 0 ? 'useAutocomplete' : _props$componentName,
        _props$defaultValue = props.defaultValue,
        defaultValue = _props$defaultValue === void 0 ? props.multiple ? [] : null : _props$defaultValue,
        _props$disableClearab = props.disableClearable,
        disableClearable = _props$disableClearab === void 0 ? false : _props$disableClearab,
        _props$disableCloseOn = props.disableCloseOnSelect,
        disableCloseOnSelect = _props$disableCloseOn === void 0 ? false : _props$disableCloseOn,
        _props$disabledItemsF = props.disabledItemsFocusable,
        disabledItemsFocusable = _props$disabledItemsF === void 0 ? false : _props$disabledItemsF,
        _props$disableListWra = props.disableListWrap,
        disableListWrap = _props$disableListWra === void 0 ? false : _props$disableListWra,
        _props$filterOptions = props.filterOptions,
        filterOptions = _props$filterOptions === void 0 ? defaultFilterOptions : _props$filterOptions,
        _props$filterSelected = props.filterSelectedOptions,
        filterSelectedOptions = _props$filterSelected === void 0 ? false : _props$filterSelected,
        _props$freeSolo = props.freeSolo,
        freeSolo = _props$freeSolo === void 0 ? false : _props$freeSolo,
        getOptionDisabled = props.getOptionDisabled,
        _props$getOptionLabel = props.getOptionLabel,
        getOptionLabelProp = _props$getOptionLabel === void 0 ? function (option) {
      var _option$label;

      return (_option$label = option.label) != null ? _option$label : option;
    } : _props$getOptionLabel,
        _props$isOptionEqualT = props.isOptionEqualToValue,
        isOptionEqualToValue = _props$isOptionEqualT === void 0 ? function (option, value) {
      return option === value;
    } : _props$isOptionEqualT,
        groupBy = props.groupBy,
        _props$handleHomeEndK = props.handleHomeEndKeys,
        handleHomeEndKeys = _props$handleHomeEndK === void 0 ? !props.freeSolo : _props$handleHomeEndK,
        idProp = props.id,
        _props$includeInputIn = props.includeInputInList,
        includeInputInList = _props$includeInputIn === void 0 ? false : _props$includeInputIn,
        inputValueProp = props.inputValue,
        _props$multiple = props.multiple,
        multiple = _props$multiple === void 0 ? false : _props$multiple,
        onChange = props.onChange,
        onClose = props.onClose,
        onHighlightChange = props.onHighlightChange,
        onInputChange = props.onInputChange,
        onOpen = props.onOpen,
        openProp = props.open,
        _props$openOnFocus = props.openOnFocus,
        openOnFocus = _props$openOnFocus === void 0 ? false : _props$openOnFocus,
        options = props.options,
        _props$selectOnFocus = props.selectOnFocus,
        selectOnFocus = _props$selectOnFocus === void 0 ? !props.freeSolo : _props$selectOnFocus,
        valueProp = props.value;
    var id = useId(idProp);
    var getOptionLabel = getOptionLabelProp;

    getOptionLabel = function getOptionLabel(option) {
      var optionLabel = getOptionLabelProp(option);

      if (typeof optionLabel !== 'string') {
        if (process.env.NODE_ENV !== 'production') {
          var erroneousReturn = optionLabel === undefined ? 'undefined' : "".concat(typeof optionLabel, " (").concat(optionLabel, ")");
          console.error("MUI: The `getOptionLabel` method of ".concat(componentName, " returned ").concat(erroneousReturn, " instead of a string for ").concat(JSON.stringify(option), "."));
        }

        return String(optionLabel);
      }

      return optionLabel;
    };

    var ignoreFocus = React__namespace.useRef(false);
    var firstFocus = React__namespace.useRef(true);
    var inputRef = React__namespace.useRef(null);
    var listboxRef = React__namespace.useRef(null);

    var _React__namespace$use7 = React__namespace.useState(null),
        _React__namespace$use8 = _slicedToArray(_React__namespace$use7, 2),
        anchorEl = _React__namespace$use8[0],
        setAnchorEl = _React__namespace$use8[1];

    var _React__namespace$use9 = React__namespace.useState(-1),
        _React__namespace$use10 = _slicedToArray(_React__namespace$use9, 2),
        focusedTag = _React__namespace$use10[0],
        setFocusedTag = _React__namespace$use10[1];

    var defaultHighlighted = autoHighlight ? 0 : -1;
    var highlightedIndexRef = React__namespace.useRef(defaultHighlighted);

    var _useControlled = useControlled({
      controlled: valueProp,
      default: defaultValue,
      name: componentName
    }),
        _useControlled2 = _slicedToArray(_useControlled, 2),
        value = _useControlled2[0],
        setValueState = _useControlled2[1];

    var _useControlled3 = useControlled({
      controlled: inputValueProp,
      default: '',
      name: componentName,
      state: 'inputValue'
    }),
        _useControlled4 = _slicedToArray(_useControlled3, 2),
        inputValue = _useControlled4[0],
        setInputValueState = _useControlled4[1];

    var _React__namespace$use11 = React__namespace.useState(false),
        _React__namespace$use12 = _slicedToArray(_React__namespace$use11, 2),
        focused = _React__namespace$use12[0],
        setFocused = _React__namespace$use12[1];

    var resetInputValue = React__namespace.useCallback(function (event, newValue) {
      // retain current `inputValue` if new option isn't selected and `clearOnBlur` is false
      // When `multiple` is enabled, `newValue` is an array of all selected items including the newly selected item
      var isOptionSelected = multiple ? value.length < newValue.length : newValue !== null;

      if (!isOptionSelected && !clearOnBlur) {
        return;
      }

      var newInputValue;

      if (multiple) {
        newInputValue = '';
      } else if (newValue == null) {
        newInputValue = '';
      } else {
        var optionLabel = getOptionLabel(newValue);
        newInputValue = typeof optionLabel === 'string' ? optionLabel : '';
      }

      if (inputValue === newInputValue) {
        return;
      }

      setInputValueState(newInputValue);

      if (onInputChange) {
        onInputChange(event, newInputValue, 'reset');
      }
    }, [getOptionLabel, inputValue, multiple, onInputChange, setInputValueState, clearOnBlur, value]);
    var prevValue = React__namespace.useRef();
    React__namespace.useEffect(function () {
      var valueChange = value !== prevValue.current;
      prevValue.current = value;

      if (focused && !valueChange) {
        return;
      } // Only reset the input's value when freeSolo if the component's value changes.


      if (freeSolo && !valueChange) {
        return;
      }

      resetInputValue(null, value);
    }, [value, resetInputValue, focused, prevValue, freeSolo]);

    var _useControlled5 = useControlled({
      controlled: openProp,
      default: false,
      name: componentName,
      state: 'open'
    }),
        _useControlled6 = _slicedToArray(_useControlled5, 2),
        open = _useControlled6[0],
        setOpenState = _useControlled6[1];

    var _React__namespace$use13 = React__namespace.useState(true),
        _React__namespace$use14 = _slicedToArray(_React__namespace$use13, 2),
        inputPristine = _React__namespace$use14[0],
        setInputPristine = _React__namespace$use14[1];

    var inputValueIsSelectedValue = !multiple && value != null && inputValue === getOptionLabel(value);
    var popupOpen = open;
    var filteredOptions = popupOpen ? filterOptions(options.filter(function (option) {
      if (filterSelectedOptions && (multiple ? value : [value]).some(function (value2) {
        return value2 !== null && isOptionEqualToValue(option, value2);
      })) {
        return false;
      }

      return true;
    }), // we use the empty string to manipulate `filterOptions` to not filter any options
    // i.e. the filter predicate always returns true
    {
      inputValue: inputValueIsSelectedValue && inputPristine ? '' : inputValue,
      getOptionLabel: getOptionLabel
    }) : [];
    var listboxAvailable = open && filteredOptions.length > 0;

    if (process.env.NODE_ENV !== 'production') {
      if (value !== null && !freeSolo && options.length > 0) {
        var missingValue = (multiple ? value : [value]).filter(function (value2) {
          return !options.some(function (option) {
            return isOptionEqualToValue(option, value2);
          });
        });

        if (missingValue.length > 0) {
          console.warn(["MUI: The value provided to ".concat(componentName, " is invalid."), "None of the options match with `".concat(missingValue.length > 1 ? JSON.stringify(missingValue) : JSON.stringify(missingValue[0]), "`."), 'You can use the `isOptionEqualToValue` prop to customize the equality test.'].join('\n'));
        }
      }
    }

    var focusTag = useEventCallback(function (tagToFocus) {
      if (tagToFocus === -1) {
        inputRef.current.focus();
      } else {
        anchorEl.querySelector("[data-tag-index=\"".concat(tagToFocus, "\"]")).focus();
      }
    }); // Ensure the focusedTag is never inconsistent

    React__namespace.useEffect(function () {
      if (multiple && focusedTag > value.length - 1) {
        setFocusedTag(-1);
        focusTag(-1);
      }
    }, [value, multiple, focusedTag, focusTag]);

    function validOptionIndex(index, direction) {
      if (!listboxRef.current || index === -1) {
        return -1;
      }

      var nextFocus = index;

      while (true) {
        // Out of range
        if (direction === 'next' && nextFocus === filteredOptions.length || direction === 'previous' && nextFocus === -1) {
          return -1;
        }

        var option = listboxRef.current.querySelector("[data-option-index=\"".concat(nextFocus, "\"]")); // Same logic as MenuList.js

        var nextFocusDisabled = disabledItemsFocusable ? false : !option || option.disabled || option.getAttribute('aria-disabled') === 'true';

        if (option && !option.hasAttribute('tabindex') || nextFocusDisabled) {
          // Move to the next element.
          nextFocus += direction === 'next' ? 1 : -1;
        } else {
          return nextFocus;
        }
      }
    }

    var setHighlightedIndex = useEventCallback(function (_ref7) {
      var event = _ref7.event,
          index = _ref7.index,
          _ref7$reason = _ref7.reason,
          reason = _ref7$reason === void 0 ? 'auto' : _ref7$reason;
      highlightedIndexRef.current = index; // does the index exist?

      if (index === -1) {
        inputRef.current.removeAttribute('aria-activedescendant');
      } else {
        inputRef.current.setAttribute('aria-activedescendant', "".concat(id, "-option-").concat(index));
      }

      if (onHighlightChange) {
        onHighlightChange(event, index === -1 ? null : filteredOptions[index], reason);
      }

      if (!listboxRef.current) {
        return;
      }

      var prev = listboxRef.current.querySelector('[role="option"].Mui-focused');

      if (prev) {
        prev.classList.remove('Mui-focused');
        prev.classList.remove('Mui-focusVisible');
      }

      var listboxNode = listboxRef.current.parentElement.querySelector('[role="listbox"]'); // "No results"

      if (!listboxNode) {
        return;
      }

      if (index === -1) {
        listboxNode.scrollTop = 0;
        return;
      }

      var option = listboxRef.current.querySelector("[data-option-index=\"".concat(index, "\"]"));

      if (!option) {
        return;
      }

      option.classList.add('Mui-focused');

      if (reason === 'keyboard') {
        option.classList.add('Mui-focusVisible');
      } // Scroll active descendant into view.
      // Logic copied from https://www.w3.org/TR/wai-aria-practices/examples/listbox/js/listbox.js
      //
      // Consider this API instead once it has a better browser support:
      // .scrollIntoView({ scrollMode: 'if-needed', block: 'nearest' });


      if (listboxNode.scrollHeight > listboxNode.clientHeight && reason !== 'mouse') {
        var element = option;
        var scrollBottom = listboxNode.clientHeight + listboxNode.scrollTop;
        var elementBottom = element.offsetTop + element.offsetHeight;

        if (elementBottom > scrollBottom) {
          listboxNode.scrollTop = elementBottom - listboxNode.clientHeight;
        } else if (element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0) < listboxNode.scrollTop) {
          listboxNode.scrollTop = element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0);
        }
      }
    });
    var changeHighlightedIndex = useEventCallback(function (_ref8) {
      var event = _ref8.event,
          diff = _ref8.diff,
          _ref8$direction = _ref8.direction,
          direction = _ref8$direction === void 0 ? 'next' : _ref8$direction,
          _ref8$reason = _ref8.reason,
          reason = _ref8$reason === void 0 ? 'auto' : _ref8$reason;

      if (!popupOpen) {
        return;
      }

      var getNextIndex = function getNextIndex() {
        var maxIndex = filteredOptions.length - 1;

        if (diff === 'reset') {
          return defaultHighlighted;
        }

        if (diff === 'start') {
          return 0;
        }

        if (diff === 'end') {
          return maxIndex;
        }

        var newIndex = highlightedIndexRef.current + diff;

        if (newIndex < 0) {
          if (newIndex === -1 && includeInputInList) {
            return -1;
          }

          if (disableListWrap && highlightedIndexRef.current !== -1 || Math.abs(diff) > 1) {
            return 0;
          }

          return maxIndex;
        }

        if (newIndex > maxIndex) {
          if (newIndex === maxIndex + 1 && includeInputInList) {
            return -1;
          }

          if (disableListWrap || Math.abs(diff) > 1) {
            return maxIndex;
          }

          return 0;
        }

        return newIndex;
      };

      var nextIndex = validOptionIndex(getNextIndex(), direction);
      setHighlightedIndex({
        index: nextIndex,
        reason: reason,
        event: event
      }); // Sync the content of the input with the highlighted option.

      if (autoComplete && diff !== 'reset') {
        if (nextIndex === -1) {
          inputRef.current.value = inputValue;
        } else {
          var option = getOptionLabel(filteredOptions[nextIndex]);
          inputRef.current.value = option; // The portion of the selected suggestion that has not been typed by the user,
          // a completion string, appears inline after the input cursor in the textbox.

          var _index = option.toLowerCase().indexOf(inputValue.toLowerCase());

          if (_index === 0 && inputValue.length > 0) {
            inputRef.current.setSelectionRange(inputValue.length, option.length);
          }
        }
      }
    });
    var syncHighlightedIndex = React__namespace.useCallback(function () {
      if (!popupOpen) {
        return;
      }

      var valueItem = multiple ? value[0] : value; // The popup is empty, reset

      if (filteredOptions.length === 0 || valueItem == null) {
        changeHighlightedIndex({
          diff: 'reset'
        });
        return;
      }

      if (!listboxRef.current) {
        return;
      } // Synchronize the value with the highlighted index


      if (valueItem != null) {
        var currentOption = filteredOptions[highlightedIndexRef.current]; // Keep the current highlighted index if possible

        if (multiple && currentOption && findIndex$2(value, function (val) {
          return isOptionEqualToValue(currentOption, val);
        }) !== -1) {
          return;
        }

        var itemIndex = findIndex$2(filteredOptions, function (optionItem) {
          return isOptionEqualToValue(optionItem, valueItem);
        });

        if (itemIndex === -1) {
          changeHighlightedIndex({
            diff: 'reset'
          });
        } else {
          setHighlightedIndex({
            index: itemIndex
          });
        }

        return;
      } // Prevent the highlighted index to leak outside the boundaries.


      if (highlightedIndexRef.current >= filteredOptions.length - 1) {
        setHighlightedIndex({
          index: filteredOptions.length - 1
        });
        return;
      } // Restore the focus to the previous index.


      setHighlightedIndex({
        index: highlightedIndexRef.current
      }); // Ignore filteredOptions (and options, isOptionEqualToValue, getOptionLabel) not to break the scroll position
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [// Only sync the highlighted index when the option switch between empty and not
    filteredOptions.length, // Don't sync the highlighted index with the value when multiple
    // eslint-disable-next-line react-hooks/exhaustive-deps
    multiple ? false : value, filterSelectedOptions, changeHighlightedIndex, setHighlightedIndex, popupOpen, inputValue, multiple]);
    var handleListboxRef = useEventCallback(function (node) {
      setRef(listboxRef, node);

      if (!node) {
        return;
      }

      syncHighlightedIndex();
    });

    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      React__namespace.useEffect(function () {
        if (!inputRef.current || inputRef.current.nodeName !== 'INPUT') {
          console.error(["MUI: Unable to find the input element. It was resolved to ".concat(inputRef.current, " while an HTMLInputElement was expected."), "Instead, ".concat(componentName, " expects an input element."), '', componentName === 'useAutocomplete' ? 'Make sure you have binded getInputProps correctly and that the normal ref/effect resolutions order is guaranteed.' : 'Make sure you have customized the input component correctly.'].join('\n'));
        }
      }, [componentName]);
    }

    React__namespace.useEffect(function () {
      syncHighlightedIndex();
    }, [syncHighlightedIndex]);

    var handleOpen = function handleOpen(event) {
      if (open) {
        return;
      }

      setOpenState(true);
      setInputPristine(true);

      if (onOpen) {
        onOpen(event);
      }
    };

    var handleClose = function handleClose(event, reason) {
      if (!open) {
        return;
      }

      setOpenState(false);

      if (onClose) {
        onClose(event, reason);
      }
    };

    var handleValue = function handleValue(event, newValue, reason, details) {
      if (value === newValue) {
        return;
      }

      if (onChange) {
        onChange(event, newValue, reason, details);
      }

      setValueState(newValue);
    };

    var isTouch = React__namespace.useRef(false);

    var selectNewValue = function selectNewValue(event, option) {
      var reasonProp = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'selectOption';
      var origin = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'options';
      var reason = reasonProp;
      var newValue = option;

      if (multiple) {
        newValue = Array.isArray(value) ? value.slice() : [];

        if (process.env.NODE_ENV !== 'production') {
          var matches = newValue.filter(function (val) {
            return isOptionEqualToValue(option, val);
          });

          if (matches.length > 1) {
            console.error(["MUI: The `isOptionEqualToValue` method of ".concat(componentName, " do not handle the arguments correctly."), "The component expects a single value to match a given option but found ".concat(matches.length, " matches.")].join('\n'));
          }
        }

        var itemIndex = findIndex$2(newValue, function (valueItem) {
          return isOptionEqualToValue(option, valueItem);
        });

        if (itemIndex === -1) {
          newValue.push(option);
        } else if (origin !== 'freeSolo') {
          newValue.splice(itemIndex, 1);
          reason = 'removeOption';
        }
      }

      resetInputValue(event, newValue);
      handleValue(event, newValue, reason, {
        option: option
      });

      if (!disableCloseOnSelect && !event.ctrlKey && !event.metaKey) {
        handleClose(event, reason);
      }

      if (blurOnSelect === true || blurOnSelect === 'touch' && isTouch.current || blurOnSelect === 'mouse' && !isTouch.current) {
        inputRef.current.blur();
      }
    };

    function validTagIndex(index, direction) {
      if (index === -1) {
        return -1;
      }

      var nextFocus = index;

      while (true) {
        // Out of range
        if (direction === 'next' && nextFocus === value.length || direction === 'previous' && nextFocus === -1) {
          return -1;
        }

        var option = anchorEl.querySelector("[data-tag-index=\"".concat(nextFocus, "\"]")); // Same logic as MenuList.js

        if (!option || !option.hasAttribute('tabindex') || option.disabled || option.getAttribute('aria-disabled') === 'true') {
          nextFocus += direction === 'next' ? 1 : -1;
        } else {
          return nextFocus;
        }
      }
    }

    var handleFocusTag = function handleFocusTag(event, direction) {
      if (!multiple) {
        return;
      }

      handleClose(event, 'toggleInput');
      var nextTag = focusedTag;

      if (focusedTag === -1) {
        if (inputValue === '' && direction === 'previous') {
          nextTag = value.length - 1;
        }
      } else {
        nextTag += direction === 'next' ? 1 : -1;

        if (nextTag < 0) {
          nextTag = 0;
        }

        if (nextTag === value.length) {
          nextTag = -1;
        }
      }

      nextTag = validTagIndex(nextTag, direction);
      setFocusedTag(nextTag);
      focusTag(nextTag);
    };

    var handleClear = function handleClear(event) {
      ignoreFocus.current = true;
      setInputValueState('');

      if (onInputChange) {
        onInputChange(event, '', 'clear');
      }

      handleValue(event, multiple ? [] : null, 'clear');
    };

    var handleKeyDown = function handleKeyDown(other) {
      return function (event) {
        if (other.onKeyDown) {
          other.onKeyDown(event);
        }

        if (event.defaultMuiPrevented) {
          return;
        }

        if (focusedTag !== -1 && ['ArrowLeft', 'ArrowRight'].indexOf(event.key) === -1) {
          setFocusedTag(-1);
          focusTag(-1);
        } // Wait until IME is settled.


        if (event.which !== 229) {
          switch (event.key) {
            case 'Home':
              if (popupOpen && handleHomeEndKeys) {
                // Prevent scroll of the page
                event.preventDefault();
                changeHighlightedIndex({
                  diff: 'start',
                  direction: 'next',
                  reason: 'keyboard',
                  event: event
                });
              }

              break;

            case 'End':
              if (popupOpen && handleHomeEndKeys) {
                // Prevent scroll of the page
                event.preventDefault();
                changeHighlightedIndex({
                  diff: 'end',
                  direction: 'previous',
                  reason: 'keyboard',
                  event: event
                });
              }

              break;

            case 'PageUp':
              // Prevent scroll of the page
              event.preventDefault();
              changeHighlightedIndex({
                diff: -pageSize,
                direction: 'previous',
                reason: 'keyboard',
                event: event
              });
              handleOpen(event);
              break;

            case 'PageDown':
              // Prevent scroll of the page
              event.preventDefault();
              changeHighlightedIndex({
                diff: pageSize,
                direction: 'next',
                reason: 'keyboard',
                event: event
              });
              handleOpen(event);
              break;

            case 'ArrowDown':
              // Prevent cursor move
              event.preventDefault();
              changeHighlightedIndex({
                diff: 1,
                direction: 'next',
                reason: 'keyboard',
                event: event
              });
              handleOpen(event);
              break;

            case 'ArrowUp':
              // Prevent cursor move
              event.preventDefault();
              changeHighlightedIndex({
                diff: -1,
                direction: 'previous',
                reason: 'keyboard',
                event: event
              });
              handleOpen(event);
              break;

            case 'ArrowLeft':
              handleFocusTag(event, 'previous');
              break;

            case 'ArrowRight':
              handleFocusTag(event, 'next');
              break;

            case 'Enter':
              if (highlightedIndexRef.current !== -1 && popupOpen) {
                var option = filteredOptions[highlightedIndexRef.current];
                var disabled = getOptionDisabled ? getOptionDisabled(option) : false; // Avoid early form validation, let the end-users continue filling the form.

                event.preventDefault();

                if (disabled) {
                  return;
                }

                selectNewValue(event, option, 'selectOption'); // Move the selection to the end.

                if (autoComplete) {
                  inputRef.current.setSelectionRange(inputRef.current.value.length, inputRef.current.value.length);
                }
              } else if (freeSolo && inputValue !== '' && inputValueIsSelectedValue === false) {
                if (multiple) {
                  // Allow people to add new values before they submit the form.
                  event.preventDefault();
                }

                selectNewValue(event, inputValue, 'createOption', 'freeSolo');
              }

              break;

            case 'Escape':
              if (popupOpen) {
                // Avoid Opera to exit fullscreen mode.
                event.preventDefault(); // Avoid the Modal to handle the event.

                event.stopPropagation();
                handleClose(event, 'escape');
              } else if (clearOnEscape && (inputValue !== '' || multiple && value.length > 0)) {
                // Avoid Opera to exit fullscreen mode.
                event.preventDefault(); // Avoid the Modal to handle the event.

                event.stopPropagation();
                handleClear(event);
              }

              break;

            case 'Backspace':
              if (multiple && inputValue === '' && value.length > 0) {
                var _index2 = focusedTag === -1 ? value.length - 1 : focusedTag;

                var newValue = value.slice();
                newValue.splice(_index2, 1);
                handleValue(event, newValue, 'removeOption', {
                  option: value[_index2]
                });
              }

              break;
          }
        }
      };
    };

    var handleFocus = function handleFocus(event) {
      setFocused(true);

      if (openOnFocus && !ignoreFocus.current) {
        handleOpen(event);
      }
    };

    var handleBlur = function handleBlur(event) {
      // Ignore the event when using the scrollbar with IE11
      if (listboxRef.current !== null && listboxRef.current.parentElement.contains(document.activeElement)) {
        inputRef.current.focus();
        return;
      }

      setFocused(false);
      firstFocus.current = true;
      ignoreFocus.current = false;

      if (autoSelect && highlightedIndexRef.current !== -1 && popupOpen) {
        selectNewValue(event, filteredOptions[highlightedIndexRef.current], 'blur');
      } else if (autoSelect && freeSolo && inputValue !== '') {
        selectNewValue(event, inputValue, 'blur', 'freeSolo');
      } else if (clearOnBlur) {
        resetInputValue(event, value);
      }

      handleClose(event, 'blur');
    };

    var handleInputChange = function handleInputChange(event) {
      var newValue = event.target.value;

      if (inputValue !== newValue) {
        setInputValueState(newValue);
        setInputPristine(false);

        if (onInputChange) {
          onInputChange(event, newValue, 'input');
        }
      }

      if (newValue === '') {
        if (!disableClearable && !multiple) {
          handleValue(event, null, 'clear');
        }
      } else {
        handleOpen(event);
      }
    };

    var handleOptionMouseOver = function handleOptionMouseOver(event) {
      setHighlightedIndex({
        event: event,
        index: Number(event.currentTarget.getAttribute('data-option-index')),
        reason: 'mouse'
      });
    };

    var handleOptionTouchStart = function handleOptionTouchStart() {
      isTouch.current = true;
    };

    var handleOptionClick = function handleOptionClick(event) {
      var index = Number(event.currentTarget.getAttribute('data-option-index'));
      selectNewValue(event, filteredOptions[index], 'selectOption');
      isTouch.current = false;
    };

    var handleTagDelete = function handleTagDelete(index) {
      return function (event) {
        var newValue = value.slice();
        newValue.splice(index, 1);
        handleValue(event, newValue, 'removeOption', {
          option: value[index]
        });
      };
    };

    var handlePopupIndicator = function handlePopupIndicator(event) {
      if (open) {
        handleClose(event, 'toggleInput');
      } else {
        handleOpen(event);
      }
    }; // Prevent input blur when interacting with the combobox


    var handleMouseDown = function handleMouseDown(event) {
      if (event.target.getAttribute('id') !== id) {
        event.preventDefault();
      }
    }; // Focus the input when interacting with the combobox


    var handleClick = function handleClick() {
      inputRef.current.focus();

      if (selectOnFocus && firstFocus.current && inputRef.current.selectionEnd - inputRef.current.selectionStart === 0) {
        inputRef.current.select();
      }

      firstFocus.current = false;
    };

    var handleInputMouseDown = function handleInputMouseDown(event) {
      if (inputValue === '' || !open) {
        handlePopupIndicator(event);
      }
    };

    var dirty = freeSolo && inputValue.length > 0;
    dirty = dirty || (multiple ? value.length > 0 : value !== null);
    var groupedOptions = filteredOptions;

    if (groupBy) {
      // used to keep track of key and indexes in the result array
      var indexBy = new Map();
      var warn = false;
      groupedOptions = filteredOptions.reduce(function (acc, option, index) {
        var group = groupBy(option);

        if (acc.length > 0 && acc[acc.length - 1].group === group) {
          acc[acc.length - 1].options.push(option);
        } else {
          if (process.env.NODE_ENV !== 'production') {
            if (indexBy.get(group) && !warn) {
              console.warn("MUI: The options provided combined with the `groupBy` method of ".concat(componentName, " returns duplicated headers."), 'You can solve the issue by sorting the options with the output of `groupBy`.');
              warn = true;
            }

            indexBy.set(group, true);
          }

          acc.push({
            key: index,
            index: index,
            group: group,
            options: [option]
          });
        }

        return acc;
      }, []);
    }

    if (disabledProp && focused) {
      handleBlur();
    }

    return {
      getRootProps: function getRootProps() {
        var other = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return _extends$b({
          'aria-owns': listboxAvailable ? "".concat(id, "-listbox") : null,
          role: 'combobox',
          'aria-expanded': listboxAvailable
        }, other, {
          onKeyDown: handleKeyDown(other),
          onMouseDown: handleMouseDown,
          onClick: handleClick
        });
      },
      getInputLabelProps: function getInputLabelProps() {
        return {
          id: "".concat(id, "-label"),
          htmlFor: id
        };
      },
      getInputProps: function getInputProps() {
        return {
          id: id,
          value: inputValue,
          onBlur: handleBlur,
          onFocus: handleFocus,
          onChange: handleInputChange,
          onMouseDown: handleInputMouseDown,
          // if open then this is handled imperativeley so don't let react override
          // only have an opinion about this when closed
          'aria-activedescendant': popupOpen ? '' : null,
          'aria-autocomplete': autoComplete ? 'both' : 'list',
          'aria-controls': listboxAvailable ? "".concat(id, "-listbox") : null,
          // Disable browser's suggestion that might overlap with the popup.
          // Handle autocomplete but not autofill.
          autoComplete: 'off',
          ref: inputRef,
          autoCapitalize: 'none',
          spellCheck: 'false'
        };
      },
      getClearProps: function getClearProps() {
        return {
          tabIndex: -1,
          onClick: handleClear
        };
      },
      getPopupIndicatorProps: function getPopupIndicatorProps() {
        return {
          tabIndex: -1,
          onClick: handlePopupIndicator
        };
      },
      getTagProps: function getTagProps(_ref9) {
        var index = _ref9.index;
        return {
          key: index,
          'data-tag-index': index,
          tabIndex: -1,
          onDelete: handleTagDelete(index)
        };
      },
      getListboxProps: function getListboxProps() {
        return {
          role: 'listbox',
          id: "".concat(id, "-listbox"),
          'aria-labelledby': "".concat(id, "-label"),
          ref: handleListboxRef,
          onMouseDown: function onMouseDown(event) {
            // Prevent blur
            event.preventDefault();
          }
        };
      },
      getOptionProps: function getOptionProps(_ref10) {
        var index = _ref10.index,
            option = _ref10.option;
        var selected = (multiple ? value : [value]).some(function (value2) {
          return value2 != null && isOptionEqualToValue(option, value2);
        });
        var disabled = getOptionDisabled ? getOptionDisabled(option) : false;
        return {
          key: getOptionLabel(option),
          tabIndex: -1,
          role: 'option',
          id: "".concat(id, "-option-").concat(index),
          onMouseOver: handleOptionMouseOver,
          onClick: handleOptionClick,
          onTouchStart: handleOptionTouchStart,
          'data-option-index': index,
          'aria-disabled': disabled,
          'aria-selected': selected
        };
      },
      id: id,
      inputValue: inputValue,
      value: value,
      dirty: dirty,
      popupOpen: popupOpen,
      focused: focused || focusedTag !== -1,
      anchorEl: anchorEl,
      setAnchorEl: setAnchorEl,
      focusedTag: focusedTag,
      groupedOptions: groupedOptions
    };
  }

  function _objectWithoutPropertiesLoose$5(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }

  function composeClasses(slots, getUtilityClass, classes) {
    var output = {};
    Object.keys(slots).forEach( // `Objet.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    function (slot) {
      output[slot] = slots[slot].reduce(function (acc, key) {
        if (key) {
          if (classes && classes[key]) {
            acc.push(classes[key]);
          }

          acc.push(getUtilityClass(key));
        }

        return acc;
      }, []).join(' ');
    });
    return output;
  }

  var defaultGenerator = function defaultGenerator(componentName) {
    return componentName;
  };

  var createClassNameGenerator = function createClassNameGenerator() {
    var _generate = defaultGenerator;
    return {
      configure: function configure(generator) {
        _generate = generator;
      },
      generate: function generate(componentName) {
        return _generate(componentName);
      },
      reset: function reset() {
        _generate = defaultGenerator;
      }
    };
  };

  var ClassNameGenerator = createClassNameGenerator();
  var ClassNameGenerator$1 = ClassNameGenerator;
  var globalStateClassesMapping = {
    active: 'Mui-active',
    checked: 'Mui-checked',
    completed: 'Mui-completed',
    disabled: 'Mui-disabled',
    error: 'Mui-error',
    expanded: 'Mui-expanded',
    focused: 'Mui-focused',
    focusVisible: 'Mui-focusVisible',
    required: 'Mui-required',
    selected: 'Mui-selected'
  };

  function generateUtilityClass(componentName, slot) {
    var globalStateClass = globalStateClassesMapping[slot];
    return globalStateClass || "".concat(ClassNameGenerator$1.generate(componentName), "-").concat(slot);
  }

  function generateUtilityClasses(componentName, slots) {
    var result = {};
    slots.forEach(function (slot) {
      result[slot] = generateUtilityClass(componentName, slot);
    });
    return result;
  }

  function getBackdropUtilityClass(slot) {
    return generateUtilityClass('MuiBackdrop', slot);
  }

  generateUtilityClasses('MuiBackdrop', ['root', 'invisible']);
  var _excluded$1S = ["classes", "className", "invisible", "component", "components", "componentsProps", "theme"];

  var useUtilityClasses$1k = function useUtilityClasses$1k(ownerState) {
    var classes = ownerState.classes,
        invisible = ownerState.invisible;
    var slots = {
      root: ['root', invisible && 'invisible']
    };
    return composeClasses(slots, getBackdropUtilityClass, classes);
  };

  var BackdropUnstyled = /*#__PURE__*/React__namespace.forwardRef(function BackdropUnstyled(props, ref) {
    var classesProp = props.classes,
        className = props.className,
        _props$invisible = props.invisible,
        invisible = _props$invisible === void 0 ? false : _props$invisible,
        _props$component = props.component,
        component = _props$component === void 0 ? 'div' : _props$component,
        _props$components = props.components,
        components = _props$components === void 0 ? {} : _props$components,
        _props$componentsProp = props.componentsProps,
        componentsProps = _props$componentsProp === void 0 ? {} : _props$componentsProp,
        theme = props.theme,
        other = _objectWithoutPropertiesLoose$5(props, _excluded$1S);

    var ownerState = _extends$b({}, props, {
      classes: classesProp,
      invisible: invisible
    });

    var classes = useUtilityClasses$1k(ownerState);
    var Root = components.Root || component;
    var rootProps = componentsProps.root || {};
    return /*#__PURE__*/jsxRuntime$1.jsx(Root, _extends$b({
      "aria-hidden": true
    }, rootProps, !isHostComponent(Root) && {
      as: component,
      ownerState: _extends$b({}, ownerState, rootProps.ownerState),
      theme: theme
    }, {
      ref: ref
    }, other, {
      className: clsx(classes.root, rootProps.className, className)
    }));
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var BackdropUnstyled$1 = BackdropUnstyled;

  function getBadgeUtilityClass(slot) {
    return generateUtilityClass('MuiBadge', slot);
  }

  var badgeUnstyledClasses = generateUtilityClasses('MuiBadge', ['root', 'badge', 'dot', 'standard', 'anchorOriginTopLeftCircular', 'anchorOriginTopLeftRectangular', 'anchorOriginTopRightCircular', 'anchorOriginTopRightRectangular', 'anchorOriginBottomLeftCircular', 'anchorOriginBottomLeftRectangular', 'anchorOriginBottomRightCircular', 'anchorOriginBottomRightRectangular', 'invisible']);
  var badgeUnstyledClasses$1 = badgeUnstyledClasses;
  var _excluded$1R = ["anchorOrigin", "classes", "badgeContent", "component", "children", "className", "components", "componentsProps", "invisible", "max", "overlap", "showZero", "variant", "theme"];

  var useUtilityClasses$1j = function useUtilityClasses$1j(ownerState) {
    var variant = ownerState.variant,
        anchorOrigin = ownerState.anchorOrigin,
        overlap = ownerState.overlap,
        invisible = ownerState.invisible,
        classes = ownerState.classes;
    var slots = {
      root: ['root'],
      badge: ['badge', variant, "anchorOrigin".concat(capitalize$1(anchorOrigin.vertical)).concat(capitalize$1(anchorOrigin.horizontal)).concat(capitalize$1(overlap)), invisible && 'invisible']
    };
    return composeClasses(slots, getBadgeUtilityClass, classes);
  };

  var BadgeUnstyled = /*#__PURE__*/React__namespace.forwardRef(function BadgeUnstyled(props, ref) {
    var _props$anchorOrigin = props.anchorOrigin,
        anchorOriginProp = _props$anchorOrigin === void 0 ? {
      vertical: 'top',
      horizontal: 'right'
    } : _props$anchorOrigin,
        classesProp = props.classes,
        badgeContentProp = props.badgeContent,
        _props$component2 = props.component,
        component = _props$component2 === void 0 ? 'span' : _props$component2,
        children = props.children,
        className = props.className,
        _props$components2 = props.components,
        components = _props$components2 === void 0 ? {} : _props$components2,
        _props$componentsProp2 = props.componentsProps,
        componentsProps = _props$componentsProp2 === void 0 ? {} : _props$componentsProp2,
        invisibleProp = props.invisible,
        _props$max = props.max,
        maxProp = _props$max === void 0 ? 99 : _props$max,
        _props$overlap = props.overlap,
        overlapProp = _props$overlap === void 0 ? 'rectangular' : _props$overlap,
        _props$showZero = props.showZero,
        showZero = _props$showZero === void 0 ? false : _props$showZero,
        _props$variant = props.variant,
        variantProp = _props$variant === void 0 ? 'standard' : _props$variant,
        theme = props.theme,
        other = _objectWithoutPropertiesLoose$5(props, _excluded$1R);

    var prevProps = usePreviousProps$1({
      anchorOrigin: anchorOriginProp,
      badgeContent: badgeContentProp,
      max: maxProp,
      overlap: overlapProp,
      variant: variantProp
    });
    var invisible = invisibleProp;

    if (invisibleProp == null && (badgeContentProp === 0 && !showZero || badgeContentProp == null && variantProp !== 'dot')) {
      invisible = true;
    }

    var _ref11 = invisible ? prevProps : props,
        _ref11$anchorOrigin = _ref11.anchorOrigin,
        anchorOrigin = _ref11$anchorOrigin === void 0 ? anchorOriginProp : _ref11$anchorOrigin,
        badgeContent = _ref11.badgeContent,
        _ref11$max = _ref11.max,
        max = _ref11$max === void 0 ? maxProp : _ref11$max,
        _ref11$overlap = _ref11.overlap,
        overlap = _ref11$overlap === void 0 ? overlapProp : _ref11$overlap,
        _ref11$variant = _ref11.variant,
        variant = _ref11$variant === void 0 ? variantProp : _ref11$variant;

    var ownerState = _extends$b({}, props, {
      anchorOrigin: anchorOrigin,
      badgeContent: badgeContent,
      classes: classesProp,
      invisible: invisible,
      max: max,
      overlap: overlap,
      variant: variant
    });

    var displayValue = '';

    if (variant !== 'dot') {
      displayValue = badgeContent > max ? "".concat(max, "+") : badgeContent;
    }

    var classes = useUtilityClasses$1j(ownerState);
    var Root = components.Root || component;
    var rootProps = componentsProps.root || {};
    var Badge = components.Badge || 'span';
    var badgeProps = componentsProps.badge || {};
    return /*#__PURE__*/jsxRuntime$1.jsxs(Root, _extends$b({}, rootProps, !isHostComponent(Root) && {
      as: component,
      ownerState: _extends$b({}, ownerState, rootProps.ownerState),
      theme: theme
    }, {
      ref: ref
    }, other, {
      className: clsx(classes.root, rootProps.className, className),
      children: [children, /*#__PURE__*/jsxRuntime$1.jsx(Badge, _extends$b({}, badgeProps, !isHostComponent(Badge) && {
        ownerState: _extends$b({}, ownerState, badgeProps.ownerState),
        theme: theme
      }, {
        className: clsx(classes.badge, badgeProps.className),
        children: displayValue
      }))]
    }));
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var BadgeUnstyled$1 = BadgeUnstyled;

  function mapEventPropToEvent(eventProp) {
    return eventProp.substring(2).toLowerCase();
  }

  function clickedRootScrollbar$1(event, doc) {
    return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
  }
  /**
   * Listen for click events that occur somewhere in the document, outside of the element itself.
   * For instance, if you need to hide a menu when people click anywhere else on your page.
   *
   * Demos:
   *
   * - [Click Away Listener](https://mui.com/components/click-away-listener/)
   * - [Menus](https://mui.com/components/menus/)
   *
   * API:
   *
   * - [ClickAwayListener API](https://mui.com/api/click-away-listener/)
   */


  function ClickAwayListener(props) {
    var children = props.children,
        _props$disableReactTr = props.disableReactTree,
        disableReactTree = _props$disableReactTr === void 0 ? false : _props$disableReactTr,
        _props$mouseEvent = props.mouseEvent,
        mouseEvent = _props$mouseEvent === void 0 ? 'onClick' : _props$mouseEvent,
        onClickAway = props.onClickAway,
        _props$touchEvent = props.touchEvent,
        touchEvent = _props$touchEvent === void 0 ? 'onTouchEnd' : _props$touchEvent;
    var movedRef = React__namespace.useRef(false);
    var nodeRef = React__namespace.useRef(null);
    var activatedRef = React__namespace.useRef(false);
    var syntheticEventRef = React__namespace.useRef(false);
    React__namespace.useEffect(function () {
      // Ensure that this component is not "activated" synchronously.
      // https://github.com/facebook/react/issues/20074
      setTimeout(function () {
        activatedRef.current = true;
      }, 0);
      return function () {
        activatedRef.current = false;
      };
    }, []);
    var handleRef = useForkRef( // @ts-expect-error TODO upstream fix
    children.ref, nodeRef); // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviors like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.

    var handleClickAway = useEventCallback(function (event) {
      // Given developers can stop the propagation of the synthetic event,
      // we can only be confident with a positive value.
      var insideReactTree = syntheticEventRef.current;
      syntheticEventRef.current = false;
      var doc = ownerDocument(nodeRef.current); // 1. IE11 support, which trigger the handleClickAway even after the unbind
      // 2. The child might render null.
      // 3. Behave like a blur listener.

      if (!activatedRef.current || !nodeRef.current || 'clientX' in event && clickedRootScrollbar$1(event, doc)) {
        return;
      } // Do not act if user performed touchmove


      if (movedRef.current) {
        movedRef.current = false;
        return;
      }

      var insideDOM; // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js

      if (event.composedPath) {
        insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
      } else {
        insideDOM = !doc.documentElement.contains( // @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target) || nodeRef.current.contains( // @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target);
      }

      if (!insideDOM && (disableReactTree || !insideReactTree)) {
        onClickAway(event);
      }
    }); // Keep track of mouse/touch events that bubbled up through the portal.

    var createHandleSynthetic = function createHandleSynthetic(handlerName) {
      return function (event) {
        syntheticEventRef.current = true;
        var childrenPropsHandler = children.props[handlerName];

        if (childrenPropsHandler) {
          childrenPropsHandler(event);
        }
      };
    };

    var childrenProps = {
      ref: handleRef
    };

    if (touchEvent !== false) {
      childrenProps[touchEvent] = createHandleSynthetic(touchEvent);
    }

    React__namespace.useEffect(function () {
      if (touchEvent !== false) {
        var mappedTouchEvent = mapEventPropToEvent(touchEvent);
        var doc = ownerDocument(nodeRef.current);

        var handleTouchMove = function handleTouchMove() {
          movedRef.current = true;
        };

        doc.addEventListener(mappedTouchEvent, handleClickAway);
        doc.addEventListener('touchmove', handleTouchMove);
        return function () {
          doc.removeEventListener(mappedTouchEvent, handleClickAway);
          doc.removeEventListener('touchmove', handleTouchMove);
        };
      }

      return undefined;
    }, [handleClickAway, touchEvent]);

    if (mouseEvent !== false) {
      childrenProps[mouseEvent] = createHandleSynthetic(mouseEvent);
    }

    React__namespace.useEffect(function () {
      if (mouseEvent !== false) {
        var mappedMouseEvent = mapEventPropToEvent(mouseEvent);
        var doc = ownerDocument(nodeRef.current);
        doc.addEventListener(mappedMouseEvent, handleClickAway);
        return function () {
          doc.removeEventListener(mappedMouseEvent, handleClickAway);
        };
      }

      return undefined;
    }, [handleClickAway, mouseEvent]);
    return /*#__PURE__*/jsxRuntime$1.jsx(React__namespace.Fragment, {
      children: /*#__PURE__*/React__namespace.cloneElement(children, childrenProps)
    });
  }

  process.env.NODE_ENV !== "production" ? void 0 : void 0;

  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line
    ClickAwayListener['propTypes' + ''] = exactProp(ClickAwayListener.propTypes);
  }

  function getContainer$1(container) {
    return typeof container === 'function' ? container() : container;
  }
  /**
   * Portals provide a first-class way to render children into a DOM node
   * that exists outside the DOM hierarchy of the parent component.
   */


  var Portal = /*#__PURE__*/React__namespace.forwardRef(function Portal(props, ref) {
    var children = props.children,
        container = props.container,
        _props$disablePortal = props.disablePortal,
        disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal;

    var _React__namespace$use15 = React__namespace.useState(null),
        _React__namespace$use16 = _slicedToArray(_React__namespace$use15, 2),
        mountNode = _React__namespace$use16[0],
        setMountNode = _React__namespace$use16[1];

    var handleRef = useForkRef( /*#__PURE__*/React__namespace.isValidElement(children) ? children.ref : null, ref);
    useEnhancedEffect$1(function () {
      if (!disablePortal) {
        setMountNode(getContainer$1(container) || document.body);
      }
    }, [container, disablePortal]);
    useEnhancedEffect$1(function () {
      if (mountNode && !disablePortal) {
        setRef(ref, mountNode);
        return function () {
          setRef(ref, null);
        };
      }

      return undefined;
    }, [ref, mountNode, disablePortal]);

    if (disablePortal) {
      if ( /*#__PURE__*/React__namespace.isValidElement(children)) {
        return /*#__PURE__*/React__namespace.cloneElement(children, {
          ref: handleRef
        });
      }

      return children;
    }

    return mountNode ? /*#__PURE__*/ReactDOM__namespace.createPortal(children, mountNode) : mountNode;
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;

  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line
    Portal['propTypes' + ''] = exactProp(Portal.propTypes);
  }

  var Portal$1 = Portal; // Is a vertical scrollbar displayed?

  function isOverflowing(container) {
    var doc = ownerDocument(container);

    if (doc.body === container) {
      return ownerWindow(container).innerWidth > doc.documentElement.clientWidth;
    }

    return container.scrollHeight > container.clientHeight;
  }

  function ariaHidden(element, show) {
    if (show) {
      element.setAttribute('aria-hidden', 'true');
    } else {
      element.removeAttribute('aria-hidden');
    }
  }

  function getPaddingRight(element) {
    return parseInt(ownerWindow(element).getComputedStyle(element).paddingRight, 10) || 0;
  }

  function ariaHiddenSiblings(container, mountElement, currentElement) {
    var elementsToExclude = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
    var show = arguments.length > 4 ? arguments[4] : undefined;
    var blacklist = [mountElement, currentElement].concat(_toConsumableArray(elementsToExclude));
    var blacklistTagNames = ['TEMPLATE', 'SCRIPT', 'STYLE'];
    [].forEach.call(container.children, function (element) {
      if (blacklist.indexOf(element) === -1 && blacklistTagNames.indexOf(element.tagName) === -1) {
        ariaHidden(element, show);
      }
    });
  }

  function findIndexOf(items, callback) {
    var idx = -1;
    items.some(function (item, index) {
      if (callback(item)) {
        idx = index;
        return true;
      }

      return false;
    });
    return idx;
  }

  function handleContainer(containerInfo, props) {
    var restoreStyle = [];
    var container = containerInfo.container;

    if (!props.disableScrollLock) {
      if (isOverflowing(container)) {
        // Compute the size before applying overflow hidden to avoid any scroll jumps.
        var scrollbarSize = getScrollbarSize(ownerDocument(container));
        restoreStyle.push({
          value: container.style.paddingRight,
          property: 'padding-right',
          el: container
        }); // Use computed style, here to get the real padding to add our scrollbar width.

        container.style.paddingRight = "".concat(getPaddingRight(container) + scrollbarSize, "px"); // .mui-fixed is a global helper.

        var _fixedElements = ownerDocument(container).querySelectorAll('.mui-fixed');

        [].forEach.call(_fixedElements, function (element) {
          restoreStyle.push({
            value: element.style.paddingRight,
            property: 'padding-right',
            el: element
          });
          element.style.paddingRight = "".concat(getPaddingRight(element) + scrollbarSize, "px");
        });
      } // Improve Gatsby support
      // https://css-tricks.com/snippets/css/force-vertical-scrollbar/


      var _parent2 = container.parentElement;
      var containerWindow = ownerWindow(container);
      var scrollContainer = (_parent2 == null ? void 0 : _parent2.nodeName) === 'HTML' && containerWindow.getComputedStyle(_parent2).overflowY === 'scroll' ? _parent2 : container; // Block the scroll even if no scrollbar is visible to account for mobile keyboard
      // screensize shrink.

      restoreStyle.push({
        value: scrollContainer.style.overflow,
        property: 'overflow',
        el: scrollContainer
      }, {
        value: scrollContainer.style.overflowX,
        property: 'overflow-x',
        el: scrollContainer
      }, {
        value: scrollContainer.style.overflowY,
        property: 'overflow-y',
        el: scrollContainer
      });
      scrollContainer.style.overflow = 'hidden';
    }

    var restore = function restore() {
      restoreStyle.forEach(function (_ref12) {
        var value = _ref12.value,
            el = _ref12.el,
            property = _ref12.property;

        if (value) {
          el.style.setProperty(property, value);
        } else {
          el.style.removeProperty(property);
        }
      });
    };

    return restore;
  }

  function getHiddenSiblings(container) {
    var hiddenSiblings = [];
    [].forEach.call(container.children, function (element) {
      if (element.getAttribute('aria-hidden') === 'true') {
        hiddenSiblings.push(element);
      }
    });
    return hiddenSiblings;
  }
  /**
   * @ignore - do not document.
   *
   * Proper state management for containers and the modals in those containers.
   * Simplified, but inspired by react-overlay's ModalManager class.
   * Used by the Modal to ensure proper styling of containers.
   */


  var ModalManager = /*#__PURE__*/function () {
    function ModalManager() {
      _classCallCheck(this, ModalManager);

      this.containers = void 0;
      this.modals = void 0;
      this.modals = [];
      this.containers = [];
    }

    _createClass2(ModalManager, [{
      key: "add",
      value: function add(modal, container) {
        var modalIndex = this.modals.indexOf(modal);

        if (modalIndex !== -1) {
          return modalIndex;
        }

        modalIndex = this.modals.length;
        this.modals.push(modal); // If the modal we are adding is already in the DOM.

        if (modal.modalRef) {
          ariaHidden(modal.modalRef, false);
        }

        var hiddenSiblings = getHiddenSiblings(container);
        ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
        var containerIndex = findIndexOf(this.containers, function (item) {
          return item.container === container;
        });

        if (containerIndex !== -1) {
          this.containers[containerIndex].modals.push(modal);
          return modalIndex;
        }

        this.containers.push({
          modals: [modal],
          container: container,
          restore: null,
          hiddenSiblings: hiddenSiblings
        });
        return modalIndex;
      }
    }, {
      key: "mount",
      value: function mount(modal, props) {
        var containerIndex = findIndexOf(this.containers, function (item) {
          return item.modals.indexOf(modal) !== -1;
        });
        var containerInfo = this.containers[containerIndex];

        if (!containerInfo.restore) {
          containerInfo.restore = handleContainer(containerInfo, props);
        }
      }
    }, {
      key: "remove",
      value: function remove(modal) {
        var modalIndex = this.modals.indexOf(modal);

        if (modalIndex === -1) {
          return modalIndex;
        }

        var containerIndex = findIndexOf(this.containers, function (item) {
          return item.modals.indexOf(modal) !== -1;
        });
        var containerInfo = this.containers[containerIndex];
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1); // If that was the last modal in a container, clean up the container.

        if (containerInfo.modals.length === 0) {
          // The modal might be closed before it had the chance to be mounted in the DOM.
          if (containerInfo.restore) {
            containerInfo.restore();
          }

          if (modal.modalRef) {
            // In case the modal wasn't in the DOM yet.
            ariaHidden(modal.modalRef, true);
          }

          ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
          this.containers.splice(containerIndex, 1);
        } else {
          // Otherwise make sure the next top modal is visible to a screen reader.
          var nextTop = containerInfo.modals[containerInfo.modals.length - 1]; // as soon as a modal is adding its modalRef is undefined. it can't set
          // aria-hidden because the dom element doesn't exist either
          // when modal was unmounted before modalRef gets null

          if (nextTop.modalRef) {
            ariaHidden(nextTop.modalRef, false);
          }
        }

        return modalIndex;
      }
    }, {
      key: "isTopModal",
      value: function isTopModal(modal) {
        return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
      }
    }]);

    return ModalManager;
  }();
  /* eslint-disable @typescript-eslint/naming-convention, consistent-return, jsx-a11y/no-noninteractive-tabindex */


  var candidatesSelector = ['input', 'select', 'textarea', 'a[href]', 'button', '[tabindex]', 'audio[controls]', 'video[controls]', '[contenteditable]:not([contenteditable="false"])'].join(',');

  function getTabIndex(node) {
    var tabindexAttr = parseInt(node.getAttribute('tabindex'), 10);

    if (!Number.isNaN(tabindexAttr)) {
      return tabindexAttr;
    } // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // https://bugs.chromium.org/p/chromium/issues/detail?id=661108&q=contenteditable%20tabindex&can=2
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0.


    if (node.contentEditable === 'true' || (node.nodeName === 'AUDIO' || node.nodeName === 'VIDEO' || node.nodeName === 'DETAILS') && node.getAttribute('tabindex') === null) {
      return 0;
    }

    return node.tabIndex;
  }

  function isNonTabbableRadio(node) {
    if (node.tagName !== 'INPUT' || node.type !== 'radio') {
      return false;
    }

    if (!node.name) {
      return false;
    }

    var getRadio = function getRadio(selector) {
      return node.ownerDocument.querySelector("input[type=\"radio\"]".concat(selector));
    };

    var roving = getRadio("[name=\"".concat(node.name, "\"]:checked"));

    if (!roving) {
      roving = getRadio("[name=\"".concat(node.name, "\"]"));
    }

    return roving !== node;
  }

  function isNodeMatchingSelectorFocusable(node) {
    if (node.disabled || node.tagName === 'INPUT' && node.type === 'hidden' || isNonTabbableRadio(node)) {
      return false;
    }

    return true;
  }

  function defaultGetTabbable(root) {
    var regularTabNodes = [];
    var orderedTabNodes = [];
    Array.from(root.querySelectorAll(candidatesSelector)).forEach(function (node, i) {
      var nodeTabIndex = getTabIndex(node);

      if (nodeTabIndex === -1 || !isNodeMatchingSelectorFocusable(node)) {
        return;
      }

      if (nodeTabIndex === 0) {
        regularTabNodes.push(node);
      } else {
        orderedTabNodes.push({
          documentOrder: i,
          tabIndex: nodeTabIndex,
          node: node
        });
      }
    });
    return orderedTabNodes.sort(function (a, b) {
      return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
    }).map(function (a) {
      return a.node;
    }).concat(regularTabNodes);
  }

  function defaultIsEnabled() {
    return true;
  }
  /**
   * Utility component that locks focus inside the component.
   */


  function Unstable_TrapFocus(props) {
    var children = props.children,
        _props$disableAutoFoc = props.disableAutoFocus,
        disableAutoFocus = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc,
        _props$disableEnforce = props.disableEnforceFocus,
        disableEnforceFocus = _props$disableEnforce === void 0 ? false : _props$disableEnforce,
        _props$disableRestore = props.disableRestoreFocus,
        disableRestoreFocus = _props$disableRestore === void 0 ? false : _props$disableRestore,
        _props$getTabbable = props.getTabbable,
        getTabbable = _props$getTabbable === void 0 ? defaultGetTabbable : _props$getTabbable,
        _props$isEnabled = props.isEnabled,
        isEnabled = _props$isEnabled === void 0 ? defaultIsEnabled : _props$isEnabled,
        open = props.open;
    var ignoreNextEnforceFocus = React__namespace.useRef();
    var sentinelStart = React__namespace.useRef(null);
    var sentinelEnd = React__namespace.useRef(null);
    var nodeToRestore = React__namespace.useRef(null);
    var reactFocusEventTarget = React__namespace.useRef(null); // This variable is useful when disableAutoFocus is true.
    // It waits for the active element to move into the component to activate.

    var activated = React__namespace.useRef(false);
    var rootRef = React__namespace.useRef(null);
    var handleRef = useForkRef(children.ref, rootRef);
    var lastKeydown = React__namespace.useRef(null);
    React__namespace.useEffect(function () {
      // We might render an empty child.
      if (!open || !rootRef.current) {
        return;
      }

      activated.current = !disableAutoFocus;
    }, [disableAutoFocus, open]);
    React__namespace.useEffect(function () {
      // We might render an empty child.
      if (!open || !rootRef.current) {
        return;
      }

      var doc = ownerDocument(rootRef.current);

      if (!rootRef.current.contains(doc.activeElement)) {
        if (!rootRef.current.hasAttribute('tabIndex')) {
          if (process.env.NODE_ENV !== 'production') {
            console.error(['MUI: The modal content node does not accept focus.', 'For the benefit of assistive technologies, ' + 'the tabIndex of the node is being set to "-1".'].join('\n'));
          }

          rootRef.current.setAttribute('tabIndex', -1);
        }

        if (activated.current) {
          rootRef.current.focus();
        }
      }

      return function () {
        // restoreLastFocus()
        if (!disableRestoreFocus) {
          // In IE11 it is possible for document.activeElement to be null resulting
          // in nodeToRestore.current being null.
          // Not all elements in IE11 have a focus method.
          // Once IE11 support is dropped the focus() call can be unconditional.
          if (nodeToRestore.current && nodeToRestore.current.focus) {
            ignoreNextEnforceFocus.current = true;
            nodeToRestore.current.focus();
          }

          nodeToRestore.current = null;
        }
      }; // Missing `disableRestoreFocus` which is fine.
      // We don't support changing that prop on an open TrapFocus
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open]);
    React__namespace.useEffect(function () {
      // We might render an empty child.
      if (!open || !rootRef.current) {
        return;
      }

      var doc = ownerDocument(rootRef.current);

      var contain = function contain(nativeEvent) {
        var rootElement = rootRef.current; // Cleanup functions are executed lazily in React 17.
        // Contain can be called between the component being unmounted and its cleanup function being run.

        if (rootElement === null) {
          return;
        }

        if (!doc.hasFocus() || disableEnforceFocus || !isEnabled() || ignoreNextEnforceFocus.current) {
          ignoreNextEnforceFocus.current = false;
          return;
        }

        if (!rootElement.contains(doc.activeElement)) {
          // if the focus event is not coming from inside the children's react tree, reset the refs
          if (nativeEvent && reactFocusEventTarget.current !== nativeEvent.target || doc.activeElement !== reactFocusEventTarget.current) {
            reactFocusEventTarget.current = null;
          } else if (reactFocusEventTarget.current !== null) {
            return;
          }

          if (!activated.current) {
            return;
          }

          var tabbable = [];

          if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) {
            tabbable = getTabbable(rootRef.current);
          }

          if (tabbable.length > 0) {
            var _lastKeydown$current, _lastKeydown$current2;

            var isShiftTab = Boolean(((_lastKeydown$current = lastKeydown.current) == null ? void 0 : _lastKeydown$current.shiftKey) && ((_lastKeydown$current2 = lastKeydown.current) == null ? void 0 : _lastKeydown$current2.key) === 'Tab');
            var focusNext = tabbable[0];
            var focusPrevious = tabbable[tabbable.length - 1];

            if (isShiftTab) {
              focusPrevious.focus();
            } else {
              focusNext.focus();
            }
          } else {
            rootElement.focus();
          }
        }
      };

      var loopFocus = function loopFocus(nativeEvent) {
        lastKeydown.current = nativeEvent;

        if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== 'Tab') {
          return;
        } // Make sure the next tab starts from the right place.
        // doc.activeElement referes to the origin.


        if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
          // We need to ignore the next contain as
          // it will try to move the focus back to the rootRef element.
          ignoreNextEnforceFocus.current = true;
          sentinelEnd.current.focus();
        }
      };

      doc.addEventListener('focusin', contain);
      doc.addEventListener('keydown', loopFocus, true); // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
      // e.g. https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
      // Instead, we can look if the active element was restored on the BODY element.
      //
      // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
      // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.

      var interval = setInterval(function () {
        if (doc.activeElement.tagName === 'BODY') {
          contain();
        }
      }, 50);
      return function () {
        clearInterval(interval);
        doc.removeEventListener('focusin', contain);
        doc.removeEventListener('keydown', loopFocus, true);
      };
    }, [disableAutoFocus, disableEnforceFocus, disableRestoreFocus, isEnabled, open, getTabbable]);

    var onFocus = function onFocus(event) {
      if (nodeToRestore.current === null) {
        nodeToRestore.current = event.relatedTarget;
      }

      activated.current = true;
      reactFocusEventTarget.current = event.target;
      var childrenPropsHandler = children.props.onFocus;

      if (childrenPropsHandler) {
        childrenPropsHandler(event);
      }
    };

    var handleFocusSentinel = function handleFocusSentinel(event) {
      if (nodeToRestore.current === null) {
        nodeToRestore.current = event.relatedTarget;
      }

      activated.current = true;
    };

    return /*#__PURE__*/jsxRuntime$1.jsxs(React__namespace.Fragment, {
      children: [/*#__PURE__*/jsxRuntime$1.jsx("div", {
        tabIndex: 0,
        onFocus: handleFocusSentinel,
        ref: sentinelStart,
        "data-test": "sentinelStart"
      }), /*#__PURE__*/React__namespace.cloneElement(children, {
        ref: handleRef,
        onFocus: onFocus
      }), /*#__PURE__*/jsxRuntime$1.jsx("div", {
        tabIndex: 0,
        onFocus: handleFocusSentinel,
        ref: sentinelEnd,
        "data-test": "sentinelEnd"
      })]
    });
  }

  process.env.NODE_ENV !== "production" ? void 0 : void 0;

  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line
    Unstable_TrapFocus['propTypes' + ''] = exactProp(Unstable_TrapFocus.propTypes);
  }

  function getModalUtilityClass(slot) {
    return generateUtilityClass('MuiModal', slot);
  }

  generateUtilityClasses('MuiModal', ['root', 'hidden']);
  var _excluded$1Q = ["BackdropComponent", "BackdropProps", "children", "classes", "className", "closeAfterTransition", "component", "components", "componentsProps", "container", "disableAutoFocus", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "disableScrollLock", "hideBackdrop", "keepMounted", "manager", "onBackdropClick", "onClose", "onKeyDown", "open", "theme", "onTransitionEnter", "onTransitionExited"];

  var useUtilityClasses$1i = function useUtilityClasses$1i(ownerState) {
    var open = ownerState.open,
        exited = ownerState.exited,
        classes = ownerState.classes;
    var slots = {
      root: ['root', !open && exited && 'hidden']
    };
    return composeClasses(slots, getModalUtilityClass, classes);
  };

  function getContainer(container) {
    return typeof container === 'function' ? container() : container;
  }

  function getHasTransition(props) {
    return props.children ? props.children.props.hasOwnProperty('in') : false;
  } // A modal manager used to track and manage the state of open Modals.
  // Modals don't open on the server so this won't conflict with concurrent requests.


  var defaultManager = new ModalManager();
  /**
   * Modal is a lower-level construct that is leveraged by the following components:
   *
   * - [Dialog](/api/dialog/)
   * - [Drawer](/api/drawer/)
   * - [Menu](/api/menu/)
   * - [Popover](/api/popover/)
   *
   * If you are creating a modal dialog, you probably want to use the [Dialog](/api/dialog/) component
   * rather than directly using Modal.
   *
   * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
   */

  var ModalUnstyled = /*#__PURE__*/React__namespace.forwardRef(function ModalUnstyled(props, ref) {
    var BackdropComponent = props.BackdropComponent,
        BackdropProps = props.BackdropProps,
        children = props.children,
        classesProp = props.classes,
        className = props.className,
        _props$closeAfterTran = props.closeAfterTransition,
        closeAfterTransition = _props$closeAfterTran === void 0 ? false : _props$closeAfterTran,
        _props$component3 = props.component,
        component = _props$component3 === void 0 ? 'div' : _props$component3,
        _props$components3 = props.components,
        components = _props$components3 === void 0 ? {} : _props$components3,
        _props$componentsProp3 = props.componentsProps,
        componentsProps = _props$componentsProp3 === void 0 ? {} : _props$componentsProp3,
        container = props.container,
        _props$disableAutoFoc2 = props.disableAutoFocus,
        disableAutoFocus = _props$disableAutoFoc2 === void 0 ? false : _props$disableAutoFoc2,
        _props$disableEnforce2 = props.disableEnforceFocus,
        disableEnforceFocus = _props$disableEnforce2 === void 0 ? false : _props$disableEnforce2,
        _props$disableEscapeK = props.disableEscapeKeyDown,
        disableEscapeKeyDown = _props$disableEscapeK === void 0 ? false : _props$disableEscapeK,
        _props$disablePortal2 = props.disablePortal,
        disablePortal = _props$disablePortal2 === void 0 ? false : _props$disablePortal2,
        _props$disableRestore2 = props.disableRestoreFocus,
        disableRestoreFocus = _props$disableRestore2 === void 0 ? false : _props$disableRestore2,
        _props$disableScrollL = props.disableScrollLock,
        disableScrollLock = _props$disableScrollL === void 0 ? false : _props$disableScrollL,
        _props$hideBackdrop = props.hideBackdrop,
        hideBackdrop = _props$hideBackdrop === void 0 ? false : _props$hideBackdrop,
        _props$keepMounted = props.keepMounted,
        keepMounted = _props$keepMounted === void 0 ? false : _props$keepMounted,
        _props$manager = props.manager,
        manager = _props$manager === void 0 ? defaultManager : _props$manager,
        onBackdropClick = props.onBackdropClick,
        onClose = props.onClose,
        onKeyDown = props.onKeyDown,
        open = props.open,
        theme = props.theme,
        onTransitionEnter = props.onTransitionEnter,
        onTransitionExited = props.onTransitionExited,
        other = _objectWithoutPropertiesLoose$5(props, _excluded$1Q);

    var _React__namespace$use17 = React__namespace.useState(true),
        _React__namespace$use18 = _slicedToArray(_React__namespace$use17, 2),
        exited = _React__namespace$use18[0],
        setExited = _React__namespace$use18[1];

    var modal = React__namespace.useRef({});
    var mountNodeRef = React__namespace.useRef(null);
    var modalRef = React__namespace.useRef(null);
    var handleRef = useForkRef(modalRef, ref);
    var hasTransition = getHasTransition(props);

    var getDoc = function getDoc() {
      return ownerDocument(mountNodeRef.current);
    };

    var getModal = function getModal() {
      modal.current.modalRef = modalRef.current;
      modal.current.mountNode = mountNodeRef.current;
      return modal.current;
    };

    var handleMounted = function handleMounted() {
      manager.mount(getModal(), {
        disableScrollLock: disableScrollLock
      }); // Fix a bug on Chrome where the scroll isn't initially 0.

      modalRef.current.scrollTop = 0;
    };

    var handleOpen = useEventCallback(function () {
      var resolvedContainer = getContainer(container) || getDoc().body;
      manager.add(getModal(), resolvedContainer); // The element was already mounted.

      if (modalRef.current) {
        handleMounted();
      }
    });
    var isTopModal = React__namespace.useCallback(function () {
      return manager.isTopModal(getModal());
    }, [manager]);
    var handlePortalRef = useEventCallback(function (node) {
      mountNodeRef.current = node;

      if (!node) {
        return;
      }

      if (open && isTopModal()) {
        handleMounted();
      } else {
        ariaHidden(modalRef.current, true);
      }
    });
    var handleClose = React__namespace.useCallback(function () {
      manager.remove(getModal());
    }, [manager]);
    React__namespace.useEffect(function () {
      return function () {
        handleClose();
      };
    }, [handleClose]);
    React__namespace.useEffect(function () {
      if (open) {
        handleOpen();
      } else if (!hasTransition || !closeAfterTransition) {
        handleClose();
      }
    }, [open, handleClose, hasTransition, closeAfterTransition, handleOpen]);

    var ownerState = _extends$b({}, props, {
      classes: classesProp,
      closeAfterTransition: closeAfterTransition,
      disableAutoFocus: disableAutoFocus,
      disableEnforceFocus: disableEnforceFocus,
      disableEscapeKeyDown: disableEscapeKeyDown,
      disablePortal: disablePortal,
      disableRestoreFocus: disableRestoreFocus,
      disableScrollLock: disableScrollLock,
      exited: exited,
      hideBackdrop: hideBackdrop,
      keepMounted: keepMounted
    });

    var classes = useUtilityClasses$1i(ownerState);

    if (!keepMounted && !open && (!hasTransition || exited)) {
      return null;
    }

    var handleEnter = function handleEnter() {
      setExited(false);

      if (onTransitionEnter) {
        onTransitionEnter();
      }
    };

    var handleExited = function handleExited() {
      setExited(true);

      if (onTransitionExited) {
        onTransitionExited();
      }

      if (closeAfterTransition) {
        handleClose();
      }
    };

    var handleBackdropClick = function handleBackdropClick(event) {
      if (event.target !== event.currentTarget) {
        return;
      }

      if (onBackdropClick) {
        onBackdropClick(event);
      }

      if (onClose) {
        onClose(event, 'backdropClick');
      }
    };

    var handleKeyDown = function handleKeyDown(event) {
      if (onKeyDown) {
        onKeyDown(event);
      } // The handler doesn't take event.defaultPrevented into account:
      //
      // event.preventDefault() is meant to stop default behaviors like
      // clicking a checkbox to check it, hitting a button to submit a form,
      // and hitting left arrow to move the cursor in a text input etc.
      // Only special HTML elements have these default behaviors.


      if (event.key !== 'Escape' || !isTopModal()) {
        return;
      }

      if (!disableEscapeKeyDown) {
        // Swallow the event, in case someone is listening for the escape key on the body.
        event.stopPropagation();

        if (onClose) {
          onClose(event, 'escapeKeyDown');
        }
      }
    };

    var childProps = {};

    if (children.props.tabIndex === undefined) {
      childProps.tabIndex = '-1';
    } // It's a Transition like component


    if (hasTransition) {
      childProps.onEnter = createChainedFunction(handleEnter, children.props.onEnter);
      childProps.onExited = createChainedFunction(handleExited, children.props.onExited);
    }

    var Root = components.Root || component;
    var rootProps = componentsProps.root || {};
    return /*#__PURE__*/jsxRuntime$1.jsx(Portal$1, {
      ref: handlePortalRef,
      container: container,
      disablePortal: disablePortal,
      children: /*#__PURE__*/jsxRuntime$1.jsxs(Root, _extends$b({
        role: "presentation"
      }, rootProps, !isHostComponent(Root) && {
        as: component,
        ownerState: _extends$b({}, ownerState, rootProps.ownerState),
        theme: theme
      }, other, {
        ref: handleRef,
        onKeyDown: handleKeyDown,
        className: clsx(classes.root, rootProps.className, className),
        children: [!hideBackdrop && BackdropComponent ? /*#__PURE__*/jsxRuntime$1.jsx(BackdropComponent, _extends$b({
          open: open,
          onClick: handleBackdropClick
        }, BackdropProps)) : null, /*#__PURE__*/jsxRuntime$1.jsx(Unstable_TrapFocus, {
          disableEnforceFocus: disableEnforceFocus,
          disableAutoFocus: disableAutoFocus,
          disableRestoreFocus: disableRestoreFocus,
          isEnabled: isTopModal,
          open: open,
          children: /*#__PURE__*/React__namespace.cloneElement(children, childProps)
        })]
      }))
    });
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var ModalUnstyled$1 = ModalUnstyled;

  function NoSsr(props) {
    var children = props.children,
        _props$defer = props.defer,
        defer = _props$defer === void 0 ? false : _props$defer,
        _props$fallback = props.fallback,
        fallback = _props$fallback === void 0 ? null : _props$fallback;

    var _React__namespace$use19 = React__namespace.useState(false),
        _React__namespace$use20 = _slicedToArray(_React__namespace$use19, 2),
        mountedState = _React__namespace$use20[0],
        setMountedState = _React__namespace$use20[1];

    useEnhancedEffect$1(function () {
      if (!defer) {
        setMountedState(true);
      }
    }, [defer]);
    React__namespace.useEffect(function () {
      if (defer) {
        setMountedState(true);
      }
    }, [defer]); // We need the Fragment here to force react-docgen to recognise NoSsr as a component.

    return /*#__PURE__*/jsxRuntime$1.jsx(React__namespace.Fragment, {
      children: mountedState ? children : fallback
    });
  }

  process.env.NODE_ENV !== "production" ? void 0 : void 0;

  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line
    NoSsr['propTypes' + ''] = exactProp(NoSsr.propTypes);
  }

  var top$1 = 'top';
  var bottom$1 = 'bottom';
  var right$1 = 'right';
  var left$1 = 'left';
  var auto = 'auto';
  var basePlacements = [top$1, bottom$1, right$1, left$1];
  var start = 'start';
  var end = 'end';
  var clippingParents = 'clippingParents';
  var viewport = 'viewport';
  var popper = 'popper';
  var reference = 'reference';
  var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
    return acc.concat([placement + "-" + start, placement + "-" + end]);
  }, []);
  var placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
    return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
  }, []); // modifiers that need to read the DOM

  var beforeRead = 'beforeRead';
  var read = 'read';
  var afterRead = 'afterRead'; // pure-logic modifiers

  var beforeMain = 'beforeMain';
  var main = 'main';
  var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

  var beforeWrite = 'beforeWrite';
  var write = 'write';
  var afterWrite = 'afterWrite';
  var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];

  function getNodeName(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
  }

  function getWindow$1(node) {
    if (node == null) {
      return window;
    }

    if (node.toString() !== '[object Window]') {
      var ownerDocument = node.ownerDocument;
      return ownerDocument ? ownerDocument.defaultView || window : window;
    }

    return node;
  }

  function isElement(node) {
    var OwnElement = getWindow$1(node).Element;
    return node instanceof OwnElement || node instanceof Element;
  }

  function isHTMLElement$1(node) {
    var OwnElement = getWindow$1(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
  }

  function isShadowRoot(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') {
      return false;
    }

    var OwnElement = getWindow$1(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
  } // and applies them to the HTMLElements such as popper and arrow


  function applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function (name) {
      var style = state.styles[name] || {};
      var attributes = state.attributes[name] || {};
      var element = state.elements[name]; // arrow is optional + virtual elements

      if (!isHTMLElement$1(element) || !getNodeName(element)) {
        return;
      } // Flow doesn't support to extend this property, but it's the most
      // effective way to apply styles to an HTMLElement
      // $FlowFixMe[cannot-write]


      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (name) {
        var value = attributes[name];

        if (value === false) {
          element.removeAttribute(name);
        } else {
          element.setAttribute(name, value === true ? '' : value);
        }
      });
    });
  }

  function effect$2(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
      popper: {
        position: state.options.strategy,
        left: '0',
        top: '0',
        margin: '0'
      },
      arrow: {
        position: 'absolute'
      },
      reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;

    if (state.elements.arrow) {
      Object.assign(state.elements.arrow.style, initialStyles.arrow);
    }

    return function () {
      Object.keys(state.elements).forEach(function (name) {
        var element = state.elements[name];
        var attributes = state.attributes[name] || {};
        var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

        var style = styleProperties.reduce(function (style, property) {
          style[property] = '';
          return style;
        }, {}); // arrow is optional + virtual elements

        if (!isHTMLElement$1(element) || !getNodeName(element)) {
          return;
        }

        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function (attribute) {
          element.removeAttribute(attribute);
        });
      });
    };
  } // eslint-disable-next-line import/no-unused-modules


  var applyStyles$1 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: applyStyles,
    effect: effect$2,
    requires: ['computeStyles']
  };

  function getBasePlacement(placement) {
    return placement.split('-')[0];
  }

  var max = Math.max;
  var min = Math.min;
  var round$2 = Math.round;

  function getBoundingClientRect(element, includeScale) {
    if (includeScale === void 0) {
      includeScale = false;
    }

    var rect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;

    if (isHTMLElement$1(element) && includeScale) {
      var offsetHeight = element.offsetHeight;
      var offsetWidth = element.offsetWidth; // Do not attempt to divide by 0, otherwise we get `Infinity` as scale
      // Fallback to 1 in case both values are `0`

      if (offsetWidth > 0) {
        scaleX = round$2(rect.width) / offsetWidth || 1;
      }

      if (offsetHeight > 0) {
        scaleY = round$2(rect.height) / offsetHeight || 1;
      }
    }

    return {
      width: rect.width / scaleX,
      height: rect.height / scaleY,
      top: rect.top / scaleY,
      right: rect.right / scaleX,
      bottom: rect.bottom / scaleY,
      left: rect.left / scaleX,
      x: rect.left / scaleX,
      y: rect.top / scaleY
    };
  } // means it doesn't take into account transforms.


  function getLayoutRect(element) {
    var clientRect = getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223

    var width = element.offsetWidth;
    var height = element.offsetHeight;

    if (Math.abs(clientRect.width - width) <= 1) {
      width = clientRect.width;
    }

    if (Math.abs(clientRect.height - height) <= 1) {
      height = clientRect.height;
    }

    return {
      x: element.offsetLeft,
      y: element.offsetTop,
      width: width,
      height: height
    };
  }

  function contains(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

    if (parent.contains(child)) {
      return true;
    } // then fallback to custom implementation with Shadow DOM support
    else if (rootNode && isShadowRoot(rootNode)) {
      var next = child;

      do {
        if (next && parent.isSameNode(next)) {
          return true;
        } // $FlowFixMe[prop-missing]: need a better way to handle this...


        next = next.parentNode || next.host;
      } while (next);
    } // Give up, the result is false


    return false;
  }

  function getComputedStyle$2(element) {
    return getWindow$1(element).getComputedStyle(element);
  }

  function isTableElement(element) {
    return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
  }

  function getDocumentElement(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return ((isElement(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
    element.document) || window.document).documentElement;
  }

  function getParentNode(element) {
    if (getNodeName(element) === 'html') {
      return element;
    }

    return (// this is a quicker (but less type safe) way to save quite some bytes from the bundle
      // $FlowFixMe[incompatible-return]
      // $FlowFixMe[prop-missing]
      element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
      element.parentNode || ( // DOM Element detected
      isShadowRoot(element) ? element.host : null) || // ShadowRoot detected
      // $FlowFixMe[incompatible-call]: HTMLElement is a Node
      getDocumentElement(element) // fallback

    );
  }

  function getTrueOffsetParent(element) {
    if (!isHTMLElement$1(element) || // https://github.com/popperjs/popper-core/issues/837
    getComputedStyle$2(element).position === 'fixed') {
      return null;
    }

    return element.offsetParent;
  } // `.offsetParent` reports `null` for fixed elements, while absolute elements
  // return the containing block


  function getContainingBlock(element) {
    var isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') !== -1;
    var isIE = navigator.userAgent.indexOf('Trident') !== -1;

    if (isIE && isHTMLElement$1(element)) {
      // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
      var elementCss = getComputedStyle$2(element);

      if (elementCss.position === 'fixed') {
        return null;
      }
    }

    var currentNode = getParentNode(element);

    while (isHTMLElement$1(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
      var css = getComputedStyle$2(currentNode); // This is non-exhaustive but covers the most common CSS properties that
      // create a containing block.
      // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

      if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
        return currentNode;
      } else {
        currentNode = currentNode.parentNode;
      }
    }

    return null;
  } // Gets the closest ancestor positioned element. Handles some edge cases,
  // such as table ancestors and cross browser bugs.


  function getOffsetParent(element) {
    var window = getWindow$1(element);
    var offsetParent = getTrueOffsetParent(element);

    while (offsetParent && isTableElement(offsetParent) && getComputedStyle$2(offsetParent).position === 'static') {
      offsetParent = getTrueOffsetParent(offsetParent);
    }

    if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle$2(offsetParent).position === 'static')) {
      return window;
    }

    return offsetParent || getContainingBlock(element) || window;
  }

  function getMainAxisFromPlacement(placement) {
    return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
  }

  function within(min$1, value, max$1) {
    return max(min$1, min(value, max$1));
  }

  function withinMaxClamp(min, value, max) {
    var v = within(min, value, max);
    return v > max ? max : v;
  }

  function getFreshSideObject() {
    return {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    };
  }

  function mergePaddingObject(paddingObject) {
    return Object.assign({}, getFreshSideObject(), paddingObject);
  }

  function expandToHashMap(value, keys) {
    return keys.reduce(function (hashMap, key) {
      hashMap[key] = value;
      return hashMap;
    }, {});
  }

  var toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
      placement: state.placement
    })) : padding;
    return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
  };

  function arrow(_ref) {
    var _state$modifiersData$;

    var state = _ref.state,
        name = _ref.name,
        options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = getBasePlacement(state.placement);
    var axis = getMainAxisFromPlacement(basePlacement);
    var isVertical = [left$1, right$1].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';

    if (!arrowElement || !popperOffsets) {
      return;
    }

    var paddingObject = toPaddingObject(options.padding, state);
    var arrowRect = getLayoutRect(arrowElement);
    var minProp = axis === 'y' ? top$1 : left$1;
    var maxProp = axis === 'y' ? bottom$1 : right$1;
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = getOffsetParent(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds

    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = within(min, center, max); // Prevents breaking syntax highlighting...

    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
  }

  function effect$1(_ref2) {
    var state = _ref2.state,
        options = _ref2.options;
    var _options$element = options.element,
        arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;

    if (arrowElement == null) {
      return;
    } // CSS selector


    if (typeof arrowElement === 'string') {
      arrowElement = state.elements.popper.querySelector(arrowElement);

      if (!arrowElement) {
        return;
      }
    }

    if (process.env.NODE_ENV !== "production") {
      if (!isHTMLElement$1(arrowElement)) {
        console.error(['Popper: "arrow" element must be an HTMLElement (not an SVGElement).', 'To use an SVG arrow, wrap it in an HTMLElement that will be used as', 'the arrow.'].join(' '));
      }
    }

    if (!contains(state.elements.popper, arrowElement)) {
      if (process.env.NODE_ENV !== "production") {
        console.error(['Popper: "arrow" modifier\'s `element` must be a child of the popper', 'element.'].join(' '));
      }

      return;
    }

    state.elements.arrow = arrowElement;
  } // eslint-disable-next-line import/no-unused-modules


  var arrow$1 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: arrow,
    effect: effect$1,
    requires: ['popperOffsets'],
    requiresIfExists: ['preventOverflow']
  };

  function getVariation(placement) {
    return placement.split('-')[1];
  }

  var unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
  }; // Round the offsets to the nearest suitable subpixel based on the DPR.
  // Zooming can change the DPR, but it seems to report a value that will
  // cleanly divide the values into the appropriate subpixels.

  function roundOffsetsByDPR(_ref) {
    var x = _ref.x,
        y = _ref.y;
    var win = window;
    var dpr = win.devicePixelRatio || 1;
    return {
      x: round$2(x * dpr) / dpr || 0,
      y: round$2(y * dpr) / dpr || 0
    };
  }

  function mapToStyles(_ref2) {
    var _Object$assign2;

    var popper = _ref2.popper,
        popperRect = _ref2.popperRect,
        placement = _ref2.placement,
        variation = _ref2.variation,
        offsets = _ref2.offsets,
        position = _ref2.position,
        gpuAcceleration = _ref2.gpuAcceleration,
        adaptive = _ref2.adaptive,
        roundOffsets = _ref2.roundOffsets,
        isFixed = _ref2.isFixed;

    var _ref3 = roundOffsets === true ? roundOffsetsByDPR(offsets) : typeof roundOffsets === 'function' ? roundOffsets(offsets) : offsets,
        _ref3$x = _ref3.x,
        x = _ref3$x === void 0 ? 0 : _ref3$x,
        _ref3$y = _ref3.y,
        y = _ref3$y === void 0 ? 0 : _ref3$y;

    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = left$1;
    var sideY = top$1;
    var win = window;

    if (adaptive) {
      var offsetParent = getOffsetParent(popper);
      var heightProp = 'clientHeight';
      var widthProp = 'clientWidth';

      if (offsetParent === getWindow$1(popper)) {
        offsetParent = getDocumentElement(popper);

        if (getComputedStyle$2(offsetParent).position !== 'static' && position === 'absolute') {
          heightProp = 'scrollHeight';
          widthProp = 'scrollWidth';
        }
      } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it


      offsetParent = offsetParent;

      if (placement === top$1 || (placement === left$1 || placement === right$1) && variation === end) {
        sideY = bottom$1;
        var offsetY = isFixed && win.visualViewport ? win.visualViewport.height : // $FlowFixMe[prop-missing]
        offsetParent[heightProp];
        y -= offsetY - popperRect.height;
        y *= gpuAcceleration ? 1 : -1;
      }

      if (placement === left$1 || (placement === top$1 || placement === bottom$1) && variation === end) {
        sideX = right$1;
        var offsetX = isFixed && win.visualViewport ? win.visualViewport.width : // $FlowFixMe[prop-missing]
        offsetParent[widthProp];
        x -= offsetX - popperRect.width;
        x *= gpuAcceleration ? 1 : -1;
      }
    }

    var commonStyles = Object.assign({
      position: position
    }, adaptive && unsetSides);

    if (gpuAcceleration) {
      var _Object$assign;

      return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }

    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
  }

  function computeStyles(_ref4) {
    var state = _ref4.state,
        options = _ref4.options;
    var _options$gpuAccelerat = options.gpuAcceleration,
        gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
        _options$adaptive = options.adaptive,
        adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
        _options$roundOffsets = options.roundOffsets,
        roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;

    if (process.env.NODE_ENV !== "production") {
      var transitionProperty = getComputedStyle$2(state.elements.popper).transitionProperty || '';

      if (adaptive && ['transform', 'top', 'right', 'bottom', 'left'].some(function (property) {
        return transitionProperty.indexOf(property) >= 0;
      })) {
        console.warn(['Popper: Detected CSS transitions on at least one of the following', 'CSS properties: "transform", "top", "right", "bottom", "left".', '\n\n', 'Disable the "computeStyles" modifier\'s `adaptive` option to allow', 'for smooth transitions, or remove these properties from the CSS', 'transition declaration on the popper element if only transitioning', 'opacity or background-color for example.', '\n\n', 'We recommend using the popper element as a wrapper around an inner', 'element that can have any CSS property transitioned for animations.'].join(' '));
      }
    }

    var commonStyles = {
      placement: getBasePlacement(state.placement),
      variation: getVariation(state.placement),
      popper: state.elements.popper,
      popperRect: state.rects.popper,
      gpuAcceleration: gpuAcceleration,
      isFixed: state.options.strategy === 'fixed'
    };

    if (state.modifiersData.popperOffsets != null) {
      state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
      })));
    }

    if (state.modifiersData.arrow != null) {
      state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
      })));
    }

    state.attributes.popper = Object.assign({}, state.attributes.popper, {
      'data-popper-placement': state.placement
    });
  } // eslint-disable-next-line import/no-unused-modules


  var computeStyles$1 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: computeStyles,
    data: {}
  };
  var passive = {
    passive: true
  };

  function effect(_ref) {
    var state = _ref.state,
        instance = _ref.instance,
        options = _ref.options;
    var _options$scroll = options.scroll,
        scroll = _options$scroll === void 0 ? true : _options$scroll,
        _options$resize = options.resize,
        resize = _options$resize === void 0 ? true : _options$resize;
    var window = getWindow$1(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);

    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, passive);
      });
    }

    if (resize) {
      window.addEventListener('resize', instance.update, passive);
    }

    return function () {
      if (scroll) {
        scrollParents.forEach(function (scrollParent) {
          scrollParent.removeEventListener('scroll', instance.update, passive);
        });
      }

      if (resize) {
        window.removeEventListener('resize', instance.update, passive);
      }
    };
  } // eslint-disable-next-line import/no-unused-modules


  var eventListeners = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: effect,
    data: {}
  };
  var hash$2 = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
  };

  function getOppositePlacement(placement) {
    return placement.replace(/left|right|bottom|top/g, function (matched) {
      return hash$2[matched];
    });
  }

  var hash$1 = {
    start: 'end',
    end: 'start'
  };

  function getOppositeVariationPlacement(placement) {
    return placement.replace(/start|end/g, function (matched) {
      return hash$1[matched];
    });
  }

  function getWindowScroll(node) {
    var win = getWindow$1(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
      scrollLeft: scrollLeft,
      scrollTop: scrollTop
    };
  }

  function getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
  }

  function getViewportRect(element) {
    var win = getWindow$1(element);
    var html = getDocumentElement(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0; // NB: This isn't supported on iOS <= 12. If the keyboard is open, the popper
    // can be obscured underneath it.
    // Also, `html.clientHeight` adds the bottom bar height in Safari iOS, even
    // if it isn't open, so if this isn't available, the popper will be detected
    // to overflow the bottom of the screen too early.

    if (visualViewport) {
      width = visualViewport.width;
      height = visualViewport.height; // Uses Layout Viewport (like Chrome; Safari does not currently)
      // In Chrome, it returns a value very close to 0 (+/-) but contains rounding
      // errors due to floating point numbers, so we need to check precision.
      // Safari returns a number <= 0, usually < -1 when pinch-zoomed
      // Feature detection fails in mobile emulation mode in Chrome.
      // Math.abs(win.innerWidth / visualViewport.scale - visualViewport.width) <
      // 0.001
      // Fallback here: "Not Safari" userAgent

      if (!/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
        x = visualViewport.offsetLeft;
        y = visualViewport.offsetTop;
      }
    }

    return {
      width: width,
      height: height,
      x: x + getWindowScrollBarX(element),
      y: y
    };
  } // of the `<html>` and `<body>` rect bounds if horizontally scrollable


  function getDocumentRect(element) {
    var _element$ownerDocumen;

    var html = getDocumentElement(element);
    var winScroll = getWindowScroll(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
    var y = -winScroll.scrollTop;

    if (getComputedStyle$2(body || html).direction === 'rtl') {
      x += max(html.clientWidth, body ? body.clientWidth : 0) - width;
    }

    return {
      width: width,
      height: height,
      x: x,
      y: y
    };
  }

  function isScrollParent(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = getComputedStyle$2(element),
        overflow = _getComputedStyle.overflow,
        overflowX = _getComputedStyle.overflowX,
        overflowY = _getComputedStyle.overflowY;

    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
  }

  function getScrollParent(node) {
    if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
      // $FlowFixMe[incompatible-return]: assume body is always available
      return node.ownerDocument.body;
    }

    if (isHTMLElement$1(node) && isScrollParent(node)) {
      return node;
    }

    return getScrollParent(getParentNode(node));
  }
  /*
  given a DOM element, return the list of all scroll parents, up the list of ancesors
  until we get to the top window object. This list is what we attach scroll listeners
  to, because if any of these parent elements scroll, we'll need to re-calculate the
  reference element's position.
  */


  function listScrollParents(element, list) {
    var _element$ownerDocumen;

    if (list === void 0) {
      list = [];
    }

    var scrollParent = getScrollParent(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = getWindow$1(scrollParent);
    var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    updatedList.concat(listScrollParents(getParentNode(target)));
  }

  function rectToClientRect(rect) {
    return Object.assign({}, rect, {
      left: rect.x,
      top: rect.y,
      right: rect.x + rect.width,
      bottom: rect.y + rect.height
    });
  }

  function getInnerBoundingClientRect(element) {
    var rect = getBoundingClientRect(element);
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
  }

  function getClientRectFromMixedType(element, clippingParent) {
    return clippingParent === viewport ? rectToClientRect(getViewportRect(element)) : isElement(clippingParent) ? getInnerBoundingClientRect(clippingParent) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
  } // A "clipping parent" is an overflowable container with the characteristic of
  // clipping (or hiding) overflowing elements with a position different from
  // `initial`


  function getClippingParents(element) {
    var clippingParents = listScrollParents(getParentNode(element));
    var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle$2(element).position) >= 0;
    var clipperElement = canEscapeClipping && isHTMLElement$1(element) ? getOffsetParent(element) : element;

    if (!isElement(clipperElement)) {
      return [];
    } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414


    return clippingParents.filter(function (clippingParent) {
      return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body' && (canEscapeClipping ? getComputedStyle$2(clippingParent).position !== 'static' : true);
    });
  } // Gets the maximum area that the element is visible in due to any number of
  // clipping parents


  function getClippingRect(element, boundary, rootBoundary) {
    var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
      var rect = getClientRectFromMixedType(element, clippingParent);
      accRect.top = max(rect.top, accRect.top);
      accRect.right = min(rect.right, accRect.right);
      accRect.bottom = min(rect.bottom, accRect.bottom);
      accRect.left = max(rect.left, accRect.left);
      return accRect;
    }, getClientRectFromMixedType(element, firstClippingParent));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
  }

  function computeOffsets(_ref) {
    var reference = _ref.reference,
        element = _ref.element,
        placement = _ref.placement;
    var basePlacement = placement ? getBasePlacement(placement) : null;
    var variation = placement ? getVariation(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;

    switch (basePlacement) {
      case top$1:
        offsets = {
          x: commonX,
          y: reference.y - element.height
        };
        break;

      case bottom$1:
        offsets = {
          x: commonX,
          y: reference.y + reference.height
        };
        break;

      case right$1:
        offsets = {
          x: reference.x + reference.width,
          y: commonY
        };
        break;

      case left$1:
        offsets = {
          x: reference.x - element.width,
          y: commonY
        };
        break;

      default:
        offsets = {
          x: reference.x,
          y: reference.y
        };
    }

    var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;

    if (mainAxis != null) {
      var len = mainAxis === 'y' ? 'height' : 'width';

      switch (variation) {
        case start:
          offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
          break;

        case end:
          offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
          break;
      }
    }

    return offsets;
  }

  function detectOverflow(state, options) {
    if (options === void 0) {
      options = {};
    }

    var _options = options,
        _options$placement = _options.placement,
        placement = _options$placement === void 0 ? state.placement : _options$placement,
        _options$boundary = _options.boundary,
        boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
        _options$rootBoundary = _options.rootBoundary,
        rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
        _options$elementConte = _options.elementContext,
        elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
        _options$altBoundary = _options.altBoundary,
        altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
        _options$padding = _options.padding,
        padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
    var altContext = elementContext === popper ? reference : popper;
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary);
    var referenceClientRect = getBoundingClientRect(state.elements.reference);
    var popperOffsets = computeOffsets({
      reference: referenceClientRect,
      element: popperRect,
      strategy: 'absolute',
      placement: placement
    });
    var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect

    var overflowOffsets = {
      top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
      bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
      left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
      right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

    if (elementContext === popper && offsetData) {
      var offset = offsetData[placement];
      Object.keys(overflowOffsets).forEach(function (key) {
        var multiply = [right$1, bottom$1].indexOf(key) >= 0 ? 1 : -1;
        var axis = [top$1, bottom$1].indexOf(key) >= 0 ? 'y' : 'x';
        overflowOffsets[key] += offset[axis] * multiply;
      });
    }

    return overflowOffsets;
  }

  function computeAutoPlacement(state, options) {
    if (options === void 0) {
      options = {};
    }

    var _options = options,
        placement = _options.placement,
        boundary = _options.boundary,
        rootBoundary = _options.rootBoundary,
        padding = _options.padding,
        flipVariations = _options.flipVariations,
        _options$allowedAutoP = _options.allowedAutoPlacements,
        allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
    var variation = getVariation(placement);
    var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
      return getVariation(placement) === variation;
    }) : basePlacements;
    var allowedPlacements = placements$1.filter(function (placement) {
      return allowedAutoPlacements.indexOf(placement) >= 0;
    });

    if (allowedPlacements.length === 0) {
      allowedPlacements = placements$1;

      if (process.env.NODE_ENV !== "production") {
        console.error(['Popper: The `allowedAutoPlacements` option did not allow any', 'placements. Ensure the `placement` option matches the variation', 'of the allowed placements.', 'For example, "auto" cannot be used to allow "bottom-start".', 'Use "auto-start" instead.'].join(' '));
      }
    } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...


    var overflows = allowedPlacements.reduce(function (acc, placement) {
      acc[placement] = detectOverflow(state, {
        placement: placement,
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding
      })[getBasePlacement(placement)];
      return acc;
    }, {});
    return Object.keys(overflows).sort(function (a, b) {
      return overflows[a] - overflows[b];
    });
  }

  function getExpandedFallbackPlacements(placement) {
    if (getBasePlacement(placement) === auto) {
      return [];
    }

    var oppositePlacement = getOppositePlacement(placement);
    return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
  }

  function flip(_ref) {
    var state = _ref.state,
        options = _ref.options,
        name = _ref.name;

    if (state.modifiersData[name]._skip) {
      return;
    }

    var _options$mainAxis = options.mainAxis,
        checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
        _options$altAxis = options.altAxis,
        checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
        specifiedFallbackPlacements = options.fallbackPlacements,
        padding = options.padding,
        boundary = options.boundary,
        rootBoundary = options.rootBoundary,
        altBoundary = options.altBoundary,
        _options$flipVariatio = options.flipVariations,
        flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
        allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = getBasePlacement(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
    var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
      return acc.concat(getBasePlacement(placement) === auto ? computeAutoPlacement(state, {
        placement: placement,
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        flipVariations: flipVariations,
        allowedAutoPlacements: allowedAutoPlacements
      }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];

    for (var i = 0; i < placements.length; i++) {
      var placement = placements[i];

      var _basePlacement = getBasePlacement(placement);

      var isStartVariation = getVariation(placement) === start;
      var isVertical = [top$1, bottom$1].indexOf(_basePlacement) >= 0;
      var len = isVertical ? 'width' : 'height';
      var overflow = detectOverflow(state, {
        placement: placement,
        boundary: boundary,
        rootBoundary: rootBoundary,
        altBoundary: altBoundary,
        padding: padding
      });
      var mainVariationSide = isVertical ? isStartVariation ? right$1 : left$1 : isStartVariation ? bottom$1 : top$1;

      if (referenceRect[len] > popperRect[len]) {
        mainVariationSide = getOppositePlacement(mainVariationSide);
      }

      var altVariationSide = getOppositePlacement(mainVariationSide);
      var checks = [];

      if (checkMainAxis) {
        checks.push(overflow[_basePlacement] <= 0);
      }

      if (checkAltAxis) {
        checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
      }

      if (checks.every(function (check) {
        return check;
      })) {
        firstFittingPlacement = placement;
        makeFallbackChecks = false;
        break;
      }

      checksMap.set(placement, checks);
    }

    if (makeFallbackChecks) {
      // `2` may be desired in some cases – research later
      var numberOfChecks = flipVariations ? 3 : 1;

      var _loop = function _loop(_i) {
        var fittingPlacement = placements.find(function (placement) {
          var checks = checksMap.get(placement);

          if (checks) {
            return checks.slice(0, _i).every(function (check) {
              return check;
            });
          }
        });

        if (fittingPlacement) {
          firstFittingPlacement = fittingPlacement;
          return "break";
        }
      };

      for (var _i = numberOfChecks; _i > 0; _i--) {
        var _ret = _loop(_i);

        if (_ret === "break") break;
      }
    }

    if (state.placement !== firstFittingPlacement) {
      state.modifiersData[name]._skip = true;
      state.placement = firstFittingPlacement;
      state.reset = true;
    }
  } // eslint-disable-next-line import/no-unused-modules


  var flip$1 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: flip,
    requiresIfExists: ['offset'],
    data: {
      _skip: false
    }
  };

  function getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) {
      preventedOffsets = {
        x: 0,
        y: 0
      };
    }

    return {
      top: overflow.top - rect.height - preventedOffsets.y,
      right: overflow.right - rect.width + preventedOffsets.x,
      bottom: overflow.bottom - rect.height + preventedOffsets.y,
      left: overflow.left - rect.width - preventedOffsets.x
    };
  }

  function isAnySideFullyClipped(overflow) {
    return [top$1, right$1, bottom$1, left$1].some(function (side) {
      return overflow[side] >= 0;
    });
  }

  function hide(_ref) {
    var state = _ref.state,
        name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = detectOverflow(state, {
      elementContext: 'reference'
    });
    var popperAltOverflow = detectOverflow(state, {
      altBoundary: true
    });
    var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
      referenceClippingOffsets: referenceClippingOffsets,
      popperEscapeOffsets: popperEscapeOffsets,
      isReferenceHidden: isReferenceHidden,
      hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
      'data-popper-reference-hidden': isReferenceHidden,
      'data-popper-escaped': hasPopperEscaped
    });
  } // eslint-disable-next-line import/no-unused-modules


  var hide$1 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: ['preventOverflow'],
    fn: hide
  };

  function distanceAndSkiddingToXY(placement, rects, offset) {
    var basePlacement = getBasePlacement(placement);
    var invertDistance = [left$1, top$1].indexOf(basePlacement) >= 0 ? -1 : 1;

    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
      placement: placement
    })) : offset,
        skidding = _ref[0],
        distance = _ref[1];

    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [left$1, right$1].indexOf(basePlacement) >= 0 ? {
      x: distance,
      y: skidding
    } : {
      x: skidding,
      y: distance
    };
  }

  function offset$1(_ref2) {
    var state = _ref2.state,
        options = _ref2.options,
        name = _ref2.name;
    var _options$offset = options.offset,
        offset = _options$offset === void 0 ? [0, 0] : _options$offset;
    var data = placements.reduce(function (acc, placement) {
      acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
      return acc;
    }, {});
    var _data$state$placement = data[state.placement],
        x = _data$state$placement.x,
        y = _data$state$placement.y;

    if (state.modifiersData.popperOffsets != null) {
      state.modifiersData.popperOffsets.x += x;
      state.modifiersData.popperOffsets.y += y;
    }

    state.modifiersData[name] = data;
  } // eslint-disable-next-line import/no-unused-modules


  var offset$2 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: ['popperOffsets'],
    fn: offset$1
  };

  function popperOffsets(_ref) {
    var state = _ref.state,
        name = _ref.name; // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step

    state.modifiersData[name] = computeOffsets({
      reference: state.rects.reference,
      element: state.rects.popper,
      strategy: 'absolute',
      placement: state.placement
    });
  } // eslint-disable-next-line import/no-unused-modules


  var popperOffsets$1 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: popperOffsets,
    data: {}
  };

  function getAltAxis(axis) {
    return axis === 'x' ? 'y' : 'x';
  }

  function preventOverflow(_ref) {
    var state = _ref.state,
        options = _ref.options,
        name = _ref.name;
    var _options$mainAxis = options.mainAxis,
        checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
        _options$altAxis = options.altAxis,
        checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
        boundary = options.boundary,
        rootBoundary = options.rootBoundary,
        altBoundary = options.altBoundary,
        padding = options.padding,
        _options$tether = options.tether,
        tether = _options$tether === void 0 ? true : _options$tether,
        _options$tetherOffset = options.tetherOffset,
        tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = detectOverflow(state, {
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      altBoundary: altBoundary
    });
    var basePlacement = getBasePlacement(state.placement);
    var variation = getVariation(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = getMainAxisFromPlacement(basePlacement);
    var altAxis = getAltAxis(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
      placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
      mainAxis: tetherOffsetValue,
      altAxis: tetherOffsetValue
    } : Object.assign({
      mainAxis: 0,
      altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
      x: 0,
      y: 0
    };

    if (!popperOffsets) {
      return;
    }

    if (checkMainAxis) {
      var _offsetModifierState$;

      var mainSide = mainAxis === 'y' ? top$1 : left$1;
      var altSide = mainAxis === 'y' ? bottom$1 : right$1;
      var len = mainAxis === 'y' ? 'height' : 'width';
      var offset = popperOffsets[mainAxis];
      var min$1 = offset + overflow[mainSide];
      var max$1 = offset - overflow[altSide];
      var additive = tether ? -popperRect[len] / 2 : 0;
      var minLen = variation === start ? referenceRect[len] : popperRect[len];
      var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
      // outside the reference bounds

      var arrowElement = state.elements.arrow;
      var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
        width: 0,
        height: 0
      };
      var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
      var arrowPaddingMin = arrowPaddingObject[mainSide];
      var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
      // to include its full size in the calculation. If the reference is small
      // and near the edge of a boundary, the popper can overflow even if the
      // reference is not overflowing as well (e.g. virtual elements with no
      // width or height)

      var arrowLen = within(0, referenceRect[len], arrowRect[len]);
      var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
      var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
      var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
      var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
      var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
      var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
      var tetherMax = offset + maxOffset - offsetModifierValue;
      var preventedOffset = within(tether ? min(min$1, tetherMin) : min$1, offset, tether ? max(max$1, tetherMax) : max$1);
      popperOffsets[mainAxis] = preventedOffset;
      data[mainAxis] = preventedOffset - offset;
    }

    if (checkAltAxis) {
      var _offsetModifierState$2;

      var _mainSide = mainAxis === 'x' ? top$1 : left$1;

      var _altSide = mainAxis === 'x' ? bottom$1 : right$1;

      var _offset = popperOffsets[altAxis];

      var _len = altAxis === 'y' ? 'height' : 'width';

      var _min = _offset + overflow[_mainSide];

      var _max = _offset - overflow[_altSide];

      var isOriginSide = [top$1, left$1].indexOf(basePlacement) !== -1;

      var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;

      var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;

      var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;

      var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);

      popperOffsets[altAxis] = _preventedOffset;
      data[altAxis] = _preventedOffset - _offset;
    }

    state.modifiersData[name] = data;
  } // eslint-disable-next-line import/no-unused-modules


  var preventOverflow$1 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: preventOverflow,
    requiresIfExists: ['offset']
  };

  function getHTMLElementScroll(element) {
    return {
      scrollLeft: element.scrollLeft,
      scrollTop: element.scrollTop
    };
  }

  function getNodeScroll(node) {
    if (node === getWindow$1(node) || !isHTMLElement$1(node)) {
      return getWindowScroll(node);
    } else {
      return getHTMLElementScroll(node);
    }
  }

  function isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = round$2(rect.width) / element.offsetWidth || 1;
    var scaleY = round$2(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
  } // Returns the composite rect of an element relative to its offsetParent.
  // Composite means it takes into account transforms as well as layout.


  function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) {
      isFixed = false;
    }

    var isOffsetParentAnElement = isHTMLElement$1(offsetParent);
    var offsetParentIsScaled = isHTMLElement$1(offsetParent) && isElementScaled(offsetParent);
    var documentElement = getDocumentElement(offsetParent);
    var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled);
    var scroll = {
      scrollLeft: 0,
      scrollTop: 0
    };
    var offsets = {
      x: 0,
      y: 0
    };

    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
      if (getNodeName(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
      isScrollParent(documentElement)) {
        scroll = getNodeScroll(offsetParent);
      }

      if (isHTMLElement$1(offsetParent)) {
        offsets = getBoundingClientRect(offsetParent, true);
        offsets.x += offsetParent.clientLeft;
        offsets.y += offsetParent.clientTop;
      } else if (documentElement) {
        offsets.x = getWindowScrollBarX(documentElement);
      }
    }

    return {
      x: rect.left + scroll.scrollLeft - offsets.x,
      y: rect.top + scroll.scrollTop - offsets.y,
      width: rect.width,
      height: rect.height
    };
  }

  function order$1(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function (modifier) {
      map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively

    function sort(modifier) {
      visited.add(modifier.name);
      var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
      requires.forEach(function (dep) {
        if (!visited.has(dep)) {
          var depModifier = map.get(dep);

          if (depModifier) {
            sort(depModifier);
          }
        }
      });
      result.push(modifier);
    }

    modifiers.forEach(function (modifier) {
      if (!visited.has(modifier.name)) {
        // check for visited object
        sort(modifier);
      }
    });
    return result;
  }

  function orderModifiers(modifiers) {
    // order based on dependencies
    var orderedModifiers = order$1(modifiers); // order based on phase

    return modifierPhases.reduce(function (acc, phase) {
      return acc.concat(orderedModifiers.filter(function (modifier) {
        return modifier.phase === phase;
      }));
    }, []);
  }

  function debounce(fn) {
    var pending;
    return function () {
      if (!pending) {
        pending = new Promise(function (resolve) {
          Promise.resolve().then(function () {
            pending = undefined;
            resolve(fn());
          });
        });
      }

      return pending;
    };
  }

  function format$1(str) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return [].concat(args).reduce(function (p, c) {
      return p.replace(/%s/, c);
    }, str);
  }

  var INVALID_MODIFIER_ERROR = 'Popper: modifier "%s" provided an invalid %s property, expected %s but got %s';
  var MISSING_DEPENDENCY_ERROR = 'Popper: modifier "%s" requires "%s", but "%s" modifier is not available';
  var VALID_PROPERTIES = ['name', 'enabled', 'phase', 'fn', 'effect', 'requires', 'options'];

  function validateModifiers(modifiers) {
    modifiers.forEach(function (modifier) {
      [].concat(Object.keys(modifier), VALID_PROPERTIES) // IE11-compatible replacement for `new Set(iterable)`
      .filter(function (value, index, self) {
        return self.indexOf(value) === index;
      }).forEach(function (key) {
        switch (key) {
          case 'name':
            if (typeof modifier.name !== 'string') {
              console.error(format$1(INVALID_MODIFIER_ERROR, String(modifier.name), '"name"', '"string"', "\"" + String(modifier.name) + "\""));
            }

            break;

          case 'enabled':
            if (typeof modifier.enabled !== 'boolean') {
              console.error(format$1(INVALID_MODIFIER_ERROR, modifier.name, '"enabled"', '"boolean"', "\"" + String(modifier.enabled) + "\""));
            }

            break;

          case 'phase':
            if (modifierPhases.indexOf(modifier.phase) < 0) {
              console.error(format$1(INVALID_MODIFIER_ERROR, modifier.name, '"phase"', "either " + modifierPhases.join(', '), "\"" + String(modifier.phase) + "\""));
            }

            break;

          case 'fn':
            if (typeof modifier.fn !== 'function') {
              console.error(format$1(INVALID_MODIFIER_ERROR, modifier.name, '"fn"', '"function"', "\"" + String(modifier.fn) + "\""));
            }

            break;

          case 'effect':
            if (modifier.effect != null && typeof modifier.effect !== 'function') {
              console.error(format$1(INVALID_MODIFIER_ERROR, modifier.name, '"effect"', '"function"', "\"" + String(modifier.fn) + "\""));
            }

            break;

          case 'requires':
            if (modifier.requires != null && !Array.isArray(modifier.requires)) {
              console.error(format$1(INVALID_MODIFIER_ERROR, modifier.name, '"requires"', '"array"', "\"" + String(modifier.requires) + "\""));
            }

            break;

          case 'requiresIfExists':
            if (!Array.isArray(modifier.requiresIfExists)) {
              console.error(format$1(INVALID_MODIFIER_ERROR, modifier.name, '"requiresIfExists"', '"array"', "\"" + String(modifier.requiresIfExists) + "\""));
            }

            break;

          case 'options':
          case 'data':
            break;

          default:
            console.error("PopperJS: an invalid property has been provided to the \"" + modifier.name + "\" modifier, valid properties are " + VALID_PROPERTIES.map(function (s) {
              return "\"" + s + "\"";
            }).join(', ') + "; but \"" + key + "\" was provided.");
        }

        modifier.requires && modifier.requires.forEach(function (requirement) {
          if (modifiers.find(function (mod) {
            return mod.name === requirement;
          }) == null) {
            console.error(format$1(MISSING_DEPENDENCY_ERROR, String(modifier.name), requirement, requirement));
          }
        });
      });
    });
  }

  function uniqueBy(arr, fn) {
    var identifiers = new Set();
    return arr.filter(function (item) {
      var identifier = fn(item);

      if (!identifiers.has(identifier)) {
        identifiers.add(identifier);
        return true;
      }
    });
  }

  function mergeByName(modifiers) {
    var merged = modifiers.reduce(function (merged, current) {
      var existing = merged[current.name];
      merged[current.name] = existing ? Object.assign({}, existing, current, {
        options: Object.assign({}, existing.options, current.options),
        data: Object.assign({}, existing.data, current.data)
      }) : current;
      return merged;
    }, {}); // IE11 does not support Object.values

    return Object.keys(merged).map(function (key) {
      return merged[key];
    });
  }

  var INVALID_ELEMENT_ERROR = 'Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.';
  var INFINITE_LOOP_ERROR = 'Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.';
  var DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
  };

  function areValidElements() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return !args.some(function (element) {
      return !(element && typeof element.getBoundingClientRect === 'function');
    });
  }

  function popperGenerator(generatorOptions) {
    if (generatorOptions === void 0) {
      generatorOptions = {};
    }

    var _generatorOptions = generatorOptions,
        _generatorOptions$def = _generatorOptions.defaultModifiers,
        defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
        _generatorOptions$def2 = _generatorOptions.defaultOptions,
        defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
      if (options === void 0) {
        options = defaultOptions;
      }

      var state = {
        placement: 'bottom',
        orderedModifiers: [],
        options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
        modifiersData: {},
        elements: {
          reference: reference,
          popper: popper
        },
        attributes: {},
        styles: {}
      };
      var effectCleanupFns = [];
      var isDestroyed = false;
      var instance = {
        state: state,
        setOptions: function setOptions(setOptionsAction) {
          var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
          cleanupModifierEffects();
          state.options = Object.assign({}, defaultOptions, state.options, options);
          state.scrollParents = {
            reference: isElement(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
            popper: listScrollParents(popper)
          }; // Orders the modifiers based on their dependencies and `phase`
          // properties

          var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

          state.orderedModifiers = orderedModifiers.filter(function (m) {
            return m.enabled;
          }); // Validate the provided modifiers so that the consumer will get warned
          // if one of the modifiers is invalid for any reason

          if (process.env.NODE_ENV !== "production") {
            var modifiers = uniqueBy([].concat(orderedModifiers, state.options.modifiers), function (_ref) {
              var name = _ref.name;
              return name;
            });
            validateModifiers(modifiers);

            if (getBasePlacement(state.options.placement) === auto) {
              var flipModifier = state.orderedModifiers.find(function (_ref2) {
                var name = _ref2.name;
                return name === 'flip';
              });

              if (!flipModifier) {
                console.error(['Popper: "auto" placements require the "flip" modifier be', 'present and enabled to work.'].join(' '));
              }
            }

            var _getComputedStyle = getComputedStyle$2(popper),
                marginTop = _getComputedStyle.marginTop,
                marginRight = _getComputedStyle.marginRight,
                marginBottom = _getComputedStyle.marginBottom,
                marginLeft = _getComputedStyle.marginLeft; // We no longer take into account `margins` on the popper, and it can
            // cause bugs with positioning, so we'll warn the consumer


            if ([marginTop, marginRight, marginBottom, marginLeft].some(function (margin) {
              return parseFloat(margin);
            })) {
              console.warn(['Popper: CSS "margin" styles cannot be used to apply padding', 'between the popper and its reference element or boundary.', 'To replicate margin, use the `offset` modifier, as well as', 'the `padding` option in the `preventOverflow` and `flip`', 'modifiers.'].join(' '));
            }
          }

          runModifierEffects();
          return instance.update();
        },
        // Sync update – it will always be executed, even if not necessary. This
        // is useful for low frequency updates where sync behavior simplifies the
        // logic.
        // For high frequency updates (e.g. `resize` and `scroll` events), always
        // prefer the async Popper#update method
        forceUpdate: function forceUpdate() {
          if (isDestroyed) {
            return;
          }

          var _state$elements = state.elements,
              reference = _state$elements.reference,
              popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
          // anymore

          if (!areValidElements(reference, popper)) {
            if (process.env.NODE_ENV !== "production") {
              console.error(INVALID_ELEMENT_ERROR);
            }

            return;
          } // Store the reference and popper rects to be read by modifiers


          state.rects = {
            reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
            popper: getLayoutRect(popper)
          }; // Modifiers have the ability to reset the current update cycle. The
          // most common use case for this is the `flip` modifier changing the
          // placement, which then needs to re-run all the modifiers, because the
          // logic was previously ran for the previous placement and is therefore
          // stale/incorrect

          state.reset = false;
          state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
          // is filled with the initial data specified by the modifier. This means
          // it doesn't persist and is fresh on each update.
          // To ensure persistent data, use `${name}#persistent`

          state.orderedModifiers.forEach(function (modifier) {
            return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
          });
          var __debug_loops__ = 0;

          for (var index = 0; index < state.orderedModifiers.length; index++) {
            if (process.env.NODE_ENV !== "production") {
              __debug_loops__ += 1;

              if (__debug_loops__ > 100) {
                console.error(INFINITE_LOOP_ERROR);
                break;
              }
            }

            if (state.reset === true) {
              state.reset = false;
              index = -1;
              continue;
            }

            var _state$orderedModifie = state.orderedModifiers[index],
                fn = _state$orderedModifie.fn,
                _state$orderedModifie2 = _state$orderedModifie.options,
                _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
                name = _state$orderedModifie.name;

            if (typeof fn === 'function') {
              state = fn({
                state: state,
                options: _options,
                name: name,
                instance: instance
              }) || state;
            }
          }
        },
        // Async and optimistically optimized update – it will not be executed if
        // not necessary (debounced to run at most once-per-tick)
        update: debounce(function () {
          return new Promise(function (resolve) {
            instance.forceUpdate();
            resolve(state);
          });
        }),
        destroy: function destroy() {
          cleanupModifierEffects();
          isDestroyed = true;
        }
      };

      if (!areValidElements(reference, popper)) {
        if (process.env.NODE_ENV !== "production") {
          console.error(INVALID_ELEMENT_ERROR);
        }

        return instance;
      }

      instance.setOptions(options).then(function (state) {
        if (!isDestroyed && options.onFirstUpdate) {
          options.onFirstUpdate(state);
        }
      }); // Modifiers have the ability to execute arbitrary code before the first
      // update cycle runs. They will be executed in the same order as the update
      // cycle. This is useful when a modifier adds some persistent data that
      // other modifiers need to use, but the modifier is run after the dependent
      // one.

      function runModifierEffects() {
        state.orderedModifiers.forEach(function (_ref3) {
          var name = _ref3.name,
              _ref3$options = _ref3.options,
              options = _ref3$options === void 0 ? {} : _ref3$options,
              effect = _ref3.effect;

          if (typeof effect === 'function') {
            var cleanupFn = effect({
              state: state,
              name: name,
              instance: instance,
              options: options
            });

            var noopFn = function noopFn() {};

            effectCleanupFns.push(cleanupFn || noopFn);
          }
        });
      }

      function cleanupModifierEffects() {
        effectCleanupFns.forEach(function (fn) {
          return fn();
        });
        effectCleanupFns = [];
      }

      return instance;
    };
  }

  var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$2, flip$1, preventOverflow$1, arrow$1, hide$1];
  var createPopper = /*#__PURE__*/popperGenerator({
    defaultModifiers: defaultModifiers
  }); // eslint-disable-next-line import/no-unused-modules

  var _excluded$1P = ["anchorEl", "children", "direction", "disablePortal", "modifiers", "open", "placement", "popperOptions", "popperRef", "TransitionProps"],
      _excluded2$6 = ["anchorEl", "children", "container", "direction", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "style", "transition"];

  function flipPlacement(placement, direction) {
    if (direction === 'ltr') {
      return placement;
    }

    switch (placement) {
      case 'bottom-end':
        return 'bottom-start';

      case 'bottom-start':
        return 'bottom-end';

      case 'top-end':
        return 'top-start';

      case 'top-start':
        return 'top-end';

      default:
        return placement;
    }
  }

  function resolveAnchorEl$1(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
  }

  var defaultPopperOptions = {};
  /* eslint-disable react/prop-types */

  var PopperTooltip = /*#__PURE__*/React__namespace.forwardRef(function PopperTooltip(props, ref) {
    var anchorEl = props.anchorEl,
        children = props.children,
        direction = props.direction,
        disablePortal = props.disablePortal,
        modifiers = props.modifiers,
        open = props.open,
        initialPlacement = props.placement,
        popperOptions = props.popperOptions,
        popperRefProp = props.popperRef,
        TransitionProps = props.TransitionProps,
        other = _objectWithoutPropertiesLoose$5(props, _excluded$1P);

    var tooltipRef = React__namespace.useRef(null);
    var ownRef = useForkRef(tooltipRef, ref);
    var popperRef = React__namespace.useRef(null);
    var handlePopperRef = useForkRef(popperRef, popperRefProp);
    var handlePopperRefRef = React__namespace.useRef(handlePopperRef);
    useEnhancedEffect$1(function () {
      handlePopperRefRef.current = handlePopperRef;
    }, [handlePopperRef]);
    React__namespace.useImperativeHandle(popperRefProp, function () {
      return popperRef.current;
    }, []);
    var rtlPlacement = flipPlacement(initialPlacement, direction);
    /**
     * placement initialized from prop but can change during lifetime if modifiers.flip.
     * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
     */

    var _React__namespace$use21 = React__namespace.useState(rtlPlacement),
        _React__namespace$use22 = _slicedToArray(_React__namespace$use21, 2),
        placement = _React__namespace$use22[0],
        setPlacement = _React__namespace$use22[1];

    React__namespace.useEffect(function () {
      if (popperRef.current) {
        popperRef.current.forceUpdate();
      }
    });
    useEnhancedEffect$1(function () {
      if (!anchorEl || !open) {
        return undefined;
      }

      var handlePopperUpdate = function handlePopperUpdate(data) {
        setPlacement(data.placement);
      };

      var resolvedAnchorEl = resolveAnchorEl$1(anchorEl);

      if (process.env.NODE_ENV !== 'production') {
        if (resolvedAnchorEl && resolvedAnchorEl.nodeType === 1) {
          var box = resolvedAnchorEl.getBoundingClientRect();

          if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
            console.warn(['MUI: The `anchorEl` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
          }
        }
      }

      var popperModifiers = [{
        name: 'preventOverflow',
        options: {
          altBoundary: disablePortal
        }
      }, {
        name: 'flip',
        options: {
          altBoundary: disablePortal
        }
      }, {
        name: 'onUpdate',
        enabled: true,
        phase: 'afterWrite',
        fn: function fn(_ref13) {
          var state = _ref13.state;
          handlePopperUpdate(state);
        }
      }];

      if (modifiers != null) {
        popperModifiers = popperModifiers.concat(modifiers);
      }

      if (popperOptions && popperOptions.modifiers != null) {
        popperModifiers = popperModifiers.concat(popperOptions.modifiers);
      }

      var popper = createPopper(resolveAnchorEl$1(anchorEl), tooltipRef.current, _extends$b({
        placement: rtlPlacement
      }, popperOptions, {
        modifiers: popperModifiers
      }));
      handlePopperRefRef.current(popper);
      return function () {
        popper.destroy();
        handlePopperRefRef.current(null);
      };
    }, [anchorEl, disablePortal, modifiers, open, popperOptions, rtlPlacement]);
    var childProps = {
      placement: placement
    };

    if (TransitionProps !== null) {
      childProps.TransitionProps = TransitionProps;
    }

    return /*#__PURE__*/jsxRuntime$1.jsx("div", _extends$b({
      ref: ownRef,
      role: "tooltip"
    }, other, {
      children: typeof children === 'function' ? children(childProps) : children
    }));
  });
  /* eslint-enable react/prop-types */

  /**
   * Poppers rely on the 3rd party library [Popper.js](https://popper.js.org/docs/v2/) for positioning.
   */

  var PopperUnstyled = /*#__PURE__*/React__namespace.forwardRef(function PopperUnstyled(props, ref) {
    var anchorEl = props.anchorEl,
        children = props.children,
        containerProp = props.container,
        _props$direction = props.direction,
        direction = _props$direction === void 0 ? 'ltr' : _props$direction,
        _props$disablePortal3 = props.disablePortal,
        disablePortal = _props$disablePortal3 === void 0 ? false : _props$disablePortal3,
        _props$keepMounted2 = props.keepMounted,
        keepMounted = _props$keepMounted2 === void 0 ? false : _props$keepMounted2,
        modifiers = props.modifiers,
        open = props.open,
        _props$placement = props.placement,
        placement = _props$placement === void 0 ? 'bottom' : _props$placement,
        _props$popperOptions = props.popperOptions,
        popperOptions = _props$popperOptions === void 0 ? defaultPopperOptions : _props$popperOptions,
        popperRef = props.popperRef,
        style = props.style,
        _props$transition = props.transition,
        transition = _props$transition === void 0 ? false : _props$transition,
        other = _objectWithoutPropertiesLoose$5(props, _excluded2$6);

    var _React__namespace$use23 = React__namespace.useState(true),
        _React__namespace$use24 = _slicedToArray(_React__namespace$use23, 2),
        exited = _React__namespace$use24[0],
        setExited = _React__namespace$use24[1];

    var handleEnter = function handleEnter() {
      setExited(false);
    };

    var handleExited = function handleExited() {
      setExited(true);
    };

    if (!keepMounted && !open && (!transition || exited)) {
      return null;
    } // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container


    var container = containerProp || (anchorEl ? ownerDocument(resolveAnchorEl$1(anchorEl)).body : undefined);
    return /*#__PURE__*/jsxRuntime$1.jsx(Portal$1, {
      disablePortal: disablePortal,
      container: container,
      children: /*#__PURE__*/jsxRuntime$1.jsx(PopperTooltip, _extends$b({
        anchorEl: anchorEl,
        direction: direction,
        disablePortal: disablePortal,
        modifiers: modifiers,
        ref: ref,
        open: transition ? !exited : open,
        placement: placement,
        popperOptions: popperOptions,
        popperRef: popperRef
      }, other, {
        style: _extends$b({
          // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
          position: 'fixed',
          // Fix Popper.js display issue
          top: 0,
          left: 0,
          display: !open && keepMounted && (!transition || exited) ? 'none' : null
        }, style),
        TransitionProps: transition ? {
          in: open,
          onEnter: handleEnter,
          onExited: handleExited
        } : null,
        children: children
      }))
    });
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var PopperUnstyled$1 = PopperUnstyled;
  var _excluded$1O = ["onChange", "maxRows", "minRows", "style", "value"];

  function getStyleValue(computedStyle, property) {
    return parseInt(computedStyle[property], 10) || 0;
  }

  var styles$8 = {
    shadow: {
      // Visibility needed to hide the extra text area on iPads
      visibility: 'hidden',
      // Remove from the content flow
      position: 'absolute',
      // Ignore the scrollbar width
      overflow: 'hidden',
      height: 0,
      top: 0,
      left: 0,
      // Create a new layer, increase the isolation of the computed values
      transform: 'translateZ(0)'
    }
  };
  var TextareaAutosize = /*#__PURE__*/React__namespace.forwardRef(function TextareaAutosize(props, ref) {
    var onChange = props.onChange,
        maxRows = props.maxRows,
        _props$minRows = props.minRows,
        minRows = _props$minRows === void 0 ? 1 : _props$minRows,
        style = props.style,
        value = props.value,
        other = _objectWithoutPropertiesLoose$5(props, _excluded$1O);

    var _React__namespace$use25 = React__namespace.useRef(value != null),
        isControlled = _React__namespace$use25.current;

    var inputRef = React__namespace.useRef(null);
    var handleRef = useForkRef(ref, inputRef);
    var shadowRef = React__namespace.useRef(null);
    var renders = React__namespace.useRef(0);

    var _React__namespace$use26 = React__namespace.useState({}),
        _React__namespace$use27 = _slicedToArray(_React__namespace$use26, 2),
        state = _React__namespace$use27[0],
        setState = _React__namespace$use27[1];

    var syncHeight = React__namespace.useCallback(function () {
      var input = inputRef.current;
      var containerWindow = ownerWindow(input);
      var computedStyle = containerWindow.getComputedStyle(input); // If input's width is shrunk and it's not visible, don't sync height.

      if (computedStyle.width === '0px') {
        return;
      }

      var inputShallow = shadowRef.current;
      inputShallow.style.width = computedStyle.width;
      inputShallow.value = input.value || props.placeholder || 'x';

      if (inputShallow.value.slice(-1) === '\n') {
        // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        inputShallow.value += ' ';
      }

      var boxSizing = computedStyle['box-sizing'];
      var padding = getStyleValue(computedStyle, 'padding-bottom') + getStyleValue(computedStyle, 'padding-top');
      var border = getStyleValue(computedStyle, 'border-bottom-width') + getStyleValue(computedStyle, 'border-top-width'); // The height of the inner content

      var innerHeight = inputShallow.scrollHeight; // Measure height of a textarea with a single row

      inputShallow.value = 'x';
      var singleRowHeight = inputShallow.scrollHeight; // The height of the outer content

      var outerHeight = innerHeight;

      if (minRows) {
        outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
      }

      if (maxRows) {
        outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
      }

      outerHeight = Math.max(outerHeight, singleRowHeight); // Take the box sizing into account for applying this value as a style.

      var outerHeightStyle = outerHeight + (boxSizing === 'border-box' ? padding + border : 0);
      var overflow = Math.abs(outerHeight - innerHeight) <= 1;
      setState(function (prevState) {
        // Need a large enough difference to update the height.
        // This prevents infinite rendering loop.
        if (renders.current < 20 && (outerHeightStyle > 0 && Math.abs((prevState.outerHeightStyle || 0) - outerHeightStyle) > 1 || prevState.overflow !== overflow)) {
          renders.current += 1;
          return {
            overflow: overflow,
            outerHeightStyle: outerHeightStyle
          };
        }

        if (process.env.NODE_ENV !== 'production') {
          if (renders.current === 20) {
            console.error(['MUI: Too many re-renders. The layout is unstable.', 'TextareaAutosize limits the number of renders to prevent an infinite loop.'].join('\n'));
          }
        }

        return prevState;
      });
    }, [maxRows, minRows, props.placeholder]);
    React__namespace.useEffect(function () {
      var handleResize = debounce$1(function () {
        renders.current = 0;
        syncHeight();
      });
      var containerWindow = ownerWindow(inputRef.current);
      containerWindow.addEventListener('resize', handleResize);
      var resizeObserver;

      if (typeof ResizeObserver !== 'undefined') {
        resizeObserver = new ResizeObserver(handleResize);
        resizeObserver.observe(inputRef.current);
      }

      return function () {
        handleResize.clear();
        containerWindow.removeEventListener('resize', handleResize);

        if (resizeObserver) {
          resizeObserver.disconnect();
        }
      };
    }, [syncHeight]);
    useEnhancedEffect$1(function () {
      syncHeight();
    });
    React__namespace.useEffect(function () {
      renders.current = 0;
    }, [value]);

    var handleChange = function handleChange(event) {
      renders.current = 0;

      if (!isControlled) {
        syncHeight();
      }

      if (onChange) {
        onChange(event);
      }
    };

    return /*#__PURE__*/jsxRuntime$1.jsxs(React__namespace.Fragment, {
      children: [/*#__PURE__*/jsxRuntime$1.jsx("textarea", _extends$b({
        value: value,
        onChange: handleChange,
        ref: handleRef // Apply the rows prop to get a "correct" first SSR paint
        ,
        rows: minRows,
        style: _extends$b({
          height: state.outerHeightStyle,
          // Need a large enough difference to allow scrolling.
          // This prevents infinite rendering loop.
          overflow: state.overflow ? 'hidden' : null
        }, style)
      }, other)), /*#__PURE__*/jsxRuntime$1.jsx("textarea", {
        "aria-hidden": true,
        className: props.className,
        readOnly: true,
        ref: shadowRef,
        tabIndex: -1,
        style: _extends$b({}, styles$8.shadow, style, {
          padding: 0
        })
      })]
    });
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var TextareaAutosize$1 = TextareaAutosize;

  function _extends$9() {
    _extends$9 = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends$9.apply(this, arguments);
  }

  function memoize$2(fn) {
    var cache = Object.create(null);
    return function (arg) {
      if (cache[arg] === undefined) cache[arg] = fn(arg);
      return cache[arg];
    };
  }

  var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

  var isPropValid = /* #__PURE__ */memoize$2(function (prop) {
    return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
    /* o */
    && prop.charCodeAt(1) === 110
    /* n */
    && prop.charCodeAt(2) < 91;
  }
  /* Z+1 */
  );
  /*
   Based off glamor's StyleSheet, thanks Sunil ❤️
   high performance StyleSheet for css-in-js systems
   - uses multiple style tags behind the scenes for millions of rules
  - uses `insertRule` for appending in production for *much* faster performance
   // usage
   import { StyleSheet } from '@emotion/sheet'
   let styleSheet = new StyleSheet({ key: '', container: document.head })
   styleSheet.insert('#box { border: 1px solid red; }')
  - appends a css rule into the stylesheet
   styleSheet.flush()
  - empties the stylesheet of all its contents
   */
  // $FlowFixMe

  function sheetForTag(tag) {
    if (tag.sheet) {
      // $FlowFixMe
      return tag.sheet;
    } // this weirdness brought to you by firefox

    /* istanbul ignore next */


    for (var i = 0; i < document.styleSheets.length; i++) {
      if (document.styleSheets[i].ownerNode === tag) {
        // $FlowFixMe
        return document.styleSheets[i];
      }
    }
  }

  function createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);

    if (options.nonce !== undefined) {
      tag.setAttribute('nonce', options.nonce);
    }

    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
  }

  var StyleSheet = /*#__PURE__*/function () {
    function StyleSheet(options) {
      var _this = this;

      this._insertTag = function (tag) {
        var before;

        if (_this.tags.length === 0) {
          if (_this.insertionPoint) {
            before = _this.insertionPoint.nextSibling;
          } else if (_this.prepend) {
            before = _this.container.firstChild;
          } else {
            before = _this.before;
          }
        } else {
          before = _this.tags[_this.tags.length - 1].nextSibling;
        }

        _this.container.insertBefore(tag, before);

        _this.tags.push(tag);
      };

      this.isSpeedy = options.speedy === undefined ? process.env.NODE_ENV === 'production' : options.speedy;
      this.tags = [];
      this.ctr = 0;
      this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

      this.key = options.key;
      this.container = options.container;
      this.prepend = options.prepend;
      this.insertionPoint = options.insertionPoint;
      this.before = null;
    }

    var _proto = StyleSheet.prototype;

    _proto.hydrate = function hydrate(nodes) {
      nodes.forEach(this._insertTag);
    };

    _proto.insert = function insert(rule) {
      // the max length is how many rules we have per style tag, it's 65000 in speedy mode
      // it's 1 in dev because we insert source maps that map a single rule to a location
      // and you can only have one source map per style tag
      if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
        this._insertTag(createStyleElement(this));
      }

      var tag = this.tags[this.tags.length - 1];

      if (process.env.NODE_ENV !== 'production') {
        var isImportRule = rule.charCodeAt(0) === 64 && rule.charCodeAt(1) === 105;

        if (isImportRule && this._alreadyInsertedOrderInsensitiveRule) {
          // this would only cause problem in speedy mode
          // but we don't want enabling speedy to affect the observable behavior
          // so we report this error at all times
          console.error("You're attempting to insert the following rule:\n" + rule + '\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules.');
        }

        this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !isImportRule;
      }

      if (this.isSpeedy) {
        var sheet = sheetForTag(tag);

        try {
          // this is the ultrafast version, works across browsers
          // the big drawback is that the css won't be editable in devtools
          sheet.insertRule(rule, sheet.cssRules.length);
        } catch (e) {
          if (process.env.NODE_ENV !== 'production' && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear){/.test(rule)) {
            console.error("There was a problem inserting the following rule: \"" + rule + "\"", e);
          }
        }
      } else {
        tag.appendChild(document.createTextNode(rule));
      }

      this.ctr++;
    };

    _proto.flush = function flush() {
      // $FlowFixMe
      this.tags.forEach(function (tag) {
        return tag.parentNode && tag.parentNode.removeChild(tag);
      });
      this.tags = [];
      this.ctr = 0;

      if (process.env.NODE_ENV !== 'production') {
        this._alreadyInsertedOrderInsensitiveRule = false;
      }
    };

    return StyleSheet;
  }();

  var MS = '-ms-';
  var MOZ = '-moz-';
  var WEBKIT = '-webkit-';
  var COMMENT = 'comm';
  var RULESET = 'rule';
  var DECLARATION = 'decl';
  var IMPORT = '@import';
  var KEYFRAMES = '@keyframes';
  /**
   * @param {number}
   * @return {number}
   */

  var abs = Math.abs;
  /**
   * @param {number}
   * @return {string}
   */

  var from = String.fromCharCode;
  /**
   * @param {string} value
   * @param {number} length
   * @return {number}
   */

  function hash(value, length) {
    return (((length << 2 ^ charat(value, 0)) << 2 ^ charat(value, 1)) << 2 ^ charat(value, 2)) << 2 ^ charat(value, 3);
  }
  /**
   * @param {string} value
   * @return {string}
   */


  function trim$1(value) {
    return value.trim();
  }
  /**
   * @param {string} value
   * @param {RegExp} pattern
   * @return {string?}
   */


  function match$2(value, pattern) {
    return (value = pattern.exec(value)) ? value[0] : value;
  }
  /**
   * @param {string} value
   * @param {(string|RegExp)} pattern
   * @param {string} replacement
   * @return {string}
   */


  function replace(value, pattern, replacement) {
    return value.replace(pattern, replacement);
  }
  /**
   * @param {string} value
   * @param {string} value
   * @return {number}
   */


  function indexof(value, search) {
    return value.indexOf(search);
  }
  /**
   * @param {string} value
   * @param {number} index
   * @return {number}
   */


  function charat(value, index) {
    return value.charCodeAt(index) | 0;
  }
  /**
   * @param {string} value
   * @param {number} begin
   * @param {number} end
   * @return {string}
   */


  function substr(value, begin, end) {
    return value.slice(begin, end);
  }
  /**
   * @param {string} value
   * @return {number}
   */


  function strlen(value) {
    return value.length;
  }
  /**
   * @param {any[]} value
   * @return {number}
   */


  function sizeof(value) {
    return value.length;
  }
  /**
   * @param {any} value
   * @param {any[]} array
   * @return {any}
   */


  function append$1(value, array) {
    return array.push(value), value;
  }
  /**
   * @param {string[]} array
   * @param {function} callback
   * @return {string}
   */


  function combine(array, callback) {
    return array.map(callback).join('');
  }

  var line = 1;
  var column = 1;
  var length = 0;
  var position$1 = 0;
  var character = 0;
  var characters = '';
  /**
   * @param {string} value
   * @param {object} root
   * @param {object?} parent
   * @param {string} type
   * @param {string[]} props
   * @param {object[]} children
   * @param {number} length
   */

  function node(value, root, parent, type, props, children, length) {
    return {
      value: value,
      root: root,
      parent: parent,
      type: type,
      props: props,
      children: children,
      line: line,
      column: column,
      length: length,
      return: ''
    };
  }
  /**
   * @param {string} value
   * @param {object} root
   * @param {string} type
   */


  function copy(value, root, type) {
    return node(value, root.root, root.parent, type, root.props, root.children, 0);
  }
  /**
   * @return {number}
   */


  function char() {
    return character;
  }
  /**
   * @return {number}
   */


  function prev$1() {
    character = position$1 > 0 ? charat(characters, --position$1) : 0;
    if (column--, character === 10) column = 1, line--;
    return character;
  }
  /**
   * @return {number}
   */


  function next$1() {
    character = position$1 < length ? charat(characters, position$1++) : 0;
    if (column++, character === 10) column = 1, line++;
    return character;
  }
  /**
   * @return {number}
   */


  function peek() {
    return charat(characters, position$1);
  }
  /**
   * @return {number}
   */


  function caret() {
    return position$1;
  }
  /**
   * @param {number} begin
   * @param {number} end
   * @return {string}
   */


  function slice(begin, end) {
    return substr(characters, begin, end);
  }
  /**
   * @param {number} type
   * @return {number}
   */


  function token(type) {
    switch (type) {
      // \0 \t \n \r \s whitespace token
      case 0:
      case 9:
      case 10:
      case 13:
      case 32:
        return 5;
      // ! + , / > @ ~ isolate token

      case 33:
      case 43:
      case 44:
      case 47:
      case 62:
      case 64:
      case 126: // ; { } breakpoint token

      case 59:
      case 123:
      case 125:
        return 4;
      // : accompanied token

      case 58:
        return 3;
      // " ' ( [ opening delimit token

      case 34:
      case 39:
      case 40:
      case 91:
        return 2;
      // ) ] closing delimit token

      case 41:
      case 93:
        return 1;
    }

    return 0;
  }
  /**
   * @param {string} value
   * @return {any[]}
   */


  function alloc(value) {
    return line = column = 1, length = strlen(characters = value), position$1 = 0, [];
  }
  /**
   * @param {any} value
   * @return {any}
   */


  function dealloc(value) {
    return characters = '', value;
  }
  /**
   * @param {number} type
   * @return {string}
   */


  function delimit(type) {
    return trim$1(slice(position$1 - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)));
  }
  /**
   * @param {number} type
   * @return {string}
   */


  function whitespace(type) {
    while (character = peek()) {
      if (character < 33) next$1();else break;
    }

    return token(type) > 2 || token(character) > 3 ? '' : ' ';
  }
  /**
   * @param {number} index
   * @param {number} count
   * @return {string}
   */


  function escaping(index, count) {
    while (--count && next$1()) {
      // not 0-9 A-F a-f
      if (character < 48 || character > 102 || character > 57 && character < 65 || character > 70 && character < 97) break;
    }

    return slice(index, caret() + (count < 6 && peek() == 32 && next$1() == 32));
  }
  /**
   * @param {number} type
   * @return {number}
   */


  function delimiter(type) {
    while (next$1()) {
      switch (character) {
        // ] ) " '
        case type:
          return position$1;
        // " '

        case 34:
        case 39:
          return delimiter(type === 34 || type === 39 ? type : character);
        // (

        case 40:
          if (type === 41) delimiter(type);
          break;
        // \

        case 92:
          next$1();
          break;
      }
    }

    return position$1;
  }
  /**
   * @param {number} type
   * @param {number} index
   * @return {number}
   */


  function commenter(type, index) {
    while (next$1()) {
      // //
      if (type + character === 47 + 10) break; // /*
      else if (type + character === 42 + 42 && peek() === 47) break;
    }

    return '/*' + slice(index, position$1 - 1) + '*' + from(type === 47 ? type : next$1());
  }
  /**
   * @param {number} index
   * @return {string}
   */


  function identifier(index) {
    while (!token(peek())) {
      next$1();
    }

    return slice(index, position$1);
  }
  /**
   * @param {string} value
   * @return {object[]}
   */


  function compile(value) {
    return dealloc(parse$1('', null, null, null, [''], value = alloc(value), 0, [0], value));
  }
  /**
   * @param {string} value
   * @param {object} root
   * @param {object?} parent
   * @param {string[]} rule
   * @param {string[]} rules
   * @param {string[]} rulesets
   * @param {number[]} pseudo
   * @param {number[]} points
   * @param {string[]} declarations
   * @return {object}
   */


  function parse$1(value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
    var index = 0;
    var offset = 0;
    var length = pseudo;
    var atrule = 0;
    var property = 0;
    var previous = 0;
    var variable = 1;
    var scanning = 1;
    var ampersand = 1;
    var character = 0;
    var type = '';
    var props = rules;
    var children = rulesets;
    var reference = rule;
    var characters = type;

    while (scanning) {
      switch (previous = character, character = next$1()) {
        // " ' [ (
        case 34:
        case 39:
        case 91:
        case 40:
          characters += delimit(character);
          break;
        // \t \n \r \s

        case 9:
        case 10:
        case 13:
        case 32:
          characters += whitespace(previous);
          break;
        // \

        case 92:
          characters += escaping(caret() - 1, 7);
          continue;
        // /

        case 47:
          switch (peek()) {
            case 42:
            case 47:
              append$1(comment(commenter(next$1(), caret()), root, parent), declarations);
              break;

            default:
              characters += '/';
          }

          break;
        // {

        case 123 * variable:
          points[index++] = strlen(characters) * ampersand;
        // } ; \0

        case 125 * variable:
        case 59:
        case 0:
          switch (character) {
            // \0 }
            case 0:
            case 125:
              scanning = 0;
            // ;

            case 59 + offset:
              if (property > 0 && strlen(characters) - length) append$1(property > 32 ? declaration(characters + ';', rule, parent, length - 1) : declaration(replace(characters, ' ', '') + ';', rule, parent, length - 2), declarations);
              break;
            // @ ;

            case 59:
              characters += ';';
            // { rule/at-rule

            default:
              append$1(reference = ruleset(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets);
              if (character === 123) if (offset === 0) parse$1(characters, root, reference, reference, props, rulesets, length, points, children);else switch (atrule) {
                // d m s
                case 100:
                case 109:
                case 115:
                  parse$1(value, reference, reference, rule && append$1(ruleset(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children);
                  break;

                default:
                  parse$1(characters, reference, reference, reference, [''], children, length, points, children);
              }
          }

          index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
          break;
        // :

        case 58:
          length = 1 + strlen(characters), property = previous;

        default:
          if (variable < 1) if (character == 123) --variable;else if (character == 125 && variable++ == 0 && prev$1() == 125) continue;

          switch (characters += from(character), character * variable) {
            // &
            case 38:
              ampersand = offset > 0 ? 1 : (characters += '\f', -1);
              break;
            // ,

            case 44:
              points[index++] = (strlen(characters) - 1) * ampersand, ampersand = 1;
              break;
            // @

            case 64:
              // -
              if (peek() === 45) characters += delimit(next$1());
              atrule = peek(), offset = strlen(type = characters += identifier(caret())), character++;
              break;
            // -

            case 45:
              if (previous === 45 && strlen(characters) == 2) variable = 0;
          }

      }
    }

    return rulesets;
  }
  /**
   * @param {string} value
   * @param {object} root
   * @param {object?} parent
   * @param {number} index
   * @param {number} offset
   * @param {string[]} rules
   * @param {number[]} points
   * @param {string} type
   * @param {string[]} props
   * @param {string[]} children
   * @param {number} length
   * @return {object}
   */


  function ruleset(value, root, parent, index, offset, rules, points, type, props, children, length) {
    var post = offset - 1;
    var rule = offset === 0 ? rules : [''];
    var size = sizeof(rule);

    for (var i = 0, j = 0, k = 0; i < index; ++i) {
      for (var x = 0, y = substr(value, post + 1, post = abs(j = points[i])), z = value; x < size; ++x) {
        if (z = trim$1(j > 0 ? rule[x] + ' ' + y : replace(y, /&\f/g, rule[x]))) props[k++] = z;
      }
    }

    return node(value, root, parent, offset === 0 ? RULESET : type, props, children, length);
  }
  /**
   * @param {number} value
   * @param {object} root
   * @param {object?} parent
   * @return {object}
   */


  function comment(value, root, parent) {
    return node(value, root, parent, COMMENT, from(char()), substr(value, 2, -2), 0);
  }
  /**
   * @param {string} value
   * @param {object} root
   * @param {object?} parent
   * @param {number} length
   * @return {object}
   */


  function declaration(value, root, parent, length) {
    return node(value, root, parent, DECLARATION, substr(value, 0, length), substr(value, length + 1, -1), length);
  }
  /**
   * @param {string} value
   * @param {number} length
   * @return {string}
   */


  function prefix(value, length) {
    switch (hash(value, length)) {
      // color-adjust
      case 5103:
        return WEBKIT + 'print-' + value + value;
      // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)

      case 5737:
      case 4201:
      case 3177:
      case 3433:
      case 1641:
      case 4457:
      case 2921: // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break

      case 5572:
      case 6356:
      case 5844:
      case 3191:
      case 6645:
      case 3005: // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,

      case 6391:
      case 5879:
      case 5623:
      case 6135:
      case 4599:
      case 4855: // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)

      case 4215:
      case 6389:
      case 5109:
      case 5365:
      case 5621:
      case 3829:
        return WEBKIT + value + value;
      // appearance, user-select, transform, hyphens, text-size-adjust

      case 5349:
      case 4246:
      case 4810:
      case 6968:
      case 2756:
        return WEBKIT + value + MOZ + value + MS + value + value;
      // flex, flex-direction

      case 6828:
      case 4268:
        return WEBKIT + value + MS + value + value;
      // order

      case 6165:
        return WEBKIT + value + MS + 'flex-' + value + value;
      // align-items

      case 5187:
        return WEBKIT + value + replace(value, /(\w+).+(:[^]+)/, WEBKIT + 'box-$1$2' + MS + 'flex-$1$2') + value;
      // align-self

      case 5443:
        return WEBKIT + value + MS + 'flex-item-' + replace(value, /flex-|-self/, '') + value;
      // align-content

      case 4675:
        return WEBKIT + value + MS + 'flex-line-pack' + replace(value, /align-content|flex-|-self/, '') + value;
      // flex-shrink

      case 5548:
        return WEBKIT + value + MS + replace(value, 'shrink', 'negative') + value;
      // flex-basis

      case 5292:
        return WEBKIT + value + MS + replace(value, 'basis', 'preferred-size') + value;
      // flex-grow

      case 6060:
        return WEBKIT + 'box-' + replace(value, '-grow', '') + WEBKIT + value + MS + replace(value, 'grow', 'positive') + value;
      // transition

      case 4554:
        return WEBKIT + replace(value, /([^-])(transform)/g, '$1' + WEBKIT + '$2') + value;
      // cursor

      case 6187:
        return replace(replace(replace(value, /(zoom-|grab)/, WEBKIT + '$1'), /(image-set)/, WEBKIT + '$1'), value, '') + value;
      // background, background-image

      case 5495:
      case 3959:
        return replace(value, /(image-set\([^]*)/, WEBKIT + '$1' + '$`$1');
      // justify-content

      case 4968:
        return replace(replace(value, /(.+:)(flex-)?(.*)/, WEBKIT + 'box-pack:$3' + MS + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + WEBKIT + value + value;
      // (margin|padding)-inline-(start|end)

      case 4095:
      case 3583:
      case 4068:
      case 2532:
        return replace(value, /(.+)-inline(.+)/, WEBKIT + '$1$2') + value;
      // (min|max)?(width|height|inline-size|block-size)

      case 8116:
      case 7059:
      case 5753:
      case 5535:
      case 5445:
      case 5701:
      case 4933:
      case 4677:
      case 5533:
      case 5789:
      case 5021:
      case 4765:
        // stretch, max-content, min-content, fill-available
        if (strlen(value) - 1 - length > 6) switch (charat(value, length + 1)) {
          // (m)ax-content, (m)in-content
          case 109:
            // -
            if (charat(value, length + 4) !== 45) break;
          // (f)ill-available, (f)it-content

          case 102:
            return replace(value, /(.+:)(.+)-([^]+)/, '$1' + WEBKIT + '$2-$3' + '$1' + MOZ + (charat(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
          // (s)tretch

          case 115:
            return ~indexof(value, 'stretch') ? prefix(replace(value, 'stretch', 'fill-available'), length) + value : value;
        }
        break;
      // position: sticky

      case 4949:
        // (s)ticky?
        if (charat(value, length + 1) !== 115) break;
      // display: (flex|inline-flex)

      case 6444:
        switch (charat(value, strlen(value) - 3 - (~indexof(value, '!important') && 10))) {
          // stic(k)y
          case 107:
            return replace(value, ':', ':' + WEBKIT) + value;
          // (inline-)?fl(e)x

          case 101:
            return replace(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + WEBKIT + (charat(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + WEBKIT + '$2$3' + '$1' + MS + '$2box$3') + value;
        }

        break;
      // writing-mode

      case 5936:
        switch (charat(value, length + 11)) {
          // vertical-l(r)
          case 114:
            return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
          // vertical-r(l)

          case 108:
            return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
          // horizontal(-)tb

          case 45:
            return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
        }

        return WEBKIT + value + MS + value + value;
    }

    return value;
  }
  /**
   * @param {object[]} children
   * @param {function} callback
   * @return {string}
   */


  function serialize(children, callback) {
    var output = '';
    var length = sizeof(children);

    for (var i = 0; i < length; i++) {
      output += callback(children[i], i, children, callback) || '';
    }

    return output;
  }
  /**
   * @param {object} element
   * @param {number} index
   * @param {object[]} children
   * @param {function} callback
   * @return {string}
   */


  function stringify(element, index, children, callback) {
    switch (element.type) {
      case IMPORT:
      case DECLARATION:
        return element.return = element.return || element.value;

      case COMMENT:
        return '';

      case RULESET:
        element.value = element.props.join(',');
    }

    return strlen(children = serialize(element.children, callback)) ? element.return = element.value + '{' + children + '}' : '';
  }
  /**
   * @param {function[]} collection
   * @return {function}
   */


  function middleware(collection) {
    var length = sizeof(collection);
    return function (element, index, children, callback) {
      var output = '';

      for (var i = 0; i < length; i++) {
        output += collection[i](element, index, children, callback) || '';
      }

      return output;
    };
  }
  /**
   * @param {function} callback
   * @return {function}
   */


  function rulesheet(callback) {
    return function (element) {
      if (!element.root) if (element = element.return) callback(element);
    };
  }
  /**
   * @param {object} element
   * @param {number} index
   * @param {object[]} children
   * @param {function} callback
   */


  function prefixer(element, index, children, callback) {
    if (!element.return) switch (element.type) {
      case DECLARATION:
        element.return = prefix(element.value, element.length);
        break;

      case KEYFRAMES:
        return serialize([copy(replace(element.value, '@', '@' + WEBKIT), element, '')], callback);

      case RULESET:
        if (element.length) return combine(element.props, function (value) {
          switch (match$2(value, /(::plac\w+|:read-\w+)/)) {
            // :read-(only|write)
            case ':read-only':
            case ':read-write':
              return serialize([copy(replace(value, /:(read-\w+)/, ':' + MOZ + '$1'), element, '')], callback);
            // :placeholder

            case '::placeholder':
              return serialize([copy(replace(value, /:(plac\w+)/, ':' + WEBKIT + 'input-$1'), element, ''), copy(replace(value, /:(plac\w+)/, ':' + MOZ + '$1'), element, ''), copy(replace(value, /:(plac\w+)/, MS + 'input-$1'), element, '')], callback);
          }

          return '';
        });
    }
  }

  var weakMemoize = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function (arg) {
      if (cache.has(arg)) {
        // $FlowFixMe
        return cache.get(arg);
      }

      var ret = func(arg);
      cache.set(arg, ret);
      return ret;
    };
  };

  var last = function last(arr) {
    return arr.length ? arr[arr.length - 1] : null;
  }; // based on https://github.com/thysultan/stylis.js/blob/e6843c373ebcbbfade25ebcc23f540ed8508da0a/src/Tokenizer.js#L239-L244


  var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;

    while (true) {
      previous = character;
      character = peek(); // &\f

      if (previous === 38 && character === 12) {
        points[index] = 1;
      }

      if (token(character)) {
        break;
      }

      next$1();
    }

    return slice(begin, position$1);
  };

  var toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;

    do {
      switch (token(character)) {
        case 0:
          // &\f
          if (character === 38 && peek() === 12) {
            // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
          }

          parsed[index] += identifierWithPointTracking(position$1 - 1, points, index);
          break;

        case 2:
          parsed[index] += delimit(character);
          break;

        case 4:
          // comma
          if (character === 44) {
            // colon
            parsed[++index] = peek() === 58 ? '&\f' : '';
            points[index] = parsed[index].length;
            break;
          }

        // fallthrough

        default:
          parsed[index] += from(character);
      }
    } while (character = next$1());

    return parsed;
  };

  var getRules = function getRules(value, points) {
    return dealloc(toRules(alloc(value), points));
  }; // WeakSet would be more appropriate, but only WeakMap is supported in IE11


  var fixedElements = /* #__PURE__ */new WeakMap();

  var compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // .length indicates if this rule contains pseudo or not
    !element.length) {
      return;
    }

    var value = element.value,
        parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;

    while (parent.type !== 'rule') {
      parent = parent.parent;
      if (!parent) return;
    } // short-circuit for the simplest case


    if (element.props.length === 1 && value.charCodeAt(0) !== 58
    /* colon */
    && !fixedElements.get(parent)) {
      return;
    } // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"


    if (isImplicitRule) {
      return;
    }

    fixedElements.set(element, true);
    var points = [];
    var rules = getRules(value, points);
    var parentRules = parent.props;

    for (var i = 0, k = 0; i < rules.length; i++) {
      for (var j = 0; j < parentRules.length; j++, k++) {
        element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
      }
    }
  };

  var removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
      var value = element.value;

      if ( // charcode for l
      value.charCodeAt(0) === 108 && // charcode for b
      value.charCodeAt(2) === 98) {
        // this ignores label
        element["return"] = '';
        element.value = '';
      }
    }
  };

  var ignoreFlag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';

  var isIgnoringComment = function isIgnoringComment(element) {
    return !!element && element.type === 'comm' && element.children.indexOf(ignoreFlag) > -1;
  };

  var createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function (element, index, children) {
      if (element.type !== 'rule') return;
      var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);

      if (unsafePseudoClasses && cache.compat !== true) {
        var prevElement = index > 0 ? children[index - 1] : null;

        if (prevElement && isIgnoringComment(last(prevElement.children))) {
          return;
        }

        unsafePseudoClasses.forEach(function (unsafePseudoClass) {
          console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
        });
      }
    };
  };

  var isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
  };

  var isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for (var i = index - 1; i >= 0; i--) {
      if (!isImportRule(children[i])) {
        return true;
      }
    }

    return false;
  }; // use this to remove incorrect elements from further processing
  // so they don't get handed to the `sheet` (or anything else)
  // as that could potentially lead to additional logs which in turn could be overhelming to the user


  var nullifyElement = function nullifyElement(element) {
    element.type = '';
    element.value = '';
    element["return"] = '';
    element.children = '';
    element.props = '';
  };

  var incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!isImportRule(element)) {
      return;
    }

    if (element.parent) {
      console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
      nullifyElement(element);
    } else if (isPrependedWithRegularRules(index, children)) {
      console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
      nullifyElement(element);
    }
  };

  var isBrowser$4 = typeof document !== 'undefined';
  var getServerStylisCache = isBrowser$4 ? undefined : weakMemoize(function () {
    return memoize$2(function () {
      var cache = {};
      return function (name) {
        return cache[name];
      };
    });
  });
  var defaultStylisPlugins = [prefixer];

  var createCache = function createCache(options) {
    var key = options.key;

    if (process.env.NODE_ENV !== 'production' && !key) {
      throw new Error("You have to configure `key` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.\n" + "If multiple caches share the same key they might \"fight\" for each other's style elements.");
    }

    if (isBrowser$4 && key === 'css') {
      var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
      // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
      // note this very very intentionally targets all style elements regardless of the key to ensure
      // that creating a cache works inside of render of a React component

      Array.prototype.forEach.call(ssrStyles, function (node) {
        // we want to only move elements which have a space in the data-emotion attribute value
        // because that indicates that it is an Emotion 11 server-side rendered style elements
        // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
        // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
        // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
        // will not result in the Emotion 10 styles being destroyed
        var dataEmotionAttribute = node.getAttribute('data-emotion');

        if (dataEmotionAttribute.indexOf(' ') === -1) {
          return;
        }

        document.head.appendChild(node);
        node.setAttribute('data-s', '');
      });
    }

    var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;

    if (process.env.NODE_ENV !== 'production') {
      // $FlowFixMe
      if (/[^a-z-]/.test(key)) {
        throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
      }
    }

    var inserted = {}; // $FlowFixMe

    var container;
    var nodesToHydrate = [];

    if (isBrowser$4) {
      container = options.container || document.head;
      Array.prototype.forEach.call( // this means we will ignore elements which don't have a space in them which
      // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
      document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function (node) {
        var attrib = node.getAttribute("data-emotion").split(' '); // $FlowFixMe

        for (var i = 1; i < attrib.length; i++) {
          inserted[attrib[i]] = true;
        }

        nodesToHydrate.push(node);
      });
    }

    var _insert;

    var omnipresentPlugins = [compat, removeLabel];

    if (process.env.NODE_ENV !== 'production') {
      omnipresentPlugins.push(createUnsafeSelectorsAlarm({
        get compat() {
          return cache.compat;
        }

      }), incorrectImportAlarm);
    }

    if (isBrowser$4) {
      var currentSheet;
      var finalizingPlugins = [stringify, process.env.NODE_ENV !== 'production' ? function (element) {
        if (!element.root) {
          if (element["return"]) {
            currentSheet.insert(element["return"]);
          } else if (element.value && element.type !== COMMENT) {
            // insert empty rule in non-production environments
            // so @emotion/jest can grab `key` from the (JS)DOM for caches without any rules inserted yet
            currentSheet.insert(element.value + "{}");
          }
        }
      } : rulesheet(function (rule) {
        currentSheet.insert(rule);
      })];
      var serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));

      var stylis = function stylis(styles) {
        return serialize(compile(styles), serializer);
      };

      _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;

        if (process.env.NODE_ENV !== 'production' && serialized.map !== undefined) {
          currentSheet = {
            insert: function insert(rule) {
              sheet.insert(rule + serialized.map);
            }
          };
        }

        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);

        if (shouldCache) {
          cache.inserted[serialized.name] = true;
        }
      };
    } else {
      var _finalizingPlugins = [stringify];

      var _serializer = middleware(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));

      var _stylis = function _stylis(styles) {
        return serialize(compile(styles), _serializer);
      }; // $FlowFixMe


      var serverStylisCache = getServerStylisCache(stylisPlugins)(key);

      var getRules = function getRules(selector, serialized) {
        var name = serialized.name;

        if (serverStylisCache[name] === undefined) {
          serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        }

        return serverStylisCache[name];
      };

      _insert = function _insert(selector, serialized, sheet, shouldCache) {
        var name = serialized.name;
        var rules = getRules(selector, serialized);
        {
          // in regular mode, we don't set the styles on the inserted cache
          // since we don't need to and that would be wasting memory
          // we return them so that they are rendered in a style tag
          if (shouldCache) {
            cache.inserted[name] = true;
          }

          if ( // using === development instead of !== production
          // because if people do ssr in tests, the source maps showing up would be annoying
          process.env.NODE_ENV === 'development' && serialized.map !== undefined) {
            return rules + serialized.map;
          }

          return rules;
        }
      };
    }

    var cache = {
      key: key,
      sheet: new StyleSheet({
        key: key,
        container: container,
        nonce: options.nonce,
        speedy: options.speedy,
        prepend: options.prepend,
        insertionPoint: options.insertionPoint
      }),
      nonce: options.nonce,
      inserted: inserted,
      registered: {},
      insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
  };

  var createCache$1 = createCache;
  var reactIs$1 = {
    exports: {}
  };
  var reactIs_production_min = {};
  /** @license React v16.13.1
   * react-is.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  var b = "function" === typeof Symbol && Symbol.for,
      c = b ? Symbol.for("react.element") : 60103,
      d = b ? Symbol.for("react.portal") : 60106,
      e = b ? Symbol.for("react.fragment") : 60107,
      f$1 = b ? Symbol.for("react.strict_mode") : 60108,
      g$1 = b ? Symbol.for("react.profiler") : 60114,
      h$1 = b ? Symbol.for("react.provider") : 60109,
      k = b ? Symbol.for("react.context") : 60110,
      l$1 = b ? Symbol.for("react.async_mode") : 60111,
      m$1 = b ? Symbol.for("react.concurrent_mode") : 60111,
      n$2 = b ? Symbol.for("react.forward_ref") : 60112,
      p$2 = b ? Symbol.for("react.suspense") : 60113,
      q$3 = b ? Symbol.for("react.suspense_list") : 60120,
      r$2 = b ? Symbol.for("react.memo") : 60115,
      t$2 = b ? Symbol.for("react.lazy") : 60116,
      v$1 = b ? Symbol.for("react.block") : 60121,
      w$1 = b ? Symbol.for("react.fundamental") : 60117,
      x$1 = b ? Symbol.for("react.responder") : 60118,
      y$1 = b ? Symbol.for("react.scope") : 60119;

  function z$2(a) {
    if ("object" === typeof a && null !== a) {
      var u = a.$$typeof;

      switch (u) {
        case c:
          switch (a = a.type, a) {
            case l$1:
            case m$1:
            case e:
            case g$1:
            case f$1:
            case p$2:
              return a;

            default:
              switch (a = a && a.$$typeof, a) {
                case k:
                case n$2:
                case t$2:
                case r$2:
                case h$1:
                  return a;

                default:
                  return u;
              }

          }

        case d:
          return u;
      }
    }
  }

  function A$2(a) {
    return z$2(a) === m$1;
  }

  reactIs_production_min.AsyncMode = l$1;
  reactIs_production_min.ConcurrentMode = m$1;
  reactIs_production_min.ContextConsumer = k;
  reactIs_production_min.ContextProvider = h$1;
  reactIs_production_min.Element = c;
  reactIs_production_min.ForwardRef = n$2;
  reactIs_production_min.Fragment = e;
  reactIs_production_min.Lazy = t$2;
  reactIs_production_min.Memo = r$2;
  reactIs_production_min.Portal = d;
  reactIs_production_min.Profiler = g$1;
  reactIs_production_min.StrictMode = f$1;
  reactIs_production_min.Suspense = p$2;

  reactIs_production_min.isAsyncMode = function (a) {
    return A$2(a) || z$2(a) === l$1;
  };

  reactIs_production_min.isConcurrentMode = A$2;

  reactIs_production_min.isContextConsumer = function (a) {
    return z$2(a) === k;
  };

  reactIs_production_min.isContextProvider = function (a) {
    return z$2(a) === h$1;
  };

  reactIs_production_min.isElement = function (a) {
    return "object" === typeof a && null !== a && a.$$typeof === c;
  };

  reactIs_production_min.isForwardRef = function (a) {
    return z$2(a) === n$2;
  };

  reactIs_production_min.isFragment = function (a) {
    return z$2(a) === e;
  };

  reactIs_production_min.isLazy = function (a) {
    return z$2(a) === t$2;
  };

  reactIs_production_min.isMemo = function (a) {
    return z$2(a) === r$2;
  };

  reactIs_production_min.isPortal = function (a) {
    return z$2(a) === d;
  };

  reactIs_production_min.isProfiler = function (a) {
    return z$2(a) === g$1;
  };

  reactIs_production_min.isStrictMode = function (a) {
    return z$2(a) === f$1;
  };

  reactIs_production_min.isSuspense = function (a) {
    return z$2(a) === p$2;
  };

  reactIs_production_min.isValidElementType = function (a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m$1 || a === g$1 || a === f$1 || a === p$2 || a === q$3 || "object" === typeof a && null !== a && (a.$$typeof === t$2 || a.$$typeof === r$2 || a.$$typeof === h$1 || a.$$typeof === k || a.$$typeof === n$2 || a.$$typeof === w$1 || a.$$typeof === x$1 || a.$$typeof === y$1 || a.$$typeof === v$1);
  };

  reactIs_production_min.typeOf = z$2;
  var reactIs_development = {};
  /** @license React v16.13.1
   * react-is.development.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  if (process.env.NODE_ENV !== "production") {
    (function () {
      // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
      // nor polyfill, then a plain number is used for performance.
      var hasSymbol = typeof Symbol === 'function' && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
      // (unstable) APIs that have been removed. Can we remove the symbols?

      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

      function isValidElementType(type) {
        return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
      }

      function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
          var $$typeof = object.$$typeof;

          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;

              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;

                default:
                  var $$typeofType = type && type.$$typeof;

                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;

                    default:
                      return $$typeof;
                  }

              }

            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }

        return undefined;
      } // AsyncMode is deprecated along with isAsyncMode


      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

            console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
          }
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }

      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }

      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }

      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }

      function isElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }

      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }

      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }

      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }

      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }

      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }

      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }

      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }

      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }

      reactIs_development.AsyncMode = AsyncMode;
      reactIs_development.ConcurrentMode = ConcurrentMode;
      reactIs_development.ContextConsumer = ContextConsumer;
      reactIs_development.ContextProvider = ContextProvider;
      reactIs_development.Element = Element;
      reactIs_development.ForwardRef = ForwardRef;
      reactIs_development.Fragment = Fragment;
      reactIs_development.Lazy = Lazy;
      reactIs_development.Memo = Memo;
      reactIs_development.Portal = Portal;
      reactIs_development.Profiler = Profiler;
      reactIs_development.StrictMode = StrictMode;
      reactIs_development.Suspense = Suspense;
      reactIs_development.isAsyncMode = isAsyncMode;
      reactIs_development.isConcurrentMode = isConcurrentMode;
      reactIs_development.isContextConsumer = isContextConsumer;
      reactIs_development.isContextProvider = isContextProvider;
      reactIs_development.isElement = isElement;
      reactIs_development.isForwardRef = isForwardRef;
      reactIs_development.isFragment = isFragment;
      reactIs_development.isLazy = isLazy;
      reactIs_development.isMemo = isMemo;
      reactIs_development.isPortal = isPortal;
      reactIs_development.isProfiler = isProfiler;
      reactIs_development.isStrictMode = isStrictMode;
      reactIs_development.isSuspense = isSuspense;
      reactIs_development.isValidElementType = isValidElementType;
      reactIs_development.typeOf = typeOf;
    })();
  }

  if (process.env.NODE_ENV === 'production') {
    reactIs$1.exports = reactIs_production_min;
  } else {
    reactIs$1.exports = reactIs_development;
  }

  var reactIs = reactIs$1.exports;
  var FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
  };
  var MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
  };
  var TYPE_STATICS = {};
  TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
  TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
  var isBrowser$3 = typeof document !== 'undefined';

  function getRegisteredStyles(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function (className) {
      if (registered[className] !== undefined) {
        registeredStyles.push(registered[className] + ";");
      } else {
        rawClassName += className + " ";
      }
    });
    return rawClassName;
  }

  var insertStyles = function insertStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;

    if ( // we only need to add the styles to the registered cache if the
    // class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    isBrowser$3 === false && cache.compat !== undefined) && cache.registered[className] === undefined) {
      cache.registered[className] = serialized.styles;
    }

    if (cache.inserted[serialized.name] === undefined) {
      var stylesForSSR = '';
      var current = serialized;

      do {
        var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);

        if (!isBrowser$3 && maybeStyles !== undefined) {
          stylesForSSR += maybeStyles;
        }

        current = current.next;
      } while (current !== undefined);

      if (!isBrowser$3 && stylesForSSR.length !== 0) {
        return stylesForSSR;
      }
    }
  };
  /* eslint-disable */
  // Inspired by https://github.com/garycourt/murmurhash-js
  // Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86


  function murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash

    var k,
        i = 0,
        len = str.length;

    for (; len >= 4; ++i, len -= 4) {
      k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
      k =
      /* Math.imul(k, m): */
      (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
      k ^=
      /* k >>> r: */
      k >>> 24;
      h =
      /* Math.imul(k, m): */
      (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array


    switch (len) {
      case 3:
        h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

      case 2:
        h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

      case 1:
        h ^= str.charCodeAt(i) & 0xff;
        h =
        /* Math.imul(h, m): */
        (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.


    h ^= h >>> 13;
    h =
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
  }

  var unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
  };
  var ILLEGAL_ESCAPE_SEQUENCE_ERROR$1 = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
  var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
  var hyphenateRegex = /[A-Z]|^ms/g;
  var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

  var isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
  };

  var isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
  };

  var processStyleName = /* #__PURE__ */memoize$2(function (styleName) {
    return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
  });

  var processStyleValue = function processStyleValue(key, value) {
    switch (key) {
      case 'animation':
      case 'animationName':
        {
          if (typeof value === 'string') {
            return value.replace(animationRegex, function (match, p1, p2) {
              cursor = {
                name: p1,
                styles: p2,
                next: cursor
              };
              return p1;
            });
          }
        }
    }

    if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
      return value + 'px';
    }

    return value;
  };

  if (process.env.NODE_ENV !== 'production') {
    var contentValuePattern = /(attr|counters?|url|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/;
    var contentValues = ['normal', 'none', 'initial', 'inherit', 'unset'];
    var oldProcessStyleValue = processStyleValue;
    var msPattern = /^-ms-/;
    var hyphenPattern = /-(.)/g;
    var hyphenatedCache = {};

    processStyleValue = function processStyleValue(key, value) {
      if (key === 'content') {
        if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
          throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
        }
      }

      var processed = oldProcessStyleValue(key, value);

      if (processed !== '' && !isCustomProperty(key) && key.indexOf('-') !== -1 && hyphenatedCache[key] === undefined) {
        hyphenatedCache[key] = true;
        console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace(msPattern, 'ms-').replace(hyphenPattern, function (str, _char) {
          return _char.toUpperCase();
        }) + "?");
      }

      return processed;
    };
  }

  function handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) {
      return '';
    }

    if (interpolation.__emotion_styles !== undefined) {
      if (process.env.NODE_ENV !== 'production' && interpolation.toString() === 'NO_COMPONENT_SELECTOR') {
        throw new Error('Component selectors can only be used in conjunction with @emotion/babel-plugin.');
      }

      return interpolation;
    }

    switch (typeof interpolation) {
      case 'boolean':
        {
          return '';
        }

      case 'object':
        {
          if (interpolation.anim === 1) {
            cursor = {
              name: interpolation.name,
              styles: interpolation.styles,
              next: cursor
            };
            return interpolation.name;
          }

          if (interpolation.styles !== undefined) {
            var next = interpolation.next;

            if (next !== undefined) {
              // not the most efficient thing ever but this is a pretty rare case
              // and there will be very few iterations of this generally
              while (next !== undefined) {
                cursor = {
                  name: next.name,
                  styles: next.styles,
                  next: cursor
                };
                next = next.next;
              }
            }

            var styles = interpolation.styles + ";";

            if (process.env.NODE_ENV !== 'production' && interpolation.map !== undefined) {
              styles += interpolation.map;
            }

            return styles;
          }

          return createStringFromObject(mergedProps, registered, interpolation);
        }

      case 'function':
        {
          if (mergedProps !== undefined) {
            var previousCursor = cursor;
            var result = interpolation(mergedProps);
            cursor = previousCursor;
            return handleInterpolation(mergedProps, registered, result);
          } else if (process.env.NODE_ENV !== 'production') {
            console.error('Functions that are interpolated in css calls will be stringified.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
          }

          break;
        }

      case 'string':
        if (process.env.NODE_ENV !== 'production') {
          var matched = [];
          var replaced = interpolation.replace(animationRegex, function (match, p1, p2) {
            var fakeVarName = "animation" + matched.length;
            matched.push("const " + fakeVarName + " = keyframes`" + p2.replace(/^@keyframes animation-\w+/, '') + "`");
            return "${" + fakeVarName + "}";
          });

          if (matched.length) {
            console.error('`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\n' + 'Instead of doing this:\n\n' + [].concat(matched, ["`" + replaced + "`"]).join('\n') + '\n\nYou should wrap it with `css` like this:\n\n' + ("css`" + replaced + "`"));
          }
        }

        break;
    } // finalize string values (regular strings and functions interpolated into css calls)


    if (registered == null) {
      return interpolation;
    }

    var cached = registered[interpolation];
    return cached !== undefined ? cached : interpolation;
  }

  function createStringFromObject(mergedProps, registered, obj) {
    var string = '';

    if (Array.isArray(obj)) {
      for (var i = 0; i < obj.length; i++) {
        string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
      }
    } else {
      for (var _key in obj) {
        var value = obj[_key];

        if (typeof value !== 'object') {
          if (registered != null && registered[value] !== undefined) {
            string += _key + "{" + registered[value] + "}";
          } else if (isProcessableValue(value)) {
            string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
          }
        } else {
          if (_key === 'NO_COMPONENT_SELECTOR' && process.env.NODE_ENV !== 'production') {
            throw new Error('Component selectors can only be used in conjunction with @emotion/babel-plugin.');
          }

          if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
            for (var _i = 0; _i < value.length; _i++) {
              if (isProcessableValue(value[_i])) {
                string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
              }
            }
          } else {
            var interpolated = handleInterpolation(mergedProps, registered, value);

            switch (_key) {
              case 'animation':
              case 'animationName':
                {
                  string += processStyleName(_key) + ":" + interpolated + ";";
                  break;
                }

              default:
                {
                  if (process.env.NODE_ENV !== 'production' && _key === 'undefined') {
                    console.error(UNDEFINED_AS_OBJECT_KEY_ERROR);
                  }

                  string += _key + "{" + interpolated + "}";
                }
            }
          }
        }
      }
    }

    return string;
  }

  var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
  var sourceMapPattern;

  if (process.env.NODE_ENV !== 'production') {
    sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g;
  } // this is the cursor for keyframes
  // keyframes are stored on the SerializedStyles object as a linked list


  var cursor;

  var serializeStyles = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
      return args[0];
    }

    var stringMode = true;
    var styles = '';
    cursor = undefined;
    var strings = args[0];

    if (strings == null || strings.raw === undefined) {
      stringMode = false;
      styles += handleInterpolation(mergedProps, registered, strings);
    } else {
      if (process.env.NODE_ENV !== 'production' && strings[0] === undefined) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR$1);
      }

      styles += strings[0];
    } // we start at 1 since we've already handled the first arg


    for (var i = 1; i < args.length; i++) {
      styles += handleInterpolation(mergedProps, registered, args[i]);

      if (stringMode) {
        if (process.env.NODE_ENV !== 'production' && strings[i] === undefined) {
          console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR$1);
        }

        styles += strings[i];
      }
    }

    var sourceMap;

    if (process.env.NODE_ENV !== 'production') {
      styles = styles.replace(sourceMapPattern, function (match) {
        sourceMap = match;
        return '';
      });
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time


    labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

    while ((match = labelPattern.exec(styles)) !== null) {
      identifierName += '-' + // $FlowFixMe we know it's not null
      match[1];
    }

    var name = murmur2(styles) + identifierName;

    if (process.env.NODE_ENV !== 'production') {
      // $FlowFixMe SerializedStyles type doesn't have toString property (and we don't want to add it)
      return {
        name: name,
        styles: styles,
        map: sourceMap,
        next: cursor,
        toString: function toString() {
          return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
        }
      };
    }

    return {
      name: name,
      styles: styles,
      next: cursor
    };
  };

  var isBrowser$2 = typeof document !== 'undefined';
  var hasOwnProperty$d = {}.hasOwnProperty;
  var EmotionCacheContext = /* #__PURE__ */React.createContext( // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement !== 'undefined' ? /* #__PURE__ */createCache$1({
    key: 'css'
  }) : null);

  if (process.env.NODE_ENV !== 'production') {
    EmotionCacheContext.displayName = 'EmotionCacheContext';
  }

  var CacheProvider = EmotionCacheContext.Provider;

  var withEmotionCache = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/React.forwardRef(function (props, ref) {
      // the cache will never be null in the browser
      var cache = React.useContext(EmotionCacheContext);
      return func(props, cache, ref);
    });
  };

  if (!isBrowser$2) {
    withEmotionCache = function withEmotionCache(func) {
      return function (props) {
        var cache = React.useContext(EmotionCacheContext);

        if (cache === null) {
          // yes, we're potentially creating this on every render
          // it doesn't actually matter though since it's only on the server
          // so there will only every be a single render
          // that could change in the future because of suspense and etc. but for now,
          // this works and i don't want to optimise for a future thing that we aren't sure about
          cache = createCache$1({
            key: 'css'
          });
          return /*#__PURE__*/React.createElement(EmotionCacheContext.Provider, {
            value: cache
          }, func(props, cache));
        } else {
          return func(props, cache);
        }
      };
    };
  }

  var ThemeContext$2 = /* #__PURE__ */React.createContext({});

  if (process.env.NODE_ENV !== 'production') {
    ThemeContext$2.displayName = 'EmotionThemeContext';
  }

  var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
  var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';

  var Noop$2 = function Noop() {
    return null;
  };

  var Emotion = /* #__PURE__ */withEmotionCache(function (props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible

    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
      cssProp = cache.registered[cssProp];
    }

    var type = props[typePropName];
    var registeredStyles = [cssProp];
    var className = '';

    if (typeof props.className === 'string') {
      className = getRegisteredStyles(cache.registered, registeredStyles, props.className);
    } else if (props.className != null) {
      className = props.className + " ";
    }

    var serialized = serializeStyles(registeredStyles, undefined, React.useContext(ThemeContext$2));

    if (process.env.NODE_ENV !== 'production' && serialized.name.indexOf('-') === -1) {
      var labelFromStack = props[labelPropName];

      if (labelFromStack) {
        serialized = serializeStyles([serialized, 'label:' + labelFromStack + ';']);
      }
    }

    var rules = insertStyles(cache, serialized, typeof type === 'string');
    className += cache.key + "-" + serialized.name;
    var newProps = {};

    for (var key in props) {
      if (hasOwnProperty$d.call(props, key) && key !== 'css' && key !== typePropName && (process.env.NODE_ENV === 'production' || key !== labelPropName)) {
        newProps[key] = props[key];
      }
    }

    newProps.ref = ref;
    newProps.className = className;
    var ele = /*#__PURE__*/React.createElement(type, newProps);
    var possiblyStyleElement = /*#__PURE__*/React.createElement(Noop$2, null);

    if (!isBrowser$2 && rules !== undefined) {
      var _ref;

      var serializedNames = serialized.name;
      var next = serialized.next;

      while (next !== undefined) {
        serializedNames += ' ' + next.name;
        next = next.next;
      }

      possiblyStyleElement = /*#__PURE__*/React.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + " " + serializedNames, _ref.dangerouslySetInnerHTML = {
        __html: rules
      }, _ref.nonce = cache.sheet.nonce, _ref));
    } // Need to return the same number of siblings or else `React.useId` will cause hydration mismatches.


    return /*#__PURE__*/React.createElement(React.Fragment, null, possiblyStyleElement, ele);
  });

  if (process.env.NODE_ENV !== 'production') {
    Emotion.displayName = 'EmotionCssPropInternal';
  }

  var pkg = {
    name: "@emotion/react",
    version: "11.7.0",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
      "./dist/emotion-react.cjs.js": "./dist/emotion-react.browser.cjs.js",
      "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    types: "types/index.d.ts",
    files: ["src", "dist", "jsx-runtime", "jsx-dev-runtime", "_isolated-hnrs", "types/*.d.ts", "macro.js", "macro.d.ts", "macro.js.flow"],
    sideEffects: false,
    author: "mitchellhamilton <mitchell@mitchellhamilton.me>",
    license: "MIT",
    scripts: {
      "test:typescript": "dtslint types"
    },
    dependencies: {
      "@babel/runtime": "^7.13.10",
      "@emotion/cache": "^11.6.0",
      "@emotion/serialize": "^1.0.2",
      "@emotion/sheet": "^1.1.0",
      "@emotion/utils": "^1.0.0",
      "@emotion/weak-memoize": "^0.2.5",
      "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
      "@babel/core": "^7.0.0",
      react: ">=16.8.0"
    },
    peerDependenciesMeta: {
      "@babel/core": {
        optional: true
      },
      "@types/react": {
        optional: true
      }
    },
    devDependencies: {
      "@babel/core": "^7.13.10",
      "@emotion/css": "11.5.0",
      "@emotion/css-prettifier": "1.0.0",
      "@emotion/server": "11.4.0",
      "@emotion/styled": "11.6.0",
      "@types/react": "^16.9.11",
      dtslint: "^0.3.0",
      "html-tag-names": "^1.1.2",
      react: "16.14.0",
      "svg-tag-names": "^1.1.1"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
      access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
      entrypoints: ["./index.js", "./jsx-runtime.js", "./jsx-dev-runtime.js", "./_isolated-hnrs.js"],
      umdName: "emotionReact"
    }
  };
  var warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
  // initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
  // initial client-side render from SSR, use place of hydrating tag

  var Global = /* #__PURE__ */withEmotionCache(function (props, cache) {
    if (process.env.NODE_ENV !== 'production' && !warnedAboutCssPropForGlobal && ( // check for className as well since the user is
    // probably using the custom createElement which
    // means it will be turned into a className prop
    // $FlowFixMe I don't really want to add it to the type since it shouldn't be used
    props.className || props.css)) {
      console.error("It looks like you're using the css prop on Global, did you mean to use the styles prop instead?");
      warnedAboutCssPropForGlobal = true;
    }

    var styles = props.styles;
    var serialized = serializeStyles([styles], undefined, React.useContext(ThemeContext$2));

    if (!isBrowser$2) {
      var _ref;

      var serializedNames = serialized.name;
      var serializedStyles = serialized.styles;
      var next = serialized.next;

      while (next !== undefined) {
        serializedNames += ' ' + next.name;
        serializedStyles += next.styles;
        next = next.next;
      }

      var shouldCache = cache.compat === true;
      var rules = cache.insert("", {
        name: serializedNames,
        styles: serializedStyles
      }, cache.sheet, shouldCache);

      if (shouldCache) {
        return null;
      }

      return /*#__PURE__*/React.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
        __html: rules
      }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything


    var sheetRef = React.useRef();
    React.useLayoutEffect(function () {
      var key = cache.key + "-global";
      var sheet = new StyleSheet({
        key: key,
        nonce: cache.sheet.nonce,
        container: cache.sheet.container,
        speedy: cache.sheet.isSpeedy
      });
      var rehydrating = false; // $FlowFixMe

      var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");

      if (cache.sheet.tags.length) {
        sheet.before = cache.sheet.tags[0];
      }

      if (node !== null) {
        rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s

        node.setAttribute('data-emotion', key);
        sheet.hydrate([node]);
      }

      sheetRef.current = [sheet, rehydrating];
      return function () {
        sheet.flush();
      };
    }, [cache]);
    React.useLayoutEffect(function () {
      var sheetRefCurrent = sheetRef.current;
      var sheet = sheetRefCurrent[0],
          rehydrating = sheetRefCurrent[1];

      if (rehydrating) {
        sheetRefCurrent[1] = false;
        return;
      }

      if (serialized.next !== undefined) {
        // insert keyframes
        insertStyles(cache, serialized.next, true);
      }

      if (sheet.tags.length) {
        // if this doesn't exist then it will be null so the style element will be appended
        var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
        sheet.before = element;
        sheet.flush();
      }

      cache.insert("", serialized, sheet, false);
    }, [cache, serialized.name]);
    return null;
  });

  if (process.env.NODE_ENV !== 'production') {
    Global.displayName = 'EmotionGlobal';
  }

  function css$1() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return serializeStyles(args);
  }

  var keyframes = function keyframes() {
    var insertable = css$1.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe

    return {
      name: name,
      styles: "@keyframes " + name + "{" + insertable.styles + "}",
      anim: 1,
      toString: function toString() {
        return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
      }
    };
  };

  var classnames$1 = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';

    for (; i < len; i++) {
      var arg = args[i];
      if (arg == null) continue;
      var toAdd = void 0;

      switch (typeof arg) {
        case 'boolean':
          break;

        case 'object':
          {
            if (Array.isArray(arg)) {
              toAdd = classnames(arg);
            } else {
              if (process.env.NODE_ENV !== 'production' && arg.styles !== undefined && arg.name !== undefined) {
                console.error('You have passed styles created with `css` from `@emotion/react` package to the `cx`.\n' + '`cx` is meant to compose class names (strings) so you should convert those styles to a class name by passing them to the `css` received from <ClassNames/> component.');
              }

              toAdd = '';

              for (var k in arg) {
                if (arg[k] && k) {
                  toAdd && (toAdd += ' ');
                  toAdd += k;
                }
              }
            }

            break;
          }

        default:
          {
            toAdd = arg;
          }
      }

      if (toAdd) {
        cls && (cls += ' ');
        cls += toAdd;
      }
    }

    return cls;
  };

  function merge$1(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = getRegisteredStyles(registered, registeredStyles, className);

    if (registeredStyles.length < 2) {
      return className;
    }

    return rawClassName + css(registeredStyles);
  }

  var Noop$1 = function Noop() {
    return null;
  };

  var ClassNames = /* #__PURE__ */withEmotionCache(function (props, cache) {
    var rules = '';
    var serializedHashes = '';
    var hasRendered = false;

    var css = function css() {
      if (hasRendered && process.env.NODE_ENV !== 'production') {
        throw new Error('css can only be used during render');
      }

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var serialized = serializeStyles(args, cache.registered);

      if (isBrowser$2) {
        insertStyles(cache, serialized, false);
      } else {
        var res = insertStyles(cache, serialized, false);

        if (res !== undefined) {
          rules += res;
        }
      }

      if (!isBrowser$2) {
        serializedHashes += " " + serialized.name;
      }

      return cache.key + "-" + serialized.name;
    };

    var cx = function cx() {
      if (hasRendered && process.env.NODE_ENV !== 'production') {
        throw new Error('cx can only be used during render');
      }

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return merge$1(cache.registered, css, classnames$1(args));
    };

    var content = {
      css: css,
      cx: cx,
      theme: React.useContext(ThemeContext$2)
    };
    var ele = props.children(content);
    hasRendered = true;
    var possiblyStyleElement = /*#__PURE__*/React.createElement(Noop$1, null);

    if (!isBrowser$2 && rules.length !== 0) {
      var _ref;

      possiblyStyleElement = /*#__PURE__*/React.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + " " + serializedHashes.substring(1), _ref.dangerouslySetInnerHTML = {
        __html: rules
      }, _ref.nonce = cache.sheet.nonce, _ref));
    } // Need to return the same number of siblings or else `React.useId` will cause hydration mismatches.


    return /*#__PURE__*/React.createElement(React.Fragment, null, possiblyStyleElement, ele);
  });

  if (process.env.NODE_ENV !== 'production') {
    ClassNames.displayName = 'EmotionClassNames';
  }

  if (process.env.NODE_ENV !== 'production') {
    var isBrowser$1 = typeof document !== 'undefined'; // #1727 for some reason Jest evaluates modules twice if some consuming module gets mocked with jest.mock

    var isJest = typeof jest !== 'undefined';

    if (isBrowser$1 && !isJest) {
      // globalThis has wide browser support - https://caniuse.com/?search=globalThis, Node.js 12 and later
      var globalContext = // $FlowIgnore
      typeof globalThis !== 'undefined' ? globalThis // eslint-disable-line no-undef
      : isBrowser$1 ? window : global;
      var globalKey = "__EMOTION_REACT_" + pkg.version.split('.')[0] + "__";

      if (globalContext[globalKey]) {
        console.warn('You are loading @emotion/react when it is already loaded. Running ' + 'multiple instances may cause problems. This can happen if multiple ' + 'versions are used, or if multiple builds of the same version are ' + 'used.');
      }

      globalContext[globalKey] = true;
    }
  }

  var testOmitPropsOnStringTag = isPropValid;

  var testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
  };

  var getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
  };

  var composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;

    if (options) {
      var optionsShouldForwardProp = options.shouldForwardProp;
      shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function (propName) {
        return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
      } : optionsShouldForwardProp;
    }

    if (typeof shouldForwardProp !== 'function' && isReal) {
      shouldForwardProp = tag.__emotion_forwardProp;
    }

    return shouldForwardProp;
  };

  var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
  var isBrowser = typeof document !== 'undefined';

  var Noop = function Noop() {
    return null;
  };

  var createStyled$1 = function createStyled(tag, options) {
    if (process.env.NODE_ENV !== 'production') {
      if (tag === undefined) {
        throw new Error('You are trying to create a styled element with an undefined component.\nYou may have forgotten to import it.');
      }
    }

    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;

    if (options !== undefined) {
      identifierName = options.label;
      targetClassName = options.target;
    }

    var shouldForwardProp = composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function () {
      var args = arguments;
      var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];

      if (identifierName !== undefined) {
        styles.push("label:" + identifierName + ";");
      }

      if (args[0] == null || args[0].raw === undefined) {
        styles.push.apply(styles, args);
      } else {
        if (process.env.NODE_ENV !== 'production' && args[0][0] === undefined) {
          console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
        }

        styles.push(args[0][0]);
        var len = args.length;
        var i = 1;

        for (; i < len; i++) {
          if (process.env.NODE_ENV !== 'production' && args[0][i] === undefined) {
            console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
          }

          styles.push(args[i], args[0][i]);
        }
      } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class


      var Styled = withEmotionCache(function (props, cache, ref) {
        var finalTag = shouldUseAs && props.as || baseTag;
        var className = '';
        var classInterpolations = [];
        var mergedProps = props;

        if (props.theme == null) {
          mergedProps = {};

          for (var key in props) {
            mergedProps[key] = props[key];
          }

          mergedProps.theme = React.useContext(ThemeContext$2);
        }

        if (typeof props.className === 'string') {
          className = getRegisteredStyles(cache.registered, classInterpolations, props.className);
        } else if (props.className != null) {
          className = props.className + " ";
        }

        var serialized = serializeStyles(styles.concat(classInterpolations), cache.registered, mergedProps);
        var rules = insertStyles(cache, serialized, typeof finalTag === 'string');
        className += cache.key + "-" + serialized.name;

        if (targetClassName !== undefined) {
          className += " " + targetClassName;
        }

        var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? getDefaultShouldForwardProp(finalTag) : defaultShouldForwardProp;
        var newProps = {};

        for (var _key in props) {
          if (shouldUseAs && _key === 'as') continue;

          if ( // $FlowFixMe
          finalShouldForwardProp(_key)) {
            newProps[_key] = props[_key];
          }
        }

        newProps.className = className;
        newProps.ref = ref;
        var ele = /*#__PURE__*/React.createElement(finalTag, newProps);
        var possiblyStyleElement = /*#__PURE__*/React.createElement(Noop, null);

        if (!isBrowser && rules !== undefined) {
          var _ref;

          var serializedNames = serialized.name;
          var next = serialized.next;

          while (next !== undefined) {
            serializedNames += ' ' + next.name;
            next = next.next;
          }

          possiblyStyleElement = /*#__PURE__*/React.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + " " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
          }, _ref.nonce = cache.sheet.nonce, _ref));
        } // Need to return the same number of siblings or else `React.useId` will cause hydration mismatches.


        return /*#__PURE__*/React.createElement(React.Fragment, null, possiblyStyleElement, ele);
      });
      Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
      Styled.defaultProps = tag.defaultProps;
      Styled.__emotion_real = Styled;
      Styled.__emotion_base = baseTag;
      Styled.__emotion_styles = styles;
      Styled.__emotion_forwardProp = shouldForwardProp;
      Object.defineProperty(Styled, 'toString', {
        value: function value() {
          if (targetClassName === undefined && process.env.NODE_ENV !== 'production') {
            return 'NO_COMPONENT_SELECTOR';
          } // $FlowFixMe: coerce undefined to string


          return "." + targetClassName;
        }
      });

      Styled.withComponent = function (nextTag, nextOptions) {
        return createStyled(nextTag, _extends$9({}, options, nextOptions, {
          shouldForwardProp: composeShouldForwardProps(Styled, nextOptions, true)
        })).apply(void 0, styles);
      };

      return Styled;
    };
  };

  var tags = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr', // SVG
  'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];
  var newStyled = createStyled$1.bind();
  tags.forEach(function (tagName) {
    // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
    newStyled[tagName] = newStyled(tagName);
  });
  var emStyled = newStyled;
  var cache = createCache$1({
    key: 'css',
    prepend: true
  });

  function StyledEngineProvider(props) {
    var injectFirst = props.injectFirst,
        children = props.children;
    return injectFirst ? /*#__PURE__*/jsxRuntime$1.jsx(CacheProvider, {
      value: cache,
      children: children
    }) : children;
  }

  process.env.NODE_ENV !== "production" ? StyledEngineProvider.propTypes = {
    /**
     * Your component tree.
     */
    children: PropTypes.node,

    /**
     * By default, the styles are injected last in the <head> element of the page.
     * As a result, they gain more specificity than any other style sheet.
     * If you want to override MUI's styles, set this prop.
     */
    injectFirst: PropTypes.bool
  } : void 0;

  function isEmpty$3(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
  }

  function GlobalStyles$1(props) {
    var styles = props.styles,
        _props$defaultTheme = props.defaultTheme,
        defaultTheme = _props$defaultTheme === void 0 ? {} : _props$defaultTheme;
    var globalStyles = typeof styles === 'function' ? function (themeInput) {
      return styles(isEmpty$3(themeInput) ? defaultTheme : themeInput);
    } : styles;
    return /*#__PURE__*/jsxRuntime$1.jsx(Global, {
      styles: globalStyles
    });
  }

  process.env.NODE_ENV !== "production" ? GlobalStyles$1.propTypes = {
    defaultTheme: PropTypes.object,
    styles: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.func])
  } : void 0;
  /** @license MUI v5.2.0
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  function styled$2(tag, options) {
    var stylesFactory = emStyled(tag, options);

    if (process.env.NODE_ENV !== 'production') {
      return function () {
        var component = typeof tag === 'string' ? "\"".concat(tag, "\"") : 'component';

        for (var _len13 = arguments.length, styles = new Array(_len13), _key13 = 0; _key13 < _len13; _key13++) {
          styles[_key13] = arguments[_key13];
        }

        if (styles.length === 0) {
          console.error(["MUI: Seems like you called `styled(".concat(component, ")()` without a `style` argument."), 'You must provide a `styles` argument: `styled("div")(styleYouForgotToPass)`.'].join('\n'));
        } else if (styles.some(function (style) {
          return style === undefined;
        })) {
          console.error("MUI: the styled(".concat(component, ")(...args) API requires all its args to be defined."));
        }

        return stylesFactory.apply(void 0, styles);
      };
    }

    return stylesFactory;
  }

  var responsivePropType = process.env.NODE_ENV !== 'production' ? PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.object, PropTypes.array]) : {};
  var responsivePropType$1 = responsivePropType;

  function _extends$8() {
    _extends$8 = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends$8.apply(this, arguments);
  }

  function merge(acc, item) {
    if (!item) {
      return acc;
    }

    return deepmerge(acc, item, {
      clone: false // No need to clone deep, it's way faster.

    });
  } // For instance with the first breakpoint xs: [xs, sm[.


  var values$2 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen

  };
  var defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: ['xs', 'sm', 'md', 'lg', 'xl'],
    up: function up(key) {
      return "@media (min-width:".concat(values$2[key], "px)");
    }
  };

  function handleBreakpoints(props, propValue, styleFromPropValue) {
    var theme = props.theme || {};

    if (Array.isArray(propValue)) {
      var themeBreakpoints = theme.breakpoints || defaultBreakpoints;
      return propValue.reduce(function (acc, item, index) {
        acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
        return acc;
      }, {});
    }

    if (typeof propValue === 'object') {
      var _themeBreakpoints = theme.breakpoints || defaultBreakpoints;

      return Object.keys(propValue).reduce(function (acc, breakpoint) {
        // key is breakpoint
        if (Object.keys(_themeBreakpoints.values || values$2).indexOf(breakpoint) !== -1) {
          var mediaKey = _themeBreakpoints.up(breakpoint);

          acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
        } else {
          var cssKey = breakpoint;
          acc[cssKey] = propValue[cssKey];
        }

        return acc;
      }, {});
    }

    var output = styleFromPropValue(propValue);
    return output;
  }

  function createEmptyBreakpointObject() {
    var breakpointsInput = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var _breakpointsInput$key;

    var breakpointsInOrder = breakpointsInput == null ? void 0 : (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce(function (acc, key) {
      var breakpointStyleKey = breakpointsInput.up(key);
      acc[breakpointStyleKey] = {};
      return acc;
    }, {});
    return breakpointsInOrder || {};
  }

  function removeUnusedBreakpoints(breakpointKeys, style) {
    return breakpointKeys.reduce(function (acc, key) {
      var breakpointOutput = acc[key];
      var isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;

      if (isBreakpointUnused) {
        delete acc[key];
      }

      return acc;
    }, style);
  } // [1,2,3] => {xs: true, sm: true, md: true}
  // {xs: 1, sm: 2, md: 3} => {xs: true, sm: true, md: true}


  function computeBreakpointsBase(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== 'object') {
      return {};
    }

    var base = {};
    var breakpointsKeys = Object.keys(themeBreakpoints);

    if (Array.isArray(breakpointValues)) {
      breakpointsKeys.forEach(function (breakpoint, i) {
        if (i < breakpointValues.length) {
          base[breakpoint] = true;
        }
      });
    } else {
      breakpointsKeys.forEach(function (breakpoint) {
        if (breakpointValues[breakpoint] != null) {
          base[breakpoint] = true;
        }
      });
    }

    return base;
  }

  function resolveBreakpointValues(_ref14) {
    var breakpointValues = _ref14.values,
        themeBreakpoints = _ref14.breakpoints,
        customBase = _ref14.base;
    var base = customBase || computeBreakpointsBase(breakpointValues, themeBreakpoints);
    var keys = Object.keys(base);

    if (keys.length === 0) {
      return breakpointValues;
    }

    var previous;
    return keys.reduce(function (acc, breakpoint, i) {
      if (Array.isArray(breakpointValues)) {
        acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
        previous = i;
      } else {
        acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous] || breakpointValues;
        previous = breakpoint;
      }

      return acc;
    }, {});
  }

  function getPath$1(obj, path) {
    if (!path || typeof path !== 'string') {
      return null;
    }

    return path.split('.').reduce(function (acc, item) {
      return acc && acc[item] ? acc[item] : null;
    }, obj);
  }

  function getValue$2(themeMapping, transform, propValueFinal) {
    var userValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : propValueFinal;
    var value;

    if (typeof themeMapping === 'function') {
      value = themeMapping(propValueFinal);
    } else if (Array.isArray(themeMapping)) {
      value = themeMapping[propValueFinal] || userValue;
    } else {
      value = getPath$1(themeMapping, propValueFinal) || userValue;
    }

    if (transform) {
      value = transform(value);
    }

    return value;
  }

  function style$2(options) {
    var prop = options.prop,
        _options$cssProperty = options.cssProperty,
        cssProperty = _options$cssProperty === void 0 ? options.prop : _options$cssProperty,
        themeKey = options.themeKey,
        transform = options.transform;

    var fn = function fn(props) {
      if (props[prop] == null) {
        return null;
      }

      var propValue = props[prop];
      var theme = props.theme;
      var themeMapping = getPath$1(theme, themeKey) || {};

      var styleFromPropValue = function styleFromPropValue(propValueFinal) {
        var value = getValue$2(themeMapping, transform, propValueFinal);

        if (propValueFinal === value && typeof propValueFinal === 'string') {
          // Haven't found value
          value = getValue$2(themeMapping, transform, "".concat(prop).concat(propValueFinal === 'default' ? '' : capitalize$1(propValueFinal)), propValueFinal);
        }

        if (cssProperty === false) {
          return value;
        }

        return _defineProperty({}, cssProperty, value);
      };

      return handleBreakpoints(props, propValue, styleFromPropValue);
    };

    fn.propTypes = process.env.NODE_ENV !== 'production' ? _defineProperty({}, prop, responsivePropType$1) : {};
    fn.filterProps = [prop];
    return fn;
  }

  function compose() {
    for (var _len14 = arguments.length, styles = new Array(_len14), _key14 = 0; _key14 < _len14; _key14++) {
      styles[_key14] = arguments[_key14];
    }

    var handlers = styles.reduce(function (acc, style) {
      style.filterProps.forEach(function (prop) {
        acc[prop] = style;
      });
      return acc;
    }, {});

    var fn = function fn(props) {
      return Object.keys(props).reduce(function (acc, prop) {
        if (handlers[prop]) {
          return merge(acc, handlers[prop](props));
        }

        return acc;
      }, {});
    };

    fn.propTypes = process.env.NODE_ENV !== 'production' ? styles.reduce(function (acc, style) {
      return Object.assign(acc, style.propTypes);
    }, {}) : {};
    fn.filterProps = styles.reduce(function (acc, style) {
      return acc.concat(style.filterProps);
    }, []);
    return fn;
  }

  function memoize$1(fn) {
    var cache = {};
    return function (arg) {
      if (cache[arg] === undefined) {
        cache[arg] = fn(arg);
      }

      return cache[arg];
    };
  }

  var properties = {
    m: 'margin',
    p: 'padding'
  };
  var directions = {
    t: 'Top',
    r: 'Right',
    b: 'Bottom',
    l: 'Left',
    x: ['Left', 'Right'],
    y: ['Top', 'Bottom']
  };
  var aliases = {
    marginX: 'mx',
    marginY: 'my',
    paddingX: 'px',
    paddingY: 'py'
  }; // memoize() impact:
  // From 300,000 ops/sec
  // To 350,000 ops/sec

  var getCssProperties = memoize$1(function (prop) {
    // It's not a shorthand notation.
    if (prop.length > 2) {
      if (aliases[prop]) {
        prop = aliases[prop];
      } else {
        return [prop];
      }
    }

    var _prop$split = prop.split(''),
        _prop$split2 = _slicedToArray(_prop$split, 2),
        a = _prop$split2[0],
        b = _prop$split2[1];

    var property = properties[a];
    var direction = directions[b] || '';
    return Array.isArray(direction) ? direction.map(function (dir) {
      return property + dir;
    }) : [property + direction];
  });
  var marginKeys = ['m', 'mt', 'mr', 'mb', 'ml', 'mx', 'my', 'margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'marginX', 'marginY', 'marginInline', 'marginInlineStart', 'marginInlineEnd', 'marginBlock', 'marginBlockStart', 'marginBlockEnd'];
  var paddingKeys = ['p', 'pt', 'pr', 'pb', 'pl', 'px', 'py', 'padding', 'paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft', 'paddingX', 'paddingY', 'paddingInline', 'paddingInlineStart', 'paddingInlineEnd', 'paddingBlock', 'paddingBlockStart', 'paddingBlockEnd'];
  var spacingKeys = [].concat(marginKeys, paddingKeys);

  function createUnaryUnit(theme, themeKey, defaultValue, propName) {
    var themeSpacing = getPath$1(theme, themeKey) || defaultValue;

    if (typeof themeSpacing === 'number') {
      return function (abs) {
        if (typeof abs === 'string') {
          return abs;
        }

        if (process.env.NODE_ENV !== 'production') {
          if (typeof abs !== 'number') {
            console.error("MUI: Expected ".concat(propName, " argument to be a number or a string, got ").concat(abs, "."));
          }
        }

        return themeSpacing * abs;
      };
    }

    if (Array.isArray(themeSpacing)) {
      return function (abs) {
        if (typeof abs === 'string') {
          return abs;
        }

        if (process.env.NODE_ENV !== 'production') {
          if (!Number.isInteger(abs)) {
            console.error(["MUI: The `theme.".concat(themeKey, "` array type cannot be combined with non integer values.") + "You should either use an integer value that can be used as index, or define the `theme.".concat(themeKey, "` as a number.")].join('\n'));
          } else if (abs > themeSpacing.length - 1) {
            console.error(["MUI: The value provided (".concat(abs, ") overflows."), "The supported values are: ".concat(JSON.stringify(themeSpacing), "."), "".concat(abs, " > ").concat(themeSpacing.length - 1, ", you need to add the missing values.")].join('\n'));
          }
        }

        return themeSpacing[abs];
      };
    }

    if (typeof themeSpacing === 'function') {
      return themeSpacing;
    }

    if (process.env.NODE_ENV !== 'production') {
      console.error(["MUI: The `theme.".concat(themeKey, "` value (").concat(themeSpacing, ") is invalid."), 'It should be a number, an array or a function.'].join('\n'));
    }

    return function () {
      return undefined;
    };
  }

  function createUnarySpacing(theme) {
    return createUnaryUnit(theme, 'spacing', 8, 'spacing');
  }

  function getValue$1(transformer, propValue) {
    if (typeof propValue === 'string' || propValue == null) {
      return propValue;
    }

    var abs = Math.abs(propValue);
    var transformed = transformer(abs);

    if (propValue >= 0) {
      return transformed;
    }

    if (typeof transformed === 'number') {
      return -transformed;
    }

    return "-".concat(transformed);
  }

  function getStyleFromPropValue(cssProperties, transformer) {
    return function (propValue) {
      return cssProperties.reduce(function (acc, cssProperty) {
        acc[cssProperty] = getValue$1(transformer, propValue);
        return acc;
      }, {});
    };
  }

  function resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (keys.indexOf(prop) === -1) {
      return null;
    }

    var cssProperties = getCssProperties(prop);
    var styleFromPropValue = getStyleFromPropValue(cssProperties, transformer);
    var propValue = props[prop];
    return handleBreakpoints(props, propValue, styleFromPropValue);
  }

  function style$1(props, keys) {
    var transformer = createUnarySpacing(props.theme);
    return Object.keys(props).map(function (prop) {
      return resolveCssProperty(props, keys, prop, transformer);
    }).reduce(merge, {});
  }

  process.env.NODE_ENV !== 'production' ? marginKeys.reduce(function (obj, key) {
    obj[key] = responsivePropType$1;
    return obj;
  }, {}) : {};
  process.env.NODE_ENV !== 'production' ? paddingKeys.reduce(function (obj, key) {
    obj[key] = responsivePropType$1;
    return obj;
  }, {}) : {};

  function spacing(props) {
    return style$1(props, spacingKeys);
  }

  spacing.propTypes = process.env.NODE_ENV !== 'production' ? spacingKeys.reduce(function (obj, key) {
    obj[key] = responsivePropType$1;
    return obj;
  }, {}) : {};
  spacing.filterProps = spacingKeys;

  function getBorder(value) {
    if (typeof value !== 'number') {
      return value;
    }

    return "".concat(value, "px solid");
  }

  var border = style$2({
    prop: 'border',
    themeKey: 'borders',
    transform: getBorder
  });
  var borderTop = style$2({
    prop: 'borderTop',
    themeKey: 'borders',
    transform: getBorder
  });
  var borderRight = style$2({
    prop: 'borderRight',
    themeKey: 'borders',
    transform: getBorder
  });
  var borderBottom = style$2({
    prop: 'borderBottom',
    themeKey: 'borders',
    transform: getBorder
  });
  var borderLeft = style$2({
    prop: 'borderLeft',
    themeKey: 'borders',
    transform: getBorder
  });
  var borderColor = style$2({
    prop: 'borderColor',
    themeKey: 'palette'
  });
  var borderTopColor = style$2({
    prop: 'borderTopColor',
    themeKey: 'palette'
  });
  var borderRightColor = style$2({
    prop: 'borderRightColor',
    themeKey: 'palette'
  });
  var borderBottomColor = style$2({
    prop: 'borderBottomColor',
    themeKey: 'palette'
  });
  var borderLeftColor = style$2({
    prop: 'borderLeftColor',
    themeKey: 'palette'
  });

  var borderRadius = function borderRadius(props) {
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
      var transformer = createUnaryUnit(props.theme, 'shape.borderRadius', 4, 'borderRadius');

      var styleFromPropValue = function styleFromPropValue(propValue) {
        return {
          borderRadius: getValue$1(transformer, propValue)
        };
      };

      return handleBreakpoints(props, props.borderRadius, styleFromPropValue);
    }

    return null;
  };

  borderRadius.propTypes = process.env.NODE_ENV !== 'production' ? {
    borderRadius: responsivePropType$1
  } : {};
  borderRadius.filterProps = ['borderRadius'];
  var borders = compose(border, borderTop, borderRight, borderBottom, borderLeft, borderColor, borderTopColor, borderRightColor, borderBottomColor, borderLeftColor, borderRadius);
  var borders$1 = borders;
  var displayPrint = style$2({
    prop: 'displayPrint',
    cssProperty: false,
    transform: function transform(value) {
      return {
        '@media print': {
          display: value
        }
      };
    }
  });
  var displayRaw = style$2({
    prop: 'display'
  });
  var overflow = style$2({
    prop: 'overflow'
  });
  var textOverflow = style$2({
    prop: 'textOverflow'
  });
  var visibility = style$2({
    prop: 'visibility'
  });
  var whiteSpace = style$2({
    prop: 'whiteSpace'
  });
  var display = compose(displayPrint, displayRaw, overflow, textOverflow, visibility, whiteSpace);
  var flexBasis = style$2({
    prop: 'flexBasis'
  });
  var flexDirection = style$2({
    prop: 'flexDirection'
  });
  var flexWrap = style$2({
    prop: 'flexWrap'
  });
  var justifyContent = style$2({
    prop: 'justifyContent'
  });
  var alignItems = style$2({
    prop: 'alignItems'
  });
  var alignContent = style$2({
    prop: 'alignContent'
  });
  var order = style$2({
    prop: 'order'
  });
  var flex = style$2({
    prop: 'flex'
  });
  var flexGrow = style$2({
    prop: 'flexGrow'
  });
  var flexShrink = style$2({
    prop: 'flexShrink'
  });
  var alignSelf = style$2({
    prop: 'alignSelf'
  });
  var justifyItems = style$2({
    prop: 'justifyItems'
  });
  var justifySelf = style$2({
    prop: 'justifySelf'
  });
  var flexbox = compose(flexBasis, flexDirection, flexWrap, justifyContent, alignItems, alignContent, order, flex, flexGrow, flexShrink, alignSelf, justifyItems, justifySelf);
  var flexbox$1 = flexbox;

  var gap = function gap(props) {
    if (props.gap !== undefined && props.gap !== null) {
      var transformer = createUnaryUnit(props.theme, 'spacing', 8, 'gap');

      var styleFromPropValue = function styleFromPropValue(propValue) {
        return {
          gap: getValue$1(transformer, propValue)
        };
      };

      return handleBreakpoints(props, props.gap, styleFromPropValue);
    }

    return null;
  };

  gap.propTypes = process.env.NODE_ENV !== 'production' ? {
    gap: responsivePropType$1
  } : {};
  gap.filterProps = ['gap'];

  var columnGap = function columnGap(props) {
    if (props.columnGap !== undefined && props.columnGap !== null) {
      var transformer = createUnaryUnit(props.theme, 'spacing', 8, 'columnGap');

      var styleFromPropValue = function styleFromPropValue(propValue) {
        return {
          columnGap: getValue$1(transformer, propValue)
        };
      };

      return handleBreakpoints(props, props.columnGap, styleFromPropValue);
    }

    return null;
  };

  columnGap.propTypes = process.env.NODE_ENV !== 'production' ? {
    columnGap: responsivePropType$1
  } : {};
  columnGap.filterProps = ['columnGap'];

  var rowGap = function rowGap(props) {
    if (props.rowGap !== undefined && props.rowGap !== null) {
      var transformer = createUnaryUnit(props.theme, 'spacing', 8, 'rowGap');

      var styleFromPropValue = function styleFromPropValue(propValue) {
        return {
          rowGap: getValue$1(transformer, propValue)
        };
      };

      return handleBreakpoints(props, props.rowGap, styleFromPropValue);
    }

    return null;
  };

  rowGap.propTypes = process.env.NODE_ENV !== 'production' ? {
    rowGap: responsivePropType$1
  } : {};
  rowGap.filterProps = ['rowGap'];
  var gridColumn = style$2({
    prop: 'gridColumn'
  });
  var gridRow = style$2({
    prop: 'gridRow'
  });
  var gridAutoFlow = style$2({
    prop: 'gridAutoFlow'
  });
  var gridAutoColumns = style$2({
    prop: 'gridAutoColumns'
  });
  var gridAutoRows = style$2({
    prop: 'gridAutoRows'
  });
  var gridTemplateColumns = style$2({
    prop: 'gridTemplateColumns'
  });
  var gridTemplateRows = style$2({
    prop: 'gridTemplateRows'
  });
  var gridTemplateAreas = style$2({
    prop: 'gridTemplateAreas'
  });
  var gridArea = style$2({
    prop: 'gridArea'
  });
  var grid = compose(gap, columnGap, rowGap, gridColumn, gridRow, gridAutoFlow, gridAutoColumns, gridAutoRows, gridTemplateColumns, gridTemplateRows, gridTemplateAreas, gridArea);
  var grid$1 = grid;
  var color = style$2({
    prop: 'color',
    themeKey: 'palette'
  });
  var bgcolor = style$2({
    prop: 'bgcolor',
    cssProperty: 'backgroundColor',
    themeKey: 'palette'
  });
  var backgroundColor = style$2({
    prop: 'backgroundColor',
    themeKey: 'palette'
  });
  var palette = compose(color, bgcolor, backgroundColor);
  var palette$1 = palette;
  var position = style$2({
    prop: 'position'
  });
  var zIndex$2 = style$2({
    prop: 'zIndex',
    themeKey: 'zIndex'
  });
  var top = style$2({
    prop: 'top'
  });
  var right = style$2({
    prop: 'right'
  });
  var bottom = style$2({
    prop: 'bottom'
  });
  var left = style$2({
    prop: 'left'
  });
  var positions = compose(position, zIndex$2, top, right, bottom, left);
  var boxShadow = style$2({
    prop: 'boxShadow',
    themeKey: 'shadows'
  });
  var shadows$2 = boxShadow;

  function transform$1(value) {
    return value <= 1 && value !== 0 ? "".concat(value * 100, "%") : value;
  }

  var width = style$2({
    prop: 'width',
    transform: transform$1
  });

  var maxWidth = function maxWidth(props) {
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
      var styleFromPropValue = function styleFromPropValue(propValue) {
        var _props$theme, _props$theme$breakpoi, _props$theme$breakpoi2;

        var breakpoint = ((_props$theme = props.theme) == null ? void 0 : (_props$theme$breakpoi = _props$theme.breakpoints) == null ? void 0 : (_props$theme$breakpoi2 = _props$theme$breakpoi.values) == null ? void 0 : _props$theme$breakpoi2[propValue]) || values$2[propValue];
        return {
          maxWidth: breakpoint || transform$1(propValue)
        };
      };

      return handleBreakpoints(props, props.maxWidth, styleFromPropValue);
    }

    return null;
  };

  maxWidth.filterProps = ['maxWidth'];
  var minWidth = style$2({
    prop: 'minWidth',
    transform: transform$1
  });
  var height = style$2({
    prop: 'height',
    transform: transform$1
  });
  var maxHeight = style$2({
    prop: 'maxHeight',
    transform: transform$1
  });
  var minHeight = style$2({
    prop: 'minHeight',
    transform: transform$1
  });
  style$2({
    prop: 'size',
    cssProperty: 'width',
    transform: transform$1
  });
  style$2({
    prop: 'size',
    cssProperty: 'height',
    transform: transform$1
  });
  var boxSizing = style$2({
    prop: 'boxSizing'
  });
  var sizing = compose(width, maxWidth, minWidth, height, maxHeight, minHeight, boxSizing);
  var sizing$1 = sizing;
  var fontFamily = style$2({
    prop: 'fontFamily',
    themeKey: 'typography'
  });
  var fontSize = style$2({
    prop: 'fontSize',
    themeKey: 'typography'
  });
  var fontStyle = style$2({
    prop: 'fontStyle',
    themeKey: 'typography'
  });
  var fontWeight = style$2({
    prop: 'fontWeight',
    themeKey: 'typography'
  });
  var letterSpacing = style$2({
    prop: 'letterSpacing'
  });
  var lineHeight = style$2({
    prop: 'lineHeight'
  });
  var textAlign = style$2({
    prop: 'textAlign'
  });
  var typographyVariant = style$2({
    prop: 'typography',
    cssProperty: false,
    themeKey: 'typography'
  });
  var typography = compose(typographyVariant, fontFamily, fontSize, fontStyle, fontWeight, letterSpacing, lineHeight, textAlign);
  var typography$1 = typography;
  var filterPropsMapping = {
    borders: borders$1.filterProps,
    display: display.filterProps,
    flexbox: flexbox$1.filterProps,
    grid: grid$1.filterProps,
    positions: positions.filterProps,
    palette: palette$1.filterProps,
    shadows: shadows$2.filterProps,
    sizing: sizing$1.filterProps,
    spacing: spacing.filterProps,
    typography: typography$1.filterProps
  };
  var styleFunctionMapping = {
    borders: borders$1,
    display: display,
    flexbox: flexbox$1,
    grid: grid$1,
    positions: positions,
    palette: palette$1,
    shadows: shadows$2,
    sizing: sizing$1,
    spacing: spacing,
    typography: typography$1
  };
  var propToStyleFunction = Object.keys(filterPropsMapping).reduce(function (acc, styleFnName) {
    filterPropsMapping[styleFnName].forEach(function (propName) {
      acc[propName] = styleFunctionMapping[styleFnName];
    });
    return acc;
  }, {});

  function getThemeValue(prop, value, theme) {
    var _inputProps;

    var inputProps = (_inputProps = {}, _defineProperty(_inputProps, prop, value), _defineProperty(_inputProps, "theme", theme), _inputProps);
    var styleFunction = propToStyleFunction[prop];
    return styleFunction ? styleFunction(inputProps) : _defineProperty({}, prop, value);
  }

  function objectsHaveSameKeys() {
    for (var _len15 = arguments.length, objects = new Array(_len15), _key15 = 0; _key15 < _len15; _key15++) {
      objects[_key15] = arguments[_key15];
    }

    var allKeys = objects.reduce(function (keys, object) {
      return keys.concat(Object.keys(object));
    }, []);
    var union = new Set(allKeys);
    return objects.every(function (object) {
      return union.size === Object.keys(object).length;
    });
  }

  function callIfFn(maybeFn, arg) {
    return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
  }

  function styleFunctionSx(props) {
    var _ref18 = props || {},
        sx = _ref18.sx,
        _ref18$theme = _ref18.theme,
        theme = _ref18$theme === void 0 ? {} : _ref18$theme;

    if (!sx) {
      return null; // emotion & styled-components will neglect null
    }
    /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */


    function traverse(sxInput) {
      var sxObject = sxInput;

      if (typeof sxInput === 'function') {
        sxObject = sxInput(theme);
      } else if (typeof sxInput !== 'object') {
        // value
        return sxInput;
      }

      var emptyBreakpoints = createEmptyBreakpointObject(theme.breakpoints);
      var breakpointsKeys = Object.keys(emptyBreakpoints);
      var css = emptyBreakpoints;
      Object.keys(sxObject).forEach(function (styleKey) {
        var value = callIfFn(sxObject[styleKey], theme);

        if (value !== null && value !== undefined) {
          if (typeof value === 'object') {
            if (propToStyleFunction[styleKey]) {
              css = merge(css, getThemeValue(styleKey, value, theme));
            } else {
              var breakpointsValues = handleBreakpoints({
                theme: theme
              }, value, function (x) {
                return _defineProperty({}, styleKey, x);
              });

              if (objectsHaveSameKeys(breakpointsValues, value)) {
                css[styleKey] = styleFunctionSx({
                  sx: value,
                  theme: theme
                });
              } else {
                css = merge(css, breakpointsValues);
              }
            }
          } else {
            css = merge(css, getThemeValue(styleKey, value, theme));
          }
        }
      });
      return removeUnusedBreakpoints(breakpointsKeys, css);
    }

    return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
  }

  styleFunctionSx.filterProps = ['sx'];

  function _objectWithoutPropertiesLoose$4(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }

  var _excluded$1N = ["sx"];

  var splitProps = function splitProps(props) {
    var result = {
      systemProps: {},
      otherProps: {}
    };
    Object.keys(props).forEach(function (prop) {
      if (propToStyleFunction[prop]) {
        result.systemProps[prop] = props[prop];
      } else {
        result.otherProps[prop] = props[prop];
      }
    });
    return result;
  };

  function extendSxProp(props) {
    var inSx = props.sx,
        other = _objectWithoutPropertiesLoose$4(props, _excluded$1N);

    var _splitProps = splitProps(other),
        systemProps = _splitProps.systemProps,
        otherProps = _splitProps.otherProps;

    var finalSx;

    if (Array.isArray(inSx)) {
      finalSx = [systemProps].concat(_toConsumableArray(inSx));
    } else if (typeof inSx === 'function') {
      finalSx = function finalSx() {
        var result = inSx.apply(void 0, arguments);

        if (!isPlainObject(result)) {
          return systemProps;
        }

        return _extends$8({}, systemProps, result);
      };
    } else {
      finalSx = _extends$8({}, systemProps, inSx);
    }

    return _extends$8({}, otherProps, {
      sx: finalSx
    });
  }

  var _excluded$1M = ["values", "unit", "step"];

  function createBreakpoints(breakpoints) {
    var _breakpoints$values = breakpoints.values,
        values = _breakpoints$values === void 0 ? {
      xs: 0,
      // phone
      sm: 600,
      // tablet
      md: 900,
      // small laptop
      lg: 1200,
      // desktop
      xl: 1536 // large screen

    } : _breakpoints$values,
        _breakpoints$unit = breakpoints.unit,
        unit = _breakpoints$unit === void 0 ? 'px' : _breakpoints$unit,
        _breakpoints$step = breakpoints.step,
        step = _breakpoints$step === void 0 ? 5 : _breakpoints$step,
        other = _objectWithoutPropertiesLoose$4(breakpoints, _excluded$1M);

    var keys = Object.keys(values);

    function up(key) {
      var value = typeof values[key] === 'number' ? values[key] : key;
      return "@media (min-width:".concat(value).concat(unit, ")");
    }

    function down(key) {
      var value = typeof values[key] === 'number' ? values[key] : key;
      return "@media (max-width:".concat(value - step / 100).concat(unit, ")");
    }

    function between(start, end) {
      var endIndex = keys.indexOf(end);
      return "@media (min-width:".concat(typeof values[start] === 'number' ? values[start] : start).concat(unit, ") and ") + "(max-width:".concat((endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100).concat(unit, ")");
    }

    function only(key) {
      if (keys.indexOf(key) + 1 < keys.length) {
        return between(key, keys[keys.indexOf(key) + 1]);
      }

      return up(key);
    }

    return _extends$8({
      keys: keys,
      values: values,
      up: up,
      down: down,
      between: between,
      only: only,
      unit: unit
    }, other);
  }

  var shape = {
    borderRadius: 4
  };
  var shape$1 = shape;
  /* tslint:enable:unified-signatures */

  function createSpacing() {
    var spacingInput = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;

    // Already transformed.
    if (spacingInput.mui) {
      return spacingInput;
    } // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
    // Smaller components, such as icons, can align to a 4dp grid.
    // https://material.io/design/layout/understanding-layout.html#usage


    var transform = createUnarySpacing({
      spacing: spacingInput
    });

    var spacing = function spacing() {
      for (var _len16 = arguments.length, argsInput = new Array(_len16), _key16 = 0; _key16 < _len16; _key16++) {
        argsInput[_key16] = arguments[_key16];
      }

      if (process.env.NODE_ENV !== 'production') {
        if (!(argsInput.length <= 4)) {
          console.error("MUI: Too many arguments provided, expected between 0 and 4, got ".concat(argsInput.length));
        }
      }

      var args = argsInput.length === 0 ? [1] : argsInput;
      return args.map(function (argument) {
        var output = transform(argument);
        return typeof output === 'number' ? "".concat(output, "px") : output;
      }).join(' ');
    };

    spacing.mui = true;
    return spacing;
  }

  var _excluded$1L = ["breakpoints", "palette", "spacing", "shape"];

  function createTheme$1() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var _options$breakpoints = options.breakpoints,
        breakpointsInput = _options$breakpoints === void 0 ? {} : _options$breakpoints,
        _options$palette = options.palette,
        paletteInput = _options$palette === void 0 ? {} : _options$palette,
        spacingInput = options.spacing,
        _options$shape = options.shape,
        shapeInput = _options$shape === void 0 ? {} : _options$shape,
        other = _objectWithoutPropertiesLoose$4(options, _excluded$1L);

    var breakpoints = createBreakpoints(breakpointsInput);
    var spacing = createSpacing(spacingInput);
    var muiTheme = deepmerge({
      breakpoints: breakpoints,
      direction: 'ltr',
      components: {},
      // Inject component definitions.
      palette: _extends$8({
        mode: 'light'
      }, paletteInput),
      spacing: spacing,
      shape: _extends$8({}, shape$1, shapeInput)
    }, other);

    for (var _len17 = arguments.length, args = new Array(_len17 > 1 ? _len17 - 1 : 0), _key17 = 1; _key17 < _len17; _key17++) {
      args[_key17 - 1] = arguments[_key17];
    }

    muiTheme = args.reduce(function (acc, argument) {
      return deepmerge(acc, argument);
    }, muiTheme);
    return muiTheme;
  }

  function _extends$7() {
    _extends$7 = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends$7.apply(this, arguments);
  }

  var ThemeContext = /*#__PURE__*/React__namespace.createContext(null);

  if (process.env.NODE_ENV !== 'production') {
    ThemeContext.displayName = 'ThemeContext';
  }

  var ThemeContext$1 = ThemeContext;

  function useTheme$3() {
    var theme = React__namespace.useContext(ThemeContext$1);

    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      React__namespace.useDebugValue(theme);
    }

    return theme;
  }

  var hasSymbol = typeof Symbol === 'function' && Symbol.for;
  var nested = hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';

  function mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === 'function') {
      var mergedTheme = localTheme(outerTheme);

      if (process.env.NODE_ENV !== 'production') {
        if (!mergedTheme) {
          console.error(['MUI: You should return an object from your theme function, i.e.', '<ThemeProvider theme={() => ({})} />'].join('\n'));
        }
      }

      return mergedTheme;
    }

    return _extends$7({}, outerTheme, localTheme);
  }
  /**
   * This component takes a `theme` prop.
   * It makes the `theme` available down the React tree thanks to React context.
   * This component should preferably be used at **the root of your component tree**.
   */


  function ThemeProvider$1(props) {
    var children = props.children,
        localTheme = props.theme;
    var outerTheme = useTheme$3();

    if (process.env.NODE_ENV !== 'production') {
      if (outerTheme === null && typeof localTheme === 'function') {
        console.error(['MUI: You are providing a theme function prop to the ThemeProvider component:', '<ThemeProvider theme={outerTheme => outerTheme} />', '', 'However, no outer theme is present.', 'Make sure a theme is already injected higher in the React tree ' + 'or provide a theme object.'].join('\n'));
      }
    }

    var theme = React__namespace.useMemo(function () {
      var output = outerTheme === null ? localTheme : mergeOuterLocalTheme(outerTheme, localTheme);

      if (output != null) {
        output[nested] = outerTheme !== null;
      }

      return output;
    }, [localTheme, outerTheme]);
    return /*#__PURE__*/jsxRuntime$1.jsx(ThemeContext$1.Provider, {
      value: theme,
      children: children
    });
  }

  process.env.NODE_ENV !== "production" ? ThemeProvider$1.propTypes = {
    /**
     * Your component tree.
     */
    children: PropTypes.node,

    /**
     * A theme object. You can provide a function to extend the outer theme.
     */
    theme: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired
  } : void 0;

  if (process.env.NODE_ENV !== 'production') {
    process.env.NODE_ENV !== "production" ? ThemeProvider$1.propTypes = exactProp(ThemeProvider$1.propTypes) : void 0;
  }

  function isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
  }

  function useTheme$2() {
    var defaultTheme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var contextTheme = useTheme$3();
    return !contextTheme || isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
  }

  var systemDefaultTheme$1 = createTheme$1();

  function useTheme$1() {
    var defaultTheme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : systemDefaultTheme$1;
    return useTheme$2(defaultTheme);
  }

  var _excluded$1K = ["variant"];

  function isEmpty$2(string) {
    return string.length === 0;
  }
  /**
   * Generates string classKey based on the properties provided. It starts with the
   * variant if defined, and then it appends all other properties in alphabetical order.
   * @param {object} props - the properties for which the classKey should be created.
   */


  function propsToClassKey(props) {
    var variant = props.variant,
        other = _objectWithoutPropertiesLoose$4(props, _excluded$1K);

    var classKey = variant || '';
    Object.keys(other).sort().forEach(function (key) {
      if (key === 'color') {
        classKey += isEmpty$2(classKey) ? props[key] : capitalize$1(props[key]);
      } else {
        classKey += "".concat(isEmpty$2(classKey) ? key : capitalize$1(key)).concat(capitalize$1(props[key].toString()));
      }
    });
    return classKey;
  }

  var _excluded$1J = ["name", "slot", "skipVariantsResolver", "skipSx", "overridesResolver"],
      _excluded2$5 = ["theme"],
      _excluded3 = ["theme"];

  function isEmpty$1(obj) {
    return Object.keys(obj).length === 0;
  }

  var getStyleOverrides = function getStyleOverrides(name, theme) {
    if (theme.components && theme.components[name] && theme.components[name].styleOverrides) {
      return theme.components[name].styleOverrides;
    }

    return null;
  };

  var getVariantStyles = function getVariantStyles(name, theme) {
    var variants = [];

    if (theme && theme.components && theme.components[name] && theme.components[name].variants) {
      variants = theme.components[name].variants;
    }

    var variantsStyles = {};
    variants.forEach(function (definition) {
      var key = propsToClassKey(definition.props);
      variantsStyles[key] = definition.style;
    });
    return variantsStyles;
  };

  var variantsResolver = function variantsResolver(props, styles, theme, name) {
    var _theme$components, _theme$components$nam;

    var _props$ownerState = props.ownerState,
        ownerState = _props$ownerState === void 0 ? {} : _props$ownerState;
    var variantsStyles = [];
    var themeVariants = theme == null ? void 0 : (_theme$components = theme.components) == null ? void 0 : (_theme$components$nam = _theme$components[name]) == null ? void 0 : _theme$components$nam.variants;

    if (themeVariants) {
      themeVariants.forEach(function (themeVariant) {
        var isMatch = true;
        Object.keys(themeVariant.props).forEach(function (key) {
          if (ownerState[key] !== themeVariant.props[key] && props[key] !== themeVariant.props[key]) {
            isMatch = false;
          }
        });

        if (isMatch) {
          variantsStyles.push(styles[propsToClassKey(themeVariant.props)]);
        }
      });
    }

    return variantsStyles;
  };

  function shouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
  }

  var systemDefaultTheme = createTheme$1();

  var lowercaseFirstLetter = function lowercaseFirstLetter(string) {
    return string.charAt(0).toLowerCase() + string.slice(1);
  };

  function createStyled() {
    var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _input$defaultTheme = input.defaultTheme,
        defaultTheme = _input$defaultTheme === void 0 ? systemDefaultTheme : _input$defaultTheme,
        _input$rootShouldForw = input.rootShouldForwardProp,
        rootShouldForwardProp = _input$rootShouldForw === void 0 ? shouldForwardProp : _input$rootShouldForw,
        _input$slotShouldForw = input.slotShouldForwardProp,
        slotShouldForwardProp = _input$slotShouldForw === void 0 ? shouldForwardProp : _input$slotShouldForw;
    return function (tag) {
      var inputOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var componentName = inputOptions.name,
          componentSlot = inputOptions.slot,
          inputSkipVariantsResolver = inputOptions.skipVariantsResolver,
          inputSkipSx = inputOptions.skipSx,
          overridesResolver = inputOptions.overridesResolver,
          options = _objectWithoutPropertiesLoose$4(inputOptions, _excluded$1J); // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.


      var skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : componentSlot && componentSlot !== 'Root' || false;
      var skipSx = inputSkipSx || false;
      var label;

      if (process.env.NODE_ENV !== 'production') {
        if (componentName) {
          label = "".concat(componentName, "-").concat(lowercaseFirstLetter(componentSlot || 'Root'));
        }
      }

      var shouldForwardPropOption = shouldForwardProp;

      if (componentSlot === 'Root') {
        shouldForwardPropOption = rootShouldForwardProp;
      } else if (componentSlot) {
        // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
      }

      var defaultStyledResolver = styled$2(tag, _extends$8({
        shouldForwardProp: shouldForwardPropOption,
        label: label
      }, options));

      var muiStyledResolver = function muiStyledResolver(styleArg) {
        for (var _len18 = arguments.length, expressions = new Array(_len18 > 1 ? _len18 - 1 : 0), _key18 = 1; _key18 < _len18; _key18++) {
          expressions[_key18 - 1] = arguments[_key18];
        }

        var expressionsWithDefaultTheme = expressions ? expressions.map(function (stylesArg) {
          // On the server emotion doesn't use React.forwardRef for creating components, so the created
          // component stays as a function. This condition makes sure that we do not interpolate functions
          // which are basically components used as a selectors.
          // eslint-disable-next-line no-underscore-dangle
          return typeof stylesArg === 'function' && stylesArg.__emotion_real !== stylesArg ? function (_ref) {
            var themeInput = _ref.theme,
                other = _objectWithoutPropertiesLoose$4(_ref, _excluded2$5);

            return stylesArg(_extends$8({
              theme: isEmpty$1(themeInput) ? defaultTheme : themeInput
            }, other));
          } : stylesArg;
        }) : [];
        var transformedStyleArg = styleArg;

        if (componentName && overridesResolver) {
          expressionsWithDefaultTheme.push(function (props) {
            var theme = isEmpty$1(props.theme) ? defaultTheme : props.theme;
            var styleOverrides = getStyleOverrides(componentName, theme);

            if (styleOverrides) {
              return overridesResolver(props, styleOverrides);
            }

            return null;
          });
        }

        if (componentName && !skipVariantsResolver) {
          expressionsWithDefaultTheme.push(function (props) {
            var theme = isEmpty$1(props.theme) ? defaultTheme : props.theme;
            return variantsResolver(props, getVariantStyles(componentName, theme), theme, componentName);
          });
        }

        if (!skipSx) {
          expressionsWithDefaultTheme.push(function (props) {
            var theme = isEmpty$1(props.theme) ? defaultTheme : props.theme;
            return styleFunctionSx(_extends$8({}, props, {
              theme: theme
            }));
          });
        }

        var numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;

        if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
          var placeholders = new Array(numOfCustomFnsApplied).fill(''); // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.

          transformedStyleArg = [].concat(_toConsumableArray(styleArg), _toConsumableArray(placeholders));
          transformedStyleArg.raw = [].concat(_toConsumableArray(styleArg.raw), _toConsumableArray(placeholders));
        } else if (typeof styleArg === 'function') {
          // If the type is function, we need to define the default theme.
          transformedStyleArg = function transformedStyleArg(_ref2) {
            var themeInput = _ref2.theme,
                other = _objectWithoutPropertiesLoose$4(_ref2, _excluded3);

            return styleArg(_extends$8({
              theme: isEmpty$1(themeInput) ? defaultTheme : themeInput
            }, other));
          };
        }

        var Component = defaultStyledResolver.apply(void 0, [transformedStyleArg].concat(_toConsumableArray(expressionsWithDefaultTheme)));

        if (process.env.NODE_ENV !== 'production') {
          var displayName;

          if (componentName) {
            displayName = "".concat(componentName).concat(componentSlot || '');
          }

          if (displayName === undefined) {
            displayName = "Styled(".concat(getDisplayName(tag), ")");
          }

          Component.displayName = displayName;
        }

        return Component;
      };

      return muiStyledResolver;
    };
  }

  function getThemeProps(params) {
    var theme = params.theme,
        name = params.name,
        props = params.props;

    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) {
      return props;
    }

    return resolveProps(theme.components[name].defaultProps, props);
  }

  function useThemeProps$1(_ref20) {
    var props = _ref20.props,
        name = _ref20.name,
        defaultTheme = _ref20.defaultTheme;
    var theme = useTheme$1(defaultTheme);
    var mergedProps = getThemeProps({
      theme: theme,
      name: name,
      props: props
    });
    return mergedProps;
  }
  /**
   * Returns a number whose value is limited to the given range.
   * @param {number} value The value to be clamped
   * @param {number} min The lower boundary of the output range
   * @param {number} max The upper boundary of the output range
   * @returns {number} A number in the range [min, max]
   */


  function clamp(value) {
    var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

    if (process.env.NODE_ENV !== 'production') {
      if (value < min || value > max) {
        console.error("MUI: The value provided ".concat(value, " is out of range [").concat(min, ", ").concat(max, "]."));
      }
    }

    return Math.min(Math.max(min, value), max);
  }
  /**
   * Converts a color from CSS hex format to CSS rgb format.
   * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
   * @returns {string} A CSS rgb color string
   */


  function hexToRgb(color) {
    color = color.substr(1);
    var re = new RegExp(".{1,".concat(color.length >= 6 ? 2 : 1, "}"), 'g');
    var colors = color.match(re);

    if (colors && colors[0].length === 1) {
      colors = colors.map(function (n) {
        return n + n;
      });
    }

    return colors ? "rgb".concat(colors.length === 4 ? 'a' : '', "(").concat(colors.map(function (n, index) {
      return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', '), ")") : '';
  }
  /**
   * Returns an object with the type and values of a color.
   *
   * Note: Does not support rgb % values.
   * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
   * @returns {object} - A MUI color object: {type: string, values: number[]}
   */


  function decomposeColor(color) {
    // Idempotent
    if (color.type) {
      return color;
    }

    if (color.charAt(0) === '#') {
      return decomposeColor(hexToRgb(color));
    }

    var marker = color.indexOf('(');
    var type = color.substring(0, marker);

    if (['rgb', 'rgba', 'hsl', 'hsla', 'color'].indexOf(type) === -1) {
      throw new Error(process.env.NODE_ENV !== "production" ? "MUI: Unsupported `".concat(color, "` color.\nThe following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().") : formatMuiErrorMessage(9, color));
    }

    var values = color.substring(marker + 1, color.length - 1);
    var colorSpace;

    if (type === 'color') {
      values = values.split(' ');
      colorSpace = values.shift();

      if (values.length === 4 && values[3].charAt(0) === '/') {
        values[3] = values[3].substr(1);
      }

      if (['srgb', 'display-p3', 'a98-rgb', 'prophoto-rgb', 'rec-2020'].indexOf(colorSpace) === -1) {
        throw new Error(process.env.NODE_ENV !== "production" ? "MUI: unsupported `".concat(colorSpace, "` color space.\nThe following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.") : formatMuiErrorMessage(10, colorSpace));
      }
    } else {
      values = values.split(',');
    }

    values = values.map(function (value) {
      return parseFloat(value);
    });
    return {
      type: type,
      values: values,
      colorSpace: colorSpace
    };
  }
  /**
   * Converts a color object with type and values to a string.
   * @param {object} color - Decomposed color
   * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla'
   * @param {array} color.values - [n,n,n] or [n,n,n,n]
   * @returns {string} A CSS color string
   */


  function recomposeColor(color) {
    var type = color.type,
        colorSpace = color.colorSpace;
    var values = color.values;

    if (type.indexOf('rgb') !== -1) {
      // Only convert the first 3 values to int (i.e. not alpha)
      values = values.map(function (n, i) {
        return i < 3 ? parseInt(n, 10) : n;
      });
    } else if (type.indexOf('hsl') !== -1) {
      values[1] = "".concat(values[1], "%");
      values[2] = "".concat(values[2], "%");
    }

    if (type.indexOf('color') !== -1) {
      values = "".concat(colorSpace, " ").concat(values.join(' '));
    } else {
      values = "".concat(values.join(', '));
    }

    return "".concat(type, "(").concat(values, ")");
  }
  /**
   * Converts a color from hsl format to rgb format.
   * @param {string} color - HSL color values
   * @returns {string} rgb color values
   */


  function hslToRgb(color) {
    color = decomposeColor(color);
    var _color = color,
        values = _color.values;
    var h = values[0];
    var s = values[1] / 100;
    var l = values[2] / 100;
    var a = s * Math.min(l, 1 - l);

    var f = function f(n) {
      var k = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (n + h / 30) % 12;
      return l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    };

    var type = 'rgb';
    var rgb = [Math.round(f(0) * 255), Math.round(f(8) * 255), Math.round(f(4) * 255)];

    if (color.type === 'hsla') {
      type += 'a';
      rgb.push(values[3]);
    }

    return recomposeColor({
      type: type,
      values: rgb
    });
  }
  /**
   * The relative brightness of any point in a color space,
   * normalized to 0 for darkest black and 1 for lightest white.
   *
   * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
   * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
   * @returns {number} The relative brightness of the color in the range 0 - 1
   */


  function getLuminance(color) {
    color = decomposeColor(color);
    var rgb = color.type === 'hsl' ? decomposeColor(hslToRgb(color)).values : color.values;
    rgb = rgb.map(function (val) {
      if (color.type !== 'color') {
        val /= 255; // normalized
      }

      return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
    }); // Truncate at 3 digits

    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
  }
  /**
   * Calculates the contrast ratio between two colors.
   *
   * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
   * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
   * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
   * @returns {number} A contrast ratio value in the range 0 - 21.
   */


  function getContrastRatio(foreground, background) {
    var lumA = getLuminance(foreground);
    var lumB = getLuminance(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
  }
  /**
   * Sets the absolute transparency of a color.
   * Any existing alpha values are overwritten.
   * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
   * @param {number} value - value to set the alpha channel to in the range 0 - 1
   * @returns {string} A CSS color string. Hex input values are returned as rgb
   */


  function alpha(color, value) {
    color = decomposeColor(color);
    value = clamp(value);

    if (color.type === 'rgb' || color.type === 'hsl') {
      color.type += 'a';
    }

    if (color.type === 'color') {
      color.values[3] = "/".concat(value);
    } else {
      color.values[3] = value;
    }

    return recomposeColor(color);
  }
  /**
   * Darkens a color.
   * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
   * @param {number} coefficient - multiplier in the range 0 - 1
   * @returns {string} A CSS color string. Hex input values are returned as rgb
   */


  function darken(color, coefficient) {
    color = decomposeColor(color);
    coefficient = clamp(coefficient);

    if (color.type.indexOf('hsl') !== -1) {
      color.values[2] *= 1 - coefficient;
    } else if (color.type.indexOf('rgb') !== -1 || color.type.indexOf('color') !== -1) {
      for (var i = 0; i < 3; i += 1) {
        color.values[i] *= 1 - coefficient;
      }
    }

    return recomposeColor(color);
  }
  /**
   * Lightens a color.
   * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
   * @param {number} coefficient - multiplier in the range 0 - 1
   * @returns {string} A CSS color string. Hex input values are returned as rgb
   */


  function lighten(color, coefficient) {
    color = decomposeColor(color);
    coefficient = clamp(coefficient);

    if (color.type.indexOf('hsl') !== -1) {
      color.values[2] += (100 - color.values[2]) * coefficient;
    } else if (color.type.indexOf('rgb') !== -1) {
      for (var i = 0; i < 3; i += 1) {
        color.values[i] += (255 - color.values[i]) * coefficient;
      }
    } else if (color.type.indexOf('color') !== -1) {
      for (var _i4 = 0; _i4 < 3; _i4 += 1) {
        color.values[_i4] += (1 - color.values[_i4]) * coefficient;
      }
    }

    return recomposeColor(color);
  }
  /**
   * Darken or lighten a color, depending on its luminance.
   * Light colors are darkened, dark colors are lightened.
   * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
   * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
   * @returns {string} A CSS color string. Hex input values are returned as rgb
   */


  function emphasize(color) {
    var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;
    return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
  }

  function InnerThemeProvider(props) {
    var theme = useTheme$1();
    return /*#__PURE__*/jsxRuntime$1.jsx(ThemeContext$2.Provider, {
      value: typeof theme === 'object' ? theme : {},
      children: props.children
    });
  }

  process.env.NODE_ENV !== "production" ? InnerThemeProvider.propTypes = {
    /**
     * Your component tree.
     */
    children: PropTypes.node
  } : void 0;
  /**
   * This component makes the `theme` available down the React tree.
   * It should preferably be used at **the root of your component tree**.
   */

  function ThemeProvider(props) {
    var children = props.children,
        localTheme = props.theme;
    return /*#__PURE__*/jsxRuntime$1.jsx(ThemeProvider$1, {
      theme: localTheme,
      children: /*#__PURE__*/jsxRuntime$1.jsx(InnerThemeProvider, {
        children: children
      })
    });
  }

  process.env.NODE_ENV !== "production" ? ThemeProvider.propTypes = {
    /**
     * Your component tree.
     */
    children: PropTypes.node,

    /**
     * A theme object. You can provide a function to extend the outer theme.
     */
    theme: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired
  } : void 0;

  if (process.env.NODE_ENV !== 'production') {
    process.env.NODE_ENV !== "production" ? ThemeProvider.propTypes = exactProp(ThemeProvider.propTypes) : void 0;
  }

  function createMixins(breakpoints, spacing, mixins) {
    var _toolbar;

    return _extends$c({
      toolbar: (_toolbar = {
        minHeight: 56
      }, _defineProperty(_toolbar, "".concat(breakpoints.up('xs'), " and (orientation: landscape)"), {
        minHeight: 48
      }), _defineProperty(_toolbar, breakpoints.up('sm'), {
        minHeight: 64
      }), _toolbar)
    }, mixins);
  }

  var common = {
    black: '#000',
    white: '#fff'
  };
  var common$1 = common;
  var grey = {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#f5f5f5',
    A200: '#eeeeee',
    A400: '#bdbdbd',
    A700: '#616161'
  };
  var grey$1 = grey;
  var purple = {
    50: '#f3e5f5',
    100: '#e1bee7',
    200: '#ce93d8',
    300: '#ba68c8',
    400: '#ab47bc',
    500: '#9c27b0',
    600: '#8e24aa',
    700: '#7b1fa2',
    800: '#6a1b9a',
    900: '#4a148c',
    A100: '#ea80fc',
    A200: '#e040fb',
    A400: '#d500f9',
    A700: '#aa00ff'
  };
  var purple$1 = purple;
  var red = {
    50: '#ffebee',
    100: '#ffcdd2',
    200: '#ef9a9a',
    300: '#e57373',
    400: '#ef5350',
    500: '#f44336',
    600: '#e53935',
    700: '#d32f2f',
    800: '#c62828',
    900: '#b71c1c',
    A100: '#ff8a80',
    A200: '#ff5252',
    A400: '#ff1744',
    A700: '#d50000'
  };
  var red$1 = red;
  var orange = {
    50: '#fff3e0',
    100: '#ffe0b2',
    200: '#ffcc80',
    300: '#ffb74d',
    400: '#ffa726',
    500: '#ff9800',
    600: '#fb8c00',
    700: '#f57c00',
    800: '#ef6c00',
    900: '#e65100',
    A100: '#ffd180',
    A200: '#ffab40',
    A400: '#ff9100',
    A700: '#ff6d00'
  };
  var orange$1 = orange;
  var blue = {
    50: '#e3f2fd',
    100: '#bbdefb',
    200: '#90caf9',
    300: '#64b5f6',
    400: '#42a5f5',
    500: '#2196f3',
    600: '#1e88e5',
    700: '#1976d2',
    800: '#1565c0',
    900: '#0d47a1',
    A100: '#82b1ff',
    A200: '#448aff',
    A400: '#2979ff',
    A700: '#2962ff'
  };
  var blue$1 = blue;
  var lightBlue = {
    50: '#e1f5fe',
    100: '#b3e5fc',
    200: '#81d4fa',
    300: '#4fc3f7',
    400: '#29b6f6',
    500: '#03a9f4',
    600: '#039be5',
    700: '#0288d1',
    800: '#0277bd',
    900: '#01579b',
    A100: '#80d8ff',
    A200: '#40c4ff',
    A400: '#00b0ff',
    A700: '#0091ea'
  };
  var lightBlue$1 = lightBlue;
  var green = {
    50: '#e8f5e9',
    100: '#c8e6c9',
    200: '#a5d6a7',
    300: '#81c784',
    400: '#66bb6a',
    500: '#4caf50',
    600: '#43a047',
    700: '#388e3c',
    800: '#2e7d32',
    900: '#1b5e20',
    A100: '#b9f6ca',
    A200: '#69f0ae',
    A400: '#00e676',
    A700: '#00c853'
  };
  var green$1 = green;
  var _excluded$1I = ["mode", "contrastThreshold", "tonalOffset"];
  var light = {
    // The colors used to style the text.
    text: {
      // The most important text.
      primary: 'rgba(0, 0, 0, 0.87)',
      // Secondary text.
      secondary: 'rgba(0, 0, 0, 0.6)',
      // Disabled text have even lower visual prominence.
      disabled: 'rgba(0, 0, 0, 0.38)'
    },
    // The color used to divide different elements.
    divider: 'rgba(0, 0, 0, 0.12)',
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
      paper: common$1.white,
      default: common$1.white
    },
    // The colors used to style the action elements.
    action: {
      // The color of an active action like an icon button.
      active: 'rgba(0, 0, 0, 0.54)',
      // The color of an hovered action.
      hover: 'rgba(0, 0, 0, 0.04)',
      hoverOpacity: 0.04,
      // The color of a selected action.
      selected: 'rgba(0, 0, 0, 0.08)',
      selectedOpacity: 0.08,
      // The color of a disabled action.
      disabled: 'rgba(0, 0, 0, 0.26)',
      // The background color of a disabled action.
      disabledBackground: 'rgba(0, 0, 0, 0.12)',
      disabledOpacity: 0.38,
      focus: 'rgba(0, 0, 0, 0.12)',
      focusOpacity: 0.12,
      activatedOpacity: 0.12
    }
  };
  var dark = {
    text: {
      primary: common$1.white,
      secondary: 'rgba(255, 255, 255, 0.7)',
      disabled: 'rgba(255, 255, 255, 0.5)',
      icon: 'rgba(255, 255, 255, 0.5)'
    },
    divider: 'rgba(255, 255, 255, 0.12)',
    background: {
      paper: '#121212',
      default: '#121212'
    },
    action: {
      active: common$1.white,
      hover: 'rgba(255, 255, 255, 0.08)',
      hoverOpacity: 0.08,
      selected: 'rgba(255, 255, 255, 0.16)',
      selectedOpacity: 0.16,
      disabled: 'rgba(255, 255, 255, 0.3)',
      disabledBackground: 'rgba(255, 255, 255, 0.12)',
      disabledOpacity: 0.38,
      focus: 'rgba(255, 255, 255, 0.12)',
      focusOpacity: 0.12,
      activatedOpacity: 0.24
    }
  };

  function addLightOrDark(intent, direction, shade, tonalOffset) {
    var tonalOffsetLight = tonalOffset.light || tonalOffset;
    var tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;

    if (!intent[direction]) {
      if (intent.hasOwnProperty(shade)) {
        intent[direction] = intent[shade];
      } else if (direction === 'light') {
        intent.light = lighten(intent.main, tonalOffsetLight);
      } else if (direction === 'dark') {
        intent.dark = darken(intent.main, tonalOffsetDark);
      }
    }
  }

  function getDefaultPrimary() {
    var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'light';

    if (mode === 'dark') {
      return {
        main: blue$1[200],
        light: blue$1[50],
        dark: blue$1[400]
      };
    }

    return {
      main: blue$1[700],
      light: blue$1[400],
      dark: blue$1[800]
    };
  }

  function getDefaultSecondary() {
    var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'light';

    if (mode === 'dark') {
      return {
        main: purple$1[200],
        light: purple$1[50],
        dark: purple$1[400]
      };
    }

    return {
      main: purple$1[500],
      light: purple$1[300],
      dark: purple$1[700]
    };
  }

  function getDefaultError() {
    var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'light';

    if (mode === 'dark') {
      return {
        main: red$1[500],
        light: red$1[300],
        dark: red$1[700]
      };
    }

    return {
      main: red$1[700],
      light: red$1[400],
      dark: red$1[800]
    };
  }

  function getDefaultInfo() {
    var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'light';

    if (mode === 'dark') {
      return {
        main: lightBlue$1[400],
        light: lightBlue$1[300],
        dark: lightBlue$1[700]
      };
    }

    return {
      main: lightBlue$1[700],
      light: lightBlue$1[500],
      dark: lightBlue$1[900]
    };
  }

  function getDefaultSuccess() {
    var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'light';

    if (mode === 'dark') {
      return {
        main: green$1[400],
        light: green$1[300],
        dark: green$1[700]
      };
    }

    return {
      main: green$1[800],
      light: green$1[500],
      dark: green$1[900]
    };
  }

  function getDefaultWarning() {
    var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'light';

    if (mode === 'dark') {
      return {
        main: orange$1[400],
        light: orange$1[300],
        dark: orange$1[700]
      };
    }

    return {
      main: '#ed6c02',
      // closest to orange[800] that pass 3:1.
      light: orange$1[500],
      dark: orange$1[900]
    };
  }

  function createPalette(palette) {
    var _palette$mode = palette.mode,
        mode = _palette$mode === void 0 ? 'light' : _palette$mode,
        _palette$contrastThre = palette.contrastThreshold,
        contrastThreshold = _palette$contrastThre === void 0 ? 3 : _palette$contrastThre,
        _palette$tonalOffset = palette.tonalOffset,
        tonalOffset = _palette$tonalOffset === void 0 ? 0.2 : _palette$tonalOffset,
        other = _objectWithoutPropertiesLoose$6(palette, _excluded$1I);

    var primary = palette.primary || getDefaultPrimary(mode);
    var secondary = palette.secondary || getDefaultSecondary(mode);
    var error = palette.error || getDefaultError(mode);
    var info = palette.info || getDefaultInfo(mode);
    var success = palette.success || getDefaultSuccess(mode);
    var warning = palette.warning || getDefaultWarning(mode); // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54

    function getContrastText(background) {
      var contrastText = getContrastRatio(background, dark.text.primary) >= contrastThreshold ? dark.text.primary : light.text.primary;

      if (process.env.NODE_ENV !== 'production') {
        var contrast = getContrastRatio(background, contrastText);

        if (contrast < 3) {
          console.error(["MUI: The contrast ratio of ".concat(contrast, ":1 for ").concat(contrastText, " on ").concat(background), 'falls below the WCAG recommended absolute minimum contrast ratio of 3:1.', 'https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast'].join('\n'));
        }
      }

      return contrastText;
    }

    var augmentColor = function augmentColor(_ref21) {
      var color = _ref21.color,
          name = _ref21.name,
          _ref21$mainShade = _ref21.mainShade,
          mainShade = _ref21$mainShade === void 0 ? 500 : _ref21$mainShade,
          _ref21$lightShade = _ref21.lightShade,
          lightShade = _ref21$lightShade === void 0 ? 300 : _ref21$lightShade,
          _ref21$darkShade = _ref21.darkShade,
          darkShade = _ref21$darkShade === void 0 ? 700 : _ref21$darkShade;
      color = _extends$c({}, color);

      if (!color.main && color[mainShade]) {
        color.main = color[mainShade];
      }

      if (!color.hasOwnProperty('main')) {
        throw new Error(process.env.NODE_ENV !== "production" ? "MUI: The color".concat(name ? " (".concat(name, ")") : '', " provided to augmentColor(color) is invalid.\nThe color object needs to have a `main` property or a `").concat(mainShade, "` property.") : formatMuiErrorMessage(11, name ? " (".concat(name, ")") : '', mainShade));
      }

      if (typeof color.main !== 'string') {
        throw new Error(process.env.NODE_ENV !== "production" ? "MUI: The color".concat(name ? " (".concat(name, ")") : '', " provided to augmentColor(color) is invalid.\n`color.main` should be a string, but `").concat(JSON.stringify(color.main), "` was provided instead.\n\nDid you intend to use one of the following approaches?\n\nimport { green } from \"@mui/material/colors\";\n\nconst theme1 = createTheme({ palette: {\n  primary: green,\n} });\n\nconst theme2 = createTheme({ palette: {\n  primary: { main: green[500] },\n} });") : formatMuiErrorMessage(12, name ? " (".concat(name, ")") : '', JSON.stringify(color.main)));
      }

      addLightOrDark(color, 'light', lightShade, tonalOffset);
      addLightOrDark(color, 'dark', darkShade, tonalOffset);

      if (!color.contrastText) {
        color.contrastText = getContrastText(color.main);
      }

      return color;
    };

    var modes = {
      dark: dark,
      light: light
    };

    if (process.env.NODE_ENV !== 'production') {
      if (!modes[mode]) {
        console.error("MUI: The palette mode `".concat(mode, "` is not supported."));
      }
    }

    var paletteOutput = deepmerge(_extends$c({
      // A collection of common colors.
      common: common$1,
      // The palette mode, can be light or dark.
      mode: mode,
      // The colors used to represent primary interface elements for a user.
      primary: augmentColor({
        color: primary,
        name: 'primary'
      }),
      // The colors used to represent secondary interface elements for a user.
      secondary: augmentColor({
        color: secondary,
        name: 'secondary',
        mainShade: 'A400',
        lightShade: 'A200',
        darkShade: 'A700'
      }),
      // The colors used to represent interface elements that the user should be made aware of.
      error: augmentColor({
        color: error,
        name: 'error'
      }),
      // The colors used to represent potentially dangerous actions or important messages.
      warning: augmentColor({
        color: warning,
        name: 'warning'
      }),
      // The colors used to present information to the user that is neutral and not necessarily important.
      info: augmentColor({
        color: info,
        name: 'info'
      }),
      // The colors used to indicate the successful completion of an action that user triggered.
      success: augmentColor({
        color: success,
        name: 'success'
      }),
      // The grey colors.
      grey: grey$1,
      // Used by `getContrastText()` to maximize the contrast between
      // the background and the text.
      contrastThreshold: contrastThreshold,
      // Takes a background color and returns the text color that maximizes the contrast.
      getContrastText: getContrastText,
      // Generate a rich color object.
      augmentColor: augmentColor,
      // Used by the functions below to shift a color's luminance by approximately
      // two indexes within its tonal palette.
      // E.g., shift from Red 500 to Red 300 or Red 700.
      tonalOffset: tonalOffset
    }, modes[mode]), other);
    return paletteOutput;
  }

  var _excluded$1H = ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"];

  function round$1(value) {
    return Math.round(value * 1e5) / 1e5;
  }

  var caseAllCaps = {
    textTransform: 'uppercase'
  };
  var defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
  /**
   * @see @link{https://material.io/design/typography/the-type-system.html}
   * @see @link{https://material.io/design/typography/understanding-typography.html}
   */

  function createTypography(palette, typography) {
    var _ref = typeof typography === 'function' ? typography(palette) : typography,
        _ref$fontFamily = _ref.fontFamily,
        fontFamily = _ref$fontFamily === void 0 ? defaultFontFamily : _ref$fontFamily,
        _ref$fontSize = _ref.fontSize,
        fontSize = _ref$fontSize === void 0 ? 14 : _ref$fontSize,
        _ref$fontWeightLight = _ref.fontWeightLight,
        fontWeightLight = _ref$fontWeightLight === void 0 ? 300 : _ref$fontWeightLight,
        _ref$fontWeightRegula = _ref.fontWeightRegular,
        fontWeightRegular = _ref$fontWeightRegula === void 0 ? 400 : _ref$fontWeightRegula,
        _ref$fontWeightMedium = _ref.fontWeightMedium,
        fontWeightMedium = _ref$fontWeightMedium === void 0 ? 500 : _ref$fontWeightMedium,
        _ref$fontWeightBold = _ref.fontWeightBold,
        fontWeightBold = _ref$fontWeightBold === void 0 ? 700 : _ref$fontWeightBold,
        _ref$htmlFontSize = _ref.htmlFontSize,
        htmlFontSize = _ref$htmlFontSize === void 0 ? 16 : _ref$htmlFontSize,
        allVariants = _ref.allVariants,
        pxToRem2 = _ref.pxToRem,
        other = _objectWithoutPropertiesLoose$6(_ref, _excluded$1H);

    if (process.env.NODE_ENV !== 'production') {
      if (typeof fontSize !== 'number') {
        console.error('MUI: `fontSize` is required to be a number.');
      }

      if (typeof htmlFontSize !== 'number') {
        console.error('MUI: `htmlFontSize` is required to be a number.');
      }
    }

    var coef = fontSize / 14;

    var pxToRem = pxToRem2 || function (size) {
      return "".concat(size / htmlFontSize * coef, "rem");
    };

    var buildVariant = function buildVariant(fontWeight, size, lineHeight, letterSpacing, casing) {
      return _extends$c({
        fontFamily: fontFamily,
        fontWeight: fontWeight,
        fontSize: pxToRem(size),
        // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
        lineHeight: lineHeight
      }, fontFamily === defaultFontFamily ? {
        letterSpacing: "".concat(round$1(letterSpacing / size), "em")
      } : {}, casing, allVariants);
    };

    var variants = {
      h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
      h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
      h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
      h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
      h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
      h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
      subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
      subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
      body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
      body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
      button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, caseAllCaps),
      caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
      overline: buildVariant(fontWeightRegular, 12, 2.66, 1, caseAllCaps)
    };
    return deepmerge(_extends$c({
      htmlFontSize: htmlFontSize,
      pxToRem: pxToRem,
      fontFamily: fontFamily,
      fontSize: fontSize,
      fontWeightLight: fontWeightLight,
      fontWeightRegular: fontWeightRegular,
      fontWeightMedium: fontWeightMedium,
      fontWeightBold: fontWeightBold
    }, variants), other, {
      clone: false // No need to clone deep

    });
  }

  var shadowKeyUmbraOpacity = 0.2;
  var shadowKeyPenumbraOpacity = 0.14;
  var shadowAmbientShadowOpacity = 0.12;

  function createShadow() {
    return ["".concat(arguments.length <= 0 ? undefined : arguments[0], "px ").concat(arguments.length <= 1 ? undefined : arguments[1], "px ").concat(arguments.length <= 2 ? undefined : arguments[2], "px ").concat(arguments.length <= 3 ? undefined : arguments[3], "px rgba(0,0,0,").concat(shadowKeyUmbraOpacity, ")"), "".concat(arguments.length <= 4 ? undefined : arguments[4], "px ").concat(arguments.length <= 5 ? undefined : arguments[5], "px ").concat(arguments.length <= 6 ? undefined : arguments[6], "px ").concat(arguments.length <= 7 ? undefined : arguments[7], "px rgba(0,0,0,").concat(shadowKeyPenumbraOpacity, ")"), "".concat(arguments.length <= 8 ? undefined : arguments[8], "px ").concat(arguments.length <= 9 ? undefined : arguments[9], "px ").concat(arguments.length <= 10 ? undefined : arguments[10], "px ").concat(arguments.length <= 11 ? undefined : arguments[11], "px rgba(0,0,0,").concat(shadowAmbientShadowOpacity, ")")].join(',');
  } // Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss


  var shadows = ['none', createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)];
  var shadows$1 = shadows;
  var _excluded$1G = ["duration", "easing", "delay"]; // Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
  // to learn the context in which each easing should be used.

  var easing = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
  }; // Follow https://material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
  // to learn when use what timing

  var duration = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
  };

  function formatMs(milliseconds) {
    return "".concat(Math.round(milliseconds), "ms");
  }

  function getAutoHeightDuration(height) {
    if (!height) {
      return 0;
    }

    var constant = height / 36; // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10

    return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
  }

  function createTransitions(inputTransitions) {
    var mergedEasing = _extends$c({}, easing, inputTransitions.easing);

    var mergedDuration = _extends$c({}, duration, inputTransitions.duration);

    var create = function create() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['all'];
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var _options$duration = options.duration,
          durationOption = _options$duration === void 0 ? mergedDuration.standard : _options$duration,
          _options$easing = options.easing,
          easingOption = _options$easing === void 0 ? mergedEasing.easeInOut : _options$easing,
          _options$delay = options.delay,
          delay = _options$delay === void 0 ? 0 : _options$delay,
          other = _objectWithoutPropertiesLoose$6(options, _excluded$1G);

      if (process.env.NODE_ENV !== 'production') {
        var _isString = function _isString(value) {
          return typeof value === 'string';
        }; // IE11 support, replace with Number.isNaN
        // eslint-disable-next-line no-restricted-globals


        var isNumber = function isNumber(value) {
          return !isNaN(parseFloat(value));
        };

        if (!_isString(props) && !Array.isArray(props)) {
          console.error('MUI: Argument "props" must be a string or Array.');
        }

        if (!isNumber(durationOption) && !_isString(durationOption)) {
          console.error("MUI: Argument \"duration\" must be a number or a string but found ".concat(durationOption, "."));
        }

        if (!_isString(easingOption)) {
          console.error('MUI: Argument "easing" must be a string.');
        }

        if (!isNumber(delay) && !_isString(delay)) {
          console.error('MUI: Argument "delay" must be a number or a string.');
        }

        if (Object.keys(other).length !== 0) {
          console.error("MUI: Unrecognized argument(s) [".concat(Object.keys(other).join(','), "]."));
        }
      }

      return (Array.isArray(props) ? props : [props]).map(function (animatedProp) {
        return "".concat(animatedProp, " ").concat(typeof durationOption === 'string' ? durationOption : formatMs(durationOption), " ").concat(easingOption, " ").concat(typeof delay === 'string' ? delay : formatMs(delay));
      }).join(',');
    };

    return _extends$c({
      getAutoHeightDuration: getAutoHeightDuration,
      create: create
    }, inputTransitions, {
      easing: mergedEasing,
      duration: mergedDuration
    });
  } // We need to centralize the zIndex definitions as they work
  // like global values in the browser.


  var zIndex = {
    mobileStepper: 1000,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
  };
  var zIndex$1 = zIndex;
  var _excluded$1F = ["breakpoints", "mixins", "spacing", "palette", "transitions", "typography", "shape"];

  function createTheme() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var _options$mixins = options.mixins,
        mixinsInput = _options$mixins === void 0 ? {} : _options$mixins,
        _options$palette2 = options.palette,
        paletteInput = _options$palette2 === void 0 ? {} : _options$palette2,
        _options$transitions = options.transitions,
        transitionsInput = _options$transitions === void 0 ? {} : _options$transitions,
        _options$typography = options.typography,
        typographyInput = _options$typography === void 0 ? {} : _options$typography,
        other = _objectWithoutPropertiesLoose$6(options, _excluded$1F);

    var palette = createPalette(paletteInput);
    var systemTheme = createTheme$1(options);
    var muiTheme = deepmerge(systemTheme, {
      mixins: createMixins(systemTheme.breakpoints, systemTheme.spacing, mixinsInput),
      palette: palette,
      // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
      shadows: shadows$1.slice(),
      typography: createTypography(palette, typographyInput),
      transitions: createTransitions(transitionsInput),
      zIndex: _extends$c({}, zIndex$1)
    });
    muiTheme = deepmerge(muiTheme, other);

    for (var _len19 = arguments.length, args = new Array(_len19 > 1 ? _len19 - 1 : 0), _key19 = 1; _key19 < _len19; _key19++) {
      args[_key19 - 1] = arguments[_key19];
    }

    muiTheme = args.reduce(function (acc, argument) {
      return deepmerge(acc, argument);
    }, muiTheme);

    if (process.env.NODE_ENV !== 'production') {
      var stateClasses = ['active', 'checked', 'completed', 'disabled', 'error', 'expanded', 'focused', 'focusVisible', 'required', 'selected'];

      var traverse = function traverse(node, component) {
        var key; // eslint-disable-next-line guard-for-in, no-restricted-syntax

        for (key in node) {
          var child = node[key];

          if (stateClasses.indexOf(key) !== -1 && Object.keys(child).length > 0) {
            if (process.env.NODE_ENV !== 'production') {
              var stateClass = generateUtilityClass('', key);
              console.error(["MUI: The `".concat(component, "` component increases ") + "the CSS specificity of the `".concat(key, "` internal state."), 'You can not override it like this: ', JSON.stringify(node, null, 2), '', "Instead, you need to use the '&.".concat(stateClass, "' syntax:"), JSON.stringify({
                root: _defineProperty({}, "&.".concat(stateClass), child)
              }, null, 2), '', 'https://mui.com/r/state-classes-guide'].join('\n'));
            } // Remove the style to prevent global conflicts.


            node[key] = {};
          }
        }
      };

      Object.keys(muiTheme.components).forEach(function (component) {
        var styleOverrides = muiTheme.components[component].styleOverrides;

        if (styleOverrides && component.indexOf('Mui') === 0) {
          traverse(styleOverrides, component);
        }
      });
    }

    return muiTheme;
  }

  var defaultTheme = createTheme();
  var defaultTheme$1 = defaultTheme;

  function useThemeProps(_ref22) {
    var props = _ref22.props,
        name = _ref22.name;
    return useThemeProps$1({
      props: props,
      name: name,
      defaultTheme: defaultTheme$1
    });
  }

  var rootShouldForwardProp = function rootShouldForwardProp(prop) {
    return shouldForwardProp(prop) && prop !== 'classes';
  };

  var slotShouldForwardProp = shouldForwardProp;
  var styled = createStyled({
    defaultTheme: defaultTheme$1,
    rootShouldForwardProp: rootShouldForwardProp
  });
  var styled$1 = styled;

  function getSvgIconUtilityClass(slot) {
    return generateUtilityClass('MuiSvgIcon', slot);
  }

  generateUtilityClasses('MuiSvgIcon', ['root', 'colorPrimary', 'colorSecondary', 'colorAction', 'colorError', 'colorDisabled', 'fontSizeInherit', 'fontSizeSmall', 'fontSizeMedium', 'fontSizeLarge']);
  var _excluded$1E = ["children", "className", "color", "component", "fontSize", "htmlColor", "titleAccess", "viewBox"];

  var useUtilityClasses$1h = function useUtilityClasses$1h(ownerState) {
    var color = ownerState.color,
        fontSize = ownerState.fontSize,
        classes = ownerState.classes;
    var slots = {
      root: ['root', color !== 'inherit' && "color".concat(capitalize$1(color)), "fontSize".concat(capitalize$1(fontSize))]
    };
    return composeClasses(slots, getSvgIconUtilityClass, classes);
  };

  var SvgIconRoot = styled$1('svg', {
    name: 'MuiSvgIcon',
    slot: 'Root',
    overridesResolver: function overridesResolver(props, styles) {
      var ownerState = props.ownerState;
      return [styles.root, ownerState.color !== 'inherit' && styles["color".concat(capitalize$1(ownerState.color))], styles["fontSize".concat(capitalize$1(ownerState.fontSize))]];
    }
  })(function (_ref23) {
    var theme = _ref23.theme,
        ownerState = _ref23.ownerState;

    var _theme$palette$ownerS, _theme$palette$ownerS2;

    return {
      userSelect: 'none',
      width: '1em',
      height: '1em',
      display: 'inline-block',
      fill: 'currentColor',
      flexShrink: 0,
      transition: theme.transitions.create('fill', {
        duration: theme.transitions.duration.shorter
      }),
      fontSize: {
        inherit: 'inherit',
        small: theme.typography.pxToRem(20),
        medium: theme.typography.pxToRem(24),
        large: theme.typography.pxToRem(35)
      }[ownerState.fontSize],
      // TODO v5 deprecate, v6 remove for sx
      color: (_theme$palette$ownerS = (_theme$palette$ownerS2 = theme.palette[ownerState.color]) == null ? void 0 : _theme$palette$ownerS2.main) != null ? _theme$palette$ownerS : {
        action: theme.palette.action.active,
        disabled: theme.palette.action.disabled,
        inherit: undefined
      }[ownerState.color]
    };
  });
  var SvgIcon$1 = /*#__PURE__*/React__namespace.forwardRef(function SvgIcon(inProps, ref) {
    var props = useThemeProps({
      props: inProps,
      name: 'MuiSvgIcon'
    });

    var children = props.children,
        className = props.className,
        _props$color = props.color,
        color = _props$color === void 0 ? 'inherit' : _props$color,
        _props$component4 = props.component,
        component = _props$component4 === void 0 ? 'svg' : _props$component4,
        _props$fontSize = props.fontSize,
        fontSize = _props$fontSize === void 0 ? 'medium' : _props$fontSize,
        htmlColor = props.htmlColor,
        titleAccess = props.titleAccess,
        _props$viewBox = props.viewBox,
        viewBox = _props$viewBox === void 0 ? '0 0 24 24' : _props$viewBox,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$1E);

    var ownerState = _extends$c({}, props, {
      color: color,
      component: component,
      fontSize: fontSize,
      viewBox: viewBox
    });

    var classes = useUtilityClasses$1h(ownerState);
    return /*#__PURE__*/jsxRuntime$1.jsxs(SvgIconRoot, _extends$c({
      as: component,
      className: clsx(classes.root, className),
      ownerState: ownerState,
      focusable: "false",
      viewBox: viewBox,
      color: htmlColor,
      "aria-hidden": titleAccess ? undefined : true,
      role: titleAccess ? 'img' : undefined,
      ref: ref
    }, other, {
      children: [children, titleAccess ? /*#__PURE__*/jsxRuntime$1.jsx("title", {
        children: titleAccess
      }) : null]
    }));
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  SvgIcon$1.muiName = 'SvgIcon';
  var SvgIcon$2 = SvgIcon$1;

  function createSvgIcon$1(path, displayName) {
    var Component = function Component(props, ref) {
      return /*#__PURE__*/jsxRuntime$1.jsx(SvgIcon$2, _extends$c({
        "data-testid": "".concat(displayName, "Icon"),
        ref: ref
      }, props, {
        children: path
      }));
    };

    if (process.env.NODE_ENV !== 'production') {
      // Need to set `displayName` on the inner component for React.memo.
      // React prior to 16.14 ignores `displayName` on the wrapper.
      Component.displayName = "".concat(displayName, "Icon");
    }

    Component.muiName = SvgIcon$2.muiName;
    return /*#__PURE__*/React__namespace.memo( /*#__PURE__*/React__namespace.forwardRef(Component));
  }

  var CancelIcon = createSvgIcon$1( /*#__PURE__*/jsxRuntime$1.jsx("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
  }), 'Cancel');

  function _extends$6() {
    _extends$6 = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends$6.apply(this, arguments);
  }

  function _objectWithoutPropertiesLoose$3(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }

  function _setPrototypeOf$1(o, p) {
    _setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf$1(o, p);
  }

  function _inheritsLoose$1(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;

    _setPrototypeOf$1(subClass, superClass);
  }
  /**
   * Checks if a given element has a CSS class.
   * 
   * @param element the element
   * @param className the CSS class name
   */


  function hasClass$1(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
  }
  /**
   * Adds a CSS class to a given element.
   * 
   * @param element the element
   * @param className the CSS class name
   */


  function addClass$1(element, className) {
    if (element.classList) element.classList.add(className);else if (!hasClass$1(element, className)) if (typeof element.className === 'string') element.className = element.className + " " + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
  }

  function replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
  }
  /**
   * Removes a CSS class from a given element.
   * 
   * @param element the element
   * @param className the CSS class name
   */


  function removeClass$2(element, className) {
    if (element.classList) {
      element.classList.remove(className);
    } else if (typeof element.className === 'string') {
      element.className = replaceClassName(element.className, className);
    } else {
      element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
    }
  }

  var config = {
    disabled: false
  };
  var timeoutsShape = process.env.NODE_ENV !== 'production' ? PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    enter: PropTypes.number,
    exit: PropTypes.number,
    appear: PropTypes.number
  }).isRequired]) : null;
  var classNamesShape = process.env.NODE_ENV !== 'production' ? PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
    enter: PropTypes.string,
    exit: PropTypes.string,
    active: PropTypes.string
  }), PropTypes.shape({
    enter: PropTypes.string,
    enterDone: PropTypes.string,
    enterActive: PropTypes.string,
    exit: PropTypes.string,
    exitDone: PropTypes.string,
    exitActive: PropTypes.string
  })]) : null;
  var TransitionGroupContext = React__default["default"].createContext(null);
  var UNMOUNTED = 'unmounted';
  var EXITED = 'exited';
  var ENTERING = 'entering';
  var ENTERED = 'entered';
  var EXITING = 'exiting';
  /**
   * The Transition component lets you describe a transition from one component
   * state to another _over time_ with a simple declarative API. Most commonly
   * it's used to animate the mounting and unmounting of a component, but can also
   * be used to describe in-place transition states as well.
   *
   * ---
   *
   * **Note**: `Transition` is a platform-agnostic base component. If you're using
   * transitions in CSS, you'll probably want to use
   * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
   * instead. It inherits all the features of `Transition`, but contains
   * additional features necessary to play nice with CSS transitions (hence the
   * name of the component).
   *
   * ---
   *
   * By default the `Transition` component does not alter the behavior of the
   * component it renders, it only tracks "enter" and "exit" states for the
   * components. It's up to you to give meaning and effect to those states. For
   * example we can add styles to a component when it enters or exits:
   *
   * ```jsx
   * import { Transition } from 'react-transition-group';
   *
   * const duration = 300;
   *
   * const defaultStyle = {
   *   transition: `opacity ${duration}ms ease-in-out`,
   *   opacity: 0,
   * }
   *
   * const transitionStyles = {
   *   entering: { opacity: 1 },
   *   entered:  { opacity: 1 },
   *   exiting:  { opacity: 0 },
   *   exited:  { opacity: 0 },
   * };
   *
   * const Fade = ({ in: inProp }) => (
   *   <Transition in={inProp} timeout={duration}>
   *     {state => (
   *       <div style={{
   *         ...defaultStyle,
   *         ...transitionStyles[state]
   *       }}>
   *         I'm a fade Transition!
   *       </div>
   *     )}
   *   </Transition>
   * );
   * ```
   *
   * There are 4 main states a Transition can be in:
   *  - `'entering'`
   *  - `'entered'`
   *  - `'exiting'`
   *  - `'exited'`
   *
   * Transition state is toggled via the `in` prop. When `true` the component
   * begins the "Enter" stage. During this stage, the component will shift from
   * its current transition state, to `'entering'` for the duration of the
   * transition and then to the `'entered'` stage once it's complete. Let's take
   * the following example (we'll use the
   * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
   *
   * ```jsx
   * function App() {
   *   const [inProp, setInProp] = useState(false);
   *   return (
   *     <div>
   *       <Transition in={inProp} timeout={500}>
   *         {state => (
   *           // ...
   *         )}
   *       </Transition>
   *       <button onClick={() => setInProp(true)}>
   *         Click to Enter
   *       </button>
   *     </div>
   *   );
   * }
   * ```
   *
   * When the button is clicked the component will shift to the `'entering'` state
   * and stay there for 500ms (the value of `timeout`) before it finally switches
   * to `'entered'`.
   *
   * When `in` is `false` the same thing happens except the state moves from
   * `'exiting'` to `'exited'`.
   */

  var Transition = /*#__PURE__*/function (_React$Component) {
    _inheritsLoose$1(Transition, _React$Component);

    function Transition(props, context) {
      var _this;

      _this = _React$Component.call(this, props, context) || this;
      var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

      var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
      var initialStatus;
      _this.appearStatus = null;

      if (props.in) {
        if (appear) {
          initialStatus = EXITED;
          _this.appearStatus = ENTERING;
        } else {
          initialStatus = ENTERED;
        }
      } else {
        if (props.unmountOnExit || props.mountOnEnter) {
          initialStatus = UNMOUNTED;
        } else {
          initialStatus = EXITED;
        }
      }

      _this.state = {
        status: initialStatus
      };
      _this.nextCallback = null;
      return _this;
    }

    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
      var nextIn = _ref.in;

      if (nextIn && prevState.status === UNMOUNTED) {
        return {
          status: EXITED
        };
      }

      return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    //   let nextStatus = null
    //   if (prevProps !== this.props) {
    //     const { status } = this.state
    //     if (this.props.in) {
    //       if (status !== ENTERING && status !== ENTERED) {
    //         nextStatus = ENTERING
    //       }
    //     } else {
    //       if (status === ENTERING || status === ENTERED) {
    //         nextStatus = EXITING
    //       }
    //     }
    //   }
    //   return { nextStatus }
    // }
    ;

    var _proto = Transition.prototype;

    _proto.componentDidMount = function componentDidMount() {
      this.updateStatus(true, this.appearStatus);
    };

    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
      var nextStatus = null;

      if (prevProps !== this.props) {
        var status = this.state.status;

        if (this.props.in) {
          if (status !== ENTERING && status !== ENTERED) {
            nextStatus = ENTERING;
          }
        } else {
          if (status === ENTERING || status === ENTERED) {
            nextStatus = EXITING;
          }
        }
      }

      this.updateStatus(false, nextStatus);
    };

    _proto.componentWillUnmount = function componentWillUnmount() {
      this.cancelNextCallback();
    };

    _proto.getTimeouts = function getTimeouts() {
      var timeout = this.props.timeout;
      var exit, enter, appear;
      exit = enter = appear = timeout;

      if (timeout != null && typeof timeout !== 'number') {
        exit = timeout.exit;
        enter = timeout.enter; // TODO: remove fallback for next major

        appear = timeout.appear !== undefined ? timeout.appear : enter;
      }

      return {
        exit: exit,
        enter: enter,
        appear: appear
      };
    };

    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
      if (mounting === void 0) {
        mounting = false;
      }

      if (nextStatus !== null) {
        // nextStatus will always be ENTERING or EXITING.
        this.cancelNextCallback();

        if (nextStatus === ENTERING) {
          this.performEnter(mounting);
        } else {
          this.performExit();
        }
      } else if (this.props.unmountOnExit && this.state.status === EXITED) {
        this.setState({
          status: UNMOUNTED
        });
      }
    };

    _proto.performEnter = function performEnter(mounting) {
      var _this2 = this;

      var enter = this.props.enter;
      var appearing = this.context ? this.context.isMounting : mounting;

      var _ref2 = this.props.nodeRef ? [appearing] : [ReactDOM__default["default"].findDOMNode(this), appearing],
          maybeNode = _ref2[0],
          maybeAppearing = _ref2[1];

      var timeouts = this.getTimeouts();
      var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
      // if we are mounting and running this it means appear _must_ be set

      if (!mounting && !enter || config.disabled) {
        this.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(maybeNode);
        });
        return;
      }

      this.props.onEnter(maybeNode, maybeAppearing);
      this.safeSetState({
        status: ENTERING
      }, function () {
        _this2.props.onEntering(maybeNode, maybeAppearing);

        _this2.onTransitionEnd(enterTimeout, function () {
          _this2.safeSetState({
            status: ENTERED
          }, function () {
            _this2.props.onEntered(maybeNode, maybeAppearing);
          });
        });
      });
    };

    _proto.performExit = function performExit() {
      var _this3 = this;

      var exit = this.props.exit;
      var timeouts = this.getTimeouts();
      var maybeNode = this.props.nodeRef ? undefined : ReactDOM__default["default"].findDOMNode(this); // no exit animation skip right to EXITED

      if (!exit || config.disabled) {
        this.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(maybeNode);
        });
        return;
      }

      this.props.onExit(maybeNode);
      this.safeSetState({
        status: EXITING
      }, function () {
        _this3.props.onExiting(maybeNode);

        _this3.onTransitionEnd(timeouts.exit, function () {
          _this3.safeSetState({
            status: EXITED
          }, function () {
            _this3.props.onExited(maybeNode);
          });
        });
      });
    };

    _proto.cancelNextCallback = function cancelNextCallback() {
      if (this.nextCallback !== null) {
        this.nextCallback.cancel();
        this.nextCallback = null;
      }
    };

    _proto.safeSetState = function safeSetState(nextState, callback) {
      // This shouldn't be necessary, but there are weird race conditions with
      // setState callbacks and unmounting in testing, so always make sure that
      // we can cancel any pending setState callbacks after we unmount.
      callback = this.setNextCallback(callback);
      this.setState(nextState, callback);
    };

    _proto.setNextCallback = function setNextCallback(callback) {
      var _this4 = this;

      var active = true;

      this.nextCallback = function (event) {
        if (active) {
          active = false;
          _this4.nextCallback = null;
          callback(event);
        }
      };

      this.nextCallback.cancel = function () {
        active = false;
      };

      return this.nextCallback;
    };

    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
      this.setNextCallback(handler);
      var node = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM__default["default"].findDOMNode(this);
      var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

      if (!node || doesNotHaveTimeoutOrListener) {
        setTimeout(this.nextCallback, 0);
        return;
      }

      if (this.props.addEndListener) {
        var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
            maybeNode = _ref3[0],
            maybeNextCallback = _ref3[1];

        this.props.addEndListener(maybeNode, maybeNextCallback);
      }

      if (timeout != null) {
        setTimeout(this.nextCallback, timeout);
      }
    };

    _proto.render = function render() {
      var status = this.state.status;

      if (status === UNMOUNTED) {
        return null;
      }

      var _this$props = this.props,
          children = _this$props.children;
      _this$props.in;
      _this$props.mountOnEnter;
      _this$props.unmountOnExit;
      _this$props.appear;
      _this$props.enter;
      _this$props.exit;
      _this$props.timeout;
      _this$props.addEndListener;
      _this$props.onEnter;
      _this$props.onEntering;
      _this$props.onEntered;
      _this$props.onExit;
      _this$props.onExiting;
      _this$props.onExited;
      _this$props.nodeRef;

      var childProps = _objectWithoutPropertiesLoose$3(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);

      return (
        /*#__PURE__*/
        // allows for nested Transitions
        React__default["default"].createElement(TransitionGroupContext.Provider, {
          value: null
        }, typeof children === 'function' ? children(status, childProps) : React__default["default"].cloneElement(React__default["default"].Children.only(children), childProps))
      );
    };

    return Transition;
  }(React__default["default"].Component);

  Transition.contextType = TransitionGroupContext;
  Transition.propTypes = process.env.NODE_ENV !== "production" ? {
    /**
     * A React reference to DOM element that need to transition:
     * https://stackoverflow.com/a/51127130/4671932
     *
     *   - When `nodeRef` prop is used, `node` is not passed to callback functions
     *      (e.g. `onEnter`) because user already has direct access to the node.
     *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
     *     `nodeRef` need to be provided to `Transition` with changed `key` prop
     *     (see
     *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
     */
    nodeRef: PropTypes.shape({
      current: typeof Element === 'undefined' ? PropTypes.any : function (propValue, key, componentName, location, propFullName, secret) {
        var value = propValue[key];
        return PropTypes.instanceOf(value && 'ownerDocument' in value ? value.ownerDocument.defaultView.Element : Element)(propValue, key, componentName, location, propFullName, secret);
      }
    }),

    /**
     * A `function` child can be used instead of a React element. This function is
     * called with the current transition status (`'entering'`, `'entered'`,
     * `'exiting'`, `'exited'`), which can be used to apply context
     * specific props to a component.
     *
     * ```jsx
     * <Transition in={this.state.in} timeout={150}>
     *   {state => (
     *     <MyComponent className={`fade fade-${state}`} />
     *   )}
     * </Transition>
     * ```
     */
    children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

    /**
     * Show the component; triggers the enter or exit states
     */
    in: PropTypes.bool,

    /**
     * By default the child component is mounted immediately along with
     * the parent `Transition` component. If you want to "lazy mount" the component on the
     * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
     * mounted, even on "exited", unless you also specify `unmountOnExit`.
     */
    mountOnEnter: PropTypes.bool,

    /**
     * By default the child component stays mounted after it reaches the `'exited'` state.
     * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
     */
    unmountOnExit: PropTypes.bool,

    /**
     * By default the child component does not perform the enter transition when
     * it first mounts, regardless of the value of `in`. If you want this
     * behavior, set both `appear` and `in` to `true`.
     *
     * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
     * > only adds an additional enter transition. However, in the
     * > `<CSSTransition>` component that first enter transition does result in
     * > additional `.appear-*` classes, that way you can choose to style it
     * > differently.
     */
    appear: PropTypes.bool,

    /**
     * Enable or disable enter transitions.
     */
    enter: PropTypes.bool,

    /**
     * Enable or disable exit transitions.
     */
    exit: PropTypes.bool,

    /**
     * The duration of the transition, in milliseconds.
     * Required unless `addEndListener` is provided.
     *
     * You may specify a single timeout for all transitions:
     *
     * ```jsx
     * timeout={500}
     * ```
     *
     * or individually:
     *
     * ```jsx
     * timeout={{
     *  appear: 500,
     *  enter: 300,
     *  exit: 500,
     * }}
     * ```
     *
     * - `appear` defaults to the value of `enter`
     * - `enter` defaults to `0`
     * - `exit` defaults to `0`
     *
     * @type {number | { enter?: number, exit?: number, appear?: number }}
     */
    timeout: function timeout(props) {
      var pt = timeoutsShape;
      if (!props.addEndListener) pt = pt.isRequired;

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return pt.apply(void 0, [props].concat(args));
    },

    /**
     * Add a custom transition end trigger. Called with the transitioning
     * DOM node and a `done` callback. Allows for more fine grained transition end
     * logic. Timeouts are still used as a fallback if provided.
     *
     * **Note**: when `nodeRef` prop is passed, `node` is not passed.
     *
     * ```jsx
     * addEndListener={(node, done) => {
     *   // use the css transitionend event to mark the finish of a transition
     *   node.addEventListener('transitionend', done, false);
     * }}
     * ```
     */
    addEndListener: PropTypes.func,

    /**
     * Callback fired before the "entering" status is applied. An extra parameter
     * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
     *
     * **Note**: when `nodeRef` prop is passed, `node` is not passed.
     *
     * @type Function(node: HtmlElement, isAppearing: bool) -> void
     */
    onEnter: PropTypes.func,

    /**
     * Callback fired after the "entering" status is applied. An extra parameter
     * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
     *
     * **Note**: when `nodeRef` prop is passed, `node` is not passed.
     *
     * @type Function(node: HtmlElement, isAppearing: bool)
     */
    onEntering: PropTypes.func,

    /**
     * Callback fired after the "entered" status is applied. An extra parameter
     * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
     *
     * **Note**: when `nodeRef` prop is passed, `node` is not passed.
     *
     * @type Function(node: HtmlElement, isAppearing: bool) -> void
     */
    onEntered: PropTypes.func,

    /**
     * Callback fired before the "exiting" status is applied.
     *
     * **Note**: when `nodeRef` prop is passed, `node` is not passed.
     *
     * @type Function(node: HtmlElement) -> void
     */
    onExit: PropTypes.func,

    /**
     * Callback fired after the "exiting" status is applied.
     *
     * **Note**: when `nodeRef` prop is passed, `node` is not passed.
     *
     * @type Function(node: HtmlElement) -> void
     */
    onExiting: PropTypes.func,

    /**
     * Callback fired after the "exited" status is applied.
     *
     * **Note**: when `nodeRef` prop is passed, `node` is not passed
     *
     * @type Function(node: HtmlElement) -> void
     */
    onExited: PropTypes.func
  } : {}; // Name the function so it is clearer in the documentation

  function noop$1() {}

  Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: noop$1,
    onEntering: noop$1,
    onEntered: noop$1,
    onExit: noop$1,
    onExiting: noop$1,
    onExited: noop$1
  };
  Transition.UNMOUNTED = UNMOUNTED;
  Transition.EXITED = EXITED;
  Transition.ENTERING = ENTERING;
  Transition.ENTERED = ENTERED;
  Transition.EXITING = EXITING;
  var Transition$1 = Transition;

  var _addClass = function addClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function (c) {
      return addClass$1(node, c);
    });
  };

  var removeClass$1 = function removeClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function (c) {
      return removeClass$2(node, c);
    });
  };
  /**
   * A transition component inspired by the excellent
   * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
   * use it if you're using CSS transitions or animations. It's built upon the
   * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
   * component, so it inherits all of its props.
   *
   * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
   * and `exit` states of the transition. The first class is applied and then a
   * second `*-active` class in order to activate the CSS transition. After the
   * transition, matching `*-done` class names are applied to persist the
   * transition state.
   *
   * ```jsx
   * function App() {
   *   const [inProp, setInProp] = useState(false);
   *   return (
   *     <div>
   *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
   *         <div>
   *           {"I'll receive my-node-* classes"}
   *         </div>
   *       </CSSTransition>
   *       <button type="button" onClick={() => setInProp(true)}>
   *         Click to Enter
   *       </button>
   *     </div>
   *   );
   * }
   * ```
   *
   * When the `in` prop is set to `true`, the child component will first receive
   * the class `example-enter`, then the `example-enter-active` will be added in
   * the next tick. `CSSTransition` [forces a
   * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
   * between before adding the `example-enter-active`. This is an important trick
   * because it allows us to transition between `example-enter` and
   * `example-enter-active` even though they were added immediately one after
   * another. Most notably, this is what makes it possible for us to animate
   * _appearance_.
   *
   * ```css
   * .my-node-enter {
   *   opacity: 0;
   * }
   * .my-node-enter-active {
   *   opacity: 1;
   *   transition: opacity 200ms;
   * }
   * .my-node-exit {
   *   opacity: 1;
   * }
   * .my-node-exit-active {
   *   opacity: 0;
   *   transition: opacity 200ms;
   * }
   * ```
   *
   * `*-active` classes represent which styles you want to animate **to**, so it's
   * important to add `transition` declaration only to them, otherwise transitions
   * might not behave as intended! This might not be obvious when the transitions
   * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
   * the example above (minus `transition`), but it becomes apparent in more
   * complex transitions.
   *
   * **Note**: If you're using the
   * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
   * prop, make sure to define styles for `.appear-*` classes as well.
   */


  var CSSTransition = /*#__PURE__*/function (_React$Component) {
    _inheritsLoose$1(CSSTransition, _React$Component);

    function CSSTransition() {
      var _this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
      _this.appliedClasses = {
        appear: {},
        enter: {},
        exit: {}
      };

      _this.onEnter = function (maybeNode, maybeAppearing) {
        var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing),
            node = _this$resolveArgument[0],
            appearing = _this$resolveArgument[1];

        _this.removeClasses(node, 'exit');

        _this.addClass(node, appearing ? 'appear' : 'enter', 'base');

        if (_this.props.onEnter) {
          _this.props.onEnter(maybeNode, maybeAppearing);
        }
      };

      _this.onEntering = function (maybeNode, maybeAppearing) {
        var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing),
            node = _this$resolveArgument2[0],
            appearing = _this$resolveArgument2[1];

        var type = appearing ? 'appear' : 'enter';

        _this.addClass(node, type, 'active');

        if (_this.props.onEntering) {
          _this.props.onEntering(maybeNode, maybeAppearing);
        }
      };

      _this.onEntered = function (maybeNode, maybeAppearing) {
        var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing),
            node = _this$resolveArgument3[0],
            appearing = _this$resolveArgument3[1];

        var type = appearing ? 'appear' : 'enter';

        _this.removeClasses(node, type);

        _this.addClass(node, type, 'done');

        if (_this.props.onEntered) {
          _this.props.onEntered(maybeNode, maybeAppearing);
        }
      };

      _this.onExit = function (maybeNode) {
        var _this$resolveArgument4 = _this.resolveArguments(maybeNode),
            node = _this$resolveArgument4[0];

        _this.removeClasses(node, 'appear');

        _this.removeClasses(node, 'enter');

        _this.addClass(node, 'exit', 'base');

        if (_this.props.onExit) {
          _this.props.onExit(maybeNode);
        }
      };

      _this.onExiting = function (maybeNode) {
        var _this$resolveArgument5 = _this.resolveArguments(maybeNode),
            node = _this$resolveArgument5[0];

        _this.addClass(node, 'exit', 'active');

        if (_this.props.onExiting) {
          _this.props.onExiting(maybeNode);
        }
      };

      _this.onExited = function (maybeNode) {
        var _this$resolveArgument6 = _this.resolveArguments(maybeNode),
            node = _this$resolveArgument6[0];

        _this.removeClasses(node, 'exit');

        _this.addClass(node, 'exit', 'done');

        if (_this.props.onExited) {
          _this.props.onExited(maybeNode);
        }
      };

      _this.resolveArguments = function (maybeNode, maybeAppearing) {
        return _this.props.nodeRef ? [_this.props.nodeRef.current, maybeNode] // here `maybeNode` is actually `appearing`
        : [maybeNode, maybeAppearing];
      };

      _this.getClassNames = function (type) {
        var classNames = _this.props.classNames;
        var isStringClassNames = typeof classNames === 'string';
        var prefix = isStringClassNames && classNames ? classNames + "-" : '';
        var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
        var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
        var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
        return {
          baseClassName: baseClassName,
          activeClassName: activeClassName,
          doneClassName: doneClassName
        };
      };

      return _this;
    }

    var _proto = CSSTransition.prototype;

    _proto.addClass = function addClass(node, type, phase) {
      var className = this.getClassNames(type)[phase + "ClassName"];

      var _this$getClassNames = this.getClassNames('enter'),
          doneClassName = _this$getClassNames.doneClassName;

      if (type === 'appear' && phase === 'done' && doneClassName) {
        className += " " + doneClassName;
      } // This is to force a repaint,
      // which is necessary in order to transition styles when adding a class name.


      if (phase === 'active') {
        /* eslint-disable no-unused-expressions */
        node && node.scrollTop;
      }

      if (className) {
        this.appliedClasses[type][phase] = className;

        _addClass(node, className);
      }
    };

    _proto.removeClasses = function removeClasses(node, type) {
      var _this$appliedClasses$ = this.appliedClasses[type],
          baseClassName = _this$appliedClasses$.base,
          activeClassName = _this$appliedClasses$.active,
          doneClassName = _this$appliedClasses$.done;
      this.appliedClasses[type] = {};

      if (baseClassName) {
        removeClass$1(node, baseClassName);
      }

      if (activeClassName) {
        removeClass$1(node, activeClassName);
      }

      if (doneClassName) {
        removeClass$1(node, doneClassName);
      }
    };

    _proto.render = function render() {
      var _this$props = this.props;
      _this$props.classNames;

      var props = _objectWithoutPropertiesLoose$3(_this$props, ["classNames"]);

      return /*#__PURE__*/React__default["default"].createElement(Transition$1, _extends$6({}, props, {
        onEnter: this.onEnter,
        onEntered: this.onEntered,
        onEntering: this.onEntering,
        onExit: this.onExit,
        onExiting: this.onExiting,
        onExited: this.onExited
      }));
    };

    return CSSTransition;
  }(React__default["default"].Component);

  CSSTransition.defaultProps = {
    classNames: ''
  };
  CSSTransition.propTypes = process.env.NODE_ENV !== "production" ? _extends$6({}, Transition$1.propTypes, {
    /**
     * The animation classNames applied to the component as it appears, enters,
     * exits or has finished the transition. A single name can be provided, which
     * will be suffixed for each stage, e.g. `classNames="fade"` applies:
     *
     * - `fade-appear`, `fade-appear-active`, `fade-appear-done`
     * - `fade-enter`, `fade-enter-active`, `fade-enter-done`
     * - `fade-exit`, `fade-exit-active`, `fade-exit-done`
     *
     * A few details to note about how these classes are applied:
     *
     * 1. They are _joined_ with the ones that are already defined on the child
     *    component, so if you want to add some base styles, you can use
     *    `className` without worrying that it will be overridden.
     *
     * 2. If the transition component mounts with `in={false}`, no classes are
     *    applied yet. You might be expecting `*-exit-done`, but if you think
     *    about it, a component cannot finish exiting if it hasn't entered yet.
     *
     * 2. `fade-appear-done` and `fade-enter-done` will _both_ be applied. This
     *    allows you to define different behavior for when appearing is done and
     *    when regular entering is done, using selectors like
     *    `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply
     *    an epic entrance animation when element first appears in the DOM using
     *    [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
     *    simply use `fade-enter-done` for defining both cases.
     *
     * Each individual classNames can also be specified independently like:
     *
     * ```js
     * classNames={{
     *  appear: 'my-appear',
     *  appearActive: 'my-active-appear',
     *  appearDone: 'my-done-appear',
     *  enter: 'my-enter',
     *  enterActive: 'my-active-enter',
     *  enterDone: 'my-done-enter',
     *  exit: 'my-exit',
     *  exitActive: 'my-active-exit',
     *  exitDone: 'my-done-exit',
     * }}
     * ```
     *
     * If you want to set these classes using CSS Modules:
     *
     * ```js
     * import styles from './styles.css';
     * ```
     *
     * you might want to use camelCase in your CSS file, that way could simply
     * spread them instead of listing them one by one:
     *
     * ```js
     * classNames={{ ...styles }}
     * ```
     *
     * @type {string | {
     *  appear?: string,
     *  appearActive?: string,
     *  appearDone?: string,
     *  enter?: string,
     *  enterActive?: string,
     *  enterDone?: string,
     *  exit?: string,
     *  exitActive?: string,
     *  exitDone?: string,
     * }}
     */
    classNames: classNamesShape,

    /**
     * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
     * applied.
     *
     * **Note**: when `nodeRef` prop is passed, `node` is not passed.
     *
     * @type Function(node: HtmlElement, isAppearing: bool)
     */
    onEnter: PropTypes.func,

    /**
     * A `<Transition>` callback fired immediately after the 'enter-active' or
     * 'appear-active' class is applied.
     *
     * **Note**: when `nodeRef` prop is passed, `node` is not passed.
     *
     * @type Function(node: HtmlElement, isAppearing: bool)
     */
    onEntering: PropTypes.func,

    /**
     * A `<Transition>` callback fired immediately after the 'enter' or
     * 'appear' classes are **removed** and the `done` class is added to the DOM node.
     *
     * **Note**: when `nodeRef` prop is passed, `node` is not passed.
     *
     * @type Function(node: HtmlElement, isAppearing: bool)
     */
    onEntered: PropTypes.func,

    /**
     * A `<Transition>` callback fired immediately after the 'exit' class is
     * applied.
     *
     * **Note**: when `nodeRef` prop is passed, `node` is not passed
     *
     * @type Function(node: HtmlElement)
     */
    onExit: PropTypes.func,

    /**
     * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
     *
     * **Note**: when `nodeRef` prop is passed, `node` is not passed
     *
     * @type Function(node: HtmlElement)
     */
    onExiting: PropTypes.func,

    /**
     * A `<Transition>` callback fired immediately after the 'exit' classes
     * are **removed** and the `exit-done` class is added to the DOM node.
     *
     * **Note**: when `nodeRef` prop is passed, `node` is not passed
     *
     * @type Function(node: HtmlElement)
     */
    onExited: PropTypes.func
  }) : {};
  var CSSTransition$1 = CSSTransition;

  function _assertThisInitialized$1(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }
  /**
   * Given `this.props.children`, return an object mapping key to child.
   *
   * @param {*} children `this.props.children`
   * @return {object} Mapping of key to child
   */


  function getChildMapping(children, mapFn) {
    var mapper = function mapper(child) {
      return mapFn && React.isValidElement(child) ? mapFn(child) : child;
    };

    var result = Object.create(null);
    if (children) React.Children.map(children, function (c) {
      return c;
    }).forEach(function (child) {
      // run the map function here instead so that the key is the computed one
      result[child.key] = mapper(child);
    });
    return result;
  }
  /**
   * When you're adding or removing children some may be added or removed in the
   * same render pass. We want to show *both* since we want to simultaneously
   * animate elements in and out. This function takes a previous set of keys
   * and a new set of keys and merges them with its best guess of the correct
   * ordering. In the future we may expose some of the utilities in
   * ReactMultiChild to make this easy, but for now React itself does not
   * directly have this concept of the union of prevChildren and nextChildren
   * so we implement it here.
   *
   * @param {object} prev prev children as returned from
   * `ReactTransitionChildMapping.getChildMapping()`.
   * @param {object} next next children as returned from
   * `ReactTransitionChildMapping.getChildMapping()`.
   * @return {object} a key set that contains all keys in `prev` and all keys
   * in `next` in a reasonable order.
   */


  function mergeChildMappings(prev, next) {
    prev = prev || {};
    next = next || {};

    function getValueForKey(key) {
      return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list


    var nextKeysPending = Object.create(null);
    var pendingKeys = [];

    for (var prevKey in prev) {
      if (prevKey in next) {
        if (pendingKeys.length) {
          nextKeysPending[prevKey] = pendingKeys;
          pendingKeys = [];
        }
      } else {
        pendingKeys.push(prevKey);
      }
    }

    var i;
    var childMapping = {};

    for (var nextKey in next) {
      if (nextKeysPending[nextKey]) {
        for (i = 0; i < nextKeysPending[nextKey].length; i++) {
          var pendingNextKey = nextKeysPending[nextKey][i];
          childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
      }

      childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`


    for (i = 0; i < pendingKeys.length; i++) {
      childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    }

    return childMapping;
  }

  function getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
  }

  function getInitialChildMapping(props, onExited) {
    return getChildMapping(props.children, function (child) {
      return React.cloneElement(child, {
        onExited: onExited.bind(null, child),
        in: true,
        appear: getProp(child, 'appear', props),
        enter: getProp(child, 'enter', props),
        exit: getProp(child, 'exit', props)
      });
    });
  }

  function getNextChildMapping(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = getChildMapping(nextProps.children);
    var children = mergeChildMappings(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function (key) {
      var child = children[key];
      if (!React.isValidElement(child)) return;
      var hasPrev = (key in prevChildMapping);
      var hasNext = (key in nextChildMapping);
      var prevChild = prevChildMapping[key];
      var isLeaving = React.isValidElement(prevChild) && !prevChild.props.in; // item is new (entering)

      if (hasNext && (!hasPrev || isLeaving)) {
        // console.log('entering', key)
        children[key] = React.cloneElement(child, {
          onExited: onExited.bind(null, child),
          in: true,
          exit: getProp(child, 'exit', nextProps),
          enter: getProp(child, 'enter', nextProps)
        });
      } else if (!hasNext && hasPrev && !isLeaving) {
        // item is old (exiting)
        // console.log('leaving', key)
        children[key] = React.cloneElement(child, {
          in: false
        });
      } else if (hasNext && hasPrev && React.isValidElement(prevChild)) {
        // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = React.cloneElement(child, {
          onExited: onExited.bind(null, child),
          in: prevChild.props.in,
          exit: getProp(child, 'exit', nextProps),
          enter: getProp(child, 'enter', nextProps)
        });
      }
    });
    return children;
  }

  var values$1 = Object.values || function (obj) {
    return Object.keys(obj).map(function (k) {
      return obj[k];
    });
  };

  var defaultProps$d = {
    component: 'div',
    childFactory: function childFactory(child) {
      return child;
    }
  };
  /**
   * The `<TransitionGroup>` component manages a set of transition components
   * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
   * components, `<TransitionGroup>` is a state machine for managing the mounting
   * and unmounting of components over time.
   *
   * Consider the example below. As items are removed or added to the TodoList the
   * `in` prop is toggled automatically by the `<TransitionGroup>`.
   *
   * Note that `<TransitionGroup>`  does not define any animation behavior!
   * Exactly _how_ a list item animates is up to the individual transition
   * component. This means you can mix and match animations across different list
   * items.
   */

  var TransitionGroup = /*#__PURE__*/function (_React$Component) {
    _inheritsLoose$1(TransitionGroup, _React$Component);

    function TransitionGroup(props, context) {
      var _this;

      _this = _React$Component.call(this, props, context) || this;

      var handleExited = _this.handleExited.bind(_assertThisInitialized$1(_this)); // Initial children should all be entering, dependent on appear


      _this.state = {
        contextValue: {
          isMounting: true
        },
        handleExited: handleExited,
        firstRender: true
      };
      return _this;
    }

    var _proto = TransitionGroup.prototype;

    _proto.componentDidMount = function componentDidMount() {
      this.mounted = true;
      this.setState({
        contextValue: {
          isMounting: false
        }
      });
    };

    _proto.componentWillUnmount = function componentWillUnmount() {
      this.mounted = false;
    };

    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
      var prevChildMapping = _ref.children,
          handleExited = _ref.handleExited,
          firstRender = _ref.firstRender;
      return {
        children: firstRender ? getInitialChildMapping(nextProps, handleExited) : getNextChildMapping(nextProps, prevChildMapping, handleExited),
        firstRender: false
      };
    } // node is `undefined` when user provided `nodeRef` prop
    ;

    _proto.handleExited = function handleExited(child, node) {
      var currentChildMapping = getChildMapping(this.props.children);
      if (child.key in currentChildMapping) return;

      if (child.props.onExited) {
        child.props.onExited(node);
      }

      if (this.mounted) {
        this.setState(function (state) {
          var children = _extends$6({}, state.children);

          delete children[child.key];
          return {
            children: children
          };
        });
      }
    };

    _proto.render = function render() {
      var _this$props = this.props,
          Component = _this$props.component,
          childFactory = _this$props.childFactory,
          props = _objectWithoutPropertiesLoose$3(_this$props, ["component", "childFactory"]);

      var contextValue = this.state.contextValue;
      var children = values$1(this.state.children).map(childFactory);
      delete props.appear;
      delete props.enter;
      delete props.exit;

      if (Component === null) {
        return /*#__PURE__*/React__default["default"].createElement(TransitionGroupContext.Provider, {
          value: contextValue
        }, children);
      }

      return /*#__PURE__*/React__default["default"].createElement(TransitionGroupContext.Provider, {
        value: contextValue
      }, /*#__PURE__*/React__default["default"].createElement(Component, props, children));
    };

    return TransitionGroup;
  }(React__default["default"].Component);

  TransitionGroup.propTypes = process.env.NODE_ENV !== "production" ? {
    /**
     * `<TransitionGroup>` renders a `<div>` by default. You can change this
     * behavior by providing a `component` prop.
     * If you use React v16+ and would like to avoid a wrapping `<div>` element
     * you can pass in `component={null}`. This is useful if the wrapping div
     * borks your css styles.
     */
    component: PropTypes.any,

    /**
     * A set of `<Transition>` components, that are toggled `in` and out as they
     * leave. the `<TransitionGroup>` will inject specific transition props, so
     * remember to spread them through if you are wrapping the `<Transition>` as
     * with our `<Fade>` example.
     *
     * While this component is meant for multiple `Transition` or `CSSTransition`
     * children, sometimes you may want to have a single transition child with
     * content that you want to be transitioned out and in when you change it
     * (e.g. routes, images etc.) In that case you can change the `key` prop of
     * the transition child as you change its content, this will cause
     * `TransitionGroup` to transition the child out and back in.
     */
    children: PropTypes.node,

    /**
     * A convenience prop that enables or disables appear animations
     * for all children. Note that specifying this will override any defaults set
     * on individual children Transitions.
     */
    appear: PropTypes.bool,

    /**
     * A convenience prop that enables or disables enter animations
     * for all children. Note that specifying this will override any defaults set
     * on individual children Transitions.
     */
    enter: PropTypes.bool,

    /**
     * A convenience prop that enables or disables exit animations
     * for all children. Note that specifying this will override any defaults set
     * on individual children Transitions.
     */
    exit: PropTypes.bool,

    /**
     * You may need to apply reactive updates to a child as it is exiting.
     * This is generally done by using `cloneElement` however in the case of an exiting
     * child the element has already been removed and not accessible to the consumer.
     *
     * If you do need to update a child as it leaves you can provide a `childFactory`
     * to wrap every child, even the ones that are leaving.
     *
     * @type Function(child: ReactElement) -> ReactElement
     */
    childFactory: PropTypes.func
  } : {};
  TransitionGroup.defaultProps = defaultProps$d;
  var TransitionGroup$1 = TransitionGroup;

  function Ripple(props) {
    var className = props.className,
        classes = props.classes,
        _props$pulsate = props.pulsate,
        pulsate = _props$pulsate === void 0 ? false : _props$pulsate,
        rippleX = props.rippleX,
        rippleY = props.rippleY,
        rippleSize = props.rippleSize,
        inProp = props.in,
        onExited = props.onExited,
        timeout = props.timeout;

    var _React__namespace$use28 = React__namespace.useState(false),
        _React__namespace$use29 = _slicedToArray(_React__namespace$use28, 2),
        leaving = _React__namespace$use29[0],
        setLeaving = _React__namespace$use29[1];

    var rippleClassName = clsx(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    var rippleStyles = {
      width: rippleSize,
      height: rippleSize,
      top: -(rippleSize / 2) + rippleY,
      left: -(rippleSize / 2) + rippleX
    };
    var childClassName = clsx(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);

    if (!inProp && !leaving) {
      setLeaving(true);
    }

    React__namespace.useEffect(function () {
      if (!inProp && onExited != null) {
        // react-transition-group#onExited
        var timeoutId = setTimeout(onExited, timeout);
        return function () {
          clearTimeout(timeoutId);
        };
      }

      return undefined;
    }, [onExited, inProp, timeout]);
    return /*#__PURE__*/jsxRuntime$1.jsx("span", {
      className: rippleClassName,
      style: rippleStyles,
      children: /*#__PURE__*/jsxRuntime$1.jsx("span", {
        className: childClassName
      })
    });
  }

  process.env.NODE_ENV !== "production" ? Ripple.propTypes = {
    /**
     * Override or extend the styles applied to the component.
     * See [CSS API](#css) below for more details.
     */
    classes: PropTypes.object.isRequired,
    className: PropTypes.string,

    /**
     * @ignore - injected from TransitionGroup
     */
    in: PropTypes.bool,

    /**
     * @ignore - injected from TransitionGroup
     */
    onExited: PropTypes.func,

    /**
     * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
     */
    pulsate: PropTypes.bool,

    /**
     * Diameter of the ripple.
     */
    rippleSize: PropTypes.number,

    /**
     * Horizontal position of the ripple center.
     */
    rippleX: PropTypes.number,

    /**
     * Vertical position of the ripple center.
     */
    rippleY: PropTypes.number,

    /**
     * exit delay
     */
    timeout: PropTypes.number.isRequired
  } : void 0;
  var touchRippleClasses = generateUtilityClasses('MuiTouchRipple', ['root', 'ripple', 'rippleVisible', 'ripplePulsate', 'child', 'childLeaving', 'childPulsate']);
  var touchRippleClasses$1 = touchRippleClasses;
  var _excluded$1D = ["center", "classes", "className"];

  var _$2 = function _$2(t) {
    return t;
  },
      _t$2,
      _t2$1,
      _t3$1,
      _t4$1;

  var DURATION = 550;
  var DELAY_RIPPLE = 80;
  var enterKeyframe = keyframes(_t$2 || (_t$2 = _$2(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  0% {\n    transform: scale(0);\n    opacity: 0.1;\n  }\n\n  100% {\n    transform: scale(1);\n    opacity: 0.3;\n  }\n"])))));
  var exitKeyframe = keyframes(_t2$1 || (_t2$1 = _$2(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  0% {\n    opacity: 1;\n  }\n\n  100% {\n    opacity: 0;\n  }\n"])))));
  var pulsateKeyframe = keyframes(_t3$1 || (_t3$1 = _$2(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  0% {\n    transform: scale(1);\n  }\n\n  50% {\n    transform: scale(0.92);\n  }\n\n  100% {\n    transform: scale(1);\n  }\n"])))));
  var TouchRippleRoot = styled$1('span', {
    name: 'MuiTouchRipple',
    slot: 'Root',
    skipSx: true
  })({
    overflow: 'hidden',
    pointerEvents: 'none',
    position: 'absolute',
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: 'inherit'
  }); // This `styled()` function invokes keyframes. `styled-components` only supports keyframes
  // in string templates. Do not convert these styles in JS object as it will break.

  var TouchRippleRipple = styled$1(Ripple, {
    name: 'MuiTouchRipple',
    slot: 'Ripple'
  })(_t4$1 || (_t4$1 = _$2(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  opacity: 0;\n  position: absolute;\n\n  &.", " {\n    opacity: 0.3;\n    transform: scale(1);\n    animation-name: ", ";\n    animation-duration: ", "ms;\n    animation-timing-function: ", ";\n  }\n\n  &.", " {\n    animation-duration: ", "ms;\n  }\n\n  & .", " {\n    opacity: 1;\n    display: block;\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n    background-color: currentColor;\n  }\n\n  & .", " {\n    opacity: 0;\n    animation-name: ", ";\n    animation-duration: ", "ms;\n    animation-timing-function: ", ";\n  }\n\n  & .", " {\n    position: absolute;\n    /* @noflip */\n    left: 0px;\n    top: 0;\n    animation-name: ", ";\n    animation-duration: 2500ms;\n    animation-timing-function: ", ";\n    animation-iteration-count: infinite;\n    animation-delay: 200ms;\n  }\n"])), 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0)), touchRippleClasses$1.rippleVisible, enterKeyframe, DURATION, function (_ref24) {
    var theme = _ref24.theme;
    return theme.transitions.easing.easeInOut;
  }, touchRippleClasses$1.ripplePulsate, function (_ref25) {
    var theme = _ref25.theme;
    return theme.transitions.duration.shorter;
  }, touchRippleClasses$1.child, touchRippleClasses$1.childLeaving, exitKeyframe, DURATION, function (_ref26) {
    var theme = _ref26.theme;
    return theme.transitions.easing.easeInOut;
  }, touchRippleClasses$1.childPulsate, pulsateKeyframe, function (_ref27) {
    var theme = _ref27.theme;
    return theme.transitions.easing.easeInOut;
  });
  /**
   * @ignore - internal component.
   *
   * TODO v5: Make private
   */

  var TouchRipple = /*#__PURE__*/React__namespace.forwardRef(function TouchRipple(inProps, ref) {
    var props = useThemeProps({
      props: inProps,
      name: 'MuiTouchRipple'
    });

    var _props$center = props.center,
        centerProp = _props$center === void 0 ? false : _props$center,
        _props$classes = props.classes,
        classes = _props$classes === void 0 ? {} : _props$classes,
        className = props.className,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$1D);

    var _React__namespace$use30 = React__namespace.useState([]),
        _React__namespace$use31 = _slicedToArray(_React__namespace$use30, 2),
        ripples = _React__namespace$use31[0],
        setRipples = _React__namespace$use31[1];

    var nextKey = React__namespace.useRef(0);
    var rippleCallback = React__namespace.useRef(null);
    React__namespace.useEffect(function () {
      if (rippleCallback.current) {
        rippleCallback.current();
        rippleCallback.current = null;
      }
    }, [ripples]); // Used to filter out mouse emulated events on mobile.

    var ignoringMouseDown = React__namespace.useRef(false); // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.

    var startTimer = React__namespace.useRef(null); // This is the hook called once the previous timeout is ready.

    var startTimerCommit = React__namespace.useRef(null);
    var container = React__namespace.useRef(null);
    React__namespace.useEffect(function () {
      return function () {
        clearTimeout(startTimer.current);
      };
    }, []);
    var startCommit = React__namespace.useCallback(function (params) {
      var pulsate = params.pulsate,
          rippleX = params.rippleX,
          rippleY = params.rippleY,
          rippleSize = params.rippleSize,
          cb = params.cb;
      setRipples(function (oldRipples) {
        return [].concat(_toConsumableArray(oldRipples), [/*#__PURE__*/jsxRuntime$1.jsx(TouchRippleRipple, {
          classes: {
            ripple: clsx(classes.ripple, touchRippleClasses$1.ripple),
            rippleVisible: clsx(classes.rippleVisible, touchRippleClasses$1.rippleVisible),
            ripplePulsate: clsx(classes.ripplePulsate, touchRippleClasses$1.ripplePulsate),
            child: clsx(classes.child, touchRippleClasses$1.child),
            childLeaving: clsx(classes.childLeaving, touchRippleClasses$1.childLeaving),
            childPulsate: clsx(classes.childPulsate, touchRippleClasses$1.childPulsate)
          },
          timeout: DURATION,
          pulsate: pulsate,
          rippleX: rippleX,
          rippleY: rippleY,
          rippleSize: rippleSize
        }, nextKey.current)]);
      });
      nextKey.current += 1;
      rippleCallback.current = cb;
    }, [classes]);
    var start = React__namespace.useCallback(function () {
      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var cb = arguments.length > 2 ? arguments[2] : undefined;
      var _options$pulsate = options.pulsate,
          pulsate = _options$pulsate === void 0 ? false : _options$pulsate,
          _options$center = options.center,
          center = _options$center === void 0 ? centerProp || options.pulsate : _options$center,
          _options$fakeElement = options.fakeElement,
          fakeElement = _options$fakeElement === void 0 ? false : _options$fakeElement;

      if (event.type === 'mousedown' && ignoringMouseDown.current) {
        ignoringMouseDown.current = false;
        return;
      }

      if (event.type === 'touchstart') {
        ignoringMouseDown.current = true;
      }

      var element = fakeElement ? null : container.current;
      var rect = element ? element.getBoundingClientRect() : {
        width: 0,
        height: 0,
        left: 0,
        top: 0
      }; // Get the size of the ripple

      var rippleX;
      var rippleY;
      var rippleSize;

      if (center || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
        rippleX = Math.round(rect.width / 2);
        rippleY = Math.round(rect.height / 2);
      } else {
        var _ref28 = event.touches ? event.touches[0] : event,
            clientX = _ref28.clientX,
            clientY = _ref28.clientY;

        rippleX = Math.round(clientX - rect.left);
        rippleY = Math.round(clientY - rect.top);
      }

      if (center) {
        rippleSize = Math.sqrt((2 * Math.pow(rect.width, 2) + Math.pow(rect.height, 2)) / 3); // For some reason the animation is broken on Mobile Chrome if the size is even.

        if (rippleSize % 2 === 0) {
          rippleSize += 1;
        }
      } else {
        var sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
        var sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
        rippleSize = Math.sqrt(Math.pow(sizeX, 2) + Math.pow(sizeY, 2));
      } // Touche devices


      if (event.touches) {
        // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        if (startTimerCommit.current === null) {
          // Prepare the ripple effect.
          startTimerCommit.current = function () {
            startCommit({
              pulsate: pulsate,
              rippleX: rippleX,
              rippleY: rippleY,
              rippleSize: rippleSize,
              cb: cb
            });
          }; // Delay the execution of the ripple effect.


          startTimer.current = setTimeout(function () {
            if (startTimerCommit.current) {
              startTimerCommit.current();
              startTimerCommit.current = null;
            }
          }, DELAY_RIPPLE); // We have to make a tradeoff with this value.
        }
      } else {
        startCommit({
          pulsate: pulsate,
          rippleX: rippleX,
          rippleY: rippleY,
          rippleSize: rippleSize,
          cb: cb
        });
      }
    }, [centerProp, startCommit]);
    var pulsate = React__namespace.useCallback(function () {
      start({}, {
        pulsate: true
      });
    }, [start]);
    var stop = React__namespace.useCallback(function (event, cb) {
      clearTimeout(startTimer.current); // The touch interaction occurs too quickly.
      // We still want to show ripple effect.

      if (event.type === 'touchend' && startTimerCommit.current) {
        startTimerCommit.current();
        startTimerCommit.current = null;
        startTimer.current = setTimeout(function () {
          stop(event, cb);
        });
        return;
      }

      startTimerCommit.current = null;
      setRipples(function (oldRipples) {
        if (oldRipples.length > 0) {
          return oldRipples.slice(1);
        }

        return oldRipples;
      });
      rippleCallback.current = cb;
    }, []);
    React__namespace.useImperativeHandle(ref, function () {
      return {
        pulsate: pulsate,
        start: start,
        stop: stop
      };
    }, [pulsate, start, stop]);
    return /*#__PURE__*/jsxRuntime$1.jsx(TouchRippleRoot, _extends$c({
      className: clsx(classes.root, touchRippleClasses$1.root, className),
      ref: container
    }, other, {
      children: /*#__PURE__*/jsxRuntime$1.jsx(TransitionGroup$1, {
        component: null,
        exit: true,
        children: ripples
      })
    }));
  });
  process.env.NODE_ENV !== "production" ? TouchRipple.propTypes = {
    /**
     * If `true`, the ripple starts at the center of the component
     * rather than at the point of interaction.
     */
    center: PropTypes.bool,

    /**
     * Override or extend the styles applied to the component.
     * See [CSS API](#css) below for more details.
     */
    classes: PropTypes.object,

    /**
     * @ignore
     */
    className: PropTypes.string
  } : void 0;
  var TouchRipple$1 = TouchRipple;

  function getButtonBaseUtilityClass(slot) {
    return generateUtilityClass('MuiButtonBase', slot);
  }

  var buttonBaseClasses = generateUtilityClasses('MuiButtonBase', ['root', 'disabled', 'focusVisible']);
  var buttonBaseClasses$1 = buttonBaseClasses;
  var _excluded$1C = ["action", "centerRipple", "children", "className", "component", "disabled", "disableRipple", "disableTouchRipple", "focusRipple", "focusVisibleClassName", "LinkComponent", "onBlur", "onClick", "onContextMenu", "onDragLeave", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "tabIndex", "TouchRippleProps", "type"];

  var useUtilityClasses$1g = function useUtilityClasses$1g(ownerState) {
    var disabled = ownerState.disabled,
        focusVisible = ownerState.focusVisible,
        focusVisibleClassName = ownerState.focusVisibleClassName,
        classes = ownerState.classes;
    var slots = {
      root: ['root', disabled && 'disabled', focusVisible && 'focusVisible']
    };
    var composedClasses = composeClasses(slots, getButtonBaseUtilityClass, classes);

    if (focusVisible && focusVisibleClassName) {
      composedClasses.root += " ".concat(focusVisibleClassName);
    }

    return composedClasses;
  };

  var ButtonBaseRoot = styled$1('button', {
    name: 'MuiButtonBase',
    slot: 'Root',
    overridesResolver: function overridesResolver(props, styles) {
      return styles.root;
    }
  })((_styled$ = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    boxSizing: 'border-box',
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    MozAppearance: 'none',
    // Reset
    WebkitAppearance: 'none',
    // Reset
    textDecoration: 'none',
    // So we take precedent over the style of a native <a /> element.
    color: 'inherit',
    '&::-moz-focus-inner': {
      borderStyle: 'none' // Remove Firefox dotted outline.

    }
  }, _defineProperty(_styled$, "&.".concat(buttonBaseClasses$1.disabled), {
    pointerEvents: 'none',
    // Disable link interactions
    cursor: 'default'
  }), _defineProperty(_styled$, '@media print', {
    colorAdjust: 'exact'
  }), _styled$));
  /**
   * `ButtonBase` contains as few styles as possible.
   * It aims to be a simple building block for creating a button.
   * It contains a load of style reset and some focus/ripple logic.
   */

  var ButtonBase = /*#__PURE__*/React__namespace.forwardRef(function ButtonBase(inProps, ref) {
    var props = useThemeProps({
      props: inProps,
      name: 'MuiButtonBase'
    });

    var action = props.action,
        _props$centerRipple = props.centerRipple,
        centerRipple = _props$centerRipple === void 0 ? false : _props$centerRipple,
        children = props.children,
        className = props.className,
        _props$component5 = props.component,
        component = _props$component5 === void 0 ? 'button' : _props$component5,
        _props$disabled = props.disabled,
        disabled = _props$disabled === void 0 ? false : _props$disabled,
        _props$disableRipple = props.disableRipple,
        disableRipple = _props$disableRipple === void 0 ? false : _props$disableRipple,
        _props$disableTouchRi = props.disableTouchRipple,
        disableTouchRipple = _props$disableTouchRi === void 0 ? false : _props$disableTouchRi,
        _props$focusRipple = props.focusRipple,
        focusRipple = _props$focusRipple === void 0 ? false : _props$focusRipple,
        _props$LinkComponent = props.LinkComponent,
        LinkComponent = _props$LinkComponent === void 0 ? 'a' : _props$LinkComponent,
        onBlur = props.onBlur,
        onClick = props.onClick,
        onContextMenu = props.onContextMenu,
        onDragLeave = props.onDragLeave,
        onFocus = props.onFocus,
        onFocusVisible = props.onFocusVisible,
        onKeyDown = props.onKeyDown,
        onKeyUp = props.onKeyUp,
        onMouseDown = props.onMouseDown,
        onMouseLeave = props.onMouseLeave,
        onMouseUp = props.onMouseUp,
        onTouchEnd = props.onTouchEnd,
        onTouchMove = props.onTouchMove,
        onTouchStart = props.onTouchStart,
        _props$tabIndex = props.tabIndex,
        tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex,
        TouchRippleProps = props.TouchRippleProps,
        type = props.type,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$1C);

    var buttonRef = React__namespace.useRef(null);
    var rippleRef = React__namespace.useRef(null);

    var _useIsFocusVisible = useIsFocusVisible(),
        isFocusVisibleRef = _useIsFocusVisible.isFocusVisibleRef,
        handleFocusVisible = _useIsFocusVisible.onFocus,
        handleBlurVisible = _useIsFocusVisible.onBlur,
        focusVisibleRef = _useIsFocusVisible.ref;

    var _React__namespace$use32 = React__namespace.useState(false),
        _React__namespace$use33 = _slicedToArray(_React__namespace$use32, 2),
        focusVisible = _React__namespace$use33[0],
        setFocusVisible = _React__namespace$use33[1];

    if (disabled && focusVisible) {
      setFocusVisible(false);
    }

    React__namespace.useImperativeHandle(action, function () {
      return {
        focusVisible: function focusVisible() {
          setFocusVisible(true);
          buttonRef.current.focus();
        }
      };
    }, []);
    React__namespace.useEffect(function () {
      if (focusVisible && focusRipple && !disableRipple) {
        rippleRef.current.pulsate();
      }
    }, [disableRipple, focusRipple, focusVisible]);

    function useRippleHandler(rippleAction, eventCallback) {
      var skipRippleAction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : disableTouchRipple;
      return useEventCallback(function (event) {
        if (eventCallback) {
          eventCallback(event);
        }

        var ignore = skipRippleAction;

        if (!ignore && rippleRef.current) {
          rippleRef.current[rippleAction](event);
        }

        return true;
      });
    }

    var handleMouseDown = useRippleHandler('start', onMouseDown);
    var handleContextMenu = useRippleHandler('stop', onContextMenu);
    var handleDragLeave = useRippleHandler('stop', onDragLeave);
    var handleMouseUp = useRippleHandler('stop', onMouseUp);
    var handleMouseLeave = useRippleHandler('stop', function (event) {
      if (focusVisible) {
        event.preventDefault();
      }

      if (onMouseLeave) {
        onMouseLeave(event);
      }
    });
    var handleTouchStart = useRippleHandler('start', onTouchStart);
    var handleTouchEnd = useRippleHandler('stop', onTouchEnd);
    var handleTouchMove = useRippleHandler('stop', onTouchMove);
    var handleBlur = useRippleHandler('stop', function (event) {
      handleBlurVisible(event);

      if (isFocusVisibleRef.current === false) {
        setFocusVisible(false);
      }

      if (onBlur) {
        onBlur(event);
      }
    }, false);
    var handleFocus = useEventCallback(function (event) {
      // Fix for https://github.com/facebook/react/issues/7769
      if (!buttonRef.current) {
        buttonRef.current = event.currentTarget;
      }

      handleFocusVisible(event);

      if (isFocusVisibleRef.current === true) {
        setFocusVisible(true);

        if (onFocusVisible) {
          onFocusVisible(event);
        }
      }

      if (onFocus) {
        onFocus(event);
      }
    });

    var isNonNativeButton = function isNonNativeButton() {
      var button = buttonRef.current;
      return component && component !== 'button' && !(button.tagName === 'A' && button.href);
    };
    /**
     * IE11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
     */


    var keydownRef = React__namespace.useRef(false);
    var handleKeyDown = useEventCallback(function (event) {
      // Check if key is already down to avoid repeats being counted as multiple activations
      if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === ' ') {
        keydownRef.current = true;
        rippleRef.current.stop(event, function () {
          rippleRef.current.start(event);
        });
      }

      if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') {
        event.preventDefault();
      }

      if (onKeyDown) {
        onKeyDown(event);
      } // Keyboard accessibility for non interactive elements


      if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
        event.preventDefault();

        if (onClick) {
          onClick(event);
        }
      }
    });
    var handleKeyUp = useEventCallback(function (event) {
      // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
      // https://codesandbox.io/s/button-keyup-preventdefault-dn7f0
      if (focusRipple && event.key === ' ' && rippleRef.current && focusVisible && !event.defaultPrevented) {
        keydownRef.current = false;
        rippleRef.current.stop(event, function () {
          rippleRef.current.pulsate(event);
        });
      }

      if (onKeyUp) {
        onKeyUp(event);
      } // Keyboard accessibility for non interactive elements


      if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) {
        onClick(event);
      }
    });
    var ComponentProp = component;

    if (ComponentProp === 'button' && (other.href || other.to)) {
      ComponentProp = LinkComponent;
    }

    var buttonProps = {};

    if (ComponentProp === 'button') {
      buttonProps.type = type === undefined ? 'button' : type;
      buttonProps.disabled = disabled;
    } else {
      if (!other.href && !other.to) {
        buttonProps.role = 'button';
      }

      if (disabled) {
        buttonProps['aria-disabled'] = disabled;
      }
    }

    var handleOwnRef = useForkRef(focusVisibleRef, buttonRef);
    var handleRef = useForkRef(ref, handleOwnRef);

    var _React__namespace$use34 = React__namespace.useState(false),
        _React__namespace$use35 = _slicedToArray(_React__namespace$use34, 2),
        mountedState = _React__namespace$use35[0],
        setMountedState = _React__namespace$use35[1];

    React__namespace.useEffect(function () {
      setMountedState(true);
    }, []);
    var enableTouchRipple = mountedState && !disableRipple && !disabled;

    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      React__namespace.useEffect(function () {
        if (enableTouchRipple && !rippleRef.current) {
          console.error(['MUI: The `component` prop provided to ButtonBase is invalid.', 'Please make sure the children prop is rendered in this custom component.'].join('\n'));
        }
      }, [enableTouchRipple]);
    }

    var ownerState = _extends$c({}, props, {
      centerRipple: centerRipple,
      component: component,
      disabled: disabled,
      disableRipple: disableRipple,
      disableTouchRipple: disableTouchRipple,
      focusRipple: focusRipple,
      tabIndex: tabIndex,
      focusVisible: focusVisible
    });

    var classes = useUtilityClasses$1g(ownerState);
    return /*#__PURE__*/jsxRuntime$1.jsxs(ButtonBaseRoot, _extends$c({
      as: ComponentProp,
      className: clsx(classes.root, className),
      ownerState: ownerState,
      onBlur: handleBlur,
      onClick: onClick,
      onContextMenu: handleContextMenu,
      onFocus: handleFocus,
      onKeyDown: handleKeyDown,
      onKeyUp: handleKeyUp,
      onMouseDown: handleMouseDown,
      onMouseLeave: handleMouseLeave,
      onMouseUp: handleMouseUp,
      onDragLeave: handleDragLeave,
      onTouchEnd: handleTouchEnd,
      onTouchMove: handleTouchMove,
      onTouchStart: handleTouchStart,
      ref: handleRef,
      tabIndex: disabled ? -1 : tabIndex,
      type: type
    }, buttonProps, other, {
      children: [children, enableTouchRipple ?
      /*#__PURE__*/

      /* TouchRipple is only needed client-side, x2 boost on the server. */
      jsxRuntime$1.jsx(TouchRipple$1, _extends$c({
        ref: rippleRef,
        center: centerRipple
      }, TouchRippleProps)) : null]
    }));
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var ButtonBase$1 = ButtonBase;

  function getChipUtilityClass(slot) {
    return generateUtilityClass('MuiChip', slot);
  }

  var chipClasses = generateUtilityClasses('MuiChip', ['root', 'sizeSmall', 'sizeMedium', 'colorPrimary', 'colorSecondary', 'disabled', 'clickable', 'clickableColorPrimary', 'clickableColorSecondary', 'deletable', 'deletableColorPrimary', 'deletableColorSecondary', 'outlined', 'filled', 'outlinedPrimary', 'outlinedSecondary', 'avatar', 'avatarSmall', 'avatarMedium', 'avatarColorPrimary', 'avatarColorSecondary', 'icon', 'iconSmall', 'iconMedium', 'iconColorPrimary', 'iconColorSecondary', 'label', 'labelSmall', 'labelMedium', 'deleteIcon', 'deleteIconSmall', 'deleteIconMedium', 'deleteIconColorPrimary', 'deleteIconColorSecondary', 'deleteIconOutlinedColorPrimary', 'deleteIconOutlinedColorSecondary', 'focusVisible']);
  var chipClasses$1 = chipClasses;
  var _excluded$1B = ["avatar", "className", "clickable", "color", "component", "deleteIcon", "disabled", "icon", "label", "onClick", "onDelete", "onKeyDown", "onKeyUp", "size", "variant"];

  var useUtilityClasses$1f = function useUtilityClasses$1f(ownerState) {
    var classes = ownerState.classes,
        disabled = ownerState.disabled,
        size = ownerState.size,
        color = ownerState.color,
        onDelete = ownerState.onDelete,
        clickable = ownerState.clickable,
        variant = ownerState.variant;
    var slots = {
      root: ['root', variant, disabled && 'disabled', "size".concat(capitalize$1(size)), "color".concat(capitalize$1(color)), clickable && 'clickable', clickable && "clickableColor".concat(capitalize$1(color)), onDelete && 'deletable', onDelete && "deletableColor".concat(capitalize$1(color)), "".concat(variant).concat(capitalize$1(color))],
      label: ['label', "label".concat(capitalize$1(size))],
      avatar: ['avatar', "avatar".concat(capitalize$1(size)), "avatarColor".concat(capitalize$1(color))],
      icon: ['icon', "icon".concat(capitalize$1(size)), "iconColor".concat(capitalize$1(color))],
      deleteIcon: ['deleteIcon', "deleteIcon".concat(capitalize$1(size)), "deleteIconColor".concat(capitalize$1(color)), "deleteIconOutlinedColor".concat(capitalize$1(color))]
    };
    return composeClasses(slots, getChipUtilityClass, classes);
  };

  var ChipRoot = styled$1('div', {
    name: 'MuiChip',
    slot: 'Root',
    overridesResolver: function overridesResolver(props, styles) {
      var ownerState = props.ownerState;
      var color = ownerState.color,
          clickable = ownerState.clickable,
          onDelete = ownerState.onDelete,
          size = ownerState.size,
          variant = ownerState.variant;
      return [_defineProperty({}, "& .".concat(chipClasses$1.avatar), styles.avatar), _defineProperty({}, "& .".concat(chipClasses$1.avatar), styles["avatar".concat(capitalize$1(size))]), _defineProperty({}, "& .".concat(chipClasses$1.avatar), styles["avatarColor".concat(capitalize$1(color))]), _defineProperty({}, "& .".concat(chipClasses$1.icon), styles.icon), _defineProperty({}, "& .".concat(chipClasses$1.icon), styles["icon".concat(capitalize$1(size))]), _defineProperty({}, "& .".concat(chipClasses$1.icon), styles["iconColor".concat(capitalize$1(color))]), _defineProperty({}, "& .".concat(chipClasses$1.deleteIcon), styles.deleteIcon), _defineProperty({}, "& .".concat(chipClasses$1.deleteIcon), styles["deleteIcon".concat(capitalize$1(size))]), _defineProperty({}, "& .".concat(chipClasses$1.deleteIcon), styles["deleteIconColor".concat(capitalize$1(color))]), _defineProperty({}, "& .".concat(chipClasses$1.deleteIcon), styles["deleteIconOutlinedColor".concat(capitalize$1(color))]), styles.root, styles["size".concat(capitalize$1(size))], styles["color".concat(capitalize$1(color))], clickable && styles.clickable, clickable && color !== 'default' && styles["clickableColor".concat(capitalize$1(color), ")")], onDelete && styles.deletable, onDelete && color !== 'default' && styles["deletableColor".concat(capitalize$1(color))], styles[variant], variant === 'outlined' && styles["outlined".concat(capitalize$1(color))]];
    }
  })(function (_ref39) {
    var _extends$c2;

    var theme = _ref39.theme,
        ownerState = _ref39.ownerState;
    var deleteIconColor = alpha(theme.palette.text.primary, 0.26);
    return _extends$c((_extends$c2 = {
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.pxToRem(13),
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: 32,
      color: theme.palette.text.primary,
      backgroundColor: theme.palette.action.selected,
      borderRadius: 32 / 2,
      whiteSpace: 'nowrap',
      transition: theme.transitions.create(['background-color', 'box-shadow']),
      // label will inherit this from root, then `clickable` class overrides this for both
      cursor: 'default',
      // We disable the focus ring for mouse, touch and keyboard users.
      outline: 0,
      textDecoration: 'none',
      border: 0,
      // Remove `button` border
      padding: 0,
      // Remove `button` padding
      verticalAlign: 'middle',
      boxSizing: 'border-box'
    }, _defineProperty(_extends$c2, "&.".concat(chipClasses$1.disabled), {
      opacity: theme.palette.action.disabledOpacity,
      pointerEvents: 'none'
    }), _defineProperty(_extends$c2, "& .".concat(chipClasses$1.avatar), {
      marginLeft: 5,
      marginRight: -6,
      width: 24,
      height: 24,
      color: theme.palette.mode === 'light' ? theme.palette.grey[700] : theme.palette.grey[300],
      fontSize: theme.typography.pxToRem(12)
    }), _defineProperty(_extends$c2, "& .".concat(chipClasses$1.avatarColorPrimary), {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.dark
    }), _defineProperty(_extends$c2, "& .".concat(chipClasses$1.avatarColorSecondary), {
      color: theme.palette.secondary.contrastText,
      backgroundColor: theme.palette.secondary.dark
    }), _defineProperty(_extends$c2, "& .".concat(chipClasses$1.avatarSmall), {
      marginLeft: 4,
      marginRight: -4,
      width: 18,
      height: 18,
      fontSize: theme.typography.pxToRem(10)
    }), _defineProperty(_extends$c2, "& .".concat(chipClasses$1.icon), _extends$c({
      color: theme.palette.mode === 'light' ? theme.palette.grey[700] : theme.palette.grey[300],
      marginLeft: 5,
      marginRight: -6
    }, ownerState.size === 'small' && {
      fontSize: 18,
      marginLeft: 4,
      marginRight: -4
    }, ownerState.color !== 'default' && {
      color: 'inherit'
    })), _defineProperty(_extends$c2, "& .".concat(chipClasses$1.deleteIcon), _extends$c({
      WebkitTapHighlightColor: 'transparent',
      color: deleteIconColor,
      fontSize: 22,
      cursor: 'pointer',
      margin: '0 5px 0 -6px',
      '&:hover': {
        color: alpha(deleteIconColor, 0.4)
      }
    }, ownerState.size === 'small' && {
      fontSize: 16,
      marginRight: 4,
      marginLeft: -4
    }, ownerState.color !== 'default' && {
      color: alpha(theme.palette[ownerState.color].contrastText, 0.7),
      '&:hover, &:active': {
        color: theme.palette[ownerState.color].contrastText
      }
    })), _extends$c2), ownerState.size === 'small' && {
      height: 24
    }, ownerState.color !== 'default' && {
      backgroundColor: theme.palette[ownerState.color].main,
      color: theme.palette[ownerState.color].contrastText
    }, ownerState.onDelete && _defineProperty({}, "&.".concat(chipClasses$1.focusVisible), {
      backgroundColor: alpha(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
    }), ownerState.onDelete && ownerState.color !== 'default' && _defineProperty({}, "&.".concat(chipClasses$1.focusVisible), {
      backgroundColor: theme.palette[ownerState.color].dark
    }));
  }, function (_ref42) {
    var _ref43;

    var theme = _ref42.theme,
        ownerState = _ref42.ownerState;
    return _extends$c({}, ownerState.clickable && (_ref43 = {
      userSelect: 'none',
      WebkitTapHighlightColor: 'transparent',
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: alpha(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
      }
    }, _defineProperty(_ref43, "&.".concat(chipClasses$1.focusVisible), {
      backgroundColor: alpha(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
    }), _defineProperty(_ref43, '&:active', {
      boxShadow: theme.shadows[1]
    }), _ref43), ownerState.clickable && ownerState.color !== 'default' && _defineProperty({}, "&:hover, &.".concat(chipClasses$1.focusVisible), {
      backgroundColor: theme.palette[ownerState.color].dark
    }));
  }, function (_ref45) {
    var _ref46, _ref47;

    var theme = _ref45.theme,
        ownerState = _ref45.ownerState;
    return _extends$c({}, ownerState.variant === 'outlined' && (_ref46 = {
      backgroundColor: 'transparent',
      border: "1px solid ".concat(theme.palette.mode === 'light' ? theme.palette.grey[400] : theme.palette.grey[700])
    }, _defineProperty(_ref46, "&.".concat(chipClasses$1.clickable, ":hover"), {
      backgroundColor: theme.palette.action.hover
    }), _defineProperty(_ref46, "&.".concat(chipClasses$1.focusVisible), {
      backgroundColor: theme.palette.action.focus
    }), _defineProperty(_ref46, "& .".concat(chipClasses$1.avatar), {
      marginLeft: 4
    }), _defineProperty(_ref46, "& .".concat(chipClasses$1.avatarSmall), {
      marginLeft: 2
    }), _defineProperty(_ref46, "& .".concat(chipClasses$1.icon), {
      marginLeft: 4
    }), _defineProperty(_ref46, "& .".concat(chipClasses$1.iconSmall), {
      marginLeft: 2
    }), _defineProperty(_ref46, "& .".concat(chipClasses$1.deleteIcon), {
      marginRight: 5
    }), _defineProperty(_ref46, "& .".concat(chipClasses$1.deleteIconSmall), {
      marginRight: 3
    }), _ref46), ownerState.variant === 'outlined' && ownerState.color !== 'default' && (_ref47 = {
      color: theme.palette[ownerState.color].main,
      border: "1px solid ".concat(alpha(theme.palette[ownerState.color].main, 0.7))
    }, _defineProperty(_ref47, "&.".concat(chipClasses$1.clickable, ":hover"), {
      backgroundColor: alpha(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity)
    }), _defineProperty(_ref47, "&.".concat(chipClasses$1.focusVisible), {
      backgroundColor: alpha(theme.palette[ownerState.color].main, theme.palette.action.focusOpacity)
    }), _defineProperty(_ref47, "& .".concat(chipClasses$1.deleteIcon), {
      color: alpha(theme.palette[ownerState.color].main, 0.7),
      '&:hover, &:active': {
        color: theme.palette[ownerState.color].main
      }
    }), _ref47));
  });
  var ChipLabel = styled$1('span', {
    name: 'MuiChip',
    slot: 'Label',
    overridesResolver: function overridesResolver(props, styles) {
      var ownerState = props.ownerState;
      var size = ownerState.size;
      return [styles.label, styles["label".concat(capitalize$1(size))]];
    }
  })(function (_ref48) {
    var ownerState = _ref48.ownerState;
    return _extends$c({
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      paddingLeft: 12,
      paddingRight: 12,
      whiteSpace: 'nowrap'
    }, ownerState.size === 'small' && {
      paddingLeft: 8,
      paddingRight: 8
    });
  });

  function isDeleteKeyboardEvent(keyboardEvent) {
    return keyboardEvent.key === 'Backspace' || keyboardEvent.key === 'Delete';
  }
  /**
   * Chips represent complex entities in small blocks, such as a contact.
   */


  var Chip$1 = /*#__PURE__*/React__namespace.forwardRef(function Chip(inProps, ref) {
    var props = useThemeProps({
      props: inProps,
      name: 'MuiChip'
    });

    var avatarProp = props.avatar,
        className = props.className,
        clickableProp = props.clickable,
        _props$color2 = props.color,
        color = _props$color2 === void 0 ? 'default' : _props$color2,
        ComponentProp = props.component,
        deleteIconProp = props.deleteIcon,
        _props$disabled2 = props.disabled,
        disabled = _props$disabled2 === void 0 ? false : _props$disabled2,
        iconProp = props.icon,
        label = props.label,
        onClick = props.onClick,
        onDelete = props.onDelete,
        onKeyDown = props.onKeyDown,
        onKeyUp = props.onKeyUp,
        _props$size = props.size,
        size = _props$size === void 0 ? 'medium' : _props$size,
        _props$variant2 = props.variant,
        variant = _props$variant2 === void 0 ? 'filled' : _props$variant2,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$1B);

    var chipRef = React__namespace.useRef(null);
    var handleRef = useForkRef(chipRef, ref);

    var handleDeleteIconClick = function handleDeleteIconClick(event) {
      // Stop the event from bubbling up to the `Chip`
      event.stopPropagation();

      if (onDelete) {
        onDelete(event);
      }
    };

    var handleKeyDown = function handleKeyDown(event) {
      // Ignore events from children of `Chip`.
      if (event.currentTarget === event.target && isDeleteKeyboardEvent(event)) {
        // Will be handled in keyUp, otherwise some browsers
        // might init navigation
        event.preventDefault();
      }

      if (onKeyDown) {
        onKeyDown(event);
      }
    };

    var handleKeyUp = function handleKeyUp(event) {
      // Ignore events from children of `Chip`.
      if (event.currentTarget === event.target) {
        if (onDelete && isDeleteKeyboardEvent(event)) {
          onDelete(event);
        } else if (event.key === 'Escape' && chipRef.current) {
          chipRef.current.blur();
        }
      }

      if (onKeyUp) {
        onKeyUp(event);
      }
    };

    var clickable = clickableProp !== false && onClick ? true : clickableProp;
    var small = size === 'small';
    var component = clickable || onDelete ? ButtonBase$1 : ComponentProp || 'div';

    var ownerState = _extends$c({}, props, {
      component: component,
      disabled: disabled,
      size: size,
      color: color,
      onDelete: !!onDelete,
      clickable: clickable,
      variant: variant
    });

    var classes = useUtilityClasses$1f(ownerState);
    var moreProps = component === ButtonBase$1 ? _extends$c({
      component: ComponentProp || 'div',
      focusVisibleClassName: classes.focusVisible
    }, onDelete && {
      disableRipple: true
    }) : {};
    var deleteIcon = null;

    if (onDelete) {
      var customClasses = clsx(color !== 'default' && (variant === 'outlined' ? classes["deleteIconOutlinedColor".concat(capitalize$1(color))] : classes["deleteIconColor".concat(capitalize$1(color))]), small && classes.deleteIconSmall);
      deleteIcon = deleteIconProp && /*#__PURE__*/React__namespace.isValidElement(deleteIconProp) ? /*#__PURE__*/React__namespace.cloneElement(deleteIconProp, {
        className: clsx(deleteIconProp.props.className, classes.deleteIcon, customClasses),
        onClick: handleDeleteIconClick
      }) : /*#__PURE__*/jsxRuntime$1.jsx(CancelIcon, {
        className: clsx(classes.deleteIcon, customClasses),
        onClick: handleDeleteIconClick
      });
    }

    var avatar = null;

    if (avatarProp && /*#__PURE__*/React__namespace.isValidElement(avatarProp)) {
      avatar = /*#__PURE__*/React__namespace.cloneElement(avatarProp, {
        className: clsx(classes.avatar, avatarProp.props.className)
      });
    }

    var icon = null;

    if (iconProp && /*#__PURE__*/React__namespace.isValidElement(iconProp)) {
      icon = /*#__PURE__*/React__namespace.cloneElement(iconProp, {
        className: clsx(classes.icon, iconProp.props.className)
      });
    }

    if (process.env.NODE_ENV !== 'production') {
      if (avatar && icon) {
        console.error('MUI: The Chip component can not handle the avatar ' + 'and the icon prop at the same time. Pick one.');
      }
    }

    return /*#__PURE__*/jsxRuntime$1.jsxs(ChipRoot, _extends$c({
      as: component,
      className: clsx(classes.root, className),
      disabled: clickable && disabled ? true : undefined,
      onClick: onClick,
      onKeyDown: handleKeyDown,
      onKeyUp: handleKeyUp,
      ref: handleRef,
      ownerState: ownerState
    }, moreProps, other, {
      children: [avatar || icon, /*#__PURE__*/jsxRuntime$1.jsx(ChipLabel, {
        className: clsx(classes.label),
        ownerState: ownerState,
        children: label
      }), deleteIcon]
    }));
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var Chip$2 = Chip$1;
  var lodash = {
    exports: {}
  };
  /**
   * @license
   * Lodash <https://lodash.com/>
   * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
   * Released under MIT license <https://lodash.com/license>
   * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
   * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
   */

  (function (module, exports) {
    (function () {
      /** Used as a safe reference for `undefined` in pre-ES5 environments. */
      var undefined$1;
      /** Used as the semantic version number. */

      var VERSION = '4.17.21';
      /** Used as the size to enable large array optimizations. */

      var LARGE_ARRAY_SIZE = 200;
      /** Error message constants. */

      var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
          FUNC_ERROR_TEXT = 'Expected a function',
          INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';
      /** Used to stand-in for `undefined` hash values. */

      var HASH_UNDEFINED = '__lodash_hash_undefined__';
      /** Used as the maximum memoize cache size. */

      var MAX_MEMOIZE_SIZE = 500;
      /** Used as the internal argument placeholder. */

      var PLACEHOLDER = '__lodash_placeholder__';
      /** Used to compose bitmasks for cloning. */

      var CLONE_DEEP_FLAG = 1,
          CLONE_FLAT_FLAG = 2,
          CLONE_SYMBOLS_FLAG = 4;
      /** Used to compose bitmasks for value comparisons. */

      var COMPARE_PARTIAL_FLAG = 1,
          COMPARE_UNORDERED_FLAG = 2;
      /** Used to compose bitmasks for function metadata. */

      var WRAP_BIND_FLAG = 1,
          WRAP_BIND_KEY_FLAG = 2,
          WRAP_CURRY_BOUND_FLAG = 4,
          WRAP_CURRY_FLAG = 8,
          WRAP_CURRY_RIGHT_FLAG = 16,
          WRAP_PARTIAL_FLAG = 32,
          WRAP_PARTIAL_RIGHT_FLAG = 64,
          WRAP_ARY_FLAG = 128,
          WRAP_REARG_FLAG = 256,
          WRAP_FLIP_FLAG = 512;
      /** Used as default options for `_.truncate`. */

      var DEFAULT_TRUNC_LENGTH = 30,
          DEFAULT_TRUNC_OMISSION = '...';
      /** Used to detect hot functions by number of calls within a span of milliseconds. */

      var HOT_COUNT = 800,
          HOT_SPAN = 16;
      /** Used to indicate the type of lazy iteratees. */

      var LAZY_FILTER_FLAG = 1,
          LAZY_MAP_FLAG = 2,
          LAZY_WHILE_FLAG = 3;
      /** Used as references for various `Number` constants. */

      var INFINITY = 1 / 0,
          MAX_SAFE_INTEGER = 9007199254740991,
          MAX_INTEGER = 1.7976931348623157e+308,
          NAN = 0 / 0;
      /** Used as references for the maximum length and index of an array. */

      var MAX_ARRAY_LENGTH = 4294967295,
          MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
          HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
      /** Used to associate wrap methods with their bit flags. */

      var wrapFlags = [['ary', WRAP_ARY_FLAG], ['bind', WRAP_BIND_FLAG], ['bindKey', WRAP_BIND_KEY_FLAG], ['curry', WRAP_CURRY_FLAG], ['curryRight', WRAP_CURRY_RIGHT_FLAG], ['flip', WRAP_FLIP_FLAG], ['partial', WRAP_PARTIAL_FLAG], ['partialRight', WRAP_PARTIAL_RIGHT_FLAG], ['rearg', WRAP_REARG_FLAG]];
      /** `Object#toString` result references. */

      var argsTag = '[object Arguments]',
          arrayTag = '[object Array]',
          asyncTag = '[object AsyncFunction]',
          boolTag = '[object Boolean]',
          dateTag = '[object Date]',
          domExcTag = '[object DOMException]',
          errorTag = '[object Error]',
          funcTag = '[object Function]',
          genTag = '[object GeneratorFunction]',
          mapTag = '[object Map]',
          numberTag = '[object Number]',
          nullTag = '[object Null]',
          objectTag = '[object Object]',
          promiseTag = '[object Promise]',
          proxyTag = '[object Proxy]',
          regexpTag = '[object RegExp]',
          setTag = '[object Set]',
          stringTag = '[object String]',
          symbolTag = '[object Symbol]',
          undefinedTag = '[object Undefined]',
          weakMapTag = '[object WeakMap]',
          weakSetTag = '[object WeakSet]';
      var arrayBufferTag = '[object ArrayBuffer]',
          dataViewTag = '[object DataView]',
          float32Tag = '[object Float32Array]',
          float64Tag = '[object Float64Array]',
          int8Tag = '[object Int8Array]',
          int16Tag = '[object Int16Array]',
          int32Tag = '[object Int32Array]',
          uint8Tag = '[object Uint8Array]',
          uint8ClampedTag = '[object Uint8ClampedArray]',
          uint16Tag = '[object Uint16Array]',
          uint32Tag = '[object Uint32Array]';
      /** Used to match empty string literals in compiled template source. */

      var reEmptyStringLeading = /\b__p \+= '';/g,
          reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
          reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
      /** Used to match HTML entities and HTML characters. */

      var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
          reUnescapedHtml = /[&<>"']/g,
          reHasEscapedHtml = RegExp(reEscapedHtml.source),
          reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
      /** Used to match template delimiters. */

      var reEscape = /<%-([\s\S]+?)%>/g,
          reEvaluate = /<%([\s\S]+?)%>/g,
          reInterpolate = /<%=([\s\S]+?)%>/g;
      /** Used to match property names within property paths. */

      var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
          reIsPlainProp = /^\w*$/,
          rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
      /**
       * Used to match `RegExp`
       * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
       */

      var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
          reHasRegExpChar = RegExp(reRegExpChar.source);
      /** Used to match leading whitespace. */

      var reTrimStart = /^\s+/;
      /** Used to match a single whitespace character. */

      var reWhitespace = /\s/;
      /** Used to match wrap detail comments. */

      var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
          reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
          reSplitDetails = /,? & /;
      /** Used to match words composed of alphanumeric characters. */

      var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
      /**
       * Used to validate the `validate` option in `_.template` variable.
       *
       * Forbids characters which could potentially change the meaning of the function argument definition:
       * - "()," (modification of function parameters)
       * - "=" (default value)
       * - "[]{}" (destructuring of function parameters)
       * - "/" (beginning of a comment)
       * - whitespace
       */

      var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
      /** Used to match backslashes in property paths. */

      var reEscapeChar = /\\(\\)?/g;
      /**
       * Used to match
       * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
       */

      var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
      /** Used to match `RegExp` flags from their coerced string values. */

      var reFlags = /\w*$/;
      /** Used to detect bad signed hexadecimal string values. */

      var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
      /** Used to detect binary string values. */

      var reIsBinary = /^0b[01]+$/i;
      /** Used to detect host constructors (Safari). */

      var reIsHostCtor = /^\[object .+?Constructor\]$/;
      /** Used to detect octal string values. */

      var reIsOctal = /^0o[0-7]+$/i;
      /** Used to detect unsigned integer values. */

      var reIsUint = /^(?:0|[1-9]\d*)$/;
      /** Used to match Latin Unicode letters (excluding mathematical operators). */

      var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
      /** Used to ensure capturing order of template delimiters. */

      var reNoMatch = /($^)/;
      /** Used to match unescaped characters in compiled string literals. */

      var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
      /** Used to compose unicode character classes. */

      var rsAstralRange = "\\ud800-\\udfff",
          rsComboMarksRange = "\\u0300-\\u036f",
          reComboHalfMarksRange = "\\ufe20-\\ufe2f",
          rsComboSymbolsRange = "\\u20d0-\\u20ff",
          rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
          rsDingbatRange = "\\u2700-\\u27bf",
          rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
          rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
          rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
          rsPunctuationRange = "\\u2000-\\u206f",
          rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000",
          rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
          rsVarRange = "\\ufe0e\\ufe0f",
          rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
      /** Used to compose unicode capture groups. */

      var rsApos = "['\u2019]",
          rsAstral = '[' + rsAstralRange + ']',
          rsBreak = '[' + rsBreakRange + ']',
          rsCombo = '[' + rsComboRange + ']',
          rsDigits = '\\d+',
          rsDingbat = '[' + rsDingbatRange + ']',
          rsLower = '[' + rsLowerRange + ']',
          rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
          rsFitz = "\\ud83c[\\udffb-\\udfff]",
          rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
          rsNonAstral = '[^' + rsAstralRange + ']',
          rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}",
          rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]",
          rsUpper = '[' + rsUpperRange + ']',
          rsZWJ = "\\u200d";
      /** Used to compose unicode regexes. */

      var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
          rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
          rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
          rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
          reOptMod = rsModifier + '?',
          rsOptVar = '[' + rsVarRange + ']?',
          rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
          rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
          rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
          rsSeq = rsOptVar + reOptMod + rsOptJoin,
          rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
          rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
      /** Used to match apostrophes. */

      var reApos = RegExp(rsApos, 'g');
      /**
       * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
       * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
       */

      var reComboMark = RegExp(rsCombo, 'g');
      /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */

      var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
      /** Used to match complex or compound words. */

      var reUnicodeWord = RegExp([rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')', rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')', rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower, rsUpper + '+' + rsOptContrUpper, rsOrdUpper, rsOrdLower, rsDigits, rsEmoji].join('|'), 'g');
      /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */

      var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
      /** Used to detect strings that need a more robust regexp to match words. */

      var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
      /** Used to assign default `context` object properties. */

      var contextProps = ['Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array', 'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object', 'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array', 'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap', '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'];
      /** Used to make template sourceURLs easier to identify. */

      var templateCounter = -1;
      /** Used to identify `toStringTag` values of typed arrays. */

      var typedArrayTags = {};
      typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
      typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
      /** Used to identify `toStringTag` values supported by `_.clone`. */

      var cloneableTags = {};
      cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
      cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
      /** Used to map Latin Unicode letters to basic Latin letters. */

      var deburredLetters = {
        // Latin-1 Supplement block.
        '\xc0': 'A',
        '\xc1': 'A',
        '\xc2': 'A',
        '\xc3': 'A',
        '\xc4': 'A',
        '\xc5': 'A',
        '\xe0': 'a',
        '\xe1': 'a',
        '\xe2': 'a',
        '\xe3': 'a',
        '\xe4': 'a',
        '\xe5': 'a',
        '\xc7': 'C',
        '\xe7': 'c',
        '\xd0': 'D',
        '\xf0': 'd',
        '\xc8': 'E',
        '\xc9': 'E',
        '\xca': 'E',
        '\xcb': 'E',
        '\xe8': 'e',
        '\xe9': 'e',
        '\xea': 'e',
        '\xeb': 'e',
        '\xcc': 'I',
        '\xcd': 'I',
        '\xce': 'I',
        '\xcf': 'I',
        '\xec': 'i',
        '\xed': 'i',
        '\xee': 'i',
        '\xef': 'i',
        '\xd1': 'N',
        '\xf1': 'n',
        '\xd2': 'O',
        '\xd3': 'O',
        '\xd4': 'O',
        '\xd5': 'O',
        '\xd6': 'O',
        '\xd8': 'O',
        '\xf2': 'o',
        '\xf3': 'o',
        '\xf4': 'o',
        '\xf5': 'o',
        '\xf6': 'o',
        '\xf8': 'o',
        '\xd9': 'U',
        '\xda': 'U',
        '\xdb': 'U',
        '\xdc': 'U',
        '\xf9': 'u',
        '\xfa': 'u',
        '\xfb': 'u',
        '\xfc': 'u',
        '\xdd': 'Y',
        '\xfd': 'y',
        '\xff': 'y',
        '\xc6': 'Ae',
        '\xe6': 'ae',
        '\xde': 'Th',
        '\xfe': 'th',
        '\xdf': 'ss',
        // Latin Extended-A block.
        "\u0100": 'A',
        "\u0102": 'A',
        "\u0104": 'A',
        "\u0101": 'a',
        "\u0103": 'a',
        "\u0105": 'a',
        "\u0106": 'C',
        "\u0108": 'C',
        "\u010A": 'C',
        "\u010C": 'C',
        "\u0107": 'c',
        "\u0109": 'c',
        "\u010B": 'c',
        "\u010D": 'c',
        "\u010E": 'D',
        "\u0110": 'D',
        "\u010F": 'd',
        "\u0111": 'd',
        "\u0112": 'E',
        "\u0114": 'E',
        "\u0116": 'E',
        "\u0118": 'E',
        "\u011A": 'E',
        "\u0113": 'e',
        "\u0115": 'e',
        "\u0117": 'e',
        "\u0119": 'e',
        "\u011B": 'e',
        "\u011C": 'G',
        "\u011E": 'G',
        "\u0120": 'G',
        "\u0122": 'G',
        "\u011D": 'g',
        "\u011F": 'g',
        "\u0121": 'g',
        "\u0123": 'g',
        "\u0124": 'H',
        "\u0126": 'H',
        "\u0125": 'h',
        "\u0127": 'h',
        "\u0128": 'I',
        "\u012A": 'I',
        "\u012C": 'I',
        "\u012E": 'I',
        "\u0130": 'I',
        "\u0129": 'i',
        "\u012B": 'i',
        "\u012D": 'i',
        "\u012F": 'i',
        "\u0131": 'i',
        "\u0134": 'J',
        "\u0135": 'j',
        "\u0136": 'K',
        "\u0137": 'k',
        "\u0138": 'k',
        "\u0139": 'L',
        "\u013B": 'L',
        "\u013D": 'L',
        "\u013F": 'L',
        "\u0141": 'L',
        "\u013A": 'l',
        "\u013C": 'l',
        "\u013E": 'l',
        "\u0140": 'l',
        "\u0142": 'l',
        "\u0143": 'N',
        "\u0145": 'N',
        "\u0147": 'N',
        "\u014A": 'N',
        "\u0144": 'n',
        "\u0146": 'n',
        "\u0148": 'n',
        "\u014B": 'n',
        "\u014C": 'O',
        "\u014E": 'O',
        "\u0150": 'O',
        "\u014D": 'o',
        "\u014F": 'o',
        "\u0151": 'o',
        "\u0154": 'R',
        "\u0156": 'R',
        "\u0158": 'R',
        "\u0155": 'r',
        "\u0157": 'r',
        "\u0159": 'r',
        "\u015A": 'S',
        "\u015C": 'S',
        "\u015E": 'S',
        "\u0160": 'S',
        "\u015B": 's',
        "\u015D": 's',
        "\u015F": 's',
        "\u0161": 's',
        "\u0162": 'T',
        "\u0164": 'T',
        "\u0166": 'T',
        "\u0163": 't',
        "\u0165": 't',
        "\u0167": 't',
        "\u0168": 'U',
        "\u016A": 'U',
        "\u016C": 'U',
        "\u016E": 'U',
        "\u0170": 'U',
        "\u0172": 'U',
        "\u0169": 'u',
        "\u016B": 'u',
        "\u016D": 'u',
        "\u016F": 'u',
        "\u0171": 'u',
        "\u0173": 'u',
        "\u0174": 'W',
        "\u0175": 'w',
        "\u0176": 'Y',
        "\u0177": 'y',
        "\u0178": 'Y',
        "\u0179": 'Z',
        "\u017B": 'Z',
        "\u017D": 'Z',
        "\u017A": 'z',
        "\u017C": 'z',
        "\u017E": 'z',
        "\u0132": 'IJ',
        "\u0133": 'ij',
        "\u0152": 'Oe',
        "\u0153": 'oe',
        "\u0149": "'n",
        "\u017F": 's'
      };
      /** Used to map characters to HTML entities. */

      var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      };
      /** Used to map HTML entities to characters. */

      var htmlUnescapes = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'"
      };
      /** Used to escape characters for inclusion in compiled string literals. */

      var stringEscapes = {
        '\\': '\\',
        "'": "'",
        '\n': 'n',
        '\r': 'r',
        "\u2028": 'u2028',
        "\u2029": 'u2029'
      };
      /** Built-in method references without a dependency on `root`. */

      var freeParseFloat = parseFloat,
          freeParseInt = parseInt;
      /** Detect free variable `global` from Node.js. */

      var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
      /** Detect free variable `self`. */

      var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
      /** Used as a reference to the global object. */

      var root = freeGlobal || freeSelf || Function('return this')();
      /** Detect free variable `exports`. */

      var freeExports = exports && !exports.nodeType && exports;
      /** Detect free variable `module`. */

      var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;
      /** Detect the popular CommonJS extension `module.exports`. */

      var moduleExports = freeModule && freeModule.exports === freeExports;
      /** Detect free variable `process` from Node.js. */

      var freeProcess = moduleExports && freeGlobal.process;
      /** Used to access faster Node.js helpers. */

      var nodeUtil = function () {
        try {
          // Use `util.types` for Node.js 10+.
          var types = freeModule && freeModule.require && freeModule.require('util').types;

          if (types) {
            return types;
          } // Legacy `process.binding('util')` for Node.js < 10.


          return freeProcess && freeProcess.binding && freeProcess.binding('util');
        } catch (e) {}
      }();
      /* Node.js helper references. */


      var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
          nodeIsDate = nodeUtil && nodeUtil.isDate,
          nodeIsMap = nodeUtil && nodeUtil.isMap,
          nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
          nodeIsSet = nodeUtil && nodeUtil.isSet,
          nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
      /*--------------------------------------------------------------------------*/

      /**
       * A faster alternative to `Function#apply`, this function invokes `func`
       * with the `this` binding of `thisArg` and the arguments of `args`.
       *
       * @private
       * @param {Function} func The function to invoke.
       * @param {*} thisArg The `this` binding of `func`.
       * @param {Array} args The arguments to invoke `func` with.
       * @returns {*} Returns the result of `func`.
       */

      function apply(func, thisArg, args) {
        switch (args.length) {
          case 0:
            return func.call(thisArg);

          case 1:
            return func.call(thisArg, args[0]);

          case 2:
            return func.call(thisArg, args[0], args[1]);

          case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
        }

        return func.apply(thisArg, args);
      }
      /**
       * A specialized version of `baseAggregator` for arrays.
       *
       * @private
       * @param {Array} [array] The array to iterate over.
       * @param {Function} setter The function to set `accumulator` values.
       * @param {Function} iteratee The iteratee to transform keys.
       * @param {Object} accumulator The initial aggregated object.
       * @returns {Function} Returns `accumulator`.
       */


      function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1,
            length = array == null ? 0 : array.length;

        while (++index < length) {
          var value = array[index];
          setter(accumulator, value, iteratee(value), array);
        }

        return accumulator;
      }
      /**
       * A specialized version of `_.forEach` for arrays without support for
       * iteratee shorthands.
       *
       * @private
       * @param {Array} [array] The array to iterate over.
       * @param {Function} iteratee The function invoked per iteration.
       * @returns {Array} Returns `array`.
       */


      function arrayEach(array, iteratee) {
        var index = -1,
            length = array == null ? 0 : array.length;

        while (++index < length) {
          if (iteratee(array[index], index, array) === false) {
            break;
          }
        }

        return array;
      }
      /**
       * A specialized version of `_.forEachRight` for arrays without support for
       * iteratee shorthands.
       *
       * @private
       * @param {Array} [array] The array to iterate over.
       * @param {Function} iteratee The function invoked per iteration.
       * @returns {Array} Returns `array`.
       */


      function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;

        while (length--) {
          if (iteratee(array[length], length, array) === false) {
            break;
          }
        }

        return array;
      }
      /**
       * A specialized version of `_.every` for arrays without support for
       * iteratee shorthands.
       *
       * @private
       * @param {Array} [array] The array to iterate over.
       * @param {Function} predicate The function invoked per iteration.
       * @returns {boolean} Returns `true` if all elements pass the predicate check,
       *  else `false`.
       */


      function arrayEvery(array, predicate) {
        var index = -1,
            length = array == null ? 0 : array.length;

        while (++index < length) {
          if (!predicate(array[index], index, array)) {
            return false;
          }
        }

        return true;
      }
      /**
       * A specialized version of `_.filter` for arrays without support for
       * iteratee shorthands.
       *
       * @private
       * @param {Array} [array] The array to iterate over.
       * @param {Function} predicate The function invoked per iteration.
       * @returns {Array} Returns the new filtered array.
       */


      function arrayFilter(array, predicate) {
        var index = -1,
            length = array == null ? 0 : array.length,
            resIndex = 0,
            result = [];

        while (++index < length) {
          var value = array[index];

          if (predicate(value, index, array)) {
            result[resIndex++] = value;
          }
        }

        return result;
      }
      /**
       * A specialized version of `_.includes` for arrays without support for
       * specifying an index to search from.
       *
       * @private
       * @param {Array} [array] The array to inspect.
       * @param {*} target The value to search for.
       * @returns {boolean} Returns `true` if `target` is found, else `false`.
       */


      function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
      }
      /**
       * This function is like `arrayIncludes` except that it accepts a comparator.
       *
       * @private
       * @param {Array} [array] The array to inspect.
       * @param {*} target The value to search for.
       * @param {Function} comparator The comparator invoked per element.
       * @returns {boolean} Returns `true` if `target` is found, else `false`.
       */


      function arrayIncludesWith(array, value, comparator) {
        var index = -1,
            length = array == null ? 0 : array.length;

        while (++index < length) {
          if (comparator(value, array[index])) {
            return true;
          }
        }

        return false;
      }
      /**
       * A specialized version of `_.map` for arrays without support for iteratee
       * shorthands.
       *
       * @private
       * @param {Array} [array] The array to iterate over.
       * @param {Function} iteratee The function invoked per iteration.
       * @returns {Array} Returns the new mapped array.
       */


      function arrayMap(array, iteratee) {
        var index = -1,
            length = array == null ? 0 : array.length,
            result = Array(length);

        while (++index < length) {
          result[index] = iteratee(array[index], index, array);
        }

        return result;
      }
      /**
       * Appends the elements of `values` to `array`.
       *
       * @private
       * @param {Array} array The array to modify.
       * @param {Array} values The values to append.
       * @returns {Array} Returns `array`.
       */


      function arrayPush(array, values) {
        var index = -1,
            length = values.length,
            offset = array.length;

        while (++index < length) {
          array[offset + index] = values[index];
        }

        return array;
      }
      /**
       * A specialized version of `_.reduce` for arrays without support for
       * iteratee shorthands.
       *
       * @private
       * @param {Array} [array] The array to iterate over.
       * @param {Function} iteratee The function invoked per iteration.
       * @param {*} [accumulator] The initial value.
       * @param {boolean} [initAccum] Specify using the first element of `array` as
       *  the initial value.
       * @returns {*} Returns the accumulated value.
       */


      function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1,
            length = array == null ? 0 : array.length;

        if (initAccum && length) {
          accumulator = array[++index];
        }

        while (++index < length) {
          accumulator = iteratee(accumulator, array[index], index, array);
        }

        return accumulator;
      }
      /**
       * A specialized version of `_.reduceRight` for arrays without support for
       * iteratee shorthands.
       *
       * @private
       * @param {Array} [array] The array to iterate over.
       * @param {Function} iteratee The function invoked per iteration.
       * @param {*} [accumulator] The initial value.
       * @param {boolean} [initAccum] Specify using the last element of `array` as
       *  the initial value.
       * @returns {*} Returns the accumulated value.
       */


      function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;

        if (initAccum && length) {
          accumulator = array[--length];
        }

        while (length--) {
          accumulator = iteratee(accumulator, array[length], length, array);
        }

        return accumulator;
      }
      /**
       * A specialized version of `_.some` for arrays without support for iteratee
       * shorthands.
       *
       * @private
       * @param {Array} [array] The array to iterate over.
       * @param {Function} predicate The function invoked per iteration.
       * @returns {boolean} Returns `true` if any element passes the predicate check,
       *  else `false`.
       */


      function arraySome(array, predicate) {
        var index = -1,
            length = array == null ? 0 : array.length;

        while (++index < length) {
          if (predicate(array[index], index, array)) {
            return true;
          }
        }

        return false;
      }
      /**
       * Gets the size of an ASCII `string`.
       *
       * @private
       * @param {string} string The string inspect.
       * @returns {number} Returns the string size.
       */


      var asciiSize = baseProperty('length');
      /**
       * Converts an ASCII `string` to an array.
       *
       * @private
       * @param {string} string The string to convert.
       * @returns {Array} Returns the converted array.
       */

      function asciiToArray(string) {
        return string.split('');
      }
      /**
       * Splits an ASCII `string` into an array of its words.
       *
       * @private
       * @param {string} The string to inspect.
       * @returns {Array} Returns the words of `string`.
       */


      function asciiWords(string) {
        return string.match(reAsciiWord) || [];
      }
      /**
       * The base implementation of methods like `_.findKey` and `_.findLastKey`,
       * without support for iteratee shorthands, which iterates over `collection`
       * using `eachFunc`.
       *
       * @private
       * @param {Array|Object} collection The collection to inspect.
       * @param {Function} predicate The function invoked per iteration.
       * @param {Function} eachFunc The function to iterate over `collection`.
       * @returns {*} Returns the found element or its key, else `undefined`.
       */


      function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function (value, key, collection) {
          if (predicate(value, key, collection)) {
            result = key;
            return false;
          }
        });
        return result;
      }
      /**
       * The base implementation of `_.findIndex` and `_.findLastIndex` without
       * support for iteratee shorthands.
       *
       * @private
       * @param {Array} array The array to inspect.
       * @param {Function} predicate The function invoked per iteration.
       * @param {number} fromIndex The index to search from.
       * @param {boolean} [fromRight] Specify iterating from right to left.
       * @returns {number} Returns the index of the matched value, else `-1`.
       */


      function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length,
            index = fromIndex + (fromRight ? 1 : -1);

        while (fromRight ? index-- : ++index < length) {
          if (predicate(array[index], index, array)) {
            return index;
          }
        }

        return -1;
      }
      /**
       * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
       *
       * @private
       * @param {Array} array The array to inspect.
       * @param {*} value The value to search for.
       * @param {number} fromIndex The index to search from.
       * @returns {number} Returns the index of the matched value, else `-1`.
       */


      function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
      }
      /**
       * This function is like `baseIndexOf` except that it accepts a comparator.
       *
       * @private
       * @param {Array} array The array to inspect.
       * @param {*} value The value to search for.
       * @param {number} fromIndex The index to search from.
       * @param {Function} comparator The comparator invoked per element.
       * @returns {number} Returns the index of the matched value, else `-1`.
       */


      function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1,
            length = array.length;

        while (++index < length) {
          if (comparator(array[index], value)) {
            return index;
          }
        }

        return -1;
      }
      /**
       * The base implementation of `_.isNaN` without support for number objects.
       *
       * @private
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
       */


      function baseIsNaN(value) {
        return value !== value;
      }
      /**
       * The base implementation of `_.mean` and `_.meanBy` without support for
       * iteratee shorthands.
       *
       * @private
       * @param {Array} array The array to iterate over.
       * @param {Function} iteratee The function invoked per iteration.
       * @returns {number} Returns the mean.
       */


      function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
      }
      /**
       * The base implementation of `_.property` without support for deep paths.
       *
       * @private
       * @param {string} key The key of the property to get.
       * @returns {Function} Returns the new accessor function.
       */


      function baseProperty(key) {
        return function (object) {
          return object == null ? undefined$1 : object[key];
        };
      }
      /**
       * The base implementation of `_.propertyOf` without support for deep paths.
       *
       * @private
       * @param {Object} object The object to query.
       * @returns {Function} Returns the new accessor function.
       */


      function basePropertyOf(object) {
        return function (key) {
          return object == null ? undefined$1 : object[key];
        };
      }
      /**
       * The base implementation of `_.reduce` and `_.reduceRight`, without support
       * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
       *
       * @private
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} iteratee The function invoked per iteration.
       * @param {*} accumulator The initial value.
       * @param {boolean} initAccum Specify using the first or last element of
       *  `collection` as the initial value.
       * @param {Function} eachFunc The function to iterate over `collection`.
       * @returns {*} Returns the accumulated value.
       */


      function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function (value, index, collection) {
          accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
      }
      /**
       * The base implementation of `_.sortBy` which uses `comparer` to define the
       * sort order of `array` and replaces criteria objects with their corresponding
       * values.
       *
       * @private
       * @param {Array} array The array to sort.
       * @param {Function} comparer The function to define sort order.
       * @returns {Array} Returns `array`.
       */


      function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);

        while (length--) {
          array[length] = array[length].value;
        }

        return array;
      }
      /**
       * The base implementation of `_.sum` and `_.sumBy` without support for
       * iteratee shorthands.
       *
       * @private
       * @param {Array} array The array to iterate over.
       * @param {Function} iteratee The function invoked per iteration.
       * @returns {number} Returns the sum.
       */


      function baseSum(array, iteratee) {
        var result,
            index = -1,
            length = array.length;

        while (++index < length) {
          var current = iteratee(array[index]);

          if (current !== undefined$1) {
            result = result === undefined$1 ? current : result + current;
          }
        }

        return result;
      }
      /**
       * The base implementation of `_.times` without support for iteratee shorthands
       * or max array length checks.
       *
       * @private
       * @param {number} n The number of times to invoke `iteratee`.
       * @param {Function} iteratee The function invoked per iteration.
       * @returns {Array} Returns the array of results.
       */


      function baseTimes(n, iteratee) {
        var index = -1,
            result = Array(n);

        while (++index < n) {
          result[index] = iteratee(index);
        }

        return result;
      }
      /**
       * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
       * of key-value pairs for `object` corresponding to the property names of `props`.
       *
       * @private
       * @param {Object} object The object to query.
       * @param {Array} props The property names to get values for.
       * @returns {Object} Returns the key-value pairs.
       */


      function baseToPairs(object, props) {
        return arrayMap(props, function (key) {
          return [key, object[key]];
        });
      }
      /**
       * The base implementation of `_.trim`.
       *
       * @private
       * @param {string} string The string to trim.
       * @returns {string} Returns the trimmed string.
       */


      function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
      }
      /**
       * The base implementation of `_.unary` without support for storing metadata.
       *
       * @private
       * @param {Function} func The function to cap arguments for.
       * @returns {Function} Returns the new capped function.
       */


      function baseUnary(func) {
        return function (value) {
          return func(value);
        };
      }
      /**
       * The base implementation of `_.values` and `_.valuesIn` which creates an
       * array of `object` property values corresponding to the property names
       * of `props`.
       *
       * @private
       * @param {Object} object The object to query.
       * @param {Array} props The property names to get values for.
       * @returns {Object} Returns the array of property values.
       */


      function baseValues(object, props) {
        return arrayMap(props, function (key) {
          return object[key];
        });
      }
      /**
       * Checks if a `cache` value for `key` exists.
       *
       * @private
       * @param {Object} cache The cache to query.
       * @param {string} key The key of the entry to check.
       * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
       */


      function cacheHas(cache, key) {
        return cache.has(key);
      }
      /**
       * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
       * that is not found in the character symbols.
       *
       * @private
       * @param {Array} strSymbols The string symbols to inspect.
       * @param {Array} chrSymbols The character symbols to find.
       * @returns {number} Returns the index of the first unmatched string symbol.
       */


      function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1,
            length = strSymbols.length;

        while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}

        return index;
      }
      /**
       * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
       * that is not found in the character symbols.
       *
       * @private
       * @param {Array} strSymbols The string symbols to inspect.
       * @param {Array} chrSymbols The character symbols to find.
       * @returns {number} Returns the index of the last unmatched string symbol.
       */


      function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;

        while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}

        return index;
      }
      /**
       * Gets the number of `placeholder` occurrences in `array`.
       *
       * @private
       * @param {Array} array The array to inspect.
       * @param {*} placeholder The placeholder to search for.
       * @returns {number} Returns the placeholder count.
       */


      function countHolders(array, placeholder) {
        var length = array.length,
            result = 0;

        while (length--) {
          if (array[length] === placeholder) {
            ++result;
          }
        }

        return result;
      }
      /**
       * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
       * letters to basic Latin letters.
       *
       * @private
       * @param {string} letter The matched letter to deburr.
       * @returns {string} Returns the deburred letter.
       */


      var deburrLetter = basePropertyOf(deburredLetters);
      /**
       * Used by `_.escape` to convert characters to HTML entities.
       *
       * @private
       * @param {string} chr The matched character to escape.
       * @returns {string} Returns the escaped character.
       */

      var escapeHtmlChar = basePropertyOf(htmlEscapes);
      /**
       * Used by `_.template` to escape characters for inclusion in compiled string literals.
       *
       * @private
       * @param {string} chr The matched character to escape.
       * @returns {string} Returns the escaped character.
       */

      function escapeStringChar(chr) {
        return '\\' + stringEscapes[chr];
      }
      /**
       * Gets the value at `key` of `object`.
       *
       * @private
       * @param {Object} [object] The object to query.
       * @param {string} key The key of the property to get.
       * @returns {*} Returns the property value.
       */


      function getValue(object, key) {
        return object == null ? undefined$1 : object[key];
      }
      /**
       * Checks if `string` contains Unicode symbols.
       *
       * @private
       * @param {string} string The string to inspect.
       * @returns {boolean} Returns `true` if a symbol is found, else `false`.
       */


      function hasUnicode(string) {
        return reHasUnicode.test(string);
      }
      /**
       * Checks if `string` contains a word composed of Unicode symbols.
       *
       * @private
       * @param {string} string The string to inspect.
       * @returns {boolean} Returns `true` if a word is found, else `false`.
       */


      function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
      }
      /**
       * Converts `iterator` to an array.
       *
       * @private
       * @param {Object} iterator The iterator to convert.
       * @returns {Array} Returns the converted array.
       */


      function iteratorToArray(iterator) {
        var data,
            result = [];

        while (!(data = iterator.next()).done) {
          result.push(data.value);
        }

        return result;
      }
      /**
       * Converts `map` to its key-value pairs.
       *
       * @private
       * @param {Object} map The map to convert.
       * @returns {Array} Returns the key-value pairs.
       */


      function mapToArray(map) {
        var index = -1,
            result = Array(map.size);
        map.forEach(function (value, key) {
          result[++index] = [key, value];
        });
        return result;
      }
      /**
       * Creates a unary function that invokes `func` with its argument transformed.
       *
       * @private
       * @param {Function} func The function to wrap.
       * @param {Function} transform The argument transform.
       * @returns {Function} Returns the new function.
       */


      function overArg(func, transform) {
        return function (arg) {
          return func(transform(arg));
        };
      }
      /**
       * Replaces all `placeholder` elements in `array` with an internal placeholder
       * and returns an array of their indexes.
       *
       * @private
       * @param {Array} array The array to modify.
       * @param {*} placeholder The placeholder to replace.
       * @returns {Array} Returns the new array of placeholder indexes.
       */


      function replaceHolders(array, placeholder) {
        var index = -1,
            length = array.length,
            resIndex = 0,
            result = [];

        while (++index < length) {
          var value = array[index];

          if (value === placeholder || value === PLACEHOLDER) {
            array[index] = PLACEHOLDER;
            result[resIndex++] = index;
          }
        }

        return result;
      }
      /**
       * Converts `set` to an array of its values.
       *
       * @private
       * @param {Object} set The set to convert.
       * @returns {Array} Returns the values.
       */


      function setToArray(set) {
        var index = -1,
            result = Array(set.size);
        set.forEach(function (value) {
          result[++index] = value;
        });
        return result;
      }
      /**
       * Converts `set` to its value-value pairs.
       *
       * @private
       * @param {Object} set The set to convert.
       * @returns {Array} Returns the value-value pairs.
       */


      function setToPairs(set) {
        var index = -1,
            result = Array(set.size);
        set.forEach(function (value) {
          result[++index] = [value, value];
        });
        return result;
      }
      /**
       * A specialized version of `_.indexOf` which performs strict equality
       * comparisons of values, i.e. `===`.
       *
       * @private
       * @param {Array} array The array to inspect.
       * @param {*} value The value to search for.
       * @param {number} fromIndex The index to search from.
       * @returns {number} Returns the index of the matched value, else `-1`.
       */


      function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1,
            length = array.length;

        while (++index < length) {
          if (array[index] === value) {
            return index;
          }
        }

        return -1;
      }
      /**
       * A specialized version of `_.lastIndexOf` which performs strict equality
       * comparisons of values, i.e. `===`.
       *
       * @private
       * @param {Array} array The array to inspect.
       * @param {*} value The value to search for.
       * @param {number} fromIndex The index to search from.
       * @returns {number} Returns the index of the matched value, else `-1`.
       */


      function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;

        while (index--) {
          if (array[index] === value) {
            return index;
          }
        }

        return index;
      }
      /**
       * Gets the number of symbols in `string`.
       *
       * @private
       * @param {string} string The string to inspect.
       * @returns {number} Returns the string size.
       */


      function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
      }
      /**
       * Converts `string` to an array.
       *
       * @private
       * @param {string} string The string to convert.
       * @returns {Array} Returns the converted array.
       */


      function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
      }
      /**
       * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
       * character of `string`.
       *
       * @private
       * @param {string} string The string to inspect.
       * @returns {number} Returns the index of the last non-whitespace character.
       */


      function trimmedEndIndex(string) {
        var index = string.length;

        while (index-- && reWhitespace.test(string.charAt(index))) {}

        return index;
      }
      /**
       * Used by `_.unescape` to convert HTML entities to characters.
       *
       * @private
       * @param {string} chr The matched character to unescape.
       * @returns {string} Returns the unescaped character.
       */


      var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
      /**
       * Gets the size of a Unicode `string`.
       *
       * @private
       * @param {string} string The string inspect.
       * @returns {number} Returns the string size.
       */

      function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;

        while (reUnicode.test(string)) {
          ++result;
        }

        return result;
      }
      /**
       * Converts a Unicode `string` to an array.
       *
       * @private
       * @param {string} string The string to convert.
       * @returns {Array} Returns the converted array.
       */


      function unicodeToArray(string) {
        return string.match(reUnicode) || [];
      }
      /**
       * Splits a Unicode `string` into an array of its words.
       *
       * @private
       * @param {string} The string to inspect.
       * @returns {Array} Returns the words of `string`.
       */


      function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
      }
      /*--------------------------------------------------------------------------*/

      /**
       * Create a new pristine `lodash` function using the `context` object.
       *
       * @static
       * @memberOf _
       * @since 1.1.0
       * @category Util
       * @param {Object} [context=root] The context object.
       * @returns {Function} Returns a new `lodash` function.
       * @example
       *
       * _.mixin({ 'foo': _.constant('foo') });
       *
       * var lodash = _.runInContext();
       * lodash.mixin({ 'bar': lodash.constant('bar') });
       *
       * _.isFunction(_.foo);
       * // => true
       * _.isFunction(_.bar);
       * // => false
       *
       * lodash.isFunction(lodash.foo);
       * // => false
       * lodash.isFunction(lodash.bar);
       * // => true
       *
       * // Create a suped-up `defer` in Node.js.
       * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
       */


      var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */

        var Array = context.Array,
            Date = context.Date,
            Error = context.Error,
            Function = context.Function,
            Math = context.Math,
            Object = context.Object,
            RegExp = context.RegExp,
            String = context.String,
            TypeError = context.TypeError;
        /** Used for built-in method references. */

        var arrayProto = Array.prototype,
            funcProto = Function.prototype,
            objectProto = Object.prototype;
        /** Used to detect overreaching core-js shims. */

        var coreJsData = context['__core-js_shared__'];
        /** Used to resolve the decompiled source of functions. */

        var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */

        var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */

        var idCounter = 0;
        /** Used to detect methods masquerading as native. */

        var maskSrcKey = function () {
          var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
          return uid ? 'Symbol(src)_1.' + uid : '';
        }();
        /**
         * Used to resolve the
         * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
         * of values.
         */


        var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */

        var objectCtorString = funcToString.call(Object);
        /** Used to restore the original `_` reference in `_.noConflict`. */

        var oldDash = root._;
        /** Used to detect if a method is native. */

        var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        /** Built-in value references. */

        var Buffer = moduleExports ? context.Buffer : undefined$1,
            Symbol = context.Symbol,
            Uint8Array = context.Uint8Array,
            allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined$1,
            getPrototype = overArg(Object.getPrototypeOf, Object),
            objectCreate = Object.create,
            propertyIsEnumerable = objectProto.propertyIsEnumerable,
            splice = arrayProto.splice,
            spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined$1,
            symIterator = Symbol ? Symbol.iterator : undefined$1,
            symToStringTag = Symbol ? Symbol.toStringTag : undefined$1;

        var defineProperty = function () {
          try {
            var func = getNative(Object, 'defineProperty');
            func({}, '', {});
            return func;
          } catch (e) {}
        }();
        /** Mocked built-ins. */


        var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
            ctxNow = Date && Date.now !== root.Date.now && Date.now,
            ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */

        var nativeCeil = Math.ceil,
            nativeFloor = Math.floor,
            nativeGetSymbols = Object.getOwnPropertySymbols,
            nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined$1,
            nativeIsFinite = context.isFinite,
            nativeJoin = arrayProto.join,
            nativeKeys = overArg(Object.keys, Object),
            nativeMax = Math.max,
            nativeMin = Math.min,
            nativeNow = Date.now,
            nativeParseInt = context.parseInt,
            nativeRandom = Math.random,
            nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */

        var DataView = getNative(context, 'DataView'),
            Map = getNative(context, 'Map'),
            Promise = getNative(context, 'Promise'),
            Set = getNative(context, 'Set'),
            WeakMap = getNative(context, 'WeakMap'),
            nativeCreate = getNative(Object, 'create');
        /** Used to store function metadata. */

        var metaMap = WeakMap && new WeakMap();
        /** Used to lookup unminified function names. */

        var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */

        var dataViewCtorString = toSource(DataView),
            mapCtorString = toSource(Map),
            promiseCtorString = toSource(Promise),
            setCtorString = toSource(Set),
            weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */

        var symbolProto = Symbol ? Symbol.prototype : undefined$1,
            symbolValueOf = symbolProto ? symbolProto.valueOf : undefined$1,
            symbolToString = symbolProto ? symbolProto.toString : undefined$1;
        /*------------------------------------------------------------------------*/

        /**
         * Creates a `lodash` object which wraps `value` to enable implicit method
         * chain sequences. Methods that operate on and return arrays, collections,
         * and functions can be chained together. Methods that retrieve a single value
         * or may return a primitive value will automatically end the chain sequence
         * and return the unwrapped value. Otherwise, the value must be unwrapped
         * with `_#value`.
         *
         * Explicit chain sequences, which must be unwrapped with `_#value`, may be
         * enabled using `_.chain`.
         *
         * The execution of chained methods is lazy, that is, it's deferred until
         * `_#value` is implicitly or explicitly called.
         *
         * Lazy evaluation allows several methods to support shortcut fusion.
         * Shortcut fusion is an optimization to merge iteratee calls; this avoids
         * the creation of intermediate arrays and can greatly reduce the number of
         * iteratee executions. Sections of a chain sequence qualify for shortcut
         * fusion if the section is applied to an array and iteratees accept only
         * one argument. The heuristic for whether a section qualifies for shortcut
         * fusion is subject to change.
         *
         * Chaining is supported in custom builds as long as the `_#value` method is
         * directly or indirectly included in the build.
         *
         * In addition to lodash methods, wrappers have `Array` and `String` methods.
         *
         * The wrapper `Array` methods are:
         * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
         *
         * The wrapper `String` methods are:
         * `replace` and `split`
         *
         * The wrapper methods that support shortcut fusion are:
         * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
         * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
         * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
         *
         * The chainable wrapper methods are:
         * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
         * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
         * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
         * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
         * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
         * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
         * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
         * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
         * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
         * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
         * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
         * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
         * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
         * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
         * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
         * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
         * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
         * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
         * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
         * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
         * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
         * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
         * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
         * `zipObject`, `zipObjectDeep`, and `zipWith`
         *
         * The wrapper methods that are **not** chainable by default are:
         * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
         * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
         * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
         * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
         * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
         * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
         * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
         * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
         * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
         * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
         * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
         * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
         * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
         * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
         * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
         * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
         * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
         * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
         * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
         * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
         * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
         * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
         * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
         * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
         * `upperFirst`, `value`, and `words`
         *
         * @name _
         * @constructor
         * @category Seq
         * @param {*} value The value to wrap in a `lodash` instance.
         * @returns {Object} Returns the new `lodash` wrapper instance.
         * @example
         *
         * function square(n) {
         *   return n * n;
         * }
         *
         * var wrapped = _([1, 2, 3]);
         *
         * // Returns an unwrapped value.
         * wrapped.reduce(_.add);
         * // => 6
         *
         * // Returns a wrapped value.
         * var squares = wrapped.map(square);
         *
         * _.isArray(squares);
         * // => false
         *
         * _.isArray(squares.value());
         * // => true
         */

        function lodash(value) {
          if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
            if (value instanceof LodashWrapper) {
              return value;
            }

            if (hasOwnProperty.call(value, '__wrapped__')) {
              return wrapperClone(value);
            }
          }

          return new LodashWrapper(value);
        }
        /**
         * The base implementation of `_.create` without support for assigning
         * properties to the created object.
         *
         * @private
         * @param {Object} proto The object to inherit from.
         * @returns {Object} Returns the new object.
         */


        var baseCreate = function () {
          function object() {}

          return function (proto) {
            if (!isObject(proto)) {
              return {};
            }

            if (objectCreate) {
              return objectCreate(proto);
            }

            object.prototype = proto;
            var result = new object();
            object.prototype = undefined$1;
            return result;
          };
        }();
        /**
         * The function whose prototype chain sequence wrappers inherit from.
         *
         * @private
         */


        function baseLodash() {// No operation performed.
        }
        /**
         * The base constructor for creating `lodash` wrapper objects.
         *
         * @private
         * @param {*} value The value to wrap.
         * @param {boolean} [chainAll] Enable explicit method chain sequences.
         */


        function LodashWrapper(value, chainAll) {
          this.__wrapped__ = value;
          this.__actions__ = [];
          this.__chain__ = !!chainAll;
          this.__index__ = 0;
          this.__values__ = undefined$1;
        }
        /**
         * By default, the template delimiters used by lodash are like those in
         * embedded Ruby (ERB) as well as ES2015 template strings. Change the
         * following template settings to use alternative delimiters.
         *
         * @static
         * @memberOf _
         * @type {Object}
         */


        lodash.templateSettings = {
          /**
           * Used to detect `data` property values to be HTML-escaped.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          'escape': reEscape,

          /**
           * Used to detect code to be evaluated.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          'evaluate': reEvaluate,

          /**
           * Used to detect `data` property values to inject.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          'interpolate': reInterpolate,

          /**
           * Used to reference the data object in the template text.
           *
           * @memberOf _.templateSettings
           * @type {string}
           */
          'variable': '',

          /**
           * Used to import variables into the compiled template.
           *
           * @memberOf _.templateSettings
           * @type {Object}
           */
          'imports': {
            /**
             * A reference to the `lodash` function.
             *
             * @memberOf _.templateSettings.imports
             * @type {Function}
             */
            '_': lodash
          }
        }; // Ensure wrappers are instances of `baseLodash`.

        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/

        /**
         * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
         *
         * @private
         * @constructor
         * @param {*} value The value to wrap.
         */

        function LazyWrapper(value) {
          this.__wrapped__ = value;
          this.__actions__ = [];
          this.__dir__ = 1;
          this.__filtered__ = false;
          this.__iteratees__ = [];
          this.__takeCount__ = MAX_ARRAY_LENGTH;
          this.__views__ = [];
        }
        /**
         * Creates a clone of the lazy wrapper object.
         *
         * @private
         * @name clone
         * @memberOf LazyWrapper
         * @returns {Object} Returns the cloned `LazyWrapper` object.
         */


        function lazyClone() {
          var result = new LazyWrapper(this.__wrapped__);
          result.__actions__ = copyArray(this.__actions__);
          result.__dir__ = this.__dir__;
          result.__filtered__ = this.__filtered__;
          result.__iteratees__ = copyArray(this.__iteratees__);
          result.__takeCount__ = this.__takeCount__;
          result.__views__ = copyArray(this.__views__);
          return result;
        }
        /**
         * Reverses the direction of lazy iteration.
         *
         * @private
         * @name reverse
         * @memberOf LazyWrapper
         * @returns {Object} Returns the new reversed `LazyWrapper` object.
         */


        function lazyReverse() {
          if (this.__filtered__) {
            var result = new LazyWrapper(this);
            result.__dir__ = -1;
            result.__filtered__ = true;
          } else {
            result = this.clone();
            result.__dir__ *= -1;
          }

          return result;
        }
        /**
         * Extracts the unwrapped value from its lazy wrapper.
         *
         * @private
         * @name value
         * @memberOf LazyWrapper
         * @returns {*} Returns the unwrapped value.
         */


        function lazyValue() {
          var array = this.__wrapped__.value(),
              dir = this.__dir__,
              isArr = isArray(array),
              isRight = dir < 0,
              arrLength = isArr ? array.length : 0,
              view = getView(0, arrLength, this.__views__),
              start = view.start,
              end = view.end,
              length = end - start,
              index = isRight ? end : start - 1,
              iteratees = this.__iteratees__,
              iterLength = iteratees.length,
              resIndex = 0,
              takeCount = nativeMin(length, this.__takeCount__);

          if (!isArr || !isRight && arrLength == length && takeCount == length) {
            return baseWrapperValue(array, this.__actions__);
          }

          var result = [];

          outer: while (length-- && resIndex < takeCount) {
            index += dir;
            var iterIndex = -1,
                value = array[index];

            while (++iterIndex < iterLength) {
              var data = iteratees[iterIndex],
                  iteratee = data.iteratee,
                  type = data.type,
                  computed = iteratee(value);

              if (type == LAZY_MAP_FLAG) {
                value = computed;
              } else if (!computed) {
                if (type == LAZY_FILTER_FLAG) {
                  continue outer;
                } else {
                  break outer;
                }
              }
            }

            result[resIndex++] = value;
          }

          return result;
        } // Ensure `LazyWrapper` is an instance of `baseLodash`.


        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/

        /**
         * Creates a hash object.
         *
         * @private
         * @constructor
         * @param {Array} [entries] The key-value pairs to cache.
         */

        function Hash(entries) {
          var index = -1,
              length = entries == null ? 0 : entries.length;
          this.clear();

          while (++index < length) {
            var entry = entries[index];
            this.set(entry[0], entry[1]);
          }
        }
        /**
         * Removes all key-value entries from the hash.
         *
         * @private
         * @name clear
         * @memberOf Hash
         */


        function hashClear() {
          this.__data__ = nativeCreate ? nativeCreate(null) : {};
          this.size = 0;
        }
        /**
         * Removes `key` and its value from the hash.
         *
         * @private
         * @name delete
         * @memberOf Hash
         * @param {Object} hash The hash to modify.
         * @param {string} key The key of the value to remove.
         * @returns {boolean} Returns `true` if the entry was removed, else `false`.
         */


        function hashDelete(key) {
          var result = this.has(key) && delete this.__data__[key];
          this.size -= result ? 1 : 0;
          return result;
        }
        /**
         * Gets the hash value for `key`.
         *
         * @private
         * @name get
         * @memberOf Hash
         * @param {string} key The key of the value to get.
         * @returns {*} Returns the entry value.
         */


        function hashGet(key) {
          var data = this.__data__;

          if (nativeCreate) {
            var result = data[key];
            return result === HASH_UNDEFINED ? undefined$1 : result;
          }

          return hasOwnProperty.call(data, key) ? data[key] : undefined$1;
        }
        /**
         * Checks if a hash value for `key` exists.
         *
         * @private
         * @name has
         * @memberOf Hash
         * @param {string} key The key of the entry to check.
         * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
         */


        function hashHas(key) {
          var data = this.__data__;
          return nativeCreate ? data[key] !== undefined$1 : hasOwnProperty.call(data, key);
        }
        /**
         * Sets the hash `key` to `value`.
         *
         * @private
         * @name set
         * @memberOf Hash
         * @param {string} key The key of the value to set.
         * @param {*} value The value to set.
         * @returns {Object} Returns the hash instance.
         */


        function hashSet(key, value) {
          var data = this.__data__;
          this.size += this.has(key) ? 0 : 1;
          data[key] = nativeCreate && value === undefined$1 ? HASH_UNDEFINED : value;
          return this;
        } // Add methods to `Hash`.


        Hash.prototype.clear = hashClear;
        Hash.prototype['delete'] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/

        /**
         * Creates an list cache object.
         *
         * @private
         * @constructor
         * @param {Array} [entries] The key-value pairs to cache.
         */

        function ListCache(entries) {
          var index = -1,
              length = entries == null ? 0 : entries.length;
          this.clear();

          while (++index < length) {
            var entry = entries[index];
            this.set(entry[0], entry[1]);
          }
        }
        /**
         * Removes all key-value entries from the list cache.
         *
         * @private
         * @name clear
         * @memberOf ListCache
         */


        function listCacheClear() {
          this.__data__ = [];
          this.size = 0;
        }
        /**
         * Removes `key` and its value from the list cache.
         *
         * @private
         * @name delete
         * @memberOf ListCache
         * @param {string} key The key of the value to remove.
         * @returns {boolean} Returns `true` if the entry was removed, else `false`.
         */


        function listCacheDelete(key) {
          var data = this.__data__,
              index = assocIndexOf(data, key);

          if (index < 0) {
            return false;
          }

          var lastIndex = data.length - 1;

          if (index == lastIndex) {
            data.pop();
          } else {
            splice.call(data, index, 1);
          }

          --this.size;
          return true;
        }
        /**
         * Gets the list cache value for `key`.
         *
         * @private
         * @name get
         * @memberOf ListCache
         * @param {string} key The key of the value to get.
         * @returns {*} Returns the entry value.
         */


        function listCacheGet(key) {
          var data = this.__data__,
              index = assocIndexOf(data, key);
          return index < 0 ? undefined$1 : data[index][1];
        }
        /**
         * Checks if a list cache value for `key` exists.
         *
         * @private
         * @name has
         * @memberOf ListCache
         * @param {string} key The key of the entry to check.
         * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
         */


        function listCacheHas(key) {
          return assocIndexOf(this.__data__, key) > -1;
        }
        /**
         * Sets the list cache `key` to `value`.
         *
         * @private
         * @name set
         * @memberOf ListCache
         * @param {string} key The key of the value to set.
         * @param {*} value The value to set.
         * @returns {Object} Returns the list cache instance.
         */


        function listCacheSet(key, value) {
          var data = this.__data__,
              index = assocIndexOf(data, key);

          if (index < 0) {
            ++this.size;
            data.push([key, value]);
          } else {
            data[index][1] = value;
          }

          return this;
        } // Add methods to `ListCache`.


        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype['delete'] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/

        /**
         * Creates a map cache object to store key-value pairs.
         *
         * @private
         * @constructor
         * @param {Array} [entries] The key-value pairs to cache.
         */

        function MapCache(entries) {
          var index = -1,
              length = entries == null ? 0 : entries.length;
          this.clear();

          while (++index < length) {
            var entry = entries[index];
            this.set(entry[0], entry[1]);
          }
        }
        /**
         * Removes all key-value entries from the map.
         *
         * @private
         * @name clear
         * @memberOf MapCache
         */


        function mapCacheClear() {
          this.size = 0;
          this.__data__ = {
            'hash': new Hash(),
            'map': new (Map || ListCache)(),
            'string': new Hash()
          };
        }
        /**
         * Removes `key` and its value from the map.
         *
         * @private
         * @name delete
         * @memberOf MapCache
         * @param {string} key The key of the value to remove.
         * @returns {boolean} Returns `true` if the entry was removed, else `false`.
         */


        function mapCacheDelete(key) {
          var result = getMapData(this, key)['delete'](key);
          this.size -= result ? 1 : 0;
          return result;
        }
        /**
         * Gets the map value for `key`.
         *
         * @private
         * @name get
         * @memberOf MapCache
         * @param {string} key The key of the value to get.
         * @returns {*} Returns the entry value.
         */


        function mapCacheGet(key) {
          return getMapData(this, key).get(key);
        }
        /**
         * Checks if a map value for `key` exists.
         *
         * @private
         * @name has
         * @memberOf MapCache
         * @param {string} key The key of the entry to check.
         * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
         */


        function mapCacheHas(key) {
          return getMapData(this, key).has(key);
        }
        /**
         * Sets the map `key` to `value`.
         *
         * @private
         * @name set
         * @memberOf MapCache
         * @param {string} key The key of the value to set.
         * @param {*} value The value to set.
         * @returns {Object} Returns the map cache instance.
         */


        function mapCacheSet(key, value) {
          var data = getMapData(this, key),
              size = data.size;
          data.set(key, value);
          this.size += data.size == size ? 0 : 1;
          return this;
        } // Add methods to `MapCache`.


        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype['delete'] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/

        /**
         *
         * Creates an array cache object to store unique values.
         *
         * @private
         * @constructor
         * @param {Array} [values] The values to cache.
         */

        function SetCache(values) {
          var index = -1,
              length = values == null ? 0 : values.length;
          this.__data__ = new MapCache();

          while (++index < length) {
            this.add(values[index]);
          }
        }
        /**
         * Adds `value` to the array cache.
         *
         * @private
         * @name add
         * @memberOf SetCache
         * @alias push
         * @param {*} value The value to cache.
         * @returns {Object} Returns the cache instance.
         */


        function setCacheAdd(value) {
          this.__data__.set(value, HASH_UNDEFINED);

          return this;
        }
        /**
         * Checks if `value` is in the array cache.
         *
         * @private
         * @name has
         * @memberOf SetCache
         * @param {*} value The value to search for.
         * @returns {number} Returns `true` if `value` is found, else `false`.
         */


        function setCacheHas(value) {
          return this.__data__.has(value);
        } // Add methods to `SetCache`.


        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/

        /**
         * Creates a stack cache object to store key-value pairs.
         *
         * @private
         * @constructor
         * @param {Array} [entries] The key-value pairs to cache.
         */

        function Stack(entries) {
          var data = this.__data__ = new ListCache(entries);
          this.size = data.size;
        }
        /**
         * Removes all key-value entries from the stack.
         *
         * @private
         * @name clear
         * @memberOf Stack
         */


        function stackClear() {
          this.__data__ = new ListCache();
          this.size = 0;
        }
        /**
         * Removes `key` and its value from the stack.
         *
         * @private
         * @name delete
         * @memberOf Stack
         * @param {string} key The key of the value to remove.
         * @returns {boolean} Returns `true` if the entry was removed, else `false`.
         */


        function stackDelete(key) {
          var data = this.__data__,
              result = data['delete'](key);
          this.size = data.size;
          return result;
        }
        /**
         * Gets the stack value for `key`.
         *
         * @private
         * @name get
         * @memberOf Stack
         * @param {string} key The key of the value to get.
         * @returns {*} Returns the entry value.
         */


        function stackGet(key) {
          return this.__data__.get(key);
        }
        /**
         * Checks if a stack value for `key` exists.
         *
         * @private
         * @name has
         * @memberOf Stack
         * @param {string} key The key of the entry to check.
         * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
         */


        function stackHas(key) {
          return this.__data__.has(key);
        }
        /**
         * Sets the stack `key` to `value`.
         *
         * @private
         * @name set
         * @memberOf Stack
         * @param {string} key The key of the value to set.
         * @param {*} value The value to set.
         * @returns {Object} Returns the stack cache instance.
         */


        function stackSet(key, value) {
          var data = this.__data__;

          if (data instanceof ListCache) {
            var pairs = data.__data__;

            if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
              pairs.push([key, value]);
              this.size = ++data.size;
              return this;
            }

            data = this.__data__ = new MapCache(pairs);
          }

          data.set(key, value);
          this.size = data.size;
          return this;
        } // Add methods to `Stack`.


        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/

        /**
         * Creates an array of the enumerable property names of the array-like `value`.
         *
         * @private
         * @param {*} value The value to query.
         * @param {boolean} inherited Specify returning inherited property names.
         * @returns {Array} Returns the array of property names.
         */

        function arrayLikeKeys(value, inherited) {
          var isArr = isArray(value),
              isArg = !isArr && isArguments(value),
              isBuff = !isArr && !isArg && isBuffer(value),
              isType = !isArr && !isArg && !isBuff && isTypedArray(value),
              skipIndexes = isArr || isArg || isBuff || isType,
              result = skipIndexes ? baseTimes(value.length, String) : [],
              length = result.length;

          for (var key in value) {
            if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && ( // Safari 9 has enumerable `arguments.length` in strict mode.
            key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
            isIndex(key, length)))) {
              result.push(key);
            }
          }

          return result;
        }
        /**
         * A specialized version of `_.sample` for arrays.
         *
         * @private
         * @param {Array} array The array to sample.
         * @returns {*} Returns the random element.
         */


        function arraySample(array) {
          var length = array.length;
          return length ? array[baseRandom(0, length - 1)] : undefined$1;
        }
        /**
         * A specialized version of `_.sampleSize` for arrays.
         *
         * @private
         * @param {Array} array The array to sample.
         * @param {number} n The number of elements to sample.
         * @returns {Array} Returns the random elements.
         */


        function arraySampleSize(array, n) {
          return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
         * A specialized version of `_.shuffle` for arrays.
         *
         * @private
         * @param {Array} array The array to shuffle.
         * @returns {Array} Returns the new shuffled array.
         */


        function arrayShuffle(array) {
          return shuffleSelf(copyArray(array));
        }
        /**
         * This function is like `assignValue` except that it doesn't assign
         * `undefined` values.
         *
         * @private
         * @param {Object} object The object to modify.
         * @param {string} key The key of the property to assign.
         * @param {*} value The value to assign.
         */


        function assignMergeValue(object, key, value) {
          if (value !== undefined$1 && !eq(object[key], value) || value === undefined$1 && !(key in object)) {
            baseAssignValue(object, key, value);
          }
        }
        /**
         * Assigns `value` to `key` of `object` if the existing value is not equivalent
         * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
         * for equality comparisons.
         *
         * @private
         * @param {Object} object The object to modify.
         * @param {string} key The key of the property to assign.
         * @param {*} value The value to assign.
         */


        function assignValue(object, key, value) {
          var objValue = object[key];

          if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined$1 && !(key in object)) {
            baseAssignValue(object, key, value);
          }
        }
        /**
         * Gets the index at which the `key` is found in `array` of key-value pairs.
         *
         * @private
         * @param {Array} array The array to inspect.
         * @param {*} key The key to search for.
         * @returns {number} Returns the index of the matched value, else `-1`.
         */


        function assocIndexOf(array, key) {
          var length = array.length;

          while (length--) {
            if (eq(array[length][0], key)) {
              return length;
            }
          }

          return -1;
        }
        /**
         * Aggregates elements of `collection` on `accumulator` with keys transformed
         * by `iteratee` and values set by `setter`.
         *
         * @private
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} setter The function to set `accumulator` values.
         * @param {Function} iteratee The iteratee to transform keys.
         * @param {Object} accumulator The initial aggregated object.
         * @returns {Function} Returns `accumulator`.
         */


        function baseAggregator(collection, setter, iteratee, accumulator) {
          baseEach(collection, function (value, key, collection) {
            setter(accumulator, value, iteratee(value), collection);
          });
          return accumulator;
        }
        /**
         * The base implementation of `_.assign` without support for multiple sources
         * or `customizer` functions.
         *
         * @private
         * @param {Object} object The destination object.
         * @param {Object} source The source object.
         * @returns {Object} Returns `object`.
         */


        function baseAssign(object, source) {
          return object && copyObject(source, keys(source), object);
        }
        /**
         * The base implementation of `_.assignIn` without support for multiple sources
         * or `customizer` functions.
         *
         * @private
         * @param {Object} object The destination object.
         * @param {Object} source The source object.
         * @returns {Object} Returns `object`.
         */


        function baseAssignIn(object, source) {
          return object && copyObject(source, keysIn(source), object);
        }
        /**
         * The base implementation of `assignValue` and `assignMergeValue` without
         * value checks.
         *
         * @private
         * @param {Object} object The object to modify.
         * @param {string} key The key of the property to assign.
         * @param {*} value The value to assign.
         */


        function baseAssignValue(object, key, value) {
          if (key == '__proto__' && defineProperty) {
            defineProperty(object, key, {
              'configurable': true,
              'enumerable': true,
              'value': value,
              'writable': true
            });
          } else {
            object[key] = value;
          }
        }
        /**
         * The base implementation of `_.at` without support for individual paths.
         *
         * @private
         * @param {Object} object The object to iterate over.
         * @param {string[]} paths The property paths to pick.
         * @returns {Array} Returns the picked elements.
         */


        function baseAt(object, paths) {
          var index = -1,
              length = paths.length,
              result = Array(length),
              skip = object == null;

          while (++index < length) {
            result[index] = skip ? undefined$1 : get(object, paths[index]);
          }

          return result;
        }
        /**
         * The base implementation of `_.clamp` which doesn't coerce arguments.
         *
         * @private
         * @param {number} number The number to clamp.
         * @param {number} [lower] The lower bound.
         * @param {number} upper The upper bound.
         * @returns {number} Returns the clamped number.
         */


        function baseClamp(number, lower, upper) {
          if (number === number) {
            if (upper !== undefined$1) {
              number = number <= upper ? number : upper;
            }

            if (lower !== undefined$1) {
              number = number >= lower ? number : lower;
            }
          }

          return number;
        }
        /**
         * The base implementation of `_.clone` and `_.cloneDeep` which tracks
         * traversed objects.
         *
         * @private
         * @param {*} value The value to clone.
         * @param {boolean} bitmask The bitmask flags.
         *  1 - Deep clone
         *  2 - Flatten inherited properties
         *  4 - Clone symbols
         * @param {Function} [customizer] The function to customize cloning.
         * @param {string} [key] The key of `value`.
         * @param {Object} [object] The parent object of `value`.
         * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
         * @returns {*} Returns the cloned value.
         */


        function baseClone(value, bitmask, customizer, key, object, stack) {
          var result,
              isDeep = bitmask & CLONE_DEEP_FLAG,
              isFlat = bitmask & CLONE_FLAT_FLAG,
              isFull = bitmask & CLONE_SYMBOLS_FLAG;

          if (customizer) {
            result = object ? customizer(value, key, object, stack) : customizer(value);
          }

          if (result !== undefined$1) {
            return result;
          }

          if (!isObject(value)) {
            return value;
          }

          var isArr = isArray(value);

          if (isArr) {
            result = initCloneArray(value);

            if (!isDeep) {
              return copyArray(value, result);
            }
          } else {
            var tag = getTag(value),
                isFunc = tag == funcTag || tag == genTag;

            if (isBuffer(value)) {
              return cloneBuffer(value, isDeep);
            }

            if (tag == objectTag || tag == argsTag || isFunc && !object) {
              result = isFlat || isFunc ? {} : initCloneObject(value);

              if (!isDeep) {
                return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
              }
            } else {
              if (!cloneableTags[tag]) {
                return object ? value : {};
              }

              result = initCloneByTag(value, tag, isDeep);
            }
          } // Check for circular references and return its corresponding clone.


          stack || (stack = new Stack());
          var stacked = stack.get(value);

          if (stacked) {
            return stacked;
          }

          stack.set(value, result);

          if (isSet(value)) {
            value.forEach(function (subValue) {
              result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
          } else if (isMap(value)) {
            value.forEach(function (subValue, key) {
              result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
          }

          var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
          var props = isArr ? undefined$1 : keysFunc(value);
          arrayEach(props || value, function (subValue, key) {
            if (props) {
              key = subValue;
              subValue = value[key];
            } // Recursively populate clone (susceptible to call stack limits).


            assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
          });
          return result;
        }
        /**
         * The base implementation of `_.conforms` which doesn't clone `source`.
         *
         * @private
         * @param {Object} source The object of property predicates to conform to.
         * @returns {Function} Returns the new spec function.
         */


        function baseConforms(source) {
          var props = keys(source);
          return function (object) {
            return baseConformsTo(object, source, props);
          };
        }
        /**
         * The base implementation of `_.conformsTo` which accepts `props` to check.
         *
         * @private
         * @param {Object} object The object to inspect.
         * @param {Object} source The object of property predicates to conform to.
         * @returns {boolean} Returns `true` if `object` conforms, else `false`.
         */


        function baseConformsTo(object, source, props) {
          var length = props.length;

          if (object == null) {
            return !length;
          }

          object = Object(object);

          while (length--) {
            var key = props[length],
                predicate = source[key],
                value = object[key];

            if (value === undefined$1 && !(key in object) || !predicate(value)) {
              return false;
            }
          }

          return true;
        }
        /**
         * The base implementation of `_.delay` and `_.defer` which accepts `args`
         * to provide to `func`.
         *
         * @private
         * @param {Function} func The function to delay.
         * @param {number} wait The number of milliseconds to delay invocation.
         * @param {Array} args The arguments to provide to `func`.
         * @returns {number|Object} Returns the timer id or timeout object.
         */


        function baseDelay(func, wait, args) {
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }

          return setTimeout(function () {
            func.apply(undefined$1, args);
          }, wait);
        }
        /**
         * The base implementation of methods like `_.difference` without support
         * for excluding multiple arrays or iteratee shorthands.
         *
         * @private
         * @param {Array} array The array to inspect.
         * @param {Array} values The values to exclude.
         * @param {Function} [iteratee] The iteratee invoked per element.
         * @param {Function} [comparator] The comparator invoked per element.
         * @returns {Array} Returns the new array of filtered values.
         */


        function baseDifference(array, values, iteratee, comparator) {
          var index = -1,
              includes = arrayIncludes,
              isCommon = true,
              length = array.length,
              result = [],
              valuesLength = values.length;

          if (!length) {
            return result;
          }

          if (iteratee) {
            values = arrayMap(values, baseUnary(iteratee));
          }

          if (comparator) {
            includes = arrayIncludesWith;
            isCommon = false;
          } else if (values.length >= LARGE_ARRAY_SIZE) {
            includes = cacheHas;
            isCommon = false;
            values = new SetCache(values);
          }

          outer: while (++index < length) {
            var value = array[index],
                computed = iteratee == null ? value : iteratee(value);
            value = comparator || value !== 0 ? value : 0;

            if (isCommon && computed === computed) {
              var valuesIndex = valuesLength;

              while (valuesIndex--) {
                if (values[valuesIndex] === computed) {
                  continue outer;
                }
              }

              result.push(value);
            } else if (!includes(values, computed, comparator)) {
              result.push(value);
            }
          }

          return result;
        }
        /**
         * The base implementation of `_.forEach` without support for iteratee shorthands.
         *
         * @private
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} iteratee The function invoked per iteration.
         * @returns {Array|Object} Returns `collection`.
         */


        var baseEach = createBaseEach(baseForOwn);
        /**
         * The base implementation of `_.forEachRight` without support for iteratee shorthands.
         *
         * @private
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} iteratee The function invoked per iteration.
         * @returns {Array|Object} Returns `collection`.
         */

        var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
         * The base implementation of `_.every` without support for iteratee shorthands.
         *
         * @private
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} predicate The function invoked per iteration.
         * @returns {boolean} Returns `true` if all elements pass the predicate check,
         *  else `false`
         */

        function baseEvery(collection, predicate) {
          var result = true;
          baseEach(collection, function (value, index, collection) {
            result = !!predicate(value, index, collection);
            return result;
          });
          return result;
        }
        /**
         * The base implementation of methods like `_.max` and `_.min` which accepts a
         * `comparator` to determine the extremum value.
         *
         * @private
         * @param {Array} array The array to iterate over.
         * @param {Function} iteratee The iteratee invoked per iteration.
         * @param {Function} comparator The comparator used to compare values.
         * @returns {*} Returns the extremum value.
         */


        function baseExtremum(array, iteratee, comparator) {
          var index = -1,
              length = array.length;

          while (++index < length) {
            var value = array[index],
                current = iteratee(value);

            if (current != null && (computed === undefined$1 ? current === current && !isSymbol(current) : comparator(current, computed))) {
              var computed = current,
                  result = value;
            }
          }

          return result;
        }
        /**
         * The base implementation of `_.fill` without an iteratee call guard.
         *
         * @private
         * @param {Array} array The array to fill.
         * @param {*} value The value to fill `array` with.
         * @param {number} [start=0] The start position.
         * @param {number} [end=array.length] The end position.
         * @returns {Array} Returns `array`.
         */


        function baseFill(array, value, start, end) {
          var length = array.length;
          start = toInteger(start);

          if (start < 0) {
            start = -start > length ? 0 : length + start;
          }

          end = end === undefined$1 || end > length ? length : toInteger(end);

          if (end < 0) {
            end += length;
          }

          end = start > end ? 0 : toLength(end);

          while (start < end) {
            array[start++] = value;
          }

          return array;
        }
        /**
         * The base implementation of `_.filter` without support for iteratee shorthands.
         *
         * @private
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} predicate The function invoked per iteration.
         * @returns {Array} Returns the new filtered array.
         */


        function baseFilter(collection, predicate) {
          var result = [];
          baseEach(collection, function (value, index, collection) {
            if (predicate(value, index, collection)) {
              result.push(value);
            }
          });
          return result;
        }
        /**
         * The base implementation of `_.flatten` with support for restricting flattening.
         *
         * @private
         * @param {Array} array The array to flatten.
         * @param {number} depth The maximum recursion depth.
         * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
         * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
         * @param {Array} [result=[]] The initial result value.
         * @returns {Array} Returns the new flattened array.
         */


        function baseFlatten(array, depth, predicate, isStrict, result) {
          var index = -1,
              length = array.length;
          predicate || (predicate = isFlattenable);
          result || (result = []);

          while (++index < length) {
            var value = array[index];

            if (depth > 0 && predicate(value)) {
              if (depth > 1) {
                // Recursively flatten arrays (susceptible to call stack limits).
                baseFlatten(value, depth - 1, predicate, isStrict, result);
              } else {
                arrayPush(result, value);
              }
            } else if (!isStrict) {
              result[result.length] = value;
            }
          }

          return result;
        }
        /**
         * The base implementation of `baseForOwn` which iterates over `object`
         * properties returned by `keysFunc` and invokes `iteratee` for each property.
         * Iteratee functions may exit iteration early by explicitly returning `false`.
         *
         * @private
         * @param {Object} object The object to iterate over.
         * @param {Function} iteratee The function invoked per iteration.
         * @param {Function} keysFunc The function to get the keys of `object`.
         * @returns {Object} Returns `object`.
         */


        var baseFor = createBaseFor();
        /**
         * This function is like `baseFor` except that it iterates over properties
         * in the opposite order.
         *
         * @private
         * @param {Object} object The object to iterate over.
         * @param {Function} iteratee The function invoked per iteration.
         * @param {Function} keysFunc The function to get the keys of `object`.
         * @returns {Object} Returns `object`.
         */

        var baseForRight = createBaseFor(true);
        /**
         * The base implementation of `_.forOwn` without support for iteratee shorthands.
         *
         * @private
         * @param {Object} object The object to iterate over.
         * @param {Function} iteratee The function invoked per iteration.
         * @returns {Object} Returns `object`.
         */

        function baseForOwn(object, iteratee) {
          return object && baseFor(object, iteratee, keys);
        }
        /**
         * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
         *
         * @private
         * @param {Object} object The object to iterate over.
         * @param {Function} iteratee The function invoked per iteration.
         * @returns {Object} Returns `object`.
         */


        function baseForOwnRight(object, iteratee) {
          return object && baseForRight(object, iteratee, keys);
        }
        /**
         * The base implementation of `_.functions` which creates an array of
         * `object` function property names filtered from `props`.
         *
         * @private
         * @param {Object} object The object to inspect.
         * @param {Array} props The property names to filter.
         * @returns {Array} Returns the function names.
         */


        function baseFunctions(object, props) {
          return arrayFilter(props, function (key) {
            return isFunction(object[key]);
          });
        }
        /**
         * The base implementation of `_.get` without support for default values.
         *
         * @private
         * @param {Object} object The object to query.
         * @param {Array|string} path The path of the property to get.
         * @returns {*} Returns the resolved value.
         */


        function baseGet(object, path) {
          path = castPath(path, object);
          var index = 0,
              length = path.length;

          while (object != null && index < length) {
            object = object[toKey(path[index++])];
          }

          return index && index == length ? object : undefined$1;
        }
        /**
         * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
         * `keysFunc` and `symbolsFunc` to get the enumerable property names and
         * symbols of `object`.
         *
         * @private
         * @param {Object} object The object to query.
         * @param {Function} keysFunc The function to get the keys of `object`.
         * @param {Function} symbolsFunc The function to get the symbols of `object`.
         * @returns {Array} Returns the array of property names and symbols.
         */


        function baseGetAllKeys(object, keysFunc, symbolsFunc) {
          var result = keysFunc(object);
          return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
         * The base implementation of `getTag` without fallbacks for buggy environments.
         *
         * @private
         * @param {*} value The value to query.
         * @returns {string} Returns the `toStringTag`.
         */


        function baseGetTag(value) {
          if (value == null) {
            return value === undefined$1 ? undefinedTag : nullTag;
          }

          return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
        }
        /**
         * The base implementation of `_.gt` which doesn't coerce arguments.
         *
         * @private
         * @param {*} value The value to compare.
         * @param {*} other The other value to compare.
         * @returns {boolean} Returns `true` if `value` is greater than `other`,
         *  else `false`.
         */


        function baseGt(value, other) {
          return value > other;
        }
        /**
         * The base implementation of `_.has` without support for deep paths.
         *
         * @private
         * @param {Object} [object] The object to query.
         * @param {Array|string} key The key to check.
         * @returns {boolean} Returns `true` if `key` exists, else `false`.
         */


        function baseHas(object, key) {
          return object != null && hasOwnProperty.call(object, key);
        }
        /**
         * The base implementation of `_.hasIn` without support for deep paths.
         *
         * @private
         * @param {Object} [object] The object to query.
         * @param {Array|string} key The key to check.
         * @returns {boolean} Returns `true` if `key` exists, else `false`.
         */


        function baseHasIn(object, key) {
          return object != null && key in Object(object);
        }
        /**
         * The base implementation of `_.inRange` which doesn't coerce arguments.
         *
         * @private
         * @param {number} number The number to check.
         * @param {number} start The start of the range.
         * @param {number} end The end of the range.
         * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
         */


        function baseInRange(number, start, end) {
          return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
         * The base implementation of methods like `_.intersection`, without support
         * for iteratee shorthands, that accepts an array of arrays to inspect.
         *
         * @private
         * @param {Array} arrays The arrays to inspect.
         * @param {Function} [iteratee] The iteratee invoked per element.
         * @param {Function} [comparator] The comparator invoked per element.
         * @returns {Array} Returns the new array of shared values.
         */


        function baseIntersection(arrays, iteratee, comparator) {
          var includes = comparator ? arrayIncludesWith : arrayIncludes,
              length = arrays[0].length,
              othLength = arrays.length,
              othIndex = othLength,
              caches = Array(othLength),
              maxLength = Infinity,
              result = [];

          while (othIndex--) {
            var array = arrays[othIndex];

            if (othIndex && iteratee) {
              array = arrayMap(array, baseUnary(iteratee));
            }

            maxLength = nativeMin(array.length, maxLength);
            caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined$1;
          }

          array = arrays[0];
          var index = -1,
              seen = caches[0];

          outer: while (++index < length && result.length < maxLength) {
            var value = array[index],
                computed = iteratee ? iteratee(value) : value;
            value = comparator || value !== 0 ? value : 0;

            if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
              othIndex = othLength;

              while (--othIndex) {
                var cache = caches[othIndex];

                if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) {
                  continue outer;
                }
              }

              if (seen) {
                seen.push(computed);
              }

              result.push(value);
            }
          }

          return result;
        }
        /**
         * The base implementation of `_.invert` and `_.invertBy` which inverts
         * `object` with values transformed by `iteratee` and set by `setter`.
         *
         * @private
         * @param {Object} object The object to iterate over.
         * @param {Function} setter The function to set `accumulator` values.
         * @param {Function} iteratee The iteratee to transform values.
         * @param {Object} accumulator The initial inverted object.
         * @returns {Function} Returns `accumulator`.
         */


        function baseInverter(object, setter, iteratee, accumulator) {
          baseForOwn(object, function (value, key, object) {
            setter(accumulator, iteratee(value), key, object);
          });
          return accumulator;
        }
        /**
         * The base implementation of `_.invoke` without support for individual
         * method arguments.
         *
         * @private
         * @param {Object} object The object to query.
         * @param {Array|string} path The path of the method to invoke.
         * @param {Array} args The arguments to invoke the method with.
         * @returns {*} Returns the result of the invoked method.
         */


        function baseInvoke(object, path, args) {
          path = castPath(path, object);
          object = parent(object, path);
          var func = object == null ? object : object[toKey(last(path))];
          return func == null ? undefined$1 : apply(func, object, args);
        }
        /**
         * The base implementation of `_.isArguments`.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is an `arguments` object,
         */


        function baseIsArguments(value) {
          return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
         * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
         */


        function baseIsArrayBuffer(value) {
          return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
         * The base implementation of `_.isDate` without Node.js optimizations.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
         */


        function baseIsDate(value) {
          return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
         * The base implementation of `_.isEqual` which supports partial comparisons
         * and tracks traversed objects.
         *
         * @private
         * @param {*} value The value to compare.
         * @param {*} other The other value to compare.
         * @param {boolean} bitmask The bitmask flags.
         *  1 - Unordered comparison
         *  2 - Partial comparison
         * @param {Function} [customizer] The function to customize comparisons.
         * @param {Object} [stack] Tracks traversed `value` and `other` objects.
         * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
         */


        function baseIsEqual(value, other, bitmask, customizer, stack) {
          if (value === other) {
            return true;
          }

          if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
            return value !== value && other !== other;
          }

          return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
         * A specialized version of `baseIsEqual` for arrays and objects which performs
         * deep comparisons and tracks traversed objects enabling objects with circular
         * references to be compared.
         *
         * @private
         * @param {Object} object The object to compare.
         * @param {Object} other The other object to compare.
         * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
         * @param {Function} customizer The function to customize comparisons.
         * @param {Function} equalFunc The function to determine equivalents of values.
         * @param {Object} [stack] Tracks traversed `object` and `other` objects.
         * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
         */


        function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
          var objIsArr = isArray(object),
              othIsArr = isArray(other),
              objTag = objIsArr ? arrayTag : getTag(object),
              othTag = othIsArr ? arrayTag : getTag(other);
          objTag = objTag == argsTag ? objectTag : objTag;
          othTag = othTag == argsTag ? objectTag : othTag;
          var objIsObj = objTag == objectTag,
              othIsObj = othTag == objectTag,
              isSameTag = objTag == othTag;

          if (isSameTag && isBuffer(object)) {
            if (!isBuffer(other)) {
              return false;
            }

            objIsArr = true;
            objIsObj = false;
          }

          if (isSameTag && !objIsObj) {
            stack || (stack = new Stack());
            return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
          }

          if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
            var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
                othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

            if (objIsWrapped || othIsWrapped) {
              var objUnwrapped = objIsWrapped ? object.value() : object,
                  othUnwrapped = othIsWrapped ? other.value() : other;
              stack || (stack = new Stack());
              return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
            }
          }

          if (!isSameTag) {
            return false;
          }

          stack || (stack = new Stack());
          return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
         * The base implementation of `_.isMap` without Node.js optimizations.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a map, else `false`.
         */


        function baseIsMap(value) {
          return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
         * The base implementation of `_.isMatch` without support for iteratee shorthands.
         *
         * @private
         * @param {Object} object The object to inspect.
         * @param {Object} source The object of property values to match.
         * @param {Array} matchData The property names, values, and compare flags to match.
         * @param {Function} [customizer] The function to customize comparisons.
         * @returns {boolean} Returns `true` if `object` is a match, else `false`.
         */


        function baseIsMatch(object, source, matchData, customizer) {
          var index = matchData.length,
              length = index,
              noCustomizer = !customizer;

          if (object == null) {
            return !length;
          }

          object = Object(object);

          while (index--) {
            var data = matchData[index];

            if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
              return false;
            }
          }

          while (++index < length) {
            data = matchData[index];
            var key = data[0],
                objValue = object[key],
                srcValue = data[1];

            if (noCustomizer && data[2]) {
              if (objValue === undefined$1 && !(key in object)) {
                return false;
              }
            } else {
              var stack = new Stack();

              if (customizer) {
                var result = customizer(objValue, srcValue, key, object, source, stack);
              }

              if (!(result === undefined$1 ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) {
                return false;
              }
            }
          }

          return true;
        }
        /**
         * The base implementation of `_.isNative` without bad shim checks.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a native function,
         *  else `false`.
         */


        function baseIsNative(value) {
          if (!isObject(value) || isMasked(value)) {
            return false;
          }

          var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
          return pattern.test(toSource(value));
        }
        /**
         * The base implementation of `_.isRegExp` without Node.js optimizations.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
         */


        function baseIsRegExp(value) {
          return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
         * The base implementation of `_.isSet` without Node.js optimizations.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a set, else `false`.
         */


        function baseIsSet(value) {
          return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
         * The base implementation of `_.isTypedArray` without Node.js optimizations.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
         */


        function baseIsTypedArray(value) {
          return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
         * The base implementation of `_.iteratee`.
         *
         * @private
         * @param {*} [value=_.identity] The value to convert to an iteratee.
         * @returns {Function} Returns the iteratee.
         */


        function baseIteratee(value) {
          // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
          // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
          if (typeof value == 'function') {
            return value;
          }

          if (value == null) {
            return identity;
          }

          if (typeof value == 'object') {
            return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
          }

          return property(value);
        }
        /**
         * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
         *
         * @private
         * @param {Object} object The object to query.
         * @returns {Array} Returns the array of property names.
         */


        function baseKeys(object) {
          if (!isPrototype(object)) {
            return nativeKeys(object);
          }

          var result = [];

          for (var key in Object(object)) {
            if (hasOwnProperty.call(object, key) && key != 'constructor') {
              result.push(key);
            }
          }

          return result;
        }
        /**
         * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
         *
         * @private
         * @param {Object} object The object to query.
         * @returns {Array} Returns the array of property names.
         */


        function baseKeysIn(object) {
          if (!isObject(object)) {
            return nativeKeysIn(object);
          }

          var isProto = isPrototype(object),
              result = [];

          for (var key in object) {
            if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
              result.push(key);
            }
          }

          return result;
        }
        /**
         * The base implementation of `_.lt` which doesn't coerce arguments.
         *
         * @private
         * @param {*} value The value to compare.
         * @param {*} other The other value to compare.
         * @returns {boolean} Returns `true` if `value` is less than `other`,
         *  else `false`.
         */


        function baseLt(value, other) {
          return value < other;
        }
        /**
         * The base implementation of `_.map` without support for iteratee shorthands.
         *
         * @private
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} iteratee The function invoked per iteration.
         * @returns {Array} Returns the new mapped array.
         */


        function baseMap(collection, iteratee) {
          var index = -1,
              result = isArrayLike(collection) ? Array(collection.length) : [];
          baseEach(collection, function (value, key, collection) {
            result[++index] = iteratee(value, key, collection);
          });
          return result;
        }
        /**
         * The base implementation of `_.matches` which doesn't clone `source`.
         *
         * @private
         * @param {Object} source The object of property values to match.
         * @returns {Function} Returns the new spec function.
         */


        function baseMatches(source) {
          var matchData = getMatchData(source);

          if (matchData.length == 1 && matchData[0][2]) {
            return matchesStrictComparable(matchData[0][0], matchData[0][1]);
          }

          return function (object) {
            return object === source || baseIsMatch(object, source, matchData);
          };
        }
        /**
         * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
         *
         * @private
         * @param {string} path The path of the property to get.
         * @param {*} srcValue The value to match.
         * @returns {Function} Returns the new spec function.
         */


        function baseMatchesProperty(path, srcValue) {
          if (isKey(path) && isStrictComparable(srcValue)) {
            return matchesStrictComparable(toKey(path), srcValue);
          }

          return function (object) {
            var objValue = get(object, path);
            return objValue === undefined$1 && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
          };
        }
        /**
         * The base implementation of `_.merge` without support for multiple sources.
         *
         * @private
         * @param {Object} object The destination object.
         * @param {Object} source The source object.
         * @param {number} srcIndex The index of `source`.
         * @param {Function} [customizer] The function to customize merged values.
         * @param {Object} [stack] Tracks traversed source values and their merged
         *  counterparts.
         */


        function baseMerge(object, source, srcIndex, customizer, stack) {
          if (object === source) {
            return;
          }

          baseFor(source, function (srcValue, key) {
            stack || (stack = new Stack());

            if (isObject(srcValue)) {
              baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
            } else {
              var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined$1;

              if (newValue === undefined$1) {
                newValue = srcValue;
              }

              assignMergeValue(object, key, newValue);
            }
          }, keysIn);
        }
        /**
         * A specialized version of `baseMerge` for arrays and objects which performs
         * deep merges and tracks traversed objects enabling objects with circular
         * references to be merged.
         *
         * @private
         * @param {Object} object The destination object.
         * @param {Object} source The source object.
         * @param {string} key The key of the value to merge.
         * @param {number} srcIndex The index of `source`.
         * @param {Function} mergeFunc The function to merge values.
         * @param {Function} [customizer] The function to customize assigned values.
         * @param {Object} [stack] Tracks traversed source values and their merged
         *  counterparts.
         */


        function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
          var objValue = safeGet(object, key),
              srcValue = safeGet(source, key),
              stacked = stack.get(srcValue);

          if (stacked) {
            assignMergeValue(object, key, stacked);
            return;
          }

          var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined$1;
          var isCommon = newValue === undefined$1;

          if (isCommon) {
            var isArr = isArray(srcValue),
                isBuff = !isArr && isBuffer(srcValue),
                isTyped = !isArr && !isBuff && isTypedArray(srcValue);
            newValue = srcValue;

            if (isArr || isBuff || isTyped) {
              if (isArray(objValue)) {
                newValue = objValue;
              } else if (isArrayLikeObject(objValue)) {
                newValue = copyArray(objValue);
              } else if (isBuff) {
                isCommon = false;
                newValue = cloneBuffer(srcValue, true);
              } else if (isTyped) {
                isCommon = false;
                newValue = cloneTypedArray(srcValue, true);
              } else {
                newValue = [];
              }
            } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
              newValue = objValue;

              if (isArguments(objValue)) {
                newValue = toPlainObject(objValue);
              } else if (!isObject(objValue) || isFunction(objValue)) {
                newValue = initCloneObject(srcValue);
              }
            } else {
              isCommon = false;
            }
          }

          if (isCommon) {
            // Recursively merge objects and arrays (susceptible to call stack limits).
            stack.set(srcValue, newValue);
            mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
            stack['delete'](srcValue);
          }

          assignMergeValue(object, key, newValue);
        }
        /**
         * The base implementation of `_.nth` which doesn't coerce arguments.
         *
         * @private
         * @param {Array} array The array to query.
         * @param {number} n The index of the element to return.
         * @returns {*} Returns the nth element of `array`.
         */


        function baseNth(array, n) {
          var length = array.length;

          if (!length) {
            return;
          }

          n += n < 0 ? length : 0;
          return isIndex(n, length) ? array[n] : undefined$1;
        }
        /**
         * The base implementation of `_.orderBy` without param guards.
         *
         * @private
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
         * @param {string[]} orders The sort orders of `iteratees`.
         * @returns {Array} Returns the new sorted array.
         */


        function baseOrderBy(collection, iteratees, orders) {
          if (iteratees.length) {
            iteratees = arrayMap(iteratees, function (iteratee) {
              if (isArray(iteratee)) {
                return function (value) {
                  return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
              }

              return iteratee;
            });
          } else {
            iteratees = [identity];
          }

          var index = -1;
          iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
          var result = baseMap(collection, function (value, key, collection) {
            var criteria = arrayMap(iteratees, function (iteratee) {
              return iteratee(value);
            });
            return {
              'criteria': criteria,
              'index': ++index,
              'value': value
            };
          });
          return baseSortBy(result, function (object, other) {
            return compareMultiple(object, other, orders);
          });
        }
        /**
         * The base implementation of `_.pick` without support for individual
         * property identifiers.
         *
         * @private
         * @param {Object} object The source object.
         * @param {string[]} paths The property paths to pick.
         * @returns {Object} Returns the new object.
         */


        function basePick(object, paths) {
          return basePickBy(object, paths, function (value, path) {
            return hasIn(object, path);
          });
        }
        /**
         * The base implementation of  `_.pickBy` without support for iteratee shorthands.
         *
         * @private
         * @param {Object} object The source object.
         * @param {string[]} paths The property paths to pick.
         * @param {Function} predicate The function invoked per property.
         * @returns {Object} Returns the new object.
         */


        function basePickBy(object, paths, predicate) {
          var index = -1,
              length = paths.length,
              result = {};

          while (++index < length) {
            var path = paths[index],
                value = baseGet(object, path);

            if (predicate(value, path)) {
              baseSet(result, castPath(path, object), value);
            }
          }

          return result;
        }
        /**
         * A specialized version of `baseProperty` which supports deep paths.
         *
         * @private
         * @param {Array|string} path The path of the property to get.
         * @returns {Function} Returns the new accessor function.
         */


        function basePropertyDeep(path) {
          return function (object) {
            return baseGet(object, path);
          };
        }
        /**
         * The base implementation of `_.pullAllBy` without support for iteratee
         * shorthands.
         *
         * @private
         * @param {Array} array The array to modify.
         * @param {Array} values The values to remove.
         * @param {Function} [iteratee] The iteratee invoked per element.
         * @param {Function} [comparator] The comparator invoked per element.
         * @returns {Array} Returns `array`.
         */


        function basePullAll(array, values, iteratee, comparator) {
          var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
              index = -1,
              length = values.length,
              seen = array;

          if (array === values) {
            values = copyArray(values);
          }

          if (iteratee) {
            seen = arrayMap(array, baseUnary(iteratee));
          }

          while (++index < length) {
            var fromIndex = 0,
                value = values[index],
                computed = iteratee ? iteratee(value) : value;

            while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
              if (seen !== array) {
                splice.call(seen, fromIndex, 1);
              }

              splice.call(array, fromIndex, 1);
            }
          }

          return array;
        }
        /**
         * The base implementation of `_.pullAt` without support for individual
         * indexes or capturing the removed elements.
         *
         * @private
         * @param {Array} array The array to modify.
         * @param {number[]} indexes The indexes of elements to remove.
         * @returns {Array} Returns `array`.
         */


        function basePullAt(array, indexes) {
          var length = array ? indexes.length : 0,
              lastIndex = length - 1;

          while (length--) {
            var index = indexes[length];

            if (length == lastIndex || index !== previous) {
              var previous = index;

              if (isIndex(index)) {
                splice.call(array, index, 1);
              } else {
                baseUnset(array, index);
              }
            }
          }

          return array;
        }
        /**
         * The base implementation of `_.random` without support for returning
         * floating-point numbers.
         *
         * @private
         * @param {number} lower The lower bound.
         * @param {number} upper The upper bound.
         * @returns {number} Returns the random number.
         */


        function baseRandom(lower, upper) {
          return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
         * The base implementation of `_.range` and `_.rangeRight` which doesn't
         * coerce arguments.
         *
         * @private
         * @param {number} start The start of the range.
         * @param {number} end The end of the range.
         * @param {number} step The value to increment or decrement by.
         * @param {boolean} [fromRight] Specify iterating from right to left.
         * @returns {Array} Returns the range of numbers.
         */


        function baseRange(start, end, step, fromRight) {
          var index = -1,
              length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
              result = Array(length);

          while (length--) {
            result[fromRight ? length : ++index] = start;
            start += step;
          }

          return result;
        }
        /**
         * The base implementation of `_.repeat` which doesn't coerce arguments.
         *
         * @private
         * @param {string} string The string to repeat.
         * @param {number} n The number of times to repeat the string.
         * @returns {string} Returns the repeated string.
         */


        function baseRepeat(string, n) {
          var result = '';

          if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
            return result;
          } // Leverage the exponentiation by squaring algorithm for a faster repeat.
          // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.


          do {
            if (n % 2) {
              result += string;
            }

            n = nativeFloor(n / 2);

            if (n) {
              string += string;
            }
          } while (n);

          return result;
        }
        /**
         * The base implementation of `_.rest` which doesn't validate or coerce arguments.
         *
         * @private
         * @param {Function} func The function to apply a rest parameter to.
         * @param {number} [start=func.length-1] The start position of the rest parameter.
         * @returns {Function} Returns the new function.
         */


        function baseRest(func, start) {
          return setToString(overRest(func, start, identity), func + '');
        }
        /**
         * The base implementation of `_.sample`.
         *
         * @private
         * @param {Array|Object} collection The collection to sample.
         * @returns {*} Returns the random element.
         */


        function baseSample(collection) {
          return arraySample(values(collection));
        }
        /**
         * The base implementation of `_.sampleSize` without param guards.
         *
         * @private
         * @param {Array|Object} collection The collection to sample.
         * @param {number} n The number of elements to sample.
         * @returns {Array} Returns the random elements.
         */


        function baseSampleSize(collection, n) {
          var array = values(collection);
          return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
         * The base implementation of `_.set`.
         *
         * @private
         * @param {Object} object The object to modify.
         * @param {Array|string} path The path of the property to set.
         * @param {*} value The value to set.
         * @param {Function} [customizer] The function to customize path creation.
         * @returns {Object} Returns `object`.
         */


        function baseSet(object, path, value, customizer) {
          if (!isObject(object)) {
            return object;
          }

          path = castPath(path, object);
          var index = -1,
              length = path.length,
              lastIndex = length - 1,
              nested = object;

          while (nested != null && ++index < length) {
            var key = toKey(path[index]),
                newValue = value;

            if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
              return object;
            }

            if (index != lastIndex) {
              var objValue = nested[key];
              newValue = customizer ? customizer(objValue, key, nested) : undefined$1;

              if (newValue === undefined$1) {
                newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
              }
            }

            assignValue(nested, key, newValue);
            nested = nested[key];
          }

          return object;
        }
        /**
         * The base implementation of `setData` without support for hot loop shorting.
         *
         * @private
         * @param {Function} func The function to associate metadata with.
         * @param {*} data The metadata.
         * @returns {Function} Returns `func`.
         */


        var baseSetData = !metaMap ? identity : function (func, data) {
          metaMap.set(func, data);
          return func;
        };
        /**
         * The base implementation of `setToString` without support for hot loop shorting.
         *
         * @private
         * @param {Function} func The function to modify.
         * @param {Function} string The `toString` result.
         * @returns {Function} Returns `func`.
         */

        var baseSetToString = !defineProperty ? identity : function (func, string) {
          return defineProperty(func, 'toString', {
            'configurable': true,
            'enumerable': false,
            'value': constant(string),
            'writable': true
          });
        };
        /**
         * The base implementation of `_.shuffle`.
         *
         * @private
         * @param {Array|Object} collection The collection to shuffle.
         * @returns {Array} Returns the new shuffled array.
         */

        function baseShuffle(collection) {
          return shuffleSelf(values(collection));
        }
        /**
         * The base implementation of `_.slice` without an iteratee call guard.
         *
         * @private
         * @param {Array} array The array to slice.
         * @param {number} [start=0] The start position.
         * @param {number} [end=array.length] The end position.
         * @returns {Array} Returns the slice of `array`.
         */


        function baseSlice(array, start, end) {
          var index = -1,
              length = array.length;

          if (start < 0) {
            start = -start > length ? 0 : length + start;
          }

          end = end > length ? length : end;

          if (end < 0) {
            end += length;
          }

          length = start > end ? 0 : end - start >>> 0;
          start >>>= 0;
          var result = Array(length);

          while (++index < length) {
            result[index] = array[index + start];
          }

          return result;
        }
        /**
         * The base implementation of `_.some` without support for iteratee shorthands.
         *
         * @private
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} predicate The function invoked per iteration.
         * @returns {boolean} Returns `true` if any element passes the predicate check,
         *  else `false`.
         */


        function baseSome(collection, predicate) {
          var result;
          baseEach(collection, function (value, index, collection) {
            result = predicate(value, index, collection);
            return !result;
          });
          return !!result;
        }
        /**
         * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
         * performs a binary search of `array` to determine the index at which `value`
         * should be inserted into `array` in order to maintain its sort order.
         *
         * @private
         * @param {Array} array The sorted array to inspect.
         * @param {*} value The value to evaluate.
         * @param {boolean} [retHighest] Specify returning the highest qualified index.
         * @returns {number} Returns the index at which `value` should be inserted
         *  into `array`.
         */


        function baseSortedIndex(array, value, retHighest) {
          var low = 0,
              high = array == null ? low : array.length;

          if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
            while (low < high) {
              var mid = low + high >>> 1,
                  computed = array[mid];

              if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) {
                low = mid + 1;
              } else {
                high = mid;
              }
            }

            return high;
          }

          return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
         * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
         * which invokes `iteratee` for `value` and each element of `array` to compute
         * their sort ranking. The iteratee is invoked with one argument; (value).
         *
         * @private
         * @param {Array} array The sorted array to inspect.
         * @param {*} value The value to evaluate.
         * @param {Function} iteratee The iteratee invoked per element.
         * @param {boolean} [retHighest] Specify returning the highest qualified index.
         * @returns {number} Returns the index at which `value` should be inserted
         *  into `array`.
         */


        function baseSortedIndexBy(array, value, iteratee, retHighest) {
          var low = 0,
              high = array == null ? 0 : array.length;

          if (high === 0) {
            return 0;
          }

          value = iteratee(value);
          var valIsNaN = value !== value,
              valIsNull = value === null,
              valIsSymbol = isSymbol(value),
              valIsUndefined = value === undefined$1;

          while (low < high) {
            var mid = nativeFloor((low + high) / 2),
                computed = iteratee(array[mid]),
                othIsDefined = computed !== undefined$1,
                othIsNull = computed === null,
                othIsReflexive = computed === computed,
                othIsSymbol = isSymbol(computed);

            if (valIsNaN) {
              var setLow = retHighest || othIsReflexive;
            } else if (valIsUndefined) {
              setLow = othIsReflexive && (retHighest || othIsDefined);
            } else if (valIsNull) {
              setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
            } else if (valIsSymbol) {
              setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
            } else if (othIsNull || othIsSymbol) {
              setLow = false;
            } else {
              setLow = retHighest ? computed <= value : computed < value;
            }

            if (setLow) {
              low = mid + 1;
            } else {
              high = mid;
            }
          }

          return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
         * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
         * support for iteratee shorthands.
         *
         * @private
         * @param {Array} array The array to inspect.
         * @param {Function} [iteratee] The iteratee invoked per element.
         * @returns {Array} Returns the new duplicate free array.
         */


        function baseSortedUniq(array, iteratee) {
          var index = -1,
              length = array.length,
              resIndex = 0,
              result = [];

          while (++index < length) {
            var value = array[index],
                computed = iteratee ? iteratee(value) : value;

            if (!index || !eq(computed, seen)) {
              var seen = computed;
              result[resIndex++] = value === 0 ? 0 : value;
            }
          }

          return result;
        }
        /**
         * The base implementation of `_.toNumber` which doesn't ensure correct
         * conversions of binary, hexadecimal, or octal string values.
         *
         * @private
         * @param {*} value The value to process.
         * @returns {number} Returns the number.
         */


        function baseToNumber(value) {
          if (typeof value == 'number') {
            return value;
          }

          if (isSymbol(value)) {
            return NAN;
          }

          return +value;
        }
        /**
         * The base implementation of `_.toString` which doesn't convert nullish
         * values to empty strings.
         *
         * @private
         * @param {*} value The value to process.
         * @returns {string} Returns the string.
         */


        function baseToString(value) {
          // Exit early for strings to avoid a performance hit in some environments.
          if (typeof value == 'string') {
            return value;
          }

          if (isArray(value)) {
            // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + '';
          }

          if (isSymbol(value)) {
            return symbolToString ? symbolToString.call(value) : '';
          }

          var result = value + '';
          return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
         * The base implementation of `_.uniqBy` without support for iteratee shorthands.
         *
         * @private
         * @param {Array} array The array to inspect.
         * @param {Function} [iteratee] The iteratee invoked per element.
         * @param {Function} [comparator] The comparator invoked per element.
         * @returns {Array} Returns the new duplicate free array.
         */


        function baseUniq(array, iteratee, comparator) {
          var index = -1,
              includes = arrayIncludes,
              length = array.length,
              isCommon = true,
              result = [],
              seen = result;

          if (comparator) {
            isCommon = false;
            includes = arrayIncludesWith;
          } else if (length >= LARGE_ARRAY_SIZE) {
            var set = iteratee ? null : createSet(array);

            if (set) {
              return setToArray(set);
            }

            isCommon = false;
            includes = cacheHas;
            seen = new SetCache();
          } else {
            seen = iteratee ? [] : result;
          }

          outer: while (++index < length) {
            var value = array[index],
                computed = iteratee ? iteratee(value) : value;
            value = comparator || value !== 0 ? value : 0;

            if (isCommon && computed === computed) {
              var seenIndex = seen.length;

              while (seenIndex--) {
                if (seen[seenIndex] === computed) {
                  continue outer;
                }
              }

              if (iteratee) {
                seen.push(computed);
              }

              result.push(value);
            } else if (!includes(seen, computed, comparator)) {
              if (seen !== result) {
                seen.push(computed);
              }

              result.push(value);
            }
          }

          return result;
        }
        /**
         * The base implementation of `_.unset`.
         *
         * @private
         * @param {Object} object The object to modify.
         * @param {Array|string} path The property path to unset.
         * @returns {boolean} Returns `true` if the property is deleted, else `false`.
         */


        function baseUnset(object, path) {
          path = castPath(path, object);
          object = parent(object, path);
          return object == null || delete object[toKey(last(path))];
        }
        /**
         * The base implementation of `_.update`.
         *
         * @private
         * @param {Object} object The object to modify.
         * @param {Array|string} path The path of the property to update.
         * @param {Function} updater The function to produce the updated value.
         * @param {Function} [customizer] The function to customize path creation.
         * @returns {Object} Returns `object`.
         */


        function baseUpdate(object, path, updater, customizer) {
          return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
         * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
         * without support for iteratee shorthands.
         *
         * @private
         * @param {Array} array The array to query.
         * @param {Function} predicate The function invoked per iteration.
         * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
         * @param {boolean} [fromRight] Specify iterating from right to left.
         * @returns {Array} Returns the slice of `array`.
         */


        function baseWhile(array, predicate, isDrop, fromRight) {
          var length = array.length,
              index = fromRight ? length : -1;

          while ((fromRight ? index-- : ++index < length) && predicate(array[index], index, array)) {}

          return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
         * The base implementation of `wrapperValue` which returns the result of
         * performing a sequence of actions on the unwrapped `value`, where each
         * successive action is supplied the return value of the previous.
         *
         * @private
         * @param {*} value The unwrapped value.
         * @param {Array} actions Actions to perform to resolve the unwrapped value.
         * @returns {*} Returns the resolved value.
         */


        function baseWrapperValue(value, actions) {
          var result = value;

          if (result instanceof LazyWrapper) {
            result = result.value();
          }

          return arrayReduce(actions, function (result, action) {
            return action.func.apply(action.thisArg, arrayPush([result], action.args));
          }, result);
        }
        /**
         * The base implementation of methods like `_.xor`, without support for
         * iteratee shorthands, that accepts an array of arrays to inspect.
         *
         * @private
         * @param {Array} arrays The arrays to inspect.
         * @param {Function} [iteratee] The iteratee invoked per element.
         * @param {Function} [comparator] The comparator invoked per element.
         * @returns {Array} Returns the new array of values.
         */


        function baseXor(arrays, iteratee, comparator) {
          var length = arrays.length;

          if (length < 2) {
            return length ? baseUniq(arrays[0]) : [];
          }

          var index = -1,
              result = Array(length);

          while (++index < length) {
            var array = arrays[index],
                othIndex = -1;

            while (++othIndex < length) {
              if (othIndex != index) {
                result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
              }
            }
          }

          return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
         * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
         *
         * @private
         * @param {Array} props The property identifiers.
         * @param {Array} values The property values.
         * @param {Function} assignFunc The function to assign values.
         * @returns {Object} Returns the new object.
         */


        function baseZipObject(props, values, assignFunc) {
          var index = -1,
              length = props.length,
              valsLength = values.length,
              result = {};

          while (++index < length) {
            var value = index < valsLength ? values[index] : undefined$1;
            assignFunc(result, props[index], value);
          }

          return result;
        }
        /**
         * Casts `value` to an empty array if it's not an array like object.
         *
         * @private
         * @param {*} value The value to inspect.
         * @returns {Array|Object} Returns the cast array-like object.
         */


        function castArrayLikeObject(value) {
          return isArrayLikeObject(value) ? value : [];
        }
        /**
         * Casts `value` to `identity` if it's not a function.
         *
         * @private
         * @param {*} value The value to inspect.
         * @returns {Function} Returns cast function.
         */


        function castFunction(value) {
          return typeof value == 'function' ? value : identity;
        }
        /**
         * Casts `value` to a path array if it's not one.
         *
         * @private
         * @param {*} value The value to inspect.
         * @param {Object} [object] The object to query keys on.
         * @returns {Array} Returns the cast property path array.
         */


        function castPath(value, object) {
          if (isArray(value)) {
            return value;
          }

          return isKey(value, object) ? [value] : stringToPath(toString(value));
        }
        /**
         * A `baseRest` alias which can be replaced with `identity` by module
         * replacement plugins.
         *
         * @private
         * @type {Function}
         * @param {Function} func The function to apply a rest parameter to.
         * @returns {Function} Returns the new function.
         */


        var castRest = baseRest;
        /**
         * Casts `array` to a slice if it's needed.
         *
         * @private
         * @param {Array} array The array to inspect.
         * @param {number} start The start position.
         * @param {number} [end=array.length] The end position.
         * @returns {Array} Returns the cast slice.
         */

        function castSlice(array, start, end) {
          var length = array.length;
          end = end === undefined$1 ? length : end;
          return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
         * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
         *
         * @private
         * @param {number|Object} id The timer id or timeout object of the timer to clear.
         */


        var clearTimeout = ctxClearTimeout || function (id) {
          return root.clearTimeout(id);
        };
        /**
         * Creates a clone of  `buffer`.
         *
         * @private
         * @param {Buffer} buffer The buffer to clone.
         * @param {boolean} [isDeep] Specify a deep clone.
         * @returns {Buffer} Returns the cloned buffer.
         */


        function cloneBuffer(buffer, isDeep) {
          if (isDeep) {
            return buffer.slice();
          }

          var length = buffer.length,
              result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
          buffer.copy(result);
          return result;
        }
        /**
         * Creates a clone of `arrayBuffer`.
         *
         * @private
         * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
         * @returns {ArrayBuffer} Returns the cloned array buffer.
         */


        function cloneArrayBuffer(arrayBuffer) {
          var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
          new Uint8Array(result).set(new Uint8Array(arrayBuffer));
          return result;
        }
        /**
         * Creates a clone of `dataView`.
         *
         * @private
         * @param {Object} dataView The data view to clone.
         * @param {boolean} [isDeep] Specify a deep clone.
         * @returns {Object} Returns the cloned data view.
         */


        function cloneDataView(dataView, isDeep) {
          var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
          return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
         * Creates a clone of `regexp`.
         *
         * @private
         * @param {Object} regexp The regexp to clone.
         * @returns {Object} Returns the cloned regexp.
         */


        function cloneRegExp(regexp) {
          var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
          result.lastIndex = regexp.lastIndex;
          return result;
        }
        /**
         * Creates a clone of the `symbol` object.
         *
         * @private
         * @param {Object} symbol The symbol object to clone.
         * @returns {Object} Returns the cloned symbol object.
         */


        function cloneSymbol(symbol) {
          return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
        }
        /**
         * Creates a clone of `typedArray`.
         *
         * @private
         * @param {Object} typedArray The typed array to clone.
         * @param {boolean} [isDeep] Specify a deep clone.
         * @returns {Object} Returns the cloned typed array.
         */


        function cloneTypedArray(typedArray, isDeep) {
          var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
          return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
         * Compares values to sort them in ascending order.
         *
         * @private
         * @param {*} value The value to compare.
         * @param {*} other The other value to compare.
         * @returns {number} Returns the sort order indicator for `value`.
         */


        function compareAscending(value, other) {
          if (value !== other) {
            var valIsDefined = value !== undefined$1,
                valIsNull = value === null,
                valIsReflexive = value === value,
                valIsSymbol = isSymbol(value);
            var othIsDefined = other !== undefined$1,
                othIsNull = other === null,
                othIsReflexive = other === other,
                othIsSymbol = isSymbol(other);

            if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) {
              return 1;
            }

            if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) {
              return -1;
            }
          }

          return 0;
        }
        /**
         * Used by `_.orderBy` to compare multiple properties of a value to another
         * and stable sort them.
         *
         * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
         * specify an order of "desc" for descending or "asc" for ascending sort order
         * of corresponding values.
         *
         * @private
         * @param {Object} object The object to compare.
         * @param {Object} other The other object to compare.
         * @param {boolean[]|string[]} orders The order to sort by for each property.
         * @returns {number} Returns the sort order indicator for `object`.
         */


        function compareMultiple(object, other, orders) {
          var index = -1,
              objCriteria = object.criteria,
              othCriteria = other.criteria,
              length = objCriteria.length,
              ordersLength = orders.length;

          while (++index < length) {
            var result = compareAscending(objCriteria[index], othCriteria[index]);

            if (result) {
              if (index >= ordersLength) {
                return result;
              }

              var order = orders[index];
              return result * (order == 'desc' ? -1 : 1);
            }
          } // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
          // that causes it, under certain circumstances, to provide the same value for
          // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
          // for more details.
          //
          // This also ensures a stable sort in V8 and other engines.
          // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.


          return object.index - other.index;
        }
        /**
         * Creates an array that is the composition of partially applied arguments,
         * placeholders, and provided arguments into a single array of arguments.
         *
         * @private
         * @param {Array} args The provided arguments.
         * @param {Array} partials The arguments to prepend to those provided.
         * @param {Array} holders The `partials` placeholder indexes.
         * @params {boolean} [isCurried] Specify composing for a curried function.
         * @returns {Array} Returns the new array of composed arguments.
         */


        function composeArgs(args, partials, holders, isCurried) {
          var argsIndex = -1,
              argsLength = args.length,
              holdersLength = holders.length,
              leftIndex = -1,
              leftLength = partials.length,
              rangeLength = nativeMax(argsLength - holdersLength, 0),
              result = Array(leftLength + rangeLength),
              isUncurried = !isCurried;

          while (++leftIndex < leftLength) {
            result[leftIndex] = partials[leftIndex];
          }

          while (++argsIndex < holdersLength) {
            if (isUncurried || argsIndex < argsLength) {
              result[holders[argsIndex]] = args[argsIndex];
            }
          }

          while (rangeLength--) {
            result[leftIndex++] = args[argsIndex++];
          }

          return result;
        }
        /**
         * This function is like `composeArgs` except that the arguments composition
         * is tailored for `_.partialRight`.
         *
         * @private
         * @param {Array} args The provided arguments.
         * @param {Array} partials The arguments to append to those provided.
         * @param {Array} holders The `partials` placeholder indexes.
         * @params {boolean} [isCurried] Specify composing for a curried function.
         * @returns {Array} Returns the new array of composed arguments.
         */


        function composeArgsRight(args, partials, holders, isCurried) {
          var argsIndex = -1,
              argsLength = args.length,
              holdersIndex = -1,
              holdersLength = holders.length,
              rightIndex = -1,
              rightLength = partials.length,
              rangeLength = nativeMax(argsLength - holdersLength, 0),
              result = Array(rangeLength + rightLength),
              isUncurried = !isCurried;

          while (++argsIndex < rangeLength) {
            result[argsIndex] = args[argsIndex];
          }

          var offset = argsIndex;

          while (++rightIndex < rightLength) {
            result[offset + rightIndex] = partials[rightIndex];
          }

          while (++holdersIndex < holdersLength) {
            if (isUncurried || argsIndex < argsLength) {
              result[offset + holders[holdersIndex]] = args[argsIndex++];
            }
          }

          return result;
        }
        /**
         * Copies the values of `source` to `array`.
         *
         * @private
         * @param {Array} source The array to copy values from.
         * @param {Array} [array=[]] The array to copy values to.
         * @returns {Array} Returns `array`.
         */


        function copyArray(source, array) {
          var index = -1,
              length = source.length;
          array || (array = Array(length));

          while (++index < length) {
            array[index] = source[index];
          }

          return array;
        }
        /**
         * Copies properties of `source` to `object`.
         *
         * @private
         * @param {Object} source The object to copy properties from.
         * @param {Array} props The property identifiers to copy.
         * @param {Object} [object={}] The object to copy properties to.
         * @param {Function} [customizer] The function to customize copied values.
         * @returns {Object} Returns `object`.
         */


        function copyObject(source, props, object, customizer) {
          var isNew = !object;
          object || (object = {});
          var index = -1,
              length = props.length;

          while (++index < length) {
            var key = props[index];
            var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined$1;

            if (newValue === undefined$1) {
              newValue = source[key];
            }

            if (isNew) {
              baseAssignValue(object, key, newValue);
            } else {
              assignValue(object, key, newValue);
            }
          }

          return object;
        }
        /**
         * Copies own symbols of `source` to `object`.
         *
         * @private
         * @param {Object} source The object to copy symbols from.
         * @param {Object} [object={}] The object to copy symbols to.
         * @returns {Object} Returns `object`.
         */


        function copySymbols(source, object) {
          return copyObject(source, getSymbols(source), object);
        }
        /**
         * Copies own and inherited symbols of `source` to `object`.
         *
         * @private
         * @param {Object} source The object to copy symbols from.
         * @param {Object} [object={}] The object to copy symbols to.
         * @returns {Object} Returns `object`.
         */


        function copySymbolsIn(source, object) {
          return copyObject(source, getSymbolsIn(source), object);
        }
        /**
         * Creates a function like `_.groupBy`.
         *
         * @private
         * @param {Function} setter The function to set accumulator values.
         * @param {Function} [initializer] The accumulator object initializer.
         * @returns {Function} Returns the new aggregator function.
         */


        function createAggregator(setter, initializer) {
          return function (collection, iteratee) {
            var func = isArray(collection) ? arrayAggregator : baseAggregator,
                accumulator = initializer ? initializer() : {};
            return func(collection, setter, getIteratee(iteratee, 2), accumulator);
          };
        }
        /**
         * Creates a function like `_.assign`.
         *
         * @private
         * @param {Function} assigner The function to assign values.
         * @returns {Function} Returns the new assigner function.
         */


        function createAssigner(assigner) {
          return baseRest(function (object, sources) {
            var index = -1,
                length = sources.length,
                customizer = length > 1 ? sources[length - 1] : undefined$1,
                guard = length > 2 ? sources[2] : undefined$1;
            customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined$1;

            if (guard && isIterateeCall(sources[0], sources[1], guard)) {
              customizer = length < 3 ? undefined$1 : customizer;
              length = 1;
            }

            object = Object(object);

            while (++index < length) {
              var source = sources[index];

              if (source) {
                assigner(object, source, index, customizer);
              }
            }

            return object;
          });
        }
        /**
         * Creates a `baseEach` or `baseEachRight` function.
         *
         * @private
         * @param {Function} eachFunc The function to iterate over a collection.
         * @param {boolean} [fromRight] Specify iterating from right to left.
         * @returns {Function} Returns the new base function.
         */


        function createBaseEach(eachFunc, fromRight) {
          return function (collection, iteratee) {
            if (collection == null) {
              return collection;
            }

            if (!isArrayLike(collection)) {
              return eachFunc(collection, iteratee);
            }

            var length = collection.length,
                index = fromRight ? length : -1,
                iterable = Object(collection);

            while (fromRight ? index-- : ++index < length) {
              if (iteratee(iterable[index], index, iterable) === false) {
                break;
              }
            }

            return collection;
          };
        }
        /**
         * Creates a base function for methods like `_.forIn` and `_.forOwn`.
         *
         * @private
         * @param {boolean} [fromRight] Specify iterating from right to left.
         * @returns {Function} Returns the new base function.
         */


        function createBaseFor(fromRight) {
          return function (object, iteratee, keysFunc) {
            var index = -1,
                iterable = Object(object),
                props = keysFunc(object),
                length = props.length;

            while (length--) {
              var key = props[fromRight ? length : ++index];

              if (iteratee(iterable[key], key, iterable) === false) {
                break;
              }
            }

            return object;
          };
        }
        /**
         * Creates a function that wraps `func` to invoke it with the optional `this`
         * binding of `thisArg`.
         *
         * @private
         * @param {Function} func The function to wrap.
         * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
         * @param {*} [thisArg] The `this` binding of `func`.
         * @returns {Function} Returns the new wrapped function.
         */


        function createBind(func, bitmask, thisArg) {
          var isBind = bitmask & WRAP_BIND_FLAG,
              Ctor = createCtor(func);

          function wrapper() {
            var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
            return fn.apply(isBind ? thisArg : this, arguments);
          }

          return wrapper;
        }
        /**
         * Creates a function like `_.lowerFirst`.
         *
         * @private
         * @param {string} methodName The name of the `String` case method to use.
         * @returns {Function} Returns the new case function.
         */


        function createCaseFirst(methodName) {
          return function (string) {
            string = toString(string);
            var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined$1;
            var chr = strSymbols ? strSymbols[0] : string.charAt(0);
            var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
            return chr[methodName]() + trailing;
          };
        }
        /**
         * Creates a function like `_.camelCase`.
         *
         * @private
         * @param {Function} callback The function to combine each word.
         * @returns {Function} Returns the new compounder function.
         */


        function createCompounder(callback) {
          return function (string) {
            return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
          };
        }
        /**
         * Creates a function that produces an instance of `Ctor` regardless of
         * whether it was invoked as part of a `new` expression or by `call` or `apply`.
         *
         * @private
         * @param {Function} Ctor The constructor to wrap.
         * @returns {Function} Returns the new wrapped function.
         */


        function createCtor(Ctor) {
          return function () {
            // Use a `switch` statement to work with class constructors. See
            // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
            // for more details.
            var args = arguments;

            switch (args.length) {
              case 0:
                return new Ctor();

              case 1:
                return new Ctor(args[0]);

              case 2:
                return new Ctor(args[0], args[1]);

              case 3:
                return new Ctor(args[0], args[1], args[2]);

              case 4:
                return new Ctor(args[0], args[1], args[2], args[3]);

              case 5:
                return new Ctor(args[0], args[1], args[2], args[3], args[4]);

              case 6:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);

              case 7:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
            }

            var thisBinding = baseCreate(Ctor.prototype),
                result = Ctor.apply(thisBinding, args); // Mimic the constructor's `return` behavior.
            // See https://es5.github.io/#x13.2.2 for more details.

            return isObject(result) ? result : thisBinding;
          };
        }
        /**
         * Creates a function that wraps `func` to enable currying.
         *
         * @private
         * @param {Function} func The function to wrap.
         * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
         * @param {number} arity The arity of `func`.
         * @returns {Function} Returns the new wrapped function.
         */


        function createCurry(func, bitmask, arity) {
          var Ctor = createCtor(func);

          function wrapper() {
            var length = arguments.length,
                args = Array(length),
                index = length,
                placeholder = getHolder(wrapper);

            while (index--) {
              args[index] = arguments[index];
            }

            var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
            length -= holders.length;

            if (length < arity) {
              return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined$1, args, holders, undefined$1, undefined$1, arity - length);
            }

            var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
            return apply(fn, this, args);
          }

          return wrapper;
        }
        /**
         * Creates a `_.find` or `_.findLast` function.
         *
         * @private
         * @param {Function} findIndexFunc The function to find the collection index.
         * @returns {Function} Returns the new find function.
         */


        function createFind(findIndexFunc) {
          return function (collection, predicate, fromIndex) {
            var iterable = Object(collection);

            if (!isArrayLike(collection)) {
              var iteratee = getIteratee(predicate, 3);
              collection = keys(collection);

              predicate = function predicate(key) {
                return iteratee(iterable[key], key, iterable);
              };
            }

            var index = findIndexFunc(collection, predicate, fromIndex);
            return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined$1;
          };
        }
        /**
         * Creates a `_.flow` or `_.flowRight` function.
         *
         * @private
         * @param {boolean} [fromRight] Specify iterating from right to left.
         * @returns {Function} Returns the new flow function.
         */


        function createFlow(fromRight) {
          return flatRest(function (funcs) {
            var length = funcs.length,
                index = length,
                prereq = LodashWrapper.prototype.thru;

            if (fromRight) {
              funcs.reverse();
            }

            while (index--) {
              var func = funcs[index];

              if (typeof func != 'function') {
                throw new TypeError(FUNC_ERROR_TEXT);
              }

              if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
                var wrapper = new LodashWrapper([], true);
              }
            }

            index = wrapper ? index : length;

            while (++index < length) {
              func = funcs[index];
              var funcName = getFuncName(func),
                  data = funcName == 'wrapper' ? getData(func) : undefined$1;

              if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) {
                wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
              } else {
                wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
              }
            }

            return function () {
              var args = arguments,
                  value = args[0];

              if (wrapper && args.length == 1 && isArray(value)) {
                return wrapper.plant(value).value();
              }

              var index = 0,
                  result = length ? funcs[index].apply(this, args) : value;

              while (++index < length) {
                result = funcs[index].call(this, result);
              }

              return result;
            };
          });
        }
        /**
         * Creates a function that wraps `func` to invoke it with optional `this`
         * binding of `thisArg`, partial application, and currying.
         *
         * @private
         * @param {Function|string} func The function or method name to wrap.
         * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
         * @param {*} [thisArg] The `this` binding of `func`.
         * @param {Array} [partials] The arguments to prepend to those provided to
         *  the new function.
         * @param {Array} [holders] The `partials` placeholder indexes.
         * @param {Array} [partialsRight] The arguments to append to those provided
         *  to the new function.
         * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
         * @param {Array} [argPos] The argument positions of the new function.
         * @param {number} [ary] The arity cap of `func`.
         * @param {number} [arity] The arity of `func`.
         * @returns {Function} Returns the new wrapped function.
         */


        function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
          var isAry = bitmask & WRAP_ARY_FLAG,
              isBind = bitmask & WRAP_BIND_FLAG,
              isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
              isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
              isFlip = bitmask & WRAP_FLIP_FLAG,
              Ctor = isBindKey ? undefined$1 : createCtor(func);

          function wrapper() {
            var length = arguments.length,
                args = Array(length),
                index = length;

            while (index--) {
              args[index] = arguments[index];
            }

            if (isCurried) {
              var placeholder = getHolder(wrapper),
                  holdersCount = countHolders(args, placeholder);
            }

            if (partials) {
              args = composeArgs(args, partials, holders, isCurried);
            }

            if (partialsRight) {
              args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
            }

            length -= holdersCount;

            if (isCurried && length < arity) {
              var newHolders = replaceHolders(args, placeholder);
              return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
            }

            var thisBinding = isBind ? thisArg : this,
                fn = isBindKey ? thisBinding[func] : func;
            length = args.length;

            if (argPos) {
              args = reorder(args, argPos);
            } else if (isFlip && length > 1) {
              args.reverse();
            }

            if (isAry && ary < length) {
              args.length = ary;
            }

            if (this && this !== root && this instanceof wrapper) {
              fn = Ctor || createCtor(fn);
            }

            return fn.apply(thisBinding, args);
          }

          return wrapper;
        }
        /**
         * Creates a function like `_.invertBy`.
         *
         * @private
         * @param {Function} setter The function to set accumulator values.
         * @param {Function} toIteratee The function to resolve iteratees.
         * @returns {Function} Returns the new inverter function.
         */


        function createInverter(setter, toIteratee) {
          return function (object, iteratee) {
            return baseInverter(object, setter, toIteratee(iteratee), {});
          };
        }
        /**
         * Creates a function that performs a mathematical operation on two values.
         *
         * @private
         * @param {Function} operator The function to perform the operation.
         * @param {number} [defaultValue] The value used for `undefined` arguments.
         * @returns {Function} Returns the new mathematical operation function.
         */


        function createMathOperation(operator, defaultValue) {
          return function (value, other) {
            var result;

            if (value === undefined$1 && other === undefined$1) {
              return defaultValue;
            }

            if (value !== undefined$1) {
              result = value;
            }

            if (other !== undefined$1) {
              if (result === undefined$1) {
                return other;
              }

              if (typeof value == 'string' || typeof other == 'string') {
                value = baseToString(value);
                other = baseToString(other);
              } else {
                value = baseToNumber(value);
                other = baseToNumber(other);
              }

              result = operator(value, other);
            }

            return result;
          };
        }
        /**
         * Creates a function like `_.over`.
         *
         * @private
         * @param {Function} arrayFunc The function to iterate over iteratees.
         * @returns {Function} Returns the new over function.
         */


        function createOver(arrayFunc) {
          return flatRest(function (iteratees) {
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            return baseRest(function (args) {
              var thisArg = this;
              return arrayFunc(iteratees, function (iteratee) {
                return apply(iteratee, thisArg, args);
              });
            });
          });
        }
        /**
         * Creates the padding for `string` based on `length`. The `chars` string
         * is truncated if the number of characters exceeds `length`.
         *
         * @private
         * @param {number} length The padding length.
         * @param {string} [chars=' '] The string used as padding.
         * @returns {string} Returns the padding for `string`.
         */


        function createPadding(length, chars) {
          chars = chars === undefined$1 ? ' ' : baseToString(chars);
          var charsLength = chars.length;

          if (charsLength < 2) {
            return charsLength ? baseRepeat(chars, length) : chars;
          }

          var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
          return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
        }
        /**
         * Creates a function that wraps `func` to invoke it with the `this` binding
         * of `thisArg` and `partials` prepended to the arguments it receives.
         *
         * @private
         * @param {Function} func The function to wrap.
         * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
         * @param {*} thisArg The `this` binding of `func`.
         * @param {Array} partials The arguments to prepend to those provided to
         *  the new function.
         * @returns {Function} Returns the new wrapped function.
         */


        function createPartial(func, bitmask, thisArg, partials) {
          var isBind = bitmask & WRAP_BIND_FLAG,
              Ctor = createCtor(func);

          function wrapper() {
            var argsIndex = -1,
                argsLength = arguments.length,
                leftIndex = -1,
                leftLength = partials.length,
                args = Array(leftLength + argsLength),
                fn = this && this !== root && this instanceof wrapper ? Ctor : func;

            while (++leftIndex < leftLength) {
              args[leftIndex] = partials[leftIndex];
            }

            while (argsLength--) {
              args[leftIndex++] = arguments[++argsIndex];
            }

            return apply(fn, isBind ? thisArg : this, args);
          }

          return wrapper;
        }
        /**
         * Creates a `_.range` or `_.rangeRight` function.
         *
         * @private
         * @param {boolean} [fromRight] Specify iterating from right to left.
         * @returns {Function} Returns the new range function.
         */


        function createRange(fromRight) {
          return function (start, end, step) {
            if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
              end = step = undefined$1;
            } // Ensure the sign of `-0` is preserved.


            start = toFinite(start);

            if (end === undefined$1) {
              end = start;
              start = 0;
            } else {
              end = toFinite(end);
            }

            step = step === undefined$1 ? start < end ? 1 : -1 : toFinite(step);
            return baseRange(start, end, step, fromRight);
          };
        }
        /**
         * Creates a function that performs a relational operation on two values.
         *
         * @private
         * @param {Function} operator The function to perform the operation.
         * @returns {Function} Returns the new relational operation function.
         */


        function createRelationalOperation(operator) {
          return function (value, other) {
            if (!(typeof value == 'string' && typeof other == 'string')) {
              value = toNumber(value);
              other = toNumber(other);
            }

            return operator(value, other);
          };
        }
        /**
         * Creates a function that wraps `func` to continue currying.
         *
         * @private
         * @param {Function} func The function to wrap.
         * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
         * @param {Function} wrapFunc The function to create the `func` wrapper.
         * @param {*} placeholder The placeholder value.
         * @param {*} [thisArg] The `this` binding of `func`.
         * @param {Array} [partials] The arguments to prepend to those provided to
         *  the new function.
         * @param {Array} [holders] The `partials` placeholder indexes.
         * @param {Array} [argPos] The argument positions of the new function.
         * @param {number} [ary] The arity cap of `func`.
         * @param {number} [arity] The arity of `func`.
         * @returns {Function} Returns the new wrapped function.
         */


        function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
          var isCurry = bitmask & WRAP_CURRY_FLAG,
              newHolders = isCurry ? holders : undefined$1,
              newHoldersRight = isCurry ? undefined$1 : holders,
              newPartials = isCurry ? partials : undefined$1,
              newPartialsRight = isCurry ? undefined$1 : partials;
          bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
          bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

          if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
            bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
          }

          var newData = [func, bitmask, thisArg, newPartials, newHolders, newPartialsRight, newHoldersRight, argPos, ary, arity];
          var result = wrapFunc.apply(undefined$1, newData);

          if (isLaziable(func)) {
            setData(result, newData);
          }

          result.placeholder = placeholder;
          return setWrapToString(result, func, bitmask);
        }
        /**
         * Creates a function like `_.round`.
         *
         * @private
         * @param {string} methodName The name of the `Math` method to use when rounding.
         * @returns {Function} Returns the new round function.
         */


        function createRound(methodName) {
          var func = Math[methodName];
          return function (number, precision) {
            number = toNumber(number);
            precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);

            if (precision && nativeIsFinite(number)) {
              // Shift with exponential notation to avoid floating-point issues.
              // See [MDN](https://mdn.io/round#Examples) for more details.
              var pair = (toString(number) + 'e').split('e'),
                  value = func(pair[0] + 'e' + (+pair[1] + precision));
              pair = (toString(value) + 'e').split('e');
              return +(pair[0] + 'e' + (+pair[1] - precision));
            }

            return func(number);
          };
        }
        /**
         * Creates a set object of `values`.
         *
         * @private
         * @param {Array} values The values to add to the set.
         * @returns {Object} Returns the new set.
         */


        var createSet = !(Set && 1 / setToArray(new Set([, -0]))[1] == INFINITY) ? noop : function (values) {
          return new Set(values);
        };
        /**
         * Creates a `_.toPairs` or `_.toPairsIn` function.
         *
         * @private
         * @param {Function} keysFunc The function to get the keys of a given object.
         * @returns {Function} Returns the new pairs function.
         */

        function createToPairs(keysFunc) {
          return function (object) {
            var tag = getTag(object);

            if (tag == mapTag) {
              return mapToArray(object);
            }

            if (tag == setTag) {
              return setToPairs(object);
            }

            return baseToPairs(object, keysFunc(object));
          };
        }
        /**
         * Creates a function that either curries or invokes `func` with optional
         * `this` binding and partially applied arguments.
         *
         * @private
         * @param {Function|string} func The function or method name to wrap.
         * @param {number} bitmask The bitmask flags.
         *    1 - `_.bind`
         *    2 - `_.bindKey`
         *    4 - `_.curry` or `_.curryRight` of a bound function
         *    8 - `_.curry`
         *   16 - `_.curryRight`
         *   32 - `_.partial`
         *   64 - `_.partialRight`
         *  128 - `_.rearg`
         *  256 - `_.ary`
         *  512 - `_.flip`
         * @param {*} [thisArg] The `this` binding of `func`.
         * @param {Array} [partials] The arguments to be partially applied.
         * @param {Array} [holders] The `partials` placeholder indexes.
         * @param {Array} [argPos] The argument positions of the new function.
         * @param {number} [ary] The arity cap of `func`.
         * @param {number} [arity] The arity of `func`.
         * @returns {Function} Returns the new wrapped function.
         */


        function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
          var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;

          if (!isBindKey && typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }

          var length = partials ? partials.length : 0;

          if (!length) {
            bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
            partials = holders = undefined$1;
          }

          ary = ary === undefined$1 ? ary : nativeMax(toInteger(ary), 0);
          arity = arity === undefined$1 ? arity : toInteger(arity);
          length -= holders ? holders.length : 0;

          if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
            var partialsRight = partials,
                holdersRight = holders;
            partials = holders = undefined$1;
          }

          var data = isBindKey ? undefined$1 : getData(func);
          var newData = [func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity];

          if (data) {
            mergeData(newData, data);
          }

          func = newData[0];
          bitmask = newData[1];
          thisArg = newData[2];
          partials = newData[3];
          holders = newData[4];
          arity = newData[9] = newData[9] === undefined$1 ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);

          if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
            bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
          }

          if (!bitmask || bitmask == WRAP_BIND_FLAG) {
            var result = createBind(func, bitmask, thisArg);
          } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
            result = createCurry(func, bitmask, arity);
          } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
            result = createPartial(func, bitmask, thisArg, partials);
          } else {
            result = createHybrid.apply(undefined$1, newData);
          }

          var setter = data ? baseSetData : setData;
          return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
         * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
         * of source objects to the destination object for all destination properties
         * that resolve to `undefined`.
         *
         * @private
         * @param {*} objValue The destination value.
         * @param {*} srcValue The source value.
         * @param {string} key The key of the property to assign.
         * @param {Object} object The parent object of `objValue`.
         * @returns {*} Returns the value to assign.
         */


        function customDefaultsAssignIn(objValue, srcValue, key, object) {
          if (objValue === undefined$1 || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) {
            return srcValue;
          }

          return objValue;
        }
        /**
         * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
         * objects into destination objects that are passed thru.
         *
         * @private
         * @param {*} objValue The destination value.
         * @param {*} srcValue The source value.
         * @param {string} key The key of the property to merge.
         * @param {Object} object The parent object of `objValue`.
         * @param {Object} source The parent object of `srcValue`.
         * @param {Object} [stack] Tracks traversed source values and their merged
         *  counterparts.
         * @returns {*} Returns the value to assign.
         */


        function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
          if (isObject(objValue) && isObject(srcValue)) {
            // Recursively merge objects and arrays (susceptible to call stack limits).
            stack.set(srcValue, objValue);
            baseMerge(objValue, srcValue, undefined$1, customDefaultsMerge, stack);
            stack['delete'](srcValue);
          }

          return objValue;
        }
        /**
         * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
         * objects.
         *
         * @private
         * @param {*} value The value to inspect.
         * @param {string} key The key of the property to inspect.
         * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
         */


        function customOmitClone(value) {
          return isPlainObject(value) ? undefined$1 : value;
        }
        /**
         * A specialized version of `baseIsEqualDeep` for arrays with support for
         * partial deep comparisons.
         *
         * @private
         * @param {Array} array The array to compare.
         * @param {Array} other The other array to compare.
         * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
         * @param {Function} customizer The function to customize comparisons.
         * @param {Function} equalFunc The function to determine equivalents of values.
         * @param {Object} stack Tracks traversed `array` and `other` objects.
         * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
         */


        function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
              arrLength = array.length,
              othLength = other.length;

          if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
            return false;
          } // Check that cyclic values are equal.


          var arrStacked = stack.get(array);
          var othStacked = stack.get(other);

          if (arrStacked && othStacked) {
            return arrStacked == other && othStacked == array;
          }

          var index = -1,
              result = true,
              seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : undefined$1;
          stack.set(array, other);
          stack.set(other, array); // Ignore non-index properties.

          while (++index < arrLength) {
            var arrValue = array[index],
                othValue = other[index];

            if (customizer) {
              var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
            }

            if (compared !== undefined$1) {
              if (compared) {
                continue;
              }

              result = false;
              break;
            } // Recursively compare arrays (susceptible to call stack limits).


            if (seen) {
              if (!arraySome(other, function (othValue, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
                result = false;
                break;
              }
            } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              result = false;
              break;
            }
          }

          stack['delete'](array);
          stack['delete'](other);
          return result;
        }
        /**
         * A specialized version of `baseIsEqualDeep` for comparing objects of
         * the same `toStringTag`.
         *
         * **Note:** This function only supports comparing values with tags of
         * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
         *
         * @private
         * @param {Object} object The object to compare.
         * @param {Object} other The other object to compare.
         * @param {string} tag The `toStringTag` of the objects to compare.
         * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
         * @param {Function} customizer The function to customize comparisons.
         * @param {Function} equalFunc The function to determine equivalents of values.
         * @param {Object} stack Tracks traversed `object` and `other` objects.
         * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
         */


        function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
          switch (tag) {
            case dataViewTag:
              if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
                return false;
              }

              object = object.buffer;
              other = other.buffer;

            case arrayBufferTag:
              if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
                return false;
              }

              return true;

            case boolTag:
            case dateTag:
            case numberTag:
              // Coerce booleans to `1` or `0` and dates to milliseconds.
              // Invalid dates are coerced to `NaN`.
              return eq(+object, +other);

            case errorTag:
              return object.name == other.name && object.message == other.message;

            case regexpTag:
            case stringTag:
              // Coerce regexes to strings and treat strings, primitives and objects,
              // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
              // for more details.
              return object == other + '';

            case mapTag:
              var convert = mapToArray;

            case setTag:
              var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
              convert || (convert = setToArray);

              if (object.size != other.size && !isPartial) {
                return false;
              } // Assume cyclic values are equal.


              var stacked = stack.get(object);

              if (stacked) {
                return stacked == other;
              }

              bitmask |= COMPARE_UNORDERED_FLAG; // Recursively compare objects (susceptible to call stack limits).

              stack.set(object, other);
              var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
              stack['delete'](object);
              return result;

            case symbolTag:
              if (symbolValueOf) {
                return symbolValueOf.call(object) == symbolValueOf.call(other);
              }

          }

          return false;
        }
        /**
         * A specialized version of `baseIsEqualDeep` for objects with support for
         * partial deep comparisons.
         *
         * @private
         * @param {Object} object The object to compare.
         * @param {Object} other The other object to compare.
         * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
         * @param {Function} customizer The function to customize comparisons.
         * @param {Function} equalFunc The function to determine equivalents of values.
         * @param {Object} stack Tracks traversed `object` and `other` objects.
         * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
         */


        function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
              objProps = getAllKeys(object),
              objLength = objProps.length,
              othProps = getAllKeys(other),
              othLength = othProps.length;

          if (objLength != othLength && !isPartial) {
            return false;
          }

          var index = objLength;

          while (index--) {
            var key = objProps[index];

            if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
              return false;
            }
          } // Check that cyclic values are equal.


          var objStacked = stack.get(object);
          var othStacked = stack.get(other);

          if (objStacked && othStacked) {
            return objStacked == other && othStacked == object;
          }

          var result = true;
          stack.set(object, other);
          stack.set(other, object);
          var skipCtor = isPartial;

          while (++index < objLength) {
            key = objProps[index];
            var objValue = object[key],
                othValue = other[key];

            if (customizer) {
              var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
            } // Recursively compare objects (susceptible to call stack limits).


            if (!(compared === undefined$1 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
              result = false;
              break;
            }

            skipCtor || (skipCtor = key == 'constructor');
          }

          if (result && !skipCtor) {
            var objCtor = object.constructor,
                othCtor = other.constructor; // Non `Object` object instances with different constructors are not equal.

            if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) {
              result = false;
            }
          }

          stack['delete'](object);
          stack['delete'](other);
          return result;
        }
        /**
         * A specialized version of `baseRest` which flattens the rest array.
         *
         * @private
         * @param {Function} func The function to apply a rest parameter to.
         * @returns {Function} Returns the new function.
         */


        function flatRest(func) {
          return setToString(overRest(func, undefined$1, flatten), func + '');
        }
        /**
         * Creates an array of own enumerable property names and symbols of `object`.
         *
         * @private
         * @param {Object} object The object to query.
         * @returns {Array} Returns the array of property names and symbols.
         */


        function getAllKeys(object) {
          return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
         * Creates an array of own and inherited enumerable property names and
         * symbols of `object`.
         *
         * @private
         * @param {Object} object The object to query.
         * @returns {Array} Returns the array of property names and symbols.
         */


        function getAllKeysIn(object) {
          return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
         * Gets metadata for `func`.
         *
         * @private
         * @param {Function} func The function to query.
         * @returns {*} Returns the metadata for `func`.
         */


        var getData = !metaMap ? noop : function (func) {
          return metaMap.get(func);
        };
        /**
         * Gets the name of `func`.
         *
         * @private
         * @param {Function} func The function to query.
         * @returns {string} Returns the function name.
         */

        function getFuncName(func) {
          var result = func.name + '',
              array = realNames[result],
              length = hasOwnProperty.call(realNames, result) ? array.length : 0;

          while (length--) {
            var data = array[length],
                otherFunc = data.func;

            if (otherFunc == null || otherFunc == func) {
              return data.name;
            }
          }

          return result;
        }
        /**
         * Gets the argument placeholder value for `func`.
         *
         * @private
         * @param {Function} func The function to inspect.
         * @returns {*} Returns the placeholder value.
         */


        function getHolder(func) {
          var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
          return object.placeholder;
        }
        /**
         * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
         * this function returns the custom method, otherwise it returns `baseIteratee`.
         * If arguments are provided, the chosen function is invoked with them and
         * its result is returned.
         *
         * @private
         * @param {*} [value] The value to convert to an iteratee.
         * @param {number} [arity] The arity of the created iteratee.
         * @returns {Function} Returns the chosen function or its result.
         */


        function getIteratee() {
          var result = lodash.iteratee || iteratee;
          result = result === iteratee ? baseIteratee : result;
          return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
         * Gets the data for `map`.
         *
         * @private
         * @param {Object} map The map to query.
         * @param {string} key The reference key.
         * @returns {*} Returns the map data.
         */


        function getMapData(map, key) {
          var data = map.__data__;
          return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
        }
        /**
         * Gets the property names, values, and compare flags of `object`.
         *
         * @private
         * @param {Object} object The object to query.
         * @returns {Array} Returns the match data of `object`.
         */


        function getMatchData(object) {
          var result = keys(object),
              length = result.length;

          while (length--) {
            var key = result[length],
                value = object[key];
            result[length] = [key, value, isStrictComparable(value)];
          }

          return result;
        }
        /**
         * Gets the native function at `key` of `object`.
         *
         * @private
         * @param {Object} object The object to query.
         * @param {string} key The key of the method to get.
         * @returns {*} Returns the function if it's native, else `undefined`.
         */


        function getNative(object, key) {
          var value = getValue(object, key);
          return baseIsNative(value) ? value : undefined$1;
        }
        /**
         * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
         *
         * @private
         * @param {*} value The value to query.
         * @returns {string} Returns the raw `toStringTag`.
         */


        function getRawTag(value) {
          var isOwn = hasOwnProperty.call(value, symToStringTag),
              tag = value[symToStringTag];

          try {
            value[symToStringTag] = undefined$1;
            var unmasked = true;
          } catch (e) {}

          var result = nativeObjectToString.call(value);

          if (unmasked) {
            if (isOwn) {
              value[symToStringTag] = tag;
            } else {
              delete value[symToStringTag];
            }
          }

          return result;
        }
        /**
         * Creates an array of the own enumerable symbols of `object`.
         *
         * @private
         * @param {Object} object The object to query.
         * @returns {Array} Returns the array of symbols.
         */


        var getSymbols = !nativeGetSymbols ? stubArray : function (object) {
          if (object == null) {
            return [];
          }

          object = Object(object);
          return arrayFilter(nativeGetSymbols(object), function (symbol) {
            return propertyIsEnumerable.call(object, symbol);
          });
        };
        /**
         * Creates an array of the own and inherited enumerable symbols of `object`.
         *
         * @private
         * @param {Object} object The object to query.
         * @returns {Array} Returns the array of symbols.
         */

        var getSymbolsIn = !nativeGetSymbols ? stubArray : function (object) {
          var result = [];

          while (object) {
            arrayPush(result, getSymbols(object));
            object = getPrototype(object);
          }

          return result;
        };
        /**
         * Gets the `toStringTag` of `value`.
         *
         * @private
         * @param {*} value The value to query.
         * @returns {string} Returns the `toStringTag`.
         */

        var getTag = baseGetTag; // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.

        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map()) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set()) != setTag || WeakMap && getTag(new WeakMap()) != weakMapTag) {
          getTag = function getTag(value) {
            var result = baseGetTag(value),
                Ctor = result == objectTag ? value.constructor : undefined$1,
                ctorString = Ctor ? toSource(Ctor) : '';

            if (ctorString) {
              switch (ctorString) {
                case dataViewCtorString:
                  return dataViewTag;

                case mapCtorString:
                  return mapTag;

                case promiseCtorString:
                  return promiseTag;

                case setCtorString:
                  return setTag;

                case weakMapCtorString:
                  return weakMapTag;
              }
            }

            return result;
          };
        }
        /**
         * Gets the view, applying any `transforms` to the `start` and `end` positions.
         *
         * @private
         * @param {number} start The start of the view.
         * @param {number} end The end of the view.
         * @param {Array} transforms The transformations to apply to the view.
         * @returns {Object} Returns an object containing the `start` and `end`
         *  positions of the view.
         */


        function getView(start, end, transforms) {
          var index = -1,
              length = transforms.length;

          while (++index < length) {
            var data = transforms[index],
                size = data.size;

            switch (data.type) {
              case 'drop':
                start += size;
                break;

              case 'dropRight':
                end -= size;
                break;

              case 'take':
                end = nativeMin(end, start + size);
                break;

              case 'takeRight':
                start = nativeMax(start, end - size);
                break;
            }
          }

          return {
            'start': start,
            'end': end
          };
        }
        /**
         * Extracts wrapper details from the `source` body comment.
         *
         * @private
         * @param {string} source The source to inspect.
         * @returns {Array} Returns the wrapper details.
         */


        function getWrapDetails(source) {
          var match = source.match(reWrapDetails);
          return match ? match[1].split(reSplitDetails) : [];
        }
        /**
         * Checks if `path` exists on `object`.
         *
         * @private
         * @param {Object} object The object to query.
         * @param {Array|string} path The path to check.
         * @param {Function} hasFunc The function to check properties.
         * @returns {boolean} Returns `true` if `path` exists, else `false`.
         */


        function hasPath(object, path, hasFunc) {
          path = castPath(path, object);
          var index = -1,
              length = path.length,
              result = false;

          while (++index < length) {
            var key = toKey(path[index]);

            if (!(result = object != null && hasFunc(object, key))) {
              break;
            }

            object = object[key];
          }

          if (result || ++index != length) {
            return result;
          }

          length = object == null ? 0 : object.length;
          return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
         * Initializes an array clone.
         *
         * @private
         * @param {Array} array The array to clone.
         * @returns {Array} Returns the initialized clone.
         */


        function initCloneArray(array) {
          var length = array.length,
              result = new array.constructor(length); // Add properties assigned by `RegExp#exec`.

          if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
            result.index = array.index;
            result.input = array.input;
          }

          return result;
        }
        /**
         * Initializes an object clone.
         *
         * @private
         * @param {Object} object The object to clone.
         * @returns {Object} Returns the initialized clone.
         */


        function initCloneObject(object) {
          return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
         * Initializes an object clone based on its `toStringTag`.
         *
         * **Note:** This function only supports cloning values with tags of
         * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
         *
         * @private
         * @param {Object} object The object to clone.
         * @param {string} tag The `toStringTag` of the object to clone.
         * @param {boolean} [isDeep] Specify a deep clone.
         * @returns {Object} Returns the initialized clone.
         */


        function initCloneByTag(object, tag, isDeep) {
          var Ctor = object.constructor;

          switch (tag) {
            case arrayBufferTag:
              return cloneArrayBuffer(object);

            case boolTag:
            case dateTag:
              return new Ctor(+object);

            case dataViewTag:
              return cloneDataView(object, isDeep);

            case float32Tag:
            case float64Tag:
            case int8Tag:
            case int16Tag:
            case int32Tag:
            case uint8Tag:
            case uint8ClampedTag:
            case uint16Tag:
            case uint32Tag:
              return cloneTypedArray(object, isDeep);

            case mapTag:
              return new Ctor();

            case numberTag:
            case stringTag:
              return new Ctor(object);

            case regexpTag:
              return cloneRegExp(object);

            case setTag:
              return new Ctor();

            case symbolTag:
              return cloneSymbol(object);
          }
        }
        /**
         * Inserts wrapper `details` in a comment at the top of the `source` body.
         *
         * @private
         * @param {string} source The source to modify.
         * @returns {Array} details The details to insert.
         * @returns {string} Returns the modified source.
         */


        function insertWrapDetails(source, details) {
          var length = details.length;

          if (!length) {
            return source;
          }

          var lastIndex = length - 1;
          details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
          details = details.join(length > 2 ? ', ' : ' ');
          return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
        }
        /**
         * Checks if `value` is a flattenable `arguments` object or array.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
         */


        function isFlattenable(value) {
          return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
         * Checks if `value` is a valid array-like index.
         *
         * @private
         * @param {*} value The value to check.
         * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
         * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
         */


        function isIndex(value, length) {
          var type = typeof value;
          length = length == null ? MAX_SAFE_INTEGER : length;
          return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
         * Checks if the given arguments are from an iteratee call.
         *
         * @private
         * @param {*} value The potential iteratee value argument.
         * @param {*} index The potential iteratee index or key argument.
         * @param {*} object The potential iteratee object argument.
         * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
         *  else `false`.
         */


        function isIterateeCall(value, index, object) {
          if (!isObject(object)) {
            return false;
          }

          var type = typeof index;

          if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) {
            return eq(object[index], value);
          }

          return false;
        }
        /**
         * Checks if `value` is a property name and not a property path.
         *
         * @private
         * @param {*} value The value to check.
         * @param {Object} [object] The object to query keys on.
         * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
         */


        function isKey(value, object) {
          if (isArray(value)) {
            return false;
          }

          var type = typeof value;

          if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) {
            return true;
          }

          return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
        }
        /**
         * Checks if `value` is suitable for use as unique object key.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
         */


        function isKeyable(value) {
          var type = typeof value;
          return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
        }
        /**
         * Checks if `func` has a lazy counterpart.
         *
         * @private
         * @param {Function} func The function to check.
         * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
         *  else `false`.
         */


        function isLaziable(func) {
          var funcName = getFuncName(func),
              other = lodash[funcName];

          if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
            return false;
          }

          if (func === other) {
            return true;
          }

          var data = getData(other);
          return !!data && func === data[0];
        }
        /**
         * Checks if `func` has its source masked.
         *
         * @private
         * @param {Function} func The function to check.
         * @returns {boolean} Returns `true` if `func` is masked, else `false`.
         */


        function isMasked(func) {
          return !!maskSrcKey && maskSrcKey in func;
        }
        /**
         * Checks if `func` is capable of being masked.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
         */


        var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
         * Checks if `value` is likely a prototype object.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
         */

        function isPrototype(value) {
          var Ctor = value && value.constructor,
              proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
          return value === proto;
        }
        /**
         * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` if suitable for strict
         *  equality comparisons, else `false`.
         */


        function isStrictComparable(value) {
          return value === value && !isObject(value);
        }
        /**
         * A specialized version of `matchesProperty` for source values suitable
         * for strict equality comparisons, i.e. `===`.
         *
         * @private
         * @param {string} key The key of the property to get.
         * @param {*} srcValue The value to match.
         * @returns {Function} Returns the new spec function.
         */


        function matchesStrictComparable(key, srcValue) {
          return function (object) {
            if (object == null) {
              return false;
            }

            return object[key] === srcValue && (srcValue !== undefined$1 || key in Object(object));
          };
        }
        /**
         * A specialized version of `_.memoize` which clears the memoized function's
         * cache when it exceeds `MAX_MEMOIZE_SIZE`.
         *
         * @private
         * @param {Function} func The function to have its output memoized.
         * @returns {Function} Returns the new memoized function.
         */


        function memoizeCapped(func) {
          var result = memoize(func, function (key) {
            if (cache.size === MAX_MEMOIZE_SIZE) {
              cache.clear();
            }

            return key;
          });
          var cache = result.cache;
          return result;
        }
        /**
         * Merges the function metadata of `source` into `data`.
         *
         * Merging metadata reduces the number of wrappers used to invoke a function.
         * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
         * may be applied regardless of execution order. Methods like `_.ary` and
         * `_.rearg` modify function arguments, making the order in which they are
         * executed important, preventing the merging of metadata. However, we make
         * an exception for a safe combined case where curried functions have `_.ary`
         * and or `_.rearg` applied.
         *
         * @private
         * @param {Array} data The destination metadata.
         * @param {Array} source The source metadata.
         * @returns {Array} Returns `data`.
         */


        function mergeData(data, source) {
          var bitmask = data[1],
              srcBitmask = source[1],
              newBitmask = bitmask | srcBitmask,
              isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
          var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG; // Exit early if metadata can't be merged.

          if (!(isCommon || isCombo)) {
            return data;
          } // Use source `thisArg` if available.


          if (srcBitmask & WRAP_BIND_FLAG) {
            data[2] = source[2]; // Set when currying a bound function.

            newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
          } // Compose partial arguments.


          var value = source[3];

          if (value) {
            var partials = data[3];
            data[3] = partials ? composeArgs(partials, value, source[4]) : value;
            data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
          } // Compose partial right arguments.


          value = source[5];

          if (value) {
            partials = data[5];
            data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
            data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
          } // Use source `argPos` if available.


          value = source[7];

          if (value) {
            data[7] = value;
          } // Use source `ary` if it's smaller.


          if (srcBitmask & WRAP_ARY_FLAG) {
            data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
          } // Use source `arity` if one is not provided.


          if (data[9] == null) {
            data[9] = source[9];
          } // Use source `func` and merge bitmasks.


          data[0] = source[0];
          data[1] = newBitmask;
          return data;
        }
        /**
         * This function is like
         * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
         * except that it includes inherited enumerable properties.
         *
         * @private
         * @param {Object} object The object to query.
         * @returns {Array} Returns the array of property names.
         */


        function nativeKeysIn(object) {
          var result = [];

          if (object != null) {
            for (var key in Object(object)) {
              result.push(key);
            }
          }

          return result;
        }
        /**
         * Converts `value` to a string using `Object.prototype.toString`.
         *
         * @private
         * @param {*} value The value to convert.
         * @returns {string} Returns the converted string.
         */


        function objectToString(value) {
          return nativeObjectToString.call(value);
        }
        /**
         * A specialized version of `baseRest` which transforms the rest array.
         *
         * @private
         * @param {Function} func The function to apply a rest parameter to.
         * @param {number} [start=func.length-1] The start position of the rest parameter.
         * @param {Function} transform The rest array transform.
         * @returns {Function} Returns the new function.
         */


        function overRest(func, start, transform) {
          start = nativeMax(start === undefined$1 ? func.length - 1 : start, 0);
          return function () {
            var args = arguments,
                index = -1,
                length = nativeMax(args.length - start, 0),
                array = Array(length);

            while (++index < length) {
              array[index] = args[start + index];
            }

            index = -1;
            var otherArgs = Array(start + 1);

            while (++index < start) {
              otherArgs[index] = args[index];
            }

            otherArgs[start] = transform(array);
            return apply(func, this, otherArgs);
          };
        }
        /**
         * Gets the parent value at `path` of `object`.
         *
         * @private
         * @param {Object} object The object to query.
         * @param {Array} path The path to get the parent value of.
         * @returns {*} Returns the parent value.
         */


        function parent(object, path) {
          return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
         * Reorder `array` according to the specified indexes where the element at
         * the first index is assigned as the first element, the element at
         * the second index is assigned as the second element, and so on.
         *
         * @private
         * @param {Array} array The array to reorder.
         * @param {Array} indexes The arranged array indexes.
         * @returns {Array} Returns `array`.
         */


        function reorder(array, indexes) {
          var arrLength = array.length,
              length = nativeMin(indexes.length, arrLength),
              oldArray = copyArray(array);

          while (length--) {
            var index = indexes[length];
            array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined$1;
          }

          return array;
        }
        /**
         * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
         *
         * @private
         * @param {Object} object The object to query.
         * @param {string} key The key of the property to get.
         * @returns {*} Returns the property value.
         */


        function safeGet(object, key) {
          if (key === 'constructor' && typeof object[key] === 'function') {
            return;
          }

          if (key == '__proto__') {
            return;
          }

          return object[key];
        }
        /**
         * Sets metadata for `func`.
         *
         * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
         * period of time, it will trip its breaker and transition to an identity
         * function to avoid garbage collection pauses in V8. See
         * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
         * for more details.
         *
         * @private
         * @param {Function} func The function to associate metadata with.
         * @param {*} data The metadata.
         * @returns {Function} Returns `func`.
         */


        var setData = shortOut(baseSetData);
        /**
         * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
         *
         * @private
         * @param {Function} func The function to delay.
         * @param {number} wait The number of milliseconds to delay invocation.
         * @returns {number|Object} Returns the timer id or timeout object.
         */

        var setTimeout = ctxSetTimeout || function (func, wait) {
          return root.setTimeout(func, wait);
        };
        /**
         * Sets the `toString` method of `func` to return `string`.
         *
         * @private
         * @param {Function} func The function to modify.
         * @param {Function} string The `toString` result.
         * @returns {Function} Returns `func`.
         */


        var setToString = shortOut(baseSetToString);
        /**
         * Sets the `toString` method of `wrapper` to mimic the source of `reference`
         * with wrapper details in a comment at the top of the source body.
         *
         * @private
         * @param {Function} wrapper The function to modify.
         * @param {Function} reference The reference function.
         * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
         * @returns {Function} Returns `wrapper`.
         */

        function setWrapToString(wrapper, reference, bitmask) {
          var source = reference + '';
          return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
         * Creates a function that'll short out and invoke `identity` instead
         * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
         * milliseconds.
         *
         * @private
         * @param {Function} func The function to restrict.
         * @returns {Function} Returns the new shortable function.
         */


        function shortOut(func) {
          var count = 0,
              lastCalled = 0;
          return function () {
            var stamp = nativeNow(),
                remaining = HOT_SPAN - (stamp - lastCalled);
            lastCalled = stamp;

            if (remaining > 0) {
              if (++count >= HOT_COUNT) {
                return arguments[0];
              }
            } else {
              count = 0;
            }

            return func.apply(undefined$1, arguments);
          };
        }
        /**
         * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
         *
         * @private
         * @param {Array} array The array to shuffle.
         * @param {number} [size=array.length] The size of `array`.
         * @returns {Array} Returns `array`.
         */


        function shuffleSelf(array, size) {
          var index = -1,
              length = array.length,
              lastIndex = length - 1;
          size = size === undefined$1 ? length : size;

          while (++index < size) {
            var rand = baseRandom(index, lastIndex),
                value = array[rand];
            array[rand] = array[index];
            array[index] = value;
          }

          array.length = size;
          return array;
        }
        /**
         * Converts `string` to a property path array.
         *
         * @private
         * @param {string} string The string to convert.
         * @returns {Array} Returns the property path array.
         */


        var stringToPath = memoizeCapped(function (string) {
          var result = [];

          if (string.charCodeAt(0) === 46
          /* . */
          ) {
            result.push('');
          }

          string.replace(rePropName, function (match, number, quote, subString) {
            result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
          });
          return result;
        });
        /**
         * Converts `value` to a string key if it's not a string or symbol.
         *
         * @private
         * @param {*} value The value to inspect.
         * @returns {string|symbol} Returns the key.
         */

        function toKey(value) {
          if (typeof value == 'string' || isSymbol(value)) {
            return value;
          }

          var result = value + '';
          return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
         * Converts `func` to its source code.
         *
         * @private
         * @param {Function} func The function to convert.
         * @returns {string} Returns the source code.
         */


        function toSource(func) {
          if (func != null) {
            try {
              return funcToString.call(func);
            } catch (e) {}

            try {
              return func + '';
            } catch (e) {}
          }

          return '';
        }
        /**
         * Updates wrapper `details` based on `bitmask` flags.
         *
         * @private
         * @returns {Array} details The details to modify.
         * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
         * @returns {Array} Returns `details`.
         */


        function updateWrapDetails(details, bitmask) {
          arrayEach(wrapFlags, function (pair) {
            var value = '_.' + pair[0];

            if (bitmask & pair[1] && !arrayIncludes(details, value)) {
              details.push(value);
            }
          });
          return details.sort();
        }
        /**
         * Creates a clone of `wrapper`.
         *
         * @private
         * @param {Object} wrapper The wrapper to clone.
         * @returns {Object} Returns the cloned wrapper.
         */


        function wrapperClone(wrapper) {
          if (wrapper instanceof LazyWrapper) {
            return wrapper.clone();
          }

          var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
          result.__actions__ = copyArray(wrapper.__actions__);
          result.__index__ = wrapper.__index__;
          result.__values__ = wrapper.__values__;
          return result;
        }
        /*------------------------------------------------------------------------*/

        /**
         * Creates an array of elements split into groups the length of `size`.
         * If `array` can't be split evenly, the final chunk will be the remaining
         * elements.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Array
         * @param {Array} array The array to process.
         * @param {number} [size=1] The length of each chunk
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
         * @returns {Array} Returns the new array of chunks.
         * @example
         *
         * _.chunk(['a', 'b', 'c', 'd'], 2);
         * // => [['a', 'b'], ['c', 'd']]
         *
         * _.chunk(['a', 'b', 'c', 'd'], 3);
         * // => [['a', 'b', 'c'], ['d']]
         */


        function chunk(array, size, guard) {
          if (guard ? isIterateeCall(array, size, guard) : size === undefined$1) {
            size = 1;
          } else {
            size = nativeMax(toInteger(size), 0);
          }

          var length = array == null ? 0 : array.length;

          if (!length || size < 1) {
            return [];
          }

          var index = 0,
              resIndex = 0,
              result = Array(nativeCeil(length / size));

          while (index < length) {
            result[resIndex++] = baseSlice(array, index, index += size);
          }

          return result;
        }
        /**
         * Creates an array with all falsey values removed. The values `false`, `null`,
         * `0`, `""`, `undefined`, and `NaN` are falsey.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Array
         * @param {Array} array The array to compact.
         * @returns {Array} Returns the new array of filtered values.
         * @example
         *
         * _.compact([0, 1, false, 2, '', 3]);
         * // => [1, 2, 3]
         */


        function compact(array) {
          var index = -1,
              length = array == null ? 0 : array.length,
              resIndex = 0,
              result = [];

          while (++index < length) {
            var value = array[index];

            if (value) {
              result[resIndex++] = value;
            }
          }

          return result;
        }
        /**
         * Creates a new array concatenating `array` with any additional arrays
         * and/or values.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {Array} array The array to concatenate.
         * @param {...*} [values] The values to concatenate.
         * @returns {Array} Returns the new concatenated array.
         * @example
         *
         * var array = [1];
         * var other = _.concat(array, 2, [3], [[4]]);
         *
         * console.log(other);
         * // => [1, 2, 3, [4]]
         *
         * console.log(array);
         * // => [1]
         */


        function concat() {
          var length = arguments.length;

          if (!length) {
            return [];
          }

          var args = Array(length - 1),
              array = arguments[0],
              index = length;

          while (index--) {
            args[index - 1] = arguments[index];
          }

          return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
        }
        /**
         * Creates an array of `array` values not included in the other given arrays
         * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
         * for equality comparisons. The order and references of result values are
         * determined by the first array.
         *
         * **Note:** Unlike `_.pullAll`, this method returns a new array.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Array
         * @param {Array} array The array to inspect.
         * @param {...Array} [values] The values to exclude.
         * @returns {Array} Returns the new array of filtered values.
         * @see _.without, _.xor
         * @example
         *
         * _.difference([2, 1], [2, 3]);
         * // => [1]
         */


        var difference = baseRest(function (array, values) {
          return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
         * This method is like `_.difference` except that it accepts `iteratee` which
         * is invoked for each element of `array` and `values` to generate the criterion
         * by which they're compared. The order and references of result values are
         * determined by the first array. The iteratee is invoked with one argument:
         * (value).
         *
         * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {Array} array The array to inspect.
         * @param {...Array} [values] The values to exclude.
         * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
         * @returns {Array} Returns the new array of filtered values.
         * @example
         *
         * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
         * // => [1.2]
         *
         * // The `_.property` iteratee shorthand.
         * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
         * // => [{ 'x': 2 }]
         */

        var differenceBy = baseRest(function (array, values) {
          var iteratee = last(values);

          if (isArrayLikeObject(iteratee)) {
            iteratee = undefined$1;
          }

          return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
         * This method is like `_.difference` except that it accepts `comparator`
         * which is invoked to compare elements of `array` to `values`. The order and
         * references of result values are determined by the first array. The comparator
         * is invoked with two arguments: (arrVal, othVal).
         *
         * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {Array} array The array to inspect.
         * @param {...Array} [values] The values to exclude.
         * @param {Function} [comparator] The comparator invoked per element.
         * @returns {Array} Returns the new array of filtered values.
         * @example
         *
         * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
         *
         * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
         * // => [{ 'x': 2, 'y': 1 }]
         */

        var differenceWith = baseRest(function (array, values) {
          var comparator = last(values);

          if (isArrayLikeObject(comparator)) {
            comparator = undefined$1;
          }

          return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined$1, comparator) : [];
        });
        /**
         * Creates a slice of `array` with `n` elements dropped from the beginning.
         *
         * @static
         * @memberOf _
         * @since 0.5.0
         * @category Array
         * @param {Array} array The array to query.
         * @param {number} [n=1] The number of elements to drop.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
         * @returns {Array} Returns the slice of `array`.
         * @example
         *
         * _.drop([1, 2, 3]);
         * // => [2, 3]
         *
         * _.drop([1, 2, 3], 2);
         * // => [3]
         *
         * _.drop([1, 2, 3], 5);
         * // => []
         *
         * _.drop([1, 2, 3], 0);
         * // => [1, 2, 3]
         */

        function drop(array, n, guard) {
          var length = array == null ? 0 : array.length;

          if (!length) {
            return [];
          }

          n = guard || n === undefined$1 ? 1 : toInteger(n);
          return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
         * Creates a slice of `array` with `n` elements dropped from the end.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Array
         * @param {Array} array The array to query.
         * @param {number} [n=1] The number of elements to drop.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
         * @returns {Array} Returns the slice of `array`.
         * @example
         *
         * _.dropRight([1, 2, 3]);
         * // => [1, 2]
         *
         * _.dropRight([1, 2, 3], 2);
         * // => [1]
         *
         * _.dropRight([1, 2, 3], 5);
         * // => []
         *
         * _.dropRight([1, 2, 3], 0);
         * // => [1, 2, 3]
         */


        function dropRight(array, n, guard) {
          var length = array == null ? 0 : array.length;

          if (!length) {
            return [];
          }

          n = guard || n === undefined$1 ? 1 : toInteger(n);
          n = length - n;
          return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
         * Creates a slice of `array` excluding elements dropped from the end.
         * Elements are dropped until `predicate` returns falsey. The predicate is
         * invoked with three arguments: (value, index, array).
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Array
         * @param {Array} array The array to query.
         * @param {Function} [predicate=_.identity] The function invoked per iteration.
         * @returns {Array} Returns the slice of `array`.
         * @example
         *
         * var users = [
         *   { 'user': 'barney',  'active': true },
         *   { 'user': 'fred',    'active': false },
         *   { 'user': 'pebbles', 'active': false }
         * ];
         *
         * _.dropRightWhile(users, function(o) { return !o.active; });
         * // => objects for ['barney']
         *
         * // The `_.matches` iteratee shorthand.
         * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
         * // => objects for ['barney', 'fred']
         *
         * // The `_.matchesProperty` iteratee shorthand.
         * _.dropRightWhile(users, ['active', false]);
         * // => objects for ['barney']
         *
         * // The `_.property` iteratee shorthand.
         * _.dropRightWhile(users, 'active');
         * // => objects for ['barney', 'fred', 'pebbles']
         */


        function dropRightWhile(array, predicate) {
          return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
         * Creates a slice of `array` excluding elements dropped from the beginning.
         * Elements are dropped until `predicate` returns falsey. The predicate is
         * invoked with three arguments: (value, index, array).
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Array
         * @param {Array} array The array to query.
         * @param {Function} [predicate=_.identity] The function invoked per iteration.
         * @returns {Array} Returns the slice of `array`.
         * @example
         *
         * var users = [
         *   { 'user': 'barney',  'active': false },
         *   { 'user': 'fred',    'active': false },
         *   { 'user': 'pebbles', 'active': true }
         * ];
         *
         * _.dropWhile(users, function(o) { return !o.active; });
         * // => objects for ['pebbles']
         *
         * // The `_.matches` iteratee shorthand.
         * _.dropWhile(users, { 'user': 'barney', 'active': false });
         * // => objects for ['fred', 'pebbles']
         *
         * // The `_.matchesProperty` iteratee shorthand.
         * _.dropWhile(users, ['active', false]);
         * // => objects for ['pebbles']
         *
         * // The `_.property` iteratee shorthand.
         * _.dropWhile(users, 'active');
         * // => objects for ['barney', 'fred', 'pebbles']
         */


        function dropWhile(array, predicate) {
          return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
         * Fills elements of `array` with `value` from `start` up to, but not
         * including, `end`.
         *
         * **Note:** This method mutates `array`.
         *
         * @static
         * @memberOf _
         * @since 3.2.0
         * @category Array
         * @param {Array} array The array to fill.
         * @param {*} value The value to fill `array` with.
         * @param {number} [start=0] The start position.
         * @param {number} [end=array.length] The end position.
         * @returns {Array} Returns `array`.
         * @example
         *
         * var array = [1, 2, 3];
         *
         * _.fill(array, 'a');
         * console.log(array);
         * // => ['a', 'a', 'a']
         *
         * _.fill(Array(3), 2);
         * // => [2, 2, 2]
         *
         * _.fill([4, 6, 8, 10], '*', 1, 3);
         * // => [4, '*', '*', 10]
         */


        function fill(array, value, start, end) {
          var length = array == null ? 0 : array.length;

          if (!length) {
            return [];
          }

          if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
            start = 0;
            end = length;
          }

          return baseFill(array, value, start, end);
        }
        /**
         * This method is like `_.find` except that it returns the index of the first
         * element `predicate` returns truthy for instead of the element itself.
         *
         * @static
         * @memberOf _
         * @since 1.1.0
         * @category Array
         * @param {Array} array The array to inspect.
         * @param {Function} [predicate=_.identity] The function invoked per iteration.
         * @param {number} [fromIndex=0] The index to search from.
         * @returns {number} Returns the index of the found element, else `-1`.
         * @example
         *
         * var users = [
         *   { 'user': 'barney',  'active': false },
         *   { 'user': 'fred',    'active': false },
         *   { 'user': 'pebbles', 'active': true }
         * ];
         *
         * _.findIndex(users, function(o) { return o.user == 'barney'; });
         * // => 0
         *
         * // The `_.matches` iteratee shorthand.
         * _.findIndex(users, { 'user': 'fred', 'active': false });
         * // => 1
         *
         * // The `_.matchesProperty` iteratee shorthand.
         * _.findIndex(users, ['active', false]);
         * // => 0
         *
         * // The `_.property` iteratee shorthand.
         * _.findIndex(users, 'active');
         * // => 2
         */


        function findIndex(array, predicate, fromIndex) {
          var length = array == null ? 0 : array.length;

          if (!length) {
            return -1;
          }

          var index = fromIndex == null ? 0 : toInteger(fromIndex);

          if (index < 0) {
            index = nativeMax(length + index, 0);
          }

          return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
         * This method is like `_.findIndex` except that it iterates over elements
         * of `collection` from right to left.
         *
         * @static
         * @memberOf _
         * @since 2.0.0
         * @category Array
         * @param {Array} array The array to inspect.
         * @param {Function} [predicate=_.identity] The function invoked per iteration.
         * @param {number} [fromIndex=array.length-1] The index to search from.
         * @returns {number} Returns the index of the found element, else `-1`.
         * @example
         *
         * var users = [
         *   { 'user': 'barney',  'active': true },
         *   { 'user': 'fred',    'active': false },
         *   { 'user': 'pebbles', 'active': false }
         * ];
         *
         * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
         * // => 2
         *
         * // The `_.matches` iteratee shorthand.
         * _.findLastIndex(users, { 'user': 'barney', 'active': true });
         * // => 0
         *
         * // The `_.matchesProperty` iteratee shorthand.
         * _.findLastIndex(users, ['active', false]);
         * // => 2
         *
         * // The `_.property` iteratee shorthand.
         * _.findLastIndex(users, 'active');
         * // => 0
         */


        function findLastIndex(array, predicate, fromIndex) {
          var length = array == null ? 0 : array.length;

          if (!length) {
            return -1;
          }

          var index = length - 1;

          if (fromIndex !== undefined$1) {
            index = toInteger(fromIndex);
            index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
          }

          return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
         * Flattens `array` a single level deep.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Array
         * @param {Array} array The array to flatten.
         * @returns {Array} Returns the new flattened array.
         * @example
         *
         * _.flatten([1, [2, [3, [4]], 5]]);
         * // => [1, 2, [3, [4]], 5]
         */


        function flatten(array) {
          var length = array == null ? 0 : array.length;
          return length ? baseFlatten(array, 1) : [];
        }
        /**
         * Recursively flattens `array`.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Array
         * @param {Array} array The array to flatten.
         * @returns {Array} Returns the new flattened array.
         * @example
         *
         * _.flattenDeep([1, [2, [3, [4]], 5]]);
         * // => [1, 2, 3, 4, 5]
         */


        function flattenDeep(array) {
          var length = array == null ? 0 : array.length;
          return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
         * Recursively flatten `array` up to `depth` times.
         *
         * @static
         * @memberOf _
         * @since 4.4.0
         * @category Array
         * @param {Array} array The array to flatten.
         * @param {number} [depth=1] The maximum recursion depth.
         * @returns {Array} Returns the new flattened array.
         * @example
         *
         * var array = [1, [2, [3, [4]], 5]];
         *
         * _.flattenDepth(array, 1);
         * // => [1, 2, [3, [4]], 5]
         *
         * _.flattenDepth(array, 2);
         * // => [1, 2, 3, [4], 5]
         */


        function flattenDepth(array, depth) {
          var length = array == null ? 0 : array.length;

          if (!length) {
            return [];
          }

          depth = depth === undefined$1 ? 1 : toInteger(depth);
          return baseFlatten(array, depth);
        }
        /**
         * The inverse of `_.toPairs`; this method returns an object composed
         * from key-value `pairs`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {Array} pairs The key-value pairs.
         * @returns {Object} Returns the new object.
         * @example
         *
         * _.fromPairs([['a', 1], ['b', 2]]);
         * // => { 'a': 1, 'b': 2 }
         */


        function fromPairs(pairs) {
          var index = -1,
              length = pairs == null ? 0 : pairs.length,
              result = {};

          while (++index < length) {
            var pair = pairs[index];
            result[pair[0]] = pair[1];
          }

          return result;
        }
        /**
         * Gets the first element of `array`.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @alias first
         * @category Array
         * @param {Array} array The array to query.
         * @returns {*} Returns the first element of `array`.
         * @example
         *
         * _.head([1, 2, 3]);
         * // => 1
         *
         * _.head([]);
         * // => undefined
         */


        function head(array) {
          return array && array.length ? array[0] : undefined$1;
        }
        /**
         * Gets the index at which the first occurrence of `value` is found in `array`
         * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
         * for equality comparisons. If `fromIndex` is negative, it's used as the
         * offset from the end of `array`.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Array
         * @param {Array} array The array to inspect.
         * @param {*} value The value to search for.
         * @param {number} [fromIndex=0] The index to search from.
         * @returns {number} Returns the index of the matched value, else `-1`.
         * @example
         *
         * _.indexOf([1, 2, 1, 2], 2);
         * // => 1
         *
         * // Search from the `fromIndex`.
         * _.indexOf([1, 2, 1, 2], 2, 2);
         * // => 3
         */


        function indexOf(array, value, fromIndex) {
          var length = array == null ? 0 : array.length;

          if (!length) {
            return -1;
          }

          var index = fromIndex == null ? 0 : toInteger(fromIndex);

          if (index < 0) {
            index = nativeMax(length + index, 0);
          }

          return baseIndexOf(array, value, index);
        }
        /**
         * Gets all but the last element of `array`.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Array
         * @param {Array} array The array to query.
         * @returns {Array} Returns the slice of `array`.
         * @example
         *
         * _.initial([1, 2, 3]);
         * // => [1, 2]
         */


        function initial(array) {
          var length = array == null ? 0 : array.length;
          return length ? baseSlice(array, 0, -1) : [];
        }
        /**
         * Creates an array of unique values that are included in all given arrays
         * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
         * for equality comparisons. The order and references of result values are
         * determined by the first array.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Array
         * @param {...Array} [arrays] The arrays to inspect.
         * @returns {Array} Returns the new array of intersecting values.
         * @example
         *
         * _.intersection([2, 1], [2, 3]);
         * // => [2]
         */


        var intersection = baseRest(function (arrays) {
          var mapped = arrayMap(arrays, castArrayLikeObject);
          return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
         * This method is like `_.intersection` except that it accepts `iteratee`
         * which is invoked for each element of each `arrays` to generate the criterion
         * by which they're compared. The order and references of result values are
         * determined by the first array. The iteratee is invoked with one argument:
         * (value).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {...Array} [arrays] The arrays to inspect.
         * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
         * @returns {Array} Returns the new array of intersecting values.
         * @example
         *
         * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
         * // => [2.1]
         *
         * // The `_.property` iteratee shorthand.
         * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
         * // => [{ 'x': 1 }]
         */

        var intersectionBy = baseRest(function (arrays) {
          var iteratee = last(arrays),
              mapped = arrayMap(arrays, castArrayLikeObject);

          if (iteratee === last(mapped)) {
            iteratee = undefined$1;
          } else {
            mapped.pop();
          }

          return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
         * This method is like `_.intersection` except that it accepts `comparator`
         * which is invoked to compare elements of `arrays`. The order and references
         * of result values are determined by the first array. The comparator is
         * invoked with two arguments: (arrVal, othVal).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {...Array} [arrays] The arrays to inspect.
         * @param {Function} [comparator] The comparator invoked per element.
         * @returns {Array} Returns the new array of intersecting values.
         * @example
         *
         * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
         * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
         *
         * _.intersectionWith(objects, others, _.isEqual);
         * // => [{ 'x': 1, 'y': 2 }]
         */

        var intersectionWith = baseRest(function (arrays) {
          var comparator = last(arrays),
              mapped = arrayMap(arrays, castArrayLikeObject);
          comparator = typeof comparator == 'function' ? comparator : undefined$1;

          if (comparator) {
            mapped.pop();
          }

          return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined$1, comparator) : [];
        });
        /**
         * Converts all elements in `array` into a string separated by `separator`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {Array} array The array to convert.
         * @param {string} [separator=','] The element separator.
         * @returns {string} Returns the joined string.
         * @example
         *
         * _.join(['a', 'b', 'c'], '~');
         * // => 'a~b~c'
         */

        function join(array, separator) {
          return array == null ? '' : nativeJoin.call(array, separator);
        }
        /**
         * Gets the last element of `array`.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Array
         * @param {Array} array The array to query.
         * @returns {*} Returns the last element of `array`.
         * @example
         *
         * _.last([1, 2, 3]);
         * // => 3
         */


        function last(array) {
          var length = array == null ? 0 : array.length;
          return length ? array[length - 1] : undefined$1;
        }
        /**
         * This method is like `_.indexOf` except that it iterates over elements of
         * `array` from right to left.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Array
         * @param {Array} array The array to inspect.
         * @param {*} value The value to search for.
         * @param {number} [fromIndex=array.length-1] The index to search from.
         * @returns {number} Returns the index of the matched value, else `-1`.
         * @example
         *
         * _.lastIndexOf([1, 2, 1, 2], 2);
         * // => 3
         *
         * // Search from the `fromIndex`.
         * _.lastIndexOf([1, 2, 1, 2], 2, 2);
         * // => 1
         */


        function lastIndexOf(array, value, fromIndex) {
          var length = array == null ? 0 : array.length;

          if (!length) {
            return -1;
          }

          var index = length;

          if (fromIndex !== undefined$1) {
            index = toInteger(fromIndex);
            index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
          }

          return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
         * Gets the element at index `n` of `array`. If `n` is negative, the nth
         * element from the end is returned.
         *
         * @static
         * @memberOf _
         * @since 4.11.0
         * @category Array
         * @param {Array} array The array to query.
         * @param {number} [n=0] The index of the element to return.
         * @returns {*} Returns the nth element of `array`.
         * @example
         *
         * var array = ['a', 'b', 'c', 'd'];
         *
         * _.nth(array, 1);
         * // => 'b'
         *
         * _.nth(array, -2);
         * // => 'c';
         */


        function nth(array, n) {
          return array && array.length ? baseNth(array, toInteger(n)) : undefined$1;
        }
        /**
         * Removes all given values from `array` using
         * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
         * for equality comparisons.
         *
         * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
         * to remove elements from an array by predicate.
         *
         * @static
         * @memberOf _
         * @since 2.0.0
         * @category Array
         * @param {Array} array The array to modify.
         * @param {...*} [values] The values to remove.
         * @returns {Array} Returns `array`.
         * @example
         *
         * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
         *
         * _.pull(array, 'a', 'c');
         * console.log(array);
         * // => ['b', 'b']
         */


        var pull = baseRest(pullAll);
        /**
         * This method is like `_.pull` except that it accepts an array of values to remove.
         *
         * **Note:** Unlike `_.difference`, this method mutates `array`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {Array} array The array to modify.
         * @param {Array} values The values to remove.
         * @returns {Array} Returns `array`.
         * @example
         *
         * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
         *
         * _.pullAll(array, ['a', 'c']);
         * console.log(array);
         * // => ['b', 'b']
         */

        function pullAll(array, values) {
          return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
         * This method is like `_.pullAll` except that it accepts `iteratee` which is
         * invoked for each element of `array` and `values` to generate the criterion
         * by which they're compared. The iteratee is invoked with one argument: (value).
         *
         * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {Array} array The array to modify.
         * @param {Array} values The values to remove.
         * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
         * @returns {Array} Returns `array`.
         * @example
         *
         * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
         *
         * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
         * console.log(array);
         * // => [{ 'x': 2 }]
         */


        function pullAllBy(array, values, iteratee) {
          return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
         * This method is like `_.pullAll` except that it accepts `comparator` which
         * is invoked to compare elements of `array` to `values`. The comparator is
         * invoked with two arguments: (arrVal, othVal).
         *
         * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
         *
         * @static
         * @memberOf _
         * @since 4.6.0
         * @category Array
         * @param {Array} array The array to modify.
         * @param {Array} values The values to remove.
         * @param {Function} [comparator] The comparator invoked per element.
         * @returns {Array} Returns `array`.
         * @example
         *
         * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
         *
         * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
         * console.log(array);
         * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
         */


        function pullAllWith(array, values, comparator) {
          return array && array.length && values && values.length ? basePullAll(array, values, undefined$1, comparator) : array;
        }
        /**
         * Removes elements from `array` corresponding to `indexes` and returns an
         * array of removed elements.
         *
         * **Note:** Unlike `_.at`, this method mutates `array`.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Array
         * @param {Array} array The array to modify.
         * @param {...(number|number[])} [indexes] The indexes of elements to remove.
         * @returns {Array} Returns the new array of removed elements.
         * @example
         *
         * var array = ['a', 'b', 'c', 'd'];
         * var pulled = _.pullAt(array, [1, 3]);
         *
         * console.log(array);
         * // => ['a', 'c']
         *
         * console.log(pulled);
         * // => ['b', 'd']
         */


        var pullAt = flatRest(function (array, indexes) {
          var length = array == null ? 0 : array.length,
              result = baseAt(array, indexes);
          basePullAt(array, arrayMap(indexes, function (index) {
            return isIndex(index, length) ? +index : index;
          }).sort(compareAscending));
          return result;
        });
        /**
         * Removes all elements from `array` that `predicate` returns truthy for
         * and returns an array of the removed elements. The predicate is invoked
         * with three arguments: (value, index, array).
         *
         * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
         * to pull elements from an array by value.
         *
         * @static
         * @memberOf _
         * @since 2.0.0
         * @category Array
         * @param {Array} array The array to modify.
         * @param {Function} [predicate=_.identity] The function invoked per iteration.
         * @returns {Array} Returns the new array of removed elements.
         * @example
         *
         * var array = [1, 2, 3, 4];
         * var evens = _.remove(array, function(n) {
         *   return n % 2 == 0;
         * });
         *
         * console.log(array);
         * // => [1, 3]
         *
         * console.log(evens);
         * // => [2, 4]
         */

        function remove(array, predicate) {
          var result = [];

          if (!(array && array.length)) {
            return result;
          }

          var index = -1,
              indexes = [],
              length = array.length;
          predicate = getIteratee(predicate, 3);

          while (++index < length) {
            var value = array[index];

            if (predicate(value, index, array)) {
              result.push(value);
              indexes.push(index);
            }
          }

          basePullAt(array, indexes);
          return result;
        }
        /**
         * Reverses `array` so that the first element becomes the last, the second
         * element becomes the second to last, and so on.
         *
         * **Note:** This method mutates `array` and is based on
         * [`Array#reverse`](https://mdn.io/Array/reverse).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {Array} array The array to modify.
         * @returns {Array} Returns `array`.
         * @example
         *
         * var array = [1, 2, 3];
         *
         * _.reverse(array);
         * // => [3, 2, 1]
         *
         * console.log(array);
         * // => [3, 2, 1]
         */


        function reverse(array) {
          return array == null ? array : nativeReverse.call(array);
        }
        /**
         * Creates a slice of `array` from `start` up to, but not including, `end`.
         *
         * **Note:** This method is used instead of
         * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
         * returned.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Array
         * @param {Array} array The array to slice.
         * @param {number} [start=0] The start position.
         * @param {number} [end=array.length] The end position.
         * @returns {Array} Returns the slice of `array`.
         */


        function slice(array, start, end) {
          var length = array == null ? 0 : array.length;

          if (!length) {
            return [];
          }

          if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
            start = 0;
            end = length;
          } else {
            start = start == null ? 0 : toInteger(start);
            end = end === undefined$1 ? length : toInteger(end);
          }

          return baseSlice(array, start, end);
        }
        /**
         * Uses a binary search to determine the lowest index at which `value`
         * should be inserted into `array` in order to maintain its sort order.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Array
         * @param {Array} array The sorted array to inspect.
         * @param {*} value The value to evaluate.
         * @returns {number} Returns the index at which `value` should be inserted
         *  into `array`.
         * @example
         *
         * _.sortedIndex([30, 50], 40);
         * // => 1
         */


        function sortedIndex(array, value) {
          return baseSortedIndex(array, value);
        }
        /**
         * This method is like `_.sortedIndex` except that it accepts `iteratee`
         * which is invoked for `value` and each element of `array` to compute their
         * sort ranking. The iteratee is invoked with one argument: (value).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {Array} array The sorted array to inspect.
         * @param {*} value The value to evaluate.
         * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
         * @returns {number} Returns the index at which `value` should be inserted
         *  into `array`.
         * @example
         *
         * var objects = [{ 'x': 4 }, { 'x': 5 }];
         *
         * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
         * // => 0
         *
         * // The `_.property` iteratee shorthand.
         * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
         * // => 0
         */


        function sortedIndexBy(array, value, iteratee) {
          return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
         * This method is like `_.indexOf` except that it performs a binary
         * search on a sorted `array`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {Array} array The array to inspect.
         * @param {*} value The value to search for.
         * @returns {number} Returns the index of the matched value, else `-1`.
         * @example
         *
         * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
         * // => 1
         */


        function sortedIndexOf(array, value) {
          var length = array == null ? 0 : array.length;

          if (length) {
            var index = baseSortedIndex(array, value);

            if (index < length && eq(array[index], value)) {
              return index;
            }
          }

          return -1;
        }
        /**
         * This method is like `_.sortedIndex` except that it returns the highest
         * index at which `value` should be inserted into `array` in order to
         * maintain its sort order.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Array
         * @param {Array} array The sorted array to inspect.
         * @param {*} value The value to evaluate.
         * @returns {number} Returns the index at which `value` should be inserted
         *  into `array`.
         * @example
         *
         * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
         * // => 4
         */


        function sortedLastIndex(array, value) {
          return baseSortedIndex(array, value, true);
        }
        /**
         * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
         * which is invoked for `value` and each element of `array` to compute their
         * sort ranking. The iteratee is invoked with one argument: (value).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {Array} array The sorted array to inspect.
         * @param {*} value The value to evaluate.
         * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
         * @returns {number} Returns the index at which `value` should be inserted
         *  into `array`.
         * @example
         *
         * var objects = [{ 'x': 4 }, { 'x': 5 }];
         *
         * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
         * // => 1
         *
         * // The `_.property` iteratee shorthand.
         * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
         * // => 1
         */


        function sortedLastIndexBy(array, value, iteratee) {
          return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
         * This method is like `_.lastIndexOf` except that it performs a binary
         * search on a sorted `array`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {Array} array The array to inspect.
         * @param {*} value The value to search for.
         * @returns {number} Returns the index of the matched value, else `-1`.
         * @example
         *
         * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
         * // => 3
         */


        function sortedLastIndexOf(array, value) {
          var length = array == null ? 0 : array.length;

          if (length) {
            var index = baseSortedIndex(array, value, true) - 1;

            if (eq(array[index], value)) {
              return index;
            }
          }

          return -1;
        }
        /**
         * This method is like `_.uniq` except that it's designed and optimized
         * for sorted arrays.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {Array} array The array to inspect.
         * @returns {Array} Returns the new duplicate free array.
         * @example
         *
         * _.sortedUniq([1, 1, 2]);
         * // => [1, 2]
         */


        function sortedUniq(array) {
          return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
         * This method is like `_.uniqBy` except that it's designed and optimized
         * for sorted arrays.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {Array} array The array to inspect.
         * @param {Function} [iteratee] The iteratee invoked per element.
         * @returns {Array} Returns the new duplicate free array.
         * @example
         *
         * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
         * // => [1.1, 2.3]
         */


        function sortedUniqBy(array, iteratee) {
          return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
         * Gets all but the first element of `array`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {Array} array The array to query.
         * @returns {Array} Returns the slice of `array`.
         * @example
         *
         * _.tail([1, 2, 3]);
         * // => [2, 3]
         */


        function tail(array) {
          var length = array == null ? 0 : array.length;
          return length ? baseSlice(array, 1, length) : [];
        }
        /**
         * Creates a slice of `array` with `n` elements taken from the beginning.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Array
         * @param {Array} array The array to query.
         * @param {number} [n=1] The number of elements to take.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
         * @returns {Array} Returns the slice of `array`.
         * @example
         *
         * _.take([1, 2, 3]);
         * // => [1]
         *
         * _.take([1, 2, 3], 2);
         * // => [1, 2]
         *
         * _.take([1, 2, 3], 5);
         * // => [1, 2, 3]
         *
         * _.take([1, 2, 3], 0);
         * // => []
         */


        function take(array, n, guard) {
          if (!(array && array.length)) {
            return [];
          }

          n = guard || n === undefined$1 ? 1 : toInteger(n);
          return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
         * Creates a slice of `array` with `n` elements taken from the end.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Array
         * @param {Array} array The array to query.
         * @param {number} [n=1] The number of elements to take.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
         * @returns {Array} Returns the slice of `array`.
         * @example
         *
         * _.takeRight([1, 2, 3]);
         * // => [3]
         *
         * _.takeRight([1, 2, 3], 2);
         * // => [2, 3]
         *
         * _.takeRight([1, 2, 3], 5);
         * // => [1, 2, 3]
         *
         * _.takeRight([1, 2, 3], 0);
         * // => []
         */


        function takeRight(array, n, guard) {
          var length = array == null ? 0 : array.length;

          if (!length) {
            return [];
          }

          n = guard || n === undefined$1 ? 1 : toInteger(n);
          n = length - n;
          return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
         * Creates a slice of `array` with elements taken from the end. Elements are
         * taken until `predicate` returns falsey. The predicate is invoked with
         * three arguments: (value, index, array).
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Array
         * @param {Array} array The array to query.
         * @param {Function} [predicate=_.identity] The function invoked per iteration.
         * @returns {Array} Returns the slice of `array`.
         * @example
         *
         * var users = [
         *   { 'user': 'barney',  'active': true },
         *   { 'user': 'fred',    'active': false },
         *   { 'user': 'pebbles', 'active': false }
         * ];
         *
         * _.takeRightWhile(users, function(o) { return !o.active; });
         * // => objects for ['fred', 'pebbles']
         *
         * // The `_.matches` iteratee shorthand.
         * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
         * // => objects for ['pebbles']
         *
         * // The `_.matchesProperty` iteratee shorthand.
         * _.takeRightWhile(users, ['active', false]);
         * // => objects for ['fred', 'pebbles']
         *
         * // The `_.property` iteratee shorthand.
         * _.takeRightWhile(users, 'active');
         * // => []
         */


        function takeRightWhile(array, predicate) {
          return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
         * Creates a slice of `array` with elements taken from the beginning. Elements
         * are taken until `predicate` returns falsey. The predicate is invoked with
         * three arguments: (value, index, array).
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Array
         * @param {Array} array The array to query.
         * @param {Function} [predicate=_.identity] The function invoked per iteration.
         * @returns {Array} Returns the slice of `array`.
         * @example
         *
         * var users = [
         *   { 'user': 'barney',  'active': false },
         *   { 'user': 'fred',    'active': false },
         *   { 'user': 'pebbles', 'active': true }
         * ];
         *
         * _.takeWhile(users, function(o) { return !o.active; });
         * // => objects for ['barney', 'fred']
         *
         * // The `_.matches` iteratee shorthand.
         * _.takeWhile(users, { 'user': 'barney', 'active': false });
         * // => objects for ['barney']
         *
         * // The `_.matchesProperty` iteratee shorthand.
         * _.takeWhile(users, ['active', false]);
         * // => objects for ['barney', 'fred']
         *
         * // The `_.property` iteratee shorthand.
         * _.takeWhile(users, 'active');
         * // => []
         */


        function takeWhile(array, predicate) {
          return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
         * Creates an array of unique values, in order, from all given arrays using
         * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
         * for equality comparisons.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Array
         * @param {...Array} [arrays] The arrays to inspect.
         * @returns {Array} Returns the new array of combined values.
         * @example
         *
         * _.union([2], [1, 2]);
         * // => [2, 1]
         */


        var union = baseRest(function (arrays) {
          return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
         * This method is like `_.union` except that it accepts `iteratee` which is
         * invoked for each element of each `arrays` to generate the criterion by
         * which uniqueness is computed. Result values are chosen from the first
         * array in which the value occurs. The iteratee is invoked with one argument:
         * (value).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {...Array} [arrays] The arrays to inspect.
         * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
         * @returns {Array} Returns the new array of combined values.
         * @example
         *
         * _.unionBy([2.1], [1.2, 2.3], Math.floor);
         * // => [2.1, 1.2]
         *
         * // The `_.property` iteratee shorthand.
         * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
         * // => [{ 'x': 1 }, { 'x': 2 }]
         */

        var unionBy = baseRest(function (arrays) {
          var iteratee = last(arrays);

          if (isArrayLikeObject(iteratee)) {
            iteratee = undefined$1;
          }

          return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
         * This method is like `_.union` except that it accepts `comparator` which
         * is invoked to compare elements of `arrays`. Result values are chosen from
         * the first array in which the value occurs. The comparator is invoked
         * with two arguments: (arrVal, othVal).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {...Array} [arrays] The arrays to inspect.
         * @param {Function} [comparator] The comparator invoked per element.
         * @returns {Array} Returns the new array of combined values.
         * @example
         *
         * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
         * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
         *
         * _.unionWith(objects, others, _.isEqual);
         * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
         */

        var unionWith = baseRest(function (arrays) {
          var comparator = last(arrays);
          comparator = typeof comparator == 'function' ? comparator : undefined$1;
          return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined$1, comparator);
        });
        /**
         * Creates a duplicate-free version of an array, using
         * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
         * for equality comparisons, in which only the first occurrence of each element
         * is kept. The order of result values is determined by the order they occur
         * in the array.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Array
         * @param {Array} array The array to inspect.
         * @returns {Array} Returns the new duplicate free array.
         * @example
         *
         * _.uniq([2, 1, 2]);
         * // => [2, 1]
         */

        function uniq(array) {
          return array && array.length ? baseUniq(array) : [];
        }
        /**
         * This method is like `_.uniq` except that it accepts `iteratee` which is
         * invoked for each element in `array` to generate the criterion by which
         * uniqueness is computed. The order of result values is determined by the
         * order they occur in the array. The iteratee is invoked with one argument:
         * (value).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {Array} array The array to inspect.
         * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
         * @returns {Array} Returns the new duplicate free array.
         * @example
         *
         * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
         * // => [2.1, 1.2]
         *
         * // The `_.property` iteratee shorthand.
         * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
         * // => [{ 'x': 1 }, { 'x': 2 }]
         */


        function uniqBy(array, iteratee) {
          return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
         * This method is like `_.uniq` except that it accepts `comparator` which
         * is invoked to compare elements of `array`. The order of result values is
         * determined by the order they occur in the array.The comparator is invoked
         * with two arguments: (arrVal, othVal).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {Array} array The array to inspect.
         * @param {Function} [comparator] The comparator invoked per element.
         * @returns {Array} Returns the new duplicate free array.
         * @example
         *
         * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
         *
         * _.uniqWith(objects, _.isEqual);
         * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
         */


        function uniqWith(array, comparator) {
          comparator = typeof comparator == 'function' ? comparator : undefined$1;
          return array && array.length ? baseUniq(array, undefined$1, comparator) : [];
        }
        /**
         * This method is like `_.zip` except that it accepts an array of grouped
         * elements and creates an array regrouping the elements to their pre-zip
         * configuration.
         *
         * @static
         * @memberOf _
         * @since 1.2.0
         * @category Array
         * @param {Array} array The array of grouped elements to process.
         * @returns {Array} Returns the new array of regrouped elements.
         * @example
         *
         * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
         * // => [['a', 1, true], ['b', 2, false]]
         *
         * _.unzip(zipped);
         * // => [['a', 'b'], [1, 2], [true, false]]
         */


        function unzip(array) {
          if (!(array && array.length)) {
            return [];
          }

          var length = 0;
          array = arrayFilter(array, function (group) {
            if (isArrayLikeObject(group)) {
              length = nativeMax(group.length, length);
              return true;
            }
          });
          return baseTimes(length, function (index) {
            return arrayMap(array, baseProperty(index));
          });
        }
        /**
         * This method is like `_.unzip` except that it accepts `iteratee` to specify
         * how regrouped values should be combined. The iteratee is invoked with the
         * elements of each group: (...group).
         *
         * @static
         * @memberOf _
         * @since 3.8.0
         * @category Array
         * @param {Array} array The array of grouped elements to process.
         * @param {Function} [iteratee=_.identity] The function to combine
         *  regrouped values.
         * @returns {Array} Returns the new array of regrouped elements.
         * @example
         *
         * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
         * // => [[1, 10, 100], [2, 20, 200]]
         *
         * _.unzipWith(zipped, _.add);
         * // => [3, 30, 300]
         */


        function unzipWith(array, iteratee) {
          if (!(array && array.length)) {
            return [];
          }

          var result = unzip(array);

          if (iteratee == null) {
            return result;
          }

          return arrayMap(result, function (group) {
            return apply(iteratee, undefined$1, group);
          });
        }
        /**
         * Creates an array excluding all given values using
         * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
         * for equality comparisons.
         *
         * **Note:** Unlike `_.pull`, this method returns a new array.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Array
         * @param {Array} array The array to inspect.
         * @param {...*} [values] The values to exclude.
         * @returns {Array} Returns the new array of filtered values.
         * @see _.difference, _.xor
         * @example
         *
         * _.without([2, 1, 2, 3], 1, 2);
         * // => [3]
         */


        var without = baseRest(function (array, values) {
          return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
         * Creates an array of unique values that is the
         * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
         * of the given arrays. The order of result values is determined by the order
         * they occur in the arrays.
         *
         * @static
         * @memberOf _
         * @since 2.4.0
         * @category Array
         * @param {...Array} [arrays] The arrays to inspect.
         * @returns {Array} Returns the new array of filtered values.
         * @see _.difference, _.without
         * @example
         *
         * _.xor([2, 1], [2, 3]);
         * // => [1, 3]
         */

        var xor = baseRest(function (arrays) {
          return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
         * This method is like `_.xor` except that it accepts `iteratee` which is
         * invoked for each element of each `arrays` to generate the criterion by
         * which by which they're compared. The order of result values is determined
         * by the order they occur in the arrays. The iteratee is invoked with one
         * argument: (value).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {...Array} [arrays] The arrays to inspect.
         * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
         * @returns {Array} Returns the new array of filtered values.
         * @example
         *
         * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
         * // => [1.2, 3.4]
         *
         * // The `_.property` iteratee shorthand.
         * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
         * // => [{ 'x': 2 }]
         */

        var xorBy = baseRest(function (arrays) {
          var iteratee = last(arrays);

          if (isArrayLikeObject(iteratee)) {
            iteratee = undefined$1;
          }

          return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
         * This method is like `_.xor` except that it accepts `comparator` which is
         * invoked to compare elements of `arrays`. The order of result values is
         * determined by the order they occur in the arrays. The comparator is invoked
         * with two arguments: (arrVal, othVal).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {...Array} [arrays] The arrays to inspect.
         * @param {Function} [comparator] The comparator invoked per element.
         * @returns {Array} Returns the new array of filtered values.
         * @example
         *
         * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
         * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
         *
         * _.xorWith(objects, others, _.isEqual);
         * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
         */

        var xorWith = baseRest(function (arrays) {
          var comparator = last(arrays);
          comparator = typeof comparator == 'function' ? comparator : undefined$1;
          return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined$1, comparator);
        });
        /**
         * Creates an array of grouped elements, the first of which contains the
         * first elements of the given arrays, the second of which contains the
         * second elements of the given arrays, and so on.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Array
         * @param {...Array} [arrays] The arrays to process.
         * @returns {Array} Returns the new array of grouped elements.
         * @example
         *
         * _.zip(['a', 'b'], [1, 2], [true, false]);
         * // => [['a', 1, true], ['b', 2, false]]
         */

        var zip = baseRest(unzip);
        /**
         * This method is like `_.fromPairs` except that it accepts two arrays,
         * one of property identifiers and one of corresponding values.
         *
         * @static
         * @memberOf _
         * @since 0.4.0
         * @category Array
         * @param {Array} [props=[]] The property identifiers.
         * @param {Array} [values=[]] The property values.
         * @returns {Object} Returns the new object.
         * @example
         *
         * _.zipObject(['a', 'b'], [1, 2]);
         * // => { 'a': 1, 'b': 2 }
         */

        function zipObject(props, values) {
          return baseZipObject(props || [], values || [], assignValue);
        }
        /**
         * This method is like `_.zipObject` except that it supports property paths.
         *
         * @static
         * @memberOf _
         * @since 4.1.0
         * @category Array
         * @param {Array} [props=[]] The property identifiers.
         * @param {Array} [values=[]] The property values.
         * @returns {Object} Returns the new object.
         * @example
         *
         * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
         * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
         */


        function zipObjectDeep(props, values) {
          return baseZipObject(props || [], values || [], baseSet);
        }
        /**
         * This method is like `_.zip` except that it accepts `iteratee` to specify
         * how grouped values should be combined. The iteratee is invoked with the
         * elements of each group: (...group).
         *
         * @static
         * @memberOf _
         * @since 3.8.0
         * @category Array
         * @param {...Array} [arrays] The arrays to process.
         * @param {Function} [iteratee=_.identity] The function to combine
         *  grouped values.
         * @returns {Array} Returns the new array of grouped elements.
         * @example
         *
         * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
         *   return a + b + c;
         * });
         * // => [111, 222]
         */


        var zipWith = baseRest(function (arrays) {
          var length = arrays.length,
              iteratee = length > 1 ? arrays[length - 1] : undefined$1;
          iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined$1;
          return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/

        /**
         * Creates a `lodash` wrapper instance that wraps `value` with explicit method
         * chain sequences enabled. The result of such sequences must be unwrapped
         * with `_#value`.
         *
         * @static
         * @memberOf _
         * @since 1.3.0
         * @category Seq
         * @param {*} value The value to wrap.
         * @returns {Object} Returns the new `lodash` wrapper instance.
         * @example
         *
         * var users = [
         *   { 'user': 'barney',  'age': 36 },
         *   { 'user': 'fred',    'age': 40 },
         *   { 'user': 'pebbles', 'age': 1 }
         * ];
         *
         * var youngest = _
         *   .chain(users)
         *   .sortBy('age')
         *   .map(function(o) {
         *     return o.user + ' is ' + o.age;
         *   })
         *   .head()
         *   .value();
         * // => 'pebbles is 1'
         */

        function chain(value) {
          var result = lodash(value);
          result.__chain__ = true;
          return result;
        }
        /**
         * This method invokes `interceptor` and returns `value`. The interceptor
         * is invoked with one argument; (value). The purpose of this method is to
         * "tap into" a method chain sequence in order to modify intermediate results.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Seq
         * @param {*} value The value to provide to `interceptor`.
         * @param {Function} interceptor The function to invoke.
         * @returns {*} Returns `value`.
         * @example
         *
         * _([1, 2, 3])
         *  .tap(function(array) {
         *    // Mutate input array.
         *    array.pop();
         *  })
         *  .reverse()
         *  .value();
         * // => [2, 1]
         */


        function tap(value, interceptor) {
          interceptor(value);
          return value;
        }
        /**
         * This method is like `_.tap` except that it returns the result of `interceptor`.
         * The purpose of this method is to "pass thru" values replacing intermediate
         * results in a method chain sequence.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Seq
         * @param {*} value The value to provide to `interceptor`.
         * @param {Function} interceptor The function to invoke.
         * @returns {*} Returns the result of `interceptor`.
         * @example
         *
         * _('  abc  ')
         *  .chain()
         *  .trim()
         *  .thru(function(value) {
         *    return [value];
         *  })
         *  .value();
         * // => ['abc']
         */


        function thru(value, interceptor) {
          return interceptor(value);
        }
        /**
         * This method is the wrapper version of `_.at`.
         *
         * @name at
         * @memberOf _
         * @since 1.0.0
         * @category Seq
         * @param {...(string|string[])} [paths] The property paths to pick.
         * @returns {Object} Returns the new `lodash` wrapper instance.
         * @example
         *
         * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
         *
         * _(object).at(['a[0].b.c', 'a[1]']).value();
         * // => [3, 4]
         */


        var wrapperAt = flatRest(function (paths) {
          var length = paths.length,
              start = length ? paths[0] : 0,
              value = this.__wrapped__,
              interceptor = function interceptor(object) {
            return baseAt(object, paths);
          };

          if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) {
            return this.thru(interceptor);
          }

          value = value.slice(start, +start + (length ? 1 : 0));

          value.__actions__.push({
            'func': thru,
            'args': [interceptor],
            'thisArg': undefined$1
          });

          return new LodashWrapper(value, this.__chain__).thru(function (array) {
            if (length && !array.length) {
              array.push(undefined$1);
            }

            return array;
          });
        });
        /**
         * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
         *
         * @name chain
         * @memberOf _
         * @since 0.1.0
         * @category Seq
         * @returns {Object} Returns the new `lodash` wrapper instance.
         * @example
         *
         * var users = [
         *   { 'user': 'barney', 'age': 36 },
         *   { 'user': 'fred',   'age': 40 }
         * ];
         *
         * // A sequence without explicit chaining.
         * _(users).head();
         * // => { 'user': 'barney', 'age': 36 }
         *
         * // A sequence with explicit chaining.
         * _(users)
         *   .chain()
         *   .head()
         *   .pick('user')
         *   .value();
         * // => { 'user': 'barney' }
         */

        function wrapperChain() {
          return chain(this);
        }
        /**
         * Executes the chain sequence and returns the wrapped result.
         *
         * @name commit
         * @memberOf _
         * @since 3.2.0
         * @category Seq
         * @returns {Object} Returns the new `lodash` wrapper instance.
         * @example
         *
         * var array = [1, 2];
         * var wrapped = _(array).push(3);
         *
         * console.log(array);
         * // => [1, 2]
         *
         * wrapped = wrapped.commit();
         * console.log(array);
         * // => [1, 2, 3]
         *
         * wrapped.last();
         * // => 3
         *
         * console.log(array);
         * // => [1, 2, 3]
         */


        function wrapperCommit() {
          return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
         * Gets the next value on a wrapped object following the
         * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
         *
         * @name next
         * @memberOf _
         * @since 4.0.0
         * @category Seq
         * @returns {Object} Returns the next iterator value.
         * @example
         *
         * var wrapped = _([1, 2]);
         *
         * wrapped.next();
         * // => { 'done': false, 'value': 1 }
         *
         * wrapped.next();
         * // => { 'done': false, 'value': 2 }
         *
         * wrapped.next();
         * // => { 'done': true, 'value': undefined }
         */


        function wrapperNext() {
          if (this.__values__ === undefined$1) {
            this.__values__ = toArray(this.value());
          }

          var done = this.__index__ >= this.__values__.length,
              value = done ? undefined$1 : this.__values__[this.__index__++];
          return {
            'done': done,
            'value': value
          };
        }
        /**
         * Enables the wrapper to be iterable.
         *
         * @name Symbol.iterator
         * @memberOf _
         * @since 4.0.0
         * @category Seq
         * @returns {Object} Returns the wrapper object.
         * @example
         *
         * var wrapped = _([1, 2]);
         *
         * wrapped[Symbol.iterator]() === wrapped;
         * // => true
         *
         * Array.from(wrapped);
         * // => [1, 2]
         */


        function wrapperToIterator() {
          return this;
        }
        /**
         * Creates a clone of the chain sequence planting `value` as the wrapped value.
         *
         * @name plant
         * @memberOf _
         * @since 3.2.0
         * @category Seq
         * @param {*} value The value to plant.
         * @returns {Object} Returns the new `lodash` wrapper instance.
         * @example
         *
         * function square(n) {
         *   return n * n;
         * }
         *
         * var wrapped = _([1, 2]).map(square);
         * var other = wrapped.plant([3, 4]);
         *
         * other.value();
         * // => [9, 16]
         *
         * wrapped.value();
         * // => [1, 4]
         */


        function wrapperPlant(value) {
          var result,
              parent = this;

          while (parent instanceof baseLodash) {
            var clone = wrapperClone(parent);
            clone.__index__ = 0;
            clone.__values__ = undefined$1;

            if (result) {
              previous.__wrapped__ = clone;
            } else {
              result = clone;
            }

            var previous = clone;
            parent = parent.__wrapped__;
          }

          previous.__wrapped__ = value;
          return result;
        }
        /**
         * This method is the wrapper version of `_.reverse`.
         *
         * **Note:** This method mutates the wrapped array.
         *
         * @name reverse
         * @memberOf _
         * @since 0.1.0
         * @category Seq
         * @returns {Object} Returns the new `lodash` wrapper instance.
         * @example
         *
         * var array = [1, 2, 3];
         *
         * _(array).reverse().value()
         * // => [3, 2, 1]
         *
         * console.log(array);
         * // => [3, 2, 1]
         */


        function wrapperReverse() {
          var value = this.__wrapped__;

          if (value instanceof LazyWrapper) {
            var wrapped = value;

            if (this.__actions__.length) {
              wrapped = new LazyWrapper(this);
            }

            wrapped = wrapped.reverse();

            wrapped.__actions__.push({
              'func': thru,
              'args': [reverse],
              'thisArg': undefined$1
            });

            return new LodashWrapper(wrapped, this.__chain__);
          }

          return this.thru(reverse);
        }
        /**
         * Executes the chain sequence to resolve the unwrapped value.
         *
         * @name value
         * @memberOf _
         * @since 0.1.0
         * @alias toJSON, valueOf
         * @category Seq
         * @returns {*} Returns the resolved unwrapped value.
         * @example
         *
         * _([1, 2, 3]).value();
         * // => [1, 2, 3]
         */


        function wrapperValue() {
          return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/

        /**
         * Creates an object composed of keys generated from the results of running
         * each element of `collection` thru `iteratee`. The corresponding value of
         * each key is the number of times the key was returned by `iteratee`. The
         * iteratee is invoked with one argument: (value).
         *
         * @static
         * @memberOf _
         * @since 0.5.0
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
         * @returns {Object} Returns the composed aggregate object.
         * @example
         *
         * _.countBy([6.1, 4.2, 6.3], Math.floor);
         * // => { '4': 1, '6': 2 }
         *
         * // The `_.property` iteratee shorthand.
         * _.countBy(['one', 'two', 'three'], 'length');
         * // => { '3': 2, '5': 1 }
         */


        var countBy = createAggregator(function (result, value, key) {
          if (hasOwnProperty.call(result, key)) {
            ++result[key];
          } else {
            baseAssignValue(result, key, 1);
          }
        });
        /**
         * Checks if `predicate` returns truthy for **all** elements of `collection`.
         * Iteration is stopped once `predicate` returns falsey. The predicate is
         * invoked with three arguments: (value, index|key, collection).
         *
         * **Note:** This method returns `true` for
         * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
         * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
         * elements of empty collections.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} [predicate=_.identity] The function invoked per iteration.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
         * @returns {boolean} Returns `true` if all elements pass the predicate check,
         *  else `false`.
         * @example
         *
         * _.every([true, 1, null, 'yes'], Boolean);
         * // => false
         *
         * var users = [
         *   { 'user': 'barney', 'age': 36, 'active': false },
         *   { 'user': 'fred',   'age': 40, 'active': false }
         * ];
         *
         * // The `_.matches` iteratee shorthand.
         * _.every(users, { 'user': 'barney', 'active': false });
         * // => false
         *
         * // The `_.matchesProperty` iteratee shorthand.
         * _.every(users, ['active', false]);
         * // => true
         *
         * // The `_.property` iteratee shorthand.
         * _.every(users, 'active');
         * // => false
         */

        function every(collection, predicate, guard) {
          var func = isArray(collection) ? arrayEvery : baseEvery;

          if (guard && isIterateeCall(collection, predicate, guard)) {
            predicate = undefined$1;
          }

          return func(collection, getIteratee(predicate, 3));
        }
        /**
         * Iterates over elements of `collection`, returning an array of all elements
         * `predicate` returns truthy for. The predicate is invoked with three
         * arguments: (value, index|key, collection).
         *
         * **Note:** Unlike `_.remove`, this method returns a new array.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} [predicate=_.identity] The function invoked per iteration.
         * @returns {Array} Returns the new filtered array.
         * @see _.reject
         * @example
         *
         * var users = [
         *   { 'user': 'barney', 'age': 36, 'active': true },
         *   { 'user': 'fred',   'age': 40, 'active': false }
         * ];
         *
         * _.filter(users, function(o) { return !o.active; });
         * // => objects for ['fred']
         *
         * // The `_.matches` iteratee shorthand.
         * _.filter(users, { 'age': 36, 'active': true });
         * // => objects for ['barney']
         *
         * // The `_.matchesProperty` iteratee shorthand.
         * _.filter(users, ['active', false]);
         * // => objects for ['fred']
         *
         * // The `_.property` iteratee shorthand.
         * _.filter(users, 'active');
         * // => objects for ['barney']
         *
         * // Combining several predicates using `_.overEvery` or `_.overSome`.
         * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
         * // => objects for ['fred', 'barney']
         */


        function filter(collection, predicate) {
          var func = isArray(collection) ? arrayFilter : baseFilter;
          return func(collection, getIteratee(predicate, 3));
        }
        /**
         * Iterates over elements of `collection`, returning the first element
         * `predicate` returns truthy for. The predicate is invoked with three
         * arguments: (value, index|key, collection).
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Collection
         * @param {Array|Object} collection The collection to inspect.
         * @param {Function} [predicate=_.identity] The function invoked per iteration.
         * @param {number} [fromIndex=0] The index to search from.
         * @returns {*} Returns the matched element, else `undefined`.
         * @example
         *
         * var users = [
         *   { 'user': 'barney',  'age': 36, 'active': true },
         *   { 'user': 'fred',    'age': 40, 'active': false },
         *   { 'user': 'pebbles', 'age': 1,  'active': true }
         * ];
         *
         * _.find(users, function(o) { return o.age < 40; });
         * // => object for 'barney'
         *
         * // The `_.matches` iteratee shorthand.
         * _.find(users, { 'age': 1, 'active': true });
         * // => object for 'pebbles'
         *
         * // The `_.matchesProperty` iteratee shorthand.
         * _.find(users, ['active', false]);
         * // => object for 'fred'
         *
         * // The `_.property` iteratee shorthand.
         * _.find(users, 'active');
         * // => object for 'barney'
         */


        var find = createFind(findIndex);
        /**
         * This method is like `_.find` except that it iterates over elements of
         * `collection` from right to left.
         *
         * @static
         * @memberOf _
         * @since 2.0.0
         * @category Collection
         * @param {Array|Object} collection The collection to inspect.
         * @param {Function} [predicate=_.identity] The function invoked per iteration.
         * @param {number} [fromIndex=collection.length-1] The index to search from.
         * @returns {*} Returns the matched element, else `undefined`.
         * @example
         *
         * _.findLast([1, 2, 3, 4], function(n) {
         *   return n % 2 == 1;
         * });
         * // => 3
         */

        var findLast = createFind(findLastIndex);
        /**
         * Creates a flattened array of values by running each element in `collection`
         * thru `iteratee` and flattening the mapped results. The iteratee is invoked
         * with three arguments: (value, index|key, collection).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} [iteratee=_.identity] The function invoked per iteration.
         * @returns {Array} Returns the new flattened array.
         * @example
         *
         * function duplicate(n) {
         *   return [n, n];
         * }
         *
         * _.flatMap([1, 2], duplicate);
         * // => [1, 1, 2, 2]
         */

        function flatMap(collection, iteratee) {
          return baseFlatten(map(collection, iteratee), 1);
        }
        /**
         * This method is like `_.flatMap` except that it recursively flattens the
         * mapped results.
         *
         * @static
         * @memberOf _
         * @since 4.7.0
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} [iteratee=_.identity] The function invoked per iteration.
         * @returns {Array} Returns the new flattened array.
         * @example
         *
         * function duplicate(n) {
         *   return [[[n, n]]];
         * }
         *
         * _.flatMapDeep([1, 2], duplicate);
         * // => [1, 1, 2, 2]
         */


        function flatMapDeep(collection, iteratee) {
          return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
         * This method is like `_.flatMap` except that it recursively flattens the
         * mapped results up to `depth` times.
         *
         * @static
         * @memberOf _
         * @since 4.7.0
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} [iteratee=_.identity] The function invoked per iteration.
         * @param {number} [depth=1] The maximum recursion depth.
         * @returns {Array} Returns the new flattened array.
         * @example
         *
         * function duplicate(n) {
         *   return [[[n, n]]];
         * }
         *
         * _.flatMapDepth([1, 2], duplicate, 2);
         * // => [[1, 1], [2, 2]]
         */


        function flatMapDepth(collection, iteratee, depth) {
          depth = depth === undefined$1 ? 1 : toInteger(depth);
          return baseFlatten(map(collection, iteratee), depth);
        }
        /**
         * Iterates over elements of `collection` and invokes `iteratee` for each element.
         * The iteratee is invoked with three arguments: (value, index|key, collection).
         * Iteratee functions may exit iteration early by explicitly returning `false`.
         *
         * **Note:** As with other "Collections" methods, objects with a "length"
         * property are iterated like arrays. To avoid this behavior use `_.forIn`
         * or `_.forOwn` for object iteration.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @alias each
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} [iteratee=_.identity] The function invoked per iteration.
         * @returns {Array|Object} Returns `collection`.
         * @see _.forEachRight
         * @example
         *
         * _.forEach([1, 2], function(value) {
         *   console.log(value);
         * });
         * // => Logs `1` then `2`.
         *
         * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
         *   console.log(key);
         * });
         * // => Logs 'a' then 'b' (iteration order is not guaranteed).
         */


        function forEach(collection, iteratee) {
          var func = isArray(collection) ? arrayEach : baseEach;
          return func(collection, getIteratee(iteratee, 3));
        }
        /**
         * This method is like `_.forEach` except that it iterates over elements of
         * `collection` from right to left.
         *
         * @static
         * @memberOf _
         * @since 2.0.0
         * @alias eachRight
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} [iteratee=_.identity] The function invoked per iteration.
         * @returns {Array|Object} Returns `collection`.
         * @see _.forEach
         * @example
         *
         * _.forEachRight([1, 2], function(value) {
         *   console.log(value);
         * });
         * // => Logs `2` then `1`.
         */


        function forEachRight(collection, iteratee) {
          var func = isArray(collection) ? arrayEachRight : baseEachRight;
          return func(collection, getIteratee(iteratee, 3));
        }
        /**
         * Creates an object composed of keys generated from the results of running
         * each element of `collection` thru `iteratee`. The order of grouped values
         * is determined by the order they occur in `collection`. The corresponding
         * value of each key is an array of elements responsible for generating the
         * key. The iteratee is invoked with one argument: (value).
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
         * @returns {Object} Returns the composed aggregate object.
         * @example
         *
         * _.groupBy([6.1, 4.2, 6.3], Math.floor);
         * // => { '4': [4.2], '6': [6.1, 6.3] }
         *
         * // The `_.property` iteratee shorthand.
         * _.groupBy(['one', 'two', 'three'], 'length');
         * // => { '3': ['one', 'two'], '5': ['three'] }
         */


        var groupBy = createAggregator(function (result, value, key) {
          if (hasOwnProperty.call(result, key)) {
            result[key].push(value);
          } else {
            baseAssignValue(result, key, [value]);
          }
        });
        /**
         * Checks if `value` is in `collection`. If `collection` is a string, it's
         * checked for a substring of `value`, otherwise
         * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
         * is used for equality comparisons. If `fromIndex` is negative, it's used as
         * the offset from the end of `collection`.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Collection
         * @param {Array|Object|string} collection The collection to inspect.
         * @param {*} value The value to search for.
         * @param {number} [fromIndex=0] The index to search from.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
         * @returns {boolean} Returns `true` if `value` is found, else `false`.
         * @example
         *
         * _.includes([1, 2, 3], 1);
         * // => true
         *
         * _.includes([1, 2, 3], 1, 2);
         * // => false
         *
         * _.includes({ 'a': 1, 'b': 2 }, 1);
         * // => true
         *
         * _.includes('abcd', 'bc');
         * // => true
         */

        function includes(collection, value, fromIndex, guard) {
          collection = isArrayLike(collection) ? collection : values(collection);
          fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
          var length = collection.length;

          if (fromIndex < 0) {
            fromIndex = nativeMax(length + fromIndex, 0);
          }

          return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
         * Invokes the method at `path` of each element in `collection`, returning
         * an array of the results of each invoked method. Any additional arguments
         * are provided to each invoked method. If `path` is a function, it's invoked
         * for, and `this` bound to, each element in `collection`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Array|Function|string} path The path of the method to invoke or
         *  the function invoked per iteration.
         * @param {...*} [args] The arguments to invoke each method with.
         * @returns {Array} Returns the array of results.
         * @example
         *
         * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
         * // => [[1, 5, 7], [1, 2, 3]]
         *
         * _.invokeMap([123, 456], String.prototype.split, '');
         * // => [['1', '2', '3'], ['4', '5', '6']]
         */


        var invokeMap = baseRest(function (collection, path, args) {
          var index = -1,
              isFunc = typeof path == 'function',
              result = isArrayLike(collection) ? Array(collection.length) : [];
          baseEach(collection, function (value) {
            result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
          });
          return result;
        });
        /**
         * Creates an object composed of keys generated from the results of running
         * each element of `collection` thru `iteratee`. The corresponding value of
         * each key is the last element responsible for generating the key. The
         * iteratee is invoked with one argument: (value).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
         * @returns {Object} Returns the composed aggregate object.
         * @example
         *
         * var array = [
         *   { 'dir': 'left', 'code': 97 },
         *   { 'dir': 'right', 'code': 100 }
         * ];
         *
         * _.keyBy(array, function(o) {
         *   return String.fromCharCode(o.code);
         * });
         * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
         *
         * _.keyBy(array, 'dir');
         * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
         */

        var keyBy = createAggregator(function (result, value, key) {
          baseAssignValue(result, key, value);
        });
        /**
         * Creates an array of values by running each element in `collection` thru
         * `iteratee`. The iteratee is invoked with three arguments:
         * (value, index|key, collection).
         *
         * Many lodash methods are guarded to work as iteratees for methods like
         * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
         *
         * The guarded methods are:
         * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
         * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
         * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
         * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} [iteratee=_.identity] The function invoked per iteration.
         * @returns {Array} Returns the new mapped array.
         * @example
         *
         * function square(n) {
         *   return n * n;
         * }
         *
         * _.map([4, 8], square);
         * // => [16, 64]
         *
         * _.map({ 'a': 4, 'b': 8 }, square);
         * // => [16, 64] (iteration order is not guaranteed)
         *
         * var users = [
         *   { 'user': 'barney' },
         *   { 'user': 'fred' }
         * ];
         *
         * // The `_.property` iteratee shorthand.
         * _.map(users, 'user');
         * // => ['barney', 'fred']
         */

        function map(collection, iteratee) {
          var func = isArray(collection) ? arrayMap : baseMap;
          return func(collection, getIteratee(iteratee, 3));
        }
        /**
         * This method is like `_.sortBy` except that it allows specifying the sort
         * orders of the iteratees to sort by. If `orders` is unspecified, all values
         * are sorted in ascending order. Otherwise, specify an order of "desc" for
         * descending or "asc" for ascending sort order of corresponding values.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
         *  The iteratees to sort by.
         * @param {string[]} [orders] The sort orders of `iteratees`.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
         * @returns {Array} Returns the new sorted array.
         * @example
         *
         * var users = [
         *   { 'user': 'fred',   'age': 48 },
         *   { 'user': 'barney', 'age': 34 },
         *   { 'user': 'fred',   'age': 40 },
         *   { 'user': 'barney', 'age': 36 }
         * ];
         *
         * // Sort by `user` in ascending order and by `age` in descending order.
         * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
         * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
         */


        function orderBy(collection, iteratees, orders, guard) {
          if (collection == null) {
            return [];
          }

          if (!isArray(iteratees)) {
            iteratees = iteratees == null ? [] : [iteratees];
          }

          orders = guard ? undefined$1 : orders;

          if (!isArray(orders)) {
            orders = orders == null ? [] : [orders];
          }

          return baseOrderBy(collection, iteratees, orders);
        }
        /**
         * Creates an array of elements split into two groups, the first of which
         * contains elements `predicate` returns truthy for, the second of which
         * contains elements `predicate` returns falsey for. The predicate is
         * invoked with one argument: (value).
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} [predicate=_.identity] The function invoked per iteration.
         * @returns {Array} Returns the array of grouped elements.
         * @example
         *
         * var users = [
         *   { 'user': 'barney',  'age': 36, 'active': false },
         *   { 'user': 'fred',    'age': 40, 'active': true },
         *   { 'user': 'pebbles', 'age': 1,  'active': false }
         * ];
         *
         * _.partition(users, function(o) { return o.active; });
         * // => objects for [['fred'], ['barney', 'pebbles']]
         *
         * // The `_.matches` iteratee shorthand.
         * _.partition(users, { 'age': 1, 'active': false });
         * // => objects for [['pebbles'], ['barney', 'fred']]
         *
         * // The `_.matchesProperty` iteratee shorthand.
         * _.partition(users, ['active', false]);
         * // => objects for [['barney', 'pebbles'], ['fred']]
         *
         * // The `_.property` iteratee shorthand.
         * _.partition(users, 'active');
         * // => objects for [['fred'], ['barney', 'pebbles']]
         */


        var partition = createAggregator(function (result, value, key) {
          result[key ? 0 : 1].push(value);
        }, function () {
          return [[], []];
        });
        /**
         * Reduces `collection` to a value which is the accumulated result of running
         * each element in `collection` thru `iteratee`, where each successive
         * invocation is supplied the return value of the previous. If `accumulator`
         * is not given, the first element of `collection` is used as the initial
         * value. The iteratee is invoked with four arguments:
         * (accumulator, value, index|key, collection).
         *
         * Many lodash methods are guarded to work as iteratees for methods like
         * `_.reduce`, `_.reduceRight`, and `_.transform`.
         *
         * The guarded methods are:
         * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
         * and `sortBy`
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} [iteratee=_.identity] The function invoked per iteration.
         * @param {*} [accumulator] The initial value.
         * @returns {*} Returns the accumulated value.
         * @see _.reduceRight
         * @example
         *
         * _.reduce([1, 2], function(sum, n) {
         *   return sum + n;
         * }, 0);
         * // => 3
         *
         * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
         *   (result[value] || (result[value] = [])).push(key);
         *   return result;
         * }, {});
         * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
         */

        function reduce(collection, iteratee, accumulator) {
          var func = isArray(collection) ? arrayReduce : baseReduce,
              initAccum = arguments.length < 3;
          return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
         * This method is like `_.reduce` except that it iterates over elements of
         * `collection` from right to left.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} [iteratee=_.identity] The function invoked per iteration.
         * @param {*} [accumulator] The initial value.
         * @returns {*} Returns the accumulated value.
         * @see _.reduce
         * @example
         *
         * var array = [[0, 1], [2, 3], [4, 5]];
         *
         * _.reduceRight(array, function(flattened, other) {
         *   return flattened.concat(other);
         * }, []);
         * // => [4, 5, 2, 3, 0, 1]
         */


        function reduceRight(collection, iteratee, accumulator) {
          var func = isArray(collection) ? arrayReduceRight : baseReduce,
              initAccum = arguments.length < 3;
          return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
         * The opposite of `_.filter`; this method returns the elements of `collection`
         * that `predicate` does **not** return truthy for.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} [predicate=_.identity] The function invoked per iteration.
         * @returns {Array} Returns the new filtered array.
         * @see _.filter
         * @example
         *
         * var users = [
         *   { 'user': 'barney', 'age': 36, 'active': false },
         *   { 'user': 'fred',   'age': 40, 'active': true }
         * ];
         *
         * _.reject(users, function(o) { return !o.active; });
         * // => objects for ['fred']
         *
         * // The `_.matches` iteratee shorthand.
         * _.reject(users, { 'age': 40, 'active': true });
         * // => objects for ['barney']
         *
         * // The `_.matchesProperty` iteratee shorthand.
         * _.reject(users, ['active', false]);
         * // => objects for ['fred']
         *
         * // The `_.property` iteratee shorthand.
         * _.reject(users, 'active');
         * // => objects for ['barney']
         */


        function reject(collection, predicate) {
          var func = isArray(collection) ? arrayFilter : baseFilter;
          return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
         * Gets a random element from `collection`.
         *
         * @static
         * @memberOf _
         * @since 2.0.0
         * @category Collection
         * @param {Array|Object} collection The collection to sample.
         * @returns {*} Returns the random element.
         * @example
         *
         * _.sample([1, 2, 3, 4]);
         * // => 2
         */


        function sample(collection) {
          var func = isArray(collection) ? arraySample : baseSample;
          return func(collection);
        }
        /**
         * Gets `n` random elements at unique keys from `collection` up to the
         * size of `collection`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Collection
         * @param {Array|Object} collection The collection to sample.
         * @param {number} [n=1] The number of elements to sample.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
         * @returns {Array} Returns the random elements.
         * @example
         *
         * _.sampleSize([1, 2, 3], 2);
         * // => [3, 1]
         *
         * _.sampleSize([1, 2, 3], 4);
         * // => [2, 3, 1]
         */


        function sampleSize(collection, n, guard) {
          if (guard ? isIterateeCall(collection, n, guard) : n === undefined$1) {
            n = 1;
          } else {
            n = toInteger(n);
          }

          var func = isArray(collection) ? arraySampleSize : baseSampleSize;
          return func(collection, n);
        }
        /**
         * Creates an array of shuffled values, using a version of the
         * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Collection
         * @param {Array|Object} collection The collection to shuffle.
         * @returns {Array} Returns the new shuffled array.
         * @example
         *
         * _.shuffle([1, 2, 3, 4]);
         * // => [4, 1, 3, 2]
         */


        function shuffle(collection) {
          var func = isArray(collection) ? arrayShuffle : baseShuffle;
          return func(collection);
        }
        /**
         * Gets the size of `collection` by returning its length for array-like
         * values or the number of own enumerable string keyed properties for objects.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Collection
         * @param {Array|Object|string} collection The collection to inspect.
         * @returns {number} Returns the collection size.
         * @example
         *
         * _.size([1, 2, 3]);
         * // => 3
         *
         * _.size({ 'a': 1, 'b': 2 });
         * // => 2
         *
         * _.size('pebbles');
         * // => 7
         */


        function size(collection) {
          if (collection == null) {
            return 0;
          }

          if (isArrayLike(collection)) {
            return isString(collection) ? stringSize(collection) : collection.length;
          }

          var tag = getTag(collection);

          if (tag == mapTag || tag == setTag) {
            return collection.size;
          }

          return baseKeys(collection).length;
        }
        /**
         * Checks if `predicate` returns truthy for **any** element of `collection`.
         * Iteration is stopped once `predicate` returns truthy. The predicate is
         * invoked with three arguments: (value, index|key, collection).
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} [predicate=_.identity] The function invoked per iteration.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
         * @returns {boolean} Returns `true` if any element passes the predicate check,
         *  else `false`.
         * @example
         *
         * _.some([null, 0, 'yes', false], Boolean);
         * // => true
         *
         * var users = [
         *   { 'user': 'barney', 'active': true },
         *   { 'user': 'fred',   'active': false }
         * ];
         *
         * // The `_.matches` iteratee shorthand.
         * _.some(users, { 'user': 'barney', 'active': false });
         * // => false
         *
         * // The `_.matchesProperty` iteratee shorthand.
         * _.some(users, ['active', false]);
         * // => true
         *
         * // The `_.property` iteratee shorthand.
         * _.some(users, 'active');
         * // => true
         */


        function some(collection, predicate, guard) {
          var func = isArray(collection) ? arraySome : baseSome;

          if (guard && isIterateeCall(collection, predicate, guard)) {
            predicate = undefined$1;
          }

          return func(collection, getIteratee(predicate, 3));
        }
        /**
         * Creates an array of elements, sorted in ascending order by the results of
         * running each element in a collection thru each iteratee. This method
         * performs a stable sort, that is, it preserves the original sort order of
         * equal elements. The iteratees are invoked with one argument: (value).
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {...(Function|Function[])} [iteratees=[_.identity]]
         *  The iteratees to sort by.
         * @returns {Array} Returns the new sorted array.
         * @example
         *
         * var users = [
         *   { 'user': 'fred',   'age': 48 },
         *   { 'user': 'barney', 'age': 36 },
         *   { 'user': 'fred',   'age': 30 },
         *   { 'user': 'barney', 'age': 34 }
         * ];
         *
         * _.sortBy(users, [function(o) { return o.user; }]);
         * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
         *
         * _.sortBy(users, ['user', 'age']);
         * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
         */


        var sortBy = baseRest(function (collection, iteratees) {
          if (collection == null) {
            return [];
          }

          var length = iteratees.length;

          if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
            iteratees = [];
          } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
            iteratees = [iteratees[0]];
          }

          return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/

        /**
         * Gets the timestamp of the number of milliseconds that have elapsed since
         * the Unix epoch (1 January 1970 00:00:00 UTC).
         *
         * @static
         * @memberOf _
         * @since 2.4.0
         * @category Date
         * @returns {number} Returns the timestamp.
         * @example
         *
         * _.defer(function(stamp) {
         *   console.log(_.now() - stamp);
         * }, _.now());
         * // => Logs the number of milliseconds it took for the deferred invocation.
         */

        var now = ctxNow || function () {
          return root.Date.now();
        };
        /*------------------------------------------------------------------------*/

        /**
         * The opposite of `_.before`; this method creates a function that invokes
         * `func` once it's called `n` or more times.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Function
         * @param {number} n The number of calls before `func` is invoked.
         * @param {Function} func The function to restrict.
         * @returns {Function} Returns the new restricted function.
         * @example
         *
         * var saves = ['profile', 'settings'];
         *
         * var done = _.after(saves.length, function() {
         *   console.log('done saving!');
         * });
         *
         * _.forEach(saves, function(type) {
         *   asyncSave({ 'type': type, 'complete': done });
         * });
         * // => Logs 'done saving!' after the two async saves have completed.
         */


        function after(n, func) {
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }

          n = toInteger(n);
          return function () {
            if (--n < 1) {
              return func.apply(this, arguments);
            }
          };
        }
        /**
         * Creates a function that invokes `func`, with up to `n` arguments,
         * ignoring any additional arguments.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Function
         * @param {Function} func The function to cap arguments for.
         * @param {number} [n=func.length] The arity cap.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
         * @returns {Function} Returns the new capped function.
         * @example
         *
         * _.map(['6', '8', '10'], _.ary(parseInt, 1));
         * // => [6, 8, 10]
         */


        function ary(func, n, guard) {
          n = guard ? undefined$1 : n;
          n = func && n == null ? func.length : n;
          return createWrap(func, WRAP_ARY_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, n);
        }
        /**
         * Creates a function that invokes `func`, with the `this` binding and arguments
         * of the created function, while it's called less than `n` times. Subsequent
         * calls to the created function return the result of the last `func` invocation.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Function
         * @param {number} n The number of calls at which `func` is no longer invoked.
         * @param {Function} func The function to restrict.
         * @returns {Function} Returns the new restricted function.
         * @example
         *
         * jQuery(element).on('click', _.before(5, addContactToList));
         * // => Allows adding up to 4 contacts to the list.
         */


        function before(n, func) {
          var result;

          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }

          n = toInteger(n);
          return function () {
            if (--n > 0) {
              result = func.apply(this, arguments);
            }

            if (n <= 1) {
              func = undefined$1;
            }

            return result;
          };
        }
        /**
         * Creates a function that invokes `func` with the `this` binding of `thisArg`
         * and `partials` prepended to the arguments it receives.
         *
         * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
         * may be used as a placeholder for partially applied arguments.
         *
         * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
         * property of bound functions.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Function
         * @param {Function} func The function to bind.
         * @param {*} thisArg The `this` binding of `func`.
         * @param {...*} [partials] The arguments to be partially applied.
         * @returns {Function} Returns the new bound function.
         * @example
         *
         * function greet(greeting, punctuation) {
         *   return greeting + ' ' + this.user + punctuation;
         * }
         *
         * var object = { 'user': 'fred' };
         *
         * var bound = _.bind(greet, object, 'hi');
         * bound('!');
         * // => 'hi fred!'
         *
         * // Bound with placeholders.
         * var bound = _.bind(greet, object, _, '!');
         * bound('hi');
         * // => 'hi fred!'
         */


        var bind = baseRest(function (func, thisArg, partials) {
          var bitmask = WRAP_BIND_FLAG;

          if (partials.length) {
            var holders = replaceHolders(partials, getHolder(bind));
            bitmask |= WRAP_PARTIAL_FLAG;
          }

          return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
         * Creates a function that invokes the method at `object[key]` with `partials`
         * prepended to the arguments it receives.
         *
         * This method differs from `_.bind` by allowing bound functions to reference
         * methods that may be redefined or don't yet exist. See
         * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
         * for more details.
         *
         * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
         * builds, may be used as a placeholder for partially applied arguments.
         *
         * @static
         * @memberOf _
         * @since 0.10.0
         * @category Function
         * @param {Object} object The object to invoke the method on.
         * @param {string} key The key of the method.
         * @param {...*} [partials] The arguments to be partially applied.
         * @returns {Function} Returns the new bound function.
         * @example
         *
         * var object = {
         *   'user': 'fred',
         *   'greet': function(greeting, punctuation) {
         *     return greeting + ' ' + this.user + punctuation;
         *   }
         * };
         *
         * var bound = _.bindKey(object, 'greet', 'hi');
         * bound('!');
         * // => 'hi fred!'
         *
         * object.greet = function(greeting, punctuation) {
         *   return greeting + 'ya ' + this.user + punctuation;
         * };
         *
         * bound('!');
         * // => 'hiya fred!'
         *
         * // Bound with placeholders.
         * var bound = _.bindKey(object, 'greet', _, '!');
         * bound('hi');
         * // => 'hiya fred!'
         */

        var bindKey = baseRest(function (object, key, partials) {
          var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;

          if (partials.length) {
            var holders = replaceHolders(partials, getHolder(bindKey));
            bitmask |= WRAP_PARTIAL_FLAG;
          }

          return createWrap(key, bitmask, object, partials, holders);
        });
        /**
         * Creates a function that accepts arguments of `func` and either invokes
         * `func` returning its result, if at least `arity` number of arguments have
         * been provided, or returns a function that accepts the remaining `func`
         * arguments, and so on. The arity of `func` may be specified if `func.length`
         * is not sufficient.
         *
         * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
         * may be used as a placeholder for provided arguments.
         *
         * **Note:** This method doesn't set the "length" property of curried functions.
         *
         * @static
         * @memberOf _
         * @since 2.0.0
         * @category Function
         * @param {Function} func The function to curry.
         * @param {number} [arity=func.length] The arity of `func`.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
         * @returns {Function} Returns the new curried function.
         * @example
         *
         * var abc = function(a, b, c) {
         *   return [a, b, c];
         * };
         *
         * var curried = _.curry(abc);
         *
         * curried(1)(2)(3);
         * // => [1, 2, 3]
         *
         * curried(1, 2)(3);
         * // => [1, 2, 3]
         *
         * curried(1, 2, 3);
         * // => [1, 2, 3]
         *
         * // Curried with placeholders.
         * curried(1)(_, 3)(2);
         * // => [1, 2, 3]
         */

        function curry(func, arity, guard) {
          arity = guard ? undefined$1 : arity;
          var result = createWrap(func, WRAP_CURRY_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, undefined$1, arity);
          result.placeholder = curry.placeholder;
          return result;
        }
        /**
         * This method is like `_.curry` except that arguments are applied to `func`
         * in the manner of `_.partialRight` instead of `_.partial`.
         *
         * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
         * builds, may be used as a placeholder for provided arguments.
         *
         * **Note:** This method doesn't set the "length" property of curried functions.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Function
         * @param {Function} func The function to curry.
         * @param {number} [arity=func.length] The arity of `func`.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
         * @returns {Function} Returns the new curried function.
         * @example
         *
         * var abc = function(a, b, c) {
         *   return [a, b, c];
         * };
         *
         * var curried = _.curryRight(abc);
         *
         * curried(3)(2)(1);
         * // => [1, 2, 3]
         *
         * curried(2, 3)(1);
         * // => [1, 2, 3]
         *
         * curried(1, 2, 3);
         * // => [1, 2, 3]
         *
         * // Curried with placeholders.
         * curried(3)(1, _)(2);
         * // => [1, 2, 3]
         */


        function curryRight(func, arity, guard) {
          arity = guard ? undefined$1 : arity;
          var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, undefined$1, arity);
          result.placeholder = curryRight.placeholder;
          return result;
        }
        /**
         * Creates a debounced function that delays invoking `func` until after `wait`
         * milliseconds have elapsed since the last time the debounced function was
         * invoked. The debounced function comes with a `cancel` method to cancel
         * delayed `func` invocations and a `flush` method to immediately invoke them.
         * Provide `options` to indicate whether `func` should be invoked on the
         * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
         * with the last arguments provided to the debounced function. Subsequent
         * calls to the debounced function return the result of the last `func`
         * invocation.
         *
         * **Note:** If `leading` and `trailing` options are `true`, `func` is
         * invoked on the trailing edge of the timeout only if the debounced function
         * is invoked more than once during the `wait` timeout.
         *
         * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
         * until to the next tick, similar to `setTimeout` with a timeout of `0`.
         *
         * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
         * for details over the differences between `_.debounce` and `_.throttle`.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Function
         * @param {Function} func The function to debounce.
         * @param {number} [wait=0] The number of milliseconds to delay.
         * @param {Object} [options={}] The options object.
         * @param {boolean} [options.leading=false]
         *  Specify invoking on the leading edge of the timeout.
         * @param {number} [options.maxWait]
         *  The maximum time `func` is allowed to be delayed before it's invoked.
         * @param {boolean} [options.trailing=true]
         *  Specify invoking on the trailing edge of the timeout.
         * @returns {Function} Returns the new debounced function.
         * @example
         *
         * // Avoid costly calculations while the window size is in flux.
         * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
         *
         * // Invoke `sendMail` when clicked, debouncing subsequent calls.
         * jQuery(element).on('click', _.debounce(sendMail, 300, {
         *   'leading': true,
         *   'trailing': false
         * }));
         *
         * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
         * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
         * var source = new EventSource('/stream');
         * jQuery(source).on('message', debounced);
         *
         * // Cancel the trailing debounced invocation.
         * jQuery(window).on('popstate', debounced.cancel);
         */


        function debounce(func, wait, options) {
          var lastArgs,
              lastThis,
              maxWait,
              result,
              timerId,
              lastCallTime,
              lastInvokeTime = 0,
              leading = false,
              maxing = false,
              trailing = true;

          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }

          wait = toNumber(wait) || 0;

          if (isObject(options)) {
            leading = !!options.leading;
            maxing = 'maxWait' in options;
            maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
            trailing = 'trailing' in options ? !!options.trailing : trailing;
          }

          function invokeFunc(time) {
            var args = lastArgs,
                thisArg = lastThis;
            lastArgs = lastThis = undefined$1;
            lastInvokeTime = time;
            result = func.apply(thisArg, args);
            return result;
          }

          function leadingEdge(time) {
            // Reset any `maxWait` timer.
            lastInvokeTime = time; // Start the timer for the trailing edge.

            timerId = setTimeout(timerExpired, wait); // Invoke the leading edge.

            return leading ? invokeFunc(time) : result;
          }

          function remainingWait(time) {
            var timeSinceLastCall = time - lastCallTime,
                timeSinceLastInvoke = time - lastInvokeTime,
                timeWaiting = wait - timeSinceLastCall;
            return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
          }

          function shouldInvoke(time) {
            var timeSinceLastCall = time - lastCallTime,
                timeSinceLastInvoke = time - lastInvokeTime; // Either this is the first call, activity has stopped and we're at the
            // trailing edge, the system time has gone backwards and we're treating
            // it as the trailing edge, or we've hit the `maxWait` limit.

            return lastCallTime === undefined$1 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
          }

          function timerExpired() {
            var time = now();

            if (shouldInvoke(time)) {
              return trailingEdge(time);
            } // Restart the timer.


            timerId = setTimeout(timerExpired, remainingWait(time));
          }

          function trailingEdge(time) {
            timerId = undefined$1; // Only invoke if we have `lastArgs` which means `func` has been
            // debounced at least once.

            if (trailing && lastArgs) {
              return invokeFunc(time);
            }

            lastArgs = lastThis = undefined$1;
            return result;
          }

          function cancel() {
            if (timerId !== undefined$1) {
              clearTimeout(timerId);
            }

            lastInvokeTime = 0;
            lastArgs = lastCallTime = lastThis = timerId = undefined$1;
          }

          function flush() {
            return timerId === undefined$1 ? result : trailingEdge(now());
          }

          function debounced() {
            var time = now(),
                isInvoking = shouldInvoke(time);
            lastArgs = arguments;
            lastThis = this;
            lastCallTime = time;

            if (isInvoking) {
              if (timerId === undefined$1) {
                return leadingEdge(lastCallTime);
              }

              if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
              }
            }

            if (timerId === undefined$1) {
              timerId = setTimeout(timerExpired, wait);
            }

            return result;
          }

          debounced.cancel = cancel;
          debounced.flush = flush;
          return debounced;
        }
        /**
         * Defers invoking the `func` until the current call stack has cleared. Any
         * additional arguments are provided to `func` when it's invoked.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Function
         * @param {Function} func The function to defer.
         * @param {...*} [args] The arguments to invoke `func` with.
         * @returns {number} Returns the timer id.
         * @example
         *
         * _.defer(function(text) {
         *   console.log(text);
         * }, 'deferred');
         * // => Logs 'deferred' after one millisecond.
         */


        var defer = baseRest(function (func, args) {
          return baseDelay(func, 1, args);
        });
        /**
         * Invokes `func` after `wait` milliseconds. Any additional arguments are
         * provided to `func` when it's invoked.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Function
         * @param {Function} func The function to delay.
         * @param {number} wait The number of milliseconds to delay invocation.
         * @param {...*} [args] The arguments to invoke `func` with.
         * @returns {number} Returns the timer id.
         * @example
         *
         * _.delay(function(text) {
         *   console.log(text);
         * }, 1000, 'later');
         * // => Logs 'later' after one second.
         */

        var delay = baseRest(function (func, wait, args) {
          return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
         * Creates a function that invokes `func` with arguments reversed.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Function
         * @param {Function} func The function to flip arguments for.
         * @returns {Function} Returns the new flipped function.
         * @example
         *
         * var flipped = _.flip(function() {
         *   return _.toArray(arguments);
         * });
         *
         * flipped('a', 'b', 'c', 'd');
         * // => ['d', 'c', 'b', 'a']
         */

        function flip(func) {
          return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
         * Creates a function that memoizes the result of `func`. If `resolver` is
         * provided, it determines the cache key for storing the result based on the
         * arguments provided to the memoized function. By default, the first argument
         * provided to the memoized function is used as the map cache key. The `func`
         * is invoked with the `this` binding of the memoized function.
         *
         * **Note:** The cache is exposed as the `cache` property on the memoized
         * function. Its creation may be customized by replacing the `_.memoize.Cache`
         * constructor with one whose instances implement the
         * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
         * method interface of `clear`, `delete`, `get`, `has`, and `set`.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Function
         * @param {Function} func The function to have its output memoized.
         * @param {Function} [resolver] The function to resolve the cache key.
         * @returns {Function} Returns the new memoized function.
         * @example
         *
         * var object = { 'a': 1, 'b': 2 };
         * var other = { 'c': 3, 'd': 4 };
         *
         * var values = _.memoize(_.values);
         * values(object);
         * // => [1, 2]
         *
         * values(other);
         * // => [3, 4]
         *
         * object.a = 2;
         * values(object);
         * // => [1, 2]
         *
         * // Modify the result cache.
         * values.cache.set(object, ['a', 'b']);
         * values(object);
         * // => ['a', 'b']
         *
         * // Replace `_.memoize.Cache`.
         * _.memoize.Cache = WeakMap;
         */


        function memoize(func, resolver) {
          if (typeof func != 'function' || resolver != null && typeof resolver != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }

          var memoized = function memoized() {
            var args = arguments,
                key = resolver ? resolver.apply(this, args) : args[0],
                cache = memoized.cache;

            if (cache.has(key)) {
              return cache.get(key);
            }

            var result = func.apply(this, args);
            memoized.cache = cache.set(key, result) || cache;
            return result;
          };

          memoized.cache = new (memoize.Cache || MapCache)();
          return memoized;
        } // Expose `MapCache`.


        memoize.Cache = MapCache;
        /**
         * Creates a function that negates the result of the predicate `func`. The
         * `func` predicate is invoked with the `this` binding and arguments of the
         * created function.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Function
         * @param {Function} predicate The predicate to negate.
         * @returns {Function} Returns the new negated function.
         * @example
         *
         * function isEven(n) {
         *   return n % 2 == 0;
         * }
         *
         * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
         * // => [1, 3, 5]
         */

        function negate(predicate) {
          if (typeof predicate != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }

          return function () {
            var args = arguments;

            switch (args.length) {
              case 0:
                return !predicate.call(this);

              case 1:
                return !predicate.call(this, args[0]);

              case 2:
                return !predicate.call(this, args[0], args[1]);

              case 3:
                return !predicate.call(this, args[0], args[1], args[2]);
            }

            return !predicate.apply(this, args);
          };
        }
        /**
         * Creates a function that is restricted to invoking `func` once. Repeat calls
         * to the function return the value of the first invocation. The `func` is
         * invoked with the `this` binding and arguments of the created function.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Function
         * @param {Function} func The function to restrict.
         * @returns {Function} Returns the new restricted function.
         * @example
         *
         * var initialize = _.once(createApplication);
         * initialize();
         * initialize();
         * // => `createApplication` is invoked once
         */


        function once(func) {
          return before(2, func);
        }
        /**
         * Creates a function that invokes `func` with its arguments transformed.
         *
         * @static
         * @since 4.0.0
         * @memberOf _
         * @category Function
         * @param {Function} func The function to wrap.
         * @param {...(Function|Function[])} [transforms=[_.identity]]
         *  The argument transforms.
         * @returns {Function} Returns the new function.
         * @example
         *
         * function doubled(n) {
         *   return n * 2;
         * }
         *
         * function square(n) {
         *   return n * n;
         * }
         *
         * var func = _.overArgs(function(x, y) {
         *   return [x, y];
         * }, [square, doubled]);
         *
         * func(9, 3);
         * // => [81, 6]
         *
         * func(10, 5);
         * // => [100, 10]
         */


        var overArgs = castRest(function (func, transforms) {
          transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
          var funcsLength = transforms.length;
          return baseRest(function (args) {
            var index = -1,
                length = nativeMin(args.length, funcsLength);

            while (++index < length) {
              args[index] = transforms[index].call(this, args[index]);
            }

            return apply(func, this, args);
          });
        });
        /**
         * Creates a function that invokes `func` with `partials` prepended to the
         * arguments it receives. This method is like `_.bind` except it does **not**
         * alter the `this` binding.
         *
         * The `_.partial.placeholder` value, which defaults to `_` in monolithic
         * builds, may be used as a placeholder for partially applied arguments.
         *
         * **Note:** This method doesn't set the "length" property of partially
         * applied functions.
         *
         * @static
         * @memberOf _
         * @since 0.2.0
         * @category Function
         * @param {Function} func The function to partially apply arguments to.
         * @param {...*} [partials] The arguments to be partially applied.
         * @returns {Function} Returns the new partially applied function.
         * @example
         *
         * function greet(greeting, name) {
         *   return greeting + ' ' + name;
         * }
         *
         * var sayHelloTo = _.partial(greet, 'hello');
         * sayHelloTo('fred');
         * // => 'hello fred'
         *
         * // Partially applied with placeholders.
         * var greetFred = _.partial(greet, _, 'fred');
         * greetFred('hi');
         * // => 'hi fred'
         */

        var partial = baseRest(function (func, partials) {
          var holders = replaceHolders(partials, getHolder(partial));
          return createWrap(func, WRAP_PARTIAL_FLAG, undefined$1, partials, holders);
        });
        /**
         * This method is like `_.partial` except that partially applied arguments
         * are appended to the arguments it receives.
         *
         * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
         * builds, may be used as a placeholder for partially applied arguments.
         *
         * **Note:** This method doesn't set the "length" property of partially
         * applied functions.
         *
         * @static
         * @memberOf _
         * @since 1.0.0
         * @category Function
         * @param {Function} func The function to partially apply arguments to.
         * @param {...*} [partials] The arguments to be partially applied.
         * @returns {Function} Returns the new partially applied function.
         * @example
         *
         * function greet(greeting, name) {
         *   return greeting + ' ' + name;
         * }
         *
         * var greetFred = _.partialRight(greet, 'fred');
         * greetFred('hi');
         * // => 'hi fred'
         *
         * // Partially applied with placeholders.
         * var sayHelloTo = _.partialRight(greet, 'hello', _);
         * sayHelloTo('fred');
         * // => 'hello fred'
         */

        var partialRight = baseRest(function (func, partials) {
          var holders = replaceHolders(partials, getHolder(partialRight));
          return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined$1, partials, holders);
        });
        /**
         * Creates a function that invokes `func` with arguments arranged according
         * to the specified `indexes` where the argument value at the first index is
         * provided as the first argument, the argument value at the second index is
         * provided as the second argument, and so on.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Function
         * @param {Function} func The function to rearrange arguments for.
         * @param {...(number|number[])} indexes The arranged argument indexes.
         * @returns {Function} Returns the new function.
         * @example
         *
         * var rearged = _.rearg(function(a, b, c) {
         *   return [a, b, c];
         * }, [2, 0, 1]);
         *
         * rearged('b', 'c', 'a')
         * // => ['a', 'b', 'c']
         */

        var rearg = flatRest(function (func, indexes) {
          return createWrap(func, WRAP_REARG_FLAG, undefined$1, undefined$1, undefined$1, indexes);
        });
        /**
         * Creates a function that invokes `func` with the `this` binding of the
         * created function and arguments from `start` and beyond provided as
         * an array.
         *
         * **Note:** This method is based on the
         * [rest parameter](https://mdn.io/rest_parameters).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Function
         * @param {Function} func The function to apply a rest parameter to.
         * @param {number} [start=func.length-1] The start position of the rest parameter.
         * @returns {Function} Returns the new function.
         * @example
         *
         * var say = _.rest(function(what, names) {
         *   return what + ' ' + _.initial(names).join(', ') +
         *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
         * });
         *
         * say('hello', 'fred', 'barney', 'pebbles');
         * // => 'hello fred, barney, & pebbles'
         */

        function rest(func, start) {
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }

          start = start === undefined$1 ? start : toInteger(start);
          return baseRest(func, start);
        }
        /**
         * Creates a function that invokes `func` with the `this` binding of the
         * create function and an array of arguments much like
         * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
         *
         * **Note:** This method is based on the
         * [spread operator](https://mdn.io/spread_operator).
         *
         * @static
         * @memberOf _
         * @since 3.2.0
         * @category Function
         * @param {Function} func The function to spread arguments over.
         * @param {number} [start=0] The start position of the spread.
         * @returns {Function} Returns the new function.
         * @example
         *
         * var say = _.spread(function(who, what) {
         *   return who + ' says ' + what;
         * });
         *
         * say(['fred', 'hello']);
         * // => 'fred says hello'
         *
         * var numbers = Promise.all([
         *   Promise.resolve(40),
         *   Promise.resolve(36)
         * ]);
         *
         * numbers.then(_.spread(function(x, y) {
         *   return x + y;
         * }));
         * // => a Promise of 76
         */


        function spread(func, start) {
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }

          start = start == null ? 0 : nativeMax(toInteger(start), 0);
          return baseRest(function (args) {
            var array = args[start],
                otherArgs = castSlice(args, 0, start);

            if (array) {
              arrayPush(otherArgs, array);
            }

            return apply(func, this, otherArgs);
          });
        }
        /**
         * Creates a throttled function that only invokes `func` at most once per
         * every `wait` milliseconds. The throttled function comes with a `cancel`
         * method to cancel delayed `func` invocations and a `flush` method to
         * immediately invoke them. Provide `options` to indicate whether `func`
         * should be invoked on the leading and/or trailing edge of the `wait`
         * timeout. The `func` is invoked with the last arguments provided to the
         * throttled function. Subsequent calls to the throttled function return the
         * result of the last `func` invocation.
         *
         * **Note:** If `leading` and `trailing` options are `true`, `func` is
         * invoked on the trailing edge of the timeout only if the throttled function
         * is invoked more than once during the `wait` timeout.
         *
         * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
         * until to the next tick, similar to `setTimeout` with a timeout of `0`.
         *
         * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
         * for details over the differences between `_.throttle` and `_.debounce`.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Function
         * @param {Function} func The function to throttle.
         * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
         * @param {Object} [options={}] The options object.
         * @param {boolean} [options.leading=true]
         *  Specify invoking on the leading edge of the timeout.
         * @param {boolean} [options.trailing=true]
         *  Specify invoking on the trailing edge of the timeout.
         * @returns {Function} Returns the new throttled function.
         * @example
         *
         * // Avoid excessively updating the position while scrolling.
         * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
         *
         * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
         * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
         * jQuery(element).on('click', throttled);
         *
         * // Cancel the trailing throttled invocation.
         * jQuery(window).on('popstate', throttled.cancel);
         */


        function throttle(func, wait, options) {
          var leading = true,
              trailing = true;

          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }

          if (isObject(options)) {
            leading = 'leading' in options ? !!options.leading : leading;
            trailing = 'trailing' in options ? !!options.trailing : trailing;
          }

          return debounce(func, wait, {
            'leading': leading,
            'maxWait': wait,
            'trailing': trailing
          });
        }
        /**
         * Creates a function that accepts up to one argument, ignoring any
         * additional arguments.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Function
         * @param {Function} func The function to cap arguments for.
         * @returns {Function} Returns the new capped function.
         * @example
         *
         * _.map(['6', '8', '10'], _.unary(parseInt));
         * // => [6, 8, 10]
         */


        function unary(func) {
          return ary(func, 1);
        }
        /**
         * Creates a function that provides `value` to `wrapper` as its first
         * argument. Any additional arguments provided to the function are appended
         * to those provided to the `wrapper`. The wrapper is invoked with the `this`
         * binding of the created function.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Function
         * @param {*} value The value to wrap.
         * @param {Function} [wrapper=identity] The wrapper function.
         * @returns {Function} Returns the new function.
         * @example
         *
         * var p = _.wrap(_.escape, function(func, text) {
         *   return '<p>' + func(text) + '</p>';
         * });
         *
         * p('fred, barney, & pebbles');
         * // => '<p>fred, barney, &amp; pebbles</p>'
         */


        function wrap(value, wrapper) {
          return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/

        /**
         * Casts `value` as an array if it's not one.
         *
         * @static
         * @memberOf _
         * @since 4.4.0
         * @category Lang
         * @param {*} value The value to inspect.
         * @returns {Array} Returns the cast array.
         * @example
         *
         * _.castArray(1);
         * // => [1]
         *
         * _.castArray({ 'a': 1 });
         * // => [{ 'a': 1 }]
         *
         * _.castArray('abc');
         * // => ['abc']
         *
         * _.castArray(null);
         * // => [null]
         *
         * _.castArray(undefined);
         * // => [undefined]
         *
         * _.castArray();
         * // => []
         *
         * var array = [1, 2, 3];
         * console.log(_.castArray(array) === array);
         * // => true
         */


        function castArray() {
          if (!arguments.length) {
            return [];
          }

          var value = arguments[0];
          return isArray(value) ? value : [value];
        }
        /**
         * Creates a shallow clone of `value`.
         *
         * **Note:** This method is loosely based on the
         * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
         * and supports cloning arrays, array buffers, booleans, date objects, maps,
         * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
         * arrays. The own enumerable properties of `arguments` objects are cloned
         * as plain objects. An empty object is returned for uncloneable values such
         * as error objects, functions, DOM nodes, and WeakMaps.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to clone.
         * @returns {*} Returns the cloned value.
         * @see _.cloneDeep
         * @example
         *
         * var objects = [{ 'a': 1 }, { 'b': 2 }];
         *
         * var shallow = _.clone(objects);
         * console.log(shallow[0] === objects[0]);
         * // => true
         */


        function clone(value) {
          return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
         * This method is like `_.clone` except that it accepts `customizer` which
         * is invoked to produce the cloned value. If `customizer` returns `undefined`,
         * cloning is handled by the method instead. The `customizer` is invoked with
         * up to four arguments; (value [, index|key, object, stack]).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to clone.
         * @param {Function} [customizer] The function to customize cloning.
         * @returns {*} Returns the cloned value.
         * @see _.cloneDeepWith
         * @example
         *
         * function customizer(value) {
         *   if (_.isElement(value)) {
         *     return value.cloneNode(false);
         *   }
         * }
         *
         * var el = _.cloneWith(document.body, customizer);
         *
         * console.log(el === document.body);
         * // => false
         * console.log(el.nodeName);
         * // => 'BODY'
         * console.log(el.childNodes.length);
         * // => 0
         */


        function cloneWith(value, customizer) {
          customizer = typeof customizer == 'function' ? customizer : undefined$1;
          return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
         * This method is like `_.clone` except that it recursively clones `value`.
         *
         * @static
         * @memberOf _
         * @since 1.0.0
         * @category Lang
         * @param {*} value The value to recursively clone.
         * @returns {*} Returns the deep cloned value.
         * @see _.clone
         * @example
         *
         * var objects = [{ 'a': 1 }, { 'b': 2 }];
         *
         * var deep = _.cloneDeep(objects);
         * console.log(deep[0] === objects[0]);
         * // => false
         */


        function cloneDeep(value) {
          return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
         * This method is like `_.cloneWith` except that it recursively clones `value`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to recursively clone.
         * @param {Function} [customizer] The function to customize cloning.
         * @returns {*} Returns the deep cloned value.
         * @see _.cloneWith
         * @example
         *
         * function customizer(value) {
         *   if (_.isElement(value)) {
         *     return value.cloneNode(true);
         *   }
         * }
         *
         * var el = _.cloneDeepWith(document.body, customizer);
         *
         * console.log(el === document.body);
         * // => false
         * console.log(el.nodeName);
         * // => 'BODY'
         * console.log(el.childNodes.length);
         * // => 20
         */


        function cloneDeepWith(value, customizer) {
          customizer = typeof customizer == 'function' ? customizer : undefined$1;
          return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
         * Checks if `object` conforms to `source` by invoking the predicate
         * properties of `source` with the corresponding property values of `object`.
         *
         * **Note:** This method is equivalent to `_.conforms` when `source` is
         * partially applied.
         *
         * @static
         * @memberOf _
         * @since 4.14.0
         * @category Lang
         * @param {Object} object The object to inspect.
         * @param {Object} source The object of property predicates to conform to.
         * @returns {boolean} Returns `true` if `object` conforms, else `false`.
         * @example
         *
         * var object = { 'a': 1, 'b': 2 };
         *
         * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
         * // => true
         *
         * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
         * // => false
         */


        function conformsTo(object, source) {
          return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
         * Performs a
         * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
         * comparison between two values to determine if they are equivalent.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to compare.
         * @param {*} other The other value to compare.
         * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
         * @example
         *
         * var object = { 'a': 1 };
         * var other = { 'a': 1 };
         *
         * _.eq(object, object);
         * // => true
         *
         * _.eq(object, other);
         * // => false
         *
         * _.eq('a', 'a');
         * // => true
         *
         * _.eq('a', Object('a'));
         * // => false
         *
         * _.eq(NaN, NaN);
         * // => true
         */


        function eq(value, other) {
          return value === other || value !== value && other !== other;
        }
        /**
         * Checks if `value` is greater than `other`.
         *
         * @static
         * @memberOf _
         * @since 3.9.0
         * @category Lang
         * @param {*} value The value to compare.
         * @param {*} other The other value to compare.
         * @returns {boolean} Returns `true` if `value` is greater than `other`,
         *  else `false`.
         * @see _.lt
         * @example
         *
         * _.gt(3, 1);
         * // => true
         *
         * _.gt(3, 3);
         * // => false
         *
         * _.gt(1, 3);
         * // => false
         */


        var gt = createRelationalOperation(baseGt);
        /**
         * Checks if `value` is greater than or equal to `other`.
         *
         * @static
         * @memberOf _
         * @since 3.9.0
         * @category Lang
         * @param {*} value The value to compare.
         * @param {*} other The other value to compare.
         * @returns {boolean} Returns `true` if `value` is greater than or equal to
         *  `other`, else `false`.
         * @see _.lte
         * @example
         *
         * _.gte(3, 1);
         * // => true
         *
         * _.gte(3, 3);
         * // => true
         *
         * _.gte(1, 3);
         * // => false
         */

        var gte = createRelationalOperation(function (value, other) {
          return value >= other;
        });
        /**
         * Checks if `value` is likely an `arguments` object.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is an `arguments` object,
         *  else `false`.
         * @example
         *
         * _.isArguments(function() { return arguments; }());
         * // => true
         *
         * _.isArguments([1, 2, 3]);
         * // => false
         */

        var isArguments = baseIsArguments(function () {
          return arguments;
        }()) ? baseIsArguments : function (value) {
          return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        };
        /**
         * Checks if `value` is classified as an `Array` object.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is an array, else `false`.
         * @example
         *
         * _.isArray([1, 2, 3]);
         * // => true
         *
         * _.isArray(document.body.children);
         * // => false
         *
         * _.isArray('abc');
         * // => false
         *
         * _.isArray(_.noop);
         * // => false
         */

        var isArray = Array.isArray;
        /**
         * Checks if `value` is classified as an `ArrayBuffer` object.
         *
         * @static
         * @memberOf _
         * @since 4.3.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
         * @example
         *
         * _.isArrayBuffer(new ArrayBuffer(2));
         * // => true
         *
         * _.isArrayBuffer(new Array(2));
         * // => false
         */

        var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
         * Checks if `value` is array-like. A value is considered array-like if it's
         * not a function and has a `value.length` that's an integer greater than or
         * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
         * @example
         *
         * _.isArrayLike([1, 2, 3]);
         * // => true
         *
         * _.isArrayLike(document.body.children);
         * // => true
         *
         * _.isArrayLike('abc');
         * // => true
         *
         * _.isArrayLike(_.noop);
         * // => false
         */

        function isArrayLike(value) {
          return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
         * This method is like `_.isArrayLike` except that it also checks if `value`
         * is an object.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is an array-like object,
         *  else `false`.
         * @example
         *
         * _.isArrayLikeObject([1, 2, 3]);
         * // => true
         *
         * _.isArrayLikeObject(document.body.children);
         * // => true
         *
         * _.isArrayLikeObject('abc');
         * // => false
         *
         * _.isArrayLikeObject(_.noop);
         * // => false
         */


        function isArrayLikeObject(value) {
          return isObjectLike(value) && isArrayLike(value);
        }
        /**
         * Checks if `value` is classified as a boolean primitive or object.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
         * @example
         *
         * _.isBoolean(false);
         * // => true
         *
         * _.isBoolean(null);
         * // => false
         */


        function isBoolean(value) {
          return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
         * Checks if `value` is a buffer.
         *
         * @static
         * @memberOf _
         * @since 4.3.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
         * @example
         *
         * _.isBuffer(new Buffer(2));
         * // => true
         *
         * _.isBuffer(new Uint8Array(2));
         * // => false
         */


        var isBuffer = nativeIsBuffer || stubFalse;
        /**
         * Checks if `value` is classified as a `Date` object.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
         * @example
         *
         * _.isDate(new Date);
         * // => true
         *
         * _.isDate('Mon April 23 2012');
         * // => false
         */

        var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
         * Checks if `value` is likely a DOM element.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
         * @example
         *
         * _.isElement(document.body);
         * // => true
         *
         * _.isElement('<body>');
         * // => false
         */

        function isElement(value) {
          return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
         * Checks if `value` is an empty object, collection, map, or set.
         *
         * Objects are considered empty if they have no own enumerable string keyed
         * properties.
         *
         * Array-like values such as `arguments` objects, arrays, buffers, strings, or
         * jQuery-like collections are considered empty if they have a `length` of `0`.
         * Similarly, maps and sets are considered empty if they have a `size` of `0`.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is empty, else `false`.
         * @example
         *
         * _.isEmpty(null);
         * // => true
         *
         * _.isEmpty(true);
         * // => true
         *
         * _.isEmpty(1);
         * // => true
         *
         * _.isEmpty([1, 2, 3]);
         * // => false
         *
         * _.isEmpty({ 'a': 1 });
         * // => false
         */


        function isEmpty(value) {
          if (value == null) {
            return true;
          }

          if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) {
            return !value.length;
          }

          var tag = getTag(value);

          if (tag == mapTag || tag == setTag) {
            return !value.size;
          }

          if (isPrototype(value)) {
            return !baseKeys(value).length;
          }

          for (var key in value) {
            if (hasOwnProperty.call(value, key)) {
              return false;
            }
          }

          return true;
        }
        /**
         * Performs a deep comparison between two values to determine if they are
         * equivalent.
         *
         * **Note:** This method supports comparing arrays, array buffers, booleans,
         * date objects, error objects, maps, numbers, `Object` objects, regexes,
         * sets, strings, symbols, and typed arrays. `Object` objects are compared
         * by their own, not inherited, enumerable properties. Functions and DOM
         * nodes are compared by strict equality, i.e. `===`.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to compare.
         * @param {*} other The other value to compare.
         * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
         * @example
         *
         * var object = { 'a': 1 };
         * var other = { 'a': 1 };
         *
         * _.isEqual(object, other);
         * // => true
         *
         * object === other;
         * // => false
         */


        function isEqual(value, other) {
          return baseIsEqual(value, other);
        }
        /**
         * This method is like `_.isEqual` except that it accepts `customizer` which
         * is invoked to compare values. If `customizer` returns `undefined`, comparisons
         * are handled by the method instead. The `customizer` is invoked with up to
         * six arguments: (objValue, othValue [, index|key, object, other, stack]).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to compare.
         * @param {*} other The other value to compare.
         * @param {Function} [customizer] The function to customize comparisons.
         * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
         * @example
         *
         * function isGreeting(value) {
         *   return /^h(?:i|ello)$/.test(value);
         * }
         *
         * function customizer(objValue, othValue) {
         *   if (isGreeting(objValue) && isGreeting(othValue)) {
         *     return true;
         *   }
         * }
         *
         * var array = ['hello', 'goodbye'];
         * var other = ['hi', 'goodbye'];
         *
         * _.isEqualWith(array, other, customizer);
         * // => true
         */


        function isEqualWith(value, other, customizer) {
          customizer = typeof customizer == 'function' ? customizer : undefined$1;
          var result = customizer ? customizer(value, other) : undefined$1;
          return result === undefined$1 ? baseIsEqual(value, other, undefined$1, customizer) : !!result;
        }
        /**
         * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
         * `SyntaxError`, `TypeError`, or `URIError` object.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
         * @example
         *
         * _.isError(new Error);
         * // => true
         *
         * _.isError(Error);
         * // => false
         */


        function isError(value) {
          if (!isObjectLike(value)) {
            return false;
          }

          var tag = baseGetTag(value);
          return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
        }
        /**
         * Checks if `value` is a finite primitive number.
         *
         * **Note:** This method is based on
         * [`Number.isFinite`](https://mdn.io/Number/isFinite).
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
         * @example
         *
         * _.isFinite(3);
         * // => true
         *
         * _.isFinite(Number.MIN_VALUE);
         * // => true
         *
         * _.isFinite(Infinity);
         * // => false
         *
         * _.isFinite('3');
         * // => false
         */


        function isFinite(value) {
          return typeof value == 'number' && nativeIsFinite(value);
        }
        /**
         * Checks if `value` is classified as a `Function` object.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a function, else `false`.
         * @example
         *
         * _.isFunction(_);
         * // => true
         *
         * _.isFunction(/abc/);
         * // => false
         */


        function isFunction(value) {
          if (!isObject(value)) {
            return false;
          } // The use of `Object#toString` avoids issues with the `typeof` operator
          // in Safari 9 which returns 'object' for typed arrays and other constructors.


          var tag = baseGetTag(value);
          return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
         * Checks if `value` is an integer.
         *
         * **Note:** This method is based on
         * [`Number.isInteger`](https://mdn.io/Number/isInteger).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
         * @example
         *
         * _.isInteger(3);
         * // => true
         *
         * _.isInteger(Number.MIN_VALUE);
         * // => false
         *
         * _.isInteger(Infinity);
         * // => false
         *
         * _.isInteger('3');
         * // => false
         */


        function isInteger(value) {
          return typeof value == 'number' && value == toInteger(value);
        }
        /**
         * Checks if `value` is a valid array-like length.
         *
         * **Note:** This method is loosely based on
         * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
         * @example
         *
         * _.isLength(3);
         * // => true
         *
         * _.isLength(Number.MIN_VALUE);
         * // => false
         *
         * _.isLength(Infinity);
         * // => false
         *
         * _.isLength('3');
         * // => false
         */


        function isLength(value) {
          return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
         * Checks if `value` is the
         * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
         * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is an object, else `false`.
         * @example
         *
         * _.isObject({});
         * // => true
         *
         * _.isObject([1, 2, 3]);
         * // => true
         *
         * _.isObject(_.noop);
         * // => true
         *
         * _.isObject(null);
         * // => false
         */


        function isObject(value) {
          var type = typeof value;
          return value != null && (type == 'object' || type == 'function');
        }
        /**
         * Checks if `value` is object-like. A value is object-like if it's not `null`
         * and has a `typeof` result of "object".
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
         * @example
         *
         * _.isObjectLike({});
         * // => true
         *
         * _.isObjectLike([1, 2, 3]);
         * // => true
         *
         * _.isObjectLike(_.noop);
         * // => false
         *
         * _.isObjectLike(null);
         * // => false
         */


        function isObjectLike(value) {
          return value != null && typeof value == 'object';
        }
        /**
         * Checks if `value` is classified as a `Map` object.
         *
         * @static
         * @memberOf _
         * @since 4.3.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a map, else `false`.
         * @example
         *
         * _.isMap(new Map);
         * // => true
         *
         * _.isMap(new WeakMap);
         * // => false
         */


        var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
         * Performs a partial deep comparison between `object` and `source` to
         * determine if `object` contains equivalent property values.
         *
         * **Note:** This method is equivalent to `_.matches` when `source` is
         * partially applied.
         *
         * Partial comparisons will match empty array and empty object `source`
         * values against any array or object value, respectively. See `_.isEqual`
         * for a list of supported value comparisons.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Lang
         * @param {Object} object The object to inspect.
         * @param {Object} source The object of property values to match.
         * @returns {boolean} Returns `true` if `object` is a match, else `false`.
         * @example
         *
         * var object = { 'a': 1, 'b': 2 };
         *
         * _.isMatch(object, { 'b': 2 });
         * // => true
         *
         * _.isMatch(object, { 'b': 1 });
         * // => false
         */

        function isMatch(object, source) {
          return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
         * This method is like `_.isMatch` except that it accepts `customizer` which
         * is invoked to compare values. If `customizer` returns `undefined`, comparisons
         * are handled by the method instead. The `customizer` is invoked with five
         * arguments: (objValue, srcValue, index|key, object, source).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {Object} object The object to inspect.
         * @param {Object} source The object of property values to match.
         * @param {Function} [customizer] The function to customize comparisons.
         * @returns {boolean} Returns `true` if `object` is a match, else `false`.
         * @example
         *
         * function isGreeting(value) {
         *   return /^h(?:i|ello)$/.test(value);
         * }
         *
         * function customizer(objValue, srcValue) {
         *   if (isGreeting(objValue) && isGreeting(srcValue)) {
         *     return true;
         *   }
         * }
         *
         * var object = { 'greeting': 'hello' };
         * var source = { 'greeting': 'hi' };
         *
         * _.isMatchWith(object, source, customizer);
         * // => true
         */


        function isMatchWith(object, source, customizer) {
          customizer = typeof customizer == 'function' ? customizer : undefined$1;
          return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
         * Checks if `value` is `NaN`.
         *
         * **Note:** This method is based on
         * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
         * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
         * `undefined` and other non-number values.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
         * @example
         *
         * _.isNaN(NaN);
         * // => true
         *
         * _.isNaN(new Number(NaN));
         * // => true
         *
         * isNaN(undefined);
         * // => true
         *
         * _.isNaN(undefined);
         * // => false
         */


        function isNaN(value) {
          // An `NaN` primitive is the only value that is not equal to itself.
          // Perform the `toStringTag` check first to avoid errors with some
          // ActiveX objects in IE.
          return isNumber(value) && value != +value;
        }
        /**
         * Checks if `value` is a pristine native function.
         *
         * **Note:** This method can't reliably detect native functions in the presence
         * of the core-js package because core-js circumvents this kind of detection.
         * Despite multiple requests, the core-js maintainer has made it clear: any
         * attempt to fix the detection will be obstructed. As a result, we're left
         * with little choice but to throw an error. Unfortunately, this also affects
         * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
         * which rely on core-js.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a native function,
         *  else `false`.
         * @example
         *
         * _.isNative(Array.prototype.push);
         * // => true
         *
         * _.isNative(_);
         * // => false
         */


        function isNative(value) {
          if (isMaskable(value)) {
            throw new Error(CORE_ERROR_TEXT);
          }

          return baseIsNative(value);
        }
        /**
         * Checks if `value` is `null`.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
         * @example
         *
         * _.isNull(null);
         * // => true
         *
         * _.isNull(void 0);
         * // => false
         */


        function isNull(value) {
          return value === null;
        }
        /**
         * Checks if `value` is `null` or `undefined`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
         * @example
         *
         * _.isNil(null);
         * // => true
         *
         * _.isNil(void 0);
         * // => true
         *
         * _.isNil(NaN);
         * // => false
         */


        function isNil(value) {
          return value == null;
        }
        /**
         * Checks if `value` is classified as a `Number` primitive or object.
         *
         * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
         * classified as numbers, use the `_.isFinite` method.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a number, else `false`.
         * @example
         *
         * _.isNumber(3);
         * // => true
         *
         * _.isNumber(Number.MIN_VALUE);
         * // => true
         *
         * _.isNumber(Infinity);
         * // => true
         *
         * _.isNumber('3');
         * // => false
         */


        function isNumber(value) {
          return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
         * Checks if `value` is a plain object, that is, an object created by the
         * `Object` constructor or one with a `[[Prototype]]` of `null`.
         *
         * @static
         * @memberOf _
         * @since 0.8.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
         * @example
         *
         * function Foo() {
         *   this.a = 1;
         * }
         *
         * _.isPlainObject(new Foo);
         * // => false
         *
         * _.isPlainObject([1, 2, 3]);
         * // => false
         *
         * _.isPlainObject({ 'x': 0, 'y': 0 });
         * // => true
         *
         * _.isPlainObject(Object.create(null));
         * // => true
         */


        function isPlainObject(value) {
          if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
            return false;
          }

          var proto = getPrototype(value);

          if (proto === null) {
            return true;
          }

          var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
          return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
         * Checks if `value` is classified as a `RegExp` object.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
         * @example
         *
         * _.isRegExp(/abc/);
         * // => true
         *
         * _.isRegExp('/abc/');
         * // => false
         */


        var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
         * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
         * double precision number which isn't the result of a rounded unsafe integer.
         *
         * **Note:** This method is based on
         * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
         * @example
         *
         * _.isSafeInteger(3);
         * // => true
         *
         * _.isSafeInteger(Number.MIN_VALUE);
         * // => false
         *
         * _.isSafeInteger(Infinity);
         * // => false
         *
         * _.isSafeInteger('3');
         * // => false
         */

        function isSafeInteger(value) {
          return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
         * Checks if `value` is classified as a `Set` object.
         *
         * @static
         * @memberOf _
         * @since 4.3.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a set, else `false`.
         * @example
         *
         * _.isSet(new Set);
         * // => true
         *
         * _.isSet(new WeakSet);
         * // => false
         */


        var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
         * Checks if `value` is classified as a `String` primitive or object.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a string, else `false`.
         * @example
         *
         * _.isString('abc');
         * // => true
         *
         * _.isString(1);
         * // => false
         */

        function isString(value) {
          return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
         * Checks if `value` is classified as a `Symbol` primitive or object.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
         * @example
         *
         * _.isSymbol(Symbol.iterator);
         * // => true
         *
         * _.isSymbol('abc');
         * // => false
         */


        function isSymbol(value) {
          return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
         * Checks if `value` is classified as a typed array.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
         * @example
         *
         * _.isTypedArray(new Uint8Array);
         * // => true
         *
         * _.isTypedArray([]);
         * // => false
         */


        var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
         * Checks if `value` is `undefined`.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
         * @example
         *
         * _.isUndefined(void 0);
         * // => true
         *
         * _.isUndefined(null);
         * // => false
         */

        function isUndefined(value) {
          return value === undefined$1;
        }
        /**
         * Checks if `value` is classified as a `WeakMap` object.
         *
         * @static
         * @memberOf _
         * @since 4.3.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
         * @example
         *
         * _.isWeakMap(new WeakMap);
         * // => true
         *
         * _.isWeakMap(new Map);
         * // => false
         */


        function isWeakMap(value) {
          return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
         * Checks if `value` is classified as a `WeakSet` object.
         *
         * @static
         * @memberOf _
         * @since 4.3.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
         * @example
         *
         * _.isWeakSet(new WeakSet);
         * // => true
         *
         * _.isWeakSet(new Set);
         * // => false
         */


        function isWeakSet(value) {
          return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
         * Checks if `value` is less than `other`.
         *
         * @static
         * @memberOf _
         * @since 3.9.0
         * @category Lang
         * @param {*} value The value to compare.
         * @param {*} other The other value to compare.
         * @returns {boolean} Returns `true` if `value` is less than `other`,
         *  else `false`.
         * @see _.gt
         * @example
         *
         * _.lt(1, 3);
         * // => true
         *
         * _.lt(3, 3);
         * // => false
         *
         * _.lt(3, 1);
         * // => false
         */


        var lt = createRelationalOperation(baseLt);
        /**
         * Checks if `value` is less than or equal to `other`.
         *
         * @static
         * @memberOf _
         * @since 3.9.0
         * @category Lang
         * @param {*} value The value to compare.
         * @param {*} other The other value to compare.
         * @returns {boolean} Returns `true` if `value` is less than or equal to
         *  `other`, else `false`.
         * @see _.gte
         * @example
         *
         * _.lte(1, 3);
         * // => true
         *
         * _.lte(3, 3);
         * // => true
         *
         * _.lte(3, 1);
         * // => false
         */

        var lte = createRelationalOperation(function (value, other) {
          return value <= other;
        });
        /**
         * Converts `value` to an array.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Lang
         * @param {*} value The value to convert.
         * @returns {Array} Returns the converted array.
         * @example
         *
         * _.toArray({ 'a': 1, 'b': 2 });
         * // => [1, 2]
         *
         * _.toArray('abc');
         * // => ['a', 'b', 'c']
         *
         * _.toArray(1);
         * // => []
         *
         * _.toArray(null);
         * // => []
         */

        function toArray(value) {
          if (!value) {
            return [];
          }

          if (isArrayLike(value)) {
            return isString(value) ? stringToArray(value) : copyArray(value);
          }

          if (symIterator && value[symIterator]) {
            return iteratorToArray(value[symIterator]());
          }

          var tag = getTag(value),
              func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
          return func(value);
        }
        /**
         * Converts `value` to a finite number.
         *
         * @static
         * @memberOf _
         * @since 4.12.0
         * @category Lang
         * @param {*} value The value to convert.
         * @returns {number} Returns the converted number.
         * @example
         *
         * _.toFinite(3.2);
         * // => 3.2
         *
         * _.toFinite(Number.MIN_VALUE);
         * // => 5e-324
         *
         * _.toFinite(Infinity);
         * // => 1.7976931348623157e+308
         *
         * _.toFinite('3.2');
         * // => 3.2
         */


        function toFinite(value) {
          if (!value) {
            return value === 0 ? value : 0;
          }

          value = toNumber(value);

          if (value === INFINITY || value === -INFINITY) {
            var sign = value < 0 ? -1 : 1;
            return sign * MAX_INTEGER;
          }

          return value === value ? value : 0;
        }
        /**
         * Converts `value` to an integer.
         *
         * **Note:** This method is loosely based on
         * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to convert.
         * @returns {number} Returns the converted integer.
         * @example
         *
         * _.toInteger(3.2);
         * // => 3
         *
         * _.toInteger(Number.MIN_VALUE);
         * // => 0
         *
         * _.toInteger(Infinity);
         * // => 1.7976931348623157e+308
         *
         * _.toInteger('3.2');
         * // => 3
         */


        function toInteger(value) {
          var result = toFinite(value),
              remainder = result % 1;
          return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
         * Converts `value` to an integer suitable for use as the length of an
         * array-like object.
         *
         * **Note:** This method is based on
         * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to convert.
         * @returns {number} Returns the converted integer.
         * @example
         *
         * _.toLength(3.2);
         * // => 3
         *
         * _.toLength(Number.MIN_VALUE);
         * // => 0
         *
         * _.toLength(Infinity);
         * // => 4294967295
         *
         * _.toLength('3.2');
         * // => 3
         */


        function toLength(value) {
          return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
         * Converts `value` to a number.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to process.
         * @returns {number} Returns the number.
         * @example
         *
         * _.toNumber(3.2);
         * // => 3.2
         *
         * _.toNumber(Number.MIN_VALUE);
         * // => 5e-324
         *
         * _.toNumber(Infinity);
         * // => Infinity
         *
         * _.toNumber('3.2');
         * // => 3.2
         */


        function toNumber(value) {
          if (typeof value == 'number') {
            return value;
          }

          if (isSymbol(value)) {
            return NAN;
          }

          if (isObject(value)) {
            var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
            value = isObject(other) ? other + '' : other;
          }

          if (typeof value != 'string') {
            return value === 0 ? value : +value;
          }

          value = baseTrim(value);
          var isBinary = reIsBinary.test(value);
          return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
         * Converts `value` to a plain object flattening inherited enumerable string
         * keyed properties of `value` to own properties of the plain object.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Lang
         * @param {*} value The value to convert.
         * @returns {Object} Returns the converted plain object.
         * @example
         *
         * function Foo() {
         *   this.b = 2;
         * }
         *
         * Foo.prototype.c = 3;
         *
         * _.assign({ 'a': 1 }, new Foo);
         * // => { 'a': 1, 'b': 2 }
         *
         * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
         * // => { 'a': 1, 'b': 2, 'c': 3 }
         */


        function toPlainObject(value) {
          return copyObject(value, keysIn(value));
        }
        /**
         * Converts `value` to a safe integer. A safe integer can be compared and
         * represented correctly.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to convert.
         * @returns {number} Returns the converted integer.
         * @example
         *
         * _.toSafeInteger(3.2);
         * // => 3
         *
         * _.toSafeInteger(Number.MIN_VALUE);
         * // => 0
         *
         * _.toSafeInteger(Infinity);
         * // => 9007199254740991
         *
         * _.toSafeInteger('3.2');
         * // => 3
         */


        function toSafeInteger(value) {
          return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
         * Converts `value` to a string. An empty string is returned for `null`
         * and `undefined` values. The sign of `-0` is preserved.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to convert.
         * @returns {string} Returns the converted string.
         * @example
         *
         * _.toString(null);
         * // => ''
         *
         * _.toString(-0);
         * // => '-0'
         *
         * _.toString([1, 2, 3]);
         * // => '1,2,3'
         */


        function toString(value) {
          return value == null ? '' : baseToString(value);
        }
        /*------------------------------------------------------------------------*/

        /**
         * Assigns own enumerable string keyed properties of source objects to the
         * destination object. Source objects are applied from left to right.
         * Subsequent sources overwrite property assignments of previous sources.
         *
         * **Note:** This method mutates `object` and is loosely based on
         * [`Object.assign`](https://mdn.io/Object/assign).
         *
         * @static
         * @memberOf _
         * @since 0.10.0
         * @category Object
         * @param {Object} object The destination object.
         * @param {...Object} [sources] The source objects.
         * @returns {Object} Returns `object`.
         * @see _.assignIn
         * @example
         *
         * function Foo() {
         *   this.a = 1;
         * }
         *
         * function Bar() {
         *   this.c = 3;
         * }
         *
         * Foo.prototype.b = 2;
         * Bar.prototype.d = 4;
         *
         * _.assign({ 'a': 0 }, new Foo, new Bar);
         * // => { 'a': 1, 'c': 3 }
         */


        var assign = createAssigner(function (object, source) {
          if (isPrototype(source) || isArrayLike(source)) {
            copyObject(source, keys(source), object);
            return;
          }

          for (var key in source) {
            if (hasOwnProperty.call(source, key)) {
              assignValue(object, key, source[key]);
            }
          }
        });
        /**
         * This method is like `_.assign` except that it iterates over own and
         * inherited source properties.
         *
         * **Note:** This method mutates `object`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @alias extend
         * @category Object
         * @param {Object} object The destination object.
         * @param {...Object} [sources] The source objects.
         * @returns {Object} Returns `object`.
         * @see _.assign
         * @example
         *
         * function Foo() {
         *   this.a = 1;
         * }
         *
         * function Bar() {
         *   this.c = 3;
         * }
         *
         * Foo.prototype.b = 2;
         * Bar.prototype.d = 4;
         *
         * _.assignIn({ 'a': 0 }, new Foo, new Bar);
         * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
         */

        var assignIn = createAssigner(function (object, source) {
          copyObject(source, keysIn(source), object);
        });
        /**
         * This method is like `_.assignIn` except that it accepts `customizer`
         * which is invoked to produce the assigned values. If `customizer` returns
         * `undefined`, assignment is handled by the method instead. The `customizer`
         * is invoked with five arguments: (objValue, srcValue, key, object, source).
         *
         * **Note:** This method mutates `object`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @alias extendWith
         * @category Object
         * @param {Object} object The destination object.
         * @param {...Object} sources The source objects.
         * @param {Function} [customizer] The function to customize assigned values.
         * @returns {Object} Returns `object`.
         * @see _.assignWith
         * @example
         *
         * function customizer(objValue, srcValue) {
         *   return _.isUndefined(objValue) ? srcValue : objValue;
         * }
         *
         * var defaults = _.partialRight(_.assignInWith, customizer);
         *
         * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
         * // => { 'a': 1, 'b': 2 }
         */

        var assignInWith = createAssigner(function (object, source, srcIndex, customizer) {
          copyObject(source, keysIn(source), object, customizer);
        });
        /**
         * This method is like `_.assign` except that it accepts `customizer`
         * which is invoked to produce the assigned values. If `customizer` returns
         * `undefined`, assignment is handled by the method instead. The `customizer`
         * is invoked with five arguments: (objValue, srcValue, key, object, source).
         *
         * **Note:** This method mutates `object`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Object
         * @param {Object} object The destination object.
         * @param {...Object} sources The source objects.
         * @param {Function} [customizer] The function to customize assigned values.
         * @returns {Object} Returns `object`.
         * @see _.assignInWith
         * @example
         *
         * function customizer(objValue, srcValue) {
         *   return _.isUndefined(objValue) ? srcValue : objValue;
         * }
         *
         * var defaults = _.partialRight(_.assignWith, customizer);
         *
         * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
         * // => { 'a': 1, 'b': 2 }
         */

        var assignWith = createAssigner(function (object, source, srcIndex, customizer) {
          copyObject(source, keys(source), object, customizer);
        });
        /**
         * Creates an array of values corresponding to `paths` of `object`.
         *
         * @static
         * @memberOf _
         * @since 1.0.0
         * @category Object
         * @param {Object} object The object to iterate over.
         * @param {...(string|string[])} [paths] The property paths to pick.
         * @returns {Array} Returns the picked values.
         * @example
         *
         * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
         *
         * _.at(object, ['a[0].b.c', 'a[1]']);
         * // => [3, 4]
         */

        var at = flatRest(baseAt);
        /**
         * Creates an object that inherits from the `prototype` object. If a
         * `properties` object is given, its own enumerable string keyed properties
         * are assigned to the created object.
         *
         * @static
         * @memberOf _
         * @since 2.3.0
         * @category Object
         * @param {Object} prototype The object to inherit from.
         * @param {Object} [properties] The properties to assign to the object.
         * @returns {Object} Returns the new object.
         * @example
         *
         * function Shape() {
         *   this.x = 0;
         *   this.y = 0;
         * }
         *
         * function Circle() {
         *   Shape.call(this);
         * }
         *
         * Circle.prototype = _.create(Shape.prototype, {
         *   'constructor': Circle
         * });
         *
         * var circle = new Circle;
         * circle instanceof Circle;
         * // => true
         *
         * circle instanceof Shape;
         * // => true
         */

        function create(prototype, properties) {
          var result = baseCreate(prototype);
          return properties == null ? result : baseAssign(result, properties);
        }
        /**
         * Assigns own and inherited enumerable string keyed properties of source
         * objects to the destination object for all destination properties that
         * resolve to `undefined`. Source objects are applied from left to right.
         * Once a property is set, additional values of the same property are ignored.
         *
         * **Note:** This method mutates `object`.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Object
         * @param {Object} object The destination object.
         * @param {...Object} [sources] The source objects.
         * @returns {Object} Returns `object`.
         * @see _.defaultsDeep
         * @example
         *
         * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
         * // => { 'a': 1, 'b': 2 }
         */


        var defaults = baseRest(function (object, sources) {
          object = Object(object);
          var index = -1;
          var length = sources.length;
          var guard = length > 2 ? sources[2] : undefined$1;

          if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            length = 1;
          }

          while (++index < length) {
            var source = sources[index];
            var props = keysIn(source);
            var propsIndex = -1;
            var propsLength = props.length;

            while (++propsIndex < propsLength) {
              var key = props[propsIndex];
              var value = object[key];

              if (value === undefined$1 || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) {
                object[key] = source[key];
              }
            }
          }

          return object;
        });
        /**
         * This method is like `_.defaults` except that it recursively assigns
         * default properties.
         *
         * **Note:** This method mutates `object`.
         *
         * @static
         * @memberOf _
         * @since 3.10.0
         * @category Object
         * @param {Object} object The destination object.
         * @param {...Object} [sources] The source objects.
         * @returns {Object} Returns `object`.
         * @see _.defaults
         * @example
         *
         * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
         * // => { 'a': { 'b': 2, 'c': 3 } }
         */

        var defaultsDeep = baseRest(function (args) {
          args.push(undefined$1, customDefaultsMerge);
          return apply(mergeWith, undefined$1, args);
        });
        /**
         * This method is like `_.find` except that it returns the key of the first
         * element `predicate` returns truthy for instead of the element itself.
         *
         * @static
         * @memberOf _
         * @since 1.1.0
         * @category Object
         * @param {Object} object The object to inspect.
         * @param {Function} [predicate=_.identity] The function invoked per iteration.
         * @returns {string|undefined} Returns the key of the matched element,
         *  else `undefined`.
         * @example
         *
         * var users = {
         *   'barney':  { 'age': 36, 'active': true },
         *   'fred':    { 'age': 40, 'active': false },
         *   'pebbles': { 'age': 1,  'active': true }
         * };
         *
         * _.findKey(users, function(o) { return o.age < 40; });
         * // => 'barney' (iteration order is not guaranteed)
         *
         * // The `_.matches` iteratee shorthand.
         * _.findKey(users, { 'age': 1, 'active': true });
         * // => 'pebbles'
         *
         * // The `_.matchesProperty` iteratee shorthand.
         * _.findKey(users, ['active', false]);
         * // => 'fred'
         *
         * // The `_.property` iteratee shorthand.
         * _.findKey(users, 'active');
         * // => 'barney'
         */

        function findKey(object, predicate) {
          return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
         * This method is like `_.findKey` except that it iterates over elements of
         * a collection in the opposite order.
         *
         * @static
         * @memberOf _
         * @since 2.0.0
         * @category Object
         * @param {Object} object The object to inspect.
         * @param {Function} [predicate=_.identity] The function invoked per iteration.
         * @returns {string|undefined} Returns the key of the matched element,
         *  else `undefined`.
         * @example
         *
         * var users = {
         *   'barney':  { 'age': 36, 'active': true },
         *   'fred':    { 'age': 40, 'active': false },
         *   'pebbles': { 'age': 1,  'active': true }
         * };
         *
         * _.findLastKey(users, function(o) { return o.age < 40; });
         * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
         *
         * // The `_.matches` iteratee shorthand.
         * _.findLastKey(users, { 'age': 36, 'active': true });
         * // => 'barney'
         *
         * // The `_.matchesProperty` iteratee shorthand.
         * _.findLastKey(users, ['active', false]);
         * // => 'fred'
         *
         * // The `_.property` iteratee shorthand.
         * _.findLastKey(users, 'active');
         * // => 'pebbles'
         */


        function findLastKey(object, predicate) {
          return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
         * Iterates over own and inherited enumerable string keyed properties of an
         * object and invokes `iteratee` for each property. The iteratee is invoked
         * with three arguments: (value, key, object). Iteratee functions may exit
         * iteration early by explicitly returning `false`.
         *
         * @static
         * @memberOf _
         * @since 0.3.0
         * @category Object
         * @param {Object} object The object to iterate over.
         * @param {Function} [iteratee=_.identity] The function invoked per iteration.
         * @returns {Object} Returns `object`.
         * @see _.forInRight
         * @example
         *
         * function Foo() {
         *   this.a = 1;
         *   this.b = 2;
         * }
         *
         * Foo.prototype.c = 3;
         *
         * _.forIn(new Foo, function(value, key) {
         *   console.log(key);
         * });
         * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
         */


        function forIn(object, iteratee) {
          return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
         * This method is like `_.forIn` except that it iterates over properties of
         * `object` in the opposite order.
         *
         * @static
         * @memberOf _
         * @since 2.0.0
         * @category Object
         * @param {Object} object The object to iterate over.
         * @param {Function} [iteratee=_.identity] The function invoked per iteration.
         * @returns {Object} Returns `object`.
         * @see _.forIn
         * @example
         *
         * function Foo() {
         *   this.a = 1;
         *   this.b = 2;
         * }
         *
         * Foo.prototype.c = 3;
         *
         * _.forInRight(new Foo, function(value, key) {
         *   console.log(key);
         * });
         * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
         */


        function forInRight(object, iteratee) {
          return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
         * Iterates over own enumerable string keyed properties of an object and
         * invokes `iteratee` for each property. The iteratee is invoked with three
         * arguments: (value, key, object). Iteratee functions may exit iteration
         * early by explicitly returning `false`.
         *
         * @static
         * @memberOf _
         * @since 0.3.0
         * @category Object
         * @param {Object} object The object to iterate over.
         * @param {Function} [iteratee=_.identity] The function invoked per iteration.
         * @returns {Object} Returns `object`.
         * @see _.forOwnRight
         * @example
         *
         * function Foo() {
         *   this.a = 1;
         *   this.b = 2;
         * }
         *
         * Foo.prototype.c = 3;
         *
         * _.forOwn(new Foo, function(value, key) {
         *   console.log(key);
         * });
         * // => Logs 'a' then 'b' (iteration order is not guaranteed).
         */


        function forOwn(object, iteratee) {
          return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
         * This method is like `_.forOwn` except that it iterates over properties of
         * `object` in the opposite order.
         *
         * @static
         * @memberOf _
         * @since 2.0.0
         * @category Object
         * @param {Object} object The object to iterate over.
         * @param {Function} [iteratee=_.identity] The function invoked per iteration.
         * @returns {Object} Returns `object`.
         * @see _.forOwn
         * @example
         *
         * function Foo() {
         *   this.a = 1;
         *   this.b = 2;
         * }
         *
         * Foo.prototype.c = 3;
         *
         * _.forOwnRight(new Foo, function(value, key) {
         *   console.log(key);
         * });
         * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
         */


        function forOwnRight(object, iteratee) {
          return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
         * Creates an array of function property names from own enumerable properties
         * of `object`.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Object
         * @param {Object} object The object to inspect.
         * @returns {Array} Returns the function names.
         * @see _.functionsIn
         * @example
         *
         * function Foo() {
         *   this.a = _.constant('a');
         *   this.b = _.constant('b');
         * }
         *
         * Foo.prototype.c = _.constant('c');
         *
         * _.functions(new Foo);
         * // => ['a', 'b']
         */


        function functions(object) {
          return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
         * Creates an array of function property names from own and inherited
         * enumerable properties of `object`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Object
         * @param {Object} object The object to inspect.
         * @returns {Array} Returns the function names.
         * @see _.functions
         * @example
         *
         * function Foo() {
         *   this.a = _.constant('a');
         *   this.b = _.constant('b');
         * }
         *
         * Foo.prototype.c = _.constant('c');
         *
         * _.functionsIn(new Foo);
         * // => ['a', 'b', 'c']
         */


        function functionsIn(object) {
          return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
         * Gets the value at `path` of `object`. If the resolved value is
         * `undefined`, the `defaultValue` is returned in its place.
         *
         * @static
         * @memberOf _
         * @since 3.7.0
         * @category Object
         * @param {Object} object The object to query.
         * @param {Array|string} path The path of the property to get.
         * @param {*} [defaultValue] The value returned for `undefined` resolved values.
         * @returns {*} Returns the resolved value.
         * @example
         *
         * var object = { 'a': [{ 'b': { 'c': 3 } }] };
         *
         * _.get(object, 'a[0].b.c');
         * // => 3
         *
         * _.get(object, ['a', '0', 'b', 'c']);
         * // => 3
         *
         * _.get(object, 'a.b.c', 'default');
         * // => 'default'
         */


        function get(object, path, defaultValue) {
          var result = object == null ? undefined$1 : baseGet(object, path);
          return result === undefined$1 ? defaultValue : result;
        }
        /**
         * Checks if `path` is a direct property of `object`.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Object
         * @param {Object} object The object to query.
         * @param {Array|string} path The path to check.
         * @returns {boolean} Returns `true` if `path` exists, else `false`.
         * @example
         *
         * var object = { 'a': { 'b': 2 } };
         * var other = _.create({ 'a': _.create({ 'b': 2 }) });
         *
         * _.has(object, 'a');
         * // => true
         *
         * _.has(object, 'a.b');
         * // => true
         *
         * _.has(object, ['a', 'b']);
         * // => true
         *
         * _.has(other, 'a');
         * // => false
         */


        function has(object, path) {
          return object != null && hasPath(object, path, baseHas);
        }
        /**
         * Checks if `path` is a direct or inherited property of `object`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Object
         * @param {Object} object The object to query.
         * @param {Array|string} path The path to check.
         * @returns {boolean} Returns `true` if `path` exists, else `false`.
         * @example
         *
         * var object = _.create({ 'a': _.create({ 'b': 2 }) });
         *
         * _.hasIn(object, 'a');
         * // => true
         *
         * _.hasIn(object, 'a.b');
         * // => true
         *
         * _.hasIn(object, ['a', 'b']);
         * // => true
         *
         * _.hasIn(object, 'b');
         * // => false
         */


        function hasIn(object, path) {
          return object != null && hasPath(object, path, baseHasIn);
        }
        /**
         * Creates an object composed of the inverted keys and values of `object`.
         * If `object` contains duplicate values, subsequent values overwrite
         * property assignments of previous values.
         *
         * @static
         * @memberOf _
         * @since 0.7.0
         * @category Object
         * @param {Object} object The object to invert.
         * @returns {Object} Returns the new inverted object.
         * @example
         *
         * var object = { 'a': 1, 'b': 2, 'c': 1 };
         *
         * _.invert(object);
         * // => { '1': 'c', '2': 'b' }
         */


        var invert = createInverter(function (result, value, key) {
          if (value != null && typeof value.toString != 'function') {
            value = nativeObjectToString.call(value);
          }

          result[value] = key;
        }, constant(identity));
        /**
         * This method is like `_.invert` except that the inverted object is generated
         * from the results of running each element of `object` thru `iteratee`. The
         * corresponding inverted value of each inverted key is an array of keys
         * responsible for generating the inverted value. The iteratee is invoked
         * with one argument: (value).
         *
         * @static
         * @memberOf _
         * @since 4.1.0
         * @category Object
         * @param {Object} object The object to invert.
         * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
         * @returns {Object} Returns the new inverted object.
         * @example
         *
         * var object = { 'a': 1, 'b': 2, 'c': 1 };
         *
         * _.invertBy(object);
         * // => { '1': ['a', 'c'], '2': ['b'] }
         *
         * _.invertBy(object, function(value) {
         *   return 'group' + value;
         * });
         * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
         */

        var invertBy = createInverter(function (result, value, key) {
          if (value != null && typeof value.toString != 'function') {
            value = nativeObjectToString.call(value);
          }

          if (hasOwnProperty.call(result, value)) {
            result[value].push(key);
          } else {
            result[value] = [key];
          }
        }, getIteratee);
        /**
         * Invokes the method at `path` of `object`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Object
         * @param {Object} object The object to query.
         * @param {Array|string} path The path of the method to invoke.
         * @param {...*} [args] The arguments to invoke the method with.
         * @returns {*} Returns the result of the invoked method.
         * @example
         *
         * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
         *
         * _.invoke(object, 'a[0].b.c.slice', 1, 3);
         * // => [2, 3]
         */

        var invoke = baseRest(baseInvoke);
        /**
         * Creates an array of the own enumerable property names of `object`.
         *
         * **Note:** Non-object values are coerced to objects. See the
         * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
         * for more details.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Object
         * @param {Object} object The object to query.
         * @returns {Array} Returns the array of property names.
         * @example
         *
         * function Foo() {
         *   this.a = 1;
         *   this.b = 2;
         * }
         *
         * Foo.prototype.c = 3;
         *
         * _.keys(new Foo);
         * // => ['a', 'b'] (iteration order is not guaranteed)
         *
         * _.keys('hi');
         * // => ['0', '1']
         */

        function keys(object) {
          return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
         * Creates an array of the own and inherited enumerable property names of `object`.
         *
         * **Note:** Non-object values are coerced to objects.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Object
         * @param {Object} object The object to query.
         * @returns {Array} Returns the array of property names.
         * @example
         *
         * function Foo() {
         *   this.a = 1;
         *   this.b = 2;
         * }
         *
         * Foo.prototype.c = 3;
         *
         * _.keysIn(new Foo);
         * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
         */


        function keysIn(object) {
          return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
         * The opposite of `_.mapValues`; this method creates an object with the
         * same values as `object` and keys generated by running each own enumerable
         * string keyed property of `object` thru `iteratee`. The iteratee is invoked
         * with three arguments: (value, key, object).
         *
         * @static
         * @memberOf _
         * @since 3.8.0
         * @category Object
         * @param {Object} object The object to iterate over.
         * @param {Function} [iteratee=_.identity] The function invoked per iteration.
         * @returns {Object} Returns the new mapped object.
         * @see _.mapValues
         * @example
         *
         * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
         *   return key + value;
         * });
         * // => { 'a1': 1, 'b2': 2 }
         */


        function mapKeys(object, iteratee) {
          var result = {};
          iteratee = getIteratee(iteratee, 3);
          baseForOwn(object, function (value, key, object) {
            baseAssignValue(result, iteratee(value, key, object), value);
          });
          return result;
        }
        /**
         * Creates an object with the same keys as `object` and values generated
         * by running each own enumerable string keyed property of `object` thru
         * `iteratee`. The iteratee is invoked with three arguments:
         * (value, key, object).
         *
         * @static
         * @memberOf _
         * @since 2.4.0
         * @category Object
         * @param {Object} object The object to iterate over.
         * @param {Function} [iteratee=_.identity] The function invoked per iteration.
         * @returns {Object} Returns the new mapped object.
         * @see _.mapKeys
         * @example
         *
         * var users = {
         *   'fred':    { 'user': 'fred',    'age': 40 },
         *   'pebbles': { 'user': 'pebbles', 'age': 1 }
         * };
         *
         * _.mapValues(users, function(o) { return o.age; });
         * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
         *
         * // The `_.property` iteratee shorthand.
         * _.mapValues(users, 'age');
         * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
         */


        function mapValues(object, iteratee) {
          var result = {};
          iteratee = getIteratee(iteratee, 3);
          baseForOwn(object, function (value, key, object) {
            baseAssignValue(result, key, iteratee(value, key, object));
          });
          return result;
        }
        /**
         * This method is like `_.assign` except that it recursively merges own and
         * inherited enumerable string keyed properties of source objects into the
         * destination object. Source properties that resolve to `undefined` are
         * skipped if a destination value exists. Array and plain object properties
         * are merged recursively. Other objects and value types are overridden by
         * assignment. Source objects are applied from left to right. Subsequent
         * sources overwrite property assignments of previous sources.
         *
         * **Note:** This method mutates `object`.
         *
         * @static
         * @memberOf _
         * @since 0.5.0
         * @category Object
         * @param {Object} object The destination object.
         * @param {...Object} [sources] The source objects.
         * @returns {Object} Returns `object`.
         * @example
         *
         * var object = {
         *   'a': [{ 'b': 2 }, { 'd': 4 }]
         * };
         *
         * var other = {
         *   'a': [{ 'c': 3 }, { 'e': 5 }]
         * };
         *
         * _.merge(object, other);
         * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
         */


        var merge = createAssigner(function (object, source, srcIndex) {
          baseMerge(object, source, srcIndex);
        });
        /**
         * This method is like `_.merge` except that it accepts `customizer` which
         * is invoked to produce the merged values of the destination and source
         * properties. If `customizer` returns `undefined`, merging is handled by the
         * method instead. The `customizer` is invoked with six arguments:
         * (objValue, srcValue, key, object, source, stack).
         *
         * **Note:** This method mutates `object`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Object
         * @param {Object} object The destination object.
         * @param {...Object} sources The source objects.
         * @param {Function} customizer The function to customize assigned values.
         * @returns {Object} Returns `object`.
         * @example
         *
         * function customizer(objValue, srcValue) {
         *   if (_.isArray(objValue)) {
         *     return objValue.concat(srcValue);
         *   }
         * }
         *
         * var object = { 'a': [1], 'b': [2] };
         * var other = { 'a': [3], 'b': [4] };
         *
         * _.mergeWith(object, other, customizer);
         * // => { 'a': [1, 3], 'b': [2, 4] }
         */

        var mergeWith = createAssigner(function (object, source, srcIndex, customizer) {
          baseMerge(object, source, srcIndex, customizer);
        });
        /**
         * The opposite of `_.pick`; this method creates an object composed of the
         * own and inherited enumerable property paths of `object` that are not omitted.
         *
         * **Note:** This method is considerably slower than `_.pick`.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Object
         * @param {Object} object The source object.
         * @param {...(string|string[])} [paths] The property paths to omit.
         * @returns {Object} Returns the new object.
         * @example
         *
         * var object = { 'a': 1, 'b': '2', 'c': 3 };
         *
         * _.omit(object, ['a', 'c']);
         * // => { 'b': '2' }
         */

        var omit = flatRest(function (object, paths) {
          var result = {};

          if (object == null) {
            return result;
          }

          var isDeep = false;
          paths = arrayMap(paths, function (path) {
            path = castPath(path, object);
            isDeep || (isDeep = path.length > 1);
            return path;
          });
          copyObject(object, getAllKeysIn(object), result);

          if (isDeep) {
            result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
          }

          var length = paths.length;

          while (length--) {
            baseUnset(result, paths[length]);
          }

          return result;
        });
        /**
         * The opposite of `_.pickBy`; this method creates an object composed of
         * the own and inherited enumerable string keyed properties of `object` that
         * `predicate` doesn't return truthy for. The predicate is invoked with two
         * arguments: (value, key).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Object
         * @param {Object} object The source object.
         * @param {Function} [predicate=_.identity] The function invoked per property.
         * @returns {Object} Returns the new object.
         * @example
         *
         * var object = { 'a': 1, 'b': '2', 'c': 3 };
         *
         * _.omitBy(object, _.isNumber);
         * // => { 'b': '2' }
         */

        function omitBy(object, predicate) {
          return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
         * Creates an object composed of the picked `object` properties.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Object
         * @param {Object} object The source object.
         * @param {...(string|string[])} [paths] The property paths to pick.
         * @returns {Object} Returns the new object.
         * @example
         *
         * var object = { 'a': 1, 'b': '2', 'c': 3 };
         *
         * _.pick(object, ['a', 'c']);
         * // => { 'a': 1, 'c': 3 }
         */


        var pick = flatRest(function (object, paths) {
          return object == null ? {} : basePick(object, paths);
        });
        /**
         * Creates an object composed of the `object` properties `predicate` returns
         * truthy for. The predicate is invoked with two arguments: (value, key).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Object
         * @param {Object} object The source object.
         * @param {Function} [predicate=_.identity] The function invoked per property.
         * @returns {Object} Returns the new object.
         * @example
         *
         * var object = { 'a': 1, 'b': '2', 'c': 3 };
         *
         * _.pickBy(object, _.isNumber);
         * // => { 'a': 1, 'c': 3 }
         */

        function pickBy(object, predicate) {
          if (object == null) {
            return {};
          }

          var props = arrayMap(getAllKeysIn(object), function (prop) {
            return [prop];
          });
          predicate = getIteratee(predicate);
          return basePickBy(object, props, function (value, path) {
            return predicate(value, path[0]);
          });
        }
        /**
         * This method is like `_.get` except that if the resolved value is a
         * function it's invoked with the `this` binding of its parent object and
         * its result is returned.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Object
         * @param {Object} object The object to query.
         * @param {Array|string} path The path of the property to resolve.
         * @param {*} [defaultValue] The value returned for `undefined` resolved values.
         * @returns {*} Returns the resolved value.
         * @example
         *
         * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
         *
         * _.result(object, 'a[0].b.c1');
         * // => 3
         *
         * _.result(object, 'a[0].b.c2');
         * // => 4
         *
         * _.result(object, 'a[0].b.c3', 'default');
         * // => 'default'
         *
         * _.result(object, 'a[0].b.c3', _.constant('default'));
         * // => 'default'
         */


        function result(object, path, defaultValue) {
          path = castPath(path, object);
          var index = -1,
              length = path.length; // Ensure the loop is entered when path is empty.

          if (!length) {
            length = 1;
            object = undefined$1;
          }

          while (++index < length) {
            var value = object == null ? undefined$1 : object[toKey(path[index])];

            if (value === undefined$1) {
              index = length;
              value = defaultValue;
            }

            object = isFunction(value) ? value.call(object) : value;
          }

          return object;
        }
        /**
         * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
         * it's created. Arrays are created for missing index properties while objects
         * are created for all other missing properties. Use `_.setWith` to customize
         * `path` creation.
         *
         * **Note:** This method mutates `object`.
         *
         * @static
         * @memberOf _
         * @since 3.7.0
         * @category Object
         * @param {Object} object The object to modify.
         * @param {Array|string} path The path of the property to set.
         * @param {*} value The value to set.
         * @returns {Object} Returns `object`.
         * @example
         *
         * var object = { 'a': [{ 'b': { 'c': 3 } }] };
         *
         * _.set(object, 'a[0].b.c', 4);
         * console.log(object.a[0].b.c);
         * // => 4
         *
         * _.set(object, ['x', '0', 'y', 'z'], 5);
         * console.log(object.x[0].y.z);
         * // => 5
         */


        function set(object, path, value) {
          return object == null ? object : baseSet(object, path, value);
        }
        /**
         * This method is like `_.set` except that it accepts `customizer` which is
         * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
         * path creation is handled by the method instead. The `customizer` is invoked
         * with three arguments: (nsValue, key, nsObject).
         *
         * **Note:** This method mutates `object`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Object
         * @param {Object} object The object to modify.
         * @param {Array|string} path The path of the property to set.
         * @param {*} value The value to set.
         * @param {Function} [customizer] The function to customize assigned values.
         * @returns {Object} Returns `object`.
         * @example
         *
         * var object = {};
         *
         * _.setWith(object, '[0][1]', 'a', Object);
         * // => { '0': { '1': 'a' } }
         */


        function setWith(object, path, value, customizer) {
          customizer = typeof customizer == 'function' ? customizer : undefined$1;
          return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
         * Creates an array of own enumerable string keyed-value pairs for `object`
         * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
         * entries are returned.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @alias entries
         * @category Object
         * @param {Object} object The object to query.
         * @returns {Array} Returns the key-value pairs.
         * @example
         *
         * function Foo() {
         *   this.a = 1;
         *   this.b = 2;
         * }
         *
         * Foo.prototype.c = 3;
         *
         * _.toPairs(new Foo);
         * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
         */


        var toPairs = createToPairs(keys);
        /**
         * Creates an array of own and inherited enumerable string keyed-value pairs
         * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
         * or set, its entries are returned.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @alias entriesIn
         * @category Object
         * @param {Object} object The object to query.
         * @returns {Array} Returns the key-value pairs.
         * @example
         *
         * function Foo() {
         *   this.a = 1;
         *   this.b = 2;
         * }
         *
         * Foo.prototype.c = 3;
         *
         * _.toPairsIn(new Foo);
         * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
         */

        var toPairsIn = createToPairs(keysIn);
        /**
         * An alternative to `_.reduce`; this method transforms `object` to a new
         * `accumulator` object which is the result of running each of its own
         * enumerable string keyed properties thru `iteratee`, with each invocation
         * potentially mutating the `accumulator` object. If `accumulator` is not
         * provided, a new object with the same `[[Prototype]]` will be used. The
         * iteratee is invoked with four arguments: (accumulator, value, key, object).
         * Iteratee functions may exit iteration early by explicitly returning `false`.
         *
         * @static
         * @memberOf _
         * @since 1.3.0
         * @category Object
         * @param {Object} object The object to iterate over.
         * @param {Function} [iteratee=_.identity] The function invoked per iteration.
         * @param {*} [accumulator] The custom accumulator value.
         * @returns {*} Returns the accumulated value.
         * @example
         *
         * _.transform([2, 3, 4], function(result, n) {
         *   result.push(n *= n);
         *   return n % 2 == 0;
         * }, []);
         * // => [4, 9]
         *
         * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
         *   (result[value] || (result[value] = [])).push(key);
         * }, {});
         * // => { '1': ['a', 'c'], '2': ['b'] }
         */

        function transform(object, iteratee, accumulator) {
          var isArr = isArray(object),
              isArrLike = isArr || isBuffer(object) || isTypedArray(object);
          iteratee = getIteratee(iteratee, 4);

          if (accumulator == null) {
            var Ctor = object && object.constructor;

            if (isArrLike) {
              accumulator = isArr ? new Ctor() : [];
            } else if (isObject(object)) {
              accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
            } else {
              accumulator = {};
            }
          }

          (isArrLike ? arrayEach : baseForOwn)(object, function (value, index, object) {
            return iteratee(accumulator, value, index, object);
          });
          return accumulator;
        }
        /**
         * Removes the property at `path` of `object`.
         *
         * **Note:** This method mutates `object`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Object
         * @param {Object} object The object to modify.
         * @param {Array|string} path The path of the property to unset.
         * @returns {boolean} Returns `true` if the property is deleted, else `false`.
         * @example
         *
         * var object = { 'a': [{ 'b': { 'c': 7 } }] };
         * _.unset(object, 'a[0].b.c');
         * // => true
         *
         * console.log(object);
         * // => { 'a': [{ 'b': {} }] };
         *
         * _.unset(object, ['a', '0', 'b', 'c']);
         * // => true
         *
         * console.log(object);
         * // => { 'a': [{ 'b': {} }] };
         */


        function unset(object, path) {
          return object == null ? true : baseUnset(object, path);
        }
        /**
         * This method is like `_.set` except that accepts `updater` to produce the
         * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
         * is invoked with one argument: (value).
         *
         * **Note:** This method mutates `object`.
         *
         * @static
         * @memberOf _
         * @since 4.6.0
         * @category Object
         * @param {Object} object The object to modify.
         * @param {Array|string} path The path of the property to set.
         * @param {Function} updater The function to produce the updated value.
         * @returns {Object} Returns `object`.
         * @example
         *
         * var object = { 'a': [{ 'b': { 'c': 3 } }] };
         *
         * _.update(object, 'a[0].b.c', function(n) { return n * n; });
         * console.log(object.a[0].b.c);
         * // => 9
         *
         * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
         * console.log(object.x[0].y.z);
         * // => 0
         */


        function update(object, path, updater) {
          return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
         * This method is like `_.update` except that it accepts `customizer` which is
         * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
         * path creation is handled by the method instead. The `customizer` is invoked
         * with three arguments: (nsValue, key, nsObject).
         *
         * **Note:** This method mutates `object`.
         *
         * @static
         * @memberOf _
         * @since 4.6.0
         * @category Object
         * @param {Object} object The object to modify.
         * @param {Array|string} path The path of the property to set.
         * @param {Function} updater The function to produce the updated value.
         * @param {Function} [customizer] The function to customize assigned values.
         * @returns {Object} Returns `object`.
         * @example
         *
         * var object = {};
         *
         * _.updateWith(object, '[0][1]', _.constant('a'), Object);
         * // => { '0': { '1': 'a' } }
         */


        function updateWith(object, path, updater, customizer) {
          customizer = typeof customizer == 'function' ? customizer : undefined$1;
          return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
         * Creates an array of the own enumerable string keyed property values of `object`.
         *
         * **Note:** Non-object values are coerced to objects.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Object
         * @param {Object} object The object to query.
         * @returns {Array} Returns the array of property values.
         * @example
         *
         * function Foo() {
         *   this.a = 1;
         *   this.b = 2;
         * }
         *
         * Foo.prototype.c = 3;
         *
         * _.values(new Foo);
         * // => [1, 2] (iteration order is not guaranteed)
         *
         * _.values('hi');
         * // => ['h', 'i']
         */


        function values(object) {
          return object == null ? [] : baseValues(object, keys(object));
        }
        /**
         * Creates an array of the own and inherited enumerable string keyed property
         * values of `object`.
         *
         * **Note:** Non-object values are coerced to objects.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Object
         * @param {Object} object The object to query.
         * @returns {Array} Returns the array of property values.
         * @example
         *
         * function Foo() {
         *   this.a = 1;
         *   this.b = 2;
         * }
         *
         * Foo.prototype.c = 3;
         *
         * _.valuesIn(new Foo);
         * // => [1, 2, 3] (iteration order is not guaranteed)
         */


        function valuesIn(object) {
          return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/

        /**
         * Clamps `number` within the inclusive `lower` and `upper` bounds.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Number
         * @param {number} number The number to clamp.
         * @param {number} [lower] The lower bound.
         * @param {number} upper The upper bound.
         * @returns {number} Returns the clamped number.
         * @example
         *
         * _.clamp(-10, -5, 5);
         * // => -5
         *
         * _.clamp(10, -5, 5);
         * // => 5
         */


        function clamp(number, lower, upper) {
          if (upper === undefined$1) {
            upper = lower;
            lower = undefined$1;
          }

          if (upper !== undefined$1) {
            upper = toNumber(upper);
            upper = upper === upper ? upper : 0;
          }

          if (lower !== undefined$1) {
            lower = toNumber(lower);
            lower = lower === lower ? lower : 0;
          }

          return baseClamp(toNumber(number), lower, upper);
        }
        /**
         * Checks if `n` is between `start` and up to, but not including, `end`. If
         * `end` is not specified, it's set to `start` with `start` then set to `0`.
         * If `start` is greater than `end` the params are swapped to support
         * negative ranges.
         *
         * @static
         * @memberOf _
         * @since 3.3.0
         * @category Number
         * @param {number} number The number to check.
         * @param {number} [start=0] The start of the range.
         * @param {number} end The end of the range.
         * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
         * @see _.range, _.rangeRight
         * @example
         *
         * _.inRange(3, 2, 4);
         * // => true
         *
         * _.inRange(4, 8);
         * // => true
         *
         * _.inRange(4, 2);
         * // => false
         *
         * _.inRange(2, 2);
         * // => false
         *
         * _.inRange(1.2, 2);
         * // => true
         *
         * _.inRange(5.2, 4);
         * // => false
         *
         * _.inRange(-3, -2, -6);
         * // => true
         */


        function inRange(number, start, end) {
          start = toFinite(start);

          if (end === undefined$1) {
            end = start;
            start = 0;
          } else {
            end = toFinite(end);
          }

          number = toNumber(number);
          return baseInRange(number, start, end);
        }
        /**
         * Produces a random number between the inclusive `lower` and `upper` bounds.
         * If only one argument is provided a number between `0` and the given number
         * is returned. If `floating` is `true`, or either `lower` or `upper` are
         * floats, a floating-point number is returned instead of an integer.
         *
         * **Note:** JavaScript follows the IEEE-754 standard for resolving
         * floating-point values which can produce unexpected results.
         *
         * @static
         * @memberOf _
         * @since 0.7.0
         * @category Number
         * @param {number} [lower=0] The lower bound.
         * @param {number} [upper=1] The upper bound.
         * @param {boolean} [floating] Specify returning a floating-point number.
         * @returns {number} Returns the random number.
         * @example
         *
         * _.random(0, 5);
         * // => an integer between 0 and 5
         *
         * _.random(5);
         * // => also an integer between 0 and 5
         *
         * _.random(5, true);
         * // => a floating-point number between 0 and 5
         *
         * _.random(1.2, 5.2);
         * // => a floating-point number between 1.2 and 5.2
         */


        function random(lower, upper, floating) {
          if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
            upper = floating = undefined$1;
          }

          if (floating === undefined$1) {
            if (typeof upper == 'boolean') {
              floating = upper;
              upper = undefined$1;
            } else if (typeof lower == 'boolean') {
              floating = lower;
              lower = undefined$1;
            }
          }

          if (lower === undefined$1 && upper === undefined$1) {
            lower = 0;
            upper = 1;
          } else {
            lower = toFinite(lower);

            if (upper === undefined$1) {
              upper = lower;
              lower = 0;
            } else {
              upper = toFinite(upper);
            }
          }

          if (lower > upper) {
            var temp = lower;
            lower = upper;
            upper = temp;
          }

          if (floating || lower % 1 || upper % 1) {
            var rand = nativeRandom();
            return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
          }

          return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/

        /**
         * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category String
         * @param {string} [string=''] The string to convert.
         * @returns {string} Returns the camel cased string.
         * @example
         *
         * _.camelCase('Foo Bar');
         * // => 'fooBar'
         *
         * _.camelCase('--foo-bar--');
         * // => 'fooBar'
         *
         * _.camelCase('__FOO_BAR__');
         * // => 'fooBar'
         */


        var camelCase = createCompounder(function (result, word, index) {
          word = word.toLowerCase();
          return result + (index ? capitalize(word) : word);
        });
        /**
         * Converts the first character of `string` to upper case and the remaining
         * to lower case.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category String
         * @param {string} [string=''] The string to capitalize.
         * @returns {string} Returns the capitalized string.
         * @example
         *
         * _.capitalize('FRED');
         * // => 'Fred'
         */

        function capitalize(string) {
          return upperFirst(toString(string).toLowerCase());
        }
        /**
         * Deburrs `string` by converting
         * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
         * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
         * letters to basic Latin letters and removing
         * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category String
         * @param {string} [string=''] The string to deburr.
         * @returns {string} Returns the deburred string.
         * @example
         *
         * _.deburr('déjà vu');
         * // => 'deja vu'
         */


        function deburr(string) {
          string = toString(string);
          return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
        }
        /**
         * Checks if `string` ends with the given target string.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category String
         * @param {string} [string=''] The string to inspect.
         * @param {string} [target] The string to search for.
         * @param {number} [position=string.length] The position to search up to.
         * @returns {boolean} Returns `true` if `string` ends with `target`,
         *  else `false`.
         * @example
         *
         * _.endsWith('abc', 'c');
         * // => true
         *
         * _.endsWith('abc', 'b');
         * // => false
         *
         * _.endsWith('abc', 'b', 2);
         * // => true
         */


        function endsWith(string, target, position) {
          string = toString(string);
          target = baseToString(target);
          var length = string.length;
          position = position === undefined$1 ? length : baseClamp(toInteger(position), 0, length);
          var end = position;
          position -= target.length;
          return position >= 0 && string.slice(position, end) == target;
        }
        /**
         * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
         * corresponding HTML entities.
         *
         * **Note:** No other characters are escaped. To escape additional
         * characters use a third-party library like [_he_](https://mths.be/he).
         *
         * Though the ">" character is escaped for symmetry, characters like
         * ">" and "/" don't need escaping in HTML and have no special meaning
         * unless they're part of a tag or unquoted attribute value. See
         * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
         * (under "semi-related fun fact") for more details.
         *
         * When working with HTML you should always
         * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
         * XSS vectors.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category String
         * @param {string} [string=''] The string to escape.
         * @returns {string} Returns the escaped string.
         * @example
         *
         * _.escape('fred, barney, & pebbles');
         * // => 'fred, barney, &amp; pebbles'
         */


        function escape(string) {
          string = toString(string);
          return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
         * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
         * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category String
         * @param {string} [string=''] The string to escape.
         * @returns {string} Returns the escaped string.
         * @example
         *
         * _.escapeRegExp('[lodash](https://lodash.com/)');
         * // => '\[lodash\]\(https://lodash\.com/\)'
         */


        function escapeRegExp(string) {
          string = toString(string);
          return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
        }
        /**
         * Converts `string` to
         * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category String
         * @param {string} [string=''] The string to convert.
         * @returns {string} Returns the kebab cased string.
         * @example
         *
         * _.kebabCase('Foo Bar');
         * // => 'foo-bar'
         *
         * _.kebabCase('fooBar');
         * // => 'foo-bar'
         *
         * _.kebabCase('__FOO_BAR__');
         * // => 'foo-bar'
         */


        var kebabCase = createCompounder(function (result, word, index) {
          return result + (index ? '-' : '') + word.toLowerCase();
        });
        /**
         * Converts `string`, as space separated words, to lower case.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category String
         * @param {string} [string=''] The string to convert.
         * @returns {string} Returns the lower cased string.
         * @example
         *
         * _.lowerCase('--Foo-Bar--');
         * // => 'foo bar'
         *
         * _.lowerCase('fooBar');
         * // => 'foo bar'
         *
         * _.lowerCase('__FOO_BAR__');
         * // => 'foo bar'
         */

        var lowerCase = createCompounder(function (result, word, index) {
          return result + (index ? ' ' : '') + word.toLowerCase();
        });
        /**
         * Converts the first character of `string` to lower case.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category String
         * @param {string} [string=''] The string to convert.
         * @returns {string} Returns the converted string.
         * @example
         *
         * _.lowerFirst('Fred');
         * // => 'fred'
         *
         * _.lowerFirst('FRED');
         * // => 'fRED'
         */

        var lowerFirst = createCaseFirst('toLowerCase');
        /**
         * Pads `string` on the left and right sides if it's shorter than `length`.
         * Padding characters are truncated if they can't be evenly divided by `length`.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category String
         * @param {string} [string=''] The string to pad.
         * @param {number} [length=0] The padding length.
         * @param {string} [chars=' '] The string used as padding.
         * @returns {string} Returns the padded string.
         * @example
         *
         * _.pad('abc', 8);
         * // => '  abc   '
         *
         * _.pad('abc', 8, '_-');
         * // => '_-abc_-_'
         *
         * _.pad('abc', 3);
         * // => 'abc'
         */

        function pad(string, length, chars) {
          string = toString(string);
          length = toInteger(length);
          var strLength = length ? stringSize(string) : 0;

          if (!length || strLength >= length) {
            return string;
          }

          var mid = (length - strLength) / 2;
          return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
         * Pads `string` on the right side if it's shorter than `length`. Padding
         * characters are truncated if they exceed `length`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category String
         * @param {string} [string=''] The string to pad.
         * @param {number} [length=0] The padding length.
         * @param {string} [chars=' '] The string used as padding.
         * @returns {string} Returns the padded string.
         * @example
         *
         * _.padEnd('abc', 6);
         * // => 'abc   '
         *
         * _.padEnd('abc', 6, '_-');
         * // => 'abc_-_'
         *
         * _.padEnd('abc', 3);
         * // => 'abc'
         */


        function padEnd(string, length, chars) {
          string = toString(string);
          length = toInteger(length);
          var strLength = length ? stringSize(string) : 0;
          return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
         * Pads `string` on the left side if it's shorter than `length`. Padding
         * characters are truncated if they exceed `length`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category String
         * @param {string} [string=''] The string to pad.
         * @param {number} [length=0] The padding length.
         * @param {string} [chars=' '] The string used as padding.
         * @returns {string} Returns the padded string.
         * @example
         *
         * _.padStart('abc', 6);
         * // => '   abc'
         *
         * _.padStart('abc', 6, '_-');
         * // => '_-_abc'
         *
         * _.padStart('abc', 3);
         * // => 'abc'
         */


        function padStart(string, length, chars) {
          string = toString(string);
          length = toInteger(length);
          var strLength = length ? stringSize(string) : 0;
          return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
         * Converts `string` to an integer of the specified radix. If `radix` is
         * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
         * hexadecimal, in which case a `radix` of `16` is used.
         *
         * **Note:** This method aligns with the
         * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
         *
         * @static
         * @memberOf _
         * @since 1.1.0
         * @category String
         * @param {string} string The string to convert.
         * @param {number} [radix=10] The radix to interpret `value` by.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
         * @returns {number} Returns the converted integer.
         * @example
         *
         * _.parseInt('08');
         * // => 8
         *
         * _.map(['6', '08', '10'], _.parseInt);
         * // => [6, 8, 10]
         */


        function parseInt(string, radix, guard) {
          if (guard || radix == null) {
            radix = 0;
          } else if (radix) {
            radix = +radix;
          }

          return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
        }
        /**
         * Repeats the given string `n` times.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category String
         * @param {string} [string=''] The string to repeat.
         * @param {number} [n=1] The number of times to repeat the string.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
         * @returns {string} Returns the repeated string.
         * @example
         *
         * _.repeat('*', 3);
         * // => '***'
         *
         * _.repeat('abc', 2);
         * // => 'abcabc'
         *
         * _.repeat('abc', 0);
         * // => ''
         */


        function repeat(string, n, guard) {
          if (guard ? isIterateeCall(string, n, guard) : n === undefined$1) {
            n = 1;
          } else {
            n = toInteger(n);
          }

          return baseRepeat(toString(string), n);
        }
        /**
         * Replaces matches for `pattern` in `string` with `replacement`.
         *
         * **Note:** This method is based on
         * [`String#replace`](https://mdn.io/String/replace).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category String
         * @param {string} [string=''] The string to modify.
         * @param {RegExp|string} pattern The pattern to replace.
         * @param {Function|string} replacement The match replacement.
         * @returns {string} Returns the modified string.
         * @example
         *
         * _.replace('Hi Fred', 'Fred', 'Barney');
         * // => 'Hi Barney'
         */


        function replace() {
          var args = arguments,
              string = toString(args[0]);
          return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
         * Converts `string` to
         * [snake case](https://en.wikipedia.org/wiki/Snake_case).
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category String
         * @param {string} [string=''] The string to convert.
         * @returns {string} Returns the snake cased string.
         * @example
         *
         * _.snakeCase('Foo Bar');
         * // => 'foo_bar'
         *
         * _.snakeCase('fooBar');
         * // => 'foo_bar'
         *
         * _.snakeCase('--FOO-BAR--');
         * // => 'foo_bar'
         */


        var snakeCase = createCompounder(function (result, word, index) {
          return result + (index ? '_' : '') + word.toLowerCase();
        });
        /**
         * Splits `string` by `separator`.
         *
         * **Note:** This method is based on
         * [`String#split`](https://mdn.io/String/split).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category String
         * @param {string} [string=''] The string to split.
         * @param {RegExp|string} separator The separator pattern to split by.
         * @param {number} [limit] The length to truncate results to.
         * @returns {Array} Returns the string segments.
         * @example
         *
         * _.split('a-b-c', '-', 2);
         * // => ['a', 'b']
         */

        function split(string, separator, limit) {
          if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
            separator = limit = undefined$1;
          }

          limit = limit === undefined$1 ? MAX_ARRAY_LENGTH : limit >>> 0;

          if (!limit) {
            return [];
          }

          string = toString(string);

          if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
            separator = baseToString(separator);

            if (!separator && hasUnicode(string)) {
              return castSlice(stringToArray(string), 0, limit);
            }
          }

          return string.split(separator, limit);
        }
        /**
         * Converts `string` to
         * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
         *
         * @static
         * @memberOf _
         * @since 3.1.0
         * @category String
         * @param {string} [string=''] The string to convert.
         * @returns {string} Returns the start cased string.
         * @example
         *
         * _.startCase('--foo-bar--');
         * // => 'Foo Bar'
         *
         * _.startCase('fooBar');
         * // => 'Foo Bar'
         *
         * _.startCase('__FOO_BAR__');
         * // => 'FOO BAR'
         */


        var startCase = createCompounder(function (result, word, index) {
          return result + (index ? ' ' : '') + upperFirst(word);
        });
        /**
         * Checks if `string` starts with the given target string.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category String
         * @param {string} [string=''] The string to inspect.
         * @param {string} [target] The string to search for.
         * @param {number} [position=0] The position to search from.
         * @returns {boolean} Returns `true` if `string` starts with `target`,
         *  else `false`.
         * @example
         *
         * _.startsWith('abc', 'a');
         * // => true
         *
         * _.startsWith('abc', 'b');
         * // => false
         *
         * _.startsWith('abc', 'b', 1);
         * // => true
         */

        function startsWith(string, target, position) {
          string = toString(string);
          position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
          target = baseToString(target);
          return string.slice(position, position + target.length) == target;
        }
        /**
         * Creates a compiled template function that can interpolate data properties
         * in "interpolate" delimiters, HTML-escape interpolated data properties in
         * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
         * properties may be accessed as free variables in the template. If a setting
         * object is given, it takes precedence over `_.templateSettings` values.
         *
         * **Note:** In the development build `_.template` utilizes
         * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
         * for easier debugging.
         *
         * For more information on precompiling templates see
         * [lodash's custom builds documentation](https://lodash.com/custom-builds).
         *
         * For more information on Chrome extension sandboxes see
         * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category String
         * @param {string} [string=''] The template string.
         * @param {Object} [options={}] The options object.
         * @param {RegExp} [options.escape=_.templateSettings.escape]
         *  The HTML "escape" delimiter.
         * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
         *  The "evaluate" delimiter.
         * @param {Object} [options.imports=_.templateSettings.imports]
         *  An object to import into the template as free variables.
         * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
         *  The "interpolate" delimiter.
         * @param {string} [options.sourceURL='lodash.templateSources[n]']
         *  The sourceURL of the compiled template.
         * @param {string} [options.variable='obj']
         *  The data object variable name.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
         * @returns {Function} Returns the compiled template function.
         * @example
         *
         * // Use the "interpolate" delimiter to create a compiled template.
         * var compiled = _.template('hello <%= user %>!');
         * compiled({ 'user': 'fred' });
         * // => 'hello fred!'
         *
         * // Use the HTML "escape" delimiter to escape data property values.
         * var compiled = _.template('<b><%- value %></b>');
         * compiled({ 'value': '<script>' });
         * // => '<b>&lt;script&gt;</b>'
         *
         * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
         * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
         * compiled({ 'users': ['fred', 'barney'] });
         * // => '<li>fred</li><li>barney</li>'
         *
         * // Use the internal `print` function in "evaluate" delimiters.
         * var compiled = _.template('<% print("hello " + user); %>!');
         * compiled({ 'user': 'barney' });
         * // => 'hello barney!'
         *
         * // Use the ES template literal delimiter as an "interpolate" delimiter.
         * // Disable support by replacing the "interpolate" delimiter.
         * var compiled = _.template('hello ${ user }!');
         * compiled({ 'user': 'pebbles' });
         * // => 'hello pebbles!'
         *
         * // Use backslashes to treat delimiters as plain text.
         * var compiled = _.template('<%= "\\<%- value %\\>" %>');
         * compiled({ 'value': 'ignored' });
         * // => '<%- value %>'
         *
         * // Use the `imports` option to import `jQuery` as `jq`.
         * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
         * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
         * compiled({ 'users': ['fred', 'barney'] });
         * // => '<li>fred</li><li>barney</li>'
         *
         * // Use the `sourceURL` option to specify a custom sourceURL for the template.
         * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
         * compiled(data);
         * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
         *
         * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
         * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
         * compiled.source;
         * // => function(data) {
         * //   var __t, __p = '';
         * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
         * //   return __p;
         * // }
         *
         * // Use custom template delimiters.
         * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
         * var compiled = _.template('hello {{ user }}!');
         * compiled({ 'user': 'mustache' });
         * // => 'hello mustache!'
         *
         * // Use the `source` property to inline compiled templates for meaningful
         * // line numbers in error messages and stack traces.
         * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
         *   var JST = {\
         *     "main": ' + _.template(mainText).source + '\
         *   };\
         * ');
         */


        function template(string, options, guard) {
          // Based on John Resig's `tmpl` implementation
          // (http://ejohn.org/blog/javascript-micro-templating/)
          // and Laura Doktorova's doT.js (https://github.com/olado/doT).
          var settings = lodash.templateSettings;

          if (guard && isIterateeCall(string, options, guard)) {
            options = undefined$1;
          }

          string = toString(string);
          options = assignInWith({}, options, settings, customDefaultsAssignIn);
          var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
              importsKeys = keys(imports),
              importsValues = baseValues(imports, importsKeys);
          var isEscaping,
              isEvaluating,
              index = 0,
              interpolate = options.interpolate || reNoMatch,
              source = "__p += '"; // Compile the regexp to match each delimiter.

          var reDelimiters = RegExp((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g'); // Use a sourceURL for easier debugging.
          // The sourceURL gets injected into the source that's eval-ed, so be careful
          // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
          // and escape the comment, thus injecting code that gets evaled.

          var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
          string.replace(reDelimiters, function (match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
            interpolateValue || (interpolateValue = esTemplateValue); // Escape characters that can't be included in string literals.

            source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar); // Replace delimiters with snippets.

            if (escapeValue) {
              isEscaping = true;
              source += "' +\n__e(" + escapeValue + ") +\n'";
            }

            if (evaluateValue) {
              isEvaluating = true;
              source += "';\n" + evaluateValue + ";\n__p += '";
            }

            if (interpolateValue) {
              source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
            }

            index = offset + match.length; // The JS engine embedded in Adobe products needs `match` returned in
            // order to produce the correct `offset` value.

            return match;
          });
          source += "';\n"; // If `variable` is not specified wrap a with-statement around the generated
          // code to add the data object to the top of the scope chain.

          var variable = hasOwnProperty.call(options, 'variable') && options.variable;

          if (!variable) {
            source = 'with (obj) {\n' + source + '\n}\n';
          } // Throw an error if a forbidden character was found in `variable`, to prevent
          // potential command injection attacks.
          else if (reForbiddenIdentifierChars.test(variable)) {
            throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
          } // Cleanup code by stripping empty strings.


          source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;'); // Frame code as the function body.

          source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ', __j = Array.prototype.join;\n' + "function print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
          var result = attempt(function () {
            return Function(importsKeys, sourceURL + 'return ' + source).apply(undefined$1, importsValues);
          }); // Provide the compiled function's source by its `toString` method or
          // the `source` property as a convenience for inlining compiled templates.

          result.source = source;

          if (isError(result)) {
            throw result;
          }

          return result;
        }
        /**
         * Converts `string`, as a whole, to lower case just like
         * [String#toLowerCase](https://mdn.io/toLowerCase).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category String
         * @param {string} [string=''] The string to convert.
         * @returns {string} Returns the lower cased string.
         * @example
         *
         * _.toLower('--Foo-Bar--');
         * // => '--foo-bar--'
         *
         * _.toLower('fooBar');
         * // => 'foobar'
         *
         * _.toLower('__FOO_BAR__');
         * // => '__foo_bar__'
         */


        function toLower(value) {
          return toString(value).toLowerCase();
        }
        /**
         * Converts `string`, as a whole, to upper case just like
         * [String#toUpperCase](https://mdn.io/toUpperCase).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category String
         * @param {string} [string=''] The string to convert.
         * @returns {string} Returns the upper cased string.
         * @example
         *
         * _.toUpper('--foo-bar--');
         * // => '--FOO-BAR--'
         *
         * _.toUpper('fooBar');
         * // => 'FOOBAR'
         *
         * _.toUpper('__foo_bar__');
         * // => '__FOO_BAR__'
         */


        function toUpper(value) {
          return toString(value).toUpperCase();
        }
        /**
         * Removes leading and trailing whitespace or specified characters from `string`.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category String
         * @param {string} [string=''] The string to trim.
         * @param {string} [chars=whitespace] The characters to trim.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
         * @returns {string} Returns the trimmed string.
         * @example
         *
         * _.trim('  abc  ');
         * // => 'abc'
         *
         * _.trim('-_-abc-_-', '_-');
         * // => 'abc'
         *
         * _.map(['  foo  ', '  bar  '], _.trim);
         * // => ['foo', 'bar']
         */


        function trim(string, chars, guard) {
          string = toString(string);

          if (string && (guard || chars === undefined$1)) {
            return baseTrim(string);
          }

          if (!string || !(chars = baseToString(chars))) {
            return string;
          }

          var strSymbols = stringToArray(string),
              chrSymbols = stringToArray(chars),
              start = charsStartIndex(strSymbols, chrSymbols),
              end = charsEndIndex(strSymbols, chrSymbols) + 1;
          return castSlice(strSymbols, start, end).join('');
        }
        /**
         * Removes trailing whitespace or specified characters from `string`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category String
         * @param {string} [string=''] The string to trim.
         * @param {string} [chars=whitespace] The characters to trim.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
         * @returns {string} Returns the trimmed string.
         * @example
         *
         * _.trimEnd('  abc  ');
         * // => '  abc'
         *
         * _.trimEnd('-_-abc-_-', '_-');
         * // => '-_-abc'
         */


        function trimEnd(string, chars, guard) {
          string = toString(string);

          if (string && (guard || chars === undefined$1)) {
            return string.slice(0, trimmedEndIndex(string) + 1);
          }

          if (!string || !(chars = baseToString(chars))) {
            return string;
          }

          var strSymbols = stringToArray(string),
              end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
          return castSlice(strSymbols, 0, end).join('');
        }
        /**
         * Removes leading whitespace or specified characters from `string`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category String
         * @param {string} [string=''] The string to trim.
         * @param {string} [chars=whitespace] The characters to trim.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
         * @returns {string} Returns the trimmed string.
         * @example
         *
         * _.trimStart('  abc  ');
         * // => 'abc  '
         *
         * _.trimStart('-_-abc-_-', '_-');
         * // => 'abc-_-'
         */


        function trimStart(string, chars, guard) {
          string = toString(string);

          if (string && (guard || chars === undefined$1)) {
            return string.replace(reTrimStart, '');
          }

          if (!string || !(chars = baseToString(chars))) {
            return string;
          }

          var strSymbols = stringToArray(string),
              start = charsStartIndex(strSymbols, stringToArray(chars));
          return castSlice(strSymbols, start).join('');
        }
        /**
         * Truncates `string` if it's longer than the given maximum string length.
         * The last characters of the truncated string are replaced with the omission
         * string which defaults to "...".
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category String
         * @param {string} [string=''] The string to truncate.
         * @param {Object} [options={}] The options object.
         * @param {number} [options.length=30] The maximum string length.
         * @param {string} [options.omission='...'] The string to indicate text is omitted.
         * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
         * @returns {string} Returns the truncated string.
         * @example
         *
         * _.truncate('hi-diddly-ho there, neighborino');
         * // => 'hi-diddly-ho there, neighbo...'
         *
         * _.truncate('hi-diddly-ho there, neighborino', {
         *   'length': 24,
         *   'separator': ' '
         * });
         * // => 'hi-diddly-ho there,...'
         *
         * _.truncate('hi-diddly-ho there, neighborino', {
         *   'length': 24,
         *   'separator': /,? +/
         * });
         * // => 'hi-diddly-ho there...'
         *
         * _.truncate('hi-diddly-ho there, neighborino', {
         *   'omission': ' [...]'
         * });
         * // => 'hi-diddly-ho there, neig [...]'
         */


        function truncate(string, options) {
          var length = DEFAULT_TRUNC_LENGTH,
              omission = DEFAULT_TRUNC_OMISSION;

          if (isObject(options)) {
            var separator = 'separator' in options ? options.separator : separator;
            length = 'length' in options ? toInteger(options.length) : length;
            omission = 'omission' in options ? baseToString(options.omission) : omission;
          }

          string = toString(string);
          var strLength = string.length;

          if (hasUnicode(string)) {
            var strSymbols = stringToArray(string);
            strLength = strSymbols.length;
          }

          if (length >= strLength) {
            return string;
          }

          var end = length - stringSize(omission);

          if (end < 1) {
            return omission;
          }

          var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);

          if (separator === undefined$1) {
            return result + omission;
          }

          if (strSymbols) {
            end += result.length - end;
          }

          if (isRegExp(separator)) {
            if (string.slice(end).search(separator)) {
              var match,
                  substring = result;

              if (!separator.global) {
                separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
              }

              separator.lastIndex = 0;

              while (match = separator.exec(substring)) {
                var newEnd = match.index;
              }

              result = result.slice(0, newEnd === undefined$1 ? end : newEnd);
            }
          } else if (string.indexOf(baseToString(separator), end) != end) {
            var index = result.lastIndexOf(separator);

            if (index > -1) {
              result = result.slice(0, index);
            }
          }

          return result + omission;
        }
        /**
         * The inverse of `_.escape`; this method converts the HTML entities
         * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
         * their corresponding characters.
         *
         * **Note:** No other HTML entities are unescaped. To unescape additional
         * HTML entities use a third-party library like [_he_](https://mths.be/he).
         *
         * @static
         * @memberOf _
         * @since 0.6.0
         * @category String
         * @param {string} [string=''] The string to unescape.
         * @returns {string} Returns the unescaped string.
         * @example
         *
         * _.unescape('fred, barney, &amp; pebbles');
         * // => 'fred, barney, & pebbles'
         */


        function unescape(string) {
          string = toString(string);
          return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
         * Converts `string`, as space separated words, to upper case.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category String
         * @param {string} [string=''] The string to convert.
         * @returns {string} Returns the upper cased string.
         * @example
         *
         * _.upperCase('--foo-bar');
         * // => 'FOO BAR'
         *
         * _.upperCase('fooBar');
         * // => 'FOO BAR'
         *
         * _.upperCase('__foo_bar__');
         * // => 'FOO BAR'
         */


        var upperCase = createCompounder(function (result, word, index) {
          return result + (index ? ' ' : '') + word.toUpperCase();
        });
        /**
         * Converts the first character of `string` to upper case.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category String
         * @param {string} [string=''] The string to convert.
         * @returns {string} Returns the converted string.
         * @example
         *
         * _.upperFirst('fred');
         * // => 'Fred'
         *
         * _.upperFirst('FRED');
         * // => 'FRED'
         */

        var upperFirst = createCaseFirst('toUpperCase');
        /**
         * Splits `string` into an array of its words.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category String
         * @param {string} [string=''] The string to inspect.
         * @param {RegExp|string} [pattern] The pattern to match words.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
         * @returns {Array} Returns the words of `string`.
         * @example
         *
         * _.words('fred, barney, & pebbles');
         * // => ['fred', 'barney', 'pebbles']
         *
         * _.words('fred, barney, & pebbles', /[^, ]+/g);
         * // => ['fred', 'barney', '&', 'pebbles']
         */

        function words(string, pattern, guard) {
          string = toString(string);
          pattern = guard ? undefined$1 : pattern;

          if (pattern === undefined$1) {
            return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
          }

          return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/

        /**
         * Attempts to invoke `func`, returning either the result or the caught error
         * object. Any additional arguments are provided to `func` when it's invoked.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Util
         * @param {Function} func The function to attempt.
         * @param {...*} [args] The arguments to invoke `func` with.
         * @returns {*} Returns the `func` result or error object.
         * @example
         *
         * // Avoid throwing errors for invalid selectors.
         * var elements = _.attempt(function(selector) {
         *   return document.querySelectorAll(selector);
         * }, '>_>');
         *
         * if (_.isError(elements)) {
         *   elements = [];
         * }
         */


        var attempt = baseRest(function (func, args) {
          try {
            return apply(func, undefined$1, args);
          } catch (e) {
            return isError(e) ? e : new Error(e);
          }
        });
        /**
         * Binds methods of an object to the object itself, overwriting the existing
         * method.
         *
         * **Note:** This method doesn't set the "length" property of bound functions.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Util
         * @param {Object} object The object to bind and assign the bound methods to.
         * @param {...(string|string[])} methodNames The object method names to bind.
         * @returns {Object} Returns `object`.
         * @example
         *
         * var view = {
         *   'label': 'docs',
         *   'click': function() {
         *     console.log('clicked ' + this.label);
         *   }
         * };
         *
         * _.bindAll(view, ['click']);
         * jQuery(element).on('click', view.click);
         * // => Logs 'clicked docs' when clicked.
         */

        var bindAll = flatRest(function (object, methodNames) {
          arrayEach(methodNames, function (key) {
            key = toKey(key);
            baseAssignValue(object, key, bind(object[key], object));
          });
          return object;
        });
        /**
         * Creates a function that iterates over `pairs` and invokes the corresponding
         * function of the first predicate to return truthy. The predicate-function
         * pairs are invoked with the `this` binding and arguments of the created
         * function.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Util
         * @param {Array} pairs The predicate-function pairs.
         * @returns {Function} Returns the new composite function.
         * @example
         *
         * var func = _.cond([
         *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
         *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
         *   [_.stubTrue,                      _.constant('no match')]
         * ]);
         *
         * func({ 'a': 1, 'b': 2 });
         * // => 'matches A'
         *
         * func({ 'a': 0, 'b': 1 });
         * // => 'matches B'
         *
         * func({ 'a': '1', 'b': '2' });
         * // => 'no match'
         */

        function cond(pairs) {
          var length = pairs == null ? 0 : pairs.length,
              toIteratee = getIteratee();
          pairs = !length ? [] : arrayMap(pairs, function (pair) {
            if (typeof pair[1] != 'function') {
              throw new TypeError(FUNC_ERROR_TEXT);
            }

            return [toIteratee(pair[0]), pair[1]];
          });
          return baseRest(function (args) {
            var index = -1;

            while (++index < length) {
              var pair = pairs[index];

              if (apply(pair[0], this, args)) {
                return apply(pair[1], this, args);
              }
            }
          });
        }
        /**
         * Creates a function that invokes the predicate properties of `source` with
         * the corresponding property values of a given object, returning `true` if
         * all predicates return truthy, else `false`.
         *
         * **Note:** The created function is equivalent to `_.conformsTo` with
         * `source` partially applied.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Util
         * @param {Object} source The object of property predicates to conform to.
         * @returns {Function} Returns the new spec function.
         * @example
         *
         * var objects = [
         *   { 'a': 2, 'b': 1 },
         *   { 'a': 1, 'b': 2 }
         * ];
         *
         * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
         * // => [{ 'a': 1, 'b': 2 }]
         */


        function conforms(source) {
          return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
         * Creates a function that returns `value`.
         *
         * @static
         * @memberOf _
         * @since 2.4.0
         * @category Util
         * @param {*} value The value to return from the new function.
         * @returns {Function} Returns the new constant function.
         * @example
         *
         * var objects = _.times(2, _.constant({ 'a': 1 }));
         *
         * console.log(objects);
         * // => [{ 'a': 1 }, { 'a': 1 }]
         *
         * console.log(objects[0] === objects[1]);
         * // => true
         */


        function constant(value) {
          return function () {
            return value;
          };
        }
        /**
         * Checks `value` to determine whether a default value should be returned in
         * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
         * or `undefined`.
         *
         * @static
         * @memberOf _
         * @since 4.14.0
         * @category Util
         * @param {*} value The value to check.
         * @param {*} defaultValue The default value.
         * @returns {*} Returns the resolved value.
         * @example
         *
         * _.defaultTo(1, 10);
         * // => 1
         *
         * _.defaultTo(undefined, 10);
         * // => 10
         */


        function defaultTo(value, defaultValue) {
          return value == null || value !== value ? defaultValue : value;
        }
        /**
         * Creates a function that returns the result of invoking the given functions
         * with the `this` binding of the created function, where each successive
         * invocation is supplied the return value of the previous.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Util
         * @param {...(Function|Function[])} [funcs] The functions to invoke.
         * @returns {Function} Returns the new composite function.
         * @see _.flowRight
         * @example
         *
         * function square(n) {
         *   return n * n;
         * }
         *
         * var addSquare = _.flow([_.add, square]);
         * addSquare(1, 2);
         * // => 9
         */


        var flow = createFlow();
        /**
         * This method is like `_.flow` except that it creates a function that
         * invokes the given functions from right to left.
         *
         * @static
         * @since 3.0.0
         * @memberOf _
         * @category Util
         * @param {...(Function|Function[])} [funcs] The functions to invoke.
         * @returns {Function} Returns the new composite function.
         * @see _.flow
         * @example
         *
         * function square(n) {
         *   return n * n;
         * }
         *
         * var addSquare = _.flowRight([square, _.add]);
         * addSquare(1, 2);
         * // => 9
         */

        var flowRight = createFlow(true);
        /**
         * This method returns the first argument it receives.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Util
         * @param {*} value Any value.
         * @returns {*} Returns `value`.
         * @example
         *
         * var object = { 'a': 1 };
         *
         * console.log(_.identity(object) === object);
         * // => true
         */

        function identity(value) {
          return value;
        }
        /**
         * Creates a function that invokes `func` with the arguments of the created
         * function. If `func` is a property name, the created function returns the
         * property value for a given element. If `func` is an array or object, the
         * created function returns `true` for elements that contain the equivalent
         * source properties, otherwise it returns `false`.
         *
         * @static
         * @since 4.0.0
         * @memberOf _
         * @category Util
         * @param {*} [func=_.identity] The value to convert to a callback.
         * @returns {Function} Returns the callback.
         * @example
         *
         * var users = [
         *   { 'user': 'barney', 'age': 36, 'active': true },
         *   { 'user': 'fred',   'age': 40, 'active': false }
         * ];
         *
         * // The `_.matches` iteratee shorthand.
         * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
         * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
         *
         * // The `_.matchesProperty` iteratee shorthand.
         * _.filter(users, _.iteratee(['user', 'fred']));
         * // => [{ 'user': 'fred', 'age': 40 }]
         *
         * // The `_.property` iteratee shorthand.
         * _.map(users, _.iteratee('user'));
         * // => ['barney', 'fred']
         *
         * // Create custom iteratee shorthands.
         * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
         *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
         *     return func.test(string);
         *   };
         * });
         *
         * _.filter(['abc', 'def'], /ef/);
         * // => ['def']
         */


        function iteratee(func) {
          return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
         * Creates a function that performs a partial deep comparison between a given
         * object and `source`, returning `true` if the given object has equivalent
         * property values, else `false`.
         *
         * **Note:** The created function is equivalent to `_.isMatch` with `source`
         * partially applied.
         *
         * Partial comparisons will match empty array and empty object `source`
         * values against any array or object value, respectively. See `_.isEqual`
         * for a list of supported value comparisons.
         *
         * **Note:** Multiple values can be checked by combining several matchers
         * using `_.overSome`
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Util
         * @param {Object} source The object of property values to match.
         * @returns {Function} Returns the new spec function.
         * @example
         *
         * var objects = [
         *   { 'a': 1, 'b': 2, 'c': 3 },
         *   { 'a': 4, 'b': 5, 'c': 6 }
         * ];
         *
         * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
         * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
         *
         * // Checking for several possible values
         * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
         * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
         */


        function matches(source) {
          return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
         * Creates a function that performs a partial deep comparison between the
         * value at `path` of a given object to `srcValue`, returning `true` if the
         * object value is equivalent, else `false`.
         *
         * **Note:** Partial comparisons will match empty array and empty object
         * `srcValue` values against any array or object value, respectively. See
         * `_.isEqual` for a list of supported value comparisons.
         *
         * **Note:** Multiple values can be checked by combining several matchers
         * using `_.overSome`
         *
         * @static
         * @memberOf _
         * @since 3.2.0
         * @category Util
         * @param {Array|string} path The path of the property to get.
         * @param {*} srcValue The value to match.
         * @returns {Function} Returns the new spec function.
         * @example
         *
         * var objects = [
         *   { 'a': 1, 'b': 2, 'c': 3 },
         *   { 'a': 4, 'b': 5, 'c': 6 }
         * ];
         *
         * _.find(objects, _.matchesProperty('a', 4));
         * // => { 'a': 4, 'b': 5, 'c': 6 }
         *
         * // Checking for several possible values
         * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
         * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
         */


        function matchesProperty(path, srcValue) {
          return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
         * Creates a function that invokes the method at `path` of a given object.
         * Any additional arguments are provided to the invoked method.
         *
         * @static
         * @memberOf _
         * @since 3.7.0
         * @category Util
         * @param {Array|string} path The path of the method to invoke.
         * @param {...*} [args] The arguments to invoke the method with.
         * @returns {Function} Returns the new invoker function.
         * @example
         *
         * var objects = [
         *   { 'a': { 'b': _.constant(2) } },
         *   { 'a': { 'b': _.constant(1) } }
         * ];
         *
         * _.map(objects, _.method('a.b'));
         * // => [2, 1]
         *
         * _.map(objects, _.method(['a', 'b']));
         * // => [2, 1]
         */


        var method = baseRest(function (path, args) {
          return function (object) {
            return baseInvoke(object, path, args);
          };
        });
        /**
         * The opposite of `_.method`; this method creates a function that invokes
         * the method at a given path of `object`. Any additional arguments are
         * provided to the invoked method.
         *
         * @static
         * @memberOf _
         * @since 3.7.0
         * @category Util
         * @param {Object} object The object to query.
         * @param {...*} [args] The arguments to invoke the method with.
         * @returns {Function} Returns the new invoker function.
         * @example
         *
         * var array = _.times(3, _.constant),
         *     object = { 'a': array, 'b': array, 'c': array };
         *
         * _.map(['a[2]', 'c[0]'], _.methodOf(object));
         * // => [2, 0]
         *
         * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
         * // => [2, 0]
         */

        var methodOf = baseRest(function (object, args) {
          return function (path) {
            return baseInvoke(object, path, args);
          };
        });
        /**
         * Adds all own enumerable string keyed function properties of a source
         * object to the destination object. If `object` is a function, then methods
         * are added to its prototype as well.
         *
         * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
         * avoid conflicts caused by modifying the original.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Util
         * @param {Function|Object} [object=lodash] The destination object.
         * @param {Object} source The object of functions to add.
         * @param {Object} [options={}] The options object.
         * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
         * @returns {Function|Object} Returns `object`.
         * @example
         *
         * function vowels(string) {
         *   return _.filter(string, function(v) {
         *     return /[aeiou]/i.test(v);
         *   });
         * }
         *
         * _.mixin({ 'vowels': vowels });
         * _.vowels('fred');
         * // => ['e']
         *
         * _('fred').vowels().value();
         * // => ['e']
         *
         * _.mixin({ 'vowels': vowels }, { 'chain': false });
         * _('fred').vowels();
         * // => ['e']
         */

        function mixin(object, source, options) {
          var props = keys(source),
              methodNames = baseFunctions(source, props);

          if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
            options = source;
            source = object;
            object = this;
            methodNames = baseFunctions(source, keys(source));
          }

          var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
              isFunc = isFunction(object);
          arrayEach(methodNames, function (methodName) {
            var func = source[methodName];
            object[methodName] = func;

            if (isFunc) {
              object.prototype[methodName] = function () {
                var chainAll = this.__chain__;

                if (chain || chainAll) {
                  var result = object(this.__wrapped__),
                      actions = result.__actions__ = copyArray(this.__actions__);
                  actions.push({
                    'func': func,
                    'args': arguments,
                    'thisArg': object
                  });
                  result.__chain__ = chainAll;
                  return result;
                }

                return func.apply(object, arrayPush([this.value()], arguments));
              };
            }
          });
          return object;
        }
        /**
         * Reverts the `_` variable to its previous value and returns a reference to
         * the `lodash` function.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Util
         * @returns {Function} Returns the `lodash` function.
         * @example
         *
         * var lodash = _.noConflict();
         */


        function noConflict() {
          if (root._ === this) {
            root._ = oldDash;
          }

          return this;
        }
        /**
         * This method returns `undefined`.
         *
         * @static
         * @memberOf _
         * @since 2.3.0
         * @category Util
         * @example
         *
         * _.times(2, _.noop);
         * // => [undefined, undefined]
         */


        function noop() {// No operation performed.
        }
        /**
         * Creates a function that gets the argument at index `n`. If `n` is negative,
         * the nth argument from the end is returned.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Util
         * @param {number} [n=0] The index of the argument to return.
         * @returns {Function} Returns the new pass-thru function.
         * @example
         *
         * var func = _.nthArg(1);
         * func('a', 'b', 'c', 'd');
         * // => 'b'
         *
         * var func = _.nthArg(-2);
         * func('a', 'b', 'c', 'd');
         * // => 'c'
         */


        function nthArg(n) {
          n = toInteger(n);
          return baseRest(function (args) {
            return baseNth(args, n);
          });
        }
        /**
         * Creates a function that invokes `iteratees` with the arguments it receives
         * and returns their results.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Util
         * @param {...(Function|Function[])} [iteratees=[_.identity]]
         *  The iteratees to invoke.
         * @returns {Function} Returns the new function.
         * @example
         *
         * var func = _.over([Math.max, Math.min]);
         *
         * func(1, 2, 3, 4);
         * // => [4, 1]
         */


        var over = createOver(arrayMap);
        /**
         * Creates a function that checks if **all** of the `predicates` return
         * truthy when invoked with the arguments it receives.
         *
         * Following shorthands are possible for providing predicates.
         * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
         * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Util
         * @param {...(Function|Function[])} [predicates=[_.identity]]
         *  The predicates to check.
         * @returns {Function} Returns the new function.
         * @example
         *
         * var func = _.overEvery([Boolean, isFinite]);
         *
         * func('1');
         * // => true
         *
         * func(null);
         * // => false
         *
         * func(NaN);
         * // => false
         */

        var overEvery = createOver(arrayEvery);
        /**
         * Creates a function that checks if **any** of the `predicates` return
         * truthy when invoked with the arguments it receives.
         *
         * Following shorthands are possible for providing predicates.
         * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
         * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Util
         * @param {...(Function|Function[])} [predicates=[_.identity]]
         *  The predicates to check.
         * @returns {Function} Returns the new function.
         * @example
         *
         * var func = _.overSome([Boolean, isFinite]);
         *
         * func('1');
         * // => true
         *
         * func(null);
         * // => true
         *
         * func(NaN);
         * // => false
         *
         * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
         * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
         */

        var overSome = createOver(arraySome);
        /**
         * Creates a function that returns the value at `path` of a given object.
         *
         * @static
         * @memberOf _
         * @since 2.4.0
         * @category Util
         * @param {Array|string} path The path of the property to get.
         * @returns {Function} Returns the new accessor function.
         * @example
         *
         * var objects = [
         *   { 'a': { 'b': 2 } },
         *   { 'a': { 'b': 1 } }
         * ];
         *
         * _.map(objects, _.property('a.b'));
         * // => [2, 1]
         *
         * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
         * // => [1, 2]
         */

        function property(path) {
          return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
         * The opposite of `_.property`; this method creates a function that returns
         * the value at a given path of `object`.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Util
         * @param {Object} object The object to query.
         * @returns {Function} Returns the new accessor function.
         * @example
         *
         * var array = [0, 1, 2],
         *     object = { 'a': array, 'b': array, 'c': array };
         *
         * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
         * // => [2, 0]
         *
         * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
         * // => [2, 0]
         */


        function propertyOf(object) {
          return function (path) {
            return object == null ? undefined$1 : baseGet(object, path);
          };
        }
        /**
         * Creates an array of numbers (positive and/or negative) progressing from
         * `start` up to, but not including, `end`. A step of `-1` is used if a negative
         * `start` is specified without an `end` or `step`. If `end` is not specified,
         * it's set to `start` with `start` then set to `0`.
         *
         * **Note:** JavaScript follows the IEEE-754 standard for resolving
         * floating-point values which can produce unexpected results.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Util
         * @param {number} [start=0] The start of the range.
         * @param {number} end The end of the range.
         * @param {number} [step=1] The value to increment or decrement by.
         * @returns {Array} Returns the range of numbers.
         * @see _.inRange, _.rangeRight
         * @example
         *
         * _.range(4);
         * // => [0, 1, 2, 3]
         *
         * _.range(-4);
         * // => [0, -1, -2, -3]
         *
         * _.range(1, 5);
         * // => [1, 2, 3, 4]
         *
         * _.range(0, 20, 5);
         * // => [0, 5, 10, 15]
         *
         * _.range(0, -4, -1);
         * // => [0, -1, -2, -3]
         *
         * _.range(1, 4, 0);
         * // => [1, 1, 1]
         *
         * _.range(0);
         * // => []
         */


        var range = createRange();
        /**
         * This method is like `_.range` except that it populates values in
         * descending order.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Util
         * @param {number} [start=0] The start of the range.
         * @param {number} end The end of the range.
         * @param {number} [step=1] The value to increment or decrement by.
         * @returns {Array} Returns the range of numbers.
         * @see _.inRange, _.range
         * @example
         *
         * _.rangeRight(4);
         * // => [3, 2, 1, 0]
         *
         * _.rangeRight(-4);
         * // => [-3, -2, -1, 0]
         *
         * _.rangeRight(1, 5);
         * // => [4, 3, 2, 1]
         *
         * _.rangeRight(0, 20, 5);
         * // => [15, 10, 5, 0]
         *
         * _.rangeRight(0, -4, -1);
         * // => [-3, -2, -1, 0]
         *
         * _.rangeRight(1, 4, 0);
         * // => [1, 1, 1]
         *
         * _.rangeRight(0);
         * // => []
         */

        var rangeRight = createRange(true);
        /**
         * This method returns a new empty array.
         *
         * @static
         * @memberOf _
         * @since 4.13.0
         * @category Util
         * @returns {Array} Returns the new empty array.
         * @example
         *
         * var arrays = _.times(2, _.stubArray);
         *
         * console.log(arrays);
         * // => [[], []]
         *
         * console.log(arrays[0] === arrays[1]);
         * // => false
         */

        function stubArray() {
          return [];
        }
        /**
         * This method returns `false`.
         *
         * @static
         * @memberOf _
         * @since 4.13.0
         * @category Util
         * @returns {boolean} Returns `false`.
         * @example
         *
         * _.times(2, _.stubFalse);
         * // => [false, false]
         */


        function stubFalse() {
          return false;
        }
        /**
         * This method returns a new empty object.
         *
         * @static
         * @memberOf _
         * @since 4.13.0
         * @category Util
         * @returns {Object} Returns the new empty object.
         * @example
         *
         * var objects = _.times(2, _.stubObject);
         *
         * console.log(objects);
         * // => [{}, {}]
         *
         * console.log(objects[0] === objects[1]);
         * // => false
         */


        function stubObject() {
          return {};
        }
        /**
         * This method returns an empty string.
         *
         * @static
         * @memberOf _
         * @since 4.13.0
         * @category Util
         * @returns {string} Returns the empty string.
         * @example
         *
         * _.times(2, _.stubString);
         * // => ['', '']
         */


        function stubString() {
          return '';
        }
        /**
         * This method returns `true`.
         *
         * @static
         * @memberOf _
         * @since 4.13.0
         * @category Util
         * @returns {boolean} Returns `true`.
         * @example
         *
         * _.times(2, _.stubTrue);
         * // => [true, true]
         */


        function stubTrue() {
          return true;
        }
        /**
         * Invokes the iteratee `n` times, returning an array of the results of
         * each invocation. The iteratee is invoked with one argument; (index).
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Util
         * @param {number} n The number of times to invoke `iteratee`.
         * @param {Function} [iteratee=_.identity] The function invoked per iteration.
         * @returns {Array} Returns the array of results.
         * @example
         *
         * _.times(3, String);
         * // => ['0', '1', '2']
         *
         *  _.times(4, _.constant(0));
         * // => [0, 0, 0, 0]
         */


        function times(n, iteratee) {
          n = toInteger(n);

          if (n < 1 || n > MAX_SAFE_INTEGER) {
            return [];
          }

          var index = MAX_ARRAY_LENGTH,
              length = nativeMin(n, MAX_ARRAY_LENGTH);
          iteratee = getIteratee(iteratee);
          n -= MAX_ARRAY_LENGTH;
          var result = baseTimes(length, iteratee);

          while (++index < n) {
            iteratee(index);
          }

          return result;
        }
        /**
         * Converts `value` to a property path array.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Util
         * @param {*} value The value to convert.
         * @returns {Array} Returns the new property path array.
         * @example
         *
         * _.toPath('a.b.c');
         * // => ['a', 'b', 'c']
         *
         * _.toPath('a[0].b.c');
         * // => ['a', '0', 'b', 'c']
         */


        function toPath(value) {
          if (isArray(value)) {
            return arrayMap(value, toKey);
          }

          return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
        }
        /**
         * Generates a unique ID. If `prefix` is given, the ID is appended to it.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Util
         * @param {string} [prefix=''] The value to prefix the ID with.
         * @returns {string} Returns the unique ID.
         * @example
         *
         * _.uniqueId('contact_');
         * // => 'contact_104'
         *
         * _.uniqueId();
         * // => '105'
         */


        function uniqueId(prefix) {
          var id = ++idCounter;
          return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/

        /**
         * Adds two numbers.
         *
         * @static
         * @memberOf _
         * @since 3.4.0
         * @category Math
         * @param {number} augend The first number in an addition.
         * @param {number} addend The second number in an addition.
         * @returns {number} Returns the total.
         * @example
         *
         * _.add(6, 4);
         * // => 10
         */


        var add = createMathOperation(function (augend, addend) {
          return augend + addend;
        }, 0);
        /**
         * Computes `number` rounded up to `precision`.
         *
         * @static
         * @memberOf _
         * @since 3.10.0
         * @category Math
         * @param {number} number The number to round up.
         * @param {number} [precision=0] The precision to round up to.
         * @returns {number} Returns the rounded up number.
         * @example
         *
         * _.ceil(4.006);
         * // => 5
         *
         * _.ceil(6.004, 2);
         * // => 6.01
         *
         * _.ceil(6040, -2);
         * // => 6100
         */

        var ceil = createRound('ceil');
        /**
         * Divide two numbers.
         *
         * @static
         * @memberOf _
         * @since 4.7.0
         * @category Math
         * @param {number} dividend The first number in a division.
         * @param {number} divisor The second number in a division.
         * @returns {number} Returns the quotient.
         * @example
         *
         * _.divide(6, 4);
         * // => 1.5
         */

        var divide = createMathOperation(function (dividend, divisor) {
          return dividend / divisor;
        }, 1);
        /**
         * Computes `number` rounded down to `precision`.
         *
         * @static
         * @memberOf _
         * @since 3.10.0
         * @category Math
         * @param {number} number The number to round down.
         * @param {number} [precision=0] The precision to round down to.
         * @returns {number} Returns the rounded down number.
         * @example
         *
         * _.floor(4.006);
         * // => 4
         *
         * _.floor(0.046, 2);
         * // => 0.04
         *
         * _.floor(4060, -2);
         * // => 4000
         */

        var floor = createRound('floor');
        /**
         * Computes the maximum value of `array`. If `array` is empty or falsey,
         * `undefined` is returned.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Math
         * @param {Array} array The array to iterate over.
         * @returns {*} Returns the maximum value.
         * @example
         *
         * _.max([4, 2, 8, 6]);
         * // => 8
         *
         * _.max([]);
         * // => undefined
         */

        function max(array) {
          return array && array.length ? baseExtremum(array, identity, baseGt) : undefined$1;
        }
        /**
         * This method is like `_.max` except that it accepts `iteratee` which is
         * invoked for each element in `array` to generate the criterion by which
         * the value is ranked. The iteratee is invoked with one argument: (value).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Math
         * @param {Array} array The array to iterate over.
         * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
         * @returns {*} Returns the maximum value.
         * @example
         *
         * var objects = [{ 'n': 1 }, { 'n': 2 }];
         *
         * _.maxBy(objects, function(o) { return o.n; });
         * // => { 'n': 2 }
         *
         * // The `_.property` iteratee shorthand.
         * _.maxBy(objects, 'n');
         * // => { 'n': 2 }
         */


        function maxBy(array, iteratee) {
          return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined$1;
        }
        /**
         * Computes the mean of the values in `array`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Math
         * @param {Array} array The array to iterate over.
         * @returns {number} Returns the mean.
         * @example
         *
         * _.mean([4, 2, 8, 6]);
         * // => 5
         */


        function mean(array) {
          return baseMean(array, identity);
        }
        /**
         * This method is like `_.mean` except that it accepts `iteratee` which is
         * invoked for each element in `array` to generate the value to be averaged.
         * The iteratee is invoked with one argument: (value).
         *
         * @static
         * @memberOf _
         * @since 4.7.0
         * @category Math
         * @param {Array} array The array to iterate over.
         * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
         * @returns {number} Returns the mean.
         * @example
         *
         * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
         *
         * _.meanBy(objects, function(o) { return o.n; });
         * // => 5
         *
         * // The `_.property` iteratee shorthand.
         * _.meanBy(objects, 'n');
         * // => 5
         */


        function meanBy(array, iteratee) {
          return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
         * Computes the minimum value of `array`. If `array` is empty or falsey,
         * `undefined` is returned.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Math
         * @param {Array} array The array to iterate over.
         * @returns {*} Returns the minimum value.
         * @example
         *
         * _.min([4, 2, 8, 6]);
         * // => 2
         *
         * _.min([]);
         * // => undefined
         */


        function min(array) {
          return array && array.length ? baseExtremum(array, identity, baseLt) : undefined$1;
        }
        /**
         * This method is like `_.min` except that it accepts `iteratee` which is
         * invoked for each element in `array` to generate the criterion by which
         * the value is ranked. The iteratee is invoked with one argument: (value).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Math
         * @param {Array} array The array to iterate over.
         * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
         * @returns {*} Returns the minimum value.
         * @example
         *
         * var objects = [{ 'n': 1 }, { 'n': 2 }];
         *
         * _.minBy(objects, function(o) { return o.n; });
         * // => { 'n': 1 }
         *
         * // The `_.property` iteratee shorthand.
         * _.minBy(objects, 'n');
         * // => { 'n': 1 }
         */


        function minBy(array, iteratee) {
          return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined$1;
        }
        /**
         * Multiply two numbers.
         *
         * @static
         * @memberOf _
         * @since 4.7.0
         * @category Math
         * @param {number} multiplier The first number in a multiplication.
         * @param {number} multiplicand The second number in a multiplication.
         * @returns {number} Returns the product.
         * @example
         *
         * _.multiply(6, 4);
         * // => 24
         */


        var multiply = createMathOperation(function (multiplier, multiplicand) {
          return multiplier * multiplicand;
        }, 1);
        /**
         * Computes `number` rounded to `precision`.
         *
         * @static
         * @memberOf _
         * @since 3.10.0
         * @category Math
         * @param {number} number The number to round.
         * @param {number} [precision=0] The precision to round to.
         * @returns {number} Returns the rounded number.
         * @example
         *
         * _.round(4.006);
         * // => 4
         *
         * _.round(4.006, 2);
         * // => 4.01
         *
         * _.round(4060, -2);
         * // => 4100
         */

        var round = createRound('round');
        /**
         * Subtract two numbers.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Math
         * @param {number} minuend The first number in a subtraction.
         * @param {number} subtrahend The second number in a subtraction.
         * @returns {number} Returns the difference.
         * @example
         *
         * _.subtract(6, 4);
         * // => 2
         */

        var subtract = createMathOperation(function (minuend, subtrahend) {
          return minuend - subtrahend;
        }, 0);
        /**
         * Computes the sum of the values in `array`.
         *
         * @static
         * @memberOf _
         * @since 3.4.0
         * @category Math
         * @param {Array} array The array to iterate over.
         * @returns {number} Returns the sum.
         * @example
         *
         * _.sum([4, 2, 8, 6]);
         * // => 20
         */

        function sum(array) {
          return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
         * This method is like `_.sum` except that it accepts `iteratee` which is
         * invoked for each element in `array` to generate the value to be summed.
         * The iteratee is invoked with one argument: (value).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Math
         * @param {Array} array The array to iterate over.
         * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
         * @returns {number} Returns the sum.
         * @example
         *
         * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
         *
         * _.sumBy(objects, function(o) { return o.n; });
         * // => 20
         *
         * // The `_.property` iteratee shorthand.
         * _.sumBy(objects, 'n');
         * // => 20
         */


        function sumBy(array, iteratee) {
          return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/
        // Add methods that return wrapped values in chain sequences.


        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith; // Add aliases.

        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith; // Add methods to `lodash.prototype`.

        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/
        // Add methods that return unwrapped values in chain sequences.

        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst; // Add aliases.

        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function () {
          var source = {};
          baseForOwn(lodash, function (func, methodName) {
            if (!hasOwnProperty.call(lodash.prototype, methodName)) {
              source[methodName] = func;
            }
          });
          return source;
        }(), {
          'chain': false
        });
        /*------------------------------------------------------------------------*/

        /**
         * The semantic version number.
         *
         * @static
         * @memberOf _
         * @type {string}
         */

        lodash.VERSION = VERSION; // Assign default placeholders.

        arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function (methodName) {
          lodash[methodName].placeholder = lodash;
        }); // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.

        arrayEach(['drop', 'take'], function (methodName, index) {
          LazyWrapper.prototype[methodName] = function (n) {
            n = n === undefined$1 ? 1 : nativeMax(toInteger(n), 0);
            var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();

            if (result.__filtered__) {
              result.__takeCount__ = nativeMin(n, result.__takeCount__);
            } else {
              result.__views__.push({
                'size': nativeMin(n, MAX_ARRAY_LENGTH),
                'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
              });
            }

            return result;
          };

          LazyWrapper.prototype[methodName + 'Right'] = function (n) {
            return this.reverse()[methodName](n).reverse();
          };
        }); // Add `LazyWrapper` methods that accept an `iteratee` value.

        arrayEach(['filter', 'map', 'takeWhile'], function (methodName, index) {
          var type = index + 1,
              isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

          LazyWrapper.prototype[methodName] = function (iteratee) {
            var result = this.clone();

            result.__iteratees__.push({
              'iteratee': getIteratee(iteratee, 3),
              'type': type
            });

            result.__filtered__ = result.__filtered__ || isFilter;
            return result;
          };
        }); // Add `LazyWrapper` methods for `_.head` and `_.last`.

        arrayEach(['head', 'last'], function (methodName, index) {
          var takeName = 'take' + (index ? 'Right' : '');

          LazyWrapper.prototype[methodName] = function () {
            return this[takeName](1).value()[0];
          };
        }); // Add `LazyWrapper` methods for `_.initial` and `_.tail`.

        arrayEach(['initial', 'tail'], function (methodName, index) {
          var dropName = 'drop' + (index ? '' : 'Right');

          LazyWrapper.prototype[methodName] = function () {
            return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
          };
        });

        LazyWrapper.prototype.compact = function () {
          return this.filter(identity);
        };

        LazyWrapper.prototype.find = function (predicate) {
          return this.filter(predicate).head();
        };

        LazyWrapper.prototype.findLast = function (predicate) {
          return this.reverse().find(predicate);
        };

        LazyWrapper.prototype.invokeMap = baseRest(function (path, args) {
          if (typeof path == 'function') {
            return new LazyWrapper(this);
          }

          return this.map(function (value) {
            return baseInvoke(value, path, args);
          });
        });

        LazyWrapper.prototype.reject = function (predicate) {
          return this.filter(negate(getIteratee(predicate)));
        };

        LazyWrapper.prototype.slice = function (start, end) {
          start = toInteger(start);
          var result = this;

          if (result.__filtered__ && (start > 0 || end < 0)) {
            return new LazyWrapper(result);
          }

          if (start < 0) {
            result = result.takeRight(-start);
          } else if (start) {
            result = result.drop(start);
          }

          if (end !== undefined$1) {
            end = toInteger(end);
            result = end < 0 ? result.dropRight(-end) : result.take(end - start);
          }

          return result;
        };

        LazyWrapper.prototype.takeRightWhile = function (predicate) {
          return this.reverse().takeWhile(predicate).reverse();
        };

        LazyWrapper.prototype.toArray = function () {
          return this.take(MAX_ARRAY_LENGTH);
        }; // Add `LazyWrapper` methods to `lodash.prototype`.


        baseForOwn(LazyWrapper.prototype, function (func, methodName) {
          var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
              isTaker = /^(?:head|last)$/.test(methodName),
              lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName],
              retUnwrapped = isTaker || /^find/.test(methodName);

          if (!lodashFunc) {
            return;
          }

          lodash.prototype[methodName] = function () {
            var value = this.__wrapped__,
                args = isTaker ? [1] : arguments,
                isLazy = value instanceof LazyWrapper,
                iteratee = args[0],
                useLazy = isLazy || isArray(value);

            var interceptor = function interceptor(value) {
              var result = lodashFunc.apply(lodash, arrayPush([value], args));
              return isTaker && chainAll ? result[0] : result;
            };

            if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
              // Avoid lazy use if the iteratee has a "length" value other than `1`.
              isLazy = useLazy = false;
            }

            var chainAll = this.__chain__,
                isHybrid = !!this.__actions__.length,
                isUnwrapped = retUnwrapped && !chainAll,
                onlyLazy = isLazy && !isHybrid;

            if (!retUnwrapped && useLazy) {
              value = onlyLazy ? value : new LazyWrapper(this);
              var result = func.apply(value, args);

              result.__actions__.push({
                'func': thru,
                'args': [interceptor],
                'thisArg': undefined$1
              });

              return new LodashWrapper(result, chainAll);
            }

            if (isUnwrapped && onlyLazy) {
              return func.apply(this, args);
            }

            result = this.thru(interceptor);
            return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
          };
        }); // Add `Array` methods to `lodash.prototype`.

        arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function (methodName) {
          var func = arrayProto[methodName],
              chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
              retUnwrapped = /^(?:pop|shift)$/.test(methodName);

          lodash.prototype[methodName] = function () {
            var args = arguments;

            if (retUnwrapped && !this.__chain__) {
              var value = this.value();
              return func.apply(isArray(value) ? value : [], args);
            }

            return this[chainName](function (value) {
              return func.apply(isArray(value) ? value : [], args);
            });
          };
        }); // Map minified method names to their real names.

        baseForOwn(LazyWrapper.prototype, function (func, methodName) {
          var lodashFunc = lodash[methodName];

          if (lodashFunc) {
            var key = lodashFunc.name + '';

            if (!hasOwnProperty.call(realNames, key)) {
              realNames[key] = [];
            }

            realNames[key].push({
              'name': methodName,
              'func': lodashFunc
            });
          }
        });
        realNames[createHybrid(undefined$1, WRAP_BIND_KEY_FLAG).name] = [{
          'name': 'wrapper',
          'func': undefined$1
        }]; // Add methods to `LazyWrapper`.

        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue; // Add chain sequence methods to the `lodash` wrapper.

        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue; // Add lazy aliases.

        lodash.prototype.first = lodash.prototype.head;

        if (symIterator) {
          lodash.prototype[symIterator] = wrapperToIterator;
        }

        return lodash;
      };
      /*--------------------------------------------------------------------------*/
      // Export lodash.


      var _ = runInContext(); // Some AMD build optimizers, like r.js, check for condition patterns like:


      if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _; // Export for CommonJS support.

        freeExports._ = _;
      } else {
        // Export to the global object.
        root._ = _;
      }
    }).call(commonjsGlobal);
  })(lodash, lodash.exports);

  var _$1 = lodash.exports;
  var classnames = {
    exports: {}
  };
  /*!
    Copyright (c) 2018 Jed Watson.
    Licensed under the MIT License (MIT), see
    http://jedwatson.github.io/classnames
  */

  (function (module) {
    /* global define */
    (function () {
      var hasOwn = {}.hasOwnProperty;

      function classNames() {
        var classes = [];

        for (var i = 0; i < arguments.length; i++) {
          var arg = arguments[i];
          if (!arg) continue;
          var argType = typeof arg;

          if (argType === 'string' || argType === 'number') {
            classes.push(arg);
          } else if (Array.isArray(arg)) {
            if (arg.length) {
              var inner = classNames.apply(null, arg);

              if (inner) {
                classes.push(inner);
              }
            }
          } else if (argType === 'object') {
            if (arg.toString === Object.prototype.toString) {
              for (var key in arg) {
                if (hasOwn.call(arg, key) && arg[key]) {
                  classes.push(key);
                }
              }
            } else {
              classes.push(arg.toString());
            }
          }
        }

        return classes.join(' ');
      }

      if (module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
      } else {
        window.classNames = classNames;
      }
    })();
  })(classnames);

  var classNames = classnames.exports;

  function generateComponentDataAttributes(componentName, className, customClassName) {
    return {
      'data-testid': lodash.exports.kebabCase(componentName),
      'data-component-name': componentName,
      'data-component-library': 'generic',
      className: classNames("ds-generic-react-" + componentName, className, customClassName !== null && customClassName !== void 0 ? customClassName : {})
    };
  }

  var Chip = function Chip(props) {
    var className = props.className,
        otherProps = __rest$1(props, ["className"]);

    var dataAttributes = generateComponentDataAttributes('Chip', className);
    return React__namespace.createElement(Chip$2, _assign2({}, dataAttributes, otherProps));
  };

  var defaultProps$c = {
    color: 'inherit',
    fontSize: 'medium',
    viewBox: '0 0 24 24'
  };

  var SvgIcon = function SvgIcon(props) {
    var className = props.className,
        otherProps = __rest$1(props, ["className"]);

    var dataAttributes = generateComponentDataAttributes('SvgIcon', className);
    return React__namespace.createElement(SvgIcon$2, _assign2({}, dataAttributes, otherProps));
  };

  SvgIcon.defaultProps = defaultProps$c;

  function useTheme() {
    var theme = useTheme$1(defaultTheme$1);

    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      React__namespace.useDebugValue(theme);
    }

    return theme;
  }

  var utils = /*#__PURE__*/Object.freeze({
    __proto__: null,
    capitalize: capitalize$1,
    createChainedFunction: createChainedFunction,
    createSvgIcon: createSvgIcon$1,
    debounce: debounce$1,
    deprecatedPropType: deprecatedPropType,
    isMuiElement: isMuiElement,
    ownerDocument: ownerDocument,
    ownerWindow: ownerWindow,
    requirePropFactory: requirePropFactory,
    setRef: setRef,
    unstable_useEnhancedEffect: useEnhancedEffect$1,
    unstable_useId: useId,
    unsupportedProp: unsupportedProp,
    useControlled: useControlled,
    useEventCallback: useEventCallback,
    useForkRef: useForkRef,
    useIsFocusVisible: useIsFocusVisible,
    unstable_ClassNameGenerator: ClassNameGenerator$1
  });

  var reflow = function reflow(node) {
    return node.scrollTop;
  };

  function getTransitionProps(props, options) {
    var _style$transitionDura, _style$transitionTimi;

    var timeout = props.timeout,
        easing = props.easing,
        _props$style = props.style,
        style = _props$style === void 0 ? {} : _props$style;
    return {
      duration: (_style$transitionDura = style.transitionDuration) != null ? _style$transitionDura : typeof timeout === 'number' ? timeout : timeout[options.mode] || 0,
      easing: (_style$transitionTimi = style.transitionTimingFunction) != null ? _style$transitionTimi : typeof easing === 'object' ? easing[options.mode] : easing,
      delay: style.transitionDelay
    };
  }

  function getCollapseUtilityClass(slot) {
    return generateUtilityClass('MuiCollapse', slot);
  }

  generateUtilityClasses('MuiCollapse', ['root', 'horizontal', 'vertical', 'entered', 'hidden', 'wrapper', 'wrapperInner']);
  var _excluded$1A = ["addEndListener", "children", "className", "collapsedSize", "component", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "orientation", "style", "timeout", "TransitionComponent"];

  var useUtilityClasses$1e = function useUtilityClasses$1e(ownerState) {
    var orientation = ownerState.orientation,
        classes = ownerState.classes;
    var slots = {
      root: ['root', "".concat(orientation)],
      entered: ['entered'],
      hidden: ['hidden'],
      wrapper: ['wrapper', "".concat(orientation)],
      wrapperInner: ['wrapperInner', "".concat(orientation)]
    };
    return composeClasses(slots, getCollapseUtilityClass, classes);
  };

  var CollapseRoot = styled$1('div', {
    name: 'MuiCollapse',
    slot: 'Root',
    overridesResolver: function overridesResolver(props, styles) {
      var ownerState = props.ownerState;
      return [styles.root, styles[ownerState.orientation], ownerState.state === 'entered' && styles.entered, ownerState.state === 'exited' && !ownerState.in && ownerState.collapsedSize === '0px' && styles.hidden];
    }
  })(function (_ref49) {
    var theme = _ref49.theme,
        ownerState = _ref49.ownerState;
    return _extends$c({
      height: 0,
      overflow: 'hidden',
      transition: theme.transitions.create('height')
    }, ownerState.orientation === 'horizontal' && {
      height: 'auto',
      width: 0,
      transition: theme.transitions.create('width')
    }, ownerState.state === 'entered' && _extends$c({
      height: 'auto',
      overflow: 'visible'
    }, ownerState.orientation === 'horizontal' && {
      width: 'auto'
    }), ownerState.state === 'exited' && !ownerState.in && ownerState.collapsedSize === '0px' && {
      visibility: 'hidden'
    });
  });
  var CollapseWrapper = styled$1('div', {
    name: 'MuiCollapse',
    slot: 'Wrapper',
    overridesResolver: function overridesResolver(props, styles) {
      return styles.wrapper;
    }
  })(function (_ref50) {
    var ownerState = _ref50.ownerState;
    return _extends$c({
      // Hack to get children with a negative margin to not falsify the height computation.
      display: 'flex',
      width: '100%'
    }, ownerState.orientation === 'horizontal' && {
      width: 'auto',
      height: '100%'
    });
  });
  var CollapseWrapperInner = styled$1('div', {
    name: 'MuiCollapse',
    slot: 'WrapperInner',
    overridesResolver: function overridesResolver(props, styles) {
      return styles.wrapperInner;
    }
  })(function (_ref51) {
    var ownerState = _ref51.ownerState;
    return _extends$c({
      width: '100%'
    }, ownerState.orientation === 'horizontal' && {
      width: 'auto',
      height: '100%'
    });
  });
  /**
   * The Collapse transition is used by the
   * [Vertical Stepper](/components/steppers/#vertical-stepper) StepContent component.
   * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
   */

  var Collapse = /*#__PURE__*/React__namespace.forwardRef(function Collapse(inProps, ref) {
    var props = useThemeProps({
      props: inProps,
      name: 'MuiCollapse'
    });

    var addEndListener = props.addEndListener,
        _children = props.children,
        className = props.className,
        _props$collapsedSize = props.collapsedSize,
        collapsedSizeProp = _props$collapsedSize === void 0 ? '0px' : _props$collapsedSize,
        component = props.component,
        easing = props.easing,
        inProp = props.in,
        onEnter = props.onEnter,
        onEntered = props.onEntered,
        onEntering = props.onEntering,
        onExit = props.onExit,
        onExited = props.onExited,
        onExiting = props.onExiting,
        _props$orientation = props.orientation,
        orientation = _props$orientation === void 0 ? 'vertical' : _props$orientation,
        style = props.style,
        _props$timeout = props.timeout,
        timeout = _props$timeout === void 0 ? duration.standard : _props$timeout,
        _props$TransitionComp = props.TransitionComponent,
        TransitionComponent = _props$TransitionComp === void 0 ? Transition$1 : _props$TransitionComp,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$1A);

    var ownerState = _extends$c({}, props, {
      orientation: orientation,
      collapsedSize: collapsedSizeProp
    });

    var classes = useUtilityClasses$1e(ownerState);
    var theme = useTheme();
    var timer = React__namespace.useRef();
    var wrapperRef = React__namespace.useRef(null);
    var autoTransitionDuration = React__namespace.useRef();
    var collapsedSize = typeof collapsedSizeProp === 'number' ? "".concat(collapsedSizeProp, "px") : collapsedSizeProp;
    var isHorizontal = orientation === 'horizontal';
    var size = isHorizontal ? 'width' : 'height';
    React__namespace.useEffect(function () {
      return function () {
        clearTimeout(timer.current);
      };
    }, []);
    var nodeRef = React__namespace.useRef(null);
    var handleRef = useForkRef(ref, nodeRef);

    var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
      return function (maybeIsAppearing) {
        if (callback) {
          var _node = nodeRef.current; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.

          if (maybeIsAppearing === undefined) {
            callback(_node);
          } else {
            callback(_node, maybeIsAppearing);
          }
        }
      };
    };

    var getWrapperSize = function getWrapperSize() {
      return wrapperRef.current ? wrapperRef.current[isHorizontal ? 'clientWidth' : 'clientHeight'] : 0;
    };

    var handleEnter = normalizedTransitionCallback(function (node, isAppearing) {
      if (wrapperRef.current && isHorizontal) {
        // Set absolute position to get the size of collapsed content
        wrapperRef.current.style.position = 'absolute';
      }

      node.style[size] = collapsedSize;

      if (onEnter) {
        onEnter(node, isAppearing);
      }
    });
    var handleEntering = normalizedTransitionCallback(function (node, isAppearing) {
      var wrapperSize = getWrapperSize();

      if (wrapperRef.current && isHorizontal) {
        // After the size is read reset the position back to default
        wrapperRef.current.style.position = '';
      }

      var _getTransitionProps = getTransitionProps({
        style: style,
        timeout: timeout,
        easing: easing
      }, {
        mode: 'enter'
      }),
          transitionDuration = _getTransitionProps.duration,
          transitionTimingFunction = _getTransitionProps.easing;

      if (timeout === 'auto') {
        var duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
        node.style.transitionDuration = "".concat(duration2, "ms");
        autoTransitionDuration.current = duration2;
      } else {
        node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : "".concat(transitionDuration, "ms");
      }

      node.style[size] = "".concat(wrapperSize, "px");
      node.style.transitionTimingFunction = transitionTimingFunction;

      if (onEntering) {
        onEntering(node, isAppearing);
      }
    });
    var handleEntered = normalizedTransitionCallback(function (node, isAppearing) {
      node.style[size] = 'auto';

      if (onEntered) {
        onEntered(node, isAppearing);
      }
    });
    var handleExit = normalizedTransitionCallback(function (node) {
      node.style[size] = "".concat(getWrapperSize(), "px");

      if (onExit) {
        onExit(node);
      }
    });
    var handleExited = normalizedTransitionCallback(onExited);
    var handleExiting = normalizedTransitionCallback(function (node) {
      var wrapperSize = getWrapperSize();

      var _getTransitionProps2 = getTransitionProps({
        style: style,
        timeout: timeout,
        easing: easing
      }, {
        mode: 'exit'
      }),
          transitionDuration = _getTransitionProps2.duration,
          transitionTimingFunction = _getTransitionProps2.easing;

      if (timeout === 'auto') {
        // TODO: rename getAutoHeightDuration to something more generic (width support)
        // Actually it just calculates animation duration based on size
        var duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
        node.style.transitionDuration = "".concat(duration2, "ms");
        autoTransitionDuration.current = duration2;
      } else {
        node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : "".concat(transitionDuration, "ms");
      }

      node.style[size] = collapsedSize;
      node.style.transitionTimingFunction = transitionTimingFunction;

      if (onExiting) {
        onExiting(node);
      }
    });

    var handleAddEndListener = function handleAddEndListener(next) {
      if (timeout === 'auto') {
        timer.current = setTimeout(next, autoTransitionDuration.current || 0);
      }

      if (addEndListener) {
        // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
      }
    };

    return /*#__PURE__*/jsxRuntime$1.jsx(TransitionComponent, _extends$c({
      in: inProp,
      onEnter: handleEnter,
      onEntered: handleEntered,
      onEntering: handleEntering,
      onExit: handleExit,
      onExited: handleExited,
      onExiting: handleExiting,
      addEndListener: handleAddEndListener,
      nodeRef: nodeRef,
      timeout: timeout === 'auto' ? null : timeout
    }, other, {
      children: function children(state, childProps) {
        return /*#__PURE__*/jsxRuntime$1.jsx(CollapseRoot, _extends$c({
          as: component,
          className: clsx(classes.root, className, {
            'entered': classes.entered,
            'exited': !inProp && collapsedSize === '0px' && classes.hidden
          }[state]),
          style: _extends$c(_defineProperty({}, isHorizontal ? 'minWidth' : 'minHeight', collapsedSize), style),
          ownerState: _extends$c({}, ownerState, {
            state: state
          }),
          ref: handleRef
        }, childProps, {
          children: /*#__PURE__*/jsxRuntime$1.jsx(CollapseWrapper, {
            ownerState: _extends$c({}, ownerState, {
              state: state
            }),
            className: classes.wrapper,
            ref: wrapperRef,
            children: /*#__PURE__*/jsxRuntime$1.jsx(CollapseWrapperInner, {
              ownerState: _extends$c({}, ownerState, {
                state: state
              }),
              className: classes.wrapperInner,
              children: _children
            })
          })
        }));
      }
    }));
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  Collapse.muiSupportAuto = true;
  var Collapse$1 = Collapse;

  function getPaperUtilityClass(slot) {
    return generateUtilityClass('MuiPaper', slot);
  }

  generateUtilityClasses('MuiPaper', ['root', 'rounded', 'outlined', 'elevation', 'elevation0', 'elevation1', 'elevation2', 'elevation3', 'elevation4', 'elevation5', 'elevation6', 'elevation7', 'elevation8', 'elevation9', 'elevation10', 'elevation11', 'elevation12', 'elevation13', 'elevation14', 'elevation15', 'elevation16', 'elevation17', 'elevation18', 'elevation19', 'elevation20', 'elevation21', 'elevation22', 'elevation23', 'elevation24']);
  var _excluded$1z = ["className", "component", "elevation", "square", "variant"];

  var getOverlayAlpha = function getOverlayAlpha(elevation) {
    var alphaValue;

    if (elevation < 1) {
      alphaValue = 5.11916 * Math.pow(elevation, 2);
    } else {
      alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    }

    return (alphaValue / 100).toFixed(2);
  };

  var useUtilityClasses$1d = function useUtilityClasses$1d(ownerState) {
    var square = ownerState.square,
        elevation = ownerState.elevation,
        variant = ownerState.variant,
        classes = ownerState.classes;
    var slots = {
      root: ['root', variant, !square && 'rounded', variant === 'elevation' && "elevation".concat(elevation)]
    };
    return composeClasses(slots, getPaperUtilityClass, classes);
  };

  var PaperRoot = styled$1('div', {
    name: 'MuiPaper',
    slot: 'Root',
    overridesResolver: function overridesResolver(props, styles) {
      var ownerState = props.ownerState;
      return [styles.root, styles[ownerState.variant], !ownerState.square && styles.rounded, ownerState.variant === 'elevation' && styles["elevation".concat(ownerState.elevation)]];
    }
  })(function (_ref52) {
    var theme = _ref52.theme,
        ownerState = _ref52.ownerState;
    return _extends$c({
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.text.primary,
      transition: theme.transitions.create('box-shadow')
    }, !ownerState.square && {
      borderRadius: theme.shape.borderRadius
    }, ownerState.variant === 'outlined' && {
      border: "1px solid ".concat(theme.palette.divider)
    }, ownerState.variant === 'elevation' && _extends$c({
      boxShadow: theme.shadows[ownerState.elevation]
    }, theme.palette.mode === 'dark' && {
      backgroundImage: "linear-gradient(".concat(alpha('#fff', getOverlayAlpha(ownerState.elevation)), ", ").concat(alpha('#fff', getOverlayAlpha(ownerState.elevation)), ")")
    }));
  });
  var Paper$1 = /*#__PURE__*/React__namespace.forwardRef(function Paper(inProps, ref) {
    var props = useThemeProps({
      props: inProps,
      name: 'MuiPaper'
    });

    var className = props.className,
        _props$component6 = props.component,
        component = _props$component6 === void 0 ? 'div' : _props$component6,
        _props$elevation = props.elevation,
        elevation = _props$elevation === void 0 ? 1 : _props$elevation,
        _props$square = props.square,
        square = _props$square === void 0 ? false : _props$square,
        _props$variant3 = props.variant,
        variant = _props$variant3 === void 0 ? 'elevation' : _props$variant3,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$1z);

    var ownerState = _extends$c({}, props, {
      component: component,
      elevation: elevation,
      square: square,
      variant: variant
    });

    var classes = useUtilityClasses$1d(ownerState);

    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      var theme = useTheme();

      if (theme.shadows[elevation] === undefined) {
        console.error(["MUI: The elevation provided <Paper elevation={".concat(elevation, "}> is not available in the theme."), "Please make sure that `theme.shadows[".concat(elevation, "]` is defined.")].join('\n'));
      }
    }

    return /*#__PURE__*/jsxRuntime$1.jsx(PaperRoot, _extends$c({
      as: component,
      ownerState: ownerState,
      className: clsx(classes.root, className),
      ref: ref
    }, other));
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var BasePaper = Paper$1;
  /**
   * @ignore - internal component.
   * @type {React.Context<{} | {expanded: boolean, disabled: boolean, toggle: () => void}>}
   */

  var AccordionContext = /*#__PURE__*/React__namespace.createContext({});

  if (process.env.NODE_ENV !== 'production') {
    AccordionContext.displayName = 'AccordionContext';
  }

  var AccordionContext$1 = AccordionContext;

  function getAccordionUtilityClass(slot) {
    return generateUtilityClass('MuiAccordion', slot);
  }

  var accordionClasses = generateUtilityClasses('MuiAccordion', ['root', 'rounded', 'expanded', 'disabled', 'gutters', 'region']);
  var accordionClasses$1 = accordionClasses;
  var _excluded$1y = ["children", "className", "defaultExpanded", "disabled", "disableGutters", "expanded", "onChange", "square", "TransitionComponent", "TransitionProps"];

  var useUtilityClasses$1c = function useUtilityClasses$1c(ownerState) {
    var classes = ownerState.classes,
        square = ownerState.square,
        expanded = ownerState.expanded,
        disabled = ownerState.disabled,
        disableGutters = ownerState.disableGutters;
    var slots = {
      root: ['root', !square && 'rounded', expanded && 'expanded', disabled && 'disabled', !disableGutters && 'gutters'],
      region: ['region']
    };
    return composeClasses(slots, getAccordionUtilityClass, classes);
  };

  var AccordionRoot = styled$1(BasePaper, {
    name: 'MuiAccordion',
    slot: 'Root',
    overridesResolver: function overridesResolver(props, styles) {
      var ownerState = props.ownerState;
      return [_defineProperty({}, "& .".concat(accordionClasses$1.region), styles.region), styles.root, !ownerState.square && styles.rounded, !ownerState.disableGutters && styles.gutters];
    }
  })(function (_ref54) {
    var _ref55;

    var theme = _ref54.theme;
    var transition = {
      duration: theme.transitions.duration.shortest
    };
    return _ref55 = {
      position: 'relative',
      transition: theme.transitions.create(['margin'], transition),
      overflowAnchor: 'none',
      // Keep the same scrolling position
      '&:before': {
        position: 'absolute',
        left: 0,
        top: -1,
        right: 0,
        height: 1,
        content: '""',
        opacity: 1,
        backgroundColor: theme.palette.divider,
        transition: theme.transitions.create(['opacity', 'background-color'], transition)
      },
      '&:first-of-type': {
        '&:before': {
          display: 'none'
        }
      }
    }, _defineProperty(_ref55, "&.".concat(accordionClasses$1.expanded), {
      '&:before': {
        opacity: 0
      },
      '&:first-of-type': {
        marginTop: 0
      },
      '&:last-of-type': {
        marginBottom: 0
      },
      '& + &': {
        '&:before': {
          display: 'none'
        }
      }
    }), _defineProperty(_ref55, "&.".concat(accordionClasses$1.disabled), {
      backgroundColor: theme.palette.action.disabledBackground
    }), _ref55;
  }, function (_ref56) {
    var theme = _ref56.theme,
        ownerState = _ref56.ownerState;
    return _extends$c({}, !ownerState.square && {
      borderRadius: 0,
      '&:first-of-type': {
        borderTopLeftRadius: theme.shape.borderRadius,
        borderTopRightRadius: theme.shape.borderRadius
      },
      '&:last-of-type': {
        borderBottomLeftRadius: theme.shape.borderRadius,
        borderBottomRightRadius: theme.shape.borderRadius,
        // Fix a rendering issue on Edge
        '@supports (-ms-ime-align: auto)': {
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0
        }
      }
    }, !ownerState.disableGutters && _defineProperty({}, "&.".concat(accordionClasses$1.expanded), {
      margin: '16px 0'
    }));
  });
  var Accordion$1 = /*#__PURE__*/React__namespace.forwardRef(function Accordion(inProps, ref) {
    var props = useThemeProps({
      props: inProps,
      name: 'MuiAccordion'
    });

    var childrenProp = props.children,
        className = props.className,
        _props$defaultExpande = props.defaultExpanded,
        defaultExpanded = _props$defaultExpande === void 0 ? false : _props$defaultExpande,
        _props$disabled3 = props.disabled,
        disabled = _props$disabled3 === void 0 ? false : _props$disabled3,
        _props$disableGutters = props.disableGutters,
        disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
        expandedProp = props.expanded,
        onChange = props.onChange,
        _props$square2 = props.square,
        square = _props$square2 === void 0 ? false : _props$square2,
        _props$TransitionComp2 = props.TransitionComponent,
        TransitionComponent = _props$TransitionComp2 === void 0 ? Collapse$1 : _props$TransitionComp2,
        TransitionProps = props.TransitionProps,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$1y);

    var _useControlled7 = useControlled({
      controlled: expandedProp,
      default: defaultExpanded,
      name: 'Accordion',
      state: 'expanded'
    }),
        _useControlled8 = _slicedToArray(_useControlled7, 2),
        expanded = _useControlled8[0],
        setExpandedState = _useControlled8[1];

    var handleChange = React__namespace.useCallback(function (event) {
      setExpandedState(!expanded);

      if (onChange) {
        onChange(event, !expanded);
      }
    }, [expanded, onChange, setExpandedState]);

    var _React__namespace$Chi = React__namespace.Children.toArray(childrenProp),
        _React__namespace$Chi2 = _toArray(_React__namespace$Chi),
        summary = _React__namespace$Chi2[0],
        children = _React__namespace$Chi2.slice(1);

    var contextValue = React__namespace.useMemo(function () {
      return {
        expanded: expanded,
        disabled: disabled,
        disableGutters: disableGutters,
        toggle: handleChange
      };
    }, [expanded, disabled, disableGutters, handleChange]);

    var ownerState = _extends$c({}, props, {
      square: square,
      disabled: disabled,
      disableGutters: disableGutters,
      expanded: expanded
    });

    var classes = useUtilityClasses$1c(ownerState);
    return /*#__PURE__*/jsxRuntime$1.jsxs(AccordionRoot, _extends$c({
      className: clsx(classes.root, className),
      ref: ref,
      ownerState: ownerState,
      square: square
    }, other, {
      children: [/*#__PURE__*/jsxRuntime$1.jsx(AccordionContext$1.Provider, {
        value: contextValue,
        children: summary
      }), /*#__PURE__*/jsxRuntime$1.jsx(TransitionComponent, _extends$c({
        in: expanded,
        timeout: "auto"
      }, TransitionProps, {
        children: /*#__PURE__*/jsxRuntime$1.jsx("div", {
          "aria-labelledby": summary.props.id,
          id: summary.props['aria-controls'],
          role: "region",
          className: classes.region,
          children: children
        })
      }))]
    }));
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var BaseAccordion = Accordion$1;

  function getAccordionActionsUtilityClass(slot) {
    return generateUtilityClass('MuiAccordionActions', slot);
  }

  generateUtilityClasses('MuiAccordionActions', ['root', 'spacing']);
  var _excluded$1x = ["className", "disableSpacing"];

  var useUtilityClasses$1b = function useUtilityClasses$1b(ownerState) {
    var classes = ownerState.classes,
        disableSpacing = ownerState.disableSpacing;
    var slots = {
      root: ['root', !disableSpacing && 'spacing']
    };
    return composeClasses(slots, getAccordionActionsUtilityClass, classes);
  };

  var AccordionActionsRoot = styled$1('div', {
    name: 'MuiAccordionActions',
    slot: 'Root',
    overridesResolver: function overridesResolver(props, styles) {
      var ownerState = props.ownerState;
      return [styles.root, !ownerState.disableSpacing && styles.spacing];
    }
  })(function (_ref58) {
    var ownerState = _ref58.ownerState;
    return _extends$c({
      display: 'flex',
      alignItems: 'center',
      padding: 8,
      justifyContent: 'flex-end'
    }, !ownerState.disableSpacing && {
      '& > :not(:first-of-type)': {
        marginLeft: 8
      }
    });
  });
  var AccordionActions$1 = /*#__PURE__*/React__namespace.forwardRef(function AccordionActions(inProps, ref) {
    var props = useThemeProps({
      props: inProps,
      name: 'MuiAccordionActions'
    });

    var className = props.className,
        _props$disableSpacing = props.disableSpacing,
        disableSpacing = _props$disableSpacing === void 0 ? false : _props$disableSpacing,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$1x);

    var ownerState = _extends$c({}, props, {
      disableSpacing: disableSpacing
    });

    var classes = useUtilityClasses$1b(ownerState);
    return /*#__PURE__*/jsxRuntime$1.jsx(AccordionActionsRoot, _extends$c({
      className: clsx(classes.root, className),
      ref: ref,
      ownerState: ownerState
    }, other));
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var BaseAccordionActions = AccordionActions$1;

  function getAccordionDetailsUtilityClass(slot) {
    return generateUtilityClass('MuiAccordionDetails', slot);
  }

  generateUtilityClasses('MuiAccordionDetails', ['root']);
  var _excluded$1w = ["className"];

  var useUtilityClasses$1a = function useUtilityClasses$1a(ownerState) {
    var classes = ownerState.classes;
    var slots = {
      root: ['root']
    };
    return composeClasses(slots, getAccordionDetailsUtilityClass, classes);
  };

  var AccordionDetailsRoot = styled$1('div', {
    name: 'MuiAccordionDetails',
    slot: 'Root',
    overridesResolver: function overridesResolver(props, styles) {
      return styles.root;
    }
  })(function (_ref59) {
    var theme = _ref59.theme;
    return {
      padding: theme.spacing(1, 2, 2)
    };
  });
  var AccordionDetails$1 = /*#__PURE__*/React__namespace.forwardRef(function AccordionDetails(inProps, ref) {
    var props = useThemeProps({
      props: inProps,
      name: 'MuiAccordionDetails'
    });

    var className = props.className,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$1w);

    var ownerState = props;
    var classes = useUtilityClasses$1a(ownerState);
    return /*#__PURE__*/jsxRuntime$1.jsx(AccordionDetailsRoot, _extends$c({
      className: clsx(classes.root, className),
      ref: ref,
      ownerState: ownerState
    }, other));
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var BaseAccordionDetails = AccordionDetails$1;

  function getAccordionSummaryUtilityClass(slot) {
    return generateUtilityClass('MuiAccordionSummary', slot);
  }

  var accordionSummaryClasses = generateUtilityClasses('MuiAccordionSummary', ['root', 'expanded', 'focusVisible', 'disabled', 'gutters', 'contentGutters', 'content', 'expandIconWrapper']);
  var accordionSummaryClasses$1 = accordionSummaryClasses;
  var _excluded$1v = ["children", "className", "expandIcon", "focusVisibleClassName", "onClick"];

  var useUtilityClasses$19 = function useUtilityClasses$19(ownerState) {
    var classes = ownerState.classes,
        expanded = ownerState.expanded,
        disabled = ownerState.disabled,
        disableGutters = ownerState.disableGutters;
    var slots = {
      root: ['root', expanded && 'expanded', disabled && 'disabled', !disableGutters && 'gutters'],
      focusVisible: ['focusVisible'],
      content: ['content', expanded && 'expanded', !disableGutters && 'contentGutters'],
      expandIconWrapper: ['expandIconWrapper', expanded && 'expanded']
    };
    return composeClasses(slots, getAccordionSummaryUtilityClass, classes);
  };

  var AccordionSummaryRoot = styled$1(ButtonBase$1, {
    name: 'MuiAccordionSummary',
    slot: 'Root',
    overridesResolver: function overridesResolver(props, styles) {
      return styles.root;
    }
  })(function (_ref60) {
    var _extends$c4;

    var theme = _ref60.theme,
        ownerState = _ref60.ownerState;
    var transition = {
      duration: theme.transitions.duration.shortest
    };
    return _extends$c((_extends$c4 = {
      display: 'flex',
      minHeight: 48,
      padding: theme.spacing(0, 2),
      transition: theme.transitions.create(['min-height', 'background-color'], transition)
    }, _defineProperty(_extends$c4, "&.".concat(accordionSummaryClasses$1.focusVisible), {
      backgroundColor: theme.palette.action.focus
    }), _defineProperty(_extends$c4, "&.".concat(accordionSummaryClasses$1.disabled), {
      opacity: theme.palette.action.disabledOpacity
    }), _defineProperty(_extends$c4, "&:hover:not(.".concat(accordionSummaryClasses$1.disabled, ")"), {
      cursor: 'pointer'
    }), _extends$c4), !ownerState.disableGutters && _defineProperty({}, "&.".concat(accordionSummaryClasses$1.expanded), {
      minHeight: 64
    }));
  });
  var AccordionSummaryContent = styled$1('div', {
    name: 'MuiAccordionSummary',
    slot: 'Content',
    overridesResolver: function overridesResolver(props, styles) {
      return styles.content;
    }
  })(function (_ref62) {
    var theme = _ref62.theme,
        ownerState = _ref62.ownerState;
    return _extends$c({
      display: 'flex',
      flexGrow: 1,
      margin: '12px 0'
    }, !ownerState.disableGutters && _defineProperty({
      transition: theme.transitions.create(['margin'], {
        duration: theme.transitions.duration.shortest
      })
    }, "&.".concat(accordionSummaryClasses$1.expanded), {
      margin: '20px 0'
    }));
  });
  var AccordionSummaryExpandIconWrapper = styled$1('div', {
    name: 'MuiAccordionSummary',
    slot: 'ExpandIconWrapper',
    overridesResolver: function overridesResolver(props, styles) {
      return styles.expandIconWrapper;
    }
  })(function (_ref64) {
    var theme = _ref64.theme;
    return _defineProperty({
      display: 'flex',
      color: theme.palette.action.active,
      transform: 'rotate(0deg)',
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest
      })
    }, "&.".concat(accordionSummaryClasses$1.expanded), {
      transform: 'rotate(180deg)'
    });
  });
  var AccordionSummary$1 = /*#__PURE__*/React__namespace.forwardRef(function AccordionSummary(inProps, ref) {
    var props = useThemeProps({
      props: inProps,
      name: 'MuiAccordionSummary'
    });

    var children = props.children,
        className = props.className,
        expandIcon = props.expandIcon,
        focusVisibleClassName = props.focusVisibleClassName,
        onClick = props.onClick,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$1v);

    var _React__namespace$use36 = React__namespace.useContext(AccordionContext$1),
        _React__namespace$use37 = _React__namespace$use36.disabled,
        disabled = _React__namespace$use37 === void 0 ? false : _React__namespace$use37,
        disableGutters = _React__namespace$use36.disableGutters,
        expanded = _React__namespace$use36.expanded,
        toggle = _React__namespace$use36.toggle;

    var handleChange = function handleChange(event) {
      if (toggle) {
        toggle(event);
      }

      if (onClick) {
        onClick(event);
      }
    };

    var ownerState = _extends$c({}, props, {
      expanded: expanded,
      disabled: disabled,
      disableGutters: disableGutters
    });

    var classes = useUtilityClasses$19(ownerState);
    return /*#__PURE__*/jsxRuntime$1.jsxs(AccordionSummaryRoot, _extends$c({
      focusRipple: false,
      disableRipple: true,
      disabled: disabled,
      component: "div",
      "aria-expanded": expanded,
      className: clsx(classes.root, className),
      focusVisibleClassName: clsx(classes.focusVisible, focusVisibleClassName),
      onClick: handleChange,
      ref: ref,
      ownerState: ownerState
    }, other, {
      children: [/*#__PURE__*/jsxRuntime$1.jsx(AccordionSummaryContent, {
        className: classes.content,
        ownerState: ownerState,
        children: children
      }), expandIcon && /*#__PURE__*/jsxRuntime$1.jsx(AccordionSummaryExpandIconWrapper, {
        className: classes.expandIconWrapper,
        ownerState: ownerState,
        children: expandIcon
      })]
    }));
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var BaseAccordionSummary = AccordionSummary$1;

  function getAlertUtilityClass(slot) {
    return generateUtilityClass('MuiAlert', slot);
  }

  var alertClasses = generateUtilityClasses('MuiAlert', ['root', 'action', 'icon', 'message', 'filled', 'filledSuccess', 'filledInfo', 'filledWarning', 'filledError', 'outlined', 'outlinedSuccess', 'outlinedInfo', 'outlinedWarning', 'outlinedError', 'standard', 'standardSuccess', 'standardInfo', 'standardWarning', 'standardError']);
  var alertClasses$1 = alertClasses;

  function getIconButtonUtilityClass(slot) {
    return generateUtilityClass('MuiIconButton', slot);
  }

  var iconButtonClasses = generateUtilityClasses('MuiIconButton', ['root', 'disabled', 'colorInherit', 'colorPrimary', 'colorSecondary', 'edgeStart', 'edgeEnd', 'sizeSmall', 'sizeMedium', 'sizeLarge']);
  var iconButtonClasses$1 = iconButtonClasses;
  var _excluded$1u = ["edge", "children", "className", "color", "disabled", "disableFocusRipple", "size"];

  var useUtilityClasses$18 = function useUtilityClasses$18(ownerState) {
    var classes = ownerState.classes,
        disabled = ownerState.disabled,
        color = ownerState.color,
        edge = ownerState.edge,
        size = ownerState.size;
    var slots = {
      root: ['root', disabled && 'disabled', color !== 'default' && "color".concat(capitalize$1(color)), edge && "edge".concat(capitalize$1(edge)), "size".concat(capitalize$1(size))]
    };
    return composeClasses(slots, getIconButtonUtilityClass, classes);
  };

  var IconButtonRoot = styled$1(ButtonBase$1, {
    name: 'MuiIconButton',
    slot: 'Root',
    overridesResolver: function overridesResolver(props, styles) {
      var ownerState = props.ownerState;
      return [styles.root, ownerState.color !== 'default' && styles["color".concat(capitalize$1(ownerState.color))], ownerState.edge && styles["edge".concat(capitalize$1(ownerState.edge))], styles["size".concat(capitalize$1(ownerState.size))]];
    }
  })(function (_ref66) {
    var theme = _ref66.theme,
        ownerState = _ref66.ownerState;
    return _extends$c({
      textAlign: 'center',
      flex: '0 0 auto',
      fontSize: theme.typography.pxToRem(24),
      padding: 8,
      borderRadius: '50%',
      overflow: 'visible',
      // Explicitly set the default value to solve a bug on IE11.
      color: theme.palette.action.active,
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.shortest
      })
    }, !ownerState.disableRipple && {
      '&:hover': {
        backgroundColor: alpha(theme.palette.action.active, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    }, ownerState.edge === 'start' && {
      marginLeft: ownerState.size === 'small' ? -3 : -12
    }, ownerState.edge === 'end' && {
      marginRight: ownerState.size === 'small' ? -3 : -12
    });
  }, function (_ref67) {
    var theme = _ref67.theme,
        ownerState = _ref67.ownerState;
    return _extends$c({}, ownerState.color === 'inherit' && {
      color: 'inherit'
    }, ownerState.color !== 'inherit' && ownerState.color !== 'default' && _extends$c({
      color: theme.palette[ownerState.color].main
    }, !ownerState.disableRipple && {
      '&:hover': {
        backgroundColor: alpha(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    }), ownerState.size === 'small' && {
      padding: 5,
      fontSize: theme.typography.pxToRem(18)
    }, ownerState.size === 'large' && {
      padding: 12,
      fontSize: theme.typography.pxToRem(28)
    }, _defineProperty({}, "&.".concat(iconButtonClasses$1.disabled), {
      backgroundColor: 'transparent',
      color: theme.palette.action.disabled
    }));
  });
  /**
   * Refer to the [Icons](/components/icons/) section of the documentation
   * regarding the available icon options.
   */

  var IconButton$1 = /*#__PURE__*/React__namespace.forwardRef(function IconButton(inProps, ref) {
    var props = useThemeProps({
      props: inProps,
      name: 'MuiIconButton'
    });

    var _props$edge = props.edge,
        edge = _props$edge === void 0 ? false : _props$edge,
        children = props.children,
        className = props.className,
        _props$color3 = props.color,
        color = _props$color3 === void 0 ? 'default' : _props$color3,
        _props$disabled4 = props.disabled,
        disabled = _props$disabled4 === void 0 ? false : _props$disabled4,
        _props$disableFocusRi = props.disableFocusRipple,
        disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
        _props$size2 = props.size,
        size = _props$size2 === void 0 ? 'medium' : _props$size2,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$1u);

    var ownerState = _extends$c({}, props, {
      edge: edge,
      color: color,
      disabled: disabled,
      disableFocusRipple: disableFocusRipple,
      size: size
    });

    var classes = useUtilityClasses$18(ownerState);
    return /*#__PURE__*/jsxRuntime$1.jsx(IconButtonRoot, _extends$c({
      className: clsx(classes.root, className),
      centerRipple: true,
      focusRipple: !disableFocusRipple,
      disabled: disabled,
      ref: ref,
      ownerState: ownerState
    }, other, {
      children: children
    }));
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var IconButton$2 = IconButton$1;
  var SuccessOutlinedIcon = createSvgIcon$1( /*#__PURE__*/jsxRuntime$1.jsx("path", {
    d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
  }), 'SuccessOutlined');
  var ReportProblemOutlinedIcon = createSvgIcon$1( /*#__PURE__*/jsxRuntime$1.jsx("path", {
    d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
  }), 'ReportProblemOutlined');
  var ErrorOutlineIcon = createSvgIcon$1( /*#__PURE__*/jsxRuntime$1.jsx("path", {
    d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
  }), 'ErrorOutline');
  var InfoOutlinedIcon = createSvgIcon$1( /*#__PURE__*/jsxRuntime$1.jsx("path", {
    d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
  }), 'InfoOutlined');
  var ClearIcon = createSvgIcon$1( /*#__PURE__*/jsxRuntime$1.jsx("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
  }), 'Close');

  var _CloseIcon;

  var _excluded$1t = ["action", "children", "className", "closeText", "color", "icon", "iconMapping", "onClose", "role", "severity", "variant"];

  var useUtilityClasses$17 = function useUtilityClasses$17(ownerState) {
    var variant = ownerState.variant,
        color = ownerState.color,
        severity = ownerState.severity,
        classes = ownerState.classes;
    var slots = {
      root: ['root', "".concat(variant).concat(capitalize$1(color || severity)), "".concat(variant)],
      icon: ['icon'],
      message: ['message'],
      action: ['action']
    };
    return composeClasses(slots, getAlertUtilityClass, classes);
  };

  var AlertRoot = styled$1(BasePaper, {
    name: 'MuiAlert',
    slot: 'Root',
    overridesResolver: function overridesResolver(props, styles) {
      var ownerState = props.ownerState;
      return [styles.root, styles[ownerState.variant], styles["".concat(ownerState.variant).concat(capitalize$1(ownerState.color || ownerState.severity))]];
    }
  })(function (_ref68) {
    var theme = _ref68.theme,
        ownerState = _ref68.ownerState;
    var getColor = theme.palette.mode === 'light' ? darken : lighten;
    var getBackgroundColor = theme.palette.mode === 'light' ? lighten : darken;
    var color = ownerState.color || ownerState.severity;
    return _extends$c({}, theme.typography.body2, {
      backgroundColor: 'transparent',
      display: 'flex',
      padding: '6px 16px'
    }, color && ownerState.variant === 'standard' && _defineProperty({
      color: getColor(theme.palette[color].light, 0.6),
      backgroundColor: getBackgroundColor(theme.palette[color].light, 0.9)
    }, "& .".concat(alertClasses$1.icon), {
      color: theme.palette.mode === 'dark' ? theme.palette[color].main : theme.palette[color].light
    }), color && ownerState.variant === 'outlined' && _defineProperty({
      color: getColor(theme.palette[color].light, 0.6),
      border: "1px solid ".concat(theme.palette[color].light)
    }, "& .".concat(alertClasses$1.icon), {
      color: theme.palette.mode === 'dark' ? theme.palette[color].main : theme.palette[color].light
    }), color && ownerState.variant === 'filled' && {
      color: '#fff',
      fontWeight: theme.typography.fontWeightMedium,
      backgroundColor: theme.palette.mode === 'dark' ? theme.palette[color].dark : theme.palette[color].main
    });
  });
  var AlertIcon = styled$1('div', {
    name: 'MuiAlert',
    slot: 'Icon',
    overridesResolver: function overridesResolver(props, styles) {
      return styles.icon;
    }
  })({
    marginRight: 12,
    padding: '7px 0',
    display: 'flex',
    fontSize: 22,
    opacity: 0.9
  });
  var AlertMessage = styled$1('div', {
    name: 'MuiAlert',
    slot: 'Message',
    overridesResolver: function overridesResolver(props, styles) {
      return styles.message;
    }
  })({
    padding: '8px 0'
  });
  var AlertAction = styled$1('div', {
    name: 'MuiAlert',
    slot: 'Action',
    overridesResolver: function overridesResolver(props, styles) {
      return styles.action;
    }
  })({
    display: 'flex',
    alignItems: 'flex-start',
    padding: '4px 0 0 16px',
    marginLeft: 'auto',
    marginRight: -8
  });
  var defaultIconMapping = {
    success: /*#__PURE__*/jsxRuntime$1.jsx(SuccessOutlinedIcon, {
      fontSize: "inherit"
    }),
    warning: /*#__PURE__*/jsxRuntime$1.jsx(ReportProblemOutlinedIcon, {
      fontSize: "inherit"
    }),
    error: /*#__PURE__*/jsxRuntime$1.jsx(ErrorOutlineIcon, {
      fontSize: "inherit"
    }),
    info: /*#__PURE__*/jsxRuntime$1.jsx(InfoOutlinedIcon, {
      fontSize: "inherit"
    })
  };
  var Alert$1 = /*#__PURE__*/React__namespace.forwardRef(function Alert(inProps, ref) {
    var props = useThemeProps({
      props: inProps,
      name: 'MuiAlert'
    });

    var action = props.action,
        children = props.children,
        className = props.className,
        _props$closeText = props.closeText,
        closeText = _props$closeText === void 0 ? 'Close' : _props$closeText,
        color = props.color,
        icon = props.icon,
        _props$iconMapping = props.iconMapping,
        iconMapping = _props$iconMapping === void 0 ? defaultIconMapping : _props$iconMapping,
        onClose = props.onClose,
        _props$role = props.role,
        role = _props$role === void 0 ? 'alert' : _props$role,
        _props$severity = props.severity,
        severity = _props$severity === void 0 ? 'success' : _props$severity,
        _props$variant4 = props.variant,
        variant = _props$variant4 === void 0 ? 'standard' : _props$variant4,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$1t);

    var ownerState = _extends$c({}, props, {
      color: color,
      severity: severity,
      variant: variant
    });

    var classes = useUtilityClasses$17(ownerState);
    return /*#__PURE__*/jsxRuntime$1.jsxs(AlertRoot, _extends$c({
      role: role,
      elevation: 0,
      ownerState: ownerState,
      className: clsx(classes.root, className),
      ref: ref
    }, other, {
      children: [icon !== false ? /*#__PURE__*/jsxRuntime$1.jsx(AlertIcon, {
        ownerState: ownerState,
        className: classes.icon,
        children: icon || iconMapping[severity] || defaultIconMapping[severity]
      }) : null, /*#__PURE__*/jsxRuntime$1.jsx(AlertMessage, {
        ownerState: ownerState,
        className: classes.message,
        children: children
      }), action != null ? /*#__PURE__*/jsxRuntime$1.jsx(AlertAction, {
        className: classes.action,
        children: action
      }) : null, action == null && onClose ? /*#__PURE__*/jsxRuntime$1.jsx(AlertAction, {
        ownerState: ownerState,
        className: classes.action,
        children: /*#__PURE__*/jsxRuntime$1.jsx(IconButton$2, {
          size: "small",
          "aria-label": closeText,
          title: closeText,
          color: "inherit",
          onClick: onClose,
          children: _CloseIcon || (_CloseIcon = /*#__PURE__*/jsxRuntime$1.jsx(ClearIcon, {
            fontSize: "small"
          }))
        })
      }) : null]
    }));
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var BaseAlert = Alert$1;

  function getTypographyUtilityClass(slot) {
    return generateUtilityClass('MuiTypography', slot);
  }

  generateUtilityClasses('MuiTypography', ['root', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'subtitle1', 'subtitle2', 'body1', 'body2', 'inherit', 'button', 'caption', 'overline', 'alignLeft', 'alignRight', 'alignCenter', 'alignJustify', 'noWrap', 'gutterBottom', 'paragraph']);
  var _excluded$1s = ["align", "className", "component", "gutterBottom", "noWrap", "paragraph", "variant", "variantMapping"];

  var useUtilityClasses$16 = function useUtilityClasses$16(ownerState) {
    var align = ownerState.align,
        gutterBottom = ownerState.gutterBottom,
        noWrap = ownerState.noWrap,
        paragraph = ownerState.paragraph,
        variant = ownerState.variant,
        classes = ownerState.classes;
    var slots = {
      root: ['root', variant, ownerState.align !== 'inherit' && "align".concat(capitalize$1(align)), gutterBottom && 'gutterBottom', noWrap && 'noWrap', paragraph && 'paragraph']
    };
    return composeClasses(slots, getTypographyUtilityClass, classes);
  };

  var TypographyRoot = styled$1('span', {
    name: 'MuiTypography',
    slot: 'Root',
    overridesResolver: function overridesResolver(props, styles) {
      var ownerState = props.ownerState;
      return [styles.root, ownerState.variant && styles[ownerState.variant], ownerState.align !== 'inherit' && styles["align".concat(capitalize$1(ownerState.align))], ownerState.noWrap && styles.noWrap, ownerState.gutterBottom && styles.gutterBottom, ownerState.paragraph && styles.paragraph];
    }
  })(function (_ref71) {
    var theme = _ref71.theme,
        ownerState = _ref71.ownerState;
    return _extends$c({
      margin: 0
    }, ownerState.variant && theme.typography[ownerState.variant], ownerState.align !== 'inherit' && {
      textAlign: ownerState.align
    }, ownerState.noWrap && {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    }, ownerState.gutterBottom && {
      marginBottom: '0.35em'
    }, ownerState.paragraph && {
      marginBottom: 16
    });
  });
  var defaultVariantMapping = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    subtitle1: 'h6',
    subtitle2: 'h6',
    body1: 'p',
    body2: 'p',
    inherit: 'p'
  }; // TODO v6: deprecate these color values in v5.x and remove the transformation in v6

  var colorTransformations$1 = {
    primary: 'primary.main',
    textPrimary: 'text.primary',
    secondary: 'secondary.main',
    textSecondary: 'text.secondary',
    error: 'error.main'
  };

  var transformDeprecatedColors$1 = function transformDeprecatedColors$1(color) {
    return colorTransformations$1[color] || color;
  };

  var Typography$1 = /*#__PURE__*/React__namespace.forwardRef(function Typography(inProps, ref) {
    var themeProps = useThemeProps({
      props: inProps,
      name: 'MuiTypography'
    });
    var color = transformDeprecatedColors$1(themeProps.color);
    var props = extendSxProp(_extends$c({}, themeProps, {
      color: color
    }));

    var _props$align = props.align,
        align = _props$align === void 0 ? 'inherit' : _props$align,
        className = props.className,
        component = props.component,
        _props$gutterBottom = props.gutterBottom,
        gutterBottom = _props$gutterBottom === void 0 ? false : _props$gutterBottom,
        _props$noWrap = props.noWrap,
        noWrap = _props$noWrap === void 0 ? false : _props$noWrap,
        _props$paragraph = props.paragraph,
        paragraph = _props$paragraph === void 0 ? false : _props$paragraph,
        _props$variant5 = props.variant,
        variant = _props$variant5 === void 0 ? 'body1' : _props$variant5,
        _props$variantMapping = props.variantMapping,
        variantMapping = _props$variantMapping === void 0 ? defaultVariantMapping : _props$variantMapping,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$1s);

    var ownerState = _extends$c({}, props, {
      align: align,
      color: color,
      className: className,
      component: component,
      gutterBottom: gutterBottom,
      noWrap: noWrap,
      paragraph: paragraph,
      variant: variant,
      variantMapping: variantMapping
    });

    var Component = component || (paragraph ? 'p' : variantMapping[variant] || defaultVariantMapping[variant]) || 'span';
    var classes = useUtilityClasses$16(ownerState);
    return /*#__PURE__*/jsxRuntime$1.jsx(TypographyRoot, _extends$c({
      as: Component,
      ref: ref,
      ownerState: ownerState,
      className: clsx(classes.root, className)
    }, other));
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var Typography$2 = Typography$1;

  function getAppBarUtilityClass(slot) {
    return generateUtilityClass('MuiAppBar', slot);
  }

  generateUtilityClasses('MuiAppBar', ['root', 'positionFixed', 'positionAbsolute', 'positionSticky', 'positionStatic', 'positionRelative', 'colorDefault', 'colorPrimary', 'colorSecondary', 'colorInherit', 'colorTransparent']);
  var _excluded$1r = ["className", "color", "enableColorOnDark", "position"];

  var useUtilityClasses$15 = function useUtilityClasses$15(ownerState) {
    var color = ownerState.color,
        position = ownerState.position,
        classes = ownerState.classes;
    var slots = {
      root: ['root', "color".concat(capitalize$1(color)), "position".concat(capitalize$1(position))]
    };
    return composeClasses(slots, getAppBarUtilityClass, classes);
  };

  var AppBarRoot = styled$1(BasePaper, {
    name: 'MuiAppBar',
    slot: 'Root',
    overridesResolver: function overridesResolver(props, styles) {
      var ownerState = props.ownerState;
      return [styles.root, styles["position".concat(capitalize$1(ownerState.position))], styles["color".concat(capitalize$1(ownerState.color))]];
    }
  })(function (_ref72) {
    var theme = _ref72.theme,
        ownerState = _ref72.ownerState;
    var backgroundColorDefault = theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[900];
    return _extends$c({
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      boxSizing: 'border-box',
      // Prevent padding issue with the Modal and fixed positioned AppBar.
      flexShrink: 0
    }, ownerState.position === 'fixed' && {
      position: 'fixed',
      zIndex: theme.zIndex.appBar,
      top: 0,
      left: 'auto',
      right: 0,
      '@media print': {
        // Prevent the app bar to be visible on each printed page.
        position: 'absolute'
      }
    }, ownerState.position === 'absolute' && {
      position: 'absolute',
      zIndex: theme.zIndex.appBar,
      top: 0,
      left: 'auto',
      right: 0
    }, ownerState.position === 'sticky' && {
      // ⚠️ sticky is not supported by IE11.
      position: 'sticky',
      zIndex: theme.zIndex.appBar,
      top: 0,
      left: 'auto',
      right: 0
    }, ownerState.position === 'static' && {
      position: 'static'
    }, ownerState.position === 'relative' && {
      position: 'relative'
    }, ownerState.color === 'default' && {
      backgroundColor: backgroundColorDefault,
      color: theme.palette.getContrastText(backgroundColorDefault)
    }, ownerState.color && ownerState.color !== 'default' && ownerState.color !== 'inherit' && ownerState.color !== 'transparent' && {
      backgroundColor: theme.palette[ownerState.color].main,
      color: theme.palette[ownerState.color].contrastText
    }, ownerState.color === 'inherit' && {
      color: 'inherit'
    }, theme.palette.mode === 'dark' && !ownerState.enableColorOnDark && {
      backgroundColor: null,
      color: null
    }, ownerState.color === 'transparent' && _extends$c({
      backgroundColor: 'transparent',
      color: 'inherit'
    }, theme.palette.mode === 'dark' && {
      backgroundImage: 'none'
    }));
  });
  var AppBar$1 = /*#__PURE__*/React__namespace.forwardRef(function AppBar(inProps, ref) {
    var props = useThemeProps({
      props: inProps,
      name: 'MuiAppBar'
    });

    var className = props.className,
        _props$color4 = props.color,
        color = _props$color4 === void 0 ? 'primary' : _props$color4,
        _props$enableColorOnD = props.enableColorOnDark,
        enableColorOnDark = _props$enableColorOnD === void 0 ? false : _props$enableColorOnD,
        _props$position = props.position,
        position = _props$position === void 0 ? 'fixed' : _props$position,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$1r);

    var ownerState = _extends$c({}, props, {
      color: color,
      position: position,
      enableColorOnDark: enableColorOnDark
    });

    var classes = useUtilityClasses$15(ownerState);
    return /*#__PURE__*/jsxRuntime$1.jsx(AppBarRoot, _extends$c({
      square: true,
      component: "header",
      ownerState: ownerState,
      elevation: 4,
      className: clsx(classes.root, className, position === 'fixed' && 'mui-fixed'),
      ref: ref
    }, other));
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var BaseAppBar = AppBar$1;
  /**
   *
   * Demos:
   *
   * - [Autocomplete](https://mui.com/components/autocomplete/)
   * - [Menus](https://mui.com/components/menus/)
   * - [Popper](https://mui.com/components/popper/)
   *
   * API:
   *
   * - [Popper API](https://mui.com/api/popper/)
   */

  var Popper$1 = /*#__PURE__*/React__namespace.forwardRef(function Popper(props, ref) {
    var theme = useTheme$2();
    return /*#__PURE__*/jsxRuntime$1.jsx(PopperUnstyled$1, _extends$c({
      direction: theme == null ? void 0 : theme.direction
    }, props, {
      ref: ref
    }));
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var BasePopper = Popper$1;

  function getListSubheaderUtilityClass(slot) {
    return generateUtilityClass('MuiListSubheader', slot);
  }

  generateUtilityClasses('MuiListSubheader', ['root', 'colorPrimary', 'colorInherit', 'gutters', 'inset', 'sticky']);
  var _excluded$1q = ["className", "color", "component", "disableGutters", "disableSticky", "inset"];

  var useUtilityClasses$14 = function useUtilityClasses$14(ownerState) {
    var classes = ownerState.classes,
        color = ownerState.color,
        disableGutters = ownerState.disableGutters,
        inset = ownerState.inset,
        disableSticky = ownerState.disableSticky;
    var slots = {
      root: ['root', color !== 'default' && "color".concat(capitalize$1(color)), !disableGutters && 'gutters', inset && 'inset', !disableSticky && 'sticky']
    };
    return composeClasses(slots, getListSubheaderUtilityClass, classes);
  };

  var ListSubheaderRoot = styled$1('li', {
    name: 'MuiListSubheader',
    slot: 'Root',
    overridesResolver: function overridesResolver(props, styles) {
      var ownerState = props.ownerState;
      return [styles.root, ownerState.color !== 'default' && styles["color".concat(capitalize$1(ownerState.color))], !ownerState.disableGutters && styles.gutters, ownerState.inset && styles.inset, !ownerState.disableSticky && styles.sticky];
    }
  })(function (_ref73) {
    var theme = _ref73.theme,
        ownerState = _ref73.ownerState;
    return _extends$c({
      boxSizing: 'border-box',
      lineHeight: '48px',
      listStyle: 'none',
      color: theme.palette.text.secondary,
      fontFamily: theme.typography.fontFamily,
      fontWeight: theme.typography.fontWeightMedium,
      fontSize: theme.typography.pxToRem(14)
    }, ownerState.color === 'primary' && {
      color: theme.palette.primary.main
    }, ownerState.color === 'inherit' && {
      color: 'inherit'
    }, !ownerState.disableGutters && {
      paddingLeft: 16,
      paddingRight: 16
    }, ownerState.inset && {
      paddingLeft: 72
    }, !ownerState.disableSticky && {
      position: 'sticky',
      top: 0,
      zIndex: 1,
      backgroundColor: theme.palette.background.paper
    });
  });
  var ListSubheader = /*#__PURE__*/React__namespace.forwardRef(function ListSubheader(inProps, ref) {
    var props = useThemeProps({
      props: inProps,
      name: 'MuiListSubheader'
    });

    var className = props.className,
        _props$color5 = props.color,
        color = _props$color5 === void 0 ? 'default' : _props$color5,
        _props$component7 = props.component,
        component = _props$component7 === void 0 ? 'li' : _props$component7,
        _props$disableGutters2 = props.disableGutters,
        disableGutters = _props$disableGutters2 === void 0 ? false : _props$disableGutters2,
        _props$disableSticky = props.disableSticky,
        disableSticky = _props$disableSticky === void 0 ? false : _props$disableSticky,
        _props$inset = props.inset,
        inset = _props$inset === void 0 ? false : _props$inset,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$1q);

    var ownerState = _extends$c({}, props, {
      color: color,
      component: component,
      disableGutters: disableGutters,
      disableSticky: disableSticky,
      inset: inset
    });

    var classes = useUtilityClasses$14(ownerState);
    return /*#__PURE__*/jsxRuntime$1.jsx(ListSubheaderRoot, _extends$c({
      as: component,
      className: clsx(classes.root, className),
      ref: ref,
      ownerState: ownerState
    }, other));
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var ListSubheader$1 = ListSubheader;

  function getInputUtilityClass(slot) {
    return generateUtilityClass('MuiInput', slot);
  }

  var inputClasses = generateUtilityClasses('MuiInput', ['root', 'formControl', 'focused', 'disabled', 'colorSecondary', 'underline', 'error', 'sizeSmall', 'multiline', 'fullWidth', 'input', 'inputSizeSmall', 'inputMultiline', 'inputTypeSearch']);
  var inputClasses$1 = inputClasses;

  function getInputBaseUtilityClass(slot) {
    return generateUtilityClass('MuiInputBase', slot);
  }

  var inputBaseClasses = generateUtilityClasses('MuiInputBase', ['root', 'formControl', 'focused', 'disabled', 'adornedStart', 'adornedEnd', 'error', 'sizeSmall', 'multiline', 'colorSecondary', 'fullWidth', 'hiddenLabel', 'input', 'inputSizeSmall', 'inputMultiline', 'inputTypeSearch', 'inputAdornedStart', 'inputAdornedEnd', 'inputHiddenLabel']);
  var inputBaseClasses$1 = inputBaseClasses;

  function getOutlinedInputUtilityClass(slot) {
    return generateUtilityClass('MuiOutlinedInput', slot);
  }

  var outlinedInputClasses = generateUtilityClasses('MuiOutlinedInput', ['root', 'colorSecondary', 'focused', 'disabled', 'adornedStart', 'adornedEnd', 'error', 'sizeSmall', 'multiline', 'notchedOutline', 'input', 'inputSizeSmall', 'inputMultiline', 'inputAdornedStart', 'inputAdornedEnd']);
  var outlinedInputClasses$1 = outlinedInputClasses;

  function getFilledInputUtilityClass(slot) {
    return generateUtilityClass('MuiFilledInput', slot);
  }

  var filledInputClasses = generateUtilityClasses('MuiFilledInput', ['root', 'colorSecondary', 'underline', 'focused', 'disabled', 'adornedStart', 'adornedEnd', 'error', 'sizeSmall', 'multiline', 'hiddenLabel', 'input', 'inputSizeSmall', 'inputHiddenLabel', 'inputMultiline', 'inputAdornedStart', 'inputAdornedEnd']);
  var filledInputClasses$1 = filledInputClasses;
  var ArrowDropDownIcon$1 = createSvgIcon$1( /*#__PURE__*/jsxRuntime$1.jsx("path", {
    d: "M7 10l5 5 5-5z"
  }), 'ArrowDropDown');

  function getAutocompleteUtilityClass(slot) {
    return generateUtilityClass('MuiAutocomplete', slot);
  }

  var autocompleteClasses = generateUtilityClasses('MuiAutocomplete', ['root', 'fullWidth', 'focused', 'focusVisible', 'tag', 'tagSizeSmall', 'tagSizeMedium', 'hasPopupIcon', 'hasClearIcon', 'inputRoot', 'input', 'inputFocused', 'endAdornment', 'clearIndicator', 'popupIndicator', 'popupIndicatorOpen', 'popper', 'popperDisablePortal', 'paper', 'listbox', 'loading', 'noOptions', 'option', 'groupLabel', 'groupUl']);
  var autocompleteClasses$1 = autocompleteClasses;

  var _ClearIcon, _ArrowDropDownIcon;

  var _excluded$1p = ["autoComplete", "autoHighlight", "autoSelect", "blurOnSelect", "ChipProps", "className", "clearIcon", "clearOnBlur", "clearOnEscape", "clearText", "closeText", "componentsProps", "defaultValue", "disableClearable", "disableCloseOnSelect", "disabled", "disabledItemsFocusable", "disableListWrap", "disablePortal", "filterOptions", "filterSelectedOptions", "forcePopupIcon", "freeSolo", "fullWidth", "getLimitTagsText", "getOptionDisabled", "getOptionLabel", "isOptionEqualToValue", "groupBy", "handleHomeEndKeys", "id", "includeInputInList", "inputValue", "limitTags", "ListboxComponent", "ListboxProps", "loading", "loadingText", "multiple", "noOptionsText", "onChange", "onClose", "onHighlightChange", "onInputChange", "onOpen", "open", "openOnFocus", "openText", "options", "PaperComponent", "PopperComponent", "popupIcon", "renderGroup", "renderInput", "renderOption", "renderTags", "selectOnFocus", "size", "value"];

  var useUtilityClasses$13 = function useUtilityClasses$13(ownerState) {
    var classes = ownerState.classes,
        disablePortal = ownerState.disablePortal,
        focused = ownerState.focused,
        fullWidth = ownerState.fullWidth,
        hasClearIcon = ownerState.hasClearIcon,
        hasPopupIcon = ownerState.hasPopupIcon,
        inputFocused = ownerState.inputFocused,
        popupOpen = ownerState.popupOpen,
        size = ownerState.size;
    var slots = {
      root: ['root', focused && 'focused', fullWidth && 'fullWidth', hasClearIcon && 'hasClearIcon', hasPopupIcon && 'hasPopupIcon'],
      inputRoot: ['inputRoot'],
      input: ['input', inputFocused && 'inputFocused'],
      tag: ['tag', "tagSize".concat(capitalize$1(size))],
      endAdornment: ['endAdornment'],
      clearIndicator: ['clearIndicator'],
      popupIndicator: ['popupIndicator', popupOpen && 'popupIndicatorOpen'],
      popper: ['popper', disablePortal && 'popperDisablePortal'],
      paper: ['paper'],
      listbox: ['listbox'],
      loading: ['loading'],
      noOptions: ['noOptions'],
      option: ['option'],
      groupLabel: ['groupLabel'],
      groupUl: ['groupUl']
    };
    return composeClasses(slots, getAutocompleteUtilityClass, classes);
  };

  var AutocompleteRoot = styled$1('div', {
    name: 'MuiAutocomplete',
    slot: 'Root',
    overridesResolver: function overridesResolver(props, styles) {
      var ownerState = props.ownerState;
      var fullWidth = ownerState.fullWidth,
          hasClearIcon = ownerState.hasClearIcon,
          hasPopupIcon = ownerState.hasPopupIcon,
          inputFocused = ownerState.inputFocused,
          size = ownerState.size;
      return [_defineProperty({}, "& .".concat(autocompleteClasses$1.tag), styles.tag), _defineProperty({}, "& .".concat(autocompleteClasses$1.tag), styles["tagSize".concat(capitalize$1(size))]), _defineProperty({}, "& .".concat(autocompleteClasses$1.inputRoot), styles.inputRoot), _defineProperty({}, "& .".concat(autocompleteClasses$1.input), styles.input), _defineProperty({}, "& .".concat(autocompleteClasses$1.input), inputFocused && styles.inputFocused), styles.root, fullWidth && styles.fullWidth, hasPopupIcon && styles.hasPopupIcon, hasClearIcon && styles.hasClearIcon];
    }
  })(function (_ref79) {
    var _extends$c6, _$concat, _$concat2, _$concat3, _extends$c7;

    var ownerState = _ref79.ownerState;
    return _extends$c((_extends$c6 = {}, _defineProperty(_extends$c6, "&.".concat(autocompleteClasses$1.focused, " .").concat(autocompleteClasses$1.clearIndicator), {
      visibility: 'visible'
    }), _defineProperty(_extends$c6, '@media (pointer: fine)', _defineProperty({}, "&:hover .".concat(autocompleteClasses$1.clearIndicator), {
      visibility: 'visible'
    })), _extends$c6), ownerState.fullWidth && {
      width: '100%'
    }, (_extends$c7 = {}, _defineProperty(_extends$c7, "& .".concat(autocompleteClasses$1.tag), _extends$c({
      margin: 3,
      maxWidth: 'calc(100% - 6px)'
    }, ownerState.size === 'small' && {
      margin: 2,
      maxWidth: 'calc(100% - 4px)'
    })), _defineProperty(_extends$c7, "& .".concat(autocompleteClasses$1.inputRoot), (_$concat = {
      flexWrap: 'wrap'
    }, _defineProperty(_$concat, ".".concat(autocompleteClasses$1.hasPopupIcon, "&, .").concat(autocompleteClasses$1.hasClearIcon, "&"), {
      paddingRight: 26 + 4
    }), _defineProperty(_$concat, ".".concat(autocompleteClasses$1.hasPopupIcon, ".").concat(autocompleteClasses$1.hasClearIcon, "&"), {
      paddingRight: 52 + 4
    }), _defineProperty(_$concat, "& .".concat(autocompleteClasses$1.input), {
      width: 0,
      minWidth: 30
    }), _$concat)), _defineProperty(_extends$c7, "& .".concat(inputClasses$1.root), {
      paddingBottom: 1,
      '& .MuiInput-input': {
        padding: '4px 4px 4px 0px'
      }
    }), _defineProperty(_extends$c7, "& .".concat(inputClasses$1.root, ".").concat(inputBaseClasses$1.sizeSmall), _defineProperty({}, "& .".concat(inputClasses$1.input), {
      padding: '2px 4px 3px 0'
    })), _defineProperty(_extends$c7, "& .".concat(outlinedInputClasses$1.root), (_$concat2 = {
      padding: 9
    }, _defineProperty(_$concat2, ".".concat(autocompleteClasses$1.hasPopupIcon, "&, .").concat(autocompleteClasses$1.hasClearIcon, "&"), {
      paddingRight: 26 + 4 + 9
    }), _defineProperty(_$concat2, ".".concat(autocompleteClasses$1.hasPopupIcon, ".").concat(autocompleteClasses$1.hasClearIcon, "&"), {
      paddingRight: 52 + 4 + 9
    }), _defineProperty(_$concat2, "& .".concat(autocompleteClasses$1.input), {
      padding: '7.5px 4px 7.5px 6px'
    }), _defineProperty(_$concat2, "& .".concat(autocompleteClasses$1.endAdornment), {
      right: 9
    }), _$concat2)), _defineProperty(_extends$c7, "& .".concat(outlinedInputClasses$1.root, ".").concat(inputBaseClasses$1.sizeSmall), _defineProperty({
      padding: 6
    }, "& .".concat(autocompleteClasses$1.input), {
      padding: '2.5px 4px 2.5px 6px'
    })), _defineProperty(_extends$c7, "& .".concat(filledInputClasses$1.root), (_$concat3 = {
      paddingTop: 19,
      paddingLeft: 8
    }, _defineProperty(_$concat3, ".".concat(autocompleteClasses$1.hasPopupIcon, "&, .").concat(autocompleteClasses$1.hasClearIcon, "&"), {
      paddingRight: 26 + 4 + 9
    }), _defineProperty(_$concat3, ".".concat(autocompleteClasses$1.hasPopupIcon, ".").concat(autocompleteClasses$1.hasClearIcon, "&"), {
      paddingRight: 52 + 4 + 9
    }), _defineProperty(_$concat3, "& .".concat(filledInputClasses$1.input), {
      padding: '7px 4px'
    }), _defineProperty(_$concat3, "& .".concat(autocompleteClasses$1.endAdornment), {
      right: 9
    }), _$concat3)), _defineProperty(_extends$c7, "& .".concat(filledInputClasses$1.root, ".").concat(inputBaseClasses$1.sizeSmall), _defineProperty({
      paddingBottom: 1
    }, "& .".concat(filledInputClasses$1.input), {
      padding: '2.5px 4px'
    })), _defineProperty(_extends$c7, "& .".concat(inputBaseClasses$1.hiddenLabel), {
      paddingTop: 8
    }), _defineProperty(_extends$c7, "& .".concat(autocompleteClasses$1.input), _extends$c({
      flexGrow: 1,
      textOverflow: 'ellipsis',
      opacity: 0
    }, ownerState.inputFocused && {
      opacity: 1
    })), _extends$c7));
  });
  var AutocompleteEndAdornment = styled$1('div', {
    name: 'MuiAutocomplete',
    slot: 'EndAdornment',
    overridesResolver: function overridesResolver(props, styles) {
      return styles.endAdornment;
    }
  })({
    // We use a position absolute to support wrapping tags.
    position: 'absolute',
    right: 0,
    top: 'calc(50% - 14px)' // Center vertically

  });
  var AutocompleteClearIndicator = styled$1(IconButton$2, {
    name: 'MuiAutocomplete',
    slot: 'ClearIndicator',
    overridesResolver: function overridesResolver(props, styles) {
      return styles.clearIndicator;
    }
  })({
    marginRight: -2,
    padding: 4,
    visibility: 'hidden'
  });
  var AutocompletePopupIndicator = styled$1(IconButton$2, {
    name: 'MuiAutocomplete',
    slot: 'PopupIndicator',
    overridesResolver: function overridesResolver(_ref80, styles) {
      var ownerState = _ref80.ownerState;
      return _extends$c({}, styles.popupIndicator, ownerState.popupOpen && styles.popupIndicatorOpen);
    }
  })(function (_ref81) {
    var ownerState = _ref81.ownerState;
    return _extends$c({
      padding: 2,
      marginRight: -2
    }, ownerState.popupOpen && {
      transform: 'rotate(180deg)'
    });
  });
  var AutocompletePopper = styled$1(BasePopper, {
    name: 'MuiAutocomplete',
    slot: 'Popper',
    overridesResolver: function overridesResolver(props, styles) {
      var ownerState = props.ownerState;
      return [_defineProperty({}, "& .".concat(autocompleteClasses$1.option), styles.option), styles.popper, ownerState.disablePortal && styles.popperDisablePortal];
    }
  })(function (_ref83) {
    var theme = _ref83.theme,
        ownerState = _ref83.ownerState;
    return _extends$c({
      zIndex: theme.zIndex.modal
    }, ownerState.disablePortal && {
      position: 'absolute'
    });
  });
  var AutocompletePaper = styled$1(BasePaper, {
    name: 'MuiAutocomplete',
    slot: 'Paper',
    overridesResolver: function overridesResolver(props, styles) {
      return styles.paper;
    }
  })(function (_ref84) {
    var theme = _ref84.theme;
    return _extends$c({}, theme.typography.body1, {
      overflow: 'auto'
    });
  });
  var AutocompleteLoading = styled$1('div', {
    name: 'MuiAutocomplete',
    slot: 'Loading',
    overridesResolver: function overridesResolver(props, styles) {
      return styles.loading;
    }
  })(function (_ref85) {
    var theme = _ref85.theme;
    return {
      color: theme.palette.text.secondary,
      padding: '14px 16px'
    };
  });
  var AutocompleteNoOptions = styled$1('div', {
    name: 'MuiAutocomplete',
    slot: 'NoOptions',
    overridesResolver: function overridesResolver(props, styles) {
      return styles.noOptions;
    }
  })(function (_ref86) {
    var theme = _ref86.theme;
    return {
      color: theme.palette.text.secondary,
      padding: '14px 16px'
    };
  });
  var AutocompleteListbox = styled$1('div', {
    name: 'MuiAutocomplete',
    slot: 'Listbox',
    overridesResolver: function overridesResolver(props, styles) {
      return styles.listbox;
    }
  })(function (_ref87) {
    var _ariaSelectedTru, _$concat4;

    var theme = _ref87.theme;
    return _defineProperty({
      listStyle: 'none',
      margin: 0,
      padding: '8px 0',
      maxHeight: '40vh',
      overflow: 'auto'
    }, "& .".concat(autocompleteClasses$1.option), (_$concat4 = {
      minHeight: 48,
      display: 'flex',
      overflow: 'hidden',
      justifyContent: 'flex-start',
      alignItems: 'center',
      cursor: 'pointer',
      paddingTop: 6,
      boxSizing: 'border-box',
      outline: '0',
      WebkitTapHighlightColor: 'transparent',
      paddingBottom: 6,
      paddingLeft: 16,
      paddingRight: 16
    }, _defineProperty(_$concat4, theme.breakpoints.up('sm'), {
      minHeight: 'auto'
    }), _defineProperty(_$concat4, "&.".concat(autocompleteClasses$1.focused), {
      backgroundColor: theme.palette.action.hover,
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        backgroundColor: 'transparent'
      }
    }), _defineProperty(_$concat4, '&[aria-disabled="true"]', {
      opacity: theme.palette.action.disabledOpacity,
      pointerEvents: 'none'
    }), _defineProperty(_$concat4, "&.".concat(autocompleteClasses$1.focusVisible), {
      backgroundColor: theme.palette.action.focus
    }), _defineProperty(_$concat4, '&[aria-selected="true"]', (_ariaSelectedTru = {
      backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity)
    }, _defineProperty(_ariaSelectedTru, "&.".concat(autocompleteClasses$1.focused), {
      backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        backgroundColor: theme.palette.action.selected
      }
    }), _defineProperty(_ariaSelectedTru, "&.".concat(autocompleteClasses$1.focusVisible), {
      backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
    }), _ariaSelectedTru)), _$concat4));
  });
  var AutocompleteGroupLabel = styled$1(ListSubheader$1, {
    name: 'MuiAutocomplete',
    slot: 'GroupLabel',
    overridesResolver: function overridesResolver(props, styles) {
      return styles.groupLabel;
    }
  })(function (_ref89) {
    var theme = _ref89.theme;
    return {
      backgroundColor: theme.palette.background.paper,
      top: -8
    };
  });
  var AutocompleteGroupUl = styled$1('ul', {
    name: 'MuiAutocomplete',
    slot: 'GroupUl',
    overridesResolver: function overridesResolver(props, styles) {
      return styles.groupUl;
    }
  })(_defineProperty({
    padding: 0
  }, "& .".concat(autocompleteClasses$1.option), {
    paddingLeft: 24
  }));
  var Autocomplete$1 = /*#__PURE__*/React__namespace.forwardRef(function Autocomplete(inProps, ref) {
    var _componentsProps$clea;

    var props = useThemeProps({
      props: inProps,
      name: 'MuiAutocomplete'
    });
    /* eslint-disable @typescript-eslint/no-unused-vars */

    var _props$autoComplete2 = props.autoComplete,
        autoComplete = _props$autoComplete2 === void 0 ? false : _props$autoComplete2,
        _props$autoHighlight2 = props.autoHighlight,
        autoHighlight = _props$autoHighlight2 === void 0 ? false : _props$autoHighlight2,
        _props$autoSelect2 = props.autoSelect,
        autoSelect = _props$autoSelect2 === void 0 ? false : _props$autoSelect2,
        _props$blurOnSelect2 = props.blurOnSelect,
        blurOnSelect = _props$blurOnSelect2 === void 0 ? false : _props$blurOnSelect2,
        ChipProps = props.ChipProps,
        className = props.className,
        _props$clearIcon = props.clearIcon,
        clearIcon = _props$clearIcon === void 0 ? _ClearIcon || (_ClearIcon = /*#__PURE__*/jsxRuntime$1.jsx(ClearIcon, {
      fontSize: "small"
    })) : _props$clearIcon,
        _props$clearOnBlur2 = props.clearOnBlur,
        clearOnBlur = _props$clearOnBlur2 === void 0 ? !props.freeSolo : _props$clearOnBlur2,
        _props$clearOnEscape2 = props.clearOnEscape,
        clearOnEscape = _props$clearOnEscape2 === void 0 ? false : _props$clearOnEscape2,
        _props$clearText = props.clearText,
        clearText = _props$clearText === void 0 ? 'Clear' : _props$clearText,
        _props$closeText2 = props.closeText,
        closeText = _props$closeText2 === void 0 ? 'Close' : _props$closeText2,
        _props$componentsProp4 = props.componentsProps,
        componentsProps = _props$componentsProp4 === void 0 ? {} : _props$componentsProp4,
        _props$defaultValue2 = props.defaultValue,
        defaultValue = _props$defaultValue2 === void 0 ? props.multiple ? [] : null : _props$defaultValue2,
        _props$disableClearab2 = props.disableClearable,
        disableClearable = _props$disableClearab2 === void 0 ? false : _props$disableClearab2,
        _props$disableCloseOn2 = props.disableCloseOnSelect,
        disableCloseOnSelect = _props$disableCloseOn2 === void 0 ? false : _props$disableCloseOn2,
        _props$disabled5 = props.disabled,
        disabled = _props$disabled5 === void 0 ? false : _props$disabled5,
        _props$disabledItemsF2 = props.disabledItemsFocusable,
        disabledItemsFocusable = _props$disabledItemsF2 === void 0 ? false : _props$disabledItemsF2,
        _props$disableListWra2 = props.disableListWrap,
        disableListWrap = _props$disableListWra2 === void 0 ? false : _props$disableListWra2,
        _props$disablePortal4 = props.disablePortal,
        disablePortal = _props$disablePortal4 === void 0 ? false : _props$disablePortal4,
        _props$filterSelected2 = props.filterSelectedOptions,
        filterSelectedOptions = _props$filterSelected2 === void 0 ? false : _props$filterSelected2,
        _props$forcePopupIcon = props.forcePopupIcon,
        forcePopupIcon = _props$forcePopupIcon === void 0 ? 'auto' : _props$forcePopupIcon,
        _props$freeSolo2 = props.freeSolo,
        freeSolo = _props$freeSolo2 === void 0 ? false : _props$freeSolo2,
        _props$fullWidth = props.fullWidth,
        fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
        _props$getLimitTagsTe = props.getLimitTagsText,
        getLimitTagsText = _props$getLimitTagsTe === void 0 ? function (more) {
      return "+".concat(more);
    } : _props$getLimitTagsTe,
        _props$getOptionLabel2 = props.getOptionLabel,
        getOptionLabel = _props$getOptionLabel2 === void 0 ? function (option) {
      var _option$label;

      return (_option$label = option.label) != null ? _option$label : option;
    } : _props$getOptionLabel2,
        groupBy = props.groupBy,
        _props$handleHomeEndK2 = props.handleHomeEndKeys,
        handleHomeEndKeys = _props$handleHomeEndK2 === void 0 ? !props.freeSolo : _props$handleHomeEndK2,
        _props$includeInputIn2 = props.includeInputInList,
        includeInputInList = _props$includeInputIn2 === void 0 ? false : _props$includeInputIn2,
        _props$limitTags = props.limitTags,
        limitTags = _props$limitTags === void 0 ? -1 : _props$limitTags,
        _props$ListboxCompone = props.ListboxComponent,
        ListboxComponent = _props$ListboxCompone === void 0 ? 'ul' : _props$ListboxCompone,
        ListboxProps = props.ListboxProps,
        _props$loading = props.loading,
        loading = _props$loading === void 0 ? false : _props$loading,
        _props$loadingText = props.loadingText,
        loadingText = _props$loadingText === void 0 ? 'Loading…' : _props$loadingText,
        _props$multiple2 = props.multiple,
        multiple = _props$multiple2 === void 0 ? false : _props$multiple2,
        _props$noOptionsText = props.noOptionsText,
        noOptionsText = _props$noOptionsText === void 0 ? 'No options' : _props$noOptionsText,
        _props$openOnFocus2 = props.openOnFocus,
        openOnFocus = _props$openOnFocus2 === void 0 ? false : _props$openOnFocus2,
        _props$openText = props.openText,
        openText = _props$openText === void 0 ? 'Open' : _props$openText,
        _props$PaperComponent = props.PaperComponent,
        PaperComponent = _props$PaperComponent === void 0 ? BasePaper : _props$PaperComponent,
        _props$PopperComponen = props.PopperComponent,
        PopperComponent = _props$PopperComponen === void 0 ? BasePopper : _props$PopperComponen,
        _props$popupIcon = props.popupIcon,
        popupIcon = _props$popupIcon === void 0 ? _ArrowDropDownIcon || (_ArrowDropDownIcon = /*#__PURE__*/jsxRuntime$1.jsx(ArrowDropDownIcon$1, {})) : _props$popupIcon,
        renderGroupProp = props.renderGroup,
        renderInput = props.renderInput,
        renderOptionProp = props.renderOption,
        renderTags = props.renderTags,
        _props$selectOnFocus2 = props.selectOnFocus,
        selectOnFocus = _props$selectOnFocus2 === void 0 ? !props.freeSolo : _props$selectOnFocus2,
        _props$size3 = props.size,
        size = _props$size3 === void 0 ? 'medium' : _props$size3,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$1p);
    /* eslint-enable @typescript-eslint/no-unused-vars */


    var _useAutocomplete = useAutocomplete(_extends$c({}, props, {
      componentName: 'Autocomplete'
    })),
        getRootProps = _useAutocomplete.getRootProps,
        getInputProps = _useAutocomplete.getInputProps,
        getInputLabelProps = _useAutocomplete.getInputLabelProps,
        getPopupIndicatorProps = _useAutocomplete.getPopupIndicatorProps,
        getClearProps = _useAutocomplete.getClearProps,
        getTagProps = _useAutocomplete.getTagProps,
        getListboxProps = _useAutocomplete.getListboxProps,
        getOptionProps = _useAutocomplete.getOptionProps,
        value = _useAutocomplete.value,
        dirty = _useAutocomplete.dirty,
        id = _useAutocomplete.id,
        popupOpen = _useAutocomplete.popupOpen,
        focused = _useAutocomplete.focused,
        focusedTag = _useAutocomplete.focusedTag,
        anchorEl = _useAutocomplete.anchorEl,
        setAnchorEl = _useAutocomplete.setAnchorEl,
        inputValue = _useAutocomplete.inputValue,
        groupedOptions = _useAutocomplete.groupedOptions;

    var hasClearIcon = !disableClearable && !disabled && dirty;
    var hasPopupIcon = (!freeSolo || forcePopupIcon === true) && forcePopupIcon !== false;

    var ownerState = _extends$c({}, props, {
      disablePortal: disablePortal,
      focused: focused,
      fullWidth: fullWidth,
      hasClearIcon: hasClearIcon,
      hasPopupIcon: hasPopupIcon,
      inputFocused: focusedTag === -1,
      popupOpen: popupOpen,
      size: size
    });

    var classes = useUtilityClasses$13(ownerState);
    var startAdornment;

    if (multiple && value.length > 0) {
      var getCustomizedTagProps = function getCustomizedTagProps(params) {
        return _extends$c({
          className: clsx(classes.tag),
          disabled: disabled
        }, getTagProps(params));
      };

      if (renderTags) {
        startAdornment = renderTags(value, getCustomizedTagProps);
      } else {
        startAdornment = value.map(function (option, index) {
          return /*#__PURE__*/jsxRuntime$1.jsx(Chip$2, _extends$c({
            label: getOptionLabel(option),
            size: size
          }, getCustomizedTagProps({
            index: index
          }), ChipProps));
        });
      }
    }

    if (limitTags > -1 && Array.isArray(startAdornment)) {
      var more = startAdornment.length - limitTags;

      if (!focused && more > 0) {
        startAdornment = startAdornment.splice(0, limitTags);
        startAdornment.push( /*#__PURE__*/jsxRuntime$1.jsx("span", {
          className: classes.tag,
          children: getLimitTagsText(more)
        }, startAdornment.length));
      }
    }

    var defaultRenderGroup = function defaultRenderGroup(params) {
      return /*#__PURE__*/jsxRuntime$1.jsxs("li", {
        children: [/*#__PURE__*/jsxRuntime$1.jsx(AutocompleteGroupLabel, {
          className: classes.groupLabel,
          ownerState: ownerState,
          component: "div",
          children: params.group
        }), /*#__PURE__*/jsxRuntime$1.jsx(AutocompleteGroupUl, {
          className: classes.groupUl,
          ownerState: ownerState,
          children: params.children
        })]
      }, params.key);
    };

    var renderGroup = renderGroupProp || defaultRenderGroup;

    var defaultRenderOption = function defaultRenderOption(props2, option) {
      return /*#__PURE__*/jsxRuntime$1.jsx("li", _extends$c({}, props2, {
        children: getOptionLabel(option)
      }));
    };

    var renderOption = renderOptionProp || defaultRenderOption;

    var renderListOption = function renderListOption(option, index) {
      var optionProps = getOptionProps({
        option: option,
        index: index
      });
      return renderOption(_extends$c({}, optionProps, {
        className: classes.option
      }), option, {
        selected: optionProps['aria-selected'],
        inputValue: inputValue
      });
    };

    return /*#__PURE__*/jsxRuntime$1.jsxs(React__namespace.Fragment, {
      children: [/*#__PURE__*/jsxRuntime$1.jsx(AutocompleteRoot, _extends$c({
        ref: ref,
        className: clsx(classes.root, className),
        ownerState: ownerState
      }, getRootProps(other), {
        children: renderInput({
          id: id,
          disabled: disabled,
          fullWidth: true,
          size: size === 'small' ? 'small' : undefined,
          InputLabelProps: getInputLabelProps(),
          InputProps: {
            ref: setAnchorEl,
            className: classes.inputRoot,
            startAdornment: startAdornment,
            endAdornment: /*#__PURE__*/jsxRuntime$1.jsxs(AutocompleteEndAdornment, {
              className: classes.endAdornment,
              ownerState: ownerState,
              children: [hasClearIcon ? /*#__PURE__*/jsxRuntime$1.jsx(AutocompleteClearIndicator, _extends$c({}, getClearProps(), {
                "aria-label": clearText,
                title: clearText,
                ownerState: ownerState
              }, componentsProps.clearIndicator, {
                className: clsx(classes.clearIndicator, (_componentsProps$clea = componentsProps.clearIndicator) == null ? void 0 : _componentsProps$clea.className),
                children: clearIcon
              })) : null, hasPopupIcon ? /*#__PURE__*/jsxRuntime$1.jsx(AutocompletePopupIndicator, _extends$c({}, getPopupIndicatorProps(), {
                disabled: disabled,
                "aria-label": popupOpen ? closeText : openText,
                title: popupOpen ? closeText : openText,
                className: clsx(classes.popupIndicator),
                ownerState: ownerState,
                children: popupIcon
              })) : null]
            })
          },
          inputProps: _extends$c({
            className: clsx(classes.input),
            disabled: disabled
          }, getInputProps())
        })
      })), popupOpen && anchorEl ? /*#__PURE__*/jsxRuntime$1.jsx(AutocompletePopper, {
        as: PopperComponent,
        className: clsx(classes.popper),
        disablePortal: disablePortal,
        style: {
          width: anchorEl ? anchorEl.clientWidth : null
        },
        ownerState: ownerState,
        role: "presentation",
        anchorEl: anchorEl,
        open: true,
        children: /*#__PURE__*/jsxRuntime$1.jsxs(AutocompletePaper, {
          as: PaperComponent,
          className: classes.paper,
          ownerState: ownerState,
          children: [loading && groupedOptions.length === 0 ? /*#__PURE__*/jsxRuntime$1.jsx(AutocompleteLoading, {
            className: classes.loading,
            ownerState: ownerState,
            children: loadingText
          }) : null, groupedOptions.length === 0 && !freeSolo && !loading ? /*#__PURE__*/jsxRuntime$1.jsx(AutocompleteNoOptions, {
            className: classes.noOptions,
            ownerState: ownerState,
            role: "presentation",
            onMouseDown: function onMouseDown(event) {
              // Prevent input blur when interacting with the "no options" content
              event.preventDefault();
            },
            children: noOptionsText
          }) : null, groupedOptions.length > 0 ? /*#__PURE__*/jsxRuntime$1.jsx(AutocompleteListbox, _extends$c({
            as: ListboxComponent,
            className: classes.listbox,
            ownerState: ownerState
          }, getListboxProps(), ListboxProps, {
            children: groupedOptions.map(function (option, index) {
              if (groupBy) {
                return renderGroup({
                  key: option.key,
                  group: option.group,
                  children: option.options.map(function (option2, index2) {
                    return renderListOption(option2, option.index + index2);
                  })
                });
              }

              return renderListOption(option, index);
            })
          })) : null]
        })
      }) : null]
    });
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var BaseAutocomplete = Autocomplete$1;
  var _excluded$1o = ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"];
  var styles$7 = {
    entering: {
      opacity: 1
    },
    entered: {
      opacity: 1
    }
  };
  var defaultTimeout$1 = {
    enter: duration.enteringScreen,
    exit: duration.leavingScreen
  };
  /**
   * The Fade transition is used by the [Modal](/components/modal/) component.
   * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
   */

  var Fade = /*#__PURE__*/React__namespace.forwardRef(function Fade(props, ref) {
    var addEndListener = props.addEndListener,
        _props$appear = props.appear,
        appear = _props$appear === void 0 ? true : _props$appear,
        _children2 = props.children,
        easing = props.easing,
        inProp = props.in,
        onEnter = props.onEnter,
        onEntered = props.onEntered,
        onEntering = props.onEntering,
        onExit = props.onExit,
        onExited = props.onExited,
        onExiting = props.onExiting,
        style = props.style,
        _props$timeout2 = props.timeout,
        timeout = _props$timeout2 === void 0 ? defaultTimeout$1 : _props$timeout2,
        _props$TransitionComp3 = props.TransitionComponent,
        TransitionComponent = _props$TransitionComp3 === void 0 ? Transition$1 : _props$TransitionComp3,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$1o);

    var theme = useTheme();
    var nodeRef = React__namespace.useRef(null);
    var foreignRef = useForkRef(_children2.ref, ref);
    var handleRef = useForkRef(nodeRef, foreignRef);

    var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
      return function (maybeIsAppearing) {
        if (callback) {
          var _node2 = nodeRef.current; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.

          if (maybeIsAppearing === undefined) {
            callback(_node2);
          } else {
            callback(_node2, maybeIsAppearing);
          }
        }
      };
    };

    var handleEntering = normalizedTransitionCallback(onEntering);
    var handleEnter = normalizedTransitionCallback(function (node, isAppearing) {
      reflow(node); // So the animation always start from the start.

      var transitionProps = getTransitionProps({
        style: style,
        timeout: timeout,
        easing: easing
      }, {
        mode: 'enter'
      });
      node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
      node.style.transition = theme.transitions.create('opacity', transitionProps);

      if (onEnter) {
        onEnter(node, isAppearing);
      }
    });
    var handleEntered = normalizedTransitionCallback(onEntered);
    var handleExiting = normalizedTransitionCallback(onExiting);
    var handleExit = normalizedTransitionCallback(function (node) {
      var transitionProps = getTransitionProps({
        style: style,
        timeout: timeout,
        easing: easing
      }, {
        mode: 'exit'
      });
      node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
      node.style.transition = theme.transitions.create('opacity', transitionProps);

      if (onExit) {
        onExit(node);
      }
    });
    var handleExited = normalizedTransitionCallback(onExited);

    var handleAddEndListener = function handleAddEndListener(next) {
      if (addEndListener) {
        // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
      }
    };

    return /*#__PURE__*/jsxRuntime$1.jsx(TransitionComponent, _extends$c({
      appear: appear,
      in: inProp,
      nodeRef: nodeRef,
      onEnter: handleEnter,
      onEntered: handleEntered,
      onEntering: handleEntering,
      onExit: handleExit,
      onExited: handleExited,
      onExiting: handleExiting,
      addEndListener: handleAddEndListener,
      timeout: timeout
    }, other, {
      children: function children(state, childProps) {
        return /*#__PURE__*/React__namespace.cloneElement(_children2, _extends$c({
          style: _extends$c({
            opacity: 0,
            visibility: state === 'exited' && !inProp ? 'hidden' : undefined
          }, styles$7[state], style, _children2.props.style),
          ref: handleRef
        }, childProps));
      }
    }));
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var Fade$1 = Fade;
  var _excluded$1n = ["children", "components", "componentsProps", "className", "invisible", "open", "transitionDuration", "TransitionComponent"];

  var extendUtilityClasses$2 = function extendUtilityClasses$2(ownerState) {
    var classes = ownerState.classes;
    return classes;
  };

  var BackdropRoot = styled$1('div', {
    name: 'MuiBackdrop',
    slot: 'Root',
    overridesResolver: function overridesResolver(props, styles) {
      var ownerState = props.ownerState;
      return [styles.root, ownerState.invisible && styles.invisible];
    }
  })(function (_ref90) {
    var ownerState = _ref90.ownerState;
    return _extends$c({
      position: 'fixed',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      right: 0,
      bottom: 0,
      top: 0,
      left: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      WebkitTapHighlightColor: 'transparent'
    }, ownerState.invisible && {
      backgroundColor: 'transparent'
    });
  });
  var Backdrop = /*#__PURE__*/React__namespace.forwardRef(function Backdrop(inProps, ref) {
    var _componentsProps$root;

    var props = useThemeProps({
      props: inProps,
      name: 'MuiBackdrop'
    });

    var children = props.children,
        _props$components4 = props.components,
        components = _props$components4 === void 0 ? {} : _props$components4,
        _props$componentsProp5 = props.componentsProps,
        componentsProps = _props$componentsProp5 === void 0 ? {} : _props$componentsProp5,
        className = props.className,
        _props$invisible2 = props.invisible,
        invisible = _props$invisible2 === void 0 ? false : _props$invisible2,
        open = props.open,
        transitionDuration = props.transitionDuration,
        _props$TransitionComp4 = props.TransitionComponent,
        TransitionComponent = _props$TransitionComp4 === void 0 ? Fade$1 : _props$TransitionComp4,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$1n);

    var ownerState = _extends$c({}, props, {
      invisible: invisible
    });

    var classes = extendUtilityClasses$2(ownerState);
    return /*#__PURE__*/jsxRuntime$1.jsx(TransitionComponent, _extends$c({
      in: open,
      timeout: transitionDuration
    }, other, {
      children: /*#__PURE__*/jsxRuntime$1.jsx(BackdropUnstyled$1, {
        className: className,
        invisible: invisible,
        components: _extends$c({
          Root: BackdropRoot
        }, components),
        componentsProps: {
          root: _extends$c({}, componentsProps.root, (!components.Root || !isHostComponent(components.Root)) && {
            ownerState: _extends$c({}, (_componentsProps$root = componentsProps.root) == null ? void 0 : _componentsProps$root.ownerState)
          })
        },
        classes: classes,
        ref: ref,
        children: children
      })
    }));
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var Backdrop$1 = Backdrop;
  var _excluded$1m = ["components", "componentsProps", "color", "invisible", "badgeContent", "showZero", "variant"];

  var badgeClasses = _extends$c({}, badgeUnstyledClasses$1, generateUtilityClasses('MuiBadge', ['colorError', 'colorInfo', 'colorPrimary', 'colorSecondary', 'colorSuccess', 'colorWarning']));

  var RADIUS_STANDARD = 10;
  var RADIUS_DOT = 4;

  var extendUtilityClasses$1 = function extendUtilityClasses$1(ownerState) {
    var color = ownerState.color,
        _ownerState$classes = ownerState.classes,
        classes = _ownerState$classes === void 0 ? {} : _ownerState$classes;
    return _extends$c({}, classes, {
      badge: clsx(classes.badge, color !== 'default' && [getBadgeUtilityClass("color".concat(capitalize$1(color))), classes["color".concat(capitalize$1(color))]])
    });
  };

  var BadgeRoot = styled$1('span', {
    name: 'MuiBadge',
    slot: 'Root',
    overridesResolver: function overridesResolver(props, styles) {
      return styles.root;
    }
  })({
    position: 'relative',
    display: 'inline-flex',
    // For correct alignment with the text.
    verticalAlign: 'middle',
    flexShrink: 0
  });
  var BadgeBadge = styled$1('span', {
    name: 'MuiBadge',
    slot: 'Badge',
    overridesResolver: function overridesResolver(props, styles) {
      var ownerState = props.ownerState;
      return [styles.badge, styles[ownerState.variant], styles["anchorOrigin".concat(capitalize$1(ownerState.anchorOrigin.vertical)).concat(capitalize$1(ownerState.anchorOrigin.horizontal)).concat(capitalize$1(ownerState.overlap))], ownerState.color !== 'default' && styles["color".concat(capitalize$1(ownerState.color))], ownerState.invisible && styles.invisible];
    }
  })(function (_ref91) {
    var theme = _ref91.theme,
        ownerState = _ref91.ownerState;
    return _extends$c({
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'center',
      alignContent: 'center',
      alignItems: 'center',
      position: 'absolute',
      boxSizing: 'border-box',
      fontFamily: theme.typography.fontFamily,
      fontWeight: theme.typography.fontWeightMedium,
      fontSize: theme.typography.pxToRem(12),
      minWidth: RADIUS_STANDARD * 2,
      lineHeight: 1,
      padding: '0 6px',
      height: RADIUS_STANDARD * 2,
      borderRadius: RADIUS_STANDARD,
      zIndex: 1,
      // Render the badge on top of potential ripples.
      transition: theme.transitions.create('transform', {
        easing: theme.transitions.easing.easeInOut,
        duration: theme.transitions.duration.enteringScreen
      })
    }, ownerState.color !== 'default' && {
      backgroundColor: theme.palette[ownerState.color].main,
      color: theme.palette[ownerState.color].contrastText
    }, ownerState.variant === 'dot' && {
      borderRadius: RADIUS_DOT,
      height: RADIUS_DOT * 2,
      minWidth: RADIUS_DOT * 2,
      padding: 0
    }, ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'rectangular' && _defineProperty({
      top: 0,
      right: 0,
      transform: 'scale(1) translate(50%, -50%)',
      transformOrigin: '100% 0%'
    }, "&.".concat(badgeClasses.invisible), {
      transform: 'scale(0) translate(50%, -50%)'
    }), ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'rectangular' && _defineProperty({
      bottom: 0,
      right: 0,
      transform: 'scale(1) translate(50%, 50%)',
      transformOrigin: '100% 100%'
    }, "&.".concat(badgeClasses.invisible), {
      transform: 'scale(0) translate(50%, 50%)'
    }), ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'rectangular' && _defineProperty({
      top: 0,
      left: 0,
      transform: 'scale(1) translate(-50%, -50%)',
      transformOrigin: '0% 0%'
    }, "&.".concat(badgeClasses.invisible), {
      transform: 'scale(0) translate(-50%, -50%)'
    }), ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'rectangular' && _defineProperty({
      bottom: 0,
      left: 0,
      transform: 'scale(1) translate(-50%, 50%)',
      transformOrigin: '0% 100%'
    }, "&.".concat(badgeClasses.invisible), {
      transform: 'scale(0) translate(-50%, 50%)'
    }), ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'circular' && _defineProperty({
      top: '14%',
      right: '14%',
      transform: 'scale(1) translate(50%, -50%)',
      transformOrigin: '100% 0%'
    }, "&.".concat(badgeClasses.invisible), {
      transform: 'scale(0) translate(50%, -50%)'
    }), ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'circular' && _defineProperty({
      bottom: '14%',
      right: '14%',
      transform: 'scale(1) translate(50%, 50%)',
      transformOrigin: '100% 100%'
    }, "&.".concat(badgeClasses.invisible), {
      transform: 'scale(0) translate(50%, 50%)'
    }), ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'circular' && _defineProperty({
      top: '14%',
      left: '14%',
      transform: 'scale(1) translate(-50%, -50%)',
      transformOrigin: '0% 0%'
    }, "&.".concat(badgeClasses.invisible), {
      transform: 'scale(0) translate(-50%, -50%)'
    }), ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'circular' && _defineProperty({
      bottom: '14%',
      left: '14%',
      transform: 'scale(1) translate(-50%, 50%)',
      transformOrigin: '0% 100%'
    }, "&.".concat(badgeClasses.invisible), {
      transform: 'scale(0) translate(-50%, 50%)'
    }), ownerState.invisible && {
      transition: theme.transitions.create('transform', {
        easing: theme.transitions.easing.easeInOut,
        duration: theme.transitions.duration.leavingScreen
      })
    });
  });
  var Badge = /*#__PURE__*/React__namespace.forwardRef(function Badge(inProps, ref) {
    var _componentsProps$root, _componentsProps$badg;

    var props = useThemeProps({
      props: inProps,
      name: 'MuiBadge'
    });

    var _props$components5 = props.components,
        components = _props$components5 === void 0 ? {} : _props$components5,
        _props$componentsProp6 = props.componentsProps,
        componentsProps = _props$componentsProp6 === void 0 ? {} : _props$componentsProp6,
        _props$color6 = props.color,
        colorProp = _props$color6 === void 0 ? 'default' : _props$color6,
        invisibleProp = props.invisible,
        badgeContentProp = props.badgeContent,
        _props$showZero2 = props.showZero,
        showZero = _props$showZero2 === void 0 ? false : _props$showZero2,
        _props$variant6 = props.variant,
        variantProp = _props$variant6 === void 0 ? 'standard' : _props$variant6,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$1m);

    var prevProps = usePreviousProps$1({
      color: colorProp
    });
    var invisible = invisibleProp;

    if (invisibleProp == null && (badgeContentProp === 0 && !showZero || badgeContentProp == null && variantProp !== 'dot')) {
      invisible = true;
    }

    var _ref100 = invisible ? prevProps : props,
        _ref100$color = _ref100.color,
        color = _ref100$color === void 0 ? colorProp : _ref100$color;

    var ownerState = _extends$c({}, props, {
      invisible: invisible,
      color: color
    });

    var classes = extendUtilityClasses$1(ownerState);
    return /*#__PURE__*/jsxRuntime$1.jsx(BadgeUnstyled$1, _extends$c({
      invisible: invisibleProp,
      badgeContent: badgeContentProp,
      showZero: showZero,
      variant: variantProp
    }, other, {
      components: _extends$c({
        Root: BadgeRoot,
        Badge: BadgeBadge
      }, components),
      componentsProps: {
        root: _extends$c({}, componentsProps.root, (!components.Root || !isHostComponent(components.Root)) && {
          ownerState: _extends$c({}, (_componentsProps$root = componentsProps.root) == null ? void 0 : _componentsProps$root.ownerState, {
            color: color
          })
        }),
        badge: _extends$c({}, componentsProps.badge, (!components.Thumb || !isHostComponent(components.Thumb)) && {
          ownerState: _extends$c({}, (_componentsProps$badg = componentsProps.badge) == null ? void 0 : _componentsProps$badg.ownerState, {
            color: color
          })
        })
      },
      classes: classes,
      ref: ref
    }));
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var A$1 = Badge;

  function getButtonUtilityClass(slot) {
    return generateUtilityClass('MuiButton', slot);
  }

  var buttonClasses = generateUtilityClasses('MuiButton', ['root', 'text', 'textInherit', 'textPrimary', 'textSecondary', 'outlined', 'outlinedInherit', 'outlinedPrimary', 'outlinedSecondary', 'contained', 'containedInherit', 'containedPrimary', 'containedSecondary', 'disableElevation', 'focusVisible', 'disabled', 'colorInherit', 'textSizeSmall', 'textSizeMedium', 'textSizeLarge', 'outlinedSizeSmall', 'outlinedSizeMedium', 'outlinedSizeLarge', 'containedSizeSmall', 'containedSizeMedium', 'containedSizeLarge', 'sizeMedium', 'sizeSmall', 'sizeLarge', 'fullWidth', 'startIcon', 'endIcon', 'iconSizeSmall', 'iconSizeMedium', 'iconSizeLarge']);
  var buttonClasses$1 = buttonClasses;
  /**
   * @ignore - internal component.
   */

  var ButtonGroupContext = /*#__PURE__*/React__namespace.createContext({});

  if (process.env.NODE_ENV !== 'production') {
    ButtonGroupContext.displayName = 'ButtonGroupContext';
  }

  var ButtonGroupContext$1 = ButtonGroupContext;
  var _excluded$1l = ["children", "color", "component", "className", "disabled", "disableElevation", "disableFocusRipple", "endIcon", "focusVisibleClassName", "fullWidth", "size", "startIcon", "type", "variant"];

  var useUtilityClasses$12 = function useUtilityClasses$12(ownerState) {
    var color = ownerState.color,
        disableElevation = ownerState.disableElevation,
        fullWidth = ownerState.fullWidth,
        size = ownerState.size,
        variant = ownerState.variant,
        classes = ownerState.classes;
    var slots = {
      root: ['root', variant, "".concat(variant).concat(capitalize$1(color)), "size".concat(capitalize$1(size)), "".concat(variant, "Size").concat(capitalize$1(size)), color === 'inherit' && 'colorInherit', disableElevation && 'disableElevation', fullWidth && 'fullWidth'],
      label: ['label'],
      startIcon: ['startIcon', "iconSize".concat(capitalize$1(size))],
      endIcon: ['endIcon', "iconSize".concat(capitalize$1(size))]
    };
    var composedClasses = composeClasses(slots, getButtonUtilityClass, classes);
    return _extends$c({}, classes, composedClasses);
  };

  var commonIconStyles = function commonIconStyles(ownerState) {
    return _extends$c({}, ownerState.size === 'small' && {
      '& > *:nth-of-type(1)': {
        fontSize: 18
      }
    }, ownerState.size === 'medium' && {
      '& > *:nth-of-type(1)': {
        fontSize: 20
      }
    }, ownerState.size === 'large' && {
      '& > *:nth-of-type(1)': {
        fontSize: 22
      }
    });
  };

  var ButtonRoot = styled$1(ButtonBase$1, {
    shouldForwardProp: function shouldForwardProp(prop) {
      return rootShouldForwardProp(prop) || prop === 'classes';
    },
    name: 'MuiButton',
    slot: 'Root',
    overridesResolver: function overridesResolver(props, styles) {
      var ownerState = props.ownerState;
      return [styles.root, styles[ownerState.variant], styles["".concat(ownerState.variant).concat(capitalize$1(ownerState.color))], styles["size".concat(capitalize$1(ownerState.size))], styles["".concat(ownerState.variant, "Size").concat(capitalize$1(ownerState.size))], ownerState.color === 'inherit' && styles.colorInherit, ownerState.disableElevation && styles.disableElevation, ownerState.fullWidth && styles.fullWidth];
    }
  })(function (_ref101) {
    var _extends$c8;

    var theme = _ref101.theme,
        ownerState = _ref101.ownerState;
    return _extends$c({}, theme.typography.button, (_extends$c8 = {
      minWidth: 64,
      padding: '6px 16px',
      borderRadius: theme.shape.borderRadius,
      transition: theme.transitions.create(['background-color', 'box-shadow', 'border-color', 'color'], {
        duration: theme.transitions.duration.short
      }),
      '&:hover': _extends$c({
        textDecoration: 'none',
        backgroundColor: alpha(theme.palette.text.primary, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }, ownerState.variant === 'text' && ownerState.color !== 'inherit' && {
        backgroundColor: alpha(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }, ownerState.variant === 'outlined' && ownerState.color !== 'inherit' && {
        border: "1px solid ".concat(theme.palette[ownerState.color].main),
        backgroundColor: alpha(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }, ownerState.variant === 'contained' && {
        backgroundColor: theme.palette.grey.A100,
        boxShadow: theme.shadows[4],
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          boxShadow: theme.shadows[2],
          backgroundColor: theme.palette.grey[300]
        }
      }, ownerState.variant === 'contained' && ownerState.color !== 'inherit' && {
        backgroundColor: theme.palette[ownerState.color].dark,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: theme.palette[ownerState.color].main
        }
      }),
      '&:active': _extends$c({}, ownerState.variant === 'contained' && {
        boxShadow: theme.shadows[8]
      })
    }, _defineProperty(_extends$c8, "&.".concat(buttonClasses$1.focusVisible), _extends$c({}, ownerState.variant === 'contained' && {
      boxShadow: theme.shadows[6]
    })), _defineProperty(_extends$c8, "&.".concat(buttonClasses$1.disabled), _extends$c({
      color: theme.palette.action.disabled
    }, ownerState.variant === 'outlined' && {
      border: "1px solid ".concat(theme.palette.action.disabledBackground)
    }, ownerState.variant === 'outlined' && ownerState.color === 'secondary' && {
      border: "1px solid ".concat(theme.palette.action.disabled)
    }, ownerState.variant === 'contained' && {
      color: theme.palette.action.disabled,
      boxShadow: theme.shadows[0],
      backgroundColor: theme.palette.action.disabledBackground
    })), _extends$c8), ownerState.variant === 'text' && {
      padding: '6px 8px'
    }, ownerState.variant === 'text' && ownerState.color !== 'inherit' && {
      color: theme.palette[ownerState.color].main
    }, ownerState.variant === 'outlined' && {
      padding: '5px 15px',
      border: "1px solid ".concat(theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)')
    }, ownerState.variant === 'outlined' && ownerState.color !== 'inherit' && {
      color: theme.palette[ownerState.color].main,
      border: "1px solid ".concat(alpha(theme.palette[ownerState.color].main, 0.5))
    }, ownerState.variant === 'contained' && {
      color: theme.palette.getContrastText(theme.palette.grey[300]),
      backgroundColor: theme.palette.grey[300],
      boxShadow: theme.shadows[2]
    }, ownerState.variant === 'contained' && ownerState.color !== 'inherit' && {
      color: theme.palette[ownerState.color].contrastText,
      backgroundColor: theme.palette[ownerState.color].main
    }, ownerState.color === 'inherit' && {
      color: 'inherit',
      borderColor: 'currentColor'
    }, ownerState.size === 'small' && ownerState.variant === 'text' && {
      padding: '4px 5px',
      fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === 'large' && ownerState.variant === 'text' && {
      padding: '8px 11px',
      fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === 'small' && ownerState.variant === 'outlined' && {
      padding: '3px 9px',
      fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === 'large' && ownerState.variant === 'outlined' && {
      padding: '7px 21px',
      fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === 'small' && ownerState.variant === 'contained' && {
      padding: '4px 10px',
      fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === 'large' && ownerState.variant === 'contained' && {
      padding: '8px 22px',
      fontSize: theme.typography.pxToRem(15)
    }, ownerState.fullWidth && {
      width: '100%'
    });
  }, function (_ref102) {
    var _ref103;

    var ownerState = _ref102.ownerState;
    return ownerState.disableElevation && (_ref103 = {
      boxShadow: 'none',
      '&:hover': {
        boxShadow: 'none'
      }
    }, _defineProperty(_ref103, "&.".concat(buttonClasses$1.focusVisible), {
      boxShadow: 'none'
    }), _defineProperty(_ref103, '&:active', {
      boxShadow: 'none'
    }), _defineProperty(_ref103, "&.".concat(buttonClasses$1.disabled), {
      boxShadow: 'none'
    }), _ref103);
  });
  var ButtonStartIcon = styled$1('span', {
    name: 'MuiButton',
    slot: 'StartIcon',
    overridesResolver: function overridesResolver(props, styles) {
      var ownerState = props.ownerState;
      return [styles.startIcon, styles["iconSize".concat(capitalize$1(ownerState.size))]];
    }
  })(function (_ref104) {
    var ownerState = _ref104.ownerState;
    return _extends$c({
      display: 'inherit',
      marginRight: 8,
      marginLeft: -4
    }, ownerState.size === 'small' && {
      marginLeft: -2
    }, commonIconStyles(ownerState));
  });
  var ButtonEndIcon = styled$1('span', {
    name: 'MuiButton',
    slot: 'EndIcon',
    overridesResolver: function overridesResolver(props, styles) {
      var ownerState = props.ownerState;
      return [styles.endIcon, styles["iconSize".concat(capitalize$1(ownerState.size))]];
    }
  })(function (_ref105) {
    var ownerState = _ref105.ownerState;
    return _extends$c({
      display: 'inherit',
      marginRight: -4,
      marginLeft: 8
    }, ownerState.size === 'small' && {
      marginRight: -2
    }, commonIconStyles(ownerState));
  });
  var Button$1 = /*#__PURE__*/React__namespace.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    var contextProps = React__namespace.useContext(ButtonGroupContext$1);
    var resolvedProps = resolveProps(contextProps, inProps);
    var props = useThemeProps({
      props: resolvedProps,
      name: 'MuiButton'
    });

    var children = props.children,
        _props$color7 = props.color,
        color = _props$color7 === void 0 ? 'primary' : _props$color7,
        _props$component8 = props.component,
        component = _props$component8 === void 0 ? 'button' : _props$component8,
        className = props.className,
        _props$disabled6 = props.disabled,
        disabled = _props$disabled6 === void 0 ? false : _props$disabled6,
        _props$disableElevati = props.disableElevation,
        disableElevation = _props$disableElevati === void 0 ? false : _props$disableElevati,
        _props$disableFocusRi2 = props.disableFocusRipple,
        disableFocusRipple = _props$disableFocusRi2 === void 0 ? false : _props$disableFocusRi2,
        endIconProp = props.endIcon,
        focusVisibleClassName = props.focusVisibleClassName,
        _props$fullWidth2 = props.fullWidth,
        fullWidth = _props$fullWidth2 === void 0 ? false : _props$fullWidth2,
        _props$size4 = props.size,
        size = _props$size4 === void 0 ? 'medium' : _props$size4,
        startIconProp = props.startIcon,
        type = props.type,
        _props$variant7 = props.variant,
        variant = _props$variant7 === void 0 ? 'text' : _props$variant7,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$1l);

    var ownerState = _extends$c({}, props, {
      color: color,
      component: component,
      disabled: disabled,
      disableElevation: disableElevation,
      disableFocusRipple: disableFocusRipple,
      fullWidth: fullWidth,
      size: size,
      type: type,
      variant: variant
    });

    var classes = useUtilityClasses$12(ownerState);
    var startIcon = startIconProp && /*#__PURE__*/jsxRuntime$1.jsx(ButtonStartIcon, {
      className: classes.startIcon,
      ownerState: ownerState,
      children: startIconProp
    });
    var endIcon = endIconProp && /*#__PURE__*/jsxRuntime$1.jsx(ButtonEndIcon, {
      className: classes.endIcon,
      ownerState: ownerState,
      children: endIconProp
    });
    return /*#__PURE__*/jsxRuntime$1.jsxs(ButtonRoot, _extends$c({
      ownerState: ownerState,
      className: clsx(className, contextProps.className),
      component: component,
      disabled: disabled,
      focusRipple: !disableFocusRipple,
      focusVisibleClassName: clsx(classes.focusVisible, focusVisibleClassName),
      ref: ref,
      type: type
    }, other, {
      classes: classes,
      children: [startIcon, children, endIcon]
    }));
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var BaseButton = Button$1;

  function getButtonGroupUtilityClass(slot) {
    return generateUtilityClass('MuiButtonGroup', slot);
  }

  var buttonGroupClasses = generateUtilityClasses('MuiButtonGroup', ['root', 'contained', 'outlined', 'text', 'disableElevation', 'disabled', 'fullWidth', 'vertical', 'grouped', 'groupedHorizontal', 'groupedVertical', 'groupedText', 'groupedTextHorizontal', 'groupedTextVertical', 'groupedTextPrimary', 'groupedTextSecondary', 'groupedOutlined', 'groupedOutlinedHorizontal', 'groupedOutlinedVertical', 'groupedOutlinedPrimary', 'groupedOutlinedSecondary', 'groupedContained', 'groupedContainedHorizontal', 'groupedContainedVertical', 'groupedContainedPrimary', 'groupedContainedSecondary']);
  var buttonGroupClasses$1 = buttonGroupClasses;
  var _excluded$1k = ["children", "className", "color", "component", "disabled", "disableElevation", "disableFocusRipple", "disableRipple", "fullWidth", "orientation", "size", "variant"];

  var overridesResolver$4 = function overridesResolver$4(props, styles) {
    var ownerState = props.ownerState;
    return [_defineProperty({}, "& .".concat(buttonGroupClasses$1.grouped), styles.grouped), _defineProperty({}, "& .".concat(buttonGroupClasses$1.grouped), styles["grouped".concat(capitalize$1(ownerState.orientation))]), _defineProperty({}, "& .".concat(buttonGroupClasses$1.grouped), styles["grouped".concat(capitalize$1(ownerState.variant))]), _defineProperty({}, "& .".concat(buttonGroupClasses$1.grouped), styles["grouped".concat(capitalize$1(ownerState.variant)).concat(capitalize$1(ownerState.orientation))]), _defineProperty({}, "& .".concat(buttonGroupClasses$1.grouped), styles["grouped".concat(capitalize$1(ownerState.variant)).concat(capitalize$1(ownerState.color))]), styles.root, styles[ownerState.variant], ownerState.disableElevation === true && styles.disableElevation, ownerState.fullWidth && styles.fullWidth, ownerState.orientation === 'vertical' && styles.vertical];
  };

  var useUtilityClasses$11 = function useUtilityClasses$11(ownerState) {
    var classes = ownerState.classes,
        color = ownerState.color,
        disabled = ownerState.disabled,
        disableElevation = ownerState.disableElevation,
        fullWidth = ownerState.fullWidth,
        orientation = ownerState.orientation,
        variant = ownerState.variant;
    var slots = {
      root: ['root', variant, orientation === 'vertical' && 'vertical', fullWidth && 'fullWidth', disableElevation && 'disableElevation'],
      grouped: ['grouped', "grouped".concat(capitalize$1(orientation)), "grouped".concat(capitalize$1(variant)), "grouped".concat(capitalize$1(variant)).concat(capitalize$1(orientation)), "grouped".concat(capitalize$1(variant)).concat(capitalize$1(color)), disabled && 'disabled']
    };
    return composeClasses(slots, getButtonGroupUtilityClass, classes);
  };

  var ButtonGroupRoot = styled$1('div', {
    name: 'MuiButtonGroup',
    slot: 'Root',
    overridesResolver: overridesResolver$4
  })(function (_ref111) {
    var theme = _ref111.theme,
        ownerState = _ref111.ownerState;
    return _extends$c({
      display: 'inline-flex',
      borderRadius: theme.shape.borderRadius
    }, ownerState.variant === 'contained' && {
      boxShadow: theme.shadows[2]
    }, ownerState.disableElevation && {
      boxShadow: 'none'
    }, ownerState.fullWidth && {
      width: '100%'
    }, ownerState.orientation === 'vertical' && {
      flexDirection: 'column'
    }, _defineProperty({}, "& .".concat(buttonGroupClasses$1.grouped), _extends$c({
      minWidth: 40,
      '&:not(:first-of-type)': _extends$c({}, ownerState.orientation === 'horizontal' && {
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0
      }, ownerState.orientation === 'vertical' && {
        borderTopRightRadius: 0,
        borderTopLeftRadius: 0
      }, ownerState.variant === 'outlined' && ownerState.orientation === 'horizontal' && {
        marginLeft: -1
      }, ownerState.variant === 'outlined' && ownerState.orientation === 'vertical' && {
        marginTop: -1
      }),
      '&:not(:last-of-type)': _extends$c({}, ownerState.orientation === 'horizontal' && {
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0
      }, ownerState.orientation === 'vertical' && {
        borderBottomRightRadius: 0,
        borderBottomLeftRadius: 0
      }, ownerState.variant === 'text' && ownerState.orientation === 'horizontal' && {
        borderRight: "1px solid ".concat(theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)')
      }, ownerState.variant === 'text' && ownerState.orientation === 'vertical' && {
        borderBottom: "1px solid ".concat(theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)')
      }, ownerState.variant === 'text' && ownerState.color !== 'inherit' && {
        borderColor: alpha(theme.palette[ownerState.color].main, 0.5)
      }, ownerState.variant === 'outlined' && ownerState.orientation === 'horizontal' && {
        borderRightColor: 'transparent'
      }, ownerState.variant === 'outlined' && ownerState.orientation === 'vertical' && {
        borderBottomColor: 'transparent'
      }, ownerState.variant === 'contained' && ownerState.orientation === 'horizontal' && _defineProperty({
        borderRight: "1px solid ".concat(theme.palette.grey[400])
      }, "&.".concat(buttonGroupClasses$1.disabled), {
        borderRight: "1px solid ".concat(theme.palette.action.disabled)
      }), ownerState.variant === 'contained' && ownerState.orientation === 'vertical' && _defineProperty({
        borderBottom: "1px solid ".concat(theme.palette.grey[400])
      }, "&.".concat(buttonGroupClasses$1.disabled), {
        borderBottom: "1px solid ".concat(theme.palette.action.disabled)
      }), ownerState.variant === 'contained' && ownerState.color !== 'inherit' && {
        borderColor: theme.palette[ownerState.color].dark
      }, {
        '&:hover': _extends$c({}, ownerState.variant === 'outlined' && ownerState.orientation === 'horizontal' && {
          borderRightColor: 'currentColor'
        }, ownerState.variant === 'outlined' && ownerState.orientation === 'vertical' && {
          borderBottomColor: 'currentColor'
        })
      }),
      '&:hover': _extends$c({}, ownerState.variant === 'contained' && {
        boxShadow: 'none'
      })
    }, ownerState.variant === 'contained' && {
      boxShadow: 'none'
    })));
  });
  var ButtonGroup$1 = /*#__PURE__*/React__namespace.forwardRef(function ButtonGroup(inProps, ref) {
    var props = useThemeProps({
      props: inProps,
      name: 'MuiButtonGroup'
    });

    var children = props.children,
        className = props.className,
        _props$color8 = props.color,
        color = _props$color8 === void 0 ? 'primary' : _props$color8,
        _props$component9 = props.component,
        component = _props$component9 === void 0 ? 'div' : _props$component9,
        _props$disabled7 = props.disabled,
        disabled = _props$disabled7 === void 0 ? false : _props$disabled7,
        _props$disableElevati2 = props.disableElevation,
        disableElevation = _props$disableElevati2 === void 0 ? false : _props$disableElevati2,
        _props$disableFocusRi3 = props.disableFocusRipple,
        disableFocusRipple = _props$disableFocusRi3 === void 0 ? false : _props$disableFocusRi3,
        _props$disableRipple2 = props.disableRipple,
        disableRipple = _props$disableRipple2 === void 0 ? false : _props$disableRipple2,
        _props$fullWidth3 = props.fullWidth,
        fullWidth = _props$fullWidth3 === void 0 ? false : _props$fullWidth3,
        _props$orientation2 = props.orientation,
        orientation = _props$orientation2 === void 0 ? 'horizontal' : _props$orientation2,
        _props$size5 = props.size,
        size = _props$size5 === void 0 ? 'medium' : _props$size5,
        _props$variant8 = props.variant,
        variant = _props$variant8 === void 0 ? 'outlined' : _props$variant8,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$1k);

    var ownerState = _extends$c({}, props, {
      color: color,
      component: component,
      disabled: disabled,
      disableElevation: disableElevation,
      disableFocusRipple: disableFocusRipple,
      disableRipple: disableRipple,
      fullWidth: fullWidth,
      orientation: orientation,
      size: size,
      variant: variant
    });

    var classes = useUtilityClasses$11(ownerState);
    var context = React__namespace.useMemo(function () {
      return {
        className: classes.grouped,
        color: color,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        disableRipple: disableRipple,
        fullWidth: fullWidth,
        size: size,
        variant: variant
      };
    }, [color, disabled, disableElevation, disableFocusRipple, disableRipple, fullWidth, size, variant, classes.grouped]);
    return /*#__PURE__*/jsxRuntime$1.jsx(ButtonGroupRoot, _extends$c({
      as: component,
      role: "group",
      className: clsx(classes.root, className),
      ref: ref,
      ownerState: ownerState
    }, other, {
      children: /*#__PURE__*/jsxRuntime$1.jsx(ButtonGroupContext$1.Provider, {
        value: context,
        children: children
      })
    }));
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var BaseButtonGroup = ButtonGroup$1;

  function getCardUtilityClass(slot) {
    return generateUtilityClass('MuiCard', slot);
  }

  generateUtilityClasses('MuiCard', ['root']);
  var _excluded$1j = ["className", "raised"];

  var useUtilityClasses$10 = function useUtilityClasses$10(ownerState) {
    var classes = ownerState.classes;
    var slots = {
      root: ['root']
    };
    return composeClasses(slots, getCardUtilityClass, classes);
  };

  var CardRoot = styled$1(BasePaper, {
    name: 'MuiCard',
    slot: 'Root',
    overridesResolver: function overridesResolver(props, styles) {
      return styles.root;
    }
  })(function () {
    return {
      overflow: 'hidden'
    };
  });
  var Card$1 = /*#__PURE__*/React__namespace.forwardRef(function Card(inProps, ref) {
    var props = useThemeProps({
      props: inProps,
      name: 'MuiCard'
    });

    var className = props.className,
        _props$raised = props.raised,
        raised = _props$raised === void 0 ? false : _props$raised,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$1j);

    var ownerState = _extends$c({}, props, {
      raised: raised
    });

    var classes = useUtilityClasses$10(ownerState);
    return /*#__PURE__*/jsxRuntime$1.jsx(CardRoot, _extends$c({
      className: clsx(classes.root, className),
      elevation: raised ? 8 : undefined,
      ref: ref,
      ownerState: ownerState
    }, other));
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var BaseCard = Card$1;

  function getCardActionAreaUtilityClass(slot) {
    return generateUtilityClass('MuiCardActionArea', slot);
  }

  var cardActionAreaClasses = generateUtilityClasses('MuiCardActionArea', ['root', 'focusVisible', 'focusHighlight']);
  var cardActionAreaClasses$1 = cardActionAreaClasses;
  var _excluded$1i = ["children", "className", "focusVisibleClassName"];

  var useUtilityClasses$$ = function useUtilityClasses$$(ownerState) {
    var classes = ownerState.classes;
    var slots = {
      root: ['root'],
      focusHighlight: ['focusHighlight']
    };
    return composeClasses(slots, getCardActionAreaUtilityClass, classes);
  };

  var CardActionAreaRoot = styled$1(ButtonBase$1, {
    name: 'MuiCardActionArea',
    slot: 'Root',
    overridesResolver: function overridesResolver(props, styles) {
      return styles.root;
    }
  })(function (_ref114) {
    var _ref115;

    var theme = _ref114.theme;
    return _ref115 = {
      display: 'block',
      textAlign: 'inherit',
      width: '100%'
    }, _defineProperty(_ref115, "&:hover .".concat(cardActionAreaClasses$1.focusHighlight), {
      opacity: theme.palette.action.hoverOpacity,
      '@media (hover: none)': {
        opacity: 0
      }
    }), _defineProperty(_ref115, "&.".concat(cardActionAreaClasses$1.focusVisible, " .").concat(cardActionAreaClasses$1.focusHighlight), {
      opacity: theme.palette.action.focusOpacity
    }), _ref115;
  });
  var CardActionAreaFocusHighlight = styled$1('span', {
    name: 'MuiCardActionArea',
    slot: 'FocusHighlight',
    overridesResolver: function overridesResolver(props, styles) {
      return styles.focusHighlight;
    }
  })(function (_ref116) {
    var theme = _ref116.theme;
    return {
      overflow: 'hidden',
      pointerEvents: 'none',
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      borderRadius: 'inherit',
      opacity: 0,
      backgroundColor: 'currentcolor',
      transition: theme.transitions.create('opacity', {
        duration: theme.transitions.duration.short
      })
    };
  });
  var CardActionArea$1 = /*#__PURE__*/React__namespace.forwardRef(function CardActionArea(inProps, ref) {
    var props = useThemeProps({
      props: inProps,
      name: 'MuiCardActionArea'
    });

    var children = props.children,
        className = props.className,
        focusVisibleClassName = props.focusVisibleClassName,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$1i);

    var ownerState = props;
    var classes = useUtilityClasses$$(ownerState);
    return /*#__PURE__*/jsxRuntime$1.jsxs(CardActionAreaRoot, _extends$c({
      className: clsx(classes.root, className),
      focusVisibleClassName: clsx(focusVisibleClassName, classes.focusVisible),
      ref: ref,
      ownerState: ownerState
    }, other, {
      children: [children, /*#__PURE__*/jsxRuntime$1.jsx(CardActionAreaFocusHighlight, {
        className: classes.focusHighlight,
        ownerState: ownerState
      })]
    }));
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var BaseCardActionArea = CardActionArea$1;

  function getCardActionsUtilityClass(slot) {
    return generateUtilityClass('MuiCardActions', slot);
  }

  generateUtilityClasses('MuiCardActions', ['root', 'spacing']);
  var _excluded$1h = ["disableSpacing", "className"];

  var useUtilityClasses$_ = function useUtilityClasses$_(ownerState) {
    var classes = ownerState.classes,
        disableSpacing = ownerState.disableSpacing;
    var slots = {
      root: ['root', !disableSpacing && 'spacing']
    };
    return composeClasses(slots, getCardActionsUtilityClass, classes);
  };

  var CardActionsRoot = styled$1('div', {
    name: 'MuiCardActions',
    slot: 'Root',
    overridesResolver: function overridesResolver(props, styles) {
      var ownerState = props.ownerState;
      return [styles.root, !ownerState.disableSpacing && styles.spacing];
    }
  })(function (_ref117) {
    var ownerState = _ref117.ownerState;
    return _extends$c({
      display: 'flex',
      alignItems: 'center',
      padding: 8
    }, !ownerState.disableSpacing && {
      '& > :not(:first-of-type)': {
        marginLeft: 8
      }
    });
  });
  var CardActions$1 = /*#__PURE__*/React__namespace.forwardRef(function CardActions(inProps, ref) {
    var props = useThemeProps({
      props: inProps,
      name: 'MuiCardActions'
    });

    var _props$disableSpacing2 = props.disableSpacing,
        disableSpacing = _props$disableSpacing2 === void 0 ? false : _props$disableSpacing2,
        className = props.className,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$1h);

    var ownerState = _extends$c({}, props, {
      disableSpacing: disableSpacing
    });

    var classes = useUtilityClasses$_(ownerState);
    return /*#__PURE__*/jsxRuntime$1.jsx(CardActionsRoot, _extends$c({
      className: clsx(classes.root, className),
      ownerState: ownerState,
      ref: ref
    }, other));
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var BaseCardActions = CardActions$1;

  function getCardContentUtilityClass(slot) {
    return generateUtilityClass('MuiCardContent', slot);
  }

  generateUtilityClasses('MuiCardContent', ['root']);
  var _excluded$1g = ["className", "component"];

  var useUtilityClasses$Z = function useUtilityClasses$Z(ownerState) {
    var classes = ownerState.classes;
    var slots = {
      root: ['root']
    };
    return composeClasses(slots, getCardContentUtilityClass, classes);
  };

  var CardContentRoot = styled$1('div', {
    name: 'MuiCardContent',
    slot: 'Root',
    overridesResolver: function overridesResolver(props, styles) {
      return styles.root;
    }
  })(function () {
    return {
      padding: 16,
      '&:last-child': {
        paddingBottom: 24
      }
    };
  });
  var CardContent$1 = /*#__PURE__*/React__namespace.forwardRef(function CardContent(inProps, ref) {
    var props = useThemeProps({
      props: inProps,
      name: 'MuiCardContent'
    });

    var className = props.className,
        _props$component10 = props.component,
        component = _props$component10 === void 0 ? 'div' : _props$component10,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$1g);

    var ownerState = _extends$c({}, props, {
      component: component
    });

    var classes = useUtilityClasses$Z(ownerState);
    return /*#__PURE__*/jsxRuntime$1.jsx(CardContentRoot, _extends$c({
      as: component,
      className: clsx(classes.root, className),
      ownerState: ownerState,
      ref: ref
    }, other));
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var BaseCardContent = CardContent$1;

  function getCardHeaderUtilityClass(slot) {
    return generateUtilityClass('MuiCardHeader', slot);
  }

  var cardHeaderClasses = generateUtilityClasses('MuiCardHeader', ['root', 'avatar', 'action', 'content', 'title', 'subheader']);
  var cardHeaderClasses$1 = cardHeaderClasses;
  var _excluded$1f = ["action", "avatar", "className", "component", "disableTypography", "subheader", "subheaderTypographyProps", "title", "titleTypographyProps"];

  var useUtilityClasses$Y = function useUtilityClasses$Y(ownerState) {
    var classes = ownerState.classes;
    var slots = {
      root: ['root'],
      avatar: ['avatar'],
      action: ['action'],
      content: ['content'],
      title: ['title'],
      subheader: ['subheader']
    };
    return composeClasses(slots, getCardHeaderUtilityClass, classes);
  };

  var CardHeaderRoot = styled$1('div', {
    name: 'MuiCardHeader',
    slot: 'Root',
    overridesResolver: function overridesResolver(props, styles) {
      var _extends$c10;

      return _extends$c((_extends$c10 = {}, _defineProperty(_extends$c10, "& .".concat(cardHeaderClasses$1.title), styles.title), _defineProperty(_extends$c10, "& .".concat(cardHeaderClasses$1.subheader), styles.subheader), _extends$c10), styles.root);
    }
  })({
    display: 'flex',
    alignItems: 'center',
    padding: 16
  });
  var CardHeaderAvatar = styled$1('div', {
    name: 'MuiCardHeader',
    slot: 'Avatar',
    overridesResolver: function overridesResolver(props, styles) {
      return styles.avatar;
    }
  })({
    display: 'flex',
    flex: '0 0 auto',
    marginRight: 16
  });
  var CardHeaderAction = styled$1('div', {
    name: 'MuiCardHeader',
    slot: 'Action',
    overridesResolver: function overridesResolver(props, styles) {
      return styles.action;
    }
  })({
    flex: '0 0 auto',
    alignSelf: 'flex-start',
    marginTop: -4,
    marginRight: -8,
    marginBottom: -4
  });
  var CardHeaderContent = styled$1('div', {
    name: 'MuiCardHeader',
    slot: 'Content',
    overridesResolver: function overridesResolver(props, styles) {
      return styles.content;
    }
  })({
    flex: '1 1 auto'
  });
  var CardHeader$1 = /*#__PURE__*/React__namespace.forwardRef(function CardHeader(inProps, ref) {
    var props = useThemeProps({
      props: inProps,
      name: 'MuiCardHeader'
    });

    var action = props.action,
        avatar = props.avatar,
        className = props.className,
        _props$component11 = props.component,
        component = _props$component11 === void 0 ? 'div' : _props$component11,
        _props$disableTypogra = props.disableTypography,
        disableTypography = _props$disableTypogra === void 0 ? false : _props$disableTypogra,
        subheaderProp = props.subheader,
        subheaderTypographyProps = props.subheaderTypographyProps,
        titleProp = props.title,
        titleTypographyProps = props.titleTypographyProps,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$1f);

    var ownerState = _extends$c({}, props, {
      component: component,
      disableTypography: disableTypography
    });

    var classes = useUtilityClasses$Y(ownerState);
    var title = titleProp;

    if (title != null && title.type !== Typography$2 && !disableTypography) {
      title = /*#__PURE__*/jsxRuntime$1.jsx(Typography$2, _extends$c({
        variant: avatar ? 'body2' : 'h5',
        className: classes.title,
        component: "span",
        display: "block"
      }, titleTypographyProps, {
        children: title
      }));
    }

    var subheader = subheaderProp;

    if (subheader != null && subheader.type !== Typography$2 && !disableTypography) {
      subheader = /*#__PURE__*/jsxRuntime$1.jsx(Typography$2, _extends$c({
        variant: avatar ? 'body2' : 'body1',
        className: classes.subheader,
        color: "text.secondary",
        component: "span",
        display: "block"
      }, subheaderTypographyProps, {
        children: subheader
      }));
    }

    return /*#__PURE__*/jsxRuntime$1.jsxs(CardHeaderRoot, _extends$c({
      className: clsx(classes.root, className),
      as: component,
      ref: ref,
      ownerState: ownerState
    }, other, {
      children: [avatar && /*#__PURE__*/jsxRuntime$1.jsx(CardHeaderAvatar, {
        className: classes.avatar,
        ownerState: ownerState,
        children: avatar
      }), /*#__PURE__*/jsxRuntime$1.jsxs(CardHeaderContent, {
        className: classes.content,
        ownerState: ownerState,
        children: [title, subheader]
      }), action && /*#__PURE__*/jsxRuntime$1.jsx(CardHeaderAction, {
        className: classes.action,
        ownerState: ownerState,
        children: action
      })]
    }));
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var BaseCardHeader = CardHeader$1;

  function getCardMediaUtilityClass(slot) {
    return generateUtilityClass('MuiCardMedia', slot);
  }

  generateUtilityClasses('MuiCardMedia', ['root', 'media', 'img']);
  var _excluded$1e = ["children", "className", "component", "image", "src", "style"];

  var useUtilityClasses$X = function useUtilityClasses$X(ownerState) {
    var classes = ownerState.classes,
        isMediaComponent = ownerState.isMediaComponent,
        isImageComponent = ownerState.isImageComponent;
    var slots = {
      root: ['root', isMediaComponent && 'media', isImageComponent && 'img']
    };
    return composeClasses(slots, getCardMediaUtilityClass, classes);
  };

  var CardMediaRoot = styled$1('div', {
    name: 'MuiCardMedia',
    slot: 'Root',
    overridesResolver: function overridesResolver(props, styles) {
      var ownerState = props.ownerState;
      var isMediaComponent = ownerState.isMediaComponent,
          isImageComponent = ownerState.isImageComponent;
      return [styles.root, isMediaComponent && styles.media, isImageComponent && styles.img];
    }
  })(function (_ref118) {
    var ownerState = _ref118.ownerState;
    return _extends$c({
      display: 'block',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center'
    }, ownerState.isMediaComponent && {
      width: '100%'
    }, ownerState.isImageComponent && {
      // ⚠️ object-fit is not supported by IE11.
      objectFit: 'cover'
    });
  });
  var MEDIA_COMPONENTS = ['video', 'audio', 'picture', 'iframe', 'img'];
  var IMAGE_COMPONENTS = ['picture', 'img'];
  var CardMedia$1 = /*#__PURE__*/React__namespace.forwardRef(function CardMedia(inProps, ref) {
    var props = useThemeProps({
      props: inProps,
      name: 'MuiCardMedia'
    });

    var children = props.children,
        className = props.className,
        _props$component12 = props.component,
        component = _props$component12 === void 0 ? 'div' : _props$component12,
        image = props.image,
        src = props.src,
        style = props.style,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$1e);

    var isMediaComponent = MEDIA_COMPONENTS.indexOf(component) !== -1;
    var composedStyle = !isMediaComponent && image ? _extends$c({
      backgroundImage: "url(\"".concat(image, "\")")
    }, style) : style;

    var ownerState = _extends$c({}, props, {
      component: component,
      isMediaComponent: isMediaComponent,
      isImageComponent: IMAGE_COMPONENTS.indexOf(component) !== -1
    });

    var classes = useUtilityClasses$X(ownerState);
    return /*#__PURE__*/jsxRuntime$1.jsx(CardMediaRoot, _extends$c({
      className: clsx(classes.root, className),
      as: component,
      role: !isMediaComponent && image ? 'img' : undefined,
      ref: ref,
      style: composedStyle,
      ownerState: ownerState,
      src: isMediaComponent ? image || src : undefined
    }, other, {
      children: children
    }));
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var BaseCardMedia = CardMedia$1;
  /**
   * @ignore - internal component.
   */

  var FormControlContext = /*#__PURE__*/React__namespace.createContext();

  if (process.env.NODE_ENV !== 'production') {
    FormControlContext.displayName = 'FormControlContext';
  }

  var FormControlContext$1 = FormControlContext;

  function useFormControl() {
    return React__namespace.useContext(FormControlContext$1);
  }

  function getSwitchBaseUtilityClass(slot) {
    return generateUtilityClass('PrivateSwitchBase', slot);
  }

  generateUtilityClasses('PrivateSwitchBase', ['root', 'checked', 'disabled', 'input', 'edgeStart', 'edgeEnd']);
  var _excluded$1d = ["autoFocus", "checked", "checkedIcon", "className", "defaultChecked", "disabled", "disableFocusRipple", "edge", "icon", "id", "inputProps", "inputRef", "name", "onBlur", "onChange", "onFocus", "readOnly", "required", "tabIndex", "type", "value"];

  var useUtilityClasses$W = function useUtilityClasses$W(ownerState) {
    var classes = ownerState.classes,
        checked = ownerState.checked,
        disabled = ownerState.disabled,
        edge = ownerState.edge;
    var slots = {
      root: ['root', checked && 'checked', disabled && 'disabled', edge && "edge".concat(capitalize$1(edge))],
      input: ['input']
    };
    return composeClasses(slots, getSwitchBaseUtilityClass, classes);
  };

  var SwitchBaseRoot = styled$1(ButtonBase$1, {
    skipSx: true
  })(function (_ref119) {
    var ownerState = _ref119.ownerState;
    return _extends$c({
      padding: 9,
      borderRadius: '50%'
    }, ownerState.edge === 'start' && {
      marginLeft: ownerState.size === 'small' ? -3 : -12
    }, ownerState.edge === 'end' && {
      marginRight: ownerState.size === 'small' ? -3 : -12
    });
  });
  var SwitchBaseInput = styled$1('input', {
    skipSx: true
  })({
    cursor: 'inherit',
    position: 'absolute',
    opacity: 0,
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    zIndex: 1
  });
  /**
   * @ignore - internal component.
   */

  var SwitchBase = /*#__PURE__*/React__namespace.forwardRef(function SwitchBase(props, ref) {
    var autoFocus = props.autoFocus,
        checkedProp = props.checked,
        checkedIcon = props.checkedIcon,
        className = props.className,
        defaultChecked = props.defaultChecked,
        disabledProp = props.disabled,
        _props$disableFocusRi4 = props.disableFocusRipple,
        disableFocusRipple = _props$disableFocusRi4 === void 0 ? false : _props$disableFocusRi4,
        _props$edge2 = props.edge,
        edge = _props$edge2 === void 0 ? false : _props$edge2,
        icon = props.icon,
        id = props.id,
        inputProps = props.inputProps,
        inputRef = props.inputRef,
        name = props.name,
        onBlur = props.onBlur,
        onChange = props.onChange,
        onFocus = props.onFocus,
        readOnly = props.readOnly,
        required = props.required,
        tabIndex = props.tabIndex,
        type = props.type,
        value = props.value,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$1d);

    var _useControlled9 = useControlled({
      controlled: checkedProp,
      default: Boolean(defaultChecked),
      name: 'SwitchBase',
      state: 'checked'
    }),
        _useControlled10 = _slicedToArray(_useControlled9, 2),
        checked = _useControlled10[0],
        setCheckedState = _useControlled10[1];

    var muiFormControl = useFormControl();

    var handleFocus = function handleFocus(event) {
      if (onFocus) {
        onFocus(event);
      }

      if (muiFormControl && muiFormControl.onFocus) {
        muiFormControl.onFocus(event);
      }
    };

    var handleBlur = function handleBlur(event) {
      if (onBlur) {
        onBlur(event);
      }

      if (muiFormControl && muiFormControl.onBlur) {
        muiFormControl.onBlur(event);
      }
    };

    var handleInputChange = function handleInputChange(event) {
      // Workaround for https://github.com/facebook/react/issues/9023
      if (event.nativeEvent.defaultPrevented) {
        return;
      }

      var newChecked = event.target.checked;
      setCheckedState(newChecked);

      if (onChange) {
        // TODO v6: remove the second argument.
        onChange(event, newChecked);
      }
    };

    var disabled = disabledProp;

    if (muiFormControl) {
      if (typeof disabled === 'undefined') {
        disabled = muiFormControl.disabled;
      }
    }

    var hasLabelFor = type === 'checkbox' || type === 'radio';

    var ownerState = _extends$c({}, props, {
      checked: checked,
      disabled: disabled,
      disableFocusRipple: disableFocusRipple,
      edge: edge
    });

    var classes = useUtilityClasses$W(ownerState);
    return /*#__PURE__*/jsxRuntime$1.jsxs(SwitchBaseRoot, _extends$c({
      component: "span",
      className: clsx(classes.root, className),
      centerRipple: true,
      focusRipple: !disableFocusRipple,
      disabled: disabled,
      tabIndex: null,
      role: undefined,
      onFocus: handleFocus,
      onBlur: handleBlur,
      ownerState: ownerState,
      ref: ref
    }, other, {
      children: [/*#__PURE__*/jsxRuntime$1.jsx(SwitchBaseInput, _extends$c({
        autoFocus: autoFocus,
        checked: checkedProp,
        defaultChecked: defaultChecked,
        className: classes.input,
        disabled: disabled,
        id: hasLabelFor && id,
        name: name,
        onChange: handleInputChange,
        readOnly: readOnly,
        ref: inputRef,
        required: required,
        ownerState: ownerState,
        tabIndex: tabIndex,
        type: type
      }, type === 'checkbox' && value === undefined ? {} : {
        value: value
      }, inputProps)), checked ? checkedIcon : icon]
    }));
  }); // NB: If changed, please update Checkbox, Switch and Radio
  // so that the API documentation is updated.

  process.env.NODE_ENV !== "production" ? SwitchBase.propTypes = {
    /**
     * If `true`, the `input` element is focused during the first mount.
     */
    autoFocus: PropTypes.bool,

    /**
     * If `true`, the component is checked.
     */
    checked: PropTypes.bool,

    /**
     * The icon to display when the component is checked.
     */
    checkedIcon: PropTypes.node.isRequired,

    /**
     * Override or extend the styles applied to the component.
     * See [CSS API](#css) below for more details.
     */
    classes: PropTypes.object,

    /**
     * @ignore
     */
    className: PropTypes.string,

    /**
     * @ignore
     */
    defaultChecked: PropTypes.bool,

    /**
     * If `true`, the component is disabled.
     */
    disabled: PropTypes.bool,

    /**
     * If `true`, the  keyboard focus ripple is disabled.
     * @default false
     */
    disableFocusRipple: PropTypes.bool,

    /**
     * If given, uses a negative margin to counteract the padding on one
     * side (this is often helpful for aligning the left or right
     * side of the icon with content above or below, without ruining the border
     * size and shape).
     * @default false
     */
    edge: PropTypes.oneOf(['end', 'start', false]),

    /**
     * The icon to display when the component is unchecked.
     */
    icon: PropTypes.node.isRequired,

    /**
     * The id of the `input` element.
     */
    id: PropTypes.string,

    /**
     * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
     */
    inputProps: PropTypes.object,

    /**
     * Pass a ref to the `input` element.
     */
    inputRef: refType$1,

    /*
     * @ignore
     */
    name: PropTypes.string,

    /**
     * @ignore
     */
    onBlur: PropTypes.func,

    /**
     * Callback fired when the state is changed.
     *
     * @param {object} event The event source of the callback.
     * You can pull out the new checked state by accessing `event.target.checked` (boolean).
     */
    onChange: PropTypes.func,

    /**
     * @ignore
     */
    onFocus: PropTypes.func,

    /**
     * It prevents the user from changing the value of the field
     * (not from interacting with the field).
     */
    readOnly: PropTypes.bool,

    /**
     * If `true`, the `input` element is required.
     */
    required: PropTypes.bool,

    /**
     * The system prop that allows defining system overrides as well as additional CSS styles.
     */
    sx: PropTypes.object,

    /**
     * @ignore
     */
    tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

    /**
     * The input component prop `type`.
     */
    type: PropTypes.string.isRequired,

    /**
     * The value of the component.
     */
    value: PropTypes.any
  } : void 0;
  var SwitchBase$1 = SwitchBase;
  var CheckBoxOutlineBlankIcon = createSvgIcon$1( /*#__PURE__*/jsxRuntime$1.jsx("path", {
    d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
  }), 'CheckBoxOutlineBlank');
  var CheckBoxIcon = createSvgIcon$1( /*#__PURE__*/jsxRuntime$1.jsx("path", {
    d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
  }), 'CheckBox');
  var IndeterminateCheckBoxIcon = createSvgIcon$1( /*#__PURE__*/jsxRuntime$1.jsx("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
  }), 'IndeterminateCheckBox');

  function getCheckboxUtilityClass(slot) {
    return generateUtilityClass('MuiCheckbox', slot);
  }

  var checkboxClasses = generateUtilityClasses('MuiCheckbox', ['root', 'checked', 'disabled', 'indeterminate', 'colorPrimary', 'colorSecondary']);
  var checkboxClasses$1 = checkboxClasses;
  var _excluded$1c = ["checkedIcon", "color", "icon", "indeterminate", "indeterminateIcon", "inputProps", "size"];

  var useUtilityClasses$V = function useUtilityClasses$V(ownerState) {
    var classes = ownerState.classes,
        indeterminate = ownerState.indeterminate,
        color = ownerState.color;
    var slots = {
      root: ['root', indeterminate && 'indeterminate', "color".concat(capitalize$1(color))]
    };
    var composedClasses = composeClasses(slots, getCheckboxUtilityClass, classes);
    return _extends$c({}, classes, composedClasses);
  };

  var CheckboxRoot = styled$1(SwitchBase$1, {
    shouldForwardProp: function shouldForwardProp(prop) {
      return rootShouldForwardProp(prop) || prop === 'classes';
    },
    name: 'MuiCheckbox',
    slot: 'Root',
    overridesResolver: function overridesResolver(props, styles) {
      var ownerState = props.ownerState;
      return [styles.root, ownerState.indeterminate && styles.indeterminate, ownerState.color !== 'default' && styles["color".concat(capitalize$1(ownerState.color))]];
    }
  })(function (_ref120) {
    var _ref121;

    var theme = _ref120.theme,
        ownerState = _ref120.ownerState;
    return _extends$c({
      color: theme.palette.text.secondary
    }, !ownerState.disableRipple && {
      '&:hover': {
        backgroundColor: alpha(ownerState.color === 'default' ? theme.palette.action.active : theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    }, ownerState.color !== 'default' && (_ref121 = {}, _defineProperty(_ref121, "&.".concat(checkboxClasses$1.checked, ", &.").concat(checkboxClasses$1.indeterminate), {
      color: theme.palette[ownerState.color].main
    }), _defineProperty(_ref121, "&.".concat(checkboxClasses$1.disabled), {
      color: theme.palette.action.disabled
    }), _ref121));
  });
  var defaultCheckedIcon$1 = /*#__PURE__*/jsxRuntime$1.jsx(CheckBoxIcon, {});
  var defaultIcon$1 = /*#__PURE__*/jsxRuntime$1.jsx(CheckBoxOutlineBlankIcon, {});
  var defaultIndeterminateIcon = /*#__PURE__*/jsxRuntime$1.jsx(IndeterminateCheckBoxIcon, {});
  var Checkbox$1 = /*#__PURE__*/React__namespace.forwardRef(function Checkbox(inProps, ref) {
    var _icon$props$fontSize, _indeterminateIcon$pr;

    var props = useThemeProps({
      props: inProps,
      name: 'MuiCheckbox'
    });

    var _props$checkedIcon = props.checkedIcon,
        checkedIcon = _props$checkedIcon === void 0 ? defaultCheckedIcon$1 : _props$checkedIcon,
        _props$color9 = props.color,
        color = _props$color9 === void 0 ? 'primary' : _props$color9,
        _props$icon = props.icon,
        iconProp = _props$icon === void 0 ? defaultIcon$1 : _props$icon,
        _props$indeterminate = props.indeterminate,
        indeterminate = _props$indeterminate === void 0 ? false : _props$indeterminate,
        _props$indeterminateI = props.indeterminateIcon,
        indeterminateIconProp = _props$indeterminateI === void 0 ? defaultIndeterminateIcon : _props$indeterminateI,
        inputProps = props.inputProps,
        _props$size6 = props.size,
        size = _props$size6 === void 0 ? 'medium' : _props$size6,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$1c);

    var icon = indeterminate ? indeterminateIconProp : iconProp;
    var indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;

    var ownerState = _extends$c({}, props, {
      color: color,
      indeterminate: indeterminate,
      size: size
    });

    var classes = useUtilityClasses$V(ownerState);
    return /*#__PURE__*/jsxRuntime$1.jsx(CheckboxRoot, _extends$c({
      type: "checkbox",
      inputProps: _extends$c({
        'data-indeterminate': indeterminate
      }, inputProps),
      icon: /*#__PURE__*/React__namespace.cloneElement(icon, {
        fontSize: (_icon$props$fontSize = icon.props.fontSize) != null ? _icon$props$fontSize : size
      }),
      checkedIcon: /*#__PURE__*/React__namespace.cloneElement(indeterminateIcon, {
        fontSize: (_indeterminateIcon$pr = indeterminateIcon.props.fontSize) != null ? _indeterminateIcon$pr : size
      }),
      ownerState: ownerState,
      ref: ref
    }, other, {
      classes: classes
    }));
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var BaseCheckbox = Checkbox$1;

  function getCircularProgressUtilityClass(slot) {
    return generateUtilityClass('MuiCircularProgress', slot);
  }

  generateUtilityClasses('MuiCircularProgress', ['root', 'determinate', 'indeterminate', 'colorPrimary', 'colorSecondary', 'svg', 'circle', 'circleDeterminate', 'circleIndeterminate', 'circleDisableShrink']);
  var _excluded$1b = ["className", "color", "disableShrink", "size", "style", "thickness", "value", "variant"];

  var _ = function _(t) {
    return t;
  },
      _t$1,
      _t2,
      _t3,
      _t4;

  var SIZE = 44;
  var circularRotateKeyframe = keyframes(_t$1 || (_t$1 = _(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n"])))));
  var circularDashKeyframe = keyframes(_t2 || (_t2 = _(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  0% {\n    stroke-dasharray: 1px, 200px;\n    stroke-dashoffset: 0;\n  }\n\n  50% {\n    stroke-dasharray: 100px, 200px;\n    stroke-dashoffset: -15px;\n  }\n\n  100% {\n    stroke-dasharray: 100px, 200px;\n    stroke-dashoffset: -125px;\n  }\n"])))));

  var useUtilityClasses$U = function useUtilityClasses$U(ownerState) {
    var classes = ownerState.classes,
        variant = ownerState.variant,
        color = ownerState.color,
        disableShrink = ownerState.disableShrink;
    var slots = {
      root: ['root', variant, "color".concat(capitalize$1(color))],
      svg: ['svg'],
      circle: ['circle', "circle".concat(capitalize$1(variant)), disableShrink && 'circleDisableShrink']
    };
    return composeClasses(slots, getCircularProgressUtilityClass, classes);
  };

  var CircularProgressRoot = styled$1('span', {
    name: 'MuiCircularProgress',
    slot: 'Root',
    overridesResolver: function overridesResolver(props, styles) {
      var ownerState = props.ownerState;
      return [styles.root, styles[ownerState.variant], styles["color".concat(capitalize$1(ownerState.color))]];
    }
  })(function (_ref122) {
    var ownerState = _ref122.ownerState,
        theme = _ref122.theme;
    return _extends$c({
      display: 'inline-block'
    }, ownerState.variant === 'determinate' && {
      transition: theme.transitions.create('transform')
    }, ownerState.color !== 'inherit' && {
      color: theme.palette[ownerState.color].main
    });
  }, function (_ref123) {
    var ownerState = _ref123.ownerState;
    return ownerState.variant === 'indeterminate' && css$1(_t3 || (_t3 = _(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n      animation: ", " 1.4s linear infinite;\n    "])), 0)), circularRotateKeyframe);
  });
  var CircularProgressSVG = styled$1('svg', {
    name: 'MuiCircularProgress',
    slot: 'Svg',
    overridesResolver: function overridesResolver(props, styles) {
      return styles.svg;
    }
  })({
    display: 'block' // Keeps the progress centered

  });
  var CircularProgressCircle = styled$1('circle', {
    name: 'MuiCircularProgress',
    slot: 'Circle',
    overridesResolver: function overridesResolver(props, styles) {
      var ownerState = props.ownerState;
      return [styles.circle, styles["circle".concat(capitalize$1(ownerState.variant))], ownerState.disableShrink && styles.circleDisableShrink];
    }
  })(function (_ref124) {
    var ownerState = _ref124.ownerState,
        theme = _ref124.theme;
    return _extends$c({
      stroke: 'currentColor'
    }, ownerState.variant === 'determinate' && {
      transition: theme.transitions.create('stroke-dashoffset')
    }, ownerState.variant === 'indeterminate' && {
      // Some default value that looks fine waiting for the animation to kicks in.
      strokeDasharray: '80px, 200px',
      strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.

    });
  }, function (_ref125) {
    var ownerState = _ref125.ownerState;
    return ownerState.variant === 'indeterminate' && !ownerState.disableShrink && css$1(_t4 || (_t4 = _(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n      animation: ", " 1.4s ease-in-out infinite;\n    "])), 0)), circularDashKeyframe);
  });
  /**
   * ## ARIA
   *
   * If the progress bar is describing the loading progress of a particular region of a page,
   * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
   * attribute to `true` on that region until it has finished loading.
   */

  var CircularProgress = /*#__PURE__*/React__namespace.forwardRef(function CircularProgress(inProps, ref) {
    var props = useThemeProps({
      props: inProps,
      name: 'MuiCircularProgress'
    });

    var className = props.className,
        _props$color10 = props.color,
        color = _props$color10 === void 0 ? 'primary' : _props$color10,
        _props$disableShrink = props.disableShrink,
        disableShrink = _props$disableShrink === void 0 ? false : _props$disableShrink,
        _props$size7 = props.size,
        size = _props$size7 === void 0 ? 40 : _props$size7,
        style = props.style,
        _props$thickness = props.thickness,
        thickness = _props$thickness === void 0 ? 3.6 : _props$thickness,
        _props$value = props.value,
        value = _props$value === void 0 ? 0 : _props$value,
        _props$variant9 = props.variant,
        variant = _props$variant9 === void 0 ? 'indeterminate' : _props$variant9,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$1b);

    var ownerState = _extends$c({}, props, {
      color: color,
      disableShrink: disableShrink,
      size: size,
      thickness: thickness,
      value: value,
      variant: variant
    });

    var classes = useUtilityClasses$U(ownerState);
    var circleStyle = {};
    var rootStyle = {};
    var rootProps = {};

    if (variant === 'determinate') {
      var circumference = 2 * Math.PI * ((SIZE - thickness) / 2);
      circleStyle.strokeDasharray = circumference.toFixed(3);
      rootProps['aria-valuenow'] = Math.round(value);
      circleStyle.strokeDashoffset = "".concat(((100 - value) / 100 * circumference).toFixed(3), "px");
      rootStyle.transform = 'rotate(-90deg)';
    }

    return /*#__PURE__*/jsxRuntime$1.jsx(CircularProgressRoot, _extends$c({
      className: clsx(classes.root, className),
      style: _extends$c({
        width: size,
        height: size
      }, rootStyle, style),
      ownerState: ownerState,
      ref: ref,
      role: "progressbar"
    }, rootProps, other, {
      children: /*#__PURE__*/jsxRuntime$1.jsx(CircularProgressSVG, {
        className: classes.svg,
        ownerState: ownerState,
        viewBox: "".concat(SIZE / 2, " ").concat(SIZE / 2, " ").concat(SIZE, " ").concat(SIZE),
        children: /*#__PURE__*/jsxRuntime$1.jsx(CircularProgressCircle, {
          className: classes.circle,
          style: circleStyle,
          ownerState: ownerState,
          cx: SIZE,
          cy: SIZE,
          r: (SIZE - thickness) / 2,
          fill: "none",
          strokeWidth: thickness
        })
      })
    }));
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var BaseCircularProgress = CircularProgress;

  function getContainerUtilityClass(slot) {
    return generateUtilityClass('MuiContainer', slot);
  }

  generateUtilityClasses('MuiContainer', ['root', 'disableGutters', 'fixed', 'maxWidthXs', 'maxWidthSm', 'maxWidthMd', 'maxWidthLg', 'maxWidthXl']);
  var _excluded$1a = ["className", "component", "disableGutters", "fixed", "maxWidth"];

  var useUtilityClasses$T = function useUtilityClasses$T(ownerState) {
    var classes = ownerState.classes,
        fixed = ownerState.fixed,
        disableGutters = ownerState.disableGutters,
        maxWidth = ownerState.maxWidth;
    var slots = {
      root: ['root', maxWidth && "maxWidth".concat(capitalize$1(String(maxWidth))), fixed && 'fixed', disableGutters && 'disableGutters']
    };
    return composeClasses(slots, getContainerUtilityClass, classes);
  };

  var ContainerRoot = styled$1('div', {
    name: 'MuiContainer',
    slot: 'Root',
    overridesResolver: function overridesResolver(props, styles) {
      var ownerState = props.ownerState;
      return [styles.root, styles["maxWidth".concat(capitalize$1(String(ownerState.maxWidth)))], ownerState.fixed && styles.fixed, ownerState.disableGutters && styles.disableGutters];
    }
  })(function (_ref126) {
    var theme = _ref126.theme,
        ownerState = _ref126.ownerState;
    return _extends$c({
      width: '100%',
      marginLeft: 'auto',
      boxSizing: 'border-box',
      marginRight: 'auto',
      display: 'block'
    }, !ownerState.disableGutters && _defineProperty({
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    }, theme.breakpoints.up('sm'), {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3)
    }));
  }, function (_ref128) {
    var theme = _ref128.theme,
        ownerState = _ref128.ownerState;
    return ownerState.fixed && Object.keys(theme.breakpoints.values).reduce(function (acc, breakpoint) {
      var value = theme.breakpoints.values[breakpoint];

      if (value !== 0) {
        acc[theme.breakpoints.up(breakpoint)] = {
          maxWidth: "".concat(value).concat(theme.breakpoints.unit)
        };
      }

      return acc;
    }, {});
  }, function (_ref129) {
    var theme = _ref129.theme,
        ownerState = _ref129.ownerState;
    return _extends$c({}, ownerState.maxWidth === 'xs' && _defineProperty({}, theme.breakpoints.up('xs'), {
      maxWidth: Math.max(theme.breakpoints.values.xs, 444)
    }), ownerState.maxWidth && ownerState.maxWidth !== 'xs' && _defineProperty({}, theme.breakpoints.up(ownerState.maxWidth), {
      maxWidth: "".concat(theme.breakpoints.values[ownerState.maxWidth]).concat(theme.breakpoints.unit)
    }));
  });
  var Container$1 = /*#__PURE__*/React__namespace.forwardRef(function Container(inProps, ref) {
    var props = useThemeProps({
      props: inProps,
      name: 'MuiContainer'
    });

    var className = props.className,
        _props$component13 = props.component,
        component = _props$component13 === void 0 ? 'div' : _props$component13,
        _props$disableGutters3 = props.disableGutters,
        disableGutters = _props$disableGutters3 === void 0 ? false : _props$disableGutters3,
        _props$fixed = props.fixed,
        fixed = _props$fixed === void 0 ? false : _props$fixed,
        _props$maxWidth = props.maxWidth,
        maxWidth = _props$maxWidth === void 0 ? 'lg' : _props$maxWidth,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$1a);

    var ownerState = _extends$c({}, props, {
      component: component,
      disableGutters: disableGutters,
      fixed: fixed,
      maxWidth: maxWidth
    });

    var classes = useUtilityClasses$T(ownerState);
    return /*#__PURE__*/jsxRuntime$1.jsx(ContainerRoot, _extends$c({
      as: component,
      ownerState: ownerState,
      className: clsx(classes.root, className),
      ref: ref
    }, other));
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var BaseContainer = Container$1;

  function GlobalStyles(props) {
    return /*#__PURE__*/jsxRuntime$1.jsx(GlobalStyles$1, _extends$c({}, props, {
      defaultTheme: defaultTheme$1
    }));
  }

  process.env.NODE_ENV !== "production" ? void 0 : void 0;

  var html$1 = function html$1(theme, enableColorScheme) {
    return _extends$c({
      WebkitFontSmoothing: 'antialiased',
      // Antialiasing.
      MozOsxFontSmoothing: 'grayscale',
      // Antialiasing.
      // Change from `box-sizing: content-box` so that `width`
      // is not affected by `padding` or `border`.
      boxSizing: 'border-box',
      // Fix font resize problem in iOS
      WebkitTextSizeAdjust: '100%'
    }, enableColorScheme && {
      colorScheme: theme.palette.mode
    });
  };

  var body = function body(theme) {
    return _extends$c({
      color: theme.palette.text.primary
    }, theme.typography.body1, {
      backgroundColor: theme.palette.background.default,
      '@media print': {
        // Save printer ink.
        backgroundColor: theme.palette.common.white
      }
    });
  };

  var styles$6 = function styles$6(theme) {
    var enableColorScheme = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var _theme$components, _theme$components$Mui;

    var defaultStyles = {
      html: html$1(theme, enableColorScheme),
      '*, *::before, *::after': {
        boxSizing: 'inherit'
      },
      'strong, b': {
        fontWeight: theme.typography.fontWeightBold
      },
      body: _extends$c({
        margin: 0
      }, body(theme), {
        // Add support for document.body.requestFullScreen().
        // Other elements, if background transparent, are not supported.
        '&::backdrop': {
          backgroundColor: theme.palette.background.default
        }
      })
    };
    var themeOverrides = (_theme$components = theme.components) == null ? void 0 : (_theme$components$Mui = _theme$components.MuiCssBaseline) == null ? void 0 : _theme$components$Mui.styleOverrides;

    if (themeOverrides) {
      defaultStyles = [defaultStyles, themeOverrides];
    }

    return defaultStyles;
  };
  /**
   * Kickstart an elegant, consistent, and simple baseline to build upon.
   */


  function CssBaseline(inProps) {
    var props = useThemeProps({
      props: inProps,
      name: 'MuiCssBaseline'
    });
    var children = props.children,
        _props$enableColorSch = props.enableColorScheme,
        enableColorScheme = _props$enableColorSch === void 0 ? false : _props$enableColorSch;
    return /*#__PURE__*/jsxRuntime$1.jsxs(React__namespace.Fragment, {
      children: [/*#__PURE__*/jsxRuntime$1.jsx(GlobalStyles, {
        styles: function styles(theme) {
          return styles$6(theme, enableColorScheme);
        }
      }), children]
    });
  }

  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var _excluded$19 = ["BackdropComponent", "closeAfterTransition", "children", "components", "componentsProps", "disableAutoFocus", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "disableScrollLock", "hideBackdrop", "keepMounted"];

  var extendUtilityClasses = function extendUtilityClasses(ownerState) {
    return ownerState.classes;
  };

  var ModalRoot = styled$1('div', {
    name: 'MuiModal',
    slot: 'Root',
    overridesResolver: function overridesResolver(props, styles) {
      var ownerState = props.ownerState;
      return [styles.root, !ownerState.open && ownerState.exited && styles.hidden];
    }
  })(function (_ref132) {
    var theme = _ref132.theme,
        ownerState = _ref132.ownerState;
    return _extends$c({
      position: 'fixed',
      zIndex: theme.zIndex.modal,
      right: 0,
      bottom: 0,
      top: 0,
      left: 0
    }, !ownerState.open && ownerState.exited && {
      visibility: 'hidden'
    });
  });
  var ModalBackdrop = styled$1(Backdrop$1, {
    name: 'MuiModal',
    slot: 'Backdrop',
    overridesResolver: function overridesResolver(props, styles) {
      return styles.backdrop;
    }
  })({
    zIndex: -1
  });
  /**
   * Modal is a lower-level construct that is leveraged by the following components:
   *
   * - [Dialog](/api/dialog/)
   * - [Drawer](/api/drawer/)
   * - [Menu](/api/menu/)
   * - [Popover](/api/popover/)
   *
   * If you are creating a modal dialog, you probably want to use the [Dialog](/api/dialog/) component
   * rather than directly using Modal.
   *
   * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
   */

  var Modal = /*#__PURE__*/React__namespace.forwardRef(function Modal(inProps, ref) {
    var _componentsProps$root;

    var props = useThemeProps({
      name: 'MuiModal',
      props: inProps
    });

    var _props$BackdropCompon = props.BackdropComponent,
        BackdropComponent = _props$BackdropCompon === void 0 ? ModalBackdrop : _props$BackdropCompon,
        _props$closeAfterTran2 = props.closeAfterTransition,
        closeAfterTransition = _props$closeAfterTran2 === void 0 ? false : _props$closeAfterTran2,
        children = props.children,
        _props$components6 = props.components,
        components = _props$components6 === void 0 ? {} : _props$components6,
        _props$componentsProp7 = props.componentsProps,
        componentsProps = _props$componentsProp7 === void 0 ? {} : _props$componentsProp7,
        _props$disableAutoFoc3 = props.disableAutoFocus,
        disableAutoFocus = _props$disableAutoFoc3 === void 0 ? false : _props$disableAutoFoc3,
        _props$disableEnforce3 = props.disableEnforceFocus,
        disableEnforceFocus = _props$disableEnforce3 === void 0 ? false : _props$disableEnforce3,
        _props$disableEscapeK2 = props.disableEscapeKeyDown,
        disableEscapeKeyDown = _props$disableEscapeK2 === void 0 ? false : _props$disableEscapeK2,
        _props$disablePortal5 = props.disablePortal,
        disablePortal = _props$disablePortal5 === void 0 ? false : _props$disablePortal5,
        _props$disableRestore3 = props.disableRestoreFocus,
        disableRestoreFocus = _props$disableRestore3 === void 0 ? false : _props$disableRestore3,
        _props$disableScrollL2 = props.disableScrollLock,
        disableScrollLock = _props$disableScrollL2 === void 0 ? false : _props$disableScrollL2,
        _props$hideBackdrop2 = props.hideBackdrop,
        hideBackdrop = _props$hideBackdrop2 === void 0 ? false : _props$hideBackdrop2,
        _props$keepMounted3 = props.keepMounted,
        keepMounted = _props$keepMounted3 === void 0 ? false : _props$keepMounted3,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$19);

    var _React__namespace$use38 = React__namespace.useState(true),
        _React__namespace$use39 = _slicedToArray(_React__namespace$use38, 2),
        exited = _React__namespace$use39[0],
        setExited = _React__namespace$use39[1];

    var commonProps = {
      closeAfterTransition: closeAfterTransition,
      disableAutoFocus: disableAutoFocus,
      disableEnforceFocus: disableEnforceFocus,
      disableEscapeKeyDown: disableEscapeKeyDown,
      disablePortal: disablePortal,
      disableRestoreFocus: disableRestoreFocus,
      disableScrollLock: disableScrollLock,
      hideBackdrop: hideBackdrop,
      keepMounted: keepMounted
    };

    var ownerState = _extends$c({}, props, commonProps, {
      exited: exited
    });

    var classes = extendUtilityClasses(ownerState);
    return /*#__PURE__*/jsxRuntime$1.jsx(ModalUnstyled$1, _extends$c({
      components: _extends$c({
        Root: ModalRoot
      }, components),
      componentsProps: {
        root: _extends$c({}, componentsProps.root, (!components.Root || !isHostComponent(components.Root)) && {
          ownerState: _extends$c({}, (_componentsProps$root = componentsProps.root) == null ? void 0 : _componentsProps$root.ownerState)
        })
      },
      BackdropComponent: BackdropComponent,
      onTransitionEnter: function onTransitionEnter() {
        return setExited(false);
      },
      onTransitionExited: function onTransitionExited() {
        return setExited(true);
      },
      ref: ref
    }, other, {
      classes: classes
    }, commonProps, {
      children: children
    }));
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var Modal$1 = Modal;

  function getDialogUtilityClass(slot) {
    return generateUtilityClass('MuiDialog', slot);
  }

  var dialogClasses = generateUtilityClasses('MuiDialog', ['root', 'scrollPaper', 'scrollBody', 'container', 'paper', 'paperScrollPaper', 'paperScrollBody', 'paperWidthFalse', 'paperWidthXs', 'paperWidthSm', 'paperWidthMd', 'paperWidthLg', 'paperWidthXl', 'paperFullWidth', 'paperFullScreen']);
  var dialogClasses$1 = dialogClasses;
  var DialogContext = /*#__PURE__*/React.createContext({});

  if (process.env.NODE_ENV !== 'production') {
    DialogContext.displayName = 'DialogContext';
  }

  var DialogContext$1 = DialogContext;
  var _excluded$18 = ["aria-describedby", "aria-labelledby", "BackdropComponent", "BackdropProps", "children", "className", "disableEscapeKeyDown", "fullScreen", "fullWidth", "maxWidth", "onBackdropClick", "onClose", "open", "PaperComponent", "PaperProps", "scroll", "TransitionComponent", "transitionDuration", "TransitionProps"];
  var DialogBackdrop = styled$1(Backdrop$1, {
    name: 'MuiDialog',
    slot: 'Backdrop',
    overrides: function overrides(props, styles) {
      return styles.backdrop;
    }
  })({
    // Improve scrollable dialog support.
    zIndex: -1
  });

  var useUtilityClasses$S = function useUtilityClasses$S(ownerState) {
    var classes = ownerState.classes,
        scroll = ownerState.scroll,
        maxWidth = ownerState.maxWidth,
        fullWidth = ownerState.fullWidth,
        fullScreen = ownerState.fullScreen;
    var slots = {
      root: ['root'],
      container: ['container', "scroll".concat(capitalize$1(scroll))],
      paper: ['paper', "paperScroll".concat(capitalize$1(scroll)), "paperWidth".concat(capitalize$1(String(maxWidth))), fullWidth && 'paperFullWidth', fullScreen && 'paperFullScreen']
    };
    return composeClasses(slots, getDialogUtilityClass, classes);
  };

  var DialogRoot = styled$1(Modal$1, {
    name: 'MuiDialog',
    slot: 'Root',
    overridesResolver: function overridesResolver(props, styles) {
      return styles.root;
    }
  })({
    '@media print': {
      // Use !important to override the Modal inline-style.
      position: 'absolute !important'
    }
  });
  var DialogContainer = styled$1('div', {
    name: 'MuiDialog',
    slot: 'Container',
    overridesResolver: function overridesResolver(props, styles) {
      var ownerState = props.ownerState;
      return [styles.container, styles["scroll".concat(capitalize$1(ownerState.scroll))]];
    }
  })(function (_ref133) {
    var ownerState = _ref133.ownerState;
    return _extends$c({
      height: '100%',
      '@media print': {
        height: 'auto'
      },
      // We disable the focus ring for mouse, touch and keyboard users.
      outline: 0
    }, ownerState.scroll === 'paper' && {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }, ownerState.scroll === 'body' && {
      overflowY: 'auto',
      overflowX: 'hidden',
      textAlign: 'center',
      '&:after': {
        content: '""',
        display: 'inline-block',
        verticalAlign: 'middle',
        height: '100%',
        width: '0'
      }
    });
  });
  var DialogPaper = styled$1(BasePaper, {
    name: 'MuiDialog',
    slot: 'Paper',
    overridesResolver: function overridesResolver(props, styles) {
      var ownerState = props.ownerState;
      return [styles.paper, styles["scrollPaper".concat(capitalize$1(ownerState.scroll))], styles["paperWidth".concat(capitalize$1(String(ownerState.maxWidth)))], ownerState.fullWidth && styles.paperFullWidth, ownerState.fullScreen && styles.paperFullScreen];
    }
  })(function (_ref134) {
    var theme = _ref134.theme,
        ownerState = _ref134.ownerState;
    return _extends$c({
      margin: 32,
      position: 'relative',
      overflowY: 'auto',
      // Fix IE11 issue, to remove at some point.
      '@media print': {
        overflowY: 'visible',
        boxShadow: 'none'
      }
    }, ownerState.scroll === 'paper' && {
      display: 'flex',
      flexDirection: 'column',
      maxHeight: 'calc(100% - 64px)'
    }, ownerState.scroll === 'body' && {
      display: 'inline-block',
      verticalAlign: 'middle',
      textAlign: 'left' // 'initial' doesn't work on IE11

    }, !ownerState.maxWidth && {
      maxWidth: 'calc(100% - 64px)'
    }, ownerState.maxWidth === 'xs' && _defineProperty({
      maxWidth: theme.breakpoints.unit === 'px' ? Math.max(theme.breakpoints.values.xs, 444) : "".concat(theme.breakpoints.values.xs).concat(theme.breakpoints.unit)
    }, "&.".concat(dialogClasses$1.paperScrollBody), _defineProperty({}, theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 32 * 2), {
      maxWidth: 'calc(100% - 64px)'
    })), ownerState.maxWidth !== 'xs' && _defineProperty({
      maxWidth: "".concat(theme.breakpoints.values[ownerState.maxWidth]).concat(theme.breakpoints.unit)
    }, "&.".concat(dialogClasses$1.paperScrollBody), _defineProperty({}, theme.breakpoints.down(theme.breakpoints.values[ownerState.maxWidth] + 32 * 2), {
      maxWidth: 'calc(100% - 64px)'
    })), ownerState.fullWidth && {
      width: 'calc(100% - 64px)'
    }, ownerState.fullScreen && _defineProperty({
      margin: 0,
      width: '100%',
      maxWidth: '100%',
      height: '100%',
      maxHeight: 'none',
      borderRadius: 0
    }, "&.".concat(dialogClasses$1.paperScrollBody), {
      margin: 0,
      maxWidth: '100%'
    }));
  });
  var defaultTransitionDuration$1 = {
    enter: duration.enteringScreen,
    exit: duration.leavingScreen
  };
  /**
   * Dialogs are overlaid modal paper based components with a backdrop.
   */

  var Dialog$1 = /*#__PURE__*/React__namespace.forwardRef(function Dialog(inProps, ref) {
    var props = useThemeProps({
      props: inProps,
      name: 'MuiDialog'
    });

    var ariaDescribedby = props['aria-describedby'],
        ariaLabelledbyProp = props['aria-labelledby'],
        BackdropComponent = props.BackdropComponent,
        BackdropProps = props.BackdropProps,
        children = props.children,
        className = props.className,
        _props$disableEscapeK3 = props.disableEscapeKeyDown,
        disableEscapeKeyDown = _props$disableEscapeK3 === void 0 ? false : _props$disableEscapeK3,
        _props$fullScreen = props.fullScreen,
        fullScreen = _props$fullScreen === void 0 ? false : _props$fullScreen,
        _props$fullWidth4 = props.fullWidth,
        fullWidth = _props$fullWidth4 === void 0 ? false : _props$fullWidth4,
        _props$maxWidth2 = props.maxWidth,
        maxWidth = _props$maxWidth2 === void 0 ? 'sm' : _props$maxWidth2,
        onBackdropClick = props.onBackdropClick,
        onClose = props.onClose,
        open = props.open,
        _props$PaperComponent2 = props.PaperComponent,
        PaperComponent = _props$PaperComponent2 === void 0 ? BasePaper : _props$PaperComponent2,
        _props$PaperProps = props.PaperProps,
        PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
        _props$scroll = props.scroll,
        scroll = _props$scroll === void 0 ? 'paper' : _props$scroll,
        _props$TransitionComp5 = props.TransitionComponent,
        TransitionComponent = _props$TransitionComp5 === void 0 ? Fade$1 : _props$TransitionComp5,
        _props$transitionDura = props.transitionDuration,
        transitionDuration = _props$transitionDura === void 0 ? defaultTransitionDuration$1 : _props$transitionDura,
        TransitionProps = props.TransitionProps,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$18);

    var ownerState = _extends$c({}, props, {
      disableEscapeKeyDown: disableEscapeKeyDown,
      fullScreen: fullScreen,
      fullWidth: fullWidth,
      maxWidth: maxWidth,
      scroll: scroll
    });

    var classes = useUtilityClasses$S(ownerState);
    var backdropClick = React__namespace.useRef();

    var handleMouseDown = function handleMouseDown(event) {
      // We don't want to close the dialog when clicking the dialog content.
      // Make sure the event starts and ends on the same DOM element.
      backdropClick.current = event.target === event.currentTarget;
    };

    var handleBackdropClick = function handleBackdropClick(event) {
      // Ignore the events not coming from the "backdrop".
      if (!backdropClick.current) {
        return;
      }

      backdropClick.current = null;

      if (onBackdropClick) {
        onBackdropClick(event);
      }

      if (onClose) {
        onClose(event, 'backdropClick');
      }
    };

    var ariaLabelledby = useId(ariaLabelledbyProp);
    var dialogContextValue = React__namespace.useMemo(function () {
      return {
        titleId: ariaLabelledby
      };
    }, [ariaLabelledby]);
    return /*#__PURE__*/jsxRuntime$1.jsx(DialogRoot, _extends$c({
      className: clsx(classes.root, className),
      BackdropProps: _extends$c({
        transitionDuration: transitionDuration,
        as: BackdropComponent
      }, BackdropProps),
      closeAfterTransition: true,
      BackdropComponent: DialogBackdrop,
      disableEscapeKeyDown: disableEscapeKeyDown,
      onClose: onClose,
      open: open,
      ref: ref,
      onClick: handleBackdropClick,
      ownerState: ownerState
    }, other, {
      children: /*#__PURE__*/jsxRuntime$1.jsx(TransitionComponent, _extends$c({
        appear: true,
        in: open,
        timeout: transitionDuration,
        role: "presentation"
      }, TransitionProps, {
        children: /*#__PURE__*/jsxRuntime$1.jsx(DialogContainer, {
          className: clsx(classes.container),
          onMouseDown: handleMouseDown,
          ownerState: ownerState,
          children: /*#__PURE__*/jsxRuntime$1.jsx(DialogPaper, _extends$c({
            as: PaperComponent,
            elevation: 24,
            role: "dialog",
            "aria-describedby": ariaDescribedby,
            "aria-labelledby": ariaLabelledby
          }, PaperProps, {
            className: clsx(classes.paper, PaperProps.className),
            ownerState: ownerState,
            children: /*#__PURE__*/jsxRuntime$1.jsx(DialogContext$1.Provider, {
              value: dialogContextValue,
              children: children
            })
          }))
        })
      }))
    }));
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var BaseDialog = Dialog$1;

  function getDialogActionsUtilityClass(slot) {
    return generateUtilityClass('MuiDialogActions', slot);
  }

  generateUtilityClasses('MuiDialogActions', ['root', 'spacing']);
  var _excluded$17 = ["className", "disableSpacing"];

  var useUtilityClasses$R = function useUtilityClasses$R(ownerState) {
    var classes = ownerState.classes,
        disableSpacing = ownerState.disableSpacing;
    var slots = {
      root: ['root', !disableSpacing && 'spacing']
    };
    return composeClasses(slots, getDialogActionsUtilityClass, classes);
  };

  var DialogActionsRoot = styled$1('div', {
    name: 'MuiDialogActions',
    slot: 'Root',
    overridesResolver: function overridesResolver(props, styles) {
      var ownerState = props.ownerState;
      return [styles.root, !ownerState.disableSpacing && styles.spacing];
    }
  })(function (_ref138) {
    var ownerState = _ref138.ownerState;
    return _extends$c({
      display: 'flex',
      alignItems: 'center',
      padding: 8,
      justifyContent: 'flex-end',
      flex: '0 0 auto'
    }, !ownerState.disableSpacing && {
      '& > :not(:first-of-type)': {
        marginLeft: 8
      }
    });
  });
  var DialogActions$1 = /*#__PURE__*/React__namespace.forwardRef(function DialogActions(inProps, ref) {
    var props = useThemeProps({
      props: inProps,
      name: 'MuiDialogActions'
    });

    var className = props.className,
        _props$disableSpacing3 = props.disableSpacing,
        disableSpacing = _props$disableSpacing3 === void 0 ? false : _props$disableSpacing3,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$17);

    var ownerState = _extends$c({}, props, {
      disableSpacing: disableSpacing
    });

    var classes = useUtilityClasses$R(ownerState);
    return /*#__PURE__*/jsxRuntime$1.jsx(DialogActionsRoot, _extends$c({
      className: clsx(classes.root, className),
      ownerState: ownerState,
      ref: ref
    }, other));
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var BaseDialogActions = DialogActions$1;

  function getDialogContentUtilityClass(slot) {
    return generateUtilityClass('MuiDialogContent', slot);
  }

  generateUtilityClasses('MuiDialogContent', ['root', 'dividers']);

  function getDialogTitleUtilityClass(slot) {
    return generateUtilityClass('MuiDialogTitle', slot);
  }

  var dialogTitleClasses = generateUtilityClasses('MuiDialogTitle', ['root']);
  var dialogTitleClasses$1 = dialogTitleClasses;
  var _excluded$16 = ["className", "dividers"];

  var useUtilityClasses$Q = function useUtilityClasses$Q(ownerState) {
    var classes = ownerState.classes,
        dividers = ownerState.dividers;
    var slots = {
      root: ['root', dividers && 'dividers']
    };
    return composeClasses(slots, getDialogContentUtilityClass, classes);
  };

  var DialogContentRoot = styled$1('div', {
    name: 'MuiDialogContent',
    slot: 'Root',
    overridesResolver: function overridesResolver(props, styles) {
      var ownerState = props.ownerState;
      return [styles.root, ownerState.dividers && styles.dividers];
    }
  })(function (_ref139) {
    var theme = _ref139.theme,
        ownerState = _ref139.ownerState;
    return _extends$c({
      flex: '1 1 auto',
      // Add iOS momentum scrolling for iOS < 13.0
      WebkitOverflowScrolling: 'touch',
      overflowY: 'auto',
      padding: '20px 24px'
    }, ownerState.dividers ? {
      padding: '16px 24px',
      borderTop: "1px solid ".concat(theme.palette.divider),
      borderBottom: "1px solid ".concat(theme.palette.divider)
    } : _defineProperty({}, ".".concat(dialogTitleClasses$1.root, " + &"), {
      paddingTop: 0
    }));
  });
  var DialogContent$1 = /*#__PURE__*/React__namespace.forwardRef(function DialogContent(inProps, ref) {
    var props = useThemeProps({
      props: inProps,
      name: 'MuiDialogContent'
    });

    var className = props.className,
        _props$dividers = props.dividers,
        dividers = _props$dividers === void 0 ? false : _props$dividers,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$16);

    var ownerState = _extends$c({}, props, {
      dividers: dividers
    });

    var classes = useUtilityClasses$Q(ownerState);
    return /*#__PURE__*/jsxRuntime$1.jsx(DialogContentRoot, _extends$c({
      className: clsx(classes.root, className),
      ownerState: ownerState,
      ref: ref
    }, other));
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var BaseDialogContent = DialogContent$1;

  function getDialogContentTextUtilityClass(slot) {
    return generateUtilityClass('MuiDialogContentText', slot);
  }

  generateUtilityClasses('MuiDialogContentText', ['root']);
  var _excluded$15 = ["children"];

  var useUtilityClasses$P = function useUtilityClasses$P(ownerState) {
    var classes = ownerState.classes;
    var slots = {
      root: ['root']
    };
    var composedClasses = composeClasses(slots, getDialogContentTextUtilityClass, classes);
    return _extends$c({}, classes, composedClasses);
  };

  var DialogContentTextRoot = styled$1(Typography$2, {
    shouldForwardProp: function shouldForwardProp(prop) {
      return rootShouldForwardProp(prop) || prop === 'classes';
    },
    name: 'MuiDialogContentText',
    slot: 'Root',
    overridesResolver: function overridesResolver(props, styles) {
      return styles.root;
    }
  })({});
  var DialogContentText$1 = /*#__PURE__*/React__namespace.forwardRef(function DialogContentText(inProps, ref) {
    var props = useThemeProps({
      props: inProps,
      name: 'MuiDialogContentText'
    });

    var ownerState = _objectWithoutPropertiesLoose$6(props, _excluded$15);

    var classes = useUtilityClasses$P(ownerState);
    return /*#__PURE__*/jsxRuntime$1.jsx(DialogContentTextRoot, _extends$c({
      component: "p",
      variant: "body1",
      color: "text.secondary",
      ref: ref,
      ownerState: ownerState
    }, props, {
      classes: classes
    }));
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var BaseDialogContentText = DialogContentText$1;
  var _excluded$14 = ["className", "id"];

  var useUtilityClasses$O = function useUtilityClasses$O(ownerState) {
    var classes = ownerState.classes;
    var slots = {
      root: ['root']
    };
    return composeClasses(slots, getDialogTitleUtilityClass, classes);
  };

  var DialogTitleRoot = styled$1(Typography$2, {
    name: 'MuiDialogTitle',
    slot: 'Root',
    overridesResolver: function overridesResolver(props, styles) {
      return styles.root;
    }
  })({
    padding: '16px 24px',
    flex: '0 0 auto'
  });
  var DialogTitle$1 = /*#__PURE__*/React__namespace.forwardRef(function DialogTitle(inProps, ref) {
    var props = useThemeProps({
      props: inProps,
      name: 'MuiDialogTitle'
    });

    var className = props.className,
        idProp = props.id,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$14);

    var ownerState = props;
    var classes = useUtilityClasses$O(ownerState);

    var _React__namespace$use40 = React__namespace.useContext(DialogContext$1),
        _React__namespace$use41 = _React__namespace$use40.titleId,
        id = _React__namespace$use41 === void 0 ? idProp : _React__namespace$use41;

    return /*#__PURE__*/jsxRuntime$1.jsx(DialogTitleRoot, _extends$c({
      component: "h2",
      className: clsx(classes.root, className),
      ownerState: ownerState,
      ref: ref,
      variant: "h6",
      id: id
    }, other));
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var BaseDialogTitle = DialogTitle$1;
  var dividerClasses = generateUtilityClasses('MuiDivider', ['root', 'absolute', 'fullWidth', 'inset', 'middle', 'flexItem', 'light', 'vertical', 'withChildren', 'withChildrenVertical', 'textAlignRight', 'textAlignLeft', 'wrapper', 'wrapperVertical']);
  var dividerClasses$1 = dividerClasses;
  var _excluded$13 = ["addEndListener", "appear", "children", "container", "direction", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"];

  function getTranslateValue(direction, node, resolvedContainer) {
    var rect = node.getBoundingClientRect();
    var containerRect = resolvedContainer && resolvedContainer.getBoundingClientRect();
    var containerWindow = ownerWindow(node);
    var transform;

    if (node.fakeTransform) {
      transform = node.fakeTransform;
    } else {
      var computedStyle = containerWindow.getComputedStyle(node);
      transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');
    }

    var offsetX = 0;
    var offsetY = 0;

    if (transform && transform !== 'none' && typeof transform === 'string') {
      var transformValues = transform.split('(')[1].split(')')[0].split(',');
      offsetX = parseInt(transformValues[4], 10);
      offsetY = parseInt(transformValues[5], 10);
    }

    if (direction === 'left') {
      if (containerRect) {
        return "translateX(".concat(containerRect.right + offsetX - rect.left, "px)");
      }

      return "translateX(".concat(containerWindow.innerWidth + offsetX - rect.left, "px)");
    }

    if (direction === 'right') {
      if (containerRect) {
        return "translateX(-".concat(rect.right - containerRect.left - offsetX, "px)");
      }

      return "translateX(-".concat(rect.left + rect.width - offsetX, "px)");
    }

    if (direction === 'up') {
      if (containerRect) {
        return "translateY(".concat(containerRect.bottom + offsetY - rect.top, "px)");
      }

      return "translateY(".concat(containerWindow.innerHeight + offsetY - rect.top, "px)");
    } // direction === 'down'


    if (containerRect) {
      return "translateY(-".concat(rect.top - containerRect.top + rect.height - offsetY, "px)");
    }

    return "translateY(-".concat(rect.top + rect.height - offsetY, "px)");
  }

  function resolveContainer(containerPropProp) {
    return typeof containerPropProp === 'function' ? containerPropProp() : containerPropProp;
  }

  function setTranslateValue(direction, node, containerProp) {
    var resolvedContainer = resolveContainer(containerProp);
    var transform = getTranslateValue(direction, node, resolvedContainer);

    if (transform) {
      node.style.webkitTransform = transform;
      node.style.transform = transform;
    }
  }

  var defaultEasing = {
    enter: easing.easeOut,
    exit: easing.sharp
  };
  var defaultTimeout = {
    enter: duration.enteringScreen,
    exit: duration.leavingScreen
  };
  /**
   * The Slide transition is used by the [Drawer](/components/drawers/) component.
   * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
   */

  var Slide$1 = /*#__PURE__*/React__namespace.forwardRef(function Slide(props, ref) {
    var addEndListener = props.addEndListener,
        _props$appear2 = props.appear,
        appear = _props$appear2 === void 0 ? true : _props$appear2,
        _children3 = props.children,
        containerProp = props.container,
        _props$direction2 = props.direction,
        direction = _props$direction2 === void 0 ? 'down' : _props$direction2,
        _props$easing = props.easing,
        easingProp = _props$easing === void 0 ? defaultEasing : _props$easing,
        inProp = props.in,
        onEnter = props.onEnter,
        onEntered = props.onEntered,
        onEntering = props.onEntering,
        onExit = props.onExit,
        onExited = props.onExited,
        onExiting = props.onExiting,
        style = props.style,
        _props$timeout3 = props.timeout,
        timeout = _props$timeout3 === void 0 ? defaultTimeout : _props$timeout3,
        _props$TransitionComp6 = props.TransitionComponent,
        TransitionComponent = _props$TransitionComp6 === void 0 ? Transition$1 : _props$TransitionComp6,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$13);

    var theme = useTheme();
    var childrenRef = React__namespace.useRef(null);
    var handleRefIntermediary = useForkRef(_children3.ref, childrenRef);
    var handleRef = useForkRef(handleRefIntermediary, ref);

    var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
      return function (isAppearing) {
        if (callback) {
          // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
          if (isAppearing === undefined) {
            callback(childrenRef.current);
          } else {
            callback(childrenRef.current, isAppearing);
          }
        }
      };
    };

    var handleEnter = normalizedTransitionCallback(function (node, isAppearing) {
      setTranslateValue(direction, node, containerProp);
      reflow(node);

      if (onEnter) {
        onEnter(node, isAppearing);
      }
    });
    var handleEntering = normalizedTransitionCallback(function (node, isAppearing) {
      var transitionProps = getTransitionProps({
        timeout: timeout,
        style: style,
        easing: easingProp
      }, {
        mode: 'enter'
      });
      node.style.webkitTransition = theme.transitions.create('-webkit-transform', _extends$c({}, transitionProps));
      node.style.transition = theme.transitions.create('transform', _extends$c({}, transitionProps));
      node.style.webkitTransform = 'none';
      node.style.transform = 'none';

      if (onEntering) {
        onEntering(node, isAppearing);
      }
    });
    var handleEntered = normalizedTransitionCallback(onEntered);
    var handleExiting = normalizedTransitionCallback(onExiting);
    var handleExit = normalizedTransitionCallback(function (node) {
      var transitionProps = getTransitionProps({
        timeout: timeout,
        style: style,
        easing: easingProp
      }, {
        mode: 'exit'
      });
      node.style.webkitTransition = theme.transitions.create('-webkit-transform', transitionProps);
      node.style.transition = theme.transitions.create('transform', transitionProps);
      setTranslateValue(direction, node, containerProp);

      if (onExit) {
        onExit(node);
      }
    });
    var handleExited = normalizedTransitionCallback(function (node) {
      // No need for transitions when the component is hidden
      node.style.webkitTransition = '';
      node.style.transition = '';

      if (onExited) {
        onExited(node);
      }
    });

    var handleAddEndListener = function handleAddEndListener(next) {
      if (addEndListener) {
        // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(childrenRef.current, next);
      }
    };

    var updatePosition = React__namespace.useCallback(function () {
      if (childrenRef.current) {
        setTranslateValue(direction, childrenRef.current, containerProp);
      }
    }, [direction, containerProp]);
    React__namespace.useEffect(function () {
      // Skip configuration where the position is screen size invariant.
      if (inProp || direction === 'down' || direction === 'right') {
        return undefined;
      }

      var handleResize = debounce$1(function () {
        if (childrenRef.current) {
          setTranslateValue(direction, childrenRef.current, containerProp);
        }
      });
      var containerWindow = ownerWindow(childrenRef.current);
      containerWindow.addEventListener('resize', handleResize);
      return function () {
        handleResize.clear();
        containerWindow.removeEventListener('resize', handleResize);
      };
    }, [direction, inProp, containerProp]);
    React__namespace.useEffect(function () {
      if (!inProp) {
        // We need to update the position of the drawer when the direction change and
        // when it's hidden.
        updatePosition();
      }
    }, [inProp, updatePosition]);
    return /*#__PURE__*/jsxRuntime$1.jsx(TransitionComponent, _extends$c({
      nodeRef: childrenRef,
      onEnter: handleEnter,
      onEntered: handleEntered,
      onEntering: handleEntering,
      onExit: handleExit,
      onExited: handleExited,
      onExiting: handleExiting,
      addEndListener: handleAddEndListener,
      appear: appear,
      in: inProp,
      timeout: timeout
    }, other, {
      children: function children(state, childProps) {
        return /*#__PURE__*/React__namespace.cloneElement(_children3, _extends$c({
          ref: handleRef,
          style: _extends$c({
            visibility: state === 'exited' && !inProp ? 'hidden' : undefined
          }, style, _children3.props.style)
        }, childProps));
      }
    }));
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var Slide$2 = Slide$1;

  function getDrawerUtilityClass(slot) {
    return generateUtilityClass('MuiDrawer', slot);
  }

  generateUtilityClasses('MuiDrawer', ['root', 'docked', 'paper', 'paperAnchorLeft', 'paperAnchorRight', 'paperAnchorTop', 'paperAnchorBottom', 'paperAnchorDockedLeft', 'paperAnchorDockedRight', 'paperAnchorDockedTop', 'paperAnchorDockedBottom', 'modal']);
  var _excluded$12 = ["BackdropProps"],
      _excluded2$4 = ["anchor", "BackdropProps", "children", "className", "elevation", "hideBackdrop", "ModalProps", "onClose", "open", "PaperProps", "SlideProps", "TransitionComponent", "transitionDuration", "variant"];

  var overridesResolver$3 = function overridesResolver$3(props, styles) {
    var ownerState = props.ownerState;
    return [styles.root, (ownerState.variant === 'permanent' || ownerState.variant === 'persistent') && styles.docked, styles.modal];
  };

  var useUtilityClasses$N = function useUtilityClasses$N(ownerState) {
    var classes = ownerState.classes,
        anchor = ownerState.anchor,
        variant = ownerState.variant;
    var slots = {
      root: ['root'],
      docked: [(variant === 'permanent' || variant === 'persistent') && 'docked'],
      modal: ['modal'],
      paper: ['paper', "paperAnchor".concat(capitalize$1(anchor)), variant !== 'temporary' && "paperAnchorDocked".concat(capitalize$1(anchor))]
    };
    return composeClasses(slots, getDrawerUtilityClass, classes);
  };

  var DrawerRoot = styled$1(Modal$1, {
    name: 'MuiDrawer',
    slot: 'Root',
    overridesResolver: overridesResolver$3
  })(function (_ref141) {
    var theme = _ref141.theme;
    return {
      zIndex: theme.zIndex.drawer
    };
  });
  var DrawerDockedRoot = styled$1('div', {
    shouldForwardProp: rootShouldForwardProp,
    name: 'MuiDrawer',
    slot: 'Docked',
    skipVariantsResolver: false,
    overridesResolver: overridesResolver$3
  })({
    flex: '0 0 auto'
  });
  var DrawerPaper = styled$1(BasePaper, {
    name: 'MuiDrawer',
    slot: 'Paper',
    overridesResolver: function overridesResolver(props, styles) {
      var ownerState = props.ownerState;
      return [styles.paper, styles["paperAnchor".concat(capitalize$1(ownerState.anchor))], ownerState.variant !== 'temporary' && styles["paperAnchorDocked".concat(capitalize$1(ownerState.anchor))]];
    }
  })(function (_ref142) {
    var theme = _ref142.theme,
        ownerState = _ref142.ownerState;
    return _extends$c({
      overflowY: 'auto',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      flex: '1 0 auto',
      zIndex: theme.zIndex.drawer,
      // Add iOS momentum scrolling for iOS < 13.0
      WebkitOverflowScrolling: 'touch',
      // temporary style
      position: 'fixed',
      top: 0,
      // We disable the focus ring for mouse, touch and keyboard users.
      // At some point, it would be better to keep it for keyboard users.
      // :focus-ring CSS pseudo-class will help.
      outline: 0
    }, ownerState.anchor === 'left' && {
      left: 0
    }, ownerState.anchor === 'top' && {
      top: 0,
      left: 0,
      right: 0,
      height: 'auto',
      maxHeight: '100%'
    }, ownerState.anchor === 'right' && {
      right: 0
    }, ownerState.anchor === 'bottom' && {
      top: 'auto',
      left: 0,
      bottom: 0,
      right: 0,
      height: 'auto',
      maxHeight: '100%'
    }, ownerState.anchor === 'left' && ownerState.variant !== 'temporary' && {
      borderRight: "1px solid ".concat(theme.palette.divider)
    }, ownerState.anchor === 'top' && ownerState.variant !== 'temporary' && {
      borderBottom: "1px solid ".concat(theme.palette.divider)
    }, ownerState.anchor === 'right' && ownerState.variant !== 'temporary' && {
      borderLeft: "1px solid ".concat(theme.palette.divider)
    }, ownerState.anchor === 'bottom' && ownerState.variant !== 'temporary' && {
      borderTop: "1px solid ".concat(theme.palette.divider)
    });
  });
  var oppositeDirection = {
    left: 'right',
    right: 'left',
    top: 'down',
    bottom: 'up'
  };

  function isHorizontal(anchor) {
    return ['left', 'right'].indexOf(anchor) !== -1;
  }

  function getAnchor(theme, anchor) {
    return theme.direction === 'rtl' && isHorizontal(anchor) ? oppositeDirection[anchor] : anchor;
  }

  var defaultTransitionDuration = {
    enter: duration.enteringScreen,
    exit: duration.leavingScreen
  };
  /**
   * The props of the [Modal](/api/modal/) component are available
   * when `variant="temporary"` is set.
   */

  var Drawer$1 = /*#__PURE__*/React__namespace.forwardRef(function Drawer(inProps, ref) {
    var props = useThemeProps({
      props: inProps,
      name: 'MuiDrawer'
    });
    var _props$anchor = props.anchor,
        anchorProp = _props$anchor === void 0 ? 'left' : _props$anchor,
        BackdropProps = props.BackdropProps,
        children = props.children,
        className = props.className,
        _props$elevation2 = props.elevation,
        elevation = _props$elevation2 === void 0 ? 16 : _props$elevation2,
        _props$hideBackdrop3 = props.hideBackdrop,
        hideBackdrop = _props$hideBackdrop3 === void 0 ? false : _props$hideBackdrop3,
        _props$ModalProps = props.ModalProps;
    _props$ModalProps = _props$ModalProps === void 0 ? {} : _props$ModalProps;

    var BackdropPropsProp = _props$ModalProps.BackdropProps,
        onClose = props.onClose,
        _props$open = props.open,
        open = _props$open === void 0 ? false : _props$open,
        _props$PaperProps2 = props.PaperProps,
        PaperProps = _props$PaperProps2 === void 0 ? {} : _props$PaperProps2,
        SlideProps = props.SlideProps,
        _props$TransitionComp7 = props.TransitionComponent,
        TransitionComponent = _props$TransitionComp7 === void 0 ? Slide$2 : _props$TransitionComp7,
        _props$transitionDura2 = props.transitionDuration,
        transitionDuration = _props$transitionDura2 === void 0 ? defaultTransitionDuration : _props$transitionDura2,
        _props$variant10 = props.variant,
        variant = _props$variant10 === void 0 ? 'temporary' : _props$variant10,
        ModalProps = _objectWithoutPropertiesLoose$6(props.ModalProps, _excluded$12),
        other = _objectWithoutPropertiesLoose$6(props, _excluded2$4);

    var theme = useTheme(); // Let's assume that the Drawer will always be rendered on user space.
    // We use this state is order to skip the appear transition during the
    // initial mount of the component.

    var mounted = React__namespace.useRef(false);
    React__namespace.useEffect(function () {
      mounted.current = true;
    }, []);
    var anchorInvariant = getAnchor(theme, anchorProp);
    var anchor = anchorProp;

    var ownerState = _extends$c({}, props, {
      anchor: anchor,
      elevation: elevation,
      open: open,
      variant: variant
    }, other);

    var classes = useUtilityClasses$N(ownerState);
    var drawer = /*#__PURE__*/jsxRuntime$1.jsx(DrawerPaper, _extends$c({
      elevation: variant === 'temporary' ? elevation : 0,
      square: true
    }, PaperProps, {
      className: clsx(classes.paper, PaperProps.className),
      ownerState: ownerState,
      children: children
    }));

    if (variant === 'permanent') {
      return /*#__PURE__*/jsxRuntime$1.jsx(DrawerDockedRoot, _extends$c({
        className: clsx(classes.root, classes.docked, className),
        ownerState: ownerState,
        ref: ref
      }, other, {
        children: drawer
      }));
    }

    var slidingDrawer = /*#__PURE__*/jsxRuntime$1.jsx(TransitionComponent, _extends$c({
      in: open,
      direction: oppositeDirection[anchorInvariant],
      timeout: transitionDuration,
      appear: mounted.current
    }, SlideProps, {
      children: drawer
    }));

    if (variant === 'persistent') {
      return /*#__PURE__*/jsxRuntime$1.jsx(DrawerDockedRoot, _extends$c({
        className: clsx(classes.root, classes.docked, className),
        ownerState: ownerState,
        ref: ref
      }, other, {
        children: slidingDrawer
      }));
    } // variant === temporary


    return /*#__PURE__*/jsxRuntime$1.jsx(DrawerRoot, _extends$c({
      BackdropProps: _extends$c({}, BackdropProps, BackdropPropsProp, {
        transitionDuration: transitionDuration
      }),
      className: clsx(classes.root, classes.modal, className),
      open: open,
      ownerState: ownerState,
      onClose: onClose,
      hideBackdrop: hideBackdrop,
      ref: ref
    }, other, ModalProps, {
      children: slidingDrawer
    }));
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var BaseDrawer = Drawer$1;

  function formControlState(_ref143) {
    var props = _ref143.props,
        states = _ref143.states,
        muiFormControl = _ref143.muiFormControl;
    return states.reduce(function (acc, state) {
      acc[state] = props[state];

      if (muiFormControl) {
        if (typeof props[state] === 'undefined') {
          acc[state] = muiFormControl[state];
        }
      }

      return acc;
    }, {});
  } // Supports determination of isControlled().
  // Controlled input accepts its current value as a prop.
  //
  // @see https://facebook.github.io/react/docs/forms.html#controlled-components
  // @param value
  // @returns {boolean} true if string (including '') or number (including zero)


  function hasValue(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
  } // Determine if field is empty or filled.
  // Response determines if label is presented above field or as placeholder.
  //
  // @param obj
  // @param SSR
  // @returns {boolean} False when not present or empty string.
  //                    True when any number or string with length.


  function isFilled(obj) {
    var SSR = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return obj && (hasValue(obj.value) && obj.value !== '' || SSR && hasValue(obj.defaultValue) && obj.defaultValue !== '');
  } // Determine if an Input is adorned on start.
  // It's corresponding to the left with LTR.
  //
  // @param obj
  // @returns {boolean} False when no adornments.
  //                    True when adorned at the start.


  function isAdornedStart(obj) {
    return obj.startAdornment;
  }

  var _excluded$11 = ["aria-describedby", "autoComplete", "autoFocus", "className", "color", "components", "componentsProps", "defaultValue", "disabled", "endAdornment", "error", "fullWidth", "id", "inputComponent", "inputProps", "inputRef", "margin", "maxRows", "minRows", "multiline", "name", "onBlur", "onChange", "onClick", "onFocus", "onKeyDown", "onKeyUp", "placeholder", "readOnly", "renderSuffix", "rows", "size", "startAdornment", "type", "value"];

  var rootOverridesResolver = function rootOverridesResolver(props, styles) {
    var ownerState = props.ownerState;
    return [styles.root, ownerState.formControl && styles.formControl, ownerState.startAdornment && styles.adornedStart, ownerState.endAdornment && styles.adornedEnd, ownerState.error && styles.error, ownerState.size === 'small' && styles.sizeSmall, ownerState.multiline && styles.multiline, ownerState.color && styles["color".concat(capitalize$1(ownerState.color))], ownerState.fullWidth && styles.fullWidth, ownerState.hiddenLabel && styles.hiddenLabel];
  };

  var inputOverridesResolver = function inputOverridesResolver(props, styles) {
    var ownerState = props.ownerState;
    return [styles.input, ownerState.size === 'small' && styles.inputSizeSmall, ownerState.multiline && styles.inputMultiline, ownerState.type === 'search' && styles.inputTypeSearch, ownerState.startAdornment && styles.inputAdornedStart, ownerState.endAdornment && styles.inputAdornedEnd, ownerState.hiddenLabel && styles.inputHiddenLabel];
  };

  var useUtilityClasses$M = function useUtilityClasses$M(ownerState) {
    var classes = ownerState.classes,
        color = ownerState.color,
        disabled = ownerState.disabled,
        error = ownerState.error,
        endAdornment = ownerState.endAdornment,
        focused = ownerState.focused,
        formControl = ownerState.formControl,
        fullWidth = ownerState.fullWidth,
        hiddenLabel = ownerState.hiddenLabel,
        multiline = ownerState.multiline,
        size = ownerState.size,
        startAdornment = ownerState.startAdornment,
        type = ownerState.type;
    var slots = {
      root: ['root', "color".concat(capitalize$1(color)), disabled && 'disabled', error && 'error', fullWidth && 'fullWidth', focused && 'focused', formControl && 'formControl', size === 'small' && 'sizeSmall', multiline && 'multiline', startAdornment && 'adornedStart', endAdornment && 'adornedEnd', hiddenLabel && 'hiddenLabel'],
      input: ['input', disabled && 'disabled', type === 'search' && 'inputTypeSearch', multiline && 'inputMultiline', size === 'small' && 'inputSizeSmall', hiddenLabel && 'inputHiddenLabel', startAdornment && 'inputAdornedStart', endAdornment && 'inputAdornedEnd']
    };
    return composeClasses(slots, getInputBaseUtilityClass, classes);
  };

  var InputBaseRoot = styled$1('div', {
    name: 'MuiInputBase',
    slot: 'Root',
    overridesResolver: rootOverridesResolver
  })(function (_ref144) {
    var theme = _ref144.theme,
        ownerState = _ref144.ownerState;
    return _extends$c({}, theme.typography.body1, _defineProperty({
      color: theme.palette.text.primary,
      lineHeight: '1.4375em',
      // 23px
      boxSizing: 'border-box',
      // Prevent padding issue with fullWidth.
      position: 'relative',
      cursor: 'text',
      display: 'inline-flex',
      alignItems: 'center'
    }, "&.".concat(inputBaseClasses$1.disabled), {
      color: theme.palette.text.disabled,
      cursor: 'default'
    }), ownerState.multiline && _extends$c({
      padding: '4px 0 5px'
    }, ownerState.size === 'small' && {
      paddingTop: 1
    }), ownerState.fullWidth && {
      width: '100%'
    });
  });
  var InputBaseComponent = styled$1('input', {
    name: 'MuiInputBase',
    slot: 'Input',
    overridesResolver: inputOverridesResolver
  })(function (_ref145) {
    var _extends$c12;

    var theme = _ref145.theme,
        ownerState = _ref145.ownerState;
    var light = theme.palette.mode === 'light';
    var placeholder = {
      color: 'currentColor',
      opacity: light ? 0.42 : 0.5,
      transition: theme.transitions.create('opacity', {
        duration: theme.transitions.duration.shorter
      })
    };
    var placeholderHidden = {
      opacity: '0 !important'
    };
    var placeholderVisible = {
      opacity: light ? 0.42 : 0.5
    };
    return _extends$c((_extends$c12 = {
      font: 'inherit',
      letterSpacing: 'inherit',
      color: 'currentColor',
      padding: '4px 0 5px',
      border: 0,
      boxSizing: 'content-box',
      background: 'none',
      height: '1.4375em',
      // Reset 23pxthe native input line-height
      margin: 0,
      // Reset for Safari
      WebkitTapHighlightColor: 'transparent',
      display: 'block',
      // Make the flex item shrink with Firefox
      minWidth: 0,
      width: '100%',
      // Fix IE11 width issue
      animationName: 'mui-auto-fill-cancel',
      animationDuration: '10ms',
      '&::-webkit-input-placeholder': placeholder,
      '&::-moz-placeholder': placeholder,
      // Firefox 19+
      '&:-ms-input-placeholder': placeholder,
      // IE11
      '&::-ms-input-placeholder': placeholder,
      // Edge
      '&:focus': {
        outline: 0
      },
      // Reset Firefox invalid required input style
      '&:invalid': {
        boxShadow: 'none'
      },
      '&::-webkit-search-decoration': {
        // Remove the padding when type=search.
        WebkitAppearance: 'none'
      }
    }, _defineProperty(_extends$c12, "label[data-shrink=false] + .".concat(inputBaseClasses$1.formControl, " &"), {
      '&::-webkit-input-placeholder': placeholderHidden,
      '&::-moz-placeholder': placeholderHidden,
      // Firefox 19+
      '&:-ms-input-placeholder': placeholderHidden,
      // IE11
      '&::-ms-input-placeholder': placeholderHidden,
      // Edge
      '&:focus::-webkit-input-placeholder': placeholderVisible,
      '&:focus::-moz-placeholder': placeholderVisible,
      // Firefox 19+
      '&:focus:-ms-input-placeholder': placeholderVisible,
      // IE11
      '&:focus::-ms-input-placeholder': placeholderVisible // Edge

    }), _defineProperty(_extends$c12, "&.".concat(inputBaseClasses$1.disabled), {
      opacity: 1,
      // Reset iOS opacity
      WebkitTextFillColor: theme.palette.text.disabled // Fix opacity Safari bug

    }), _defineProperty(_extends$c12, '&:-webkit-autofill', {
      animationDuration: '5000s',
      animationName: 'mui-auto-fill'
    }), _extends$c12), ownerState.size === 'small' && {
      paddingTop: 1
    }, ownerState.multiline && {
      height: 'auto',
      resize: 'none',
      padding: 0,
      paddingTop: 0
    }, ownerState.type === 'search' && {
      // Improve type search style.
      MozAppearance: 'textfield'
    });
  });
  var inputGlobalStyles = /*#__PURE__*/jsxRuntime$1.jsx(GlobalStyles, {
    styles: {
      '@keyframes mui-auto-fill': {
        from: {
          display: 'block'
        }
      },
      '@keyframes mui-auto-fill-cancel': {
        from: {
          display: 'block'
        }
      }
    }
  });
  /**
   * `InputBase` contains as few styles as possible.
   * It aims to be a simple building block for creating an input.
   * It contains a load of style reset and some state logic.
   */

  var InputBase = /*#__PURE__*/React__namespace.forwardRef(function InputBase(inProps, ref) {
    var props = useThemeProps({
      props: inProps,
      name: 'MuiInputBase'
    });

    var ariaDescribedby = props['aria-describedby'],
        autoComplete = props.autoComplete,
        autoFocus = props.autoFocus,
        className = props.className,
        _props$components7 = props.components,
        components = _props$components7 === void 0 ? {} : _props$components7,
        _props$componentsProp8 = props.componentsProps,
        componentsProps = _props$componentsProp8 === void 0 ? {} : _props$componentsProp8,
        defaultValue = props.defaultValue,
        disabled = props.disabled,
        endAdornment = props.endAdornment,
        _props$fullWidth5 = props.fullWidth,
        fullWidth = _props$fullWidth5 === void 0 ? false : _props$fullWidth5,
        id = props.id,
        _props$inputComponent = props.inputComponent,
        inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent,
        _props$inputProps = props.inputProps,
        inputPropsProp = _props$inputProps === void 0 ? {} : _props$inputProps,
        inputRefProp = props.inputRef,
        maxRows = props.maxRows,
        minRows = props.minRows,
        _props$multiline = props.multiline,
        multiline = _props$multiline === void 0 ? false : _props$multiline,
        name = props.name,
        onBlur = props.onBlur,
        onChange = props.onChange,
        onClick = props.onClick,
        onFocus = props.onFocus,
        onKeyDown = props.onKeyDown,
        onKeyUp = props.onKeyUp,
        placeholder = props.placeholder,
        readOnly = props.readOnly,
        renderSuffix = props.renderSuffix,
        rows = props.rows,
        startAdornment = props.startAdornment,
        _props$type = props.type,
        type = _props$type === void 0 ? 'text' : _props$type,
        valueProp = props.value,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$11);

    var value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;

    var _React__namespace$use42 = React__namespace.useRef(value != null),
        isControlled = _React__namespace$use42.current;

    var inputRef = React__namespace.useRef();
    var handleInputRefWarning = React__namespace.useCallback(function (instance) {
      if (process.env.NODE_ENV !== 'production') {
        if (instance && instance.nodeName !== 'INPUT' && !instance.focus) {
          console.error(['MUI: You have provided a `inputComponent` to the input component', 'that does not correctly handle the `ref` prop.', 'Make sure the `ref` prop is called with a HTMLInputElement.'].join('\n'));
        }
      }
    }, []);
    var handleInputPropsRefProp = useForkRef(inputPropsProp.ref, handleInputRefWarning);
    var handleInputRefProp = useForkRef(inputRefProp, handleInputPropsRefProp);
    var handleInputRef = useForkRef(inputRef, handleInputRefProp);

    var _React__namespace$use43 = React__namespace.useState(false),
        _React__namespace$use44 = _slicedToArray(_React__namespace$use43, 2),
        focused = _React__namespace$use44[0],
        setFocused = _React__namespace$use44[1];

    var muiFormControl = useFormControl();

    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      React__namespace.useEffect(function () {
        if (muiFormControl) {
          return muiFormControl.registerEffect();
        }

        return undefined;
      }, [muiFormControl]);
    }

    var fcs = formControlState({
      props: props,
      muiFormControl: muiFormControl,
      states: ['color', 'disabled', 'error', 'hiddenLabel', 'size', 'required', 'filled']
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused; // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.

    React__namespace.useEffect(function () {
      if (!muiFormControl && disabled && focused) {
        setFocused(false);

        if (onBlur) {
          onBlur();
        }
      }
    }, [muiFormControl, disabled, focused, onBlur]);
    var onFilled = muiFormControl && muiFormControl.onFilled;
    var onEmpty = muiFormControl && muiFormControl.onEmpty;
    var checkDirty = React__namespace.useCallback(function (obj) {
      if (isFilled(obj)) {
        if (onFilled) {
          onFilled();
        }
      } else if (onEmpty) {
        onEmpty();
      }
    }, [onFilled, onEmpty]);
    useEnhancedEffect$1(function () {
      if (isControlled) {
        checkDirty({
          value: value
        });
      }
    }, [value, checkDirty, isControlled]);

    var handleFocus = function handleFocus(event) {
      // Fix a bug with IE11 where the focus/blur events are triggered
      // while the component is disabled.
      if (fcs.disabled) {
        event.stopPropagation();
        return;
      }

      if (onFocus) {
        onFocus(event);
      }

      if (inputPropsProp.onFocus) {
        inputPropsProp.onFocus(event);
      }

      if (muiFormControl && muiFormControl.onFocus) {
        muiFormControl.onFocus(event);
      } else {
        setFocused(true);
      }
    };

    var handleBlur = function handleBlur(event) {
      if (onBlur) {
        onBlur(event);
      }

      if (inputPropsProp.onBlur) {
        inputPropsProp.onBlur(event);
      }

      if (muiFormControl && muiFormControl.onBlur) {
        muiFormControl.onBlur(event);
      } else {
        setFocused(false);
      }
    };

    var handleChange = function handleChange(event) {
      if (!isControlled) {
        var element = event.target || inputRef.current;

        if (element == null) {
          throw new Error(process.env.NODE_ENV !== "production" ? "MUI: Expected valid input target. Did you use a custom `inputComponent` and forget to forward refs? See https://mui.com/r/input-component-ref-interface for more info." : formatMuiErrorMessage(1));
        }

        checkDirty({
          value: element.value
        });
      }

      for (var _len20 = arguments.length, args = new Array(_len20 > 1 ? _len20 - 1 : 0), _key20 = 1; _key20 < _len20; _key20++) {
        args[_key20 - 1] = arguments[_key20];
      }

      if (inputPropsProp.onChange) {
        inputPropsProp.onChange.apply(inputPropsProp, [event].concat(args));
      } // Perform in the willUpdate


      if (onChange) {
        onChange.apply(void 0, [event].concat(args));
      }
    }; // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).


    React__namespace.useEffect(function () {
      checkDirty(inputRef.current); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    var handleClick = function handleClick(event) {
      if (inputRef.current && event.currentTarget === event.target) {
        inputRef.current.focus();
      }

      if (onClick) {
        onClick(event);
      }
    };

    var InputComponent = inputComponent;
    var inputProps = inputPropsProp;

    if (multiline && InputComponent === 'input') {
      if (rows) {
        if (process.env.NODE_ENV !== 'production') {
          if (minRows || maxRows) {
            console.warn('MUI: You can not use the `minRows` or `maxRows` props when the input `rows` prop is set.');
          }
        }

        inputProps = _extends$c({
          type: undefined,
          minRows: rows,
          maxRows: rows
        }, inputProps);
      } else {
        inputProps = _extends$c({
          type: undefined,
          maxRows: maxRows,
          minRows: minRows
        }, inputProps);
      }

      InputComponent = TextareaAutosize$1;
    }

    var handleAutoFill = function handleAutoFill(event) {
      // Provide a fake value as Chrome might not let you access it for security reasons.
      checkDirty(event.animationName === 'mui-auto-fill-cancel' ? inputRef.current : {
        value: 'x'
      });
    };

    React__namespace.useEffect(function () {
      if (muiFormControl) {
        muiFormControl.setAdornedStart(Boolean(startAdornment));
      }
    }, [muiFormControl, startAdornment]);

    var ownerState = _extends$c({}, props, {
      color: fcs.color || 'primary',
      disabled: fcs.disabled,
      endAdornment: endAdornment,
      error: fcs.error,
      focused: fcs.focused,
      formControl: muiFormControl,
      fullWidth: fullWidth,
      hiddenLabel: fcs.hiddenLabel,
      multiline: multiline,
      size: fcs.size,
      startAdornment: startAdornment,
      type: type
    });

    var classes = useUtilityClasses$M(ownerState);
    var Root = components.Root || InputBaseRoot;
    var rootProps = componentsProps.root || {};
    var Input = components.Input || InputBaseComponent;
    inputProps = _extends$c({}, inputProps, componentsProps.input);
    return /*#__PURE__*/jsxRuntime$1.jsxs(React__namespace.Fragment, {
      children: [inputGlobalStyles, /*#__PURE__*/jsxRuntime$1.jsxs(Root, _extends$c({}, rootProps, !isHostComponent(Root) && {
        ownerState: _extends$c({}, ownerState, rootProps.ownerState)
      }, {
        ref: ref,
        onClick: handleClick
      }, other, {
        className: clsx(classes.root, rootProps.className, className),
        children: [startAdornment, /*#__PURE__*/jsxRuntime$1.jsx(FormControlContext$1.Provider, {
          value: null,
          children: /*#__PURE__*/jsxRuntime$1.jsx(Input, _extends$c({
            ownerState: ownerState,
            "aria-invalid": fcs.error,
            "aria-describedby": ariaDescribedby,
            autoComplete: autoComplete,
            autoFocus: autoFocus,
            defaultValue: defaultValue,
            disabled: fcs.disabled,
            id: id,
            onAnimationStart: handleAutoFill,
            name: name,
            placeholder: placeholder,
            readOnly: readOnly,
            required: fcs.required,
            rows: rows,
            value: value,
            onKeyDown: onKeyDown,
            onKeyUp: onKeyUp,
            type: type
          }, inputProps, !isHostComponent(Input) && {
            as: InputComponent,
            ownerState: _extends$c({}, ownerState, inputProps.ownerState)
          }, {
            ref: handleInputRef,
            className: clsx(classes.input, inputProps.className),
            onBlur: handleBlur,
            onChange: handleChange,
            onFocus: handleFocus
          }))
        }), endAdornment, renderSuffix ? renderSuffix(_extends$c({}, fcs, {
          startAdornment: startAdornment
        })) : null]
      }))]
    });
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var E$1 = InputBase;
  var _excluded$10 = ["disableUnderline", "components", "componentsProps", "fullWidth", "hiddenLabel", "inputComponent", "multiline", "type"];

  var useUtilityClasses$L = function useUtilityClasses$L(ownerState) {
    var classes = ownerState.classes,
        disableUnderline = ownerState.disableUnderline;
    var slots = {
      root: ['root', !disableUnderline && 'underline'],
      input: ['input']
    };
    var composedClasses = composeClasses(slots, getFilledInputUtilityClass, classes);
    return _extends$c({}, classes, composedClasses);
  };

  var FilledInputRoot = styled$1(InputBaseRoot, {
    shouldForwardProp: function shouldForwardProp(prop) {
      return rootShouldForwardProp(prop) || prop === 'classes';
    },
    name: 'MuiFilledInput',
    slot: 'Root',
    overridesResolver: function overridesResolver(props, styles) {
      var ownerState = props.ownerState;
      return [].concat(_toConsumableArray(rootOverridesResolver(props, styles)), [!ownerState.disableUnderline && styles.underline]);
    }
  })(function (_ref146) {
    var _extends$c13, _ref147;

    var theme = _ref146.theme,
        ownerState = _ref146.ownerState;
    var light = theme.palette.mode === 'light';
    var bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    var backgroundColor = light ? 'rgba(0, 0, 0, 0.06)' : 'rgba(255, 255, 255, 0.09)';
    return _extends$c((_extends$c13 = {
      position: 'relative',
      backgroundColor: backgroundColor,
      borderTopLeftRadius: theme.shape.borderRadius,
      borderTopRightRadius: theme.shape.borderRadius,
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.shorter,
        easing: theme.transitions.easing.easeOut
      }),
      '&:hover': {
        backgroundColor: light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.13)',
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: backgroundColor
        }
      }
    }, _defineProperty(_extends$c13, "&.".concat(filledInputClasses$1.focused), {
      backgroundColor: backgroundColor
    }), _defineProperty(_extends$c13, "&.".concat(filledInputClasses$1.disabled), {
      backgroundColor: light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)'
    }), _extends$c13), !ownerState.disableUnderline && (_ref147 = {
      '&:after': {
        borderBottom: "2px solid ".concat(theme.palette[ownerState.color].main),
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
        content: '""',
        position: 'absolute',
        right: 0,
        transform: 'scaleX(0)',
        transition: theme.transitions.create('transform', {
          duration: theme.transitions.duration.shorter,
          easing: theme.transitions.easing.easeOut
        }),
        pointerEvents: 'none' // Transparent to the hover style.

      }
    }, _defineProperty(_ref147, "&.".concat(filledInputClasses$1.focused, ":after"), {
      transform: 'scaleX(1)'
    }), _defineProperty(_ref147, "&.".concat(filledInputClasses$1.error, ":after"), {
      borderBottomColor: theme.palette.error.main,
      transform: 'scaleX(1)' // error is always underlined in red

    }), _defineProperty(_ref147, '&:before', {
      borderBottom: "1px solid ".concat(bottomLineColor),
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '"\\00a0"',
      position: 'absolute',
      right: 0,
      transition: theme.transitions.create('border-bottom-color', {
        duration: theme.transitions.duration.shorter
      }),
      pointerEvents: 'none' // Transparent to the hover style.

    }), _defineProperty(_ref147, "&:hover:not(.".concat(filledInputClasses$1.disabled, "):before"), {
      borderBottom: "1px solid ".concat(theme.palette.text.primary)
    }), _defineProperty(_ref147, "&.".concat(filledInputClasses$1.disabled, ":before"), {
      borderBottomStyle: 'dotted'
    }), _ref147), ownerState.startAdornment && {
      paddingLeft: 12
    }, ownerState.endAdornment && {
      paddingRight: 12
    }, ownerState.multiline && _extends$c({
      padding: '25px 12px 8px'
    }, ownerState.size === 'small' && {
      paddingTop: 21,
      paddingBottom: 4
    }, ownerState.hiddenLabel && {
      paddingTop: 16,
      paddingBottom: 17
    }));
  });
  var FilledInputInput = styled$1(InputBaseComponent, {
    name: 'MuiFilledInput',
    slot: 'Input',
    overridesResolver: inputOverridesResolver
  })(function (_ref148) {
    var theme = _ref148.theme,
        ownerState = _ref148.ownerState;
    return _extends$c({
      paddingTop: 25,
      paddingRight: 12,
      paddingBottom: 8,
      paddingLeft: 12,
      '&:-webkit-autofill': {
        WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
        WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
        caretColor: theme.palette.mode === 'light' ? null : '#fff',
        borderTopLeftRadius: 'inherit',
        borderTopRightRadius: 'inherit'
      }
    }, ownerState.size === 'small' && {
      paddingTop: 21,
      paddingBottom: 4
    }, ownerState.hiddenLabel && {
      paddingTop: 16,
      paddingBottom: 17
    }, ownerState.multiline && {
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0
    }, ownerState.startAdornment && {
      paddingLeft: 0
    }, ownerState.endAdornment && {
      paddingRight: 0
    }, ownerState.hiddenLabel && ownerState.size === 'small' && {
      paddingTop: 8,
      paddingBottom: 9
    });
  });
  var FilledInput = /*#__PURE__*/React__namespace.forwardRef(function FilledInput(inProps, ref) {
    var props = useThemeProps({
      props: inProps,
      name: 'MuiFilledInput'
    });

    var _props$components8 = props.components,
        components = _props$components8 === void 0 ? {} : _props$components8,
        componentsPropsProp = props.componentsProps,
        _props$fullWidth6 = props.fullWidth,
        fullWidth = _props$fullWidth6 === void 0 ? false : _props$fullWidth6,
        _props$inputComponent2 = props.inputComponent,
        inputComponent = _props$inputComponent2 === void 0 ? 'input' : _props$inputComponent2,
        _props$multiline2 = props.multiline,
        multiline = _props$multiline2 === void 0 ? false : _props$multiline2,
        _props$type2 = props.type,
        type = _props$type2 === void 0 ? 'text' : _props$type2,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$10);

    var ownerState = _extends$c({}, props, {
      fullWidth: fullWidth,
      inputComponent: inputComponent,
      multiline: multiline,
      type: type
    });

    var classes = useUtilityClasses$L(props);
    var filledInputComponentsProps = {
      root: {
        ownerState: ownerState
      },
      input: {
        ownerState: ownerState
      }
    };
    var componentsProps = componentsPropsProp ? deepmerge(componentsPropsProp, filledInputComponentsProps) : filledInputComponentsProps;
    return /*#__PURE__*/jsxRuntime$1.jsx(E$1, _extends$c({
      components: _extends$c({
        Root: FilledInputRoot,
        Input: FilledInputInput
      }, components),
      componentsProps: componentsProps,
      fullWidth: fullWidth,
      inputComponent: inputComponent,
      multiline: multiline,
      ref: ref,
      type: type
    }, other, {
      classes: classes
    }));
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  FilledInput.muiName = 'Input';
  var FilledInput$1 = FilledInput;

  function getFormControlUtilityClasses(slot) {
    return generateUtilityClass('MuiFormControl', slot);
  }

  generateUtilityClasses('MuiFormControl', ['root', 'marginNone', 'marginNormal', 'marginDense', 'fullWidth', 'disabled']);
  var _excluded$$ = ["children", "className", "color", "component", "disabled", "error", "focused", "fullWidth", "hiddenLabel", "margin", "required", "size", "variant"];

  var useUtilityClasses$K = function useUtilityClasses$K(ownerState) {
    var classes = ownerState.classes,
        margin = ownerState.margin,
        fullWidth = ownerState.fullWidth;
    var slots = {
      root: ['root', margin !== 'none' && "margin".concat(capitalize$1(margin)), fullWidth && 'fullWidth']
    };
    return composeClasses(slots, getFormControlUtilityClasses, classes);
  };

  var FormControlRoot = styled$1('div', {
    name: 'MuiFormControl',
    slot: 'Root',
    overridesResolver: function overridesResolver(_ref149, styles) {
      var ownerState = _ref149.ownerState;
      return _extends$c({}, styles.root, styles["margin".concat(capitalize$1(ownerState.margin))], ownerState.fullWidth && styles.fullWidth);
    }
  })(function (_ref150) {
    var ownerState = _ref150.ownerState;
    return _extends$c({
      display: 'inline-flex',
      flexDirection: 'column',
      position: 'relative',
      // Reset fieldset default style.
      minWidth: 0,
      padding: 0,
      margin: 0,
      border: 0,
      verticalAlign: 'top'
    }, ownerState.margin === 'normal' && {
      marginTop: 16,
      marginBottom: 8
    }, ownerState.margin === 'dense' && {
      marginTop: 8,
      marginBottom: 4
    }, ownerState.fullWidth && {
      width: '100%'
    });
  });
  /**
   * Provides context such as filled/focused/error/required for form inputs.
   * Relying on the context provides high flexibility and ensures that the state always stays
   * consistent across the children of the `FormControl`.
   * This context is used by the following components:
   *
   *  - FormLabel
   *  - FormHelperText
   *  - Input
   *  - InputLabel
   *
   * You can find one composition example below and more going to [the demos](/components/text-fields/#components).
   *
   * ```jsx
   * <FormControl>
   *   <InputLabel htmlFor="my-input">Email address</InputLabel>
   *   <Input id="my-input" aria-describedby="my-helper-text" />
   *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
   * </FormControl>
   * ```
   *
   * ⚠️ Only one `InputBase` can be used within a FormControl because it create visual inconsistencies.
   * For instance, only one input can be focused at the same time, the state shouldn't be shared.
   */

  var FormControl$1 = /*#__PURE__*/React__namespace.forwardRef(function FormControl(inProps, ref) {
    var props = useThemeProps({
      props: inProps,
      name: 'MuiFormControl'
    });

    var children = props.children,
        className = props.className,
        _props$color11 = props.color,
        color = _props$color11 === void 0 ? 'primary' : _props$color11,
        _props$component14 = props.component,
        component = _props$component14 === void 0 ? 'div' : _props$component14,
        _props$disabled8 = props.disabled,
        disabled = _props$disabled8 === void 0 ? false : _props$disabled8,
        _props$error = props.error,
        error = _props$error === void 0 ? false : _props$error,
        visuallyFocused = props.focused,
        _props$fullWidth7 = props.fullWidth,
        fullWidth = _props$fullWidth7 === void 0 ? false : _props$fullWidth7,
        _props$hiddenLabel = props.hiddenLabel,
        hiddenLabel = _props$hiddenLabel === void 0 ? false : _props$hiddenLabel,
        _props$margin = props.margin,
        margin = _props$margin === void 0 ? 'none' : _props$margin,
        _props$required = props.required,
        required = _props$required === void 0 ? false : _props$required,
        _props$size8 = props.size,
        size = _props$size8 === void 0 ? 'medium' : _props$size8,
        _props$variant11 = props.variant,
        variant = _props$variant11 === void 0 ? 'outlined' : _props$variant11,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$$);

    var ownerState = _extends$c({}, props, {
      color: color,
      component: component,
      disabled: disabled,
      error: error,
      fullWidth: fullWidth,
      hiddenLabel: hiddenLabel,
      margin: margin,
      required: required,
      size: size,
      variant: variant
    });

    var classes = useUtilityClasses$K(ownerState);

    var _React__namespace$use45 = React__namespace.useState(function () {
      // We need to iterate through the children and find the Input in order
      // to fully support server-side rendering.
      var initialAdornedStart = false;

      if (children) {
        React__namespace.Children.forEach(children, function (child) {
          if (!isMuiElement(child, ['Input', 'Select'])) {
            return;
          }

          var input = isMuiElement(child, ['Select']) ? child.props.input : child;

          if (input && isAdornedStart(input.props)) {
            initialAdornedStart = true;
          }
        });
      }

      return initialAdornedStart;
    }),
        _React__namespace$use46 = _slicedToArray(_React__namespace$use45, 2),
        adornedStart = _React__namespace$use46[0],
        setAdornedStart = _React__namespace$use46[1];

    var _React__namespace$use47 = React__namespace.useState(function () {
      // We need to iterate through the children and find the Input in order
      // to fully support server-side rendering.
      var initialFilled = false;

      if (children) {
        React__namespace.Children.forEach(children, function (child) {
          if (!isMuiElement(child, ['Input', 'Select'])) {
            return;
          }

          if (isFilled(child.props, true)) {
            initialFilled = true;
          }
        });
      }

      return initialFilled;
    }),
        _React__namespace$use48 = _slicedToArray(_React__namespace$use47, 2),
        filled = _React__namespace$use48[0],
        setFilled = _React__namespace$use48[1];

    var _React__namespace$use49 = React__namespace.useState(false),
        _React__namespace$use50 = _slicedToArray(_React__namespace$use49, 2),
        focusedState = _React__namespace$use50[0],
        setFocused = _React__namespace$use50[1];

    if (disabled && focusedState) {
      setFocused(false);
    }

    var focused = visuallyFocused !== undefined && !disabled ? visuallyFocused : focusedState;
    var registerEffect;

    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      var registeredInput = React__namespace.useRef(false);

      registerEffect = function registerEffect() {
        if (registeredInput.current) {
          console.error(['MUI: There are multiple `InputBase` components inside a FormControl.', 'This creates visual inconsistencies, only use one `InputBase`.'].join('\n'));
        }

        registeredInput.current = true;
        return function () {
          registeredInput.current = false;
        };
      };
    }

    var onFilled = React__namespace.useCallback(function () {
      setFilled(true);
    }, []);
    var onEmpty = React__namespace.useCallback(function () {
      setFilled(false);
    }, []);
    var childContext = {
      adornedStart: adornedStart,
      setAdornedStart: setAdornedStart,
      color: color,
      disabled: disabled,
      error: error,
      filled: filled,
      focused: focused,
      fullWidth: fullWidth,
      hiddenLabel: hiddenLabel,
      size: size,
      onBlur: function onBlur() {
        setFocused(false);
      },
      onEmpty: onEmpty,
      onFilled: onFilled,
      onFocus: function onFocus() {
        setFocused(true);
      },
      registerEffect: registerEffect,
      required: required,
      variant: variant
    };
    return /*#__PURE__*/jsxRuntime$1.jsx(FormControlContext$1.Provider, {
      value: childContext,
      children: /*#__PURE__*/jsxRuntime$1.jsx(FormControlRoot, _extends$c({
        as: component,
        ownerState: ownerState,
        className: clsx(classes.root, className),
        ref: ref
      }, other, {
        children: children
      }))
    });
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var BaseFormControl = FormControl$1;

  function getFormControlLabelUtilityClasses(slot) {
    return generateUtilityClass('MuiFormControlLabel', slot);
  }

  var formControlLabelClasses = generateUtilityClasses('MuiFormControlLabel', ['root', 'labelPlacementStart', 'labelPlacementTop', 'labelPlacementBottom', 'disabled', 'label']);
  var formControlLabelClasses$1 = formControlLabelClasses;
  var _excluded$_ = ["checked", "className", "componentsProps", "control", "disabled", "disableTypography", "inputRef", "label", "labelPlacement", "name", "onChange", "value"];

  var useUtilityClasses$J = function useUtilityClasses$J(ownerState) {
    var classes = ownerState.classes,
        disabled = ownerState.disabled,
        labelPlacement = ownerState.labelPlacement;
    var slots = {
      root: ['root', disabled && 'disabled', "labelPlacement".concat(capitalize$1(labelPlacement))],
      label: ['label', disabled && 'disabled']
    };
    return composeClasses(slots, getFormControlLabelUtilityClasses, classes);
  };

  var FormControlLabelRoot = styled$1('label', {
    name: 'MuiFormControlLabel',
    slot: 'Root',
    overridesResolver: function overridesResolver(props, styles) {
      var ownerState = props.ownerState;
      return [_defineProperty({}, "& .".concat(formControlLabelClasses$1.label), styles.label), styles.root, styles["labelPlacement".concat(capitalize$1(ownerState.labelPlacement))]];
    }
  })(function (_ref152) {
    var theme = _ref152.theme,
        ownerState = _ref152.ownerState;
    return _extends$c(_defineProperty({
      display: 'inline-flex',
      alignItems: 'center',
      cursor: 'pointer',
      // For correct alignment with the text.
      verticalAlign: 'middle',
      WebkitTapHighlightColor: 'transparent',
      marginLeft: -11,
      marginRight: 16
    }, "&.".concat(formControlLabelClasses$1.disabled), {
      cursor: 'default'
    }), ownerState.labelPlacement === 'start' && {
      flexDirection: 'row-reverse',
      marginLeft: 16,
      // used for row presentation of radio/checkbox
      marginRight: -11
    }, ownerState.labelPlacement === 'top' && {
      flexDirection: 'column-reverse',
      marginLeft: 16
    }, ownerState.labelPlacement === 'bottom' && {
      flexDirection: 'column',
      marginLeft: 16
    }, _defineProperty({}, "& .".concat(formControlLabelClasses$1.label), _defineProperty({}, "&.".concat(formControlLabelClasses$1.disabled), {
      color: theme.palette.text.disabled
    })));
  });
  /**
   * Drop-in replacement of the `Radio`, `Switch` and `Checkbox` component.
   * Use this component if you want to display an extra label.
   */

  var FormControlLabel$1 = /*#__PURE__*/React__namespace.forwardRef(function FormControlLabel(inProps, ref) {
    var props = useThemeProps({
      props: inProps,
      name: 'MuiFormControlLabel'
    });

    var className = props.className,
        _props$componentsProp9 = props.componentsProps,
        componentsProps = _props$componentsProp9 === void 0 ? {} : _props$componentsProp9,
        control = props.control,
        disabledProp = props.disabled,
        disableTypography = props.disableTypography,
        label = props.label,
        _props$labelPlacement = props.labelPlacement,
        labelPlacement = _props$labelPlacement === void 0 ? 'end' : _props$labelPlacement,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$_);

    var muiFormControl = useFormControl();
    var disabled = disabledProp;

    if (typeof disabled === 'undefined' && typeof control.props.disabled !== 'undefined') {
      disabled = control.props.disabled;
    }

    if (typeof disabled === 'undefined' && muiFormControl) {
      disabled = muiFormControl.disabled;
    }

    var controlProps = {
      disabled: disabled
    };
    ['checked', 'name', 'onChange', 'value', 'inputRef'].forEach(function (key) {
      if (typeof control.props[key] === 'undefined' && typeof props[key] !== 'undefined') {
        controlProps[key] = props[key];
      }
    });

    var ownerState = _extends$c({}, props, {
      disabled: disabled,
      label: label,
      labelPlacement: labelPlacement
    });

    var classes = useUtilityClasses$J(ownerState);
    return /*#__PURE__*/jsxRuntime$1.jsxs(FormControlLabelRoot, _extends$c({
      className: clsx(classes.root, className),
      ownerState: ownerState,
      ref: ref
    }, other, {
      children: [/*#__PURE__*/React__namespace.cloneElement(control, controlProps), label.type === Typography$2 || disableTypography ? label : /*#__PURE__*/jsxRuntime$1.jsx(Typography$2, _extends$c({
        component: "span",
        className: classes.label
      }, componentsProps.typography, {
        children: label
      }))]
    }));
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var BaseFormControlLabel = FormControlLabel$1;

  function getFormGroupUtilityClass(slot) {
    return generateUtilityClass('MuiFormGroup', slot);
  }

  generateUtilityClasses('MuiFormGroup', ['root', 'row']);
  var _excluded$Z = ["className", "row"];

  var useUtilityClasses$I = function useUtilityClasses$I(ownerState) {
    var classes = ownerState.classes,
        row = ownerState.row;
    var slots = {
      root: ['root', row && 'row']
    };
    return composeClasses(slots, getFormGroupUtilityClass, classes);
  };

  var FormGroupRoot = styled$1('div', {
    name: 'MuiFormGroup',
    slot: 'Root',
    overridesResolver: function overridesResolver(props, styles) {
      var ownerState = props.ownerState;
      return [styles.root, ownerState.row && styles.row];
    }
  })(function (_ref153) {
    var ownerState = _ref153.ownerState;
    return _extends$c({
      display: 'flex',
      flexDirection: 'column',
      flexWrap: 'wrap'
    }, ownerState.row && {
      flexDirection: 'row'
    });
  });
  /**
   * `FormGroup` wraps controls such as `Checkbox` and `Switch`.
   * It provides compact row layout.
   * For the `Radio`, you should be using the `RadioGroup` component instead of this one.
   */

  var FormGroup$1 = /*#__PURE__*/React__namespace.forwardRef(function FormGroup(inProps, ref) {
    var props = useThemeProps({
      props: inProps,
      name: 'MuiFormGroup'
    });

    var className = props.className,
        _props$row = props.row,
        row = _props$row === void 0 ? false : _props$row,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$Z);

    var ownerState = _extends$c({}, props, {
      row: row
    });

    var classes = useUtilityClasses$I(ownerState);
    return /*#__PURE__*/jsxRuntime$1.jsx(FormGroupRoot, _extends$c({
      className: clsx(classes.root, className),
      ownerState: ownerState,
      ref: ref
    }, other));
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var BaseFormGroup = FormGroup$1;

  function getFormHelperTextUtilityClasses(slot) {
    return generateUtilityClass('MuiFormHelperText', slot);
  }

  var formHelperTextClasses = generateUtilityClasses('MuiFormHelperText', ['root', 'error', 'disabled', 'sizeSmall', 'sizeMedium', 'contained', 'focused', 'filled', 'required']);
  var formHelperTextClasses$1 = formHelperTextClasses;
  var _excluded$Y = ["children", "className", "component", "disabled", "error", "filled", "focused", "margin", "required", "variant"];

  var useUtilityClasses$H = function useUtilityClasses$H(ownerState) {
    var classes = ownerState.classes,
        contained = ownerState.contained,
        size = ownerState.size,
        disabled = ownerState.disabled,
        error = ownerState.error,
        filled = ownerState.filled,
        focused = ownerState.focused,
        required = ownerState.required;
    var slots = {
      root: ['root', disabled && 'disabled', error && 'error', size && "size".concat(capitalize$1(size)), contained && 'contained', focused && 'focused', filled && 'filled', required && 'required']
    };
    return composeClasses(slots, getFormHelperTextUtilityClasses, classes);
  };

  var FormHelperTextRoot = styled$1('p', {
    name: 'MuiFormHelperText',
    slot: 'Root',
    overridesResolver: function overridesResolver(props, styles) {
      var ownerState = props.ownerState;
      return [styles.root, ownerState.size && styles["size".concat(capitalize$1(ownerState.size))], ownerState.contained && styles.contained, ownerState.filled && styles.filled];
    }
  })(function (_ref154) {
    var _extends$c16;

    var theme = _ref154.theme,
        ownerState = _ref154.ownerState;
    return _extends$c({
      color: theme.palette.text.secondary
    }, theme.typography.caption, (_extends$c16 = {
      textAlign: 'left',
      marginTop: 3,
      marginRight: 0,
      marginBottom: 0,
      marginLeft: 0
    }, _defineProperty(_extends$c16, "&.".concat(formHelperTextClasses$1.disabled), {
      color: theme.palette.text.disabled
    }), _defineProperty(_extends$c16, "&.".concat(formHelperTextClasses$1.error), {
      color: theme.palette.error.main
    }), _extends$c16), ownerState.size === 'small' && {
      marginTop: 4
    }, ownerState.contained && {
      marginLeft: 14,
      marginRight: 14
    });
  });
  var FormHelperText$1 = /*#__PURE__*/React__namespace.forwardRef(function FormHelperText(inProps, ref) {
    var props = useThemeProps({
      props: inProps,
      name: 'MuiFormHelperText'
    });

    var children = props.children,
        className = props.className,
        _props$component15 = props.component,
        component = _props$component15 === void 0 ? 'p' : _props$component15,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$Y);

    var muiFormControl = useFormControl();
    var fcs = formControlState({
      props: props,
      muiFormControl: muiFormControl,
      states: ['variant', 'size', 'disabled', 'error', 'filled', 'focused', 'required']
    });

    var ownerState = _extends$c({}, props, {
      component: component,
      contained: fcs.variant === 'filled' || fcs.variant === 'outlined',
      variant: fcs.variant,
      size: fcs.size,
      disabled: fcs.disabled,
      error: fcs.error,
      filled: fcs.filled,
      focused: fcs.focused,
      required: fcs.required
    });

    var classes = useUtilityClasses$H(ownerState);
    return /*#__PURE__*/jsxRuntime$1.jsx(FormHelperTextRoot, _extends$c({
      as: component,
      ownerState: ownerState,
      className: clsx(classes.root, className),
      ref: ref
    }, other, {
      children: children === ' ' ?
      /*#__PURE__*/
      // notranslate needed while Google Translate will not fix zero-width space issue
      // eslint-disable-next-line react/no-danger
      jsxRuntime$1.jsx("span", {
        className: "notranslate",
        dangerouslySetInnerHTML: {
          __html: '&#8203;'
        }
      }) : children
    }));
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var BaseFormHelperText = FormHelperText$1;

  function getFormLabelUtilityClasses(slot) {
    return generateUtilityClass('MuiFormLabel', slot);
  }

  var formLabelClasses = generateUtilityClasses('MuiFormLabel', ['root', 'colorSecondary', 'focused', 'disabled', 'error', 'filled', 'required', 'asterisk']);
  var formLabelClasses$1 = formLabelClasses;
  var _excluded$X = ["children", "className", "color", "component", "disabled", "error", "filled", "focused", "required"];

  var useUtilityClasses$G = function useUtilityClasses$G(ownerState) {
    var classes = ownerState.classes,
        color = ownerState.color,
        focused = ownerState.focused,
        disabled = ownerState.disabled,
        error = ownerState.error,
        filled = ownerState.filled,
        required = ownerState.required;
    var slots = {
      root: ['root', "color".concat(capitalize$1(color)), disabled && 'disabled', error && 'error', filled && 'filled', focused && 'focused', required && 'required'],
      asterisk: ['asterisk', error && 'error']
    };
    return composeClasses(slots, getFormLabelUtilityClasses, classes);
  };

  var FormLabelRoot = styled$1('label', {
    name: 'MuiFormLabel',
    slot: 'Root',
    overridesResolver: function overridesResolver(_ref155, styles) {
      var ownerState = _ref155.ownerState;
      return _extends$c({}, styles.root, ownerState.color === 'secondary' && styles.colorSecondary, ownerState.filled && styles.filled);
    }
  })(function (_ref156) {
    var _extends$c17;

    var theme = _ref156.theme,
        ownerState = _ref156.ownerState;
    return _extends$c({
      color: theme.palette.text.secondary
    }, theme.typography.body1, (_extends$c17 = {
      lineHeight: '1.4375em',
      padding: 0,
      position: 'relative'
    }, _defineProperty(_extends$c17, "&.".concat(formLabelClasses$1.focused), {
      color: theme.palette[ownerState.color].main
    }), _defineProperty(_extends$c17, "&.".concat(formLabelClasses$1.disabled), {
      color: theme.palette.text.disabled
    }), _defineProperty(_extends$c17, "&.".concat(formLabelClasses$1.error), {
      color: theme.palette.error.main
    }), _extends$c17));
  });
  var AsteriskComponent = styled$1('span', {
    name: 'MuiFormLabel',
    slot: 'Asterisk',
    overridesResolver: function overridesResolver(props, styles) {
      return styles.asterisk;
    }
  })(function (_ref157) {
    var theme = _ref157.theme;
    return _defineProperty({}, "&.".concat(formLabelClasses$1.error), {
      color: theme.palette.error.main
    });
  });
  var FormLabel$1 = /*#__PURE__*/React__namespace.forwardRef(function FormLabel(inProps, ref) {
    var props = useThemeProps({
      props: inProps,
      name: 'MuiFormLabel'
    });

    var children = props.children,
        className = props.className,
        _props$component16 = props.component,
        component = _props$component16 === void 0 ? 'label' : _props$component16,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$X);

    var muiFormControl = useFormControl();
    var fcs = formControlState({
      props: props,
      muiFormControl: muiFormControl,
      states: ['color', 'required', 'focused', 'disabled', 'error', 'filled']
    });

    var ownerState = _extends$c({}, props, {
      color: fcs.color || 'primary',
      component: component,
      disabled: fcs.disabled,
      error: fcs.error,
      filled: fcs.filled,
      focused: fcs.focused,
      required: fcs.required
    });

    var classes = useUtilityClasses$G(ownerState);
    return /*#__PURE__*/jsxRuntime$1.jsxs(FormLabelRoot, _extends$c({
      as: component,
      ownerState: ownerState,
      className: clsx(classes.root, className),
      ref: ref
    }, other, {
      children: [children, fcs.required && /*#__PURE__*/jsxRuntime$1.jsxs(AsteriskComponent, {
        ownerState: ownerState,
        "aria-hidden": true,
        className: classes.asterisk,
        children: ["\u2009", '*']
      })]
    }));
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var BaseFormLabel = FormLabel$1;
  /**
   * @ignore - internal component.
   */

  var GridContext = /*#__PURE__*/React__namespace.createContext();

  if (process.env.NODE_ENV !== 'production') {
    GridContext.displayName = 'GridContext';
  }

  var GridContext$1 = GridContext;

  function getGridUtilityClass(slot) {
    return generateUtilityClass('MuiGrid', slot);
  }

  var SPACINGS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  var DIRECTIONS = ['column-reverse', 'column', 'row-reverse', 'row'];
  var WRAPS = ['nowrap', 'wrap-reverse', 'wrap'];
  var GRID_SIZES = ['auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  var gridClasses = generateUtilityClasses('MuiGrid', ['root', 'container', 'item', 'zeroMinWidth'].concat(_toConsumableArray(SPACINGS.map(function (spacing) {
    return "spacing-xs-".concat(spacing);
  })), _toConsumableArray(DIRECTIONS.map(function (direction) {
    return "direction-xs-".concat(direction);
  })), _toConsumableArray(WRAPS.map(function (wrap) {
    return "wrap-xs-".concat(wrap);
  })), _toConsumableArray(GRID_SIZES.map(function (size) {
    return "grid-xs-".concat(size);
  })), _toConsumableArray(GRID_SIZES.map(function (size) {
    return "grid-sm-".concat(size);
  })), _toConsumableArray(GRID_SIZES.map(function (size) {
    return "grid-md-".concat(size);
  })), _toConsumableArray(GRID_SIZES.map(function (size) {
    return "grid-lg-".concat(size);
  })), _toConsumableArray(GRID_SIZES.map(function (size) {
    return "grid-xl-".concat(size);
  }))));
  var _excluded$W = ["className", "columns", "columnSpacing", "component", "container", "direction", "item", "lg", "md", "rowSpacing", "sm", "spacing", "wrap", "xl", "xs", "zeroMinWidth"];

  function getOffset(val) {
    var parse = parseFloat(val);
    return "".concat(parse).concat(String(val).replace(String(parse), '') || 'px');
  }

  function generateGrid(globalStyles, theme, breakpoint, ownerState) {
    var size = ownerState[breakpoint];

    if (!size) {
      return;
    }

    var styles = {};

    if (size === true) {
      // For the auto layouting
      styles = {
        flexBasis: 0,
        flexGrow: 1,
        maxWidth: '100%'
      };
    } else if (size === 'auto') {
      styles = {
        flexBasis: 'auto',
        flexGrow: 0,
        flexShrink: 0,
        maxWidth: 'none',
        width: 'auto'
      };
    } else {
      var columnsBreakpointValues = resolveBreakpointValues({
        values: ownerState.columns,
        breakpoints: theme.breakpoints.values
      });
      var columnValue = typeof columnsBreakpointValues === 'object' ? columnsBreakpointValues[breakpoint] : columnsBreakpointValues; // Keep 7 significant numbers.

      var _width2 = "".concat(Math.round(size / columnValue * 10e7) / 10e5, "%");

      var more = {};

      if (ownerState.container && ownerState.item && ownerState.columnSpacing !== 0) {
        var themeSpacing = theme.spacing(ownerState.columnSpacing);

        if (themeSpacing !== '0px') {
          var fullWidth = "calc(".concat(_width2, " + ").concat(getOffset(themeSpacing), ")");
          more = {
            flexBasis: fullWidth,
            maxWidth: fullWidth
          };
        }
      } // Close to the bootstrap implementation:
      // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41


      styles = _extends$c({
        flexBasis: _width2,
        flexGrow: 0,
        maxWidth: _width2
      }, more);
    } // No need for a media query for the first size.


    if (theme.breakpoints.values[breakpoint] === 0) {
      Object.assign(globalStyles, styles);
    } else {
      globalStyles[theme.breakpoints.up(breakpoint)] = styles;
    }
  }

  function generateDirection(_ref159) {
    var theme = _ref159.theme,
        ownerState = _ref159.ownerState;
    var directionValues = resolveBreakpointValues({
      values: ownerState.direction,
      breakpoints: theme.breakpoints.values
    });
    return handleBreakpoints({
      theme: theme
    }, directionValues, function (propValue) {
      var output = {
        flexDirection: propValue
      };

      if (propValue.indexOf('column') === 0) {
        output["& > .".concat(gridClasses.item)] = {
          maxWidth: 'none'
        };
      }

      return output;
    });
  }

  function generateRowGap(_ref160) {
    var theme = _ref160.theme,
        ownerState = _ref160.ownerState;
    var container = ownerState.container,
        rowSpacing = ownerState.rowSpacing;
    var styles = {};

    if (container && rowSpacing !== 0) {
      var rowSpacingValues = resolveBreakpointValues({
        values: rowSpacing,
        breakpoints: theme.breakpoints.values
      });
      styles = handleBreakpoints({
        theme: theme
      }, rowSpacingValues, function (propValue) {
        var themeSpacing = theme.spacing(propValue);

        if (themeSpacing !== '0px') {
          return _defineProperty({
            marginTop: "-".concat(getOffset(themeSpacing))
          }, "& > .".concat(gridClasses.item), {
            paddingTop: getOffset(themeSpacing)
          });
        }

        return {};
      });
    }

    return styles;
  }

  function generateColumnGap(_ref162) {
    var theme = _ref162.theme,
        ownerState = _ref162.ownerState;
    var container = ownerState.container,
        columnSpacing = ownerState.columnSpacing;
    var styles = {};

    if (container && columnSpacing !== 0) {
      var columnSpacingValues = resolveBreakpointValues({
        values: columnSpacing,
        breakpoints: theme.breakpoints.values
      });
      styles = handleBreakpoints({
        theme: theme
      }, columnSpacingValues, function (propValue) {
        var themeSpacing = theme.spacing(propValue);

        if (themeSpacing !== '0px') {
          return _defineProperty({
            width: "calc(100% + ".concat(getOffset(themeSpacing), ")"),
            marginLeft: "-".concat(getOffset(themeSpacing))
          }, "& > .".concat(gridClasses.item), {
            paddingLeft: getOffset(themeSpacing)
          });
        }

        return {};
      });
    }

    return styles;
  }

  function resolveSpacingClasses(spacing, container) {
    var styles = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    // in case of grid item or undefined/null or `spacing` <= 0
    if (!container || !spacing || spacing <= 0) {
      return [];
    } // in case of string/number `spacing`


    if (typeof spacing === 'string' && !Number.isNaN(Number(spacing)) || typeof spacing === 'number') {
      return [styles["spacing-xs-".concat(String(spacing))] || "spacing-xs-".concat(String(spacing))];
    } // in case of object `spacing`


    var xs = spacing.xs,
        sm = spacing.sm,
        md = spacing.md,
        lg = spacing.lg,
        xl = spacing.xl;
    return [Number(xs) > 0 && (styles["spacing-xs-".concat(String(xs))] || "spacing-xs-".concat(String(xs))), Number(sm) > 0 && (styles["spacing-sm-".concat(String(sm))] || "spacing-sm-".concat(String(sm))), Number(md) > 0 && (styles["spacing-md-".concat(String(md))] || "spacing-md-".concat(String(md))), Number(lg) > 0 && (styles["spacing-lg-".concat(String(lg))] || "spacing-lg-".concat(String(lg))), Number(xl) > 0 && (styles["spacing-xl-".concat(String(xl))] || "spacing-xl-".concat(String(xl)))];
  } // Default CSS values
  // flex: '0 1 auto',
  // flexDirection: 'row',
  // alignItems: 'flex-start',
  // flexWrap: 'nowrap',
  // justifyContent: 'flex-start',


  var GridRoot = styled$1('div', {
    name: 'MuiGrid',
    slot: 'Root',
    overridesResolver: function overridesResolver(props, styles) {
      var _props$ownerState2 = props.ownerState,
          container = _props$ownerState2.container,
          direction = _props$ownerState2.direction,
          item = _props$ownerState2.item,
          lg = _props$ownerState2.lg,
          md = _props$ownerState2.md,
          sm = _props$ownerState2.sm,
          spacing = _props$ownerState2.spacing,
          wrap = _props$ownerState2.wrap,
          xl = _props$ownerState2.xl,
          xs = _props$ownerState2.xs,
          zeroMinWidth = _props$ownerState2.zeroMinWidth;
      return [styles.root, container && styles.container, item && styles.item, zeroMinWidth && styles.zeroMinWidth].concat(_toConsumableArray(resolveSpacingClasses(spacing, container, styles)), [direction !== 'row' && styles["direction-xs-".concat(String(direction))], wrap !== 'wrap' && styles["wrap-xs-".concat(String(wrap))], xs !== false && styles["grid-xs-".concat(String(xs))], sm !== false && styles["grid-sm-".concat(String(sm))], md !== false && styles["grid-md-".concat(String(md))], lg !== false && styles["grid-lg-".concat(String(lg))], xl !== false && styles["grid-xl-".concat(String(xl))]]);
    }
  })(function (_ref164) {
    var ownerState = _ref164.ownerState;
    return _extends$c({
      boxSizing: 'border-box'
    }, ownerState.container && {
      display: 'flex',
      flexWrap: 'wrap',
      width: '100%'
    }, ownerState.item && {
      margin: 0 // For instance, it's useful when used with a `figure` element.

    }, ownerState.zeroMinWidth && {
      minWidth: 0
    }, ownerState.wrap === 'nowrap' && {
      flexWrap: 'nowrap'
    }, ownerState.wrap === 'reverse' && {
      flexWrap: 'wrap-reverse'
    });
  }, generateDirection, generateRowGap, generateColumnGap, function (_ref165) {
    var theme = _ref165.theme,
        ownerState = _ref165.ownerState;
    return theme.breakpoints.keys.reduce(function (globalStyles, breakpoint) {
      // Use side effect over immutability for better performance.
      generateGrid(globalStyles, theme, breakpoint, ownerState);
      return globalStyles;
    }, {});
  });

  var useUtilityClasses$F = function useUtilityClasses$F(ownerState) {
    var classes = ownerState.classes,
        container = ownerState.container,
        direction = ownerState.direction,
        item = ownerState.item,
        lg = ownerState.lg,
        md = ownerState.md,
        sm = ownerState.sm,
        spacing = ownerState.spacing,
        wrap = ownerState.wrap,
        xl = ownerState.xl,
        xs = ownerState.xs,
        zeroMinWidth = ownerState.zeroMinWidth;
    var slots = {
      root: ['root', container && 'container', item && 'item', zeroMinWidth && 'zeroMinWidth'].concat(_toConsumableArray(resolveSpacingClasses(spacing, container)), [direction !== 'row' && "direction-xs-".concat(String(direction)), wrap !== 'wrap' && "wrap-xs-".concat(String(wrap)), xs !== false && "grid-xs-".concat(String(xs)), sm !== false && "grid-sm-".concat(String(sm)), md !== false && "grid-md-".concat(String(md)), lg !== false && "grid-lg-".concat(String(lg)), xl !== false && "grid-xl-".concat(String(xl))])
    };
    return composeClasses(slots, getGridUtilityClass, classes);
  };

  var Grid$1 = /*#__PURE__*/React__namespace.forwardRef(function Grid(inProps, ref) {
    var themeProps = useThemeProps({
      props: inProps,
      name: 'MuiGrid'
    });
    var props = extendSxProp(themeProps);

    var className = props.className,
        columnsProp = props.columns,
        columnSpacingProp = props.columnSpacing,
        _props$component17 = props.component,
        component = _props$component17 === void 0 ? 'div' : _props$component17,
        _props$container = props.container,
        container = _props$container === void 0 ? false : _props$container,
        _props$direction3 = props.direction,
        direction = _props$direction3 === void 0 ? 'row' : _props$direction3,
        _props$item = props.item,
        item = _props$item === void 0 ? false : _props$item,
        _props$lg = props.lg,
        lg = _props$lg === void 0 ? false : _props$lg,
        _props$md = props.md,
        md = _props$md === void 0 ? false : _props$md,
        rowSpacingProp = props.rowSpacing,
        _props$sm = props.sm,
        sm = _props$sm === void 0 ? false : _props$sm,
        _props$spacing = props.spacing,
        spacing = _props$spacing === void 0 ? 0 : _props$spacing,
        _props$wrap = props.wrap,
        wrap = _props$wrap === void 0 ? 'wrap' : _props$wrap,
        _props$xl = props.xl,
        xl = _props$xl === void 0 ? false : _props$xl,
        _props$xs = props.xs,
        xs = _props$xs === void 0 ? false : _props$xs,
        _props$zeroMinWidth = props.zeroMinWidth,
        zeroMinWidth = _props$zeroMinWidth === void 0 ? false : _props$zeroMinWidth,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$W);

    var rowSpacing = rowSpacingProp || spacing;
    var columnSpacing = columnSpacingProp || spacing;
    var columnsContext = React__namespace.useContext(GridContext$1); // setting prop before context to accomodate nesting
    // colums set with default breakpoint unit of 12

    var columns = columnsProp || columnsContext || 12;

    var ownerState = _extends$c({}, props, {
      columns: columns,
      container: container,
      direction: direction,
      item: item,
      lg: lg,
      md: md,
      sm: sm,
      rowSpacing: rowSpacing,
      columnSpacing: columnSpacing,
      wrap: wrap,
      xl: xl,
      xs: xs,
      zeroMinWidth: zeroMinWidth
    });

    var classes = useUtilityClasses$F(ownerState);

    var wrapChild = function wrapChild(element) {
      return columns !== 12 ? /*#__PURE__*/jsxRuntime$1.jsx(GridContext$1.Provider, {
        value: columns,
        children: element
      }) : element;
    };

    return wrapChild( /*#__PURE__*/jsxRuntime$1.jsx(GridRoot, _extends$c({
      ownerState: ownerState,
      className: clsx(classes.root, className),
      as: component,
      ref: ref
    }, other)));
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;

  if (process.env.NODE_ENV !== 'production') {
    var requireProp = requirePropFactory('Grid', Grid$1); // eslint-disable-next-line no-useless-concat

    Grid$1['propTypes' + ''] = _extends$c({}, Grid$1.propTypes, {
      direction: requireProp('container'),
      lg: requireProp('item'),
      md: requireProp('item'),
      sm: requireProp('item'),
      spacing: requireProp('container'),
      wrap: requireProp('container'),
      xs: requireProp('item'),
      zeroMinWidth: requireProp('item')
    });
  }

  var BaseGrid = Grid$1;
  var _excluded$V = ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"];

  function getScale(value) {
    return "scale(".concat(value, ", ").concat(Math.pow(value, 2), ")");
  }

  var styles$5 = {
    entering: {
      opacity: 1,
      transform: getScale(1)
    },
    entered: {
      opacity: 1,
      transform: 'none'
    }
  };
  /**
   * The Grow transition is used by the [Tooltip](/components/tooltips/) and
   * [Popover](/components/popover/) components.
   * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
   */

  var Grow = /*#__PURE__*/React__namespace.forwardRef(function Grow(props, ref) {
    var addEndListener = props.addEndListener,
        _props$appear3 = props.appear,
        appear = _props$appear3 === void 0 ? true : _props$appear3,
        _children4 = props.children,
        easing = props.easing,
        inProp = props.in,
        onEnter = props.onEnter,
        onEntered = props.onEntered,
        onEntering = props.onEntering,
        onExit = props.onExit,
        onExited = props.onExited,
        onExiting = props.onExiting,
        style = props.style,
        _props$timeout4 = props.timeout,
        timeout = _props$timeout4 === void 0 ? 'auto' : _props$timeout4,
        _props$TransitionComp8 = props.TransitionComponent,
        TransitionComponent = _props$TransitionComp8 === void 0 ? Transition$1 : _props$TransitionComp8,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$V);

    var timer = React__namespace.useRef();
    var autoTimeout = React__namespace.useRef();
    var theme = useTheme();
    var nodeRef = React__namespace.useRef(null);
    var foreignRef = useForkRef(_children4.ref, ref);
    var handleRef = useForkRef(nodeRef, foreignRef);

    var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
      return function (maybeIsAppearing) {
        if (callback) {
          var _node3 = nodeRef.current; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.

          if (maybeIsAppearing === undefined) {
            callback(_node3);
          } else {
            callback(_node3, maybeIsAppearing);
          }
        }
      };
    };

    var handleEntering = normalizedTransitionCallback(onEntering);
    var handleEnter = normalizedTransitionCallback(function (node, isAppearing) {
      reflow(node); // So the animation always start from the start.

      var _getTransitionProps3 = getTransitionProps({
        style: style,
        timeout: timeout,
        easing: easing
      }, {
        mode: 'enter'
      }),
          transitionDuration = _getTransitionProps3.duration,
          delay = _getTransitionProps3.delay,
          transitionTimingFunction = _getTransitionProps3.easing;

      var duration;

      if (timeout === 'auto') {
        duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
        autoTimeout.current = duration;
      } else {
        duration = transitionDuration;
      }

      node.style.transition = [theme.transitions.create('opacity', {
        duration: duration,
        delay: delay
      }), theme.transitions.create('transform', {
        duration: duration * 0.666,
        delay: delay,
        easing: transitionTimingFunction
      })].join(',');

      if (onEnter) {
        onEnter(node, isAppearing);
      }
    });
    var handleEntered = normalizedTransitionCallback(onEntered);
    var handleExiting = normalizedTransitionCallback(onExiting);
    var handleExit = normalizedTransitionCallback(function (node) {
      var _getTransitionProps4 = getTransitionProps({
        style: style,
        timeout: timeout,
        easing: easing
      }, {
        mode: 'exit'
      }),
          transitionDuration = _getTransitionProps4.duration,
          delay = _getTransitionProps4.delay,
          transitionTimingFunction = _getTransitionProps4.easing;

      var duration;

      if (timeout === 'auto') {
        duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
        autoTimeout.current = duration;
      } else {
        duration = transitionDuration;
      }

      node.style.transition = [theme.transitions.create('opacity', {
        duration: duration,
        delay: delay
      }), theme.transitions.create('transform', {
        duration: duration * 0.666,
        delay: delay || duration * 0.333,
        easing: transitionTimingFunction
      })].join(',');
      node.style.opacity = '0';
      node.style.transform = getScale(0.75);

      if (onExit) {
        onExit(node);
      }
    });
    var handleExited = normalizedTransitionCallback(onExited);

    var handleAddEndListener = function handleAddEndListener(next) {
      if (timeout === 'auto') {
        timer.current = setTimeout(next, autoTimeout.current || 0);
      }

      if (addEndListener) {
        // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
      }
    };

    React__namespace.useEffect(function () {
      return function () {
        clearTimeout(timer.current);
      };
    }, []);
    return /*#__PURE__*/jsxRuntime$1.jsx(TransitionComponent, _extends$c({
      appear: appear,
      in: inProp,
      nodeRef: nodeRef,
      onEnter: handleEnter,
      onEntered: handleEntered,
      onEntering: handleEntering,
      onExit: handleExit,
      onExited: handleExited,
      onExiting: handleExiting,
      addEndListener: handleAddEndListener,
      timeout: timeout === 'auto' ? null : timeout
    }, other, {
      children: function children(state, childProps) {
        return /*#__PURE__*/React__namespace.cloneElement(_children4, _extends$c({
          style: _extends$c({
            opacity: 0,
            transform: getScale(0.75),
            visibility: state === 'exited' && !inProp ? 'hidden' : undefined
          }, styles$5[state], style, _children4.props.style),
          ref: handleRef
        }, childProps));
      }
    }));
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  Grow.muiSupportAuto = true;
  var Grow$1 = Grow;
  /**
   * @deprecated Not used internally. Use `MediaQueryListEvent` from lib.dom.d.ts instead.
   */

  function useMediaQuery(queryInput) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var theme = useTheme$2(); // Wait for jsdom to support the match media feature.
    // All the browsers MUI support have this built-in.
    // This defensive check is here for simplicity.
    // Most of the time, the match media logic isn't central to people tests.

    var supportMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';

    var _getThemeProps = getThemeProps({
      name: 'MuiUseMediaQuery',
      props: options,
      theme: theme
    }),
        _getThemeProps$defaul = _getThemeProps.defaultMatches,
        defaultMatches = _getThemeProps$defaul === void 0 ? false : _getThemeProps$defaul,
        _getThemeProps$matchM = _getThemeProps.matchMedia,
        matchMedia = _getThemeProps$matchM === void 0 ? supportMatchMedia ? window.matchMedia : null : _getThemeProps$matchM,
        _getThemeProps$noSsr = _getThemeProps.noSsr,
        noSsr = _getThemeProps$noSsr === void 0 ? false : _getThemeProps$noSsr,
        _getThemeProps$ssrMat = _getThemeProps.ssrMatchMedia,
        ssrMatchMedia = _getThemeProps$ssrMat === void 0 ? null : _getThemeProps$ssrMat;

    if (process.env.NODE_ENV !== 'production') {
      if (typeof queryInput === 'function' && theme === null) {
        console.error(['MUI: The `query` argument provided is invalid.', 'You are providing a function without a theme in the context.', 'One of the parent elements needs to use a ThemeProvider.'].join('\n'));
      }
    }

    var query = typeof queryInput === 'function' ? queryInput(theme) : queryInput;
    query = query.replace(/^@media( ?)/m, '');

    var _React__namespace$use51 = React__namespace.useState(function () {
      if (noSsr && supportMatchMedia) {
        return matchMedia(query).matches;
      }

      if (ssrMatchMedia) {
        return ssrMatchMedia(query).matches;
      } // Once the component is mounted, we rely on the
      // event listeners to return the correct matches value.


      // Once the component is mounted, we rely on the
      // event listeners to return the correct matches value.
      return defaultMatches;
    }),
        _React__namespace$use52 = _slicedToArray(_React__namespace$use51, 2),
        match = _React__namespace$use52[0],
        setMatch = _React__namespace$use52[1];

    useEnhancedEffect$1(function () {
      var active = true;

      if (!supportMatchMedia) {
        return undefined;
      }

      var queryList = matchMedia(query);

      var updateMatch = function updateMatch() {
        // Workaround Safari wrong implementation of matchMedia
        // TODO can we remove it?
        // https://github.com/mui-org/material-ui/pull/17315#issuecomment-528286677
        if (active) {
          setMatch(queryList.matches);
        }
      };

      updateMatch();
      queryList.addListener(updateMatch);
      return function () {
        active = false;
        queryList.removeListener(updateMatch);
      };
    }, [query, matchMedia, supportMatchMedia]);

    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      React__namespace.useDebugValue({
        query: query,
        match: match
      });
    }

    return match;
  }

  var _excluded$U = ["disableUnderline", "components", "componentsProps", "fullWidth", "inputComponent", "multiline", "type"];

  var useUtilityClasses$E = function useUtilityClasses$E(ownerState) {
    var classes = ownerState.classes,
        disableUnderline = ownerState.disableUnderline;
    var slots = {
      root: ['root', !disableUnderline && 'underline'],
      input: ['input']
    };
    var composedClasses = composeClasses(slots, getInputUtilityClass, classes);
    return _extends$c({}, classes, composedClasses);
  };

  var InputRoot = styled$1(InputBaseRoot, {
    shouldForwardProp: function shouldForwardProp(prop) {
      return rootShouldForwardProp(prop) || prop === 'classes';
    },
    name: 'MuiInput',
    slot: 'Root',
    overridesResolver: function overridesResolver(props, styles) {
      var ownerState = props.ownerState;
      return [].concat(_toConsumableArray(rootOverridesResolver(props, styles)), [!ownerState.disableUnderline && styles.underline]);
    }
  })(function (_ref166) {
    var _ref167;

    var theme = _ref166.theme,
        ownerState = _ref166.ownerState;
    var light = theme.palette.mode === 'light';
    var bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    return _extends$c({
      position: 'relative'
    }, ownerState.formControl && {
      'label + &': {
        marginTop: 16
      }
    }, !ownerState.disableUnderline && (_ref167 = {
      '&:after': {
        borderBottom: "2px solid ".concat(theme.palette[ownerState.color].main),
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
        content: '""',
        position: 'absolute',
        right: 0,
        transform: 'scaleX(0)',
        transition: theme.transitions.create('transform', {
          duration: theme.transitions.duration.shorter,
          easing: theme.transitions.easing.easeOut
        }),
        pointerEvents: 'none' // Transparent to the hover style.

      }
    }, _defineProperty(_ref167, "&.".concat(inputClasses$1.focused, ":after"), {
      transform: 'scaleX(1)'
    }), _defineProperty(_ref167, "&.".concat(inputClasses$1.error, ":after"), {
      borderBottomColor: theme.palette.error.main,
      transform: 'scaleX(1)' // error is always underlined in red

    }), _defineProperty(_ref167, '&:before', {
      borderBottom: "1px solid ".concat(bottomLineColor),
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '"\\00a0"',
      position: 'absolute',
      right: 0,
      transition: theme.transitions.create('border-bottom-color', {
        duration: theme.transitions.duration.shorter
      }),
      pointerEvents: 'none' // Transparent to the hover style.

    }), _defineProperty(_ref167, "&:hover:not(.".concat(inputClasses$1.disabled, "):before"), {
      borderBottom: "2px solid ".concat(theme.palette.text.primary),
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        borderBottom: "1px solid ".concat(bottomLineColor)
      }
    }), _defineProperty(_ref167, "&.".concat(inputClasses$1.disabled, ":before"), {
      borderBottomStyle: 'dotted'
    }), _ref167));
  });
  var InputInput = styled$1(InputBaseComponent, {
    name: 'MuiInput',
    slot: 'Input',
    overridesResolver: inputOverridesResolver
  })({});
  var Input = /*#__PURE__*/React__namespace.forwardRef(function Input(inProps, ref) {
    var props = useThemeProps({
      props: inProps,
      name: 'MuiInput'
    });

    var disableUnderline = props.disableUnderline,
        _props$components9 = props.components,
        components = _props$components9 === void 0 ? {} : _props$components9,
        componentsPropsProp = props.componentsProps,
        _props$fullWidth8 = props.fullWidth,
        fullWidth = _props$fullWidth8 === void 0 ? false : _props$fullWidth8,
        _props$inputComponent3 = props.inputComponent,
        inputComponent = _props$inputComponent3 === void 0 ? 'input' : _props$inputComponent3,
        _props$multiline3 = props.multiline,
        multiline = _props$multiline3 === void 0 ? false : _props$multiline3,
        _props$type3 = props.type,
        type = _props$type3 === void 0 ? 'text' : _props$type3,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$U);

    var classes = useUtilityClasses$E(props);
    var ownerState = {
      disableUnderline: disableUnderline
    };
    var inputComponentsProps = {
      root: {
        ownerState: ownerState
      }
    };
    var componentsProps = componentsPropsProp ? deepmerge(componentsPropsProp, inputComponentsProps) : inputComponentsProps;
    return /*#__PURE__*/jsxRuntime$1.jsx(E$1, _extends$c({
      components: _extends$c({
        Root: InputRoot,
        Input: InputInput
      }, components),
      componentsProps: componentsProps,
      fullWidth: fullWidth,
      inputComponent: inputComponent,
      multiline: multiline,
      ref: ref,
      type: type
    }, other, {
      classes: classes
    }));
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  Input.muiName = 'Input';
  var Input$1 = Input;

  function getInputAdornmentUtilityClass(slot) {
    return generateUtilityClass('MuiInputAdornment', slot);
  }

  var inputAdornmentClasses = generateUtilityClasses('MuiInputAdornment', ['root', 'filled', 'standard', 'outlined', 'positionStart', 'positionEnd', 'disablePointerEvents', 'hiddenLabel', 'sizeSmall']);
  var inputAdornmentClasses$1 = inputAdornmentClasses;
  var _excluded$T = ["children", "className", "component", "disablePointerEvents", "disableTypography", "position", "variant"];

  var overridesResolver$2 = function overridesResolver$2(props, styles) {
    var ownerState = props.ownerState;
    return [styles.root, styles["position".concat(capitalize$1(ownerState.position))], ownerState.disablePointerEvents === true && styles.disablePointerEvents, styles[ownerState.variant]];
  };

  var useUtilityClasses$D = function useUtilityClasses$D(ownerState) {
    var classes = ownerState.classes,
        disablePointerEvents = ownerState.disablePointerEvents,
        hiddenLabel = ownerState.hiddenLabel,
        position = ownerState.position,
        size = ownerState.size,
        variant = ownerState.variant;
    var slots = {
      root: ['root', disablePointerEvents && 'disablePointerEvents', position && "position".concat(capitalize$1(position)), variant, hiddenLabel && 'hiddenLabel', size && "size".concat(capitalize$1(size))]
    };
    return composeClasses(slots, getInputAdornmentUtilityClass, classes);
  };

  var InputAdornmentRoot = styled$1('div', {
    name: 'MuiInputAdornment',
    slot: 'Root',
    overridesResolver: overridesResolver$2
  })(function (_ref168) {
    var theme = _ref168.theme,
        ownerState = _ref168.ownerState;
    return _extends$c({
      display: 'flex',
      height: '0.01em',
      // Fix IE11 flexbox alignment. To remove at some point.
      maxHeight: '2em',
      alignItems: 'center',
      whiteSpace: 'nowrap',
      color: theme.palette.action.active
    }, ownerState.variant === 'filled' && _defineProperty({}, "&.".concat(inputAdornmentClasses$1.positionStart, "&:not(.").concat(inputAdornmentClasses$1.hiddenLabel, ")"), {
      marginTop: 16
    }), ownerState.position === 'start' && {
      // Styles applied to the root element if `position="start"`.
      marginRight: 8
    }, ownerState.position === 'end' && {
      // Styles applied to the root element if `position="end"`.
      marginLeft: 8
    }, ownerState.disablePointerEvents === true && {
      // Styles applied to the root element if `disablePointerEvents={true}`.
      pointerEvents: 'none'
    });
  });
  var InputAdornment$1 = /*#__PURE__*/React__namespace.forwardRef(function InputAdornment(inProps, ref) {
    var props = useThemeProps({
      props: inProps,
      name: 'MuiInputAdornment'
    });

    var children = props.children,
        className = props.className,
        _props$component18 = props.component,
        component = _props$component18 === void 0 ? 'div' : _props$component18,
        _props$disablePointer = props.disablePointerEvents,
        disablePointerEvents = _props$disablePointer === void 0 ? false : _props$disablePointer,
        _props$disableTypogra2 = props.disableTypography,
        disableTypography = _props$disableTypogra2 === void 0 ? false : _props$disableTypogra2,
        position = props.position,
        variantProp = props.variant,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$T);

    var muiFormControl = useFormControl() || {};
    var variant = variantProp;

    if (variantProp && muiFormControl.variant) {
      if (process.env.NODE_ENV !== 'production') {
        if (variantProp === muiFormControl.variant) {
          console.error('MUI: The `InputAdornment` variant infers the variant prop ' + 'you do not have to provide one.');
        }
      }
    }

    if (muiFormControl && !variant) {
      variant = muiFormControl.variant;
    }

    var ownerState = _extends$c({}, props, {
      hiddenLabel: muiFormControl.hiddenLabel,
      size: muiFormControl.size,
      disablePointerEvents: disablePointerEvents,
      position: position,
      variant: variant
    });

    var classes = useUtilityClasses$D(ownerState);
    return /*#__PURE__*/jsxRuntime$1.jsx(FormControlContext$1.Provider, {
      value: null,
      children: /*#__PURE__*/jsxRuntime$1.jsx(InputAdornmentRoot, _extends$c({
        as: component,
        ownerState: ownerState,
        className: clsx(classes.root, className),
        ref: ref
      }, other, {
        children: typeof children === 'string' && !disableTypography ? /*#__PURE__*/jsxRuntime$1.jsx(Typography$2, {
          color: "text.secondary",
          children: children
        }) : /*#__PURE__*/jsxRuntime$1.jsxs(React__namespace.Fragment, {
          children: [position === 'start' ?
          /*#__PURE__*/

          /* notranslate needed while Google Translate will not fix zero-width space issue */

          /* eslint-disable-next-line react/no-danger */
          jsxRuntime$1.jsx("span", {
            className: "notranslate",
            dangerouslySetInnerHTML: {
              __html: '&#8203;'
            }
          }) : null, children]
        })
      }))
    });
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var InputAdornment$2 = InputAdornment$1;

  function getInputLabelUtilityClasses(slot) {
    return generateUtilityClass('MuiInputLabel', slot);
  }

  generateUtilityClasses('MuiInputLabel', ['root', 'focused', 'disabled', 'error', 'required', 'asterisk', 'formControl', 'sizeSmall', 'shrink', 'animated', 'standard', 'filled', 'outlined']);
  var _excluded$S = ["disableAnimation", "margin", "shrink", "variant"];

  var useUtilityClasses$C = function useUtilityClasses$C(ownerState) {
    var classes = ownerState.classes,
        formControl = ownerState.formControl,
        size = ownerState.size,
        shrink = ownerState.shrink,
        disableAnimation = ownerState.disableAnimation,
        variant = ownerState.variant,
        required = ownerState.required;
    var slots = {
      root: ['root', formControl && 'formControl', !disableAnimation && 'animated', shrink && 'shrink', size === 'small' && 'sizeSmall', variant],
      asterisk: [required && 'asterisk']
    };
    var composedClasses = composeClasses(slots, getInputLabelUtilityClasses, classes);
    return _extends$c({}, classes, composedClasses);
  };

  var InputLabelRoot = styled$1(BaseFormLabel, {
    shouldForwardProp: function shouldForwardProp(prop) {
      return rootShouldForwardProp(prop) || prop === 'classes';
    },
    name: 'MuiInputLabel',
    slot: 'Root',
    overridesResolver: function overridesResolver(props, styles) {
      var ownerState = props.ownerState;
      return [_defineProperty({}, "& .".concat(formLabelClasses$1.asterisk), styles.asterisk), styles.root, ownerState.formControl && styles.formControl, ownerState.size === 'small' && styles.sizeSmall, ownerState.shrink && styles.shrink, !ownerState.disableAnimation && styles.animated, styles[ownerState.variant]];
    }
  })(function (_ref171) {
    var theme = _ref171.theme,
        ownerState = _ref171.ownerState;
    return _extends$c({
      display: 'block',
      transformOrigin: 'top left',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      maxWidth: '100%'
    }, ownerState.formControl && {
      position: 'absolute',
      left: 0,
      top: 0,
      // slight alteration to spec spacing to match visual spec result
      transform: 'translate(0, 20px) scale(1)'
    }, ownerState.size === 'small' && {
      // Compensation for the `Input.inputSizeSmall` style.
      transform: 'translate(0, 17px) scale(1)'
    }, ownerState.shrink && {
      transform: 'translate(0, -1.5px) scale(0.75)',
      transformOrigin: 'top left',
      maxWidth: '133%'
    }, !ownerState.disableAnimation && {
      transition: theme.transitions.create(['color', 'transform', 'max-width'], {
        duration: theme.transitions.duration.shorter,
        easing: theme.transitions.easing.easeOut
      })
    }, ownerState.variant === 'filled' && _extends$c({
      // Chrome's autofill feature gives the input field a yellow background.
      // Since the input field is behind the label in the HTML tree,
      // the input field is drawn last and hides the label with an opaque background color.
      // zIndex: 1 will raise the label above opaque background-colors of input.
      zIndex: 1,
      pointerEvents: 'none',
      transform: 'translate(12px, 16px) scale(1)',
      maxWidth: 'calc(100% - 24px)'
    }, ownerState.size === 'small' && {
      transform: 'translate(12px, 13px) scale(1)'
    }, ownerState.shrink && _extends$c({
      transform: 'translate(12px, 7px) scale(0.75)',
      maxWidth: 'calc(133% - 24px)'
    }, ownerState.size === 'small' && {
      transform: 'translate(12px, 4px) scale(0.75)'
    })), ownerState.variant === 'outlined' && _extends$c({
      // see comment above on filled.zIndex
      zIndex: 1,
      pointerEvents: 'none',
      transform: 'translate(14px, 16px) scale(1)',
      maxWidth: 'calc(100% - 24px)'
    }, ownerState.size === 'small' && {
      transform: 'translate(14px, 9px) scale(1)'
    }, ownerState.shrink && {
      maxWidth: 'calc(133% - 24px)',
      transform: 'translate(14px, -9px) scale(0.75)'
    }));
  });
  var InputLabel$1 = /*#__PURE__*/React__namespace.forwardRef(function InputLabel(inProps, ref) {
    var props = useThemeProps({
      name: 'MuiInputLabel',
      props: inProps
    });

    var _props$disableAnimati = props.disableAnimation,
        disableAnimation = _props$disableAnimati === void 0 ? false : _props$disableAnimati,
        shrinkProp = props.shrink,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$S);

    var muiFormControl = useFormControl();
    var shrink = shrinkProp;

    if (typeof shrink === 'undefined' && muiFormControl) {
      shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    }

    var fcs = formControlState({
      props: props,
      muiFormControl: muiFormControl,
      states: ['size', 'variant', 'required']
    });

    var ownerState = _extends$c({}, props, {
      disableAnimation: disableAnimation,
      formControl: muiFormControl,
      shrink: shrink,
      size: fcs.size,
      variant: fcs.variant,
      required: fcs.required
    });

    var classes = useUtilityClasses$C(ownerState);
    return /*#__PURE__*/jsxRuntime$1.jsx(InputLabelRoot, _extends$c({
      "data-shrink": shrink,
      ownerState: ownerState,
      ref: ref
    }, other, {
      classes: classes
    }));
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var BaseInputLabel = InputLabel$1;

  function getLinkUtilityClass(slot) {
    return generateUtilityClass('MuiLink', slot);
  }

  var linkClasses = generateUtilityClasses('MuiLink', ['root', 'underlineNone', 'underlineHover', 'underlineAlways', 'button', 'focusVisible']);
  var linkClasses$1 = linkClasses;
  var _excluded$R = ["className", "color", "component", "onBlur", "onFocus", "TypographyClasses", "underline", "variant"];
  var colorTransformations = {
    primary: 'primary.main',
    textPrimary: 'text.primary',
    secondary: 'secondary.main',
    textSecondary: 'text.secondary',
    error: 'error.main'
  };

  var transformDeprecatedColors = function transformDeprecatedColors(color) {
    return colorTransformations[color] || color;
  };

  var useUtilityClasses$B = function useUtilityClasses$B(ownerState) {
    var classes = ownerState.classes,
        component = ownerState.component,
        focusVisible = ownerState.focusVisible,
        underline = ownerState.underline;
    var slots = {
      root: ['root', "underline".concat(capitalize$1(underline)), component === 'button' && 'button', focusVisible && 'focusVisible']
    };
    return composeClasses(slots, getLinkUtilityClass, classes);
  };

  var LinkRoot = styled$1(Typography$2, {
    name: 'MuiLink',
    slot: 'Root',
    overridesResolver: function overridesResolver(props, styles) {
      var ownerState = props.ownerState;
      return [styles.root, styles["underline".concat(capitalize$1(ownerState.underline))], ownerState.component === 'button' && styles.button];
    }
  })(function (_ref172) {
    var theme = _ref172.theme,
        ownerState = _ref172.ownerState;
    var color = getPath$1(theme, "palette.".concat(transformDeprecatedColors(ownerState.color))) || ownerState.color;
    return _extends$c({}, ownerState.underline === 'none' && {
      textDecoration: 'none'
    }, ownerState.underline === 'hover' && {
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'underline'
      }
    }, ownerState.underline === 'always' && {
      textDecoration: 'underline',
      textDecorationColor: color !== 'inherit' ? alpha(color, 0.4) : undefined,
      '&:hover': {
        textDecorationColor: 'inherit'
      }
    }, ownerState.component === 'button' && _defineProperty({
      position: 'relative',
      WebkitTapHighlightColor: 'transparent',
      backgroundColor: 'transparent',
      // Reset default value
      // We disable the focus ring for mouse, touch and keyboard users.
      outline: 0,
      border: 0,
      margin: 0,
      // Remove the margin in Safari
      borderRadius: 0,
      padding: 0,
      // Remove the padding in Firefox
      cursor: 'pointer',
      userSelect: 'none',
      verticalAlign: 'middle',
      MozAppearance: 'none',
      // Reset
      WebkitAppearance: 'none',
      // Reset
      '&::-moz-focus-inner': {
        borderStyle: 'none' // Remove Firefox dotted outline.

      }
    }, "&.".concat(linkClasses$1.focusVisible), {
      outline: 'auto'
    }));
  });
  var Link$1 = /*#__PURE__*/React__namespace.forwardRef(function Link(inProps, ref) {
    var props = useThemeProps({
      props: inProps,
      name: 'MuiLink'
    });

    var className = props.className,
        _props$color12 = props.color,
        color = _props$color12 === void 0 ? 'primary' : _props$color12,
        _props$component19 = props.component,
        component = _props$component19 === void 0 ? 'a' : _props$component19,
        onBlur = props.onBlur,
        onFocus = props.onFocus,
        TypographyClasses = props.TypographyClasses,
        _props$underline = props.underline,
        underline = _props$underline === void 0 ? 'always' : _props$underline,
        _props$variant12 = props.variant,
        variant = _props$variant12 === void 0 ? 'inherit' : _props$variant12,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$R);

    var _useIsFocusVisible2 = useIsFocusVisible(),
        isFocusVisibleRef = _useIsFocusVisible2.isFocusVisibleRef,
        handleBlurVisible = _useIsFocusVisible2.onBlur,
        handleFocusVisible = _useIsFocusVisible2.onFocus,
        focusVisibleRef = _useIsFocusVisible2.ref;

    var _React__namespace$use53 = React__namespace.useState(false),
        _React__namespace$use54 = _slicedToArray(_React__namespace$use53, 2),
        focusVisible = _React__namespace$use54[0],
        setFocusVisible = _React__namespace$use54[1];

    var handlerRef = useForkRef(ref, focusVisibleRef);

    var handleBlur = function handleBlur(event) {
      handleBlurVisible(event);

      if (isFocusVisibleRef.current === false) {
        setFocusVisible(false);
      }

      if (onBlur) {
        onBlur(event);
      }
    };

    var handleFocus = function handleFocus(event) {
      handleFocusVisible(event);

      if (isFocusVisibleRef.current === true) {
        setFocusVisible(true);
      }

      if (onFocus) {
        onFocus(event);
      }
    };

    var ownerState = _extends$c({}, props, {
      color: color,
      component: component,
      focusVisible: focusVisible,
      underline: underline,
      variant: variant
    });

    var classes = useUtilityClasses$B(ownerState);
    return /*#__PURE__*/jsxRuntime$1.jsx(LinkRoot, _extends$c({
      className: clsx(classes.root, className),
      classes: TypographyClasses,
      color: color,
      component: component,
      onBlur: handleBlur,
      onFocus: handleFocus,
      ref: handlerRef,
      ownerState: ownerState,
      variant: variant
    }, other));
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var BaseLink = Link$1;
  /**
   * @ignore - internal component.
   */

  var ListContext = /*#__PURE__*/React__namespace.createContext({});

  if (process.env.NODE_ENV !== 'production') {
    ListContext.displayName = 'ListContext';
  }

  var ListContext$1 = ListContext;

  function getListUtilityClass(slot) {
    return generateUtilityClass('MuiList', slot);
  }

  generateUtilityClasses('MuiList', ['root', 'padding', 'dense', 'subheader']);
  var _excluded$Q = ["children", "className", "component", "dense", "disablePadding", "subheader"];

  var useUtilityClasses$A = function useUtilityClasses$A(ownerState) {
    var classes = ownerState.classes,
        disablePadding = ownerState.disablePadding,
        dense = ownerState.dense,
        subheader = ownerState.subheader;
    var slots = {
      root: ['root', !disablePadding && 'padding', dense && 'dense', subheader && 'subheader']
    };
    return composeClasses(slots, getListUtilityClass, classes);
  };

  var ListRoot = styled$1('ul', {
    name: 'MuiList',
    slot: 'Root',
    overridesResolver: function overridesResolver(props, styles) {
      var ownerState = props.ownerState;
      return [styles.root, !ownerState.disablePadding && styles.padding, ownerState.dense && styles.dense, ownerState.subheader && styles.subheader];
    }
  })(function (_ref174) {
    var ownerState = _ref174.ownerState;
    return _extends$c({
      listStyle: 'none',
      margin: 0,
      padding: 0,
      position: 'relative'
    }, !ownerState.disablePadding && {
      paddingTop: 8,
      paddingBottom: 8
    }, ownerState.subheader && {
      paddingTop: 0
    });
  });
  var List = /*#__PURE__*/React__namespace.forwardRef(function List(inProps, ref) {
    var props = useThemeProps({
      props: inProps,
      name: 'MuiList'
    });

    var children = props.children,
        className = props.className,
        _props$component20 = props.component,
        component = _props$component20 === void 0 ? 'ul' : _props$component20,
        _props$dense = props.dense,
        dense = _props$dense === void 0 ? false : _props$dense,
        _props$disablePadding = props.disablePadding,
        disablePadding = _props$disablePadding === void 0 ? false : _props$disablePadding,
        subheader = props.subheader,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$Q);

    var context = React__namespace.useMemo(function () {
      return {
        dense: dense
      };
    }, [dense]);

    var ownerState = _extends$c({}, props, {
      component: component,
      dense: dense,
      disablePadding: disablePadding
    });

    var classes = useUtilityClasses$A(ownerState);
    return /*#__PURE__*/jsxRuntime$1.jsx(ListContext$1.Provider, {
      value: context,
      children: /*#__PURE__*/jsxRuntime$1.jsxs(ListRoot, _extends$c({
        as: component,
        className: clsx(classes.root, className),
        ref: ref,
        ownerState: ownerState
      }, other, {
        children: [subheader, children]
      }))
    });
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var List$1 = List;

  function getListItemIconUtilityClass(slot) {
    return generateUtilityClass('MuiListItemIcon', slot);
  }

  var listItemIconClasses = generateUtilityClasses('MuiListItemIcon', ['root', 'alignItemsFlexStart']);
  var listItemIconClasses$1 = listItemIconClasses;
  var _excluded$P = ["className"];

  var useUtilityClasses$z = function useUtilityClasses$z(ownerState) {
    var alignItems = ownerState.alignItems,
        classes = ownerState.classes;
    var slots = {
      root: ['root', alignItems === 'flex-start' && 'alignItemsFlexStart']
    };
    return composeClasses(slots, getListItemIconUtilityClass, classes);
  };

  var ListItemIconRoot = styled$1('div', {
    name: 'MuiListItemIcon',
    slot: 'Root',
    overridesResolver: function overridesResolver(props, styles) {
      var ownerState = props.ownerState;
      return [styles.root, ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart];
    }
  })(function (_ref175) {
    var theme = _ref175.theme,
        ownerState = _ref175.ownerState;
    return _extends$c({
      minWidth: 56,
      color: theme.palette.action.active,
      flexShrink: 0,
      display: 'inline-flex'
    }, ownerState.alignItems === 'flex-start' && {
      marginTop: 8
    });
  });
  /**
   * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
   */

  var ListItemIcon = /*#__PURE__*/React__namespace.forwardRef(function ListItemIcon(inProps, ref) {
    var props = useThemeProps({
      props: inProps,
      name: 'MuiListItemIcon'
    });

    var className = props.className,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$P);

    var context = React__namespace.useContext(ListContext$1);

    var ownerState = _extends$c({}, props, {
      alignItems: context.alignItems
    });

    var classes = useUtilityClasses$z(ownerState);
    return /*#__PURE__*/jsxRuntime$1.jsx(ListItemIconRoot, _extends$c({
      className: clsx(classes.root, className),
      ownerState: ownerState,
      ref: ref
    }, other));
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var j = ListItemIcon;
  var listItemTextClasses = generateUtilityClasses('MuiListItemText', ['root', 'multiline', 'dense', 'inset', 'primary', 'secondary']);
  var listItemTextClasses$1 = listItemTextClasses;
  var _excluded$O = ["actions", "autoFocus", "autoFocusItem", "children", "className", "disabledItemsFocusable", "disableListWrap", "onKeyDown", "variant"];

  function nextItem(list, item, disableListWrap) {
    if (list === item) {
      return list.firstChild;
    }

    if (item && item.nextElementSibling) {
      return item.nextElementSibling;
    }

    return disableListWrap ? null : list.firstChild;
  }

  function previousItem(list, item, disableListWrap) {
    if (list === item) {
      return disableListWrap ? list.firstChild : list.lastChild;
    }

    if (item && item.previousElementSibling) {
      return item.previousElementSibling;
    }

    return disableListWrap ? null : list.lastChild;
  }

  function textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) {
      return true;
    }

    var text = nextFocus.innerText;

    if (text === undefined) {
      // jsdom doesn't support innerText
      text = nextFocus.textContent;
    }

    text = text.trim().toLowerCase();

    if (text.length === 0) {
      return false;
    }

    if (textCriteria.repeating) {
      return text[0] === textCriteria.keys[0];
    }

    return text.indexOf(textCriteria.keys.join('')) === 0;
  }

  function moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    var wrappedOnce = false;
    var nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);

    while (nextFocus) {
      // Prevent infinite loop.
      if (nextFocus === list.firstChild) {
        if (wrappedOnce) {
          return false;
        }

        wrappedOnce = true;
      } // Same logic as useAutocomplete.js


      var nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';

      if (!nextFocus.hasAttribute('tabindex') || !textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) {
        // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
      } else {
        nextFocus.focus();
        return true;
      }
    }

    return false;
  }
  /**
   * A permanently displayed menu following https://www.w3.org/TR/wai-aria-practices/#menubutton.
   * It's exposed to help customization of the [`Menu`](/api/menu/) component if you
   * use it separately you need to move focus into the component manually. Once
   * the focus is placed inside the component it is fully keyboard accessible.
   */


  var MenuList$1 = /*#__PURE__*/React__namespace.forwardRef(function MenuList(props, ref) {
    var actions = props.actions,
        _props$autoFocus = props.autoFocus,
        autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus,
        _props$autoFocusItem = props.autoFocusItem,
        autoFocusItem = _props$autoFocusItem === void 0 ? false : _props$autoFocusItem,
        children = props.children,
        className = props.className,
        _props$disabledItemsF3 = props.disabledItemsFocusable,
        disabledItemsFocusable = _props$disabledItemsF3 === void 0 ? false : _props$disabledItemsF3,
        _props$disableListWra3 = props.disableListWrap,
        disableListWrap = _props$disableListWra3 === void 0 ? false : _props$disableListWra3,
        onKeyDown = props.onKeyDown,
        _props$variant13 = props.variant,
        variant = _props$variant13 === void 0 ? 'selectedMenu' : _props$variant13,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$O);

    var listRef = React__namespace.useRef(null);
    var textCriteriaRef = React__namespace.useRef({
      keys: [],
      repeating: true,
      previousKeyMatched: true,
      lastTime: null
    });
    useEnhancedEffect$1(function () {
      if (autoFocus) {
        listRef.current.focus();
      }
    }, [autoFocus]);
    React__namespace.useImperativeHandle(actions, function () {
      return {
        adjustStyleForScrollbar: function adjustStyleForScrollbar(containerElement, theme) {
          // Let's ignore that piece of logic if users are already overriding the width
          // of the menu.
          var noExplicitWidth = !listRef.current.style.width;

          if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
            var scrollbarSize = "".concat(getScrollbarSize(ownerDocument(containerElement)), "px");
            listRef.current.style[theme.direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = scrollbarSize;
            listRef.current.style.width = "calc(100% + ".concat(scrollbarSize, ")");
          }

          return listRef.current;
        }
      };
    }, []);

    var handleKeyDown = function handleKeyDown(event) {
      var list = listRef.current;
      var key = event.key;
      /**
       * @type {Element} - will always be defined since we are in a keydown handler
       * attached to an element. A keydown event is either dispatched to the activeElement
       * or document.body or document.documentElement. Only the first case will
       * trigger this specific handler.
       */

      var currentFocus = ownerDocument(list).activeElement;

      if (key === 'ArrowDown') {
        // Prevent scroll of the page
        event.preventDefault();
        moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, nextItem);
      } else if (key === 'ArrowUp') {
        event.preventDefault();
        moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, previousItem);
      } else if (key === 'Home') {
        event.preventDefault();
        moveFocus(list, null, disableListWrap, disabledItemsFocusable, nextItem);
      } else if (key === 'End') {
        event.preventDefault();
        moveFocus(list, null, disableListWrap, disabledItemsFocusable, previousItem);
      } else if (key.length === 1) {
        var criteria = textCriteriaRef.current;
        var lowerKey = key.toLowerCase();
        var currTime = performance.now();

        if (criteria.keys.length > 0) {
          // Reset
          if (currTime - criteria.lastTime > 500) {
            criteria.keys = [];
            criteria.repeating = true;
            criteria.previousKeyMatched = true;
          } else if (criteria.repeating && lowerKey !== criteria.keys[0]) {
            criteria.repeating = false;
          }
        }

        criteria.lastTime = currTime;
        criteria.keys.push(lowerKey);
        var keepFocusOnCurrent = currentFocus && !criteria.repeating && textCriteriaMatches(currentFocus, criteria);

        if (criteria.previousKeyMatched && (keepFocusOnCurrent || moveFocus(list, currentFocus, false, disabledItemsFocusable, nextItem, criteria))) {
          event.preventDefault();
        } else {
          criteria.previousKeyMatched = false;
        }
      }

      if (onKeyDown) {
        onKeyDown(event);
      }
    };

    var handleRef = useForkRef(listRef, ref);
    /**
     * the index of the item should receive focus
     * in a `variant="selectedMenu"` it's the first `selected` item
     * otherwise it's the very first item.
     */

    var activeItemIndex = -1; // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback

    React__namespace.Children.forEach(children, function (child, index) {
      if (! /*#__PURE__*/React__namespace.isValidElement(child)) {
        return;
      }

      if (process.env.NODE_ENV !== 'production') {
        if (reactIs$2.exports.isFragment(child)) {
          console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
        }
      }

      if (!child.props.disabled) {
        if (variant === 'selectedMenu' && child.props.selected) {
          activeItemIndex = index;
        } else if (activeItemIndex === -1) {
          activeItemIndex = index;
        }
      }
    });
    var items = React__namespace.Children.map(children, function (child, index) {
      if (index === activeItemIndex) {
        var newChildProps = {};

        if (autoFocusItem) {
          newChildProps.autoFocus = true;
        }

        if (child.props.tabIndex === undefined && variant === 'selectedMenu') {
          newChildProps.tabIndex = 0;
        }

        return /*#__PURE__*/React__namespace.cloneElement(child, newChildProps);
      }

      return child;
    });
    return /*#__PURE__*/jsxRuntime$1.jsx(List$1, _extends$c({
      role: "menu",
      ref: handleRef,
      className: className,
      onKeyDown: handleKeyDown,
      tabIndex: autoFocus ? 0 : -1
    }, other, {
      children: items
    }));
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var BaseMenuList = MenuList$1;

  function getPopoverUtilityClass(slot) {
    return generateUtilityClass('MuiPopover', slot);
  }

  generateUtilityClasses('MuiPopover', ['root', 'paper']);
  var _excluded$N = ["onEntering"],
      _excluded2$3 = ["action", "anchorEl", "anchorOrigin", "anchorPosition", "anchorReference", "children", "className", "container", "elevation", "marginThreshold", "open", "PaperProps", "transformOrigin", "TransitionComponent", "transitionDuration", "TransitionProps"];

  function getOffsetTop(rect, vertical) {
    var offset = 0;

    if (typeof vertical === 'number') {
      offset = vertical;
    } else if (vertical === 'center') {
      offset = rect.height / 2;
    } else if (vertical === 'bottom') {
      offset = rect.height;
    }

    return offset;
  }

  function getOffsetLeft(rect, horizontal) {
    var offset = 0;

    if (typeof horizontal === 'number') {
      offset = horizontal;
    } else if (horizontal === 'center') {
      offset = rect.width / 2;
    } else if (horizontal === 'right') {
      offset = rect.width;
    }

    return offset;
  }

  function getTransformOriginValue(transformOrigin) {
    return [transformOrigin.horizontal, transformOrigin.vertical].map(function (n) {
      return typeof n === 'number' ? "".concat(n, "px") : n;
    }).join(' ');
  }

  function resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
  }

  var useUtilityClasses$y = function useUtilityClasses$y(ownerState) {
    var classes = ownerState.classes;
    var slots = {
      root: ['root'],
      paper: ['paper']
    };
    return composeClasses(slots, getPopoverUtilityClass, classes);
  };

  var PopoverRoot = styled$1(Modal$1, {
    name: 'MuiPopover',
    slot: 'Root',
    overridesResolver: function overridesResolver(props, styles) {
      return styles.root;
    }
  })({});
  var PopoverPaper = styled$1(BasePaper, {
    name: 'MuiPopover',
    slot: 'Paper',
    overridesResolver: function overridesResolver(props, styles) {
      return styles.paper;
    }
  })({
    position: 'absolute',
    overflowY: 'auto',
    overflowX: 'hidden',
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: 'calc(100% - 32px)',
    maxHeight: 'calc(100% - 32px)',
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
  });
  var Popover$1 = /*#__PURE__*/React__namespace.forwardRef(function Popover(inProps, ref) {
    var props = useThemeProps({
      props: inProps,
      name: 'MuiPopover'
    });
    var action = props.action,
        anchorEl = props.anchorEl,
        _props$anchorOrigin2 = props.anchorOrigin,
        anchorOrigin = _props$anchorOrigin2 === void 0 ? {
      vertical: 'top',
      horizontal: 'left'
    } : _props$anchorOrigin2,
        anchorPosition = props.anchorPosition,
        _props$anchorReferenc = props.anchorReference,
        anchorReference = _props$anchorReferenc === void 0 ? 'anchorEl' : _props$anchorReferenc,
        children = props.children,
        className = props.className,
        containerProp = props.container,
        _props$elevation3 = props.elevation,
        elevation = _props$elevation3 === void 0 ? 8 : _props$elevation3,
        _props$marginThreshol = props.marginThreshold,
        marginThreshold = _props$marginThreshol === void 0 ? 16 : _props$marginThreshol,
        open = props.open,
        _props$PaperProps3 = props.PaperProps,
        PaperProps = _props$PaperProps3 === void 0 ? {} : _props$PaperProps3,
        _props$transformOrigi = props.transformOrigin,
        transformOrigin = _props$transformOrigi === void 0 ? {
      vertical: 'top',
      horizontal: 'left'
    } : _props$transformOrigi,
        _props$TransitionComp9 = props.TransitionComponent,
        TransitionComponent = _props$TransitionComp9 === void 0 ? Grow$1 : _props$TransitionComp9,
        _props$transitionDura3 = props.transitionDuration,
        transitionDurationProp = _props$transitionDura3 === void 0 ? 'auto' : _props$transitionDura3,
        _props$TransitionProp = props.TransitionProps;
    _props$TransitionProp = _props$TransitionProp === void 0 ? {} : _props$TransitionProp;

    var onEntering = _props$TransitionProp.onEntering,
        TransitionProps = _objectWithoutPropertiesLoose$6(props.TransitionProps, _excluded$N),
        other = _objectWithoutPropertiesLoose$6(props, _excluded2$3);

    var paperRef = React__namespace.useRef();
    var handlePaperRef = useForkRef(paperRef, PaperProps.ref);

    var ownerState = _extends$c({}, props, {
      anchorOrigin: anchorOrigin,
      anchorReference: anchorReference,
      elevation: elevation,
      marginThreshold: marginThreshold,
      PaperProps: PaperProps,
      transformOrigin: transformOrigin,
      TransitionComponent: TransitionComponent,
      transitionDuration: transitionDurationProp,
      TransitionProps: TransitionProps
    });

    var classes = useUtilityClasses$y(ownerState); // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)

    var getAnchorOffset = React__namespace.useCallback(function () {
      if (anchorReference === 'anchorPosition') {
        if (process.env.NODE_ENV !== 'production') {
          if (!anchorPosition) {
            console.error('MUI: You need to provide a `anchorPosition` prop when using ' + '<Popover anchorReference="anchorPosition" />.');
          }
        }

        return anchorPosition;
      }

      var resolvedAnchorEl = resolveAnchorEl(anchorEl); // If an anchor element wasn't provided, just use the parent body element of this Popover

      var anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : ownerDocument(paperRef.current).body;
      var anchorRect = anchorElement.getBoundingClientRect();

      if (process.env.NODE_ENV !== 'production') {
        var box = anchorElement.getBoundingClientRect();

        if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
          console.warn(['MUI: The `anchorEl` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
        }
      }

      return {
        top: anchorRect.top + getOffsetTop(anchorRect, anchorOrigin.vertical),
        left: anchorRect.left + getOffsetLeft(anchorRect, anchorOrigin.horizontal)
      };
    }, [anchorEl, anchorOrigin.horizontal, anchorOrigin.vertical, anchorPosition, anchorReference]); // Returns the base transform origin using the element

    var getTransformOrigin = React__namespace.useCallback(function (elemRect) {
      return {
        vertical: getOffsetTop(elemRect, transformOrigin.vertical),
        horizontal: getOffsetLeft(elemRect, transformOrigin.horizontal)
      };
    }, [transformOrigin.horizontal, transformOrigin.vertical]);
    var getPositioningStyle = React__namespace.useCallback(function (element) {
      var elemRect = {
        width: element.offsetWidth,
        height: element.offsetHeight
      }; // Get the transform origin point on the element itself

      var elemTransformOrigin = getTransformOrigin(elemRect);

      if (anchorReference === 'none') {
        return {
          top: null,
          left: null,
          transformOrigin: getTransformOriginValue(elemTransformOrigin)
        };
      } // Get the offset of the anchoring element


      var anchorOffset = getAnchorOffset(); // Calculate element positioning

      var top = anchorOffset.top - elemTransformOrigin.vertical;
      var left = anchorOffset.left - elemTransformOrigin.horizontal;
      var bottom = top + elemRect.height;
      var right = left + elemRect.width; // Use the parent window of the anchorEl if provided

      var containerWindow = ownerWindow(resolveAnchorEl(anchorEl)); // Window thresholds taking required margin into account

      var heightThreshold = containerWindow.innerHeight - marginThreshold;
      var widthThreshold = containerWindow.innerWidth - marginThreshold; // Check if the vertical axis needs shifting

      if (top < marginThreshold) {
        var diff = top - marginThreshold;
        top -= diff;
        elemTransformOrigin.vertical += diff;
      } else if (bottom > heightThreshold) {
        var _diff = bottom - heightThreshold;

        top -= _diff;
        elemTransformOrigin.vertical += _diff;
      }

      if (process.env.NODE_ENV !== 'production') {
        if (elemRect.height > heightThreshold && elemRect.height && heightThreshold) {
          console.error(['MUI: The popover component is too tall.', "Some part of it can not be seen on the screen (".concat(elemRect.height - heightThreshold, "px)."), 'Please consider adding a `max-height` to improve the user-experience.'].join('\n'));
        }
      } // Check if the horizontal axis needs shifting


      if (left < marginThreshold) {
        var _diff2 = left - marginThreshold;

        left -= _diff2;
        elemTransformOrigin.horizontal += _diff2;
      } else if (right > widthThreshold) {
        var _diff3 = right - widthThreshold;

        left -= _diff3;
        elemTransformOrigin.horizontal += _diff3;
      }

      return {
        top: "".concat(Math.round(top), "px"),
        left: "".concat(Math.round(left), "px"),
        transformOrigin: getTransformOriginValue(elemTransformOrigin)
      };
    }, [anchorEl, anchorReference, getAnchorOffset, getTransformOrigin, marginThreshold]);
    var setPositioningStyles = React__namespace.useCallback(function () {
      var element = paperRef.current;

      if (!element) {
        return;
      }

      var positioning = getPositioningStyle(element);

      if (positioning.top !== null) {
        element.style.top = positioning.top;
      }

      if (positioning.left !== null) {
        element.style.left = positioning.left;
      }

      element.style.transformOrigin = positioning.transformOrigin;
    }, [getPositioningStyle]);

    var handleEntering = function handleEntering(element, isAppearing) {
      if (onEntering) {
        onEntering(element, isAppearing);
      }

      setPositioningStyles();
    };

    React__namespace.useEffect(function () {
      if (open) {
        setPositioningStyles();
      }
    });
    React__namespace.useImperativeHandle(action, function () {
      return open ? {
        updatePosition: function updatePosition() {
          setPositioningStyles();
        }
      } : null;
    }, [open, setPositioningStyles]);
    React__namespace.useEffect(function () {
      if (!open) {
        return undefined;
      }

      var handleResize = debounce$1(function () {
        setPositioningStyles();
      });
      var containerWindow = ownerWindow(anchorEl);
      containerWindow.addEventListener('resize', handleResize);
      return function () {
        handleResize.clear();
        containerWindow.removeEventListener('resize', handleResize);
      };
    }, [anchorEl, open, setPositioningStyles]);
    var transitionDuration = transitionDurationProp;

    if (transitionDurationProp === 'auto' && !TransitionComponent.muiSupportAuto) {
      transitionDuration = undefined;
    } // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container


    var container = containerProp || (anchorEl ? ownerDocument(resolveAnchorEl(anchorEl)).body : undefined);
    return /*#__PURE__*/jsxRuntime$1.jsx(PopoverRoot, _extends$c({
      BackdropProps: {
        invisible: true
      },
      className: clsx(classes.root, className),
      container: container,
      open: open,
      ref: ref,
      ownerState: ownerState
    }, other, {
      children: /*#__PURE__*/jsxRuntime$1.jsx(TransitionComponent, _extends$c({
        appear: true,
        in: open,
        onEntering: handleEntering,
        timeout: transitionDuration
      }, TransitionProps, {
        children: /*#__PURE__*/jsxRuntime$1.jsx(PopoverPaper, _extends$c({
          elevation: elevation
        }, PaperProps, {
          ref: handlePaperRef,
          className: clsx(classes.paper, PaperProps.className),
          children: children
        }))
      }))
    }));
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var BasePopover = Popover$1;

  function getMenuUtilityClass(slot) {
    return generateUtilityClass('MuiMenu', slot);
  }

  generateUtilityClasses('MuiMenu', ['root', 'paper', 'list']);
  var _excluded$M = ["onEntering"],
      _excluded2$2 = ["autoFocus", "children", "disableAutoFocusItem", "MenuListProps", "onClose", "open", "PaperProps", "PopoverClasses", "transitionDuration", "TransitionProps", "variant"];
  var RTL_ORIGIN = {
    vertical: 'top',
    horizontal: 'right'
  };
  var LTR_ORIGIN = {
    vertical: 'top',
    horizontal: 'left'
  };

  var useUtilityClasses$x = function useUtilityClasses$x(ownerState) {
    var classes = ownerState.classes;
    var slots = {
      root: ['root'],
      paper: ['paper'],
      list: ['list']
    };
    return composeClasses(slots, getMenuUtilityClass, classes);
  };

  var MenuRoot = styled$1(BasePopover, {
    shouldForwardProp: function shouldForwardProp(prop) {
      return rootShouldForwardProp(prop) || prop === 'classes';
    },
    name: 'MuiMenu',
    slot: 'Root',
    overridesResolver: function overridesResolver(props, styles) {
      return styles.root;
    }
  })({});
  var MenuPaper = styled$1(BasePaper, {
    name: 'MuiMenu',
    slot: 'Paper',
    overridesResolver: function overridesResolver(props, styles) {
      return styles.paper;
    }
  })({
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tapable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: 'calc(100% - 96px)',
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: 'touch'
  });
  var MenuMenuList = styled$1(BaseMenuList, {
    name: 'MuiMenu',
    slot: 'List',
    overridesResolver: function overridesResolver(props, styles) {
      return styles.list;
    }
  })({
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
  });
  var Menu$2 = /*#__PURE__*/React__namespace.forwardRef(function Menu(inProps, ref) {
    var props = useThemeProps({
      props: inProps,
      name: 'MuiMenu'
    });
    var _props$autoFocus2 = props.autoFocus,
        autoFocus = _props$autoFocus2 === void 0 ? true : _props$autoFocus2,
        children = props.children,
        _props$disableAutoFoc4 = props.disableAutoFocusItem,
        disableAutoFocusItem = _props$disableAutoFoc4 === void 0 ? false : _props$disableAutoFoc4,
        _props$MenuListProps = props.MenuListProps,
        MenuListProps = _props$MenuListProps === void 0 ? {} : _props$MenuListProps,
        onClose = props.onClose,
        open = props.open,
        _props$PaperProps4 = props.PaperProps,
        PaperProps = _props$PaperProps4 === void 0 ? {} : _props$PaperProps4,
        PopoverClasses = props.PopoverClasses,
        _props$transitionDura4 = props.transitionDuration,
        transitionDuration = _props$transitionDura4 === void 0 ? 'auto' : _props$transitionDura4,
        _props$TransitionProp2 = props.TransitionProps;
    _props$TransitionProp2 = _props$TransitionProp2 === void 0 ? {} : _props$TransitionProp2;

    var onEntering = _props$TransitionProp2.onEntering,
        _props$variant14 = props.variant,
        variant = _props$variant14 === void 0 ? 'selectedMenu' : _props$variant14,
        TransitionProps = _objectWithoutPropertiesLoose$6(props.TransitionProps, _excluded$M),
        other = _objectWithoutPropertiesLoose$6(props, _excluded2$2);

    var theme = useTheme();
    var isRtl = theme.direction === 'rtl';

    var ownerState = _extends$c({}, props, {
      autoFocus: autoFocus,
      disableAutoFocusItem: disableAutoFocusItem,
      MenuListProps: MenuListProps,
      onEntering: onEntering,
      PaperProps: PaperProps,
      transitionDuration: transitionDuration,
      TransitionProps: TransitionProps,
      variant: variant
    });

    var classes = useUtilityClasses$x(ownerState);
    var autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    var menuListActionsRef = React__namespace.useRef(null);

    var handleEntering = function handleEntering(element, isAppearing) {
      if (menuListActionsRef.current) {
        menuListActionsRef.current.adjustStyleForScrollbar(element, theme);
      }

      if (onEntering) {
        onEntering(element, isAppearing);
      }
    };

    var handleListKeyDown = function handleListKeyDown(event) {
      if (event.key === 'Tab') {
        event.preventDefault();

        if (onClose) {
          onClose(event, 'tabKeyDown');
        }
      }
    };
    /**
     * the index of the item should receive focus
     * in a `variant="selectedMenu"` it's the first `selected` item
     * otherwise it's the very first item.
     */


    var activeItemIndex = -1; // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback

    React__namespace.Children.map(children, function (child, index) {
      if (! /*#__PURE__*/React__namespace.isValidElement(child)) {
        return;
      }

      if (process.env.NODE_ENV !== 'production') {
        if (reactIs$2.exports.isFragment(child)) {
          console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
        }
      }

      if (!child.props.disabled) {
        if (variant === 'selectedMenu' && child.props.selected) {
          activeItemIndex = index;
        } else if (activeItemIndex === -1) {
          activeItemIndex = index;
        }
      }
    });
    return /*#__PURE__*/jsxRuntime$1.jsx(MenuRoot, _extends$c({
      classes: PopoverClasses,
      onClose: onClose,
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: isRtl ? 'right' : 'left'
      },
      transformOrigin: isRtl ? RTL_ORIGIN : LTR_ORIGIN,
      PaperProps: _extends$c({
        component: MenuPaper
      }, PaperProps, {
        classes: _extends$c({}, PaperProps.classes, {
          root: classes.paper
        })
      }),
      className: classes.root,
      open: open,
      ref: ref,
      transitionDuration: transitionDuration,
      TransitionProps: _extends$c({
        onEntering: handleEntering
      }, TransitionProps),
      ownerState: ownerState
    }, other, {
      children: /*#__PURE__*/jsxRuntime$1.jsx(MenuMenuList, _extends$c({
        onKeyDown: handleListKeyDown,
        actions: menuListActionsRef,
        autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
        autoFocusItem: autoFocusItem,
        variant: variant
      }, MenuListProps, {
        className: clsx(classes.list, MenuListProps.className),
        children: children
      }))
    }));
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var BaseMenu = Menu$2;

  function getMenuItemUtilityClass(slot) {
    return generateUtilityClass('MuiMenuItem', slot);
  }

  var menuItemClasses = generateUtilityClasses('MuiMenuItem', ['root', 'focusVisible', 'dense', 'disabled', 'divider', 'gutters', 'selected']);
  var menuItemClasses$1 = menuItemClasses;
  var _excluded$L = ["autoFocus", "component", "dense", "divider", "disableGutters", "focusVisibleClassName", "role", "tabIndex"];

  var overridesResolver$1 = function overridesResolver$1(props, styles) {
    var ownerState = props.ownerState;
    return [styles.root, ownerState.dense && styles.dense, ownerState.divider && styles.divider, !ownerState.disableGutters && styles.gutters];
  };

  var useUtilityClasses$w = function useUtilityClasses$w(ownerState) {
    var disabled = ownerState.disabled,
        dense = ownerState.dense,
        divider = ownerState.divider,
        disableGutters = ownerState.disableGutters,
        selected = ownerState.selected,
        classes = ownerState.classes;
    var slots = {
      root: ['root', dense && 'dense', disabled && 'disabled', !disableGutters && 'gutters', divider && 'divider', selected && 'selected']
    };
    var composedClasses = composeClasses(slots, getMenuItemUtilityClass, classes);
    return _extends$c({}, classes, composedClasses);
  };

  var MenuItemRoot = styled$1(ButtonBase$1, {
    shouldForwardProp: function shouldForwardProp(prop) {
      return rootShouldForwardProp(prop) || prop === 'classes';
    },
    name: 'MuiMenuItem',
    slot: 'Root',
    overridesResolver: overridesResolver$1
  })(function (_ref176) {
    var _extends$c18;

    var theme = _ref176.theme,
        ownerState = _ref176.ownerState;
    return _extends$c({}, theme.typography.body1, {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      position: 'relative',
      textDecoration: 'none',
      minHeight: 48,
      paddingTop: 6,
      paddingBottom: 6,
      boxSizing: 'border-box',
      whiteSpace: 'nowrap'
    }, !ownerState.disableGutters && {
      paddingLeft: 16,
      paddingRight: 16
    }, ownerState.divider && {
      borderBottom: "1px solid ".concat(theme.palette.divider),
      backgroundClip: 'padding-box'
    }, (_extends$c18 = {
      '&:hover': {
        textDecoration: 'none',
        backgroundColor: theme.palette.action.hover,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    }, _defineProperty(_extends$c18, "&.".concat(menuItemClasses$1.selected), _defineProperty({
      backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity)
    }, "&.".concat(menuItemClasses$1.focusVisible), {
      backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
    })), _defineProperty(_extends$c18, "&.".concat(menuItemClasses$1.selected, ":hover"), {
      backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity)
      }
    }), _defineProperty(_extends$c18, "&.".concat(menuItemClasses$1.focusVisible), {
      backgroundColor: theme.palette.action.focus
    }), _defineProperty(_extends$c18, "&.".concat(menuItemClasses$1.disabled), {
      opacity: theme.palette.action.disabledOpacity
    }), _defineProperty(_extends$c18, "& + .".concat(dividerClasses$1.root), {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1)
    }), _defineProperty(_extends$c18, "& + .".concat(dividerClasses$1.inset), {
      marginLeft: 52
    }), _defineProperty(_extends$c18, "& .".concat(listItemTextClasses$1.root), {
      marginTop: 0,
      marginBottom: 0
    }), _defineProperty(_extends$c18, "& .".concat(listItemTextClasses$1.inset), {
      paddingLeft: 36
    }), _defineProperty(_extends$c18, "& .".concat(listItemIconClasses$1.root), {
      minWidth: 36
    }), _extends$c18), !ownerState.dense && _defineProperty({}, theme.breakpoints.up('sm'), {
      minHeight: 'auto'
    }), ownerState.dense && _extends$c({
      minHeight: 32,
      // https://material.io/components/menus#specs > Dense
      paddingTop: 4,
      paddingBottom: 4
    }, theme.typography.body2, _defineProperty({}, "& .".concat(listItemIconClasses$1.root, " svg"), {
      fontSize: '1.25rem'
    })));
  });
  var MenuItem$1 = /*#__PURE__*/React__namespace.forwardRef(function MenuItem(inProps, ref) {
    var props = useThemeProps({
      props: inProps,
      name: 'MuiMenuItem'
    });

    var _props$autoFocus3 = props.autoFocus,
        autoFocus = _props$autoFocus3 === void 0 ? false : _props$autoFocus3,
        _props$component21 = props.component,
        component = _props$component21 === void 0 ? 'li' : _props$component21,
        _props$dense2 = props.dense,
        dense = _props$dense2 === void 0 ? false : _props$dense2,
        _props$divider = props.divider,
        divider = _props$divider === void 0 ? false : _props$divider,
        _props$disableGutters4 = props.disableGutters,
        disableGutters = _props$disableGutters4 === void 0 ? false : _props$disableGutters4,
        focusVisibleClassName = props.focusVisibleClassName,
        _props$role2 = props.role,
        role = _props$role2 === void 0 ? 'menuitem' : _props$role2,
        tabIndexProp = props.tabIndex,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$L);

    var context = React__namespace.useContext(ListContext$1);
    var childContext = {
      dense: dense || context.dense || false,
      disableGutters: disableGutters
    };
    var menuItemRef = React__namespace.useRef(null);
    useEnhancedEffect$1(function () {
      if (autoFocus) {
        if (menuItemRef.current) {
          menuItemRef.current.focus();
        } else if (process.env.NODE_ENV !== 'production') {
          console.error('MUI: Unable to set focus to a MenuItem whose component has not been rendered.');
        }
      }
    }, [autoFocus]);

    var ownerState = _extends$c({}, props, {
      dense: childContext.dense,
      divider: divider,
      disableGutters: disableGutters
    });

    var classes = useUtilityClasses$w(props);
    var handleRef = useForkRef(menuItemRef, ref);
    var tabIndex;

    if (!props.disabled) {
      tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    }

    return /*#__PURE__*/jsxRuntime$1.jsx(ListContext$1.Provider, {
      value: childContext,
      children: /*#__PURE__*/jsxRuntime$1.jsx(MenuItemRoot, _extends$c({
        ref: handleRef,
        role: role,
        tabIndex: tabIndex,
        component: component,
        focusVisibleClassName: clsx(classes.focusVisible, focusVisibleClassName)
      }, other, {
        ownerState: ownerState,
        classes: classes
      }))
    });
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var BaseMenuItem = MenuItem$1;

  function getNativeSelectUtilityClasses(slot) {
    return generateUtilityClass('MuiNativeSelect', slot);
  }

  var nativeSelectClasses = generateUtilityClasses('MuiNativeSelect', ['root', 'select', 'multiple', 'filled', 'outlined', 'standard', 'disabled', 'icon', 'iconOpen', 'iconFilled', 'iconOutlined', 'iconStandard', 'nativeInput']);
  var _excluded$K = ["className", "disabled", "IconComponent", "inputRef", "variant"];

  var useUtilityClasses$v = function useUtilityClasses$v(ownerState) {
    var classes = ownerState.classes,
        variant = ownerState.variant,
        disabled = ownerState.disabled,
        multiple = ownerState.multiple,
        open = ownerState.open;
    var slots = {
      select: ['select', variant, disabled && 'disabled', multiple && 'multiple'],
      icon: ['icon', "icon".concat(capitalize$1(variant)), open && 'iconOpen', disabled && 'disabled']
    };
    return composeClasses(slots, getNativeSelectUtilityClasses, classes);
  };

  var nativeSelectSelectStyles = function nativeSelectSelectStyles(_ref178) {
    var _extends$c20;

    var ownerState = _ref178.ownerState,
        theme = _ref178.theme;
    return _extends$c((_extends$c20 = {
      MozAppearance: 'none',
      // Reset
      WebkitAppearance: 'none',
      // Reset
      // When interacting quickly, the text can end up selected.
      // Native select can't be selected either.
      userSelect: 'none',
      borderRadius: 0,
      // Reset
      cursor: 'pointer',
      '&:focus': {
        // Show that it's not an text input
        backgroundColor: theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.05)' : 'rgba(255, 255, 255, 0.05)',
        borderRadius: 0 // Reset Chrome style

      },
      // Remove IE11 arrow
      '&::-ms-expand': {
        display: 'none'
      }
    }, _defineProperty(_extends$c20, "&.".concat(nativeSelectClasses.disabled), {
      cursor: 'default'
    }), _defineProperty(_extends$c20, '&[multiple]', {
      height: 'auto'
    }), _defineProperty(_extends$c20, '&:not([multiple]) option, &:not([multiple]) optgroup', {
      backgroundColor: theme.palette.background.paper
    }), _defineProperty(_extends$c20, '&&&', {
      paddingRight: 24,
      minWidth: 16 // So it doesn't collapse.

    }), _extends$c20), ownerState.variant === 'filled' && {
      '&&&': {
        paddingRight: 32
      }
    }, ownerState.variant === 'outlined' && {
      borderRadius: theme.shape.borderRadius,
      '&:focus': {
        borderRadius: theme.shape.borderRadius // Reset the reset for Chrome style

      },
      '&&&': {
        paddingRight: 32
      }
    });
  };

  var NativeSelectSelect = styled$1('select', {
    name: 'MuiNativeSelect',
    slot: 'Select',
    shouldForwardProp: rootShouldForwardProp,
    overridesResolver: function overridesResolver(props, styles) {
      var ownerState = props.ownerState;
      return [styles.select, styles[ownerState.variant], _defineProperty({}, "&.".concat(nativeSelectClasses.multiple), styles.multiple)];
    }
  })(nativeSelectSelectStyles);

  var nativeSelectIconStyles = function nativeSelectIconStyles(_ref180) {
    var ownerState = _ref180.ownerState,
        theme = _ref180.theme;
    return _extends$c(_defineProperty({
      // We use a position absolute over a flexbox in order to forward the pointer events
      // to the input and to support wrapping tags..
      position: 'absolute',
      right: 0,
      top: 'calc(50% - .5em)',
      // Center vertically, height is 1em
      pointerEvents: 'none',
      // Don't block pointer events on the select under the icon.
      color: theme.palette.action.active
    }, "&.".concat(nativeSelectClasses.disabled), {
      color: theme.palette.action.disabled
    }), ownerState.open && {
      transform: 'rotate(180deg)'
    }, ownerState.variant === 'filled' && {
      right: 7
    }, ownerState.variant === 'outlined' && {
      right: 7
    });
  };

  var NativeSelectIcon = styled$1('svg', {
    name: 'MuiNativeSelect',
    slot: 'Icon',
    overridesResolver: function overridesResolver(props, styles) {
      var ownerState = props.ownerState;
      return [styles.icon, ownerState.variant && styles["icon".concat(capitalize$1(ownerState.variant))], ownerState.open && styles.iconOpen];
    }
  })(nativeSelectIconStyles);
  /**
   * @ignore - internal component.
   */

  var NativeSelectInput = /*#__PURE__*/React__namespace.forwardRef(function NativeSelectInput(props, ref) {
    var className = props.className,
        disabled = props.disabled,
        IconComponent = props.IconComponent,
        inputRef = props.inputRef,
        _props$variant15 = props.variant,
        variant = _props$variant15 === void 0 ? 'standard' : _props$variant15,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$K);

    var ownerState = _extends$c({}, props, {
      disabled: disabled,
      variant: variant
    });

    var classes = useUtilityClasses$v(ownerState);
    return /*#__PURE__*/jsxRuntime$1.jsxs(React__namespace.Fragment, {
      children: [/*#__PURE__*/jsxRuntime$1.jsx(NativeSelectSelect, _extends$c({
        ownerState: ownerState,
        className: clsx(classes.select, className),
        disabled: disabled,
        ref: inputRef || ref
      }, other)), props.multiple ? null : /*#__PURE__*/jsxRuntime$1.jsx(NativeSelectIcon, {
        as: IconComponent,
        ownerState: ownerState,
        className: classes.icon
      })]
    });
  });
  process.env.NODE_ENV !== "production" ? NativeSelectInput.propTypes = {
    /**
     * The option elements to populate the select with.
     * Can be some `<option>` elements.
     */
    children: PropTypes.node,

    /**
     * Override or extend the styles applied to the component.
     * See [CSS API](#css) below for more details.
     */
    classes: PropTypes.object,

    /**
     * The CSS class name of the select element.
     */
    className: PropTypes.string,

    /**
     * If `true`, the select is disabled.
     */
    disabled: PropTypes.bool,

    /**
     * The icon that displays the arrow.
     */
    IconComponent: PropTypes.elementType.isRequired,

    /**
     * Use that prop to pass a ref to the native select element.
     * @deprecated
     */
    inputRef: refType$1,

    /**
     * @ignore
     */
    multiple: PropTypes.bool,

    /**
     * Name attribute of the `select` or hidden `input` element.
     */
    name: PropTypes.string,

    /**
     * Callback fired when a menu item is selected.
     *
     * @param {object} event The event source of the callback.
     * You can pull out the new value by accessing `event.target.value` (string).
     */
    onChange: PropTypes.func,

    /**
     * The input value.
     */
    value: PropTypes.any,

    /**
     * The variant to use.
     */
    variant: PropTypes.oneOf(['standard', 'outlined', 'filled'])
  } : void 0;
  var NativeSelectInput$1 = NativeSelectInput;
  var _excluded$J = ["className", "children", "classes", "IconComponent", "input", "inputProps", "variant"],
      _excluded2$1 = ["root"];

  var useUtilityClasses$u = function useUtilityClasses$u(ownerState) {
    var classes = ownerState.classes;
    var slots = {
      root: ['root']
    };
    return composeClasses(slots, getNativeSelectUtilityClasses, classes);
  };

  var defaultInput = /*#__PURE__*/jsxRuntime$1.jsx(Input$1, {});
  /**
   * An alternative to `<Select native />` with a much smaller bundle size footprint.
   */

  var NativeSelect$1 = /*#__PURE__*/React__namespace.forwardRef(function NativeSelect(inProps, ref) {
    var props = useThemeProps({
      name: 'MuiNativeSelect',
      props: inProps
    });

    var className = props.className,
        children = props.children,
        _props$classes2 = props.classes,
        classesProp = _props$classes2 === void 0 ? {} : _props$classes2,
        _props$IconComponent = props.IconComponent,
        IconComponent = _props$IconComponent === void 0 ? ArrowDropDownIcon$1 : _props$IconComponent,
        _props$input = props.input,
        input = _props$input === void 0 ? defaultInput : _props$input,
        inputProps = props.inputProps,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$J);

    var muiFormControl = useFormControl();
    var fcs = formControlState({
      props: props,
      muiFormControl: muiFormControl,
      states: ['variant']
    });

    var ownerState = _extends$c({}, props, {
      classes: classesProp
    });

    var classes = useUtilityClasses$u(ownerState);

    var otherClasses = _objectWithoutPropertiesLoose$6(classesProp, _excluded2$1);

    return /*#__PURE__*/React__namespace.cloneElement(input, _extends$c({
      // Most of the logic is implemented in `NativeSelectInput`.
      // The `Select` component is a simple API wrapper to expose something better to play with.
      inputComponent: NativeSelectInput$1,
      inputProps: _extends$c({
        children: children,
        classes: otherClasses,
        IconComponent: IconComponent,
        variant: fcs.variant,
        type: undefined
      }, inputProps, input ? input.props.inputProps : {}),
      ref: ref
    }, other, {
      className: clsx(classes.root, input.props.className, className)
    }));
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  NativeSelect$1.muiName = 'Select';
  var BaseNativeSelect = NativeSelect$1;
  var _excluded$I = ["children", "classes", "className", "label", "notched"];
  var NotchedOutlineRoot$1 = styled$1('fieldset')({
    textAlign: 'left',
    position: 'absolute',
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: '0 8px',
    pointerEvents: 'none',
    borderRadius: 'inherit',
    borderStyle: 'solid',
    borderWidth: 1,
    overflow: 'hidden',
    minWidth: '0%'
  });
  var NotchedOutlineLegend = styled$1('legend', {
    skipSx: true
  })(function (_ref181) {
    var ownerState = _ref181.ownerState,
        theme = _ref181.theme;
    return _extends$c({
      float: 'unset'
    }, ownerState.label === undefined && {
      padding: 0,
      lineHeight: '11px',
      // sync with `height` in `legend` styles
      transition: theme.transitions.create('width', {
        duration: 150,
        easing: theme.transitions.easing.easeOut
      })
    }, ownerState.label !== undefined && _extends$c({
      display: 'block',
      // Fix conflict with normalize.css and sanitize.css
      width: 'auto',
      // Fix conflict with bootstrap
      padding: 0,
      height: 11,
      // sync with `lineHeight` in `legend` styles
      fontSize: '0.75em',
      visibility: 'hidden',
      maxWidth: 0.01,
      transition: theme.transitions.create('max-width', {
        duration: 50,
        easing: theme.transitions.easing.easeOut
      }),
      whiteSpace: 'nowrap',
      '& > span': {
        paddingLeft: 5,
        paddingRight: 5,
        display: 'inline-block'
      }
    }, ownerState.notched && {
      maxWidth: '100%',
      transition: theme.transitions.create('max-width', {
        duration: 100,
        easing: theme.transitions.easing.easeOut,
        delay: 50
      })
    }));
  });
  /**
   * @ignore - internal component.
   */

  function NotchedOutline(props) {
    var className = props.className,
        label = props.label,
        notched = props.notched,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$I);

    var ownerState = _extends$c({}, props, {
      notched: notched,
      label: label
    });

    return /*#__PURE__*/jsxRuntime$1.jsx(NotchedOutlineRoot$1, _extends$c({
      "aria-hidden": true,
      className: className,
      ownerState: ownerState
    }, other, {
      children: /*#__PURE__*/jsxRuntime$1.jsx(NotchedOutlineLegend, {
        ownerState: ownerState,
        children: label ? /*#__PURE__*/jsxRuntime$1.jsx("span", {
          children: label
        }) :
        /*#__PURE__*/
        // notranslate needed while Google Translate will not fix zero-width space issue
        // eslint-disable-next-line react/no-danger
        jsxRuntime$1.jsx("span", {
          className: "notranslate",
          dangerouslySetInnerHTML: {
            __html: '&#8203;'
          }
        })
      })
    }));
  }

  process.env.NODE_ENV !== "production" ? NotchedOutline.propTypes = {
    /**
     * The content of the component.
     */
    children: PropTypes.node,

    /**
     * Override or extend the styles applied to the component.
     * See [CSS API](#css) below for more details.
     */
    classes: PropTypes.object,

    /**
     * @ignore
     */
    className: PropTypes.string,

    /**
     * The label.
     */
    label: PropTypes.node,

    /**
     * If `true`, the outline is notched to accommodate the label.
     */
    notched: PropTypes.bool.isRequired,

    /**
     * @ignore
     */
    style: PropTypes.object
  } : void 0;
  var _excluded$H = ["components", "fullWidth", "inputComponent", "label", "multiline", "notched", "type"];

  var useUtilityClasses$t = function useUtilityClasses$t(ownerState) {
    var classes = ownerState.classes;
    var slots = {
      root: ['root'],
      notchedOutline: ['notchedOutline'],
      input: ['input']
    };
    var composedClasses = composeClasses(slots, getOutlinedInputUtilityClass, classes);
    return _extends$c({}, classes, composedClasses);
  };

  var OutlinedInputRoot = styled$1(InputBaseRoot, {
    shouldForwardProp: function shouldForwardProp(prop) {
      return rootShouldForwardProp(prop) || prop === 'classes';
    },
    name: 'MuiOutlinedInput',
    slot: 'Root',
    overridesResolver: rootOverridesResolver
  })(function (_ref182) {
    var _extends$c22;

    var theme = _ref182.theme,
        ownerState = _ref182.ownerState;
    var borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return _extends$c((_extends$c22 = {
      position: 'relative',
      borderRadius: theme.shape.borderRadius
    }, _defineProperty(_extends$c22, "&:hover .".concat(outlinedInputClasses$1.notchedOutline), {
      borderColor: theme.palette.text.primary
    }), _defineProperty(_extends$c22, '@media (hover: none)', _defineProperty({}, "&:hover .".concat(outlinedInputClasses$1.notchedOutline), {
      borderColor: borderColor
    })), _defineProperty(_extends$c22, "&.".concat(outlinedInputClasses$1.focused, " .").concat(outlinedInputClasses$1.notchedOutline), {
      borderColor: theme.palette[ownerState.color].main,
      borderWidth: 2
    }), _defineProperty(_extends$c22, "&.".concat(outlinedInputClasses$1.error, " .").concat(outlinedInputClasses$1.notchedOutline), {
      borderColor: theme.palette.error.main
    }), _defineProperty(_extends$c22, "&.".concat(outlinedInputClasses$1.disabled, " .").concat(outlinedInputClasses$1.notchedOutline), {
      borderColor: theme.palette.action.disabled
    }), _extends$c22), ownerState.startAdornment && {
      paddingLeft: 14
    }, ownerState.endAdornment && {
      paddingRight: 14
    }, ownerState.multiline && _extends$c({
      padding: '16.5px 14px'
    }, ownerState.size === 'small' && {
      padding: '8.5px 14px'
    }));
  });
  var NotchedOutlineRoot = styled$1(NotchedOutline, {
    name: 'MuiOutlinedInput',
    slot: 'NotchedOutline',
    overridesResolver: function overridesResolver(props, styles) {
      return styles.notchedOutline;
    }
  })(function (_ref183) {
    var theme = _ref183.theme;
    return {
      borderColor: theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'
    };
  });
  var OutlinedInputInput = styled$1(InputBaseComponent, {
    name: 'MuiOutlinedInput',
    slot: 'Input',
    overridesResolver: inputOverridesResolver
  })(function (_ref184) {
    var theme = _ref184.theme,
        ownerState = _ref184.ownerState;
    return _extends$c({
      padding: '16.5px 14px',
      '&:-webkit-autofill': {
        WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
        WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
        caretColor: theme.palette.mode === 'light' ? null : '#fff',
        borderRadius: 'inherit'
      }
    }, ownerState.size === 'small' && {
      padding: '8.5px 14px'
    }, ownerState.multiline && {
      padding: 0
    }, ownerState.startAdornment && {
      paddingLeft: 0
    }, ownerState.endAdornment && {
      paddingRight: 0
    });
  });
  var OutlinedInput = /*#__PURE__*/React__namespace.forwardRef(function OutlinedInput(inProps, ref) {
    var props = useThemeProps({
      props: inProps,
      name: 'MuiOutlinedInput'
    });

    var _props$components10 = props.components,
        components = _props$components10 === void 0 ? {} : _props$components10,
        _props$fullWidth9 = props.fullWidth,
        fullWidth = _props$fullWidth9 === void 0 ? false : _props$fullWidth9,
        _props$inputComponent4 = props.inputComponent,
        inputComponent = _props$inputComponent4 === void 0 ? 'input' : _props$inputComponent4,
        label = props.label,
        _props$multiline4 = props.multiline,
        multiline = _props$multiline4 === void 0 ? false : _props$multiline4,
        notched = props.notched,
        _props$type4 = props.type,
        type = _props$type4 === void 0 ? 'text' : _props$type4,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$H);

    var classes = useUtilityClasses$t(props);
    return /*#__PURE__*/jsxRuntime$1.jsx(E$1, _extends$c({
      components: _extends$c({
        Root: OutlinedInputRoot,
        Input: OutlinedInputInput
      }, components),
      renderSuffix: function renderSuffix(state) {
        return /*#__PURE__*/jsxRuntime$1.jsx(NotchedOutlineRoot, {
          className: classes.notchedOutline,
          label: label,
          notched: typeof notched !== 'undefined' ? notched : Boolean(state.startAdornment || state.filled || state.focused)
        });
      },
      fullWidth: fullWidth,
      inputComponent: inputComponent,
      multiline: multiline,
      ref: ref,
      type: type
    }, other, {
      classes: _extends$c({}, classes, {
        notchedOutline: null
      })
    }));
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  OutlinedInput.muiName = 'Input';
  var OutlinedInput$1 = OutlinedInput;
  var FirstPageIcon = createSvgIcon$1( /*#__PURE__*/jsxRuntime$1.jsx("path", {
    d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
  }), 'FirstPage');
  var LastPageIcon = createSvgIcon$1( /*#__PURE__*/jsxRuntime$1.jsx("path", {
    d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
  }), 'LastPage');
  var RadioButtonUncheckedIcon = createSvgIcon$1( /*#__PURE__*/jsxRuntime$1.jsx("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
  }), 'RadioButtonUnchecked');
  var RadioButtonCheckedIcon = createSvgIcon$1( /*#__PURE__*/jsxRuntime$1.jsx("path", {
    d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
  }), 'RadioButtonChecked');
  var RadioButtonIconRoot = styled$1('span')({
    position: 'relative',
    display: 'flex'
  });
  var RadioButtonIconBackground = styled$1(RadioButtonUncheckedIcon, {
    skipSx: true
  })({
    // Scale applied to prevent dot misalignment in Safari
    transform: 'scale(1)'
  });
  var RadioButtonIconDot = styled$1(RadioButtonCheckedIcon, {
    skipSx: true
  })(function (_ref185) {
    var theme = _ref185.theme,
        ownerState = _ref185.ownerState;
    return _extends$c({
      left: 0,
      position: 'absolute',
      transform: 'scale(0)',
      transition: theme.transitions.create('transform', {
        easing: theme.transitions.easing.easeIn,
        duration: theme.transitions.duration.shortest
      })
    }, ownerState.checked && {
      transform: 'scale(1)',
      transition: theme.transitions.create('transform', {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.shortest
      })
    });
  });
  /**
   * @ignore - internal component.
   */

  function RadioButtonIcon(props) {
    var _props$checked = props.checked,
        checked = _props$checked === void 0 ? false : _props$checked,
        _props$classes3 = props.classes,
        classes = _props$classes3 === void 0 ? {} : _props$classes3,
        fontSize = props.fontSize;

    var ownerState = _extends$c({}, props, {
      checked: checked
    });

    return /*#__PURE__*/jsxRuntime$1.jsxs(RadioButtonIconRoot, {
      className: classes.root,
      ownerState: ownerState,
      children: [/*#__PURE__*/jsxRuntime$1.jsx(RadioButtonIconBackground, {
        fontSize: fontSize,
        className: classes.background,
        ownerState: ownerState
      }), /*#__PURE__*/jsxRuntime$1.jsx(RadioButtonIconDot, {
        fontSize: fontSize,
        className: classes.dot,
        ownerState: ownerState
      })]
    });
  }

  process.env.NODE_ENV !== "production" ? RadioButtonIcon.propTypes = {
    /**
     * If `true`, the component is checked.
     */
    checked: PropTypes.bool,

    /**
     * Override or extend the styles applied to the component.
     * See [CSS API](#css) below for more details.
     */
    classes: PropTypes.object,

    /**
     * The size of the component.
     * `small` is equivalent to the dense radio styling.
     */
    fontSize: PropTypes.oneOf(['small', 'medium'])
  } : void 0;
  /**
   * @ignore - internal component.
   */

  var RadioGroupContext = /*#__PURE__*/React__namespace.createContext(undefined);

  if (process.env.NODE_ENV !== 'production') {
    RadioGroupContext.displayName = 'RadioGroupContext';
  }

  var RadioGroupContext$1 = RadioGroupContext;

  function useRadioGroup() {
    return React__namespace.useContext(RadioGroupContext$1);
  }

  function getRadioUtilityClass(slot) {
    return generateUtilityClass('MuiRadio', slot);
  }

  var radioClasses = generateUtilityClasses('MuiRadio', ['root', 'checked', 'disabled', 'colorPrimary', 'colorSecondary']);
  var radioClasses$1 = radioClasses;
  var _excluded$G = ["checked", "checkedIcon", "color", "icon", "name", "onChange", "size"];

  var useUtilityClasses$s = function useUtilityClasses$s(ownerState) {
    var classes = ownerState.classes,
        color = ownerState.color;
    var slots = {
      root: ['root', "color".concat(capitalize$1(color))]
    };
    return _extends$c({}, classes, composeClasses(slots, getRadioUtilityClass, classes));
  };

  var RadioRoot = styled$1(SwitchBase$1, {
    shouldForwardProp: function shouldForwardProp(prop) {
      return rootShouldForwardProp(prop) || prop === 'classes';
    },
    name: 'MuiRadio',
    slot: 'Root',
    overridesResolver: function overridesResolver(props, styles) {
      var ownerState = props.ownerState;
      return [styles.root, styles["color".concat(capitalize$1(ownerState.color))]];
    }
  })(function (_ref186) {
    var theme = _ref186.theme,
        ownerState = _ref186.ownerState;
    return _extends$c({
      color: theme.palette.text.secondary,
      '&:hover': {
        backgroundColor: alpha(ownerState.color === 'default' ? theme.palette.action.active : theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    }, ownerState.color !== 'default' && _defineProperty({}, "&.".concat(radioClasses$1.checked), {
      color: theme.palette[ownerState.color].main
    }), _defineProperty({}, "&.".concat(radioClasses$1.disabled), {
      color: theme.palette.action.disabled
    }));
  });

  function areEqualValues$1(a, b) {
    if (typeof b === 'object' && b !== null) {
      return a === b;
    } // The value could be a number, the DOM will stringify it anyway.


    return String(a) === String(b);
  }

  var defaultCheckedIcon = /*#__PURE__*/jsxRuntime$1.jsx(RadioButtonIcon, {
    checked: true
  });
  var defaultIcon = /*#__PURE__*/jsxRuntime$1.jsx(RadioButtonIcon, {});
  var Radio$1 = /*#__PURE__*/React__namespace.forwardRef(function Radio(inProps, ref) {
    var _defaultIcon$props$fo, _defaultCheckedIcon$p;

    var props = useThemeProps({
      props: inProps,
      name: 'MuiRadio'
    });

    var checkedProp = props.checked,
        _props$checkedIcon2 = props.checkedIcon,
        checkedIcon = _props$checkedIcon2 === void 0 ? defaultCheckedIcon : _props$checkedIcon2,
        _props$color13 = props.color,
        color = _props$color13 === void 0 ? 'primary' : _props$color13,
        _props$icon2 = props.icon,
        icon = _props$icon2 === void 0 ? defaultIcon : _props$icon2,
        nameProp = props.name,
        onChangeProp = props.onChange,
        _props$size9 = props.size,
        size = _props$size9 === void 0 ? 'medium' : _props$size9,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$G);

    var ownerState = _extends$c({}, props, {
      color: color,
      size: size
    });

    var classes = useUtilityClasses$s(ownerState);
    var radioGroup = useRadioGroup();
    var checked = checkedProp;
    var onChange = createChainedFunction(onChangeProp, radioGroup && radioGroup.onChange);
    var name = nameProp;

    if (radioGroup) {
      if (typeof checked === 'undefined') {
        checked = areEqualValues$1(radioGroup.value, props.value);
      }

      if (typeof name === 'undefined') {
        name = radioGroup.name;
      }
    }

    return /*#__PURE__*/jsxRuntime$1.jsx(RadioRoot, _extends$c({
      type: "radio",
      icon: /*#__PURE__*/React__namespace.cloneElement(icon, {
        fontSize: (_defaultIcon$props$fo = defaultIcon.props.fontSize) != null ? _defaultIcon$props$fo : size
      }),
      checkedIcon: /*#__PURE__*/React__namespace.cloneElement(checkedIcon, {
        fontSize: (_defaultCheckedIcon$p = defaultCheckedIcon.props.fontSize) != null ? _defaultCheckedIcon$p : size
      }),
      ownerState: ownerState,
      classes: classes,
      name: name,
      checked: checked,
      onChange: onChange,
      ref: ref
    }, other));
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var BaseRadio = Radio$1;
  var _excluded$F = ["actions", "children", "defaultValue", "name", "onChange", "value"];
  var RadioGroup$1 = /*#__PURE__*/React__namespace.forwardRef(function RadioGroup(props, ref) {
    var actions = props.actions,
        children = props.children,
        defaultValue = props.defaultValue,
        nameProp = props.name,
        onChange = props.onChange,
        valueProp = props.value,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$F);

    var rootRef = React__namespace.useRef(null);

    var _useControlled11 = useControlled({
      controlled: valueProp,
      default: defaultValue,
      name: 'RadioGroup'
    }),
        _useControlled12 = _slicedToArray(_useControlled11, 2),
        value = _useControlled12[0],
        setValueState = _useControlled12[1];

    React__namespace.useImperativeHandle(actions, function () {
      return {
        focus: function focus() {
          var input = rootRef.current.querySelector('input:not(:disabled):checked');

          if (!input) {
            input = rootRef.current.querySelector('input:not(:disabled)');
          }

          if (input) {
            input.focus();
          }
        }
      };
    }, []);
    var handleRef = useForkRef(ref, rootRef);

    var handleChange = function handleChange(event) {
      setValueState(event.target.value);

      if (onChange) {
        onChange(event, event.target.value);
      }
    };

    var name = useId(nameProp);
    return /*#__PURE__*/jsxRuntime$1.jsx(RadioGroupContext$1.Provider, {
      value: {
        name: name,
        onChange: handleChange,
        value: value
      },
      children: /*#__PURE__*/jsxRuntime$1.jsx(BaseFormGroup, _extends$c({
        role: "radiogroup",
        ref: handleRef
      }, other, {
        children: children
      }))
    });
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var BaseRadioGroup$1 = RadioGroup$1;

  function getSelectUtilityClasses(slot) {
    return generateUtilityClass('MuiSelect', slot);
  }

  var selectClasses = generateUtilityClasses('MuiSelect', ['select', 'multiple', 'filled', 'outlined', 'standard', 'disabled', 'focused', 'icon', 'iconOpen', 'iconFilled', 'iconOutlined', 'iconStandard', 'nativeInput']);
  var selectClasses$1 = selectClasses;
  var _excluded$E = ["aria-describedby", "aria-label", "autoFocus", "autoWidth", "children", "className", "defaultValue", "disabled", "displayEmpty", "IconComponent", "inputRef", "labelId", "MenuProps", "multiple", "name", "onBlur", "onChange", "onClose", "onFocus", "onOpen", "open", "readOnly", "renderValue", "SelectDisplayProps", "tabIndex", "type", "value", "variant"];
  var SelectSelect = styled$1('div', {
    name: 'MuiSelect',
    slot: 'Select',
    overridesResolver: function overridesResolver(props, styles) {
      var ownerState = props.ownerState;
      return [// Win specificity over the input base
      _defineProperty({}, "&.".concat(selectClasses$1.select), styles.select), _defineProperty({}, "&.".concat(selectClasses$1.select), styles[ownerState.variant]), _defineProperty({}, "&.".concat(selectClasses$1.multiple), styles.multiple)];
    }
  })(nativeSelectSelectStyles, _defineProperty({}, "&.".concat(selectClasses$1.select), {
    height: 'auto',
    // Resets for multiple select with chips
    minHeight: '1.4375em',
    // Required for select\text-field height consistency
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden'
  }));
  var SelectIcon = styled$1('svg', {
    name: 'MuiSelect',
    slot: 'Icon',
    overridesResolver: function overridesResolver(props, styles) {
      var ownerState = props.ownerState;
      return [styles.icon, ownerState.variant && styles["icon".concat(capitalize$1(ownerState.variant))], ownerState.open && styles.iconOpen];
    }
  })(nativeSelectIconStyles);
  var SelectNativeInput = styled$1('input', {
    shouldForwardProp: function shouldForwardProp(prop) {
      return slotShouldForwardProp(prop) && prop !== 'classes';
    },
    name: 'MuiSelect',
    slot: 'NativeInput',
    overridesResolver: function overridesResolver(props, styles) {
      return styles.nativeInput;
    }
  })({
    bottom: 0,
    left: 0,
    position: 'absolute',
    opacity: 0,
    pointerEvents: 'none',
    width: '100%',
    boxSizing: 'border-box'
  });

  function areEqualValues(a, b) {
    if (typeof b === 'object' && b !== null) {
      return a === b;
    } // The value could be a number, the DOM will stringify it anyway.


    return String(a) === String(b);
  }

  function isEmpty(display) {
    return display == null || typeof display === 'string' && !display.trim();
  }

  var useUtilityClasses$r = function useUtilityClasses$r(ownerState) {
    var classes = ownerState.classes,
        variant = ownerState.variant,
        disabled = ownerState.disabled,
        multiple = ownerState.multiple,
        open = ownerState.open;
    var slots = {
      select: ['select', variant, disabled && 'disabled', multiple && 'multiple'],
      icon: ['icon', "icon".concat(capitalize$1(variant)), open && 'iconOpen', disabled && 'disabled'],
      nativeInput: ['nativeInput']
    };
    return composeClasses(slots, getSelectUtilityClasses, classes);
  };
  /**
   * @ignore - internal component.
   */


  var SelectInput = /*#__PURE__*/React__namespace.forwardRef(function SelectInput(props, ref) {
    var ariaDescribedby = props['aria-describedby'],
        ariaLabel = props['aria-label'],
        autoFocus = props.autoFocus,
        autoWidth = props.autoWidth,
        children = props.children,
        className = props.className,
        defaultValue = props.defaultValue,
        disabled = props.disabled,
        displayEmpty = props.displayEmpty,
        IconComponent = props.IconComponent,
        inputRefProp = props.inputRef,
        labelId = props.labelId,
        _props$MenuProps = props.MenuProps,
        MenuProps = _props$MenuProps === void 0 ? {} : _props$MenuProps,
        multiple = props.multiple,
        name = props.name,
        onBlur = props.onBlur,
        onChange = props.onChange,
        onClose = props.onClose,
        onFocus = props.onFocus,
        onOpen = props.onOpen,
        openProp = props.open,
        readOnly = props.readOnly,
        renderValue = props.renderValue,
        _props$SelectDisplayP = props.SelectDisplayProps,
        SelectDisplayProps = _props$SelectDisplayP === void 0 ? {} : _props$SelectDisplayP,
        tabIndexProp = props.tabIndex,
        valueProp = props.value,
        _props$variant16 = props.variant,
        variant = _props$variant16 === void 0 ? 'standard' : _props$variant16,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$E);

    var _useControlled13 = useControlled({
      controlled: valueProp,
      default: defaultValue,
      name: 'Select'
    }),
        _useControlled14 = _slicedToArray(_useControlled13, 2),
        value = _useControlled14[0],
        setValueState = _useControlled14[1];

    var inputRef = React__namespace.useRef(null);
    var displayRef = React__namespace.useRef(null);

    var _React__namespace$use55 = React__namespace.useState(null),
        _React__namespace$use56 = _slicedToArray(_React__namespace$use55, 2),
        displayNode = _React__namespace$use56[0],
        setDisplayNode = _React__namespace$use56[1];

    var _React__namespace$use57 = React__namespace.useRef(openProp != null),
        isOpenControlled = _React__namespace$use57.current;

    var _React__namespace$use58 = React__namespace.useState(),
        _React__namespace$use59 = _slicedToArray(_React__namespace$use58, 2),
        menuMinWidthState = _React__namespace$use59[0],
        setMenuMinWidthState = _React__namespace$use59[1];

    var _React__namespace$use60 = React__namespace.useState(false),
        _React__namespace$use61 = _slicedToArray(_React__namespace$use60, 2),
        openState = _React__namespace$use61[0],
        setOpenState = _React__namespace$use61[1];

    var handleRef = useForkRef(ref, inputRefProp);
    var handleDisplayRef = React__namespace.useCallback(function (node) {
      displayRef.current = node;

      if (node) {
        setDisplayNode(node);
      }
    }, []);
    React__namespace.useImperativeHandle(handleRef, function () {
      return {
        focus: function focus() {
          displayRef.current.focus();
        },
        node: inputRef.current,
        value: value
      };
    }, [value]);
    React__namespace.useEffect(function () {
      if (autoFocus) {
        displayRef.current.focus();
      }
    }, [autoFocus]);
    React__namespace.useEffect(function () {
      var label = ownerDocument(displayRef.current).getElementById(labelId);

      if (label) {
        var handler = function handler() {
          if (getSelection().isCollapsed) {
            displayRef.current.focus();
          }
        };

        label.addEventListener('click', handler);
        return function () {
          label.removeEventListener('click', handler);
        };
      }

      return undefined;
    }, [labelId]);

    var update = function update(open, event) {
      if (open) {
        if (onOpen) {
          onOpen(event);
        }
      } else if (onClose) {
        onClose(event);
      }

      if (!isOpenControlled) {
        setMenuMinWidthState(autoWidth ? null : displayNode.clientWidth);
        setOpenState(open);
      }
    };

    var handleMouseDown = function handleMouseDown(event) {
      // Ignore everything but left-click
      if (event.button !== 0) {
        return;
      } // Hijack the default focus behavior.


      event.preventDefault();
      displayRef.current.focus();
      update(true, event);
    };

    var handleClose = function handleClose(event) {
      update(false, event);
    };

    var childrenArray = React__namespace.Children.toArray(children); // Support autofill.

    var handleChange = function handleChange(event) {
      var index = childrenArray.map(function (child) {
        return child.props.value;
      }).indexOf(event.target.value);

      if (index === -1) {
        return;
      }

      var child = childrenArray[index];
      setValueState(child.props.value);

      if (onChange) {
        onChange(event, child);
      }
    };

    var handleItemClick = function handleItemClick(child) {
      return function (event) {
        var newValue; // We use the tabindex attribute to signal the available options.

        if (!event.currentTarget.hasAttribute('tabindex')) {
          return;
        }

        if (multiple) {
          newValue = Array.isArray(value) ? value.slice() : [];
          var itemIndex = value.indexOf(child.props.value);

          if (itemIndex === -1) {
            newValue.push(child.props.value);
          } else {
            newValue.splice(itemIndex, 1);
          }
        } else {
          newValue = child.props.value;
        }

        if (child.props.onClick) {
          child.props.onClick(event);
        }

        if (value !== newValue) {
          setValueState(newValue);

          if (onChange) {
            // Redefine target to allow name and value to be read.
            // This allows seamless integration with the most popular form libraries.
            // https://github.com/mui-org/material-ui/issues/13485#issuecomment-676048492
            // Clone the event to not override `target` of the original event.
            var nativeEvent = event.nativeEvent || event;
            var clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
            Object.defineProperty(clonedEvent, 'target', {
              writable: true,
              value: {
                value: newValue,
                name: name
              }
            });
            onChange(clonedEvent, child);
          }
        }

        if (!multiple) {
          update(false, event);
        }
      };
    };

    var handleKeyDown = function handleKeyDown(event) {
      if (!readOnly) {
        var validKeys = [' ', 'ArrowUp', 'ArrowDown', // The native select doesn't respond to enter on MacOS, but it's recommended by
        // https://www.w3.org/TR/wai-aria-practices/examples/listbox/listbox-collapsible.html
        'Enter'];

        if (validKeys.indexOf(event.key) !== -1) {
          event.preventDefault();
          update(true, event);
        }
      }
    };

    var open = displayNode !== null && (isOpenControlled ? openProp : openState);

    var handleBlur = function handleBlur(event) {
      // if open event.stopImmediatePropagation
      if (!open && onBlur) {
        // Preact support, target is read only property on a native event.
        Object.defineProperty(event, 'target', {
          writable: true,
          value: {
            value: value,
            name: name
          }
        });
        onBlur(event);
      }
    };

    delete other['aria-invalid'];
    var display;
    var displaySingle;
    var displayMultiple = [];
    var computeDisplay = false;
    var foundMatch = false; // No need to display any value if the field is empty.

    if (isFilled({
      value: value
    }) || displayEmpty) {
      if (renderValue) {
        display = renderValue(value);
      } else {
        computeDisplay = true;
      }
    }

    var items = childrenArray.map(function (child) {
      if (! /*#__PURE__*/React__namespace.isValidElement(child)) {
        return null;
      }

      if (process.env.NODE_ENV !== 'production') {
        if (reactIs$2.exports.isFragment(child)) {
          console.error(["MUI: The Select component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
        }
      }

      var selected;

      if (multiple) {
        if (!Array.isArray(value)) {
          throw new Error(process.env.NODE_ENV !== "production" ? "MUI: The `value` prop must be an array when using the `Select` component with `multiple`." : formatMuiErrorMessage(2));
        }

        selected = value.some(function (v) {
          return areEqualValues(v, child.props.value);
        });

        if (selected && computeDisplay) {
          displayMultiple.push(child.props.children);
        }
      } else {
        selected = areEqualValues(value, child.props.value);

        if (selected && computeDisplay) {
          displaySingle = child.props.children;
        }
      }

      if (selected) {
        foundMatch = true;
      }

      return /*#__PURE__*/React__namespace.cloneElement(child, {
        'aria-selected': selected ? 'true' : 'false',
        onClick: handleItemClick(child),
        onKeyUp: function onKeyUp(event) {
          if (event.key === ' ') {
            // otherwise our MenuItems dispatches a click event
            // it's not behavior of the native <option> and causes
            // the select to close immediately since we open on space keydown
            event.preventDefault();
          }

          if (child.props.onKeyUp) {
            child.props.onKeyUp(event);
          }
        },
        role: 'option',
        selected: selected,
        value: undefined,
        // The value is most likely not a valid HTML attribute.
        'data-value': child.props.value // Instead, we provide it as a data attribute.

      });
    });

    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      React__namespace.useEffect(function () {
        if (!foundMatch && !multiple && value !== '') {
          var _values = childrenArray.map(function (child) {
            return child.props.value;
          });

          console.warn(["MUI: You have provided an out-of-range value `".concat(value, "` for the select ").concat(name ? "(name=\"".concat(name, "\") ") : '', "component."), "Consider providing a value that matches one of the available options or ''.", "The available values are ".concat(_values.filter(function (x) {
            return x != null;
          }).map(function (x) {
            return "`".concat(x, "`");
          }).join(', ') || '""', ".")].join('\n'));
        }
      }, [foundMatch, childrenArray, multiple, name, value]);
    }

    if (computeDisplay) {
      if (multiple) {
        if (value.length === 0) {
          display = '';
        } else {
          display = displayMultiple.reduce(function (prev, curr) {
            return [prev, ', ', curr];
          });
        }
      } else {
        display = displaySingle;
      }
    } // Avoid performing a layout computation in the render method.


    var menuMinWidth = menuMinWidthState;

    if (!autoWidth && isOpenControlled && displayNode) {
      menuMinWidth = displayNode.clientWidth;
    }

    var tabIndex;

    if (typeof tabIndexProp !== 'undefined') {
      tabIndex = tabIndexProp;
    } else {
      tabIndex = disabled ? null : 0;
    }

    var buttonId = SelectDisplayProps.id || (name ? "mui-component-select-".concat(name) : undefined);

    var ownerState = _extends$c({}, props, {
      variant: variant,
      value: value,
      open: open
    });

    var classes = useUtilityClasses$r(ownerState);
    return /*#__PURE__*/jsxRuntime$1.jsxs(React__namespace.Fragment, {
      children: [/*#__PURE__*/jsxRuntime$1.jsx(SelectSelect, _extends$c({
        ref: handleDisplayRef,
        tabIndex: tabIndex,
        role: "button",
        "aria-disabled": disabled ? 'true' : undefined,
        "aria-expanded": open ? 'true' : 'false',
        "aria-haspopup": "listbox",
        "aria-label": ariaLabel,
        "aria-labelledby": [labelId, buttonId].filter(Boolean).join(' ') || undefined,
        "aria-describedby": ariaDescribedby,
        onKeyDown: handleKeyDown,
        onMouseDown: disabled || readOnly ? null : handleMouseDown,
        onBlur: handleBlur,
        onFocus: onFocus
      }, SelectDisplayProps, {
        ownerState: ownerState,
        className: clsx(classes.select, className, SelectDisplayProps.className) // The id is required for proper a11y
        ,
        id: buttonId,
        children: isEmpty(display) ?
        /*#__PURE__*/
        // notranslate needed while Google Translate will not fix zero-width space issue
        // eslint-disable-next-line react/no-danger
        jsxRuntime$1.jsx("span", {
          className: "notranslate",
          dangerouslySetInnerHTML: {
            __html: '&#8203;'
          }
        }) : display
      })), /*#__PURE__*/jsxRuntime$1.jsx(SelectNativeInput, _extends$c({
        value: Array.isArray(value) ? value.join(',') : value,
        name: name,
        ref: inputRef,
        "aria-hidden": true,
        onChange: handleChange,
        tabIndex: -1,
        disabled: disabled,
        className: classes.nativeInput,
        autoFocus: autoFocus,
        ownerState: ownerState
      }, other)), /*#__PURE__*/jsxRuntime$1.jsx(SelectIcon, {
        as: IconComponent,
        className: classes.icon,
        ownerState: ownerState
      }), /*#__PURE__*/jsxRuntime$1.jsx(BaseMenu, _extends$c({
        id: "menu-".concat(name || ''),
        anchorEl: displayNode,
        open: open,
        onClose: handleClose,
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'center'
        },
        transformOrigin: {
          vertical: 'top',
          horizontal: 'center'
        }
      }, MenuProps, {
        MenuListProps: _extends$c({
          'aria-labelledby': labelId,
          role: 'listbox',
          disableListWrap: true
        }, MenuProps.MenuListProps),
        PaperProps: _extends$c({}, MenuProps.PaperProps, {
          style: _extends$c({
            minWidth: menuMinWidth
          }, MenuProps.PaperProps != null ? MenuProps.PaperProps.style : null)
        }),
        children: items
      }))]
    });
  });
  process.env.NODE_ENV !== "production" ? SelectInput.propTypes = {
    /**
     * @ignore
     */
    'aria-describedby': PropTypes.string,

    /**
     * @ignore
     */
    'aria-label': PropTypes.string,

    /**
     * @ignore
     */
    autoFocus: PropTypes.bool,

    /**
     * If `true`, the width of the popover will automatically be set according to the items inside the
     * menu, otherwise it will be at least the width of the select input.
     */
    autoWidth: PropTypes.bool,

    /**
     * The option elements to populate the select with.
     * Can be some `<MenuItem>` elements.
     */
    children: PropTypes.node,

    /**
     * Override or extend the styles applied to the component.
     * See [CSS API](#css) below for more details.
     */
    classes: PropTypes.object,

    /**
     * The CSS class name of the select element.
     */
    className: PropTypes.string,

    /**
     * The default value. Use when the component is not controlled.
     */
    defaultValue: PropTypes.any,

    /**
     * If `true`, the select is disabled.
     */
    disabled: PropTypes.bool,

    /**
     * If `true`, the selected item is displayed even if its value is empty.
     */
    displayEmpty: PropTypes.bool,

    /**
     * The icon that displays the arrow.
     */
    IconComponent: PropTypes.elementType.isRequired,

    /**
     * Imperative handle implementing `{ value: T, node: HTMLElement, focus(): void }`
     * Equivalent to `ref`
     */
    inputRef: refType$1,

    /**
     * The ID of an element that acts as an additional label. The Select will
     * be labelled by the additional label and the selected value.
     */
    labelId: PropTypes.string,

    /**
     * Props applied to the [`Menu`](/api/menu/) element.
     */
    MenuProps: PropTypes.object,

    /**
     * If `true`, `value` must be an array and the menu will support multiple selections.
     */
    multiple: PropTypes.bool,

    /**
     * Name attribute of the `select` or hidden `input` element.
     */
    name: PropTypes.string,

    /**
     * @ignore
     */
    onBlur: PropTypes.func,

    /**
     * Callback fired when a menu item is selected.
     *
     * @param {object} event The event source of the callback.
     * You can pull out the new value by accessing `event.target.value` (any).
     * @param {object} [child] The react element that was selected.
     */
    onChange: PropTypes.func,

    /**
     * Callback fired when the component requests to be closed.
     * Use in controlled mode (see open).
     *
     * @param {object} event The event source of the callback.
     */
    onClose: PropTypes.func,

    /**
     * @ignore
     */
    onFocus: PropTypes.func,

    /**
     * Callback fired when the component requests to be opened.
     * Use in controlled mode (see open).
     *
     * @param {object} event The event source of the callback.
     */
    onOpen: PropTypes.func,

    /**
     * If `true`, the component is shown.
     */
    open: PropTypes.bool,

    /**
     * @ignore
     */
    readOnly: PropTypes.bool,

    /**
     * Render the selected value.
     *
     * @param {any} value The `value` provided to the component.
     * @returns {ReactNode}
     */
    renderValue: PropTypes.func,

    /**
     * Props applied to the clickable div element.
     */
    SelectDisplayProps: PropTypes.object,

    /**
     * @ignore
     */
    tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

    /**
     * @ignore
     */
    type: PropTypes.any,

    /**
     * The input value.
     */
    value: PropTypes.any,

    /**
     * The variant to use.
     */
    variant: PropTypes.oneOf(['standard', 'outlined', 'filled'])
  } : void 0;
  var SelectInput$1 = SelectInput;

  var _Input, _FilledInput;

  var _excluded$D = ["autoWidth", "children", "classes", "className", "displayEmpty", "IconComponent", "id", "input", "inputProps", "label", "labelId", "MenuProps", "multiple", "native", "onClose", "onOpen", "open", "renderValue", "SelectDisplayProps", "variant"];

  var useUtilityClasses$q = function useUtilityClasses$q(ownerState) {
    var classes = ownerState.classes;
    return classes;
  };

  var Select$1 = /*#__PURE__*/React__namespace.forwardRef(function Select(inProps, ref) {
    var props = useThemeProps({
      name: 'MuiSelect',
      props: inProps
    });

    var _props$autoWidth = props.autoWidth,
        autoWidth = _props$autoWidth === void 0 ? false : _props$autoWidth,
        children = props.children,
        _props$classes4 = props.classes,
        classesProp = _props$classes4 === void 0 ? {} : _props$classes4,
        className = props.className,
        _props$displayEmpty = props.displayEmpty,
        displayEmpty = _props$displayEmpty === void 0 ? false : _props$displayEmpty,
        _props$IconComponent2 = props.IconComponent,
        IconComponent = _props$IconComponent2 === void 0 ? ArrowDropDownIcon$1 : _props$IconComponent2,
        id = props.id,
        input = props.input,
        inputProps = props.inputProps,
        label = props.label,
        labelId = props.labelId,
        MenuProps = props.MenuProps,
        _props$multiple3 = props.multiple,
        multiple = _props$multiple3 === void 0 ? false : _props$multiple3,
        _props$native = props.native,
        native = _props$native === void 0 ? false : _props$native,
        onClose = props.onClose,
        onOpen = props.onOpen,
        open = props.open,
        renderValue = props.renderValue,
        SelectDisplayProps = props.SelectDisplayProps,
        _props$variant17 = props.variant,
        variantProps = _props$variant17 === void 0 ? 'outlined' : _props$variant17,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$D);

    var inputComponent = native ? NativeSelectInput$1 : SelectInput$1;
    var muiFormControl = useFormControl();
    var fcs = formControlState({
      props: props,
      muiFormControl: muiFormControl,
      states: ['variant']
    });
    var variant = fcs.variant || variantProps;
    var InputComponent = input || {
      standard: _Input || (_Input = /*#__PURE__*/jsxRuntime$1.jsx(Input$1, {})),
      outlined: /*#__PURE__*/jsxRuntime$1.jsx(OutlinedInput$1, {
        label: label
      }),
      filled: _FilledInput || (_FilledInput = /*#__PURE__*/jsxRuntime$1.jsx(FilledInput$1, {}))
    }[variant];

    var ownerState = _extends$c({}, props, {
      classes: classesProp
    });

    var classes = useUtilityClasses$q(ownerState);
    var inputComponentRef = useForkRef(ref, InputComponent.ref);
    return /*#__PURE__*/React__namespace.cloneElement(InputComponent, _extends$c({
      // Most of the logic is implemented in `SelectInput`.
      // The `Select` component is a simple API wrapper to expose something better to play with.
      inputComponent: inputComponent,
      inputProps: _extends$c({
        children: children,
        IconComponent: IconComponent,
        variant: variant,
        type: undefined,
        // We render a select. We can ignore the type provided by the `Input`.
        multiple: multiple
      }, native ? {
        id: id
      } : {
        autoWidth: autoWidth,
        displayEmpty: displayEmpty,
        labelId: labelId,
        MenuProps: MenuProps,
        onClose: onClose,
        onOpen: onOpen,
        open: open,
        renderValue: renderValue,
        SelectDisplayProps: _extends$c({
          id: id
        }, SelectDisplayProps)
      }, inputProps, {
        classes: inputProps ? deepmerge(classes, inputProps.classes) : classes
      }, input ? input.props.inputProps : {})
    }, multiple && native && variant === 'outlined' ? {
      notched: true
    } : {}, {
      ref: inputComponentRef,
      className: clsx(InputComponent.props.className, className)
    }, other));
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  Select$1.muiName = 'Select';
  var D$1 = Select$1;

  function getSnackbarContentUtilityClass(slot) {
    return generateUtilityClass('MuiSnackbarContent', slot);
  }

  generateUtilityClasses('MuiSnackbarContent', ['root', 'message', 'action']);
  var _excluded$C = ["action", "className", "message", "role"];

  var useUtilityClasses$p = function useUtilityClasses$p(ownerState) {
    var classes = ownerState.classes;
    var slots = {
      root: ['root'],
      action: ['action'],
      message: ['message']
    };
    return composeClasses(slots, getSnackbarContentUtilityClass, classes);
  };

  var SnackbarContentRoot = styled$1(BasePaper, {
    name: 'MuiSnackbarContent',
    slot: 'Root',
    overridesResolver: function overridesResolver(props, styles) {
      return styles.root;
    }
  })(function (_ref191) {
    var theme = _ref191.theme;
    var emphasis = theme.palette.mode === 'light' ? 0.8 : 0.98;
    var backgroundColor = emphasize(theme.palette.background.default, emphasis);
    return _extends$c({}, theme.typography.body2, _defineProperty({
      color: theme.palette.getContrastText(backgroundColor),
      backgroundColor: backgroundColor,
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      padding: '6px 16px',
      borderRadius: theme.shape.borderRadius,
      flexGrow: 1
    }, theme.breakpoints.up('sm'), {
      flexGrow: 'initial',
      minWidth: 288
    }));
  });
  var SnackbarContentMessage = styled$1('div', {
    name: 'MuiSnackbarContent',
    slot: 'Message',
    overridesResolver: function overridesResolver(props, styles) {
      return styles.message;
    }
  })({
    padding: '8px 0'
  });
  var SnackbarContentAction = styled$1('div', {
    name: 'MuiSnackbarContent',
    slot: 'Action',
    overridesResolver: function overridesResolver(props, styles) {
      return styles.action;
    }
  })({
    display: 'flex',
    alignItems: 'center',
    marginLeft: 'auto',
    paddingLeft: 16,
    marginRight: -8
  });
  var SnackbarContent = /*#__PURE__*/React__namespace.forwardRef(function SnackbarContent(inProps, ref) {
    var props = useThemeProps({
      props: inProps,
      name: 'MuiSnackbarContent'
    });

    var action = props.action,
        className = props.className,
        message = props.message,
        _props$role3 = props.role,
        role = _props$role3 === void 0 ? 'alert' : _props$role3,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$C);

    var ownerState = props;
    var classes = useUtilityClasses$p(ownerState);
    return /*#__PURE__*/jsxRuntime$1.jsxs(SnackbarContentRoot, _extends$c({
      role: role,
      square: true,
      elevation: 6,
      className: clsx(classes.root, className),
      ownerState: ownerState,
      ref: ref
    }, other, {
      children: [/*#__PURE__*/jsxRuntime$1.jsx(SnackbarContentMessage, {
        className: classes.message,
        ownerState: ownerState,
        children: message
      }), action ? /*#__PURE__*/jsxRuntime$1.jsx(SnackbarContentAction, {
        className: classes.action,
        ownerState: ownerState,
        children: action
      }) : null]
    }));
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var SnackbarContent$1 = SnackbarContent;

  function getSnackbarUtilityClass(slot) {
    return generateUtilityClass('MuiSnackbar', slot);
  }

  generateUtilityClasses('MuiSnackbar', ['root', 'anchorOriginTopCenter', 'anchorOriginBottomCenter', 'anchorOriginTopRight', 'anchorOriginBottomRight', 'anchorOriginTopLeft', 'anchorOriginBottomLeft']);
  var _excluded$B = ["onEnter", "onExited"],
      _excluded2 = ["action", "anchorOrigin", "autoHideDuration", "children", "className", "ClickAwayListenerProps", "ContentProps", "disableWindowBlurListener", "message", "onBlur", "onClose", "onFocus", "onMouseEnter", "onMouseLeave", "open", "resumeHideDuration", "TransitionComponent", "transitionDuration", "TransitionProps"];

  var useUtilityClasses$o = function useUtilityClasses$o(ownerState) {
    var classes = ownerState.classes,
        anchorOrigin = ownerState.anchorOrigin;
    var slots = {
      root: ['root', "anchorOrigin".concat(capitalize$1(anchorOrigin.vertical)).concat(capitalize$1(anchorOrigin.horizontal))]
    };
    return composeClasses(slots, getSnackbarUtilityClass, classes);
  };

  var SnackbarRoot = styled$1('div', {
    name: 'MuiSnackbar',
    slot: 'Root',
    overridesResolver: function overridesResolver(props, styles) {
      var ownerState = props.ownerState;
      return [styles.root, styles["anchorOrigin".concat(capitalize$1(ownerState.anchorOrigin.vertical)).concat(capitalize$1(ownerState.anchorOrigin.horizontal))]];
    }
  })(function (_ref192) {
    var theme = _ref192.theme,
        ownerState = _ref192.ownerState;

    var center = _extends$c({}, !ownerState.isRtl && {
      left: '50%',
      right: 'auto',
      transform: 'translateX(-50%)'
    }, ownerState.isRtl && {
      right: '50%',
      left: 'auto',
      transform: 'translateX(50%)'
    });

    return _extends$c({
      zIndex: theme.zIndex.snackbar,
      position: 'fixed',
      display: 'flex',
      left: 8,
      right: 8,
      justifyContent: 'center',
      alignItems: 'center'
    }, ownerState.anchorOrigin.vertical === 'top' ? {
      top: 8
    } : {
      bottom: 8
    }, ownerState.anchorOrigin.horizontal === 'left' && {
      justifyContent: 'flex-start'
    }, ownerState.anchorOrigin.horizontal === 'right' && {
      justifyContent: 'flex-end'
    }, _defineProperty({}, theme.breakpoints.up('sm'), _extends$c({}, ownerState.anchorOrigin.vertical === 'top' ? {
      top: 24
    } : {
      bottom: 24
    }, ownerState.anchorOrigin.horizontal === 'center' && center, ownerState.anchorOrigin.horizontal === 'left' && _extends$c({}, !ownerState.isRtl && {
      left: 24,
      right: 'auto'
    }, ownerState.isRtl && {
      right: 24,
      left: 'auto'
    }), ownerState.anchorOrigin.horizontal === 'right' && _extends$c({}, !ownerState.isRtl && {
      right: 24,
      left: 'auto'
    }, ownerState.isRtl && {
      left: 24,
      right: 'auto'
    }))));
  });
  var Snackbar = /*#__PURE__*/React__namespace.forwardRef(function Snackbar(inProps, ref) {
    var props = useThemeProps({
      props: inProps,
      name: 'MuiSnackbar'
    });
    var action = props.action,
        _props$anchorOrigin3 = props.anchorOrigin;
    _props$anchorOrigin3 = _props$anchorOrigin3 === void 0 ? {
      vertical: 'bottom',
      horizontal: 'left'
    } : _props$anchorOrigin3;
    var vertical = _props$anchorOrigin3.vertical,
        horizontal = _props$anchorOrigin3.horizontal,
        _props$autoHideDurati = props.autoHideDuration,
        autoHideDuration = _props$autoHideDurati === void 0 ? null : _props$autoHideDurati,
        children = props.children,
        className = props.className,
        ClickAwayListenerProps = props.ClickAwayListenerProps,
        ContentProps = props.ContentProps,
        _props$disableWindowB = props.disableWindowBlurListener,
        disableWindowBlurListener = _props$disableWindowB === void 0 ? false : _props$disableWindowB,
        message = props.message,
        onBlur = props.onBlur,
        onClose = props.onClose,
        onFocus = props.onFocus,
        onMouseEnter = props.onMouseEnter,
        onMouseLeave = props.onMouseLeave,
        open = props.open,
        resumeHideDuration = props.resumeHideDuration,
        _props$TransitionComp10 = props.TransitionComponent,
        TransitionComponent = _props$TransitionComp10 === void 0 ? Grow$1 : _props$TransitionComp10,
        _props$transitionDura5 = props.transitionDuration,
        transitionDuration = _props$transitionDura5 === void 0 ? {
      enter: duration.enteringScreen,
      exit: duration.leavingScreen
    } : _props$transitionDura5,
        _props$TransitionProp3 = props.TransitionProps;
    _props$TransitionProp3 = _props$TransitionProp3 === void 0 ? {} : _props$TransitionProp3;

    var onEnter = _props$TransitionProp3.onEnter,
        onExited = _props$TransitionProp3.onExited,
        TransitionProps = _objectWithoutPropertiesLoose$6(props.TransitionProps, _excluded$B),
        other = _objectWithoutPropertiesLoose$6(props, _excluded2);

    var theme = useTheme();
    var isRtl = theme.direction === 'rtl';

    var ownerState = _extends$c({}, props, {
      anchorOrigin: {
        vertical: vertical,
        horizontal: horizontal
      },
      isRtl: isRtl
    });

    var classes = useUtilityClasses$o(ownerState);
    var timerAutoHide = React__namespace.useRef();

    var _React__namespace$use62 = React__namespace.useState(true),
        _React__namespace$use63 = _slicedToArray(_React__namespace$use62, 2),
        exited = _React__namespace$use63[0],
        setExited = _React__namespace$use63[1];

    var handleClose = useEventCallback(function () {
      if (onClose) {
        onClose.apply(void 0, arguments);
      }
    });
    var setAutoHideTimer = useEventCallback(function (autoHideDurationParam) {
      if (!onClose || autoHideDurationParam == null) {
        return;
      }

      clearTimeout(timerAutoHide.current);
      timerAutoHide.current = setTimeout(function () {
        handleClose(null, 'timeout');
      }, autoHideDurationParam);
    });
    React__namespace.useEffect(function () {
      if (open) {
        setAutoHideTimer(autoHideDuration);
      }

      return function () {
        clearTimeout(timerAutoHide.current);
      };
    }, [open, autoHideDuration, setAutoHideTimer]); // Pause the timer when the user is interacting with the Snackbar
    // or when the user hide the window.

    var handlePause = function handlePause() {
      clearTimeout(timerAutoHide.current);
    }; // Restart the timer when the user is no longer interacting with the Snackbar
    // or when the window is shown back.


    var handleResume = React__namespace.useCallback(function () {
      if (autoHideDuration != null) {
        setAutoHideTimer(resumeHideDuration != null ? resumeHideDuration : autoHideDuration * 0.5);
      }
    }, [autoHideDuration, resumeHideDuration, setAutoHideTimer]);

    var handleFocus = function handleFocus(event) {
      if (onFocus) {
        onFocus(event);
      }

      handlePause();
    };

    var handleMouseEnter = function handleMouseEnter(event) {
      if (onMouseEnter) {
        onMouseEnter(event);
      }

      handlePause();
    };

    var handleBlur = function handleBlur(event) {
      if (onBlur) {
        onBlur(event);
      }

      handleResume();
    };

    var handleMouseLeave = function handleMouseLeave(event) {
      if (onMouseLeave) {
        onMouseLeave(event);
      }

      handleResume();
    };

    var handleClickAway = function handleClickAway(event) {
      if (onClose) {
        onClose(event, 'clickaway');
      }
    };

    var handleExited = function handleExited(node) {
      setExited(true);

      if (onExited) {
        onExited(node);
      }
    };

    var handleEnter = function handleEnter(node, isAppearing) {
      setExited(false);

      if (onEnter) {
        onEnter(node, isAppearing);
      }
    };

    React__namespace.useEffect(function () {
      // TODO: window global should be refactored here
      if (!disableWindowBlurListener && open) {
        window.addEventListener('focus', handleResume);
        window.addEventListener('blur', handlePause);
        return function () {
          window.removeEventListener('focus', handleResume);
          window.removeEventListener('blur', handlePause);
        };
      }

      return undefined;
    }, [disableWindowBlurListener, handleResume, open]);
    React__namespace.useEffect(function () {
      if (!open) {
        return undefined;
      }
      /**
       * @param {KeyboardEvent} nativeEvent
       */


      function handleKeyDown(nativeEvent) {
        if (!nativeEvent.defaultPrevented) {
          // IE11, Edge (prior to using Bink?) use 'Esc'
          if (nativeEvent.key === 'Escape' || nativeEvent.key === 'Esc') {
            // not calling `preventDefault` since we don't know if people may ignore this event e.g. a permanently open snackbar
            if (onClose) {
              onClose(nativeEvent, 'escapeKeyDown');
            }
          }
        }
      }

      document.addEventListener('keydown', handleKeyDown);
      return function () {
        document.removeEventListener('keydown', handleKeyDown);
      };
    }, [exited, open, onClose]); // So we only render active snackbars.

    if (!open && exited) {
      return null;
    }

    return /*#__PURE__*/jsxRuntime$1.jsx(ClickAwayListener, _extends$c({
      onClickAway: handleClickAway
    }, ClickAwayListenerProps, {
      children: /*#__PURE__*/jsxRuntime$1.jsx(SnackbarRoot, _extends$c({
        className: clsx(classes.root, className),
        onBlur: handleBlur,
        onFocus: handleFocus,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        ownerState: ownerState,
        ref: ref
      }, other, {
        children: /*#__PURE__*/jsxRuntime$1.jsx(TransitionComponent, _extends$c({
          appear: true,
          in: open,
          timeout: transitionDuration,
          direction: vertical === 'top' ? 'down' : 'up',
          onEnter: handleEnter,
          onExited: handleExited
        }, TransitionProps, {
          children: children || /*#__PURE__*/jsxRuntime$1.jsx(SnackbarContent$1, _extends$c({
            message: message,
            action: action
          }, ContentProps))
        }))
      }))
    }));
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var BaseRadioGroup = Snackbar;

  function getTooltipUtilityClass(slot) {
    return generateUtilityClass('MuiTooltip', slot);
  }

  var tooltipClasses = generateUtilityClasses('MuiTooltip', ['popper', 'popperInteractive', 'popperArrow', 'popperClose', 'tooltip', 'tooltipArrow', 'touch', 'tooltipPlacementLeft', 'tooltipPlacementRight', 'tooltipPlacementTop', 'tooltipPlacementBottom', 'arrow']);
  var tooltipClasses$1 = tooltipClasses;
  var _excluded$A = ["arrow", "children", "classes", "components", "componentsProps", "describeChild", "disableFocusListener", "disableHoverListener", "disableInteractive", "disableTouchListener", "enterDelay", "enterNextDelay", "enterTouchDelay", "followCursor", "id", "leaveDelay", "leaveTouchDelay", "onClose", "onOpen", "open", "placement", "PopperComponent", "PopperProps", "title", "TransitionComponent", "TransitionProps"];

  function round(value) {
    return Math.round(value * 1e5) / 1e5;
  }

  var useUtilityClasses$n = function useUtilityClasses$n(ownerState) {
    var classes = ownerState.classes,
        disableInteractive = ownerState.disableInteractive,
        arrow = ownerState.arrow,
        touch = ownerState.touch,
        placement = ownerState.placement;
    var slots = {
      popper: ['popper', !disableInteractive && 'popperInteractive', arrow && 'popperArrow'],
      tooltip: ['tooltip', arrow && 'tooltipArrow', touch && 'touch', "tooltipPlacement".concat(capitalize$1(placement.split('-')[0]))],
      arrow: ['arrow']
    };
    return composeClasses(slots, getTooltipUtilityClass, classes);
  };

  var TooltipPopper = styled$1(BasePopper, {
    name: 'MuiTooltip',
    slot: 'Popper',
    overridesResolver: function overridesResolver(props, styles) {
      var ownerState = props.ownerState;
      return [styles.popper, !ownerState.disableInteractive && styles.popperInteractive, ownerState.arrow && styles.popperArrow, !ownerState.open && styles.popperClose];
    }
  })(function (_ref193) {
    var _ref194;

    var theme = _ref193.theme,
        ownerState = _ref193.ownerState,
        open = _ref193.open;
    return _extends$c({
      zIndex: theme.zIndex.tooltip,
      pointerEvents: 'none'
    }, !ownerState.disableInteractive && {
      pointerEvents: 'auto'
    }, !open && {
      pointerEvents: 'none'
    }, ownerState.arrow && (_ref194 = {}, _defineProperty(_ref194, "&[data-popper-placement*=\"bottom\"] .".concat(tooltipClasses$1.arrow), {
      top: 0,
      marginTop: '-0.71em',
      '&::before': {
        transformOrigin: '0 100%'
      }
    }), _defineProperty(_ref194, "&[data-popper-placement*=\"top\"] .".concat(tooltipClasses$1.arrow), {
      bottom: 0,
      marginBottom: '-0.71em',
      '&::before': {
        transformOrigin: '100% 0'
      }
    }), _defineProperty(_ref194, "&[data-popper-placement*=\"right\"] .".concat(tooltipClasses$1.arrow), _extends$c({}, !ownerState.isRtl ? {
      left: 0,
      marginLeft: '-0.71em'
    } : {
      right: 0,
      marginRight: '-0.71em'
    }, {
      height: '1em',
      width: '0.71em',
      '&::before': {
        transformOrigin: '100% 100%'
      }
    })), _defineProperty(_ref194, "&[data-popper-placement*=\"left\"] .".concat(tooltipClasses$1.arrow), _extends$c({}, !ownerState.isRtl ? {
      right: 0,
      marginRight: '-0.71em'
    } : {
      left: 0,
      marginLeft: '-0.71em'
    }, {
      height: '1em',
      width: '0.71em',
      '&::before': {
        transformOrigin: '0 0'
      }
    })), _ref194));
  });
  var TooltipTooltip = styled$1('div', {
    name: 'MuiTooltip',
    slot: 'Tooltip',
    overridesResolver: function overridesResolver(props, styles) {
      var ownerState = props.ownerState;
      return [styles.tooltip, ownerState.touch && styles.touch, ownerState.arrow && styles.tooltipArrow, styles["tooltipPlacement".concat(capitalize$1(ownerState.placement.split('-')[0]))]];
    }
  })(function (_ref195) {
    var _extends$c26;

    var theme = _ref195.theme,
        ownerState = _ref195.ownerState;
    return _extends$c({
      backgroundColor: alpha(theme.palette.grey[700], 0.92),
      borderRadius: theme.shape.borderRadius,
      color: theme.palette.common.white,
      fontFamily: theme.typography.fontFamily,
      padding: '4px 8px',
      fontSize: theme.typography.pxToRem(11),
      maxWidth: 300,
      margin: 2,
      wordWrap: 'break-word',
      fontWeight: theme.typography.fontWeightMedium
    }, ownerState.arrow && {
      position: 'relative',
      margin: 0
    }, ownerState.touch && {
      padding: '8px 16px',
      fontSize: theme.typography.pxToRem(14),
      lineHeight: "".concat(round(16 / 14), "em"),
      fontWeight: theme.typography.fontWeightRegular
    }, (_extends$c26 = {}, _defineProperty(_extends$c26, ".".concat(tooltipClasses$1.popper, "[data-popper-placement*=\"left\"] &"), _extends$c({
      transformOrigin: 'right center'
    }, !ownerState.isRtl ? _extends$c({
      marginRight: '14px'
    }, ownerState.touch && {
      marginRight: '24px'
    }) : _extends$c({
      marginLeft: '14px'
    }, ownerState.touch && {
      marginLeft: '24px'
    }))), _defineProperty(_extends$c26, ".".concat(tooltipClasses$1.popper, "[data-popper-placement*=\"right\"] &"), _extends$c({
      transformOrigin: 'left center'
    }, !ownerState.isRtl ? _extends$c({
      marginLeft: '14px'
    }, ownerState.touch && {
      marginLeft: '24px'
    }) : _extends$c({
      marginRight: '14px'
    }, ownerState.touch && {
      marginRight: '24px'
    }))), _defineProperty(_extends$c26, ".".concat(tooltipClasses$1.popper, "[data-popper-placement*=\"top\"] &"), _extends$c({
      transformOrigin: 'center bottom',
      marginBottom: '14px'
    }, ownerState.touch && {
      marginBottom: '24px'
    })), _defineProperty(_extends$c26, ".".concat(tooltipClasses$1.popper, "[data-popper-placement*=\"bottom\"] &"), _extends$c({
      transformOrigin: 'center top',
      marginTop: '14px'
    }, ownerState.touch && {
      marginTop: '24px'
    })), _extends$c26));
  });
  var TooltipArrow = styled$1('span', {
    name: 'MuiTooltip',
    slot: 'Arrow',
    overridesResolver: function overridesResolver(props, styles) {
      return styles.arrow;
    }
  })(function (_ref196) {
    var theme = _ref196.theme;
    return {
      overflow: 'hidden',
      position: 'absolute',
      width: '1em',
      height: '0.71em'
      /* = width / sqrt(2) = (length of the hypotenuse) */
      ,
      boxSizing: 'border-box',
      color: alpha(theme.palette.grey[700], 0.9),
      '&::before': {
        content: '""',
        margin: 'auto',
        display: 'block',
        width: '100%',
        height: '100%',
        backgroundColor: 'currentColor',
        transform: 'rotate(45deg)'
      }
    };
  });
  var hystersisOpen = false;
  var hystersisTimer = null;

  function composeEventHandler(handler, eventHandler) {
    return function (event) {
      if (eventHandler) {
        eventHandler(event);
      }

      handler(event);
    };
  } // TODO v6: Remove PopperComponent, PopperProps, TransitionComponent and TransitionProps.


  var Tooltip = /*#__PURE__*/React__namespace.forwardRef(function Tooltip(inProps, ref) {
    var _components$Popper, _ref, _components$Transitio, _components$Tooltip, _components$Arrow, _componentsProps$popp;

    var props = useThemeProps({
      props: inProps,
      name: 'MuiTooltip'
    });

    var _props$arrow = props.arrow,
        arrow = _props$arrow === void 0 ? false : _props$arrow,
        children = props.children,
        _props$components11 = props.components,
        components = _props$components11 === void 0 ? {} : _props$components11,
        _props$componentsProp10 = props.componentsProps,
        componentsProps = _props$componentsProp10 === void 0 ? {} : _props$componentsProp10,
        _props$describeChild = props.describeChild,
        describeChild = _props$describeChild === void 0 ? false : _props$describeChild,
        _props$disableFocusLi = props.disableFocusListener,
        disableFocusListener = _props$disableFocusLi === void 0 ? false : _props$disableFocusLi,
        _props$disableHoverLi = props.disableHoverListener,
        disableHoverListener = _props$disableHoverLi === void 0 ? false : _props$disableHoverLi,
        _props$disableInterac = props.disableInteractive,
        disableInteractiveProp = _props$disableInterac === void 0 ? false : _props$disableInterac,
        _props$disableTouchLi = props.disableTouchListener,
        disableTouchListener = _props$disableTouchLi === void 0 ? false : _props$disableTouchLi,
        _props$enterDelay = props.enterDelay,
        enterDelay = _props$enterDelay === void 0 ? 100 : _props$enterDelay,
        _props$enterNextDelay = props.enterNextDelay,
        enterNextDelay = _props$enterNextDelay === void 0 ? 0 : _props$enterNextDelay,
        _props$enterTouchDela = props.enterTouchDelay,
        enterTouchDelay = _props$enterTouchDela === void 0 ? 700 : _props$enterTouchDela,
        _props$followCursor = props.followCursor,
        followCursor = _props$followCursor === void 0 ? false : _props$followCursor,
        idProp = props.id,
        _props$leaveDelay = props.leaveDelay,
        leaveDelay = _props$leaveDelay === void 0 ? 0 : _props$leaveDelay,
        _props$leaveTouchDela = props.leaveTouchDelay,
        leaveTouchDelay = _props$leaveTouchDela === void 0 ? 1500 : _props$leaveTouchDela,
        onClose = props.onClose,
        onOpen = props.onOpen,
        openProp = props.open,
        _props$placement2 = props.placement,
        placement = _props$placement2 === void 0 ? 'bottom' : _props$placement2,
        PopperComponentProp = props.PopperComponent,
        _props$PopperProps = props.PopperProps,
        PopperProps = _props$PopperProps === void 0 ? {} : _props$PopperProps,
        title = props.title,
        _props$TransitionComp11 = props.TransitionComponent,
        TransitionComponentProp = _props$TransitionComp11 === void 0 ? Grow$1 : _props$TransitionComp11,
        TransitionProps = props.TransitionProps,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$A);

    var theme = useTheme();
    var isRtl = theme.direction === 'rtl';

    var _React__namespace$use64 = React__namespace.useState(),
        _React__namespace$use65 = _slicedToArray(_React__namespace$use64, 2),
        childNode = _React__namespace$use65[0],
        setChildNode = _React__namespace$use65[1];

    var _React__namespace$use66 = React__namespace.useState(null),
        _React__namespace$use67 = _slicedToArray(_React__namespace$use66, 2),
        arrowRef = _React__namespace$use67[0],
        setArrowRef = _React__namespace$use67[1];

    var ignoreNonTouchEvents = React__namespace.useRef(false);
    var disableInteractive = disableInteractiveProp || followCursor;
    var closeTimer = React__namespace.useRef();
    var enterTimer = React__namespace.useRef();
    var leaveTimer = React__namespace.useRef();
    var touchTimer = React__namespace.useRef();

    var _useControlled15 = useControlled({
      controlled: openProp,
      default: false,
      name: 'Tooltip',
      state: 'open'
    }),
        _useControlled16 = _slicedToArray(_useControlled15, 2),
        openState = _useControlled16[0],
        setOpenState = _useControlled16[1];

    var open = openState;

    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      var _React__namespace$use68 = React__namespace.useRef(openProp !== undefined),
          isControlled = _React__namespace$use68.current; // eslint-disable-next-line react-hooks/rules-of-hooks


      React__namespace.useEffect(function () {
        if (childNode && childNode.disabled && !isControlled && title !== '' && childNode.tagName.toLowerCase() === 'button') {
          console.error(['MUI: You are providing a disabled `button` child to the Tooltip component.', 'A disabled element does not fire events.', "Tooltip needs to listen to the child element's events to display the title.", '', 'Add a simple wrapper element, such as a `span`.'].join('\n'));
        }
      }, [title, childNode, isControlled]);
    }

    var id = useId(idProp);
    var prevUserSelect = React__namespace.useRef();
    var stopTouchInteraction = React__namespace.useCallback(function () {
      if (prevUserSelect.current !== undefined) {
        document.body.style.WebkitUserSelect = prevUserSelect.current;
        prevUserSelect.current = undefined;
      }

      clearTimeout(touchTimer.current);
    }, []);
    React__namespace.useEffect(function () {
      return function () {
        clearTimeout(closeTimer.current);
        clearTimeout(enterTimer.current);
        clearTimeout(leaveTimer.current);
        stopTouchInteraction();
      };
    }, [stopTouchInteraction]);

    var handleOpen = function handleOpen(event) {
      clearTimeout(hystersisTimer);
      hystersisOpen = true; // The mouseover event will trigger for every nested element in the tooltip.
      // We can skip rerendering when the tooltip is already open.
      // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.

      setOpenState(true);

      if (onOpen && !open) {
        onOpen(event);
      }
    };

    var handleClose = useEventCallback(
    /**
     * @param {React.SyntheticEvent | Event} event
     */
    function (event) {
      clearTimeout(hystersisTimer);
      hystersisTimer = setTimeout(function () {
        hystersisOpen = false;
      }, 800 + leaveDelay);
      setOpenState(false);

      if (onClose && open) {
        onClose(event);
      }

      clearTimeout(closeTimer.current);
      closeTimer.current = setTimeout(function () {
        ignoreNonTouchEvents.current = false;
      }, theme.transitions.duration.shortest);
    });

    var handleEnter = function handleEnter(event) {
      if (ignoreNonTouchEvents.current && event.type !== 'touchstart') {
        return;
      } // Remove the title ahead of time.
      // We don't want to wait for the next render commit.
      // We would risk displaying two tooltips at the same time (native + this one).


      if (childNode) {
        childNode.removeAttribute('title');
      }

      clearTimeout(enterTimer.current);
      clearTimeout(leaveTimer.current);

      if (enterDelay || hystersisOpen && enterNextDelay) {
        enterTimer.current = setTimeout(function () {
          handleOpen(event);
        }, hystersisOpen ? enterNextDelay : enterDelay);
      } else {
        handleOpen(event);
      }
    };

    var handleLeave = function handleLeave(event) {
      clearTimeout(enterTimer.current);
      clearTimeout(leaveTimer.current);
      leaveTimer.current = setTimeout(function () {
        handleClose(event);
      }, leaveDelay);
    };

    var _useIsFocusVisible3 = useIsFocusVisible(),
        isFocusVisibleRef = _useIsFocusVisible3.isFocusVisibleRef,
        handleBlurVisible = _useIsFocusVisible3.onBlur,
        handleFocusVisible = _useIsFocusVisible3.onFocus,
        focusVisibleRef = _useIsFocusVisible3.ref; // We don't necessarily care about the focusVisible state (which is safe to access via ref anyway).
    // We just need to re-render the Tooltip if the focus-visible state changes.


    var _React__namespace$use69 = React__namespace.useState(false),
        _React__namespace$use70 = _slicedToArray(_React__namespace$use69, 2),
        setChildIsFocusVisible = _React__namespace$use70[1];

    var handleBlur = function handleBlur(event) {
      handleBlurVisible(event);

      if (isFocusVisibleRef.current === false) {
        setChildIsFocusVisible(false);
        handleLeave(event);
      }
    };

    var handleFocus = function handleFocus(event) {
      // Workaround for https://github.com/facebook/react/issues/7769
      // The autoFocus of React might trigger the event before the componentDidMount.
      // We need to account for this eventuality.
      if (!childNode) {
        setChildNode(event.currentTarget);
      }

      handleFocusVisible(event);

      if (isFocusVisibleRef.current === true) {
        setChildIsFocusVisible(true);
        handleEnter(event);
      }
    };

    var detectTouchStart = function detectTouchStart(event) {
      ignoreNonTouchEvents.current = true;
      var childrenProps = children.props;

      if (childrenProps.onTouchStart) {
        childrenProps.onTouchStart(event);
      }
    };

    var handleMouseOver = handleEnter;
    var handleMouseLeave = handleLeave;

    var handleTouchStart = function handleTouchStart(event) {
      detectTouchStart(event);
      clearTimeout(leaveTimer.current);
      clearTimeout(closeTimer.current);
      stopTouchInteraction();
      prevUserSelect.current = document.body.style.WebkitUserSelect; // Prevent iOS text selection on long-tap.

      document.body.style.WebkitUserSelect = 'none';
      touchTimer.current = setTimeout(function () {
        document.body.style.WebkitUserSelect = prevUserSelect.current;
        handleEnter(event);
      }, enterTouchDelay);
    };

    var handleTouchEnd = function handleTouchEnd(event) {
      if (children.props.onTouchEnd) {
        children.props.onTouchEnd(event);
      }

      stopTouchInteraction();
      clearTimeout(leaveTimer.current);
      leaveTimer.current = setTimeout(function () {
        handleClose(event);
      }, leaveTouchDelay);
    };

    React__namespace.useEffect(function () {
      if (!open) {
        return undefined;
      }
      /**
       * @param {KeyboardEvent} nativeEvent
       */


      function handleKeyDown(nativeEvent) {
        // IE11, Edge (prior to using Bink?) use 'Esc'
        if (nativeEvent.key === 'Escape' || nativeEvent.key === 'Esc') {
          handleClose(nativeEvent);
        }
      }

      document.addEventListener('keydown', handleKeyDown);
      return function () {
        document.removeEventListener('keydown', handleKeyDown);
      };
    }, [handleClose, open]);
    var handleUseRef = useForkRef(setChildNode, ref);
    var handleFocusRef = useForkRef(focusVisibleRef, handleUseRef);
    var handleRef = useForkRef(children.ref, handleFocusRef); // There is no point in displaying an empty tooltip.

    if (title === '') {
      open = false;
    }

    var positionRef = React__namespace.useRef({
      x: 0,
      y: 0
    });
    var popperRef = React__namespace.useRef();

    var handleMouseMove = function handleMouseMove(event) {
      var childrenProps = children.props;

      if (childrenProps.onMouseMove) {
        childrenProps.onMouseMove(event);
      }

      positionRef.current = {
        x: event.clientX,
        y: event.clientY
      };

      if (popperRef.current) {
        popperRef.current.update();
      }
    };

    var nameOrDescProps = {};
    var titleIsString = typeof title === 'string';

    if (describeChild) {
      nameOrDescProps.title = !open && titleIsString && !disableHoverListener ? title : null;
      nameOrDescProps['aria-describedby'] = open ? id : null;
    } else {
      nameOrDescProps['aria-label'] = titleIsString ? title : null;
      nameOrDescProps['aria-labelledby'] = open && !titleIsString ? id : null;
    }

    var childrenProps = _extends$c({}, nameOrDescProps, other, children.props, {
      className: clsx(other.className, children.props.className),
      onTouchStart: detectTouchStart,
      ref: handleRef
    }, followCursor ? {
      onMouseMove: handleMouseMove
    } : {});

    if (process.env.NODE_ENV !== 'production') {
      childrenProps['data-mui-internal-clone-element'] = true; // eslint-disable-next-line react-hooks/rules-of-hooks

      React__namespace.useEffect(function () {
        if (childNode && !childNode.getAttribute('data-mui-internal-clone-element')) {
          console.error(['MUI: The `children` component of the Tooltip is not forwarding its props correctly.', 'Please make sure that props are spread on the same element that the ref is applied to.'].join('\n'));
        }
      }, [childNode]);
    }

    var interactiveWrapperListeners = {};

    if (!disableTouchListener) {
      childrenProps.onTouchStart = handleTouchStart;
      childrenProps.onTouchEnd = handleTouchEnd;
    }

    if (!disableHoverListener) {
      childrenProps.onMouseOver = composeEventHandler(handleMouseOver, childrenProps.onMouseOver);
      childrenProps.onMouseLeave = composeEventHandler(handleMouseLeave, childrenProps.onMouseLeave);

      if (!disableInteractive) {
        interactiveWrapperListeners.onMouseOver = handleMouseOver;
        interactiveWrapperListeners.onMouseLeave = handleMouseLeave;
      }
    }

    if (!disableFocusListener) {
      childrenProps.onFocus = composeEventHandler(handleFocus, childrenProps.onFocus);
      childrenProps.onBlur = composeEventHandler(handleBlur, childrenProps.onBlur);

      if (!disableInteractive) {
        interactiveWrapperListeners.onFocus = handleFocus;
        interactiveWrapperListeners.onBlur = handleBlur;
      }
    }

    if (process.env.NODE_ENV !== 'production') {
      if (children.props.title) {
        console.error(['MUI: You have provided a `title` prop to the child of <Tooltip />.', "Remove this title prop `".concat(children.props.title, "` or the Tooltip component.")].join('\n'));
      }
    }

    var popperOptions = React__namespace.useMemo(function () {
      var _PopperProps$popperOp;

      var tooltipModifiers = [{
        name: 'arrow',
        enabled: Boolean(arrowRef),
        options: {
          element: arrowRef,
          padding: 4
        }
      }];

      if ((_PopperProps$popperOp = PopperProps.popperOptions) != null && _PopperProps$popperOp.modifiers) {
        tooltipModifiers = tooltipModifiers.concat(PopperProps.popperOptions.modifiers);
      }

      return _extends$c({}, PopperProps.popperOptions, {
        modifiers: tooltipModifiers
      });
    }, [arrowRef, PopperProps]);

    var ownerState = _extends$c({}, props, {
      isRtl: isRtl,
      arrow: arrow,
      disableInteractive: disableInteractive,
      placement: placement,
      PopperComponentProp: PopperComponentProp,
      touch: ignoreNonTouchEvents.current
    });

    var classes = useUtilityClasses$n(ownerState);
    var PopperComponent = (_components$Popper = components.Popper) != null ? _components$Popper : TooltipPopper;
    var TransitionComponent = (_ref = (_components$Transitio = components.Transition) != null ? _components$Transitio : TransitionComponentProp) != null ? _ref : Grow$1;
    var TooltipComponent = (_components$Tooltip = components.Tooltip) != null ? _components$Tooltip : TooltipTooltip;
    var ArrowComponent = (_components$Arrow = components.Arrow) != null ? _components$Arrow : TooltipArrow;
    var popperProps = appendOwnerState(PopperComponent, _extends$c({}, PopperProps, componentsProps.popper), ownerState);
    var transitionProps = appendOwnerState(TransitionComponent, _extends$c({}, TransitionProps, componentsProps.transition), ownerState);
    var tooltipProps = appendOwnerState(TooltipComponent, _extends$c({}, componentsProps.tooltip), ownerState);
    var tooltipArrowProps = appendOwnerState(ArrowComponent, _extends$c({}, componentsProps.arrow), ownerState);
    return /*#__PURE__*/jsxRuntime$1.jsxs(React__namespace.Fragment, {
      children: [/*#__PURE__*/React__namespace.cloneElement(children, childrenProps), /*#__PURE__*/jsxRuntime$1.jsx(PopperComponent, _extends$c({
        as: PopperComponentProp != null ? PopperComponentProp : BasePopper,
        placement: placement,
        anchorEl: followCursor ? {
          getBoundingClientRect: function getBoundingClientRect() {
            return {
              top: positionRef.current.y,
              left: positionRef.current.x,
              right: positionRef.current.x,
              bottom: positionRef.current.y,
              width: 0,
              height: 0
            };
          }
        } : childNode,
        popperRef: popperRef,
        open: childNode ? open : false,
        id: id,
        transition: true
      }, interactiveWrapperListeners, popperProps, {
        className: clsx(classes.popper, PopperProps == null ? void 0 : PopperProps.className, (_componentsProps$popp = componentsProps.popper) == null ? void 0 : _componentsProps$popp.className),
        popperOptions: popperOptions,
        children: function children(_ref197) {
          var TransitionPropsInner = _ref197.TransitionProps;

          var _componentsProps$tool, _componentsProps$arro;

          return /*#__PURE__*/jsxRuntime$1.jsx(TransitionComponent, _extends$c({
            timeout: theme.transitions.duration.shorter
          }, TransitionPropsInner, transitionProps, {
            children: /*#__PURE__*/jsxRuntime$1.jsxs(TooltipComponent, _extends$c({}, tooltipProps, {
              className: clsx(classes.tooltip, (_componentsProps$tool = componentsProps.tooltip) == null ? void 0 : _componentsProps$tool.className),
              children: [title, arrow ? /*#__PURE__*/jsxRuntime$1.jsx(ArrowComponent, _extends$c({}, tooltipArrowProps, {
                className: clsx(classes.arrow, (_componentsProps$arro = componentsProps.arrow) == null ? void 0 : _componentsProps$arro.className),
                ref: setArrowRef
              })) : null]
            }))
          }));
        }
      }))]
    });
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var $$1 = Tooltip;
  var _excluded$z = ["component", "direction", "spacing", "divider", "children"];

  function joinChildren(children, separator) {
    var childrenArray = React__namespace.Children.toArray(children).filter(Boolean);
    return childrenArray.reduce(function (output, child, index) {
      output.push(child);

      if (index < childrenArray.length - 1) {
        output.push( /*#__PURE__*/React__namespace.cloneElement(separator, {
          key: "separator-".concat(index)
        }));
      }

      return output;
    }, []);
  }

  var getSideFromDirection = function getSideFromDirection(direction) {
    return {
      row: 'Left',
      'row-reverse': 'Right',
      column: 'Top',
      'column-reverse': 'Bottom'
    }[direction];
  };

  var style = function style(_ref198) {
    var ownerState = _ref198.ownerState,
        theme = _ref198.theme;

    var styles = _extends$c({
      display: 'flex'
    }, handleBreakpoints({
      theme: theme
    }, resolveBreakpointValues({
      values: ownerState.direction,
      breakpoints: theme.breakpoints.values
    }), function (propValue) {
      return {
        flexDirection: propValue
      };
    }));

    if (ownerState.spacing) {
      var transformer = createUnarySpacing(theme);
      var base = Object.keys(theme.breakpoints.values).reduce(function (acc, breakpoint) {
        if (ownerState.spacing[breakpoint] != null || ownerState.direction[breakpoint] != null) {
          acc[breakpoint] = true;
        }

        return acc;
      }, {});
      var directionValues = resolveBreakpointValues({
        values: ownerState.direction,
        base: base
      });
      var spacingValues = resolveBreakpointValues({
        values: ownerState.spacing,
        base: base
      });

      var styleFromPropValue = function styleFromPropValue(propValue, breakpoint) {
        return {
          '& > :not(style) + :not(style)': _defineProperty({
            margin: 0
          }, "margin".concat(getSideFromDirection(breakpoint ? directionValues[breakpoint] : ownerState.direction)), getValue$1(transformer, propValue))
        };
      };

      styles = deepmerge(styles, handleBreakpoints({
        theme: theme
      }, spacingValues, styleFromPropValue));
    }

    return styles;
  };

  var StackRoot = styled$1('div', {
    name: 'MuiStack',
    slot: 'Root',
    overridesResolver: function overridesResolver(props, styles) {
      return [styles.root];
    }
  })(style);
  var Stack$2 = /*#__PURE__*/React__namespace.forwardRef(function Stack(inProps, ref) {
    var themeProps = useThemeProps({
      props: inProps,
      name: 'MuiStack'
    });
    var props = extendSxProp(themeProps);

    var _props$component22 = props.component,
        component = _props$component22 === void 0 ? 'div' : _props$component22,
        _props$direction4 = props.direction,
        direction = _props$direction4 === void 0 ? 'column' : _props$direction4,
        _props$spacing2 = props.spacing,
        spacing = _props$spacing2 === void 0 ? 0 : _props$spacing2,
        divider = props.divider,
        children = props.children,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$z);

    var ownerState = {
      direction: direction,
      spacing: spacing
    };
    return /*#__PURE__*/jsxRuntime$1.jsx(StackRoot, _extends$c({
      as: component,
      ownerState: ownerState,
      ref: ref
    }, other, {
      children: divider ? joinChildren(children, divider) : children
    }));
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var BaseStack = Stack$2;
  /**
   * @ignore - internal component.
   */

  var StepperContext = /*#__PURE__*/React__namespace.createContext({});

  if (process.env.NODE_ENV !== 'production') {
    StepperContext.displayName = 'StepperContext';
  }

  var StepperContext$1 = StepperContext;
  /**
   * @ignore - internal component.
   */

  var StepContext = /*#__PURE__*/React__namespace.createContext({});

  if (process.env.NODE_ENV !== 'production') {
    StepContext.displayName = 'StepContext';
  }

  var StepContext$1 = StepContext;

  function getStepUtilityClass(slot) {
    return generateUtilityClass('MuiStep', slot);
  }

  generateUtilityClasses('MuiStep', ['root', 'horizontal', 'vertical', 'alternativeLabel', 'completed']);
  var _excluded$y = ["active", "children", "className", "completed", "disabled", "expanded", "index", "last"];

  var useUtilityClasses$m = function useUtilityClasses$m(ownerState) {
    var classes = ownerState.classes,
        orientation = ownerState.orientation,
        alternativeLabel = ownerState.alternativeLabel,
        completed = ownerState.completed;
    var slots = {
      root: ['root', orientation, alternativeLabel && 'alternativeLabel', completed && 'completed']
    };
    return composeClasses(slots, getStepUtilityClass, classes);
  };

  var StepRoot = styled$1('div', {
    name: 'MuiStep',
    slot: 'Root',
    overridesResolver: function overridesResolver(props, styles) {
      var ownerState = props.ownerState;
      return [styles.root, styles[ownerState.orientation], ownerState.alternativeLabel && styles.alternativeLabel, ownerState.completed && styles.completed];
    }
  })(function (_ref199) {
    var ownerState = _ref199.ownerState;
    return _extends$c({}, ownerState.orientation === 'horizontal' && {
      paddingLeft: 8,
      paddingRight: 8
    }, ownerState.alternativeLabel && {
      flex: 1,
      position: 'relative'
    });
  });
  var Step$1 = /*#__PURE__*/React__namespace.forwardRef(function Step(inProps, ref) {
    var props = useThemeProps({
      props: inProps,
      name: 'MuiStep'
    });

    var activeProp = props.active,
        children = props.children,
        className = props.className,
        completedProp = props.completed,
        disabledProp = props.disabled,
        _props$expanded = props.expanded,
        expanded = _props$expanded === void 0 ? false : _props$expanded,
        index = props.index,
        last = props.last,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$y);

    var _React__namespace$use71 = React__namespace.useContext(StepperContext$1),
        activeStep = _React__namespace$use71.activeStep,
        connector = _React__namespace$use71.connector,
        alternativeLabel = _React__namespace$use71.alternativeLabel,
        orientation = _React__namespace$use71.orientation,
        nonLinear = _React__namespace$use71.nonLinear;

    var _activeProp = activeProp,
        active = _activeProp === void 0 ? false : _activeProp,
        _completedProp = completedProp,
        completed = _completedProp === void 0 ? false : _completedProp,
        _disabledProp = disabledProp,
        disabled = _disabledProp === void 0 ? false : _disabledProp;

    if (activeStep === index) {
      active = activeProp !== undefined ? activeProp : true;
    } else if (!nonLinear && activeStep > index) {
      completed = completedProp !== undefined ? completedProp : true;
    } else if (!nonLinear && activeStep < index) {
      disabled = disabledProp !== undefined ? disabledProp : true;
    }

    var contextValue = React__namespace.useMemo(function () {
      return {
        index: index,
        last: last,
        expanded: expanded,
        icon: index + 1,
        active: active,
        completed: completed,
        disabled: disabled
      };
    }, [index, last, expanded, active, completed, disabled]);

    var ownerState = _extends$c({}, props, {
      active: active,
      orientation: orientation,
      alternativeLabel: alternativeLabel,
      completed: completed,
      disabled: disabled,
      expanded: expanded
    });

    var classes = useUtilityClasses$m(ownerState);
    var newChildren = /*#__PURE__*/jsxRuntime$1.jsxs(StepRoot, _extends$c({
      className: clsx(classes.root, className),
      ref: ref,
      ownerState: ownerState
    }, other, {
      children: [connector && alternativeLabel && index !== 0 ? connector : null, children]
    }));
    return /*#__PURE__*/jsxRuntime$1.jsx(StepContext$1.Provider, {
      value: contextValue,
      children: connector && !alternativeLabel && index !== 0 ? /*#__PURE__*/jsxRuntime$1.jsxs(React__namespace.Fragment, {
        children: [connector, newChildren]
      }) : newChildren
    });
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var BaseStep = Step$1;
  var CheckCircle = createSvgIcon$1( /*#__PURE__*/jsxRuntime$1.jsx("path", {
    d: "M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24zm-2 17l-5-5 1.4-1.4 3.6 3.6 7.6-7.6L19 8l-9 9z"
  }), 'CheckCircle');
  var Warning = createSvgIcon$1( /*#__PURE__*/jsxRuntime$1.jsx("path", {
    d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
  }), 'Warning');

  function getStepIconUtilityClass(slot) {
    return generateUtilityClass('MuiStepIcon', slot);
  }

  var stepIconClasses = generateUtilityClasses('MuiStepIcon', ['root', 'active', 'completed', 'error', 'text']);
  var stepIconClasses$1 = stepIconClasses;

  var _circle;

  var _excluded$x = ["active", "className", "completed", "error", "icon"];

  var useUtilityClasses$l = function useUtilityClasses$l(ownerState) {
    var classes = ownerState.classes,
        active = ownerState.active,
        completed = ownerState.completed,
        error = ownerState.error;
    var slots = {
      root: ['root', active && 'active', completed && 'completed', error && 'error'],
      text: ['text']
    };
    return composeClasses(slots, getStepIconUtilityClass, classes);
  };

  var StepIconRoot = styled$1(SvgIcon$2, {
    name: 'MuiStepIcon',
    slot: 'Root',
    overridesResolver: function overridesResolver(props, styles) {
      return styles.root;
    }
  })(function (_ref200) {
    var _ref201;

    var theme = _ref200.theme;
    return _ref201 = {
      display: 'block',
      transition: theme.transitions.create('color', {
        duration: theme.transitions.duration.shortest
      }),
      color: theme.palette.text.disabled
    }, _defineProperty(_ref201, "&.".concat(stepIconClasses$1.completed), {
      color: theme.palette.primary.main
    }), _defineProperty(_ref201, "&.".concat(stepIconClasses$1.active), {
      color: theme.palette.primary.main
    }), _defineProperty(_ref201, "&.".concat(stepIconClasses$1.error), {
      color: theme.palette.error.main
    }), _ref201;
  });
  var StepIconText = styled$1('text', {
    name: 'MuiStepIcon',
    slot: 'Text',
    overridesResolver: function overridesResolver(props, styles) {
      return styles.text;
    }
  })(function (_ref202) {
    var theme = _ref202.theme;
    return {
      fill: theme.palette.primary.contrastText,
      fontSize: theme.typography.caption.fontSize,
      fontFamily: theme.typography.fontFamily
    };
  });
  var StepIcon$1 = /*#__PURE__*/React__namespace.forwardRef(function StepIcon(inProps, ref) {
    var props = useThemeProps({
      props: inProps,
      name: 'MuiStepIcon'
    });

    var _props$active = props.active,
        active = _props$active === void 0 ? false : _props$active,
        classNameProp = props.className,
        _props$completed = props.completed,
        completed = _props$completed === void 0 ? false : _props$completed,
        _props$error2 = props.error,
        error = _props$error2 === void 0 ? false : _props$error2,
        icon = props.icon,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$x);

    var ownerState = _extends$c({}, props, {
      active: active,
      completed: completed,
      error: error
    });

    var classes = useUtilityClasses$l(ownerState);

    if (typeof icon === 'number' || typeof icon === 'string') {
      var className = clsx(classNameProp, classes.root);

      if (error) {
        return /*#__PURE__*/jsxRuntime$1.jsx(StepIconRoot, _extends$c({
          as: Warning,
          className: className,
          ref: ref,
          ownerState: ownerState
        }, other));
      }

      if (completed) {
        return /*#__PURE__*/jsxRuntime$1.jsx(StepIconRoot, _extends$c({
          as: CheckCircle,
          className: className,
          ref: ref,
          ownerState: ownerState
        }, other));
      }

      return /*#__PURE__*/jsxRuntime$1.jsxs(StepIconRoot, _extends$c({
        className: className,
        ref: ref,
        ownerState: ownerState
      }, other, {
        children: [_circle || (_circle = /*#__PURE__*/jsxRuntime$1.jsx("circle", {
          cx: "12",
          cy: "12",
          r: "12"
        })), /*#__PURE__*/jsxRuntime$1.jsx(StepIconText, {
          className: classes.text,
          x: "12",
          y: "16",
          textAnchor: "middle",
          ownerState: ownerState,
          children: icon
        })]
      }));
    }

    return icon;
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var BaseStepIcon = StepIcon$1;

  function getStepLabelUtilityClass(slot) {
    return generateUtilityClass('MuiStepLabel', slot);
  }

  var stepLabelClasses = generateUtilityClasses('MuiStepLabel', ['root', 'horizontal', 'vertical', 'label', 'active', 'completed', 'error', 'disabled', 'iconContainer', 'alternativeLabel', 'labelContainer']);
  var stepLabelClasses$1 = stepLabelClasses;
  var _excluded$w = ["children", "className", "componentsProps", "error", "icon", "optional", "StepIconComponent", "StepIconProps"];

  var useUtilityClasses$k = function useUtilityClasses$k(ownerState) {
    var classes = ownerState.classes,
        orientation = ownerState.orientation,
        active = ownerState.active,
        completed = ownerState.completed,
        error = ownerState.error,
        disabled = ownerState.disabled,
        alternativeLabel = ownerState.alternativeLabel;
    var slots = {
      root: ['root', orientation, error && 'error', disabled && 'disabled', alternativeLabel && 'alternativeLabel'],
      label: ['label', active && 'active', completed && 'completed', error && 'error', disabled && 'disabled', alternativeLabel && 'alternativeLabel'],
      iconContainer: ['iconContainer', alternativeLabel && 'alternativeLabel'],
      labelContainer: ['labelContainer']
    };
    return composeClasses(slots, getStepLabelUtilityClass, classes);
  };

  var StepLabelRoot = styled$1('span', {
    name: 'MuiStepLabel',
    slot: 'Root',
    overridesResolver: function overridesResolver(props, styles) {
      var ownerState = props.ownerState;
      return [styles.root, styles[ownerState.orientation]];
    }
  })(function (_ref203) {
    var _extends$c27;

    var ownerState = _ref203.ownerState;
    return _extends$c((_extends$c27 = {
      display: 'flex',
      alignItems: 'center'
    }, _defineProperty(_extends$c27, "&.".concat(stepLabelClasses$1.alternativeLabel), {
      flexDirection: 'column'
    }), _defineProperty(_extends$c27, "&.".concat(stepLabelClasses$1.disabled), {
      cursor: 'default'
    }), _extends$c27), ownerState.orientation === 'vertical' && {
      textAlign: 'left',
      padding: '8px 0'
    });
  });
  var StepLabelLabel = styled$1('span', {
    name: 'MuiStepLabel',
    slot: 'Label',
    overridesResolver: function overridesResolver(props, styles) {
      return styles.label;
    }
  })(function (_ref204) {
    var _extends$c28;

    var theme = _ref204.theme;
    return _extends$c({}, theme.typography.body2, (_extends$c28 = {
      display: 'block',
      transition: theme.transitions.create('color', {
        duration: theme.transitions.duration.shortest
      })
    }, _defineProperty(_extends$c28, "&.".concat(stepLabelClasses$1.active), {
      color: theme.palette.text.primary,
      fontWeight: 500
    }), _defineProperty(_extends$c28, "&.".concat(stepLabelClasses$1.completed), {
      color: theme.palette.text.primary,
      fontWeight: 500
    }), _defineProperty(_extends$c28, "&.".concat(stepLabelClasses$1.alternativeLabel), {
      textAlign: 'center',
      marginTop: 16
    }), _defineProperty(_extends$c28, "&.".concat(stepLabelClasses$1.error), {
      color: theme.palette.error.main
    }), _extends$c28));
  });
  var StepLabelIconContainer = styled$1('span', {
    name: 'MuiStepLabel',
    slot: 'IconContainer',
    overridesResolver: function overridesResolver(props, styles) {
      return styles.iconContainer;
    }
  })(function () {
    return _defineProperty({
      flexShrink: 0,
      // Fix IE11 issue
      display: 'flex',
      paddingRight: 8
    }, "&.".concat(stepLabelClasses$1.alternativeLabel), {
      paddingRight: 0
    });
  });
  var StepLabelLabelContainer = styled$1('span', {
    name: 'MuiStepLabel',
    slot: 'LabelContainer',
    overridesResolver: function overridesResolver(props, styles) {
      return styles.labelContainer;
    }
  })(function (_ref206) {
    var theme = _ref206.theme;
    return {
      width: '100%',
      color: theme.palette.text.secondary
    };
  });
  var StepLabel$1 = /*#__PURE__*/React__namespace.forwardRef(function StepLabel(inProps, ref) {
    var props = useThemeProps({
      props: inProps,
      name: 'MuiStepLabel'
    });

    var children = props.children,
        className = props.className,
        _props$componentsProp11 = props.componentsProps,
        componentsProps = _props$componentsProp11 === void 0 ? {} : _props$componentsProp11,
        _props$error3 = props.error,
        error = _props$error3 === void 0 ? false : _props$error3,
        iconProp = props.icon,
        optional = props.optional,
        StepIconComponentProp = props.StepIconComponent,
        StepIconProps = props.StepIconProps,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$w);

    var _React__namespace$use72 = React__namespace.useContext(StepperContext$1),
        alternativeLabel = _React__namespace$use72.alternativeLabel,
        orientation = _React__namespace$use72.orientation;

    var _React__namespace$use73 = React__namespace.useContext(StepContext$1),
        active = _React__namespace$use73.active,
        disabled = _React__namespace$use73.disabled,
        completed = _React__namespace$use73.completed,
        iconContext = _React__namespace$use73.icon;

    var icon = iconProp || iconContext;
    var StepIconComponent = StepIconComponentProp;

    if (icon && !StepIconComponent) {
      StepIconComponent = BaseStepIcon;
    }

    var ownerState = _extends$c({}, props, {
      active: active,
      alternativeLabel: alternativeLabel,
      completed: completed,
      disabled: disabled,
      error: error,
      orientation: orientation
    });

    var classes = useUtilityClasses$k(ownerState);
    return /*#__PURE__*/jsxRuntime$1.jsxs(StepLabelRoot, _extends$c({
      className: clsx(classes.root, className),
      ref: ref,
      ownerState: ownerState
    }, other, {
      children: [icon || StepIconComponent ? /*#__PURE__*/jsxRuntime$1.jsx(StepLabelIconContainer, {
        className: classes.iconContainer,
        ownerState: ownerState,
        children: /*#__PURE__*/jsxRuntime$1.jsx(StepIconComponent, _extends$c({
          completed: completed,
          active: active,
          error: error,
          icon: icon
        }, StepIconProps))
      }) : null, /*#__PURE__*/jsxRuntime$1.jsxs(StepLabelLabelContainer, {
        className: classes.labelContainer,
        ownerState: ownerState,
        children: [children ? /*#__PURE__*/jsxRuntime$1.jsx(StepLabelLabel, _extends$c({
          className: classes.label,
          ownerState: ownerState
        }, componentsProps.label, {
          children: children
        })) : null, optional]
      })]
    }));
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  StepLabel$1.muiName = 'StepLabel';
  var BaseStepLabel = StepLabel$1;

  function getStepButtonUtilityClass(slot) {
    return generateUtilityClass('MuiStepButton', slot);
  }

  var stepButtonClasses = generateUtilityClasses('MuiStepButton', ['root', 'horizontal', 'vertical', 'touchRipple']);
  var stepButtonClasses$1 = stepButtonClasses;
  var _excluded$v = ["children", "className", "icon", "optional"];

  var useUtilityClasses$j = function useUtilityClasses$j(ownerState) {
    var classes = ownerState.classes,
        orientation = ownerState.orientation;
    var slots = {
      root: ['root', orientation],
      touchRipple: ['touchRipple']
    };
    return composeClasses(slots, getStepButtonUtilityClass, classes);
  };

  var StepButtonRoot = styled$1(ButtonBase$1, {
    name: 'MuiStepButton',
    slot: 'Root',
    overridesResolver: function overridesResolver(props, styles) {
      var ownerState = props.ownerState;
      return [_defineProperty({}, "& .".concat(stepButtonClasses$1.touchRipple), styles.touchRipple), styles.root, styles[ownerState.orientation]];
    }
  })(function (_ref208) {
    var ownerState = _ref208.ownerState;
    return _extends$c({
      width: '100%',
      padding: '24px 16px',
      margin: '-24px -16px',
      boxSizing: 'content-box'
    }, ownerState.orientation === 'vertical' && {
      justifyContent: 'flex-start',
      padding: '8px',
      margin: '-8px'
    }, _defineProperty({}, "& .".concat(stepButtonClasses$1.touchRipple), {
      color: 'rgba(0, 0, 0, 0.3)'
    }));
  });
  var StepButton$1 = /*#__PURE__*/React__namespace.forwardRef(function StepButton(inProps, ref) {
    var props = useThemeProps({
      props: inProps,
      name: 'MuiStepButton'
    });

    var children = props.children,
        className = props.className,
        icon = props.icon,
        optional = props.optional,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$v);

    var _React__namespace$use74 = React__namespace.useContext(StepContext$1),
        disabled = _React__namespace$use74.disabled;

    var _React__namespace$use75 = React__namespace.useContext(StepperContext$1),
        orientation = _React__namespace$use75.orientation;

    var ownerState = _extends$c({}, props, {
      orientation: orientation
    });

    var classes = useUtilityClasses$j(ownerState);
    var childProps = {
      icon: icon,
      optional: optional
    };
    var child = isMuiElement(children, ['StepLabel']) ? /*#__PURE__*/React__namespace.cloneElement(children, childProps) : /*#__PURE__*/jsxRuntime$1.jsx(BaseStepLabel, _extends$c({}, childProps, {
      children: children
    }));
    return /*#__PURE__*/jsxRuntime$1.jsx(StepButtonRoot, _extends$c({
      focusRipple: true,
      disabled: disabled,
      TouchRippleProps: {
        className: classes.touchRipple
      },
      className: clsx(classes.root, className),
      ref: ref,
      ownerState: ownerState
    }, other, {
      children: child
    }));
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var BaseStepButton = StepButton$1;

  function getStepConnectorUtilityClass(slot) {
    return generateUtilityClass('MuiStepConnector', slot);
  }

  generateUtilityClasses('MuiStepConnector', ['root', 'horizontal', 'vertical', 'alternativeLabel', 'active', 'completed', 'disabled', 'line', 'lineHorizontal', 'lineVertical']);
  var _excluded$u = ["className"];

  var useUtilityClasses$i = function useUtilityClasses$i(ownerState) {
    var classes = ownerState.classes,
        orientation = ownerState.orientation,
        alternativeLabel = ownerState.alternativeLabel,
        active = ownerState.active,
        completed = ownerState.completed,
        disabled = ownerState.disabled;
    var slots = {
      root: ['root', orientation, alternativeLabel && 'alternativeLabel', active && 'active', completed && 'completed', disabled && 'disabled'],
      line: ['line', "line".concat(capitalize$1(orientation))]
    };
    return composeClasses(slots, getStepConnectorUtilityClass, classes);
  };

  var StepConnectorRoot = styled$1('div', {
    name: 'MuiStepConnector',
    slot: 'Root',
    overridesResolver: function overridesResolver(props, styles) {
      var ownerState = props.ownerState;
      return [styles.root, styles[ownerState.orientation], ownerState.alternativeLabel && styles.alternativeLabel, ownerState.completed && styles.completed];
    }
  })(function (_ref209) {
    var ownerState = _ref209.ownerState;
    return _extends$c({
      flex: '1 1 auto'
    }, ownerState.orientation === 'vertical' && {
      marginLeft: 12 // half icon

    }, ownerState.alternativeLabel && {
      position: 'absolute',
      top: 8 + 4,
      left: 'calc(-50% + 20px)',
      right: 'calc(50% + 20px)'
    });
  });
  var StepConnectorLine = styled$1('span', {
    name: 'MuiStepConnector',
    slot: 'Line',
    overridesResolver: function overridesResolver(props, styles) {
      var ownerState = props.ownerState;
      return [styles.line, styles["line".concat(capitalize$1(ownerState.orientation))]];
    }
  })(function (_ref210) {
    var ownerState = _ref210.ownerState,
        theme = _ref210.theme;
    return _extends$c({
      display: 'block',
      borderColor: theme.palette.mode === 'light' ? theme.palette.grey[400] : theme.palette.grey[600]
    }, ownerState.orientation === 'horizontal' && {
      borderTopStyle: 'solid',
      borderTopWidth: 1
    }, ownerState.orientation === 'vertical' && {
      borderLeftStyle: 'solid',
      borderLeftWidth: 1,
      minHeight: 24
    });
  });
  var StepConnector$1 = /*#__PURE__*/React__namespace.forwardRef(function StepConnector(inProps, ref) {
    var props = useThemeProps({
      props: inProps,
      name: 'MuiStepConnector'
    });

    var className = props.className,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$u);

    var _React__namespace$use76 = React__namespace.useContext(StepperContext$1),
        alternativeLabel = _React__namespace$use76.alternativeLabel,
        _React__namespace$use77 = _React__namespace$use76.orientation,
        orientation = _React__namespace$use77 === void 0 ? 'horizontal' : _React__namespace$use77;

    var _React__namespace$use78 = React__namespace.useContext(StepContext$1),
        active = _React__namespace$use78.active,
        disabled = _React__namespace$use78.disabled,
        completed = _React__namespace$use78.completed;

    var ownerState = _extends$c({}, props, {
      alternativeLabel: alternativeLabel,
      orientation: orientation,
      active: active,
      completed: completed,
      disabled: disabled
    });

    var classes = useUtilityClasses$i(ownerState);
    return /*#__PURE__*/jsxRuntime$1.jsx(StepConnectorRoot, _extends$c({
      className: clsx(classes.root, className),
      ref: ref,
      ownerState: ownerState
    }, other, {
      children: /*#__PURE__*/jsxRuntime$1.jsx(StepConnectorLine, {
        className: classes.line,
        ownerState: ownerState
      })
    }));
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var BaseStepConnector = StepConnector$1;

  function getStepContentUtilityClass(slot) {
    return generateUtilityClass('MuiStepContent', slot);
  }

  generateUtilityClasses('MuiStepContent', ['root', 'last', 'transition']);
  var _excluded$t = ["children", "className", "TransitionComponent", "transitionDuration", "TransitionProps"];

  var useUtilityClasses$h = function useUtilityClasses$h(ownerState) {
    var classes = ownerState.classes,
        last = ownerState.last;
    var slots = {
      root: ['root', last && 'last'],
      transition: ['transition']
    };
    return composeClasses(slots, getStepContentUtilityClass, classes);
  };

  var StepContentRoot = styled$1('div', {
    name: 'MuiStepContent',
    slot: 'Root',
    overridesResolver: function overridesResolver(props, styles) {
      var ownerState = props.ownerState;
      return [styles.root, ownerState.last && styles.last];
    }
  })(function (_ref211) {
    var ownerState = _ref211.ownerState,
        theme = _ref211.theme;
    return _extends$c({
      marginLeft: 12,
      // half icon
      paddingLeft: 8 + 12,
      // margin + half icon
      paddingRight: 8,
      borderLeft: "1px solid ".concat(theme.palette.mode === 'light' ? theme.palette.grey[400] : theme.palette.grey[600])
    }, ownerState.last && {
      borderLeft: 'none'
    });
  });
  var StepContentTransition = styled$1(Collapse$1, {
    name: 'MuiStepContent',
    slot: 'Transition',
    overridesResolver: function overridesResolver(props, styles) {
      return styles.transition;
    }
  })({});
  var StepContent$1 = /*#__PURE__*/React__namespace.forwardRef(function StepContent(inProps, ref) {
    var props = useThemeProps({
      props: inProps,
      name: 'MuiStepContent'
    });

    var children = props.children,
        className = props.className,
        _props$TransitionComp12 = props.TransitionComponent,
        TransitionComponent = _props$TransitionComp12 === void 0 ? Collapse$1 : _props$TransitionComp12,
        _props$transitionDura6 = props.transitionDuration,
        transitionDurationProp = _props$transitionDura6 === void 0 ? 'auto' : _props$transitionDura6,
        TransitionProps = props.TransitionProps,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$t);

    var _React__namespace$use79 = React__namespace.useContext(StepperContext$1),
        orientation = _React__namespace$use79.orientation;

    var _React__namespace$use80 = React__namespace.useContext(StepContext$1),
        active = _React__namespace$use80.active,
        last = _React__namespace$use80.last,
        expanded = _React__namespace$use80.expanded;

    var ownerState = _extends$c({}, props, {
      last: last
    });

    var classes = useUtilityClasses$h(ownerState);

    if (process.env.NODE_ENV !== 'production') {
      if (orientation !== 'vertical') {
        console.error('MUI: <StepContent /> is only designed for use with the vertical stepper.');
      }
    }

    var transitionDuration = transitionDurationProp;

    if (transitionDurationProp === 'auto' && !TransitionComponent.muiSupportAuto) {
      transitionDuration = undefined;
    }

    return /*#__PURE__*/jsxRuntime$1.jsx(StepContentRoot, _extends$c({
      className: clsx(classes.root, className),
      ref: ref,
      ownerState: ownerState
    }, other, {
      children: /*#__PURE__*/jsxRuntime$1.jsx(StepContentTransition, _extends$c({
        as: TransitionComponent,
        in: active || expanded,
        className: classes.transition,
        ownerState: ownerState,
        timeout: transitionDuration,
        unmountOnExit: true
      }, TransitionProps, {
        children: children
      }))
    }));
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var BaseStepContent = StepContent$1;

  function getStepperUtilityClass(slot) {
    return generateUtilityClass('MuiStepper', slot);
  }

  generateUtilityClasses('MuiStepper', ['root', 'horizontal', 'vertical', 'alternativeLabel']);
  var _excluded$s = ["activeStep", "alternativeLabel", "children", "className", "connector", "nonLinear", "orientation"];

  var useUtilityClasses$g = function useUtilityClasses$g(ownerState) {
    var orientation = ownerState.orientation,
        alternativeLabel = ownerState.alternativeLabel,
        classes = ownerState.classes;
    var slots = {
      root: ['root', orientation, alternativeLabel && 'alternativeLabel']
    };
    return composeClasses(slots, getStepperUtilityClass, classes);
  };

  var StepperRoot = styled$1('div', {
    name: 'MuiStepper',
    slot: 'Root',
    overridesResolver: function overridesResolver(props, styles) {
      var ownerState = props.ownerState;
      return [styles.root, styles[ownerState.orientation], ownerState.alternativeLabel && styles.alternativeLabel];
    }
  })(function (_ref212) {
    var ownerState = _ref212.ownerState;
    return _extends$c({
      display: 'flex'
    }, ownerState.orientation === 'horizontal' && {
      flexDirection: 'row',
      alignItems: 'center'
    }, ownerState.orientation === 'vertical' && {
      flexDirection: 'column'
    }, ownerState.alternativeLabel && {
      alignItems: 'flex-start'
    });
  });
  var defaultConnector = /*#__PURE__*/jsxRuntime$1.jsx(BaseStepConnector, {});
  var Stepper$1 = /*#__PURE__*/React__namespace.forwardRef(function Stepper(inProps, ref) {
    var props = useThemeProps({
      props: inProps,
      name: 'MuiStepper'
    });

    var _props$activeStep = props.activeStep,
        activeStep = _props$activeStep === void 0 ? 0 : _props$activeStep,
        _props$alternativeLab = props.alternativeLabel,
        alternativeLabel = _props$alternativeLab === void 0 ? false : _props$alternativeLab,
        children = props.children,
        className = props.className,
        _props$connector = props.connector,
        connector = _props$connector === void 0 ? defaultConnector : _props$connector,
        _props$nonLinear = props.nonLinear,
        nonLinear = _props$nonLinear === void 0 ? false : _props$nonLinear,
        _props$orientation3 = props.orientation,
        orientation = _props$orientation3 === void 0 ? 'horizontal' : _props$orientation3,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$s);

    var ownerState = _extends$c({}, props, {
      alternativeLabel: alternativeLabel,
      orientation: orientation
    });

    var classes = useUtilityClasses$g(ownerState);
    var childrenArray = React__namespace.Children.toArray(children).filter(Boolean);
    var steps = childrenArray.map(function (step, index) {
      return /*#__PURE__*/React__namespace.cloneElement(step, _extends$c({
        index: index,
        last: index + 1 === childrenArray.length
      }, step.props));
    });
    var contextValue = React__namespace.useMemo(function () {
      return {
        activeStep: activeStep,
        alternativeLabel: alternativeLabel,
        connector: connector,
        nonLinear: nonLinear,
        orientation: orientation
      };
    }, [activeStep, alternativeLabel, connector, nonLinear, orientation]);
    return /*#__PURE__*/jsxRuntime$1.jsx(StepperContext$1.Provider, {
      value: contextValue,
      children: /*#__PURE__*/jsxRuntime$1.jsx(StepperRoot, _extends$c({
        ownerState: ownerState,
        className: clsx(classes.root, className),
        ref: ref
      }, other, {
        children: steps
      }))
    });
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var BaseStepper = Stepper$1;

  function getSwitchUtilityClass(slot) {
    return generateUtilityClass('MuiSwitch', slot);
  }

  var switchClasses = generateUtilityClasses('MuiSwitch', ['root', 'edgeStart', 'edgeEnd', 'switchBase', 'colorPrimary', 'colorSecondary', 'sizeSmall', 'sizeMedium', 'checked', 'disabled', 'input', 'thumb', 'track']);
  var N$1 = switchClasses;
  var _excluded$r = ["className", "color", "edge", "size", "sx"];

  var useUtilityClasses$f = function useUtilityClasses$f(ownerState) {
    var classes = ownerState.classes,
        edge = ownerState.edge,
        size = ownerState.size,
        color = ownerState.color,
        checked = ownerState.checked,
        disabled = ownerState.disabled;
    var slots = {
      root: ['root', edge && "edge".concat(capitalize$1(edge)), "size".concat(capitalize$1(size))],
      switchBase: ['switchBase', "color".concat(capitalize$1(color)), checked && 'checked', disabled && 'disabled'],
      thumb: ['thumb'],
      track: ['track'],
      input: ['input']
    };
    var composedClasses = composeClasses(slots, getSwitchUtilityClass, classes);
    return _extends$c({}, classes, composedClasses);
  };

  var SwitchRoot = styled$1('span', {
    name: 'MuiSwitch',
    slot: 'Root',
    overridesResolver: function overridesResolver(props, styles) {
      var ownerState = props.ownerState;
      return [styles.root, ownerState.edge && styles["edge".concat(capitalize$1(ownerState.edge))], styles["size".concat(capitalize$1(ownerState.size))]];
    }
  })(function (_ref213) {
    var _ref214;

    var ownerState = _ref213.ownerState;
    return _extends$c({
      display: 'inline-flex',
      width: 34 + 12 * 2,
      height: 14 + 12 * 2,
      overflow: 'hidden',
      padding: 12,
      boxSizing: 'border-box',
      position: 'relative',
      flexShrink: 0,
      zIndex: 0,
      // Reset the stacking context.
      verticalAlign: 'middle',
      // For correct alignment with the text.
      '@media print': {
        colorAdjust: 'exact'
      }
    }, ownerState.edge === 'start' && {
      marginLeft: -8
    }, ownerState.edge === 'end' && {
      marginRight: -8
    }, ownerState.size === 'small' && (_ref214 = {
      width: 40,
      height: 24,
      padding: 7
    }, _defineProperty(_ref214, "& .".concat(N$1.thumb), {
      width: 16,
      height: 16
    }), _defineProperty(_ref214, "& .".concat(N$1.switchBase), _defineProperty({
      padding: 4
    }, "&.".concat(N$1.checked), {
      transform: 'translateX(16px)'
    })), _ref214));
  });
  var SwitchSwitchBase = styled$1(SwitchBase$1, {
    name: 'MuiSwitch',
    slot: 'SwitchBase',
    overridesResolver: function overridesResolver(props, styles) {
      var ownerState = props.ownerState;
      return [styles.switchBase, _defineProperty({}, "& .".concat(N$1.input), styles.input), ownerState.color !== 'default' && styles["color".concat(capitalize$1(ownerState.color))]];
    }
  })(function (_ref216) {
    var _ref217;

    var theme = _ref216.theme;
    return _ref217 = {
      position: 'absolute',
      top: 0,
      left: 0,
      zIndex: 1,
      // Render above the focus ripple.
      color: theme.palette.mode === 'light' ? theme.palette.common.white : theme.palette.grey[300],
      transition: theme.transitions.create(['left', 'transform'], {
        duration: theme.transitions.duration.shortest
      })
    }, _defineProperty(_ref217, "&.".concat(N$1.checked), {
      transform: 'translateX(20px)'
    }), _defineProperty(_ref217, "&.".concat(N$1.disabled), {
      color: theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[600]
    }), _defineProperty(_ref217, "&.".concat(N$1.checked, " + .").concat(N$1.track), {
      opacity: 0.5
    }), _defineProperty(_ref217, "&.".concat(N$1.disabled, " + .").concat(N$1.track), {
      opacity: theme.palette.mode === 'light' ? 0.12 : 0.2
    }), _defineProperty(_ref217, "& .".concat(N$1.input), {
      left: '-100%',
      width: '300%'
    }), _ref217;
  }, function (_ref218) {
    var _ref219;

    var theme = _ref218.theme,
        ownerState = _ref218.ownerState;
    return _extends$c({
      '&:hover': {
        backgroundColor: alpha(theme.palette.action.active, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    }, ownerState.color !== 'default' && (_ref219 = {}, _defineProperty(_ref219, "&.".concat(N$1.checked), _defineProperty({
      color: theme.palette[ownerState.color].main,
      '&:hover': {
        backgroundColor: alpha(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    }, "&.".concat(N$1.disabled), {
      color: theme.palette.mode === 'light' ? lighten(theme.palette[ownerState.color].main, 0.62) : darken(theme.palette[ownerState.color].main, 0.55)
    })), _defineProperty(_ref219, "&.".concat(N$1.checked, " + .").concat(N$1.track), {
      backgroundColor: theme.palette[ownerState.color].main
    }), _ref219));
  });
  var SwitchTrack = styled$1('span', {
    name: 'MuiSwitch',
    slot: 'Track',
    overridesResolver: function overridesResolver(props, styles) {
      return styles.track;
    }
  })(function (_ref220) {
    var theme = _ref220.theme;
    return {
      height: '100%',
      width: '100%',
      borderRadius: 14 / 2,
      zIndex: -1,
      transition: theme.transitions.create(['opacity', 'background-color'], {
        duration: theme.transitions.duration.shortest
      }),
      backgroundColor: theme.palette.mode === 'light' ? theme.palette.common.black : theme.palette.common.white,
      opacity: theme.palette.mode === 'light' ? 0.38 : 0.3
    };
  });
  var SwitchThumb = styled$1('span', {
    name: 'MuiSwitch',
    slot: 'Thumb',
    overridesResolver: function overridesResolver(props, styles) {
      return styles.thumb;
    }
  })(function (_ref221) {
    var theme = _ref221.theme;
    return {
      boxShadow: theme.shadows[1],
      backgroundColor: 'currentColor',
      width: 20,
      height: 20,
      borderRadius: '50%'
    };
  });
  var Switch = /*#__PURE__*/React__namespace.forwardRef(function Switch(inProps, ref) {
    var props = useThemeProps({
      props: inProps,
      name: 'MuiSwitch'
    });

    var className = props.className,
        _props$color14 = props.color,
        color = _props$color14 === void 0 ? 'primary' : _props$color14,
        _props$edge3 = props.edge,
        edge = _props$edge3 === void 0 ? false : _props$edge3,
        _props$size10 = props.size,
        size = _props$size10 === void 0 ? 'medium' : _props$size10,
        sx = props.sx,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$r);

    var ownerState = _extends$c({}, props, {
      color: color,
      edge: edge,
      size: size
    });

    var classes = useUtilityClasses$f(ownerState);
    var icon = /*#__PURE__*/jsxRuntime$1.jsx(SwitchThumb, {
      className: classes.thumb,
      ownerState: ownerState
    });
    return /*#__PURE__*/jsxRuntime$1.jsxs(SwitchRoot, {
      className: clsx(classes.root, className),
      sx: sx,
      ownerState: ownerState,
      children: [/*#__PURE__*/jsxRuntime$1.jsx(SwitchSwitchBase, _extends$c({
        type: "checkbox",
        icon: icon,
        checkedIcon: icon,
        ref: ref,
        ownerState: ownerState
      }, other, {
        classes: _extends$c({}, classes, {
          root: classes.switchBase
        })
      })), /*#__PURE__*/jsxRuntime$1.jsx(SwitchTrack, {
        className: classes.track,
        ownerState: ownerState
      })]
    });
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var z$1 = Switch;
  /**
   * @ignore - internal component.
   */

  var TableContext = /*#__PURE__*/React__namespace.createContext();

  if (process.env.NODE_ENV !== 'production') {
    TableContext.displayName = 'TableContext';
  }

  var TableContext$1 = TableContext;

  function getTableUtilityClass(slot) {
    return generateUtilityClass('MuiTable', slot);
  }

  generateUtilityClasses('MuiTable', ['root', 'stickyHeader']);
  var _excluded$q = ["className", "component", "padding", "size", "stickyHeader"];

  var useUtilityClasses$e = function useUtilityClasses$e(ownerState) {
    var classes = ownerState.classes,
        stickyHeader = ownerState.stickyHeader;
    var slots = {
      root: ['root', stickyHeader && 'stickyHeader']
    };
    return composeClasses(slots, getTableUtilityClass, classes);
  };

  var TableRoot = styled$1('table', {
    name: 'MuiTable',
    slot: 'Root',
    overridesResolver: function overridesResolver(props, styles) {
      var ownerState = props.ownerState;
      return [styles.root, ownerState.stickyHeader && styles.stickyHeader];
    }
  })(function (_ref222) {
    var theme = _ref222.theme,
        ownerState = _ref222.ownerState;
    return _extends$c({
      display: 'table',
      width: '100%',
      borderCollapse: 'collapse',
      borderSpacing: 0,
      '& caption': _extends$c({}, theme.typography.body2, {
        padding: theme.spacing(2),
        color: theme.palette.text.secondary,
        textAlign: 'left',
        captionSide: 'bottom'
      })
    }, ownerState.stickyHeader && {
      borderCollapse: 'separate'
    });
  });
  var defaultComponent$3 = 'table';
  var Table$1 = /*#__PURE__*/React__namespace.forwardRef(function Table(inProps, ref) {
    var props = useThemeProps({
      props: inProps,
      name: 'MuiTable'
    });

    var className = props.className,
        _props$component23 = props.component,
        component = _props$component23 === void 0 ? defaultComponent$3 : _props$component23,
        _props$padding = props.padding,
        padding = _props$padding === void 0 ? 'normal' : _props$padding,
        _props$size11 = props.size,
        size = _props$size11 === void 0 ? 'medium' : _props$size11,
        _props$stickyHeader = props.stickyHeader,
        stickyHeader = _props$stickyHeader === void 0 ? false : _props$stickyHeader,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$q);

    var ownerState = _extends$c({}, props, {
      component: component,
      padding: padding,
      size: size,
      stickyHeader: stickyHeader
    });

    var classes = useUtilityClasses$e(ownerState);
    var table = React__namespace.useMemo(function () {
      return {
        padding: padding,
        size: size,
        stickyHeader: stickyHeader
      };
    }, [padding, size, stickyHeader]);
    return /*#__PURE__*/jsxRuntime$1.jsx(TableContext$1.Provider, {
      value: table,
      children: /*#__PURE__*/jsxRuntime$1.jsx(TableRoot, _extends$c({
        as: component,
        role: component === defaultComponent$3 ? null : 'table',
        ref: ref,
        className: clsx(classes.root, className),
        ownerState: ownerState
      }, other))
    });
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var BaseTable = Table$1;
  /**
   * @ignore - internal component.
   */

  var Tablelvl2Context = /*#__PURE__*/React__namespace.createContext();

  if (process.env.NODE_ENV !== 'production') {
    Tablelvl2Context.displayName = 'Tablelvl2Context';
  }

  var Tablelvl2Context$1 = Tablelvl2Context;

  function getTableBodyUtilityClass(slot) {
    return generateUtilityClass('MuiTableBody', slot);
  }

  generateUtilityClasses('MuiTableBody', ['root']);
  var _excluded$p = ["className", "component"];

  var useUtilityClasses$d = function useUtilityClasses$d(ownerState) {
    var classes = ownerState.classes;
    var slots = {
      root: ['root']
    };
    return composeClasses(slots, getTableBodyUtilityClass, classes);
  };

  var TableBodyRoot = styled$1('tbody', {
    name: 'MuiTableBody',
    slot: 'Root',
    overridesResolver: function overridesResolver(props, styles) {
      return styles.root;
    }
  })({
    display: 'table-row-group'
  });
  var tablelvl2$1 = {
    variant: 'body'
  };
  var defaultComponent$2 = 'tbody';
  var TableBody$1 = /*#__PURE__*/React__namespace.forwardRef(function TableBody(inProps, ref) {
    var props = useThemeProps({
      props: inProps,
      name: 'MuiTableBody'
    });

    var className = props.className,
        _props$component24 = props.component,
        component = _props$component24 === void 0 ? defaultComponent$2 : _props$component24,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$p);

    var ownerState = _extends$c({}, props, {
      component: component
    });

    var classes = useUtilityClasses$d(ownerState);
    return /*#__PURE__*/jsxRuntime$1.jsx(Tablelvl2Context$1.Provider, {
      value: tablelvl2$1,
      children: /*#__PURE__*/jsxRuntime$1.jsx(TableBodyRoot, _extends$c({
        className: clsx(classes.root, className),
        as: component,
        ref: ref,
        role: component === defaultComponent$2 ? null : 'rowgroup',
        ownerState: ownerState
      }, other))
    });
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var BaseTableBody = TableBody$1;

  function getTableCellUtilityClass(slot) {
    return generateUtilityClass('MuiTableCell', slot);
  }

  var tableCellClasses = generateUtilityClasses('MuiTableCell', ['root', 'head', 'body', 'footer', 'sizeSmall', 'sizeMedium', 'paddingCheckbox', 'paddingNone', 'alignLeft', 'alignCenter', 'alignRight', 'alignJustify', 'stickyHeader']);
  var tableCellClasses$1 = tableCellClasses;
  var _excluded$o = ["align", "className", "component", "padding", "scope", "size", "sortDirection", "variant"];

  var useUtilityClasses$c = function useUtilityClasses$c(ownerState) {
    var classes = ownerState.classes,
        variant = ownerState.variant,
        align = ownerState.align,
        padding = ownerState.padding,
        size = ownerState.size,
        stickyHeader = ownerState.stickyHeader;
    var slots = {
      root: ['root', variant, stickyHeader && 'stickyHeader', align !== 'inherit' && "align".concat(capitalize$1(align)), padding !== 'normal' && "padding".concat(capitalize$1(padding)), "size".concat(capitalize$1(size))]
    };
    return composeClasses(slots, getTableCellUtilityClass, classes);
  };

  var TableCellRoot = styled$1('td', {
    name: 'MuiTableCell',
    slot: 'Root',
    overridesResolver: function overridesResolver(props, styles) {
      var ownerState = props.ownerState;
      return [styles.root, styles[ownerState.variant], styles["size".concat(capitalize$1(ownerState.size))], ownerState.padding !== 'normal' && styles["padding".concat(capitalize$1(ownerState.padding))], ownerState.align !== 'inherit' && styles["align".concat(capitalize$1(ownerState.align))], ownerState.stickyHeader && styles.stickyHeader];
    }
  })(function (_ref223) {
    var theme = _ref223.theme,
        ownerState = _ref223.ownerState;
    return _extends$c({}, theme.typography.body2, {
      display: 'table-cell',
      verticalAlign: 'inherit',
      // Workaround for a rendering bug with spanned columns in Chrome 62.0.
      // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
      borderBottom: "1px solid\n    ".concat(theme.palette.mode === 'light' ? lighten(alpha(theme.palette.divider, 1), 0.88) : darken(alpha(theme.palette.divider, 1), 0.68)),
      textAlign: 'left',
      padding: 16
    }, ownerState.variant === 'head' && {
      color: theme.palette.text.primary,
      lineHeight: theme.typography.pxToRem(24),
      fontWeight: theme.typography.fontWeightMedium
    }, ownerState.variant === 'body' && {
      color: theme.palette.text.primary
    }, ownerState.variant === 'footer' && {
      color: theme.palette.text.secondary,
      lineHeight: theme.typography.pxToRem(21),
      fontSize: theme.typography.pxToRem(12)
    }, ownerState.size === 'small' && _defineProperty({
      padding: '6px 16px'
    }, "&.".concat(tableCellClasses$1.paddingCheckbox), {
      width: 24,
      // prevent the checkbox column from growing
      padding: '0 12px 0 16px',
      '& > *': {
        padding: 0
      }
    }), ownerState.padding === 'checkbox' && {
      width: 48,
      // prevent the checkbox column from growing
      padding: '0 0 0 4px'
    }, ownerState.padding === 'none' && {
      padding: 0
    }, ownerState.align === 'left' && {
      textAlign: 'left'
    }, ownerState.align === 'center' && {
      textAlign: 'center'
    }, ownerState.align === 'right' && {
      textAlign: 'right',
      flexDirection: 'row-reverse'
    }, ownerState.align === 'justify' && {
      textAlign: 'justify'
    }, ownerState.stickyHeader && {
      position: 'sticky',
      top: 0,
      zIndex: 2,
      backgroundColor: theme.palette.background.default
    });
  });
  /**
   * The component renders a `<th>` element when the parent context is a header
   * or otherwise a `<td>` element.
   */

  var TableCell$1 = /*#__PURE__*/React__namespace.forwardRef(function TableCell(inProps, ref) {
    var props = useThemeProps({
      props: inProps,
      name: 'MuiTableCell'
    });

    var _props$align2 = props.align,
        align = _props$align2 === void 0 ? 'inherit' : _props$align2,
        className = props.className,
        componentProp = props.component,
        paddingProp = props.padding,
        scopeProp = props.scope,
        sizeProp = props.size,
        sortDirection = props.sortDirection,
        variantProp = props.variant,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$o);

    var table = React__namespace.useContext(TableContext$1);
    var tablelvl2 = React__namespace.useContext(Tablelvl2Context$1);
    var isHeadCell = tablelvl2 && tablelvl2.variant === 'head';
    var component;

    if (componentProp) {
      component = componentProp;
    } else {
      component = isHeadCell ? 'th' : 'td';
    }

    var scope = scopeProp;

    if (!scope && isHeadCell) {
      scope = 'col';
    }

    var variant = variantProp || tablelvl2 && tablelvl2.variant;

    var ownerState = _extends$c({}, props, {
      align: align,
      component: component,
      padding: paddingProp || (table && table.padding ? table.padding : 'normal'),
      size: sizeProp || (table && table.size ? table.size : 'medium'),
      sortDirection: sortDirection,
      stickyHeader: variant === 'head' && table && table.stickyHeader,
      variant: variant
    });

    var classes = useUtilityClasses$c(ownerState);
    var ariaSort = null;

    if (sortDirection) {
      ariaSort = sortDirection === 'asc' ? 'ascending' : 'descending';
    }

    return /*#__PURE__*/jsxRuntime$1.jsx(TableCellRoot, _extends$c({
      as: component,
      ref: ref,
      className: clsx(classes.root, className),
      "aria-sort": ariaSort,
      scope: scope,
      ownerState: ownerState
    }, other));
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var BaseTableCell = TableCell$1;

  function getTableContainerUtilityClass(slot) {
    return generateUtilityClass('MuiTableContainer', slot);
  }

  generateUtilityClasses('MuiTableContainer', ['root']);
  var _excluded$n = ["className", "component"];

  var useUtilityClasses$b = function useUtilityClasses$b(ownerState) {
    var classes = ownerState.classes;
    var slots = {
      root: ['root']
    };
    return composeClasses(slots, getTableContainerUtilityClass, classes);
  };

  var TableContainerRoot = styled$1('div', {
    name: 'MuiTableContainer',
    slot: 'Root',
    overridesResolver: function overridesResolver(props, styles) {
      return styles.root;
    }
  })({
    width: '100%',
    overflowX: 'auto'
  });
  var TableContainer$1 = /*#__PURE__*/React__namespace.forwardRef(function TableContainer(inProps, ref) {
    var props = useThemeProps({
      props: inProps,
      name: 'MuiTableContainer'
    });

    var className = props.className,
        _props$component25 = props.component,
        component = _props$component25 === void 0 ? 'div' : _props$component25,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$n);

    var ownerState = _extends$c({}, props, {
      component: component
    });

    var classes = useUtilityClasses$b(ownerState);
    return /*#__PURE__*/jsxRuntime$1.jsx(TableContainerRoot, _extends$c({
      ref: ref,
      as: component,
      className: clsx(classes.root, className),
      ownerState: ownerState
    }, other));
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var BaseTableContainer = TableContainer$1;

  function getTableHeadUtilityClass(slot) {
    return generateUtilityClass('MuiTableHead', slot);
  }

  generateUtilityClasses('MuiTableHead', ['root']);
  var _excluded$m = ["className", "component"];

  var useUtilityClasses$a = function useUtilityClasses$a(ownerState) {
    var classes = ownerState.classes;
    var slots = {
      root: ['root']
    };
    return composeClasses(slots, getTableHeadUtilityClass, classes);
  };

  var TableHeadRoot = styled$1('thead', {
    name: 'MuiTableHead',
    slot: 'Root',
    overridesResolver: function overridesResolver(props, styles) {
      return styles.root;
    }
  })({
    display: 'table-header-group'
  });
  var tablelvl2 = {
    variant: 'head'
  };
  var defaultComponent$1 = 'thead';
  var TableHead$1 = /*#__PURE__*/React__namespace.forwardRef(function TableHead(inProps, ref) {
    var props = useThemeProps({
      props: inProps,
      name: 'MuiTableHead'
    });

    var className = props.className,
        _props$component26 = props.component,
        component = _props$component26 === void 0 ? defaultComponent$1 : _props$component26,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$m);

    var ownerState = _extends$c({}, props, {
      component: component
    });

    var classes = useUtilityClasses$a(ownerState);
    return /*#__PURE__*/jsxRuntime$1.jsx(Tablelvl2Context$1.Provider, {
      value: tablelvl2,
      children: /*#__PURE__*/jsxRuntime$1.jsx(TableHeadRoot, _extends$c({
        as: component,
        className: clsx(classes.root, className),
        ref: ref,
        role: component === defaultComponent$1 ? null : 'rowgroup',
        ownerState: ownerState
      }, other))
    });
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var BaseTableHead = TableHead$1;

  function getToolbarUtilityClass(slot) {
    return generateUtilityClass('MuiToolbar', slot);
  }

  generateUtilityClasses('MuiToolbar', ['root', 'gutters', 'regular', 'dense']);
  var _excluded$l = ["className", "component", "disableGutters", "variant"];

  var useUtilityClasses$9 = function useUtilityClasses$9(ownerState) {
    var classes = ownerState.classes,
        disableGutters = ownerState.disableGutters,
        variant = ownerState.variant;
    var slots = {
      root: ['root', !disableGutters && 'gutters', variant]
    };
    return composeClasses(slots, getToolbarUtilityClass, classes);
  };

  var ToolbarRoot = styled$1('div', {
    name: 'MuiToolbar',
    slot: 'Root',
    overridesResolver: function overridesResolver(props, styles) {
      var ownerState = props.ownerState;
      return [styles.root, !ownerState.disableGutters && styles.gutters, styles[ownerState.variant]];
    }
  })(function (_ref225) {
    var theme = _ref225.theme,
        ownerState = _ref225.ownerState;
    return _extends$c({
      position: 'relative',
      display: 'flex',
      alignItems: 'center'
    }, !ownerState.disableGutters && _defineProperty({
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    }, theme.breakpoints.up('sm'), {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3)
    }), ownerState.variant === 'dense' && {
      minHeight: 48
    });
  }, function (_ref227) {
    var theme = _ref227.theme,
        ownerState = _ref227.ownerState;
    return ownerState.variant === 'regular' && theme.mixins.toolbar;
  });
  var Toolbar$1 = /*#__PURE__*/React__namespace.forwardRef(function Toolbar(inProps, ref) {
    var props = useThemeProps({
      props: inProps,
      name: 'MuiToolbar'
    });

    var className = props.className,
        _props$component27 = props.component,
        component = _props$component27 === void 0 ? 'div' : _props$component27,
        _props$disableGutters5 = props.disableGutters,
        disableGutters = _props$disableGutters5 === void 0 ? false : _props$disableGutters5,
        _props$variant18 = props.variant,
        variant = _props$variant18 === void 0 ? 'regular' : _props$variant18,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$l);

    var ownerState = _extends$c({}, props, {
      component: component,
      disableGutters: disableGutters,
      variant: variant
    });

    var classes = useUtilityClasses$9(ownerState);
    return /*#__PURE__*/jsxRuntime$1.jsx(ToolbarRoot, _extends$c({
      as: component,
      className: clsx(classes.root, className),
      ref: ref,
      ownerState: ownerState
    }, other));
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var BaseToolbar = Toolbar$1;
  var KeyboardArrowLeft = createSvgIcon$1( /*#__PURE__*/jsxRuntime$1.jsx("path", {
    d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
  }), 'KeyboardArrowLeft');
  var KeyboardArrowRight = createSvgIcon$1( /*#__PURE__*/jsxRuntime$1.jsx("path", {
    d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
  }), 'KeyboardArrowRight');

  var _LastPageIcon, _FirstPageIcon, _KeyboardArrowRight, _KeyboardArrowLeft, _KeyboardArrowLeft2, _KeyboardArrowRight2, _FirstPageIcon2, _LastPageIcon2;

  var _excluded$k = ["backIconButtonProps", "count", "getItemAriaLabel", "nextIconButtonProps", "onPageChange", "page", "rowsPerPage", "showFirstButton", "showLastButton"];
  var TablePaginationActions = /*#__PURE__*/React__namespace.forwardRef(function TablePaginationActions(props, ref) {
    var backIconButtonProps = props.backIconButtonProps,
        count = props.count,
        getItemAriaLabel = props.getItemAriaLabel,
        nextIconButtonProps = props.nextIconButtonProps,
        onPageChange = props.onPageChange,
        page = props.page,
        rowsPerPage = props.rowsPerPage,
        showFirstButton = props.showFirstButton,
        showLastButton = props.showLastButton,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$k);

    var theme = useTheme();

    var handleFirstPageButtonClick = function handleFirstPageButtonClick(event) {
      onPageChange(event, 0);
    };

    var handleBackButtonClick = function handleBackButtonClick(event) {
      onPageChange(event, page - 1);
    };

    var handleNextButtonClick = function handleNextButtonClick(event) {
      onPageChange(event, page + 1);
    };

    var handleLastPageButtonClick = function handleLastPageButtonClick(event) {
      onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return /*#__PURE__*/jsxRuntime$1.jsxs("div", _extends$c({
      ref: ref
    }, other, {
      children: [showFirstButton && /*#__PURE__*/jsxRuntime$1.jsx(IconButton$2, {
        onClick: handleFirstPageButtonClick,
        disabled: page === 0,
        "aria-label": getItemAriaLabel('first', page),
        title: getItemAriaLabel('first', page),
        children: theme.direction === 'rtl' ? _LastPageIcon || (_LastPageIcon = /*#__PURE__*/jsxRuntime$1.jsx(LastPageIcon, {})) : _FirstPageIcon || (_FirstPageIcon = /*#__PURE__*/jsxRuntime$1.jsx(FirstPageIcon, {}))
      }), /*#__PURE__*/jsxRuntime$1.jsx(IconButton$2, _extends$c({
        onClick: handleBackButtonClick,
        disabled: page === 0,
        color: "inherit",
        "aria-label": getItemAriaLabel('previous', page),
        title: getItemAriaLabel('previous', page)
      }, backIconButtonProps, {
        children: theme.direction === 'rtl' ? _KeyboardArrowRight || (_KeyboardArrowRight = /*#__PURE__*/jsxRuntime$1.jsx(KeyboardArrowRight, {})) : _KeyboardArrowLeft || (_KeyboardArrowLeft = /*#__PURE__*/jsxRuntime$1.jsx(KeyboardArrowLeft, {}))
      })), /*#__PURE__*/jsxRuntime$1.jsx(IconButton$2, _extends$c({
        onClick: handleNextButtonClick,
        disabled: count !== -1 ? page >= Math.ceil(count / rowsPerPage) - 1 : false,
        color: "inherit",
        "aria-label": getItemAriaLabel('next', page),
        title: getItemAriaLabel('next', page)
      }, nextIconButtonProps, {
        children: theme.direction === 'rtl' ? _KeyboardArrowLeft2 || (_KeyboardArrowLeft2 = /*#__PURE__*/jsxRuntime$1.jsx(KeyboardArrowLeft, {})) : _KeyboardArrowRight2 || (_KeyboardArrowRight2 = /*#__PURE__*/jsxRuntime$1.jsx(KeyboardArrowRight, {}))
      })), showLastButton && /*#__PURE__*/jsxRuntime$1.jsx(IconButton$2, {
        onClick: handleLastPageButtonClick,
        disabled: page >= Math.ceil(count / rowsPerPage) - 1,
        "aria-label": getItemAriaLabel('last', page),
        title: getItemAriaLabel('last', page),
        children: theme.direction === 'rtl' ? _FirstPageIcon2 || (_FirstPageIcon2 = /*#__PURE__*/jsxRuntime$1.jsx(FirstPageIcon, {})) : _LastPageIcon2 || (_LastPageIcon2 = /*#__PURE__*/jsxRuntime$1.jsx(LastPageIcon, {}))
      })]
    }));
  });
  process.env.NODE_ENV !== "production" ? TablePaginationActions.propTypes = {
    /**
     * Props applied to the back arrow [`IconButton`](/api/icon-button/) element.
     */
    backIconButtonProps: PropTypes.object,

    /**
     * The total number of rows.
     */
    count: PropTypes.number.isRequired,

    /**
     * Accepts a function which returns a string value that provides a user-friendly name for the current page.
     *
     * For localization purposes, you can use the provided [translations](/guides/localization/).
     *
     * @param {string} type The link or button type to format ('page' | 'first' | 'last' | 'next' | 'previous'). Defaults to 'page'.
     * @param {number} page The page number to format.
     * @returns {string}
     */
    getItemAriaLabel: PropTypes.func.isRequired,

    /**
     * Props applied to the next arrow [`IconButton`](/api/icon-button/) element.
     */
    nextIconButtonProps: PropTypes.object,

    /**
     * Callback fired when the page is changed.
     *
     * @param {object} event The event source of the callback.
     * @param {number} page The page selected.
     */
    onPageChange: PropTypes.func.isRequired,

    /**
     * The zero-based index of the current page.
     */
    page: PropTypes.number.isRequired,

    /**
     * The number of rows per page.
     */
    rowsPerPage: PropTypes.number.isRequired,

    /**
     * If `true`, show the first-page button.
     */
    showFirstButton: PropTypes.bool.isRequired,

    /**
     * If `true`, show the last-page button.
     */
    showLastButton: PropTypes.bool.isRequired
  } : void 0;
  var TablePaginationActions$1 = TablePaginationActions;

  function getTablePaginationUtilityClass(slot) {
    return generateUtilityClass('MuiTablePagination', slot);
  }

  var tablePaginationClasses = generateUtilityClasses('MuiTablePagination', ['root', 'toolbar', 'spacer', 'selectLabel', 'selectRoot', 'select', 'selectIcon', 'input', 'menuItem', 'displayedRows', 'actions']);
  var q$2 = tablePaginationClasses;

  var _InputBase;

  var _excluded$j = ["ActionsComponent", "backIconButtonProps", "className", "colSpan", "component", "count", "getItemAriaLabel", "labelDisplayedRows", "labelRowsPerPage", "nextIconButtonProps", "onPageChange", "onRowsPerPageChange", "page", "rowsPerPage", "rowsPerPageOptions", "SelectProps", "showFirstButton", "showLastButton"];
  var TablePaginationRoot = styled$1(BaseTableCell, {
    name: 'MuiTablePagination',
    slot: 'Root',
    overridesResolver: function overridesResolver(props, styles) {
      return styles.root;
    }
  })(function (_ref228) {
    var theme = _ref228.theme;
    return {
      overflow: 'auto',
      color: theme.palette.text.primary,
      fontSize: theme.typography.pxToRem(14),
      // Increase the specificity to override TableCell.
      '&:last-child': {
        padding: 0
      }
    };
  });
  var TablePaginationToolbar = styled$1(BaseToolbar, {
    name: 'MuiTablePagination',
    slot: 'Toolbar',
    overridesResolver: function overridesResolver(props, styles) {
      return _extends$c(_defineProperty({}, "& .".concat(q$2.actions), styles.actions), styles.toolbar);
    }
  })(function (_ref229) {
    var _ref230;

    var theme = _ref229.theme;
    return _ref230 = {
      minHeight: 52,
      paddingRight: 2
    }, _defineProperty(_ref230, "".concat(theme.breakpoints.up('xs'), " and (orientation: landscape)"), {
      minHeight: 52
    }), _defineProperty(_ref230, theme.breakpoints.up('sm'), {
      minHeight: 52,
      paddingRight: 2
    }), _defineProperty(_ref230, "& .".concat(q$2.actions), {
      flexShrink: 0,
      marginLeft: 20
    }), _ref230;
  });
  var TablePaginationSpacer = styled$1('div', {
    name: 'MuiTablePagination',
    slot: 'Spacer',
    overridesResolver: function overridesResolver(props, styles) {
      return styles.spacer;
    }
  })({
    flex: '1 1 100%'
  });
  var TablePaginationSelectLabel = styled$1('p', {
    name: 'MuiTablePagination',
    slot: 'SelectLabel',
    overridesResolver: function overridesResolver(props, styles) {
      return styles.selectLabel;
    }
  })(function (_ref231) {
    var theme = _ref231.theme;
    return _extends$c({}, theme.typography.body2, {
      flexShrink: 0
    });
  });
  var TablePaginationSelect = styled$1(D$1, {
    name: 'MuiTablePagination',
    slot: 'Select',
    overridesResolver: function overridesResolver(props, styles) {
      var _extends$c31;

      return _extends$c((_extends$c31 = {}, _defineProperty(_extends$c31, "& .".concat(q$2.selectIcon), styles.selectIcon), _defineProperty(_extends$c31, "& .".concat(q$2.select), styles.select), _extends$c31), styles.input, styles.selectRoot);
    }
  })(_defineProperty({
    color: 'inherit',
    fontSize: 'inherit',
    flexShrink: 0,
    marginRight: 32,
    marginLeft: 8
  }, "& .".concat(q$2.select), {
    paddingLeft: 8,
    paddingRight: 24,
    textAlign: 'right',
    textAlignLast: 'right' // Align <select> on Chrome.

  }));
  var TablePaginationMenuItem = styled$1(BaseMenuItem, {
    name: 'MuiTablePagination',
    slot: 'MenuItem',
    overridesResolver: function overridesResolver(props, styles) {
      return styles.menuItem;
    }
  })({});
  var TablePaginationDisplayedRows = styled$1('p', {
    name: 'MuiTablePagination',
    slot: 'DisplayedRows',
    overridesResolver: function overridesResolver(props, styles) {
      return styles.displayedRows;
    }
  })(function (_ref232) {
    var theme = _ref232.theme;
    return _extends$c({}, theme.typography.body2, {
      flexShrink: 0
    });
  });

  function defaultLabelDisplayedRows(_ref233) {
    var from = _ref233.from,
        to = _ref233.to,
        count = _ref233.count;
    return "".concat(from, "\u2013").concat(to, " of ").concat(count !== -1 ? count : "more than ".concat(to));
  }

  function defaultGetAriaLabel(type) {
    return "Go to ".concat(type, " page");
  }

  var useUtilityClasses$8 = function useUtilityClasses$8(ownerState) {
    var classes = ownerState.classes;
    var slots = {
      root: ['root'],
      toolbar: ['toolbar'],
      spacer: ['spacer'],
      selectLabel: ['selectLabel'],
      select: ['select'],
      input: ['input'],
      selectIcon: ['selectIcon'],
      menuItem: ['menuItem'],
      displayedRows: ['displayedRows'],
      actions: ['actions']
    };
    return composeClasses(slots, getTablePaginationUtilityClass, classes);
  };
  /**
   * A `TableCell` based component for placing inside `TableFooter` for pagination.
   */


  var TablePagination = /*#__PURE__*/React__namespace.forwardRef(function TablePagination(inProps, ref) {
    var props = useThemeProps({
      props: inProps,
      name: 'MuiTablePagination'
    });

    var _props$ActionsCompone = props.ActionsComponent,
        ActionsComponent = _props$ActionsCompone === void 0 ? TablePaginationActions$1 : _props$ActionsCompone,
        backIconButtonProps = props.backIconButtonProps,
        className = props.className,
        colSpanProp = props.colSpan,
        _props$component28 = props.component,
        component = _props$component28 === void 0 ? BaseTableCell : _props$component28,
        count = props.count,
        _props$getItemAriaLab = props.getItemAriaLabel,
        getItemAriaLabel = _props$getItemAriaLab === void 0 ? defaultGetAriaLabel : _props$getItemAriaLab,
        _props$labelDisplayed = props.labelDisplayedRows,
        labelDisplayedRows = _props$labelDisplayed === void 0 ? defaultLabelDisplayedRows : _props$labelDisplayed,
        _props$labelRowsPerPa = props.labelRowsPerPage,
        labelRowsPerPage = _props$labelRowsPerPa === void 0 ? 'Rows per page:' : _props$labelRowsPerPa,
        nextIconButtonProps = props.nextIconButtonProps,
        onPageChange = props.onPageChange,
        onRowsPerPageChange = props.onRowsPerPageChange,
        page = props.page,
        rowsPerPage = props.rowsPerPage,
        _props$rowsPerPageOpt = props.rowsPerPageOptions,
        rowsPerPageOptions = _props$rowsPerPageOpt === void 0 ? [10, 25, 50, 100] : _props$rowsPerPageOpt,
        _props$SelectProps = props.SelectProps,
        SelectProps = _props$SelectProps === void 0 ? {} : _props$SelectProps,
        _props$showFirstButto = props.showFirstButton,
        showFirstButton = _props$showFirstButto === void 0 ? false : _props$showFirstButto,
        _props$showLastButton = props.showLastButton,
        showLastButton = _props$showLastButton === void 0 ? false : _props$showLastButton,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$j);

    var ownerState = props;
    var classes = useUtilityClasses$8(ownerState);
    var MenuItemComponent = SelectProps.native ? 'option' : TablePaginationMenuItem;
    var colSpan;

    if (component === BaseTableCell || component === 'td') {
      colSpan = colSpanProp || 1000; // col-span over everything
    }

    var selectId = useId(SelectProps.id);
    var labelId = useId(SelectProps.labelId);

    var getLabelDisplayedRowsTo = function getLabelDisplayedRowsTo() {
      if (count === -1) {
        return (page + 1) * rowsPerPage;
      }

      return rowsPerPage === -1 ? count : Math.min(count, (page + 1) * rowsPerPage);
    };

    return /*#__PURE__*/jsxRuntime$1.jsx(TablePaginationRoot, _extends$c({
      colSpan: colSpan,
      ref: ref,
      as: component,
      ownerState: ownerState,
      className: clsx(classes.root, className)
    }, other, {
      children: /*#__PURE__*/jsxRuntime$1.jsxs(TablePaginationToolbar, {
        className: classes.toolbar,
        children: [/*#__PURE__*/jsxRuntime$1.jsx(TablePaginationSpacer, {
          className: classes.spacer
        }), rowsPerPageOptions.length > 1 && /*#__PURE__*/jsxRuntime$1.jsx(TablePaginationSelectLabel, {
          className: classes.selectLabel,
          id: labelId,
          children: labelRowsPerPage
        }), rowsPerPageOptions.length > 1 && /*#__PURE__*/jsxRuntime$1.jsx(TablePaginationSelect, _extends$c({
          variant: "standard",
          input: _InputBase || (_InputBase = /*#__PURE__*/jsxRuntime$1.jsx(E$1, {})),
          value: rowsPerPage,
          onChange: onRowsPerPageChange,
          id: selectId,
          labelId: labelId
        }, SelectProps, {
          classes: _extends$c({}, SelectProps.classes, {
            // TODO v5 remove `classes.input`
            root: clsx(classes.input, classes.selectRoot, (SelectProps.classes || {}).root),
            select: clsx(classes.select, (SelectProps.classes || {}).select),
            // TODO v5 remove `selectIcon`
            icon: clsx(classes.selectIcon, (SelectProps.classes || {}).icon)
          }),
          children: rowsPerPageOptions.map(function (rowsPerPageOption) {
            return /*#__PURE__*/React.createElement(MenuItemComponent, _extends$c({}, !isHostComponent(MenuItemComponent) && {
              ownerState: ownerState
            }, {
              className: classes.menuItem,
              key: rowsPerPageOption.label ? rowsPerPageOption.label : rowsPerPageOption,
              value: rowsPerPageOption.value ? rowsPerPageOption.value : rowsPerPageOption
            }), rowsPerPageOption.label ? rowsPerPageOption.label : rowsPerPageOption);
          })
        })), /*#__PURE__*/jsxRuntime$1.jsx(TablePaginationDisplayedRows, {
          className: classes.displayedRows,
          children: labelDisplayedRows({
            from: count === 0 ? 0 : page * rowsPerPage + 1,
            to: getLabelDisplayedRowsTo(),
            count: count === -1 ? -1 : count,
            page: page
          })
        }), /*#__PURE__*/jsxRuntime$1.jsx(ActionsComponent, {
          className: classes.actions,
          backIconButtonProps: backIconButtonProps,
          count: count,
          nextIconButtonProps: nextIconButtonProps,
          onPageChange: onPageChange,
          page: page,
          rowsPerPage: rowsPerPage,
          showFirstButton: showFirstButton,
          showLastButton: showLastButton,
          getItemAriaLabel: getItemAriaLabel
        })]
      })
    }));
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var K$1 = TablePagination;

  function getTableRowUtilityClass(slot) {
    return generateUtilityClass('MuiTableRow', slot);
  }

  var tableRowClasses = generateUtilityClasses('MuiTableRow', ['root', 'selected', 'hover', 'head', 'footer']);
  var tableRowClasses$1 = tableRowClasses;
  var _excluded$i = ["className", "component", "hover", "selected"];

  var useUtilityClasses$7 = function useUtilityClasses$7(ownerState) {
    var classes = ownerState.classes,
        selected = ownerState.selected,
        hover = ownerState.hover,
        head = ownerState.head,
        footer = ownerState.footer;
    var slots = {
      root: ['root', selected && 'selected', hover && 'hover', head && 'head', footer && 'footer']
    };
    return composeClasses(slots, getTableRowUtilityClass, classes);
  };

  var TableRowRoot = styled$1('tr', {
    name: 'MuiTableRow',
    slot: 'Root',
    overridesResolver: function overridesResolver(props, styles) {
      var ownerState = props.ownerState;
      return [styles.root, ownerState.head && styles.head, ownerState.footer && styles.footer];
    }
  })(function (_ref234) {
    var _ref235;

    var theme = _ref234.theme;
    return _ref235 = {
      color: 'inherit',
      display: 'table-row',
      verticalAlign: 'middle',
      // We disable the focus ring for mouse, touch and keyboard users.
      outline: 0
    }, _defineProperty(_ref235, "&.".concat(tableRowClasses$1.hover, ":hover"), {
      backgroundColor: theme.palette.action.hover
    }), _defineProperty(_ref235, "&.".concat(tableRowClasses$1.selected), {
      backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity),
      '&:hover': {
        backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
      }
    }), _ref235;
  });
  var defaultComponent = 'tr';
  /**
   * Will automatically set dynamic row height
   * based on the material table element parent (head, body, etc).
   */

  var TableRow$1 = /*#__PURE__*/React__namespace.forwardRef(function TableRow(inProps, ref) {
    var props = useThemeProps({
      props: inProps,
      name: 'MuiTableRow'
    });

    var className = props.className,
        _props$component29 = props.component,
        component = _props$component29 === void 0 ? defaultComponent : _props$component29,
        _props$hover = props.hover,
        hover = _props$hover === void 0 ? false : _props$hover,
        _props$selected = props.selected,
        selected = _props$selected === void 0 ? false : _props$selected,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$i);

    var tablelvl2 = React__namespace.useContext(Tablelvl2Context$1);

    var ownerState = _extends$c({}, props, {
      component: component,
      hover: hover,
      selected: selected,
      head: tablelvl2 && tablelvl2.variant === 'head',
      footer: tablelvl2 && tablelvl2.variant === 'footer'
    });

    var classes = useUtilityClasses$7(ownerState);
    return /*#__PURE__*/jsxRuntime$1.jsx(TableRowRoot, _extends$c({
      as: component,
      ref: ref,
      className: clsx(classes.root, className),
      role: component === defaultComponent ? null : 'row',
      ownerState: ownerState
    }, other));
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var BaseTableRow = TableRow$1;

  function getTextFieldUtilityClass(slot) {
    return generateUtilityClass('MuiTextField', slot);
  }

  generateUtilityClasses('MuiTextField', ['root']);
  var _excluded$h = ["autoComplete", "autoFocus", "children", "className", "color", "defaultValue", "disabled", "error", "FormHelperTextProps", "fullWidth", "helperText", "id", "InputLabelProps", "inputProps", "InputProps", "inputRef", "label", "maxRows", "minRows", "multiline", "name", "onBlur", "onChange", "onFocus", "placeholder", "required", "rows", "select", "SelectProps", "type", "value", "variant"];
  var variantComponent = {
    standard: Input$1,
    filled: FilledInput$1,
    outlined: OutlinedInput$1
  };

  var useUtilityClasses$6 = function useUtilityClasses$6(ownerState) {
    var classes = ownerState.classes;
    var slots = {
      root: ['root']
    };
    return composeClasses(slots, getTextFieldUtilityClass, classes);
  };

  var TextFieldRoot = styled$1(BaseFormControl, {
    name: 'MuiTextField',
    slot: 'Root',
    overridesResolver: function overridesResolver(props, styles) {
      return styles.root;
    }
  })({});
  /**
   * The `TextField` is a convenience wrapper for the most common cases (80%).
   * It cannot be all things to all people, otherwise the API would grow out of control.
   *
   * ## Advanced Configuration
   *
   * It's important to understand that the text field is a simple abstraction
   * on top of the following components:
   *
   * - [FormControl](/api/form-control/)
   * - [InputLabel](/api/input-label/)
   * - [FilledInput](/api/filled-input/)
   * - [OutlinedInput](/api/outlined-input/)
   * - [Input](/api/input/)
   * - [FormHelperText](/api/form-helper-text/)
   *
   * If you wish to alter the props applied to the `input` element, you can do so as follows:
   *
   * ```jsx
   * const inputProps = {
   *   step: 300,
   * };
   *
   * return <TextField id="time" type="time" inputProps={inputProps} />;
   * ```
   *
   * For advanced cases, please look at the source of TextField by clicking on the
   * "Edit this page" button above. Consider either:
   *
   * - using the upper case props for passing values directly to the components
   * - using the underlying components directly as shown in the demos
   */

  var TextField$2 = /*#__PURE__*/React__namespace.forwardRef(function TextField(inProps, ref) {
    var props = useThemeProps({
      props: inProps,
      name: 'MuiTextField'
    });

    var autoComplete = props.autoComplete,
        _props$autoFocus4 = props.autoFocus,
        autoFocus = _props$autoFocus4 === void 0 ? false : _props$autoFocus4,
        children = props.children,
        className = props.className,
        _props$color15 = props.color,
        color = _props$color15 === void 0 ? 'primary' : _props$color15,
        defaultValue = props.defaultValue,
        _props$disabled9 = props.disabled,
        disabled = _props$disabled9 === void 0 ? false : _props$disabled9,
        _props$error4 = props.error,
        error = _props$error4 === void 0 ? false : _props$error4,
        FormHelperTextProps = props.FormHelperTextProps,
        _props$fullWidth10 = props.fullWidth,
        fullWidth = _props$fullWidth10 === void 0 ? false : _props$fullWidth10,
        helperText = props.helperText,
        idOverride = props.id,
        InputLabelProps = props.InputLabelProps,
        inputProps = props.inputProps,
        InputProps = props.InputProps,
        inputRef = props.inputRef,
        label = props.label,
        maxRows = props.maxRows,
        minRows = props.minRows,
        _props$multiline5 = props.multiline,
        multiline = _props$multiline5 === void 0 ? false : _props$multiline5,
        name = props.name,
        onBlur = props.onBlur,
        onChange = props.onChange,
        onFocus = props.onFocus,
        placeholder = props.placeholder,
        _props$required2 = props.required,
        required = _props$required2 === void 0 ? false : _props$required2,
        rows = props.rows,
        _props$select = props.select,
        select = _props$select === void 0 ? false : _props$select,
        SelectProps = props.SelectProps,
        type = props.type,
        value = props.value,
        _props$variant19 = props.variant,
        variant = _props$variant19 === void 0 ? 'outlined' : _props$variant19,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$h);

    var ownerState = _extends$c({}, props, {
      autoFocus: autoFocus,
      color: color,
      disabled: disabled,
      error: error,
      fullWidth: fullWidth,
      multiline: multiline,
      required: required,
      select: select,
      variant: variant
    });

    var classes = useUtilityClasses$6(ownerState);

    if (process.env.NODE_ENV !== 'production') {
      if (select && !children) {
        console.error('MUI: `children` must be passed when using the `TextField` component with `select`.');
      }
    }

    var InputMore = {};

    if (variant === 'outlined') {
      if (InputLabelProps && typeof InputLabelProps.shrink !== 'undefined') {
        InputMore.notched = InputLabelProps.shrink;
      }

      if (label) {
        var _InputLabelProps$requ;

        var displayRequired = (_InputLabelProps$requ = InputLabelProps == null ? void 0 : InputLabelProps.required) != null ? _InputLabelProps$requ : required;
        InputMore.label = /*#__PURE__*/jsxRuntime$1.jsxs(React__namespace.Fragment, {
          children: [label, displayRequired && "\xA0*"]
        });
      }
    }

    if (select) {
      // unset defaults from textbox inputs
      if (!SelectProps || !SelectProps.native) {
        InputMore.id = undefined;
      }

      InputMore['aria-describedby'] = undefined;
    }

    var id = useId(idOverride);
    var helperTextId = helperText && id ? "".concat(id, "-helper-text") : undefined;
    var inputLabelId = label && id ? "".concat(id, "-label") : undefined;
    var InputComponent = variantComponent[variant];
    var InputElement = /*#__PURE__*/jsxRuntime$1.jsx(InputComponent, _extends$c({
      "aria-describedby": helperTextId,
      autoComplete: autoComplete,
      autoFocus: autoFocus,
      defaultValue: defaultValue,
      fullWidth: fullWidth,
      multiline: multiline,
      name: name,
      rows: rows,
      maxRows: maxRows,
      minRows: minRows,
      type: type,
      value: value,
      id: id,
      inputRef: inputRef,
      onBlur: onBlur,
      onChange: onChange,
      onFocus: onFocus,
      placeholder: placeholder,
      inputProps: inputProps
    }, InputMore, InputProps));
    return /*#__PURE__*/jsxRuntime$1.jsxs(TextFieldRoot, _extends$c({
      className: clsx(classes.root, className),
      disabled: disabled,
      error: error,
      fullWidth: fullWidth,
      ref: ref,
      required: required,
      color: color,
      variant: variant,
      ownerState: ownerState
    }, other, {
      children: [label && /*#__PURE__*/jsxRuntime$1.jsx(BaseInputLabel, _extends$c({
        htmlFor: id,
        id: inputLabelId
      }, InputLabelProps, {
        children: label
      })), select ? /*#__PURE__*/jsxRuntime$1.jsx(D$1, _extends$c({
        "aria-describedby": helperTextId,
        id: id,
        labelId: inputLabelId,
        value: value,
        input: InputElement
      }, SelectProps, {
        children: children
      })) : InputElement, helperText && /*#__PURE__*/jsxRuntime$1.jsx(BaseFormHelperText, _extends$c({
        id: helperTextId
      }, FormHelperTextProps, {
        children: helperText
      }))]
    }));
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var BaseTextField = TextField$2;
  var _excluded$g = ["getTrigger", "target"];

  function defaultTrigger(store, options) {
    var _options$disableHyste = options.disableHysteresis,
        disableHysteresis = _options$disableHyste === void 0 ? false : _options$disableHyste,
        _options$threshold = options.threshold,
        threshold = _options$threshold === void 0 ? 100 : _options$threshold,
        target = options.target;
    var previous = store.current;

    if (target) {
      // Get vertical scroll
      store.current = target.pageYOffset !== undefined ? target.pageYOffset : target.scrollTop;
    }

    if (!disableHysteresis && previous !== undefined) {
      if (store.current < previous) {
        return false;
      }
    }

    return store.current > threshold;
  }

  var defaultTarget = typeof window !== 'undefined' ? window : null;

  function useScrollTrigger$1() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var _options$getTrigger = options.getTrigger,
        getTrigger = _options$getTrigger === void 0 ? defaultTrigger : _options$getTrigger,
        _options$target = options.target,
        target = _options$target === void 0 ? defaultTarget : _options$target,
        other = _objectWithoutPropertiesLoose$6(options, _excluded$g);

    var store = React__namespace.useRef();

    var _React__namespace$use81 = React__namespace.useState(function () {
      return getTrigger(store, other);
    }),
        _React__namespace$use82 = _slicedToArray(_React__namespace$use81, 2),
        trigger = _React__namespace$use82[0],
        setTrigger = _React__namespace$use82[1];

    React__namespace.useEffect(function () {
      var handleScroll = function handleScroll() {
        setTrigger(getTrigger(store, _extends$c({
          target: target
        }, other)));
      };

      handleScroll(); // Re-evaluate trigger when dependencies change

      target.addEventListener('scroll', handleScroll);
      return function () {
        target.removeEventListener('scroll', handleScroll);
      }; // See Option 3. https://github.com/facebook/react/issues/14476#issuecomment-471199055
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [target, getTrigger, JSON.stringify(other)]);
    return trigger;
  } // Cache implementation based on Erik Rasmussen's `lru-memoize`:
  // https://github.com/erikras/lru-memoize


  var NOT_FOUND = 'NOT_FOUND';

  function createSingletonCache(equals) {
    var entry;
    return {
      get: function get(key) {
        if (entry && equals(entry.key, key)) {
          return entry.value;
        }

        return NOT_FOUND;
      },
      put: function put(key, value) {
        entry = {
          key: key,
          value: value
        };
      },
      getEntries: function getEntries() {
        return entry ? [entry] : [];
      },
      clear: function clear() {
        entry = undefined;
      }
    };
  }

  function createLruCache(maxSize, equals) {
    var entries = [];

    function get(key) {
      var cacheIndex = entries.findIndex(function (entry) {
        return equals(key, entry.key);
      }); // We found a cached entry

      if (cacheIndex > -1) {
        var entry = entries[cacheIndex]; // Cached entry not at top of cache, move it to the top

        if (cacheIndex > 0) {
          entries.splice(cacheIndex, 1);
          entries.unshift(entry);
        }

        return entry.value;
      } // No entry found in cache, return sentinel


      return NOT_FOUND;
    }

    function put(key, value) {
      if (get(key) === NOT_FOUND) {
        // TODO Is unshift slow?
        entries.unshift({
          key: key,
          value: value
        });

        if (entries.length > maxSize) {
          entries.pop();
        }
      }
    }

    function getEntries() {
      return entries;
    }

    function clear() {
      entries = [];
    }

    return {
      get: get,
      put: put,
      getEntries: getEntries,
      clear: clear
    };
  }

  var defaultEqualityCheck = function defaultEqualityCheck(a, b) {
    return a === b;
  };

  function createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
      if (prev === null || next === null || prev.length !== next.length) {
        return false;
      } // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.


      var length = prev.length;

      for (var i = 0; i < length; i++) {
        if (!equalityCheck(prev[i], next[i])) {
          return false;
        }
      }

      return true;
    };
  } // defaultMemoize now supports a configurable cache size with LRU behavior,
  // and optional comparison of the result value with existing values


  function defaultMemoize(func, equalityCheckOrOptions) {
    var providedOptions = typeof equalityCheckOrOptions === 'object' ? equalityCheckOrOptions : {
      equalityCheck: equalityCheckOrOptions
    };
    var _providedOptions$equa = providedOptions.equalityCheck,
        equalityCheck = _providedOptions$equa === void 0 ? defaultEqualityCheck : _providedOptions$equa,
        _providedOptions$maxS = providedOptions.maxSize,
        maxSize = _providedOptions$maxS === void 0 ? 1 : _providedOptions$maxS,
        resultEqualityCheck = providedOptions.resultEqualityCheck;
    var comparator = createCacheKeyComparator(equalityCheck);
    var cache = maxSize === 1 ? createSingletonCache(comparator) : createLruCache(maxSize, comparator); // we reference arguments instead of spreading them for performance reasons

    function memoized() {
      var value = cache.get(arguments);

      if (value === NOT_FOUND) {
        // @ts-ignore
        value = func.apply(null, arguments);

        if (resultEqualityCheck) {
          var entries = cache.getEntries();
          var matchingEntry = entries.find(function (entry) {
            return resultEqualityCheck(entry.value, value);
          });

          if (matchingEntry) {
            value = matchingEntry.value;
          }
        }

        cache.put(arguments, value);
      }

      return value;
    }

    memoized.clearCache = function () {
      return cache.clear();
    };

    return memoized;
  }

  function getDependencies(funcs) {
    var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

    if (!dependencies.every(function (dep) {
      return typeof dep === 'function';
    })) {
      var dependencyTypes = dependencies.map(function (dep) {
        return typeof dep === 'function' ? "function " + (dep.name || 'unnamed') + "()" : typeof dep;
      }).join(', ');
      throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + dependencyTypes + "]");
    }

    return dependencies;
  }

  function createSelectorCreator(memoize) {
    for (var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      memoizeOptionsFromArgs[_key - 1] = arguments[_key];
    }

    var createSelector = function createSelector() {
      for (var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        funcs[_key2] = arguments[_key2];
      }

      var _recomputations = 0;

      var _lastResult; // Due to the intricacies of rest params, we can't do an optional arg after `...funcs`.
      // So, start by declaring the default value here.
      // (And yes, the words 'memoize' and 'options' appear too many times in this next sequence.)


      var directlyPassedOptions = {
        memoizeOptions: undefined
      }; // Normally, the result func or "output selector" is the last arg

      var resultFunc = funcs.pop(); // If the result func is actually an _object_, assume it's our options object

      if (typeof resultFunc === 'object') {
        directlyPassedOptions = resultFunc; // and pop the real result func off

        resultFunc = funcs.pop();
      }

      if (typeof resultFunc !== 'function') {
        throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof resultFunc + "]");
      } // Determine which set of options we're using. Prefer options passed directly,
      // but fall back to options given to createSelectorCreator.


      var _directlyPassedOption = directlyPassedOptions,
          _directlyPassedOption2 = _directlyPassedOption.memoizeOptions,
          memoizeOptions = _directlyPassedOption2 === void 0 ? memoizeOptionsFromArgs : _directlyPassedOption2; // Simplifying assumption: it's unlikely that the first options arg of the provided memoizer
      // is an array. In most libs I've looked at, it's an equality function or options object.
      // Based on that, if `memoizeOptions` _is_ an array, we assume it's a full
      // user-provided array of options. Otherwise, it must be just the _first_ arg, and so
      // we wrap it in an array so we can apply it.

      var finalMemoizeOptions = Array.isArray(memoizeOptions) ? memoizeOptions : [memoizeOptions];
      var dependencies = getDependencies(funcs);
      var memoizedResultFunc = memoize.apply(void 0, [function () {
        _recomputations++; // apply arguments instead of spreading for performance.

        return resultFunc.apply(null, arguments);
      }].concat(finalMemoizeOptions)); // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.

      var selector = memoize(function () {
        var params = [];
        var length = dependencies.length;

        for (var i = 0; i < length; i++) {
          // apply arguments instead of spreading and mutate a local list of params for performance.
          // @ts-ignore
          params.push(dependencies[i].apply(null, arguments));
        } // apply arguments instead of spreading for performance.


        _lastResult = memoizedResultFunc.apply(null, params);
        return _lastResult;
      });
      Object.assign(selector, {
        resultFunc: resultFunc,
        memoizedResultFunc: memoizedResultFunc,
        dependencies: dependencies,
        lastResult: function lastResult() {
          return _lastResult;
        },
        recomputations: function recomputations() {
          return _recomputations;
        },
        resetRecomputations: function resetRecomputations() {
          return _recomputations = 0;
        }
      });
      return selector;
    }; // @ts-ignore


    return createSelector;
  }

  var createSelector = /* #__PURE__ */createSelectorCreator(defaultMemoize);
  var arSD = {
    components: {
      MuiBreadcrumbs: {
        defaultProps: {
          expandText: 'إظهر العنوان'
        }
      },
      MuiTablePagination: {
        defaultProps: {
          getItemAriaLabel: function getItemAriaLabel(type) {
            if (type === 'first') {
              return 'إذهب الى الصفحة الأولى';
            }

            if (type === 'last') {
              return 'إذهب الي الصفحة الأخيرة';
            }

            if (type === 'next') {
              return 'إذهب الى الصفحة التالية';
            } // if (type === 'previous') {


            return 'إذهب الى الصفحة السابقة';
          },
          labelRowsPerPage: 'عدد الصفوف في الصفحة:',
          labelDisplayedRows: function labelDisplayedRows(_ref236) {
            var from = _ref236.from,
                to = _ref236.to,
                count = _ref236.count;
            return "".concat(from, "\u2013").concat(to, " \u0645\u0646 ").concat(count !== -1 ? count : " \u0623\u0643\u062B\u0631 \u0645\u0646".concat(to));
          }
        }
      },
      MuiRating: {
        defaultProps: {
          getLabelText: function getLabelText(value) {
            return "".concat(value, " ").concat(value !== 1 ? 'نجوم' : 'نجمة');
          },
          emptyLabelText: 'فارغ'
        }
      },
      MuiAutocomplete: {
        defaultProps: {
          clearText: 'مسح',
          closeText: 'إغلاق',
          loadingText: 'يتم التحميل…',
          noOptionsText: 'لا يوجد خيارات',
          openText: 'فتح'
        }
      },
      MuiAlert: {
        defaultProps: {
          closeText: 'إغلاق'
        }
      },
      MuiPagination: {
        defaultProps: {
          'aria-label': 'التنقل عبر الصفحات',
          getItemAriaLabel: function getItemAriaLabel(type, page, selected) {
            if (type === 'page') {
              return "".concat(selected ? '' : 'إذهب إلى ', " \u0635\u0641\u062D\u0629 ").concat(page);
            }

            if (type === 'first') {
              return 'إذهب الى الصفحة الأولى';
            }

            if (type === 'last') {
              return 'إذهب الي الصفحة الأخيرة';
            }

            if (type === 'next') {
              return 'إذهب الى الصفحة التالية';
            } // if (type === 'previous') {


            return 'إذهب الى الصفحة السابقة';
          }
        }
      }
    }
  };
  var bgBG = {
    components: {
      MuiBreadcrumbs: {
        defaultProps: {
          expandText: 'Показване на пътя'
        }
      },
      MuiTablePagination: {
        defaultProps: {
          getItemAriaLabel: function getItemAriaLabel(type) {
            if (type === 'first') {
              return 'Отиди на първата страница';
            }

            if (type === 'last') {
              return 'Отиди на последната страница';
            }

            if (type === 'next') {
              return 'Отиди на следващата страница';
            } // if (type === 'previous') {


            return 'Отиди на предишната страница';
          },
          labelRowsPerPage: 'Редове на страница:' // labelDisplayedRows: ({ from, to, count }) =>
          //   `${from}–${to} от ${count !== -1 ? count : `more than ${to}`}`,

        }
      },
      MuiRating: {
        defaultProps: {
          getLabelText: function getLabelText(value) {
            return "".concat(value, " \u0417\u0432\u0435\u0437\u0434").concat(value !== 1 ? 'и' : 'а');
          },
          emptyLabelText: 'Изчисти'
        }
      },
      MuiAutocomplete: {
        defaultProps: {
          clearText: 'Изчисти',
          closeText: 'Затвори',
          loadingText: 'Зареждане…',
          noOptionsText: 'Няма налични опции',
          openText: 'Отвори'
        }
      },
      MuiAlert: {
        defaultProps: {
          closeText: 'Затвори'
        }
      },
      MuiPagination: {
        defaultProps: {
          'aria-label': 'Пагинация',
          getItemAriaLabel: function getItemAriaLabel(type, page, selected) {
            if (type === 'page') {
              return "".concat(selected ? '' : 'Към ', "\u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430 ").concat(page);
            }

            if (type === 'first') {
              return 'Отиди на първата страница';
            }

            if (type === 'last') {
              return 'Отиди на последната страница';
            }

            if (type === 'next') {
              return 'Отиди на следващата страница';
            } // if (type === 'previous') {


            return 'Отиди на предишната страница';
          }
        }
      }
    }
  };
  var csCZ = {
    components: {
      MuiBreadcrumbs: {
        defaultProps: {
          expandText: 'Ukázat cestu'
        }
      },
      MuiTablePagination: {
        defaultProps: {
          getItemAriaLabel: function getItemAriaLabel(type) {
            if (type === 'first') {
              return 'Jít na první stránku';
            }

            if (type === 'last') {
              return 'Jít na poslední stránku';
            }

            if (type === 'next') {
              return 'Jít na další stránku';
            } // if (type === 'previous') {


            return 'Jít na předchozí stránku';
          },
          labelRowsPerPage: 'Řádků na stránce:',
          labelDisplayedRows: function labelDisplayedRows(_ref237) {
            var from = _ref237.from,
                to = _ref237.to,
                count = _ref237.count;
            return "".concat(from, "\u2013").concat(to, " z ").concat(count !== -1 ? count : "v\xEDce ne\u017E ".concat(to));
          }
        }
      },
      MuiRating: {
        defaultProps: {
          getLabelText: function getLabelText(value) {
            if (value === 1) {
              return "".concat(value, " hv\u011Bzdi\u010Dka");
            }

            if (value >= 2 && value <= 4) {
              return "".concat(value, " hv\u011Bzdi\u010Dky");
            }

            return "".concat(value, " hv\u011Bzdi\u010Dek");
          },
          emptyLabelText: 'Prázdné'
        }
      },
      MuiAutocomplete: {
        defaultProps: {
          clearText: 'Vymazat',
          closeText: 'Zavřít',
          loadingText: 'Načítání…',
          noOptionsText: 'Žádné možnosti',
          openText: 'Otevřít'
        }
      },
      MuiAlert: {
        defaultProps: {
          closeText: 'Zavřít'
        }
      },
      MuiPagination: {
        defaultProps: {
          'aria-label': 'Navigace stránkováním',
          getItemAriaLabel: function getItemAriaLabel(type, page, selected) {
            if (type === 'page') {
              return "".concat(selected ? '' : 'Jít na ').concat(page, " str\xE1nku");
            }

            if (type === 'first') {
              return 'Jít na první stránku';
            }

            if (type === 'last') {
              return 'Jít na poslední stránku';
            }

            if (type === 'next') {
              return 'Jít na další stránku';
            } // if (type === 'previous') {


            return 'Jít na předchozí stránku';
          }
        }
      }
    }
  };
  var deDE = {
    components: {
      MuiBreadcrumbs: {
        defaultProps: {
          expandText: 'Pfad anzeigen'
        }
      },
      MuiTablePagination: {
        defaultProps: {
          getItemAriaLabel: function getItemAriaLabel(type) {
            if (type === 'first') {
              return 'Zur ersten Seite';
            }

            if (type === 'last') {
              return 'Zur letzten Seite';
            }

            if (type === 'next') {
              return 'Zur nächsten Seite';
            } // if (type === 'previous') {


            return 'Zur vorherigen Seite';
          },
          labelRowsPerPage: 'Zeilen pro Seite:',
          labelDisplayedRows: function labelDisplayedRows(_ref238) {
            var from = _ref238.from,
                to = _ref238.to,
                count = _ref238.count;
            return "".concat(from, "\u2013").concat(to, " von ").concat(count !== -1 ? count : "mehr als ".concat(to));
          }
        }
      },
      MuiRating: {
        defaultProps: {
          getLabelText: function getLabelText(value) {
            return "".concat(value, " ").concat(value !== 1 ? 'Sterne' : 'Stern');
          },
          emptyLabelText: 'Keine Wertung'
        }
      },
      MuiAutocomplete: {
        defaultProps: {
          clearText: 'Leeren',
          closeText: 'Schließen',
          loadingText: 'Wird geladen…',
          noOptionsText: 'Keine Optionen',
          openText: 'Öffnen'
        }
      },
      MuiAlert: {
        defaultProps: {
          closeText: 'Schließen'
        }
      },
      MuiPagination: {
        defaultProps: {
          'aria-label': 'Navigation via Seitennummerierung',
          getItemAriaLabel: function getItemAriaLabel(type, page, selected) {
            if (type === 'page') {
              return "".concat(selected ? '' : 'Gehe zu ', "Seite ").concat(page);
            }

            if (type === 'first') {
              return 'Zur ersten Seite';
            }

            if (type === 'last') {
              return 'Zur letzten Seite';
            }

            if (type === 'next') {
              return 'Zur nächsten Seite';
            } // if (type === 'previous') {


            return 'Zur vorherigen Seite';
          }
        }
      }
    }
  };
  var enUS = {
    /*
    components: {
      MuiBreadcrumbs: { defaultProps: {
        expandText: 'Show path',
      }},
      MuiTablePagination: { defaultProps: { 
        getItemAriaLabel: (type) => {
          if (type === 'first') {
            return 'Go to first page';
          }
          if (type === 'last') {
            return 'Go to last page';
          }
          if (type === 'next') {
            return 'Go to next page';
          }
          // if (type === 'previous') {
          return 'Go to previous page';
        },
        labelRowsPerPage: 'Rows per page:',
        labelDisplayedRows: ({ from, to, count }) =>
    `${from}–${to} of ${count !== -1 ? count : `more than ${to}`}`,
      }},
      MuiRating: { defaultProps: { 
        getLabelText: value => `${value} Star${value !== 1 ? 's' : ''}`,
        emptyLabelText: 'Empty',
      }},
      MuiAutocomplete: { defaultProps: { 
        clearText: 'Clear',
        closeText: 'Close',
        loadingText: 'Loading…',
        noOptionsText: 'No options',
        openText: 'Open',
      }},
      MuiAlert: { defaultProps: { 
        closeText: 'Close',
      }},
      MuiPagination: {  defaultProps: { 
        'aria-label': 'Pagination navigation',
        getItemAriaLabel: (type, page, selected) => {
          if (type === 'page') {
            return `${selected ? '' : 'Go to '}page ${page}`;
          }
          if (type === 'first') {
            return 'Go to first page';
          }
          if (type === 'last') {
            return 'Go to last page';
          }
          if (type === 'next') {
            return 'Go to next page';
          }
          // if (type === 'previous') {
          return 'Go to previous page';
        },
      },
    },
    */
  };
  var esES = {
    components: {
      MuiBreadcrumbs: {
        defaultProps: {
          expandText: 'Mostrar ruta'
        }
      },
      MuiTablePagination: {
        defaultProps: {
          getItemAriaLabel: function getItemAriaLabel(type) {
            if (type === 'first') {
              return 'Ir a la primera página';
            }

            if (type === 'last') {
              return 'Ir a la última página';
            }

            if (type === 'next') {
              return 'Ir a la página siguiente';
            } // if (type === 'previous') {


            return 'Ir a la página anterior';
          },
          labelRowsPerPage: 'Filas por página:',
          labelDisplayedRows: function labelDisplayedRows(_ref239) {
            var from = _ref239.from,
                to = _ref239.to,
                count = _ref239.count;
            return "".concat(from, "\u2013").concat(to, " de ").concat(count !== -1 ? count : "m\xE1s de ".concat(to));
          }
        }
      },
      MuiRating: {
        defaultProps: {
          getLabelText: function getLabelText(value) {
            return "".concat(value, " Estrella").concat(value !== 1 ? 's' : '');
          },
          emptyLabelText: 'Vacío'
        }
      },
      MuiAutocomplete: {
        defaultProps: {
          clearText: 'Limpiar',
          closeText: 'Cerrar',
          loadingText: 'Cargando…',
          noOptionsText: 'Sin opciones',
          openText: 'Abierto'
        }
      },
      MuiAlert: {
        defaultProps: {
          closeText: 'Cerrar'
        }
      },
      MuiPagination: {
        defaultProps: {
          'aria-label': 'Paginador',
          getItemAriaLabel: function getItemAriaLabel(type, page, selected) {
            if (type === 'page') {
              return "".concat(selected ? '' : 'Ir a la ', "p\xE1gina ").concat(page);
            }

            if (type === 'first') {
              return 'Ir a la primera página';
            }

            if (type === 'last') {
              return 'Ir a la última página';
            }

            if (type === 'next') {
              return 'Ir a la página siguiente';
            } // if (type === 'previous') {


            return 'Ir a la página anterior';
          }
        }
      }
    }
  };
  var faIR = {
    components: {
      // MuiBreadcrumbs: {
      //   defaultProps: {
      //     expandText: 'Show path',
      //   },
      // },
      MuiBreadcrumbs: {
        defaultProps: {
          expandText: 'نمایش مسیر'
        }
      },
      MuiTablePagination: {
        defaultProps: {
          getItemAriaLabel: function getItemAriaLabel(type) {
            if (type === 'first') {
              return 'رفتن به اولین صفحه';
            }

            if (type === 'last') {
              return 'رفتن به آخرین صفحه';
            }

            if (type === 'next') {
              return 'رفتن به صفحه‌ی بعدی';
            } // if (type === 'previous') {


            return 'رفتن به صفحه‌ی قبلی';
          },
          labelRowsPerPage: 'تعداد سطرهای هر صفحه:' // labelDisplayedRows: ({ from, to, count }) =>
          //   `${from}–${to} از ${count !== -1 ? count : `more than ${to}`}`,

        }
      },
      MuiRating: {
        defaultProps: {
          getLabelText: function getLabelText(value) {
            return "".concat(value, " \u0633\u062A\u0627\u0631\u0647");
          },
          emptyLabelText: 'خالی'
        }
      },
      MuiAutocomplete: {
        defaultProps: {
          clearText: 'پاک‌کردن',
          closeText: 'بستن',
          loadingText: 'در حال بارگذاری…',
          noOptionsText: 'بی‌نتیجه',
          openText: 'بازکردن'
        }
      },
      MuiAlert: {
        defaultProps: {
          closeText: 'بستن'
        }
      },
      MuiPagination: {
        defaultProps: {
          'aria-label': 'ناوبری صفحه',
          getItemAriaLabel: function getItemAriaLabel(type, page, selected) {
            if (type === 'page') {
              return "".concat(selected ? '' : 'رفتن به ', "\u0635\u0641\u062D\u0647\u0654 ").concat(page);
            }

            if (type === 'first') {
              return 'رفتن به اولین صفحه';
            }

            if (type === 'last') {
              return 'رفتن به آخرین صفحه';
            }

            if (type === 'next') {
              return 'رفتن به صفحه‌ی بعدی';
            } // if (type === 'previous') {


            return 'رفتن به صفحه‌ی قبلی';
          }
        }
      }
    }
  };
  var frFR = {
    components: {
      MuiBreadcrumbs: {
        defaultProps: {
          expandText: 'Montrer le chemin'
        }
      },
      MuiTablePagination: {
        defaultProps: {
          getItemAriaLabel: function getItemAriaLabel(type) {
            if (type === 'first') {
              return 'Aller à la première page';
            }

            if (type === 'last') {
              return 'Aller à la dernière page';
            }

            if (type === 'next') {
              return 'Aller à la page suivante';
            } // if (type === 'previous') {


            return 'Aller à la page précédente';
          },
          labelRowsPerPage: 'Lignes par page :',
          labelDisplayedRows: function labelDisplayedRows(_ref240) {
            var from = _ref240.from,
                to = _ref240.to,
                count = _ref240.count;
            return "".concat(from, "\u2013").concat(to, " sur ").concat(count !== -1 ? count : "plus que ".concat(to));
          }
        }
      },
      MuiRating: {
        defaultProps: {
          getLabelText: function getLabelText(value) {
            return "".concat(value, " Etoile").concat(value !== 1 ? 's' : '');
          },
          emptyLabelText: 'Vide'
        }
      },
      MuiAutocomplete: {
        defaultProps: {
          clearText: 'Vider',
          closeText: 'Fermer',
          loadingText: 'Chargement…',
          noOptionsText: 'Pas de résultats',
          openText: 'Ouvrir'
        }
      },
      MuiAlert: {
        defaultProps: {
          closeText: 'Fermer'
        }
      },
      MuiPagination: {
        defaultProps: {
          'aria-label': 'navigation de pagination',
          getItemAriaLabel: function getItemAriaLabel(type, page, selected) {
            if (type === 'page') {
              return "".concat(selected ? '' : 'Aller à la ', "page ").concat(page);
            }

            if (type === 'first') {
              return 'Aller à la première page';
            }

            if (type === 'last') {
              return 'Aller à la dernière page';
            }

            if (type === 'next') {
              return 'Aller à la page suivante';
            } // if (type === 'previous') {


            return 'Aller à la page précédente';
          }
        }
      }
    }
  };
  var heIL = {
    components: {
      MuiBreadcrumbs: {
        defaultProps: {
          expandText: 'הצג נתיב'
        }
      },
      MuiTablePagination: {
        defaultProps: {
          getItemAriaLabel: function getItemAriaLabel(type) {
            if (type === 'first') {
              return 'לעמוד הראשון';
            }

            if (type === 'last') {
              return 'לעמוד האחרון';
            }

            if (type === 'next') {
              return 'לעמוד הבא';
            } // if (type === 'previous') {


            return 'לעמוד הקודם';
          },
          labelRowsPerPage: 'שורות בעמוד:',
          labelDisplayedRows: function labelDisplayedRows(_ref241) {
            var from = _ref241.from,
                to = _ref241.to,
                count = _ref241.count;
            return "".concat(from, "\u2013").concat(to, " \u05DE\u05EA\u05D5\u05DA ").concat(count !== -1 ? count : "\u05D9\u05D5\u05EA\u05E8 \u05DE ".concat(to));
          }
        }
      },
      MuiRating: {
        defaultProps: {
          getLabelText: function getLabelText(value) {
            return "".concat(value, " \u05DB\u05D5\u05DB\u05D1").concat(value !== 1 ? 'ים' : '');
          },
          emptyLabelText: 'ריק'
        }
      },
      MuiAutocomplete: {
        defaultProps: {
          clearText: 'נקה',
          closeText: 'סגור',
          loadingText: 'טוען…',
          noOptionsText: 'אין אופציות',
          openText: 'פתח'
        }
      },
      MuiAlert: {
        defaultProps: {
          closeText: 'סגור'
        }
      },
      MuiPagination: {
        defaultProps: {
          'aria-label': 'ניווט בעמודים',
          getItemAriaLabel: function getItemAriaLabel(type, page, selected) {
            if (type === 'page') {
              return "".concat(selected ? '' : 'ל ', "\u05E2\u05DE\u05D5\u05D3 ").concat(page);
            }

            if (type === 'first') {
              return 'לעמוד הראשון';
            }

            if (type === 'last') {
              return 'לעמוד האחרון';
            }

            if (type === 'next') {
              return 'לעמוד הבא';
            } // if (type === 'previous') {


            return 'לעמוד הקודם';
          }
        }
      }
    }
  };
  var itIT = {
    components: {
      MuiBreadcrumbs: {
        defaultProps: {
          expandText: 'Visualizza percorso'
        }
      },
      MuiTablePagination: {
        defaultProps: {
          getItemAriaLabel: function getItemAriaLabel(type) {
            if (type === 'first') {
              return 'Vai alla prima pagina';
            }

            if (type === 'last') {
              return "Vai all'ultima pagina";
            }

            if (type === 'next') {
              return 'Vai alla pagina successiva';
            } // if (type === 'previous') {


            return 'Vai alla pagina precedente';
          },
          labelRowsPerPage: 'Righe per pagina:' // labelDisplayedRows: ({ from, to, count }) =>
          //   `${from}–${to} di ${count !== -1 ? count : `more than ${to}`}`,

        }
      },
      MuiRating: {
        defaultProps: {
          getLabelText: function getLabelText(value) {
            return "".concat(value, " Stell").concat(value !== 1 ? 'e' : 'a');
          },
          emptyLabelText: 'Vuoto'
        }
      },
      MuiAutocomplete: {
        defaultProps: {
          clearText: 'Svuota',
          closeText: 'Chiudi',
          loadingText: 'Caricamento in corso…',
          noOptionsText: 'Nessuna opzione',
          openText: 'Apri'
        }
      },
      MuiAlert: {
        defaultProps: {
          closeText: 'Chiudi'
        }
      },
      MuiPagination: {
        defaultProps: {
          'aria-label': 'Navigazione impaginata',
          getItemAriaLabel: function getItemAriaLabel(type, page, selected) {
            if (type === 'page') {
              return "".concat(selected ? '' : 'Vai alla ', "pagina ").concat(page);
            }

            if (type === 'first') {
              return 'Vai alla prima pagina';
            }

            if (type === 'last') {
              return "Vai all'ultima pagina";
            }

            if (type === 'next') {
              return 'Vai alla pagina successiva';
            } // if (type === 'previous') {


            return 'Vai alla pagina precedente';
          }
        }
      }
    }
  };
  var jaJP = {
    components: {
      MuiBreadcrumbs: {
        defaultProps: {
          expandText: 'すべて表示'
        }
      },
      MuiTablePagination: {
        defaultProps: {
          getItemAriaLabel: function getItemAriaLabel(type) {
            if (type === 'first') {
              return '最初のページへ';
            }

            if (type === 'last') {
              return '最後のページへ';
            }

            if (type === 'next') {
              return '次のページへ';
            } // if (type === 'previous') {


            return '前のページへ';
          },
          labelRowsPerPage: 'ページあたりの行数:',
          labelDisplayedRows: function labelDisplayedRows(_ref242) {
            var from = _ref242.from,
                to = _ref242.to,
                count = _ref242.count;
            return "".concat(from, "\uFF5E").concat(to, " / ").concat(count !== -1 ? count : "".concat(to, "\u4EE5\u4E0A"));
          }
        }
      },
      MuiRating: {
        defaultProps: {
          getLabelText: function getLabelText(value) {
            return "\u661F".concat(value);
          },
          emptyLabelText: '星なし'
        }
      },
      MuiAutocomplete: {
        defaultProps: {
          clearText: 'クリア',
          closeText: '閉じる',
          loadingText: '読み込み中…',
          noOptionsText: 'データがありません',
          openText: '開く'
        }
      },
      MuiAlert: {
        defaultProps: {
          closeText: '閉じる'
        }
      },
      MuiPagination: {
        defaultProps: {
          'aria-label': 'ページ選択',
          getItemAriaLabel: function getItemAriaLabel(type, page, selected) {
            if (type === 'page') {
              return "\u30DA\u30FC\u30B8".concat(page).concat(selected ? '' : 'へ');
            }

            if (type === 'first') {
              return '最初のページへ';
            }

            if (type === 'last') {
              return '最後のページへ';
            }

            if (type === 'next') {
              return '次のページへ';
            } // if (type === 'previous') {


            return '前のページへ';
          }
        }
      }
    }
  };
  var koKR = {
    components: {
      MuiBreadcrumbs: {
        defaultProps: {
          expandText: '경로 보기'
        }
      },
      MuiTablePagination: {
        defaultProps: {
          getItemAriaLabel: function getItemAriaLabel(type) {
            if (type === 'first') {
              return '첫 번째 페이지로 이동';
            }

            if (type === 'last') {
              return '마지막 페이지로 이동';
            }

            if (type === 'next') {
              return '다음 페이지로 이동';
            } // if (type === 'previous') {


            return '이전 페이지로 이동';
          },
          labelRowsPerPage: '페이지 당 행:',
          labelDisplayedRows: function labelDisplayedRows(_ref243) {
            var from = _ref243.from,
                to = _ref243.to,
                count = _ref243.count;
            return "".concat(from, "\u2013").concat(to, " / ").concat(count !== -1 ? count : "".concat(to, "\uAC1C \uC774\uC0C1"));
          }
        }
      },
      MuiRating: {
        defaultProps: {
          getLabelText: function getLabelText(value) {
            return "".concat(value, " \uC810");
          },
          emptyLabelText: '빈 텍스트'
        }
      },
      MuiAutocomplete: {
        defaultProps: {
          clearText: '지우기',
          closeText: '닫기',
          loadingText: '불러오는 중…',
          noOptionsText: '옵션 없음',
          openText: '열기'
        }
      },
      MuiAlert: {
        defaultProps: {
          closeText: '닫기'
        }
      },
      MuiPagination: {
        defaultProps: {
          'aria-label': '페이지네이션 네비게이션',
          getItemAriaLabel: function getItemAriaLabel(type, page, selected) {
            if (type === 'page') {
              return "".concat(page, " \uBC88\uC9F8 \uD398\uC774\uC9C0").concat(selected ? '' : '로 이동');
            }

            if (type === 'first') {
              return '첫 번째 페이지로 이동';
            }

            if (type === 'last') {
              return '마지막 페이지로 이동';
            }

            if (type === 'next') {
              return '다음 페이지로 이동';
            } // if (type === 'previous') {


            return '이전 페이지로 이동';
          }
        }
      }
    }
  };
  var nlNL = {
    components: {
      MuiBreadcrumbs: {
        defaultProps: {
          expandText: 'Pad tonen'
        }
      },
      MuiTablePagination: {
        defaultProps: {
          getItemAriaLabel: function getItemAriaLabel(type) {
            if (type === 'first') {
              return 'Ga naar eerste pagina';
            }

            if (type === 'last') {
              return 'Ga naar laatste pagina';
            }

            if (type === 'next') {
              return 'Ga naar volgende pagina';
            } // if (type === 'previous') {


            return 'Ga naar vorige pagina';
          },
          labelRowsPerPage: 'Regels per pagina:',
          labelDisplayedRows: function labelDisplayedRows(_ref244) {
            var from = _ref244.from,
                to = _ref244.to,
                count = _ref244.count;
            return "".concat(from, "\u2013").concat(to, " van ").concat(count !== -1 ? count : "meer dan ".concat(to));
          }
        }
      },
      MuiRating: {
        defaultProps: {
          getLabelText: function getLabelText(value) {
            return "".concat(value, " Ster").concat(value !== 1 ? 'ren' : '');
          },
          emptyLabelText: 'Leeg'
        }
      },
      MuiAutocomplete: {
        defaultProps: {
          clearText: 'Wissen',
          closeText: 'Sluiten',
          loadingText: 'Laden…',
          noOptionsText: 'Geen opties',
          openText: 'Openen'
        }
      },
      MuiAlert: {
        defaultProps: {
          closeText: 'Sluiten'
        }
      },
      MuiPagination: {
        defaultProps: {
          'aria-label': 'Navigatie via paginering',
          getItemAriaLabel: function getItemAriaLabel(type, page, selected) {
            if (type === 'page') {
              return "".concat(selected ? '' : 'Ga naar ', "pagina ").concat(page);
            }

            if (type === 'first') {
              return 'Ga naar eerste pagina';
            }

            if (type === 'last') {
              return 'Ga naar laatste pagina';
            }

            if (type === 'next') {
              return 'Ga naar volgende pagina';
            } // if (type === 'previous') {


            return 'Ga naar vorige pagina';
          }
        }
      }
    }
  };
  var plPL = {
    components: {
      MuiBreadcrumbs: {
        defaultProps: {
          expandText: 'Pokaż ścieżkę'
        }
      },
      MuiTablePagination: {
        defaultProps: {
          getItemAriaLabel: function getItemAriaLabel(type) {
            if (type === 'first') {
              return 'Przejdź do pierwszej strony';
            }

            if (type === 'last') {
              return 'Przejdź do ostatniej strony';
            }

            if (type === 'next') {
              return 'Przejdź do następnej strony';
            } // if (type === 'previous') {


            return 'Przejdź do poprzedniej strony';
          },
          labelRowsPerPage: 'Wierszy na stronę:' // labelDisplayedRows: ({ from, to, count }) =>
          //   `${from}–${to} z ${count !== -1 ? count : `more than ${to}`}`,

        }
      },
      MuiRating: {
        defaultProps: {
          getLabelText: function getLabelText(value) {
            var pluralForm = 'gwiazdek';
            var lastDigit = value % 10;

            if ((value < 10 || value > 20) && lastDigit > 1 && lastDigit < 5) {
              pluralForm = 'gwiazdki';
            } else if (value === 1) {
              pluralForm = 'gwiazdka';
            }

            return "".concat(value, " ").concat(pluralForm);
          },
          emptyLabelText: 'Brak gwiazdek'
        }
      },
      MuiAutocomplete: {
        defaultProps: {
          clearText: 'Wyczyść',
          closeText: 'Zamknij',
          loadingText: 'Ładowanie…',
          noOptionsText: 'Brak opcji',
          openText: 'Otwórz'
        }
      },
      MuiAlert: {
        defaultProps: {
          closeText: 'Zamknij'
        }
      },
      MuiPagination: {
        defaultProps: {
          'aria-label': 'Nawigacja podziału na strony',
          getItemAriaLabel: function getItemAriaLabel(type, page, selected) {
            if (type === 'page') {
              return selected ? "".concat(page, ". strona") : "Przejd\u017A do ".concat(page, ". strony");
            }

            if (type === 'first') {
              return 'Przejdź do pierwszej strony';
            }

            if (type === 'last') {
              return 'Przejdź do ostatniej strony';
            }

            if (type === 'next') {
              return 'Przejdź do następnej strony';
            } // if (type === 'previous') {


            return 'Przejdź do poprzedniej strony';
          }
        }
      }
    }
  };
  var ptBR = {
    components: {
      MuiBreadcrumbs: {
        defaultProps: {
          expandText: 'Mostrar caminho'
        }
      },
      MuiTablePagination: {
        defaultProps: {
          getItemAriaLabel: function getItemAriaLabel(type) {
            if (type === 'first') {
              return 'Ir para a primeira página';
            }

            if (type === 'last') {
              return 'Ir para a última página';
            }

            if (type === 'next') {
              return 'Ir para a próxima página';
            } // if (type === 'previous') {


            return 'Ir para a página anterior';
          },
          labelRowsPerPage: 'Linhas por página:',
          labelDisplayedRows: function labelDisplayedRows(_ref245) {
            var from = _ref245.from,
                to = _ref245.to,
                count = _ref245.count;
            return "".concat(from, "\u2013").concat(to, " de ").concat(count !== -1 ? count : "mais de ".concat(to));
          }
        }
      },
      MuiRating: {
        defaultProps: {
          getLabelText: function getLabelText(value) {
            return "".concat(value, " Estrela").concat(value !== 1 ? 's' : '');
          },
          emptyLabelText: 'Vazio'
        }
      },
      MuiAutocomplete: {
        defaultProps: {
          clearText: 'Limpar',
          closeText: 'Fechar',
          loadingText: 'Carregando…',
          noOptionsText: 'Sem opções',
          openText: 'Abrir'
        }
      },
      MuiAlert: {
        defaultProps: {
          closeText: 'Fechar'
        }
      },
      MuiPagination: {
        defaultProps: {
          'aria-label': 'Navegar pela paginação',
          getItemAriaLabel: function getItemAriaLabel(type, page, selected) {
            if (type === 'page') {
              return "".concat(selected ? '' : 'Ir para a ', "p\xE1gina ").concat(page);
            }

            if (type === 'first') {
              return 'Ir para a primeira página';
            }

            if (type === 'last') {
              return 'Ir para a última página';
            }

            if (type === 'next') {
              return 'Ir para a próxima página';
            } // if (type === 'previous') {


            return 'Ir para a página anterior';
          }
        }
      }
    }
  };
  var ruRU = {
    components: {
      MuiBreadcrumbs: {
        defaultProps: {
          expandText: 'Показать полный путь'
        }
      },
      MuiTablePagination: {
        defaultProps: {
          getItemAriaLabel: function getItemAriaLabel(type) {
            if (type === 'first') {
              return 'Перейти на первую страницу';
            }

            if (type === 'last') {
              return 'Перейти на последнюю страницу';
            }

            if (type === 'next') {
              return 'Перейти на следующую страницу';
            } // if (type === 'previous') {


            return 'Перейти на предыдущую страницу';
          },
          labelRowsPerPage: 'Строк на странице:',
          labelDisplayedRows: function labelDisplayedRows(_ref246) {
            var from = _ref246.from,
                to = _ref246.to,
                count = _ref246.count;
            return "".concat(from, "\u2013").concat(to, " \u0438\u0437 ").concat(count !== -1 ? count : "\u0431\u043E\u043B\u0435\u0435 \u0447\u0435\u043C ".concat(to));
          }
        }
      },
      MuiRating: {
        defaultProps: {
          getLabelText: function getLabelText(value) {
            var pluralForm = 'Звёзд';
            var lastDigit = value % 10;

            if (lastDigit > 1 && lastDigit < 5) {
              pluralForm = 'Звезды';
            } else if (lastDigit === 1) {
              pluralForm = 'Звезда';
            }

            return "".concat(value, " ").concat(pluralForm);
          },
          emptyLabelText: 'Рейтинг отсутствует'
        }
      },
      MuiAutocomplete: {
        defaultProps: {
          clearText: 'Очистить',
          closeText: 'Закрыть',
          loadingText: 'Загрузка…',
          noOptionsText: 'Нет доступных вариантов',
          openText: 'Открыть'
        }
      },
      MuiAlert: {
        defaultProps: {
          closeText: 'Закрыть'
        }
      },
      MuiPagination: {
        defaultProps: {
          'aria-label': 'Навигация по страницам',
          getItemAriaLabel: function getItemAriaLabel(type, page, selected) {
            if (type === 'page') {
              if (selected) {
                return "".concat(page, " \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430");
              }

              return "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043D\u0430 ".concat(page, " \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443");
            }

            if (type === 'first') {
              return 'Перейти на первую страницу';
            }

            if (type === 'last') {
              return 'Перейти на последнюю страницу';
            }

            if (type === 'next') {
              return 'Перейти на следующую страницу';
            } // if (type === 'previous') {


            return 'Перейти на предыдущую страницу';
          }
        }
      }
    }
  };
  var skSK = {
    components: {
      MuiBreadcrumbs: {
        defaultProps: {
          expandText: 'Ukázať cestu '
        }
      },
      MuiTablePagination: {
        defaultProps: {
          getItemAriaLabel: function getItemAriaLabel(type) {
            if (type === 'first') {
              return 'Ísť na prvú stránku';
            }

            if (type === 'last') {
              return 'Ísť na poslednú stránku';
            }

            if (type === 'next') {
              return 'Ísť na ďaľšiu stránku';
            } // if (type === 'previous') {


            return 'Ísť na predchádzajúcu stránku';
          },
          labelRowsPerPage: 'Riadkov na stránke:',
          labelDisplayedRows: function labelDisplayedRows(_ref247) {
            var from = _ref247.from,
                to = _ref247.to,
                count = _ref247.count;
            return "".concat(from, "\u2013").concat(to, " z ").concat(count !== -1 ? count : "viac ako ".concat(to));
          }
        }
      },
      MuiRating: {
        defaultProps: {
          getLabelText: function getLabelText(value) {
            if (value === 1) {
              return "".concat(value, " hviezdi\u010Dka");
            }

            if (value >= 2 && value <= 4) {
              return "".concat(value, " hviezdi\u010Dky");
            }

            return "".concat(value, " hviezdi\u010Diek");
          },
          emptyLabelText: 'Prázdne'
        }
      },
      MuiAutocomplete: {
        defaultProps: {
          clearText: 'Vymazať',
          closeText: 'Zavrieť',
          loadingText: 'Načítanie…',
          noOptionsText: 'Žiadne možnosti',
          openText: 'Otvoriť'
        }
      },
      MuiAlert: {
        defaultProps: {
          closeText: 'Zavrieť'
        }
      },
      MuiPagination: {
        defaultProps: {
          'aria-label': 'Navigácia stránkovanim',
          getItemAriaLabel: function getItemAriaLabel(type, page, selected) {
            if (type === 'page') {
              return "".concat(selected ? '' : 'Ísť na ', "str\xE1nku ").concat(page);
            }

            if (type === 'first') {
              return 'Ísť na prvú stránku';
            }

            if (type === 'last') {
              return 'Ísť na poslednú stránku';
            }

            if (type === 'next') {
              return 'Ísť na ďaľšiu stránku';
            } // if (type === 'previous') {


            return 'Ísť na predchádzajúcu stránku';
          }
        }
      }
    }
  };
  var trTR = {
    components: {
      MuiBreadcrumbs: {
        defaultProps: {
          expandText: 'Yolu göster'
        }
      },
      MuiTablePagination: {
        defaultProps: {
          getItemAriaLabel: function getItemAriaLabel(type) {
            if (type === 'first') {
              return 'İlk sayfaya git';
            }

            if (type === 'last') {
              return 'Son sayfaya git';
            }

            if (type === 'next') {
              return 'Sonraki sayfaya git';
            } // if (type === 'previous') {


            return 'Önceki sayfaya git';
          },
          labelRowsPerPage: 'Sayfa başına satır:' // labelDisplayedRows: ({ from, to, count }) =>
          //   `${from}–${to} tanesinden ${count !== -1 ? count : `more than ${to}`}`,

        }
      },
      MuiRating: {
        defaultProps: {
          getLabelText: function getLabelText(value) {
            return "".concat(value, " Y\u0131ld\u0131z");
          },
          emptyLabelText: 'Boş'
        }
      },
      MuiAutocomplete: {
        defaultProps: {
          clearText: 'Temizle',
          closeText: 'Kapat',
          loadingText: 'Yükleniyor…',
          noOptionsText: 'Seçenek yok',
          openText: 'Aç'
        }
      },
      MuiAlert: {
        defaultProps: {
          closeText: 'Kapat'
        }
      },
      MuiPagination: {
        defaultProps: {
          'aria-label': 'Sayfa navigasyonu',
          getItemAriaLabel: function getItemAriaLabel(type, page, selected) {
            if (type === 'page') {
              return "".concat(page, ". ").concat(selected ? 'sayfa' : 'sayfaya git');
            }

            if (type === 'first') {
              return 'İlk sayfaya git';
            }

            if (type === 'last') {
              return 'Son sayfaya git';
            }

            if (type === 'next') {
              return 'Sonraki sayfaya git';
            } // if (type === 'previous') {


            return 'Önceki sayfaya git';
          }
        }
      }
    }
  };
  var ukUA = {
    components: {
      MuiBreadcrumbs: {
        defaultProps: {
          expandText: 'Показати шлях сторінок'
        }
      },
      MuiTablePagination: {
        defaultProps: {
          getItemAriaLabel: function getItemAriaLabel(type) {
            if (type === 'first') {
              return 'Перейти на першу сторінку';
            }

            if (type === 'last') {
              return 'Перейти на останню сторінку';
            }

            if (type === 'next') {
              return 'Перейти на наступну сторінку';
            } // if (type === 'previous') {


            return 'Перейти на попередню сторінку';
          },
          labelRowsPerPage: 'Рядків на сторінці:',
          labelDisplayedRows: function labelDisplayedRows(_ref248) {
            var from = _ref248.from,
                to = _ref248.to,
                count = _ref248.count;
            return "".concat(from, "\u2013").concat(to, " \u0437 ").concat(count !== -1 ? count : "\u043F\u043E\u043D\u0430\u0434 ".concat(to));
          }
        }
      },
      MuiRating: {
        defaultProps: {
          getLabelText: function getLabelText(value) {
            var pluralForm = 'Зірок';
            var lastDigit = value % 10;

            if (lastDigit > 1 && lastDigit < 5) {
              pluralForm = 'Зірки';
            } else if (lastDigit === 1) {
              pluralForm = 'Зірка';
            }

            return "".concat(value, " ").concat(pluralForm);
          },
          emptyLabelText: 'Рейтинг відсутній'
        }
      },
      MuiAutocomplete: {
        defaultProps: {
          clearText: 'Очистити',
          closeText: 'Згорнути',
          loadingText: 'Завантаження…',
          noOptionsText: 'Немає варіантів',
          openText: 'Розгорнути'
        }
      },
      MuiAlert: {
        defaultProps: {
          closeText: 'Згорнути'
        }
      },
      MuiPagination: {
        defaultProps: {
          'aria-label': 'Навігація сторінками',
          getItemAriaLabel: function getItemAriaLabel(type, page, selected) {
            if (type === 'page') {
              return "".concat(selected ? '' : 'Перейти на ', "\u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443 ").concat(page);
            }

            if (type === 'first') {
              return 'Перейти на першу сторінку';
            }

            if (type === 'last') {
              return 'Перейти на останню сторінку';
            }

            if (type === 'next') {
              return 'Перейти на наступну сторінку';
            } // if (type === 'previous') {


            return 'Перейти на попередню сторінку';
          }
        }
      }
    }
  };
  var viVN = {
    components: {
      // MuiBreadcrumbs: {
      //   defaultProps: {
      //     expandText: 'Show path',
      //   },
      // },
      MuiTablePagination: {
        defaultProps: {
          // getItemAriaLabel: (type) => {
          //   if (type === 'first') {
          //     return 'Go to first page';
          //   }
          //   if (type === 'last') {
          //     return 'Go to last page';
          //   }
          //   if (type === 'next') {
          //     return 'Go to next page';
          //   }
          //   // if (type === 'previous') {
          //   return 'Go to previous page';
          // },
          labelRowsPerPage: 'Số hàng mỗi trang:',
          labelDisplayedRows: function labelDisplayedRows(_ref249) {
            var from = _ref249.from,
                to = _ref249.to,
                count = _ref249.count;
            return "".concat(from, "\u2013").concat(to, " trong ").concat(count !== -1 ? count : "nhi\u1EC1u h\u01A1n ".concat(to));
          }
        }
      },
      MuiRating: {
        defaultProps: {
          getLabelText: function getLabelText(value) {
            return "".concat(value, " sao");
          },
          emptyLabelText: 'Trống'
        }
      },
      MuiAutocomplete: {
        defaultProps: {
          clearText: 'Xóa',
          closeText: 'Đóng',
          loadingText: 'Đang tải…',
          noOptionsText: 'Không có lựa chọn',
          openText: 'Mở'
        }
      },
      MuiAlert: {
        defaultProps: {
          closeText: 'Đóng'
        }
      } // MuiPagination: {
      //   defaultProps: {
      //     'aria-label': 'Pagination navigation',
      //     getItemAriaLabel: (type, page, selected) => {
      //       if (type === 'page') {
      //         return `${selected ? '' : 'Go to '}page ${page}`;
      //       }
      //       if (type === 'first') {
      //         return 'Go to first page';
      //       }
      //       if (type === 'last') {
      //         return 'Go to last page';
      //       }
      //       if (type === 'next') {
      //         return 'Go to next page';
      //       }
      //       // if (type === 'previous') {
      //       return 'Go to previous page';
      //     },
      //   },
      // },

    }
  };
  var zhCN = {
    components: {
      MuiBreadcrumbs: {
        defaultProps: {
          expandText: '展开'
        }
      },
      MuiTablePagination: {
        defaultProps: {
          getItemAriaLabel: function getItemAriaLabel(type) {
            if (type === 'first') {
              return '第一页';
            }

            if (type === 'last') {
              return '最后一页';
            }

            if (type === 'next') {
              return '下一页';
            }

            return '上一页';
          },
          labelRowsPerPage: '每页行数:',
          labelDisplayedRows: function labelDisplayedRows(_ref250) {
            var from = _ref250.from,
                to = _ref250.to,
                count = _ref250.count;
            return "\u7B2C ".concat(from, " \u6761\u5230\u7B2C ").concat(to, " \u6761\uFF0C").concat(count !== -1 ? "\u5171 ".concat(count, " \u6761") : "\u81F3\u5C11 ".concat(to, " \u6761"));
          }
        }
      },
      MuiRating: {
        defaultProps: {
          getLabelText: function getLabelText(value) {
            return "".concat(value, " \u9897\u661F");
          },
          emptyLabelText: '无标签'
        }
      },
      MuiAutocomplete: {
        defaultProps: {
          clearText: '清空',
          closeText: '关闭',
          loadingText: '加载中……',
          noOptionsText: '没有可用选项',
          openText: '打开'
        }
      },
      MuiAlert: {
        defaultProps: {
          closeText: '关闭'
        }
      }
    }
  };
  var ge;
  !function (e) {
    e.resize = "resize", e.debouncedResize = "debouncedResize", e.viewportInnerSizeChange = "viewportInnerSizeChange", e.componentError = "componentError", e.unmount = "unmount", e.cellModeChange = "cellModeChange", e.cellClick = "cellClick", e.cellDoubleClick = "cellDoubleClick", e.cellMouseDown = "cellMouseDown", e.cellMouseUp = "cellMouseUp", e.cellKeyDown = "cellKeyDown", e.cellFocusIn = "cellFocusIn", e.cellFocusOut = "cellFocusOut", e.cellDragEnter = "cellDragEnter", e.cellDragOver = "cellDragOver", e.editCellPropsChange = "editCellPropsChange", e.cellEditCommit = "cellEditCommit", e.cellEditStart = "cellEditStart", e.cellEditStop = "cellEditStop", e.rowEditStart = "rowEditStart", e.rowEditStop = "rowEditStop", e.rowEditCommit = "rowEditCommit", e.cellNavigationKeyDown = "cellNavigationKeyDown", e.rowClick = "rowClick", e.rowDoubleClick = "rowDoubleClick", e.editRowsModelChange = "editRowsModelChange", e.columnHeaderBlur = "columnHeaderBlur", e.columnHeaderFocus = "columnHeaderFocus", e.columnHeaderNavigationKeyDown = "columnHeaderNavigationKeyDown", e.columnHeaderKeyDown = "columnHeaderKeyDown", e.columnHeaderClick = "columnHeaderClick", e.columnHeaderDoubleClick = "columnHeaderDoubleClick", e.columnHeaderOver = "columnHeaderOver", e.columnHeaderOut = "columnHeaderOut", e.columnHeaderEnter = "columnHeaderEnter", e.columnHeaderLeave = "columnHeaderLeave", e.columnHeaderDragStart = "columnHeaderDragStart", e.columnHeaderDragOver = "columnHeaderDragOver", e.columnHeaderDragEnter = "columnHeaderDragEnter", e.columnHeaderDragEnd = "columnHeaderDragEnd", e.selectionChange = "selectionChange", e.headerSelectionCheckboxChange = "headerSelectionCheckboxChange", e.rowSelectionCheckboxChange = "rowSelectionCheckboxChange", e.pageChange = "pageChange", e.pageSizeChange = "pageSizeChange", e.rowsScroll = "rowsScroll", e.rowsScrollEnd = "rowsScrollEnd", e.columnSeparatorMouseDown = "columnSeparatorMouseDown", e.columnResize = "columnResize", e.columnWidthChange = "columnWidthChange", e.columnResizeStart = "columnResizeStart", e.columnResizeStop = "columnResizeStop", e.columnOrderChange = "columnOrderChange", e.rowsSet = "rowsSet", e.rowExpansionChange = "rowExpansionChange", e.visibleRowsSet = "visibleRowsSet", e.columnsChange = "columnsChange", e.preProcessorRegister = "preProcessorRegister", e.preProcessorUnregister = "preProcessorUnregister", e.rowGroupsPreProcessingChange = "rowGroupsPreProcessingChange", e.sortModelChange = "sortModelChange", e.filterModelChange = "filterModelChange", e.stateChange = "stateChange", e.columnVisibilityChange = "columnVisibilityChange";
  }(ge || (ge = {}));
  var he = React__namespace.createContext(void 0);

  function Ce() {
    var t = React__namespace.useContext(he);
    if (void 0 === t) throw new Error(["MUI: Could not find the data grid context.", "It looks like you rendered your component outside of a DataGrid or DataGridPro parent component.", "This can also happen if you are bundling multiple versions of the data grid."].join("\n"));
    return t;
  }

  function ve(e) {
    return generateUtilityClass("MuiDataGrid", e);
  }

  "production" !== process.env.NODE_ENV && (he.displayName = "GridApiContext");
  var we = generateUtilityClasses("MuiDataGrid", ["actionsCell", "autoHeight", "booleanCell", "cell--editable", "cell--editing", "cell--textCenter", "cell--textLeft", "cell--textRight", "cell--withRenderer", "cell", "cellCheckbox", "checkboxInput", "columnHeader--alignCenter", "columnHeader--alignLeft", "columnHeader--alignRight", "columnHeader--dragging", "columnHeader--moving", "columnHeader--numeric", "columnHeader--sortable", "columnHeader--sorted", "columnHeader", "columnHeaderCheckbox", "columnHeaderDraggableContainer", "columnHeaderDropZone", "columnHeaderTitle", "columnHeaderTitleContainer", "columnHeaders", "columnHeadersInner", "columnHeadersInner--scrollable", "columnSeparator--resizable", "columnSeparator--resizing", "columnSeparator", "columnsPanel", "columnsPanelRow", "panel", "panelHeader", "panelWrapper", "panelContent", "panelFooter", "paper", "editBooleanCell", "editInputCell", "filterForm", "filterIcon", "footerContainer", "iconButtonContainer", "iconSeparator", "main", "menu", "menuIcon", "menuIconButton", "menuOpen", "menuList", "overlay", "root", "row--editable", "row--editing", "row", "rowCount", "scrollArea--left", "scrollArea--right", "scrollArea", "selectedRowCount", "sortIcon", "toolbarContainer", "toolbarFilterList", "virtualScroller", "virtualScrollerContent", "virtualScrollerRenderZone", "withBorder", "treeDataGroupingCell", "treeDataGroupingCellToggle"]),
      Oe = React__namespace.createContext(void 0);
  "production" !== process.env.NODE_ENV && (Oe.displayName = "GridRootPropsContext");

  var ye = function ye() {
    var t = React__namespace.useContext(Oe);
    if (!t) throw new Error("MUI: useGridRootProps should only be used inside the DataGrid/DataGridPro component.");
    return t;
  },
      Ee = styled$1("div", {
    name: "MuiDataGrid",
    slot: "Main",
    overridesResolver: function overridesResolver(e, t) {
      return t.main;
    }
  })(function () {
    return {
      position: "relative",
      flexGrow: 1,
      display: "flex",
      flexDirection: "column"
    };
  });

  function Se(t) {
    var r = function (e) {
      var t = e.classes;
      return composeClasses({
        root: ["main"]
      }, ve, t);
    }({
      classes: ye().classes
    });

    return React__namespace.createElement(Ee, {
      className: r.root
    }, t.children);
  }
  /*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
   Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
   THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** */


  function Re(e, t) {
    var r = {};

    for (var l in e) {
      Object.prototype.hasOwnProperty.call(e, l) && t.indexOf(l) < 0 && (r[l] = e[l]);
    }

    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
      var o = 0;

      for (l = Object.getOwnPropertySymbols(e); o < l.length; o++) {
        t.indexOf(l[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, l[o]) && (r[l[o]] = e[l[o]]);
      }
    }

    return r;
  }

  function Pe(e, t, r, l) {
    return new (r || (r = Promise))(function (o, n) {
      function a(e) {
        try {
          s(l.next(e));
        } catch (e) {
          n(e);
        }
      }

      function i(e) {
        try {
          s(l.throw(e));
        } catch (e) {
          n(e);
        }
      }

      function s(e) {
        var t;
        e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function (e) {
          e(t);
        })).then(a, i);
      }

      s((l = l.apply(e, t || [])).next());
    });
  }

  function xe(e, t) {
    var r = function r(e) {
      var t = e.__resizeTriggers__,
          r = t.firstElementChild,
          l = t.lastElementChild,
          o = r.firstElementChild;
      l.scrollLeft = l.scrollWidth, l.scrollTop = l.scrollHeight, o.style.width = r.offsetWidth + 1 + "px", o.style.height = r.offsetHeight + 1 + "px", r.scrollLeft = r.scrollWidth, r.scrollTop = r.scrollHeight;
    },
        l = function l(e) {
      if (!(e.target.className.indexOf("contract-trigger") < 0 && e.target.className.indexOf("expand-trigger") < 0)) {
        var l = this;
        r(this), this.__resizeRAF__ && t.cancelAnimationFrame(this.__resizeRAF__), this.__resizeRAF__ = t.requestAnimationFrame(function () {
          (function (e) {
            return e.offsetWidth != e.__resizeLast__.width || e.offsetHeight != e.__resizeLast__.height;
          })(l) && (l.__resizeLast__.width = l.offsetWidth, l.__resizeLast__.height = l.offsetHeight, l.__resizeListeners__.forEach(function (t) {
            t.call(l, e);
          }));
        });
      }
    },
        o = !1,
        n = "",
        a = "animationstart",
        i = "Webkit Moz O ms".split(" "),
        s = "webkitAnimationStart animationstart oAnimationStart MSAnimationStart".split(" "),
        c = document.createElement("fakeelement");

    if (void 0 !== c.style.animationName && (o = !0), !1 === o) for (var u = 0; u < i.length; u++) {
      if (void 0 !== c.style[i[u] + "AnimationName"]) {
        n = "-" + i[u].toLowerCase() + "-", a = s[u], o = !0;
        break;
      }
    }
    var d = "resizeanim",
        p = "@" + n + "keyframes " + "resizeanim { from { opacity: 0; } to { opacity: 0; } } ",
        m = n + "animation: 1ms " + "resizeanim; ";
    return {
      addResizeListener: function addResizeListener(o, n) {
        if (!o.__resizeTriggers__) {
          var i = o.ownerDocument,
              s = t.getComputedStyle(o);
          s && "static" == s.position && (o.style.position = "relative"), function (t) {
            if (!t.getElementById("muiDetectElementResize")) {
              var r = (p || "") + ".Mui-resizeTriggers { " + (m || "") + 'visibility: hidden; opacity: 0; } .Mui-resizeTriggers, .Mui-resizeTriggers > div, .contract-trigger:before { content: " "; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; z-index: -1; } .Mui-resizeTriggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }',
                  l = t.head || t.getElementsByTagName("head")[0],
                  o = t.createElement("style");
              o.id = "muiDetectElementResize", o.type = "text/css", null != e && o.setAttribute("nonce", e), o.styleSheet ? o.styleSheet.cssText = r : o.appendChild(t.createTextNode(r)), l.appendChild(o);
            }
          }(i), o.__resizeLast__ = {}, o.__resizeListeners__ = [], (o.__resizeTriggers__ = i.createElement("div")).className = "Mui-resizeTriggers", o.__resizeTriggers__.innerHTML = '<div class="expand-trigger"><div></div></div><div class="contract-trigger"></div>', o.appendChild(o.__resizeTriggers__), r(o), o.addEventListener("scroll", l, !0), a && (o.__resizeTriggers__.__animationListener__ = function (e) {
            e.animationName == d && r(o);
          }, o.__resizeTriggers__.addEventListener(a, o.__resizeTriggers__.__animationListener__));
        }

        o.__resizeListeners__.push(n);
      },
      removeResizeListener: function removeResizeListener(e, t) {
        if (e.__resizeListeners__.splice(e.__resizeListeners__.indexOf(t), 1), !e.__resizeListeners__.length) {
          e.removeEventListener("scroll", l, !0), e.__resizeTriggers__.__animationListener__ && (e.__resizeTriggers__.removeEventListener(a, e.__resizeTriggers__.__animationListener__), e.__resizeTriggers__.__animationListener__ = null);

          try {
            e.__resizeTriggers__ = !e.removeChild(e.__resizeTriggers__);
          } catch (e) {}
        }
      }
    };
  }

  var ke = React__namespace.forwardRef(function (t, r) {
    var l = t.children,
        _t$defaultHeight = t.defaultHeight,
        o = _t$defaultHeight === void 0 ? null : _t$defaultHeight,
        _t$defaultWidth = t.defaultWidth,
        n = _t$defaultWidth === void 0 ? null : _t$defaultWidth,
        _t$disableHeight = t.disableHeight,
        a = _t$disableHeight === void 0 ? !1 : _t$disableHeight,
        _t$disableWidth = t.disableWidth,
        i = _t$disableWidth === void 0 ? !1 : _t$disableWidth,
        s = t.nonce,
        c = t.onResize,
        u = t.style,
        b = Re(t, ["children", "defaultHeight", "defaultWidth", "disableHeight", "disableWidth", "nonce", "onResize", "style"]),
        _React__namespace$use83 = React__namespace.useState({
      height: o,
      width: n
    }),
        _React__namespace$use84 = _slicedToArray(_React__namespace$use83, 2),
        g = _React__namespace$use84[0],
        h = _React__namespace$use84[1],
        C = React__namespace.useRef(null),
        v = React__namespace.useRef(null),
        w = useEventCallback(function () {
      if (v.current) {
        var _e2 = v.current.offsetHeight || 0,
            _t5 = v.current.offsetWidth || 0,
            _r2 = ownerWindow(v.current).getComputedStyle(v.current),
            _l2 = parseInt(_r2.paddingLeft, 10) || 0,
            _o2 = parseInt(_r2.paddingRight, 10) || 0,
            _n2 = _e2 - (parseInt(_r2.paddingTop, 10) || 0) - (parseInt(_r2.paddingBottom, 10) || 0),
            _s = _t5 - _l2 - _o2;

        (!a && g.height !== _n2 || !i && g.width !== _s) && (h({
          height: _n2,
          width: _s
        }), c && c({
          height: _n2,
          width: _s
        }));
      }
    });

    useEnhancedEffect$1(function () {
      var e;
      if (v.current = C.current.parentElement, !v) return;
      var t = ownerWindow(null !== (e = v.current) && void 0 !== e ? e : void 0),
          r = xe(s, t);
      return r.addResizeListener(v.current, w), w(), function () {
        r.removeResizeListener(v.current, w);
      };
    }, [s, w]);
    var O = {
      overflow: "visible"
    },
        y = {};
    a || (O.height = 0, y.height = g.height), i || (O.width = 0, y.width = g.width);
    var E = useForkRef(C, r);
    return React__namespace.createElement("div", Object.assign({
      ref: E,
      style: Object.assign(Object.assign({}, O), u)
    }, b), null === g.height && null === g.width ? null : l(y));
  });

  function Me(e, t) {
    return e === t || e != e && t != t;
  }

  function Le(e, t) {
    for (var r = e.length; r--;) {
      if (Me(e[r][0], t)) return r;
    }

    return -1;
  }

  var Fe = Array.prototype.splice;

  function De(e) {
    var t = -1,
        r = null == e ? 0 : e.length;

    for (this.clear(); ++t < r;) {
      var l = e[t];
      this.set(l[0], l[1]);
    }
  }

  De.prototype.clear = function () {
    this.__data__ = [], this.size = 0;
  }, De.prototype.delete = function (e) {
    var t = this.__data__,
        r = Le(t, e);
    return !(r < 0) && (r == t.length - 1 ? t.pop() : Fe.call(t, r, 1), --this.size, !0);
  }, De.prototype.get = function (e) {
    var t = this.__data__,
        r = Le(t, e);
    return r < 0 ? void 0 : t[r][1];
  }, De.prototype.has = function (e) {
    return Le(this.__data__, e) > -1;
  }, De.prototype.set = function (e, t) {
    var r = this.__data__,
        l = Le(r, e);
    return l < 0 ? (++this.size, r.push([e, t])) : r[l][1] = t, this;
  };
  var Ie = "object" == typeof global && global && global.Object === Object && global,
      je = "object" == typeof self && self && self.Object === Object && self,
      Te = Ie || je || Function("return this")(),
      He = Te.Symbol,
      Ae = Object.prototype,
      $e = Ae.hasOwnProperty,
      ze = Ae.toString,
      Ne = He ? He.toStringTag : void 0;
  var _e = Object.prototype.toString;
  var Ve = He ? He.toStringTag : void 0;

  function Be(e) {
    return null == e ? void 0 === e ? "[object Undefined]" : "[object Null]" : Ve && Ve in Object(e) ? function (e) {
      var t = $e.call(e, Ne),
          r = e[Ne];

      try {
        e[Ne] = void 0;
        var l = !0;
      } catch (e) {}

      var o = ze.call(e);
      return l && (t ? e[Ne] = r : delete e[Ne]), o;
    }(e) : function (e) {
      return _e.call(e);
    }(e);
  }

  function Ge(e) {
    var t = typeof e;
    return null != e && ("object" == t || "function" == t);
  }

  function We(e) {
    if (!Ge(e)) return !1;
    var t = Be(e);
    return "[object Function]" == t || "[object GeneratorFunction]" == t || "[object AsyncFunction]" == t || "[object Proxy]" == t;
  }

  var Ue,
      Ke = Te["__core-js_shared__"],
      qe = (Ue = /[^.]+$/.exec(Ke && Ke.keys && Ke.keys.IE_PROTO || "")) ? "Symbol(src)_1." + Ue : "";
  var Ze = Function.prototype.toString;

  function Ye(e) {
    if (null != e) {
      try {
        return Ze.call(e);
      } catch (e) {}

      try {
        return e + "";
      } catch (e) {}
    }

    return "";
  }

  var Xe = /^\[object .+?Constructor\]$/,
      Je = Function.prototype,
      Qe = Object.prototype,
      et = Je.toString,
      tt = Qe.hasOwnProperty,
      rt = RegExp("^" + et.call(tt).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");

  function lt(e) {
    return !(!Ge(e) || (t = e, qe && qe in t)) && (We(e) ? rt : Xe).test(Ye(e));
    var t;
  }

  function ot(e, t) {
    var r = function (e, t) {
      return null == e ? void 0 : e[t];
    }(e, t);

    return lt(r) ? r : void 0;
  }

  var nt = ot(Te, "Map"),
      at = ot(Object, "create");
  var it = Object.prototype.hasOwnProperty;
  var st = Object.prototype.hasOwnProperty;

  function ct(e) {
    var t = -1,
        r = null == e ? 0 : e.length;

    for (this.clear(); ++t < r;) {
      var l = e[t];
      this.set(l[0], l[1]);
    }
  }

  function ut(e, t) {
    var r,
        l,
        o = e.__data__;
    return ("string" == (l = typeof (r = t)) || "number" == l || "symbol" == l || "boolean" == l ? "__proto__" !== r : null === r) ? o["string" == typeof t ? "string" : "hash"] : o.map;
  }

  function dt(e) {
    var t = -1,
        r = null == e ? 0 : e.length;

    for (this.clear(); ++t < r;) {
      var l = e[t];
      this.set(l[0], l[1]);
    }
  }

  ct.prototype.clear = function () {
    this.__data__ = at ? at(null) : {}, this.size = 0;
  }, ct.prototype.delete = function (e) {
    var t = this.has(e) && delete this.__data__[e];
    return this.size -= t ? 1 : 0, t;
  }, ct.prototype.get = function (e) {
    var t = this.__data__;

    if (at) {
      var r = t[e];
      return "__lodash_hash_undefined__" === r ? void 0 : r;
    }

    return it.call(t, e) ? t[e] : void 0;
  }, ct.prototype.has = function (e) {
    var t = this.__data__;
    return at ? void 0 !== t[e] : st.call(t, e);
  }, ct.prototype.set = function (e, t) {
    var r = this.__data__;
    return this.size += this.has(e) ? 0 : 1, r[e] = at && void 0 === t ? "__lodash_hash_undefined__" : t, this;
  }, dt.prototype.clear = function () {
    this.size = 0, this.__data__ = {
      hash: new ct(),
      map: new (nt || De)(),
      string: new ct()
    };
  }, dt.prototype.delete = function (e) {
    var t = ut(this, e).delete(e);
    return this.size -= t ? 1 : 0, t;
  }, dt.prototype.get = function (e) {
    return ut(this, e).get(e);
  }, dt.prototype.has = function (e) {
    return ut(this, e).has(e);
  }, dt.prototype.set = function (e, t) {
    var r = ut(this, e),
        l = r.size;
    return r.set(e, t), this.size += r.size == l ? 0 : 1, this;
  };

  function pt(e) {
    var t = this.__data__ = new De(e);
    this.size = t.size;
  }

  pt.prototype.clear = function () {
    this.__data__ = new De(), this.size = 0;
  }, pt.prototype.delete = function (e) {
    var t = this.__data__,
        r = t.delete(e);
    return this.size = t.size, r;
  }, pt.prototype.get = function (e) {
    return this.__data__.get(e);
  }, pt.prototype.has = function (e) {
    return this.__data__.has(e);
  }, pt.prototype.set = function (e, t) {
    var r = this.__data__;

    if (r instanceof De) {
      var l = r.__data__;
      if (!nt || l.length < 199) return l.push([e, t]), this.size = ++r.size, this;
      r = this.__data__ = new dt(l);
    }

    return r.set(e, t), this.size = r.size, this;
  };

  function mt(e) {
    var t = -1,
        r = null == e ? 0 : e.length;

    for (this.__data__ = new dt(); ++t < r;) {
      this.add(e[t]);
    }
  }

  function ft(e, t) {
    for (var r = -1, l = null == e ? 0 : e.length; ++r < l;) {
      if (t(e[r], r, e)) return !0;
    }

    return !1;
  }

  mt.prototype.add = mt.prototype.push = function (e) {
    return this.__data__.set(e, "__lodash_hash_undefined__"), this;
  }, mt.prototype.has = function (e) {
    return this.__data__.has(e);
  };

  function bt(e, t, r, l, o, n) {
    var a = 1 & r,
        i = e.length,
        s = t.length;
    if (i != s && !(a && s > i)) return !1;
    var c = n.get(e);
    if (c && n.get(t)) return c == t;
    var u = -1,
        d = !0,
        p = 2 & r ? new mt() : void 0;

    for (n.set(e, t), n.set(t, e); ++u < i;) {
      var m = e[u],
          f = t[u];
      if (l) var b = a ? l(f, m, u, t, e, n) : l(m, f, u, e, t, n);

      if (void 0 !== b) {
        if (b) continue;
        d = !1;
        break;
      }

      if (p) {
        if (!ft(t, function (e, t) {
          if (a = t, !p.has(a) && (m === e || o(m, e, r, l, n))) return p.push(t);
          var a;
        })) {
          d = !1;
          break;
        }
      } else if (m !== f && !o(m, f, r, l, n)) {
        d = !1;
        break;
      }
    }

    return n.delete(e), n.delete(t), d;
  }

  var gt = Te.Uint8Array;

  function ht(e) {
    var t = -1,
        r = Array(e.size);
    return e.forEach(function (e, l) {
      r[++t] = [l, e];
    }), r;
  }

  function Ct(e) {
    var t = -1,
        r = Array(e.size);
    return e.forEach(function (e) {
      r[++t] = e;
    }), r;
  }

  var vt = He ? He.prototype : void 0,
      wt = vt ? vt.valueOf : void 0;
  var Ot = Array.isArray;
  var yt = Object.prototype.propertyIsEnumerable,
      Et = Object.getOwnPropertySymbols,
      St = Et ? function (e) {
    return null == e ? [] : (e = Object(e), function (e, t) {
      for (var r = -1, l = null == e ? 0 : e.length, o = 0, n = []; ++r < l;) {
        var a = e[r];
        t(a, r, e) && (n[o++] = a);
      }

      return n;
    }(Et(e), function (t) {
      return yt.call(e, t);
    }));
  } : function () {
    return [];
  };

  function Rt(e) {
    return null != e && "object" == typeof e;
  }

  function Pt(e) {
    return Rt(e) && "[object Arguments]" == Be(e);
  }

  var xt = Object.prototype,
      kt = xt.hasOwnProperty,
      Mt = xt.propertyIsEnumerable,
      Lt = Pt(function () {
    return arguments;
  }()) ? Pt : function (e) {
    return Rt(e) && kt.call(e, "callee") && !Mt.call(e, "callee");
  };

  var Ft = "object" == typeof exports && exports && !exports.nodeType && exports,
      Dt = Ft && "object" == typeof module && module && !module.nodeType && module,
      It = Dt && Dt.exports === Ft ? Te.Buffer : void 0,
      jt = (It ? It.isBuffer : void 0) || function () {
    return !1;
  },
      Tt = /^(?:0|[1-9]\d*)$/;

  function Ht(e, t) {
    var r = typeof e;
    return !!(t = null == t ? 9007199254740991 : t) && ("number" == r || "symbol" != r && Tt.test(e)) && e > -1 && e % 1 == 0 && e < t;
  }

  function At(e) {
    return "number" == typeof e && e > -1 && e % 1 == 0 && e <= 9007199254740991;
  }

  var $t = {};
  $t["[object Float32Array]"] = $t["[object Float64Array]"] = $t["[object Int8Array]"] = $t["[object Int16Array]"] = $t["[object Int32Array]"] = $t["[object Uint8Array]"] = $t["[object Uint8ClampedArray]"] = $t["[object Uint16Array]"] = $t["[object Uint32Array]"] = !0, $t["[object Arguments]"] = $t["[object Array]"] = $t["[object ArrayBuffer]"] = $t["[object Boolean]"] = $t["[object DataView]"] = $t["[object Date]"] = $t["[object Error]"] = $t["[object Function]"] = $t["[object Map]"] = $t["[object Number]"] = $t["[object Object]"] = $t["[object RegExp]"] = $t["[object Set]"] = $t["[object String]"] = $t["[object WeakMap]"] = !1;

  var zt,
      Nt = "object" == typeof exports && exports && !exports.nodeType && exports,
      _t = Nt && "object" == typeof module && module && !module.nodeType && module,
      Vt = _t && _t.exports === Nt && Ie.process,
      Bt = function () {
    try {
      return Vt && Vt.binding && Vt.binding("util");
    } catch (e) {}
  }(),
      Gt = Bt && Bt.isTypedArray,
      Wt = Gt ? (zt = Gt, function (e) {
    return zt(e);
  }) : function (e) {
    return Rt(e) && At(e.length) && !!$t[Be(e)];
  },
      Ut = Object.prototype.hasOwnProperty;

  function Kt(e, t) {
    var r = Ot(e),
        l = !r && Lt(e),
        o = !r && !l && jt(e),
        n = !r && !l && !o && Wt(e),
        a = r || l || o || n,
        i = a ? function (e, t) {
      for (var r = -1, l = Array(e); ++r < e;) {
        l[r] = t(r);
      }

      return l;
    }(e.length, String) : [],
        s = i.length;

    for (var c in e) {
      !t && !Ut.call(e, c) || a && ("length" == c || o && ("offset" == c || "parent" == c) || n && ("buffer" == c || "byteLength" == c || "byteOffset" == c) || Ht(c, s)) || i.push(c);
    }

    return i;
  }

  var qt = Object.prototype;

  var Zt = function (e, t) {
    return function (r) {
      return e(t(r));
    };
  }(Object.keys, Object),
      Yt = Object.prototype.hasOwnProperty;

  function Xt(e) {
    if (r = (t = e) && t.constructor, t !== ("function" == typeof r && r.prototype || qt)) return Zt(e);
    var t,
        r,
        l = [];

    for (var o in Object(e)) {
      Yt.call(e, o) && "constructor" != o && l.push(o);
    }

    return l;
  }

  function Jt(e) {
    return null != (t = e) && At(t.length) && !We(t) ? Kt(e) : Xt(e);
    var t;
  }

  function Qt(e) {
    return function (e, t, r) {
      var l = t(e);
      return Ot(e) ? l : function (e, t) {
        for (var r = -1, l = t.length, o = e.length; ++r < l;) {
          e[o + r] = t[r];
        }

        return e;
      }(l, r(e));
    }(e, Jt, St);
  }

  var er = Object.prototype.hasOwnProperty;
  var tr = ot(Te, "DataView"),
      rr = ot(Te, "Promise"),
      lr = ot(Te, "Set"),
      or = ot(Te, "WeakMap"),
      nr = Ye(tr),
      ar = Ye(nt),
      ir = Ye(rr),
      sr = Ye(lr),
      cr = Ye(or),
      ur = Be;
  (tr && "[object DataView]" != ur(new tr(new ArrayBuffer(1))) || nt && "[object Map]" != ur(new nt()) || rr && "[object Promise]" != ur(rr.resolve()) || lr && "[object Set]" != ur(new lr()) || or && "[object WeakMap]" != ur(new or())) && (ur = function ur(e) {
    var t = Be(e),
        r = "[object Object]" == t ? e.constructor : void 0,
        l = r ? Ye(r) : "";
    if (l) switch (l) {
      case nr:
        return "[object DataView]";

      case ar:
        return "[object Map]";

      case ir:
        return "[object Promise]";

      case sr:
        return "[object Set]";

      case cr:
        return "[object WeakMap]";
    }
    return t;
  });
  var dr = ur,
      pr = "[object Object]",
      mr = Object.prototype.hasOwnProperty;

  function fr(e, t, r, l, o, n) {
    var a = Ot(e),
        i = Ot(t),
        s = a ? "[object Array]" : dr(e),
        c = i ? "[object Array]" : dr(t),
        u = (s = "[object Arguments]" == s ? pr : s) == pr,
        d = (c = "[object Arguments]" == c ? pr : c) == pr,
        p = s == c;

    if (p && jt(e)) {
      if (!jt(t)) return !1;
      a = !0, u = !1;
    }

    if (p && !u) return n || (n = new pt()), a || Wt(e) ? bt(e, t, r, l, o, n) : function (e, t, r, l, o, n, a) {
      switch (r) {
        case "[object DataView]":
          if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
          e = e.buffer, t = t.buffer;

        case "[object ArrayBuffer]":
          return !(e.byteLength != t.byteLength || !n(new gt(e), new gt(t)));

        case "[object Boolean]":
        case "[object Date]":
        case "[object Number]":
          return Me(+e, +t);

        case "[object Error]":
          return e.name == t.name && e.message == t.message;

        case "[object RegExp]":
        case "[object String]":
          return e == t + "";

        case "[object Map]":
          var i = ht;

        case "[object Set]":
          var s = 1 & l;
          if (i || (i = Ct), e.size != t.size && !s) return !1;
          var c = a.get(e);
          if (c) return c == t;
          l |= 2, a.set(e, t);
          var u = bt(i(e), i(t), l, o, n, a);
          return a.delete(e), u;

        case "[object Symbol]":
          if (wt) return wt.call(e) == wt.call(t);
      }

      return !1;
    }(e, t, s, r, l, o, n);

    if (!(1 & r)) {
      var m = u && mr.call(e, "__wrapped__"),
          f = d && mr.call(t, "__wrapped__");

      if (m || f) {
        var b = m ? e.value() : e,
            g = f ? t.value() : t;
        return n || (n = new pt()), o(b, g, r, l, n);
      }
    }

    return !!p && (n || (n = new pt()), function (e, t, r, l, o, n) {
      var a = 1 & r,
          i = Qt(e),
          s = i.length;
      if (s != Qt(t).length && !a) return !1;

      for (var c = s; c--;) {
        var u = i[c];
        if (!(a ? u in t : er.call(t, u))) return !1;
      }

      var d = n.get(e);
      if (d && n.get(t)) return d == t;
      var p = !0;
      n.set(e, t), n.set(t, e);

      for (var m = a; ++c < s;) {
        var f = e[u = i[c]],
            b = t[u];
        if (l) var g = a ? l(b, f, u, t, e, n) : l(f, b, u, e, t, n);

        if (!(void 0 === g ? f === b || o(f, b, r, l, n) : g)) {
          p = !1;
          break;
        }

        m || (m = "constructor" == u);
      }

      if (p && !m) {
        var h = e.constructor,
            C = t.constructor;
        h == C || !("constructor" in e) || !("constructor" in t) || "function" == typeof h && h instanceof h && "function" == typeof C && C instanceof C || (p = !1);
      }

      return n.delete(e), n.delete(t), p;
    }(e, t, r, l, o, n));
  }

  function br(e, t, r, l, o) {
    return e === t || (null == e || null == t || !Rt(e) && !Rt(t) ? e != e && t != t : fr(e, t, r, l, br, o));
  }

  function gr(e) {
    return "function" == typeof e;
  }

  function hr() {
    try {
      var _e3 = "__some_random_key_you_are_not_going_to_use__";
      return window.localStorage.setItem(_e3, _e3), window.localStorage.removeItem(_e3), !0;
    } catch (e) {
      return !1;
    }
  }

  function Cr(e) {
    return e.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
  }

  function vr(t, r) {
    var l = React__namespace.useRef(null);
    if (l.current) return l.current;
    var o = t.current.getLogger(r);
    return l.current = o, o;
  }

  function wr(t, r, l) {
    var o = vr(t, "useGridApiMethod"),
        n = React__namespace.useRef(r),
        _React__namespace$use85 = React__namespace.useState(Object.keys(r)),
        _React__namespace$use86 = _slicedToArray(_React__namespace$use85, 1),
        a = _React__namespace$use86[0],
        i = React__namespace.useCallback(function () {
      t.current && a.forEach(function (e) {
        t.current.hasOwnProperty(e) || (o.debug("Adding ".concat(l, ".").concat(e, " to apiRef")), t.current[e] = function () {
          var _n$current;

          return (_n$current = n.current)[e].apply(_n$current, arguments);
        });
      });
    }, [a, l, t, o]);

    React__namespace.useEffect(function () {
      n.current = r;
    }, [r]), React__namespace.useEffect(function () {
      i();
    }, [i]), i();
  }

  var Or = function Or(t) {
    var r = vr(t, "useGridApi"),
        _React__namespace$use87 = React__namespace.useState(),
        _React__namespace$use88 = _slicedToArray(_React__namespace$use87, 2),
        l = _React__namespace$use88[1];

    t.current.state || (r.info("Initialising state."), t.current.state = {}, t.current.forceUpdate = l);
    var o = React__namespace.useCallback(function (e) {
      var r;
      r = gr(e) ? e(t.current.state) : e, t.current.state = r, l(function () {
        return r;
      }), t.current.publishEvent(ge.stateChange, r);
    }, [t]);
    return wr(t, {
      setState: o
    }, "GridStateApi"), t.current;
  },
      yr = function yr(t) {
    Or(t);
    var r = React__namespace.useCallback(function () {
      return t.current.forceUpdate(function () {
        return t.current.state;
      });
    }, [t]),
        l = React__namespace.useCallback(function (e) {
      var r = e(t.current.state);
      if (t.current.state === r) return !1;

      var _t$current$unstable_a = t.current.unstable_applyControlStateConstraint(r),
          l = _t$current$unstable_a.ignoreSetState,
          o = _t$current$unstable_a.postUpdate;

      return l || (t.current.state = r, t.current.publishEvent && t.current.publishEvent(ge.stateChange, r)), o(), !l;
    }, [t]);
    return [t.current.state, l, r];
  },
      Er = function Er(e, t) {
    var _yr = yr(e),
        _yr2 = _slicedToArray(_yr, 1),
        r = _yr2[0];

    return t(r);
  },
      Sr = function Sr(e) {
    return e.rows;
  },
      Rr = createSelector(Sr, function (e) {
    return e.totalRowCount;
  }),
      Pr = createSelector(Sr, function (e) {
    return e.totalTopLevelRowCount;
  }),
      xr = createSelector(Sr, function (e) {
    return e.idRowsLookup;
  }),
      kr = createSelector(Sr, function (e) {
    return e.tree;
  }),
      Mr = createSelector(Sr, function (e) {
    return e.treeDepth;
  }),
      Lr = createSelector(Sr, function (e) {
    return e.ids;
  }),
      Fr = function Fr(e) {
    return e.sorting;
  },
      Dr = createSelector(Fr, function (e) {
    return e.sortedRows;
  }),
      Ir = createSelector(Dr, xr, function (e, t) {
    return e.map(function (e) {
      return {
        id: e,
        model: t[e]
      };
    });
  }),
      jr = createSelector(Fr, function (e) {
    return e.sortModel;
  }),
      Tr = createSelector(jr, function (e) {
    return e.reduce(function (t, r, l) {
      return t[r.field] = {
        sortDirection: r.sort,
        sortIndex: e.length > 1 ? l + 1 : void 0
      }, t;
    }, {});
  }),
      Hr = function Hr(e) {
    return e.columns;
  },
      Ar = function Ar(e) {
    return e.columns.all;
  },
      $r = function $r(e) {
    return e.columns.lookup;
  },
      zr = createSelector(Ar, $r, function (e, t) {
    return e.map(function (e) {
      return t[e];
    });
  }),
      Nr = createSelector(zr, function (e) {
    return e.filter(function (e) {
      return null != e.field && !e.hide;
    });
  }),
      _r = createSelector(Nr, function (e) {
    var t = [];
    return {
      totalWidth: e.reduce(function (e, r) {
        return t.push(e), e + r.computedWidth;
      }, 0),
      positions: t
    };
  }),
      Vr = createSelector(zr, function (e) {
    return e.filter(function (e) {
      return e.filterable;
    });
  }),
      Br = createSelector(Vr, function (e) {
    return e.map(function (e) {
      return e.field;
    });
  }),
      Gr = createSelector(Nr, function (e) {
    return e.length;
  }),
      Wr = createSelector(_r, function (e) {
    return e.totalWidth;
  }),
      Ur = function Ur(e) {
    return e.filter;
  },
      Kr = createSelector(Ur, function (e) {
    return e.filterModel;
  }),
      qr = createSelector(Ur, function (e) {
    return e.visibleRowsLookup;
  });

  createSelector(Ur, function (e) {
    return e.filteredDescendantCountLookup;
  });
  var Yr = createSelector(qr, Ir, function (e, t) {
    return t.filter(function (t) {
      return !1 !== e[t.id];
    });
  }),
      Xr = createSelector(Yr, function (e) {
    return e.map(function (e) {
      return e.id;
    });
  }),
      Qr = createSelector(Yr, kr, Mr, function (e, t, r) {
    return r < 2 ? e : e.filter(function (e) {
      var r;
      return 0 === (null === (r = t[e.id]) || void 0 === r ? void 0 : r.depth);
    });
  }),
      el = createSelector(Yr, function (e) {
    return e.length;
  }),
      tl = createSelector(Qr, function (e) {
    return e.length;
  }),
      rl = createSelector(Kr, $r, function (e, t) {
    var r;
    return null === (r = e.items) || void 0 === r ? void 0 : r.filter(function (e) {
      var r, l;
      if (!e.columnField) return !1;
      var o = t[e.columnField];
      if (!(null == o ? void 0 : o.filterOperators) || 0 === (null === (r = null == o ? void 0 : o.filterOperators) || void 0 === r ? void 0 : r.length)) return !1;
      var n = o.filterOperators.find(function (t) {
        return t.value === e.operatorValue;
      });
      return !!n && (!n.InputComponent || null != e.value && "" !== (null === (l = e.value) || void 0 === l ? void 0 : l.toString()));
    });
  }),
      ll = createSelector(rl, function (e) {
    return e.reduce(function (e, t) {
      return e[t.columnField] ? e[t.columnField].push(t) : e[t.columnField] = [t], e;
    }, {});
  });

  function ol() {
    var t, r, l;
    var o = Ce(),
        n = ye(),
        a = Er(o, Rr),
        i = Er(o, el),
        s = !n.loading && 0 === a,
        c = !n.loading && a > 0 && 0 === i;
    return s ? React__namespace.createElement(n.components.NoRowsOverlay, Object.assign({}, null === (t = n.componentsProps) || void 0 === t ? void 0 : t.noRowsOverlay)) : c ? React__namespace.createElement(n.components.NoResultsOverlay, Object.assign({}, null === (r = n.componentsProps) || void 0 === r ? void 0 : r.noResultsOverlay)) : n.loading ? React__namespace.createElement(n.components.LoadingOverlay, Object.assign({}, null === (l = n.componentsProps) || void 0 === l ? void 0 : l.loadingOverlay)) : null;
  }

  var nl = function nl(e) {
    return e.selection;
  },
      al = createSelector(nl, function (e) {
    return e.length;
  }),
      il = createSelector(nl, xr, function (e, t) {
    return new Map(e.map(function (e) {
      return [e, t[e]];
    }));
  }),
      sl = createSelector(nl, function (e) {
    return e.reduce(function (e, t) {
      return e[t] = t, e;
    }, {});
  }),
      cl = function cl(e) {
    return e.density;
  },
      ul = createSelector(cl, function (e) {
    return e.value;
  }),
      dl = createSelector(cl, function (e) {
    return e.rowHeight;
  }),
      pl = createSelector(cl, function (e) {
    return e.headerHeight;
  });

  function ml(t) {
    var r = t.children,
        l = t.VirtualScrollerComponent,
        o = t.ColumnHeadersComponent,
        n = Ce(),
        a = ye(),
        i = Er(n, nl),
        s = Er(n, pl),
        _React__namespace$use89 = React__namespace.useState(a.disableVirtualization),
        _React__namespace$use90 = _slicedToArray(_React__namespace$use89, 2),
        c = _React__namespace$use90[0],
        u = _React__namespace$use90[1],
        d = React__namespace.useCallback(function () {
      u(!0);
    }, []),
        p = React__namespace.useCallback(function () {
      u(!1);
    }, []);

    n.current.unstable_disableVirtualization = d, n.current.unstable_enableVirtualization = p;
    var m = React__namespace.useRef(null),
        f = React__namespace.useRef(null),
        b = React__namespace.useRef(null),
        g = React__namespace.useRef(null);
    n.current.columnHeadersContainerElementRef = f, n.current.columnHeadersElementRef = m, n.current.windowRef = b, n.current.renderingZoneRef = g;
    var h = React__namespace.useCallback(function (e) {
      return n.current.publishEvent(ge.resize, e);
    }, [n]),
        C = React__namespace.useMemo(function () {
      return "function" == typeof a.isRowSelectable ? i.filter(function (e) {
        return a.isRowSelectable(n.current.getRowParams(e));
      }) : i;
    }, [n, a.isRowSelectable, i]),
        v = React__namespace.useMemo(function () {
      return C.reduce(function (e, t) {
        return e[t] = t, e;
      }, {});
    }, [C]);
    return React__namespace.createElement(Se, null, React__namespace.createElement(ol, null), React__namespace.createElement(o, {
      ref: f,
      innerRef: m
    }), React__namespace.createElement(ke, {
      nonce: a.nonce,
      disableHeight: a.autoHeight,
      onResize: h
    }, function (t) {
      var r = {
        width: t.width,
        height: t.height ? t.height - s : "auto",
        marginTop: s
      };
      return React__namespace.createElement(l, {
        ref: b,
        style: r,
        selectionLookup: v,
        disableVirtualization: c
      });
    }), r);
  }

  var fl = /*#__PURE__*/function (_React__namespace$Com) {
    _inherits(fl, _React__namespace$Com);

    var _super = _createSuper(fl);

    function fl() {
      _classCallCheck(this, fl);

      return _super.apply(this, arguments);
    }

    _createClass2(fl, [{
      key: "componentDidCatch",
      value: function componentDidCatch(e, t) {
        this.props.api.current && (this.logError(e), this.props.api.current.showError({
          error: e,
          errorInfo: t
        }));
      }
    }, {
      key: "logError",
      value: function logError(e, t) {
        this.props.logger.error("An unexpected error occurred. Error: ".concat(e && e.message, ". "), e, t);
      }
    }, {
      key: "render",
      value: function render() {
        var e;
        return this.props.hasError || (null === (e = this.state) || void 0 === e ? void 0 : e.hasError) ? this.props.render(this.props.componentProps || this.state) : this.props.children;
      }
    }], [{
      key: "getDerivedStateFromError",
      value: function getDerivedStateFromError(e) {
        return {
          hasError: !0,
          error: e
        };
      }
    }]);

    return fl;
  }(React__namespace.Component);

  function bl(t) {
    var r = t.children,
        l = Ce(),
        o = vr(l, "GridErrorHandler"),
        n = ye(),
        _yr3 = yr(l),
        _yr4 = _slicedToArray(_yr3, 1),
        a = _yr4[0];

    return React__namespace.createElement(fl, {
      hasError: null != a.error,
      componentProps: a.error,
      api: l,
      logger: o,
      render: function render(t) {
        var r;
        return React__namespace.createElement(Se, null, React__namespace.createElement(n.components.ErrorOverlay, Object.assign({}, t, null === (r = n.componentsProps) || void 0 === r ? void 0 : r.errorOverlay)));
      }
    }, r);
  }

  function gl() {
    var t;
    var r = Ce(),
        l = ye(),
        o = React__namespace.useRef(null);
    return r.current.footerRef = o, l.hideFooter ? null : React__namespace.createElement("div", {
      ref: o
    }, React__namespace.createElement(l.components.Footer, Object.assign({}, null === (t = l.componentsProps) || void 0 === t ? void 0 : t.footer)));
  }

  function hl() {
    var t;
    var r = Ce(),
        l = ye(),
        o = React__namespace.useRef(null);
    return r.current.headerRef = o, React__namespace.createElement("div", {
      ref: o
    }, React__namespace.createElement(l.components.Header, Object.assign({}, null === (t = l.componentsProps) || void 0 === t ? void 0 : t.header)));
  }

  function Cl(t) {
    var r = t.item,
        l = t.applyValue,
        o = t.apiRef,
        n = t.focusElementRef,
        a = Re(t, ["item", "applyValue", "apiRef", "focusElementRef"]),
        _React__namespace$use91 = React__namespace.useState(r.value || ""),
        _React__namespace$use92 = _slicedToArray(_React__namespace$use91, 2),
        i = _React__namespace$use92[0],
        s = _React__namespace$use92[1],
        c = React__namespace.useCallback(function (e) {
      var t = e.target.value;
      s(t), l(Object.assign(Object.assign({}, r), {
        value: t
      }));
    }, [l, r]);

    return React__namespace.useEffect(function () {
      s(r.value || "");
    }, [r.value]), React__namespace.createElement(BaseTextField, Object.assign({
      label: o.current.getLocaleText("filterPanelInputLabel"),
      value: i,
      onChange: c,
      variant: "standard",
      select: !0,
      SelectProps: {
        native: !0
      },
      InputLabelProps: {
        shrink: !0
      },
      inputRef: n
    }, a), React__namespace.createElement("option", {
      value: ""
    }, o.current.getLocaleText("filterValueAny")), React__namespace.createElement("option", {
      value: "true"
    }, o.current.getLocaleText("filterValueTrue")), React__namespace.createElement("option", {
      value: "false"
    }, o.current.getLocaleText("filterValueFalse")));
  }

  var vl = function vl() {
    return [{
      value: "is",
      getApplyFilterFn: function getApplyFilterFn(e) {
        if (!e.value) return null;
        var t = "true" === e.value;
        return function (_ref251) {
          var e = _ref251.value;
          return Boolean(e) === t;
        };
      },
      InputComponent: Cl
    }];
  },
      wl = createSvgIcon$1(React__namespace.createElement("path", {
    d: "M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"
  }), "ArrowUpward"),
      Ol = createSvgIcon$1(React__namespace.createElement("path", {
    d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
  }), "ArrowDownward"),
      yl = createSvgIcon$1(React__namespace.createElement("path", {
    d: "M8.59 16.59 13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
  }), "KeyboardArrowRight"),
      El = createSvgIcon$1(React__namespace.createElement("path", {
    d: "m12 8-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"
  }), "ExpandMore"),
      Sl = createSvgIcon$1(React__namespace.createElement("path", {
    d: "M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"
  }), "FilterList"),
      Rl = createSvgIcon$1(React__namespace.createElement("path", {
    d: "M4.25 5.61C6.27 8.2 10 13 10 13v6c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-6s3.72-4.8 5.74-7.39c.51-.66.04-1.61-.79-1.61H5.04c-.83 0-1.3.95-.79 1.61z"
  }), "FilterAlt");

  createSvgIcon$1(React__namespace.createElement("path", {
    d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
  }), "Search");
  createSvgIcon$1(React__namespace.createElement("path", {
    d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
  }), "Menu");
  createSvgIcon$1(React__namespace.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
  }), "CheckCircle");

  var Ml = createSvgIcon$1(React__namespace.createElement("path", {
    d: "M6 5H3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm14 0h-3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm-7 0h-3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1z"
  }), "ColumnIcon"),
      Ll = createSvgIcon$1(React__namespace.createElement("path", {
    d: "M11 19V5h2v14z"
  }), "Separator"),
      Fl = createSvgIcon$1(React__namespace.createElement("path", {
    d: "M4 15h16v-2H4v2zm0 4h16v-2H4v2zm0-8h16V9H4v2zm0-6v2h16V5H4z"
  }), "ViewHeadline"),
      Dl = createSvgIcon$1(React__namespace.createElement("path", {
    d: "M21,8H3V4h18V8z M21,10H3v4h18V10z M21,16H3v4h18V16z"
  }), "TableRows"),
      Il = createSvgIcon$1(React__namespace.createElement("path", {
    d: "M4 18h17v-6H4v6zM4 5v6h17V5H4z"
  }), "ViewStream"),
      jl = createSvgIcon$1(React__namespace.createElement("path", {
    d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
  }), "TripleDotsVertical"),
      Tl = createSvgIcon$1(React__namespace.createElement("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
  }), "Close"),
      Hl = createSvgIcon$1(React__namespace.createElement("path", {
    d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
  }), "Add"),
      Al = createSvgIcon$1(React__namespace.createElement("path", {
    d: "M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z"
  }), "Load"),
      $l = createSvgIcon$1(React__namespace.createElement("path", {
    d: "M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
  }), "Drag"),
      zl = createSvgIcon$1(React__namespace.createElement("path", {
    d: "M19 12v7H5v-7H3v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zm-6 .67l2.59-2.58L17 11.5l-5 5-5-5 1.41-1.41L11 12.67V3h2z"
  }), "SaveAlt"),
      Nl = createSvgIcon$1(React__namespace.createElement("path", {
    d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
  }), "Check"),
      _l = createSvgIcon$1(React__namespace.createElement("path", {
    d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
  }), "MoreVert");

  function Bl(t) {
    var r;

    var l = t.item,
        o = t.applyValue,
        n = t.type,
        a = t.apiRef,
        i = t.focusElementRef,
        s = Re(t, ["item", "applyValue", "type", "apiRef", "focusElementRef"]),
        c = React__namespace.useRef(),
        _React__namespace$use93 = React__namespace.useState(null !== (r = l.value) && void 0 !== r ? r : ""),
        _React__namespace$use94 = _slicedToArray(_React__namespace$use93, 2),
        u = _React__namespace$use94[0],
        d = _React__namespace$use94[1],
        _React__namespace$use95 = React__namespace.useState(!1),
        _React__namespace$use96 = _slicedToArray(_React__namespace$use95, 2),
        p = _React__namespace$use96[0],
        m = _React__namespace$use96[1],
        f = useId(),
        b = React__namespace.useCallback(function (e) {
      var t = e.target.value;
      clearTimeout(c.current), d(String(t)), m(!0), c.current = setTimeout(function () {
        o(Object.assign(Object.assign({}, l), {
          value: t
        })), m(!1);
      }, 500);
    }, [o, l]);

    React__namespace.useEffect(function () {
      return function () {
        clearTimeout(c.current);
      };
    }, []), React__namespace.useEffect(function () {
      var e;
      var t = null !== (e = l.value) && void 0 !== e ? e : "";
      d(String(t));
    }, [l.value]);
    var h = Object.assign(Object.assign(Object.assign({}, p ? {
      endAdornment: React__namespace.createElement(Al, null)
    } : {}), {
      max: "datetime-local" === n ? "9999-12-31T23:59" : "9999-12-31"
    }), s.InputProps);
    return React__namespace.createElement(BaseTextField, Object.assign({
      id: f,
      label: a.current.getLocaleText("filterPanelInputLabel"),
      placeholder: a.current.getLocaleText("filterPanelInputPlaceholder"),
      value: u,
      onChange: b,
      type: n || "text",
      variant: "standard",
      InputLabelProps: {
        shrink: !0
      },
      inputRef: i
    }, s, {
      InputProps: h
    }));
  }

  var Gl = /(\d+)-(\d+)-(\d+)/,
      Wl = /(\d+)-(\d+)-(\d+)T(\d+):(\d+)/;

  function Ul(e, t, r, l) {
    if (!e.value) return null;

    var _e$value$match$slice$ = e.value.match(r ? Wl : Gl).slice(1).map(Number),
        _e$value$match$slice$2 = _slicedToArray(_e$value$match$slice$, 5),
        o = _e$value$match$slice$2[0],
        n = _e$value$match$slice$2[1],
        a = _e$value$match$slice$2[2],
        i = _e$value$match$slice$2[3],
        s = _e$value$match$slice$2[4],
        c = new Date(o, n - 1, a, i || 0, s || 0).getTime();

    return function (_ref252) {
      var e = _ref252.value;
      if (!e) return !1;
      var o = e instanceof Date ? e : new Date(e.toString());
      if (l) return t(o.getTime(), c);
      var n = (e instanceof Date ? new Date(o) : o).setHours(r ? o.getHours() : 0, r ? o.getMinutes() : 0, 0, 0);
      return t(n, c);
    };
  }

  var Kl = function Kl(e) {
    return [{
      value: "is",
      getApplyFilterFn: function getApplyFilterFn(t) {
        return Ul(t, function (e, t) {
          return e === t;
        }, e);
      },
      InputComponent: Bl,
      InputComponentProps: {
        type: e ? "datetime-local" : "date"
      }
    }, {
      value: "not",
      getApplyFilterFn: function getApplyFilterFn(t) {
        return Ul(t, function (e, t) {
          return e !== t;
        }, e);
      },
      InputComponent: Bl,
      InputComponentProps: {
        type: e ? "datetime-local" : "date"
      }
    }, {
      value: "after",
      getApplyFilterFn: function getApplyFilterFn(t) {
        return Ul(t, function (e, t) {
          return e > t;
        }, e);
      },
      InputComponent: Bl,
      InputComponentProps: {
        type: e ? "datetime-local" : "date"
      }
    }, {
      value: "onOrAfter",
      getApplyFilterFn: function getApplyFilterFn(t) {
        return Ul(t, function (e, t) {
          return e >= t;
        }, e);
      },
      InputComponent: Bl,
      InputComponentProps: {
        type: e ? "datetime-local" : "date"
      }
    }, {
      value: "before",
      getApplyFilterFn: function getApplyFilterFn(t) {
        return Ul(t, function (e, t) {
          return e < t;
        }, e, !e);
      },
      InputComponent: Bl,
      InputComponentProps: {
        type: e ? "datetime-local" : "date"
      }
    }, {
      value: "onOrBefore",
      getApplyFilterFn: function getApplyFilterFn(t) {
        return Ul(t, function (e, t) {
          return e <= t;
        }, e);
      },
      InputComponent: Bl,
      InputComponentProps: {
        type: e ? "datetime-local" : "date"
      }
    }, {
      value: "isEmpty",
      getApplyFilterFn: function getApplyFilterFn() {
        return function (_ref253) {
          var e = _ref253.value;
          return null == e;
        };
      }
    }, {
      value: "isNotEmpty",
      getApplyFilterFn: function getApplyFilterFn() {
        return function (_ref254) {
          var e = _ref254.value;
          return null != e;
        };
      }
    }];
  },
      ql = {};

  var Zl = function Zl(_ref255, o) {
    var t = _ref255.valueOptions,
        r = _ref255.valueFormatter,
        l = _ref255.field;
    return ("function" == typeof t ? [""].concat(_toConsumableArray(t({
      field: l
    }))) : [""].concat(_toConsumableArray(t || []))).map(function (t) {
      return "object" == typeof t ? React__namespace.createElement("option", {
        key: t.value,
        value: t.value
      }, t.label) : React__namespace.createElement("option", {
        key: t,
        value: t
      }, r && "" !== t ? r({
        value: t,
        field: l,
        api: o
      }) : t);
    });
  };

  function Xl(t) {
    var r;
    var l = t.item,
        o = t.applyValue,
        n = t.type,
        a = t.apiRef,
        i = t.focusElementRef,
        s = Re(t, ["item", "applyValue", "type", "apiRef", "focusElementRef"]);
    "production" !== process.env.NODE_ENV && ["date", "datetime-local", "singleSelect"].includes(n) && !ql[n] && function (e) {
      console.warn(["MUI: Using GridFilterInputValue with a \"".concat(e, "\" column is deprecated."), "Use GridFilterInputSingleSelect instead."].join("\n")), ql[e] = !0;
    }(n);

    var c = React__namespace.useRef(),
        _React__namespace$use97 = React__namespace.useState(null !== (r = l.value) && void 0 !== r ? r : ""),
        _React__namespace$use98 = _slicedToArray(_React__namespace$use97, 2),
        u = _React__namespace$use98[0],
        d = _React__namespace$use98[1],
        _React__namespace$use99 = React__namespace.useState(!1),
        _React__namespace$use100 = _slicedToArray(_React__namespace$use99, 2),
        p = _React__namespace$use100[0],
        m = _React__namespace$use100[1],
        f = useId(),
        b = "singleSelect" === n ? {
      select: !0,
      SelectProps: {
        native: !0
      },
      children: Zl(a.current.getColumn(l.columnField), a.current)
    } : {},
        h = React__namespace.useCallback(function (e) {
      var t = e.target.value;

      if ("singleSelect" === n) {
        var _e4 = a.current.getColumn(l.columnField),
            _r3 = "function" == typeof _e4.valueOptions ? _e4.valueOptions({
          field: _e4.field
        }) : _e4.valueOptions;

        t = _r3.map(function (e) {
          return "object" == typeof e ? e.value : e;
        }).find(function (e) {
          return String(e) === t;
        });
      }

      clearTimeout(c.current), d(String(t)), m(!0), c.current = setTimeout(function () {
        o(Object.assign(Object.assign({}, l), {
          value: t
        })), m(!1);
      }, 500);
    }, [a, o, l, n]);

    React__namespace.useEffect(function () {
      return function () {
        clearTimeout(c.current);
      };
    }, []), React__namespace.useEffect(function () {
      var e;
      var t = null !== (e = l.value) && void 0 !== e ? e : "";
      d(String(t));
    }, [l.value]);
    var C = p ? {
      endAdornment: React__namespace.createElement(Al, null)
    } : s.InputProps;
    return React__namespace.createElement(BaseTextField, Object.assign({
      id: f,
      label: a.current.getLocaleText("filterPanelInputLabel"),
      placeholder: a.current.getLocaleText("filterPanelInputPlaceholder"),
      value: u,
      onChange: h,
      type: n || "text",
      variant: "standard",
      InputProps: C,
      InputLabelProps: {
        shrink: !0
      },
      inputRef: i
    }, b, s));
  }

  var Jl = function Jl(e) {
    return null == e ? null : Number(e);
  },
      Ql = function Ql() {
    return [{
      label: "=",
      value: "=",
      getApplyFilterFn: function getApplyFilterFn(e) {
        return null == e.value || Number.isNaN(e.value) ? null : function (_ref256) {
          var t = _ref256.value;
          return Jl(t) === e.value;
        };
      },
      InputComponent: Xl,
      InputComponentProps: {
        type: "number"
      }
    }, {
      label: "!=",
      value: "!=",
      getApplyFilterFn: function getApplyFilterFn(e) {
        return null == e.value || Number.isNaN(e.value) ? null : function (_ref257) {
          var t = _ref257.value;
          return Jl(t) !== e.value;
        };
      },
      InputComponent: Xl,
      InputComponentProps: {
        type: "number"
      }
    }, {
      label: ">",
      value: ">",
      getApplyFilterFn: function getApplyFilterFn(e) {
        return null == e.value || Number.isNaN(e.value) ? null : function (_ref258) {
          var t = _ref258.value;
          return null != t && Jl(t) > e.value;
        };
      },
      InputComponent: Xl,
      InputComponentProps: {
        type: "number"
      }
    }, {
      label: ">=",
      value: ">=",
      getApplyFilterFn: function getApplyFilterFn(e) {
        return null == e.value || Number.isNaN(e.value) ? null : function (_ref259) {
          var t = _ref259.value;
          return null != t && Jl(t) >= e.value;
        };
      },
      InputComponent: Xl,
      InputComponentProps: {
        type: "number"
      }
    }, {
      label: "<",
      value: "<",
      getApplyFilterFn: function getApplyFilterFn(e) {
        return null == e.value || Number.isNaN(e.value) ? null : function (_ref260) {
          var t = _ref260.value;
          return null != t && Jl(t) < e.value;
        };
      },
      InputComponent: Xl,
      InputComponentProps: {
        type: "number"
      }
    }, {
      label: "<=",
      value: "<=",
      getApplyFilterFn: function getApplyFilterFn(e) {
        return null == e.value || Number.isNaN(e.value) ? null : function (_ref261) {
          var t = _ref261.value;
          return null != t && Jl(t) <= e.value;
        };
      },
      InputComponent: Xl,
      InputComponentProps: {
        type: "number"
      }
    }, {
      value: "isEmpty",
      getApplyFilterFn: function getApplyFilterFn() {
        return function (_ref262) {
          var e = _ref262.value;
          return null == e;
        };
      }
    }, {
      value: "isNotEmpty",
      getApplyFilterFn: function getApplyFilterFn() {
        return function (_ref263) {
          var e = _ref263.value;
          return null != e;
        };
      }
    }];
  };

  function eo(t) {
    var r;

    var l = t.item,
        o = t.applyValue,
        n = t.type,
        a = t.apiRef,
        i = t.focusElementRef,
        s = Re(t, ["item", "applyValue", "type", "apiRef", "focusElementRef"]),
        _React__namespace$use101 = React__namespace.useState(null !== (r = l.value) && void 0 !== r ? r : ""),
        _React__namespace$use102 = _slicedToArray(_React__namespace$use101, 2),
        c = _React__namespace$use102[0],
        u = _React__namespace$use102[1],
        d = useId(),
        p = React__namespace.useCallback(function (e) {
      var t = e.target.value;
      var r = a.current.getColumn(l.columnField),
          n = "function" == typeof r.valueOptions ? r.valueOptions({
        field: r.field
      }) : r.valueOptions;
      t = n.map(function (e) {
        return "object" == typeof e ? e.value : e;
      }).find(function (e) {
        return String(e) === t;
      }), u(String(t)), o(Object.assign(Object.assign({}, l), {
        value: t
      }));
    }, [a, o, l]);

    return React__namespace.useEffect(function () {
      var e;
      var t = null !== (e = l.value) && void 0 !== e ? e : "";
      u(String(t));
    }, [l.value]), React__namespace.createElement(BaseTextField, Object.assign({
      id: d,
      label: a.current.getLocaleText("filterPanelInputLabel"),
      placeholder: a.current.getLocaleText("filterPanelInputPlaceholder"),
      value: c,
      onChange: p,
      type: n || "text",
      variant: "standard",
      InputLabelProps: {
        shrink: !0
      },
      inputRef: i,
      select: !0,
      SelectProps: {
        native: !0
      }
    }, s), function (_ref264, o) {
      var t = _ref264.valueOptions,
          r = _ref264.valueFormatter,
          l = _ref264.field;
      return ("function" == typeof t ? [""].concat(_toConsumableArray(t({
        field: l
      }))) : [""].concat(_toConsumableArray(t || []))).map(function (t) {
        return "object" == typeof t ? React__namespace.createElement("option", {
          key: t.value,
          value: t.value
        }, t.label) : React__namespace.createElement("option", {
          key: t,
          value: t
        }, r && "" !== t ? r({
          value: t,
          field: l,
          api: o
        }) : t);
      });
    }(a.current.getColumn(l.columnField), a.current));
  }

  var to = function to() {
    return [{
      value: "is",
      getApplyFilterFn: function getApplyFilterFn(e) {
        return null == e.value || "" === e.value ? null : function (_ref265) {
          var t = _ref265.value;
          return "object" == typeof t ? e.value === t.value : e.value === t;
        };
      },
      InputComponent: eo
    }, {
      value: "not",
      getApplyFilterFn: function getApplyFilterFn(e) {
        return null == e.value || "" === e.value ? null : function (_ref266) {
          var t = _ref266.value;
          return "object" == typeof t ? e.value !== t.value : e.value !== t;
        };
      },
      InputComponent: eo
    }];
  },
      ro = function ro() {
    return [{
      value: "contains",
      getApplyFilterFn: function getApplyFilterFn(e) {
        if (!e.value) return null;
        var t = new RegExp(Cr(e.value), "i");
        return function (_ref267) {
          var e = _ref267.value;
          return t.test(e && e.toString() || "");
        };
      },
      InputComponent: Xl
    }, {
      value: "equals",
      getApplyFilterFn: function getApplyFilterFn(e) {
        if (!e.value) return null;
        var t = new Intl.Collator(void 0, {
          sensitivity: "base",
          usage: "search"
        });
        return function (_ref268) {
          var r = _ref268.value;
          return 0 === t.compare(e.value, r && r.toString() || "");
        };
      },
      InputComponent: Xl
    }, {
      value: "startsWith",
      getApplyFilterFn: function getApplyFilterFn(e) {
        if (!e.value) return null;
        var t = new RegExp("^".concat(Cr(e.value), ".*$"), "i");
        return function (_ref269) {
          var e = _ref269.value;
          return t.test(e && e.toString() || "");
        };
      },
      InputComponent: Xl
    }, {
      value: "endsWith",
      getApplyFilterFn: function getApplyFilterFn(e) {
        if (!e.value) return null;
        var t = new RegExp(".*".concat(Cr(e.value), "$"), "i");
        return function (_ref270) {
          var e = _ref270.value;
          return t.test(e && e.toString() || "");
        };
      },
      InputComponent: Xl
    }, {
      value: "isEmpty",
      getApplyFilterFn: function getApplyFilterFn() {
        return function (_ref271) {
          var e = _ref271.value;
          return "" === e || null == e;
        };
      }
    }, {
      value: "isNotEmpty",
      getApplyFilterFn: function getApplyFilterFn() {
        return function (_ref272) {
          var e = _ref272.value;
          return "" !== e && null != e;
        };
      }
    }];
  },
      lo = styled$1(E$1, {
    name: "MuiDataGrid",
    slot: "EditInputCell",
    overridesResolver: function overridesResolver(e, t) {
      return t.editInputCell;
    }
  })(function (_ref273) {
    var e = _ref273.theme;
    return Object.assign(Object.assign({}, e.typography.body2), {
      padding: "1px 0",
      "& input": {
        padding: "0 16px",
        height: "100%"
      }
    });
  });

  function oo(t) {
    var r = t.id,
        l = t.value,
        o = t.formattedValue,
        a = t.api,
        i = t.field,
        s = t.row,
        c = t.rowNode,
        u = t.colDef,
        d = t.cellMode,
        p = t.isEditable,
        f = t.tabIndex,
        b = t.hasFocus,
        g = t.getValue,
        h = Re(t, ["id", "value", "formattedValue", "api", "field", "row", "rowNode", "colDef", "cellMode", "isEditable", "tabIndex", "hasFocus", "getValue"]),
        C = React__namespace.useRef(),
        _React__namespace$use103 = React__namespace.useState(l),
        _React__namespace$use104 = _slicedToArray(_React__namespace$use103, 2),
        v = _React__namespace$use104[0],
        w = _React__namespace$use104[1],
        O = function (e) {
      var t = e.classes;
      return composeClasses({
        root: ["editInputCell"]
      }, ve, t);
    }({
      classes: ye().classes
    }),
        y = React__namespace.useCallback(function (e) {
      var t = e.target.value;
      w(t), a.setEditCellValue({
        id: r,
        field: i,
        value: t
      }, e);
    }, [a, i, r]);

    return React__namespace.useEffect(function () {
      w(l);
    }, [l]), useEnhancedEffect$1(function () {
      b && C.current.focus();
    }, [b]), React__namespace.createElement(lo, Object.assign({
      inputRef: C,
      className: O.root,
      fullWidth: !0,
      type: "number" === u.type ? u.type : "text",
      value: v || "",
      onChange: y
    }, h));
  }

  var no = function no(t) {
    return React__namespace.createElement(oo, Object.assign({}, t));
  },
      ao = function ao(e, t) {
    var r = e.indexOf(t);
    return t && -1 !== r && r + 1 !== e.length ? e[r + 1] : e[0];
  },
      io = function io(e, t) {
    return null == e && null != t ? -1 : null == t && null != e ? 1 : null == e && null == t ? 0 : null;
  },
      so = new Intl.Collator(),
      co = function co(e, t) {
    var r = io(e, t);
    return null !== r ? r : Number(e) - Number(t);
  },
      uo = function uo(e, t) {
    var r = io(e, t);
    return null !== r ? r : e > t ? 1 : e < t ? -1 : 0;
  },
      po = {
    width: 100,
    minWidth: 50,
    hide: !1,
    sortable: !0,
    resizable: !0,
    filterable: !0,
    sortComparator: function sortComparator(e, t) {
      var r = io(e, t);
      return null !== r ? r : "string" == typeof e ? so.compare(e.toString(), t.toString()) : e - t;
    },
    type: "string",
    align: "left",
    filterOperators: ro(),
    renderEditCell: no
  },
      mo = styled$1(BasePopper, {
    name: "MuiDataGrid",
    slot: "Menu",
    overridesResolver: function overridesResolver(e, t) {
      return t.menu;
    }
  })(function (_ref274) {
    var e = _ref274.theme;
    return _defineProperty({
      zIndex: e.zIndex.modal
    }, "& .".concat(we.menuList), {
      outline: 0
    });
  }),
      fo = {
    "bottom-start": "top left",
    "bottom-end": "top right"
  },
      bo = function bo(t) {
    var r = t.open,
        l = t.target,
        o = t.onClickAway,
        a = t.children,
        i = t.position,
        s = t.className,
        c = Re(t, ["open", "target", "onClickAway", "children", "position", "className"]),
        u = React__namespace.useRef(l),
        d = React__namespace.useRef(r),
        p = function (e) {
      var t = e.classes;
      return composeClasses({
        root: ["menu"]
      }, ve, t);
    }({
      classes: ye().classes
    });

    return React__namespace.useEffect(function () {
      d.current && u.current && u.current.focus(), d.current = r, u.current = l;
    }, [r, l]), React__namespace.createElement(mo, Object.assign({
      className: clsx(s, p.root),
      open: r,
      anchorEl: l,
      transition: !0,
      placement: i
    }, c), function (_ref276) {
      var t = _ref276.TransitionProps,
          r = _ref276.placement;
      return React__namespace.createElement(ClickAwayListener, {
        onClickAway: o
      }, React__namespace.createElement(Grow$1, Object.assign({}, t, {
        style: {
          transformOrigin: fo[r]
        }
      }), React__namespace.createElement(BasePaper, null, a)));
    });
  },
      go = function go(t) {
    var _React__namespace$use105 = React__namespace.useState(!1),
        _React__namespace$use106 = _slicedToArray(_React__namespace$use105, 2),
        r = _React__namespace$use106[0],
        l = _React__namespace$use106[1],
        o = React__namespace.useRef(null),
        n = useId(),
        a = useId(),
        i = ye(),
        s = t.colDef,
        c = t.id,
        u = t.api,
        _t$position = t.position,
        d = _t$position === void 0 ? "bottom-end" : _t$position;

    if (!function (e) {
      return "function" == typeof e.getActions;
    }(s)) throw new Error("MUI: Missing the `getActions` property in the `GridColDef`.");

    var p = function p() {
      return l(!1);
    },
        m = s.getActions(u.getRowParams(c)),
        f = m.filter(function (e) {
      return !e.props.showInMenu;
    }),
        b = m.filter(function (e) {
      return e.props.showInMenu;
    });

    return React__namespace.createElement("div", {
      className: we.actionsCell
    }, f.map(function (t, r) {
      return React__namespace.cloneElement(t, {
        key: r
      });
    }), b.length > 0 && React__namespace.createElement(IconButton$2, {
      ref: o,
      id: a,
      "aria-label": u.getLocaleText("actionsCellMore"),
      "aria-controls": n,
      "aria-expanded": r ? "true" : void 0,
      "aria-haspopup": "true",
      size: "small",
      onClick: function onClick(e) {
        e.stopPropagation(), l(!0);
      }
    }, React__namespace.createElement(i.components.MoreActionsIcon, {
      fontSize: "small"
    })), b.length > 0 && React__namespace.createElement(bo, {
      id: n,
      onClickAway: p,
      onClick: p,
      open: r,
      target: o.current,
      position: d,
      "aria-labelledby": a
    }, React__namespace.createElement(BaseMenuList, {
      className: we.menuList
    }, b.map(function (t, r) {
      return React__namespace.cloneElement(t, {
        key: r
      });
    }))));
  },
      ho = function ho(t) {
    return React__namespace.createElement(go, Object.assign({}, t));
  },
      Co = Object.assign(Object.assign({}, po), {
    sortable: !1,
    filterable: !1,
    width: 100,
    align: "center",
    headerAlign: "center",
    headerName: "",
    disableColumnMenu: !0,
    disableExport: !0,
    renderCell: ho
  }),
      vo = React__namespace.memo(function (t) {
    var r = t.id,
        l = t.value,
        o = t.formattedValue,
        a = t.api,
        i = t.field,
        s = t.row,
        c = t.rowNode,
        u = t.colDef,
        d = t.cellMode,
        p = t.isEditable,
        m = t.hasFocus,
        f = t.tabIndex,
        b = t.getValue,
        g = Re(t, ["id", "value", "formattedValue", "api", "field", "row", "rowNode", "colDef", "cellMode", "isEditable", "hasFocus", "tabIndex", "getValue"]),
        h = ye(),
        C = function (e) {
      var t = e.classes;
      return composeClasses({
        root: ["booleanCell"]
      }, ve, t);
    }({
      classes: h.classes
    }),
        v = React__namespace.useMemo(function () {
      return l ? h.components.BooleanCellTrueIcon : h.components.BooleanCellFalseIcon;
    }, [h.components.BooleanCellFalseIcon, h.components.BooleanCellTrueIcon, l]);

    return React__namespace.createElement(v, Object.assign({
      fontSize: "small",
      className: C.root,
      titleAccess: a.getLocaleText(l ? "booleanCellTrueLabel" : "booleanCellFalseLabel"),
      "data-value": Boolean(l)
    }, g));
  });

  function wo(t) {
    var r = t.id,
        l = t.value,
        o = t.formattedValue,
        a = t.api,
        i = t.field,
        s = t.row,
        c = t.rowNode,
        u = t.colDef,
        d = t.cellMode,
        p = t.isEditable,
        f = t.tabIndex,
        b = t.className,
        h = t.getValue,
        C = t.hasFocus,
        v = Re(t, ["id", "value", "formattedValue", "api", "field", "row", "rowNode", "colDef", "cellMode", "isEditable", "tabIndex", "className", "getValue", "hasFocus"]),
        w = React__namespace.useRef(null),
        y = useId(),
        _React__namespace$use107 = React__namespace.useState(l),
        _React__namespace$use108 = _slicedToArray(_React__namespace$use107, 2),
        E = _React__namespace$use108[0],
        S = _React__namespace$use108[1],
        R = function (e) {
      var t = e.classes;
      return composeClasses({
        root: ["editBooleanCell"]
      }, ve, t);
    }({
      classes: ye().classes
    }),
        P = React__namespace.useCallback(function (e) {
      var t = e.target.checked;
      S(t), a.setEditCellValue({
        id: r,
        field: i,
        value: t
      }, e);
    }, [a, i, r]);

    return React__namespace.useEffect(function () {
      S(l);
    }, [l]), useEnhancedEffect$1(function () {
      C && w.current.focus();
    }, [C]), React__namespace.createElement("label", Object.assign({
      htmlFor: y,
      className: clsx(R.root, b)
    }, v), React__namespace.createElement(BaseCheckbox, {
      id: y,
      inputRef: w,
      checked: Boolean(E),
      onChange: P,
      size: "small"
    }));
  }

  var Oo = Object.assign(Object.assign({}, po), {
    type: "boolean",
    align: "center",
    headerAlign: "center",
    renderCell: function renderCell(t) {
      return React__namespace.createElement(vo, Object.assign({}, t));
    },
    renderEditCell: function renderEditCell(t) {
      return React__namespace.createElement(wo, Object.assign({}, t));
    },
    sortComparator: co,
    valueFormatter: function valueFormatter(_ref277) {
      var e = _ref277.value,
          t = _ref277.api;
      return e ? t.getLocaleText("booleanCellTrueLabel") : t.getLocaleText("booleanCellFalseLabel");
    },
    filterOperators: vl()
  }),
      yo = function yo(e) {
    return "Escape" === e;
  },
      Eo = function Eo(e) {
    return "Enter" === e;
  },
      So = function So(e) {
    return "Tab" === e;
  },
      Ro = function Ro(e) {
    return " " === e;
  },
      Po = function Po(e) {
    return "Delete" === e || "Backspace" === e;
  },
      xo = /^((?:[A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088E\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5D\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BF\u31F0-\u31FF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7CA\uA7D0\uA7D1\uA7D3\uA7D5-\uA7D9\uA7F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDD00-\uDD23\uDE80-\uDEA9\uDEB0\uDEB1\uDF00-\uDF1C\uDF27\uDF30-\uDF45\uDF70-\uDF81\uDFB0-\uDFC4\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC71\uDC72\uDC75\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDEB8\uDF00-\uDF1A\uDF40-\uDF46]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCDF\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEB0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDEE0-\uDEF2\uDFB0]|\uD808[\uDC00-\uDF99]|\uD809[\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE70-\uDEBE\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDE40-\uDE7F\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDD00-\uDD08]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD50-\uDD52\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD837[\uDF00-\uDF1E]|\uD838[\uDD00-\uDD2C\uDD37-\uDD3D\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB]|\uD839[\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43\uDD4B]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF38\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A])|(?:[\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u0898-\u089F\u08CA-\u08E1\u08E3-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962\u0963\u0981-\u0983\u09BC\u09BE-\u09C4\u09C7\u09C8\u09CB-\u09CD\u09D7\u09E2\u09E3\u09FE\u0A01-\u0A03\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81-\u0A83\u0ABC\u0ABE-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01-\u0B03\u0B3C\u0B3E-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B55-\u0B57\u0B62\u0B63\u0B82\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD7\u0C00-\u0C04\u0C3C\u0C3E-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81-\u0C83\u0CBC\u0CBE-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0D00-\u0D03\u0D3B\u0D3C\u0D3E-\u0D44\u0D46-\u0D48\u0D4A-\u0D4D\u0D57\u0D62\u0D63\u0D81-\u0D83\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DF2\u0DF3\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F3E\u0F3F\u0F71-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102B-\u103E\u1056-\u1059\u105E-\u1060\u1062-\u1064\u1067-\u106D\u1071-\u1074\u1082-\u108D\u108F\u109A-\u109D\u135D-\u135F\u1712-\u1715\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4-\u17D3\u17DD\u180B-\u180D\u180F\u1885\u1886\u18A9\u1920-\u192B\u1930-\u193B\u1A17-\u1A1B\u1A55-\u1A5E\u1A60-\u1A7C\u1A7F\u1AB0-\u1ACE\u1B00-\u1B04\u1B34-\u1B44\u1B6B-\u1B73\u1B80-\u1B82\u1BA1-\u1BAD\u1BE6-\u1BF3\u1C24-\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE8\u1CED\u1CF4\u1CF7-\u1CF9\u1DC0-\u1DFF\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA823-\uA827\uA82C\uA880\uA881\uA8B4-\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA953\uA980-\uA983\uA9B3-\uA9C0\uA9E5\uAA29-\uAA36\uAA43\uAA4C\uAA4D\uAA7B-\uAA7D\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEB-\uAAEF\uAAF5\uAAF6\uABE3-\uABEA\uABEC\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F]|\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD803[\uDD24-\uDD27\uDEAB\uDEAC\uDF46-\uDF50\uDF82-\uDF85]|\uD804[\uDC00-\uDC02\uDC38-\uDC46\uDC70\uDC73\uDC74\uDC7F-\uDC82\uDCB0-\uDCBA\uDCC2\uDD00-\uDD02\uDD27-\uDD34\uDD45\uDD46\uDD73\uDD80-\uDD82\uDDB3-\uDDC0\uDDC9-\uDDCC\uDDCE\uDDCF\uDE2C-\uDE37\uDE3E\uDEDF-\uDEEA\uDF00-\uDF03\uDF3B\uDF3C\uDF3E-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF57\uDF62\uDF63\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC35-\uDC46\uDC5E\uDCB0-\uDCC3\uDDAF-\uDDB5\uDDB8-\uDDC0\uDDDC\uDDDD\uDE30-\uDE40\uDEAB-\uDEB7\uDF1D-\uDF2B]|\uD806[\uDC2C-\uDC3A\uDD30-\uDD35\uDD37\uDD38\uDD3B-\uDD3E\uDD40\uDD42\uDD43\uDDD1-\uDDD7\uDDDA-\uDDE0\uDDE4\uDE01-\uDE0A\uDE33-\uDE39\uDE3B-\uDE3E\uDE47\uDE51-\uDE5B\uDE8A-\uDE99]|\uD807[\uDC2F-\uDC36\uDC38-\uDC3F\uDC92-\uDCA7\uDCA9-\uDCB6\uDD31-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD45\uDD47\uDD8A-\uDD8E\uDD90\uDD91\uDD93-\uDD97\uDEF3-\uDEF6]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF4F\uDF51-\uDF87\uDF8F-\uDF92\uDFE4\uDFF0\uDFF1]|\uD82F[\uDC9D\uDC9E]|\uD833[\uDF00-\uDF2D\uDF30-\uDF46]|\uD834[\uDD65-\uDD69\uDD6D-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A\uDD30-\uDD36\uDEAE\uDEEC-\uDEEF]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uDB40[\uDD00-\uDDEF])(?:[A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088E\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5D\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BF\u31F0-\u31FF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7CA\uA7D0\uA7D1\uA7D3\uA7D5-\uA7D9\uA7F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDD00-\uDD23\uDE80-\uDEA9\uDEB0\uDEB1\uDF00-\uDF1C\uDF27\uDF30-\uDF45\uDF70-\uDF81\uDFB0-\uDFC4\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC71\uDC72\uDC75\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDEB8\uDF00-\uDF1A\uDF40-\uDF46]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCDF\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEB0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDEE0-\uDEF2\uDFB0]|\uD808[\uDC00-\uDF99]|\uD809[\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE70-\uDEBE\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDE40-\uDE7F\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDD00-\uDD08]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD50-\uDD52\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD837[\uDF00-\uDF1E]|\uD838[\uDD00-\uDD2C\uDD37-\uDD3D\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB]|\uD839[\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43\uDD4B]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF38\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A])|(?:[\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u0898-\u089F\u08CA-\u08E1\u08E3-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962\u0963\u0981-\u0983\u09BC\u09BE-\u09C4\u09C7\u09C8\u09CB-\u09CD\u09D7\u09E2\u09E3\u09FE\u0A01-\u0A03\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81-\u0A83\u0ABC\u0ABE-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01-\u0B03\u0B3C\u0B3E-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B55-\u0B57\u0B62\u0B63\u0B82\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD7\u0C00-\u0C04\u0C3C\u0C3E-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81-\u0C83\u0CBC\u0CBE-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0D00-\u0D03\u0D3B\u0D3C\u0D3E-\u0D44\u0D46-\u0D48\u0D4A-\u0D4D\u0D57\u0D62\u0D63\u0D81-\u0D83\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DF2\u0DF3\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F3E\u0F3F\u0F71-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102B-\u103E\u1056-\u1059\u105E-\u1060\u1062-\u1064\u1067-\u106D\u1071-\u1074\u1082-\u108D\u108F\u109A-\u109D\u135D-\u135F\u1712-\u1715\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4-\u17D3\u17DD\u180B-\u180D\u180F\u1885\u1886\u18A9\u1920-\u192B\u1930-\u193B\u1A17-\u1A1B\u1A55-\u1A5E\u1A60-\u1A7C\u1A7F\u1AB0-\u1ACE\u1B00-\u1B04\u1B34-\u1B44\u1B6B-\u1B73\u1B80-\u1B82\u1BA1-\u1BAD\u1BE6-\u1BF3\u1C24-\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE8\u1CED\u1CF4\u1CF7-\u1CF9\u1DC0-\u1DFF\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA823-\uA827\uA82C\uA880\uA881\uA8B4-\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA953\uA980-\uA983\uA9B3-\uA9C0\uA9E5\uAA29-\uAA36\uAA43\uAA4C\uAA4D\uAA7B-\uAA7D\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEB-\uAAEF\uAAF5\uAAF6\uABE3-\uABEA\uABEC\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F]|\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD803[\uDD24-\uDD27\uDEAB\uDEAC\uDF46-\uDF50\uDF82-\uDF85]|\uD804[\uDC00-\uDC02\uDC38-\uDC46\uDC70\uDC73\uDC74\uDC7F-\uDC82\uDCB0-\uDCBA\uDCC2\uDD00-\uDD02\uDD27-\uDD34\uDD45\uDD46\uDD73\uDD80-\uDD82\uDDB3-\uDDC0\uDDC9-\uDDCC\uDDCE\uDDCF\uDE2C-\uDE37\uDE3E\uDEDF-\uDEEA\uDF00-\uDF03\uDF3B\uDF3C\uDF3E-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF57\uDF62\uDF63\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC35-\uDC46\uDC5E\uDCB0-\uDCC3\uDDAF-\uDDB5\uDDB8-\uDDC0\uDDDC\uDDDD\uDE30-\uDE40\uDEAB-\uDEB7\uDF1D-\uDF2B]|\uD806[\uDC2C-\uDC3A\uDD30-\uDD35\uDD37\uDD38\uDD3B-\uDD3E\uDD40\uDD42\uDD43\uDDD1-\uDDD7\uDDDA-\uDDE0\uDDE4\uDE01-\uDE0A\uDE33-\uDE39\uDE3B-\uDE3E\uDE47\uDE51-\uDE5B\uDE8A-\uDE99]|\uD807[\uDC2F-\uDC36\uDC38-\uDC3F\uDC92-\uDCA7\uDCA9-\uDCB6\uDD31-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD45\uDD47\uDD8A-\uDD8E\uDD90\uDD91\uDD93-\uDD97\uDEF3-\uDEF6]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF4F\uDF51-\uDF87\uDF8F-\uDF92\uDFE4\uDFF0\uDFF1]|\uD82F[\uDC9D\uDC9E]|\uD833[\uDF00-\uDF2D\uDF30-\uDF46]|\uD834[\uDD65-\uDD69\uDD6D-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A\uDD30-\uDD36\uDEAE\uDEEC-\uDEEF]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uDB40[\uDD00-\uDDEF])|(?:[0-9\xB2\xB3\xB9\xBC-\xBE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D58-\u0D5E\u0D66-\u0D78\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19]|\uD800[\uDD07-\uDD33\uDD40-\uDD78\uDD8A\uDD8B\uDEE1-\uDEFB\uDF20-\uDF23\uDF41\uDF4A\uDFD1-\uDFD5]|\uD801[\uDCA0-\uDCA9]|\uD802[\uDC58-\uDC5F\uDC79-\uDC7F\uDCA7-\uDCAF\uDCFB-\uDCFF\uDD16-\uDD1B\uDDBC\uDDBD\uDDC0-\uDDCF\uDDD2-\uDDFF\uDE40-\uDE48\uDE7D\uDE7E\uDE9D-\uDE9F\uDEEB-\uDEEF\uDF58-\uDF5F\uDF78-\uDF7F\uDFA9-\uDFAF]|\uD803[\uDCFA-\uDCFF\uDD30-\uDD39\uDE60-\uDE7E\uDF1D-\uDF26\uDF51-\uDF54\uDFC5-\uDFCB]|\uD804[\uDC52-\uDC6F\uDCF0-\uDCF9\uDD36-\uDD3F\uDDD0-\uDDD9\uDDE1-\uDDF4\uDEF0-\uDEF9]|\uD805[\uDC50-\uDC59\uDCD0-\uDCD9\uDE50-\uDE59\uDEC0-\uDEC9\uDF30-\uDF3B]|\uD806[\uDCE0-\uDCF2\uDD50-\uDD59]|\uD807[\uDC50-\uDC6C\uDD50-\uDD59\uDDA0-\uDDA9\uDFC0-\uDFD4]|\uD809[\uDC00-\uDC6E]|\uD81A[\uDE60-\uDE69\uDEC0-\uDEC9\uDF50-\uDF59\uDF5B-\uDF61]|\uD81B[\uDE80-\uDE96]|\uD834[\uDEE0-\uDEF3\uDF60-\uDF78]|\uD835[\uDFCE-\uDFFF]|\uD838[\uDD40-\uDD49\uDEF0-\uDEF9]|\uD83A[\uDCC7-\uDCCF\uDD50-\uDD59]|\uD83B[\uDC71-\uDCAB\uDCAD-\uDCAF\uDCB1-\uDCB4\uDD01-\uDD2D\uDD2F-\uDD3D]|\uD83C[\uDD00-\uDD0C]|\uD83E[\uDFF0-\uDFF9])|[ \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]|(?:[\$\+<->\^`\|~\xA2-\xA6\xA8\xA9\xAC\xAE-\xB1\xB4\xB8\xD7\xF7\u02C2-\u02C5\u02D2-\u02DF\u02E5-\u02EB\u02ED\u02EF-\u02FF\u0375\u0384\u0385\u03F6\u0482\u058D-\u058F\u0606-\u0608\u060B\u060E\u060F\u06DE\u06E9\u06FD\u06FE\u07F6\u07FE\u07FF\u0888\u09F2\u09F3\u09FA\u09FB\u0AF1\u0B70\u0BF3-\u0BFA\u0C7F\u0D4F\u0D79\u0E3F\u0F01-\u0F03\u0F13\u0F15-\u0F17\u0F1A-\u0F1F\u0F34\u0F36\u0F38\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE\u0FCF\u0FD5-\u0FD8\u109E\u109F\u1390-\u1399\u166D\u17DB\u1940\u19DE-\u19FF\u1B61-\u1B6A\u1B74-\u1B7C\u1FBD\u1FBF-\u1FC1\u1FCD-\u1FCF\u1FDD-\u1FDF\u1FED-\u1FEF\u1FFD\u1FFE\u2044\u2052\u207A-\u207C\u208A-\u208C\u20A0-\u20C0\u2100\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211E-\u2123\u2125\u2127\u2129\u212E\u213A\u213B\u2140-\u2144\u214A-\u214D\u214F\u218A\u218B\u2190-\u2307\u230C-\u2328\u232B-\u2426\u2440-\u244A\u249C-\u24E9\u2500-\u2767\u2794-\u27C4\u27C7-\u27E5\u27F0-\u2982\u2999-\u29D7\u29DC-\u29FB\u29FE-\u2B73\u2B76-\u2B95\u2B97-\u2BFF\u2CE5-\u2CEA\u2E50\u2E51\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFB\u3004\u3012\u3013\u3020\u3036\u3037\u303E\u303F\u309B\u309C\u3190\u3191\u3196-\u319F\u31C0-\u31E3\u3200-\u321E\u322A-\u3247\u3250\u3260-\u327F\u328A-\u32B0\u32C0-\u33FF\u4DC0-\u4DFF\uA490-\uA4C6\uA700-\uA716\uA720\uA721\uA789\uA78A\uA828-\uA82B\uA836-\uA839\uAA77-\uAA79\uAB5B\uAB6A\uAB6B\uFB29\uFBB2-\uFBC2\uFD40-\uFD4F\uFDCF\uFDFC-\uFDFF\uFE62\uFE64-\uFE66\uFE69\uFF04\uFF0B\uFF1C-\uFF1E\uFF3E\uFF40\uFF5C\uFF5E\uFFE0-\uFFE6\uFFE8-\uFFEE\uFFFC\uFFFD]|\uD800[\uDD37-\uDD3F\uDD79-\uDD89\uDD8C-\uDD8E\uDD90-\uDD9C\uDDA0\uDDD0-\uDDFC]|\uD802[\uDC77\uDC78\uDEC8]|\uD805\uDF3F|\uD807[\uDFD5-\uDFF1]|\uD81A[\uDF3C-\uDF3F\uDF45]|\uD82F\uDC9C|\uD833[\uDF50-\uDFC3]|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD64\uDD6A-\uDD6C\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDEA\uDE00-\uDE41\uDE45\uDF00-\uDF56]|\uD835[\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85\uDE86]|\uD838[\uDD4F\uDEFF]|\uD83B[\uDCAC\uDCB0\uDD2E\uDEF0\uDEF1]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD0D-\uDDAD\uDDE6-\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDE60-\uDE65\uDF00-\uDFFF]|\uD83D[\uDC00-\uDED7\uDEDD-\uDEEC\uDEF0-\uDEFC\uDF00-\uDF73\uDF80-\uDFD8\uDFE0-\uDFEB\uDFF0]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDCB0\uDCB1\uDD00-\uDE53\uDE60-\uDE6D\uDE70-\uDE74\uDE78-\uDE7C\uDE80-\uDE86\uDE90-\uDEAC\uDEB0-\uDEBA\uDEC0-\uDEC5\uDED0-\uDED9\uDEE0-\uDEE7\uDEF0-\uDEF6\uDF00-\uDF92\uDF94-\uDFCA])|(?:[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061D-\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1B7D\u1B7E\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52-\u2E5D\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDEAD\uDF55-\uDF59\uDF86-\uDF89]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5A\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDEB9\uDF3C-\uDF3E]|\uD806[\uDC3B\uDD44-\uDD46\uDDE2\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8\uDFFF]|\uD809[\uDC70-\uDC74]|\uD80B[\uDFF1\uDFF2]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A\uDFE2]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]))$/i,
      ko = function ko(e) {
    return xo.test(e);
  },
      Mo = ["Enter", "Escape", "Tab"],
      Lo = ["Enter", "Tab"],
      Fo = function Fo(e) {
    return Lo.indexOf(e) > -1;
  },
      Do = function Do(e) {
    return function (e) {
      return "Home" === e || "End" === e;
    }(e) || function (e) {
      return 0 === e.indexOf("Arrow");
    }(e) || function (e) {
      return 0 === e.indexOf("Page");
    }(e) || Ro(e);
  },
      Io = function Io(e) {
    return !!e.key;
  },
      jo = function jo(e) {
    return So(e) || yo(e);
  },
      To = React__namespace.forwardRef(function (t, r) {
    var l;

    var o = t.field,
        a = t.id,
        i = t.value,
        s = t.tabIndex,
        c = t.hasFocus,
        u = Ce(),
        d = ye(),
        p = function (e) {
      var t = e.classes;
      return composeClasses({
        root: ["checkboxInput"]
      }, ve, t);
    }({
      classes: d.classes
    }),
        m = React__namespace.useRef(null),
        b = useForkRef(m, r),
        g = u.current.getCellElement(a, o);

    React__namespace.useLayoutEffect(function () {
      0 === s && g && (g.tabIndex = -1);
    }, [g, s]), React__namespace.useLayoutEffect(function () {
      if (c && m.current) {
        m.current.querySelector("input").focus();
      }
    }, [c]);
    var h = React__namespace.useCallback(function (e) {
      Ro(e.key) && e.stopPropagation(), Do(e.key) && !e.shiftKey && u.current.publishEvent(ge.cellNavigationKeyDown, t, e);
    }, [u, t]),
        C = !d.isRowSelectable || d.isRowSelectable(u.current.getRowParams(a));
    return React__namespace.createElement(d.components.BaseCheckbox, Object.assign({
      ref: b,
      tabIndex: s,
      checked: !!i,
      onChange: function onChange(e) {
        var t = {
          value: e.target.checked,
          id: a
        };
        u.current.publishEvent(ge.rowSelectionCheckboxChange, t, e);
      },
      onClick: function onClick(e) {
        e.stopPropagation();
      },
      className: p.root,
      color: "primary",
      inputProps: {
        "aria-label": "Select Row checkbox"
      },
      onKeyDown: h,
      disabled: !C
    }, null === (l = d.componentsProps) || void 0 === l ? void 0 : l.baseCheckbox));
  }),
      Ho = React__namespace.memo(To),
      Ao = function Ao(e) {
    return e.focus;
  },
      $o = createSelector(Ao, function (e) {
    return e.cell;
  }),
      zo = createSelector(Ao, function (e) {
    return e.columnHeader;
  }),
      No = function No(e) {
    return e.tabIndex;
  },
      _o = createSelector(No, function (e) {
    return e.cell;
  }),
      Vo = createSelector(No, function (e) {
    return e.columnHeader;
  }),
      Bo = function Bo(e) {
    return e.pagination;
  },
      Go = createSelector(Bo, function (e) {
    return e.page;
  }),
      Wo = createSelector(Bo, function (e) {
    return e.pageSize;
  }),
      Uo = createSelector(Bo, kr, Mr, Yr, Qr, function (e, t, r, l, o) {
    var n = o.length,
        a = Math.min(e.pageSize * e.page, n - 1),
        i = Math.min(a + e.pageSize - 1, n - 1);
    if (-1 === a || -1 === i) return null;
    if (r < 2) return {
      firstRowIndex: a,
      lastRowIndex: i
    };
    var s = o[a],
        c = i - a + 1,
        u = l.findIndex(function (e) {
      return e.id === s.id;
    });
    var d = u,
        p = 0;

    for (; d < l.length && p <= c;) {
      var _e5 = t[l[d].id].depth;
      (p < c || _e5 > 0) && (d += 1), 0 === _e5 && (p += 1);
    }

    return {
      firstRowIndex: u,
      lastRowIndex: d - 1
    };
  }),
      Ko = createSelector(Yr, Uo, function (e, t) {
    return t ? e.slice(t.firstRowIndex, t.lastRowIndex + 1) : [];
  }),
      qo = createSelector(Xr, Uo, function (e, t) {
    return t ? e.slice(t.firstRowIndex, t.lastRowIndex + 1) : [];
  }),
      Zo = React__namespace.forwardRef(function (t, r) {
    var l;

    var _React__namespace$use109 = React__namespace.useState(!1),
        _React__namespace$use110 = _slicedToArray(_React__namespace$use109, 2),
        o = _React__namespace$use110[1],
        a = Ce(),
        i = ye(),
        s = function (e) {
      var t = e.classes;
      return composeClasses({
        root: ["checkboxInput"]
      }, ve, t);
    }({
      classes: i.classes
    }),
        c = Er(a, Vo),
        u = Er(a, nl),
        d = Er(a, Xr),
        p = Er(a, qo),
        m = React__namespace.useMemo(function () {
      return "function" == typeof i.isRowSelectable ? u.filter(function (e) {
        return i.isRowSelectable(a.current.getRowParams(e));
      }) : u;
    }, [a, i.isRowSelectable, u]),
        f = React__namespace.useMemo(function () {
      return (i.pagination && i.checkboxSelectionVisibleOnly ? p : d).reduce(function (e, t) {
        return e[t] = !0, e;
      }, {});
    }, [i.pagination, i.checkboxSelectionVisibleOnly, p, d]),
        b = React__namespace.useMemo(function () {
      return m.filter(function (e) {
        return f[e];
      }).length;
    }, [m, f]),
        g = b > 0 && b < Object.keys(f).length,
        h = b > 0,
        C = null !== c && c.field === t.field ? 0 : -1;

    React__namespace.useLayoutEffect(function () {
      var e = a.current.getColumnHeaderElement(t.field);
      0 === C && e && (e.tabIndex = -1);
    }, [C, a, t.field]);
    var v = React__namespace.useCallback(function (e) {
      Ro(e.key) && e.stopPropagation(), Do(e.key) && !e.shiftKey && a.current.publishEvent(ge.columnHeaderNavigationKeyDown, t, e);
    }, [a, t]),
        w = React__namespace.useCallback(function () {
      o(function (e) {
        return !e;
      });
    }, []);
    return React__namespace.useEffect(function () {
      return a.current.subscribeEvent(ge.selectionChange, w);
    }, [a, w]), React__namespace.createElement(i.components.BaseCheckbox, Object.assign({
      ref: r,
      indeterminate: g,
      checked: h,
      onChange: function onChange(e) {
        var t = {
          value: e.target.checked
        };
        a.current.publishEvent(ge.headerSelectionCheckboxChange, t);
      },
      className: s.root,
      color: "primary",
      inputProps: {
        "aria-label": "Select All Rows checkbox"
      },
      tabIndex: C,
      onKeyDown: v
    }, null === (l = i.componentsProps) || void 0 === l ? void 0 : l.baseCheckbox));
  }),
      Yo = Object.assign(Object.assign({}, Oo), {
    field: "__check__",
    type: "checkboxSelection",
    width: 50,
    resizable: !1,
    sortable: !1,
    filterable: !1,
    disableColumnMenu: !0,
    disableReorder: !0,
    disableExport: !0,
    valueGetter: function valueGetter(e) {
      return void 0 !== sl(e.api.state)[e.id];
    },
    renderHeader: function renderHeader(t) {
      return React__namespace.createElement(Zo, Object.assign({}, t));
    },
    renderCell: function renderCell(t) {
      return React__namespace.createElement(Ho, Object.assign({}, t));
    }
  });

  function Xo(t) {
    var r, l;

    var o = t.id,
        a = t.value,
        i = t.formattedValue,
        s = t.api,
        c = t.field,
        u = t.row,
        d = t.rowNode,
        p = t.colDef,
        f = t.cellMode,
        b = t.isEditable,
        g = t.tabIndex,
        h = t.hasFocus,
        C = t.getValue,
        v = Re(t, ["id", "value", "formattedValue", "api", "field", "row", "rowNode", "colDef", "cellMode", "isEditable", "tabIndex", "hasFocus", "getValue"]),
        w = "dateTime" === p.type,
        O = React__namespace.useRef(),
        y = React__namespace.useMemo(function () {
      var e, t;
      if (e = null == a ? null : a instanceof Date ? a : new Date((null != a ? a : "").toString()), null == e || Number.isNaN(e.getTime())) t = "";else {
        t = new Date(e.getTime() - 60 * e.getTimezoneOffset() * 1e3).toISOString().substr(0, w ? 16 : 10);
      }
      return {
        parsed: e,
        formatted: t
      };
    }, [a, w]),
        _React__namespace$use111 = React__namespace.useState(y),
        _React__namespace$use112 = _slicedToArray(_React__namespace$use111, 2),
        S = _React__namespace$use112[0],
        R = _React__namespace$use112[1],
        P = function (e) {
      var t = e.classes;
      return composeClasses({
        root: ["editInputCell"]
      }, ve, t);
    }({
      classes: ye().classes
    }),
        x = React__namespace.useCallback(function (e) {
      var t = e.target.value;
      var r;
      if ("" === t) r = null;else {
        var _t$split = t.split("T"),
            _t$split2 = _slicedToArray(_t$split, 2),
            _e6 = _t$split2[0],
            _l3 = _t$split2[1],
            _e6$split = _e6.split("-"),
            _e6$split2 = _slicedToArray(_e6$split, 3),
            _o3 = _e6$split2[0],
            _n3 = _e6$split2[1],
            _a2 = _e6$split2[2];

        if (r = new Date(), r.setFullYear(Number(_o3)), r.setMonth(Number(_n3) - 1), r.setDate(Number(_a2)), r.setHours(0, 0, 0, 0), _l3) {
          var _l3$split = _l3.split(":"),
              _l3$split2 = _slicedToArray(_l3$split, 2),
              _e7 = _l3$split2[0],
              _t6 = _l3$split2[1];

          r.setHours(Number(_e7), Number(_t6), 0, 0);
        }
      }
      R({
        parsed: r,
        formatted: t
      }), s.setEditCellValue({
        id: o,
        field: c,
        value: r
      }, e);
    }, [s, c, o]);

    return y.parsed !== S.parsed && (null === (r = y.parsed) || void 0 === r ? void 0 : r.getTime()) !== (null === (l = S.parsed) || void 0 === l ? void 0 : l.getTime()) && R(y), useEnhancedEffect$1(function () {
      h && O.current.focus();
    }, [h]), React__namespace.createElement(E$1, Object.assign({
      inputRef: O,
      fullWidth: !0,
      className: P.root,
      type: w ? "datetime-local" : "date",
      value: S.formatted,
      onChange: x
    }, v));
  }

  var Jo = function Jo(t) {
    return React__namespace.createElement(Xo, Object.assign({}, t));
  };

  function Qo(_ref278) {
    var e = _ref278.value;
    return e instanceof Date ? e.toLocaleDateString() : e;
  }

  function en(_ref279) {
    var e = _ref279.value;
    return e instanceof Date ? e.toLocaleString() : e;
  }

  var tn = Object.assign(Object.assign({}, po), {
    type: "date",
    sortComparator: uo,
    valueFormatter: Qo,
    filterOperators: Kl(),
    renderEditCell: Jo
  }),
      rn = Object.assign(Object.assign({}, po), {
    type: "dateTime",
    sortComparator: uo,
    valueFormatter: en,
    filterOperators: Kl(!0),
    renderEditCell: Jo
  }),
      ln = Object.assign(Object.assign({}, po), {
    type: "number",
    align: "right",
    headerAlign: "right",
    sortComparator: co,
    valueParser: function valueParser(e) {
      return "" === e ? null : Number(e);
    },
    valueFormatter: function valueFormatter(_ref280) {
      var e = _ref280.value;
      return e && function (e) {
        return "number" == typeof e;
      }(e) && e.toLocaleString() || e;
    },
    filterOperators: Ql()
  });
  var on$1, nn, an;
  !function (e) {
    e.Cell = "cell", e.Row = "row";
  }(on$1 || (on$1 = {})), function (e) {
    e.Edit = "edit", e.View = "view";
  }(nn || (nn = {})), function (e) {
    e.Edit = "edit", e.View = "view";
  }(an || (an = {}));

  var sn = function sn(t) {
    return "object" == typeof t ? React__namespace.createElement(BaseMenuItem, {
      key: t.value,
      value: t.value
    }, t.label) : React__namespace.createElement(BaseMenuItem, {
      key: t,
      value: t
    }, t);
  };

  function cn(t) {
    var _this6 = this;

    var r = t.id,
        l = t.value,
        o = t.formattedValue,
        n = t.api,
        a = t.field,
        i = t.row,
        s = t.rowNode,
        c = t.colDef,
        u = t.cellMode,
        d = t.isEditable,
        p = t.tabIndex,
        f = t.className,
        b = t.getValue,
        g = t.hasFocus,
        h = t.error,
        C = Re(t, ["id", "value", "formattedValue", "api", "field", "row", "rowNode", "colDef", "cellMode", "isEditable", "tabIndex", "className", "getValue", "hasFocus", "error"]),
        v = React__namespace.useRef(),
        w = React__namespace.useRef(),
        O = ye(),
        _React__namespace$use113 = React__namespace.useState("cell" === O.editMode),
        _React__namespace$use114 = _slicedToArray(_React__namespace$use113, 2),
        y = _React__namespace$use114[0],
        E = _React__namespace$use114[1];

    var S;
    S = "function" == typeof c.valueOptions ? c.valueOptions({
      id: r,
      row: i,
      field: a
    }) : c.valueOptions, c.valueFormatter && (S = S.map(function (e) {
      if ("object" == typeof e) return e;
      var t = {
        field: a,
        api: n,
        value: e
      };
      return {
        value: e,
        label: String(c.valueFormatter(t))
      };
    }));
    return useEnhancedEffect$1(function () {
      g && w.current.focus();
    }, [g]), React__namespace.createElement(D$1, Object.assign({
      ref: v,
      inputRef: w,
      value: l,
      onChange: function onChange(e) {
        return Pe(_this6, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var _t7;

          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!(E(!1), n.setEditCellValue({
                    id: r,
                    field: a,
                    value: e.target.value
                  }, e), O.editMode === on$1.Row)) {
                    _context.next = 2;
                    break;
                  }

                  return _context.abrupt("return");

                case 2:
                  _context.next = 4;
                  return Promise.resolve(n.commitCellChange({
                    id: r,
                    field: a
                  }, e));

                case 4:
                  _context.t0 = _context.sent;

                  if (!_context.t0) {
                    _context.next = 7;
                    break;
                  }

                  _context.t0 = (n.setCellMode(r, a, "view"), e.key);

                case 7:
                  if (!_context.t0) {
                    _context.next = 10;
                    break;
                  }

                  _t7 = n.getCellParams(r, a);
                  n.publishEvent(ge.cellNavigationKeyDown, _t7, e);

                case 10:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));
      },
      open: y,
      onOpen: function onOpen() {
        E(!0);
      },
      MenuProps: {
        onClose: function onClose(e, t) {
          O.editMode !== on$1.Row ? ("backdropClick" === t || yo(e.key)) && n.setCellMode(r, a, "view") : E(!1);
        }
      },
      error: h,
      fullWidth: !0
    }, C), S.map(sn));
  }

  var un = function un(t) {
    return React__namespace.createElement(cn, Object.assign({}, t));
  },
      dn = Object.assign(Object.assign({}, po), {
    type: "singleSelect",
    renderEditCell: un,
    filterOperators: to()
  }),
      mn = function mn() {
    var e = {
      string: po,
      number: ln,
      date: tn,
      dateTime: rn,
      boolean: Oo,
      singleSelect: dn,
      actions: Co
    };
    return e.__default__ = po, e;
  },
      fn = {
    client: "client",
    server: "server"
  };

  var bn, gn;

  function hn(e, t) {
    var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "A row was provided without id in the rows prop:";
    if (null == e) throw new Error(["MUI: The data grid component requires all rows to have a unique id property.", r, JSON.stringify(t)].join("\n"));
  }

  var Cn;
  !function (e) {
    e.And = "and", e.Or = "or";
  }(bn || (bn = {})), function (e) {
    e.Compact = "compact", e.Standard = "standard", e.Comfortable = "comfortable";
  }(gn || (gn = {}));

  function vn(t) {
    var r = t.align,
        l = t.children,
        o = t.colIndex,
        a = t.cellMode,
        i = t.field,
        s = t.formattedValue,
        c = t.hasFocus,
        u = t.height,
        d = t.isEditable,
        p = t.rowId,
        m = t.tabIndex,
        f = t.value,
        b = t.width,
        g = t.className,
        v = t.showRightBorder,
        w = t.extendRowFullWidth,
        y = t.row,
        E = t.onClick,
        S = t.onDoubleClick,
        R = t.onMouseDown,
        P = t.onMouseUp,
        x = t.onKeyDown,
        k = t.onDragEnter,
        M = t.onDragOver,
        L = Re(t, ["align", "children", "colIndex", "cellMode", "field", "formattedValue", "hasFocus", "height", "isEditable", "rowId", "tabIndex", "value", "width", "className", "showRightBorder", "extendRowFullWidth", "row", "onClick", "onDoubleClick", "onMouseDown", "onMouseUp", "onKeyDown", "onDragEnter", "onDragOver"]),
        F = null == s ? f : s,
        D = React__namespace.useRef(null),
        I = Ce(),
        j = function (e) {
      var t = e.align,
          r = e.showRightBorder,
          l = e.isEditable,
          o = e.classes,
          a = {
        root: ["cell", "cell--text".concat(capitalize$1(t)), l && "cell--editable", r && "withBorder"]
      };
      return composeClasses(a, ve, o);
    }({
      align: r,
      showRightBorder: v,
      isEditable: d,
      classes: ye().classes
    }),
        T = React__namespace.useCallback(function (e) {
      return function (t) {
        var r = I.current.getCellParams(p, i || "");
        I.current.publishEvent(e, r, t), P && P(t);
      };
    }, [I, i, P, p]),
        H = React__namespace.useCallback(function (e, t) {
      return function (r) {
        if (!r.currentTarget.contains(r.target)) return;
        if (!I.current.getRow(p)) return;
        var l = I.current.getCellParams(p, i || "");
        I.current.publishEvent(e, l, r), t && t(r);
      };
    }, [I, i, p]),
        A = {
      minWidth: b,
      maxWidth: b,
      minHeight: u,
      maxHeight: u,
      lineHeight: u - 1 + "px"
    };

    return React__namespace.useLayoutEffect(function () {
      if (!c || a === nn.Edit) return;
      var e = ownerDocument(I.current.rootElementRef.current);

      if (D.current && !D.current.contains(e.activeElement)) {
        var _e8 = D.current.querySelector('[tabindex="0"]') || D.current;

        if (void 0 === Cn && document.createElement("div").focus({
          get preventScroll() {
            return Cn = !0, !1;
          }

        }), Cn) _e8.focus({
          preventScroll: !0
        });else {
          var _t8 = I.current.getScrollPosition();

          _e8.focus(), I.current.scroll(_t8);
        }
      }
    }), React__namespace.createElement("div", Object.assign({
      ref: D,
      className: clsx(g, j.root),
      role: "cell",
      "data-field": i,
      "data-colindex": o,
      "aria-colindex": o + 1,
      style: A,
      tabIndex: "view" !== a && d ? -1 : m,
      onClick: H(ge.cellClick, E),
      onDoubleClick: H(ge.cellDoubleClick, S),
      onMouseDown: H(ge.cellMouseDown, R),
      onMouseUp: T(ge.cellMouseUp),
      onKeyDown: H(ge.cellKeyDown, x),
      onDragEnter: H(ge.cellDragEnter, k),
      onDragOver: H(ge.cellDragOver, M)
    }, L), null != l ? l : null == F ? void 0 : F.toString());
  }

  var yn = styled$1("div", {
    name: "MuiDataGrid",
    slot: "Root",
    overridesResolver: function overridesResolver(e, t) {
      return [_defineProperty({}, "&.".concat(we.autoHeight), t.autoHeight), _defineProperty({}, "& .".concat(we.editBooleanCell), t.editBooleanCell), _defineProperty({}, "& .".concat(we["cell--editing"]), t["cell--editing"]), _defineProperty({}, "& .".concat(we["cell--textCenter"]), t["cell--textCenter"]), _defineProperty({}, "& .".concat(we["cell--textLeft"]), t["cell--textLeft"]), _defineProperty({}, "& .".concat(we["cell--textRight"]), t["cell--textRight"]), _defineProperty({}, "& .".concat(we["cell--withRenderer"]), t["cell--withRenderer"]), _defineProperty({}, "& .".concat(we.cell), t.cell), _defineProperty({}, "& .".concat(we.cellCheckbox), t.cellCheckbox), _defineProperty({}, "& .".concat(we.checkboxInput), t.checkboxInput), _defineProperty({}, "& .".concat(we["columnHeader--alignCenter"]), t["columnHeader--alignCenter"]), _defineProperty({}, "& .".concat(we["columnHeader--alignLeft"]), t["columnHeader--alignLeft"]), _defineProperty({}, "& .".concat(we["columnHeader--alignRight"]), t["columnHeader--alignRight"]), _defineProperty({}, "& .".concat(we["columnHeader--dragging"]), t["columnHeader--dragging"]), _defineProperty({}, "& .".concat(we["columnHeader--moving"]), t["columnHeader--moving"]), _defineProperty({}, "& .".concat(we["columnHeader--numeric"]), t["columnHeader--numeric"]), _defineProperty({}, "& .".concat(we["columnHeader--sortable"]), t["columnHeader--sortable"]), _defineProperty({}, "& .".concat(we["columnHeader--sorted"]), t["columnHeader--sorted"]), _defineProperty({}, "& .".concat(we.columnHeader), t.columnHeader), _defineProperty({}, "& .".concat(we.columnHeaderCheckbox), t.columnHeaderCheckbox), _defineProperty({}, "& .".concat(we.columnHeaderDraggableContainer), t.columnHeaderDraggableContainer), _defineProperty({}, "& .".concat(we.columnHeaderTitleContainer), t.columnHeaderTitleContainer), _defineProperty({}, "& .".concat(we["columnSeparator--resizable"]), t["columnSeparator--resizable"]), _defineProperty({}, "& .".concat(we["columnSeparator--resizing"]), t["columnSeparator--resizing"]), _defineProperty({}, "& .".concat(we.columnSeparator), t.columnSeparator), _defineProperty({}, "& .".concat(we.filterIcon), t.filterIcon), _defineProperty({}, "& .".concat(we.iconSeparator), t.iconSeparator), _defineProperty({}, "& .".concat(we.menuIcon), t.menuIcon), _defineProperty({}, "& .".concat(we.menuIconButton), t.menuIconButton), _defineProperty({}, "& .".concat(we.menuOpen), t.menuOpen), _defineProperty({}, "& .".concat(we.menuList), t.menuList), _defineProperty({}, "& .".concat(we["row--editable"]), t["row--editable"]), _defineProperty({}, "& .".concat(we["row--editing"]), t["row--editing"]), _defineProperty({}, "& .".concat(we.row), t.row), _defineProperty({}, "& .".concat(we.sortIcon), t.sortIcon), _defineProperty({}, "& .".concat(we.withBorder), t.withBorder), _defineProperty({}, "& .".concat(we.treeDataGroupingCell), t.treeDataGroupingCell), _defineProperty({}, "& .".concat(we.treeDataGroupingCellToggle), t.treeDataGroupingCellToggle), t.root];
    }
  })(function (_ref319) {
    var _$concat12, _Object$assign3;

    var e = _ref319.theme;
    var t = "light" === e.palette.mode ? lighten(alpha(e.palette.divider, 1), .88) : darken(alpha(e.palette.divider, 1), .68);
    return Object.assign(Object.assign({
      flex: 1,
      boxSizing: "border-box",
      position: "relative",
      border: "1px solid ".concat(t),
      borderRadius: e.shape.borderRadius,
      color: e.palette.text.primary
    }, e.typography.body2), (_Object$assign3 = {
      outline: "none",
      height: "100%",
      display: "flex",
      flexDirection: "column"
    }, _defineProperty(_Object$assign3, "&.".concat(we.autoHeight), {
      height: "auto"
    }), _defineProperty(_Object$assign3, "& .".concat(we.columnHeader, ", & .").concat(we.cell), {
      WebkitTapHighlightColor: "transparent",
      lineHeight: null,
      padding: "0 10px",
      boxSizing: "border-box"
    }), _defineProperty(_Object$assign3, "& .".concat(we.columnHeader, ":focus-within, & .").concat(we.cell, ":focus-within"), {
      outline: "solid ".concat(alpha(e.palette.primary.main, .5), " 1px"),
      outlineWidth: 1,
      outlineOffset: -1
    }), _defineProperty(_Object$assign3, "& .".concat(we.columnHeader, ":focus, & .").concat(we.cell, ":focus"), {
      outline: "solid ".concat(e.palette.primary.main, " 1px")
    }), _defineProperty(_Object$assign3, "& .".concat(we.columnHeaderCheckbox, ", & .").concat(we.cellCheckbox), {
      padding: 0,
      justifyContent: "center",
      alignItems: "center"
    }), _defineProperty(_Object$assign3, "& .".concat(we.columnHeader), {
      position: "relative",
      display: "flex",
      alignItems: "center"
    }), _defineProperty(_Object$assign3, "& .".concat(we["columnHeader--sorted"], " .").concat(we.iconButtonContainer), {
      visibility: "visible",
      width: "auto"
    }), _defineProperty(_Object$assign3, "& .".concat(we.columnHeader, ":not(.").concat(we["columnHeader--sorted"], ") .").concat(we.sortIcon), {
      opacity: 0,
      transition: e.transitions.create(["opacity"], {
        duration: e.transitions.duration.shorter
      })
    }), _defineProperty(_Object$assign3, "& .".concat(we.columnHeader, ":not(.").concat(we["columnHeader--sorted"], "):hover .").concat(we.sortIcon), {
      opacity: .5
    }), _defineProperty(_Object$assign3, "& .".concat(we.columnHeaderTitleContainer), {
      display: "flex",
      alignItems: "center",
      minWidth: 0,
      flex: 1,
      whiteSpace: "nowrap",
      overflow: "hidden",
      padding: "0 6px"
    }), _defineProperty(_Object$assign3, "& .".concat(we.sortIcon, ", & .").concat(we.filterIcon), {
      fontSize: "inherit"
    }), _defineProperty(_Object$assign3, "& .".concat(we["columnHeader--sortable"]), {
      cursor: "pointer"
    }), _defineProperty(_Object$assign3, "& .".concat(we["columnHeader--alignCenter"], " .").concat(we.columnHeaderTitleContainer), {
      justifyContent: "center"
    }), _defineProperty(_Object$assign3, "& .".concat(we["columnHeader--alignRight"], " .").concat(we.columnHeaderDraggableContainer, ", & .").concat(we["columnHeader--alignRight"], " .").concat(we.columnHeaderTitleContainer), {
      flexDirection: "row-reverse"
    }), _defineProperty(_Object$assign3, "& .".concat(we["columnHeader--alignCenter"], " .").concat(we.menuIcon, ", & .").concat(we["columnHeader--alignRight"], " .").concat(we.menuIcon), {
      marginRight: "auto",
      marginLeft: -6
    }), _defineProperty(_Object$assign3, "& .".concat(we["columnHeader--moving"]), {
      backgroundColor: e.palette.action.hover
    }), _defineProperty(_Object$assign3, "& .".concat(we.columnSeparator), {
      position: "absolute",
      right: -12,
      zIndex: 100,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      color: t
    }), _defineProperty(_Object$assign3, "& .".concat(we["columnSeparator--resizable"]), _defineProperty({
      cursor: "col-resize",
      touchAction: "none",
      "&:hover": {
        color: e.palette.text.primary,
        "@media (hover: none)": {
          color: t
        }
      }
    }, "&.".concat(we["columnSeparator--resizing"]), {
      color: e.palette.text.primary
    })), _defineProperty(_Object$assign3, "& .".concat(we.iconSeparator), {
      color: "inherit"
    }), _defineProperty(_Object$assign3, "& .".concat(we.menuIcon), {
      width: 0,
      visibility: "hidden",
      fontSize: 20,
      marginRight: -6,
      display: "flex",
      alignItems: "center"
    }), _defineProperty(_Object$assign3, "& .".concat(we.columnHeader, ":hover"), (_$concat12 = {}, _defineProperty(_$concat12, "& .".concat(we.iconButtonContainer), {
      visibility: "visible",
      width: "auto"
    }), _defineProperty(_$concat12, "& .".concat(we.menuIcon), {
      width: "auto",
      visibility: "visible"
    }), _$concat12)), _defineProperty(_Object$assign3, ".".concat(we.menuOpen), {
      visibility: "visible"
    }), _defineProperty(_Object$assign3, "& .".concat(we.row), {
      display: "flex",
      width: "fit-content",
      "&:hover": {
        backgroundColor: e.palette.action.hover,
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      },
      "&.Mui-selected": {
        backgroundColor: alpha(e.palette.primary.main, e.palette.action.selectedOpacity),
        "&:hover": {
          backgroundColor: alpha(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
          "@media (hover: none)": {
            backgroundColor: alpha(e.palette.primary.main, e.palette.action.selectedOpacity)
          }
        }
      }
    }), _defineProperty(_Object$assign3, "& .".concat(we.cell), {
      display: "block",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      borderBottom: "1px solid ".concat(t)
    }), _defineProperty(_Object$assign3, "& .".concat(we.cell, ".").concat(we["cell--editing"]), {
      padding: 1,
      display: "flex",
      boxShadow: e.shadows[2],
      backgroundColor: e.palette.background.paper,
      "&:focus-within": {
        outline: "solid ".concat(e.palette.primary.main, " 1px"),
        outlineOffset: "-1px"
      }
    }), _defineProperty(_Object$assign3, "& .".concat(we["row--editing"]), {
      boxShadow: e.shadows[2]
    }), _defineProperty(_Object$assign3, "& .".concat(we["row--editing"], " .").concat(we.cell), {
      boxShadow: e.shadows[0],
      backgroundColor: e.palette.background.paper
    }), _defineProperty(_Object$assign3, "& .".concat(we.editBooleanCell), {
      display: "flex",
      height: "100%",
      width: "100%",
      alignItems: "center",
      justifyContent: "center"
    }), _defineProperty(_Object$assign3, "& .".concat(we.booleanCell, "[data-value=\"true\"]"), {
      color: e.palette.text.secondary
    }), _defineProperty(_Object$assign3, "& .".concat(we.booleanCell, "[data-value=\"false\"]"), {
      color: e.palette.text.disabled
    }), _defineProperty(_Object$assign3, "& .".concat(we.actionsCell), {
      display: "inline-flex",
      alignItems: "center",
      gridGap: e.spacing(1)
    }), _defineProperty(_Object$assign3, "& .".concat(we["cell--withRenderer"]), {
      display: "flex",
      alignItems: "center"
    }), _defineProperty(_Object$assign3, "& .".concat(we.withBorder), {
      borderRight: "1px solid ".concat(t)
    }), _defineProperty(_Object$assign3, "& .".concat(we["cell--textLeft"]), {
      textAlign: "left"
    }), _defineProperty(_Object$assign3, "& .".concat(we["cell--textLeft"], ".").concat(we["cell--withRenderer"], ", & .").concat(we["cell--textLeft"], ".").concat(we["cell--editing"]), {
      justifyContent: "flex-start"
    }), _defineProperty(_Object$assign3, "& .".concat(we["cell--textRight"]), {
      textAlign: "right"
    }), _defineProperty(_Object$assign3, "& .".concat(we["cell--textRight"], ".").concat(we["cell--withRenderer"], ", & .").concat(we["cell--textRight"], ".").concat(we["cell--editing"]), {
      justifyContent: "flex-end"
    }), _defineProperty(_Object$assign3, "& .".concat(we["cell--textCenter"]), {
      textAlign: "center"
    }), _defineProperty(_Object$assign3, "& .".concat(we["cell--textCenter"], ".").concat(we["cell--withRenderer"], ", & .").concat(we["cell--textCenter"], ".").concat(we["cell--editing"]), {
      justifyContent: "center"
    }), _defineProperty(_Object$assign3, "& .".concat(we.columnHeaderDraggableContainer), {
      display: "flex",
      width: "100%"
    }), _defineProperty(_Object$assign3, "& .".concat(we["columnHeader--dragging"]), {
      background: e.palette.background.paper,
      padding: "0 12px",
      borderRadius: e.shape.borderRadius,
      opacity: e.palette.action.disabledOpacity
    }), _defineProperty(_Object$assign3, "& .".concat(we.treeDataGroupingCell), {
      display: "flex",
      alignItems: "center",
      width: "100%"
    }), _defineProperty(_Object$assign3, "& .".concat(we.treeDataGroupingCellToggle), {
      flex: "0 0 28px",
      alignSelf: "stretch",
      marginRight: e.spacing(2)
    }), _Object$assign3));
  }),
      En = React__namespace.forwardRef(function (t, r) {
    var l;
    var o = ye(),
        n = t.children,
        a = t.className,
        i = Re(t, ["children", "className"]),
        s = Ce(),
        c = Er(s, Gr),
        u = Er(s, Rr),
        d = React__namespace.useRef(null),
        p = useForkRef(d, r);
    return s.current.rootElementRef = d, React__namespace.createElement(NoSsr, null, React__namespace.createElement(yn, Object.assign({
      ref: p,
      className: clsx(a, null === (l = o.classes) || void 0 === l ? void 0 : l.root, we.root, _defineProperty({}, we.autoHeight, o.autoHeight)),
      role: "grid",
      "aria-colcount": c,
      "aria-rowcount": u,
      "aria-multiselectable": !o.disableMultipleSelection,
      "aria-label": o["aria-label"],
      "aria-labelledby": o["aria-labelledby"]
    }, i), n));
  }),
      Sn = styled$1("div", {
    name: "MuiDataGrid",
    slot: "FooterContainer",
    overridesResolver: function overridesResolver(e, t) {
      return t.footerContainer;
    }
  })(function () {
    return {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      minHeight: 52
    };
  }),
      Rn = React__namespace.forwardRef(function (t, r) {
    var l = t.className,
        o = Re(t, ["className"]),
        a = function (e) {
      var t = e.classes;
      return composeClasses({
        root: ["footerContainer"]
      }, ve, t);
    }({
      classes: ye().classes
    });

    return React__namespace.createElement(Sn, Object.assign({
      ref: r,
      className: clsx(a.root, l)
    }, o));
  });
  var Pn;

  function xn(t, r, l, o) {
    var n = React__namespace.useRef(null),
        a = React__namespace.useRef();

    if (a.current = l, !n.current && a.current) {
      var _e9 = function _e9(e, t, r) {
        var l;
        t.defaultMuiPrevented || null === (l = a.current) || void 0 === l || l.call(a, e, t, r);
      };

      n.current = t.current.subscribeEvent(r, _e9, o);
    } else !a.current && n.current && (n.current(), n.current = null);

    React__namespace.useEffect(function () {
      if (!n.current && a.current) {
        var _e10 = function _e10(e, t, r) {
          var l;
          t.defaultMuiPrevented || null === (l = a.current) || void 0 === l || l.call(a, e, t, r);
        };

        n.current = t.current.subscribeEvent(r, _e10, o);
      }

      return function () {
        var e;
        null === (e = n.current) || void 0 === e || e.call(n), n.current = null;
      };
    }, [t, r, o]);
  }

  !function (e) {
    e.DataGrid = "DataGrid", e.DataGridPro = "DataGridPro";
  }(Pn || (Pn = {}));
  var kn = {
    isFirst: !0
  };

  function Mn(e, t, r) {
    xn(e, t, r, kn);
  }

  var Ln = styled$1("div", {
    name: "MuiDataGrid",
    slot: "Overlay",
    overridesResolver: function overridesResolver(e, t) {
      return t.overlay;
    }
  })(function (_ref320) {
    var e = _ref320.theme;
    return {
      display: "flex",
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      alignSelf: "center",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: alpha(e.palette.background.default, e.palette.action.disabledOpacity)
    };
  }),
      Fn = React__namespace.forwardRef(function (t, r) {
    var l, o;

    var a = t.className,
        i = t.style,
        s = Re(t, ["className", "style"]),
        c = Ce(),
        u = ye(),
        d = function (e) {
      var t = e.classes;
      return composeClasses({
        root: ["overlay"]
      }, ve, t);
    }({
      classes: u.classes
    }),
        p = Er(c, pl),
        _React__namespace$use115 = React__namespace.useState(function () {
      var e, t;
      return null !== (t = null === (e = c.current.getRootDimensions()) || void 0 === e ? void 0 : e.viewportInnerSize) && void 0 !== t ? t : null;
    }),
        _React__namespace$use116 = _slicedToArray(_React__namespace$use115, 2),
        m = _React__namespace$use116[0],
        f = _React__namespace$use116[1];

    xn(c, ge.viewportInnerSizeChange, function () {
      var e, t;
      return f(null !== (t = null === (e = c.current.getRootDimensions()) || void 0 === e ? void 0 : e.viewportInnerSize) && void 0 !== t ? t : null);
    });
    var b = null !== (l = null == m ? void 0 : m.height) && void 0 !== l ? l : 0;
    return u.autoHeight && 0 === b && (b = "auto"), React__namespace.createElement(Ln, Object.assign({
      ref: r,
      className: clsx(d.root, a),
      style: Object.assign({
        height: b,
        width: null !== (o = null == m ? void 0 : m.width) && void 0 !== o ? o : 0,
        top: p,
        position: "absolute",
        left: 0
      }, i)
    }, s));
  }),
      Dn = styled$1("div", {
    name: "MuiDataGrid",
    slot: "ToolbarContainer",
    overridesResolver: function overridesResolver(e, t) {
      return t.toolbarContainer;
    }
  })(function (_ref321) {
    var e = _ref321.theme;
    return {
      display: "flex",
      alignItems: "center",
      padding: e.spacing(.5, .5, 0)
    };
  }),
      In = React__namespace.forwardRef(function (t, r) {
    var l = t.className,
        o = t.children,
        a = Re(t, ["className", "children"]),
        i = function (e) {
      var t = e.classes;
      return composeClasses({
        root: ["toolbarContainer"]
      }, ve, t);
    }({
      classes: ye().classes
    });

    return o ? React__namespace.createElement(Dn, Object.assign({
      ref: r,
      className: clsx(l, i.root)
    }, a), o) : null;
  }),
      jn = styled$1("div", {
    name: "MuiDataGrid",
    slot: "IconButtonContainer",
    overridesResolver: function overridesResolver(e, t) {
      return t.iconButtonContainer;
    }
  })(function () {
    return {
      display: "flex",
      visibility: "hidden",
      width: 0
    };
  }),
      Tn = React__namespace.forwardRef(function (t, r) {
    var l = t.className,
        o = Re(t, ["className"]),
        a = function (e) {
      var t = e.classes;
      return composeClasses({
        root: ["iconButtonContainer"]
      }, ve, t);
    }({
      classes: ye().classes
    });

    return React__namespace.createElement(jn, Object.assign({
      ref: r,
      className: clsx(a.root, l)
    }, o));
  });
  var Hn = React__namespace.memo(function (t) {
    var r = t.direction,
        l = t.index,
        o = Ce(),
        a = ye(),
        i = function (e) {
      var t = e.classes;
      return composeClasses({
        icon: ["sortIcon"]
      }, ve, t);
    }(Object.assign(Object.assign({}, t), {
      classes: a.classes
    })),
        s = function (t, r, l) {
      var o = t.ColumnUnsortedIcon;
      return "asc" === r ? o = t.ColumnSortedAscendingIcon : "desc" === r && (o = t.ColumnSortedDescendingIcon), o ? React__namespace.createElement(o, {
        fontSize: "small",
        className: l
      }) : null;
    }(a.components, r, i.icon);

    if (!s) return null;
    var c = React__namespace.createElement(IconButton$2, {
      tabIndex: -1,
      "aria-label": o.current.getLocaleText("columnHeaderSortIconLabel"),
      title: o.current.getLocaleText("columnHeaderSortIconLabel"),
      size: "small"
    }, s);
    return React__namespace.createElement(Tn, null, null != l && React__namespace.createElement(A$1, {
      badgeContent: l,
      color: "default"
    }, c), null == l && c);
  });

  function An(e) {
    return null != e && e.classList.contains(we.columnHeader);
  }

  function $n(e) {
    return e.replace(/["\\]/g, "\\$&");
  }

  function zn(e, t) {
    return e.querySelector(".".concat(we.row, "[data-id=\"").concat($n(String(t)), "\"]"));
  }

  var Nn = styled$1("div", {
    name: "MuiDataGrid",
    slot: "ColumnHeaderTitle",
    overridesResolver: function overridesResolver(e, t) {
      return t.columnHeaderTitle;
    }
  })(function (_ref322) {
    var e = _ref322.theme;
    return {
      textOverflow: "ellipsis",
      overflow: "hidden",
      whiteSpace: "nowrap",
      fontWeight: e.typography.fontWeightMedium
    };
  }),
      _n = React__namespace.forwardRef(function (t, r) {
    var l = t.className,
        o = Re(t, ["className"]),
        a = function (e) {
      var t = e.classes;
      return composeClasses({
        root: ["columnHeaderTitle"]
      }, ve, t);
    }({
      classes: ye().classes
    });

    return React__namespace.createElement(Nn, Object.assign({
      ref: r,
      className: clsx(a.root, l)
    }, o));
  });

  function Vn(t) {
    var r = t.label,
        l = t.description,
        o = t.columnWidth,
        n = React__namespace.useRef(null),
        _React__namespace$use117 = React__namespace.useState(""),
        _React__namespace$use118 = _slicedToArray(_React__namespace$use117, 2),
        a = _React__namespace$use118[0],
        i = _React__namespace$use118[1];

    return React__namespace.useEffect(function () {
      if (!l && n && n.current) {
        var _t9 = (e = n.current).scrollHeight > e.clientHeight || e.scrollWidth > e.clientWidth;

        i(_t9 ? r : "");
      }

      var e;
    }, [n, o, l, r]), React__namespace.createElement($$1, {
      title: l || a
    }, React__namespace.createElement(_n, {
      ref: n
    }, r));
  }

  var Bn = React__namespace.memo(function (t) {
    var r = t.resizable,
        l = t.resizing,
        o = t.height,
        a = Re(t, ["resizable", "resizing", "height"]),
        i = ye(),
        s = function (e) {
      var t = e.resizable,
          r = e.resizing,
          l = e.classes;
      return composeClasses({
        root: ["columnSeparator", t && "columnSeparator--resizable", r && "columnSeparator--resizing"],
        icon: ["iconSeparator"]
      }, ve, l);
    }(Object.assign(Object.assign({}, t), {
      classes: i.classes
    })),
        c = React__namespace.useCallback(function (e) {
      e.preventDefault(), e.stopPropagation();
    }, []);

    return React__namespace.createElement("div", Object.assign({
      className: s.root,
      style: {
        minHeight: o,
        opacity: i.showColumnRightBorder ? 0 : 1
      }
    }, a, {
      onClick: c
    }), React__namespace.createElement(i.components.ColumnResizeIcon, {
      className: s.icon
    }));
  }),
      Gn = React__namespace.memo(function (t) {
    var r = t.column,
        l = t.open,
        o = t.columnMenuId,
        a = t.columnMenuButtonId,
        i = t.iconButtonRef,
        s = Ce(),
        c = ye(),
        u = function (e) {
      var t = e.classes,
          r = e.open;
      return composeClasses({
        root: ["menuIcon", r && "menuOpen"],
        button: ["menuIconButton"]
      }, ve, t);
    }(Object.assign(Object.assign({}, t), {
      classes: c.classes
    })),
        d = React__namespace.useCallback(function (e) {
      e.preventDefault(), e.stopPropagation(), s.current.toggleColumnMenu(r.field);
    }, [s, r.field]);

    return React__namespace.createElement("div", {
      className: u.root
    }, React__namespace.createElement(IconButton$2, {
      ref: i,
      tabIndex: -1,
      className: u.button,
      "aria-label": s.current.getLocaleText("columnMenuLabel"),
      title: s.current.getLocaleText("columnMenuLabel"),
      size: "small",
      onClick: d,
      "aria-expanded": l ? "true" : void 0,
      "aria-haspopup": "true",
      "aria-controls": o,
      id: a
    }, React__namespace.createElement(c.components.ColumnMenuIcon, {
      fontSize: "small"
    })));
  }),
      Wn = function Wn(e) {
    return e.preferencePanel;
  };

  var Un;
  !function (e) {
    e.filters = "filters", e.columns = "columns";
  }(Un || (Un = {}));

  function Kn(t) {
    var r = t.counter,
        l = Ce(),
        o = ye(),
        a = function (e) {
      var t = e.classes;
      return composeClasses({
        icon: ["filterIcon"]
      }, ve, t);
    }(Object.assign(Object.assign({}, t), {
      classes: o.classes
    })),
        i = React__namespace.useCallback(function (e) {
      e.preventDefault(), e.stopPropagation();

      var _Wn = Wn(l.current.state),
          t = _Wn.open,
          r = _Wn.openedPanelValue;

      t && r === Un.filters ? l.current.hideFilterPanel() : l.current.showFilterPanel();
    }, [l]);

    if (!r) return null;
    var s = React__namespace.createElement(IconButton$2, {
      onClick: i,
      color: "default",
      "aria-label": l.current.getLocaleText("columnHeaderFiltersLabel"),
      size: "small",
      tabIndex: -1
    }, React__namespace.createElement(o.components.ColumnFilteredIcon, {
      className: a.icon,
      fontSize: "small"
    }));
    return React__namespace.createElement($$1, {
      title: l.current.getLocaleText("columnHeaderFiltersTooltipActive")(r),
      enterDelay: 1e3
    }, React__namespace.createElement(Tn, null, r > 1 && React__namespace.createElement(A$1, {
      badgeContent: r,
      color: "default"
    }, s), 1 === r && s));
  }

  function qn(_ref323) {
    var t = _ref323.columnMenuId,
        r = _ref323.columnMenuButtonId,
        l = _ref323.ContentComponent,
        o = _ref323.contentComponentProps,
        n = _ref323.field,
        a = _ref323.open,
        i = _ref323.target;
    var s = Ce(),
        c = s.current.getColumn(n),
        u = React__namespace.useCallback(function (e) {
      e.stopPropagation(), s.current.hideColumnMenu();
    }, [s]);
    return i ? React__namespace.createElement(bo, {
      placement: "bottom-" + ("right" === c.align ? "start" : "end"),
      open: a,
      target: i,
      onClickAway: u
    }, React__namespace.createElement(l, Object.assign({
      currentColumn: c,
      hideMenu: u,
      open: a,
      id: t,
      labelledby: r
    }, o))) : null;
  }

  function Zn(t) {
    var r, l, o;

    var a = t.column,
        i = t.columnMenuOpen,
        s = t.colIndex,
        c = t.headerHeight,
        u = t.isResizing,
        d = t.isLastColumn,
        p = t.sortDirection,
        m = t.sortIndex,
        f = t.filterItemsCounter,
        b = t.hasFocus,
        h = t.tabIndex,
        C = t.extendRowFullWidth,
        v = Ce(),
        w = ye(),
        y = React__namespace.useRef(null),
        E = useId(),
        S = useId(),
        R = React__namespace.useRef(null),
        _ref324 = null !== (r = v.current.getRootDimensions()) && void 0 !== r ? r : {
      hasScrollX: !1,
      hasScrollY: !1
    },
        P = _ref324.hasScrollX,
        x = _ref324.hasScrollY;

    var k = null;
    a.renderHeader && (k = a.renderHeader(v.current.getColumnHeaderParams(a.field)));

    var M = React__namespace.useCallback(function (e) {
      return function (t) {
        t.currentTarget.contains(t.target) && v.current.publishEvent(e, v.current.getColumnHeaderParams(a.field), t);
      };
    }, [v, a.field]),
        L = {
      onClick: M(ge.columnHeaderClick),
      onDoubleClick: M(ge.columnHeaderDoubleClick),
      onMouseOver: M(ge.columnHeaderOver),
      onMouseOut: M(ge.columnHeaderOut),
      onMouseEnter: M(ge.columnHeaderEnter),
      onMouseLeave: M(ge.columnHeaderLeave),
      onKeyDown: M(ge.columnHeaderKeyDown),
      onFocus: M(ge.columnHeaderFocus),
      onBlur: M(ge.columnHeaderBlur)
    },
        F = {
      onDragStart: M(ge.columnHeaderDragStart),
      onDragEnter: M(ge.columnHeaderDragEnter),
      onDragOver: M(ge.columnHeaderDragOver),
      onDragEnd: M(ge.columnHeaderDragEnd)
    },
        D = d ? !(d && P && !x) && !C : w.showColumnRightBorder,
        I = function (e) {
      var t = e.column,
          r = e.classes,
          l = e.isDragging,
          o = e.sortDirection,
          a = e.showRightBorder,
          i = null != o,
          s = "number" === t.type,
          c = {
        root: ["columnHeader", "left" === t.headerAlign && "columnHeader--alignLeft", "center" === t.headerAlign && "columnHeader--alignCenter", "right" === t.headerAlign && "columnHeader--alignRight", t.sortable && "columnHeader--sortable", l && "columnHeader--moving", i && "columnHeader--sorted", s && "columnHeader--numeric", a && "withBorder"],
        draggableContainer: ["columnHeaderDraggableContainer"],
        titleContainer: ["columnHeaderTitleContainer"]
      };
      return composeClasses(c, ve, r);
    }(Object.assign(Object.assign({}, t), {
      classes: w.classes,
      showRightBorder: D
    })),
        j = a.computedWidth;

    var T;
    null != p && (T = "asc" === p ? "ascending" : "descending");
    var H = !w.disableColumnMenu && !a.disableColumnMenu && React__namespace.createElement(Gn, {
      column: a,
      columnMenuId: E,
      columnMenuButtonId: S,
      open: i,
      iconButtonRef: R
    }),
        A = React__namespace.createElement(React__namespace.Fragment, null, !w.disableColumnFilter && React__namespace.createElement(Kn, {
      counter: f
    }), a.sortable && !a.hideSortIcons && React__namespace.createElement(Hn, {
      direction: p,
      index: m
    }));
    React__namespace.useLayoutEffect(function () {
      var e = v.current.state.columnMenu;

      if (b && !e.open) {
        var _e11 = y.current.querySelector('[tabindex="0"]');

        _e11 ? _e11.focus() : y.current.focus();
      }
    });
    var $ = "function" == typeof a.headerClassName ? a.headerClassName({
      field: a.field,
      colDef: a
    }) : a.headerClassName;
    return React__namespace.createElement("div", Object.assign({
      ref: y,
      className: clsx(I.root, $),
      "data-field": a.field,
      style: {
        width: j,
        minWidth: j,
        maxWidth: j
      },
      role: "columnheader",
      tabIndex: h,
      "aria-colindex": s + 1,
      "aria-sort": T
    }, L), React__namespace.createElement("div", Object.assign({
      className: I.draggableContainer,
      draggable: !w.disableColumnReorder && !a.disableReorder
    }, F), React__namespace.createElement("div", {
      className: I.titleContainer
    }, k || React__namespace.createElement(Vn, {
      label: null !== (l = a.headerName) && void 0 !== l ? l : a.field,
      description: a.description,
      columnWidth: j
    }), A), H), React__namespace.createElement(Bn, {
      resizable: !w.disableColumnResize && !!a.resizable,
      resizing: u,
      height: c,
      onMouseDown: M(ge.columnSeparatorMouseDown)
    }), React__namespace.createElement(qn, {
      columnMenuId: E,
      columnMenuButtonId: S,
      field: a.field,
      open: i,
      target: R.current,
      ContentComponent: w.components.ColumnMenu,
      contentComponentProps: null === (o = w.componentsProps) || void 0 === o ? void 0 : o.columnMenu
    }));
  }

  var Yn = function Yn(t) {
    var r = t.onClick,
        l = Ce(),
        o = ye(),
        n = React__namespace.useCallback(function (e) {
      r(e), l.current.showPreferences(Un.columns);
    }, [l, r]);
    return o.disableColumnSelector ? null : React__namespace.createElement(BaseMenuItem, {
      onClick: n
    }, l.current.getLocaleText("columnMenuShowColumns"));
  },
      Xn = function Xn(t) {
    var r = t.column,
        l = t.onClick,
        o = Ce(),
        n = ye(),
        a = React__namespace.useCallback(function (e) {
      l(e), o.current.showFilterPanel(null == r ? void 0 : r.field);
    }, [o, null == r ? void 0 : r.field, l]);
    return n.disableColumnFilter || !(null == r ? void 0 : r.filterable) ? null : React__namespace.createElement(BaseMenuItem, {
      onClick: a
    }, o.current.getLocaleText("columnMenuFilter"));
  },
      Jn = React__namespace.forwardRef(function (t, r) {
    var l = t.hideMenu,
        o = t.currentColumn,
        n = t.open,
        a = t.id,
        i = t.labelledby,
        s = t.className,
        c = t.children,
        u = Re(t, ["hideMenu", "currentColumn", "open", "id", "labelledby", "className", "children"]),
        d = React__namespace.useCallback(function (e) {
      So(e.key) && e.preventDefault(), jo(e.key) && l(e);
    }, [l]);
    return React__namespace.createElement(BaseMenuList, Object.assign({
      id: a,
      ref: r,
      className: clsx(we.menuList, s),
      "aria-labelledby": i,
      onKeyDown: d,
      autoFocus: n
    }, u), c);
  }),
      Qn = function Qn(t) {
    var r = t.column,
        l = t.onClick,
        o = Ce(),
        n = ye(),
        a = React__namespace.useRef(),
        i = React__namespace.useCallback(function (e) {
      l(e), a.current = setTimeout(function () {
        o.current.setColumnVisibility(null == r ? void 0 : r.field, !1);
      }, 100);
    }, [o, null == r ? void 0 : r.field, l]);
    return React__namespace.useEffect(function () {
      return function () {
        return clearTimeout(a.current);
      };
    }, []), n.disableColumnSelector ? null : React__namespace.createElement(BaseMenuItem, {
      onClick: i
    }, o.current.getLocaleText("columnMenuHideColumn"));
  },
      ea = function ea(t) {
    var r = t.column,
        l = t.onClick,
        o = Ce(),
        n = Er(o, jr),
        a = React__namespace.useMemo(function () {
      if (!r) return null;
      var e = n.find(function (e) {
        return e.field === r.field;
      });
      return null == e ? void 0 : e.sort;
    }, [r, n]),
        i = React__namespace.useCallback(function (e) {
      l(e);
      var t = e.currentTarget.getAttribute("data-value") || null;
      o.current.sortColumn(r, t);
    }, [o, r, l]);
    return r && r.sortable ? React__namespace.createElement(React__namespace.Fragment, null, React__namespace.createElement(BaseMenuItem, {
      onClick: i,
      disabled: null == a
    }, o.current.getLocaleText("columnMenuUnsort")), React__namespace.createElement(BaseMenuItem, {
      onClick: i,
      "data-value": "asc",
      disabled: "asc" === a
    }, o.current.getLocaleText("columnMenuSortAsc")), React__namespace.createElement(BaseMenuItem, {
      onClick: i,
      "data-value": "desc",
      disabled: "desc" === a
    }, o.current.getLocaleText("columnMenuSortDesc"))) : null;
  },
      ta = React__namespace.forwardRef(function (t, r) {
    var l = t.hideMenu,
        o = t.currentColumn;
    return React__namespace.createElement(Jn, Object.assign({
      ref: r
    }, t), React__namespace.createElement(ea, {
      onClick: l,
      column: o
    }), React__namespace.createElement(Xn, {
      onClick: l,
      column: o
    }), React__namespace.createElement(Qn, {
      onClick: l,
      column: o
    }), React__namespace.createElement(Yn, {
      onClick: l,
      column: o
    }));
  }),
      ra = styled$1("div", {
    name: "MuiDataGrid",
    slot: "PanelContent",
    overridesResolver: function overridesResolver(e, t) {
      return t.panelContent;
    }
  })({
    display: "flex",
    flexDirection: "column",
    overflow: "auto",
    flex: "1 1",
    maxHeight: 400
  });

  function la(t) {
    var r = t.className,
        l = Re(t, ["className"]),
        o = function (e) {
      var t = e.classes;
      return composeClasses({
        root: ["panelContent"]
      }, ve, t);
    }({
      classes: ye().classes
    });

    return React__namespace.createElement(ra, Object.assign({
      className: clsx(r, o.root)
    }, l));
  }

  var oa = styled$1("div", {
    name: "MuiDataGrid",
    slot: "PanelFooter",
    overridesResolver: function overridesResolver(e, t) {
      return t.panelFooter;
    }
  })(function (_ref325) {
    var e = _ref325.theme;
    return {
      padding: e.spacing(.5),
      display: "flex",
      justifyContent: "space-between"
    };
  });

  function na(t) {
    var r = t.className,
        l = Re(t, ["className"]),
        o = function (e) {
      var t = e.classes;
      return composeClasses({
        root: ["panelFooter"]
      }, ve, t);
    }({
      classes: ye().classes
    });

    return React__namespace.createElement(oa, Object.assign({
      className: clsx(r, o.root)
    }, l));
  }

  var aa = styled$1("div", {
    name: "MuiDataGrid",
    slot: "PanelHeader",
    overridesResolver: function overridesResolver(e, t) {
      return t.panelHeader;
    }
  })(function (_ref326) {
    var e = _ref326.theme;
    return {
      padding: e.spacing(1)
    };
  });

  function ia(t) {
    var r = t.className,
        l = Re(t, ["className"]),
        o = function (e) {
      var t = e.classes;
      return composeClasses({
        root: ["panelHeader"]
      }, ve, t);
    }({
      classes: ye().classes
    });

    return React__namespace.createElement(aa, Object.assign({
      className: clsx(r, o.root)
    }, l));
  }

  var sa = styled$1("div", {
    name: "MuiDataGrid",
    slot: "PanelWrapper",
    overridesResolver: function overridesResolver(e, t) {
      return t.panelWrapper;
    }
  })({
    display: "flex",
    flexDirection: "column",
    flex: 1,
    "&:focus": {
      outline: 0
    }
  }),
      ca = function ca() {
    return !0;
  };

  function ua(t) {
    var r = t.className,
        l = Re(t, ["className"]),
        o = function (e) {
      var t = e.classes;
      return composeClasses({
        root: ["panelWrapper"]
      }, ve, t);
    }({
      classes: ye().classes
    });

    return React__namespace.createElement(Unstable_TrapFocus, {
      open: !0,
      disableEnforceFocus: !0,
      isEnabled: ca
    }, React__namespace.createElement(sa, Object.assign({
      tabIndex: -1,
      className: clsx(r, o.root)
    }, l)));
  }

  var da = !1;
  "undefined" != typeof process && void 0 !== process.env.GRID_EXPERIMENTAL_ENABLED && hr() && window.localStorage.getItem("GRID_EXPERIMENTAL_ENABLED") ? da = "true" === window.localStorage.getItem("GRID_EXPERIMENTAL_ENABLED") : "undefined" != typeof process && (da = "true" === process.env.GRID_EXPERIMENTAL_ENABLED);
  var pa = da,
      ma = {
    noRowsLabel: "No rows",
    noResultsOverlayLabel: "No results found.",
    errorOverlayDefaultLabel: "An error occurred.",
    toolbarDensity: "Density",
    toolbarDensityLabel: "Density",
    toolbarDensityCompact: "Compact",
    toolbarDensityStandard: "Standard",
    toolbarDensityComfortable: "Comfortable",
    toolbarColumns: "Columns",
    toolbarColumnsLabel: "Select columns",
    toolbarFilters: "Filters",
    toolbarFiltersLabel: "Show filters",
    toolbarFiltersTooltipHide: "Hide filters",
    toolbarFiltersTooltipShow: "Show filters",
    toolbarFiltersTooltipActive: function toolbarFiltersTooltipActive(e) {
      return 1 !== e ? "".concat(e, " active filters") : "".concat(e, " active filter");
    },
    toolbarExport: "Export",
    toolbarExportLabel: "Export",
    toolbarExportCSV: "Download as CSV",
    toolbarExportPrint: "Print",
    columnsPanelTextFieldLabel: "Find column",
    columnsPanelTextFieldPlaceholder: "Column title",
    columnsPanelDragIconLabel: "Reorder column",
    columnsPanelShowAllButton: "Show all",
    columnsPanelHideAllButton: "Hide all",
    filterPanelAddFilter: "Add filter",
    filterPanelDeleteIconLabel: "Delete",
    filterPanelOperators: "Operators",
    filterPanelOperatorAnd: "And",
    filterPanelOperatorOr: "Or",
    filterPanelColumns: "Columns",
    filterPanelInputLabel: "Value",
    filterPanelInputPlaceholder: "Filter value",
    filterOperatorContains: "contains",
    filterOperatorEquals: "equals",
    filterOperatorStartsWith: "starts with",
    filterOperatorEndsWith: "ends with",
    filterOperatorIs: "is",
    filterOperatorNot: "is not",
    filterOperatorAfter: "is after",
    filterOperatorOnOrAfter: "is on or after",
    filterOperatorBefore: "is before",
    filterOperatorOnOrBefore: "is on or before",
    filterOperatorIsEmpty: "is empty",
    filterOperatorIsNotEmpty: "is not empty",
    filterValueAny: "any",
    filterValueTrue: "true",
    filterValueFalse: "false",
    columnMenuLabel: "Menu",
    columnMenuShowColumns: "Show columns",
    columnMenuFilter: "Filter",
    columnMenuHideColumn: "Hide",
    columnMenuUnsort: "Unsort",
    columnMenuSortAsc: "Sort by ASC",
    columnMenuSortDesc: "Sort by DESC",
    columnHeaderFiltersTooltipActive: function columnHeaderFiltersTooltipActive(e) {
      return 1 !== e ? "".concat(e, " active filters") : "".concat(e, " active filter");
    },
    columnHeaderFiltersLabel: "Show filters",
    columnHeaderSortIconLabel: "Sort",
    footerRowSelected: function footerRowSelected(e) {
      return 1 !== e ? "".concat(e.toLocaleString(), " rows selected") : "".concat(e.toLocaleString(), " row selected");
    },
    footerTotalRows: "Total Rows:",
    footerTotalVisibleRows: function footerTotalVisibleRows(e, t) {
      return "".concat(e.toLocaleString(), " of ").concat(t.toLocaleString());
    },
    checkboxSelectionHeaderName: "Checkbox selection",
    booleanCellTrueLabel: "true",
    booleanCellFalseLabel: "false",
    actionsCellMore: "more",
    treeDataGroupingHeaderName: "Group",
    treeDataExpand: "see children",
    treeDataCollapse: "hide children",
    MuiTablePagination: {}
  },
      fa = styled$1("div", {
    name: "MuiDataGrid",
    slot: "ColumnsPanel",
    overridesResolver: function overridesResolver(e, t) {
      return t.columnsPanel;
    }
  })(function () {
    return {
      padding: "8px 0px 8px 8px"
    };
  }),
      ba = styled$1("div", {
    name: "MuiDataGrid",
    slot: "ColumnsPanelRow",
    overridesResolver: function overridesResolver(e, t) {
      return t.columnsPanelRow;
    }
  })(function (_ref327) {
    var e = _ref327.theme;
    return _defineProperty({
      display: "flex",
      justifyContent: "space-between",
      padding: "1px 8px 1px 7px"
    }, "& .".concat(N$1.root), {
      marginRight: e.spacing(.5)
    });
  }),
      ga = styled$1(IconButton$2)({
    justifyContent: "flex-end"
  });

  function ha() {
    var t = Ce(),
        r = React__namespace.useRef(null),
        l = Er(t, zr),
        o = ye(),
        _React__namespace$use119 = React__namespace.useState(""),
        _React__namespace$use120 = _slicedToArray(_React__namespace$use119, 2),
        a = _React__namespace$use120[0],
        i = _React__namespace$use120[1],
        s = function (e) {
      var t = e.classes;
      return composeClasses({
        root: ["columnsPanel"],
        columnsPanelRow: ["columnsPanelRow"]
      }, ve, t);
    }({
      classes: o.classes
    }),
        c = React__namespace.useCallback(function (e) {
      var r = e.target.name,
          l = t.current.getColumn(r);
      t.current.setColumnVisibility(r, !!l.hide);
    }, [t]),
        u = React__namespace.useCallback(function (e) {
      t.current.updateColumns(l.map(function (t) {
        return t.hide = e, t;
      }));
    }, [t, l]),
        d = React__namespace.useCallback(function () {
      return u(!1);
    }, [u]),
        p = React__namespace.useCallback(function () {
      return u(!0);
    }, [u]),
        m = React__namespace.useCallback(function (e) {
      i(e.target.value);
    }, []),
        f = React__namespace.useMemo(function () {
      return a ? l.filter(function (e) {
        return e.field.toLowerCase().indexOf(a.toLowerCase()) > -1 || e.headerName && e.headerName.toLowerCase().indexOf(a.toLowerCase()) > -1;
      }) : l;
    }, [l, a]);

    return React__namespace.useEffect(function () {
      r.current.focus();
    }, []), React__namespace.createElement(ua, null, React__namespace.createElement(ia, null, React__namespace.createElement(BaseTextField, {
      label: t.current.getLocaleText("columnsPanelTextFieldLabel"),
      placeholder: t.current.getLocaleText("columnsPanelTextFieldPlaceholder"),
      inputRef: r,
      value: a,
      onChange: m,
      variant: "standard",
      fullWidth: !0
    })), React__namespace.createElement(la, null, React__namespace.createElement(fa, {
      className: s.root
    }, f.map(function (r) {
      return React__namespace.createElement(ba, {
        className: s.columnsPanelRow,
        key: r.field
      }, React__namespace.createElement(BaseFormControlLabel, {
        control: React__namespace.createElement(z$1, {
          checked: !r.hide,
          onClick: c,
          name: r.field,
          color: "primary",
          size: "small"
        }),
        label: r.headerName || r.field
      }), !o.disableColumnReorder && pa && React__namespace.createElement(ga, {
        draggable: !0,
        "aria-label": t.current.getLocaleText("columnsPanelDragIconLabel"),
        title: t.current.getLocaleText("columnsPanelDragIconLabel"),
        size: "small",
        disabled: !0
      }, React__namespace.createElement($l, null)));
    }))), React__namespace.createElement(na, null, React__namespace.createElement(BaseButton, {
      onClick: p,
      color: "primary"
    }, t.current.getLocaleText("columnsPanelHideAllButton")), React__namespace.createElement(BaseButton, {
      onClick: d,
      color: "primary"
    }, t.current.getLocaleText("columnsPanelShowAllButton"))));
  }

  var Ca = generateUtilityClasses("MuiDataGrid", ["panel", "paper"]),
      va = styled$1(BasePopper, {
    name: "MuiDataGrid",
    slot: "Panel",
    overridesResolver: function overridesResolver(e, t) {
      return t.panel;
    }
  })(function (_ref329) {
    var e = _ref329.theme;
    return {
      zIndex: e.zIndex.modal
    };
  }),
      wa = styled$1(BasePaper, {
    name: "MuiDataGrid",
    slot: "Paper",
    overridesResolver: function overridesResolver(e, t) {
      return t.paper;
    }
  })(function (_ref330) {
    var e = _ref330.theme;
    return {
      backgroundColor: e.palette.background.paper,
      minWidth: 300,
      maxHeight: 450,
      display: "flex"
    };
  }),
      Oa = React__namespace.forwardRef(function (t, r) {
    var l;

    var o = t.children,
        n = t.className,
        a = t.open,
        i = t.classes,
        s = Re(t, ["children", "className", "open", "classes"]),
        c = Ce(),
        u = Ca,
        _React__namespace$use121 = React__namespace.useState(!1),
        _React__namespace$use122 = _slicedToArray(_React__namespace$use121, 2),
        d = _React__namespace$use122[0],
        p = _React__namespace$use122[1],
        m = React__namespace.useCallback(function () {
      c.current.hidePreferences();
    }, [c]),
        f = React__namespace.useCallback(function (e) {
      yo(e.key) && c.current.hidePreferences();
    }, [c]),
        b = null === (l = c.current.columnHeadersContainerElementRef) || void 0 === l ? void 0 : l.current;

    return b ? React__namespace.createElement(va, Object.assign({
      ref: r,
      placement: "bottom-start",
      className: clsx(n, u.panel),
      open: a,
      anchorEl: b,
      modifiers: [{
        name: "flip",
        enabled: !1
      }, {
        name: "isPlaced",
        enabled: !0,
        phase: "main",
        fn: function fn() {
          p(!0);
        }
      }]
    }, s), React__namespace.createElement(ClickAwayListener, {
      onClickAway: m
    }, React__namespace.createElement(wa, {
      className: u.paper,
      elevation: 8,
      onKeyDown: f
    }, d && o))) : null;
  }),
      ya = React__namespace.forwardRef(function (t, r) {
    var l, o, n;
    var a = Ce(),
        i = Er(a, zr),
        s = ye(),
        c = Er(a, Wn),
        u = c.openedPanelValue === Un.columns,
        d = !c.openedPanelValue || !u;
    return React__namespace.createElement(s.components.Panel, Object.assign({
      ref: r,
      open: i.length > 0 && c.open
    }, null === (l = s.componentsProps) || void 0 === l ? void 0 : l.panel, t), !s.disableColumnSelector && u && React__namespace.createElement(s.components.ColumnsPanel, Object.assign({}, null === (o = s.componentsProps) || void 0 === o ? void 0 : o.columnsPanel)), !s.disableColumnFilter && d && React__namespace.createElement(s.components.FilterPanel, Object.assign({}, null === (n = s.componentsProps) || void 0 === n ? void 0 : n.filterPanel)));
  }),
      Ea = styled$1("div", {
    name: "MuiDataGrid",
    slot: "FilterForm",
    overridesResolver: function overridesResolver(e, t) {
      return t.filterForm;
    }
  })(function (_ref331) {
    var e = _ref331.theme;
    return {
      display: "flex",
      justifyContent: "space-around",
      padding: e.spacing(1)
    };
  });

  function Sa(t) {
    var r;

    var l = t.item,
        o = t.hasMultipleFilters,
        a = t.deleteFilter,
        i = t.applyFilterChanges,
        s = t.multiFilterOperator,
        c = t.showMultiFilterOperators,
        u = t.disableMultiFilterOperator,
        d = t.applyMultiFilterOperatorChanges,
        p = t.focusElementRef,
        m = Ce(),
        f = Er(m, Vr),
        b = useId(),
        h = useId(),
        v = useId(),
        w = useId(),
        O = useId(),
        y = useId(),
        E = ye(),
        R = function (e) {
      var t = e.classes;
      return composeClasses({
        root: ["filterForm"]
      }, ve, t);
    }({
      classes: E.classes
    }),
        P = React__namespace.useRef(null),
        x = React__namespace.useRef(null),
        k = l.columnField ? m.current.getColumn(l.columnField) : null,
        M = React__namespace.useMemo(function () {
      var e;
      return l.operatorValue && k ? null === (e = k.filterOperators) || void 0 === e ? void 0 : e.find(function (e) {
        return e.value === l.operatorValue;
      }) : null;
    }, [l, k]),
        L = React__namespace.useCallback(function (e) {
      var t = e.target.value,
          r = m.current.getColumn(t).filterOperators[0];
      i(Object.assign(Object.assign({}, l), {
        value: void 0,
        columnField: t,
        operatorValue: r.value
      }));
    }, [m, i, l]),
        F = React__namespace.useCallback(function (e) {
      var t = e.target.value;
      i(Object.assign(Object.assign({}, l), {
        operatorValue: t
      }));
    }, [i, l]),
        I = React__namespace.useCallback(function (e) {
      var t = e.target.value === bn.And.toString() ? bn.And : bn.Or;
      d(t);
    }, [d]);

    return React__namespace.useImperativeHandle(p, function () {
      return {
        focus: function focus() {
          var e;
          (null == M ? void 0 : M.InputComponent) ? null === (e = null == P ? void 0 : P.current) || void 0 === e || e.focus() : x.current.focus();
        }
      };
    }, [M]), React__namespace.createElement(Ea, {
      className: R.root
    }, React__namespace.createElement(BaseFormControl, {
      variant: "standard",
      sx: {
        flexShrink: 0,
        justifyContent: "flex-end",
        marginRight: .5,
        marginBottom: .2
      }
    }, React__namespace.createElement(IconButton$2, {
      "aria-label": m.current.getLocaleText("filterPanelDeleteIconLabel"),
      title: m.current.getLocaleText("filterPanelDeleteIconLabel"),
      onClick: function onClick() {
        E.disableMultipleColumnsFiltering ? i(Object.assign(Object.assign({}, l), {
          value: void 0
        })) : a(l);
      },
      size: "small"
    }, React__namespace.createElement(Tl, {
      fontSize: "small"
    }))), React__namespace.createElement(BaseFormControl, {
      variant: "standard",
      sx: {
        minWidth: 60,
        display: o ? "block" : "none",
        visibility: c ? "visible" : "hidden"
      }
    }, React__namespace.createElement(BaseInputLabel, {
      htmlFor: b,
      id: h
    }, m.current.getLocaleText("filterPanelOperators")), React__namespace.createElement(D$1, {
      labelId: h,
      id: b,
      value: s,
      onChange: I,
      disabled: !!u,
      native: !0
    }, React__namespace.createElement("option", {
      key: bn.And.toString(),
      value: bn.And.toString()
    }, m.current.getLocaleText("filterPanelOperatorAnd")), React__namespace.createElement("option", {
      key: bn.Or.toString(),
      value: bn.Or.toString()
    }, m.current.getLocaleText("filterPanelOperatorOr")))), React__namespace.createElement(BaseFormControl, {
      variant: "standard",
      sx: {
        width: 150
      }
    }, React__namespace.createElement(BaseInputLabel, {
      htmlFor: v,
      id: w
    }, m.current.getLocaleText("filterPanelColumns")), React__namespace.createElement(D$1, {
      labelId: w,
      id: v,
      value: l.columnField || "",
      onChange: L,
      native: !0
    }, f.map(function (t) {
      return React__namespace.createElement("option", {
        key: t.field,
        value: t.field
      }, t.headerName || t.field);
    }))), React__namespace.createElement(BaseFormControl, {
      variant: "standard",
      sx: {
        width: 120
      }
    }, React__namespace.createElement(BaseInputLabel, {
      htmlFor: O,
      id: y
    }, m.current.getLocaleText("filterPanelOperators")), React__namespace.createElement(D$1, {
      labelId: y,
      id: O,
      value: l.operatorValue,
      onChange: F,
      native: !0,
      inputRef: x
    }, null === (r = null == k ? void 0 : k.filterOperators) || void 0 === r ? void 0 : r.map(function (t) {
      return React__namespace.createElement("option", {
        key: t.value,
        value: t.value
      }, t.label || m.current.getLocaleText("filterOperator".concat(capitalize$1(t.value))));
    }))), React__namespace.createElement(BaseFormControl, {
      variant: "standard",
      sx: {
        width: 190
      }
    }, (null == M ? void 0 : M.InputComponent) ? React__namespace.createElement(M.InputComponent, Object.assign({
      apiRef: m,
      item: l,
      applyValue: i,
      focusElementRef: P
    }, M.InputComponentProps)) : null));
  }

  function Ra() {
    var t = Ce(),
        r = ye(),
        l = Er(t, Kr),
        o = Er(t, Vr),
        n = React__namespace.useRef(null),
        a = React__namespace.useCallback(function (e) {
      t.current.upsertFilterItem(e);
    }, [t]),
        i = React__namespace.useCallback(function (e) {
      t.current.setFilterLinkOperator(e);
    }, [t]),
        s = React__namespace.useCallback(function () {
      var e = o.find(function (e) {
        var t;
        return null === (t = e.filterOperators) || void 0 === t ? void 0 : t.length;
      });
      return e ? {
        columnField: e.field,
        operatorValue: e.filterOperators[0].value,
        id: Math.round(1e5 * Math.random())
      } : null;
    }, [o]),
        c = React__namespace.useMemo(function () {
      if (l.items.length) return l.items;
      var e = s();
      return e ? [e] : [];
    }, [l.items, s]),
        u = c.length > 1,
        d = React__namespace.useCallback(function (e) {
      t.current.deleteFilterItem(e);
    }, [t]);
    return React__namespace.useEffect(function () {
      c.length > 0 && n.current.focus();
    }, [c.length]), React__namespace.createElement(ua, null, React__namespace.createElement(la, null, c.map(function (t, r) {
      return React__namespace.createElement(Sa, {
        key: null == t.id ? r : t.id,
        item: t,
        applyFilterChanges: a,
        deleteFilter: d,
        hasMultipleFilters: u,
        showMultiFilterOperators: r > 0,
        multiFilterOperator: l.linkOperator,
        disableMultiFilterOperator: 1 !== r,
        applyMultiFilterOperatorChanges: i,
        focusElementRef: r === c.length - 1 ? n : null
      });
    })), !r.disableMultipleColumnsFiltering && React__namespace.createElement(na, null, React__namespace.createElement(BaseButton, {
      onClick: function onClick() {
        var e = s();
        e && t.current.setFilterModel(Object.assign(Object.assign({}, l), {
          items: [].concat(_toConsumableArray(c), [e])
        }));
      },
      startIcon: React__namespace.createElement(Hl, null),
      color: "primary"
    }, t.current.getLocaleText("filterPanelAddFilter"))));
  }

  var Pa = React__namespace.forwardRef(function (t, r) {
    var l = t.onClick,
        o = Re(t, ["onClick"]),
        n = Ce(),
        a = ye(),
        _Er = Er(n, Wn),
        i = _Er.open,
        s = _Er.openedPanelValue;

    return a.disableColumnSelector ? null : React__namespace.createElement(BaseButton, Object.assign({
      ref: r,
      size: "small",
      color: "primary",
      "aria-label": n.current.getLocaleText("toolbarColumnsLabel"),
      startIcon: React__namespace.createElement(a.components.ColumnSelectorIcon, null)
    }, o, {
      onClick: function onClick(e) {
        i && s === Un.columns ? n.current.hidePreferences() : n.current.showPreferences(Un.columns), null == l || l(e);
      }
    }), n.current.getLocaleText("toolbarColumns"));
  }),
      xa = React__namespace.forwardRef(function (t, r) {
    var l = t.onClick,
        o = Re(t, ["onClick"]),
        n = Ce(),
        a = ye(),
        i = Er(n, ul),
        s = useId(),
        c = useId(),
        _React__namespace$use123 = React__namespace.useState(!1),
        _React__namespace$use124 = _slicedToArray(_React__namespace$use123, 2),
        u = _React__namespace$use124[0],
        d = _React__namespace$use124[1],
        p = React__namespace.useRef(null),
        m = useForkRef(r, p),
        b = [{
      icon: React__namespace.createElement(a.components.DensityCompactIcon, null),
      label: n.current.getLocaleText("toolbarDensityCompact"),
      value: gn.Compact
    }, {
      icon: React__namespace.createElement(a.components.DensityStandardIcon, null),
      label: n.current.getLocaleText("toolbarDensityStandard"),
      value: gn.Standard
    }, {
      icon: React__namespace.createElement(a.components.DensityComfortableIcon, null),
      label: n.current.getLocaleText("toolbarDensityComfortable"),
      value: gn.Comfortable
    }],
        h = React__namespace.useMemo(function () {
      switch (i) {
        case gn.Compact:
          return React__namespace.createElement(a.components.DensityCompactIcon, null);

        case gn.Comfortable:
          return React__namespace.createElement(a.components.DensityComfortableIcon, null);

        default:
          return React__namespace.createElement(a.components.DensityStandardIcon, null);
      }
    }, [i, a]),
        C = function C() {
      return d(!1);
    };

    if (a.disableDensitySelector) return null;
    var v = b.map(function (t, r) {
      return React__namespace.createElement(BaseMenuItem, {
        key: r,
        onClick: function onClick() {
          return e = t.value, n.current.setDensity(e), void d(!1);
          var e;
        },
        selected: t.value === i
      }, React__namespace.createElement(j, null, t.icon), t.label);
    });
    return React__namespace.createElement(React__namespace.Fragment, null, React__namespace.createElement(BaseButton, Object.assign({
      ref: m,
      color: "primary",
      size: "small",
      startIcon: h,
      "aria-label": n.current.getLocaleText("toolbarDensityLabel"),
      "aria-expanded": u ? "true" : void 0,
      "aria-haspopup": "menu",
      "aria-labelledby": c,
      id: s
    }, o, {
      onClick: function onClick(e) {
        d(!0), null == l || l(e);
      }
    }), n.current.getLocaleText("toolbarDensity")), React__namespace.createElement(bo, {
      open: u,
      target: p.current,
      onClickAway: C,
      position: "bottom-start"
    }, React__namespace.createElement(BaseMenuList, {
      id: c,
      className: we.menuList,
      "aria-labelledby": s,
      onKeyDown: function onKeyDown(e) {
        So(e.key) && e.preventDefault(), jo(e.key) && C();
      },
      autoFocusItem: u
    }, v)));
  }),
      ka = styled$1("ul", {
    name: "MuiDataGrid",
    slot: "ToolbarFilterList",
    overridesResolver: function overridesResolver(e, t) {
      return t.toolbarFilterList;
    }
  })(function (_ref332) {
    var e = _ref332.theme;
    return {
      margin: e.spacing(1, 1, .5),
      padding: e.spacing(0, 1)
    };
  }),
      Ma = React__namespace.forwardRef(function (t, r) {
    var _t$componentsProps = t.componentsProps,
        l = _t$componentsProps === void 0 ? {} : _t$componentsProps,
        o = Re(t, ["componentsProps"]),
        a = l.button || {},
        i = Ce(),
        s = ye(),
        c = Er(i, rl),
        u = Er(i, $r),
        d = Er(i, Wn),
        p = function (e) {
      var t = e.classes;
      return composeClasses({
        root: ["toolbarFilterList"]
      }, ve, t);
    }({
      classes: s.classes
    }),
        m = React__namespace.useMemo(function () {
      if (d.open) return i.current.getLocaleText("toolbarFiltersTooltipHide");
      if (0 === c.length) return i.current.getLocaleText("toolbarFiltersTooltipShow");
      return React__namespace.createElement("div", null, i.current.getLocaleText("toolbarFiltersTooltipActive")(c.length), React__namespace.createElement(ka, {
        className: p.root
      }, c.map(function (t, r) {
        return Object.assign({}, u[t.columnField] && React__namespace.createElement("li", {
          key: r
        }, "".concat(u[t.columnField].headerName || t.columnField, "\n                  ").concat(function (e) {
          return u[e.columnField].filterOperators.find(function (t) {
            return t.value === e.operatorValue;
          }).label || i.current.getLocaleText("filterOperator".concat(capitalize$1(e.operatorValue))).toString();
        }(t), "\n                  ").concat(t.value)));
      })));
    }, [i, d.open, c, u, p]);

    return s.disableColumnFilter ? null : React__namespace.createElement($$1, Object.assign({
      title: m,
      enterDelay: 1e3
    }, o), React__namespace.createElement(BaseButton, Object.assign({
      ref: r,
      size: "small",
      color: "primary",
      "aria-label": i.current.getLocaleText("toolbarFiltersLabel"),
      startIcon: React__namespace.createElement(A$1, {
        badgeContent: c.length,
        color: "primary"
      }, React__namespace.createElement(s.components.OpenFilterButtonIcon, null))
    }, a, {
      onClick: function onClick(e) {
        var t;
        var r = d.open,
            l = d.openedPanelValue;
        r && l === Un.filters ? i.current.hideFilterPanel() : i.current.showFilterPanel(), null === (t = a.onClick) || void 0 === t || t.call(a, e);
      }
    }), i.current.getLocaleText("toolbarFilters")));
  }),
      La = React__namespace.forwardRef(function (t, r) {
    var l = t.csvOptions,
        o = t.printOptions,
        n = t.onClick,
        a = Re(t, ["csvOptions", "printOptions", "onClick"]),
        i = Ce(),
        s = ye(),
        c = useId(),
        u = useId(),
        _React__namespace$use125 = React__namespace.useState(!1),
        _React__namespace$use126 = _slicedToArray(_React__namespace$use125, 2),
        d = _React__namespace$use126[0],
        p = _React__namespace$use126[1],
        m = React__namespace.useRef(null),
        b = useForkRef(r, m),
        h = [{
      label: i.current.getLocaleText("toolbarExportCSV"),
      format: "csv",
      formatOptions: l
    }, {
      label: i.current.getLocaleText("toolbarExportPrint"),
      format: "print",
      formatOptions: o
    }],
        C = function C() {
      return p(!1);
    },
        v = function v(e) {
      return function () {
        switch (e.format) {
          case "csv":
            i.current.exportDataAsCsv(e.formatOptions);
            break;

          case "print":
            i.current.exportDataAsPrint(e.formatOptions);
        }

        p(!1);
      };
    };

    return React__namespace.createElement(React__namespace.Fragment, null, React__namespace.createElement(BaseButton, Object.assign({
      ref: b,
      color: "primary",
      size: "small",
      startIcon: React__namespace.createElement(s.components.ExportIcon, null),
      "aria-expanded": d ? "true" : void 0,
      "aria-label": i.current.getLocaleText("toolbarExportLabel"),
      "aria-haspopup": "menu",
      "aria-labelledby": u,
      id: c
    }, a, {
      onClick: function onClick(e) {
        p(!0), null == n || n(e);
      }
    }), i.current.getLocaleText("toolbarExport")), React__namespace.createElement(bo, {
      open: d,
      target: m.current,
      onClickAway: C,
      position: "bottom-start"
    }, React__namespace.createElement(BaseMenuList, {
      id: u,
      className: we.menuList,
      "aria-labelledby": c,
      onKeyDown: function onKeyDown(e) {
        So(e.key) && e.preventDefault(), jo(e.key) && C();
      },
      autoFocusItem: d
    }, h.map(function (t, r) {
      return React__namespace.createElement(BaseMenuItem, {
        key: r,
        onClick: v(t)
      }, t.label);
    }))));
  });
  React__namespace.forwardRef(function (t, r) {
    var l = Re(t, ["className"]),
        o = ye();
    return o.disableColumnFilter && o.disableColumnSelector && o.disableDensitySelector ? null : React__namespace.createElement(In, Object.assign({
      ref: r
    }, l), React__namespace.createElement(Pa, null), React__namespace.createElement(Ma, null), React__namespace.createElement(xa, null), React__namespace.createElement(La, null));
  });

  var Da = styled$1("div", {
    name: "MuiDataGrid",
    slot: "RowCount",
    overridesResolver: function overridesResolver(e, t) {
      return t.rowCount;
    }
  })(function (_ref333) {
    var e = _ref333.theme;
    return {
      alignItems: "center",
      display: "flex",
      margin: e.spacing(0, 2)
    };
  }),
      Ia = React__namespace.forwardRef(function (t, r) {
    var l = t.className,
        o = t.rowCount,
        a = t.visibleRowCount,
        i = Re(t, ["className", "rowCount", "visibleRowCount"]),
        s = Ce(),
        c = function (e) {
      var t = e.classes;
      return composeClasses({
        root: ["rowCount"]
      }, ve, t);
    }({
      classes: ye().classes
    });

    if (0 === o) return null;
    var u = a < o ? s.current.getLocaleText("footerTotalVisibleRows")(a, o) : o.toLocaleString();
    return React__namespace.createElement(Da, Object.assign({
      ref: r,
      className: clsx(c.root, l)
    }, i), s.current.getLocaleText("footerTotalRows"), " ", u);
  }),
      ja = styled$1("div", {
    name: "MuiDataGrid",
    slot: "SelectedRowCount",
    overridesResolver: function overridesResolver(e, t) {
      return t.selectedRowCount;
    }
  })(function (_ref334) {
    var e = _ref334.theme;
    return _defineProperty({
      alignItems: "center",
      display: "flex",
      margin: e.spacing(0, 2),
      visibility: "hidden",
      width: 0,
      height: 0
    }, e.breakpoints.up("sm"), {
      visibility: "visible",
      width: "auto",
      height: "auto"
    });
  }),
      Ta = React__namespace.forwardRef(function (t, r) {
    var l = t.className,
        o = t.selectedRowCount,
        a = Re(t, ["className", "selectedRowCount"]),
        i = Ce(),
        s = function (e) {
      var t = e.classes;
      return composeClasses({
        root: ["selectedRowCount"]
      }, ve, t);
    }({
      classes: ye().classes
    }),
        c = i.current.getLocaleText("footerRowSelected")(o);

    return React__namespace.createElement(ja, Object.assign({
      ref: r,
      className: clsx(s.root, l)
    }, a), c);
  }),
      Ha = React__namespace.forwardRef(function (t, r) {
    var l;
    var o = Ce(),
        n = ye(),
        a = Er(o, Pr),
        i = Er(o, al),
        s = Er(o, tl),
        c = !n.hideFooterSelectedRowCount && i > 0 ? React__namespace.createElement(Ta, {
      selectedRowCount: i
    }) : React__namespace.createElement("div", null),
        u = n.hideFooterRowCount || n.pagination ? null : React__namespace.createElement(Ia, {
      rowCount: a,
      visibleRowCount: s
    }),
        d = n.pagination && !n.hideFooterPagination && n.components.Pagination && React__namespace.createElement(n.components.Pagination, Object.assign({}, null === (l = n.componentsProps) || void 0 === l ? void 0 : l.pagination));
    return React__namespace.createElement(Rn, Object.assign({
      ref: r
    }, t), c, u, d);
  }),
      Aa = React__namespace.forwardRef(function (t, r) {
    var l, o;
    var n = ye();
    return React__namespace.createElement("div", Object.assign({
      ref: r
    }, t), React__namespace.createElement(n.components.PreferencesPanel, Object.assign({}, null === (l = n.componentsProps) || void 0 === l ? void 0 : l.preferencesPanel)), n.components.Toolbar && React__namespace.createElement(n.components.Toolbar, Object.assign({}, null === (o = n.componentsProps) || void 0 === o ? void 0 : o.toolbar)));
  }),
      $a = React__namespace.forwardRef(function (t, r) {
    return React__namespace.createElement(Fn, Object.assign({
      ref: r
    }, t), React__namespace.createElement(BaseCircularProgress, null));
  }),
      za = React__namespace.forwardRef(function (t, r) {
    var l = Ce().current.getLocaleText("noRowsLabel");
    return React__namespace.createElement(Fn, Object.assign({
      ref: r
    }, t), l);
  }),
      Na = styled$1(K$1)(function (_ref336) {
    var _ref337;

    var e = _ref336.theme;
    return _ref337 = {}, _defineProperty(_ref337, "& .".concat(q$2.selectLabel), _defineProperty({
      display: "none"
    }, e.breakpoints.up("sm"), {
      display: "block"
    })), _defineProperty(_ref337, "& .".concat(q$2.input), _defineProperty({
      display: "none"
    }, e.breakpoints.up("sm"), {
      display: "inline-flex"
    })), _ref337;
  }),
      _a = React__namespace.forwardRef(function (t, r) {
    var l, o, n;
    var a = Ce(),
        i = ye(),
        s = Er(a, Bo),
        c = React__namespace.useMemo(function () {
      return Math.floor(s.rowCount / (s.pageSize || 1));
    }, [s.rowCount, s.pageSize]),
        u = React__namespace.useCallback(function (e) {
      var t = Number(e.target.value);
      a.current.setPageSize(t);
    }, [a]),
        d = React__namespace.useCallback(function (e, t) {
      a.current.setPage(t);
    }, [a]);

    if ("production" !== process.env.NODE_ENV) {
      var _t10 = React__namespace.useRef(!1);

      _t10.current || i.autoPageSize || i.rowsPerPageOptions.includes(null !== (l = i.pageSize) && void 0 !== l ? l : s.pageSize) || (console.warn(["MUI: The page size `".concat(null !== (o = i.pageSize) && void 0 !== o ? o : s.pageSize, "` is not preset in the `rowsPerPageOptions`"), "Add it to show the pagination select."].join("\n")), _t10.current = !0);
    }

    return React__namespace.createElement(Na, Object.assign({
      ref: r,
      component: "div",
      count: s.rowCount,
      page: s.page <= c ? s.page : c,
      rowsPerPageOptions: (null === (n = i.rowsPerPageOptions) || void 0 === n ? void 0 : n.includes(s.pageSize)) ? i.rowsPerPageOptions : [],
      rowsPerPage: s.pageSize,
      onPageChange: d,
      onRowsPerPageChange: u
    }, a.current.getLocaleText("MuiTablePagination"), t));
  }),
      Va = function Va(_ref338) {
    var t = _ref338.width,
        r = _ref338.height;
    if (!t || !r) return null;
    var l = {
      width: t,
      height: r
    };
    return React__namespace.createElement("div", {
      className: "MuiDataGrid-cell",
      style: l
    });
  };

  function Ba(t) {
    var r, l, o, a;

    var i = t.selected,
        s = t.rowId,
        c = t.row,
        u = t.index,
        d = t.style,
        p = t.rowHeight,
        m = t.className,
        f = t.visibleColumns,
        b = t.renderedColumns,
        g = t.containerWidth,
        h = t.firstColumnToRender,
        C = t.lastColumnToRender,
        v = t.cellFocus,
        w = t.cellTabIndex,
        y = t.editRowsState,
        E = t.onClick,
        S = t.onDoubleClick,
        R = Re(t, ["selected", "rowId", "row", "index", "style", "rowHeight", "className", "visibleColumns", "renderedColumns", "containerWidth", "firstColumnToRender", "lastColumnToRender", "cellFocus", "cellTabIndex", "editRowsState", "onClick", "onDoubleClick"]),
        P = u + 2,
        x = Ce(),
        k = ye(),
        M = Er(x, _r),
        _ref339 = null !== (r = x.current.getRootDimensions()) && void 0 !== r ? r : {
      hasScrollX: !1,
      hasScrollY: !1
    },
        L = _ref339.hasScrollX,
        F = _ref339.hasScrollY,
        D = function (e) {
      var t = e.editable,
          r = e.editing,
          l = e.selected,
          o = e.classes;
      return composeClasses({
        root: ["row", l && "selected", t && "row--editable", r && "row--editing"]
      }, ve, o);
    }({
      selected: i,
      classes: k.classes,
      editing: x.current.getRowMode(s) === an.Edit,
      editable: k.editMode === on$1.Row
    }),
        I = React__namespace.useCallback(function (e, t) {
      return function (r) {
        (1 !== r.target.nodeType || r.currentTarget.contains(r.target)) && x.current.getRow(s) && (x.current.publishEvent(e, x.current.getRowParams(s), r), t && t(r));
      };
    }, [x, s]),
        j = Object.assign({
      maxHeight: p,
      minHeight: p
    }, d),
        T = "function" == typeof k.getRowClassName && k.getRowClassName(x.current.getRowParams(s)),
        H = [];

    for (var _t11 = 0; _t11 < b.length; _t11 += 1) {
      var _r4 = b[_t11],
          _n4 = h + _t11,
          _i5 = _n4 === f.length - 1,
          _c2 = _i5 && L && !F,
          _u = _i5 ? !_c2 && k.disableExtendRowFullWidth : k.showCellRightBorder,
          _d = x.current.getCellParams(s, _r4.field),
          _m = [];

      _r4.cellClassName && _m.push(clsx("function" == typeof _r4.cellClassName ? _r4.cellClassName(_d) : _r4.cellClassName));

      var _g = y[s] ? y[s][_r4.field] : null;

      var _C = null;

      if (null == _g && _r4.renderCell && (_C = _r4.renderCell(Object.assign(Object.assign({}, _d), {
        api: x.current
      })), _m.push(clsx(we["cell--withRenderer"], null === (l = k.classes) || void 0 === l ? void 0 : l["cell--withRenderer"]))), null != _g && _r4.renderEditCell) {
        var _e12 = Object.assign(Object.assign(Object.assign({}, _d), _g), {
          api: x.current
        });

        _C = _r4.renderEditCell(_e12), _m.push(clsx(we["cell--editing"], null === (o = k.classes) || void 0 === o ? void 0 : o["cell--editing"]));
      }

      k.getCellClassName && _m.push(k.getCellClassName(_d));

      var _E = null !== v && v.id === s && v.field === _r4.field,
          _S = null !== w && w.id === s && w.field === _r4.field && "view" === _d.cellMode ? 0 : -1;

      H.push(React__namespace.createElement(k.components.Cell, Object.assign({
        key: _t11,
        value: _d.value,
        field: _r4.field,
        width: _r4.computedWidth,
        rowId: s,
        height: p,
        showRightBorder: _u,
        formattedValue: _d.formattedValue,
        align: _r4.align || "left",
        cellMode: _d.cellMode,
        colIndex: _n4,
        isEditable: _d.isEditable,
        hasFocus: _E,
        tabIndex: _S,
        className: clsx(_m)
      }, null === (a = k.componentsProps) || void 0 === a ? void 0 : a.cell), _C));
    }

    var A = g - M.totalWidth;
    return React__namespace.createElement("div", Object.assign({
      "data-id": s,
      "data-rowindex": u,
      role: "row",
      className: clsx(T, D.root, m),
      "aria-rowindex": P,
      "aria-selected": i,
      style: j,
      onClick: I(ge.rowClick, E),
      onDoubleClick: I(ge.rowDoubleClick, S)
    }, R), H, A > 0 && React__namespace.createElement(Va, {
      width: A,
      height: p
    }));
  }

  var Ga = styled$1("div", {
    name: "MuiDataGrid",
    slot: "ScrollArea",
    overridesResolver: function overridesResolver(e, t) {
      return [_defineProperty({}, "&.".concat(we["scrollArea--left"]), t["scrollArea--left"]), _defineProperty({}, "&.".concat(we["scrollArea--right"]), t["scrollArea--right"]), t.scrollArea];
    }
  })(function () {
    var _ref342;

    return _ref342 = {
      position: "absolute",
      top: 0,
      zIndex: 101,
      width: 20,
      bottom: 0
    }, _defineProperty(_ref342, "&.".concat(we["scrollArea--left"]), {
      left: 0
    }), _defineProperty(_ref342, "&.".concat(we["scrollArea--right"]), {
      right: 0
    }), _ref342;
  });

  var Wa = React__namespace.memo(function (t) {
    var r = t.scrollDirection,
        l = React__namespace.useRef(null),
        o = Ce(),
        a = React__namespace.useRef(),
        _React__namespace$use127 = React__namespace.useState(!1),
        _React__namespace$use128 = _slicedToArray(_React__namespace$use127, 2),
        i = _React__namespace$use128[0],
        s = _React__namespace$use128[1],
        c = Er(o, pl),
        u = React__namespace.useRef({
      left: 0,
      top: 0
    }),
        d = ye(),
        p = function (e) {
      var t = e.scrollDirection,
          r = e.classes;
      return composeClasses({
        root: ["scrollArea", "scrollArea--".concat(t)]
      }, ve, r);
    }(Object.assign(Object.assign({}, t), {
      classes: d.classes
    })),
        m = React__namespace.useCallback(function (e) {
      u.current = e;
    }, []),
        f = React__namespace.useCallback(function (e) {
      var t;
      if ("left" === r) t = e.clientX - l.current.getBoundingClientRect().right;else {
        if ("right" !== r) throw new Error("MUI: Wrong drag direction");
        t = Math.max(1, e.clientX - l.current.getBoundingClientRect().left);
      }
      t = 1.5 * (t - 1) + 1, clearTimeout(a.current), a.current = setTimeout(function () {
        o.current.scroll({
          left: u.current.left + t,
          top: u.current.top
        });
      });
    }, [r, o]);

    React__namespace.useEffect(function () {
      return function () {
        clearTimeout(a.current);
      };
    }, []);
    var b = React__namespace.useCallback(function () {
      s(function (e) {
        return !e;
      });
    }, []);
    return xn(o, ge.rowsScroll, m), xn(o, ge.columnHeaderDragStart, b), xn(o, ge.columnHeaderDragEnd, b), i ? React__namespace.createElement(Ga, {
      ref: l,
      className: clsx(p.root),
      onDragOver: f,
      style: {
        height: c
      }
    }) : null;
  }),
      Ua = function Ua(e) {
    return e.columnMenu;
  },
      Ka = function Ka(e) {
    return e.columnReorder;
  };

  createSelector(Ka, function (e) {
    return e.dragCol;
  });

  var Za = function Za(e) {
    return e.columnResize;
  };

  createSelector(Za, function (e) {
    return e.resizingColumnField;
  });
  var Xa;
  !function (e) {
    e.hydrateColumns = "hydrateColumns";
  }(Xa || (Xa = {}));

  var Ja = function Ja(t) {
    var r = React__namespace.useRef(!0);
    r.current && (r.current = !1, t());
  },
      Qa = function Qa(e, t) {
    var r = {};
    var l = 0,
        o = t;

    if (e.all.forEach(function (t) {
      var n, a;
      var i = Object.assign({}, e.lookup[t]);
      if (i.hide) i.computedWidth = 0;else {
        var _e13 = null !== (n = i.minWidth) && void 0 !== n ? n : po.minWidth;

        var _t12;

        i.flex && i.flex > 0 ? (l += i.flex, _t12 = _e13) : _t12 = Math.max(null !== (a = i.width) && void 0 !== a ? a : po.width, _e13), o -= _t12, i.computedWidth = _t12;
      }
      r[t] = i;
    }), l > 0 && o > 0) {
      var _t13 = o / l;

      e.all.forEach(function (e) {
        var l = r[e];
        !l.hide && l.flex && l.flex > 0 && (r[e].computedWidth += _t13 * l.flex);
      });
    }

    return Object.assign(Object.assign({}, e), {
      lookup: r
    });
  },
      ei = function ei(e, t) {
    return t ? e[t] : e.__default__;
  },
      ti = function ti(_ref343) {
    var e = _ref343.columnsToUpsert,
        t = _ref343.columnsTypes,
        r = _ref343.apiRef,
        l = _ref343.reset;
    var o, n, a, i;
    var s;
    if (l) s = {
      all: [],
      lookup: {}
    };else {
      var _e14 = Hr(r.current.state);

      s = {
        all: _toConsumableArray(_e14.all),
        lookup: Object.assign({}, _e14.lookup)
      };
    }
    e.forEach(function (e) {
      null == s.lookup[e.field] ? (s.lookup[e.field] = Object.assign(Object.assign({}, ei(t, e.type)), e), s.all.push(e.field)) : s.lookup[e.field] = Object.assign(Object.assign({}, s.lookup[e.field]), e);
    });
    var c = r.current.unstable_applyPreProcessors(Xa.hydrateColumns, s);
    return Qa(c, null !== (i = null === (a = null === (n = (o = r.current).getRootDimensions) || void 0 === n ? void 0 : n.call(o)) || void 0 === a ? void 0 : a.viewportInnerSize.width) && void 0 !== i ? i : 0);
  },
      ri = function ri(e) {
    return e.editRows;
  },
      li = function li() {
    return {
      items: [],
      linkOperator: bn.And
    };
  };

  var oi = /*#__PURE__*/function () {
    function oi() {
      _classCallCheck(this, oi);

      this.maxListeners = 10, this.warnOnce = !1, this.events = {};
    }

    _createClass2(oi, [{
      key: "on",
      value: function on(e, t) {
        var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var l = this.events[e];

        if (l || (l = {
          highPriority: new Map(),
          regular: new Map()
        }, this.events[e] = l), r.isFirst ? l.highPriority.set(t, !0) : l.regular.set(t, !0), "production" !== process.env.NODE_ENV) {
          var _t14 = l.highPriority.size + l.regular.size;

          _t14 > this.maxListeners && !this.warnOnce && (this.warnOnce = !0, console.warn(["Possible EventEmitter memory leak detected. ".concat(_t14, " ").concat(e, " listeners added."), "Use emitter.setMaxListeners() to increase limit."].join("\n")));
        }
      }
    }, {
      key: "removeListener",
      value: function removeListener(e, t) {
        this.events[e] && (this.events[e].regular.delete(t), this.events[e].highPriority.delete(t));
      }
    }, {
      key: "removeAllListeners",
      value: function removeAllListeners() {
        this.events = {};
      }
    }, {
      key: "emit",
      value: function emit(e) {
        var r = this.events[e];
        if (!r) return;
        var l = Array.from(r.highPriority.keys()),
            o = Array.from(r.regular.keys());

        for (var _len21 = arguments.length, t = new Array(_len21 > 1 ? _len21 - 1 : 0), _key21 = 1; _key21 < _len21; _key21++) {
          t[_key21 - 1] = arguments[_key21];
        }

        for (var _e15 = l.length - 1; _e15 >= 0; _e15 -= 1) {
          var _o4 = l[_e15];
          r.highPriority.has(_o4) && _o4.apply(this, t);
        }

        for (var _e16 = 0; _e16 < o.length; _e16 += 1) {
          var _l4 = o[_e16];
          r.regular.has(_l4) && _l4.apply(this, t);
        }
      }
    }, {
      key: "once",
      value: function once(e, t) {
        var r = this;
        this.on(e, function l() {
          for (var _len22 = arguments.length, o = new Array(_len22), _key22 = 0; _key22 < _len22; _key22++) {
            o[_key22] = arguments[_key22];
          }

          r.removeListener(e, l), t.apply(r, o);
        });
      }
    }]);

    return oi;
  }();

  function ni() {
    var r = arguments.length <= 0 ? undefined : arguments[0],
        l = React__namespace.useRef();
    return l.current || (l.current = {
      unstable_eventManager: new oi()
    }), React__namespace.useImperativeHandle(r, function () {
      return l.current;
    }, [l]), l;
  }

  var ii = function ii(t, r, l, o, n) {
    var a = vr(t, "useNativeEventListener"),
        _React__namespace$use129 = React__namespace.useState(!1),
        _React__namespace$use130 = _slicedToArray(_React__namespace$use129, 2),
        i = _React__namespace$use130[0],
        s = _React__namespace$use130[1],
        c = React__namespace.useRef(o),
        u = React__namespace.useCallback(function (e) {
      return c.current && c.current(e);
    }, []);

    React__namespace.useEffect(function () {
      c.current = o;
    }, [o]), React__namespace.useEffect(function () {
      var e;

      if (e = gr(r) ? r() : r && r.current ? r.current : null, e && u && l && !i) {
        a.debug("Binding native ".concat(l, " event")), e.addEventListener(l, u, n);
        var _r5 = e;
        s(!0);

        var _o5 = function _o5() {
          a.debug("Clearing native ".concat(l, " event")), _r5.removeEventListener(l, u, n);
        };

        t.current.subscribeEvent(ge.unmount, _o5);
      }
    }, [r, u, l, i, a, n, t]);
  },
      si = {
    autoHeight: !1,
    autoPageSize: !1,
    checkboxSelection: !1,
    checkboxSelectionVisibleOnly: !1,
    columnBuffer: 3,
    rowBuffer: 3,
    columnThreshold: 3,
    rowThreshold: 3,
    density: gn.Standard,
    disableExtendRowFullWidth: !1,
    disableColumnFilter: !1,
    disableColumnMenu: !1,
    disableColumnReorder: !1,
    disableColumnResize: !1,
    disableColumnSelector: !1,
    disableDensitySelector: !1,
    disableMultipleColumnsFiltering: !1,
    disableChildrenFiltering: !1,
    disableMultipleSelection: !1,
    disableMultipleColumnsSorting: !1,
    disableChildrenSorting: !1,
    disableSelectionOnClick: !1,
    disableVirtualization: !1,
    editMode: on$1.Cell,
    filterMode: fn.client,
    headerHeight: 56,
    hideFooter: !1,
    hideFooterPagination: !1,
    hideFooterRowCount: !1,
    hideFooterSelectedRowCount: !1,
    logger: console,
    logLevel: "production" === process.env.NODE_ENV ? "error" : "warn",
    pagination: !1,
    paginationMode: fn.client,
    rowHeight: 52,
    rowsPerPageOptions: [25, 50, 100],
    treeData: !1,
    defaultGroupingExpansionDepth: 0,
    scrollEndThreshold: 80,
    showCellRightBorder: !1,
    showColumnRightBorder: !1,
    sortingOrder: ["asc", "desc", null],
    sortingMode: fn.client,
    throttleRowsMs: 0
  },
      ci = React__namespace.memo(function (t) {
    var r = ye(),
        _r$sortingOrder = _slicedToArray(r.sortingOrder, 1),
        l = _r$sortingOrder[0],
        o = "asc" === l ? r.components.ColumnSortedAscendingIcon : r.components.ColumnSortedDescendingIcon;

    return o ? React__namespace.createElement(o, Object.assign({}, t)) : null;
  }),
      ui = React__namespace.forwardRef(function (t, r) {
    var l = t.message,
        o = t.hasError,
        n = t.errorInfo,
        a = Re(t, ["message", "hasError", "errorInfo"]),
        i = Ce().current.getLocaleText("errorOverlayDefaultLabel");
    return React__namespace.createElement(Fn, Object.assign({
      ref: r
    }, a), l || i);
  }),
      di = React__namespace.forwardRef(function (t, r) {
    var l = Ce().current.getLocaleText("noResultsOverlayLabel");
    return React__namespace.createElement(Fn, Object.assign({
      ref: r
    }, t), l);
  }),
      pi = {
    BooleanCellTrueIcon: Nl,
    BooleanCellFalseIcon: Tl,
    ColumnMenuIcon: jl,
    OpenFilterButtonIcon: Sl,
    ColumnFilteredIcon: Rl,
    ColumnSelectorIcon: Ml,
    ColumnUnsortedIcon: ci,
    ColumnSortedAscendingIcon: wl,
    ColumnSortedDescendingIcon: Ol,
    ColumnResizeIcon: Ll,
    DensityCompactIcon: Fl,
    DensityStandardIcon: Dl,
    DensityComfortableIcon: Il,
    ExportIcon: zl,
    MoreActionsIcon: _l,
    TreeDataCollapseIcon: El,
    TreeDataExpandIcon: yl
  },
      mi = Object.assign(Object.assign({}, pi), {
    Cell: vn,
    BaseCheckbox: BaseCheckbox,
    ColumnMenu: ta,
    ErrorOverlay: ui,
    Footer: Ha,
    Header: Aa,
    Toolbar: null,
    PreferencesPanel: ya,
    LoadingOverlay: $a,
    NoResultsOverlay: di,
    NoRowsOverlay: za,
    Pagination: _a,
    FilterPanel: Ra,
    ColumnsPanel: ha,
    Panel: Oa,
    Row: Ba
  }),
      fi = function fi(t) {
    var r = React__namespace.useMemo(function () {
      return Object.assign(Object.assign({}, ma), t.localeText);
    }, [t.localeText]),
        l = React__namespace.useMemo(function () {
      var e = t.components;
      if (!e) return Object.assign({}, mi);
      var r = {};
      return Object.keys(mi).forEach(function (t) {
        r[t] = void 0 === e[t] ? mi[t] : e[t];
      }), r;
    }, [t.components]);
    return React__namespace.useMemo(function () {
      return Object.assign(Object.assign(Object.assign({}, si), t), {
        localeText: r,
        components: l
      });
    }, [t, r, l]);
  },
      bi = function bi(e, t) {
    var r;
    return {
      components: {
        MuiDataGrid: {
          defaultProps: {
            localeText: Object.assign(Object.assign({}, e), {
              MuiTablePagination: (null === (r = null == t ? void 0 : t.components) || void 0 === r ? void 0 : r.MuiTablePagination.defaultProps) || {}
            })
          }
        }
      }
    };
  };

  bi({
    noRowsLabel: "لا توجد صفوف",
    noResultsOverlayLabel: "لم يتم العثور على نتائج.",
    errorOverlayDefaultLabel: "حدث خطأ.",
    toolbarDensity: "كثافة",
    toolbarDensityLabel: "كثافة",
    toolbarDensityCompact: "مدمج",
    toolbarDensityStandard: "المعيار",
    toolbarDensityComfortable: "مريح",
    toolbarColumns: "الأعمدة",
    toolbarColumnsLabel: "حدد الأعمدة",
    toolbarFilters: "الفلاتر",
    toolbarFiltersLabel: "اظهر الفلاتر",
    toolbarFiltersTooltipHide: "إخفاء الفلاتر",
    toolbarFiltersTooltipShow: "اظهر الفلاتر",
    toolbarFiltersTooltipActive: function toolbarFiltersTooltipActive(e) {
      return "".concat(e, " \u0641\u0644\u0627\u062A\u0631 \u0646\u0634\u0637\u0629");
    },
    toolbarExport: "تصدير",
    toolbarExportLabel: "تصدير",
    toolbarExportCSV: "تنزيل كملف CSV",
    columnsPanelTextFieldLabel: "ايجاد عمود",
    columnsPanelTextFieldPlaceholder: "عنوان العمود",
    columnsPanelDragIconLabel: "إعادة ترتيب العمود",
    columnsPanelShowAllButton: "عرض الكل",
    columnsPanelHideAllButton: "اخفاء الكل",
    filterPanelAddFilter: "اضف فلتر",
    filterPanelDeleteIconLabel: "حذف",
    filterPanelOperators: "العاملين",
    filterPanelOperatorAnd: "و",
    filterPanelOperatorOr: "او",
    filterPanelColumns: "الأعمدة",
    filterPanelInputLabel: "قيمة",
    filterPanelInputPlaceholder: "قيمة التصفية",
    filterOperatorContains: "يحتوي على",
    filterOperatorEquals: "يساوي",
    filterOperatorStartsWith: "يبدأ ب",
    filterOperatorEndsWith: "ينتهي بـ",
    filterOperatorIs: "يكون",
    filterOperatorNot: "ليس",
    filterOperatorAfter: "يكون بعد",
    filterOperatorOnOrAfter: "في أو بعد",
    filterOperatorBefore: "يكون",
    filterOperatorOnOrBefore: "في أو قبل",
    filterOperatorIsEmpty: "فارغ",
    filterOperatorIsNotEmpty: "ليس فارغا",
    filterValueAny: "أي",
    filterValueTrue: "صحيح",
    filterValueFalse: "خاطئة",
    columnMenuLabel: "القائمة",
    columnMenuShowColumns: "إظهار الأعمدة",
    columnMenuFilter: "فلتر",
    columnMenuHideColumn: "إخفاء",
    columnMenuUnsort: "غير مرتب",
    columnMenuSortAsc: "الترتيب حسب ASC",
    columnMenuSortDesc: "الترتيب حسب DESC",
    columnHeaderFiltersTooltipActive: function columnHeaderFiltersTooltipActive(e) {
      return "".concat(e, " \u0641\u0644\u0627\u062A\u0631 \u0646\u0634\u0637\u0629");
    },
    columnHeaderFiltersLabel: "اظهر الفلاتر",
    columnHeaderSortIconLabel: "ترتيب",
    footerRowSelected: function footerRowSelected(e) {
      return "".concat(e.toLocaleString(), " \u0635\u0641\u0648\u0641 \u0645\u062E\u062A\u0627\u0631\u0629");
    },
    footerTotalRows: "إجمالي الصفوف:",
    footerTotalVisibleRows: function footerTotalVisibleRows(e, t) {
      return "".concat(e.toLocaleString(), " \u0645\u0646 ").concat(t.toLocaleString());
    },
    checkboxSelectionHeaderName: "تحديد",
    booleanCellTrueLabel: "صحيح",
    booleanCellFalseLabel: "خاطئة"
  }, arSD);
  bi({
    noRowsLabel: "Няма редове",
    errorOverlayDefaultLabel: "Възникна грешка.",
    toolbarDensity: "Гъстота",
    toolbarDensityLabel: "Гъстота",
    toolbarDensityCompact: "Компактна",
    toolbarDensityStandard: "Стандартна",
    toolbarDensityComfortable: "Комфортна",
    toolbarColumns: "Колони",
    toolbarColumnsLabel: "Покажи селектора на колони",
    toolbarFilters: "Филтри",
    toolbarFiltersLabel: "Покажи Филтрите",
    toolbarFiltersTooltipHide: "Скрий Филтрите",
    toolbarFiltersTooltipShow: "Покажи Филтрите",
    toolbarFiltersTooltipActive: function toolbarFiltersTooltipActive(e) {
      return "".concat(e, " \u0430\u043A\u0442\u0438\u0432\u043D\u0438 \u0444\u0438\u043B\u0442\u0440\u0438");
    },
    columnsPanelTextFieldLabel: "Намери колона",
    columnsPanelTextFieldPlaceholder: "Заглавие на колона",
    columnsPanelDragIconLabel: "Пренареди на колона",
    columnsPanelShowAllButton: "Покажи Всички",
    columnsPanelHideAllButton: "Скрий Всички",
    filterPanelAddFilter: "Добави Филтър",
    filterPanelDeleteIconLabel: "Изтрий",
    filterPanelOperators: "Оператори",
    filterPanelOperatorAnd: "И",
    filterPanelOperatorOr: "Или",
    filterPanelColumns: "Колони",
    filterPanelInputLabel: "Стойност",
    filterPanelInputPlaceholder: "Стойност на филтъра",
    filterOperatorContains: "съдържа",
    filterOperatorEquals: "равно",
    filterOperatorStartsWith: "започва с",
    filterOperatorEndsWith: "завършва с",
    filterOperatorIs: "е",
    filterOperatorNot: "не е",
    filterOperatorAfter: "е след",
    filterOperatorOnOrAfter: "е на или след",
    filterOperatorBefore: "е преди",
    filterOperatorOnOrBefore: "е на или преди",
    columnMenuLabel: "Меню",
    columnMenuShowColumns: "Покажи колоните",
    columnMenuFilter: "Филтри",
    columnMenuHideColumn: "Скрий",
    columnMenuUnsort: "Отмени сортирането",
    columnMenuSortAsc: "Сортирай по възходящ ред",
    columnMenuSortDesc: "Сортирай по низходящ ред",
    columnHeaderFiltersTooltipActive: function columnHeaderFiltersTooltipActive(e) {
      return "".concat(e, " \u0430\u043A\u0442\u0438\u0432\u043D\u0438 \u0444\u0438\u043B\u0442\u0440\u0438");
    },
    columnHeaderFiltersLabel: "Покажи Филтрите",
    columnHeaderSortIconLabel: "Сортирай",
    footerRowSelected: function footerRowSelected(e) {
      return 1 !== e ? "".concat(e.toLocaleString(), " \u0438\u0437\u0431\u0440\u0430\u043D\u0438 \u0440\u0435\u0434\u043E\u0432\u0435") : "".concat(e.toLocaleString(), " \u0438\u0437\u0431\u0440\u0430\u043D \u0440\u0435\u0434");
    },
    footerTotalRows: "Общо Rедове:"
  }, bgBG);
  bi({
    noRowsLabel: "Žádné záznamy",
    noResultsOverlayLabel: "Nenašli se žadné výsledky.",
    errorOverlayDefaultLabel: "Stala sa nepředvídaná chyba.",
    toolbarDensity: "Hustota",
    toolbarDensityLabel: "Hustota",
    toolbarDensityCompact: "Kompaktní",
    toolbarDensityStandard: "Standartní",
    toolbarDensityComfortable: "Komfortní",
    toolbarColumns: "Sloupce",
    toolbarColumnsLabel: "Vybrat sloupec",
    toolbarFilters: "Filtry",
    toolbarFiltersLabel: "Zobrazit filtry",
    toolbarFiltersTooltipHide: "Skrýt filtry",
    toolbarFiltersTooltipShow: "Zobrazit filtry",
    toolbarFiltersTooltipActive: function toolbarFiltersTooltipActive(e) {
      var t = "aktivních filtrů";
      return e > 1 && e < 5 ? t = "aktivní filtry" : 1 === e && (t = "aktivní filtr"), "".concat(e, " ").concat(t);
    },
    toolbarExport: "Export",
    toolbarExportLabel: "Export",
    toolbarExportCSV: "Stáhnout jako CSV",
    columnsPanelTextFieldLabel: "Najít sloupec",
    columnsPanelTextFieldPlaceholder: "Název sloupce",
    columnsPanelDragIconLabel: "Uspořádat sloupce",
    columnsPanelShowAllButton: "Zobrazit vše",
    columnsPanelHideAllButton: "Skrýt vše",
    filterPanelAddFilter: "Přidat filtr",
    filterPanelDeleteIconLabel: "Odstranit",
    filterPanelOperators: "Operátory",
    filterPanelOperatorAnd: "A",
    filterPanelOperatorOr: "Nebo",
    filterPanelColumns: "Sloupce",
    filterPanelInputLabel: "Hodnota",
    filterPanelInputPlaceholder: "Hodnota filtru",
    filterOperatorContains: "obsahuje",
    filterOperatorEquals: "rovná se",
    filterOperatorStartsWith: "začíná s",
    filterOperatorEndsWith: "končí na",
    filterOperatorIs: "je",
    filterOperatorNot: "není",
    filterOperatorAfter: "je po",
    filterOperatorOnOrAfter: "je na nebo po",
    filterOperatorBefore: "je před",
    filterOperatorOnOrBefore: "je na nebo dříve",
    filterValueAny: "jakýkoliv",
    filterValueTrue: "ano",
    filterValueFalse: "ne",
    columnMenuLabel: "Menu",
    columnMenuShowColumns: "Zobrazit sloupce",
    columnMenuFilter: "Filtr",
    columnMenuHideColumn: "Skrýt",
    columnMenuUnsort: "Zrušit filtry",
    columnMenuSortAsc: "Seřadit vzestupně",
    columnMenuSortDesc: "Seřadit sestupně",
    columnHeaderFiltersTooltipActive: function columnHeaderFiltersTooltipActive(e) {
      var t = "aktivních filtrů";
      return e > 1 && e < 5 ? t = "aktivní filtry" : 1 === e && (t = "aktivní filtr"), "".concat(e, " ").concat(t);
    },
    columnHeaderFiltersLabel: "Zobrazit filtry",
    columnHeaderSortIconLabel: "Filtrovat",
    footerRowSelected: function footerRowSelected(e) {
      var t = "vybraných záznamů";
      return e > 1 && e < 5 ? t = "vybrané záznamy" : 1 === e && (t = "vybraný záznam"), "".concat(e, " ").concat(t);
    },
    footerTotalRows: "Celkem řádků:",
    checkboxSelectionHeaderName: "Výběr řádku",
    booleanCellTrueLabel: "ano",
    booleanCellFalseLabel: "ne"
  }, csCZ);
  bi({
    noRowsLabel: "Keine Einträge",
    noResultsOverlayLabel: "Keine Ergebnisse gefunden.",
    errorOverlayDefaultLabel: "Ein unerwarteter Fehler ist aufgetreten.",
    toolbarDensity: "Zeilenhöhe",
    toolbarDensityLabel: "Zeilenhöhe",
    toolbarDensityCompact: "Kompakt",
    toolbarDensityStandard: "Standard",
    toolbarDensityComfortable: "Breit",
    toolbarColumns: "Spalten",
    toolbarColumnsLabel: "Zeige Spaltenauswahl",
    toolbarFilters: "Filter",
    toolbarFiltersLabel: "Zeige Filter",
    toolbarFiltersTooltipHide: "Verberge Filter",
    toolbarFiltersTooltipShow: "Zeige Filter",
    toolbarFiltersTooltipActive: function toolbarFiltersTooltipActive(e) {
      return 1 !== e ? "".concat(e, " aktive Filter") : "".concat(e, " aktiver Filter");
    },
    toolbarExport: "Exportieren",
    toolbarExportLabel: "Exportieren",
    toolbarExportCSV: "Download als CSV",
    toolbarExportPrint: "Drucken",
    columnsPanelTextFieldLabel: "Finde Spalte",
    columnsPanelTextFieldPlaceholder: "Spaltenüberschrift",
    columnsPanelDragIconLabel: "Spalte umsortieren",
    columnsPanelShowAllButton: "Zeige alle",
    columnsPanelHideAllButton: "Verberge alle",
    filterPanelAddFilter: "Filter hinzufügen",
    filterPanelDeleteIconLabel: "Löschen",
    filterPanelOperators: "Operatoren",
    filterPanelOperatorAnd: "Und",
    filterPanelOperatorOr: "Oder",
    filterPanelColumns: "Spalten",
    filterPanelInputLabel: "Wert",
    filterPanelInputPlaceholder: "Wert filtern",
    filterOperatorContains: "enthält",
    filterOperatorEquals: "ist gleich",
    filterOperatorStartsWith: "beginnt mit",
    filterOperatorEndsWith: "endet mit",
    filterOperatorIs: "ist",
    filterOperatorNot: "ist nicht",
    filterOperatorAfter: "ist nach",
    filterOperatorOnOrAfter: "ist am oder nach",
    filterOperatorBefore: "ist vor",
    filterOperatorOnOrBefore: "ist am oder vor",
    filterOperatorIsEmpty: "ist leer",
    filterOperatorIsNotEmpty: "ist nicht leer",
    filterValueAny: "Beliebig",
    filterValueTrue: "Ja",
    filterValueFalse: "Nein",
    columnMenuLabel: "Menü",
    columnMenuShowColumns: "Zeige alle Spalten",
    columnMenuFilter: "Filter",
    columnMenuHideColumn: "Verbergen",
    columnMenuUnsort: "Sortierung deaktivieren",
    columnMenuSortAsc: "Sortiere aufsteigend",
    columnMenuSortDesc: "Sortiere absteigend",
    columnHeaderFiltersTooltipActive: function columnHeaderFiltersTooltipActive(e) {
      return 1 !== e ? "".concat(e, " aktive Filter") : "".concat(e, " aktiver Filter");
    },
    columnHeaderFiltersLabel: "Zeige Filter",
    columnHeaderSortIconLabel: "Sortieren",
    footerRowSelected: function footerRowSelected(e) {
      return 1 !== e ? "".concat(e.toLocaleString(), " Eintr\xE4ge ausgew\xE4hlt") : "".concat(e.toLocaleString(), " Eintrag ausgew\xE4hlt");
    },
    footerTotalRows: "Gesamt:",
    footerTotalVisibleRows: function footerTotalVisibleRows(e, t) {
      return "".concat(e.toLocaleString(), " von ").concat(t.toLocaleString());
    },
    checkboxSelectionHeaderName: "Checkbox Auswahl",
    booleanCellTrueLabel: "Ja",
    booleanCellFalseLabel: "Nein",
    actionsCellMore: "Mehr",
    treeDataGroupingHeaderName: "Gruppe",
    treeDataExpand: "Kinder einblenden",
    treeDataCollapse: "Kinder ausblenden"
  }, deDE);
  bi({
    noRowsLabel: "Δεν υπάρχουν καταχωρήσεις",
    noResultsOverlayLabel: "Δεν βρέθηκαν αποτελέσματα.",
    errorOverlayDefaultLabel: "Παρουσιάστηκε απρόβλεπτο σφάλμα.",
    toolbarDensity: "Ύψος σειράς",
    toolbarDensityLabel: "Ύψος σειράς",
    toolbarDensityCompact: "Συμπαγής",
    toolbarDensityStandard: "Προκαθορισμένο",
    toolbarDensityComfortable: "Πλατύ",
    toolbarColumns: "Στήλες",
    toolbarColumnsLabel: "Επιλέξτε στήλες",
    toolbarFilters: "Φίλτρα",
    toolbarFiltersLabel: "Εμφάνιση φίλτρων",
    toolbarFiltersTooltipHide: "Απόκρυψη φίλτρων",
    toolbarFiltersTooltipShow: "Εμφάνιση φίλτρων",
    toolbarFiltersTooltipActive: function toolbarFiltersTooltipActive(e) {
      return 1 !== e ? "".concat(e, " \u03B5\u03BD\u03B5\u03C1\u03B3\u03AC \u03C6\u03AF\u03BB\u03C4\u03C1\u03B1") : "".concat(e, " \u03B5\u03BD\u03B5\u03C1\u03B3\u03CC \u03C6\u03AF\u03BB\u03C4\u03C1\u03BF");
    },
    toolbarExport: "Εξαγωγή",
    toolbarExportLabel: "Εξαγωγή",
    toolbarExportCSV: "Λήψη ως CSV",
    columnsPanelTextFieldLabel: "Εύρεση στήλης",
    columnsPanelTextFieldPlaceholder: "Επικεφαλίδα στήλης",
    columnsPanelDragIconLabel: "Αναδιάταξη στήλης",
    columnsPanelShowAllButton: "Προβολή όλων",
    columnsPanelHideAllButton: "Απόκρυψη όλων",
    filterPanelAddFilter: "Προσθήκη φίλτρου",
    filterPanelDeleteIconLabel: "Διαγραφή",
    filterPanelOperators: "Τελεστές",
    filterPanelOperatorAnd: "Καί",
    filterPanelOperatorOr: "Ή",
    filterPanelColumns: "Στήλες",
    filterPanelInputLabel: "Τιμή",
    filterPanelInputPlaceholder: "Τιμή φίλτρου",
    filterOperatorContains: "περιέχει",
    filterOperatorEquals: "ισούται",
    filterOperatorStartsWith: "ξεκινάει με",
    filterOperatorEndsWith: "τελειώνει με",
    filterOperatorIs: "είναι",
    filterOperatorNot: "δεν είναι",
    filterOperatorAfter: "είναι μετά",
    filterOperatorOnOrAfter: "είναι ίσο ή μετά",
    filterOperatorBefore: "είναι πριν",
    filterOperatorOnOrBefore: "είναι ίσο ή πριν",
    filterOperatorIsEmpty: "είναι κενό",
    filterOperatorIsNotEmpty: "δεν είναι κενό",
    columnMenuLabel: "Μενού",
    columnMenuShowColumns: "Εμφάνιση στηλών",
    columnMenuFilter: "Φίλτρο",
    columnMenuHideColumn: "Απόκρυψη",
    columnMenuUnsort: "Απενεργοποίηση ταξινόμησης",
    columnMenuSortAsc: "Ταξινόμηση σε αύξουσα σειρά",
    columnMenuSortDesc: "Ταξινόμηση σε φθίνουσα σειρά",
    columnHeaderFiltersTooltipActive: function columnHeaderFiltersTooltipActive(e) {
      return 1 !== e ? "".concat(e, " \u03B5\u03BD\u03B5\u03C1\u03B3\u03AC \u03C6\u03AF\u03BB\u03C4\u03C1\u03B1") : "".concat(e, " \u03B5\u03BD\u03B5\u03C1\u03B3\u03CC \u03C6\u03AF\u03BB\u03C4\u03C1\u03BF");
    },
    columnHeaderFiltersLabel: "Εμφάνιση φίλτρων",
    columnHeaderSortIconLabel: "Ταξινόμηση",
    footerRowSelected: function footerRowSelected(e) {
      return 1 !== e ? "".concat(e.toLocaleString(), " \u03B5\u03C0\u03B9\u03BB\u03B5\u03B3\u03BC\u03AD\u03BD\u03B5\u03C2 \u03B3\u03C1\u03B1\u03BC\u03BC\u03AD\u03C2") : "".concat(e.toLocaleString(), " \u03B5\u03C0\u03B9\u03BB\u03B5\u03B3\u03BC\u03AD\u03BD\u03B7 \u03B3\u03C1\u03B1\u03BC\u03BC\u03AE");
    },
    footerTotalRows: "Σύνολο Γραμμών:",
    footerTotalVisibleRows: function footerTotalVisibleRows(e, t) {
      return "".concat(e.toLocaleString(), " \u03B1\u03C0\u03CC ").concat(t.toLocaleString());
    },
    actionsCellMore: "περισσότερα"
  });
  bi(ma, enUS);
  bi({
    noRowsLabel: "Sin filas",
    errorOverlayDefaultLabel: "Ha ocurrido un error.",
    toolbarDensity: "Densidad",
    toolbarDensityLabel: "Densidad",
    toolbarDensityCompact: "Compacta",
    toolbarDensityStandard: "Standard",
    toolbarDensityComfortable: "Comoda",
    toolbarColumns: "Columnas",
    toolbarColumnsLabel: "Seleccionar columnas",
    toolbarFilters: "Filtros",
    toolbarFiltersLabel: "Mostrar filtros",
    toolbarFiltersTooltipHide: "Ocultar filtros",
    toolbarFiltersTooltipShow: "Mostrar filtros",
    toolbarFiltersTooltipActive: function toolbarFiltersTooltipActive(e) {
      return e > 1 ? "".concat(e, " filtros activos") : "".concat(e, " filtro activo");
    },
    toolbarExport: "Exportar",
    toolbarExportLabel: "Exportar",
    toolbarExportCSV: "Descargar como CSV",
    columnsPanelTextFieldLabel: "Columna de búsqueda",
    columnsPanelTextFieldPlaceholder: "Título de columna",
    columnsPanelDragIconLabel: "Reorder columna",
    columnsPanelShowAllButton: "Mostrar todo",
    columnsPanelHideAllButton: "Ocultar todo",
    filterPanelAddFilter: "Agregar filtro",
    filterPanelDeleteIconLabel: "Borrar",
    filterPanelOperators: "Operadores",
    filterPanelOperatorAnd: "Y",
    filterPanelOperatorOr: "O",
    filterPanelColumns: "Columnas",
    filterPanelInputLabel: "Valor",
    filterPanelInputPlaceholder: "Valor de filtro",
    filterOperatorContains: "contiene",
    filterOperatorEquals: "es igual",
    filterOperatorStartsWith: "comienza con",
    filterOperatorEndsWith: "termina con",
    filterOperatorIs: "es",
    filterOperatorNot: "no es",
    filterOperatorAfter: "es posterior",
    filterOperatorOnOrAfter: "es en o posterior",
    filterOperatorBefore: "es anterior",
    filterOperatorOnOrBefore: "es en o anterior",
    filterOperatorIsEmpty: "está vacío",
    filterOperatorIsNotEmpty: "no esta vacío",
    columnMenuLabel: "Menú",
    columnMenuShowColumns: "Mostrar columnas",
    columnMenuFilter: "Filtro",
    columnMenuHideColumn: "Ocultar",
    columnMenuUnsort: "Desordenar",
    columnMenuSortAsc: "Ordenar ASC",
    columnMenuSortDesc: "Ordenar DESC",
    columnHeaderFiltersTooltipActive: function columnHeaderFiltersTooltipActive(e) {
      return e > 1 ? "".concat(e, " filtros activos") : "".concat(e, " filtro activo");
    },
    columnHeaderFiltersLabel: "Mostrar filtros",
    columnHeaderSortIconLabel: "Ordenar",
    footerRowSelected: function footerRowSelected(e) {
      return e > 1 ? "".concat(e.toLocaleString(), " filas seleccionadas") : "".concat(e.toLocaleString(), " fila seleccionada");
    },
    footerTotalRows: "Filas Totales:",
    footerTotalVisibleRows: function footerTotalVisibleRows(e, t) {
      return "".concat(e.toLocaleString(), " de ").concat(t.toLocaleString());
    },
    actionsCellMore: "más"
  }, esES);
  bi({
    noRowsLabel: "بدون سطر",
    noResultsOverlayLabel: "نتیجه ای پیدا نشد.",
    errorOverlayDefaultLabel: "خطایی روی داد.",
    toolbarDensity: "تراکم",
    toolbarDensityLabel: "تراکم",
    toolbarDensityCompact: "فشرده",
    toolbarDensityStandard: "استاندارد",
    toolbarDensityComfortable: "راحت",
    toolbarColumns: "ستون‌ها",
    toolbarColumnsLabel: "ستون‌ها را انتخاب کنید",
    toolbarFilters: "فیلترها",
    toolbarFiltersLabel: "نمایش فیلترها",
    toolbarFiltersTooltipHide: "مخفی کردن فیلترها",
    toolbarFiltersTooltipShow: "نمایش فیلترها",
    toolbarFiltersTooltipActive: function toolbarFiltersTooltipActive(e) {
      return 1 !== e ? "".concat(e, " \u0641\u06CC\u0644\u062A\u0631\u0647\u0627\u06CC \u0641\u0639\u0627\u0644") : "".concat(e, " \u0641\u06CC\u0644\u062A\u0631 \u0641\u0639\u0627\u0644");
    },
    toolbarExport: "خروجی",
    toolbarExportLabel: "خروجی",
    toolbarExportCSV: "دانلود به‌صورت CSV",
    columnsPanelTextFieldLabel: "پیداکردن ستون",
    columnsPanelTextFieldPlaceholder: "عنوان ستون",
    columnsPanelDragIconLabel: "جا‌به‌جایی ستون",
    columnsPanelShowAllButton: "نمایش همه",
    columnsPanelHideAllButton: "مخفی همه",
    filterPanelAddFilter: "افزودن فیلتر",
    filterPanelDeleteIconLabel: "حذف",
    filterPanelOperators: "عملگرها",
    filterPanelOperatorAnd: "و",
    filterPanelOperatorOr: "یا",
    filterPanelColumns: "ستون‌ها",
    filterPanelInputLabel: "مقدار",
    filterPanelInputPlaceholder: "فیلتر مقدار",
    filterOperatorContains: "شامل",
    filterOperatorEquals: "مساوی",
    filterOperatorStartsWith: "شروع با",
    filterOperatorEndsWith: "پایان با",
    filterOperatorIs: "هست",
    filterOperatorNot: "نیست",
    filterOperatorAfter: "بعد از",
    filterOperatorOnOrAfter: "معادل یا بعدش",
    filterOperatorBefore: "قبلش",
    filterOperatorOnOrBefore: "معادل یا قبلش",
    filterOperatorIsEmpty: "خالی است",
    filterOperatorIsNotEmpty: "خالی نیست",
    filterValueAny: "هرچیزی",
    filterValueTrue: "صحیح",
    filterValueFalse: "غلط",
    columnMenuLabel: "فهرست",
    columnMenuShowColumns: "نمایش ستون‌ها",
    columnMenuFilter: "فیلتر",
    columnMenuHideColumn: "مخفی",
    columnMenuUnsort: "نامرتب‌کردن",
    columnMenuSortAsc: "مرتب‌کردن صعودی",
    columnMenuSortDesc: "مرتب‌کردن نزولی",
    columnHeaderFiltersTooltipActive: function columnHeaderFiltersTooltipActive(e) {
      return 1 !== e ? "".concat(e, " \u0641\u06CC\u0644\u062A\u0631\u200C\u0647\u0627\u06CC \u0641\u0639\u0627\u0644") : "".concat(e, " \u0641\u06CC\u0644\u062A\u0631 \u0641\u0639\u0627\u0644");
    },
    columnHeaderFiltersLabel: "نمایش فیلترها",
    columnHeaderSortIconLabel: "مرتب‌کردن",
    footerRowSelected: function footerRowSelected(e) {
      return 1 !== e ? "".concat(e.toLocaleString(), " \u0633\u0637\u0631\u0647\u0627\u06CC \u0627\u0646\u062A\u062E\u0627\u0628 \u0634\u062F\u0647") : "".concat(e.toLocaleString(), " \u0633\u0637\u0631 \u0627\u0646\u062A\u062E\u0627\u0628 \u0634\u062F\u0647");
    },
    footerTotalRows: "مجموع سطرها:",
    footerTotalVisibleRows: function footerTotalVisibleRows(e, t) {
      return "".concat(e.toLocaleString(), " \u0627\u0632 ").concat(t.toLocaleString());
    },
    checkboxSelectionHeaderName: "انتخاب چک‌باکس",
    booleanCellTrueLabel: "صحیح",
    booleanCellFalseLabel: "غلط",
    actionsCellMore: "بیشتر"
  }, faIR);
  bi({
    noRowsLabel: "Pas de résultats",
    noResultsOverlayLabel: "Aucun résultat.",
    errorOverlayDefaultLabel: "Une erreur est apparue.",
    toolbarDensity: "Densité",
    toolbarDensityLabel: "Densité",
    toolbarDensityCompact: "Compact",
    toolbarDensityStandard: "Standard",
    toolbarDensityComfortable: "Confortable",
    toolbarColumns: "Colonnes",
    toolbarColumnsLabel: "Choisir les colonnes",
    toolbarFilters: "Filtres",
    toolbarFiltersLabel: "Afficher les filtres",
    toolbarFiltersTooltipHide: "Cacher les filtres",
    toolbarFiltersTooltipShow: "Afficher les filtres",
    toolbarFiltersTooltipActive: function toolbarFiltersTooltipActive(e) {
      return e > 1 ? "".concat(e, " filtres actifs") : "".concat(e, " filtre actif");
    },
    toolbarExport: "Exporter",
    toolbarExportLabel: "Exporter",
    toolbarExportCSV: "Télécharger en CSV",
    columnsPanelTextFieldLabel: "Chercher colonne",
    columnsPanelTextFieldPlaceholder: "Titre de la colonne",
    columnsPanelDragIconLabel: "Réorganiser la colonne",
    columnsPanelShowAllButton: "Tout afficher",
    columnsPanelHideAllButton: "Tout cacher",
    filterPanelAddFilter: "Ajouter un filtre",
    filterPanelDeleteIconLabel: "Supprimer",
    filterPanelOperators: "Opérateurs",
    filterPanelOperatorAnd: "Et",
    filterPanelOperatorOr: "Ou",
    filterPanelColumns: "Colonnes",
    filterPanelInputLabel: "Valeur",
    filterPanelInputPlaceholder: "Filtrer la valeur",
    filterOperatorContains: "contient",
    filterOperatorEquals: "égal à",
    filterOperatorStartsWith: "commence par",
    filterOperatorEndsWith: "se termine par",
    filterOperatorIs: "est",
    filterOperatorNot: "n'est pas",
    filterOperatorAfter: "postérieur",
    filterOperatorOnOrAfter: "égal ou postérieur",
    filterOperatorBefore: "antérieur",
    filterOperatorOnOrBefore: "égal ou antérieur",
    filterOperatorIsEmpty: "est vide",
    filterOperatorIsNotEmpty: "n'est pas vide",
    columnMenuLabel: "Menu",
    columnMenuShowColumns: "Afficher les colonnes",
    columnMenuFilter: "Filtrer",
    columnMenuHideColumn: "Cacher",
    columnMenuUnsort: "Annuler le tri",
    columnMenuSortAsc: "Tri ascendant",
    columnMenuSortDesc: "Tri descendant",
    columnHeaderFiltersTooltipActive: function columnHeaderFiltersTooltipActive(e) {
      return e > 1 ? "".concat(e, " filtres actifs") : "".concat(e, " filtre actif");
    },
    columnHeaderFiltersLabel: "Afficher les filtres",
    columnHeaderSortIconLabel: "Trier",
    footerRowSelected: function footerRowSelected(e) {
      return e > 1 ? "".concat(e.toLocaleString(), " lignes s\xE9lectionn\xE9es") : "".concat(e.toLocaleString(), " ligne s\xE9lectionn\xE9e");
    },
    footerTotalRows: "Lignes totales :",
    footerTotalVisibleRows: function footerTotalVisibleRows(e, t) {
      return "".concat(e.toLocaleString(), " sur ").concat(t.toLocaleString());
    },
    checkboxSelectionHeaderName: "Sélection",
    actionsCellMore: "Plus",
    treeDataGroupingHeaderName: "Groupe",
    treeDataExpand: "afficher les enfants",
    treeDataCollapse: "masquer les enfants"
  }, frFR);
  bi({
    noRowsLabel: "אין שורות",
    noResultsOverlayLabel: "לא נמצאו תוצאות.",
    errorOverlayDefaultLabel: "אירעה שגיאה.",
    toolbarDensity: "צפיפות",
    toolbarDensityLabel: "צפיפות",
    toolbarDensityCompact: "דחוסה",
    toolbarDensityStandard: "רגילה",
    toolbarDensityComfortable: "אוורירית",
    toolbarColumns: "עמודות",
    toolbarColumnsLabel: "בחר עמודות",
    toolbarFilters: "סינון",
    toolbarFiltersLabel: "הצג מסננים",
    toolbarFiltersTooltipHide: "הסתר מסננים",
    toolbarFiltersTooltipShow: "הצג מסננים",
    toolbarFiltersTooltipActive: function toolbarFiltersTooltipActive(e) {
      return 1 !== e ? "".concat(e, " \u05DE\u05E1\u05E0\u05E0\u05D9\u05DD \u05E4\u05E2\u05D9\u05DC\u05D9\u05DD") : "מסנן אחד פעיל";
    },
    toolbarExport: "ייצוא",
    toolbarExportLabel: "ייצוא",
    toolbarExportCSV: "הורדה כ- CSV",
    toolbarExportPrint: "הדפסה",
    columnsPanelTextFieldLabel: "חפש עמודה",
    columnsPanelTextFieldPlaceholder: "כותרת עמודה",
    columnsPanelDragIconLabel: "סדר עמודות מחדש",
    columnsPanelShowAllButton: "הצג הכל",
    columnsPanelHideAllButton: "הסתר הכל",
    filterPanelAddFilter: "הוסף מסנן",
    filterPanelDeleteIconLabel: "מחק",
    filterPanelOperators: "אופרטור",
    filterPanelOperatorAnd: "וגם",
    filterPanelOperatorOr: "או",
    filterPanelColumns: "עמודות",
    filterPanelInputLabel: "ערך",
    filterPanelInputPlaceholder: "ערך מסנן",
    filterOperatorContains: "מכיל",
    filterOperatorEquals: "שווה",
    filterOperatorStartsWith: "מתחיל ב-",
    filterOperatorEndsWith: "נגמר ב-",
    filterOperatorIs: "הינו",
    filterOperatorNot: "אינו",
    filterOperatorAfter: "אחרי",
    filterOperatorOnOrAfter: "ב- או אחרי",
    filterOperatorBefore: "לפני",
    filterOperatorOnOrBefore: "ב- או לפני",
    filterOperatorIsEmpty: "ריק",
    filterOperatorIsNotEmpty: "אינו ריק",
    filterValueAny: "כל ערך",
    filterValueTrue: "כן",
    filterValueFalse: "לא",
    columnMenuLabel: "תפריט",
    columnMenuShowColumns: "הצג עמודות",
    columnMenuFilter: "סנן",
    columnMenuHideColumn: "הסתר",
    columnMenuUnsort: "בטל מיון",
    columnMenuSortAsc: "מיין בסדר עולה",
    columnMenuSortDesc: "מיין בסדר יורד",
    columnHeaderFiltersTooltipActive: function columnHeaderFiltersTooltipActive(e) {
      return 1 !== e ? "".concat(e, " \u05DE\u05E1\u05E0\u05E0\u05D9\u05DD \u05E4\u05E2\u05D9\u05DC\u05D9\u05DD") : "מסנן אחד פעיל";
    },
    columnHeaderFiltersLabel: "הצג מסננים",
    columnHeaderSortIconLabel: "מיין",
    footerRowSelected: function footerRowSelected(e) {
      return 1 !== e ? "".concat(e.toLocaleString(), " \u05E9\u05D5\u05E8\u05D5\u05EA \u05E0\u05D1\u05D7\u05E8\u05D5") : "שורה אחת נבחרה";
    },
    footerTotalRows: "סך הכל שורות: ",
    footerTotalVisibleRows: function footerTotalVisibleRows(e, t) {
      return "".concat(e.toLocaleString(), " \u05DE\u05EA\u05D5\u05DA ").concat(t.toLocaleString());
    },
    checkboxSelectionHeaderName: "בחירה",
    booleanCellTrueLabel: "כן",
    booleanCellFalseLabel: "לא",
    actionsCellMore: "עוד",
    treeDataGroupingHeaderName: "קבץ",
    treeDataExpand: "הרחב",
    treeDataCollapse: "הסתר"
  }, heIL);
  bi({
    noRowsLabel: "Nessun record",
    noResultsOverlayLabel: "Nessun record trovato.",
    errorOverlayDefaultLabel: "Si è verificato un errore.",
    toolbarDensity: "Densità",
    toolbarDensityLabel: "Densità",
    toolbarDensityCompact: "Compatta",
    toolbarDensityStandard: "Standard",
    toolbarDensityComfortable: "Comoda",
    toolbarColumns: "Colonne",
    toolbarColumnsLabel: "Seleziona le colonne",
    toolbarFilters: "Filtri",
    toolbarFiltersLabel: "Mostra i filtri",
    toolbarFiltersTooltipHide: "Nascondi i filtri",
    toolbarFiltersTooltipShow: "Mostra i filtri",
    toolbarFiltersTooltipActive: function toolbarFiltersTooltipActive(e) {
      return e > 1 ? "".concat(e, " filtri attivi") : "".concat(e, " filtro attivo");
    },
    toolbarExport: "Esporta",
    toolbarExportLabel: "Esporta",
    toolbarExportCSV: "Esporta in CSV",
    columnsPanelTextFieldLabel: "Cerca colonna",
    columnsPanelTextFieldPlaceholder: "Titolo della colonna",
    columnsPanelDragIconLabel: "Riordina la colonna",
    columnsPanelShowAllButton: "Mostra tutto",
    columnsPanelHideAllButton: "Nascondi tutto",
    filterPanelAddFilter: "Aggiungi un filtro",
    filterPanelDeleteIconLabel: "Rimuovi",
    filterPanelOperators: "Operatori",
    filterPanelOperatorAnd: "E (and)",
    filterPanelOperatorOr: "O (or)",
    filterPanelColumns: "Colonne",
    filterPanelInputLabel: "Valore",
    filterPanelInputPlaceholder: "Filtra il valore",
    filterOperatorContains: "contiene",
    filterOperatorEquals: "uguale a",
    filterOperatorStartsWith: "comincia per",
    filterOperatorEndsWith: "termina per",
    filterOperatorIs: "uguale a",
    filterOperatorNot: "diversa da",
    filterOperatorAfter: "dopo il",
    filterOperatorOnOrAfter: "a partire dal",
    filterOperatorBefore: "prima del",
    filterOperatorOnOrBefore: "fino al",
    filterOperatorIsEmpty: "è vuoto",
    filterOperatorIsNotEmpty: "non è vuoto",
    columnMenuLabel: "Menu",
    columnMenuShowColumns: "Mostra le colonne",
    columnMenuFilter: "Filtra",
    columnMenuHideColumn: "Nascondi",
    columnMenuUnsort: "Annulla l'ordinamento",
    columnMenuSortAsc: "Ordinamento crescente",
    columnMenuSortDesc: "Ordinamento decrescente",
    columnHeaderFiltersTooltipActive: function columnHeaderFiltersTooltipActive(e) {
      return e > 1 ? "".concat(e, " filtri attivi") : "".concat(e, " filtro attivo");
    },
    columnHeaderFiltersLabel: "Mostra i filtri",
    columnHeaderSortIconLabel: "Ordina",
    footerRowSelected: function footerRowSelected(e) {
      return e > 1 ? "".concat(e.toLocaleString(), " record selezionati") : "".concat(e.toLocaleString(), " record selezionato");
    },
    footerTotalRows: "Record totali:",
    footerTotalVisibleRows: function footerTotalVisibleRows(e, t) {
      return "".concat(e.toLocaleString(), " di ").concat(t.toLocaleString());
    },
    checkboxSelectionHeaderName: "Seleziona",
    actionsCellMore: "più"
  }, itIT);
  bi({
    noRowsLabel: "行がありません。",
    noResultsOverlayLabel: "結果がありません。",
    errorOverlayDefaultLabel: "エラーが発生しました。",
    toolbarDensity: "行間隔",
    toolbarDensityLabel: "行間隔",
    toolbarDensityCompact: "コンパクト",
    toolbarDensityStandard: "標準",
    toolbarDensityComfortable: "ひろめ",
    toolbarColumns: "列一覧",
    toolbarColumnsLabel: "列選択",
    toolbarFilters: "フィルター",
    toolbarFiltersLabel: "フィルター表示",
    toolbarFiltersTooltipHide: "フィルター非表示",
    toolbarFiltersTooltipShow: "フィルター表示",
    toolbarFiltersTooltipActive: function toolbarFiltersTooltipActive(e) {
      return "".concat(e, "\u4EF6\u306E\u30D5\u30A3\u30EB\u30BF\u30FC\u3092\u9069\u7528\u4E2D");
    },
    toolbarExport: "エクスポート",
    toolbarExportLabel: "エクスポート",
    toolbarExportCSV: "CSVダウンロード",
    columnsPanelTextFieldLabel: "列検索",
    columnsPanelTextFieldPlaceholder: "検索クエリを入力...",
    columnsPanelDragIconLabel: "列並べ替え",
    columnsPanelShowAllButton: "すべて表示",
    columnsPanelHideAllButton: "すべて非表示",
    filterPanelAddFilter: "フィルター追加",
    filterPanelDeleteIconLabel: "削除",
    filterPanelOperators: "オペレータ",
    filterPanelOperatorAnd: "And",
    filterPanelOperatorOr: "Or",
    filterPanelColumns: "列",
    filterPanelInputLabel: "値",
    filterPanelInputPlaceholder: "値を入力...",
    filterOperatorContains: "...を含む",
    filterOperatorEquals: "...に等しい",
    filterOperatorStartsWith: "...で始まる",
    filterOperatorEndsWith: "...で終わる",
    filterOperatorIs: "...である",
    filterOperatorNot: "...でない",
    filterOperatorAfter: "...より後ろ",
    filterOperatorOnOrAfter: "...以降",
    filterOperatorBefore: "...より前",
    filterOperatorOnOrBefore: "...以前",
    filterOperatorIsEmpty: "...空である",
    filterOperatorIsNotEmpty: "...空でない",
    columnMenuLabel: "メニュー",
    columnMenuShowColumns: "列表示",
    columnMenuFilter: "フィルター",
    columnMenuHideColumn: "列非表示",
    columnMenuUnsort: "ソート解除",
    columnMenuSortAsc: "昇順ソート",
    columnMenuSortDesc: "降順ソート",
    columnHeaderFiltersTooltipActive: function columnHeaderFiltersTooltipActive(e) {
      return "".concat(e, "\u4EF6\u306E\u30D5\u30A3\u30EB\u30BF\u30FC\u3092\u9069\u7528\u4E2D");
    },
    columnHeaderFiltersLabel: "フィルター表示",
    columnHeaderSortIconLabel: "ソート",
    footerRowSelected: function footerRowSelected(e) {
      return "".concat(e, "\u884C\u3092\u9078\u629E\u4E2D");
    },
    footerTotalRows: "総行数:",
    footerTotalVisibleRows: function footerTotalVisibleRows(e, t) {
      return "".concat(e.toLocaleString(), " / ").concat(t.toLocaleString());
    },
    checkboxSelectionHeaderName: "チェックボックス",
    booleanCellTrueLabel: "真",
    booleanCellFalseLabel: "偽"
  }, jaJP);
  bi({
    noRowsLabel: "행이 없습니다.",
    noResultsOverlayLabel: "결과값이 없습니다.",
    errorOverlayDefaultLabel: "오류가 발생했습니다.",
    toolbarDensity: "라인 간격",
    toolbarDensityLabel: "라인 간격",
    toolbarDensityCompact: "좁게",
    toolbarDensityStandard: "기본",
    toolbarDensityComfortable: "넓게",
    toolbarColumns: "열 목록",
    toolbarColumnsLabel: "열 선택",
    toolbarFilters: "필터",
    toolbarFiltersLabel: "필터 표시",
    toolbarFiltersTooltipHide: "필터 숨기기",
    toolbarFiltersTooltipShow: "필터 표시",
    toolbarFiltersTooltipActive: function toolbarFiltersTooltipActive(e) {
      return "".concat(e, "\uAC74\uC758 \uD544\uD130\uB97C \uC801\uC6A9\uC911");
    },
    toolbarExport: "내보내기",
    toolbarExportLabel: "내보내기",
    toolbarExportCSV: "CSV다운로드",
    toolbarExportPrint: "프린트",
    columnsPanelTextFieldLabel: "열 검색",
    columnsPanelTextFieldPlaceholder: "열 이름",
    columnsPanelDragIconLabel: "열 정렬",
    columnsPanelShowAllButton: "모두 보기",
    columnsPanelHideAllButton: "모두 숨기기",
    filterPanelAddFilter: "필터 추가",
    filterPanelDeleteIconLabel: "삭제",
    filterPanelOperators: "연산자",
    filterPanelOperatorAnd: "그리고",
    filterPanelOperatorOr: "또는",
    filterPanelColumns: "목록",
    filterPanelInputLabel: "값",
    filterPanelInputPlaceholder: "값 입력",
    filterOperatorContains: "포함하는",
    filterOperatorEquals: "값이 같은",
    filterOperatorStartsWith: "시작하는",
    filterOperatorEndsWith: "끝나는",
    filterOperatorIs: "~인",
    filterOperatorNot: "~아닌",
    filterOperatorAfter: "더 이후",
    filterOperatorOnOrAfter: "이후",
    filterOperatorBefore: "더 이전",
    filterOperatorOnOrBefore: "이전",
    filterOperatorIsEmpty: "값이 없는",
    filterOperatorIsNotEmpty: "값이 있는",
    filterValueAny: "아무값",
    filterValueTrue: "참",
    filterValueFalse: "거짓",
    columnMenuLabel: "메뉴",
    columnMenuShowColumns: "열 표시",
    columnMenuFilter: "필터",
    columnMenuHideColumn: "열 숨기기",
    columnMenuUnsort: "정렬 해제",
    columnMenuSortAsc: "오름차순 정렬",
    columnMenuSortDesc: "내림차순 정렬",
    columnHeaderFiltersTooltipActive: function columnHeaderFiltersTooltipActive(e) {
      return "".concat(e, "\uAC74\uC758 \uD544\uD130\uB97C \uC801\uC6A9\uC911");
    },
    columnHeaderFiltersLabel: "필터 표시",
    columnHeaderSortIconLabel: "정렬",
    footerRowSelected: function footerRowSelected(e) {
      return "".concat(e, "\uD589 \uC120\uD0DD\uC911");
    },
    footerTotalRows: "총 행수:",
    footerTotalVisibleRows: function footerTotalVisibleRows(e, t) {
      return "".concat(e.toLocaleString(), " / ").concat(t.toLocaleString());
    },
    checkboxSelectionHeaderName: "선택",
    booleanCellTrueLabel: "참",
    booleanCellFalseLabel: "거짓",
    actionsCellMore: "더보기",
    treeDataGroupingHeaderName: "그룹",
    treeDataExpand: "하위노드 펼치기",
    treeDataCollapse: "하위노드 접기"
  }, koKR);
  bi({
    noRowsLabel: "Geen resultaten.",
    errorOverlayDefaultLabel: "Er deed zich een fout voor.",
    toolbarDensity: "Grootte",
    toolbarDensityLabel: "Grootte",
    toolbarDensityCompact: "Compact",
    toolbarDensityStandard: "Normaal",
    toolbarDensityComfortable: "Breed",
    toolbarColumns: "Kolommen",
    toolbarColumnsLabel: "Kies kolommen",
    toolbarFilters: "Filters",
    toolbarFiltersLabel: "Toon filters",
    toolbarFiltersTooltipHide: "Verberg filters",
    toolbarFiltersTooltipShow: "Toon filters",
    toolbarFiltersTooltipActive: function toolbarFiltersTooltipActive(e) {
      return e > 1 ? "".concat(e, " actieve filters") : "".concat(e, " filter actief");
    },
    columnsPanelTextFieldLabel: "Zoek kolom",
    columnsPanelTextFieldPlaceholder: "Kolomtitel",
    columnsPanelDragIconLabel: "Kolom herschikken",
    columnsPanelShowAllButton: "Alles tonen",
    columnsPanelHideAllButton: "Alles verbergen",
    filterPanelAddFilter: "Filter toevoegen",
    filterPanelDeleteIconLabel: "Verwijderen",
    filterPanelOperators: "Operatoren",
    filterPanelOperatorAnd: "En",
    filterPanelOperatorOr: "Of",
    filterPanelColumns: "Kolommen",
    filterPanelInputLabel: "Waarde",
    filterPanelInputPlaceholder: "Filter waarde",
    filterOperatorContains: "bevat",
    filterOperatorEquals: "gelijk aan",
    filterOperatorStartsWith: "begint met",
    filterOperatorEndsWith: "eindigt met",
    filterOperatorIs: "is",
    filterOperatorNot: "is niet",
    filterOperatorAfter: "is voor",
    filterOperatorOnOrAfter: "is gelijk of er voor",
    filterOperatorBefore: "is na",
    filterOperatorOnOrBefore: "is gelijk of er na",
    columnMenuLabel: "Menu",
    columnMenuShowColumns: "Toon kolommen",
    columnMenuFilter: "Filteren",
    columnMenuHideColumn: "Verbergen",
    columnMenuUnsort: "Annuleer sortering",
    columnMenuSortAsc: "Oplopend sorteren",
    columnMenuSortDesc: "Aflopend sorteren",
    columnHeaderFiltersTooltipActive: function columnHeaderFiltersTooltipActive(e) {
      return e > 1 ? "".concat(e, " actieve filters") : "".concat(e, " filter actief");
    },
    columnHeaderFiltersLabel: "Toon filters",
    columnHeaderSortIconLabel: "Sorteren",
    footerRowSelected: function footerRowSelected(e) {
      return e > 1 ? "".concat(e.toLocaleString(), " rijen geselecteerd") : "".concat(e.toLocaleString(), " rij geselecteerd");
    },
    footerTotalRows: "Totaal:"
  }, nlNL);
  bi({
    noRowsLabel: "Brak danych",
    noResultsOverlayLabel: "Nie znaleziono wyników.",
    errorOverlayDefaultLabel: "Wystąpił błąd.",
    toolbarDensity: "Wysokość rzędu",
    toolbarDensityLabel: "Wysokość rzędu",
    toolbarDensityCompact: "Kompakt",
    toolbarDensityStandard: "Standard",
    toolbarDensityComfortable: "Komfort",
    toolbarColumns: "Kolumny",
    toolbarColumnsLabel: "Zaznacz kolumny",
    toolbarFilters: "Filtry",
    toolbarFiltersLabel: "Pokaż filtry",
    toolbarFiltersTooltipHide: "Ukryj filtry",
    toolbarFiltersTooltipShow: "Pokaż filtry",
    toolbarFiltersTooltipActive: function toolbarFiltersTooltipActive(e) {
      return "Liczba aktywnych filtr\xF3w: ".concat(e);
    },
    toolbarExport: "Eksportuj",
    toolbarExportLabel: "Eksportuj",
    toolbarExportCSV: "Pobierz jako plik CSV",
    columnsPanelTextFieldLabel: "Znajdź kolumnę",
    columnsPanelTextFieldPlaceholder: "Tytuł kolumny",
    columnsPanelDragIconLabel: "Zmień kolejność kolumn",
    columnsPanelShowAllButton: "Pokaż wszystko",
    columnsPanelHideAllButton: "Ukryj wszystko",
    filterPanelAddFilter: "Dodaj filtr",
    filterPanelDeleteIconLabel: "Usuń",
    filterPanelOperators: "Operator",
    filterPanelOperatorAnd: "I",
    filterPanelOperatorOr: "Lub",
    filterPanelColumns: "Kolumny",
    filterPanelInputLabel: "Wartość",
    filterPanelInputPlaceholder: "Filtrowana wartość",
    filterOperatorContains: "zawiera",
    filterOperatorEquals: "równa się",
    filterOperatorStartsWith: "zaczyna się od",
    filterOperatorEndsWith: "kończy się na",
    filterOperatorIs: "równa się",
    filterOperatorNot: "różne",
    filterOperatorAfter: "większe niż",
    filterOperatorOnOrAfter: "większe lub równe",
    filterOperatorBefore: "mniejsze niż",
    filterOperatorOnOrBefore: "mniejsze lub równe",
    filterOperatorIsEmpty: "jest pusty",
    filterOperatorIsNotEmpty: "nie jest pusty",
    columnMenuLabel: "Menu",
    columnMenuShowColumns: "Pokaż wszystkie kolumny",
    columnMenuFilter: "Filtr",
    columnMenuHideColumn: "Ukryj",
    columnMenuUnsort: "Anuluj sortowanie",
    columnMenuSortAsc: "Sortuj rosnąco",
    columnMenuSortDesc: "Sortuj malejąco",
    columnHeaderFiltersTooltipActive: function columnHeaderFiltersTooltipActive(e) {
      return "Liczba aktywnych filtr\xF3w: ".concat(e);
    },
    columnHeaderFiltersLabel: "Pokaż filtry",
    columnHeaderSortIconLabel: "Sortuj",
    footerRowSelected: function footerRowSelected(e) {
      return "Liczba wybranych wierszy: ".concat(e.toLocaleString());
    },
    footerTotalRows: "Łączna liczba wierszy:",
    footerTotalVisibleRows: function footerTotalVisibleRows(e, t) {
      return "".concat(e.toLocaleString(), " z ").concat(t.toLocaleString());
    },
    actionsCellMore: "więcej"
  }, plPL);
  bi({
    noRowsLabel: "Nenhuma linha",
    noResultsOverlayLabel: "Nenhum resultado encontrado.",
    errorOverlayDefaultLabel: "Ocorreu um erro.",
    toolbarDensity: "Densidade",
    toolbarDensityLabel: "Densidade",
    toolbarDensityCompact: "Compacto",
    toolbarDensityStandard: "Padrão",
    toolbarDensityComfortable: "Confortável",
    toolbarColumns: "Colunas",
    toolbarColumnsLabel: "Exibir seletor de colunas",
    toolbarFilters: "Filtros",
    toolbarFiltersLabel: "Exibir filtros",
    toolbarFiltersTooltipHide: "Ocultar filtros",
    toolbarFiltersTooltipShow: "Exibir filtros",
    toolbarFiltersTooltipActive: function toolbarFiltersTooltipActive(e) {
      return "".concat(e, " ").concat(1 !== e ? "filtros" : "filtro", " ").concat(1 !== e ? "ativos" : "ativo");
    },
    toolbarExport: "Exportar",
    toolbarExportLabel: "Exportar",
    toolbarExportCSV: "Baixar como CSV",
    toolbarExportPrint: "Print",
    columnsPanelTextFieldLabel: "Localizar coluna",
    columnsPanelTextFieldPlaceholder: "Título da coluna",
    columnsPanelDragIconLabel: "Reordenar Coluna",
    columnsPanelShowAllButton: "Mostrar todas",
    columnsPanelHideAllButton: "Ocultar todas",
    filterPanelAddFilter: "Adicionar filtro",
    filterPanelDeleteIconLabel: "Excluir",
    filterPanelOperators: "Operadores",
    filterPanelOperatorAnd: "E",
    filterPanelOperatorOr: "Ou",
    filterPanelColumns: "Colunas",
    filterPanelInputLabel: "Valor",
    filterPanelInputPlaceholder: "Filtrar valor",
    filterOperatorContains: "contém",
    filterOperatorEquals: "é igual a",
    filterOperatorStartsWith: "começa com",
    filterOperatorEndsWith: "termina com",
    filterOperatorIs: "é",
    filterOperatorNot: "não é",
    filterOperatorAfter: "após",
    filterOperatorOnOrAfter: "em ou após",
    filterOperatorBefore: "antes de",
    filterOperatorOnOrBefore: "em ou antes de",
    filterOperatorIsEmpty: "está vazio",
    filterOperatorIsNotEmpty: "não está vazio",
    filterValueAny: "qualquer",
    filterValueTrue: "verdadeiro",
    filterValueFalse: "falso",
    columnMenuLabel: "Menu",
    columnMenuShowColumns: "Exibir colunas",
    columnMenuFilter: "Filtrar",
    columnMenuHideColumn: "Ocultar",
    columnMenuUnsort: "Desfazer ordenação",
    columnMenuSortAsc: "Ordenar do menor para o maior",
    columnMenuSortDesc: "Ordenar do maior para o menor",
    columnHeaderFiltersTooltipActive: function columnHeaderFiltersTooltipActive(e) {
      return "".concat(e, " ").concat(1 !== e ? "filtros" : "filtro", " ").concat(1 !== e ? "ativos" : "ativo");
    },
    columnHeaderFiltersLabel: "Exibir Filtros",
    columnHeaderSortIconLabel: "Ordenar",
    footerRowSelected: function footerRowSelected(e) {
      return 1 !== e ? "".concat(e.toLocaleString(), " linhas selecionadas") : "".concat(e.toLocaleString(), " linha selecionada");
    },
    footerTotalRows: "Total de linhas:",
    footerTotalVisibleRows: function footerTotalVisibleRows(e, t) {
      return "".concat(e.toLocaleString(), " de ").concat(t.toLocaleString());
    },
    checkboxSelectionHeaderName: "Seleção",
    booleanCellTrueLabel: "sim",
    booleanCellFalseLabel: "não",
    actionsCellMore: "mais"
  }, ptBR);
  bi({
    noRowsLabel: "Нет строк",
    noResultsOverlayLabel: "Данные не найдены.",
    errorOverlayDefaultLabel: "Обнаружена ошибка.",
    toolbarDensity: "Высота строки",
    toolbarDensityLabel: "Высота строки",
    toolbarDensityCompact: "Компактная",
    toolbarDensityStandard: "Стандартная",
    toolbarDensityComfortable: "Комфортная",
    toolbarColumns: "Столбцы",
    toolbarColumnsLabel: "Выделите столбцы",
    toolbarFilters: "Фильтры",
    toolbarFiltersLabel: "Показать фильтры",
    toolbarFiltersTooltipHide: "Скрыть фильтры",
    toolbarFiltersTooltipShow: "Показать фильтры",
    toolbarFiltersTooltipActive: function toolbarFiltersTooltipActive(e) {
      var t = "активных фильтров";
      var r = e % 10;
      return r > 1 && r < 5 ? t = "активных фильтра" : 1 === r && (t = "активный фильтр"), "".concat(e, " ").concat(t);
    },
    toolbarExport: "Экспорт",
    toolbarExportLabel: "Экспорт",
    toolbarExportCSV: "Скачать в формате CSV",
    toolbarExportPrint: "Печать",
    columnsPanelTextFieldLabel: "Найти столбец",
    columnsPanelTextFieldPlaceholder: "Заголовок столбца",
    columnsPanelDragIconLabel: "Изменить порядок столбца",
    columnsPanelShowAllButton: "Показать все",
    columnsPanelHideAllButton: "Скрыть все",
    filterPanelAddFilter: "Добавить фильтр",
    filterPanelDeleteIconLabel: "Удалить",
    filterPanelOperators: "Операторы",
    filterPanelOperatorAnd: "И",
    filterPanelOperatorOr: "Или",
    filterPanelColumns: "Столбцы",
    filterPanelInputLabel: "Значение",
    filterPanelInputPlaceholder: "Значение фильтра",
    filterOperatorContains: "содержит",
    filterOperatorEquals: "равен",
    filterOperatorStartsWith: "начинается с",
    filterOperatorEndsWith: "заканчивается на",
    filterOperatorIs: "равен",
    filterOperatorNot: "не равен",
    filterOperatorAfter: "больше чем",
    filterOperatorOnOrAfter: "больше или равно",
    filterOperatorBefore: "меньше чем",
    filterOperatorOnOrBefore: "меньше или равно",
    filterOperatorIsEmpty: "пустой",
    filterOperatorIsNotEmpty: "не пустой",
    filterValueAny: "любой",
    filterValueTrue: "истина",
    filterValueFalse: "ложь",
    columnMenuLabel: "Меню",
    columnMenuShowColumns: "Показать столбцы",
    columnMenuFilter: "Фильтр",
    columnMenuHideColumn: "Скрыть",
    columnMenuUnsort: "Отменить сортировку",
    columnMenuSortAsc: "Сортировать по возрастанию",
    columnMenuSortDesc: "Сортировать по убыванию",
    columnHeaderFiltersTooltipActive: function columnHeaderFiltersTooltipActive(e) {
      var t = "активных фильтров";
      var r = e % 10;
      return r > 1 && r < 5 ? t = "активных фильтра" : 1 === r && (t = "активный фильтр"), "".concat(e, " ").concat(t);
    },
    columnHeaderFiltersLabel: "Показать фильтры",
    columnHeaderSortIconLabel: "Сортировать",
    footerRowSelected: function footerRowSelected(e) {
      var t = "строк выбрано";
      var r = e % 10;
      return r > 1 && r < 5 ? t = "строки выбраны" : 1 === r && (t = "строка выбрана"), "".concat(e, " ").concat(t);
    },
    footerTotalRows: "Всего строк:",
    footerTotalVisibleRows: function footerTotalVisibleRows(e, t) {
      return "".concat(e.toLocaleString(), " \u0438\u0437 ").concat(t.toLocaleString());
    },
    checkboxSelectionHeaderName: "Выбор флажка",
    booleanCellTrueLabel: "истина",
    booleanCellFalseLabel: "ложь",
    actionsCellMore: "ещё",
    treeDataGroupingHeaderName: "Группа",
    treeDataExpand: "показать дочерние элементы",
    treeDataCollapse: "скрыть дочерние элементы"
  }, ruRU);
  bi({
    noRowsLabel: "Žiadne záznamy",
    noResultsOverlayLabel: "Nenašli sa žadne výsledky.",
    errorOverlayDefaultLabel: "Stala sa nepredvídaná chyba.",
    toolbarDensity: "Hustota",
    toolbarDensityLabel: "Hustota",
    toolbarDensityCompact: "Kompaktná",
    toolbarDensityStandard: "Štandartná",
    toolbarDensityComfortable: "Komfortná",
    toolbarColumns: "Stĺpce",
    toolbarColumnsLabel: "Vybrať stĺpce",
    toolbarFilters: "Filtre",
    toolbarFiltersLabel: "Zobraziť filtre",
    toolbarFiltersTooltipHide: "Skryť filtre ",
    toolbarFiltersTooltipShow: "Zobraziť filtre",
    toolbarFiltersTooltipActive: function toolbarFiltersTooltipActive(e) {
      var t = "aktívnych filtrov";
      return e > 1 && e < 5 ? t = "aktívne filtre" : 1 === e && (t = "aktívny filter"), "".concat(e, " ").concat(t);
    },
    toolbarExport: "Export",
    toolbarExportLabel: "Export",
    toolbarExportCSV: "Stiahnuť ako CSV",
    columnsPanelTextFieldLabel: "Nájsť stĺpec",
    columnsPanelTextFieldPlaceholder: "Názov stĺpca",
    columnsPanelDragIconLabel: "Usporiadť stĺpce",
    columnsPanelShowAllButton: "Zobraziť všetko",
    columnsPanelHideAllButton: "Skryť všetko",
    filterPanelAddFilter: "Pridať filter",
    filterPanelDeleteIconLabel: "Odstrániť",
    filterPanelOperators: "Operátory",
    filterPanelOperatorAnd: "A",
    filterPanelOperatorOr: "Alebo",
    filterPanelColumns: "Stĺpce",
    filterPanelInputLabel: "Hodnota",
    filterPanelInputPlaceholder: "Hodnota filtra",
    filterOperatorContains: "obsahuje",
    filterOperatorEquals: "rovná sa",
    filterOperatorStartsWith: "začína s",
    filterOperatorEndsWith: "končí na",
    filterOperatorIs: "je",
    filterOperatorNot: "nie je",
    filterOperatorAfter: "je po",
    filterOperatorOnOrAfter: "je na alebo po",
    filterOperatorBefore: "je pred",
    filterOperatorOnOrBefore: "je na alebo skôr",
    filterValueAny: "akýkoľvek",
    filterValueTrue: "áno",
    filterValueFalse: "nie",
    columnMenuLabel: "Menu",
    columnMenuShowColumns: "Zobraziť stĺpce",
    columnMenuFilter: "Filter",
    columnMenuHideColumn: "Skryť",
    columnMenuUnsort: "Zrušiť filtre",
    columnMenuSortAsc: "Zoradiť vzostupne",
    columnMenuSortDesc: "Zoradiť zostupne",
    columnHeaderFiltersTooltipActive: function columnHeaderFiltersTooltipActive(e) {
      var t = "aktívnych filtrov";
      return e > 1 && e < 5 ? t = "aktívne filtre" : 1 === e && (t = "aktívny filter"), "".concat(e, " ").concat(t);
    },
    columnHeaderFiltersLabel: "Zobraziť filtre",
    columnHeaderSortIconLabel: "Filtrovať",
    footerRowSelected: function footerRowSelected(e) {
      var t = "vybraných záznamov";
      return e > 1 && e < 5 ? t = "vybrané záznamy" : 1 === e && (t = "vybraný záznam"), "".concat(e, " ").concat(t);
    },
    footerTotalRows: "Riadkov spolu:",
    checkboxSelectionHeaderName: "Výber riadku",
    booleanCellTrueLabel: "áno",
    booleanCellFalseLabel: "nie"
  }, skSK);
  bi({
    noRowsLabel: "Satır yok",
    errorOverlayDefaultLabel: "Bir hata oluştu.",
    toolbarDensity: "Yoğunluk",
    toolbarDensityLabel: "Yoğunluk",
    toolbarDensityCompact: "Sıkı",
    toolbarDensityStandard: "Standart",
    toolbarDensityComfortable: "Rahat",
    toolbarColumns: "Sütunlar",
    toolbarColumnsLabel: "Sütun seç",
    toolbarFilters: "Filtreler",
    toolbarFiltersLabel: "Filtreleri göster",
    toolbarFiltersTooltipHide: "Filtreleri gizle",
    toolbarFiltersTooltipShow: "Filtreleri göster",
    toolbarFiltersTooltipActive: function toolbarFiltersTooltipActive(e) {
      return "".concat(e, " aktif filtre");
    },
    toolbarExport: "Dışa aktar",
    toolbarExportLabel: "Dışa aktar",
    toolbarExportCSV: "CSV olarak aktar",
    columnsPanelTextFieldLabel: "Sütun ara",
    columnsPanelTextFieldPlaceholder: "Sütun adı",
    columnsPanelDragIconLabel: "Sütunları yeniden sırala",
    columnsPanelShowAllButton: "Hepsini göster",
    columnsPanelHideAllButton: "Hepsini gizle",
    filterPanelAddFilter: "Filtre Ekle",
    filterPanelDeleteIconLabel: "Kaldır",
    filterPanelOperators: "Operatör",
    filterPanelOperatorAnd: "Ve",
    filterPanelOperatorOr: "Veya",
    filterPanelColumns: "Sütunlar",
    filterPanelInputLabel: "Değer",
    filterPanelInputPlaceholder: "Filtre değeri",
    filterOperatorContains: "içerir",
    filterOperatorEquals: "eşittir",
    filterOperatorStartsWith: "ile başlar",
    filterOperatorEndsWith: "ile biter",
    filterOperatorIs: "eşittir",
    filterOperatorNot: "eşit değildir",
    filterOperatorAfter: "büyük",
    filterOperatorOnOrAfter: "büyük eşit",
    filterOperatorBefore: "küçük",
    filterOperatorOnOrBefore: "küçük eşit",
    filterOperatorIsEmpty: "boş",
    filterOperatorIsNotEmpty: "dolu",
    columnMenuLabel: "Menü",
    columnMenuShowColumns: "Sütunları göster",
    columnMenuFilter: "Filtre uygula",
    columnMenuHideColumn: "Gizle",
    columnMenuUnsort: "Sıralama",
    columnMenuSortAsc: "Sırala - Artan",
    columnMenuSortDesc: "Sırala - Azalan",
    columnHeaderFiltersTooltipActive: function columnHeaderFiltersTooltipActive(e) {
      return "".concat(e, " filtre aktif");
    },
    columnHeaderFiltersLabel: "Filtreleri göster",
    columnHeaderSortIconLabel: "Sırala",
    footerRowSelected: function footerRowSelected(e) {
      return "".concat(e.toLocaleString(), " sat\u0131r se\xE7ildi");
    },
    footerTotalRows: "Toplam Satır:",
    footerTotalVisibleRows: function footerTotalVisibleRows(e, t) {
      return "".concat(e.toLocaleString(), " / ").concat(t.toLocaleString());
    }
  }, trTR);
  bi({
    noRowsLabel: "Немає рядків",
    errorOverlayDefaultLabel: "Виявлено помилку.",
    toolbarDensity: "Висота рядка",
    toolbarDensityLabel: "Висота рядка",
    toolbarDensityCompact: "Компактний",
    toolbarDensityStandard: "Стандартний",
    toolbarDensityComfortable: "Комфортний",
    toolbarColumns: "Стовпці",
    toolbarColumnsLabel: "Виділіть стовпці",
    toolbarFilters: "Фільтри",
    toolbarFiltersLabel: "Показати фільтри",
    toolbarFiltersTooltipHide: "Сховати фільтри",
    toolbarFiltersTooltipShow: "Показати фільтри",
    toolbarFiltersTooltipActive: function toolbarFiltersTooltipActive(e) {
      return 1 !== e ? "".concat(e, " \u0430\u043A\u0442\u0438\u0432\u043D\u0456 \u0444\u0456\u043B\u044C\u0442\u0440\u0438") : "".concat(e, " \u0430\u043A\u0442\u0438\u0432\u043D\u0438\u0439 \u0444\u0456\u043B\u044C\u0442\u0440");
    },
    toolbarExport: "Експорт",
    toolbarExportLabel: "Експорт",
    toolbarExportCSV: "Завантажити у форматі CSV",
    columnsPanelTextFieldLabel: "Знайти стовпець",
    columnsPanelTextFieldPlaceholder: "Заголовок стовпця",
    columnsPanelDragIconLabel: "Змінити порядок стовпця",
    columnsPanelShowAllButton: "Показати усі",
    columnsPanelHideAllButton: "Сховати усі",
    filterPanelAddFilter: "Додати фільтр",
    filterPanelDeleteIconLabel: "Видалити",
    filterPanelOperators: "Оператори",
    filterPanelOperatorAnd: "І",
    filterPanelOperatorOr: "Або",
    filterPanelColumns: "Стовпці",
    filterPanelInputLabel: "Значення",
    filterPanelInputPlaceholder: "Значення фільтра",
    filterOperatorContains: "містить",
    filterOperatorEquals: "дорівнює",
    filterOperatorStartsWith: "починається з",
    filterOperatorEndsWith: "закінчується на",
    filterOperatorIs: "дорівнює",
    filterOperatorNot: "не",
    filterOperatorAfter: "більше ніж",
    filterOperatorOnOrAfter: "більше або дорівнює",
    filterOperatorBefore: "менше ніж",
    filterOperatorOnOrBefore: "менше або дорівнює",
    filterValueAny: "будь-який",
    filterValueTrue: "правда",
    filterValueFalse: "помилковий",
    columnMenuLabel: "Меню",
    columnMenuShowColumns: "Показати стовпці",
    columnMenuFilter: "Фільтр",
    columnMenuHideColumn: "Сховати",
    columnMenuUnsort: "Скасувати сортування",
    columnMenuSortAsc: "Сортувати за зростанням",
    columnMenuSortDesc: "Сортувати за спаданням",
    columnHeaderFiltersTooltipActive: function columnHeaderFiltersTooltipActive(e) {
      return 1 !== e ? "".concat(e, " \u0430\u043A\u0442\u0438\u0432\u043D\u0456 \u0444\u0456\u043B\u044C\u0442\u0440\u0438") : "".concat(e, " \u0430\u043A\u0442\u0438\u0432\u043D\u0438\u0439 \u0444\u0456\u043B\u044C\u0442\u0440");
    },
    columnHeaderFiltersLabel: "Показати фільтри",
    columnHeaderSortIconLabel: "Сортувати",
    footerRowSelected: function footerRowSelected(e) {
      return 1 !== e ? "".concat(e.toLocaleString(), " \u0432\u0438\u0431\u0440\u0430\u043D\u0456 \u0440\u044F\u0434\u043A\u0438") : "".concat(e.toLocaleString(), " \u0432\u0438\u0431\u0440\u0430\u043D\u0438\u0439 \u0440\u044F\u0434\u043E\u043A");
    },
    footerTotalRows: "Всього рядків:",
    checkboxSelectionHeaderName: "Вибір прапорця",
    booleanCellTrueLabel: "правда",
    booleanCellFalseLabel: "помилковий"
  }, ukUA);
  bi({
    noRowsLabel: "Không có dữ liệu",
    noResultsOverlayLabel: "Không tìm thấy kết quả.",
    errorOverlayDefaultLabel: "Có lỗi xảy ra.",
    toolbarDensity: "Độ giãn",
    toolbarDensityLabel: "Độ giãn",
    toolbarDensityCompact: "Trung bình",
    toolbarDensityStandard: "Tiêu chuẩn",
    toolbarDensityComfortable: "Rộng",
    toolbarColumns: "Cột",
    toolbarColumnsLabel: "Chọn cột",
    toolbarFilters: "Bộ lọc",
    toolbarFiltersLabel: "Hiển thị bộ lọc",
    toolbarFiltersTooltipHide: "Ẩn",
    toolbarFiltersTooltipShow: "Hiện",
    toolbarFiltersTooltipActive: function toolbarFiltersTooltipActive(e) {
      return "".concat(e, " b\u1ED9 l\u1ECDc ho\u1EA1t \u0111\u1ED9ng");
    },
    toolbarExport: "Xuất",
    toolbarExportLabel: "Xuất",
    toolbarExportCSV: "Xuất CSV",
    columnsPanelTextFieldLabel: "Tìm kiếm",
    columnsPanelTextFieldPlaceholder: "Tiêu đề cột",
    columnsPanelDragIconLabel: "Sắp xếp",
    columnsPanelShowAllButton: "Hiện tất cả",
    columnsPanelHideAllButton: "Ẩn tất cả",
    filterPanelAddFilter: "Thêm bộ lọc",
    filterPanelDeleteIconLabel: "Xóa",
    filterPanelOperators: "Toán tử",
    filterPanelOperatorAnd: "Và",
    filterPanelOperatorOr: "Hoặc",
    filterPanelColumns: "Cột",
    filterPanelInputLabel: "Giá trị",
    filterPanelInputPlaceholder: "Lọc giá trị",
    filterOperatorContains: "Chứa",
    filterOperatorEquals: "Bằng",
    filterOperatorStartsWith: "Bắt đầu bằng",
    filterOperatorEndsWith: "Kết thúc bằng",
    filterOperatorIs: "Là",
    filterOperatorNot: "Không là",
    filterOperatorAfter: "Trước",
    filterOperatorBefore: "Sau",
    filterOperatorIsEmpty: "Rỗng",
    filterOperatorIsNotEmpty: "Khác rỗng",
    columnMenuLabel: "Danh mục",
    columnMenuShowColumns: "Danh sách cột",
    columnMenuFilter: "Bộ lọc",
    columnMenuHideColumn: "Ẩn cột",
    columnMenuUnsort: "Bỏ sắp xếp",
    columnMenuSortAsc: "Sắp xếp tăng dần",
    columnMenuSortDesc: "Sắp xếp giảm dần",
    columnHeaderFiltersTooltipActive: function columnHeaderFiltersTooltipActive(e) {
      return "".concat(e, " b\u1ED9 l\u1ECDc ho\u1EA1t \u0111\u1ED9ng");
    },
    columnHeaderFiltersLabel: "Bộ lọc",
    columnHeaderSortIconLabel: "Sắp xếp",
    footerRowSelected: function footerRowSelected(e) {
      return "".concat(e.toLocaleString(), " h\xE0ng \u0111\xE3 ch\u1ECDn");
    },
    footerTotalRows: "Tổng:",
    footerTotalVisibleRows: function footerTotalVisibleRows(e, t) {
      return "".concat(e.toLocaleString(), " / ").concat(t.toLocaleString());
    },
    actionsCellMore: "Thêm"
  }, viVN);
  bi({
    noRowsLabel: "没有数据。",
    noResultsOverlayLabel: "未找到数据。",
    errorOverlayDefaultLabel: "发生错误。",
    toolbarDensity: "表格密度",
    toolbarDensityLabel: "表格密度",
    toolbarDensityCompact: "紧密",
    toolbarDensityStandard: "标准",
    toolbarDensityComfortable: "稀疏",
    toolbarColumns: "列",
    toolbarColumnsLabel: "选择列",
    toolbarFilters: "筛选器",
    toolbarFiltersLabel: "显示筛选器",
    toolbarFiltersTooltipHide: "隐藏筛选器",
    toolbarFiltersTooltipShow: "显示筛选器",
    toolbarFiltersTooltipActive: function toolbarFiltersTooltipActive(e) {
      return "".concat(e, " \u4E2A\u7B5B\u9009\u5668");
    },
    toolbarExport: "导出",
    toolbarExportLabel: "导出",
    toolbarExportCSV: "导出至CSV",
    columnsPanelTextFieldLabel: "搜索列",
    columnsPanelTextFieldPlaceholder: "列名",
    columnsPanelDragIconLabel: "重排序列",
    columnsPanelShowAllButton: "显示所有",
    columnsPanelHideAllButton: "隐藏所有",
    filterPanelAddFilter: "添加筛选器",
    filterPanelDeleteIconLabel: "删除",
    filterPanelOperators: "操作器",
    filterPanelOperatorAnd: "与",
    filterPanelOperatorOr: "或",
    filterPanelColumns: "列",
    filterPanelInputLabel: "值",
    filterPanelInputPlaceholder: "筛选值",
    filterOperatorContains: "包含",
    filterOperatorEquals: "等于",
    filterOperatorStartsWith: "开始于",
    filterOperatorEndsWith: "结束于",
    filterOperatorIs: "是",
    filterOperatorNot: "不是",
    filterOperatorAfter: "在后面",
    filterOperatorOnOrAfter: "正在后面",
    filterOperatorBefore: "在前面",
    filterOperatorOnOrBefore: "正在前面",
    filterOperatorIsEmpty: "为空",
    filterOperatorIsNotEmpty: "不为空",
    filterValueAny: "任何",
    filterValueTrue: "真",
    filterValueFalse: "假",
    columnMenuLabel: "菜单",
    columnMenuShowColumns: "显示",
    columnMenuFilter: "筛选器",
    columnMenuHideColumn: "隐藏",
    columnMenuUnsort: "恢复默认",
    columnMenuSortAsc: "升序",
    columnMenuSortDesc: "降序",
    columnHeaderFiltersTooltipActive: function columnHeaderFiltersTooltipActive(e) {
      return "".concat(e, " \u4E2A\u7B5B\u9009\u5668");
    },
    columnHeaderFiltersLabel: "显示筛选器",
    columnHeaderSortIconLabel: "排序",
    footerRowSelected: function footerRowSelected(e) {
      return "\u5171\u9009\u4E2D\u4E86".concat(e.toLocaleString(), "\u884C");
    },
    footerTotalRows: "所有行:",
    footerTotalVisibleRows: function footerTotalVisibleRows(e, t) {
      return "".concat(e.toLocaleString(), " / ").concat(t.toLocaleString());
    },
    checkboxSelectionHeaderName: "多选框",
    booleanCellTrueLabel: "真",
    booleanCellFalseLabel: "假"
  }, zhCN);

  var $i = function $i(_ref344) {
    var t = _ref344.apiRef,
        r = _ref344.props,
        l = _ref344.children;
    return React__namespace.createElement(Oe.Provider, {
      value: r
    }, React__namespace.createElement(he.Provider, {
      value: t
    }, l));
  },
      zi = hr() && null != window.localStorage.getItem("DEBUG"),
      Ni = function Ni() {},
      _i$1 = {
    debug: Ni,
    info: Ni,
    warn: Ni,
    error: Ni
  },
      Vi = ["debug", "info", "warn", "error"];

  function Bi(e, t) {
    var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : console;
    var l = Vi.indexOf(t);
    if (-1 === l) throw new Error("MUI: Log level ".concat(t, " not recognized."));
    return Vi.reduce(function (t, o, n) {
      return t[o] = n >= l ? function () {
        for (var _len23 = arguments.length, t = new Array(_len23), _key23 = 0; _key23 < _len23; _key23++) {
          t[_key23] = arguments[_key23];
        }

        var l = t[0],
            n = t.slice(1);
        r[o].apply(r, ["MUI: ".concat(e, " - ").concat(l)].concat(_toConsumableArray(n)));
      } : Ni, t;
    }, {});
  }

  var Gi = function Gi(r, l) {
    (function (t, r) {
      t.current.getLogger = React__namespace.useCallback(function (e) {
        return zi ? Bi(e, "debug", r.logger) : r.logLevel ? Bi(e, r.logLevel.toString(), r.logger) : _i$1;
      }, [r.logLevel, r.logger]);
    })(r, l), function (t, r) {
      var l = vr(t, "useApi"),
          o = React__namespace.useCallback(function () {
        for (var _len24 = arguments.length, e = new Array(_len24), _key24 = 0; _key24 < _len24; _key24++) {
          e[_key24] = arguments[_key24];
        }

        var l = e[0],
            o = e[1],
            _e$ = e[2],
            n = _e$ === void 0 ? {} : _e$;
        if (n.defaultMuiPrevented = !1, function (e) {
          return void 0 !== e.isPropagationStopped;
        }(n) && n.isPropagationStopped()) return;
        var a = r.signature === Pn.DataGridPro ? {
          api: t.current
        } : {};
        t.current.unstable_eventManager.emit(l, o, n, a);
      }, [t, r.signature]),
          n = React__namespace.useCallback(function (e, r, o) {
        l.debug("Binding ".concat(e, " event")), t.current.unstable_eventManager.on(e, r, o);
        var n = t.current;
        return function () {
          l.debug("Clearing ".concat(e, " event")), n.unstable_eventManager.removeListener(e, r);
        };
      }, [t, l]),
          a = React__namespace.useCallback(function (e) {
        t.current.publishEvent(ge.componentError, e);
      }, [t]);
      wr(t, {
        subscribeEvent: n,
        publishEvent: o,
        showError: a
      }, "GridCoreApi"), React__namespace.useEffect(function () {
        l.debug("Initializing grid api.");
        var e = t.current;
        return function () {
          l.info("Unmounting Grid component. Clearing all events listeners."), e.publishEvent(ge.unmount), e.unstable_eventManager.removeAllListeners();
        };
      }, [l, t]);
    }(r, l), function (t, r) {
      var _yr5 = yr(t),
          _yr6 = _slicedToArray(_yr5, 2),
          l = _yr6[1],
          o = React__namespace.useCallback(function (e) {
        l(function (t) {
          return Object.assign(Object.assign({}, t), {
            error: e
          });
        });
      }, [l]);

      React__namespace.useEffect(function () {
        o(r.error);
      }, [o, r.error]), xn(t, ge.componentError, o);
    }(r, l), function (e, r) {
      var l = React__default["default"].useRef({}),
          o = React__default["default"].useCallback(function (e) {
        var t = e.stateId,
            r = Re(e, ["stateId"]);
        l.current[t] = Object.assign(Object.assign({}, r), {
          stateId: t
        });
      }, []),
          n = React__default["default"].useCallback(function (t) {
        var o = !1;
        var n = [],
            a = l.current;
        if (Object.keys(a).forEach(function (r) {
          var l = a[r],
              i = l.stateSelector(e.current.state),
              s = l.stateSelector(t);
          s !== i && (s !== l.propModel && n.push(l.stateId), void 0 !== l.propModel && s !== l.propModel && (o = !0));
        }), n.length > 1) throw new Error("You're not allowed to update several sub-state in one transaction. You already updated ".concat(n[0], ", therefore, you're not allowed to update ").concat(n.join(", "), " in the same transaction."));
        return {
          ignoreSetState: o,
          postUpdate: function postUpdate() {
            n.forEach(function (l) {
              var o = a[l],
                  n = a[l].stateSelector(t);

              if (o.propOnChange) {
                var _t15 = r.signature === Pn.DataGridPro ? {
                  api: e.current
                } : {};

                o.propOnChange(n, _t15);
              }

              e.current.publishEvent(o.changeEvent, n);
            });
          }
        };
      }, [e, r.signature]);
      wr(e, {
        unstable_updateControlState: o,
        unstable_applyControlStateConstraint: n
      }, "controlStateApi");
    }(r, l), function (t) {
      var r = React__namespace.useRef({}),
          l = React__namespace.useCallback(function (e, l, o) {
        r.current[e] || (r.current[e] = {});
        var n = r.current[e],
            a = n[l];
        return a && a === o || (r.current[e] = Object.assign(Object.assign({}, n), _defineProperty({}, l, o)), t.current.publishEvent(ge.preProcessorRegister, e)), function () {
          var o = r.current[e],
              n = l;
          o[n];
          var a = Re(o, ["symbol" == typeof n ? n : n + ""]);
          r.current[e] = a, t.current.publishEvent(ge.preProcessorUnregister, e);
        };
      }, [t]),
          o = React__namespace.useCallback(function (e, t, l) {
        return r.current[e] ? Object.values(r.current[e]).reduce(function (e, t) {
          return t(e, l);
        }, t) : t;
      }, []);
      wr(t, {
        unstable_registerPreProcessor: l,
        unstable_applyPreProcessors: o
      }, "GridPreProcessing");
    }(r), function (t) {
      var r = React__namespace.useRef(new Map()),
          l = React__namespace.useCallback(function (e, l) {
        var o;
        (null !== (o = r.current.get(e)) && void 0 !== o ? o : null) !== l && (r.current.set(e, l), t.current.publishEvent(ge.rowGroupsPreProcessingChange));
      }, [t]),
          o = React__namespace.useCallback(function () {
        var t = null;
        var l = Array.from(r.current.values());

        for (; !t && l.length;) {
          var _r6 = l.shift();

          _r6 && (t = _r6.apply(void 0, arguments));
        }

        return t || function (_ref345) {
          var e = _ref345.ids,
              t = _ref345.idRowsLookup;
          var r = {};

          for (var _t16 = 0; _t16 < e.length; _t16 += 1) {
            var _l5 = e[_t16];
            r[_l5] = {
              id: _l5,
              depth: 0,
              parent: null,
              groupingKey: "",
              groupingField: null
            };
          }

          return {
            tree: r,
            treeDepth: 1,
            idRowsLookup: t,
            ids: e
          };
        }.apply(void 0, arguments);
      }, []);
      wr(t, {
        unstable_registerRowGroupsBuilder: l,
        unstable_groupRows: o
      }, "GridRowGroupsPreProcessing");
    }(r), function (t, r) {
      wr(t, {
        getLocaleText: React__namespace.useCallback(function (e) {
          if (null == r.localeText[e]) throw new Error("Missing translation for key ".concat(e, "."));
          return r.localeText[e];
        }, [r.localeText])
      }, "LocaleTextApi");
    }(r, l);
  };

  function Wi(e) {
    var t = document.createElement("span");
    t.style.whiteSpace = "pre", t.style.userSelect = "all", t.style.opacity = "0px", t.textContent = e, document.body.appendChild(t);
    var r = document.createRange();
    r.selectNode(t);
    var l = window.getSelection();
    l.removeAllRanges(), l.addRange(r);

    try {
      document.execCommand("copy");
    } finally {
      document.body.removeChild(t);
    }
  }

  var Ui = function Ui(t, r) {
    var l = React__namespace.useRef(!1);
    l.current || (t.current.state = r(t.current.state), l.current = !0);
  };

  function Ki(t, r) {
    var l = vr(t, "useGridColumns"),
        o = React__namespace.useMemo(function () {
      return function () {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var t = Object.assign(Object.assign({}, mn()), e),
            r = {};
        return Object.entries(t).forEach(function (_ref346) {
          var _ref347 = _slicedToArray(_ref346, 2),
              e = _ref347[0],
              l = _ref347[1];

          l = Object.assign(Object.assign({}, t[l.extendType || "__default__"]), l), r[e] = l;
        }), r;
      }(r.columnTypes);
    }, [r.columnTypes]);
    Ui(t, function (e) {
      var l = ti({
        apiRef: t,
        columnsTypes: o,
        columnsToUpsert: r.columns,
        reset: !0
      });
      return Object.assign(Object.assign({}, e), {
        columns: l
      });
    });

    var _yr7 = yr(t),
        _yr8 = _slicedToArray(_yr7, 3),
        n = _yr8[1],
        a = _yr8[2],
        i = React__namespace.useCallback(function (e) {
      l.debug("Updating columns state."), n(function (t) {
        return Object.assign(Object.assign({}, t), {
          columns: e
        });
      }), a(), t.current.publishEvent(ge.columnsChange, e.all);
    }, [l, n, a, t]),
        s = React__namespace.useCallback(function (e) {
      return $r(t.current.state)[e];
    }, [t]),
        c = React__namespace.useCallback(function () {
      return zr(t.current.state);
    }, [t]),
        u = React__namespace.useCallback(function () {
      return Nr(t.current.state);
    }, [t]),
        d = React__namespace.useCallback(function () {
      return _r(t.current.state);
    }, [t]),
        p = React__namespace.useCallback(function (e) {
      var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      return (r ? Nr(t.current.state) : zr(t.current.state)).findIndex(function (t) {
        return t.field === e;
      });
    }, [t]),
        m = React__namespace.useCallback(function (e) {
      var r = p(e);
      return _r(t.current.state).positions[r];
    }, [t, p]),
        f = React__namespace.useCallback(function (e) {
      var r = ti({
        apiRef: t,
        columnsTypes: o,
        columnsToUpsert: e,
        reset: !1
      });
      i(r);
    }, [t, i, o]),
        b = React__namespace.useCallback(function (e) {
      return f([e]);
    }, [f]),
        g = React__namespace.useCallback(function (e, r) {
      var l = s(e),
          o = Object.assign(Object.assign({}, l), {
        hide: !r
      });
      f([o]);
      var n = {
        field: e,
        colDef: o,
        isVisible: r
      };
      t.current.publishEvent(ge.columnVisibilityChange, n);
    }, [t, s, f]),
        h = React__namespace.useCallback(function (e, r) {
      var o = Ar(t.current.state),
          n = o.findIndex(function (t) {
        return t === e;
      });
      if (n === r) return;
      l.debug("Moving column ".concat(e, " to index ").concat(r));

      var a = _toConsumableArray(o);

      a.splice(r, 0, a.splice(n, 1)[0]), i(Object.assign(Object.assign({}, Hr(t.current.state)), {
        all: a
      }));
      var s = {
        field: e,
        element: t.current.getColumnHeaderElement(e),
        colDef: t.current.getColumn(e),
        targetIndex: r,
        oldIndex: n
      };
      t.current.publishEvent(ge.columnOrderChange, s);
    }, [t, l, i]),
        C = React__namespace.useCallback(function (e, r) {
      l.debug("Updating column ".concat(e, " width to ").concat(r));
      var o = t.current.getColumn(e),
          n = Object.assign(Object.assign({}, o), {
        width: r
      });
      t.current.updateColumns([n]), t.current.publishEvent(ge.columnWidthChange, {
        element: t.current.getColumnHeaderElement(e),
        colDef: n,
        width: r
      });
    }, [t, l]);

    wr(t, {
      getColumn: s,
      getAllColumns: c,
      getColumnIndex: p,
      getColumnPosition: m,
      getVisibleColumns: u,
      getColumnsMeta: d,
      updateColumn: b,
      updateColumns: f,
      setColumnVisibility: g,
      setColumnIndex: h,
      setColumnWidth: C
    }, "ColApi");
    var v = React__namespace.useRef(!0);
    React__namespace.useEffect(function () {
      if (v.current) return void (v.current = !1);
      l.info("GridColumns have changed, new length ".concat(r.columns.length));
      var e = ti({
        apiRef: t,
        columnsTypes: o,
        columnsToUpsert: r.columns,
        reset: !0
      });
      i(e);
    }, [l, t, i, r.columns, o]);
    var w = React__namespace.useCallback(function (e) {
      if (e !== Xa.hydrateColumns) return;
      l.info("Columns pre-processing have changed, regenerating the columns");
      var r = ti({
        apiRef: t,
        columnsTypes: o,
        columnsToUpsert: [],
        reset: !1
      });
      i(r);
    }, [t, l, i, o]),
        O = React__namespace.useRef(null);
    xn(t, ge.preProcessorRegister, w), xn(t, ge.viewportInnerSizeChange, function (e) {
      O.current !== e.width && (O.current = e.width, i(Qa(Hr(t.current.state), e.width)));
    }), Mn(t, ge.columnVisibilityChange, r.onColumnVisibilityChange);
  }

  var qi = function qi(e, t, r) {
    switch (e) {
      case gn.Compact:
        return {
          value: e,
          headerHeight: Math.floor(.7 * t),
          rowHeight: Math.floor(.7 * r)
        };

      case gn.Comfortable:
        return {
          value: e,
          headerHeight: Math.floor(1.3 * t),
          rowHeight: Math.floor(1.3 * r)
        };

      default:
        return {
          value: e,
          headerHeight: t,
          rowHeight: r
        };
    }
  },
      Zi = function Zi(t, r) {
    var l = vr(t, "useDensity");
    Ui(t, function (e) {
      return Object.assign(Object.assign({}, e), {
        density: qi(r.density, r.headerHeight, r.rowHeight)
      });
    });

    var _yr9 = yr(t),
        _yr10 = _slicedToArray(_yr9, 3),
        o = _yr10[1],
        n = _yr10[2],
        a = React__namespace.useCallback(function (e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : r.headerHeight;
      var a = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : r.rowHeight;
      l.debug("Set grid density to ".concat(e)), o(function (r) {
        var l = cl(r),
            o = qi(e, t, a);
        return br(l, o) ? r : Object.assign(Object.assign({}, r), {
          density: o
        });
      }), n();
    }, [l, o, n, r.headerHeight, r.rowHeight]);

    React__namespace.useEffect(function () {
      t.current.setDensity(r.density, r.headerHeight, r.rowHeight);
    }, [t, r.density, r.rowHeight, r.headerHeight]);
    wr(t, {
      setDensity: a
    }, "GridDensityApi");
  };

  var Yi = function Yi(e, t) {
    if ("string" == typeof e) {
      var _r7 = e.replace(/"/g, '""');

      return _r7.includes(t) ? "\"".concat(_r7, "\"") : _r7;
    }

    return e;
  };

  function Xi(e) {
    var t = e.columns,
        r = e.rowIds,
        l = e.getCellParams,
        o = e.delimiterCharacter,
        n = e.includeHeaders,
        a = r.reduce(function (e, r) {
      return "".concat(e).concat(function (e, t, r, l) {
        return t.map(function (t) {
          return Yi(r(e, t.field).formattedValue, l);
        });
      }(r, t, l, o).join(o), "\r\n");
    }, "").trim();
    if (!n) return a;
    return "".concat("".concat(t.filter(function (e) {
      return e.field !== Yo.field;
    }).map(function (e) {
      return Yi(e.headerName || e.field, o);
    }).join(o), "\r\n"), a).trim();
  }

  var Ji = function Ji(t) {
    var r = vr(t, "useGridCsvExport"),
        l = Er(t, Nr),
        o = Er(t, Xr),
        n = Er(t, zr),
        a = React__namespace.useCallback(function (e) {
      var a;
      var i;
      if (r.debug("Get data as CSV"), null == e ? void 0 : e.fields) i = e.fields.map(function (e) {
        return n.find(function (t) {
          return t.field === e;
        });
      }).filter(function (e) {
        return !!e;
      });else {
        i = ((null == e ? void 0 : e.allColumns) ? n : l).filter(function (e) {
          return !e.disableExport;
        });
      }
      var s = t.current.getSelectedRows();
      return Xi({
        columns: i,
        rowIds: s.size > 0 ? o.filter(function (e) {
          return s.has(e);
        }) : o,
        getCellParams: t.current.getCellParams,
        delimiterCharacter: (null == e ? void 0 : e.delimiter) || ",",
        includeHeaders: null === (a = null == e ? void 0 : e.includeHeaders) || void 0 === a || a
      });
    }, [r, l, n, o, t]),
        i = React__namespace.useCallback(function (e) {
      r.debug("Export data as CSV");
      var t = a(e);
      !function (e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "csv";
        var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : document.title;
        var l = "".concat(r, ".").concat(t);

        if ("download" in HTMLAnchorElement.prototype) {
          var _t17 = URL.createObjectURL(e),
              _r8 = document.createElement("a");

          return _r8.href = _t17, _r8.download = l, _r8.click(), void setTimeout(function () {
            URL.revokeObjectURL(_t17);
          });
        }

        throw new Error("MUI: exportAs not supported");
      }(new Blob([(null == e ? void 0 : e.utf8WithBom) ? new Uint8Array([239, 187, 191]) : "", t], {
        type: "text/csv"
      }), "csv", null == e ? void 0 : e.fileName);
    }, [r, a]);
    wr(t, {
      getDataAsCsv: a,
      exportDataAsCsv: i
    }, "GridCsvExportApi");
  },
      Qi = function Qi(e) {
    if (e.items.length > 1) {
      if (e.items.find(function (e) {
        return null == e.id;
      })) throw new Error("MUI: The 'id' field is required on `filterModel.items` when you use multiple filters.");
    }
  },
      es = function es(t) {
    var r = React__namespace.useCallback(function (e, r) {
      t.current.publishEvent(ge.cellNavigationKeyDown, e, r);
      var l = t.current.state.focus.cell;
      if (!l) return;
      var o = (n = r.target, a = we.row, n.closest(".".concat(a)));
      var n, a;
      var i = Number(o.getAttribute("data-rowindex")),
          s = Xr(t.current.state)[i];
      s !== l.id && t.current.selectRowRange({
        startId: s,
        endId: l.id
      }, !t.current.isRowSelected(l.id));
    }, [t]),
        l = React__namespace.useCallback(function (e, l) {
      if (null == (o = l.target) || !o.classList.contains(we.cell)) return;
      var o;
      var n = t.current.getCellParams(e.id, e.field);

      if (!(n.cellMode === nn.Edit)) {
        if (Ro(l.key) && l.shiftKey) return l.preventDefault(), void t.current.selectRow(n.id, !t.current.isRowSelected(n.id), !1);
        if (!Do(l.key) || l.shiftKey) return Do(l.key) && l.shiftKey ? (l.preventDefault(), void r(n, l)) : void ("c" === l.key.toLowerCase() && (l.ctrlKey || l.metaKey) || "a" === l.key.toLowerCase() && (l.ctrlKey || l.metaKey) && (l.preventDefault(), t.current.selectRows(t.current.getAllRowIds(), !0)));
        t.current.publishEvent(ge.cellNavigationKeyDown, n, l);
      }
    }, [t, r]),
        o = React__namespace.useCallback(function (e, r) {
      An(r.target) && (Ro(r.key) && An(r.target) && r.preventDefault(), !Do(r.key) || Ro(r.key) || r.shiftKey ? Eo(r.key) && (r.ctrlKey || r.metaKey) && t.current.toggleColumnMenu(e.field) : t.current.publishEvent(ge.columnHeaderNavigationKeyDown, e, r));
    }, [t]);
    xn(t, ge.cellKeyDown, l), xn(t, ge.columnHeaderKeyDown, o);
  },
      ts = function ts(e, t) {
    var r, l;
    return t.pagination && "client" === t.paginationMode ? (l = Uo(e), r = Ko(e)) : (r = Yr(e), l = 0 === r.length ? null : {
      firstRowIndex: 0,
      lastRowIndex: r.length - 1
    }), {
      rows: r,
      range: l
    };
  },
      rs = function rs(t, r) {
    var _yr11 = yr(t),
        _yr12 = _slicedToArray(_yr11, 1),
        l = _yr12[0],
        o = ts(l, r);

    return React__namespace.useMemo(function () {
      return {
        rows: o.rows,
        range: o.range
      };
    }, [o.rows, o.range]);
  },
      ls = function ls(e, t) {
    return t > 0 && e > 0 ? Math.ceil(e / t) : 0;
  },
      os = function os(e) {
    return e.pageCount ? Object.assign(Object.assign({}, e), {
      page: Math.max(Math.min(e.page, e.pageCount - 1), 0)
    }) : e;
  };

  function ns(e) {
    return "function" == typeof e.then;
  }

  function as(t, r) {
    var _this7 = this;

    var l = vr(t, "useGridEditRows");
    Ui(t, function (e) {
      return Object.assign(Object.assign({}, e), {
        editRows: {}
      });
    });

    var _yr13 = yr(t),
        _yr14 = _slicedToArray(_yr13, 3),
        o = _yr14[1],
        n = _yr14[2],
        a = React__namespace.useRef(null),
        i = React__namespace.useRef(null),
        s = Er(t, zr);

    t.current.unstable_updateControlState({
      stateId: "editRows",
      propModel: r.editRowsModel,
      propOnChange: r.onEditRowsModelChange,
      stateSelector: ri,
      changeEvent: ge.editRowsModelChange
    });

    var c = function c(e, l) {
      return Pe(_this7, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _this8 = this;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.t0 = e.cellMode !== nn.View;

                if (!_context3.t0) {
                  _context3.next = 9;
                  break;
                }

                if (!(r.editMode === on$1.Row)) {
                  _context3.next = 6;
                  break;
                }

                i.current = null, a.current = setTimeout(function () {
                  return Pe(_this8, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
                    var r, _r9;

                    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            if (!((null === (r = i.current) || void 0 === r ? void 0 : r.id) !== e.id)) {
                              _context2.next = 5;
                              break;
                            }

                            _context2.next = 3;
                            return t.current.commitRowChange(e.id, l);

                          case 3:
                            _r9 = t.current.getRowParams(e.id);
                            t.current.publishEvent(ge.rowEditStop, _r9, l);

                          case 5:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2);
                  }));
                });
                _context3.next = 9;
                break;

              case 6:
                _context3.next = 8;
                return t.current.commitCellChange(e, l);

              case 8:
                t.current.publishEvent(ge.cellEditStop, e, l);

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
    },
        u = React__namespace.useCallback(function (e) {
      i.current = e;
    }, []),
        p = useEventCallback(function (e, t) {
      c(e, t);
    }),
        m = useEventCallback(function () {
      var e = t.current.state.focus.cell;
      if (!e) return;
      var r = t.current.getCellParams(e.id, e.field);
      c(r, {});
    }),
        f = React__namespace.useCallback(function (e, r, a) {
      var i = t.current.getCellMode(e, r) === nn.Edit;
      a === nn.Edit && i || a === nn.View && !i || (l.debug("Switching cell id: ".concat(e, " field: ").concat(r, " to mode: ").concat(a)), o(function (l) {
        var o = Object.assign({}, l.editRows);
        return o[e] = Object.assign({}, o[e]), a === nn.Edit ? o[e][r] = {
          value: t.current.getCellValue(e, r)
        } : (delete o[e][r], Object.keys(o[e]).length || delete o[e]), Object.assign(Object.assign({}, l), {
          editRows: o
        });
      }), n(), t.current.publishEvent(ge.cellModeChange, t.current.getCellParams(e, r)));
    }, [t, n, l, o]),
        b = React__namespace.useCallback(function (e, r) {
      var l = t.current.getRowMode(e) === an.Edit;
      r === an.Edit && l || r === an.View && !l || (o(function (l) {
        var o = Object.assign({}, l.editRows);
        return r === an.Edit ? (o[e] = {}, s.forEach(function (r) {
          var l = t.current.getCellParams(e, r.field);
          l.isEditable && (o[e][r.field] = {
            value: l.value
          });
        })) : delete o[e], Object.assign(Object.assign({}, l), {
          editRows: o
        });
      }), n());
    }, [t, s, n, o]),
        g = React__namespace.useCallback(function (e) {
      return r.editMode === on$1.Cell ? an.View : t.current.state.editRows[e] ? an.Edit : an.View;
    }, [t, r.editMode]),
        h = React__namespace.useCallback(function (e, r) {
      var l = t.current.state.editRows;
      return l[e] && l[e][r] ? nn.Edit : nn.View;
    }, [t]),
        C = React__namespace.useCallback(function (e) {
      return !!e.colDef.editable && !!e.colDef.renderEditCell && (!r.isCellEditable || r.isCellEditable(e));
    }, [r.isCellEditable]),
        v = React__namespace.useCallback(function (e) {
      var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var l = {
        id: e.id,
        field: e.field,
        props: {
          value: e.value
        }
      };
      t.current.publishEvent(ge.editCellPropsChange, l, r);
    }, [t]),
        w = React__namespace.useCallback(function (e) {
      var r = e.id,
          a = e.field,
          i = e.props;
      l.debug("Setting cell props on id: ".concat(r, " field: ").concat(a)), o(function (e) {
        var l = t.current.getColumn(a),
            o = l.valueParser ? l.valueParser(i.value, t.current.getCellParams(r, a)) : i.value,
            n = Object.assign({}, e.editRows);
        return n[r] = Object.assign({}, e.editRows[r]), n[r][a] = Object.assign(Object.assign({}, i), {
          value: o
        }), Object.assign(Object.assign({}, e), {
          editRows: n
        });
      }), n();
    }, [t, n, l, o]),
        O = React__namespace.useCallback(function (e) {
      var l = t.current.getRow(e.id);

      if ("row" === r.editMode) {
        var _r10 = t.current.getEditRowsModel()[e.id];
        Object.keys(_r10).forEach(function (o) {
          return Pe(_this7, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
            var n, _t18, _a3;

            return _regeneratorRuntime.wrap(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    n = t.current.getColumn(o);

                    if (!n.preProcessEditCellProps) {
                      _context4.next = 9;
                      break;
                    }

                    _t18 = o === e.field ? e.props : _r10[o];
                    _context4.next = 5;
                    return Promise.resolve(n.preProcessEditCellProps({
                      id: e.id,
                      row: l,
                      props: _t18
                    }));

                  case 5:
                    _a3 = _context4.sent;
                    w({
                      id: e.id,
                      field: o,
                      props: _a3
                    });
                    _context4.next = 10;
                    break;

                  case 9:
                    o === e.field && w(e);

                  case 10:
                  case "end":
                    return _context4.stop();
                }
              }
            }, _callee4);
          }));
        });
      } else {
        var _r11 = t.current.getColumn(e.field),
            _o6 = _r11.preProcessEditCellProps ? _r11.preProcessEditCellProps({
          id: e.id,
          row: l,
          props: e.props
        }) : e.props;

        ns(_o6) ? _o6.then(function (t) {
          w(Object.assign(Object.assign({}, e), {
            props: t
          }));
        }) : w(Object.assign(Object.assign({}, e), {
          props: _o6
        }));
      }
    }, [t, r.editMode, w]),
        y = React__namespace.useCallback(function (e) {
      ri(t.current.state) !== e && (l.debug("Setting editRows model"), o(function (t) {
        return Object.assign(Object.assign({}, t), {
          editRows: e
        });
      }), n());
    }, [t, n, l, o]),
        E = React__namespace.useCallback(function () {
      return t.current.state.editRows;
    }, [t]),
        S = React__namespace.useCallback(function (e) {
      var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var l = e.id,
          o = e.field,
          n = t.current.getEditRowsModel();
      if (!n[l] || !n[l][o]) throw new Error("MUI: Cell at id: ".concat(l, " and field: ").concat(o, " is not in edit mode."));
      var a = n[l][o],
          i = t.current.getColumn(o),
          s = t.current.getRow(l),
          c = Object.assign(Object.assign({}, e), {
        value: a.value
      });
      var u = !!a.error;

      if (!u && "function" == typeof i.preProcessEditCellProps) {
        var _e17 = i.preProcessEditCellProps({
          id: l,
          row: s,
          props: a
        });

        if (ns(_e17)) return _e17.then(function (e) {
          return w({
            id: l,
            field: o,
            props: e
          }), !e.error && (t.current.publishEvent(ge.cellEditCommit, c, r), !0);
        });
        w({
          id: l,
          field: o,
          props: _e17
        }), u = !!_e17.error;
      }

      return !u && (t.current.publishEvent(ge.cellEditCommit, c, r), !0);
    }, [t, w]),
        R = React__namespace.useCallback(function (e) {
      if (r.editMode === on$1.Row) throw new Error("MUI: You can't commit changes when the edit mode is 'row'.");
      var o = e.id,
          n = e.field,
          a = t.current.getEditRowsModel(),
          i = a[o][n].value;
      l.debug("Setting cell id: ".concat(o, " field: ").concat(n, " to value: ").concat(null == i ? void 0 : i.toString()));
      var s = t.current.getRow(o);

      if (s) {
        var _r12 = t.current.getColumn(e.field);

        var _l6 = Object.assign(Object.assign({}, s), _defineProperty({}, n, i));

        _r12.valueSetter && (_l6 = _r12.valueSetter({
          row: s,
          value: i
        })), t.current.updateRows([_l6]);
      }
    }, [t, l, r.editMode]),
        P = React__namespace.useCallback(function (e) {
      var l = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (r.editMode === on$1.Cell) throw new Error("MUI: You can't commit changes when the edit mode is 'cell'.");
      var o = t.current.getEditRowsModel()[e];
      if (!o) throw new Error("MUI: Row at id: ".concat(e, " is not being edited."));
      if (Object.values(o).some(function (e) {
        return !!e.error;
      })) return !1;
      var n = Object.keys(o).filter(function (e) {
        return "function" == typeof t.current.getColumn(e).preProcessEditCellProps;
      });

      if (n.length > 0) {
        var _r13 = t.current.getRow(e),
            _a4 = n.map(function (l) {
          return Pe(_this7, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
            var n, a;
            return _regeneratorRuntime.wrap(function _callee5$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    n = t.current.getColumn(l);
                    _context5.next = 3;
                    return Promise.resolve(n.preProcessEditCellProps({
                      id: e,
                      row: _r13,
                      props: o[l]
                    }));

                  case 3:
                    a = _context5.sent;
                    return _context5.abrupt("return", (w({
                      id: e,
                      field: l,
                      props: a
                    }), a.error));

                  case 5:
                  case "end":
                    return _context5.stop();
                }
              }
            }, _callee5);
          }));
        });

        return Promise.all(_a4).then(function (r) {
          return !r.some(function (e) {
            return !!e;
          }) && (t.current.publishEvent(ge.rowEditCommit, e, l), !0);
        });
      }

      return t.current.publishEvent(ge.rowEditCommit, e, l), !0;
    }, [t, r.editMode, w]),
        x = React__namespace.useCallback(function (e, t) {
      e.isEditable && (f(e.id, e.field, nn.Edit), Io(t) && ko(t.key) && w({
        id: e.id,
        field: e.field,
        props: {
          value: ""
        }
      }));
    }, [w, f]),
        k = React__namespace.useCallback(function (e) {
      t.current.setRowMode(e.id, an.Edit);
    }, [t]),
        M = React__namespace.useCallback(function (e, r) {
      t.current.setRowMode(e.id, an.View), "Enter" === r.key && t.current.publishEvent(ge.cellNavigationKeyDown, e, r);
    }, [t]),
        L = React__namespace.useCallback(function (e) {
      var r = t.current.getEditRowsModel()[e];
      if (!r) throw new Error("MUI: Row at id: ".concat(e, " is not being edited."));
      var l = t.current.getRow(e);

      if (l) {
        var _e18 = Object.assign({}, l);

        Object.keys(r).forEach(function (l) {
          var o = t.current.getColumn(l),
              n = r[l].value;
          o.valueSetter ? _e18 = o.valueSetter({
            row: _e18,
            value: n
          }) : _e18[l] = n;
        }), t.current.updateRows([_e18]);
      }
    }, [t]),
        F = React__namespace.useCallback(function (e, t) {
      var r = t.detail > 1;
      e.isEditable && e.cellMode === nn.View && r && t.preventDefault();
    }, []),
        D = React__namespace.useCallback(function (e, l) {
      return Pe(_this7, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var o, n, a, i, s, _r14, c, u, _e19;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                o = e.id, n = e.field, a = e.cellMode, i = e.isEditable;

                if (i) {
                  _context6.next = 3;
                  break;
                }

                return _context6.abrupt("return");

              case 3:
                s = a === nn.Edit;

                if (!(r.editMode === on$1.Row)) {
                  _context6.next = 7;
                  break;
                }

                _r14 = t.current.getRowParams(e.id);
                return _context6.abrupt("return", void (s ? "Enter" === l.key ? (t.current.commitRowChange(e.id), t.current.publishEvent(ge.rowEditStop, _r14, l)) : "Escape" === l.key && t.current.publishEvent(ge.rowEditStop, _r14, l) : "Enter" === l.key && t.current.publishEvent(ge.rowEditStart, _r14, l)));

              case 7:
                c = l.ctrlKey || l.metaKey || l.altKey;

                if (!(!s && (u = l.key, Eo(u) || Po(u) || ko(u)) && !c && t.current.publishEvent(ge.cellEditStart, e, l), !s && Po(l.key) && (t.current.setEditCellValue({
                  id: o,
                  field: n,
                  value: ""
                }), t.current.commitCellChange({
                  id: o,
                  field: n
                }, l), t.current.publishEvent(ge.cellEditStop, e, l)), s && Fo(l.key))) {
                  _context6.next = 14;
                  break;
                }

                _e19 = {
                  id: o,
                  field: n
                };
                _context6.next = 12;
                return t.current.commitCellChange(_e19, l);

              case 12:
                if (_context6.sent) {
                  _context6.next = 14;
                  break;
                }

                return _context6.abrupt("return");

              case 14:
                s && function (e) {
                  return Mo.indexOf(e) > -1;
                }(l.key) && t.current.publishEvent(ge.cellEditStop, e, l);

              case 15:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));
    }, [t, r.editMode]),
        I = React__namespace.useCallback(function (e, r) {
      f(e.id, e.field, nn.View), Io(r) && (Fo(r.key) ? t.current.publishEvent(ge.cellNavigationKeyDown, e, r) : ("Escape" === r.key || Po(r.key)) && t.current.setCellFocus(e.id, e.field));
    }, [t, f]),
        j = React__namespace.useCallback(function (e, l) {
      if (e.isEditable) if (r.editMode === on$1.Row) {
        var _r15 = t.current.getRowParams(e.id);

        t.current.publishEvent(ge.rowEditStart, _r15, l);
      } else t.current.publishEvent(ge.cellEditStart, e, l);
    }, [t, r.editMode]);

    xn(t, ge.cellKeyDown, D), xn(t, ge.cellMouseDown, F), xn(t, ge.cellDoubleClick, j), xn(t, ge.cellFocusOut, p), xn(t, ge.cellFocusIn, u), xn(t, ge.columnHeaderDragStart, m), xn(t, ge.editCellPropsChange, O), xn(t, ge.cellEditStart, x), xn(t, ge.cellEditStop, I), xn(t, ge.cellEditCommit, R), xn(t, ge.rowEditStart, k), xn(t, ge.rowEditStop, M), xn(t, ge.rowEditCommit, L), Mn(t, ge.editCellPropsChange, r.onEditCellPropsChange), Mn(t, ge.cellEditCommit, r.onCellEditCommit), Mn(t, ge.cellEditStart, r.onCellEditStart), Mn(t, ge.cellEditStop, r.onCellEditStop), Mn(t, ge.rowEditCommit, r.onRowEditCommit), Mn(t, ge.rowEditStart, r.onRowEditStart), Mn(t, ge.rowEditStop, r.onRowEditStop), wr(t, {
      setCellMode: f,
      getCellMode: h,
      setRowMode: b,
      getRowMode: g,
      isCellEditable: C,
      commitCellChange: S,
      commitRowChange: P,
      setEditRowsModel: y,
      getEditRowsModel: E,
      setEditCellValue: v
    }, "EditRowApi"), React__namespace.useEffect(function () {
      void 0 !== r.editRowsModel && t.current.setEditRowsModel(r.editRowsModel);
    }, [t, r.editRowsModel]);
  }

  function is$1(e, t, r) {
    var l = t ? t(e) : e.id;
    return hn(l, e, r), l;
  }

  var ss = function ss(_ref348) {
    var e = _ref348.prevState,
        t = _ref348.rows,
        r = _ref348.props;
    var l = null != r ? r : e.props;
    var o;

    if (t) {
      o = {
        idRowsLookup: {},
        ids: []
      };

      for (var _e20 = 0; _e20 < t.length; _e20 += 1) {
        var _r16 = t[_e20],
            _n5 = is$1(_r16, l.getRowId);

        o.idRowsLookup[_n5] = _r16, o.ids.push(_n5);
      }
    } else o = e.value;

    return {
      value: o,
      props: l,
      rowsBeforePartialUpdates: null != t ? t : e.rowsBeforePartialUpdates
    };
  },
      cs = function cs(e, t) {
    var _e$state = e.state,
        _e$state$props$rowCou = _e$state.props.rowCount,
        r = _e$state$props$rowCou === void 0 ? 0 : _e$state$props$rowCou,
        l = _e$state.value,
        o = t.current.unstable_groupRows(l),
        n = Object.values(o.tree).filter(function (e) {
      return null == e.parent;
    }).length,
        a = r > o.ids.length ? r : o.ids.length,
        i = r > n ? r : n;
    return Object.assign(Object.assign({}, o), {
      totalRowCount: a,
      totalTopLevelRowCount: i
    });
  };

  var us = !1;

  function ds(t) {
    var r = React__namespace.useCallback(function (e) {
      return {
        field: e,
        colDef: t.current.getColumn(e)
      };
    }, [t]),
        l = React__namespace.useCallback(function (e) {
      var r = t.current.getRow(e);
      if (!r) throw new Error("No row with id #".concat(e, " found"));
      return {
        id: e,
        columns: t.current.getAllColumns(),
        row: r,
        getValue: t.current.getCellValue
      };
    }, [t]),
        o = React__namespace.useCallback(function (e, r) {
      var l = t.current.getRow(e),
          o = t.current.getRowNode(e);
      if (!l || !o) throw new Error("No row with id #".concat(e, " found"));

      var n = $o(t.current.state),
          a = _o(t.current.state);

      return {
        id: e,
        field: r,
        row: l,
        rowNode: o,
        value: l[r],
        colDef: t.current.getColumn(r),
        cellMode: t.current.getCellMode(e, r),
        getValue: t.current.getCellValue,
        api: t.current,
        hasFocus: null !== n && n.field === r && n.id === e,
        tabIndex: a && a.field === r && a.id === e ? 0 : -1
      };
    }, [t]),
        n = React__namespace.useCallback(function (e, r) {
      var l = t.current.getColumn(r),
          o = t.current.getCellValue(e, r),
          n = t.current.getRow(e),
          a = t.current.getRowNode(e);
      if (!n || !a) throw new Error("No row with id #".concat(e, " found"));

      var i = $o(t.current.state),
          s = _o(t.current.state),
          c = {
        id: e,
        field: r,
        row: n,
        rowNode: a,
        colDef: l,
        cellMode: t.current.getCellMode(e, r),
        getValue: t.current.getCellValue,
        hasFocus: null !== i && i.field === r && i.id === e,
        tabIndex: s && s.field === r && s.id === e ? 0 : -1,
        value: o,
        formattedValue: o
      };

      return l.valueFormatter && (c.formattedValue = l.valueFormatter({
        id: e,
        field: c.field,
        value: c.value,
        api: t.current
      })), c.isEditable = l && t.current.isCellEditable(c), c;
    }, [t]),
        a = React__namespace.useCallback(function (e, r) {
      var l = t.current.getColumn(r);

      if ("production" !== process.env.NODE_ENV && (l || us || function (e) {
        console.warn(["MUI: You are calling getValue('".concat(e, "') but the column `").concat(e, "` is not defined."), "Instead, you can access the data from `params.row.".concat(e, "`.")].join("\n")), us = !0;
      }(r)), !l || !l.valueGetter) {
        var _l7 = t.current.getRow(e);

        if (!_l7) throw new Error("No row with id #".concat(e, " found"));
        return _l7[r];
      }

      return l.valueGetter(o(e, r));
    }, [t, o]),
        i = React__namespace.useCallback(function (e) {
      return t.current.rootElementRef.current ? function (e, t) {
        return e.querySelector("[role=\"columnheader\"][data-field=\"".concat($n(t), "\"]"));
      }(t.current.rootElementRef.current, e) : null;
    }, [t]),
        s = React__namespace.useCallback(function (e) {
      return t.current.rootElementRef.current ? zn(t.current.rootElementRef.current, e) : null;
    }, [t]),
        c = React__namespace.useCallback(function (e, r) {
      return t.current.rootElementRef.current ? function (e, _ref349) {
        var t = _ref349.id,
            r = _ref349.field;
        var l = zn(e, t);
        return l ? l.querySelector(".".concat(we.cell, "[data-field=\"").concat($n(r), "\"]")) : null;
      }(t.current.rootElementRef.current, {
        id: e,
        field: r
      }) : null;
    }, [t]);
    wr(t, {
      getCellValue: a,
      getCellParams: n,
      getCellElement: c,
      getRowParams: l,
      getRowElement: s,
      getColumnHeaderParams: r,
      getColumnHeaderElement: i
    }, "GridParamsApi");
  }

  var ps = function ps(t, r) {
    var l = vr(t, "useGridSelection"),
        o = React__namespace.useMemo(function () {
      return null == r.selectionModel || Array.isArray(r.selectionModel) ? r.selectionModel : [r.selectionModel];
    }, [r.selectionModel]);
    Ui(t, function (e) {
      return Object.assign(Object.assign({}, e), {
        selection: null != o ? o : []
      });
    });

    var _yr15 = yr(t),
        _yr16 = _slicedToArray(_yr15, 3),
        a = _yr16[1],
        i = _yr16[2],
        s = function (t) {
      var r = t.classes;
      return React__namespace.useMemo(function () {
        return composeClasses({
          cellCheckbox: ["cellCheckbox"],
          columnHeaderCheckbox: ["columnHeaderCheckbox"]
        }, ve, r);
      }, [r]);
    }({
      classes: r.classes
    }),
        c = React__namespace.useRef(null);

    t.current.unstable_updateControlState({
      stateId: "selection",
      propModel: o,
      propOnChange: r.onSelectionModelChange,
      stateSelector: nl,
      changeEvent: ge.selectionChange
    });
    var u = r.checkboxSelection,
        d = r.disableMultipleSelection,
        p = r.disableSelectionOnClick,
        m = r.isRowSelectable,
        f = !d || u,
        b = React__namespace.useCallback(function () {
      return il(t.current.state);
    }, [t]),
        g = React__namespace.useCallback(function (e) {
      var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      if (!m || m(t.current.getRowParams(e))) if (c.current = e, o) l.debug("Setting selection for row ".concat(e)), t.current.setSelectionModel(r ? [e] : []);else {
        l.debug("Toggling selection for row ".concat(e));

        var _o7 = nl(t.current.state).filter(function (t) {
          return t !== e;
        });

        r && _o7.push(e);
        (_o7.length < 2 || f) && t.current.setSelectionModel(_o7);
      }
    }, [t, m, l, f]),
        h = React__namespace.useCallback(function (e) {
      var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      l.debug("Setting selection for several rows");
      var n = m ? e.filter(function (e) {
        return m(t.current.getRowParams(e));
      }) : e;
      var a;
      if (o) a = r ? n : [];else {
        var _e21 = Object.assign({}, sl(t.current.state));

        n.forEach(function (t) {
          r ? _e21[t] = t : delete _e21[t];
        }), a = Object.values(_e21);
      }
      (a.length < 2 || f) && t.current.setSelectionModel(a);
    }, [t, m, l, f]),
        C = React__namespace.useCallback(function (_ref350) {
      var e = _ref350.startId,
          r = _ref350.endId;
      var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      var n = arguments.length > 2 ? arguments[2] : undefined;
      if (!t.current.getRow(e) || !t.current.getRow(r)) return;
      l.debug("Expanding selection from row ".concat(e, " to row ").concat(r));

      var a = Xr(t.current.state),
          i = a.indexOf(e),
          s = a.indexOf(r),
          _ref351 = i > s ? [s, i] : [i, s],
          _ref352 = _slicedToArray(_ref351, 2),
          c = _ref352[0],
          u = _ref352[1],
          d = a.slice(c, u + 1);

      t.current.selectRows(d, o, n);
    }, [t, l]),
        v = React__namespace.useCallback(function (e) {
      var r;
      var l = e;
      var o = null !== (r = c.current) && void 0 !== r ? r : e,
          n = t.current.isRowSelected(e);

      if (n) {
        var _e22 = Xr(t.current.state),
            _r17 = _e22.findIndex(function (e) {
          return e === o;
        }),
            _n6 = _e22.findIndex(function (e) {
          return e === l;
        });

        l = _r17 > _n6 ? _e22[_n6 + 1] : _e22[_n6 - 1];
      }

      c.current = e, t.current.selectRowRange({
        startId: o,
        endId: l
      }, !n);
    }, [t]),
        w = React__namespace.useCallback(function (e) {
      nl(t.current.state) !== e && (l.debug("Setting selection model"), a(function (t) {
        return Object.assign(Object.assign({}, t), {
          selection: e
        });
      }), i());
    }, [t, a, i, l]),
        O = React__namespace.useCallback(function (e) {
      return nl(t.current.state).includes(e);
    }, [t]),
        y = React__namespace.useCallback(function () {
      var e = nl(t.current.state),
          r = xr(t.current.state),
          l = Object.assign({}, sl(t.current.state));
      var o = !1;
      e.forEach(function (e) {
        r[e] || (delete l[e], o = !0);
      }), o && t.current.setSelectionModel(Object.values(l));
    }, [t]),
        E = React__namespace.useCallback(function (e, r) {
      if (p) return;
      var l = r.metaKey || r.ctrlKey;
      if (r.shiftKey && (f || u)) v(e.id);else {
        var _r18 = !u && !l;

        !f || _r18 ? t.current.selectRow(e.id, !l && !u || !t.current.isRowSelected(e.id), !0) : t.current.selectRow(e.id, !t.current.isRowSelected(e.id), !1);
      }
    }, [t, v, f, p, u]),
        S = React__namespace.useCallback(function (e, t) {
      var r;
      f && t.shiftKey && (null === (r = window.getSelection()) || void 0 === r || r.removeAllRanges());
    }, [f]),
        R = React__namespace.useCallback(function (e, r) {
      r.nativeEvent.shiftKey ? v(e.id) : t.current.selectRow(e.id, e.value);
    }, [t, v]),
        P = React__namespace.useCallback(function (e) {
      var l = r.checkboxSelectionVisibleOnly && r.pagination ? qo(t.current.state) : Xr(t.current.state);
      t.current.selectRows(l, e.value);
    }, [t, r.checkboxSelectionVisibleOnly, r.pagination]);
    xn(t, ge.visibleRowsSet, y), xn(t, ge.rowClick, E), xn(t, ge.rowSelectionCheckboxChange, R), xn(t, ge.headerSelectionCheckboxChange, P), xn(t, ge.cellMouseDown, S);
    wr(t, {
      selectRow: g,
      selectRows: h,
      selectRowRange: C,
      setSelectionModel: w,
      getSelectedRows: b,
      isRowSelected: O
    }, "GridSelectionApi"), React__namespace.useEffect(function () {
      void 0 !== o && t.current.setSelectionModel(o);
    }, [t, o]);
    var x = null != o;
    React__namespace.useEffect(function () {
      if (x) return;
      var e = nl(t.current.state);

      if (m) {
        var _r19 = e.filter(function (e) {
          return m(t.current.getRowParams(e));
        });

        _r19.length < e.length && t.current.setSelectionModel(_r19);
      }
    }, [t, m, x]);
    var k = React__namespace.useCallback(function () {
      t.current.unstable_registerPreProcessor(Xa.hydrateColumns, "selection", function (e) {
        var l = Object.assign(Object.assign({}, Yo), {
          cellClassName: s.cellCheckbox,
          headerClassName: s.columnHeaderCheckbox,
          headerName: t.current.getLocaleText("checkboxSelectionHeaderName")
        }),
            o = r.checkboxSelection,
            n = null != e.lookup[l.field];
        return o && !n ? (e.lookup[l.field] = l, e.all = [l.field].concat(_toConsumableArray(e.all))) : !o && n && (delete e.lookup[l.field], e.all = e.all.filter(function (e) {
          return e !== l.field;
        })), e;
      });
    }, [t, r.checkboxSelection, s]);
    Ja(function () {
      k();
    });
    var M = React__namespace.useRef(!0);
    React__namespace.useEffect(function () {
      M.current ? M.current = !1 : k();
    }, [k]);
  };

  function ms(e) {
    var t = e.clientHeight,
        r = e.scrollTop,
        l = e.offsetHeight,
        o = e.offsetTop,
        n = o + l;
    return n - t > r ? n - t : o < r ? o : void 0;
  }

  var fs = "test" === process.env.NODE_ENV;

  var bs = function bs(t, r) {
    Gi(t, r), ps(t, r), Ki(t, r), function (t, r) {
      "production" !== process.env.NODE_ENV && Object.freeze(r.rows);
      var l = vr(t, "useGridRows"),
          o = React__namespace.useRef({
        state: {
          value: {
            idRowsLookup: {},
            ids: []
          },
          props: {
            rowCount: void 0,
            getRowId: void 0
          },
          rowsBeforePartialUpdates: []
        },
        timeout: null,
        lastUpdateMs: 0
      });
      Ui(t, function (e) {
        return o.current.state = ss({
          rows: r.rows,
          props: {
            rowCount: r.rowCount,
            getRowId: r.getRowId
          },
          prevState: o.current.state
        }), o.current.lastUpdateMs = Date.now(), Object.assign(Object.assign({}, e), {
          rows: cs(o.current, t)
        });
      });

      var _yr17 = yr(t),
          _yr18 = _slicedToArray(_yr17, 3),
          n = _yr18[1],
          a = _yr18[2],
          i = React__namespace.useCallback(function (e) {
        var r;
        return null !== (r = xr(t.current.state)[e]) && void 0 !== r ? r : null;
      }, [t]),
          s = React__namespace.useCallback(function (e, l) {
        var i = function i() {
          o.current.timeout = null, o.current.lastUpdateMs = Date.now(), n(function (e) {
            return Object.assign(Object.assign({}, e), {
              rows: cs(o.current, t)
            });
          }), t.current.publishEvent(ge.rowsSet), a();
        };

        if (o.current.timeout && clearTimeout(o.current.timeout), o.current.state = e, o.current.timeout = null, !l) return void i();
        var s = r.throttleRowsMs - (Date.now() - o.current.lastUpdateMs);
        s > 0 ? o.current.timeout = setTimeout(i, s) : i();
      }, [t, a, n, o, r.throttleRowsMs]),
          c = React__namespace.useCallback(function (e) {
        l.debug("Updating all rows, new length ".concat(e.length)), s(ss({
          rows: e,
          prevState: o.current.state
        }), !0);
      }, [l, s]),
          u = React__namespace.useCallback(function (e) {
        if (r.signature === Pn.DataGrid && e.length > 1) throw new Error(["MUI: You can't update several rows at once in `apiRef.current.updateRows` on the DataGrid.", "You need to upgrade to the DataGridPro component to unlock this feature."].join("\n"));
        var l = new Map();
        e.forEach(function (e) {
          var t = is$1(e, r.getRowId, "A row was provided without id when calling updateRows():");
          l.has(t) ? l.set(t, Object.assign(Object.assign({}, l.get(t)), e)) : l.set(t, e);
        });
        var n = [],
            a = {
          idRowsLookup: Object.assign({}, o.current.state.value.idRowsLookup),
          ids: _toConsumableArray(o.current.state.value.ids)
        };
        l.forEach(function (e, r) {
          return "delete" === e._action ? (delete a.idRowsLookup[r], void n.push(r)) : t.current.getRow(r) ? void (a.idRowsLookup[r] = Object.assign(Object.assign({}, t.current.getRow(r)), e)) : (a.idRowsLookup[r] = e, void a.ids.push(r));
        }), n.length > 0 && (a.ids = a.ids.filter(function (e) {
          return !n.includes(e);
        }));
        var i = Object.assign(Object.assign({}, o.current.state), {
          value: a
        });
        s(i, !0);
      }, [t, r.getRowId, s, r.signature]),
          d = React__namespace.useCallback(function () {
        var e = Lr(t.current.state),
            r = xr(t.current.state);
        return new Map(e.map(function (e) {
          return [e, r[e]];
        }));
      }, [t]),
          p = React__namespace.useCallback(function () {
        return Rr(t.current.state);
      }, [t]),
          m = React__namespace.useCallback(function () {
        return Lr(t.current.state);
      }, [t]),
          f = React__namespace.useCallback(function (e, r) {
        var l = t.current.getRowNode(e);
        if (!l) throw new Error("MUI: No row with id #".concat(e, " found"));
        var o = Object.assign(Object.assign({}, l), {
          childrenExpanded: r
        });
        n(function (t) {
          return Object.assign(Object.assign({}, t), {
            rows: Object.assign(Object.assign({}, t.rows), {
              tree: Object.assign(Object.assign({}, t.rows.tree), _defineProperty({}, e, o))
            })
          });
        }), a(), t.current.publishEvent(ge.rowExpansionChange, o);
      }, [t, n, a]),
          b = React__namespace.useCallback(function (e) {
        var r;
        return null !== (r = kr(t.current.state)[e]) && void 0 !== r ? r : null;
      }, [t]);

      React__namespace.useEffect(function () {
        return function () {
          null !== o.current.timeout && clearTimeout(o.current.timeout);
        };
      }, []);
      var g = React__namespace.useRef(!0);
      React__namespace.useEffect(function () {
        g.current ? g.current = !1 : o.current.state.rowsBeforePartialUpdates !== r.rows && (l.debug("Updating all rows, new length ".concat(r.rows.length)), s(ss({
          rows: r.rows,
          props: {
            rowCount: r.rowCount,
            getRowId: r.getRowId
          },
          prevState: o.current.state
        }), !1));
      }, [r.rows, r.rowCount, r.getRowId, l, s]);
      var h = React__namespace.useCallback(function () {
        var e;
        l.info("Row grouping pre-processing have changed, regenerating the row tree"), e = o.current.state.rowsBeforePartialUpdates === r.rows ? void 0 : r.rows, s(ss({
          rows: e,
          props: {
            rowCount: r.rowCount,
            getRowId: r.getRowId
          },
          prevState: o.current.state
        }), !1);
      }, [l, s, r.rowCount, r.getRowId, r.rows]);
      xn(t, ge.rowGroupsPreProcessingChange, h), wr(t, {
        getRow: i,
        getRowModels: d,
        getRowsCount: p,
        getAllRowIds: m,
        setRows: c,
        updateRows: u,
        setRowChildrenExpansion: f,
        getRowNode: b
      }, "GridRowApi");
    }(t, r), ds(t), as(t, r), function (t, r) {
      var l = vr(t, "useGridFocus");
      Ui(t, function (e) {
        return Object.assign(Object.assign({}, e), {
          focus: {
            cell: null,
            columnHeader: null
          },
          tabIndex: {
            cell: null,
            columnHeader: null
          }
        });
      });

      var _yr19 = yr(t),
          _yr20 = _slicedToArray(_yr19, 3),
          o = _yr20[1],
          n = _yr20[2],
          a = React__namespace.useRef(null),
          i = React__namespace.useCallback(function (e, r) {
        t.current.getRow(e) && (o(function (t) {
          return l.debug("Focusing on cell with id=".concat(e, " and field=").concat(r)), Object.assign(Object.assign({}, t), {
            tabIndex: {
              cell: {
                id: e,
                field: r
              },
              columnHeader: null
            },
            focus: {
              cell: {
                id: e,
                field: r
              },
              columnHeader: null
            }
          });
        }), n(), t.current.publishEvent(ge.cellFocusIn, t.current.getCellParams(e, r)));
      }, [t, n, l, o]),
          s = React__namespace.useCallback(function (e) {
        var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var a = t.current.state.focus.cell;
        a && t.current.publishEvent(ge.cellFocusOut, t.current.getCellParams(a.id, a.field), r), o(function (t) {
          return l.debug("Focusing on column header with colIndex=".concat(e)), Object.assign(Object.assign({}, t), {
            tabIndex: {
              columnHeader: {
                field: e
              },
              cell: null
            },
            focus: {
              columnHeader: {
                field: e
              },
              cell: null
            }
          });
        }), n();
      }, [t, n, l, o]),
          c = React__namespace.useCallback(function (_ref353) {
        var e = _ref353.id,
            r = _ref353.field;
        t.current.setCellFocus(e, r);
      }, [t]),
          u = React__namespace.useCallback(function (e, r) {
        "Enter" === r.key || "Tab" === r.key || Do(r.key) || t.current.setCellFocus(e.id, e.field);
      }, [t]),
          d = React__namespace.useCallback(function (_ref354, r) {
        var e = _ref354.field;
        r.target === r.currentTarget && t.current.setColumnHeaderFocus(e, r);
      }, [t]),
          p = React__namespace.useCallback(function () {
        l.debug("Clearing focus"), o(function (e) {
          return Object.assign(Object.assign({}, e), {
            focus: {
              cell: null,
              columnHeader: null
            }
          });
        });
      }, [l, o]),
          m = React__namespace.useCallback(function (e) {
        a.current = e;
      }, []),
          f = React__namespace.useCallback(function (e) {
        var r = a.current;
        a.current = null;
        var l = t.current.state.focus.cell;
        if (!l) return void (r && t.current.setCellFocus(r.id, r.field));
        if ((null == r ? void 0 : r.id) === l.id && (null == r ? void 0 : r.field) === l.field) return;
        var i = t.current.getCellElement(l.id, l.field);
        (null == i ? void 0 : i.contains(e.target)) || t.current.getRow(l.id) && (t.current.publishEvent(ge.cellFocusOut, t.current.getCellParams(l.id, l.field), e), r ? t.current.setCellFocus(r.id, r.field) : (o(function (e) {
          return Object.assign(Object.assign({}, e), {
            focus: {
              cell: null,
              columnHeader: null
            }
          });
        }), n()));
      }, [t, n, o]),
          b = React__namespace.useCallback(function (e) {
        if ("view" === e.cellMode) return;
        var r = t.current.state.focus.cell;
        (null == r ? void 0 : r.id) === e.id && (null == r ? void 0 : r.field) === e.field || t.current.setCellFocus(e.id, e.field);
      }, [t]);

      wr(t, {
        setCellFocus: i,
        setColumnHeaderFocus: s
      }, "GridFocusApi"), React__namespace.useEffect(function () {
        var e = t.current.state.focus.cell;
        e && (t.current.getRow(e.id) || o(function (e) {
          return Object.assign(Object.assign({}, e), {
            focus: {
              cell: null,
              columnHeader: null
            }
          });
        }));
      }, [t, o, r.rows]), React__namespace.useEffect(function () {
        var e = ownerDocument(t.current.rootElementRef.current);
        return e.addEventListener("click", f), function () {
          e.removeEventListener("click", f);
        };
      }, [t, f]), xn(t, ge.columnHeaderBlur, p), xn(t, ge.cellDoubleClick, c), xn(t, ge.cellMouseUp, m), xn(t, ge.cellKeyDown, u), xn(t, ge.cellModeChange, b), xn(t, ge.columnHeaderFocus, d);
    }(t, r), function (t, r) {
      var l = vr(t, "useGridSorting");
      Ui(t, function (e) {
        var t, l, o, n;
        return Object.assign(Object.assign({}, e), {
          sorting: {
            sortModel: null !== (n = null !== (t = r.sortModel) && void 0 !== t ? t : null === (o = null === (l = r.initialState) || void 0 === l ? void 0 : l.sorting) || void 0 === o ? void 0 : o.sortModel) && void 0 !== n ? n : [],
            sortedRows: []
          }
        });
      });

      var _yr21 = yr(t),
          _yr22 = _slicedToArray(_yr21, 3),
          o = _yr22[1],
          n = _yr22[2];

      t.current.unstable_updateControlState({
        stateId: "sortModel",
        propModel: r.sortModel,
        propOnChange: r.onSortModelChange,
        stateSelector: jr,
        changeEvent: ge.sortModelChange
      });
      var a = React__namespace.useCallback(function (e, r) {
        var l = jr(t.current.state),
            o = l.findIndex(function (t) {
          return t.field === e;
        });

        var n = _toConsumableArray(l);

        return o > -1 ? r ? n.splice(o, 1, r) : n.splice(o, 1) : n = [].concat(_toConsumableArray(l), [r]), n;
      }, [t]),
          i = React__namespace.useCallback(function (e, l) {
        var o = jr(t.current.state).find(function (t) {
          return t.field === e.field;
        });

        if (o) {
          var _e23 = void 0 === l ? ao(r.sortingOrder, o.sort) : l;

          return null == _e23 ? void 0 : Object.assign(Object.assign({}, o), {
            sort: _e23
          });
        }

        return {
          field: e.field,
          sort: void 0 === l ? ao(r.sortingOrder) : l
        };
      }, [t, r.sortingOrder]),
          s = React__namespace.useCallback(function (e, r) {
        return {
          id: e,
          field: r,
          value: t.current.getCellValue(e, r),
          api: t.current
        };
      }, [t]),
          c = React__namespace.useCallback(function (e) {
        return function (t, r) {
          return e.reduce(function (e, l, o) {
            if (0 !== e) return e;
            var n = l.comparator,
                a = t[o],
                i = r[o];
            return n(a.value, i.value, a, i);
          }, 0);
        };
      }, []),
          u = React__namespace.useCallback(function (e) {
        return e.map(function (e) {
          var r = t.current.getColumn(e.field);
          if (!r) throw new Error("Error sorting: column with field '".concat(e.field, "' not found. "));
          var l = "desc" === e.sort ? function (e, t, l, o) {
            return -1 * r.sortComparator(e, t, l, o);
          } : r.sortComparator;
          return {
            field: r.field,
            comparator: l
          };
        });
      }, [t]),
          d = React__namespace.useCallback(function () {
        if (r.sortingMode === fn.server) return l.debug("Skipping sorting rows as sortingMode = server"), void o(function (e) {
          return Object.assign(Object.assign({}, e), {
            sorting: Object.assign(Object.assign({}, e.sorting), {
              sortedRows: Lr(e)
            })
          });
        });
        o(function (e) {
          var t = Lr(e),
              l = kr(e),
              o = Mr(e) > 1,
              n = jr(e),
              a = u(n),
              i = c(a),
              d = function d(e) {
            return e.map(function (e) {
              return {
                value: e,
                params: a.map(function (t) {
                  return s(e.id, t.field);
                })
              };
            }).sort(function (e, t) {
              return i(e.params, t.params);
            }).map(function (e) {
              return e.value.id;
            });
          };

          var p = [];

          if (o) {
            var _e24 = new Map([[null, []]]);

            for (var _r20 = 0; _r20 < t.length; _r20 += 1) {
              var _o9 = l[t[_r20]];

              var _n8 = _e24.get(_o9.parent);

              _n8 || (_n8 = [], _e24.set(_o9.parent, _n8)), _n8.push(_o9);
            }

            var _o8 = new Map();

            _e24.forEach(function (e, t) {
              0 === e.length ? _o8.set(t, []) : e[0].depth > 0 && r.disableChildrenSorting || 0 === a.length ? _o8.set(t, e.map(function (e) {
                return e.id;
              })) : _o8.set(t, d(e));
            });

            var _n7 = function _n7(e, t) {
              p = [].concat(_toConsumableArray(p.slice(0, e)), _toConsumableArray(t), _toConsumableArray(p.slice(e)));
              var r = 0;
              return t.forEach(function (t) {
                r += 1;

                var l = _o8.get(t);

                if (null == l ? void 0 : l.length) {
                  var _t19 = _n7(e + r, l);

                  r += _t19;
                }
              }), r;
            };

            _n7(0, _o8.get(null));
          } else p = 0 === a.length ? t : d(Object.values(l));

          return Object.assign(Object.assign({}, e), {
            sorting: Object.assign(Object.assign({}, e.sorting), {
              sortedRows: p
            })
          });
        }), n();
      }, [l, s, o, n, u, c, r.sortingMode, r.disableChildrenSorting]),
          p = React__namespace.useCallback(function (e) {
        jr(t.current.state) !== e && (l.debug("Setting sort model"), o(function (t) {
          return Object.assign(Object.assign({}, t), {
            sorting: Object.assign(Object.assign({}, t.sorting), {
              sortModel: e
            })
          });
        }), n(), t.current.applySorting());
      }, [t, o, n, l]),
          m = React__namespace.useCallback(function (e, l, o) {
        if (!e.sortable) return;
        var n = i(e, l);
        var s;
        s = !o || r.disableMultipleColumnsSorting ? n ? [n] : [] : a(e.field, n), t.current.setSortModel(s);
      }, [t, a, i, r.disableMultipleColumnsSorting]),
          f = React__namespace.useCallback(function () {
        return jr(t.current.state);
      }, [t]),
          b = React__namespace.useCallback(function () {
        return Ir(t.current.state).map(function (e) {
          return e.model;
        });
      }, [t]),
          g = React__namespace.useCallback(function () {
        return Dr(t.current.state);
      }, [t]),
          h = React__namespace.useCallback(function (e) {
        return t.current.getSortedRowIds().indexOf(e);
      }, [t]),
          C = React__namespace.useCallback(function (e) {
        return t.current.getSortedRowIds()[e];
      }, [t]);
      wr(t, {
        getSortModel: f,
        getSortedRows: b,
        getSortedRowIds: g,
        getRowIndex: h,
        getRowIdFromRowIndex: C,
        setSortModel: p,
        sortColumn: m,
        applySorting: d
      }, "GridSortApi"), React__namespace.useEffect(function () {
        void 0 !== r.sortModel && t.current.setSortModel(r.sortModel);
      }, [t, r.sortModel]);
      var v = React__namespace.useRef(!0);
      React__namespace.useEffect(function () {
        v.current ? v.current = !1 : t.current.applySorting();
      }, [t, r.disableChildrenSorting]), Ja(function () {
        return t.current.applySorting();
      });
      var w = React__namespace.useCallback(function (_ref355, t) {
        var e = _ref355.colDef;
        var r = t.shiftKey || t.metaKey || t.ctrlKey;
        m(e, void 0, r);
      }, [m]),
          O = React__namespace.useCallback(function (_ref356, t) {
        var e = _ref356.colDef;
        !Eo(t.key) || t.ctrlKey || t.metaKey || m(e, void 0, t.shiftKey);
      }, [m]),
          y = React__namespace.useCallback(function () {
        var e = jr(t.current.state),
            r = zr(t.current.state);

        if (e.length > 0) {
          var _l8 = e.filter(function (e) {
            return r.find(function (t) {
              return t.field === e.field;
            });
          });

          _l8.length < e.length && t.current.setSortModel(_l8);
        }
      }, [t]);
      xn(t, ge.columnHeaderClick, w), xn(t, ge.columnHeaderKeyDown, O), xn(t, ge.rowsSet, t.current.applySorting), xn(t, ge.columnsChange, y);
    }(t, r), function (t, r) {
      var l = vr(t, "useGridPreferencesPanel");
      Ui(t, function (e) {
        var t, l;
        return Object.assign(Object.assign({}, e), {
          preferencePanel: null !== (l = null === (t = r.initialState) || void 0 === t ? void 0 : t.preferencePanel) && void 0 !== l ? l : {
            open: !1
          }
        });
      });

      var _yr23 = yr(t),
          _yr24 = _slicedToArray(_yr23, 3),
          o = _yr24[1],
          n = _yr24[2],
          a = React__namespace.useRef(),
          i = React__namespace.useRef(),
          s = React__namespace.useCallback(function () {
        l.debug("Hiding Preferences Panel"), o(function (e) {
          return Object.assign(Object.assign({}, e), {
            preferencePanel: {
              open: !1
            }
          });
        }), n();
      }, [n, l, o]),
          c = React__namespace.useCallback(function () {
        i.current = setTimeout(function () {
          return clearTimeout(a.current);
        }, 0);
      }, []),
          u = React__namespace.useCallback(function () {
        a.current = setTimeout(s, 100);
      }, [s]);

      wr(t, {
        showPreferences: React__namespace.useCallback(function (e) {
          l.debug("Opening Preferences Panel"), c(), o(function (t) {
            return Object.assign(Object.assign({}, t), {
              preferencePanel: Object.assign(Object.assign({}, t.preferencePanel), {
                open: !0,
                openedPanelValue: e
              })
            });
          }), n();
        }, [c, n, l, o]),
        hidePreferences: u
      }, "ColumnMenuApi"), React__namespace.useEffect(function () {
        return function () {
          clearTimeout(a.current), clearTimeout(i.current);
        };
      }, []);
    }(t, r), function (t, r) {
      var l = vr(t, "useGridFilter");
      Ui(t, function (e) {
        var t, l, o, n;
        return r.filterModel && Qi(r.filterModel), Object.assign(Object.assign({}, e), {
          filter: {
            filterModel: null !== (n = null !== (t = r.filterModel) && void 0 !== t ? t : null === (o = null === (l = r.initialState) || void 0 === l ? void 0 : l.filter) || void 0 === o ? void 0 : o.filterModel) && void 0 !== n ? n : li(),
            visibleRowsLookup: {},
            filteredDescendantCountLookup: {}
          }
        });
      });

      var _yr25 = yr(t),
          _yr26 = _slicedToArray(_yr25, 3),
          o = _yr26[1],
          n = _yr26[2];

      t.current.unstable_updateControlState({
        stateId: "filter",
        propModel: r.filterModel,
        propOnChange: r.onFilterModelChange,
        stateSelector: Kr,
        changeEvent: ge.filterModelChange
      });
      var a = React__namespace.useCallback(function (e) {
        var r = e.items,
            _e$linkOperator = e.linkOperator,
            l = _e$linkOperator === void 0 ? bn.And : _e$linkOperator,
            o = r.map(function (e) {
          if (!e.columnField || !e.operatorValue) return null;
          var r = t.current.getColumn(e.columnField);
          if (!r) return null;
          var l = r.valueParser ? r.valueParser(e.value) : e.value,
              o = Object.assign(Object.assign({}, e), {
            value: l
          }),
              n = r.filterOperators;
          if (!(null == n ? void 0 : n.length)) throw new Error("MUI: No filter operators found for column '".concat(r.field, "'."));
          var a = n.find(function (e) {
            return e.value === o.operatorValue;
          });
          if (!a) throw new Error("MUI: No filter operator found for column '".concat(r.field, "' and operator value '").concat(o.operatorValue, "'."));
          var i = a.getApplyFilterFn(o, r);
          return "function" != typeof i ? null : function (e) {
            var r = t.current.getCellParams(e, o.columnField);
            return i(r);
          };
        }).filter(function (e) {
          return !!e;
        });
        return 0 === o.length ? null : function (e) {
          return l === bn.And ? o.every(function (t) {
            return t(e);
          }) : o.some(function (t) {
            return t(e);
          });
        };
      }, [t]),
          i = React__namespace.useCallback(function () {
        o(function (e) {
          var t = Kr(e),
              l = Lr(e),
              o = kr(e),
              n = Mr(e) > 1,
              i = r.filterMode === fn.client ? a(t) : null,
              s = {},
              c = {};

          if (n) {
            var _e25 = function _e25(t, l, n) {
              var a;
              var u = r.disableChildrenFiltering && t.depth > 0;
              var d;
              d = u ? null : !i || i(t.id);
              var p,
                  m = 0;

              switch (null === (a = t.children) || void 0 === a || a.forEach(function (r) {
                var a = o[r],
                    i = _e25(a, null != d ? d : l, n && !!t.childrenExpanded);

                m += i;
              }), d) {
                case !0:
                  p = !0;
                  break;

                case !1:
                  p = m > 0;
                  break;

                default:
                  p = l;
              }

              return s[t.id] = p && n, p ? (c[t.id] = m, m + 1) : 0;
            },
                _t20 = Object.values(o);

            for (var _r21 = 0; _r21 < _t20.length; _r21 += 1) {
              var _l9 = _t20[_r21];
              0 === _l9.depth && _e25(_l9, !0, !0);
            }
          } else if (r.filterMode === fn.client && i) for (var _e26 = 0; _e26 < l.length; _e26 += 1) {
            var _t21 = l[_e26];
            s[_t21] = i(_t21);
          }

          return Object.assign(Object.assign({}, e), {
            filter: Object.assign(Object.assign({}, e.filter), {
              visibleRowsLookup: s,
              filteredDescendantCountLookup: c
            })
          });
        }), t.current.publishEvent(ge.visibleRowsSet), n();
      }, [t, o, n, r.filterMode, a, r.disableChildrenFiltering]),
          s = React__namespace.useCallback(function (e) {
        var r = Object.assign({}, e);

        if (null == r.id && (r.id = Math.round(1e5 * Math.random())), null == r.operatorValue) {
          var _e27 = t.current.getColumn(r.columnField);

          r.operatorValue = _e27 && _e27.filterOperators[0].value;
        }

        return r;
      }, [t]),
          c = React__namespace.useCallback(function (e) {
        var r = Kr(t.current.state),
            l = _toConsumableArray(r.items),
            o = l.findIndex(function (t) {
          return t.id === e.id;
        }),
            n = s(e);

        -1 === o ? l.push(n) : l[o] = n, t.current.setFilterModel(Object.assign(Object.assign({}, r), {
          items: l
        }));
      }, [t, s]),
          u = React__namespace.useCallback(function (e) {
        var r = Kr(t.current.state),
            l = r.items.filter(function (t) {
          return t.id !== e.id;
        });
        l.length !== r.items.length && t.current.setFilterModel(Object.assign(Object.assign({}, r), {
          items: l
        }));
      }, [t]),
          d = React__namespace.useCallback(function (e) {
        if (l.debug("Displaying filter panel"), e) {
          var _l10 = Kr(t.current.state),
              _o10 = _l10.items.filter(function (e) {
            return void 0 !== e.value;
          });

          var _n9;

          _n9 = _o10.find(function (t) {
            return t.columnField === e;
          }) ? _o10 : r.disableMultipleColumnsFiltering ? [s({
            columnField: e
          })] : [].concat(_toConsumableArray(_o10), [s({
            columnField: e
          })]), t.current.setFilterModel(Object.assign(Object.assign({}, _l10), {
            items: _n9
          }));
        }

        t.current.showPreferences(Un.filters);
      }, [t, l, s, r.disableMultipleColumnsFiltering]),
          p = React__namespace.useCallback(function () {
        l.debug("Hiding filter panel"), t.current.hidePreferences();
      }, [t, l]),
          m = React__namespace.useCallback(function (e) {
        var r = Kr(t.current.state);
        r.linkOperator !== e && t.current.setFilterModel(Object.assign(Object.assign({}, r), {
          linkOperator: e
        }));
      }, [t]),
          f = React__namespace.useCallback(function (e) {
        Kr(t.current.state) !== e && (Qi(e), e.items.length > 1 && r.disableMultipleColumnsFiltering && (e.items = [e.items[0]]), l.debug("Setting filter model"), o(function (t) {
          return Object.assign(Object.assign({}, t), {
            filter: Object.assign(Object.assign({}, t.filter), {
              filterModel: e
            })
          });
        }), t.current.unstable_applyFilters());
      }, [t, l, o, r.disableMultipleColumnsFiltering]),
          b = React__namespace.useCallback(function () {
        var e = Yr(t.current.state);
        return new Map(e.map(function (e) {
          return [e.id, e.model];
        }));
      }, [t]);
      wr(t, {
        setFilterLinkOperator: m,
        unstable_applyFilters: i,
        deleteFilterItem: u,
        upsertFilterItem: c,
        setFilterModel: f,
        showFilterPanel: d,
        hideFilterPanel: p,
        getVisibleRowModels: b
      }, "FilterApi");
      var g = React__namespace.useCallback(function () {
        l.debug("onColUpdated - GridColumns changed, applying filters");
        var e = Kr(t.current.state),
            r = Br(t.current.state),
            o = e.items.filter(function (e) {
          return e.columnField && r.includes(e.columnField);
        });
        o.length < e.items.length && t.current.setFilterModel(Object.assign(Object.assign({}, e), {
          items: o
        }));
      }, [t, l]);
      React__namespace.useEffect(function () {
        void 0 !== r.filterModel && t.current.setFilterModel(r.filterModel);
      }, [t, l, r.filterModel]);
      var h = React__namespace.useRef(!0);
      React__namespace.useEffect(function () {
        h.current ? h.current = !1 : t.current.unstable_applyFilters();
      }, [t, r.disableChildrenFiltering]), Ja(function () {
        return t.current.unstable_applyFilters();
      }), xn(t, ge.rowsSet, t.current.unstable_applyFilters), xn(t, ge.rowExpansionChange, t.current.unstable_applyFilters), xn(t, ge.columnsChange, g);
    }(t, r), Zi(t, r), function (t, r) {
      var l = vr(t, "useGridPageSize"),
          o = Er(t, dl);
      Ui(t, function (e) {
        var t;
        return Object.assign(Object.assign({}, e), {
          pagination: {
            pageSize: null !== (t = r.pageSize) && void 0 !== t ? t : r.autoPageSize ? 0 : 100
          }
        });
      });

      var _yr27 = yr(t),
          _yr28 = _slicedToArray(_yr27, 3),
          n = _yr28[1],
          a = _yr28[2];

      t.current.unstable_updateControlState({
        stateId: "pageSize",
        propModel: r.pageSize,
        propOnChange: r.onPageSizeChange,
        stateSelector: Wo,
        changeEvent: ge.pageSizeChange
      });
      var i = React__namespace.useCallback(function (e) {
        e !== Wo(t.current.state) && (l.debug("Setting page size to ".concat(e)), n(function (t) {
          return Object.assign(Object.assign({}, t), {
            pagination: Object.assign(Object.assign({}, t.pagination), {
              pageSize: e
            })
          });
        }), a());
      }, [t, n, a, l]);
      React__namespace.useEffect(function () {
        null == r.pageSize || r.autoPageSize || t.current.setPageSize(r.pageSize);
      }, [t, r.autoPageSize, r.pageSize]), wr(t, {
        setPageSize: i
      }, "GridPageSizeApi");
      var s = React__namespace.useCallback(function () {
        var e = t.current.getRootDimensions();
        if (!r.autoPageSize || !e) return;
        var l = Math.floor(e.viewportInnerSize.height / o);
        t.current.setPageSize(l);
      }, [t, r.autoPageSize, o]);
      React__namespace.useEffect(function () {
        s();
      }, [s]), xn(t, ge.viewportInnerSizeChange, s);
    }(t, r), function (t, r) {
      var l = vr(t, "useGridPage");
      Ui(t, function (e) {
        var t, l, o;
        return Object.assign(Object.assign({}, e), {
          pagination: Object.assign(Object.assign({}, e.pagination), {
            page: null !== (t = r.page) && void 0 !== t ? t : 0,
            pageCount: ls(null !== (l = r.rowCount) && void 0 !== l ? l : 0, e.pagination.pageSize),
            rowCount: null !== (o = r.rowCount) && void 0 !== o ? o : 0
          })
        });
      });

      var _yr29 = yr(t),
          _yr30 = _slicedToArray(_yr29, 3),
          o = _yr30[1],
          n = _yr30[2],
          a = Er(t, tl);

      t.current.unstable_updateControlState({
        stateId: "page",
        propModel: r.page,
        propOnChange: r.onPageChange,
        stateSelector: Go,
        changeEvent: ge.pageChange
      });
      var i = React__namespace.useCallback(function (e) {
        l.debug("Setting page to ".concat(e)), o(function (t) {
          return Object.assign(Object.assign({}, t), {
            pagination: os(Object.assign(Object.assign({}, t.pagination), {
              page: e
            }))
          });
        }), n();
      }, [o, n, l]);
      React__namespace.useEffect(function () {
        o(function (e) {
          var t = void 0 !== r.rowCount ? r.rowCount : a,
              l = ls(t, e.pagination.pageSize),
              o = null == r.page ? e.pagination.page : r.page;
          return Object.assign(Object.assign({}, e), {
            pagination: os(Object.assign(Object.assign({}, e.pagination), {
              page: o,
              rowCount: t,
              pageCount: l
            }))
          });
        }), n();
      }, [o, n, a, r.rowCount, r.page, t]), xn(t, ge.pageSizeChange, function (e) {
        o(function (t) {
          var r = ls(t.pagination.rowCount, e);
          return Object.assign(Object.assign({}, t), {
            pagination: os(Object.assign(Object.assign({}, t.pagination), {
              pageCount: r,
              page: t.pagination.page
            }))
          });
        }), n();
      }), wr(t, {
        setPage: i
      }, "GridPageApi");
    }(t, r), function (t, r) {
      var l = vr(t, "useGridScroll"),
          o = t.current.columnHeadersElementRef,
          n = t.current.windowRef,
          a = Er(t, dl),
          i = Er(t, Bo),
          s = Er(t, Rr),
          c = Er(t, Nr),
          u = Er(t, _r),
          d = React__namespace.useCallback(function (e) {
        if (0 === s || 0 === c.length) return !1;
        l.debug("Scrolling to cell at row ".concat(e.rowIndex, ", col: ").concat(e.colIndex, " "));
        var o = {};

        if (null != e.colIndex && (o.left = ms({
          clientHeight: n.current.clientWidth,
          scrollTop: n.current.scrollLeft,
          offsetHeight: c[e.colIndex].computedWidth,
          offsetTop: u.positions[e.colIndex]
        })), null != e.rowIndex) {
          var _t22 = r.pagination ? e.rowIndex - i.page * i.pageSize : e.rowIndex;

          o.top = ms({
            clientHeight: n.current.clientHeight,
            scrollTop: n.current.scrollTop,
            offsetHeight: a,
            offsetTop: a * _t22
          });
        }

        return (void 0 !== typeof o.left || void 0 !== typeof o.top) && (t.current.scroll(o), !0);
      }, [s, c, l, t, r.pagination, i.page, i.pageSize, n, u.positions, a]),
          p = React__namespace.useCallback(function (e) {
        n.current && null != e.left && o.current && (o.current.scrollLeft = e.left, n.current.scrollLeft = e.left, l.debug("Scrolling left: ".concat(e.left))), n.current && null != e.top && (n.current.scrollTop = e.top, l.debug("Scrolling top: ".concat(e.top))), l.debug("Scrolling, updating container, and viewport");
      }, [n, o, l]),
          m = React__namespace.useCallback(function () {
        return (null == n ? void 0 : n.current) ? {
          top: n.current.scrollTop,
          left: n.current.scrollLeft
        } : {
          top: 0,
          left: 0
        };
      }, [n]);
      wr(t, {
        scroll: p,
        scrollToIndexes: d,
        getScrollPosition: m
      }, "GridScrollApi");
      var f = React__namespace.useCallback(function (e) {
        e.target.scrollLeft = 0, e.target.scrollTop = 0;
      }, []);
      ii(t, function () {
        var e, r, l;
        return null === (l = null === (r = null === (e = t.current) || void 0 === e ? void 0 : e.renderingZoneRef) || void 0 === r ? void 0 : r.current) || void 0 === l ? void 0 : l.parentElement;
      }, "scroll", f);
    }(t, r), function (t) {
      var r = vr(t, "useGridColumnMenu");
      Ui(t, function (e) {
        return Object.assign(Object.assign({}, e), {
          columnMenu: {
            open: !1
          }
        });
      });

      var _yr31 = yr(t),
          _yr32 = _slicedToArray(_yr31, 3),
          l = _yr32[1],
          o = _yr32[2],
          n = Er(t, Ua),
          a = React__namespace.useCallback(function (e) {
        l(function (t) {
          return t.columnMenu.open && t.columnMenu.field === e ? t : (r.debug("Opening Column Menu"), Object.assign(Object.assign({}, t), {
            columnMenu: {
              open: !0,
              field: e
            }
          }));
        }) && (t.current.hidePreferences(), o());
      }, [t, o, r, l]),
          i = React__namespace.useCallback(function () {
        l(function (e) {
          return e.columnMenu.open || void 0 !== e.columnMenu.field ? (r.debug("Hiding Column Menu"), Object.assign(Object.assign({}, e), {
            columnMenu: Object.assign(Object.assign({}, e.columnMenu), {
              open: !1,
              field: void 0
            })
          })) : e;
        }) && o();
      }, [o, r, l]),
          s = React__namespace.useCallback(function (e) {
        r.debug("Toggle Column Menu"), n.open && n.field === e ? i() : a(e);
      }, [r, a, i, n]);

      wr(t, {
        showColumnMenu: a,
        hideColumnMenu: i,
        toggleColumnMenu: s
      }, "ColumnMenuApi"), xn(t, ge.columnResizeStart, i), xn(t, ge.rowsScroll, i);
    }(t), es(t), function (t, r) {
      var l = vr(t, "useGridKeyboardNavigation"),
          o = Er(t, Gr),
          n = Er(t, Yr),
          a = rs(t, r),
          i = React__namespace.useCallback(function (e, r) {
        l.debug("Navigating to cell row ".concat(r, ", col ").concat(e)), t.current.scrollToIndexes({
          colIndex: e,
          rowIndex: r
        });
        var o = t.current.getVisibleColumns()[e].field,
            a = n[r];
        t.current.setCellFocus(a.id, o);
      }, [t, l, n]),
          s = React__namespace.useCallback(function (e, r) {
        l.debug("Navigating to header col ".concat(e)), t.current.scrollToIndexes({
          colIndex: e
        });
        var o = t.current.getVisibleColumns()[e].field;
        t.current.setColumnHeaderFocus(o, r);
      }, [t, l]),
          c = React__namespace.useCallback(function (e, r) {
        r.preventDefault();
        var l = t.current.getRootDimensions();
        if (!a.range || !l) return;
        var c = t.current.unstable_getViewportPageSize(),
            u = e.field ? t.current.getColumnIndex(e.field) : 0,
            d = n.findIndex(function (t) {
          return t.id === e.id;
        }),
            p = a.range.firstRowIndex,
            m = a.range.lastRowIndex,
            f = o - 1;

        switch (r.key) {
          case "ArrowDown":
          case "Enter":
            d < m && i(u, d + 1);
            break;

          case "ArrowUp":
            d > p ? i(u, d - 1) : s(u, r);
            break;

          case "ArrowRight":
            u < f && i(u + 1, d);
            break;

          case "ArrowLeft":
            u > 0 && i(u - 1, d);
            break;

          case "Tab":
            r.shiftKey && u > 0 ? i(u - 1, d) : !r.shiftKey && u < f && i(u + 1, d);
            break;

          case "PageDown":
          case " ":
            d < m && i(u, Math.min(d + c, m));
            break;

          case "PageUp":
            d - c >= p ? i(u, d - c) : s(u, r);
            break;

          case "Home":
            r.ctrlKey || r.metaKey || r.shiftKey ? i(0, p) : i(0, d);
            break;

          case "End":
            r.ctrlKey || r.metaKey || r.shiftKey ? i(f, m) : i(f, d);
        }
      }, [t, n, o, a, i, s]),
          u = React__namespace.useCallback(function (e, r) {
        var l, n, c, u;
        if (r.preventDefault(), !t.current.getRootDimensions()) return;
        var d = t.current.unstable_getViewportPageSize(),
            p = e.field ? t.current.getColumnIndex(e.field) : 0,
            m = null !== (n = null === (l = a.range) || void 0 === l ? void 0 : l.firstRowIndex) && void 0 !== n ? n : null,
            f = null !== (u = null === (c = a.range) || void 0 === c ? void 0 : c.lastRowIndex) && void 0 !== u ? u : null,
            b = o - 1;

        switch (r.key) {
          case "ArrowDown":
          case "Enter":
            null !== m && i(p, m);
            break;

          case "ArrowRight":
            p < b && s(p + 1, r);
            break;

          case "ArrowLeft":
            p > 0 && s(p - 1, r);
            break;

          case "PageDown":
            null !== m && null !== f && i(p, Math.min(m + d, f));
            break;

          case "Home":
            s(0, r);
            break;

          case "End":
            s(b, r);
        }
      }, [t, o, a, i, s]);
      xn(t, ge.cellNavigationKeyDown, c), xn(t, ge.columnHeaderNavigationKeyDown, u);
    }(t, r), Ji(t), function (t, r) {
      var l = vr(t, "useGridPrintExport"),
          _yr33 = yr(t),
          _yr34 = _slicedToArray(_yr33, 2),
          o = _yr34[0],
          n = _yr34[1],
          a = Er(t, dl),
          i = Er(t, pl),
          s = Er(t, el),
          c = Er(t, zr),
          u = React__namespace.useRef(null),
          d = React__namespace.useRef(),
          p = React__namespace.useRef([]);

      React__namespace.useEffect(function () {
        u.current = ownerDocument(t.current.rootElementRef.current);
      }, [t]);
      var m = React__namespace.useCallback(function (e, r) {
        return new Promise(function (l) {
          e || r ? (t.current.updateColumns(c.map(function (t) {
            return t.hide && p.current.push(t.field), r ? (t.hide = !1, t) : (t.hide = !(null == e ? void 0 : e.includes(t.field)) || t.disableExport, t);
          })), l()) : l();
        });
      }, [c, t]),
          f = React__namespace.useCallback(function (e) {
        var t = document.createElement("iframe");
        return t.id = "grid-print-window", t.src = window.location.href, t.style.position = "absolute", t.style.width = "0px", t.style.height = "0px", t.title = e || document.title, t;
      }, []),
          b = React__namespace.useCallback(function (e, r) {
        var _m$body$classList;

        var l, o, n, c, d;
        var p = Object.assign({
          copyStyles: !0,
          hideToolbar: !1,
          hideFooter: !1
        }, r);
        e.onload = null;
        var m = e.contentDocument || (null === (l = e.contentWindow) || void 0 === l ? void 0 : l.document);
        if (!m) return;
        var f = t.current.rootElementRef.current,
            b = f.cloneNode(!0),
            g = b.querySelector(".".concat(we.virtualScroller));
        g.style.height = "auto", g.style.width = "auto", g.parentElement.style.width = "auto", g.parentElement.style.height = "auto", b.querySelector(".".concat(we.columnHeaders)).firstChild.style.width = "100%";
        var h = (null === (o = f.querySelector(".".concat(we.toolbarContainer))) || void 0 === o ? void 0 : o.clientHeight) || 0,
            C = (null === (n = f.querySelector(".".concat(we.footerContainer))) || void 0 === n ? void 0 : n.clientHeight) || 0;
        p.hideToolbar && (null === (c = b.querySelector(".".concat(we.toolbarContainer))) || void 0 === c || c.remove(), h = 0), p.hideFooter && (null === (d = b.querySelector(".".concat(we.footerContainer))) || void 0 === d || d.remove(), C = 0), b.style.height = "".concat(s * a + i + h + C, "px"), m.body.innerHTML = "", m.body.appendChild(b);
        var v = "function" == typeof p.pageStyle ? p.pageStyle() : p.pageStyle;

        if ("string" == typeof v) {
          var _e28 = m.createElement("style");

          _e28.appendChild(m.createTextNode(v)), m.head.appendChild(_e28);
        }

        if (p.bodyClassName && (_m$body$classList = m.body.classList).add.apply(_m$body$classList, _toConsumableArray(p.bodyClassName.split(" "))), p.copyStyles) {
          var _e29 = u.current.querySelectorAll("style, link[rel='stylesheet']");

          for (var _t23 = 0; _t23 < _e29.length; _t23 += 1) {
            var _r22 = _e29[_t23];

            if ("STYLE" === _r22.tagName) {
              var _e30 = m.createElement(_r22.tagName),
                  _t24 = _r22.sheet;

              if (_t24) {
                var _r23 = "";

                for (var _e31 = 0; _e31 < _t24.cssRules.length; _e31 += 1) {
                  "string" == typeof _t24.cssRules[_e31].cssText && (_r23 += "".concat(_t24.cssRules[_e31].cssText, "\r\n"));
                }

                _e30.appendChild(m.createTextNode(_r23)), m.head.appendChild(_e30);
              }
            } else if (_r22.getAttribute("href")) {
              var _e32 = m.createElement(_r22.tagName);

              for (var _t25 = 0; _t25 < _r22.attributes.length; _t25 += 1) {
                var _l11 = _r22.attributes[_t25];
                _l11 && _e32.setAttribute(_l11.nodeName, _l11.nodeValue || "");
              }

              m.head.appendChild(_e32);
            }
          }
        }

        e.contentWindow.print();
      }, [t, u, s, a, i]),
          g = React__namespace.useCallback(function (e) {
        u.current.body.removeChild(e), n(function (e) {
          return Object.assign(Object.assign({}, e), d.current);
        }), t.current.unstable_enableVirtualization(), p.current.length && t.current.updateColumns(c.map(function (e) {
          return e.hide = p.current.includes(e.field), e;
        })), d.current = null, p.current = [];
      }, [c, t, n]),
          C = React__namespace.useCallback(function (e) {
        return Pe(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
          var n;
          return _regeneratorRuntime.wrap(function _callee7$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  if (!(l.debug("Export data as Print"), !t.current.rootElementRef.current)) {
                    _context7.next = 2;
                    break;
                  }

                  throw new Error("MUI: No grid root element available.");

                case 2:
                  d.current = o;
                  r.pagination && t.current.setPageSize(s);
                  _context7.next = 6;
                  return m(null == e ? void 0 : e.fields, null == e ? void 0 : e.allColumns);

                case 6:
                  t.current.unstable_disableVirtualization();
                  n = f(null == e ? void 0 : e.fileName);
                  u.current.body.appendChild(n), n.onload = function () {
                    return b(n, e);
                  }, n.contentWindow.onafterprint = function () {
                    return g(n);
                  };

                case 9:
                case "end":
                  return _context7.stop();
              }
            }
          }, _callee7);
        }));
      }, [s, r, l, t, o, f, b, g, m]);
      wr(t, {
        exportDataAsPrint: C
      }, "GridPrintExportApi");
    }(t, r), function (t) {
      var r = React__namespace.useCallback(function () {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
        if (0 === t.current.getSelectedRows().size) return;
        var r = t.current.getDataAsCsv({
          includeHeaders: e,
          delimiter: "\t"
        });
        navigator.clipboard ? navigator.clipboard.writeText(r).catch(function () {
          Wi(r);
        }) : Wi(r);
      }, [t]),
          l = React__namespace.useCallback(function (e) {
        var r;
        var l = e.ctrlKey || e.metaKey || e.altKey;
        "c" === e.key.toLowerCase() && l && "" === (null === (r = window.getSelection()) || void 0 === r ? void 0 : r.toString()) && t.current.unstable_copySelectedRowsToClipboard(e.altKey);
      }, [t]);
      ii(t, t.current.rootElementRef, "keydown", l), wr(t, {
        unstable_copySelectedRowsToClipboard: r
      }, "GridClipboardApi");
    }(t), function (t, r) {
      var l = vr(t, "useResizeContainer"),
          o = React__namespace.useRef(!1),
          n = React__namespace.useRef(null),
          a = React__namespace.useRef(null),
          i = Er(t, dl),
          s = Er(t, pl),
          c = React__namespace.useCallback(function () {
        var e;
        var l = null === (e = t.current.rootElementRef) || void 0 === e ? void 0 : e.current,
            o = Wr(t.current.state);
        if (!n.current) return;
        var c;
        if (null != r.scrollbarSize) c = r.scrollbarSize;else if (o && l) {
          var _e33 = ownerDocument(l).createElement("div");

          _e33.style.width = "99px", _e33.style.height = "99px", _e33.style.position = "absolute", _e33.style.overflow = "scroll", _e33.className = "scrollDiv", l.appendChild(_e33), c = _e33.offsetWidth - _e33.clientWidth, l.removeChild(_e33);
        } else c = 0;

        var u = ts(t.current.state, {
          pagination: r.pagination,
          paginationMode: r.paginationMode
        }).rows.length * i,
            d = {
          width: n.current.width,
          height: r.autoHeight ? u : n.current.height - s
        },
            _ref357 = function (_ref358) {
          var e = _ref358.content,
              t = _ref358.container,
              r = _ref358.scrollBarSize;
          var l = e.width > t.width,
              o = e.height > t.height;
          var n = !1,
              a = !1;
          return (l || o) && (n = l, a = e.height + (n ? r : 0) > t.height, a && (n = e.width + r > t.width)), {
            hasScrollX: n,
            hasScrollY: a
          };
        }({
          content: {
            width: Math.round(o),
            height: u
          },
          container: d,
          scrollBarSize: c
        }),
            p = _ref357.hasScrollX,
            m = _ref357.hasScrollY,
            f = {
          viewportOuterSize: d,
          viewportInnerSize: {
            height: d.height - (p ? c : 0),
            width: d.width - (m ? c : 0)
          },
          hasScrollX: p,
          hasScrollY: m
        },
            b = a.current;

        a.current = f, f.viewportInnerSize.width === (null == b ? void 0 : b.viewportInnerSize.width) && f.viewportInnerSize.height === (null == b ? void 0 : b.viewportInnerSize.height) || t.current.publishEvent(ge.viewportInnerSizeChange, f.viewportInnerSize);
      }, [t, r.scrollbarSize, r.autoHeight, r.pagination, r.paginationMode, s, i]),
          u = React__namespace.useCallback(function () {
        c(), t.current.publishEvent(ge.debouncedResize, n.current);
      }, [t, c]),
          d = React__namespace.useCallback(function () {
        return a.current;
      }, []),
          p = React__namespace.useCallback(function () {
        var e = t.current.getRootDimensions();
        if (!e) return 0;
        var l = ts(t.current.state, {
          pagination: r.pagination,
          paginationMode: r.paginationMode
        }),
            o = Math.floor(e.viewportInnerSize.height / dl(t.current.state));
        return Math.min(o, l.rows.length);
      }, [t, r.pagination, r.paginationMode]);
      wr(t, {
        resize: u,
        getRootDimensions: d,
        unstable_getViewportPageSize: p
      }, "GridDimensionsApi");
      var f = React__namespace.useMemo(function () {
        return debounce$1(u, 60);
      }, [u]),
          b = React__namespace.useRef(!0),
          g = React__namespace.useCallback(function (e) {
        n.current = e;
        var t = /jsdom/.test(window.navigator.userAgent);
        return 0 !== e.height || o.current || r.autoHeight || t || (l.warn(["The parent of the grid has an empty height.", "You need to make sure the container has an intrinsic height.", "The grid displays with a height of 0px.", "", "You can find a solution in the docs:", "https://mui.com/components/data-grid/layout/"].join("\n")), o.current = !0), 0 !== e.width || o.current || t || (l.warn(["The parent of the grid has an empty width.", "You need to make sure the container has an intrinsic width.", "The grid displays with a width of 0px.", "", "You can find a solution in the docs:", "https://mui.com/components/data-grid/layout/"].join("\n")), o.current = !0), fs || b.current ? (u(), void (b.current = !1)) : void f();
      }, [r.autoHeight, f, l, u]);
      useEnhancedEffect$1(function () {
        return c();
      }, [c]), Mn(t, ge.visibleRowsSet, c), Mn(t, ge.pageChange, c), Mn(t, ge.pageSizeChange, c), Mn(t, ge.columnsChange, c), xn(t, ge.resize, g), Mn(t, ge.debouncedResize, r.onResize);
    }(t, r), function (e, t) {
      Mn(e, ge.columnHeaderClick, t.onColumnHeaderClick), Mn(e, ge.columnHeaderDoubleClick, t.onColumnHeaderDoubleClick), Mn(e, ge.columnHeaderOver, t.onColumnHeaderOver), Mn(e, ge.columnHeaderOut, t.onColumnHeaderOut), Mn(e, ge.columnHeaderEnter, t.onColumnHeaderEnter), Mn(e, ge.columnHeaderLeave, t.onColumnHeaderLeave), Mn(e, ge.columnOrderChange, t.onColumnOrderChange), Mn(e, ge.cellClick, t.onCellClick), Mn(e, ge.cellDoubleClick, t.onCellDoubleClick), Mn(e, ge.cellKeyDown, t.onCellKeyDown), Mn(e, ge.cellFocusOut, t.onCellFocusOut), Mn(e, ge.rowDoubleClick, t.onRowDoubleClick), Mn(e, ge.rowClick, t.onRowClick), Mn(e, ge.componentError, t.onError), Mn(e, ge.stateChange, t.onStateChange);
    }(t, r);
  },
      hs = {
    apiRef: void 0,
    disableColumnResize: !0,
    disableColumnReorder: !0,
    disableMultipleColumnsFiltering: !0,
    disableMultipleColumnsSorting: !0,
    disableMultipleSelection: !0,
    disableChildrenFiltering: void 0,
    disableChildrenSorting: void 0,
    getTreeDataPath: void 0,
    groupingColDef: void 0,
    throttleRowsMs: void 0,
    hideFooterRowCount: !1,
    pagination: !0,
    onRowsScrollEnd: void 0,
    checkboxSelectionVisibleOnly: !1,
    scrollEndThreshold: void 0,
    defaultGroupingExpansionDepth: void 0,
    treeData: void 0,
    signature: "DataGrid"
  },
      Cs = styled$1("div", {
    name: "MuiDataGrid",
    slot: "ColumnHeaders",
    overridesResolver: function overridesResolver(e, t) {
      return t.columnHeaders;
    }
  })(function (_ref359) {
    var e = _ref359.theme;
    return {
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      overflow: "hidden",
      display: "flex",
      alignItems: "center",
      borderBottom: "1px solid ".concat("light" === e.palette.mode ? lighten(alpha(e.palette.divider, 1), .88) : darken(alpha(e.palette.divider, 1), .68))
    };
  }),
      vs = React__namespace.forwardRef(function (t, r) {
    var l = t.innerRef,
        o = t.className,
        a = Re(t, ["innerRef", "className"]),
        i = function (e) {
      var t = e.classes;
      return composeClasses({
        root: ["columnHeaders"]
      }, ve, t);
    }({
      classes: ye().classes
    });

    return React__namespace.createElement(Cs, Object.assign({
      ref: r,
      className: clsx(o, i.root)
    }, a));
  }),
      ws = styled$1("div", {
    name: "MuiDataGrid",
    slot: "columnHeadersInner",
    overridesResolver: function overridesResolver(e, t) {
      return [_defineProperty({}, "&.".concat(we.columnHeaderDropZone), t.columnHeaderDropZone), t.columnHeadersInner];
    }
  })(function () {
    var _ref361;

    return _ref361 = {
      display: "flex",
      alignItems: "center"
    }, _defineProperty(_ref361, "&.".concat(we.columnHeaderDropZone, " .").concat(we.columnHeaderDraggableContainer), {
      cursor: "move"
    }), _defineProperty(_ref361, "&.".concat(we["columnHeadersInner--scrollable"], " .").concat(we.columnHeader, ":last-child"), {
      borderRight: "none"
    }), _ref361;
  }),
      Os = React__namespace.forwardRef(function (t, r) {
    var l, o;

    var a = t.isDragging,
        i = t.className,
        s = Re(t, ["isDragging", "className"]),
        c = Ce(),
        u = ye(),
        d = function (e) {
      var t = e.isDragging,
          r = e.hasScrollX,
          l = e.classes;
      return composeClasses({
        root: ["columnHeadersInner", t && "columnHeaderDropZone", r && "columnHeadersInner--scrollable"]
      }, ve, l);
    }({
      isDragging: a,
      hasScrollX: null !== (o = null === (l = c.current.getRootDimensions()) || void 0 === l ? void 0 : l.hasScrollX) && void 0 !== o && o,
      classes: u.classes
    });

    return React__namespace.createElement(ws, Object.assign({
      ref: r,
      className: clsx(i, d.root)
    }, s));
  }),
      ys = React__namespace.forwardRef(function (t, r) {
    var l = t.innerRef,
        o = t.className,
        n = Re(t, ["innerRef", "className"]),
        _ref362 = function (t) {
      var r = t.innerRef,
          _React__namespace$use131 = React__namespace.useState(""),
          _React__namespace$use132 = _slicedToArray(_React__namespace$use131, 2),
          l = _React__namespace$use132[0],
          o = _React__namespace$use132[1],
          _React__namespace$use133 = React__namespace.useState(""),
          _React__namespace$use134 = _slicedToArray(_React__namespace$use133, 2),
          n = _React__namespace$use134[0],
          a = _React__namespace$use134[1],
          i = Ce(),
          s = Er(i, Nr),
          c = Er(i, _r),
          u = Er(i, Vo),
          d = Er(i, _o),
          p = Er(i, zo),
          m = Er(i, pl),
          b = Er(i, ll),
          g = Er(i, Tr),
          h = Er(i, Ua),
          C = ye(),
          v = React__namespace.useRef(null),
          w = useForkRef(r, v),
          _React__namespace$use135 = React__namespace.useState(null),
          _React__namespace$use136 = _slicedToArray(_React__namespace$use135, 2),
          O = _React__namespace$use136[0],
          y = _React__namespace$use136[1],
          E = React__namespace.useRef(O),
          S = React__namespace.useRef(0),
          R = React__namespace.useMemo(function () {
        if (null == O) return [];
        var e = Math.max(O.firstColumnIndex - C.columnBuffer, 0),
            t = Math.min(O.lastColumnIndex + C.columnBuffer, s.length);
        return s.slice(e, t);
      }, [O, C.columnBuffer, s]);

      React__namespace.useEffect(function () {
        i.current.columnHeadersContainerElementRef.current.scrollLeft = 0;
      }, [i]);
      var P = React__namespace.useCallback(function (e) {
        var t = Math.max(e.firstColumnIndex - C.columnBuffer, 0),
            r = t > 0 ? S.current - c.positions[t] : S.current;
        v.current.style.transform = "translate3d(".concat(-r, "px, 0px, 0px)");
      }, [c.positions, C.columnBuffer]),
          x = React__namespace.useCallback(function (_ref363) {
        var e = _ref363.left,
            _ref363$renderContext = _ref363.renderContext,
            t = _ref363$renderContext === void 0 ? null : _ref363$renderContext;
        var r, l;
        v.current && (S.current === e && (null === (r = E.current) || void 0 === r ? void 0 : r.firstColumnIndex) === (null == t ? void 0 : t.firstColumnIndex) && (null === (l = E.current) || void 0 === l ? void 0 : l.lastColumnIndex) === (null == t ? void 0 : t.lastColumnIndex) || (S.current = e, t === E.current && E.current || (y(t), E.current = t), t && P(t)));
      }, [P]),
          k = React__namespace.useCallback(function (e) {
        return a(e.field);
      }, []),
          M = React__namespace.useCallback(function () {
        return a("");
      }, []),
          L = React__namespace.useCallback(function (e) {
        return o(e.field);
      }, []),
          F = React__namespace.useCallback(function () {
        return o("");
      }, []);
      xn(i, ge.columnResizeStart, k), xn(i, ge.columnResizeStop, M), xn(i, ge.columnHeaderDragStart, L), xn(i, ge.columnHeaderDragEnd, F), xn(i, ge.rowsScroll, x);
      var D = {
        minHeight: m,
        maxHeight: m,
        lineHeight: "".concat(m, "px")
      };
      return {
        renderContext: O,
        isDragging: !!l,
        getColumns: function getColumns() {
          if (!O) return null;
          var t = [],
              r = Math.max(O.firstColumnIndex - C.columnBuffer, 0);

          for (var _o11 = 0; _o11 < R.length; _o11 += 1) {
            var _a5 = R[_o11],
                _i6 = r + _o11,
                _s2 = 0 === _i6,
                _c3 = !(null === u && null === d),
                _f = null !== u && u.field === _a5.field || _s2 && !_c3 ? 0 : -1,
                _v = null !== p && p.field === _a5.field,
                _w = h.open && h.field === _a5.field;

            t.push(React__namespace.createElement(Zn, Object.assign({
              key: _o11
            }, g[_a5.field], {
              columnMenuOpen: _w,
              filterItemsCounter: b[_a5.field] && b[_a5.field].length,
              headerHeight: m,
              isDragging: _a5.field === l,
              column: _a5,
              colIndex: _i6,
              isResizing: n === _a5.field,
              isLastColumn: _i6 === t.length - 1,
              extendRowFullWidth: !C.disableExtendRowFullWidth,
              hasFocus: _v,
              tabIndex: _f
            })));
          }

          return t;
        },
        getRootProps: function getRootProps() {
          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          return Object.assign({
            style: D
          }, e);
        },
        getInnerProps: function getInnerProps() {
          return {
            ref: w,
            "aria-rowindex": 1,
            role: "row"
          };
        }
      };
    }({
      innerRef: l
    }),
        a = _ref362.isDragging,
        i = _ref362.getRootProps,
        s = _ref362.getInnerProps,
        c = _ref362.getColumns;

    return React__namespace.createElement(vs, Object.assign({
      ref: r
    }, i(n)), React__namespace.createElement(Wa, {
      scrollDirection: "left"
    }), React__namespace.createElement(Os, Object.assign({
      isDragging: a
    }, s()), c()), React__namespace.createElement(Wa, {
      scrollDirection: "right"
    }));
  }),
      Es = styled$1("div", {
    name: "MuiDataGrid",
    slot: "VirtualScroller",
    overridesResolver: function overridesResolver(e, t) {
      return t.virtualScroller;
    }
  })({
    overflow: "auto",
    "@media print": {
      overflow: "hidden"
    }
  }),
      Ss = React__namespace.forwardRef(function (t, r) {
    var l = t.className,
        o = Re(t, ["className"]),
        a = function (e) {
      var t = e.classes;
      return composeClasses({
        root: ["virtualScroller"]
      }, ve, t);
    }({
      classes: ye().classes
    });

    return React__namespace.createElement(Es, Object.assign({
      ref: r,
      className: clsx(a.root, l)
    }, o));
  }),
      Rs = styled$1("div", {
    name: "MuiDataGrid",
    slot: "VirtualScrollerContent",
    overridesResolver: function overridesResolver(e, t) {
      return t.virtualScrollerContent;
    }
  })({
    position: "relative",
    overflow: "hidden"
  }),
      Ps = React__namespace.forwardRef(function (t, r) {
    var l = t.className,
        o = Re(t, ["className"]),
        a = function (e) {
      var t = e.classes;
      return composeClasses({
        root: ["virtualScrollerContent"]
      }, ve, t);
    }({
      classes: ye().classes
    });

    return React__namespace.createElement(Rs, Object.assign({
      ref: r,
      className: clsx(a.root, l)
    }, o));
  }),
      xs = styled$1("div", {
    name: "MuiDataGrid",
    slot: "VirtualScrollerRenderZone",
    overridesResolver: function overridesResolver(e, t) {
      return t.virtualScrollerRenderZone;
    }
  })({
    position: "absolute"
  }),
      ks = React__namespace.forwardRef(function (t, r) {
    var l = t.className,
        o = Re(t, ["className"]),
        a = function (e) {
      var t = e.classes;
      return composeClasses({
        root: ["virtualScrollerRenderZone"]
      }, ve, t);
    }({
      classes: ye().classes
    });

    return React__namespace.createElement(xs, Object.assign({
      ref: r,
      className: clsx(a.root, l)
    }, o));
  });

  function Ms(e, t) {
    var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var l = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : t.length;
    if (t.length <= 0) return -1;
    if (r >= l) return r;
    var o = r + Math.floor((l - r) / 2);
    return e <= t[o] ? Ms(e, t, r, o) : Ms(e, t, o + 1, l);
  }

  var Ls = React__namespace.forwardRef(function (t, r) {
    var l = t.className,
        o = t.selectionLookup,
        n = t.disableVirtualization,
        a = Re(t, ["className", "selectionLookup", "disableVirtualization"]),
        _ref364 = function (t) {
      var r = t.ref,
          l = t.selectionLookup,
          o = t.disableVirtualization,
          n = Ce(),
          a = ye(),
          i = Er(n, Nr),
          s = Er(n, _r),
          c = Er(n, dl),
          u = Er(n, $o),
          d = Er(n, _o),
          p = Er(n, ri),
          m = rs(n, a),
          b = React__namespace.useRef(null),
          g = React__namespace.useRef(null),
          h = useForkRef(r, g),
          _React__namespace$use137 = React__namespace.useState(null),
          _React__namespace$use138 = _slicedToArray(_React__namespace$use137, 2),
          C = _React__namespace$use138[0],
          v = _React__namespace$use138[1],
          w = React__namespace.useRef(C),
          O = React__namespace.useRef({
        top: 0,
        left: 0
      }),
          _React__namespace$use139 = React__namespace.useState(null),
          _React__namespace$use140 = _slicedToArray(_React__namespace$use139, 2),
          y = _React__namespace$use140[0],
          E = _React__namespace$use140[1],
          S = React__namespace.useRef(s.totalWidth),
          R = React__namespace.useCallback(function () {
        if (o) return {
          firstRowIndex: 0,
          lastRowIndex: m.rows.length,
          firstColumnIndex: 0,
          lastColumnIndex: i.length
        };

        var _O$current = O.current,
            e = _O$current.top,
            t = _O$current.left,
            r = a.autoHeight ? m.rows.length : Math.floor(g.current.clientHeight / c),
            l = Math.floor(e / c),
            s = l + r,
            _r24 = _r(n.current.state),
            u = _r24.positions;

        return {
          firstRowIndex: l,
          lastRowIndex: s,
          firstColumnIndex: Ms(t, u),
          lastColumnIndex: Ms(t + y, u)
        };
      }, [n, y, a.autoHeight, o, c, m.rows.length, i.length]);

      React__namespace.useEffect(function () {
        o ? b.current.style.transform = "translate3d(0px, 0px, 0px)" : (g.current.scrollLeft = 0, g.current.scrollTop = 0), E(g.current.clientWidth);
      }, [o]), React__namespace.useEffect(function () {
        if (null == y) return;
        var e = R();
        w.current = e, v(e);
        var _O$current2 = O.current,
            t = _O$current2.top,
            r = _O$current2.left,
            l = {
          top: t,
          left: r,
          renderContext: e
        };
        n.current.publishEvent(ge.rowsScroll, l);
      }, [n, R, y]);
      var P = React__namespace.useCallback(function () {
        g.current && E(g.current.clientWidth);
      }, []);
      xn(n, ge.resize, P);

      var x = function x(e) {
        var _e$currentTarget = e.currentTarget,
            t = _e$currentTarget.scrollTop,
            r = _e$currentTarget.scrollLeft;
        if (O.current.top = t, O.current.left = r, r < 0 || t < 0 || !w.current) return;
        var l = o ? w.current : R(),
            i = Math.abs(l.firstRowIndex - w.current.firstRowIndex),
            u = Math.abs(l.firstColumnIndex - w.current.firstColumnIndex),
            d = i >= a.rowThreshold || u >= a.columnThreshold || S.current !== s.totalWidth;

        if (n.current.publishEvent(ge.rowsScroll, {
          top: t,
          left: r,
          renderContext: d ? l : w.current
        }), d) {
          v(l), w.current = l, S.current = s.totalWidth;

          var _e34 = Math.max(l.firstRowIndex - a.rowBuffer, 0) * c,
              _t26 = Math.max(l.firstColumnIndex - a.columnBuffer, 0),
              _r25 = s.positions[_t26];

          b.current.style.transform = "translate3d(".concat(_r25, "px, ").concat(_e34, "px, 0px)");
        }
      },
          k = {
        width: y && s.totalWidth > y ? s.totalWidth : "auto",
        height: Math.max(m.rows.length * c, 1)
      };

      return a.autoHeight && 0 === m.rows.length && (k.height = 2 * c), {
        getRows: function getRows() {
          var t;
          if (!m.range || !C || null == y) return null;
          var r = o ? 0 : a.rowBuffer,
              n = o ? 0 : a.columnBuffer,
              s = Math.max(C.firstRowIndex - r, 0),
              f = Math.min(C.lastRowIndex + r, m.rows.length),
              b = Math.max(C.firstColumnIndex - n, 0),
              g = Math.min(C.lastColumnIndex + n, i.length),
              h = m.rows.slice(s, f),
              v = i.slice(b, g),
              w = [];

          for (var _r26 = 0; _r26 < h.length; _r26 += 1) {
            var _h$_r = h[_r26],
                _o12 = _h$_r.id,
                _n10 = _h$_r.model;
            w.push(React__namespace.createElement(a.components.Row, Object.assign({
              key: _r26,
              row: _n10,
              rowId: _o12,
              rowHeight: c,
              cellFocus: u,
              cellTabIndex: d,
              editRowsState: p,
              renderedColumns: v,
              visibleColumns: i,
              firstColumnToRender: b,
              lastColumnToRender: g,
              selected: void 0 !== l[_o12],
              index: m.range.firstRowIndex + C.firstRowIndex + _r26,
              containerWidth: y
            }, null === (t = a.componentsProps) || void 0 === t ? void 0 : t.row)));
          }

          return w;
        },
        getRootProps: function getRootProps() {
          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          return Object.assign({
            ref: h,
            onScroll: x
          }, e);
        },
        getContentProps: function getContentProps() {
          return {
            style: k
          };
        },
        getRenderZone: function getRenderZone() {
          return {
            ref: b
          };
        }
      };
    }({
      ref: r,
      selectionLookup: o,
      disableVirtualization: n
    }),
        i = _ref364.getRootProps,
        s = _ref364.getContentProps,
        c = _ref364.getRenderZone,
        u = _ref364.getRows;

    return React__namespace.createElement(Ss, Object.assign({
      className: l
    }, i(a)), React__namespace.createElement(Ps, Object.assign({}, s()), React__namespace.createElement(ks, Object.assign({}, c()), u())));
  }),
      Fs = React__namespace.forwardRef(function (t, r) {
    var l = function (t) {
      if (t.pageSize > 100) throw new Error("'props.pageSize' cannot exceed 100 in DataGrid.");
      var r = useThemeProps({
        props: t,
        name: "MuiDataGrid"
      }),
          l = React__namespace.useMemo(function () {
        return Object.assign(Object.assign({}, r), hs);
      }, [r]);
      return fi(l);
    }(t),
        o = ni();

    return bs(o, l), React__namespace.createElement($i, {
      apiRef: o,
      props: l
    }, React__namespace.createElement(En, {
      className: l.className,
      style: l.style,
      sx: l.sx,
      ref: r
    }, React__namespace.createElement(bl, null, React__namespace.createElement(hl, null), React__namespace.createElement(ml, {
      ColumnHeadersComponent: ys,
      VirtualScrollerComponent: Ls
    }), React__namespace.createElement(gl, null))));
  }),
      Ds = React__namespace.memo(Fs);
  Fs.propTypes = {
    "aria-label": PropTypes.string,
    "aria-labelledby": PropTypes.string,
    autoHeight: PropTypes.bool,
    autoPageSize: PropTypes.bool,
    checkboxSelection: PropTypes.bool,
    classes: PropTypes.object,
    columnBuffer: PropTypes.number,
    columns: chainPropTypes(PropTypes.array.isRequired, function (e) {
      return e.columns && e.columns.some(function (e) {
        return e.resizable;
      }) ? new Error(["MUI: `column.resizable = true` is not a valid prop.", "Column resizing is not available in the MIT version.", "", "You need to upgrade to the DataGridPro component to unlock this feature."].join("\n")) : null;
    }),
    columnThreshold: PropTypes.number,
    columnTypes: PropTypes.object,
    components: PropTypes.object,
    componentsProps: PropTypes.object,
    density: PropTypes.oneOf(["comfortable", "compact", "standard"]),
    disableColumnFilter: PropTypes.bool,
    disableColumnMenu: PropTypes.bool,
    disableColumnSelector: PropTypes.bool,
    disableDensitySelector: PropTypes.bool,
    disableExtendRowFullWidth: PropTypes.bool,
    disableSelectionOnClick: PropTypes.bool,
    disableVirtualization: PropTypes.bool,
    editMode: PropTypes.oneOf(["cell", "row"]),
    editRowsModel: PropTypes.object,
    error: PropTypes.any,
    filterMode: PropTypes.oneOf(["client", "server"]),
    filterModel: chainPropTypes(PropTypes.any, function (e) {
      return null != e.filterModel && e.filterModel.items.length > 1 ? new Error(["MUI: `<DataGrid filterModel={model} />` is not a valid prop. `model.items` has more than 1 item.", "Only single filter is available in the MIT version.", "", "You need to upgrade to the DataGridPro component to unlock this feature."].join("\n")) : null;
    }),
    getCellClassName: PropTypes.func,
    getRowClassName: PropTypes.func,
    getRowId: PropTypes.func,
    headerHeight: PropTypes.number,
    hideFooter: PropTypes.bool,
    hideFooterPagination: PropTypes.bool,
    hideFooterSelectedRowCount: PropTypes.bool,
    initialState: PropTypes.object,
    isCellEditable: PropTypes.func,
    isRowSelectable: PropTypes.func,
    loading: PropTypes.bool,
    localeText: PropTypes.object,
    logger: PropTypes.shape({
      debug: PropTypes.func.isRequired,
      error: PropTypes.func.isRequired,
      info: PropTypes.func.isRequired,
      warn: PropTypes.func.isRequired
    }),
    logLevel: PropTypes.oneOf(["debug", "error", "info", "warn", !1]),
    nonce: PropTypes.string,
    onCellClick: PropTypes.func,
    onCellDoubleClick: PropTypes.func,
    onCellEditCommit: PropTypes.func,
    onCellEditStart: PropTypes.func,
    onCellEditStop: PropTypes.func,
    onCellFocusOut: PropTypes.func,
    onCellKeyDown: PropTypes.func,
    onColumnHeaderClick: PropTypes.func,
    onColumnHeaderDoubleClick: PropTypes.func,
    onColumnHeaderEnter: PropTypes.func,
    onColumnHeaderLeave: PropTypes.func,
    onColumnHeaderOut: PropTypes.func,
    onColumnHeaderOver: PropTypes.func,
    onColumnOrderChange: PropTypes.func,
    onColumnResize: PropTypes.func,
    onColumnVisibilityChange: PropTypes.func,
    onColumnWidthChange: PropTypes.func,
    onEditCellPropsChange: PropTypes.func,
    onEditRowsModelChange: PropTypes.func,
    onError: PropTypes.func,
    onFilterModelChange: PropTypes.func,
    onPageChange: PropTypes.func,
    onPageSizeChange: PropTypes.func,
    onResize: PropTypes.func,
    onRowClick: PropTypes.func,
    onRowDoubleClick: PropTypes.func,
    onRowEditCommit: PropTypes.func,
    onRowEditStart: PropTypes.func,
    onRowEditStop: PropTypes.func,
    onSelectionModelChange: PropTypes.func,
    onSortModelChange: PropTypes.func,
    onStateChange: PropTypes.func,
    page: PropTypes.number,
    pageSize: chainPropTypes(PropTypes.number, function (e) {
      return e.pageSize && e.pageSize > 100 ? new Error(["MUI: `<DataGrid pageSize={".concat(e.pageSize, "} />` is not a valid prop."), "Only page size below 100 is available in the MIT version.", "", "You need to upgrade to the DataGridPro component to unlock this feature."].join("\n")) : null;
    }),
    pagination: function pagination(e) {
      return !1 === e.pagination ? new Error(["MUI: `<DataGrid pagination={false} />` is not a valid prop.", "Infinite scrolling is not available in the MIT version.", "", "You need to upgrade to the DataGridPro component to disable the pagination."].join("\n")) : null;
    },
    paginationMode: PropTypes.oneOf(["client", "server"]),
    rowBuffer: PropTypes.number,
    rowCount: PropTypes.number,
    rowHeight: PropTypes.number,
    rows: PropTypes.arrayOf(PropTypes.object).isRequired,
    rowsPerPageOptions: PropTypes.arrayOf(PropTypes.number),
    rowThreshold: PropTypes.number,
    scrollbarSize: PropTypes.number,
    selectionModel: chainPropTypes(PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.array]), function (e) {
      return !e.checkboxSelection && Array.isArray(e.selectionModel) && e.selectionModel.length > 1 ? new Error(["MUI: `<DataGrid selectionModel={".concat(JSON.stringify(e.selectionModel), "} />` is not a valid prop."), "selectionModel can only be of 1 item in DataGrid.", "", "You need to upgrade to the DataGridPro component to unlock multiple selection."].join("\n")) : null;
    }),
    showCellRightBorder: PropTypes.bool,
    showColumnRightBorder: PropTypes.bool,
    sortingMode: PropTypes.oneOf(["client", "server"]),
    sortingOrder: PropTypes.arrayOf(PropTypes.oneOf(["asc", "desc"])),
    sortModel: PropTypes.arrayOf(PropTypes.shape({
      field: PropTypes.string.isRequired,
      sort: PropTypes.oneOf(["asc", "desc"])
    })),
    sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object])), PropTypes.func, PropTypes.object])
  };

  var DataGrid = function DataGrid(props) {
    var className = props.className,
        otherProps = __rest$1(props, ["className"]);

    var dataAttributes = generateComponentDataAttributes('DataGrid', className);
    return React__namespace.createElement(Ds, _assign2({}, dataAttributes, otherProps));
  };

  var defaultProps$b = {
    columnBuffer: 2,
    logLevel: false,
    page: 1,
    rowsPerPageOptions: [5],
    scrollbarSize: 15
  };
  DataGrid.defaultProps = defaultProps$b;

  var Table = function Table(props) {
    var className = props.className,
        otherProps = __rest$1(props, ["className"]);

    var dataAttributes = generateComponentDataAttributes('Table', className);
    return React__namespace.createElement(BaseTable, _assign2({}, dataAttributes, otherProps));
  };

  var TableBody = function TableBody(props) {
    var className = props.className,
        otherProps = __rest$1(props, ["className"]);

    var dataAttributes = generateComponentDataAttributes('TableBody', className);
    return React__namespace.createElement(BaseTableBody, _assign2({}, dataAttributes, otherProps));
  };

  var TableCell = function TableCell(props) {
    var className = props.className,
        otherProps = __rest$1(props, ["className"]);

    var dataAttributes = generateComponentDataAttributes('TableCell', className);
    return React__namespace.createElement(BaseTableCell, _assign2({}, dataAttributes, otherProps));
  };

  var TableContainer = function TableContainer(props) {
    var className = props.className,
        otherProps = __rest$1(props, ["className"]);

    var dataAttributes = generateComponentDataAttributes('TableContainer', className);
    return React__namespace.createElement(BaseTableContainer, _assign2({}, dataAttributes, otherProps));
  };

  var TableHead = function TableHead(props) {
    var className = props.className,
        otherProps = __rest$1(props, ["className"]);

    var dataAttributes = generateComponentDataAttributes('TableHead', className);
    return React__namespace.createElement(BaseTableHead, _assign2({}, dataAttributes, otherProps));
  };

  var TableRow = function TableRow(props) {
    var className = props.className,
        otherProps = __rest$1(props, ["className"]);

    var dataAttributes = generateComponentDataAttributes('TableRow', className);
    return React__namespace.createElement(BaseTableRow, _assign2({}, dataAttributes, otherProps));
  };

  var Alert = function Alert(props) {
    var className = props.className,
        otherProps = __rest$1(props, ["className"]);

    var dataAttributes = generateComponentDataAttributes('Alert', className);
    return React__namespace.createElement(BaseAlert, _assign2({}, dataAttributes, otherProps));
  };

  var Typography = function Typography(props) {
    var className = props.className,
        otherProps = __rest$1(props, ["className"]);

    var dataAttributes = generateComponentDataAttributes('Typography', className);
    return React__default["default"].createElement(Typography$2, _assign2({}, dataAttributes, otherProps));
  };

  var Dialog = function Dialog(props) {
    var className = props.className,
        _a = props.disablePortal,
        disablePortal = _a === void 0 ? true : _a,
        otherProps = __rest$1(props, ["className", "disablePortal"]);

    var dataAttributes = generateComponentDataAttributes('Dialog', className);
    return React__namespace.createElement(BaseDialog, _assign2({}, dataAttributes, {
      disablePortal: disablePortal
    }, otherProps));
  };

  var DialogActions = function DialogActions(props) {
    var className = props.className,
        otherProps = __rest$1(props, ["className"]);

    var dataAttributes = generateComponentDataAttributes('DialogActions', className);
    return React__namespace.createElement(BaseDialogActions, _assign2({}, dataAttributes, otherProps));
  };

  var DialogContent = function DialogContent(props) {
    var className = props.className,
        otherProps = __rest$1(props, ["className"]);

    var dataAttributes = generateComponentDataAttributes('DialogContent', className);
    return React__namespace.createElement(BaseDialogContent, _assign2({}, dataAttributes, otherProps));
  };

  var DialogContentText = function DialogContentText(props) {
    var className = props.className,
        otherProps = __rest$1(props, ["className"]);

    var dataAttributes = generateComponentDataAttributes('DialogContentText', className);
    return React__namespace.createElement(BaseDialogContentText, _assign2({}, dataAttributes, otherProps));
  };

  var DialogTitle = function DialogTitle(props) {
    var className = props.className,
        otherProps = __rest$1(props, ["className"]);

    var dataAttributes = generateComponentDataAttributes('DialogTitle', className);
    return React__namespace.createElement(BaseDialogTitle, _assign2({}, dataAttributes, otherProps));
  };

  var SnackBar = function SnackBar(props) {
    var className = props.className,
        otherProps = __rest$1(props, ["className"]);

    var dataAttributes = generateComponentDataAttributes('SnackBar', className);
    return React__namespace.createElement(BaseRadioGroup, _assign2({}, dataAttributes, otherProps));
  };

  var Progress = function Progress(props) {
    var className = props.className,
        otherProps = __rest$1(props, ["className"]);

    return React__namespace.createElement(BaseCircularProgress, _assign2({
      "data-testid": "CircularProgress",
      "data-component-name": "CircularProgress",
      "data-component-library": "generic",
      className: classNames('ds-generic-react-CircularProgress', className)
    }, otherProps));
  };

  var isHTMLElement = function isHTMLElement(value) {
    return value instanceof HTMLElement;
  };

  var EVENTS = {
    BLUR: 'blur',
    CHANGE: 'change',
    INPUT: 'input'
  };
  var VALIDATION_MODE = {
    onBlur: 'onBlur',
    onChange: 'onChange',
    onSubmit: 'onSubmit',
    onTouched: 'onTouched',
    all: 'all'
  };
  var SELECT = 'select';
  var UNDEFINED = 'undefined';
  var INPUT_VALIDATION_RULES = {
    max: 'max',
    min: 'min',
    maxLength: 'maxLength',
    minLength: 'minLength',
    pattern: 'pattern',
    required: 'required',
    validate: 'validate'
  };

  function attachEventListeners(_ref365, shouldAttachChangeEvent, handleChange) {
    var ref = _ref365.ref;

    if (isHTMLElement(ref) && handleChange) {
      ref.addEventListener(shouldAttachChangeEvent ? EVENTS.CHANGE : EVENTS.INPUT, handleChange);
      ref.addEventListener(EVENTS.BLUR, handleChange);
    }
  }

  var isNullOrUndefined = function isNullOrUndefined(value) {
    return value == null;
  };

  var isObjectType = function isObjectType(value) {
    return typeof value === 'object';
  };

  var isObject$6 = function isObject$6(value) {
    return !isNullOrUndefined(value) && !Array.isArray(value) && isObjectType(value) && !(value instanceof Date);
  };

  var isKey$1 = function isKey$1(value) {
    return /^\w*$/.test(value);
  };

  var compact = function compact(value) {
    return value.filter(Boolean);
  };

  var stringToPath$2 = function stringToPath$2(input) {
    return compact(input.replace(/["|']/g, '').replace(/\[/g, '.').replace(/\]/g, '').split('.'));
  };

  function set(object, path, value) {
    var index = -1;
    var tempPath = isKey$1(path) ? [path] : stringToPath$2(path);
    var length = tempPath.length;
    var lastIndex = length - 1;

    while (++index < length) {
      var key = tempPath[index];
      var newValue = value;

      if (index !== lastIndex) {
        var objValue = object[key];
        newValue = isObject$6(objValue) || Array.isArray(objValue) ? objValue : !isNaN(+tempPath[index + 1]) ? [] : {};
      }

      object[key] = newValue;
      object = object[key];
    }

    return object;
  }

  var transformToNestObject = function transformToNestObject(data) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    for (var key in data) {
      !isKey$1(key) ? set(value, key, data[key]) : value[key] = data[key];
    }

    return value;
  };

  var isUndefined = function isUndefined(val) {
    return val === undefined;
  };

  var get$1 = function get$1() {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var path = arguments.length > 1 ? arguments[1] : undefined;
    var defaultValue = arguments.length > 2 ? arguments[2] : undefined;
    var result = compact(path.split(/[,[\].]+?/)).reduce(function (result, key) {
      return isNullOrUndefined(result) ? result : result[key];
    }, obj);
    return isUndefined(result) || result === obj ? isUndefined(obj[path]) ? defaultValue : obj[path] : result;
  };

  var focusOnErrorField = function focusOnErrorField(fields, fieldErrors) {
    for (var key in fields) {
      if (get$1(fieldErrors, key)) {
        var field = fields[key];

        if (field) {
          if (field.ref.focus && isUndefined(field.ref.focus())) {
            break;
          } else if (field.options) {
            field.options[0].ref.focus();
            break;
          }
        }
      }
    }
  };

  var removeAllEventListeners = function removeAllEventListeners(ref, validateWithStateUpdate) {
    if (isHTMLElement(ref) && ref.removeEventListener) {
      ref.removeEventListener(EVENTS.INPUT, validateWithStateUpdate);
      ref.removeEventListener(EVENTS.CHANGE, validateWithStateUpdate);
      ref.removeEventListener(EVENTS.BLUR, validateWithStateUpdate);
    }
  };

  var defaultReturn = {
    isValid: false,
    value: null
  };

  var getRadioValue = function getRadioValue(options) {
    return Array.isArray(options) ? options.reduce(function (previous, option) {
      return option && option.ref.checked ? {
        isValid: true,
        value: option.ref.value
      } : previous;
    }, defaultReturn) : defaultReturn;
  };

  var getMultipleSelectValue = function getMultipleSelectValue(options) {
    return _toConsumableArray(options).filter(function (_ref366) {
      var selected = _ref366.selected;
      return selected;
    }).map(function (_ref367) {
      var value = _ref367.value;
      return value;
    });
  };

  var isRadioInput = function isRadioInput(element) {
    return element.type === 'radio';
  };

  var isFileInput = function isFileInput(element) {
    return element.type === 'file';
  };

  var isCheckBoxInput = function isCheckBoxInput(element) {
    return element.type === 'checkbox';
  };

  var isMultipleSelect = function isMultipleSelect(element) {
    return element.type === "".concat(SELECT, "-multiple");
  };

  var defaultResult = {
    value: false,
    isValid: false
  };
  var validResult = {
    value: true,
    isValid: true
  };

  var getCheckboxValue = function getCheckboxValue(options) {
    if (Array.isArray(options)) {
      if (options.length > 1) {
        var _values2 = options.filter(function (option) {
          return option && option.ref.checked;
        }).map(function (_ref368) {
          var value = _ref368.ref.value;
          return value;
        });

        return {
          value: _values2,
          isValid: !!_values2.length
        };
      }

      var _options$0$ref = options[0].ref,
          checked = _options$0$ref.checked,
          value = _options$0$ref.value,
          attributes = _options$0$ref.attributes;
      return checked ? attributes && !isUndefined(attributes.value) ? isUndefined(value) || value === '' ? validResult : {
        value: value,
        isValid: true
      } : validResult : defaultResult;
    }

    return defaultResult;
  };

  function getFieldValue(fieldsRef, name, shallowFieldsStateRef, excludeDisabled, shouldKeepRawValue) {
    var field = fieldsRef.current[name];

    if (field) {
      var _field$ref = field.ref,
          value = _field$ref.value,
          disabled = _field$ref.disabled,
          _ref369 = field.ref,
          valueAsNumber = field.valueAsNumber,
          valueAsDate = field.valueAsDate,
          setValueAs = field.setValueAs;

      if (disabled && excludeDisabled) {
        return;
      }

      if (isFileInput(_ref369)) {
        return _ref369.files;
      }

      if (isRadioInput(_ref369)) {
        return getRadioValue(field.options).value;
      }

      if (isMultipleSelect(_ref369)) {
        return getMultipleSelectValue(_ref369.options);
      }

      if (isCheckBoxInput(_ref369)) {
        return getCheckboxValue(field.options).value;
      }

      return shouldKeepRawValue ? value : valueAsNumber ? value === '' ? NaN : +value : valueAsDate ? _ref369.valueAsDate : setValueAs ? setValueAs(value) : value;
    }

    if (shallowFieldsStateRef) {
      return get$1(shallowFieldsStateRef.current, name);
    }
  }

  function isDetached(element) {
    if (!element) {
      return true;
    }

    if (!(element instanceof HTMLElement) || element.nodeType === Node.DOCUMENT_NODE) {
      return false;
    }

    return isDetached(element.parentNode);
  }

  var isEmptyObject = function isEmptyObject(value) {
    return isObject$6(value) && !Object.keys(value).length;
  };

  var isBoolean = function isBoolean(value) {
    return typeof value === 'boolean';
  };

  function baseGet$1(object, updatePath) {
    var length = updatePath.slice(0, -1).length;
    var index = 0;

    while (index < length) {
      object = isUndefined(object) ? index++ : object[updatePath[index++]];
    }

    return object;
  }

  function unset(object, path) {
    var updatePath = isKey$1(path) ? [path] : stringToPath$2(path);
    var childObject = updatePath.length == 1 ? object : baseGet$1(object, updatePath);
    var key = updatePath[updatePath.length - 1];
    var previousObjRef;

    if (childObject) {
      delete childObject[key];
    }

    for (var _k = 0; _k < updatePath.slice(0, -1).length; _k++) {
      var _index3 = -1;

      var objectRef = void 0;
      var currentPaths = updatePath.slice(0, -(_k + 1));
      var currentPathsLength = currentPaths.length - 1;

      if (_k > 0) {
        previousObjRef = object;
      }

      while (++_index3 < currentPaths.length) {
        var item = currentPaths[_index3];
        objectRef = objectRef ? objectRef[item] : object[item];

        if (currentPathsLength === _index3 && (isObject$6(objectRef) && isEmptyObject(objectRef) || Array.isArray(objectRef) && !objectRef.filter(function (data) {
          return isObject$6(data) && !isEmptyObject(data) || isBoolean(data);
        }).length)) {
          previousObjRef ? delete previousObjRef[item] : delete object[item];
        }

        previousObjRef = objectRef;
      }
    }

    return object;
  }

  var isSameRef = function isSameRef(fieldValue, ref) {
    return fieldValue && fieldValue.ref === ref;
  };

  function findRemovedFieldAndRemoveListener(fieldsRef, handleChange, field, shallowFieldsStateRef, shouldUnregister, forceDelete) {
    var ref = field.ref,
        name = field.ref.name;
    var fieldRef = fieldsRef.current[name];

    if (!shouldUnregister) {
      var value = getFieldValue(fieldsRef, name, shallowFieldsStateRef);
      !isUndefined(value) && set(shallowFieldsStateRef.current, name, value);
    }

    if (!ref.type || !fieldRef) {
      delete fieldsRef.current[name];
      return;
    }

    if (isRadioInput(ref) || isCheckBoxInput(ref)) {
      if (Array.isArray(fieldRef.options) && fieldRef.options.length) {
        compact(fieldRef.options).forEach(function () {
          var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var index = arguments.length > 1 ? arguments[1] : undefined;

          if (isDetached(option.ref) && isSameRef(option, option.ref) || forceDelete) {
            removeAllEventListeners(option.ref, handleChange);
            unset(fieldRef.options, "[".concat(index, "]"));
          }
        });

        if (fieldRef.options && !compact(fieldRef.options).length) {
          delete fieldsRef.current[name];
        }
      } else {
        delete fieldsRef.current[name];
      }
    } else if (isDetached(ref) && isSameRef(fieldRef, ref) || forceDelete) {
      removeAllEventListeners(ref, handleChange);
      delete fieldsRef.current[name];
    }
  }

  var isPrimitive = function isPrimitive(value) {
    return isNullOrUndefined(value) || !isObjectType(value);
  };

  function deepMerge(target, source) {
    if (isPrimitive(target) || isPrimitive(source)) {
      return source;
    }

    for (var key in source) {
      var targetValue = target[key];
      var sourceValue = source[key];

      try {
        target[key] = isObject$6(targetValue) && isObject$6(sourceValue) || Array.isArray(targetValue) && Array.isArray(sourceValue) ? deepMerge(targetValue, sourceValue) : sourceValue;
      } catch (_a) {}
    }

    return target;
  }

  function deepEqual(object1, object2, isErrorObject) {
    if (isPrimitive(object1) || isPrimitive(object2) || object1 instanceof Date || object2 instanceof Date) {
      return object1 === object2;
    }

    if (!React.isValidElement(object1)) {
      var keys1 = Object.keys(object1);
      var keys2 = Object.keys(object2);

      if (keys1.length !== keys2.length) {
        return false;
      }

      for (var _i7 = 0, _keys = keys1; _i7 < _keys.length; _i7++) {
        var key = _keys[_i7];
        var val1 = object1[key];

        if (!(isErrorObject && key === 'ref')) {
          var val2 = object2[key];

          if ((isObject$6(val1) || Array.isArray(val1)) && (isObject$6(val2) || Array.isArray(val2)) ? !deepEqual(val1, val2, isErrorObject) : val1 !== val2) {
            return false;
          }
        }
      }
    }

    return true;
  }

  function setDirtyFields(values, defaultValues, dirtyFields, parentNode, parentName) {
    var index = -1;

    while (++index < values.length) {
      for (var key in values[index]) {
        if (Array.isArray(values[index][key])) {
          !dirtyFields[index] && (dirtyFields[index] = {});
          dirtyFields[index][key] = [];
          setDirtyFields(values[index][key], get$1(defaultValues[index] || {}, key, []), dirtyFields[index][key], dirtyFields[index], key);
        } else {
          deepEqual(get$1(defaultValues[index] || {}, key), values[index][key]) ? set(dirtyFields[index] || {}, key) : dirtyFields[index] = Object.assign(Object.assign({}, dirtyFields[index]), _defineProperty({}, key, true));
        }
      }

      parentNode && !dirtyFields.length && delete parentNode[parentName];
    }

    return dirtyFields;
  }

  var setFieldArrayDirtyFields = function setFieldArrayDirtyFields(values, defaultValues, dirtyFields) {
    return deepMerge(setDirtyFields(values, defaultValues, dirtyFields.slice(0, values.length)), setDirtyFields(defaultValues, values, dirtyFields.slice(0, values.length)));
  };

  var isString$1 = function isString$1(value) {
    return typeof value === 'string';
  };

  var getFieldsValues = function getFieldsValues(fieldsRef, shallowFieldsState, shouldUnregister, excludeDisabled, search) {
    var output = {};

    var _loop2 = function _loop2(name) {
      if (isUndefined(search) || (isString$1(search) ? name.startsWith(search) : Array.isArray(search) && search.find(function (data) {
        return name.startsWith(data);
      }))) {
        output[name] = getFieldValue(fieldsRef, name, undefined, excludeDisabled);
      }
    };

    for (var name in fieldsRef.current) {
      _loop2(name);
    }

    return shouldUnregister ? transformToNestObject(output) : deepMerge(shallowFieldsState, transformToNestObject(output));
  };

  var isErrorStateChanged = function isErrorStateChanged(_ref370) {
    var errors = _ref370.errors,
        name = _ref370.name,
        error = _ref370.error,
        validFields = _ref370.validFields,
        fieldsWithValidation = _ref370.fieldsWithValidation;
    var isValid = isUndefined(error);
    var previousError = get$1(errors, name);
    return isValid && !!previousError || !isValid && !deepEqual(previousError, error, true) || isValid && get$1(fieldsWithValidation, name) && !get$1(validFields, name);
  };

  var isRegex = function isRegex(value) {
    return value instanceof RegExp;
  };

  var getValueAndMessage = function getValueAndMessage(validationData) {
    return isObject$6(validationData) && !isRegex(validationData) ? validationData : {
      value: validationData,
      message: ''
    };
  };

  var isFunction$1 = function isFunction$1(value) {
    return typeof value === 'function';
  };

  var isMessage = function isMessage(value) {
    return isString$1(value) || React.isValidElement(value);
  };

  function getValidateError(result, ref) {
    var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'validate';

    if (isMessage(result) || isBoolean(result) && !result) {
      return {
        type: type,
        message: isMessage(result) ? result : '',
        ref: ref
      };
    }
  }

  var appendErrors = function appendErrors(name, validateAllFieldCriteria, errors, type, message) {
    return validateAllFieldCriteria ? Object.assign(Object.assign({}, errors[name]), {
      types: Object.assign(Object.assign({}, errors[name] && errors[name].types ? errors[name].types : {}), _defineProperty({}, type, message || true))
    }) : {};
  };

  var validateField = /*#__PURE__*/function () {
    var _ref372 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(fieldsRef, validateAllFieldCriteria, _ref371, shallowFieldsStateRef) {
      var ref, value, options, required, maxLength, minLength, min, max, pattern, validate, name, error, isRadio, isCheckBox, isRadioOrCheckbox, isEmpty, appendErrorsCurry, getMinMaxMessage, _ref373, _value2, message, exceedMax, exceedMin, maxOutput, minOutput, valueNumber, valueDate, maxLengthOutput, minLengthOutput, _exceedMax, _exceedMin, _getValueAndMessage, patternValue, _message, fieldValue, validateRef, result, validateError, validationResult, _i8, _Object$entries, _Object$entries$_i, key, validateFunction, validateResult, _validateError;

      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              ref = _ref371.ref, value = _ref371.ref.value, options = _ref371.options, required = _ref371.required, maxLength = _ref371.maxLength, minLength = _ref371.minLength, min = _ref371.min, max = _ref371.max, pattern = _ref371.pattern, validate = _ref371.validate;
              name = ref.name;
              error = {};
              isRadio = isRadioInput(ref);
              isCheckBox = isCheckBoxInput(ref);
              isRadioOrCheckbox = isRadio || isCheckBox;
              isEmpty = value === '';
              appendErrorsCurry = appendErrors.bind(null, name, validateAllFieldCriteria, error);

              getMinMaxMessage = function getMinMaxMessage(exceedMax, maxLengthMessage, minLengthMessage) {
                var maxType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : INPUT_VALIDATION_RULES.maxLength;
                var minType = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : INPUT_VALIDATION_RULES.minLength;
                var message = exceedMax ? maxLengthMessage : minLengthMessage;
                error[name] = Object.assign({
                  type: exceedMax ? maxType : minType,
                  message: message,
                  ref: ref
                }, exceedMax ? appendErrorsCurry(maxType, message) : appendErrorsCurry(minType, message));
              };

              if (!(required && (!isRadio && !isCheckBox && (isEmpty || isNullOrUndefined(value)) || isBoolean(value) && !value || isCheckBox && !getCheckboxValue(options).isValid || isRadio && !getRadioValue(options).isValid))) {
                _context8.next = 15;
                break;
              }

              _ref373 = isMessage(required) ? {
                value: !!required,
                message: required
              } : getValueAndMessage(required), _value2 = _ref373.value, message = _ref373.message;

              if (!_value2) {
                _context8.next = 15;
                break;
              }

              error[name] = Object.assign({
                type: INPUT_VALIDATION_RULES.required,
                message: message,
                ref: isRadioOrCheckbox ? ((fieldsRef.current[name].options || [])[0] || {}).ref : ref
              }, appendErrorsCurry(INPUT_VALIDATION_RULES.required, message));

              if (validateAllFieldCriteria) {
                _context8.next = 15;
                break;
              }

              return _context8.abrupt("return", error);

            case 15:
              if (!((!isNullOrUndefined(min) || !isNullOrUndefined(max)) && value !== '')) {
                _context8.next = 23;
                break;
              }

              maxOutput = getValueAndMessage(max);
              minOutput = getValueAndMessage(min);

              if (!isNaN(value)) {
                valueNumber = ref.valueAsNumber || parseFloat(value);

                if (!isNullOrUndefined(maxOutput.value)) {
                  exceedMax = valueNumber > maxOutput.value;
                }

                if (!isNullOrUndefined(minOutput.value)) {
                  exceedMin = valueNumber < minOutput.value;
                }
              } else {
                valueDate = ref.valueAsDate || new Date(value);

                if (isString$1(maxOutput.value)) {
                  exceedMax = valueDate > new Date(maxOutput.value);
                }

                if (isString$1(minOutput.value)) {
                  exceedMin = valueDate < new Date(minOutput.value);
                }
              }

              if (!(exceedMax || exceedMin)) {
                _context8.next = 23;
                break;
              }

              getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, INPUT_VALIDATION_RULES.max, INPUT_VALIDATION_RULES.min);

              if (validateAllFieldCriteria) {
                _context8.next = 23;
                break;
              }

              return _context8.abrupt("return", error);

            case 23:
              if (!(isString$1(value) && !isEmpty && (maxLength || minLength))) {
                _context8.next = 32;
                break;
              }

              maxLengthOutput = getValueAndMessage(maxLength);
              minLengthOutput = getValueAndMessage(minLength);
              _exceedMax = !isNullOrUndefined(maxLengthOutput.value) && value.length > maxLengthOutput.value;
              _exceedMin = !isNullOrUndefined(minLengthOutput.value) && value.length < minLengthOutput.value;

              if (!(_exceedMax || _exceedMin)) {
                _context8.next = 32;
                break;
              }

              getMinMaxMessage(_exceedMax, maxLengthOutput.message, minLengthOutput.message);

              if (validateAllFieldCriteria) {
                _context8.next = 32;
                break;
              }

              return _context8.abrupt("return", error);

            case 32:
              if (!(isString$1(value) && pattern && !isEmpty)) {
                _context8.next = 38;
                break;
              }

              _getValueAndMessage = getValueAndMessage(pattern), patternValue = _getValueAndMessage.value, _message = _getValueAndMessage.message;

              if (!(isRegex(patternValue) && !patternValue.test(value))) {
                _context8.next = 38;
                break;
              }

              error[name] = Object.assign({
                type: INPUT_VALIDATION_RULES.pattern,
                message: _message,
                ref: ref
              }, appendErrorsCurry(INPUT_VALIDATION_RULES.pattern, _message));

              if (validateAllFieldCriteria) {
                _context8.next = 38;
                break;
              }

              return _context8.abrupt("return", error);

            case 38:
              if (!validate) {
                _context8.next = 71;
                break;
              }

              fieldValue = getFieldValue(fieldsRef, name, shallowFieldsStateRef, false, true);
              validateRef = isRadioOrCheckbox && options ? options[0].ref : ref;

              if (!isFunction$1(validate)) {
                _context8.next = 52;
                break;
              }

              _context8.next = 44;
              return validate(fieldValue);

            case 44:
              result = _context8.sent;
              validateError = getValidateError(result, validateRef);

              if (!validateError) {
                _context8.next = 50;
                break;
              }

              error[name] = Object.assign(Object.assign({}, validateError), appendErrorsCurry(INPUT_VALIDATION_RULES.validate, validateError.message));

              if (validateAllFieldCriteria) {
                _context8.next = 50;
                break;
              }

              return _context8.abrupt("return", error);

            case 50:
              _context8.next = 71;
              break;

            case 52:
              if (!isObject$6(validate)) {
                _context8.next = 71;
                break;
              }

              validationResult = {};
              _i8 = 0, _Object$entries = Object.entries(validate);

            case 55:
              if (!(_i8 < _Object$entries.length)) {
                _context8.next = 67;
                break;
              }

              _Object$entries$_i = _slicedToArray(_Object$entries[_i8], 2), key = _Object$entries$_i[0], validateFunction = _Object$entries$_i[1];

              if (!(!isEmptyObject(validationResult) && !validateAllFieldCriteria)) {
                _context8.next = 59;
                break;
              }

              return _context8.abrupt("break", 67);

            case 59:
              _context8.next = 61;
              return validateFunction(fieldValue);

            case 61:
              validateResult = _context8.sent;
              _validateError = getValidateError(validateResult, validateRef, key);

              if (_validateError) {
                validationResult = Object.assign(Object.assign({}, _validateError), appendErrorsCurry(key, _validateError.message));

                if (validateAllFieldCriteria) {
                  error[name] = validationResult;
                }
              }

            case 64:
              _i8++;
              _context8.next = 55;
              break;

            case 67:
              if (isEmptyObject(validationResult)) {
                _context8.next = 71;
                break;
              }

              error[name] = Object.assign({
                ref: validateRef
              }, validationResult);

              if (validateAllFieldCriteria) {
                _context8.next = 71;
                break;
              }

              return _context8.abrupt("return", error);

            case 71:
              return _context8.abrupt("return", error);

            case 72:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));

    return function validateField(_x, _x2, _x3, _x4) {
      return _ref372.apply(this, arguments);
    };
  }();

  var getPath = function getPath(rootPath, values) {
    var paths = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

    for (var _property in values) {
      var rootName = rootPath + (isObject$6(values) ? ".".concat(_property) : "[".concat(_property, "]"));
      isPrimitive(values[_property]) ? paths.push(rootName) : getPath(rootName, values[_property], paths);
    }

    return paths;
  };

  var assignWatchFields = function assignWatchFields(fieldValues, fieldName, watchFields, inputValue, isSingleField) {
    var value = undefined;
    watchFields.add(fieldName);

    if (!isEmptyObject(fieldValues)) {
      value = get$1(fieldValues, fieldName);

      if (isObject$6(value) || Array.isArray(value)) {
        getPath(fieldName, value).forEach(function (name) {
          return watchFields.add(name);
        });
      }
    }

    return isUndefined(value) ? isSingleField ? inputValue : get$1(inputValue, fieldName) : value;
  };

  var skipValidation = function skipValidation(_ref374) {
    var isOnBlur = _ref374.isOnBlur,
        isOnChange = _ref374.isOnChange,
        isOnTouch = _ref374.isOnTouch,
        isTouched = _ref374.isTouched,
        isReValidateOnBlur = _ref374.isReValidateOnBlur,
        isReValidateOnChange = _ref374.isReValidateOnChange,
        isBlurEvent = _ref374.isBlurEvent,
        isSubmitted = _ref374.isSubmitted,
        isOnAll = _ref374.isOnAll;

    if (isOnAll) {
      return false;
    } else if (!isSubmitted && isOnTouch) {
      return !(isTouched || isBlurEvent);
    } else if (isSubmitted ? isReValidateOnBlur : isOnBlur) {
      return !isBlurEvent;
    } else if (isSubmitted ? isReValidateOnChange : isOnChange) {
      return isBlurEvent;
    }

    return true;
  };

  var getFieldArrayParentName = function getFieldArrayParentName(name) {
    return name.substring(0, name.indexOf('['));
  };

  var isMatchFieldArrayName = function isMatchFieldArrayName(name, searchName) {
    return RegExp("^".concat(searchName, "([|.)\\d+").replace(/\[/g, '\\[').replace(/\]/g, '\\]')).test(name);
  };

  var isNameInFieldArray = function isNameInFieldArray(names, name) {
    return _toConsumableArray(names).some(function (current) {
      return isMatchFieldArrayName(name, current);
    });
  };

  var isSelectInput = function isSelectInput(element) {
    return element.type === "".concat(SELECT, "-one");
  };

  function onDomRemove(fieldsRef, removeFieldEventListenerAndRef) {
    var observer = new MutationObserver(function () {
      for (var _i9 = 0, _Object$values = Object.values(fieldsRef.current); _i9 < _Object$values.length; _i9++) {
        var field = _Object$values[_i9];

        if (field && field.options) {
          var _iterator4 = _createForOfIteratorHelper(field.options),
              _step4;

          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var option = _step4.value;

              if (option && option.ref && isDetached(option.ref)) {
                removeFieldEventListenerAndRef(field);
              }
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }
        } else if (field && isDetached(field.ref)) {
          removeFieldEventListenerAndRef(field);
        }
      }
    });
    observer.observe(window.document, {
      childList: true,
      subtree: true
    });
    return observer;
  }

  var isWeb = typeof window !== UNDEFINED && typeof document !== UNDEFINED;

  function cloneObject(data) {
    var _a;

    var copy;

    if (isPrimitive(data) || isWeb && (data instanceof File || isHTMLElement(data))) {
      return data;
    }

    if (!['Set', 'Map', 'Object', 'Date', 'Array'].includes((_a = data.constructor) === null || _a === void 0 ? void 0 : _a.name)) {
      return data;
    }

    if (data instanceof Date) {
      copy = new Date(data.getTime());
      return copy;
    }

    if (data instanceof Set) {
      copy = new Set();

      var _iterator5 = _createForOfIteratorHelper(data),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var item = _step5.value;
          copy.add(item);
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      return copy;
    }

    if (data instanceof Map) {
      copy = new Map();

      var _iterator6 = _createForOfIteratorHelper(data.keys()),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var key = _step6.value;
          copy.set(key, cloneObject(data.get(key)));
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }

      return copy;
    }

    copy = Array.isArray(data) ? [] : {};

    for (var _key25 in data) {
      copy[_key25] = cloneObject(data[_key25]);
    }

    return copy;
  }

  var modeChecker = function modeChecker(mode) {
    return {
      isOnSubmit: !mode || mode === VALIDATION_MODE.onSubmit,
      isOnBlur: mode === VALIDATION_MODE.onBlur,
      isOnChange: mode === VALIDATION_MODE.onChange,
      isOnAll: mode === VALIDATION_MODE.all,
      isOnTouch: mode === VALIDATION_MODE.onTouched
    };
  };

  var isRadioOrCheckboxFunction = function isRadioOrCheckboxFunction(ref) {
    return isRadioInput(ref) || isCheckBoxInput(ref);
  };

  var isWindowUndefined = typeof window === UNDEFINED;
  var isProxyEnabled = isWeb ? 'Proxy' in window : typeof Proxy !== UNDEFINED;

  function useForm() {
    var _ref375 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref375$mode = _ref375.mode,
        mode = _ref375$mode === void 0 ? VALIDATION_MODE.onSubmit : _ref375$mode,
        _ref375$reValidateMod = _ref375.reValidateMode,
        reValidateMode = _ref375$reValidateMod === void 0 ? VALIDATION_MODE.onChange : _ref375$reValidateMod,
        resolver = _ref375.resolver,
        context = _ref375.context,
        _ref375$defaultValues = _ref375.defaultValues,
        defaultValues = _ref375$defaultValues === void 0 ? {} : _ref375$defaultValues,
        _ref375$shouldFocusEr = _ref375.shouldFocusError,
        shouldFocusError = _ref375$shouldFocusEr === void 0 ? true : _ref375$shouldFocusEr,
        _ref375$shouldUnregis = _ref375.shouldUnregister,
        shouldUnregister = _ref375$shouldUnregis === void 0 ? true : _ref375$shouldUnregis,
        criteriaMode = _ref375.criteriaMode;

    var fieldsRef = React.useRef({});
    var fieldArrayDefaultValuesRef = React.useRef({});
    var fieldArrayValuesRef = React.useRef({});
    var watchFieldsRef = React.useRef(new Set());
    var useWatchFieldsRef = React.useRef({});
    var useWatchRenderFunctionsRef = React.useRef({});
    var fieldsWithValidationRef = React.useRef({});
    var validFieldsRef = React.useRef({});
    var defaultValuesRef = React.useRef(defaultValues);
    var isUnMount = React.useRef(false);
    var isWatchAllRef = React.useRef(false);
    var handleChangeRef = React.useRef();
    var shallowFieldsStateRef = React.useRef({});
    var resetFieldArrayFunctionRef = React.useRef({});
    var contextRef = React.useRef(context);
    var resolverRef = React.useRef(resolver);
    var fieldArrayNamesRef = React.useRef(new Set());
    var modeRef = React.useRef(modeChecker(mode));
    var _modeRef$current = modeRef.current,
        isOnSubmit = _modeRef$current.isOnSubmit,
        isOnTouch = _modeRef$current.isOnTouch;
    var isValidateAllFieldCriteria = criteriaMode === VALIDATION_MODE.all;

    var _React$useState = React.useState({
      isDirty: false,
      isValidating: false,
      dirtyFields: {},
      isSubmitted: false,
      submitCount: 0,
      touched: {},
      isSubmitting: false,
      isSubmitSuccessful: false,
      isValid: !isOnSubmit,
      errors: {}
    }),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        formState = _React$useState2[0],
        setFormState = _React$useState2[1];

    var readFormStateRef = React.useRef({
      isDirty: !isProxyEnabled,
      dirtyFields: !isProxyEnabled,
      touched: !isProxyEnabled || isOnTouch,
      isValidating: !isProxyEnabled,
      isSubmitting: !isProxyEnabled,
      isValid: !isProxyEnabled
    });
    var formStateRef = React.useRef(formState);
    var observerRef = React.useRef();
    var _React$useRef$current = React.useRef(modeChecker(reValidateMode)).current,
        isReValidateOnBlur = _React$useRef$current.isOnBlur,
        isReValidateOnChange = _React$useRef$current.isOnChange;
    contextRef.current = context;
    resolverRef.current = resolver;
    formStateRef.current = formState;
    shallowFieldsStateRef.current = shouldUnregister ? {} : isEmptyObject(shallowFieldsStateRef.current) ? cloneObject(defaultValues) : shallowFieldsStateRef.current;
    var updateFormState = React.useCallback(function () {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (!isUnMount.current) {
        formStateRef.current = Object.assign(Object.assign({}, formStateRef.current), state);
        setFormState(formStateRef.current);
      }
    }, []);

    var updateIsValidating = function updateIsValidating() {
      return readFormStateRef.current.isValidating && updateFormState({
        isValidating: true
      });
    };

    var shouldRenderBaseOnError = React.useCallback(function (name, error) {
      var shouldRender = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var state = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var isValid = arguments.length > 4 ? arguments[4] : undefined;
      var shouldReRender = shouldRender || isErrorStateChanged({
        errors: formStateRef.current.errors,
        error: error,
        name: name,
        validFields: validFieldsRef.current,
        fieldsWithValidation: fieldsWithValidationRef.current
      });
      var previousError = get$1(formStateRef.current.errors, name);

      if (error) {
        unset(validFieldsRef.current, name);
        shouldReRender = shouldReRender || !previousError || !deepEqual(previousError, error, true);
        set(formStateRef.current.errors, name, error);
      } else {
        if (get$1(fieldsWithValidationRef.current, name) || resolverRef.current) {
          set(validFieldsRef.current, name, true);
          shouldReRender = shouldReRender || previousError;
        }

        unset(formStateRef.current.errors, name);
      }

      if (shouldReRender && !isNullOrUndefined(shouldRender) || !isEmptyObject(state) || readFormStateRef.current.isValidating) {
        updateFormState(Object.assign(Object.assign(Object.assign({}, state), resolverRef.current ? {
          isValid: !!isValid
        } : {}), {
          isValidating: false
        }));
      }
    }, []);
    var setFieldValue = React.useCallback(function (name, rawValue) {
      var _fieldsRef$current$na = fieldsRef.current[name],
          ref = _fieldsRef$current$na.ref,
          options = _fieldsRef$current$na.options;
      var value = isWeb && isHTMLElement(ref) && isNullOrUndefined(rawValue) ? '' : rawValue;

      if (isRadioInput(ref)) {
        (options || []).forEach(function (_ref376) {
          var radioRef = _ref376.ref;
          return radioRef.checked = radioRef.value === value;
        });
      } else if (isFileInput(ref) && !isString$1(value)) {
        ref.files = value;
      } else if (isMultipleSelect(ref)) {
        _toConsumableArray(ref.options).forEach(function (selectRef) {
          return selectRef.selected = value.includes(selectRef.value);
        });
      } else if (isCheckBoxInput(ref) && options) {
        options.length > 1 ? options.forEach(function (_ref377) {
          var checkboxRef = _ref377.ref;
          return checkboxRef.checked = Array.isArray(value) ? !!value.find(function (data) {
            return data === checkboxRef.value;
          }) : value === checkboxRef.value;
        }) : options[0].ref.checked = !!value;
      } else {
        ref.value = value;
      }
    }, []);
    var isFormDirty = React.useCallback(function (name, data) {
      if (readFormStateRef.current.isDirty) {
        var formValues = getValues();
        name && data && set(formValues, name, data);
        return !deepEqual(formValues, defaultValuesRef.current);
      }

      return false;
    }, []);
    var updateAndGetDirtyState = React.useCallback(function (name) {
      var shouldRender = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (readFormStateRef.current.isDirty || readFormStateRef.current.dirtyFields) {
        var isFieldDirty = !deepEqual(get$1(defaultValuesRef.current, name), getFieldValue(fieldsRef, name, shallowFieldsStateRef));
        var isDirtyFieldExist = get$1(formStateRef.current.dirtyFields, name);
        var previousIsDirty = formStateRef.current.isDirty;
        isFieldDirty ? set(formStateRef.current.dirtyFields, name, true) : unset(formStateRef.current.dirtyFields, name);
        var state = {
          isDirty: isFormDirty(),
          dirtyFields: formStateRef.current.dirtyFields
        };
        var isChanged = readFormStateRef.current.isDirty && previousIsDirty !== state.isDirty || readFormStateRef.current.dirtyFields && isDirtyFieldExist !== get$1(formStateRef.current.dirtyFields, name);
        isChanged && shouldRender && updateFormState(state);
        return isChanged ? state : {};
      }

      return {};
    }, []);
    var executeValidation = React.useCallback( /*#__PURE__*/function () {
      var _ref378 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(name, skipReRender) {
        var error;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (!(process.env.NODE_ENV !== 'production')) {
                  _context9.next = 4;
                  break;
                }

                if (fieldsRef.current[name]) {
                  _context9.next = 4;
                  break;
                }

                console.warn('📋 Field is missing with `name` attribute: ', name);
                return _context9.abrupt("return", false);

              case 4:
                _context9.next = 6;
                return validateField(fieldsRef, isValidateAllFieldCriteria, fieldsRef.current[name], shallowFieldsStateRef);

              case 6:
                _context9.t0 = name;
                error = _context9.sent[_context9.t0];
                shouldRenderBaseOnError(name, error, skipReRender);
                return _context9.abrupt("return", isUndefined(error));

              case 10:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));

      return function (_x5, _x6) {
        return _ref378.apply(this, arguments);
      };
    }(), [shouldRenderBaseOnError, isValidateAllFieldCriteria]);
    var executeSchemaOrResolverValidation = React.useCallback( /*#__PURE__*/function () {
      var _ref379 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(names) {
        var _yield$resolverRef$cu, errors, previousFormIsValid, isInputsValid, _error;

        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return resolverRef.current(getValues(), contextRef.current, isValidateAllFieldCriteria);

              case 2:
                _yield$resolverRef$cu = _context10.sent;
                errors = _yield$resolverRef$cu.errors;
                previousFormIsValid = formStateRef.current.isValid;

                if (!Array.isArray(names)) {
                  _context10.next = 11;
                  break;
                }

                isInputsValid = names.map(function (name) {
                  var error = get$1(errors, name);
                  error ? set(formStateRef.current.errors, name, error) : unset(formStateRef.current.errors, name);
                  return !error;
                }).every(Boolean);
                updateFormState({
                  isValid: isEmptyObject(errors),
                  isValidating: false
                });
                return _context10.abrupt("return", isInputsValid);

              case 11:
                _error = get$1(errors, names);
                shouldRenderBaseOnError(names, _error, previousFormIsValid !== isEmptyObject(errors), {}, isEmptyObject(errors));
                return _context10.abrupt("return", !_error);

              case 14:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }));

      return function (_x7) {
        return _ref379.apply(this, arguments);
      };
    }(), [shouldRenderBaseOnError, isValidateAllFieldCriteria]);
    var trigger = React.useCallback( /*#__PURE__*/function () {
      var _ref380 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(name) {
        var fields, result;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                fields = name || Object.keys(fieldsRef.current);
                updateIsValidating();

                if (!resolverRef.current) {
                  _context12.next = 4;
                  break;
                }

                return _context12.abrupt("return", executeSchemaOrResolverValidation(fields));

              case 4:
                if (!Array.isArray(fields)) {
                  _context12.next = 11;
                  break;
                }

                !name && (formStateRef.current.errors = {});
                _context12.next = 8;
                return Promise.all(fields.map( /*#__PURE__*/function () {
                  var _ref381 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(data) {
                    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
                      while (1) {
                        switch (_context11.prev = _context11.next) {
                          case 0:
                            _context11.next = 2;
                            return executeValidation(data, null);

                          case 2:
                            return _context11.abrupt("return", _context11.sent);

                          case 3:
                          case "end":
                            return _context11.stop();
                        }
                      }
                    }, _callee11);
                  }));

                  return function (_x9) {
                    return _ref381.apply(this, arguments);
                  };
                }()));

              case 8:
                result = _context12.sent;
                updateFormState({
                  isValidating: false
                });
                return _context12.abrupt("return", result.every(Boolean));

              case 11:
                _context12.next = 13;
                return executeValidation(fields);

              case 13:
                return _context12.abrupt("return", _context12.sent);

              case 14:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }));

      return function (_x8) {
        return _ref380.apply(this, arguments);
      };
    }(), [executeSchemaOrResolverValidation, executeValidation]);
    var setInternalValues = React.useCallback(function (name, value, _ref382) {
      var shouldDirty = _ref382.shouldDirty,
          shouldValidate = _ref382.shouldValidate;
      var data = {};
      set(data, name, value);

      var _iterator7 = _createForOfIteratorHelper(getPath(name, value)),
          _step7;

      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var fieldName = _step7.value;

          if (fieldsRef.current[fieldName]) {
            setFieldValue(fieldName, get$1(data, fieldName));
            shouldDirty && updateAndGetDirtyState(fieldName);
            shouldValidate && trigger(fieldName);
          }
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }
    }, [trigger, setFieldValue, updateAndGetDirtyState]);
    var setInternalValue = React.useCallback(function (name, value, config) {
      !shouldUnregister && !isPrimitive(value) && set(shallowFieldsStateRef.current, name, Array.isArray(value) ? _toConsumableArray(value) : Object.assign({}, value));

      if (fieldsRef.current[name]) {
        setFieldValue(name, value);
        config.shouldDirty && updateAndGetDirtyState(name);
        config.shouldValidate && trigger(name);
      } else if (!isPrimitive(value)) {
        setInternalValues(name, value, config);

        if (fieldArrayNamesRef.current.has(name)) {
          var parentName = getFieldArrayParentName(name) || name;
          set(fieldArrayDefaultValuesRef.current, name, value);
          resetFieldArrayFunctionRef.current[parentName](_defineProperty({}, parentName, get$1(fieldArrayDefaultValuesRef.current, parentName)));

          if ((readFormStateRef.current.isDirty || readFormStateRef.current.dirtyFields) && config.shouldDirty) {
            set(formStateRef.current.dirtyFields, name, setFieldArrayDirtyFields(value, get$1(defaultValuesRef.current, name, []), get$1(formStateRef.current.dirtyFields, name, [])));
            updateFormState({
              isDirty: !deepEqual(Object.assign(Object.assign({}, getValues()), _defineProperty({}, name, value)), defaultValuesRef.current)
            });
          }
        }
      }

      !shouldUnregister && set(shallowFieldsStateRef.current, name, value);
    }, [updateAndGetDirtyState, setFieldValue, setInternalValues]);

    var isFieldWatched = function isFieldWatched(name) {
      return isWatchAllRef.current || watchFieldsRef.current.has(name) || watchFieldsRef.current.has((name.match(/\w+/) || [])[0]);
    };

    var renderWatchedInputs = function renderWatchedInputs(name) {
      var found = true;

      if (!isEmptyObject(useWatchFieldsRef.current)) {
        for (var key in useWatchFieldsRef.current) {
          if (!name || !useWatchFieldsRef.current[key].size || useWatchFieldsRef.current[key].has(name) || useWatchFieldsRef.current[key].has(getFieldArrayParentName(name))) {
            useWatchRenderFunctionsRef.current[key]();
            found = false;
          }
        }
      }

      return found;
    };

    function setValue(name, value, config) {
      setInternalValue(name, value, config || {});
      isFieldWatched(name) && updateFormState();
      renderWatchedInputs(name);
    }

    handleChangeRef.current = handleChangeRef.current ? handleChangeRef.current : /*#__PURE__*/function () {
      var _ref384 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(_ref383) {
        var type, target, name, field, error, isValid, isBlurEvent, shouldSkipValidation, state, shouldRender, _yield$resolverRef$cu2, errors, previousFormIsValid, parentNodeName, currentError;

        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                type = _ref383.type, target = _ref383.target;
                name = target.name;
                field = fieldsRef.current[name];

                if (!field) {
                  _context13.next = 32;
                  break;
                }

                isBlurEvent = type === EVENTS.BLUR;
                shouldSkipValidation = skipValidation(Object.assign({
                  isBlurEvent: isBlurEvent,
                  isReValidateOnChange: isReValidateOnChange,
                  isReValidateOnBlur: isReValidateOnBlur,
                  isTouched: !!get$1(formStateRef.current.touched, name),
                  isSubmitted: formStateRef.current.isSubmitted
                }, modeRef.current));
                state = updateAndGetDirtyState(name, false);
                shouldRender = !isEmptyObject(state) || !isBlurEvent && isFieldWatched(name);

                if (isBlurEvent && !get$1(formStateRef.current.touched, name) && readFormStateRef.current.touched) {
                  set(formStateRef.current.touched, name, true);
                  state = Object.assign(Object.assign({}, state), {
                    touched: formStateRef.current.touched
                  });
                }

                if (!shouldUnregister && isCheckBoxInput(target)) {
                  set(shallowFieldsStateRef.current, name, getFieldValue(fieldsRef, name));
                }

                if (!shouldSkipValidation) {
                  _context13.next = 13;
                  break;
                }

                !isBlurEvent && renderWatchedInputs(name);
                return _context13.abrupt("return", (!isEmptyObject(state) || shouldRender && isEmptyObject(state)) && updateFormState(state));

              case 13:
                updateIsValidating();

                if (!resolverRef.current) {
                  _context13.next = 26;
                  break;
                }

                _context13.next = 17;
                return resolverRef.current(getValues(), contextRef.current, isValidateAllFieldCriteria);

              case 17:
                _yield$resolverRef$cu2 = _context13.sent;
                errors = _yield$resolverRef$cu2.errors;
                previousFormIsValid = formStateRef.current.isValid;
                error = get$1(errors, name);

                if (isCheckBoxInput(target) && !error && resolverRef.current) {
                  parentNodeName = getFieldArrayParentName(name);
                  currentError = get$1(errors, parentNodeName, {});
                  currentError.type && currentError.message && (error = currentError);

                  if (parentNodeName && (currentError || get$1(formStateRef.current.errors, parentNodeName))) {
                    name = parentNodeName;
                  }
                }

                isValid = isEmptyObject(errors);
                previousFormIsValid !== isValid && (shouldRender = true);
                _context13.next = 30;
                break;

              case 26:
                _context13.next = 28;
                return validateField(fieldsRef, isValidateAllFieldCriteria, field, shallowFieldsStateRef);

              case 28:
                _context13.t0 = name;
                error = _context13.sent[_context13.t0];

              case 30:
                !isBlurEvent && renderWatchedInputs(name);
                shouldRenderBaseOnError(name, error, shouldRender, state, isValid);

              case 32:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13);
      }));

      return function (_x10) {
        return _ref384.apply(this, arguments);
      };
    }();

    function setFieldArrayDefaultValues(data) {
      if (!shouldUnregister) {
        var _copy = cloneObject(data);

        var _iterator8 = _createForOfIteratorHelper(fieldArrayNamesRef.current),
            _step8;

        try {
          for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
            var value = _step8.value;

            if (isKey$1(value) && !_copy[value]) {
              _copy = Object.assign(Object.assign({}, _copy), _defineProperty({}, value, []));
            }
          }
        } catch (err) {
          _iterator8.e(err);
        } finally {
          _iterator8.f();
        }

        return _copy;
      }

      return data;
    }

    function getValues(payload) {
      if (isString$1(payload)) {
        return getFieldValue(fieldsRef, payload, shallowFieldsStateRef);
      }

      if (Array.isArray(payload)) {
        var data = {};

        var _iterator9 = _createForOfIteratorHelper(payload),
            _step9;

        try {
          for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
            var _name2 = _step9.value;
            set(data, _name2, getFieldValue(fieldsRef, _name2, shallowFieldsStateRef));
          }
        } catch (err) {
          _iterator9.e(err);
        } finally {
          _iterator9.f();
        }

        return data;
      }

      return setFieldArrayDefaultValues(getFieldsValues(fieldsRef, cloneObject(shallowFieldsStateRef.current), shouldUnregister));
    }

    var validateResolver = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
      var values,
          newDefaultValues,
          _ref386,
          errors,
          isValid,
          _args14 = arguments;

      return _regeneratorRuntime.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              values = _args14.length > 0 && _args14[0] !== undefined ? _args14[0] : {};
              newDefaultValues = isEmptyObject(fieldsRef.current) ? defaultValuesRef.current : {};
              _context14.next = 4;
              return resolverRef.current(Object.assign(Object.assign(Object.assign({}, newDefaultValues), getValues()), values), contextRef.current, isValidateAllFieldCriteria);

            case 4:
              _context14.t0 = _context14.sent;

              if (_context14.t0) {
                _context14.next = 7;
                break;
              }

              _context14.t0 = {};

            case 7:
              _ref386 = _context14.t0;
              errors = _ref386.errors;
              isValid = isEmptyObject(errors);
              formStateRef.current.isValid !== isValid && updateFormState({
                isValid: isValid
              });

            case 11:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14);
    })), [isValidateAllFieldCriteria]);
    var removeFieldEventListener = React.useCallback(function (field, forceDelete) {
      findRemovedFieldAndRemoveListener(fieldsRef, handleChangeRef.current, field, shallowFieldsStateRef, shouldUnregister, forceDelete);

      if (shouldUnregister) {
        unset(validFieldsRef.current, field.ref.name);
        unset(fieldsWithValidationRef.current, field.ref.name);
      }
    }, [shouldUnregister]);
    var updateWatchedValue = React.useCallback(function (name) {
      if (isWatchAllRef.current) {
        updateFormState();
      } else {
        var _iterator10 = _createForOfIteratorHelper(watchFieldsRef.current),
            _step10;

        try {
          for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
            var watchField = _step10.value;

            if (watchField.startsWith(name)) {
              updateFormState();
              break;
            }
          }
        } catch (err) {
          _iterator10.e(err);
        } finally {
          _iterator10.f();
        }

        renderWatchedInputs(name);
      }
    }, []);
    var removeFieldEventListenerAndRef = React.useCallback(function (field, forceDelete) {
      if (field) {
        removeFieldEventListener(field, forceDelete);

        if (shouldUnregister && !compact(field.options || []).length) {
          unset(formStateRef.current.errors, field.ref.name);
          set(formStateRef.current.dirtyFields, field.ref.name, true);
          updateFormState({
            isDirty: isFormDirty()
          });
          readFormStateRef.current.isValid && resolverRef.current && validateResolver();
          updateWatchedValue(field.ref.name);
        }
      }
    }, [validateResolver, removeFieldEventListener]);

    function clearErrors(name) {
      name && (Array.isArray(name) ? name : [name]).forEach(function (inputName) {
        return fieldsRef.current[inputName] && isKey$1(inputName) ? delete formStateRef.current.errors[inputName] : unset(formStateRef.current.errors, inputName);
      });
      updateFormState({
        errors: name ? formStateRef.current.errors : {}
      });
    }

    function setError(name, error) {
      var ref = (fieldsRef.current[name] || {}).ref;
      set(formStateRef.current.errors, name, Object.assign(Object.assign({}, error), {
        ref: ref
      }));
      updateFormState({
        isValid: false
      });
      error.shouldFocus && ref && ref.focus && ref.focus();
    }

    var watchInternal = React.useCallback(function (fieldNames, defaultValue, watchId) {
      var watchFields = watchId ? useWatchFieldsRef.current[watchId] : watchFieldsRef.current;
      var fieldValues = getFieldsValues(fieldsRef, cloneObject(shallowFieldsStateRef.current), shouldUnregister, false, fieldNames);

      if (isString$1(fieldNames)) {
        var parentNodeName = getFieldArrayParentName(fieldNames) || fieldNames;

        if (fieldArrayNamesRef.current.has(parentNodeName)) {
          fieldValues = Object.assign(Object.assign({}, fieldArrayValuesRef.current), fieldValues);
        }

        return assignWatchFields(fieldValues, fieldNames, watchFields, isUndefined(get$1(defaultValuesRef.current, fieldNames)) ? defaultValue : get$1(defaultValuesRef.current, fieldNames), true);
      }

      var combinedDefaultValues = isUndefined(defaultValue) ? defaultValuesRef.current : defaultValue;

      if (Array.isArray(fieldNames)) {
        return fieldNames.reduce(function (previous, name) {
          return Object.assign(Object.assign({}, previous), _defineProperty({}, name, assignWatchFields(fieldValues, name, watchFields, combinedDefaultValues)));
        }, {});
      }

      isWatchAllRef.current = isUndefined(watchId);
      return transformToNestObject(!isEmptyObject(fieldValues) && fieldValues || combinedDefaultValues);
    }, []);

    function watch(fieldNames, defaultValue) {
      return watchInternal(fieldNames, defaultValue);
    }

    function unregister(name) {
      var _iterator11 = _createForOfIteratorHelper(Array.isArray(name) ? name : [name]),
          _step11;

      try {
        for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
          var fieldName = _step11.value;
          removeFieldEventListenerAndRef(fieldsRef.current[fieldName], true);
        }
      } catch (err) {
        _iterator11.e(err);
      } finally {
        _iterator11.f();
      }
    }

    function registerFieldRef(ref) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (process.env.NODE_ENV !== 'production') {
        if (!ref.name) {
          return console.warn('📋 Field is missing `name` attribute', ref, "https://react-hook-form.com/api#useForm");
        }

        if (fieldArrayNamesRef.current.has(ref.name.split(/\[\d+\]$/)[0]) && !RegExp("^".concat(ref.name.split(/\[\d+\]$/)[0], "[\\d+].\\w+").replace(/\[/g, '\\[').replace(/\]/g, '\\]')).test(ref.name)) {
          return console.warn('📋 `name` prop should be in object shape: name="test[index].name"', ref, 'https://react-hook-form.com/api#useFieldArray');
        }
      }

      var name = ref.name,
          type = ref.type,
          value = ref.value;
      var fieldRefAndValidationOptions = Object.assign({
        ref: ref
      }, options);
      var fields = fieldsRef.current;
      var isRadioOrCheckbox = isRadioOrCheckboxFunction(ref);
      var isFieldArray = isNameInFieldArray(fieldArrayNamesRef.current, name);

      var compareRef = function compareRef(currentRef) {
        return isWeb && (!isHTMLElement(ref) || currentRef === ref);
      };

      var field = fields[name];
      var isEmptyDefaultValue = true;
      var defaultValue;

      if (field && (isRadioOrCheckbox ? Array.isArray(field.options) && compact(field.options).find(function (option) {
        return value === option.ref.value && compareRef(option.ref);
      }) : compareRef(field.ref))) {
        fields[name] = Object.assign(Object.assign({}, field), options);
        return;
      }

      if (type) {
        field = isRadioOrCheckbox ? Object.assign({
          options: [].concat(_toConsumableArray(compact(field && field.options || [])), [{
            ref: ref
          }]),
          ref: {
            type: type,
            name: name
          }
        }, options) : Object.assign({}, fieldRefAndValidationOptions);
      } else {
        field = fieldRefAndValidationOptions;
      }

      fields[name] = field;
      var isEmptyUnmountFields = isUndefined(get$1(shallowFieldsStateRef.current, name));

      if (!isEmptyObject(defaultValuesRef.current) || !isEmptyUnmountFields) {
        defaultValue = get$1(isEmptyUnmountFields ? defaultValuesRef.current : shallowFieldsStateRef.current, name);
        isEmptyDefaultValue = isUndefined(defaultValue);

        if (!isEmptyDefaultValue && !isFieldArray) {
          setFieldValue(name, defaultValue);
        }
      }

      if (!isEmptyObject(options)) {
        set(fieldsWithValidationRef.current, name, true);

        if (!isOnSubmit && readFormStateRef.current.isValid) {
          validateField(fieldsRef, isValidateAllFieldCriteria, field, shallowFieldsStateRef).then(function (error) {
            var previousFormIsValid = formStateRef.current.isValid;
            isEmptyObject(error) ? set(validFieldsRef.current, name, true) : unset(validFieldsRef.current, name);
            previousFormIsValid !== isEmptyObject(error) && updateFormState();
          });
        }
      }

      if (shouldUnregister && !(isFieldArray && isEmptyDefaultValue)) {
        !isFieldArray && unset(formStateRef.current.dirtyFields, name);
      }

      if (type) {
        attachEventListeners(isRadioOrCheckbox && field.options ? field.options[field.options.length - 1] : field, isRadioOrCheckbox || isSelectInput(ref), handleChangeRef.current);
      }
    }

    function register(refOrRegisterOptions, options) {
      if (!isWindowUndefined) {
        if (isString$1(refOrRegisterOptions)) {
          registerFieldRef({
            name: refOrRegisterOptions
          }, options);
        } else if (isObject$6(refOrRegisterOptions) && 'name' in refOrRegisterOptions) {
          registerFieldRef(refOrRegisterOptions, options);
        } else {
          return function (ref) {
            return ref && registerFieldRef(ref, refOrRegisterOptions);
          };
        }
      }
    }

    var handleSubmit = React.useCallback(function (onValid, onInvalid) {
      return /*#__PURE__*/function () {
        var _ref387 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(e) {
          var fieldErrors, fieldValues, _yield$resolverRef$cu3, errors, _values3, _i10, _Object$values2, field, _name3, fieldError;

          return _regeneratorRuntime.wrap(function _callee15$(_context15) {
            while (1) {
              switch (_context15.prev = _context15.next) {
                case 0:
                  if (e && e.preventDefault) {
                    e.preventDefault();
                    e.persist();
                  }

                  fieldErrors = {};
                  fieldValues = setFieldArrayDefaultValues(getFieldsValues(fieldsRef, cloneObject(shallowFieldsStateRef.current), shouldUnregister, true));
                  readFormStateRef.current.isSubmitting && updateFormState({
                    isSubmitting: true
                  });
                  _context15.prev = 4;

                  if (!resolverRef.current) {
                    _context15.next = 15;
                    break;
                  }

                  _context15.next = 8;
                  return resolverRef.current(fieldValues, contextRef.current, isValidateAllFieldCriteria);

                case 8:
                  _yield$resolverRef$cu3 = _context15.sent;
                  errors = _yield$resolverRef$cu3.errors;
                  _values3 = _yield$resolverRef$cu3.values;
                  formStateRef.current.errors = fieldErrors = errors;
                  fieldValues = _values3;
                  _context15.next = 27;
                  break;

                case 15:
                  _i10 = 0, _Object$values2 = Object.values(fieldsRef.current);

                case 16:
                  if (!(_i10 < _Object$values2.length)) {
                    _context15.next = 27;
                    break;
                  }

                  field = _Object$values2[_i10];

                  if (!field) {
                    _context15.next = 24;
                    break;
                  }

                  _name3 = field.ref.name;
                  _context15.next = 22;
                  return validateField(fieldsRef, isValidateAllFieldCriteria, field, shallowFieldsStateRef);

                case 22:
                  fieldError = _context15.sent;

                  if (fieldError[_name3]) {
                    set(fieldErrors, _name3, fieldError[_name3]);
                    unset(validFieldsRef.current, _name3);
                  } else if (get$1(fieldsWithValidationRef.current, _name3)) {
                    unset(formStateRef.current.errors, _name3);
                    set(validFieldsRef.current, _name3, true);
                  }

                case 24:
                  _i10++;
                  _context15.next = 16;
                  break;

                case 27:
                  if (!(isEmptyObject(fieldErrors) && Object.keys(formStateRef.current.errors).every(function (name) {
                    return name in fieldsRef.current;
                  }))) {
                    _context15.next = 33;
                    break;
                  }

                  updateFormState({
                    errors: {},
                    isSubmitting: true
                  });
                  _context15.next = 31;
                  return onValid(fieldValues, e);

                case 31:
                  _context15.next = 39;
                  break;

                case 33:
                  formStateRef.current.errors = Object.assign(Object.assign({}, formStateRef.current.errors), fieldErrors);
                  _context15.t0 = onInvalid;

                  if (!_context15.t0) {
                    _context15.next = 38;
                    break;
                  }

                  _context15.next = 38;
                  return onInvalid(formStateRef.current.errors, e);

                case 38:
                  shouldFocusError && focusOnErrorField(fieldsRef.current, formStateRef.current.errors);

                case 39:
                  _context15.prev = 39;
                  formStateRef.current.isSubmitting = false;
                  updateFormState({
                    isSubmitted: true,
                    isSubmitting: false,
                    isSubmitSuccessful: isEmptyObject(formStateRef.current.errors),
                    submitCount: formStateRef.current.submitCount + 1
                  });
                  return _context15.finish(39);

                case 43:
                case "end":
                  return _context15.stop();
              }
            }
          }, _callee15, null, [[4,, 39, 43]]);
        }));

        return function (_x11) {
          return _ref387.apply(this, arguments);
        };
      }();
    }, [shouldFocusError, isValidateAllFieldCriteria]);

    var resetRefs = function resetRefs(_ref388) {
      var errors = _ref388.errors,
          isDirty = _ref388.isDirty,
          isSubmitted = _ref388.isSubmitted,
          touched = _ref388.touched,
          isValid = _ref388.isValid,
          submitCount = _ref388.submitCount,
          dirtyFields = _ref388.dirtyFields;

      if (!isValid) {
        validFieldsRef.current = {};
        fieldsWithValidationRef.current = {};
      }

      fieldArrayDefaultValuesRef.current = {};
      watchFieldsRef.current = new Set();
      isWatchAllRef.current = false;
      updateFormState({
        submitCount: submitCount ? formStateRef.current.submitCount : 0,
        isDirty: isDirty ? formStateRef.current.isDirty : false,
        isSubmitted: isSubmitted ? formStateRef.current.isSubmitted : false,
        isValid: isValid ? formStateRef.current.isValid : false,
        dirtyFields: dirtyFields ? formStateRef.current.dirtyFields : {},
        touched: touched ? formStateRef.current.touched : {},
        errors: errors ? formStateRef.current.errors : {},
        isSubmitting: false,
        isSubmitSuccessful: false
      });
    };

    var reset = function reset(values) {
      var omitResetState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (isWeb) {
        for (var _i11 = 0, _Object$values3 = Object.values(fieldsRef.current); _i11 < _Object$values3.length; _i11++) {
          var field = _Object$values3[_i11];

          if (field) {
            var _ref389 = field.ref,
                options = field.options;
            var inputRef = isRadioOrCheckboxFunction(_ref389) && Array.isArray(options) ? options[0].ref : _ref389;

            if (isHTMLElement(inputRef)) {
              try {
                inputRef.closest('form').reset();
                break;
              } catch (_a) {}
            }
          }
        }
      }

      fieldsRef.current = {};
      defaultValuesRef.current = Object.assign({}, values || defaultValuesRef.current);
      values && renderWatchedInputs('');
      Object.values(resetFieldArrayFunctionRef.current).forEach(function (resetFieldArray) {
        return isFunction$1(resetFieldArray) && resetFieldArray();
      });
      shallowFieldsStateRef.current = shouldUnregister ? {} : cloneObject(values || defaultValuesRef.current);
      resetRefs(omitResetState);
    };

    React.useEffect(function () {
      resolver && readFormStateRef.current.isValid && validateResolver();
      observerRef.current = observerRef.current || !isWeb ? observerRef.current : onDomRemove(fieldsRef, removeFieldEventListenerAndRef);
    }, [removeFieldEventListenerAndRef, defaultValuesRef.current]);
    React.useEffect(function () {
      return function () {
        observerRef.current && observerRef.current.disconnect();
        isUnMount.current = true;

        if (process.env.NODE_ENV !== 'production') {
          return;
        }

        Object.values(fieldsRef.current).forEach(function (field) {
          return removeFieldEventListenerAndRef(field, true);
        });
      };
    }, []);

    if (!resolver && readFormStateRef.current.isValid) {
      formState.isValid = deepEqual(validFieldsRef.current, fieldsWithValidationRef.current) && isEmptyObject(formStateRef.current.errors);
    }

    var commonProps = {
      trigger: trigger,
      setValue: React.useCallback(setValue, [setInternalValue, trigger]),
      getValues: React.useCallback(getValues, []),
      register: React.useCallback(register, [defaultValuesRef.current]),
      unregister: React.useCallback(unregister, []),
      formState: isProxyEnabled ? new Proxy(formState, {
        get: function get(obj, prop) {
          if (process.env.NODE_ENV !== 'production') {
            if (prop === 'isValid' && isOnSubmit) {
              console.warn('📋 `formState.isValid` is applicable with `onTouched`, `onChange` or `onBlur` mode. https://react-hook-form.com/api#formState');
            }
          }

          if (prop in obj) {
            readFormStateRef.current[prop] = true;
            return obj[prop];
          }

          return undefined;
        }
      }) : formState
    };
    var control = React.useMemo(function () {
      return Object.assign({
        isFormDirty: isFormDirty,
        updateWatchedValue: updateWatchedValue,
        shouldUnregister: shouldUnregister,
        updateFormState: updateFormState,
        removeFieldEventListener: removeFieldEventListener,
        watchInternal: watchInternal,
        mode: modeRef.current,
        reValidateMode: {
          isReValidateOnBlur: isReValidateOnBlur,
          isReValidateOnChange: isReValidateOnChange
        },
        validateResolver: resolver ? validateResolver : undefined,
        fieldsRef: fieldsRef,
        resetFieldArrayFunctionRef: resetFieldArrayFunctionRef,
        useWatchFieldsRef: useWatchFieldsRef,
        useWatchRenderFunctionsRef: useWatchRenderFunctionsRef,
        fieldArrayDefaultValuesRef: fieldArrayDefaultValuesRef,
        validFieldsRef: validFieldsRef,
        fieldsWithValidationRef: fieldsWithValidationRef,
        fieldArrayNamesRef: fieldArrayNamesRef,
        readFormStateRef: readFormStateRef,
        formStateRef: formStateRef,
        defaultValuesRef: defaultValuesRef,
        shallowFieldsStateRef: shallowFieldsStateRef,
        fieldArrayValuesRef: fieldArrayValuesRef
      }, commonProps);
    }, [defaultValuesRef.current, updateWatchedValue, shouldUnregister, removeFieldEventListener, watchInternal]);
    return Object.assign({
      watch: watch,
      control: control,
      handleSubmit: handleSubmit,
      reset: React.useCallback(reset, []),
      clearErrors: React.useCallback(clearErrors, []),
      setError: React.useCallback(setError, []),
      errors: formState.errors
    }, commonProps);
  }
  /*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
    Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** */


  function __rest(s, e) {
    var t = {};

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }

    if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
  }

  var FormContext = React.createContext(null);
  FormContext.displayName = 'RHFContext';

  var useFormContext = function useFormContext() {
    return React.useContext(FormContext);
  };

  var getInputValue = function getInputValue(event) {
    return isPrimitive(event) || !isObject$6(event.target) || isObject$6(event.target) && !event.type ? event : isUndefined(event.target.value) ? event.target.checked : event.target.value;
  };

  function useController(_ref390) {
    var name = _ref390.name,
        rules = _ref390.rules,
        defaultValue = _ref390.defaultValue,
        control = _ref390.control,
        onFocus = _ref390.onFocus;
    var methods = useFormContext();

    if (process.env.NODE_ENV !== 'production') {
      if (!control && !methods) {
        throw new Error('📋 Controller is missing `control` prop. https://react-hook-form.com/api#Controller');
      }
    }

    var _ref391 = control || methods.control,
        defaultValuesRef = _ref391.defaultValuesRef,
        setValue = _ref391.setValue,
        register = _ref391.register,
        unregister = _ref391.unregister,
        trigger = _ref391.trigger,
        mode = _ref391.mode,
        _ref391$reValidateMod = _ref391.reValidateMode,
        isReValidateOnBlur = _ref391$reValidateMod.isReValidateOnBlur,
        isReValidateOnChange = _ref391$reValidateMod.isReValidateOnChange,
        formState = _ref391.formState,
        _ref391$formStateRef$ = _ref391.formStateRef.current,
        isSubmitted = _ref391$formStateRef$.isSubmitted,
        touched = _ref391$formStateRef$.touched,
        errors = _ref391$formStateRef$.errors,
        updateFormState = _ref391.updateFormState,
        readFormStateRef = _ref391.readFormStateRef,
        fieldsRef = _ref391.fieldsRef,
        fieldArrayNamesRef = _ref391.fieldArrayNamesRef,
        shallowFieldsStateRef = _ref391.shallowFieldsStateRef;

    var isNotFieldArray = !isNameInFieldArray(fieldArrayNamesRef.current, name);

    var getInitialValue = function getInitialValue() {
      return !isUndefined(get$1(shallowFieldsStateRef.current, name)) && isNotFieldArray ? get$1(shallowFieldsStateRef.current, name) : isUndefined(defaultValue) ? get$1(defaultValuesRef.current, name) : defaultValue;
    };

    var _React$useState3 = React.useState(getInitialValue()),
        _React$useState4 = _slicedToArray(_React$useState3, 2),
        value = _React$useState4[0],
        setInputStateValue = _React$useState4[1];

    var valueRef = React.useRef(value);
    var ref = React.useRef({
      focus: function focus() {
        return null;
      }
    });
    var onFocusRef = React.useRef(onFocus || function () {
      if (isFunction$1(ref.current.focus)) {
        ref.current.focus();
      }

      if (process.env.NODE_ENV !== 'production') {
        if (!isFunction$1(ref.current.focus)) {
          console.warn("\uD83D\uDCCB 'ref' from Controller render prop must be attached to a React component or a DOM Element whose ref provides a 'focus()' method");
        }
      }
    });
    var shouldValidate = React.useCallback(function (isBlurEvent) {
      return !skipValidation(Object.assign({
        isBlurEvent: isBlurEvent,
        isReValidateOnBlur: isReValidateOnBlur,
        isReValidateOnChange: isReValidateOnChange,
        isSubmitted: isSubmitted,
        isTouched: !!get$1(touched, name)
      }, mode));
    }, [isReValidateOnBlur, isReValidateOnChange, isSubmitted, touched, name, mode]);
    var commonTask = React.useCallback(function (_ref392) {
      var _ref393 = _slicedToArray(_ref392, 1),
          event = _ref393[0];

      var data = getInputValue(event);
      setInputStateValue(data);
      valueRef.current = data;
      return data;
    }, []);
    var registerField = React.useCallback(function (shouldUpdateValue) {
      if (process.env.NODE_ENV !== 'production') {
        if (!name) {
          return console.warn('📋 Field is missing `name` prop. https://react-hook-form.com/api#Controller');
        }
      }

      if (fieldsRef.current[name]) {
        fieldsRef.current[name] = Object.assign({
          ref: fieldsRef.current[name].ref
        }, rules);
      } else {
        register(Object.defineProperties({
          name: name,
          focus: onFocusRef.current
        }, {
          value: {
            set: function set(data) {
              setInputStateValue(data);
              valueRef.current = data;
            },
            get: function get() {
              return valueRef.current;
            }
          }
        }), rules);
        shouldUpdateValue = isUndefined(get$1(defaultValuesRef.current, name));
      }

      shouldUpdateValue && isNotFieldArray && setInputStateValue(getInitialValue());
    }, [rules, name, register]);
    React.useEffect(function () {
      return function () {
        return unregister(name);
      };
    }, [name]);
    React.useEffect(function () {
      if (process.env.NODE_ENV !== 'production') {
        if (isUndefined(value)) {
          console.warn("\uD83D\uDCCB ".concat(name, " is missing in the 'defaultValue' prop of either its Controller (https://react-hook-form.com/api#Controller) or useForm (https://react-hook-form.com/api#useForm)"));
        }

        if (!isNotFieldArray && isUndefined(defaultValue)) {
          console.warn('📋 Controller is missing `defaultValue` prop when using `useFieldArray`. https://react-hook-form.com/api#Controller');
        }
      }

      registerField();
    }, [registerField]);
    React.useEffect(function () {
      !fieldsRef.current[name] && registerField(true);
    });
    var onBlur = React.useCallback(function () {
      if (readFormStateRef.current.touched && !get$1(touched, name)) {
        set(touched, name, true);
        updateFormState({
          touched: touched
        });
      }

      shouldValidate(true) && trigger(name);
    }, [name, updateFormState, shouldValidate, trigger, readFormStateRef]);
    var onChange = React.useCallback(function () {
      for (var _len25 = arguments.length, event = new Array(_len25), _key26 = 0; _key26 < _len25; _key26++) {
        event[_key26] = arguments[_key26];
      }

      return setValue(name, commonTask(event), {
        shouldValidate: shouldValidate(),
        shouldDirty: true
      });
    }, [setValue, name, shouldValidate]);
    return {
      field: {
        onChange: onChange,
        onBlur: onBlur,
        name: name,
        value: value,
        ref: ref
      },
      meta: Object.defineProperties({
        invalid: !!get$1(errors, name)
      }, {
        isDirty: {
          get: function get() {
            return !!get$1(formState.dirtyFields, name);
          }
        },
        isTouched: {
          get: function get() {
            return !!get$1(formState.touched, name);
          }
        }
      })
    };
  }

  var Controller$1 = function Controller$1(props) {
    var rules = props.rules,
        as = props.as,
        render = props.render,
        defaultValue = props.defaultValue,
        control = props.control,
        onFocus = props.onFocus,
        rest = __rest(props, ["rules", "as", "render", "defaultValue", "control", "onFocus"]);

    var _useController = useController(props),
        field = _useController.field,
        meta = _useController.meta;

    var componentProps = Object.assign(Object.assign({}, rest), field);
    return as ? React.isValidElement(as) ? React.cloneElement(as, componentProps) : React.createElement(as, componentProps) : render ? render(field, meta) : null;
  };

  var Controller = React__namespace.forwardRef(function (props, ref) {
    return React__namespace.createElement(Controller$1, _assign2({
      "data-component-name": "Controller",
      "data-component-library": "generic",
      className: classNames('ds-generic-react-Controller'),
      inputRef: ref
    }, props));
  });

  var FormControl = function FormControl(props) {
    var className = props.className,
        otherProps = __rest$1(props, ["className"]);

    var dataAttributes = generateComponentDataAttributes('FormControl', className);
    return React__namespace.createElement(BaseFormControl, _assign2({}, dataAttributes, otherProps));
  };

  var FormControlLabel = function FormControlLabel(props) {
    var className = props.className,
        otherProps = __rest$1(props, ["className"]);

    var dataAttributes = generateComponentDataAttributes('FormControlLabel', className);
    return React__namespace.createElement(BaseFormControlLabel, _assign2({}, dataAttributes, otherProps));
  };

  var FormGroup = function FormGroup(props) {
    var className = props.className,
        otherProps = __rest$1(props, ["className"]);

    var dataAttributes = generateComponentDataAttributes('FormControl', className);
    return React__namespace.createElement(BaseFormGroup, _assign2({}, dataAttributes, otherProps));
  };

  var FormHelperText = function FormHelperText(props) {
    var className = props.className,
        _a = props.variant,
        variant = _a === void 0 ? 'standard' : _a,
        otherProps = __rest$1(props, ["className", "variant"]);

    var dataAttributes = generateComponentDataAttributes('FormHelperText', className);
    return React__namespace.createElement(BaseFormHelperText, _assign2({
      variant: variant
    }, dataAttributes, otherProps));
  };

  var FormLabel = function FormLabel(props) {
    var className = props.className,
        otherProps = __rest$1(props, ["className"]);

    var dataAttributes = generateComponentDataAttributes('FormLabel', className);
    return React__namespace.createElement(BaseFormLabel, _assign2({}, dataAttributes, otherProps));
  };

  var InputLabel = function InputLabel(props) {
    var className = props.className,
        _a = props.variant,
        variant = _a === void 0 ? 'standard' : _a,
        otherProps = __rest$1(props, ["className", "variant"]);

    var dataAttributes = generateComponentDataAttributes('InputLabel', className);
    return React__namespace.createElement(BaseInputLabel, _assign2({}, dataAttributes, {
      variant: variant
    }, otherProps));
  };

  function r$1() {
    return (r$1 = Object.assign || function (e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = arguments[r];

        for (var n in t) {
          Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  }

  var t$1 = function t$1(t, n) {
    return void 0 === n && (n = {
      abortEarly: !1
    }), function (o, a, s) {
      void 0 === s && (s = !1);

      try {
        return Promise.resolve(function (e, s) {
          try {
            var c = (n.context && "development" === process.env.NODE_ENV && console.warn("You should not used the yup options context. Please, use the 'useForm' context object instead"), Promise.resolve(t.validate(o, r$1({}, n, {
              context: a
            }))).then(function (e) {
              return {
                values: e,
                errors: {}
              };
            }));
          } catch (e) {
            return s(e);
          }

          return c && c.then ? c.then(void 0, s) : c;
        }(0, function (t) {
          var n = function (e, t) {
            var n;
            return Array.isArray(e.inner) && e.inner.length ? e.inner.reduce(function (e, n) {
              var o,
                  a,
                  s = n.path,
                  c = n.message,
                  u = n.type,
                  i = e[s] && e[s].types || {},
                  p = s || u;
              return r$1({}, e, p ? ((a = {})[p] = r$1({}, e[p] || {
                message: c,
                type: u
              }, t ? {
                types: r$1({}, i, (o = {}, o[u] = i[u] ? [].concat([].concat(i[u]), [c]) : c, o))
              } : {}), a) : {});
            }, {}) : ((n = {})[e.path] = {
              message: e.message,
              type: e.type
            }, n);
          }(t, s);

          return {
            values: {},
            errors: transformToNestObject(n)
          };
        }));
      } catch (e) {
        return Promise.reject(e);
      }
    };
  };

  var hookformResolver = t$1;

  function _defineProperties$1(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass$1(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties$1(Constructor, staticProps);
    return Constructor;
  }
  /** Used for built-in method references. */


  var objectProto$f = Object.prototype;
  /** Used to check objects for own properties. */

  var hasOwnProperty$c = objectProto$f.hasOwnProperty;
  /**
   * The base implementation of `_.has` without support for deep paths.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {Array|string} key The key to check.
   * @returns {boolean} Returns `true` if `key` exists, else `false`.
   */

  function baseHas(object, key) {
    return object != null && hasOwnProperty$c.call(object, key);
  }
  /**
   * Checks if `value` is classified as an `Array` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an array, else `false`.
   * @example
   *
   * _.isArray([1, 2, 3]);
   * // => true
   *
   * _.isArray(document.body.children);
   * // => false
   *
   * _.isArray('abc');
   * // => false
   *
   * _.isArray(_.noop);
   * // => false
   */


  var isArray = Array.isArray;
  var isArray$1 = isArray;
  /** Detect free variable `global` from Node.js. */

  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
  var freeGlobal$1 = freeGlobal;
  /** Detect free variable `self`. */

  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
  /** Used as a reference to the global object. */

  var root = freeGlobal$1 || freeSelf || Function('return this')();
  var root$1 = root;
  /** Built-in value references. */

  var Symbol$1 = root$1.Symbol;
  var Symbol$2 = Symbol$1;
  /** Used for built-in method references. */

  var objectProto$e = Object.prototype;
  /** Used to check objects for own properties. */

  var hasOwnProperty$b = objectProto$e.hasOwnProperty;
  /**
   * Used to resolve the
   * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
   * of values.
   */

  var nativeObjectToString$1 = objectProto$e.toString;
  /** Built-in value references. */

  var symToStringTag$1 = Symbol$2 ? Symbol$2.toStringTag : undefined;
  /**
   * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the raw `toStringTag`.
   */

  function getRawTag(value) {
    var isOwn = hasOwnProperty$b.call(value, symToStringTag$1),
        tag = value[symToStringTag$1];

    try {
      value[symToStringTag$1] = undefined;
      var unmasked = true;
    } catch (e) {}

    var result = nativeObjectToString$1.call(value);

    if (unmasked) {
      if (isOwn) {
        value[symToStringTag$1] = tag;
      } else {
        delete value[symToStringTag$1];
      }
    }

    return result;
  }
  /** Used for built-in method references. */


  var objectProto$d = Object.prototype;
  /**
   * Used to resolve the
   * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
   * of values.
   */

  var nativeObjectToString = objectProto$d.toString;
  /**
   * Converts `value` to a string using `Object.prototype.toString`.
   *
   * @private
   * @param {*} value The value to convert.
   * @returns {string} Returns the converted string.
   */

  function objectToString(value) {
    return nativeObjectToString.call(value);
  }
  /** `Object#toString` result references. */


  var nullTag = '[object Null]',
      undefinedTag = '[object Undefined]';
  /** Built-in value references. */

  var symToStringTag = Symbol$2 ? Symbol$2.toStringTag : undefined;
  /**
   * The base implementation of `getTag` without fallbacks for buggy environments.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the `toStringTag`.
   */

  function baseGetTag(value) {
    if (value == null) {
      return value === undefined ? undefinedTag : nullTag;
    }

    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
  }
  /**
   * Checks if `value` is object-like. A value is object-like if it's not `null`
   * and has a `typeof` result of "object".
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
   * @example
   *
   * _.isObjectLike({});
   * // => true
   *
   * _.isObjectLike([1, 2, 3]);
   * // => true
   *
   * _.isObjectLike(_.noop);
   * // => false
   *
   * _.isObjectLike(null);
   * // => false
   */


  function isObjectLike(value) {
    return value != null && typeof value == 'object';
  }
  /** `Object#toString` result references. */


  var symbolTag$3 = '[object Symbol]';
  /**
   * Checks if `value` is classified as a `Symbol` primitive or object.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
   * @example
   *
   * _.isSymbol(Symbol.iterator);
   * // => true
   *
   * _.isSymbol('abc');
   * // => false
   */

  function isSymbol(value) {
    return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag$3;
  }
  /** Used to match property names within property paths. */


  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/;
  /**
   * Checks if `value` is a property name and not a property path.
   *
   * @private
   * @param {*} value The value to check.
   * @param {Object} [object] The object to query keys on.
   * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
   */

  function isKey(value, object) {
    if (isArray$1(value)) {
      return false;
    }

    var type = typeof value;

    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) {
      return true;
    }

    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
  }
  /**
   * Checks if `value` is the
   * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
   * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an object, else `false`.
   * @example
   *
   * _.isObject({});
   * // => true
   *
   * _.isObject([1, 2, 3]);
   * // => true
   *
   * _.isObject(_.noop);
   * // => true
   *
   * _.isObject(null);
   * // => false
   */


  function isObject$5(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
  }
  /** `Object#toString` result references. */


  var asyncTag = '[object AsyncFunction]',
      funcTag$2 = '[object Function]',
      genTag$1 = '[object GeneratorFunction]',
      proxyTag = '[object Proxy]';
  /**
   * Checks if `value` is classified as a `Function` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a function, else `false`.
   * @example
   *
   * _.isFunction(_);
   * // => true
   *
   * _.isFunction(/abc/);
   * // => false
   */

  function isFunction(value) {
    if (!isObject$5(value)) {
      return false;
    } // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.


    var tag = baseGetTag(value);
    return tag == funcTag$2 || tag == genTag$1 || tag == asyncTag || tag == proxyTag;
  }
  /** Used to detect overreaching core-js shims. */


  var coreJsData = root$1['__core-js_shared__'];
  var coreJsData$1 = coreJsData;
  /** Used to detect methods masquerading as native. */

  var maskSrcKey = function () {
    var uid = /[^.]+$/.exec(coreJsData$1 && coreJsData$1.keys && coreJsData$1.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
  }();
  /**
   * Checks if `func` has its source masked.
   *
   * @private
   * @param {Function} func The function to check.
   * @returns {boolean} Returns `true` if `func` is masked, else `false`.
   */


  function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
  }
  /** Used for built-in method references. */


  var funcProto$1 = Function.prototype;
  /** Used to resolve the decompiled source of functions. */

  var funcToString$1 = funcProto$1.toString;
  /**
   * Converts `func` to its source code.
   *
   * @private
   * @param {Function} func The function to convert.
   * @returns {string} Returns the source code.
   */

  function toSource(func) {
    if (func != null) {
      try {
        return funcToString$1.call(func);
      } catch (e) {}

      try {
        return func + '';
      } catch (e) {}
    }

    return '';
  }
  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */


  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
  /** Used to detect host constructors (Safari). */

  var reIsHostCtor = /^\[object .+?Constructor\]$/;
  /** Used for built-in method references. */

  var funcProto = Function.prototype,
      objectProto$c = Object.prototype;
  /** Used to resolve the decompiled source of functions. */

  var funcToString = funcProto.toString;
  /** Used to check objects for own properties. */

  var hasOwnProperty$a = objectProto$c.hasOwnProperty;
  /** Used to detect if a method is native. */

  var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty$a).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
  /**
   * The base implementation of `_.isNative` without bad shim checks.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a native function,
   *  else `false`.
   */

  function baseIsNative(value) {
    if (!isObject$5(value) || isMasked(value)) {
      return false;
    }

    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
  }
  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */


  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }
  /**
   * Gets the native function at `key` of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {string} key The key of the method to get.
   * @returns {*} Returns the function if it's native, else `undefined`.
   */


  function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
  }
  /* Built-in method references that are verified to be native. */


  var nativeCreate = getNative(Object, 'create');
  var nativeCreate$1 = nativeCreate;
  /**
   * Removes all key-value entries from the hash.
   *
   * @private
   * @name clear
   * @memberOf Hash
   */

  function hashClear() {
    this.__data__ = nativeCreate$1 ? nativeCreate$1(null) : {};
    this.size = 0;
  }
  /**
   * Removes `key` and its value from the hash.
   *
   * @private
   * @name delete
   * @memberOf Hash
   * @param {Object} hash The hash to modify.
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */


  function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
  }
  /** Used to stand-in for `undefined` hash values. */


  var HASH_UNDEFINED$2 = '__lodash_hash_undefined__';
  /** Used for built-in method references. */

  var objectProto$b = Object.prototype;
  /** Used to check objects for own properties. */

  var hasOwnProperty$9 = objectProto$b.hasOwnProperty;
  /**
   * Gets the hash value for `key`.
   *
   * @private
   * @name get
   * @memberOf Hash
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */

  function hashGet(key) {
    var data = this.__data__;

    if (nativeCreate$1) {
      var result = data[key];
      return result === HASH_UNDEFINED$2 ? undefined : result;
    }

    return hasOwnProperty$9.call(data, key) ? data[key] : undefined;
  }
  /** Used for built-in method references. */


  var objectProto$a = Object.prototype;
  /** Used to check objects for own properties. */

  var hasOwnProperty$8 = objectProto$a.hasOwnProperty;
  /**
   * Checks if a hash value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf Hash
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */

  function hashHas(key) {
    var data = this.__data__;
    return nativeCreate$1 ? data[key] !== undefined : hasOwnProperty$8.call(data, key);
  }
  /** Used to stand-in for `undefined` hash values. */


  var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';
  /**
   * Sets the hash `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf Hash
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the hash instance.
   */

  function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate$1 && value === undefined ? HASH_UNDEFINED$1 : value;
    return this;
  }
  /**
   * Creates a hash object.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */


  function Hash(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;
    this.clear();

    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  } // Add methods to `Hash`.


  Hash.prototype.clear = hashClear;
  Hash.prototype['delete'] = hashDelete;
  Hash.prototype.get = hashGet;
  Hash.prototype.has = hashHas;
  Hash.prototype.set = hashSet;
  /**
   * Removes all key-value entries from the list cache.
   *
   * @private
   * @name clear
   * @memberOf ListCache
   */

  function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
  }
  /**
   * Performs a
   * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
   * comparison between two values to determine if they are equivalent.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
   * @example
   *
   * var object = { 'a': 1 };
   * var other = { 'a': 1 };
   *
   * _.eq(object, object);
   * // => true
   *
   * _.eq(object, other);
   * // => false
   *
   * _.eq('a', 'a');
   * // => true
   *
   * _.eq('a', Object('a'));
   * // => false
   *
   * _.eq(NaN, NaN);
   * // => true
   */


  function eq$1(value, other) {
    return value === other || value !== value && other !== other;
  }
  /**
   * Gets the index at which the `key` is found in `array` of key-value pairs.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} key The key to search for.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */


  function assocIndexOf(array, key) {
    var length = array.length;

    while (length--) {
      if (eq$1(array[length][0], key)) {
        return length;
      }
    }

    return -1;
  }
  /** Used for built-in method references. */


  var arrayProto = Array.prototype;
  /** Built-in value references. */

  var splice = arrayProto.splice;
  /**
   * Removes `key` and its value from the list cache.
   *
   * @private
   * @name delete
   * @memberOf ListCache
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */

  function listCacheDelete(key) {
    var data = this.__data__,
        index = assocIndexOf(data, key);

    if (index < 0) {
      return false;
    }

    var lastIndex = data.length - 1;

    if (index == lastIndex) {
      data.pop();
    } else {
      splice.call(data, index, 1);
    }

    --this.size;
    return true;
  }
  /**
   * Gets the list cache value for `key`.
   *
   * @private
   * @name get
   * @memberOf ListCache
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */


  function listCacheGet(key) {
    var data = this.__data__,
        index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
  }
  /**
   * Checks if a list cache value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf ListCache
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */


  function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
  }
  /**
   * Sets the list cache `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf ListCache
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the list cache instance.
   */


  function listCacheSet(key, value) {
    var data = this.__data__,
        index = assocIndexOf(data, key);

    if (index < 0) {
      ++this.size;
      data.push([key, value]);
    } else {
      data[index][1] = value;
    }

    return this;
  }
  /**
   * Creates an list cache object.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */


  function ListCache(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;
    this.clear();

    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  } // Add methods to `ListCache`.


  ListCache.prototype.clear = listCacheClear;
  ListCache.prototype['delete'] = listCacheDelete;
  ListCache.prototype.get = listCacheGet;
  ListCache.prototype.has = listCacheHas;
  ListCache.prototype.set = listCacheSet;
  /* Built-in method references that are verified to be native. */

  var Map$1 = getNative(root$1, 'Map');
  var Map$2 = Map$1;
  /**
   * Removes all key-value entries from the map.
   *
   * @private
   * @name clear
   * @memberOf MapCache
   */

  function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
      'hash': new Hash(),
      'map': new (Map$2 || ListCache)(),
      'string': new Hash()
    };
  }
  /**
   * Checks if `value` is suitable for use as unique object key.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
   */


  function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
  }
  /**
   * Gets the data for `map`.
   *
   * @private
   * @param {Object} map The map to query.
   * @param {string} key The reference key.
   * @returns {*} Returns the map data.
   */


  function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
  }
  /**
   * Removes `key` and its value from the map.
   *
   * @private
   * @name delete
   * @memberOf MapCache
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */


  function mapCacheDelete(key) {
    var result = getMapData(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
  }
  /**
   * Gets the map value for `key`.
   *
   * @private
   * @name get
   * @memberOf MapCache
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */


  function mapCacheGet(key) {
    return getMapData(this, key).get(key);
  }
  /**
   * Checks if a map value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf MapCache
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */


  function mapCacheHas(key) {
    return getMapData(this, key).has(key);
  }
  /**
   * Sets the map `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf MapCache
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the map cache instance.
   */


  function mapCacheSet(key, value) {
    var data = getMapData(this, key),
        size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
  }
  /**
   * Creates a map cache object to store key-value pairs.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */


  function MapCache(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;
    this.clear();

    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  } // Add methods to `MapCache`.


  MapCache.prototype.clear = mapCacheClear;
  MapCache.prototype['delete'] = mapCacheDelete;
  MapCache.prototype.get = mapCacheGet;
  MapCache.prototype.has = mapCacheHas;
  MapCache.prototype.set = mapCacheSet;
  /** Error message constants. */

  var FUNC_ERROR_TEXT = 'Expected a function';
  /**
   * Creates a function that memoizes the result of `func`. If `resolver` is
   * provided, it determines the cache key for storing the result based on the
   * arguments provided to the memoized function. By default, the first argument
   * provided to the memoized function is used as the map cache key. The `func`
   * is invoked with the `this` binding of the memoized function.
   *
   * **Note:** The cache is exposed as the `cache` property on the memoized
   * function. Its creation may be customized by replacing the `_.memoize.Cache`
   * constructor with one whose instances implement the
   * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
   * method interface of `clear`, `delete`, `get`, `has`, and `set`.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Function
   * @param {Function} func The function to have its output memoized.
   * @param {Function} [resolver] The function to resolve the cache key.
   * @returns {Function} Returns the new memoized function.
   * @example
   *
   * var object = { 'a': 1, 'b': 2 };
   * var other = { 'c': 3, 'd': 4 };
   *
   * var values = _.memoize(_.values);
   * values(object);
   * // => [1, 2]
   *
   * values(other);
   * // => [3, 4]
   *
   * object.a = 2;
   * values(object);
   * // => [1, 2]
   *
   * // Modify the result cache.
   * values.cache.set(object, ['a', 'b']);
   * values(object);
   * // => ['a', 'b']
   *
   * // Replace `_.memoize.Cache`.
   * _.memoize.Cache = WeakMap;
   */

  function memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') {
      throw new TypeError(FUNC_ERROR_TEXT);
    }

    var memoized = function memoized() {
      var args = arguments,
          key = resolver ? resolver.apply(this, args) : args[0],
          cache = memoized.cache;

      if (cache.has(key)) {
        return cache.get(key);
      }

      var result = func.apply(this, args);
      memoized.cache = cache.set(key, result) || cache;
      return result;
    };

    memoized.cache = new (memoize.Cache || MapCache)();
    return memoized;
  } // Expose `MapCache`.


  memoize.Cache = MapCache;
  /** Used as the maximum memoize cache size. */

  var MAX_MEMOIZE_SIZE = 500;
  /**
   * A specialized version of `_.memoize` which clears the memoized function's
   * cache when it exceeds `MAX_MEMOIZE_SIZE`.
   *
   * @private
   * @param {Function} func The function to have its output memoized.
   * @returns {Function} Returns the new memoized function.
   */

  function memoizeCapped(func) {
    var result = memoize(func, function (key) {
      if (cache.size === MAX_MEMOIZE_SIZE) {
        cache.clear();
      }

      return key;
    });
    var cache = result.cache;
    return result;
  }
  /** Used to match property names within property paths. */


  var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
  /** Used to match backslashes in property paths. */

  var reEscapeChar = /\\(\\)?/g;
  /**
   * Converts `string` to a property path array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the property path array.
   */

  var stringToPath = memoizeCapped(function (string) {
    var result = [];

    if (string.charCodeAt(0) === 46
    /* . */
    ) {
      result.push('');
    }

    string.replace(rePropName, function (match, number, quote, subString) {
      result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
    });
    return result;
  });
  var stringToPath$1 = stringToPath;
  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */

  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }

    return result;
  }
  /** Used as references for various `Number` constants. */


  var INFINITY$1 = 1 / 0;
  /** Used to convert symbols to primitives and strings. */

  var symbolProto$2 = Symbol$2 ? Symbol$2.prototype : undefined,
      symbolToString$1 = symbolProto$2 ? symbolProto$2.toString : undefined;
  /**
   * The base implementation of `_.toString` which doesn't convert nullish
   * values to empty strings.
   *
   * @private
   * @param {*} value The value to process.
   * @returns {string} Returns the string.
   */

  function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') {
      return value;
    }

    if (isArray$1(value)) {
      // Recursively convert values (susceptible to call stack limits).
      return arrayMap(value, baseToString) + '';
    }

    if (isSymbol(value)) {
      return symbolToString$1 ? symbolToString$1.call(value) : '';
    }

    var result = value + '';
    return result == '0' && 1 / value == -INFINITY$1 ? '-0' : result;
  }
  /**
   * Converts `value` to a string. An empty string is returned for `null`
   * and `undefined` values. The sign of `-0` is preserved.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to convert.
   * @returns {string} Returns the converted string.
   * @example
   *
   * _.toString(null);
   * // => ''
   *
   * _.toString(-0);
   * // => '-0'
   *
   * _.toString([1, 2, 3]);
   * // => '1,2,3'
   */


  function toString$1(value) {
    return value == null ? '' : baseToString(value);
  }
  /**
   * Casts `value` to a path array if it's not one.
   *
   * @private
   * @param {*} value The value to inspect.
   * @param {Object} [object] The object to query keys on.
   * @returns {Array} Returns the cast property path array.
   */


  function castPath(value, object) {
    if (isArray$1(value)) {
      return value;
    }

    return isKey(value, object) ? [value] : stringToPath$1(toString$1(value));
  }
  /** `Object#toString` result references. */


  var argsTag$3 = '[object Arguments]';
  /**
   * The base implementation of `_.isArguments`.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an `arguments` object,
   */

  function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag$3;
  }
  /** Used for built-in method references. */


  var objectProto$9 = Object.prototype;
  /** Used to check objects for own properties. */

  var hasOwnProperty$7 = objectProto$9.hasOwnProperty;
  /** Built-in value references. */

  var propertyIsEnumerable$1 = objectProto$9.propertyIsEnumerable;
  /**
   * Checks if `value` is likely an `arguments` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an `arguments` object,
   *  else `false`.
   * @example
   *
   * _.isArguments(function() { return arguments; }());
   * // => true
   *
   * _.isArguments([1, 2, 3]);
   * // => false
   */

  var isArguments = baseIsArguments(function () {
    return arguments;
  }()) ? baseIsArguments : function (value) {
    return isObjectLike(value) && hasOwnProperty$7.call(value, 'callee') && !propertyIsEnumerable$1.call(value, 'callee');
  };
  var isArguments$1 = isArguments;
  /** Used as references for various `Number` constants. */

  var MAX_SAFE_INTEGER$1 = 9007199254740991;
  /** Used to detect unsigned integer values. */

  var reIsUint = /^(?:0|[1-9]\d*)$/;
  /**
   * Checks if `value` is a valid array-like index.
   *
   * @private
   * @param {*} value The value to check.
   * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
   * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
   */

  function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER$1 : length;
    return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
  }
  /** Used as references for various `Number` constants. */


  var MAX_SAFE_INTEGER = 9007199254740991;
  /**
   * Checks if `value` is a valid array-like length.
   *
   * **Note:** This method is loosely based on
   * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
   * @example
   *
   * _.isLength(3);
   * // => true
   *
   * _.isLength(Number.MIN_VALUE);
   * // => false
   *
   * _.isLength(Infinity);
   * // => false
   *
   * _.isLength('3');
   * // => false
   */

  function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
  }
  /** Used as references for various `Number` constants. */


  var INFINITY = 1 / 0;
  /**
   * Converts `value` to a string key if it's not a string or symbol.
   *
   * @private
   * @param {*} value The value to inspect.
   * @returns {string|symbol} Returns the key.
   */

  function toKey(value) {
    if (typeof value == 'string' || isSymbol(value)) {
      return value;
    }

    var result = value + '';
    return result == '0' && 1 / value == -INFINITY ? '-0' : result;
  }
  /**
   * Checks if `path` exists on `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array|string} path The path to check.
   * @param {Function} hasFunc The function to check properties.
   * @returns {boolean} Returns `true` if `path` exists, else `false`.
   */


  function hasPath(object, path, hasFunc) {
    path = castPath(path, object);
    var index = -1,
        length = path.length,
        result = false;

    while (++index < length) {
      var key = toKey(path[index]);

      if (!(result = object != null && hasFunc(object, key))) {
        break;
      }

      object = object[key];
    }

    if (result || ++index != length) {
      return result;
    }

    length = object == null ? 0 : object.length;
    return !!length && isLength(length) && isIndex(key, length) && (isArray$1(object) || isArguments$1(object));
  }
  /**
   * Checks if `path` is a direct property of `object`.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Object
   * @param {Object} object The object to query.
   * @param {Array|string} path The path to check.
   * @returns {boolean} Returns `true` if `path` exists, else `false`.
   * @example
   *
   * var object = { 'a': { 'b': 2 } };
   * var other = _.create({ 'a': _.create({ 'b': 2 }) });
   *
   * _.has(object, 'a');
   * // => true
   *
   * _.has(object, 'a.b');
   * // => true
   *
   * _.has(object, ['a', 'b']);
   * // => true
   *
   * _.has(other, 'a');
   * // => false
   */


  function has(object, path) {
    return object != null && hasPath(object, path, baseHas);
  }
  /**
   * Removes all key-value entries from the stack.
   *
   * @private
   * @name clear
   * @memberOf Stack
   */


  function stackClear() {
    this.__data__ = new ListCache();
    this.size = 0;
  }
  /**
   * Removes `key` and its value from the stack.
   *
   * @private
   * @name delete
   * @memberOf Stack
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */


  function stackDelete(key) {
    var data = this.__data__,
        result = data['delete'](key);
    this.size = data.size;
    return result;
  }
  /**
   * Gets the stack value for `key`.
   *
   * @private
   * @name get
   * @memberOf Stack
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */


  function stackGet(key) {
    return this.__data__.get(key);
  }
  /**
   * Checks if a stack value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf Stack
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */


  function stackHas(key) {
    return this.__data__.has(key);
  }
  /** Used as the size to enable large array optimizations. */


  var LARGE_ARRAY_SIZE = 200;
  /**
   * Sets the stack `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf Stack
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the stack cache instance.
   */

  function stackSet(key, value) {
    var data = this.__data__;

    if (data instanceof ListCache) {
      var pairs = data.__data__;

      if (!Map$2 || pairs.length < LARGE_ARRAY_SIZE - 1) {
        pairs.push([key, value]);
        this.size = ++data.size;
        return this;
      }

      data = this.__data__ = new MapCache(pairs);
    }

    data.set(key, value);
    this.size = data.size;
    return this;
  }
  /**
   * Creates a stack cache object to store key-value pairs.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */


  function Stack$1(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
  } // Add methods to `Stack`.


  Stack$1.prototype.clear = stackClear;
  Stack$1.prototype['delete'] = stackDelete;
  Stack$1.prototype.get = stackGet;
  Stack$1.prototype.has = stackHas;
  Stack$1.prototype.set = stackSet;
  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */

  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }

    return array;
  }

  var defineProperty = function () {
    try {
      var func = getNative(Object, 'defineProperty');
      func({}, '', {});
      return func;
    } catch (e) {}
  }();

  var defineProperty$1 = defineProperty;
  /**
   * The base implementation of `assignValue` and `assignMergeValue` without
   * value checks.
   *
   * @private
   * @param {Object} object The object to modify.
   * @param {string} key The key of the property to assign.
   * @param {*} value The value to assign.
   */

  function baseAssignValue(object, key, value) {
    if (key == '__proto__' && defineProperty$1) {
      defineProperty$1(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
      });
    } else {
      object[key] = value;
    }
  }
  /** Used for built-in method references. */


  var objectProto$8 = Object.prototype;
  /** Used to check objects for own properties. */

  var hasOwnProperty$6 = objectProto$8.hasOwnProperty;
  /**
   * Assigns `value` to `key` of `object` if the existing value is not equivalent
   * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
   * for equality comparisons.
   *
   * @private
   * @param {Object} object The object to modify.
   * @param {string} key The key of the property to assign.
   * @param {*} value The value to assign.
   */

  function assignValue(object, key, value) {
    var objValue = object[key];

    if (!(hasOwnProperty$6.call(object, key) && eq$1(objValue, value)) || value === undefined && !(key in object)) {
      baseAssignValue(object, key, value);
    }
  }
  /**
   * Copies properties of `source` to `object`.
   *
   * @private
   * @param {Object} source The object to copy properties from.
   * @param {Array} props The property identifiers to copy.
   * @param {Object} [object={}] The object to copy properties to.
   * @param {Function} [customizer] The function to customize copied values.
   * @returns {Object} Returns `object`.
   */


  function copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1,
        length = props.length;

    while (++index < length) {
      var key = props[index];
      var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;

      if (newValue === undefined) {
        newValue = source[key];
      }

      if (isNew) {
        baseAssignValue(object, key, newValue);
      } else {
        assignValue(object, key, newValue);
      }
    }

    return object;
  }
  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */


  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }

    return result;
  }
  /**
   * This method returns `false`.
   *
   * @static
   * @memberOf _
   * @since 4.13.0
   * @category Util
   * @returns {boolean} Returns `false`.
   * @example
   *
   * _.times(2, _.stubFalse);
   * // => [false, false]
   */


  function stubFalse() {
    return false;
  }
  /** Detect free variable `exports`. */


  var freeExports$2 = typeof exports == 'object' && exports && !exports.nodeType && exports;
  /** Detect free variable `module`. */

  var freeModule$2 = freeExports$2 && typeof module == 'object' && module && !module.nodeType && module;
  /** Detect the popular CommonJS extension `module.exports`. */

  var moduleExports$2 = freeModule$2 && freeModule$2.exports === freeExports$2;
  /** Built-in value references. */

  var Buffer$1 = moduleExports$2 ? root$1.Buffer : undefined;
  /* Built-in method references for those with the same name as other `lodash` methods. */

  var nativeIsBuffer = Buffer$1 ? Buffer$1.isBuffer : undefined;
  /**
   * Checks if `value` is a buffer.
   *
   * @static
   * @memberOf _
   * @since 4.3.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
   * @example
   *
   * _.isBuffer(new Buffer(2));
   * // => true
   *
   * _.isBuffer(new Uint8Array(2));
   * // => false
   */

  var isBuffer = nativeIsBuffer || stubFalse;
  var isBuffer$1 = isBuffer;
  /** `Object#toString` result references. */

  var argsTag$2 = '[object Arguments]',
      arrayTag$2 = '[object Array]',
      boolTag$3 = '[object Boolean]',
      dateTag$3 = '[object Date]',
      errorTag$2 = '[object Error]',
      funcTag$1 = '[object Function]',
      mapTag$6 = '[object Map]',
      numberTag$3 = '[object Number]',
      objectTag$3 = '[object Object]',
      regexpTag$3 = '[object RegExp]',
      setTag$6 = '[object Set]',
      stringTag$4 = '[object String]',
      weakMapTag$2 = '[object WeakMap]';
  var arrayBufferTag$3 = '[object ArrayBuffer]',
      dataViewTag$4 = '[object DataView]',
      float32Tag$2 = '[object Float32Array]',
      float64Tag$2 = '[object Float64Array]',
      int8Tag$2 = '[object Int8Array]',
      int16Tag$2 = '[object Int16Array]',
      int32Tag$2 = '[object Int32Array]',
      uint8Tag$2 = '[object Uint8Array]',
      uint8ClampedTag$2 = '[object Uint8ClampedArray]',
      uint16Tag$2 = '[object Uint16Array]',
      uint32Tag$2 = '[object Uint32Array]';
  /** Used to identify `toStringTag` values of typed arrays. */

  var typedArrayTags = {};
  typedArrayTags[float32Tag$2] = typedArrayTags[float64Tag$2] = typedArrayTags[int8Tag$2] = typedArrayTags[int16Tag$2] = typedArrayTags[int32Tag$2] = typedArrayTags[uint8Tag$2] = typedArrayTags[uint8ClampedTag$2] = typedArrayTags[uint16Tag$2] = typedArrayTags[uint32Tag$2] = true;
  typedArrayTags[argsTag$2] = typedArrayTags[arrayTag$2] = typedArrayTags[arrayBufferTag$3] = typedArrayTags[boolTag$3] = typedArrayTags[dataViewTag$4] = typedArrayTags[dateTag$3] = typedArrayTags[errorTag$2] = typedArrayTags[funcTag$1] = typedArrayTags[mapTag$6] = typedArrayTags[numberTag$3] = typedArrayTags[objectTag$3] = typedArrayTags[regexpTag$3] = typedArrayTags[setTag$6] = typedArrayTags[stringTag$4] = typedArrayTags[weakMapTag$2] = false;
  /**
   * The base implementation of `_.isTypedArray` without Node.js optimizations.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
   */

  function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
  }
  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */


  function baseUnary(func) {
    return function (value) {
      return func(value);
    };
  }
  /** Detect free variable `exports`. */


  var freeExports$1 = typeof exports == 'object' && exports && !exports.nodeType && exports;
  /** Detect free variable `module`. */

  var freeModule$1 = freeExports$1 && typeof module == 'object' && module && !module.nodeType && module;
  /** Detect the popular CommonJS extension `module.exports`. */

  var moduleExports$1 = freeModule$1 && freeModule$1.exports === freeExports$1;
  /** Detect free variable `process` from Node.js. */

  var freeProcess = moduleExports$1 && freeGlobal$1.process;
  /** Used to access faster Node.js helpers. */

  var nodeUtil = function () {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule$1 && freeModule$1.require && freeModule$1.require('util').types;

      if (types) {
        return types;
      } // Legacy `process.binding('util')` for Node.js < 10.


      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }();

  var nodeUtil$1 = nodeUtil;
  /* Node.js helper references. */

  var nodeIsTypedArray = nodeUtil$1 && nodeUtil$1.isTypedArray;
  /**
   * Checks if `value` is classified as a typed array.
   *
   * @static
   * @memberOf _
   * @since 3.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
   * @example
   *
   * _.isTypedArray(new Uint8Array);
   * // => true
   *
   * _.isTypedArray([]);
   * // => false
   */

  var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
  var isTypedArray$1 = isTypedArray;
  /** Used for built-in method references. */

  var objectProto$7 = Object.prototype;
  /** Used to check objects for own properties. */

  var hasOwnProperty$5 = objectProto$7.hasOwnProperty;
  /**
   * Creates an array of the enumerable property names of the array-like `value`.
   *
   * @private
   * @param {*} value The value to query.
   * @param {boolean} inherited Specify returning inherited property names.
   * @returns {Array} Returns the array of property names.
   */

  function arrayLikeKeys(value, inherited) {
    var isArr = isArray$1(value),
        isArg = !isArr && isArguments$1(value),
        isBuff = !isArr && !isArg && isBuffer$1(value),
        isType = !isArr && !isArg && !isBuff && isTypedArray$1(value),
        skipIndexes = isArr || isArg || isBuff || isType,
        result = skipIndexes ? baseTimes(value.length, String) : [],
        length = result.length;

    for (var key in value) {
      if ((inherited || hasOwnProperty$5.call(value, key)) && !(skipIndexes && ( // Safari 9 has enumerable `arguments.length` in strict mode.
      key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
      isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
      isIndex(key, length)))) {
        result.push(key);
      }
    }

    return result;
  }
  /** Used for built-in method references. */


  var objectProto$6 = Object.prototype;
  /**
   * Checks if `value` is likely a prototype object.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
   */

  function isPrototype(value) {
    var Ctor = value && value.constructor,
        proto = typeof Ctor == 'function' && Ctor.prototype || objectProto$6;
    return value === proto;
  }
  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */


  function overArg(func, transform) {
    return function (arg) {
      return func(transform(arg));
    };
  }
  /* Built-in method references for those with the same name as other `lodash` methods. */


  var nativeKeys = overArg(Object.keys, Object);
  var nativeKeys$1 = nativeKeys;
  /** Used for built-in method references. */

  var objectProto$5 = Object.prototype;
  /** Used to check objects for own properties. */

  var hasOwnProperty$4 = objectProto$5.hasOwnProperty;
  /**
   * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   */

  function baseKeys(object) {
    if (!isPrototype(object)) {
      return nativeKeys$1(object);
    }

    var result = [];

    for (var key in Object(object)) {
      if (hasOwnProperty$4.call(object, key) && key != 'constructor') {
        result.push(key);
      }
    }

    return result;
  }
  /**
   * Checks if `value` is array-like. A value is considered array-like if it's
   * not a function and has a `value.length` that's an integer greater than or
   * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
   * @example
   *
   * _.isArrayLike([1, 2, 3]);
   * // => true
   *
   * _.isArrayLike(document.body.children);
   * // => true
   *
   * _.isArrayLike('abc');
   * // => true
   *
   * _.isArrayLike(_.noop);
   * // => false
   */


  function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
  }
  /**
   * Creates an array of the own enumerable property names of `object`.
   *
   * **Note:** Non-object values are coerced to objects. See the
   * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
   * for more details.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Object
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   * @example
   *
   * function Foo() {
   *   this.a = 1;
   *   this.b = 2;
   * }
   *
   * Foo.prototype.c = 3;
   *
   * _.keys(new Foo);
   * // => ['a', 'b'] (iteration order is not guaranteed)
   *
   * _.keys('hi');
   * // => ['0', '1']
   */


  function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
  }
  /**
   * The base implementation of `_.assign` without support for multiple sources
   * or `customizer` functions.
   *
   * @private
   * @param {Object} object The destination object.
   * @param {Object} source The source object.
   * @returns {Object} Returns `object`.
   */


  function baseAssign(object, source) {
    return object && copyObject(source, keys(source), object);
  }
  /**
   * This function is like
   * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
   * except that it includes inherited enumerable properties.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   */


  function nativeKeysIn(object) {
    var result = [];

    if (object != null) {
      for (var key in Object(object)) {
        result.push(key);
      }
    }

    return result;
  }
  /** Used for built-in method references. */


  var objectProto$4 = Object.prototype;
  /** Used to check objects for own properties. */

  var hasOwnProperty$3 = objectProto$4.hasOwnProperty;
  /**
   * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   */

  function baseKeysIn(object) {
    if (!isObject$5(object)) {
      return nativeKeysIn(object);
    }

    var isProto = isPrototype(object),
        result = [];

    for (var key in object) {
      if (!(key == 'constructor' && (isProto || !hasOwnProperty$3.call(object, key)))) {
        result.push(key);
      }
    }

    return result;
  }
  /**
   * Creates an array of the own and inherited enumerable property names of `object`.
   *
   * **Note:** Non-object values are coerced to objects.
   *
   * @static
   * @memberOf _
   * @since 3.0.0
   * @category Object
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   * @example
   *
   * function Foo() {
   *   this.a = 1;
   *   this.b = 2;
   * }
   *
   * Foo.prototype.c = 3;
   *
   * _.keysIn(new Foo);
   * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
   */


  function keysIn(object) {
    return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
  }
  /**
   * The base implementation of `_.assignIn` without support for multiple sources
   * or `customizer` functions.
   *
   * @private
   * @param {Object} object The destination object.
   * @param {Object} source The source object.
   * @returns {Object} Returns `object`.
   */


  function baseAssignIn(object, source) {
    return object && copyObject(source, keysIn(source), object);
  }
  /** Detect free variable `exports`. */


  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
  /** Detect free variable `module`. */

  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
  /** Detect the popular CommonJS extension `module.exports`. */

  var moduleExports = freeModule && freeModule.exports === freeExports;
  /** Built-in value references. */

  var Buffer = moduleExports ? root$1.Buffer : undefined,
      allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
  /**
   * Creates a clone of  `buffer`.
   *
   * @private
   * @param {Buffer} buffer The buffer to clone.
   * @param {boolean} [isDeep] Specify a deep clone.
   * @returns {Buffer} Returns the cloned buffer.
   */

  function cloneBuffer(buffer, isDeep) {
    if (isDeep) {
      return buffer.slice();
    }

    var length = buffer.length,
        result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
  }
  /**
   * Copies the values of `source` to `array`.
   *
   * @private
   * @param {Array} source The array to copy values from.
   * @param {Array} [array=[]] The array to copy values to.
   * @returns {Array} Returns `array`.
   */


  function copyArray(source, array) {
    var index = -1,
        length = source.length;
    array || (array = Array(length));

    while (++index < length) {
      array[index] = source[index];
    }

    return array;
  }
  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */


  function arrayFilter$1(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];

      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }

    return result;
  }
  /**
   * This method returns a new empty array.
   *
   * @static
   * @memberOf _
   * @since 4.13.0
   * @category Util
   * @returns {Array} Returns the new empty array.
   * @example
   *
   * var arrays = _.times(2, _.stubArray);
   *
   * console.log(arrays);
   * // => [[], []]
   *
   * console.log(arrays[0] === arrays[1]);
   * // => false
   */


  function stubArray() {
    return [];
  }
  /** Used for built-in method references. */


  var objectProto$3 = Object.prototype;
  /** Built-in value references. */

  var propertyIsEnumerable = objectProto$3.propertyIsEnumerable;
  /* Built-in method references for those with the same name as other `lodash` methods. */

  var nativeGetSymbols$1 = Object.getOwnPropertySymbols;
  /**
   * Creates an array of the own enumerable symbols of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of symbols.
   */

  var getSymbols = !nativeGetSymbols$1 ? stubArray : function (object) {
    if (object == null) {
      return [];
    }

    object = Object(object);
    return arrayFilter$1(nativeGetSymbols$1(object), function (symbol) {
      return propertyIsEnumerable.call(object, symbol);
    });
  };
  var getSymbols$1 = getSymbols;
  /**
   * Copies own symbols of `source` to `object`.
   *
   * @private
   * @param {Object} source The object to copy symbols from.
   * @param {Object} [object={}] The object to copy symbols to.
   * @returns {Object} Returns `object`.
   */

  function copySymbols(source, object) {
    return copyObject(source, getSymbols$1(source), object);
  }
  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */


  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }

    return array;
  }
  /** Built-in value references. */


  var getPrototype = overArg(Object.getPrototypeOf, Object);
  var getPrototype$1 = getPrototype;
  /* Built-in method references for those with the same name as other `lodash` methods. */

  var nativeGetSymbols = Object.getOwnPropertySymbols;
  /**
   * Creates an array of the own and inherited enumerable symbols of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of symbols.
   */

  var getSymbolsIn = !nativeGetSymbols ? stubArray : function (object) {
    var result = [];

    while (object) {
      arrayPush(result, getSymbols$1(object));
      object = getPrototype$1(object);
    }

    return result;
  };
  var getSymbolsIn$1 = getSymbolsIn;
  /**
   * Copies own and inherited symbols of `source` to `object`.
   *
   * @private
   * @param {Object} source The object to copy symbols from.
   * @param {Object} [object={}] The object to copy symbols to.
   * @returns {Object} Returns `object`.
   */

  function copySymbolsIn(source, object) {
    return copyObject(source, getSymbolsIn$1(source), object);
  }
  /**
   * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
   * `keysFunc` and `symbolsFunc` to get the enumerable property names and
   * symbols of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Function} keysFunc The function to get the keys of `object`.
   * @param {Function} symbolsFunc The function to get the symbols of `object`.
   * @returns {Array} Returns the array of property names and symbols.
   */


  function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray$1(object) ? result : arrayPush(result, symbolsFunc(object));
  }
  /**
   * Creates an array of own enumerable property names and symbols of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names and symbols.
   */


  function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols$1);
  }
  /**
   * Creates an array of own and inherited enumerable property names and
   * symbols of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names and symbols.
   */


  function getAllKeysIn(object) {
    return baseGetAllKeys(object, keysIn, getSymbolsIn$1);
  }
  /* Built-in method references that are verified to be native. */


  var DataView = getNative(root$1, 'DataView');
  var DataView$1 = DataView;
  /* Built-in method references that are verified to be native. */

  var Promise$1 = getNative(root$1, 'Promise');
  var Promise$2 = Promise$1;
  /* Built-in method references that are verified to be native. */

  var Set$1 = getNative(root$1, 'Set');
  var Set$2 = Set$1;
  /* Built-in method references that are verified to be native. */

  var WeakMap$1 = getNative(root$1, 'WeakMap');
  var WeakMap$2 = WeakMap$1;
  /** `Object#toString` result references. */

  var mapTag$5 = '[object Map]',
      objectTag$2 = '[object Object]',
      promiseTag = '[object Promise]',
      setTag$5 = '[object Set]',
      weakMapTag$1 = '[object WeakMap]';
  var dataViewTag$3 = '[object DataView]';
  /** Used to detect maps, sets, and weakmaps. */

  var dataViewCtorString = toSource(DataView$1),
      mapCtorString = toSource(Map$2),
      promiseCtorString = toSource(Promise$2),
      setCtorString = toSource(Set$2),
      weakMapCtorString = toSource(WeakMap$2);
  /**
   * Gets the `toStringTag` of `value`.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the `toStringTag`.
   */

  var getTag = baseGetTag; // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.

  if (DataView$1 && getTag(new DataView$1(new ArrayBuffer(1))) != dataViewTag$3 || Map$2 && getTag(new Map$2()) != mapTag$5 || Promise$2 && getTag(Promise$2.resolve()) != promiseTag || Set$2 && getTag(new Set$2()) != setTag$5 || WeakMap$2 && getTag(new WeakMap$2()) != weakMapTag$1) {
    getTag = function getTag(value) {
      var result = baseGetTag(value),
          Ctor = result == objectTag$2 ? value.constructor : undefined,
          ctorString = Ctor ? toSource(Ctor) : '';

      if (ctorString) {
        switch (ctorString) {
          case dataViewCtorString:
            return dataViewTag$3;

          case mapCtorString:
            return mapTag$5;

          case promiseCtorString:
            return promiseTag;

          case setCtorString:
            return setTag$5;

          case weakMapCtorString:
            return weakMapTag$1;
        }
      }

      return result;
    };
  }

  var getTag$1 = getTag;
  /** Used for built-in method references. */

  var objectProto$2 = Object.prototype;
  /** Used to check objects for own properties. */

  var hasOwnProperty$2 = objectProto$2.hasOwnProperty;
  /**
   * Initializes an array clone.
   *
   * @private
   * @param {Array} array The array to clone.
   * @returns {Array} Returns the initialized clone.
   */

  function initCloneArray(array) {
    var length = array.length,
        result = new array.constructor(length); // Add properties assigned by `RegExp#exec`.

    if (length && typeof array[0] == 'string' && hasOwnProperty$2.call(array, 'index')) {
      result.index = array.index;
      result.input = array.input;
    }

    return result;
  }
  /** Built-in value references. */


  var Uint8Array$1 = root$1.Uint8Array;
  var Uint8Array$2 = Uint8Array$1;
  /**
   * Creates a clone of `arrayBuffer`.
   *
   * @private
   * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
   * @returns {ArrayBuffer} Returns the cloned array buffer.
   */

  function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array$2(result).set(new Uint8Array$2(arrayBuffer));
    return result;
  }
  /**
   * Creates a clone of `dataView`.
   *
   * @private
   * @param {Object} dataView The data view to clone.
   * @param {boolean} [isDeep] Specify a deep clone.
   * @returns {Object} Returns the cloned data view.
   */


  function cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
  }
  /** Used to match `RegExp` flags from their coerced string values. */


  var reFlags = /\w*$/;
  /**
   * Creates a clone of `regexp`.
   *
   * @private
   * @param {Object} regexp The regexp to clone.
   * @returns {Object} Returns the cloned regexp.
   */

  function cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
  }
  /** Used to convert symbols to primitives and strings. */


  var symbolProto$1 = Symbol$2 ? Symbol$2.prototype : undefined,
      symbolValueOf$1 = symbolProto$1 ? symbolProto$1.valueOf : undefined;
  /**
   * Creates a clone of the `symbol` object.
   *
   * @private
   * @param {Object} symbol The symbol object to clone.
   * @returns {Object} Returns the cloned symbol object.
   */

  function cloneSymbol(symbol) {
    return symbolValueOf$1 ? Object(symbolValueOf$1.call(symbol)) : {};
  }
  /**
   * Creates a clone of `typedArray`.
   *
   * @private
   * @param {Object} typedArray The typed array to clone.
   * @param {boolean} [isDeep] Specify a deep clone.
   * @returns {Object} Returns the cloned typed array.
   */


  function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
  }
  /** `Object#toString` result references. */


  var boolTag$2 = '[object Boolean]',
      dateTag$2 = '[object Date]',
      mapTag$4 = '[object Map]',
      numberTag$2 = '[object Number]',
      regexpTag$2 = '[object RegExp]',
      setTag$4 = '[object Set]',
      stringTag$3 = '[object String]',
      symbolTag$2 = '[object Symbol]';
  var arrayBufferTag$2 = '[object ArrayBuffer]',
      dataViewTag$2 = '[object DataView]',
      float32Tag$1 = '[object Float32Array]',
      float64Tag$1 = '[object Float64Array]',
      int8Tag$1 = '[object Int8Array]',
      int16Tag$1 = '[object Int16Array]',
      int32Tag$1 = '[object Int32Array]',
      uint8Tag$1 = '[object Uint8Array]',
      uint8ClampedTag$1 = '[object Uint8ClampedArray]',
      uint16Tag$1 = '[object Uint16Array]',
      uint32Tag$1 = '[object Uint32Array]';
  /**
   * Initializes an object clone based on its `toStringTag`.
   *
   * **Note:** This function only supports cloning values with tags of
   * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
   *
   * @private
   * @param {Object} object The object to clone.
   * @param {string} tag The `toStringTag` of the object to clone.
   * @param {boolean} [isDeep] Specify a deep clone.
   * @returns {Object} Returns the initialized clone.
   */

  function initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;

    switch (tag) {
      case arrayBufferTag$2:
        return cloneArrayBuffer(object);

      case boolTag$2:
      case dateTag$2:
        return new Ctor(+object);

      case dataViewTag$2:
        return cloneDataView(object, isDeep);

      case float32Tag$1:
      case float64Tag$1:
      case int8Tag$1:
      case int16Tag$1:
      case int32Tag$1:
      case uint8Tag$1:
      case uint8ClampedTag$1:
      case uint16Tag$1:
      case uint32Tag$1:
        return cloneTypedArray(object, isDeep);

      case mapTag$4:
        return new Ctor();

      case numberTag$2:
      case stringTag$3:
        return new Ctor(object);

      case regexpTag$2:
        return cloneRegExp(object);

      case setTag$4:
        return new Ctor();

      case symbolTag$2:
        return cloneSymbol(object);
    }
  }
  /** Built-in value references. */


  var objectCreate = Object.create;
  /**
   * The base implementation of `_.create` without support for assigning
   * properties to the created object.
   *
   * @private
   * @param {Object} proto The object to inherit from.
   * @returns {Object} Returns the new object.
   */

  var baseCreate = function () {
    function object() {}

    return function (proto) {
      if (!isObject$5(proto)) {
        return {};
      }

      if (objectCreate) {
        return objectCreate(proto);
      }

      object.prototype = proto;
      var result = new object();
      object.prototype = undefined;
      return result;
    };
  }();

  var baseCreate$1 = baseCreate;
  /**
   * Initializes an object clone.
   *
   * @private
   * @param {Object} object The object to clone.
   * @returns {Object} Returns the initialized clone.
   */

  function initCloneObject(object) {
    return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate$1(getPrototype$1(object)) : {};
  }
  /** `Object#toString` result references. */


  var mapTag$3 = '[object Map]';
  /**
   * The base implementation of `_.isMap` without Node.js optimizations.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a map, else `false`.
   */

  function baseIsMap(value) {
    return isObjectLike(value) && getTag$1(value) == mapTag$3;
  }
  /* Node.js helper references. */


  var nodeIsMap = nodeUtil$1 && nodeUtil$1.isMap;
  /**
   * Checks if `value` is classified as a `Map` object.
   *
   * @static
   * @memberOf _
   * @since 4.3.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a map, else `false`.
   * @example
   *
   * _.isMap(new Map);
   * // => true
   *
   * _.isMap(new WeakMap);
   * // => false
   */

  var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
  var isMap$1 = isMap;
  /** `Object#toString` result references. */

  var setTag$3 = '[object Set]';
  /**
   * The base implementation of `_.isSet` without Node.js optimizations.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a set, else `false`.
   */

  function baseIsSet(value) {
    return isObjectLike(value) && getTag$1(value) == setTag$3;
  }
  /* Node.js helper references. */


  var nodeIsSet = nodeUtil$1 && nodeUtil$1.isSet;
  /**
   * Checks if `value` is classified as a `Set` object.
   *
   * @static
   * @memberOf _
   * @since 4.3.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a set, else `false`.
   * @example
   *
   * _.isSet(new Set);
   * // => true
   *
   * _.isSet(new WeakSet);
   * // => false
   */

  var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
  var isSet$1 = isSet;
  /** Used to compose bitmasks for cloning. */

  var CLONE_DEEP_FLAG$1 = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG$1 = 4;
  /** `Object#toString` result references. */

  var argsTag$1 = '[object Arguments]',
      arrayTag$1 = '[object Array]',
      boolTag$1 = '[object Boolean]',
      dateTag$1 = '[object Date]',
      errorTag$1 = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag$2 = '[object Map]',
      numberTag$1 = '[object Number]',
      objectTag$1 = '[object Object]',
      regexpTag$1 = '[object RegExp]',
      setTag$2 = '[object Set]',
      stringTag$2 = '[object String]',
      symbolTag$1 = '[object Symbol]',
      weakMapTag = '[object WeakMap]';
  var arrayBufferTag$1 = '[object ArrayBuffer]',
      dataViewTag$1 = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';
  /** Used to identify `toStringTag` values supported by `_.clone`. */

  var cloneableTags = {};
  cloneableTags[argsTag$1] = cloneableTags[arrayTag$1] = cloneableTags[arrayBufferTag$1] = cloneableTags[dataViewTag$1] = cloneableTags[boolTag$1] = cloneableTags[dateTag$1] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag$2] = cloneableTags[numberTag$1] = cloneableTags[objectTag$1] = cloneableTags[regexpTag$1] = cloneableTags[setTag$2] = cloneableTags[stringTag$2] = cloneableTags[symbolTag$1] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag$1] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
  /**
   * The base implementation of `_.clone` and `_.cloneDeep` which tracks
   * traversed objects.
   *
   * @private
   * @param {*} value The value to clone.
   * @param {boolean} bitmask The bitmask flags.
   *  1 - Deep clone
   *  2 - Flatten inherited properties
   *  4 - Clone symbols
   * @param {Function} [customizer] The function to customize cloning.
   * @param {string} [key] The key of `value`.
   * @param {Object} [object] The parent object of `value`.
   * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
   * @returns {*} Returns the cloned value.
   */

  function baseClone(value, bitmask, customizer, key, object, stack) {
    var result,
        isDeep = bitmask & CLONE_DEEP_FLAG$1,
        isFlat = bitmask & CLONE_FLAT_FLAG,
        isFull = bitmask & CLONE_SYMBOLS_FLAG$1;

    if (customizer) {
      result = object ? customizer(value, key, object, stack) : customizer(value);
    }

    if (result !== undefined) {
      return result;
    }

    if (!isObject$5(value)) {
      return value;
    }

    var isArr = isArray$1(value);

    if (isArr) {
      result = initCloneArray(value);

      if (!isDeep) {
        return copyArray(value, result);
      }
    } else {
      var tag = getTag$1(value),
          isFunc = tag == funcTag || tag == genTag;

      if (isBuffer$1(value)) {
        return cloneBuffer(value, isDeep);
      }

      if (tag == objectTag$1 || tag == argsTag$1 || isFunc && !object) {
        result = isFlat || isFunc ? {} : initCloneObject(value);

        if (!isDeep) {
          return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
        }
      } else {
        if (!cloneableTags[tag]) {
          return object ? value : {};
        }

        result = initCloneByTag(value, tag, isDeep);
      }
    } // Check for circular references and return its corresponding clone.


    stack || (stack = new Stack$1());
    var stacked = stack.get(value);

    if (stacked) {
      return stacked;
    }

    stack.set(value, result);

    if (isSet$1(value)) {
      value.forEach(function (subValue) {
        result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
      });
    } else if (isMap$1(value)) {
      value.forEach(function (subValue, key) {
        result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
    }

    var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
    var props = isArr ? undefined : keysFunc(value);
    arrayEach(props || value, function (subValue, key) {
      if (props) {
        key = subValue;
        subValue = value[key];
      } // Recursively populate clone (susceptible to call stack limits).


      assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
  }
  /** Used to compose bitmasks for cloning. */


  var CLONE_DEEP_FLAG = 1,
      CLONE_SYMBOLS_FLAG = 4;
  /**
   * This method is like `_.cloneWith` except that it recursively clones `value`.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to recursively clone.
   * @param {Function} [customizer] The function to customize cloning.
   * @returns {*} Returns the deep cloned value.
   * @see _.cloneWith
   * @example
   *
   * function customizer(value) {
   *   if (_.isElement(value)) {
   *     return value.cloneNode(true);
   *   }
   * }
   *
   * var el = _.cloneDeepWith(document.body, customizer);
   *
   * console.log(el === document.body);
   * // => false
   * console.log(el.nodeName);
   * // => 'BODY'
   * console.log(el.childNodes.length);
   * // => 20
   */

  function cloneDeepWith(value, customizer) {
    customizer = typeof customizer == 'function' ? customizer : undefined;
    return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
  }
  /** `Object#toString` result references. */


  var stringTag$1 = '[object String]';
  /**
   * Checks if `value` is classified as a `String` primitive or object.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a string, else `false`.
   * @example
   *
   * _.isString('abc');
   * // => true
   *
   * _.isString(1);
   * // => false
   */

  function isString(value) {
    return typeof value == 'string' || !isArray$1(value) && isObjectLike(value) && baseGetTag(value) == stringTag$1;
  }
  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */


  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }

    return result;
  }
  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */


  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);
    map.forEach(function (value, key) {
      result[++index] = [key, value];
    });
    return result;
  }
  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */


  function setToArray(set) {
    var index = -1,
        result = Array(set.size);
    set.forEach(function (value) {
      result[++index] = value;
    });
    return result;
  }
  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */


  function asciiToArray(string) {
    return string.split('');
  }
  /** Used to compose unicode character classes. */


  var rsAstralRange$2 = "\\ud800-\\udfff",
      rsComboMarksRange$3 = "\\u0300-\\u036f",
      reComboHalfMarksRange$3 = "\\ufe20-\\ufe2f",
      rsComboSymbolsRange$3 = "\\u20d0-\\u20ff",
      rsComboRange$3 = rsComboMarksRange$3 + reComboHalfMarksRange$3 + rsComboSymbolsRange$3,
      rsVarRange$2 = "\\ufe0e\\ufe0f";
  /** Used to compose unicode capture groups. */

  var rsZWJ$2 = "\\u200d";
  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */

  var reHasUnicode = RegExp('[' + rsZWJ$2 + rsAstralRange$2 + rsComboRange$3 + rsVarRange$2 + ']');
  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */

  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }
  /** Used to compose unicode character classes. */


  var rsAstralRange$1 = "\\ud800-\\udfff",
      rsComboMarksRange$2 = "\\u0300-\\u036f",
      reComboHalfMarksRange$2 = "\\ufe20-\\ufe2f",
      rsComboSymbolsRange$2 = "\\u20d0-\\u20ff",
      rsComboRange$2 = rsComboMarksRange$2 + reComboHalfMarksRange$2 + rsComboSymbolsRange$2,
      rsVarRange$1 = "\\ufe0e\\ufe0f";
  /** Used to compose unicode capture groups. */

  var rsAstral = '[' + rsAstralRange$1 + ']',
      rsCombo$2 = '[' + rsComboRange$2 + ']',
      rsFitz$1 = "\\ud83c[\\udffb-\\udfff]",
      rsModifier$1 = '(?:' + rsCombo$2 + '|' + rsFitz$1 + ')',
      rsNonAstral$1 = '[^' + rsAstralRange$1 + ']',
      rsRegional$1 = "(?:\\ud83c[\\udde6-\\uddff]){2}",
      rsSurrPair$1 = "[\\ud800-\\udbff][\\udc00-\\udfff]",
      rsZWJ$1 = "\\u200d";
  /** Used to compose unicode regexes. */

  var reOptMod$1 = rsModifier$1 + '?',
      rsOptVar$1 = '[' + rsVarRange$1 + ']?',
      rsOptJoin$1 = '(?:' + rsZWJ$1 + '(?:' + [rsNonAstral$1, rsRegional$1, rsSurrPair$1].join('|') + ')' + rsOptVar$1 + reOptMod$1 + ')*',
      rsSeq$1 = rsOptVar$1 + reOptMod$1 + rsOptJoin$1,
      rsSymbol = '(?:' + [rsNonAstral$1 + rsCombo$2 + '?', rsCombo$2, rsRegional$1, rsSurrPair$1, rsAstral].join('|') + ')';
  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */

  var reUnicode = RegExp(rsFitz$1 + '(?=' + rsFitz$1 + ')|' + rsSymbol + rsSeq$1, 'g');
  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */

  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }
  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */


  function stringToArray(string) {
    return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
  }
  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */


  function baseValues(object, props) {
    return arrayMap(props, function (key) {
      return object[key];
    });
  }
  /**
   * Creates an array of the own enumerable string keyed property values of `object`.
   *
   * **Note:** Non-object values are coerced to objects.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Object
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property values.
   * @example
   *
   * function Foo() {
   *   this.a = 1;
   *   this.b = 2;
   * }
   *
   * Foo.prototype.c = 3;
   *
   * _.values(new Foo);
   * // => [1, 2] (iteration order is not guaranteed)
   *
   * _.values('hi');
   * // => ['h', 'i']
   */


  function values(object) {
    return object == null ? [] : baseValues(object, keys(object));
  }
  /** `Object#toString` result references. */


  var mapTag$1 = '[object Map]',
      setTag$1 = '[object Set]';
  /** Built-in value references. */

  var symIterator = Symbol$2 ? Symbol$2.iterator : undefined;
  /**
   * Converts `value` to an array.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Lang
   * @param {*} value The value to convert.
   * @returns {Array} Returns the converted array.
   * @example
   *
   * _.toArray({ 'a': 1, 'b': 2 });
   * // => [1, 2]
   *
   * _.toArray('abc');
   * // => ['a', 'b', 'c']
   *
   * _.toArray(1);
   * // => []
   *
   * _.toArray(null);
   * // => []
   */

  function toArray(value) {
    if (!value) {
      return [];
    }

    if (isArrayLike(value)) {
      return isString(value) ? stringToArray(value) : copyArray(value);
    }

    if (symIterator && value[symIterator]) {
      return iteratorToArray(value[symIterator]());
    }

    var tag = getTag$1(value),
        func = tag == mapTag$1 ? mapToArray : tag == setTag$1 ? setToArray : values;
    return func(value);
  }

  var toString = Object.prototype.toString;
  var errorToString = Error.prototype.toString;
  var regExpToString = RegExp.prototype.toString;
  var symbolToString = typeof Symbol !== 'undefined' ? Symbol.prototype.toString : function () {
    return '';
  };
  var SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;

  function printNumber(val) {
    if (val != +val) return 'NaN';
    var isNegativeZero = val === 0 && 1 / val < 0;
    return isNegativeZero ? '-0' : '' + val;
  }

  function printSimpleValue(val, quoteStrings) {
    if (quoteStrings === void 0) {
      quoteStrings = false;
    }

    if (val == null || val === true || val === false) return '' + val;
    var typeOf = typeof val;
    if (typeOf === 'number') return printNumber(val);
    if (typeOf === 'string') return quoteStrings ? "\"" + val + "\"" : val;
    if (typeOf === 'function') return '[Function ' + (val.name || 'anonymous') + ']';
    if (typeOf === 'symbol') return symbolToString.call(val).replace(SYMBOL_REGEXP, 'Symbol($1)');
    var tag = toString.call(val).slice(8, -1);
    if (tag === 'Date') return isNaN(val.getTime()) ? '' + val : val.toISOString(val);
    if (tag === 'Error' || val instanceof Error) return '[' + errorToString.call(val) + ']';
    if (tag === 'RegExp') return regExpToString.call(val);
    return null;
  }

  function printValue(value, quoteStrings) {
    var result = printSimpleValue(value, quoteStrings);
    if (result !== null) return result;
    return JSON.stringify(value, function (key, value) {
      var result = printSimpleValue(this[key], quoteStrings);
      if (result !== null) return result;
      return value;
    }, 2);
  }

  var mixed = {
    default: '${path} is invalid',
    required: '${path} is a required field',
    oneOf: '${path} must be one of the following values: ${values}',
    notOneOf: '${path} must not be one of the following values: ${values}',
    notType: function notType(_ref) {
      var path = _ref.path,
          type = _ref.type,
          value = _ref.value,
          originalValue = _ref.originalValue;
      var isCast = originalValue != null && originalValue !== value;
      var msg = path + " must be a `" + type + "` type, " + ("but the final value was: `" + printValue(value, true) + "`") + (isCast ? " (cast from the value `" + printValue(originalValue, true) + "`)." : '.');

      if (value === null) {
        msg += "\n If \"null\" is intended as an empty value be sure to mark the schema as `.nullable()`";
      }

      return msg;
    },
    defined: '${path} must be defined'
  };
  var string = {
    length: '${path} must be exactly ${length} characters',
    min: '${path} must be at least ${min} characters',
    max: '${path} must be at most ${max} characters',
    matches: '${path} must match the following: "${regex}"',
    email: '${path} must be a valid email',
    url: '${path} must be a valid URL',
    uuid: '${path} must be a valid UUID',
    trim: '${path} must be a trimmed string',
    lowercase: '${path} must be a lowercase string',
    uppercase: '${path} must be a upper case string'
  };
  var number = {
    min: '${path} must be greater than or equal to ${min}',
    max: '${path} must be less than or equal to ${max}',
    lessThan: '${path} must be less than ${less}',
    moreThan: '${path} must be greater than ${more}',
    notEqual: '${path} must be not equal to ${notEqual}',
    positive: '${path} must be a positive number',
    negative: '${path} must be a negative number',
    integer: '${path} must be an integer'
  };
  var date = {
    min: '${path} field must be later than ${min}',
    max: '${path} field must be at earlier than ${max}'
  };
  var boolean$1 = {
    isValue: '${path} field must be ${value}'
  };
  var object = {
    noUnknown: '${path} field has unspecified keys: ${unknown}'
  };
  var array = {
    min: '${path} field must have at least ${min} items',
    max: '${path} field must have less than or equal to ${max} items'
  };

  var locale$1 = _extends$6(Object.create(null), {
    mixed: mixed,
    string: string,
    number: number,
    date: date,
    object: object,
    array: array,
    boolean: boolean$1
  });

  var isSchema = function isSchema(obj) {
    return obj && obj.__isYupSchema__;
  };

  var Condition = /*#__PURE__*/function () {
    function Condition(refs, options) {
      this.refs = refs;

      if (typeof options === 'function') {
        this.fn = options;
        return;
      }

      if (!has(options, 'is')) throw new TypeError('`is:` is required for `when()` conditions');
      if (!options.then && !options.otherwise) throw new TypeError('either `then:` or `otherwise:` is required for `when()` conditions');
      var is = options.is,
          then = options.then,
          otherwise = options.otherwise;
      var check = typeof is === 'function' ? is : function () {
        for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
          values[_key] = arguments[_key];
        }

        return values.every(function (value) {
          return value === is;
        });
      };

      this.fn = function () {
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        var options = args.pop();
        var schema = args.pop();
        var branch = check.apply(void 0, args) ? then : otherwise;
        if (!branch) return undefined;
        if (typeof branch === 'function') return branch(schema);
        return schema.concat(branch.resolve(options));
      };
    }

    var _proto = Condition.prototype;

    _proto.resolve = function resolve(base, options) {
      var values = this.refs.map(function (ref) {
        return ref.getValue(options == null ? void 0 : options.value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context);
      });
      var schema = this.fn.apply(base, values.concat(base, options));
      if (schema === undefined || schema === base) return base;
      if (!isSchema(schema)) throw new TypeError('conditions must return a schema object');
      return schema.resolve(options);
    };

    return Condition;
  }();

  var strReg = /\$\{\s*(\w+)\s*\}/g;

  function ValidationError(errors, value, field, type) {
    var _this = this;

    this.name = 'ValidationError';
    this.value = value;
    this.path = field;
    this.type = type;
    this.errors = [];
    this.inner = [];
    if (errors) [].concat(errors).forEach(function (err) {
      _this.errors = _this.errors.concat(err.errors || err);
      if (err.inner) _this.inner = _this.inner.concat(err.inner.length ? err.inner : err);
    });
    this.message = this.errors.length > 1 ? this.errors.length + " errors occurred" : this.errors[0];
    if (Error.captureStackTrace) Error.captureStackTrace(this, ValidationError);
  }

  ValidationError.prototype = Object.create(Error.prototype);
  ValidationError.prototype.constructor = ValidationError;

  ValidationError.isError = function (err) {
    return err && err.name === 'ValidationError';
  };

  ValidationError.formatError = function (message, params) {
    var path = params.label || params.path || 'this';
    if (path !== params.path) params = _extends$6({}, params, {
      path: path
    });
    if (typeof message === 'string') return message.replace(strReg, function (_, key) {
      return printValue(params[key]);
    });
    if (typeof message === 'function') return message(params);
    return message;
  };

  var once = function once(cb) {
    var fired = false;
    return function () {
      if (fired) return;
      fired = true;
      cb.apply(void 0, arguments);
    };
  };

  function runTests(options, cb) {
    var endEarly = options.endEarly,
        tests = options.tests,
        args = options.args,
        value = options.value,
        errors = options.errors,
        sort = options.sort,
        path = options.path;
    var callback = once(cb);
    var count = tests.length;
    var nestedErrors = [];
    errors = errors ? errors : [];
    if (!count) return errors.length ? callback(new ValidationError(errors, value, path)) : callback(null, value);

    for (var i = 0; i < tests.length; i++) {
      var test = tests[i];
      test(args, function finishTestRun(err) {
        if (err) {
          // always return early for non validation errors
          if (!ValidationError.isError(err)) {
            return callback(err);
          }

          if (endEarly) {
            err.value = value;
            return callback(err);
          }

          nestedErrors.push(err);
        }

        if (--count <= 0) {
          if (nestedErrors.length) {
            if (sort) nestedErrors.sort(sort); //show parent errors after the nested ones: name.first, name

            if (errors.length) nestedErrors.push.apply(nestedErrors, errors);
            errors = nestedErrors;
          }

          if (errors.length) {
            callback(new ValidationError(errors, value, path));
            return;
          }

          callback(null, value);
        }
      });
    }
  }

  var isObject$4 = function isObject(obj) {
    return Object.prototype.toString.call(obj) === '[object Object]';
  };

  function prependDeep(target, source) {
    for (var key in source) {
      if (has(source, key)) {
        var sourceVal = source[key],
            targetVal = target[key];

        if (targetVal === undefined) {
          target[key] = sourceVal;
        } else if (targetVal === sourceVal) {
          continue;
        } else if (isSchema(targetVal)) {
          if (isSchema(sourceVal)) target[key] = sourceVal.concat(targetVal);
        } else if (isObject$4(targetVal)) {
          if (isObject$4(sourceVal)) target[key] = prependDeep(targetVal, sourceVal);
        } else if (Array.isArray(targetVal)) {
          if (Array.isArray(sourceVal)) target[key] = sourceVal.concat(targetVal);
        }
      }
    }

    return target;
  }
  /**
   * Creates a base function for methods like `_.forIn` and `_.forOwn`.
   *
   * @private
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {Function} Returns the new base function.
   */


  function createBaseFor(fromRight) {
    return function (object, iteratee, keysFunc) {
      var index = -1,
          iterable = Object(object),
          props = keysFunc(object),
          length = props.length;

      while (length--) {
        var key = props[fromRight ? length : ++index];

        if (iteratee(iterable[key], key, iterable) === false) {
          break;
        }
      }

      return object;
    };
  }
  /**
   * The base implementation of `baseForOwn` which iterates over `object`
   * properties returned by `keysFunc` and invokes `iteratee` for each property.
   * Iteratee functions may exit iteration early by explicitly returning `false`.
   *
   * @private
   * @param {Object} object The object to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {Function} keysFunc The function to get the keys of `object`.
   * @returns {Object} Returns `object`.
   */


  var baseFor = createBaseFor();
  var baseFor$1 = baseFor;
  /**
   * The base implementation of `_.forOwn` without support for iteratee shorthands.
   *
   * @private
   * @param {Object} object The object to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Object} Returns `object`.
   */

  function baseForOwn(object, iteratee) {
    return object && baseFor$1(object, iteratee, keys);
  }
  /** Used to stand-in for `undefined` hash values. */


  var HASH_UNDEFINED = '__lodash_hash_undefined__';
  /**
   * Adds `value` to the array cache.
   *
   * @private
   * @name add
   * @memberOf SetCache
   * @alias push
   * @param {*} value The value to cache.
   * @returns {Object} Returns the cache instance.
   */

  function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);

    return this;
  }
  /**
   * Checks if `value` is in the array cache.
   *
   * @private
   * @name has
   * @memberOf SetCache
   * @param {*} value The value to search for.
   * @returns {number} Returns `true` if `value` is found, else `false`.
   */


  function setCacheHas(value) {
    return this.__data__.has(value);
  }
  /**
   *
   * Creates an array cache object to store unique values.
   *
   * @private
   * @constructor
   * @param {Array} [values] The values to cache.
   */


  function SetCache(values) {
    var index = -1,
        length = values == null ? 0 : values.length;
    this.__data__ = new MapCache();

    while (++index < length) {
      this.add(values[index]);
    }
  } // Add methods to `SetCache`.


  SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
  SetCache.prototype.has = setCacheHas;
  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */

  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }

    return false;
  }
  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */


  function cacheHas(cache, key) {
    return cache.has(key);
  }
  /** Used to compose bitmasks for value comparisons. */


  var COMPARE_PARTIAL_FLAG$5 = 1,
      COMPARE_UNORDERED_FLAG$3 = 2;
  /**
   * A specialized version of `baseIsEqualDeep` for arrays with support for
   * partial deep comparisons.
   *
   * @private
   * @param {Array} array The array to compare.
   * @param {Array} other The other array to compare.
   * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
   * @param {Function} customizer The function to customize comparisons.
   * @param {Function} equalFunc The function to determine equivalents of values.
   * @param {Object} stack Tracks traversed `array` and `other` objects.
   * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
   */

  function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG$5,
        arrLength = array.length,
        othLength = other.length;

    if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
      return false;
    } // Check that cyclic values are equal.


    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);

    if (arrStacked && othStacked) {
      return arrStacked == other && othStacked == array;
    }

    var index = -1,
        result = true,
        seen = bitmask & COMPARE_UNORDERED_FLAG$3 ? new SetCache() : undefined;
    stack.set(array, other);
    stack.set(other, array); // Ignore non-index properties.

    while (++index < arrLength) {
      var arrValue = array[index],
          othValue = other[index];

      if (customizer) {
        var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
      }

      if (compared !== undefined) {
        if (compared) {
          continue;
        }

        result = false;
        break;
      } // Recursively compare arrays (susceptible to call stack limits).


      if (seen) {
        if (!arraySome(other, function (othValue, othIndex) {
          if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            return seen.push(othIndex);
          }
        })) {
          result = false;
          break;
        }
      } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
        result = false;
        break;
      }
    }

    stack['delete'](array);
    stack['delete'](other);
    return result;
  }
  /** Used to compose bitmasks for value comparisons. */


  var COMPARE_PARTIAL_FLAG$4 = 1,
      COMPARE_UNORDERED_FLAG$2 = 2;
  /** `Object#toString` result references. */

  var boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      errorTag = '[object Error]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]';
  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]';
  /** Used to convert symbols to primitives and strings. */

  var symbolProto = Symbol$2 ? Symbol$2.prototype : undefined,
      symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
  /**
   * A specialized version of `baseIsEqualDeep` for comparing objects of
   * the same `toStringTag`.
   *
   * **Note:** This function only supports comparing values with tags of
   * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @param {string} tag The `toStringTag` of the objects to compare.
   * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
   * @param {Function} customizer The function to customize comparisons.
   * @param {Function} equalFunc The function to determine equivalents of values.
   * @param {Object} stack Tracks traversed `object` and `other` objects.
   * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
   */

  function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch (tag) {
      case dataViewTag:
        if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
          return false;
        }

        object = object.buffer;
        other = other.buffer;

      case arrayBufferTag:
        if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array$2(object), new Uint8Array$2(other))) {
          return false;
        }

        return true;

      case boolTag:
      case dateTag:
      case numberTag:
        // Coerce booleans to `1` or `0` and dates to milliseconds.
        // Invalid dates are coerced to `NaN`.
        return eq$1(+object, +other);

      case errorTag:
        return object.name == other.name && object.message == other.message;

      case regexpTag:
      case stringTag:
        // Coerce regexes to strings and treat strings, primitives and objects,
        // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
        // for more details.
        return object == other + '';

      case mapTag:
        var convert = mapToArray;

      case setTag:
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG$4;
        convert || (convert = setToArray);

        if (object.size != other.size && !isPartial) {
          return false;
        } // Assume cyclic values are equal.


        var stacked = stack.get(object);

        if (stacked) {
          return stacked == other;
        }

        bitmask |= COMPARE_UNORDERED_FLAG$2; // Recursively compare objects (susceptible to call stack limits).

        stack.set(object, other);
        var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
        stack['delete'](object);
        return result;

      case symbolTag:
        if (symbolValueOf) {
          return symbolValueOf.call(object) == symbolValueOf.call(other);
        }

    }

    return false;
  }
  /** Used to compose bitmasks for value comparisons. */


  var COMPARE_PARTIAL_FLAG$3 = 1;
  /** Used for built-in method references. */

  var objectProto$1 = Object.prototype;
  /** Used to check objects for own properties. */

  var hasOwnProperty$1 = objectProto$1.hasOwnProperty;
  /**
   * A specialized version of `baseIsEqualDeep` for objects with support for
   * partial deep comparisons.
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
   * @param {Function} customizer The function to customize comparisons.
   * @param {Function} equalFunc The function to determine equivalents of values.
   * @param {Object} stack Tracks traversed `object` and `other` objects.
   * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
   */

  function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG$3,
        objProps = getAllKeys(object),
        objLength = objProps.length,
        othProps = getAllKeys(other),
        othLength = othProps.length;

    if (objLength != othLength && !isPartial) {
      return false;
    }

    var index = objLength;

    while (index--) {
      var key = objProps[index];

      if (!(isPartial ? key in other : hasOwnProperty$1.call(other, key))) {
        return false;
      }
    } // Check that cyclic values are equal.


    var objStacked = stack.get(object);
    var othStacked = stack.get(other);

    if (objStacked && othStacked) {
      return objStacked == other && othStacked == object;
    }

    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;

    while (++index < objLength) {
      key = objProps[index];
      var objValue = object[key],
          othValue = other[key];

      if (customizer) {
        var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
      } // Recursively compare objects (susceptible to call stack limits).


      if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
        result = false;
        break;
      }

      skipCtor || (skipCtor = key == 'constructor');
    }

    if (result && !skipCtor) {
      var objCtor = object.constructor,
          othCtor = other.constructor; // Non `Object` object instances with different constructors are not equal.

      if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) {
        result = false;
      }
    }

    stack['delete'](object);
    stack['delete'](other);
    return result;
  }
  /** Used to compose bitmasks for value comparisons. */


  var COMPARE_PARTIAL_FLAG$2 = 1;
  /** `Object#toString` result references. */

  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      objectTag = '[object Object]';
  /** Used for built-in method references. */

  var objectProto = Object.prototype;
  /** Used to check objects for own properties. */

  var hasOwnProperty = objectProto.hasOwnProperty;
  /**
   * A specialized version of `baseIsEqual` for arrays and objects which performs
   * deep comparisons and tracks traversed objects enabling objects with circular
   * references to be compared.
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
   * @param {Function} customizer The function to customize comparisons.
   * @param {Function} equalFunc The function to determine equivalents of values.
   * @param {Object} [stack] Tracks traversed `object` and `other` objects.
   * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
   */

  function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray$1(object),
        othIsArr = isArray$1(other),
        objTag = objIsArr ? arrayTag : getTag$1(object),
        othTag = othIsArr ? arrayTag : getTag$1(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag,
        othIsObj = othTag == objectTag,
        isSameTag = objTag == othTag;

    if (isSameTag && isBuffer$1(object)) {
      if (!isBuffer$1(other)) {
        return false;
      }

      objIsArr = true;
      objIsObj = false;
    }

    if (isSameTag && !objIsObj) {
      stack || (stack = new Stack$1());
      return objIsArr || isTypedArray$1(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }

    if (!(bitmask & COMPARE_PARTIAL_FLAG$2)) {
      var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
          othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

      if (objIsWrapped || othIsWrapped) {
        var objUnwrapped = objIsWrapped ? object.value() : object,
            othUnwrapped = othIsWrapped ? other.value() : other;
        stack || (stack = new Stack$1());
        return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
      }
    }

    if (!isSameTag) {
      return false;
    }

    stack || (stack = new Stack$1());
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
  }
  /**
   * The base implementation of `_.isEqual` which supports partial comparisons
   * and tracks traversed objects.
   *
   * @private
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @param {boolean} bitmask The bitmask flags.
   *  1 - Unordered comparison
   *  2 - Partial comparison
   * @param {Function} [customizer] The function to customize comparisons.
   * @param {Object} [stack] Tracks traversed `value` and `other` objects.
   * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
   */


  function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) {
      return true;
    }

    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
      return value !== value && other !== other;
    }

    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
  }
  /** Used to compose bitmasks for value comparisons. */


  var COMPARE_PARTIAL_FLAG$1 = 1,
      COMPARE_UNORDERED_FLAG$1 = 2;
  /**
   * The base implementation of `_.isMatch` without support for iteratee shorthands.
   *
   * @private
   * @param {Object} object The object to inspect.
   * @param {Object} source The object of property values to match.
   * @param {Array} matchData The property names, values, and compare flags to match.
   * @param {Function} [customizer] The function to customize comparisons.
   * @returns {boolean} Returns `true` if `object` is a match, else `false`.
   */

  function baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length,
        length = index,
        noCustomizer = !customizer;

    if (object == null) {
      return !length;
    }

    object = Object(object);

    while (index--) {
      var data = matchData[index];

      if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
        return false;
      }
    }

    while (++index < length) {
      data = matchData[index];
      var key = data[0],
          objValue = object[key],
          srcValue = data[1];

      if (noCustomizer && data[2]) {
        if (objValue === undefined && !(key in object)) {
          return false;
        }
      } else {
        var stack = new Stack$1();

        if (customizer) {
          var result = customizer(objValue, srcValue, key, object, source, stack);
        }

        if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG$1 | COMPARE_UNORDERED_FLAG$1, customizer, stack) : result)) {
          return false;
        }
      }
    }

    return true;
  }
  /**
   * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` if suitable for strict
   *  equality comparisons, else `false`.
   */


  function isStrictComparable(value) {
    return value === value && !isObject$5(value);
  }
  /**
   * Gets the property names, values, and compare flags of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the match data of `object`.
   */


  function getMatchData(object) {
    var result = keys(object),
        length = result.length;

    while (length--) {
      var key = result[length],
          value = object[key];
      result[length] = [key, value, isStrictComparable(value)];
    }

    return result;
  }
  /**
   * A specialized version of `matchesProperty` for source values suitable
   * for strict equality comparisons, i.e. `===`.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @param {*} srcValue The value to match.
   * @returns {Function} Returns the new spec function.
   */


  function matchesStrictComparable(key, srcValue) {
    return function (object) {
      if (object == null) {
        return false;
      }

      return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
  }
  /**
   * The base implementation of `_.matches` which doesn't clone `source`.
   *
   * @private
   * @param {Object} source The object of property values to match.
   * @returns {Function} Returns the new spec function.
   */


  function baseMatches(source) {
    var matchData = getMatchData(source);

    if (matchData.length == 1 && matchData[0][2]) {
      return matchesStrictComparable(matchData[0][0], matchData[0][1]);
    }

    return function (object) {
      return object === source || baseIsMatch(object, source, matchData);
    };
  }
  /**
   * The base implementation of `_.get` without support for default values.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array|string} path The path of the property to get.
   * @returns {*} Returns the resolved value.
   */


  function baseGet(object, path) {
    path = castPath(path, object);
    var index = 0,
        length = path.length;

    while (object != null && index < length) {
      object = object[toKey(path[index++])];
    }

    return index && index == length ? object : undefined;
  }
  /**
   * Gets the value at `path` of `object`. If the resolved value is
   * `undefined`, the `defaultValue` is returned in its place.
   *
   * @static
   * @memberOf _
   * @since 3.7.0
   * @category Object
   * @param {Object} object The object to query.
   * @param {Array|string} path The path of the property to get.
   * @param {*} [defaultValue] The value returned for `undefined` resolved values.
   * @returns {*} Returns the resolved value.
   * @example
   *
   * var object = { 'a': [{ 'b': { 'c': 3 } }] };
   *
   * _.get(object, 'a[0].b.c');
   * // => 3
   *
   * _.get(object, ['a', '0', 'b', 'c']);
   * // => 3
   *
   * _.get(object, 'a.b.c', 'default');
   * // => 'default'
   */


  function get(object, path, defaultValue) {
    var result = object == null ? undefined : baseGet(object, path);
    return result === undefined ? defaultValue : result;
  }
  /**
   * The base implementation of `_.hasIn` without support for deep paths.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {Array|string} key The key to check.
   * @returns {boolean} Returns `true` if `key` exists, else `false`.
   */


  function baseHasIn(object, key) {
    return object != null && key in Object(object);
  }
  /**
   * Checks if `path` is a direct or inherited property of `object`.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Object
   * @param {Object} object The object to query.
   * @param {Array|string} path The path to check.
   * @returns {boolean} Returns `true` if `path` exists, else `false`.
   * @example
   *
   * var object = _.create({ 'a': _.create({ 'b': 2 }) });
   *
   * _.hasIn(object, 'a');
   * // => true
   *
   * _.hasIn(object, 'a.b');
   * // => true
   *
   * _.hasIn(object, ['a', 'b']);
   * // => true
   *
   * _.hasIn(object, 'b');
   * // => false
   */


  function hasIn(object, path) {
    return object != null && hasPath(object, path, baseHasIn);
  }
  /** Used to compose bitmasks for value comparisons. */


  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;
  /**
   * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
   *
   * @private
   * @param {string} path The path of the property to get.
   * @param {*} srcValue The value to match.
   * @returns {Function} Returns the new spec function.
   */

  function baseMatchesProperty(path, srcValue) {
    if (isKey(path) && isStrictComparable(srcValue)) {
      return matchesStrictComparable(toKey(path), srcValue);
    }

    return function (object) {
      var objValue = get(object, path);
      return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
    };
  }
  /**
   * This method returns the first argument it receives.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Util
   * @param {*} value Any value.
   * @returns {*} Returns `value`.
   * @example
   *
   * var object = { 'a': 1 };
   *
   * console.log(_.identity(object) === object);
   * // => true
   */


  function identity(value) {
    return value;
  }
  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */


  function baseProperty(key) {
    return function (object) {
      return object == null ? undefined : object[key];
    };
  }
  /**
   * A specialized version of `baseProperty` which supports deep paths.
   *
   * @private
   * @param {Array|string} path The path of the property to get.
   * @returns {Function} Returns the new accessor function.
   */


  function basePropertyDeep(path) {
    return function (object) {
      return baseGet(object, path);
    };
  }
  /**
   * Creates a function that returns the value at `path` of a given object.
   *
   * @static
   * @memberOf _
   * @since 2.4.0
   * @category Util
   * @param {Array|string} path The path of the property to get.
   * @returns {Function} Returns the new accessor function.
   * @example
   *
   * var objects = [
   *   { 'a': { 'b': 2 } },
   *   { 'a': { 'b': 1 } }
   * ];
   *
   * _.map(objects, _.property('a.b'));
   * // => [2, 1]
   *
   * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
   * // => [1, 2]
   */


  function property(path) {
    return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
  }
  /**
   * The base implementation of `_.iteratee`.
   *
   * @private
   * @param {*} [value=_.identity] The value to convert to an iteratee.
   * @returns {Function} Returns the iteratee.
   */


  function baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') {
      return value;
    }

    if (value == null) {
      return identity;
    }

    if (typeof value == 'object') {
      return isArray$1(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
    }

    return property(value);
  }
  /**
   * Creates an object with the same keys as `object` and values generated
   * by running each own enumerable string keyed property of `object` thru
   * `iteratee`. The iteratee is invoked with three arguments:
   * (value, key, object).
   *
   * @static
   * @memberOf _
   * @since 2.4.0
   * @category Object
   * @param {Object} object The object to iterate over.
   * @param {Function} [iteratee=_.identity] The function invoked per iteration.
   * @returns {Object} Returns the new mapped object.
   * @see _.mapKeys
   * @example
   *
   * var users = {
   *   'fred':    { 'user': 'fred',    'age': 40 },
   *   'pebbles': { 'user': 'pebbles', 'age': 1 }
   * };
   *
   * _.mapValues(users, function(o) { return o.age; });
   * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
   *
   * // The `_.property` iteratee shorthand.
   * _.mapValues(users, 'age');
   * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
   */


  function mapValues(object, iteratee) {
    var result = {};
    iteratee = baseIteratee(iteratee);
    baseForOwn(object, function (value, key, object) {
      baseAssignValue(result, key, iteratee(value, key, object));
    });
    return result;
  }
  /**
   * Based on Kendo UI Core expression code <https://github.com/telerik/kendo-ui-core#license-information>
   */


  function Cache(maxSize) {
    this._maxSize = maxSize;
    this.clear();
  }

  Cache.prototype.clear = function () {
    this._size = 0;
    this._values = Object.create(null);
  };

  Cache.prototype.get = function (key) {
    return this._values[key];
  };

  Cache.prototype.set = function (key, value) {
    this._size >= this._maxSize && this.clear();
    if (!(key in this._values)) this._size++;
    return this._values[key] = value;
  };

  var SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g,
      DIGIT_REGEX = /^\d+$/,
      LEAD_DIGIT_REGEX = /^\d/,
      SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g,
      CLEAN_QUOTES_REGEX = /^\s*(['"]?)(.*?)(\1)\s*$/,
      MAX_CACHE_SIZE = 512;
  var pathCache = new Cache(MAX_CACHE_SIZE),
      setCache = new Cache(MAX_CACHE_SIZE),
      getCache = new Cache(MAX_CACHE_SIZE);
  var propertyExpr = {
    Cache: Cache,
    split: split,
    normalizePath: normalizePath,
    setter: function setter(path) {
      var parts = normalizePath(path);
      return setCache.get(path) || setCache.set(path, function setter(obj, value) {
        var index = 0;
        var len = parts.length;
        var data = obj;

        while (index < len - 1) {
          var part = parts[index];

          if (part === '__proto__' || part === 'constructor' || part === 'prototype') {
            return obj;
          }

          data = data[parts[index++]];
        }

        data[parts[index]] = value;
      });
    },
    getter: function getter(path, safe) {
      var parts = normalizePath(path);
      return getCache.get(path) || getCache.set(path, function getter(data) {
        var index = 0,
            len = parts.length;

        while (index < len) {
          if (data != null || !safe) data = data[parts[index++]];else return;
        }

        return data;
      });
    },
    join: function join(segments) {
      return segments.reduce(function (path, part) {
        return path + (isQuoted(part) || DIGIT_REGEX.test(part) ? '[' + part + ']' : (path ? '.' : '') + part);
      }, '');
    },
    forEach: function forEach(path, cb, thisArg) {
      _forEach(Array.isArray(path) ? path : split(path), cb, thisArg);
    }
  };

  function normalizePath(path) {
    return pathCache.get(path) || pathCache.set(path, split(path).map(function (part) {
      return part.replace(CLEAN_QUOTES_REGEX, '$2');
    }));
  }

  function split(path) {
    return path.match(SPLIT_REGEX);
  }

  function _forEach(parts, iter, thisArg) {
    var len = parts.length,
        part,
        idx,
        isArray,
        isBracket;

    for (idx = 0; idx < len; idx++) {
      part = parts[idx];

      if (part) {
        if (shouldBeQuoted(part)) {
          part = '"' + part + '"';
        }

        isBracket = isQuoted(part);
        isArray = !isBracket && /^\d+$/.test(part);
        iter.call(thisArg, part, isBracket, isArray, idx, parts);
      }
    }
  }

  function isQuoted(str) {
    return typeof str === 'string' && str && ["'", '"'].indexOf(str.charAt(0)) !== -1;
  }

  function hasLeadingNumber(part) {
    return part.match(LEAD_DIGIT_REGEX) && !part.match(DIGIT_REGEX);
  }

  function hasSpecialChars(part) {
    return SPEC_CHAR_REGEX.test(part);
  }

  function shouldBeQuoted(part) {
    return !isQuoted(part) && (hasLeadingNumber(part) || hasSpecialChars(part));
  }

  var prefixes = {
    context: '$',
    value: '.'
  };

  var Reference = /*#__PURE__*/function () {
    function Reference(key, options) {
      if (options === void 0) {
        options = {};
      }

      if (typeof key !== 'string') throw new TypeError('ref must be a string, got: ' + key);
      this.key = key.trim();
      if (key === '') throw new TypeError('ref must be a non-empty string');
      this.isContext = this.key[0] === prefixes.context;
      this.isValue = this.key[0] === prefixes.value;
      this.isSibling = !this.isContext && !this.isValue;
      var prefix = this.isContext ? prefixes.context : this.isValue ? prefixes.value : '';
      this.path = this.key.slice(prefix.length);
      this.getter = this.path && propertyExpr.getter(this.path, true);
      this.map = options.map;
    }

    var _proto = Reference.prototype;

    _proto.getValue = function getValue(value, parent, context) {
      var result = this.isContext ? context : this.isValue ? value : parent;
      if (this.getter) result = this.getter(result || {});
      if (this.map) result = this.map(result);
      return result;
    }
    /**
     *
     * @param {*} value
     * @param {Object} options
     * @param {Object=} options.context
     * @param {Object=} options.parent
     */
    ;

    _proto.cast = function cast(value, options) {
      return this.getValue(value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context);
    };

    _proto.resolve = function resolve() {
      return this;
    };

    _proto.describe = function describe() {
      return {
        type: 'ref',
        key: this.key
      };
    };

    _proto.toString = function toString() {
      return "Ref(" + this.key + ")";
    };

    Reference.isRef = function isRef(value) {
      return value && value.__isYupRef;
    };

    return Reference;
  }();

  Reference.prototype.__isYupRef = true;

  function createValidation(config) {
    function validate(_ref, cb) {
      var value = _ref.value,
          path = _ref.path,
          label = _ref.label,
          options = _ref.options,
          originalValue = _ref.originalValue,
          sync = _ref.sync,
          rest = _objectWithoutPropertiesLoose$3(_ref, ["value", "path", "label", "options", "originalValue", "sync"]);

      var name = config.name,
          test = config.test,
          params = config.params,
          message = config.message;
      var parent = options.parent,
          context = options.context;

      function resolve(item) {
        return Reference.isRef(item) ? item.getValue(value, parent, context) : item;
      }

      function createError(overrides) {
        if (overrides === void 0) {
          overrides = {};
        }

        var nextParams = mapValues(_extends$6({
          value: value,
          originalValue: originalValue,
          label: label,
          path: overrides.path || path
        }, params, overrides.params), resolve);
        var error = new ValidationError(ValidationError.formatError(overrides.message || message, nextParams), value, nextParams.path, overrides.type || name);
        error.params = nextParams;
        return error;
      }

      var ctx = _extends$6({
        path: path,
        parent: parent,
        type: name,
        createError: createError,
        resolve: resolve,
        options: options,
        originalValue: originalValue
      }, rest);

      if (!sync) {
        try {
          Promise.resolve(test.call(ctx, value, ctx)).then(function (validOrError) {
            if (ValidationError.isError(validOrError)) cb(validOrError);else if (!validOrError) cb(createError());else cb(null, validOrError);
          });
        } catch (err) {
          cb(err);
        }

        return;
      }

      var result;

      try {
        var _result;

        result = test.call(ctx, value, ctx);

        if (typeof ((_result = result) == null ? void 0 : _result.then) === 'function') {
          throw new Error("Validation test of type: \"" + ctx.type + "\" returned a Promise during a synchronous validate. " + "This test will finish after the validate call has returned");
        }
      } catch (err) {
        cb(err);
        return;
      }

      if (ValidationError.isError(result)) cb(result);else if (!result) cb(createError());else cb(null, result);
    }

    validate.OPTIONS = config;
    return validate;
  }

  var trim = function trim(part) {
    return part.substr(0, part.length - 1).substr(1);
  };

  function getIn(schema, path, value, context) {
    if (context === void 0) {
      context = value;
    }

    var parent, lastPart, lastPartDebug; // root path: ''

    if (!path) return {
      parent: parent,
      parentPath: path,
      schema: schema
    };
    propertyExpr.forEach(path, function (_part, isBracket, isArray) {
      var part = isBracket ? trim(_part) : _part;
      schema = schema.resolve({
        context: context,
        parent: parent,
        value: value
      });

      if (schema.innerType) {
        var idx = isArray ? parseInt(part, 10) : 0;

        if (value && idx >= value.length) {
          throw new Error("Yup.reach cannot resolve an array item at index: " + _part + ", in the path: " + path + ". " + "because there is no value at that index. ");
        }

        parent = value;
        value = value && value[idx];
        schema = schema.innerType;
      } // sometimes the array index part of a path doesn't exist: "nested.arr.child"
      // in these cases the current part is the next schema and should be processed
      // in this iteration. For cases where the index signature is included this
      // check will fail and we'll handle the `child` part on the next iteration like normal


      if (!isArray) {
        if (!schema.fields || !schema.fields[part]) throw new Error("The schema does not contain the path: " + path + ". " + ("(failed at: " + lastPartDebug + " which is a type: \"" + schema._type + "\")"));
        parent = value;
        value = value && value[part];
        schema = schema.fields[part];
      }

      lastPart = part;
      lastPartDebug = isBracket ? '[' + _part + ']' : '.' + _part;
    });
    return {
      schema: schema,
      parent: parent,
      parentPath: lastPart
    };
  }

  var reach = function reach(obj, path, value, context) {
    return getIn(obj, path, value, context).schema;
  };

  function _createForOfIteratorHelperLoose$1(o, allowArrayLike) {
    var it;

    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
      if (Array.isArray(o) || (it = _unsupportedIterableToArray$1(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        };
      }

      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }

    it = o[Symbol.iterator]();
    return it.next.bind(it);
  }

  function _unsupportedIterableToArray$1(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray$1(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen);
  }

  function _arrayLikeToArray$1(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }

  var RefSet = /*#__PURE__*/function () {
    function RefSet() {
      this.list = new Set();
      this.refs = new Map();
    }

    var _proto = RefSet.prototype;

    _proto.describe = function describe() {
      var description = [];

      for (var _iterator = _createForOfIteratorHelperLoose$1(this.list), _step; !(_step = _iterator()).done;) {
        var item = _step.value;
        description.push(item);
      }

      for (var _iterator2 = _createForOfIteratorHelperLoose$1(this.refs), _step2; !(_step2 = _iterator2()).done;) {
        var _step2$value = _step2.value,
            ref = _step2$value[1];
        description.push(ref.describe());
      }

      return description;
    };

    _proto.toArray = function toArray$1() {
      return toArray(this.list).concat(toArray(this.refs.values()));
    };

    _proto.add = function add(value) {
      Reference.isRef(value) ? this.refs.set(value.key, value) : this.list.add(value);
    };

    _proto.delete = function _delete(value) {
      Reference.isRef(value) ? this.refs.delete(value.key) : this.list.delete(value);
    };

    _proto.has = function has(value, resolve) {
      if (this.list.has(value)) return true;
      var item,
          values = this.refs.values();

      while (item = values.next(), !item.done) {
        if (resolve(item.value) === value) return true;
      }

      return false;
    };

    _proto.clone = function clone() {
      var next = new RefSet();
      next.list = new Set(this.list);
      next.refs = new Map(this.refs);
      return next;
    };

    _proto.merge = function merge(newItems, removeItems) {
      var next = this.clone();
      newItems.list.forEach(function (value) {
        return next.add(value);
      });
      newItems.refs.forEach(function (value) {
        return next.add(value);
      });
      removeItems.list.forEach(function (value) {
        return next.delete(value);
      });
      removeItems.refs.forEach(function (value) {
        return next.delete(value);
      });
      return next;
    };

    _createClass$1(RefSet, [{
      key: "size",
      get: function get() {
        return this.list.size + this.refs.size;
      }
    }]);

    return RefSet;
  }();

  function SchemaType(options) {
    var _this = this;

    if (options === void 0) {
      options = {};
    }

    if (!(this instanceof SchemaType)) return new SchemaType();
    this._deps = [];
    this._conditions = [];
    this._options = {
      abortEarly: true,
      recursive: true
    };
    this._exclusive = Object.create(null);
    this._whitelist = new RefSet();
    this._blacklist = new RefSet();
    this.tests = [];
    this.transforms = [];
    this.withMutation(function () {
      _this.typeError(mixed.notType);
    });
    if (has(options, 'default')) this._defaultDefault = options.default;
    this.type = options.type || 'mixed'; // TODO: remove

    this._type = options.type || 'mixed';
  }

  var proto = SchemaType.prototype = {
    __isYupSchema__: true,
    constructor: SchemaType,
    clone: function clone() {
      var _this2 = this;

      if (this._mutate) return this; // if the nested value is a schema we can skip cloning, since
      // they are already immutable

      return cloneDeepWith(this, function (value, key) {
        if (isSchema(value) && value !== _this2) return value; // fix for ie11 when cloning Set and Map

        if (key === '_whitelist' || key === '_blacklist') {
          return value.clone();
        }
      });
    },
    label: function label(_label) {
      var next = this.clone();
      next._label = _label;
      return next;
    },
    meta: function meta(obj) {
      if (arguments.length === 0) return this._meta;
      var next = this.clone();
      next._meta = _extends$6(next._meta || {}, obj);
      return next;
    },
    withMutation: function withMutation(fn) {
      var before = this._mutate;
      this._mutate = true;
      var result = fn(this);
      this._mutate = before;
      return result;
    },
    concat: function concat(schema) {
      if (!schema || schema === this) return this;
      if (schema._type !== this._type && this._type !== 'mixed') throw new TypeError("You cannot `concat()` schema's of different types: " + this._type + " and " + schema._type);
      var next = prependDeep(schema.clone(), this); // new undefined default is overridden by old non-undefined one, revert

      if (has(schema, '_default')) next._default = schema._default;
      next.tests = this.tests;
      next._exclusive = this._exclusive; // manually merge the blacklist/whitelist (the other `schema` takes
      // precedence in case of conflicts)

      next._whitelist = this._whitelist.merge(schema._whitelist, schema._blacklist);
      next._blacklist = this._blacklist.merge(schema._blacklist, schema._whitelist); // manually add the new tests to ensure
      // the deduping logic is consistent

      next.withMutation(function (next) {
        schema.tests.forEach(function (fn) {
          next.test(fn.OPTIONS);
        });
      });
      return next;
    },
    isType: function isType(v) {
      if (this._nullable && v === null) return true;
      return !this._typeCheck || this._typeCheck(v);
    },
    resolve: function resolve(options) {
      var schema = this;

      if (schema._conditions.length) {
        var conditions = schema._conditions;
        schema = schema.clone();
        schema._conditions = [];
        schema = conditions.reduce(function (schema, condition) {
          return condition.resolve(schema, options);
        }, schema);
        schema = schema.resolve(options);
      }

      return schema;
    },

    /**
     *
     * @param {*} value
     * @param {Object} options
     * @param {*=} options.parent
     * @param {*=} options.context
     */
    cast: function cast(value, options) {
      if (options === void 0) {
        options = {};
      }

      var resolvedSchema = this.resolve(_extends$6({
        value: value
      }, options));

      var result = resolvedSchema._cast(value, options);

      if (value !== undefined && options.assert !== false && resolvedSchema.isType(result) !== true) {
        var formattedValue = printValue(value);
        var formattedResult = printValue(result);
        throw new TypeError("The value of " + (options.path || 'field') + " could not be cast to a value " + ("that satisfies the schema type: \"" + resolvedSchema._type + "\". \n\n") + ("attempted value: " + formattedValue + " \n") + (formattedResult !== formattedValue ? "result of cast: " + formattedResult : ''));
      }

      return result;
    },
    _cast: function _cast(rawValue) {
      var _this3 = this;

      var value = rawValue === undefined ? rawValue : this.transforms.reduce(function (value, fn) {
        return fn.call(_this3, value, rawValue);
      }, rawValue);

      if (value === undefined && has(this, '_default')) {
        value = this.getDefault();
      }

      return value;
    },
    _validate: function _validate(_value, options, cb) {
      var _this4 = this;

      if (options === void 0) {
        options = {};
      }

      var _options = options,
          sync = _options.sync,
          path = _options.path,
          _options$from = _options.from,
          from = _options$from === void 0 ? [] : _options$from,
          _options$originalValu = _options.originalValue,
          originalValue = _options$originalValu === void 0 ? _value : _options$originalValu,
          _options$strict = _options.strict,
          strict = _options$strict === void 0 ? this._options.strict : _options$strict,
          _options$abortEarly = _options.abortEarly,
          abortEarly = _options$abortEarly === void 0 ? this._options.abortEarly : _options$abortEarly;
      var value = _value;

      if (!strict) {
        this._validating = true;
        value = this._cast(value, _extends$6({
          assert: false
        }, options));
        this._validating = false;
      } // value is cast, we can check if it meets type requirements


      var args = {
        value: value,
        path: path,
        options: options,
        originalValue: originalValue,
        schema: this,
        label: this._label,
        sync: sync,
        from: from
      };
      var initialTests = [];
      if (this._typeError) initialTests.push(this._typeError);
      if (this._whitelistError) initialTests.push(this._whitelistError);
      if (this._blacklistError) initialTests.push(this._blacklistError);
      return runTests({
        args: args,
        value: value,
        path: path,
        sync: sync,
        tests: initialTests,
        endEarly: abortEarly
      }, function (err) {
        if (err) return void cb(err);
        runTests({
          tests: _this4.tests,
          args: args,
          path: path,
          sync: sync,
          value: value,
          endEarly: abortEarly
        }, cb);
      });
    },
    validate: function validate(value, options, maybeCb) {
      if (options === void 0) {
        options = {};
      }

      var schema = this.resolve(_extends$6({}, options, {
        value: value
      })); // callback case is for nested validations

      return typeof maybeCb === 'function' ? schema._validate(value, options, maybeCb) : new Promise(function (resolve, reject) {
        return schema._validate(value, options, function (err, value) {
          if (err) reject(err);else resolve(value);
        });
      });
    },
    validateSync: function validateSync(value, options) {
      if (options === void 0) {
        options = {};
      }

      var schema = this.resolve(_extends$6({}, options, {
        value: value
      }));
      var result;

      schema._validate(value, _extends$6({}, options, {
        sync: true
      }), function (err, value) {
        if (err) throw err;
        result = value;
      });

      return result;
    },
    isValid: function isValid(value, options) {
      return this.validate(value, options).then(function () {
        return true;
      }).catch(function (err) {
        if (err.name === 'ValidationError') return false;
        throw err;
      });
    },
    isValidSync: function isValidSync(value, options) {
      try {
        this.validateSync(value, options);
        return true;
      } catch (err) {
        if (err.name === 'ValidationError') return false;
        throw err;
      }
    },
    _getDefault: function _getDefault() {
      var defaultValue = has(this, '_default') ? this._default : this._defaultDefault;
      return typeof defaultValue === 'function' ? defaultValue.call(this) : cloneDeepWith(defaultValue);
    },
    getDefault: function getDefault(options) {
      if (options === void 0) {
        options = {};
      }

      var schema = this.resolve(options);
      return schema._getDefault();
    },
    default: function _default(def) {
      if (arguments.length === 0) {
        console.warn('Calling `schema.default()` as a getter to retrieve a default is deprecated and will be removed in the next version. \n' + 'Use `schema.getDefault()` instead.');
        return this._getDefault();
      }

      var next = this.clone();
      next._default = def;
      return next;
    },
    strict: function strict(isStrict) {
      if (isStrict === void 0) {
        isStrict = true;
      }

      var next = this.clone();
      next._options.strict = isStrict;
      return next;
    },
    _isPresent: function _isPresent(value) {
      return value != null;
    },
    required: function required(message) {
      if (message === void 0) {
        message = mixed.required;
      }

      return this.test({
        message: message,
        name: 'required',
        exclusive: true,
        test: function test(value) {
          return this.schema._isPresent(value);
        }
      });
    },
    notRequired: function notRequired() {
      var next = this.clone();
      next.tests = next.tests.filter(function (test) {
        return test.OPTIONS.name !== 'required';
      });
      return next;
    },
    nullable: function nullable(isNullable) {
      if (isNullable === void 0) {
        isNullable = true;
      }

      var next = this.clone();
      next._nullable = isNullable;
      return next;
    },
    transform: function transform(fn) {
      var next = this.clone();
      next.transforms.push(fn);
      return next;
    },

    /**
     * Adds a test function to the schema's queue of tests.
     * tests can be exclusive or non-exclusive.
     *
     * - exclusive tests, will replace any existing tests of the same name.
     * - non-exclusive: can be stacked
     *
     * If a non-exclusive test is added to a schema with an exclusive test of the same name
     * the exclusive test is removed and further tests of the same name will be stacked.
     *
     * If an exclusive test is added to a schema with non-exclusive tests of the same name
     * the previous tests are removed and further tests of the same name will replace each other.
     */
    test: function test() {
      var opts;

      if (arguments.length === 1) {
        if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === 'function') {
          opts = {
            test: arguments.length <= 0 ? undefined : arguments[0]
          };
        } else {
          opts = arguments.length <= 0 ? undefined : arguments[0];
        }
      } else if (arguments.length === 2) {
        opts = {
          name: arguments.length <= 0 ? undefined : arguments[0],
          test: arguments.length <= 1 ? undefined : arguments[1]
        };
      } else {
        opts = {
          name: arguments.length <= 0 ? undefined : arguments[0],
          message: arguments.length <= 1 ? undefined : arguments[1],
          test: arguments.length <= 2 ? undefined : arguments[2]
        };
      }

      if (opts.message === undefined) opts.message = mixed.default;
      if (typeof opts.test !== 'function') throw new TypeError('`test` is a required parameters');
      var next = this.clone();
      var validate = createValidation(opts);
      var isExclusive = opts.exclusive || opts.name && next._exclusive[opts.name] === true;

      if (opts.exclusive && !opts.name) {
        throw new TypeError('Exclusive tests must provide a unique `name` identifying the test');
      }

      next._exclusive[opts.name] = !!opts.exclusive;
      next.tests = next.tests.filter(function (fn) {
        if (fn.OPTIONS.name === opts.name) {
          if (isExclusive) return false;
          if (fn.OPTIONS.test === validate.OPTIONS.test) return false;
        }

        return true;
      });
      next.tests.push(validate);
      return next;
    },
    when: function when(keys, options) {
      if (arguments.length === 1) {
        options = keys;
        keys = '.';
      }

      var next = this.clone(),
          deps = [].concat(keys).map(function (key) {
        return new Reference(key);
      });
      deps.forEach(function (dep) {
        if (dep.isSibling) next._deps.push(dep.key);
      });

      next._conditions.push(new Condition(deps, options));

      return next;
    },
    typeError: function typeError(message) {
      var next = this.clone();
      next._typeError = createValidation({
        message: message,
        name: 'typeError',
        test: function test(value) {
          if (value !== undefined && !this.schema.isType(value)) return this.createError({
            params: {
              type: this.schema._type
            }
          });
          return true;
        }
      });
      return next;
    },
    oneOf: function oneOf(enums, message) {
      if (message === void 0) {
        message = mixed.oneOf;
      }

      var next = this.clone();
      enums.forEach(function (val) {
        next._whitelist.add(val);

        next._blacklist.delete(val);
      });
      next._whitelistError = createValidation({
        message: message,
        name: 'oneOf',
        test: function test(value) {
          if (value === undefined) return true;
          var valids = this.schema._whitelist;
          return valids.has(value, this.resolve) ? true : this.createError({
            params: {
              values: valids.toArray().join(', ')
            }
          });
        }
      });
      return next;
    },
    notOneOf: function notOneOf(enums, message) {
      if (message === void 0) {
        message = mixed.notOneOf;
      }

      var next = this.clone();
      enums.forEach(function (val) {
        next._blacklist.add(val);

        next._whitelist.delete(val);
      });
      next._blacklistError = createValidation({
        message: message,
        name: 'notOneOf',
        test: function test(value) {
          var invalids = this.schema._blacklist;
          if (invalids.has(value, this.resolve)) return this.createError({
            params: {
              values: invalids.toArray().join(', ')
            }
          });
          return true;
        }
      });
      return next;
    },
    strip: function strip(_strip) {
      if (_strip === void 0) {
        _strip = true;
      }

      var next = this.clone();
      next._strip = _strip;
      return next;
    },
    _option: function _option(key, overrides) {
      return has(overrides, key) ? overrides[key] : this._options[key];
    },
    describe: function describe() {
      var next = this.clone();
      var description = {
        type: next._type,
        meta: next._meta,
        label: next._label,
        tests: next.tests.map(function (fn) {
          return {
            name: fn.OPTIONS.name,
            params: fn.OPTIONS.params
          };
        }).filter(function (n, idx, list) {
          return list.findIndex(function (c) {
            return c.name === n.name;
          }) === idx;
        })
      };
      if (next._whitelist.size) description.oneOf = next._whitelist.describe();
      if (next._blacklist.size) description.notOneOf = next._blacklist.describe();
      return description;
    },
    defined: function defined(message) {
      if (message === void 0) {
        message = mixed.defined;
      }

      return this.test({
        message: message,
        name: 'defined',
        exclusive: true,
        test: function test(value) {
          return value !== undefined;
        }
      });
    }
  };

  var _loop = function _loop() {
    var method = _arr[_i];

    proto[method + "At"] = function (path, value, options) {
      if (options === void 0) {
        options = {};
      }

      var _getIn = getIn(this, path, value, options.context),
          parent = _getIn.parent,
          parentPath = _getIn.parentPath,
          schema = _getIn.schema;

      return schema[method](parent && parent[parentPath], _extends$6({}, options, {
        parent: parent,
        path: path
      }));
    };
  };

  for (var _i = 0, _arr = ['validate', 'validateSync']; _i < _arr.length; _i++) {
    _loop();
  }

  for (var _i2 = 0, _arr2 = ['equals', 'is']; _i2 < _arr2.length; _i2++) {
    var alias = _arr2[_i2];
    proto[alias] = proto.oneOf;
  }

  for (var _i3 = 0, _arr3 = ['not', 'nope']; _i3 < _arr3.length; _i3++) {
    var _alias = _arr3[_i3];
    proto[_alias] = proto.notOneOf;
  }

  proto.optional = proto.notRequired;

  function inherits(ctor, superCtor, spec) {
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });

    _extends$6(ctor.prototype, spec);
  }

  var isAbsent = function isAbsent(value) {
    return value == null;
  };

  function BooleanSchema() {
    var _this = this;

    if (!(this instanceof BooleanSchema)) return new BooleanSchema();
    SchemaType.call(this, {
      type: 'boolean'
    });
    this.withMutation(function () {
      _this.transform(function (value) {
        if (!this.isType(value)) {
          if (/^(true|1)$/i.test(value)) return true;
          if (/^(false|0)$/i.test(value)) return false;
        }

        return value;
      });
    });
  }

  inherits(BooleanSchema, SchemaType, {
    _typeCheck: function _typeCheck(v) {
      if (v instanceof Boolean) v = v.valueOf();
      return typeof v === 'boolean';
    },
    isTrue: function isTrue(message) {
      if (message === void 0) {
        message = boolean$1.isValue;
      }

      return this.test({
        message: message,
        name: 'is-value',
        exclusive: true,
        params: {
          value: 'true'
        },
        test: function test(value) {
          return isAbsent(value) || value === true;
        }
      });
    },
    isFalse: function isFalse(message) {
      if (message === void 0) {
        message = boolean$1.isValue;
      }

      return this.test({
        message: message,
        name: 'is-value',
        exclusive: true,
        params: {
          value: 'false'
        },
        test: function test(value) {
          return isAbsent(value) || value === false;
        }
      });
    }
  });
  var rEmail = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i; // eslint-disable-next-line

  var rUrl = /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i; // eslint-disable-next-line

  var rUUID = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

  var isTrimmed = function isTrimmed(value) {
    return isAbsent(value) || value === value.trim();
  };

  var objStringTag = {}.toString();

  function StringSchema() {
    var _this = this;

    if (!(this instanceof StringSchema)) return new StringSchema();
    SchemaType.call(this, {
      type: 'string'
    });
    this.withMutation(function () {
      _this.transform(function (value) {
        if (this.isType(value)) return value;
        if (Array.isArray(value)) return value;
        var strValue = value != null && value.toString ? value.toString() : value;
        if (strValue === objStringTag) return value;
        return strValue;
      });
    });
  }

  inherits(StringSchema, SchemaType, {
    _typeCheck: function _typeCheck(value) {
      if (value instanceof String) value = value.valueOf();
      return typeof value === 'string';
    },
    _isPresent: function _isPresent(value) {
      return SchemaType.prototype._isPresent.call(this, value) && !!value.length;
    },
    length: function length(_length, message) {
      if (message === void 0) {
        message = string.length;
      }

      return this.test({
        message: message,
        name: 'length',
        exclusive: true,
        params: {
          length: _length
        },
        test: function test(value) {
          return isAbsent(value) || value.length === this.resolve(_length);
        }
      });
    },
    min: function min(_min, message) {
      if (message === void 0) {
        message = string.min;
      }

      return this.test({
        message: message,
        name: 'min',
        exclusive: true,
        params: {
          min: _min
        },
        test: function test(value) {
          return isAbsent(value) || value.length >= this.resolve(_min);
        }
      });
    },
    max: function max(_max, message) {
      if (message === void 0) {
        message = string.max;
      }

      return this.test({
        name: 'max',
        exclusive: true,
        message: message,
        params: {
          max: _max
        },
        test: function test(value) {
          return isAbsent(value) || value.length <= this.resolve(_max);
        }
      });
    },
    matches: function matches(regex, options) {
      var excludeEmptyString = false;
      var message;
      var name;

      if (options) {
        if (typeof options === 'object') {
          excludeEmptyString = options.excludeEmptyString;
          message = options.message;
          name = options.name;
        } else {
          message = options;
        }
      }

      return this.test({
        name: name || 'matches',
        message: message || string.matches,
        params: {
          regex: regex
        },
        test: function test(value) {
          return isAbsent(value) || value === '' && excludeEmptyString || value.search(regex) !== -1;
        }
      });
    },
    email: function email(message) {
      if (message === void 0) {
        message = string.email;
      }

      return this.matches(rEmail, {
        name: 'email',
        message: message,
        excludeEmptyString: true
      });
    },
    url: function url(message) {
      if (message === void 0) {
        message = string.url;
      }

      return this.matches(rUrl, {
        name: 'url',
        message: message,
        excludeEmptyString: true
      });
    },
    uuid: function uuid(message) {
      if (message === void 0) {
        message = string.uuid;
      }

      return this.matches(rUUID, {
        name: 'uuid',
        message: message,
        excludeEmptyString: false
      });
    },
    //-- transforms --
    ensure: function ensure() {
      return this.default('').transform(function (val) {
        return val === null ? '' : val;
      });
    },
    trim: function trim(message) {
      if (message === void 0) {
        message = string.trim;
      }

      return this.transform(function (val) {
        return val != null ? val.trim() : val;
      }).test({
        message: message,
        name: 'trim',
        test: isTrimmed
      });
    },
    lowercase: function lowercase(message) {
      if (message === void 0) {
        message = string.lowercase;
      }

      return this.transform(function (value) {
        return !isAbsent(value) ? value.toLowerCase() : value;
      }).test({
        message: message,
        name: 'string_case',
        exclusive: true,
        test: function test(value) {
          return isAbsent(value) || value === value.toLowerCase();
        }
      });
    },
    uppercase: function uppercase(message) {
      if (message === void 0) {
        message = string.uppercase;
      }

      return this.transform(function (value) {
        return !isAbsent(value) ? value.toUpperCase() : value;
      }).test({
        message: message,
        name: 'string_case',
        exclusive: true,
        test: function test(value) {
          return isAbsent(value) || value === value.toUpperCase();
        }
      });
    }
  });

  var isNaN$1 = function isNaN(value) {
    return value != +value;
  };

  function NumberSchema() {
    var _this = this;

    if (!(this instanceof NumberSchema)) return new NumberSchema();
    SchemaType.call(this, {
      type: 'number'
    });
    this.withMutation(function () {
      _this.transform(function (value) {
        var parsed = value;

        if (typeof parsed === 'string') {
          parsed = parsed.replace(/\s/g, '');
          if (parsed === '') return NaN; // don't use parseFloat to avoid positives on alpha-numeric strings

          parsed = +parsed;
        }

        if (this.isType(parsed)) return parsed;
        return parseFloat(parsed);
      });
    });
  }

  inherits(NumberSchema, SchemaType, {
    _typeCheck: function _typeCheck(value) {
      if (value instanceof Number) value = value.valueOf();
      return typeof value === 'number' && !isNaN$1(value);
    },
    min: function min(_min, message) {
      if (message === void 0) {
        message = number.min;
      }

      return this.test({
        message: message,
        name: 'min',
        exclusive: true,
        params: {
          min: _min
        },
        test: function test(value) {
          return isAbsent(value) || value >= this.resolve(_min);
        }
      });
    },
    max: function max(_max, message) {
      if (message === void 0) {
        message = number.max;
      }

      return this.test({
        message: message,
        name: 'max',
        exclusive: true,
        params: {
          max: _max
        },
        test: function test(value) {
          return isAbsent(value) || value <= this.resolve(_max);
        }
      });
    },
    lessThan: function lessThan(less, message) {
      if (message === void 0) {
        message = number.lessThan;
      }

      return this.test({
        message: message,
        name: 'max',
        exclusive: true,
        params: {
          less: less
        },
        test: function test(value) {
          return isAbsent(value) || value < this.resolve(less);
        }
      });
    },
    moreThan: function moreThan(more, message) {
      if (message === void 0) {
        message = number.moreThan;
      }

      return this.test({
        message: message,
        name: 'min',
        exclusive: true,
        params: {
          more: more
        },
        test: function test(value) {
          return isAbsent(value) || value > this.resolve(more);
        }
      });
    },
    positive: function positive(msg) {
      if (msg === void 0) {
        msg = number.positive;
      }

      return this.moreThan(0, msg);
    },
    negative: function negative(msg) {
      if (msg === void 0) {
        msg = number.negative;
      }

      return this.lessThan(0, msg);
    },
    integer: function integer(message) {
      if (message === void 0) {
        message = number.integer;
      }

      return this.test({
        name: 'integer',
        message: message,
        test: function test(val) {
          return isAbsent(val) || Number.isInteger(val);
        }
      });
    },
    truncate: function truncate() {
      return this.transform(function (value) {
        return !isAbsent(value) ? value | 0 : value;
      });
    },
    round: function round(method) {
      var avail = ['ceil', 'floor', 'round', 'trunc'];
      method = method && method.toLowerCase() || 'round'; // this exists for symemtry with the new Math.trunc

      if (method === 'trunc') return this.truncate();
      if (avail.indexOf(method.toLowerCase()) === -1) throw new TypeError('Only valid options for round() are: ' + avail.join(', '));
      return this.transform(function (value) {
        return !isAbsent(value) ? Math[method](value) : value;
      });
    }
  });
  /* eslint-disable */

  /**
   *
   * Date.parse with progressive enhancement for ISO 8601 <https://github.com/csnover/js-iso8601>
   * NON-CONFORMANT EDITION.
   * © 2011 Colin Snover <http://zetafleet.com>
   * Released under MIT license.
   */
  //              1 YYYY                 2 MM        3 DD              4 HH     5 mm        6 ss            7 msec         8 Z 9 ±    10 tzHH    11 tzmm

  var isoReg = /^(\d{4}|[+\-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;

  function parseIsoDate(date) {
    var numericKeys = [1, 4, 5, 6, 7, 10, 11],
        minutesOffset = 0,
        timestamp,
        struct;

    if (struct = isoReg.exec(date)) {
      // avoid NaN timestamps caused by “undefined” values being passed to Date.UTC
      for (var i = 0, k; k = numericKeys[i]; ++i) {
        struct[k] = +struct[k] || 0;
      } // allow undefined days and months


      struct[2] = (+struct[2] || 1) - 1;
      struct[3] = +struct[3] || 1; // allow arbitrary sub-second precision beyond milliseconds

      struct[7] = struct[7] ? String(struct[7]).substr(0, 3) : 0; // timestamps without timezone identifiers should be considered local time

      if ((struct[8] === undefined || struct[8] === '') && (struct[9] === undefined || struct[9] === '')) timestamp = +new Date(struct[1], struct[2], struct[3], struct[4], struct[5], struct[6], struct[7]);else {
        if (struct[8] !== 'Z' && struct[9] !== undefined) {
          minutesOffset = struct[10] * 60 + struct[11];
          if (struct[9] === '+') minutesOffset = 0 - minutesOffset;
        }

        timestamp = Date.UTC(struct[1], struct[2], struct[3], struct[4], struct[5] + minutesOffset, struct[6], struct[7]);
      }
    } else timestamp = Date.parse ? Date.parse(date) : NaN;

    return timestamp;
  }

  var invalidDate = new Date('');

  var isDate$1 = function isDate(obj) {
    return Object.prototype.toString.call(obj) === '[object Date]';
  };

  function DateSchema() {
    var _this = this;

    if (!(this instanceof DateSchema)) return new DateSchema();
    SchemaType.call(this, {
      type: 'date'
    });
    this.withMutation(function () {
      _this.transform(function (value) {
        if (this.isType(value)) return value;
        value = parseIsoDate(value); // 0 is a valid timestamp equivalent to 1970-01-01T00:00:00Z(unix epoch) or before.

        return !isNaN(value) ? new Date(value) : invalidDate;
      });
    });
  }

  inherits(DateSchema, SchemaType, {
    _typeCheck: function _typeCheck(v) {
      return isDate$1(v) && !isNaN(v.getTime());
    },
    min: function min(_min, message) {
      if (message === void 0) {
        message = date.min;
      }

      var limit = _min;

      if (!Reference.isRef(limit)) {
        limit = this.cast(_min);
        if (!this._typeCheck(limit)) throw new TypeError('`min` must be a Date or a value that can be `cast()` to a Date');
      }

      return this.test({
        message: message,
        name: 'min',
        exclusive: true,
        params: {
          min: _min
        },
        test: function test(value) {
          return isAbsent(value) || value >= this.resolve(limit);
        }
      });
    },
    max: function max(_max, message) {
      if (message === void 0) {
        message = date.max;
      }

      var limit = _max;

      if (!Reference.isRef(limit)) {
        limit = this.cast(_max);
        if (!this._typeCheck(limit)) throw new TypeError('`max` must be a Date or a value that can be `cast()` to a Date');
      }

      return this.test({
        message: message,
        name: 'max',
        exclusive: true,
        params: {
          max: _max
        },
        test: function test(value) {
          return isAbsent(value) || value <= this.resolve(limit);
        }
      });
    }
  });
  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */

  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }

    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }

    return accumulator;
  }
  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */


  function basePropertyOf(object) {
    return function (key) {
      return object == null ? undefined : object[key];
    };
  }
  /** Used to map Latin Unicode letters to basic Latin letters. */


  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',
    '\xc1': 'A',
    '\xc2': 'A',
    '\xc3': 'A',
    '\xc4': 'A',
    '\xc5': 'A',
    '\xe0': 'a',
    '\xe1': 'a',
    '\xe2': 'a',
    '\xe3': 'a',
    '\xe4': 'a',
    '\xe5': 'a',
    '\xc7': 'C',
    '\xe7': 'c',
    '\xd0': 'D',
    '\xf0': 'd',
    '\xc8': 'E',
    '\xc9': 'E',
    '\xca': 'E',
    '\xcb': 'E',
    '\xe8': 'e',
    '\xe9': 'e',
    '\xea': 'e',
    '\xeb': 'e',
    '\xcc': 'I',
    '\xcd': 'I',
    '\xce': 'I',
    '\xcf': 'I',
    '\xec': 'i',
    '\xed': 'i',
    '\xee': 'i',
    '\xef': 'i',
    '\xd1': 'N',
    '\xf1': 'n',
    '\xd2': 'O',
    '\xd3': 'O',
    '\xd4': 'O',
    '\xd5': 'O',
    '\xd6': 'O',
    '\xd8': 'O',
    '\xf2': 'o',
    '\xf3': 'o',
    '\xf4': 'o',
    '\xf5': 'o',
    '\xf6': 'o',
    '\xf8': 'o',
    '\xd9': 'U',
    '\xda': 'U',
    '\xdb': 'U',
    '\xdc': 'U',
    '\xf9': 'u',
    '\xfa': 'u',
    '\xfb': 'u',
    '\xfc': 'u',
    '\xdd': 'Y',
    '\xfd': 'y',
    '\xff': 'y',
    '\xc6': 'Ae',
    '\xe6': 'ae',
    '\xde': 'Th',
    '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    "\u0100": 'A',
    "\u0102": 'A',
    "\u0104": 'A',
    "\u0101": 'a',
    "\u0103": 'a',
    "\u0105": 'a',
    "\u0106": 'C',
    "\u0108": 'C',
    "\u010A": 'C',
    "\u010C": 'C',
    "\u0107": 'c',
    "\u0109": 'c',
    "\u010B": 'c',
    "\u010D": 'c',
    "\u010E": 'D',
    "\u0110": 'D',
    "\u010F": 'd',
    "\u0111": 'd',
    "\u0112": 'E',
    "\u0114": 'E',
    "\u0116": 'E',
    "\u0118": 'E',
    "\u011A": 'E',
    "\u0113": 'e',
    "\u0115": 'e',
    "\u0117": 'e',
    "\u0119": 'e',
    "\u011B": 'e',
    "\u011C": 'G',
    "\u011E": 'G',
    "\u0120": 'G',
    "\u0122": 'G',
    "\u011D": 'g',
    "\u011F": 'g',
    "\u0121": 'g',
    "\u0123": 'g',
    "\u0124": 'H',
    "\u0126": 'H',
    "\u0125": 'h',
    "\u0127": 'h',
    "\u0128": 'I',
    "\u012A": 'I',
    "\u012C": 'I',
    "\u012E": 'I',
    "\u0130": 'I',
    "\u0129": 'i',
    "\u012B": 'i',
    "\u012D": 'i',
    "\u012F": 'i',
    "\u0131": 'i',
    "\u0134": 'J',
    "\u0135": 'j',
    "\u0136": 'K',
    "\u0137": 'k',
    "\u0138": 'k',
    "\u0139": 'L',
    "\u013B": 'L',
    "\u013D": 'L',
    "\u013F": 'L',
    "\u0141": 'L',
    "\u013A": 'l',
    "\u013C": 'l',
    "\u013E": 'l',
    "\u0140": 'l',
    "\u0142": 'l',
    "\u0143": 'N',
    "\u0145": 'N',
    "\u0147": 'N',
    "\u014A": 'N',
    "\u0144": 'n',
    "\u0146": 'n',
    "\u0148": 'n',
    "\u014B": 'n',
    "\u014C": 'O',
    "\u014E": 'O',
    "\u0150": 'O',
    "\u014D": 'o',
    "\u014F": 'o',
    "\u0151": 'o',
    "\u0154": 'R',
    "\u0156": 'R',
    "\u0158": 'R',
    "\u0155": 'r',
    "\u0157": 'r',
    "\u0159": 'r',
    "\u015A": 'S',
    "\u015C": 'S',
    "\u015E": 'S',
    "\u0160": 'S',
    "\u015B": 's',
    "\u015D": 's',
    "\u015F": 's',
    "\u0161": 's',
    "\u0162": 'T',
    "\u0164": 'T',
    "\u0166": 'T',
    "\u0163": 't',
    "\u0165": 't',
    "\u0167": 't',
    "\u0168": 'U',
    "\u016A": 'U',
    "\u016C": 'U',
    "\u016E": 'U',
    "\u0170": 'U',
    "\u0172": 'U',
    "\u0169": 'u',
    "\u016B": 'u',
    "\u016D": 'u',
    "\u016F": 'u',
    "\u0171": 'u',
    "\u0173": 'u',
    "\u0174": 'W',
    "\u0175": 'w',
    "\u0176": 'Y',
    "\u0177": 'y',
    "\u0178": 'Y',
    "\u0179": 'Z',
    "\u017B": 'Z',
    "\u017D": 'Z',
    "\u017A": 'z',
    "\u017C": 'z',
    "\u017E": 'z',
    "\u0132": 'IJ',
    "\u0133": 'ij',
    "\u0152": 'Oe',
    "\u0153": 'oe',
    "\u0149": "'n",
    "\u017F": 's'
  };
  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */

  var deburrLetter = basePropertyOf(deburredLetters);
  var deburrLetter$1 = deburrLetter;
  /** Used to match Latin Unicode letters (excluding mathematical operators). */

  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
  /** Used to compose unicode character classes. */

  var rsComboMarksRange$1 = "\\u0300-\\u036f",
      reComboHalfMarksRange$1 = "\\ufe20-\\ufe2f",
      rsComboSymbolsRange$1 = "\\u20d0-\\u20ff",
      rsComboRange$1 = rsComboMarksRange$1 + reComboHalfMarksRange$1 + rsComboSymbolsRange$1;
  /** Used to compose unicode capture groups. */

  var rsCombo$1 = '[' + rsComboRange$1 + ']';
  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */

  var reComboMark = RegExp(rsCombo$1, 'g');
  /**
   * Deburrs `string` by converting
   * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
   * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
   * letters to basic Latin letters and removing
   * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
   *
   * @static
   * @memberOf _
   * @since 3.0.0
   * @category String
   * @param {string} [string=''] The string to deburr.
   * @returns {string} Returns the deburred string.
   * @example
   *
   * _.deburr('déjà vu');
   * // => 'deja vu'
   */

  function deburr(string) {
    string = toString$1(string);
    return string && string.replace(reLatin, deburrLetter$1).replace(reComboMark, '');
  }
  /** Used to match words composed of alphanumeric characters. */


  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */

  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }
  /** Used to detect strings that need a more robust regexp to match words. */


  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */

  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }
  /** Used to compose unicode character classes. */


  var rsAstralRange = "\\ud800-\\udfff",
      rsComboMarksRange = "\\u0300-\\u036f",
      reComboHalfMarksRange = "\\ufe20-\\ufe2f",
      rsComboSymbolsRange = "\\u20d0-\\u20ff",
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = "\\u2700-\\u27bf",
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = "\\u2000-\\u206f",
      rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000",
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = "\\ufe0e\\ufe0f",
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
  /** Used to compose unicode capture groups. */

  var rsApos$1 = "['\u2019]",
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = "\\ud83c[\\udffb-\\udfff]",
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}",
      rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]",
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = "\\u200d";
  /** Used to compose unicode regexes. */

  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos$1 + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos$1 + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq;
  /** Used to match complex or compound words. */

  var reUnicodeWord = RegExp([rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')', rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')', rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower, rsUpper + '+' + rsOptContrUpper, rsOrdUpper, rsOrdLower, rsDigits, rsEmoji].join('|'), 'g');
  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */

  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }
  /**
   * Splits `string` into an array of its words.
   *
   * @static
   * @memberOf _
   * @since 3.0.0
   * @category String
   * @param {string} [string=''] The string to inspect.
   * @param {RegExp|string} [pattern] The pattern to match words.
   * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
   * @returns {Array} Returns the words of `string`.
   * @example
   *
   * _.words('fred, barney, & pebbles');
   * // => ['fred', 'barney', 'pebbles']
   *
   * _.words('fred, barney, & pebbles', /[^, ]+/g);
   * // => ['fred', 'barney', '&', 'pebbles']
   */


  function words(string, pattern, guard) {
    string = toString$1(string);
    pattern = guard ? undefined : pattern;

    if (pattern === undefined) {
      return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
    }

    return string.match(pattern) || [];
  }
  /** Used to compose unicode capture groups. */


  var rsApos = "['\u2019]";
  /** Used to match apostrophes. */

  var reApos = RegExp(rsApos, 'g');
  /**
   * Creates a function like `_.camelCase`.
   *
   * @private
   * @param {Function} callback The function to combine each word.
   * @returns {Function} Returns the new compounder function.
   */

  function createCompounder(callback) {
    return function (string) {
      return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
    };
  }
  /**
   * Converts `string` to
   * [snake case](https://en.wikipedia.org/wiki/Snake_case).
   *
   * @static
   * @memberOf _
   * @since 3.0.0
   * @category String
   * @param {string} [string=''] The string to convert.
   * @returns {string} Returns the snake cased string.
   * @example
   *
   * _.snakeCase('Foo Bar');
   * // => 'foo_bar'
   *
   * _.snakeCase('fooBar');
   * // => 'foo_bar'
   *
   * _.snakeCase('--FOO-BAR--');
   * // => 'foo_bar'
   */


  var snakeCase = createCompounder(function (result, word, index) {
    return result + (index ? '_' : '') + word.toLowerCase();
  });
  var _snakeCase = snakeCase;
  /**
   * The base implementation of `_.slice` without an iteratee call guard.
   *
   * @private
   * @param {Array} array The array to slice.
   * @param {number} [start=0] The start position.
   * @param {number} [end=array.length] The end position.
   * @returns {Array} Returns the slice of `array`.
   */

  function baseSlice(array, start, end) {
    var index = -1,
        length = array.length;

    if (start < 0) {
      start = -start > length ? 0 : length + start;
    }

    end = end > length ? length : end;

    if (end < 0) {
      end += length;
    }

    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);

    while (++index < length) {
      result[index] = array[index + start];
    }

    return result;
  }
  /**
   * Casts `array` to a slice if it's needed.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {number} start The start position.
   * @param {number} [end=array.length] The end position.
   * @returns {Array} Returns the cast slice.
   */


  function castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : baseSlice(array, start, end);
  }
  /**
   * Creates a function like `_.lowerFirst`.
   *
   * @private
   * @param {string} methodName The name of the `String` case method to use.
   * @returns {Function} Returns the new case function.
   */


  function createCaseFirst(methodName) {
    return function (string) {
      string = toString$1(string);
      var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
      var chr = strSymbols ? strSymbols[0] : string.charAt(0);
      var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
      return chr[methodName]() + trailing;
    };
  }
  /**
   * Converts the first character of `string` to upper case.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category String
   * @param {string} [string=''] The string to convert.
   * @returns {string} Returns the converted string.
   * @example
   *
   * _.upperFirst('fred');
   * // => 'Fred'
   *
   * _.upperFirst('FRED');
   * // => 'FRED'
   */


  var upperFirst = createCaseFirst('toUpperCase');
  var upperFirst$1 = upperFirst;
  /**
   * Converts the first character of `string` to upper case and the remaining
   * to lower case.
   *
   * @static
   * @memberOf _
   * @since 3.0.0
   * @category String
   * @param {string} [string=''] The string to capitalize.
   * @returns {string} Returns the capitalized string.
   * @example
   *
   * _.capitalize('FRED');
   * // => 'Fred'
   */

  function capitalize(string) {
    return upperFirst$1(toString$1(string).toLowerCase());
  }
  /**
   * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
   *
   * @static
   * @memberOf _
   * @since 3.0.0
   * @category String
   * @param {string} [string=''] The string to convert.
   * @returns {string} Returns the camel cased string.
   * @example
   *
   * _.camelCase('Foo Bar');
   * // => 'fooBar'
   *
   * _.camelCase('--foo-bar--');
   * // => 'fooBar'
   *
   * _.camelCase('__FOO_BAR__');
   * // => 'fooBar'
   */


  var camelCase = createCompounder(function (result, word, index) {
    word = word.toLowerCase();
    return result + (index ? capitalize(word) : word);
  });
  var _camelCase = camelCase;
  /**
   * The opposite of `_.mapValues`; this method creates an object with the
   * same values as `object` and keys generated by running each own enumerable
   * string keyed property of `object` thru `iteratee`. The iteratee is invoked
   * with three arguments: (value, key, object).
   *
   * @static
   * @memberOf _
   * @since 3.8.0
   * @category Object
   * @param {Object} object The object to iterate over.
   * @param {Function} [iteratee=_.identity] The function invoked per iteration.
   * @returns {Object} Returns the new mapped object.
   * @see _.mapValues
   * @example
   *
   * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
   *   return key + value;
   * });
   * // => { 'a1': 1, 'b2': 2 }
   */

  function mapKeys(object, iteratee) {
    var result = {};
    iteratee = baseIteratee(iteratee);
    baseForOwn(object, function (value, key, object) {
      baseAssignValue(result, iteratee(value, key, object), value);
    });
    return result;
  }

  var toposort$2 = {
    exports: {}
  };
  /**
   * Topological sorting function
   *
   * @param {Array} edges
   * @returns {Array}
   */

  toposort$2.exports = function (edges) {
    return toposort(uniqueNodes(edges), edges);
  };

  toposort$2.exports.array = toposort;

  function toposort(nodes, edges) {
    var cursor = nodes.length,
        sorted = new Array(cursor),
        visited = {},
        i = cursor // Better data structures make algorithm much faster.
    ,
        outgoingEdges = makeOutgoingEdges(edges),
        nodesHash = makeNodesHash(nodes); // check for unknown nodes

    edges.forEach(function (edge) {
      if (!nodesHash.has(edge[0]) || !nodesHash.has(edge[1])) {
        throw new Error('Unknown node. There is an unknown node in the supplied edges.');
      }
    });

    while (i--) {
      if (!visited[i]) visit(nodes[i], i, new Set());
    }

    return sorted;

    function visit(node, i, predecessors) {
      if (predecessors.has(node)) {
        var nodeRep;

        try {
          nodeRep = ", node was:" + JSON.stringify(node);
        } catch (e) {
          nodeRep = "";
        }

        throw new Error('Cyclic dependency' + nodeRep);
      }

      if (!nodesHash.has(node)) {
        throw new Error('Found unknown node. Make sure to provided all involved nodes. Unknown node: ' + JSON.stringify(node));
      }

      if (visited[i]) return;
      visited[i] = true;
      var outgoing = outgoingEdges.get(node) || new Set();
      outgoing = Array.from(outgoing);

      if (i = outgoing.length) {
        predecessors.add(node);

        do {
          var child = outgoing[--i];
          visit(child, nodesHash.get(child), predecessors);
        } while (i);

        predecessors.delete(node);
      }

      sorted[--cursor] = node;
    }
  }

  function uniqueNodes(arr) {
    var res = new Set();

    for (var i = 0, len = arr.length; i < len; i++) {
      var edge = arr[i];
      res.add(edge[0]);
      res.add(edge[1]);
    }

    return Array.from(res);
  }

  function makeOutgoingEdges(arr) {
    var edges = new Map();

    for (var i = 0, len = arr.length; i < len; i++) {
      var edge = arr[i];
      if (!edges.has(edge[0])) edges.set(edge[0], new Set());
      if (!edges.has(edge[1])) edges.set(edge[1], new Set());
      edges.get(edge[0]).add(edge[1]);
    }

    return edges;
  }

  function makeNodesHash(arr) {
    var res = new Map();

    for (var i = 0, len = arr.length; i < len; i++) {
      res.set(arr[i], i);
    }

    return res;
  }

  var toposort$1 = toposort$2.exports;

  function sortFields(fields, excludes) {
    if (excludes === void 0) {
      excludes = [];
    }

    var edges = [];
    var nodes = [];

    function addNode(depPath, key) {
      var node = propertyExpr.split(depPath)[0];
      if (!~nodes.indexOf(node)) nodes.push(node);
      if (!~excludes.indexOf(key + "-" + node)) edges.push([key, node]);
    }

    var _loop = function _loop(key) {
      if (has(fields, key)) {
        var value = fields[key];
        if (!~nodes.indexOf(key)) nodes.push(key);
        if (Reference.isRef(value) && value.isSibling) addNode(value.path, key);else if (isSchema(value) && value._deps) value._deps.forEach(function (path) {
          return addNode(path, key);
        });
      }
    };

    for (var key in fields) {
      _loop(key);
    }

    return toposort$1.array(nodes, edges).reverse();
  }

  function findIndex$1(arr, err) {
    var idx = Infinity;
    arr.some(function (key, ii) {
      if (err.path.indexOf(key) !== -1) {
        idx = ii;
        return true;
      }
    });
    return idx;
  }

  function sortByKeyOrder(keys) {
    return function (a, b) {
      return findIndex$1(keys, a) - findIndex$1(keys, b);
    };
  }

  function _createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it;

    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
      if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        };
      }

      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }

    it = o[Symbol.iterator]();
    return it.next.bind(it);
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }

  var isObject$3 = function isObject(obj) {
    return Object.prototype.toString.call(obj) === '[object Object]';
  };

  function unknown(ctx, value) {
    var known = Object.keys(ctx.fields);
    return Object.keys(value).filter(function (key) {
      return known.indexOf(key) === -1;
    });
  }

  function ObjectSchema(spec) {
    var _this2 = this;

    if (!(this instanceof ObjectSchema)) return new ObjectSchema(spec);
    SchemaType.call(this, {
      type: 'object',
      default: function _default() {
        var _this = this;

        if (!this._nodes.length) return undefined;
        var dft = {};

        this._nodes.forEach(function (key) {
          dft[key] = _this.fields[key].default ? _this.fields[key].getDefault() : undefined;
        });

        return dft;
      }
    });
    this.fields = Object.create(null);
    this._sortErrors = sortByKeyOrder([]);
    this._nodes = [];
    this._excludedEdges = [];
    this.withMutation(function () {
      _this2.transform(function coerce(value) {
        if (typeof value === 'string') {
          try {
            value = JSON.parse(value);
          } catch (err) {
            value = null;
          }
        }

        if (this.isType(value)) return value;
        return null;
      });

      if (spec) {
        _this2.shape(spec);
      }
    });
  }

  inherits(ObjectSchema, SchemaType, {
    _typeCheck: function _typeCheck(value) {
      return isObject$3(value) || typeof value === 'function';
    },
    _cast: function _cast(_value, options) {
      var _this3 = this;

      if (options === void 0) {
        options = {};
      }

      var value = SchemaType.prototype._cast.call(this, _value); //should ignore nulls here


      if (value === undefined) return this.getDefault();
      if (!this._typeCheck(value)) return value;
      var fields = this.fields;
      var strip = this._option('stripUnknown', options) === true;

      var props = this._nodes.concat(Object.keys(value).filter(function (v) {
        return _this3._nodes.indexOf(v) === -1;
      }));

      var intermediateValue = {}; // is filled during the transform below

      var innerOptions = _extends$6({}, options, {
        parent: intermediateValue,
        __validating: options.__validating || false
      });

      var isChanged = false;

      for (var _iterator = _createForOfIteratorHelperLoose(props), _step; !(_step = _iterator()).done;) {
        var prop = _step.value;
        var field = fields[prop];
        var exists = has(value, prop);

        if (field) {
          var fieldValue = void 0;
          var strict = field._options && field._options.strict; // safe to mutate since this is fired in sequence

          innerOptions.path = (options.path ? options.path + "." : '') + prop;
          innerOptions.value = value[prop];
          field = field.resolve(innerOptions);

          if (field._strip === true) {
            isChanged = isChanged || prop in value;
            continue;
          }

          fieldValue = !options.__validating || !strict ? field.cast(value[prop], innerOptions) : value[prop];

          if (fieldValue !== undefined) {
            intermediateValue[prop] = fieldValue;
          }
        } else if (exists && !strip) {
          intermediateValue[prop] = value[prop];
        }

        if (intermediateValue[prop] !== value[prop]) {
          isChanged = true;
        }
      }

      return isChanged ? intermediateValue : value;
    },

    /**
     * @typedef {Object} Ancestor
     * @property {Object} schema - a string property of SpecialType
     * @property {*} value - a number property of SpecialType
     */

    /**
     *
     * @param {*} _value
     * @param {Object}       opts
     * @param {string=}      opts.path
     * @param {*=}           opts.parent
     * @param {Object=}      opts.context
     * @param {boolean=}     opts.sync
     * @param {boolean=}     opts.stripUnknown
     * @param {boolean=}     opts.strict
     * @param {boolean=}     opts.recursive
     * @param {boolean=}     opts.abortEarly
     * @param {boolean=}     opts.__validating
     * @param {Object=}      opts.originalValue
     * @param {Ancestor[]=}  opts.from
     * @param {Object}       [opts.from]
     * @param {Function}     callback
     */
    _validate: function _validate(_value, opts, callback) {
      var _this4 = this;

      if (opts === void 0) {
        opts = {};
      }

      var errors = [];
      var _opts = opts,
          sync = _opts.sync,
          _opts$from = _opts.from,
          from = _opts$from === void 0 ? [] : _opts$from,
          _opts$originalValue = _opts.originalValue,
          originalValue = _opts$originalValue === void 0 ? _value : _opts$originalValue,
          _opts$abortEarly = _opts.abortEarly,
          abortEarly = _opts$abortEarly === void 0 ? this._options.abortEarly : _opts$abortEarly,
          _opts$recursive = _opts.recursive,
          recursive = _opts$recursive === void 0 ? this._options.recursive : _opts$recursive;
      from = [{
        schema: this,
        value: originalValue
      }].concat(from); // this flag is needed for handling `strict` correctly in the context of
      // validation vs just casting. e.g strict() on a field is only used when validating

      opts.__validating = true;
      opts.originalValue = originalValue;
      opts.from = from;

      SchemaType.prototype._validate.call(this, _value, opts, function (err, value) {
        if (err) {
          if (abortEarly) return void callback(err);
          errors.push(err);
          value = err.value;
        }

        if (!recursive || !isObject$3(value)) {
          callback(errors[0] || null, value);
          return;
        }

        originalValue = originalValue || value;

        var tests = _this4._nodes.map(function (key) {
          return function (_, cb) {
            var path = key.indexOf('.') === -1 ? (opts.path ? opts.path + "." : '') + key : (opts.path || '') + "[\"" + key + "\"]";
            var field = _this4.fields[key];

            if (field && field.validate) {
              field.validate(value[key], _extends$6({}, opts, {
                path: path,
                from: from,
                // inner fields are always strict:
                // 1. this isn't strict so the casting will also have cast inner values
                // 2. this is strict in which case the nested values weren't cast either
                strict: true,
                parent: value,
                originalValue: originalValue[key]
              }), cb);
              return;
            }

            cb(null);
          };
        });

        runTests({
          sync: sync,
          tests: tests,
          value: value,
          errors: errors,
          endEarly: abortEarly,
          sort: _this4._sortErrors,
          path: opts.path
        }, callback);
      });
    },
    concat: function concat(schema) {
      var next = SchemaType.prototype.concat.call(this, schema);
      next._nodes = sortFields(next.fields, next._excludedEdges);
      return next;
    },
    shape: function shape(schema, excludes) {
      if (excludes === void 0) {
        excludes = [];
      }

      var next = this.clone();

      var fields = _extends$6(next.fields, schema);

      next.fields = fields;
      next._sortErrors = sortByKeyOrder(Object.keys(fields));

      if (excludes.length) {
        if (!Array.isArray(excludes[0])) excludes = [excludes];
        var keys = excludes.map(function (_ref) {
          var first = _ref[0],
              second = _ref[1];
          return first + "-" + second;
        });
        next._excludedEdges = next._excludedEdges.concat(keys);
      }

      next._nodes = sortFields(fields, next._excludedEdges);
      return next;
    },
    pick: function pick(keys) {
      var picked = {};

      for (var _iterator2 = _createForOfIteratorHelperLoose(keys), _step2; !(_step2 = _iterator2()).done;) {
        var key = _step2.value;
        if (this.fields[key]) picked[key] = this.fields[key];
      }

      return this.clone().withMutation(function (next) {
        next.fields = {};
        return next.shape(picked);
      });
    },
    omit: function omit(keys) {
      var next = this.clone();
      var fields = next.fields;
      next.fields = {};

      for (var _iterator3 = _createForOfIteratorHelperLoose(keys), _step3; !(_step3 = _iterator3()).done;) {
        var key = _step3.value;
        delete fields[key];
      }

      return next.withMutation(function (next) {
        return next.shape(fields);
      });
    },
    from: function from(_from, to, alias) {
      var fromGetter = propertyExpr.getter(_from, true);
      return this.transform(function (obj) {
        if (obj == null) return obj;
        var newObj = obj;

        if (has(obj, _from)) {
          newObj = _extends$6({}, obj);
          if (!alias) delete newObj[_from];
          newObj[to] = fromGetter(obj);
        }

        return newObj;
      });
    },
    noUnknown: function noUnknown(noAllow, message) {
      if (noAllow === void 0) {
        noAllow = true;
      }

      if (message === void 0) {
        message = object.noUnknown;
      }

      if (typeof noAllow === 'string') {
        message = noAllow;
        noAllow = true;
      }

      var next = this.test({
        name: 'noUnknown',
        exclusive: true,
        message: message,
        test: function test(value) {
          if (value == null) return true;
          var unknownKeys = unknown(this.schema, value);
          return !noAllow || unknownKeys.length === 0 || this.createError({
            params: {
              unknown: unknownKeys.join(', ')
            }
          });
        }
      });
      next._options.stripUnknown = noAllow;
      return next;
    },
    unknown: function unknown(allow, message) {
      if (allow === void 0) {
        allow = true;
      }

      if (message === void 0) {
        message = object.noUnknown;
      }

      return this.noUnknown(!allow, message);
    },
    transformKeys: function transformKeys(fn) {
      return this.transform(function (obj) {
        return obj && mapKeys(obj, function (_, key) {
          return fn(key);
        });
      });
    },
    camelCase: function camelCase() {
      return this.transformKeys(_camelCase);
    },
    snakeCase: function snakeCase() {
      return this.transformKeys(_snakeCase);
    },
    constantCase: function constantCase() {
      return this.transformKeys(function (key) {
        return _snakeCase(key).toUpperCase();
      });
    },
    describe: function describe() {
      var base = SchemaType.prototype.describe.call(this);
      base.fields = mapValues(this.fields, function (value) {
        return value.describe();
      });
      return base;
    }
  });

  function ArraySchema(type) {
    var _this = this;

    if (!(this instanceof ArraySchema)) return new ArraySchema(type);
    SchemaType.call(this, {
      type: 'array'
    }); // `undefined` specifically means uninitialized, as opposed to
    // "no subtype"

    this._subType = undefined;
    this.innerType = undefined;
    this.withMutation(function () {
      _this.transform(function (values) {
        if (typeof values === 'string') try {
          values = JSON.parse(values);
        } catch (err) {
          values = null;
        }
        return this.isType(values) ? values : null;
      });

      if (type) _this.of(type);
    });
  }

  inherits(ArraySchema, SchemaType, {
    _typeCheck: function _typeCheck(v) {
      return Array.isArray(v);
    },
    _cast: function _cast(_value, _opts) {
      var _this2 = this;

      var value = SchemaType.prototype._cast.call(this, _value, _opts); //should ignore nulls here


      if (!this._typeCheck(value) || !this.innerType) return value;
      var isChanged = false;
      var castArray = value.map(function (v, idx) {
        var castElement = _this2.innerType.cast(v, _extends$6({}, _opts, {
          path: (_opts.path || '') + "[" + idx + "]"
        }));

        if (castElement !== v) {
          isChanged = true;
        }

        return castElement;
      });
      return isChanged ? castArray : value;
    },
    _validate: function _validate(_value, options, callback) {
      var _this3 = this;

      if (options === void 0) {
        options = {};
      }

      var errors = [];
      var sync = options.sync;
      var path = options.path;
      var innerType = this.innerType;

      var endEarly = this._option('abortEarly', options);

      var recursive = this._option('recursive', options);

      var originalValue = options.originalValue != null ? options.originalValue : _value;

      SchemaType.prototype._validate.call(this, _value, options, function (err, value) {
        if (err) {
          if (endEarly) return void callback(err);
          errors.push(err);
          value = err.value;
        }

        if (!recursive || !innerType || !_this3._typeCheck(value)) {
          callback(errors[0] || null, value);
          return;
        }

        originalValue = originalValue || value; // #950 Ensure that sparse array empty slots are validated

        var tests = new Array(value.length);

        var _loop = function _loop(idx) {
          var item = value[idx];
          var path = (options.path || '') + "[" + idx + "]"; // object._validate note for isStrict explanation

          var innerOptions = _extends$6({}, options, {
            path: path,
            strict: true,
            parent: value,
            index: idx,
            originalValue: originalValue[idx]
          });

          tests[idx] = function (_, cb) {
            return innerType.validate ? innerType.validate(item, innerOptions, cb) : cb(null);
          };
        };

        for (var idx = 0; idx < value.length; idx++) {
          _loop(idx);
        }

        runTests({
          sync: sync,
          path: path,
          value: value,
          errors: errors,
          endEarly: endEarly,
          tests: tests
        }, callback);
      });
    },
    of: function of(schema) {
      var next = this.clone();
      if (schema !== false && !isSchema(schema)) throw new TypeError('`array.of()` sub-schema must be a valid yup schema, or `false` to negate a current sub-schema. ' + 'not: ' + printValue(schema));
      next._subType = schema;
      next.innerType = schema;
      return next;
    },
    min: function min(_min, message) {
      message = message || array.min;
      return this.test({
        message: message,
        name: 'min',
        exclusive: true,
        params: {
          min: _min
        },
        test: function test(value) {
          return isAbsent(value) || value.length >= this.resolve(_min);
        }
      });
    },
    max: function max(_max, message) {
      message = message || array.max;
      return this.test({
        message: message,
        name: 'max',
        exclusive: true,
        params: {
          max: _max
        },
        test: function test(value) {
          return isAbsent(value) || value.length <= this.resolve(_max);
        }
      });
    },
    length: function length(_length, message) {
      message = message || array.length;
      return this.test({
        message: message,
        name: 'length',
        exclusive: true,
        params: {
          length: _length
        },
        test: function test(value) {
          return isAbsent(value) || value.length === this.resolve(_length);
        }
      });
    },
    ensure: function ensure() {
      var _this4 = this;

      return this.default(function () {
        return [];
      }).transform(function (val, original) {
        // We don't want to return `null` for nullable schema
        if (_this4._typeCheck(val)) return val;
        return original == null ? [] : [].concat(original);
      });
    },
    compact: function compact(rejector) {
      var reject = !rejector ? function (v) {
        return !!v;
      } : function (v, i, a) {
        return !rejector(v, i, a);
      };
      return this.transform(function (values) {
        return values != null ? values.filter(reject) : values;
      });
    },
    describe: function describe() {
      var base = SchemaType.prototype.describe.call(this);
      if (this.innerType) base.innerType = this.innerType.describe();
      return base;
    }
  });

  var Lazy = /*#__PURE__*/function () {
    function Lazy(mapFn) {
      this._resolve = function (value, options) {
        var schema = mapFn(value, options);
        if (!isSchema(schema)) throw new TypeError('lazy() functions must return a valid schema');
        return schema.resolve(options);
      };
    }

    var _proto = Lazy.prototype;

    _proto.resolve = function resolve(options) {
      return this._resolve(options.value, options);
    };

    _proto.cast = function cast(value, options) {
      return this._resolve(value, options).cast(value, options);
    };

    _proto.validate = function validate(value, options, maybeCb) {
      return this._resolve(value, options).validate(value, options, maybeCb);
    };

    _proto.validateSync = function validateSync(value, options) {
      return this._resolve(value, options).validateSync(value, options);
    };

    _proto.validateAt = function validateAt(path, value, options) {
      return this._resolve(value, options).validateAt(path, value, options);
    };

    _proto.validateSyncAt = function validateSyncAt(path, value, options) {
      return this._resolve(value, options).validateSyncAt(path, value, options);
    };

    return Lazy;
  }();

  Lazy.prototype.__isYupSchema__ = true;

  function setLocale(custom) {
    Object.keys(custom).forEach(function (type) {
      Object.keys(custom[type]).forEach(function (method) {
        locale$1[type][method] = custom[type][method];
      });
    });
  }

  var boolean = BooleanSchema;

  var ref = function ref(key, options) {
    return new Reference(key, options);
  };

  var lazy = function lazy(fn) {
    return new Lazy(fn);
  };

  function addMethod(schemaType, name, fn) {
    if (!schemaType || !isSchema(schemaType.prototype)) throw new TypeError('You must provide a yup schema constructor function');
    if (typeof name !== 'string') throw new TypeError('A Method name must be provided');
    if (typeof fn !== 'function') throw new TypeError('Method function must be provided');
    schemaType.prototype[name] = fn;
  }

  var schemaValidator = /*#__PURE__*/Object.freeze({
    __proto__: null,
    mixed: SchemaType,
    string: StringSchema,
    number: NumberSchema,
    bool: BooleanSchema,
    boolean: boolean,
    date: DateSchema,
    object: ObjectSchema,
    array: ArraySchema,
    ref: ref,
    lazy: lazy,
    reach: reach,
    isSchema: isSchema,
    addMethod: addMethod,
    setLocale: setLocale,
    ValidationError: ValidationError
  });

  var Autocomplete = function Autocomplete(props) {
    var className = props.className,
        otherProps = __rest$1(props, ["className"]);

    var dataAttributes = generateComponentDataAttributes('Autocomplete', className);
    return React__namespace.createElement(BaseAutocomplete, _assign2({}, dataAttributes, otherProps));
  };

  function styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;

    if (!css || typeof document === 'undefined') {
      return;
    }

    var head = document.head || document.getElementsByTagName('head')[0];
    var style = document.createElement('style');
    style.type = 'text/css';

    if (insertAt === 'top') {
      if (head.firstChild) {
        head.insertBefore(style, head.firstChild);
      } else {
        head.appendChild(style);
      }
    } else {
      head.appendChild(style);
    }

    if (style.styleSheet) {
      style.styleSheet.cssText = css;
    } else {
      style.appendChild(document.createTextNode(css));
    }
  }

  var css_248z$8 = "[data-component-name=\"Button\"].index-module_textXL__92uPC {\n  padding: var(--padding-button-xl-text);\n  font-size: 16px; }\n\n[data-component-name=\"Button\"].index-module_outlinedXL__vs8MB {\n  padding: var(--padding-button-xl-outlined);\n  font-size: 16px; }\n\n[data-component-name=\"Button\"].index-module_containedXL__f8sim {\n  padding: var(--padding-button-xl-contained);\n  font-size: 16px; }\n\n[data-component-name=\"Button\"].index-module_primaryContained__uU-fJ:hover {\n  background-color: var(--color--primary--dark);\n  border-color: var(--color--primary--dark); }\n\n[data-component-name=\"Button\"].index-module_primaryContained__uU-fJ:active {\n  background-color: var(--color--primary--main);\n  border-color: var(--color--primary--main); }\n\n[data-component-name=\"Button\"].index-module_secondaryContained__GZhdz {\n  background-color: var(--color--secondary--main); }\n  [data-component-name=\"Button\"].index-module_secondaryContained__GZhdz:hover {\n    background-color: var(--color--secondary--dark);\n    border-color: var(--color--secondary--dark); }\n  [data-component-name=\"Button\"].index-module_secondaryContained__GZhdz:active {\n    background-color: var(--color--secondary--main);\n    border-color: var(--color--secondary--main); }\n\n[data-component-name=\"Button\"].index-module_successContained__FPo2o {\n  background-color: var(--color--success--main); }\n  [data-component-name=\"Button\"].index-module_successContained__FPo2o:hover {\n    background-color: var(--color--success--dark);\n    border-color: var(--color--success--dark); }\n  [data-component-name=\"Button\"].index-module_successContained__FPo2o:active {\n    background-color: var(--color--success--main);\n    border-color: var(--color--success--main); }\n\n[data-component-name=\"Button\"].index-module_warningContained__Wjw6q {\n  background-color: var(--color--warning--main); }\n  [data-component-name=\"Button\"].index-module_warningContained__Wjw6q:hover {\n    background-color: var(--color--warning--dark);\n    border-color: var(--color--warning--dark); }\n  [data-component-name=\"Button\"].index-module_warningContained__Wjw6q:active {\n    background-color: var(--color--warning--main);\n    border-color: var(--color--warning--main); }\n\n[data-component-name=\"Button\"].index-module_errorContained__fZoXY {\n  background-color: var(--color--error--main); }\n  [data-component-name=\"Button\"].index-module_errorContained__fZoXY:hover {\n    background-color: var(--color--error--dark);\n    border-color: var(--color--error--dark); }\n  [data-component-name=\"Button\"].index-module_errorContained__fZoXY:active {\n    background-color: var(--color--error--main);\n    border-color: var(--color--error--main); }\n\n[data-component-name=\"Button\"].index-module_primaryText__4B4bQ:hover {\n  background-color: rgba(var(--color--primary--main--rgb), 0.04); }\n\n[data-component-name=\"Button\"].index-module_secondaryText__KSNBv:hover {\n  background-color: rgba(var(--color--secondary--main--rgb), 0.04); }\n\n[data-component-name=\"Button\"].index-module_successText__vAQN6 {\n  color: var(--color--success--main); }\n  [data-component-name=\"Button\"].index-module_successText__vAQN6:hover {\n    background-color: rgba(var(--color--success--main--rgb), 0.04); }\n\n[data-component-name=\"Button\"].index-module_warningText__t7NxN {\n  color: var(--color--warning--main); }\n  [data-component-name=\"Button\"].index-module_warningText__t7NxN:hover {\n    background-color: rgba(var(--color--warning--main--rgb), 0.04); }\n\n[data-component-name=\"Button\"].index-module_errorText__UpP65 {\n  color: var(--color--error--main); }\n  [data-component-name=\"Button\"].index-module_errorText__UpP65:hover {\n    background-color: rgba(var(--color--error--main--rgb), 0.04); }\n\n[data-component-name=\"Button\"].index-module_primaryOutlined__6HDkQ {\n  border: 1px solid rgba(var(--color--primary--main--rgb), 0.5); }\n  [data-component-name=\"Button\"].index-module_primaryOutlined__6HDkQ:hover {\n    background-color: rgba(var(--color--primary--main--rgb), 0.04);\n    border: 1px solid rgba(var(--color--primary--main--rgb), 0.5); }\n\n[data-component-name=\"Button\"].index-module_secondaryOutlined__UuVtD {\n  border: 1px solid rgba(var(--color--secondary--main--rgb), 0.5); }\n  [data-component-name=\"Button\"].index-module_secondaryOutlined__UuVtD:hover {\n    background-color: rgba(var(--color--secondary--main--rgb), 0.04);\n    border: 1px solid rgba(var(--color--secondary--main--rgb), 0.5); }\n\n[data-component-name=\"Button\"].index-module_successOutlined__gI1pv {\n  border: 1px solid rgba(var(--color--success--main--rgb), 0.5);\n  color: var(--color--success--main); }\n  [data-component-name=\"Button\"].index-module_successOutlined__gI1pv:hover {\n    background-color: rgba(var(--color--success--main--rgb), 0.04);\n    border: 1px solid rgba(var(--color--success--main--rgb), 0.5); }\n\n[data-component-name=\"Button\"].index-module_warningOutlined__wANy0 {\n  border: 1px solid rgba(var(--color--warning--main--rgb), 0.5);\n  color: var(--color--warning--main); }\n  [data-component-name=\"Button\"].index-module_warningOutlined__wANy0:hover {\n    background-color: rgba(var(--color--warning--main--rgb), 0.04);\n    border: 1px solid rgba(var(--color--warning--main--rgb), 0.5); }\n\n[data-component-name=\"Button\"].index-module_errorOutlined__hBZ-0 {\n  border: 1px solid rgba(var(--color--error--main--rgb), 0.5);\n  color: var(--color--error--main); }\n  [data-component-name=\"Button\"].index-module_errorOutlined__hBZ-0:hover {\n    background-color: rgba(var(--color--error--main--rgb), 0.04);\n    border: 1px solid rgba(var(--color--error--main--rgb), 0.5); }\n\n/*# sourceMappingURL=data:application/json;base64,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 */";
  var styles$4 = {
    "textXL": "index-module_textXL__92uPC",
    "outlinedXL": "index-module_outlinedXL__vs8MB",
    "containedXL": "index-module_containedXL__f8sim",
    "primaryContained": "index-module_primaryContained__uU-fJ",
    "secondaryContained": "index-module_secondaryContained__GZhdz",
    "successContained": "index-module_successContained__FPo2o",
    "warningContained": "index-module_warningContained__Wjw6q",
    "errorContained": "index-module_errorContained__fZoXY",
    "primaryText": "index-module_primaryText__4B4bQ",
    "secondaryText": "index-module_secondaryText__KSNBv",
    "successText": "index-module_successText__vAQN6",
    "warningText": "index-module_warningText__t7NxN",
    "errorText": "index-module_errorText__UpP65",
    "primaryOutlined": "index-module_primaryOutlined__6HDkQ",
    "secondaryOutlined": "index-module_secondaryOutlined__UuVtD",
    "successOutlined": "index-module_successOutlined__gI1pv",
    "warningOutlined": "index-module_warningOutlined__wANy0",
    "errorOutlined": "index-module_errorOutlined__hBZ-0"
  };
  styleInject(css_248z$8);

  var Button = function Button(props) {
    var className = props.className,
        _a = props.size,
        buttonSize = _a === void 0 ? 'medium' : _a,
        _b = props.color,
        buttonColor = _b === void 0 ? 'primary' : _b,
        _c = props.isLoading,
        isLoading = _c === void 0 ? false : _c,
        children = props.children,
        otherProps = __rest$1(props, ["className", "size", "color", "isLoading", "children"]);

    var buttonClassName = className;
    var circularProgressSize = {
      extraLarge: 28,
      large: 25,
      medium: 23,
      small: 20
    };

    if (buttonSize === 'extraLarge') {
      buttonClassName = classNames(styles$4.textXL, className);

      if (otherProps.variant === 'outlined') {
        buttonClassName = classNames(styles$4.outlinedXL, className);
      }

      if (otherProps.variant === 'contained') {
        buttonClassName = classNames(styles$4.containedXL, className);
      }
    }

    var variant = otherProps.variant !== undefined ? otherProps.variant : 'text';

    var colorWithVariant = _$1.camelCase(buttonColor + "-" + variant);

    return React__namespace.createElement(BaseButton, _assign2({
      "data-testid": "button",
      "data-component-name": "Button",
      "data-component-library": "generic",
      className: classNames(styles$4[colorWithVariant], buttonClassName, 'ds-generic-react-Button'),
      size: buttonSize === 'extraLarge' ? 'medium' : buttonSize,
      color: buttonColor
    }, otherProps), isLoading ? React__namespace.createElement(Progress, {
      color: "inherit",
      size: circularProgressSize[buttonSize]
    }) : children);
  };

  var ButtonGroup = React__namespace.forwardRef(function (props, ref) {
    var className = props.className,
        otherProps = __rest$1(props, ["className"]);

    var dataAttributes = generateComponentDataAttributes('ButtonGroup', className);
    return React__namespace.createElement(BaseButtonGroup, _assign2({}, dataAttributes, {
      ref: ref
    }, otherProps));
  });

  var Checkbox = function Checkbox(props) {
    var className = props.className,
        otherProps = __rest$1(props, ["className"]);

    var dataAttributes = generateComponentDataAttributes('Checkbox', className);
    return React__namespace.createElement(BaseCheckbox, _assign2({}, dataAttributes, otherProps));
  };

  var defaultProps$a = {
    color: 'secondary',
    indeterminate: false
  };
  Checkbox.defaultProps = defaultProps$a;

  var Radio = function Radio(props) {
    var className = props.className,
        otherProps = __rest$1(props, ["className"]);

    var dataAttributes = generateComponentDataAttributes('Radio', className);
    return React__namespace.createElement(BaseRadio, _assign2({}, dataAttributes, otherProps));
  };

  var defaultProps$9 = {
    color: 'secondary'
  };
  Radio.defaultProps = defaultProps$9;

  var RadioGroup = function RadioGroup(props) {
    var className = props.className,
        otherProps = __rest$1(props, ["className"]);

    var dataAttributes = generateComponentDataAttributes('RadioGroup', className);
    return React__namespace.createElement(BaseRadioGroup$1, _assign2({}, dataAttributes, otherProps));
  };

  var IconButton = function IconButton(props) {
    var className = props.className,
        otherProps = __rest$1(props, ["className"]);

    var dataAttributes = generateComponentDataAttributes('IconButton', className);
    return React__namespace.createElement(IconButton$2, _assign2({}, dataAttributes, otherProps));
  };

  var Menu$1 = {};
  var interopRequireDefault = {
    exports: {}
  };

  (function (module) {
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        "default": obj
      };
    }

    module.exports = _interopRequireDefault;
    module.exports["default"] = module.exports, module.exports.__esModule = true;
  })(interopRequireDefault);

  var createSvgIcon = {};
  var require$$0$1 = /*@__PURE__*/getAugmentedNamespace(utils);

  (function (exports) {
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    Object.defineProperty(exports, "default", {
      enumerable: true,
      get: function get() {
        return _utils.createSvgIcon;
      }
    });
    var _utils = require$$0$1;
  })(createSvgIcon);

  var jsxRuntime = {
    exports: {}
  };
  var reactJsxRuntime_production_min = {};
  var react = {
    exports: {}
  };
  var react_production_min = {};
  /** @license React v17.0.2
   * react.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  var l = objectAssign,
      n$1 = 60103,
      p$1 = 60106;
  react_production_min.Fragment = 60107;
  react_production_min.StrictMode = 60108;
  react_production_min.Profiler = 60114;
  var q$1 = 60109,
      r = 60110,
      t = 60112;
  react_production_min.Suspense = 60113;
  var u = 60115,
      v = 60116;

  if ("function" === typeof Symbol && Symbol.for) {
    var w = Symbol.for;
    n$1 = w("react.element");
    p$1 = w("react.portal");
    react_production_min.Fragment = w("react.fragment");
    react_production_min.StrictMode = w("react.strict_mode");
    react_production_min.Profiler = w("react.profiler");
    q$1 = w("react.provider");
    r = w("react.context");
    t = w("react.forward_ref");
    react_production_min.Suspense = w("react.suspense");
    u = w("react.memo");
    v = w("react.lazy");
  }

  var x = "function" === typeof Symbol && Symbol.iterator;

  function y(a) {
    if (null === a || "object" !== typeof a) return null;
    a = x && a[x] || a["@@iterator"];
    return "function" === typeof a ? a : null;
  }

  function z(a) {
    for (var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++) {
      b += "&args[]=" + encodeURIComponent(arguments[c]);
    }

    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }

  var A = {
    isMounted: function isMounted() {
      return !1;
    },
    enqueueForceUpdate: function enqueueForceUpdate() {},
    enqueueReplaceState: function enqueueReplaceState() {},
    enqueueSetState: function enqueueSetState() {}
  },
      B = {};

  function C(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = B;
    this.updater = c || A;
  }

  C.prototype.isReactComponent = {};

  C.prototype.setState = function (a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error(z(85));
    this.updater.enqueueSetState(this, a, b, "setState");
  };

  C.prototype.forceUpdate = function (a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
  };

  function D() {}

  D.prototype = C.prototype;

  function E(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = B;
    this.updater = c || A;
  }

  var F = E.prototype = new D();
  F.constructor = E;
  l(F, C.prototype);
  F.isPureReactComponent = !0;
  var G = {
    current: null
  },
      H = Object.prototype.hasOwnProperty,
      I = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
  };

  function J(a, b, c) {
    var e,
        d = {},
        k = null,
        h = null;
    if (null != b) for (e in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b) {
      H.call(b, e) && !I.hasOwnProperty(e) && (d[e] = b[e]);
    }
    var g = arguments.length - 2;
    if (1 === g) d.children = c;else if (1 < g) {
      for (var f = Array(g), m = 0; m < g; m++) {
        f[m] = arguments[m + 2];
      }

      d.children = f;
    }
    if (a && a.defaultProps) for (e in g = a.defaultProps, g) {
      void 0 === d[e] && (d[e] = g[e]);
    }
    return {
      $$typeof: n$1,
      type: a,
      key: k,
      ref: h,
      props: d,
      _owner: G.current
    };
  }

  function K(a, b) {
    return {
      $$typeof: n$1,
      type: a.type,
      key: b,
      ref: a.ref,
      props: a.props,
      _owner: a._owner
    };
  }

  function L(a) {
    return "object" === typeof a && null !== a && a.$$typeof === n$1;
  }

  function escape(a) {
    var b = {
      "=": "=0",
      ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function (a) {
      return b[a];
    });
  }

  var M = /\/+/g;

  function N(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? escape("" + a.key) : b.toString(36);
  }

  function O(a, b, c, e, d) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;else switch (k) {
      case "string":
      case "number":
        h = !0;
        break;

      case "object":
        switch (a.$$typeof) {
          case n$1:
          case p$1:
            h = !0;
        }

    }
    if (h) return h = a, d = d(h), a = "" === e ? "." + N(h, 0) : e, Array.isArray(d) ? (c = "", null != a && (c = a.replace(M, "$&/") + "/"), O(d, b, c, "", function (a) {
      return a;
    })) : null != d && (L(d) && (d = K(d, c + (!d.key || h && h.key === d.key ? "" : ("" + d.key).replace(M, "$&/") + "/") + a)), b.push(d)), 1;
    h = 0;
    e = "" === e ? "." : e + ":";
    if (Array.isArray(a)) for (var g = 0; g < a.length; g++) {
      k = a[g];
      var f = e + N(k, g);
      h += O(k, b, c, f, d);
    } else if (f = y(a), "function" === typeof f) for (a = f.call(a), g = 0; !(k = a.next()).done;) {
      k = k.value, f = e + N(k, g++), h += O(k, b, c, f, d);
    } else if ("object" === k) throw b = "" + a, Error(z(31, "[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b));
    return h;
  }

  function P(a, b, c) {
    if (null == a) return a;
    var e = [],
        d = 0;
    O(a, e, "", "", function (a) {
      return b.call(c, a, d++);
    });
    return e;
  }

  function Q(a) {
    if (-1 === a._status) {
      var b = a._result;
      b = b();
      a._status = 0;
      a._result = b;
      b.then(function (b) {
        0 === a._status && (b = b.default, a._status = 1, a._result = b);
      }, function (b) {
        0 === a._status && (a._status = 2, a._result = b);
      });
    }

    if (1 === a._status) return a._result;
    throw a._result;
  }

  var R = {
    current: null
  };

  function S() {
    var a = R.current;
    if (null === a) throw Error(z(321));
    return a;
  }

  var T = {
    ReactCurrentDispatcher: R,
    ReactCurrentBatchConfig: {
      transition: 0
    },
    ReactCurrentOwner: G,
    IsSomeRendererActing: {
      current: !1
    },
    assign: l
  };
  react_production_min.Children = {
    map: P,
    forEach: function forEach(a, b, c) {
      P(a, function () {
        b.apply(this, arguments);
      }, c);
    },
    count: function count(a) {
      var b = 0;
      P(a, function () {
        b++;
      });
      return b;
    },
    toArray: function toArray(a) {
      return P(a, function (a) {
        return a;
      }) || [];
    },
    only: function only(a) {
      if (!L(a)) throw Error(z(143));
      return a;
    }
  };
  react_production_min.Component = C;
  react_production_min.PureComponent = E;
  react_production_min.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = T;

  react_production_min.cloneElement = function (a, b, c) {
    if (null === a || void 0 === a) throw Error(z(267, a));
    var e = l({}, a.props),
        d = a.key,
        k = a.ref,
        h = a._owner;

    if (null != b) {
      void 0 !== b.ref && (k = b.ref, h = G.current);
      void 0 !== b.key && (d = "" + b.key);
      if (a.type && a.type.defaultProps) var g = a.type.defaultProps;

      for (f in b) {
        H.call(b, f) && !I.hasOwnProperty(f) && (e[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
      }
    }

    var f = arguments.length - 2;
    if (1 === f) e.children = c;else if (1 < f) {
      g = Array(f);

      for (var m = 0; m < f; m++) {
        g[m] = arguments[m + 2];
      }

      e.children = g;
    }
    return {
      $$typeof: n$1,
      type: a.type,
      key: d,
      ref: k,
      props: e,
      _owner: h
    };
  };

  react_production_min.createContext = function (a, b) {
    void 0 === b && (b = null);
    a = {
      $$typeof: r,
      _calculateChangedBits: b,
      _currentValue: a,
      _currentValue2: a,
      _threadCount: 0,
      Provider: null,
      Consumer: null
    };
    a.Provider = {
      $$typeof: q$1,
      _context: a
    };
    return a.Consumer = a;
  };

  react_production_min.createElement = J;

  react_production_min.createFactory = function (a) {
    var b = J.bind(null, a);
    b.type = a;
    return b;
  };

  react_production_min.createRef = function () {
    return {
      current: null
    };
  };

  react_production_min.forwardRef = function (a) {
    return {
      $$typeof: t,
      render: a
    };
  };

  react_production_min.isValidElement = L;

  react_production_min.lazy = function (a) {
    return {
      $$typeof: v,
      _payload: {
        _status: -1,
        _result: a
      },
      _init: Q
    };
  };

  react_production_min.memo = function (a, b) {
    return {
      $$typeof: u,
      type: a,
      compare: void 0 === b ? null : b
    };
  };

  react_production_min.useCallback = function (a, b) {
    return S().useCallback(a, b);
  };

  react_production_min.useContext = function (a, b) {
    return S().useContext(a, b);
  };

  react_production_min.useDebugValue = function () {};

  react_production_min.useEffect = function (a, b) {
    return S().useEffect(a, b);
  };

  react_production_min.useImperativeHandle = function (a, b, c) {
    return S().useImperativeHandle(a, b, c);
  };

  react_production_min.useLayoutEffect = function (a, b) {
    return S().useLayoutEffect(a, b);
  };

  react_production_min.useMemo = function (a, b) {
    return S().useMemo(a, b);
  };

  react_production_min.useReducer = function (a, b, c) {
    return S().useReducer(a, b, c);
  };

  react_production_min.useRef = function (a) {
    return S().useRef(a);
  };

  react_production_min.useState = function (a) {
    return S().useState(a);
  };

  react_production_min.version = "17.0.2";
  var react_development = {};
  /** @license React v17.0.2
   * react.development.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  (function (exports) {
    if (process.env.NODE_ENV !== "production") {
      (function () {
        var _assign = objectAssign; // TODO: this is special because it gets imported during build.

        var ReactVersion = '17.0.2'; // ATTENTION
        // When adding new symbols to this file,
        // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
        // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
        // nor polyfill, then a plain number is used for performance.

        var REACT_ELEMENT_TYPE = 0xeac7;
        var REACT_PORTAL_TYPE = 0xeaca;
        exports.Fragment = 0xeacb;
        exports.StrictMode = 0xeacc;
        exports.Profiler = 0xead2;
        var REACT_PROVIDER_TYPE = 0xeacd;
        var REACT_CONTEXT_TYPE = 0xeace;
        var REACT_FORWARD_REF_TYPE = 0xead0;
        exports.Suspense = 0xead1;
        var REACT_SUSPENSE_LIST_TYPE = 0xead8;
        var REACT_MEMO_TYPE = 0xead3;
        var REACT_LAZY_TYPE = 0xead4;
        var REACT_BLOCK_TYPE = 0xead9;
        var REACT_SERVER_BLOCK_TYPE = 0xeada;
        var REACT_FUNDAMENTAL_TYPE = 0xead5;
        var REACT_DEBUG_TRACING_MODE_TYPE = 0xeae1;
        var REACT_LEGACY_HIDDEN_TYPE = 0xeae3;

        if (typeof Symbol === 'function' && Symbol.for) {
          var symbolFor = Symbol.for;
          REACT_ELEMENT_TYPE = symbolFor('react.element');
          REACT_PORTAL_TYPE = symbolFor('react.portal');
          exports.Fragment = symbolFor('react.fragment');
          exports.StrictMode = symbolFor('react.strict_mode');
          exports.Profiler = symbolFor('react.profiler');
          REACT_PROVIDER_TYPE = symbolFor('react.provider');
          REACT_CONTEXT_TYPE = symbolFor('react.context');
          REACT_FORWARD_REF_TYPE = symbolFor('react.forward_ref');
          exports.Suspense = symbolFor('react.suspense');
          REACT_SUSPENSE_LIST_TYPE = symbolFor('react.suspense_list');
          REACT_MEMO_TYPE = symbolFor('react.memo');
          REACT_LAZY_TYPE = symbolFor('react.lazy');
          REACT_BLOCK_TYPE = symbolFor('react.block');
          REACT_SERVER_BLOCK_TYPE = symbolFor('react.server.block');
          REACT_FUNDAMENTAL_TYPE = symbolFor('react.fundamental');
          symbolFor('react.scope');
          symbolFor('react.opaque.id');
          REACT_DEBUG_TRACING_MODE_TYPE = symbolFor('react.debug_trace_mode');
          symbolFor('react.offscreen');
          REACT_LEGACY_HIDDEN_TYPE = symbolFor('react.legacy_hidden');
        }

        var MAYBE_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
        var FAUX_ITERATOR_SYMBOL = '@@iterator';

        function getIteratorFn(maybeIterable) {
          if (maybeIterable === null || typeof maybeIterable !== 'object') {
            return null;
          }

          var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];

          if (typeof maybeIterator === 'function') {
            return maybeIterator;
          }

          return null;
        }
        /**
         * Keeps track of the current dispatcher.
         */


        var ReactCurrentDispatcher = {
          /**
           * @internal
           * @type {ReactComponent}
           */
          current: null
        };
        /**
         * Keeps track of the current batch's configuration such as how long an update
         * should suspend for if it needs to.
         */

        var ReactCurrentBatchConfig = {
          transition: 0
        };
        /**
         * Keeps track of the current owner.
         *
         * The current owner is the component who should own any components that are
         * currently being constructed.
         */

        var ReactCurrentOwner = {
          /**
           * @internal
           * @type {ReactComponent}
           */
          current: null
        };
        var ReactDebugCurrentFrame = {};
        var currentExtraStackFrame = null;

        function setExtraStackFrame(stack) {
          {
            currentExtraStackFrame = stack;
          }
        }

        {
          ReactDebugCurrentFrame.setExtraStackFrame = function (stack) {
            {
              currentExtraStackFrame = stack;
            }
          }; // Stack implementation injected by the current renderer.


          ReactDebugCurrentFrame.getCurrentStack = null;

          ReactDebugCurrentFrame.getStackAddendum = function () {
            var stack = ''; // Add an extra top frame while an element is being validated

            if (currentExtraStackFrame) {
              stack += currentExtraStackFrame;
            } // Delegate to the injected renderer-specific implementation


            var impl = ReactDebugCurrentFrame.getCurrentStack;

            if (impl) {
              stack += impl() || '';
            }

            return stack;
          };
        }
        /**
         * Used by act() to track whether you're inside an act() scope.
         */

        var IsSomeRendererActing = {
          current: false
        };
        var ReactSharedInternals = {
          ReactCurrentDispatcher: ReactCurrentDispatcher,
          ReactCurrentBatchConfig: ReactCurrentBatchConfig,
          ReactCurrentOwner: ReactCurrentOwner,
          IsSomeRendererActing: IsSomeRendererActing,
          // Used by renderers to avoid bundling object-assign twice in UMD bundles:
          assign: _assign
        };
        {
          ReactSharedInternals.ReactDebugCurrentFrame = ReactDebugCurrentFrame;
        } // by calls to these methods by a Babel plugin.
        //
        // In PROD (or in packages without access to React internals),
        // they are left as they are instead.

        function warn(format) {
          {
            for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
              args[_key - 1] = arguments[_key];
            }

            printWarning('warn', format, args);
          }
        }

        function error(format) {
          {
            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }

            printWarning('error', format, args);
          }
        }

        function printWarning(level, format, args) {
          // When changing this logic, you might want to also
          // update consoleWithStackDev.www.js as well.
          {
            var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
            var stack = ReactDebugCurrentFrame.getStackAddendum();

            if (stack !== '') {
              format += '%s';
              args = args.concat([stack]);
            }

            var argsWithFormat = args.map(function (item) {
              return '' + item;
            }); // Careful: RN currently depends on this prefix

            argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
            // breaks IE9: https://github.com/facebook/react/issues/13610
            // eslint-disable-next-line react-internal/no-production-logging

            Function.prototype.apply.call(console[level], console, argsWithFormat);
          }
        }

        var didWarnStateUpdateForUnmountedComponent = {};

        function warnNoop(publicInstance, callerName) {
          {
            var _constructor = publicInstance.constructor;
            var componentName = _constructor && (_constructor.displayName || _constructor.name) || 'ReactClass';
            var warningKey = componentName + "." + callerName;

            if (didWarnStateUpdateForUnmountedComponent[warningKey]) {
              return;
            }

            error("Can't call %s on a component that is not yet mounted. " + 'This is a no-op, but it might indicate a bug in your application. ' + 'Instead, assign to `this.state` directly or define a `state = {};` ' + 'class property with the desired state in the %s component.', callerName, componentName);
            didWarnStateUpdateForUnmountedComponent[warningKey] = true;
          }
        }
        /**
         * This is the abstract API for an update queue.
         */


        var ReactNoopUpdateQueue = {
          /**
           * Checks whether or not this composite component is mounted.
           * @param {ReactClass} publicInstance The instance we want to test.
           * @return {boolean} True if mounted, false otherwise.
           * @protected
           * @final
           */
          isMounted: function isMounted(publicInstance) {
            return false;
          },

          /**
           * Forces an update. This should only be invoked when it is known with
           * certainty that we are **not** in a DOM transaction.
           *
           * You may want to call this when you know that some deeper aspect of the
           * component's state has changed but `setState` was not called.
           *
           * This will not invoke `shouldComponentUpdate`, but it will invoke
           * `componentWillUpdate` and `componentDidUpdate`.
           *
           * @param {ReactClass} publicInstance The instance that should rerender.
           * @param {?function} callback Called after component is updated.
           * @param {?string} callerName name of the calling function in the public API.
           * @internal
           */
          enqueueForceUpdate: function enqueueForceUpdate(publicInstance, callback, callerName) {
            warnNoop(publicInstance, 'forceUpdate');
          },

          /**
           * Replaces all of the state. Always use this or `setState` to mutate state.
           * You should treat `this.state` as immutable.
           *
           * There is no guarantee that `this.state` will be immediately updated, so
           * accessing `this.state` after calling this method may return the old value.
           *
           * @param {ReactClass} publicInstance The instance that should rerender.
           * @param {object} completeState Next state.
           * @param {?function} callback Called after component is updated.
           * @param {?string} callerName name of the calling function in the public API.
           * @internal
           */
          enqueueReplaceState: function enqueueReplaceState(publicInstance, completeState, callback, callerName) {
            warnNoop(publicInstance, 'replaceState');
          },

          /**
           * Sets a subset of the state. This only exists because _pendingState is
           * internal. This provides a merging strategy that is not available to deep
           * properties which is confusing. TODO: Expose pendingState or don't use it
           * during the merge.
           *
           * @param {ReactClass} publicInstance The instance that should rerender.
           * @param {object} partialState Next partial state to be merged with state.
           * @param {?function} callback Called after component is updated.
           * @param {?string} Name of the calling function in the public API.
           * @internal
           */
          enqueueSetState: function enqueueSetState(publicInstance, partialState, callback, callerName) {
            warnNoop(publicInstance, 'setState');
          }
        };
        var emptyObject = {};
        {
          Object.freeze(emptyObject);
        }
        /**
         * Base class helpers for the updating state of a component.
         */

        function Component(props, context, updater) {
          this.props = props;
          this.context = context; // If a component has string refs, we will assign a different object later.

          this.refs = emptyObject; // We initialize the default updater but the real one gets injected by the
          // renderer.

          this.updater = updater || ReactNoopUpdateQueue;
        }

        Component.prototype.isReactComponent = {};
        /**
         * Sets a subset of the state. Always use this to mutate
         * state. You should treat `this.state` as immutable.
         *
         * There is no guarantee that `this.state` will be immediately updated, so
         * accessing `this.state` after calling this method may return the old value.
         *
         * There is no guarantee that calls to `setState` will run synchronously,
         * as they may eventually be batched together.  You can provide an optional
         * callback that will be executed when the call to setState is actually
         * completed.
         *
         * When a function is provided to setState, it will be called at some point in
         * the future (not synchronously). It will be called with the up to date
         * component arguments (state, props, context). These values can be different
         * from this.* because your function may be called after receiveProps but before
         * shouldComponentUpdate, and this new state, props, and context will not yet be
         * assigned to this.
         *
         * @param {object|function} partialState Next partial state or function to
         *        produce next partial state to be merged with current state.
         * @param {?function} callback Called after state is updated.
         * @final
         * @protected
         */

        Component.prototype.setState = function (partialState, callback) {
          if (!(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null)) {
            {
              throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
            }
          }

          this.updater.enqueueSetState(this, partialState, callback, 'setState');
        };
        /**
         * Forces an update. This should only be invoked when it is known with
         * certainty that we are **not** in a DOM transaction.
         *
         * You may want to call this when you know that some deeper aspect of the
         * component's state has changed but `setState` was not called.
         *
         * This will not invoke `shouldComponentUpdate`, but it will invoke
         * `componentWillUpdate` and `componentDidUpdate`.
         *
         * @param {?function} callback Called after update is complete.
         * @final
         * @protected
         */


        Component.prototype.forceUpdate = function (callback) {
          this.updater.enqueueForceUpdate(this, callback, 'forceUpdate');
        };
        /**
         * Deprecated APIs. These APIs used to exist on classic React classes but since
         * we would like to deprecate them, we're not going to move them over to this
         * modern base class. Instead, we define a getter that warns if it's accessed.
         */


        {
          var deprecatedAPIs = {
            isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
            replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
          };

          var defineDeprecationWarning = function defineDeprecationWarning(methodName, info) {
            Object.defineProperty(Component.prototype, methodName, {
              get: function get() {
                warn('%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
                return undefined;
              }
            });
          };

          for (var fnName in deprecatedAPIs) {
            if (deprecatedAPIs.hasOwnProperty(fnName)) {
              defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
            }
          }
        }

        function ComponentDummy() {}

        ComponentDummy.prototype = Component.prototype;
        /**
         * Convenience component with default shallow equality check for sCU.
         */

        function PureComponent(props, context, updater) {
          this.props = props;
          this.context = context; // If a component has string refs, we will assign a different object later.

          this.refs = emptyObject;
          this.updater = updater || ReactNoopUpdateQueue;
        }

        var pureComponentPrototype = PureComponent.prototype = new ComponentDummy();
        pureComponentPrototype.constructor = PureComponent; // Avoid an extra prototype jump for these methods.

        _assign(pureComponentPrototype, Component.prototype);

        pureComponentPrototype.isPureReactComponent = true; // an immutable object with a single mutable value

        function createRef() {
          var refObject = {
            current: null
          };
          {
            Object.seal(refObject);
          }
          return refObject;
        }

        function getWrappedName(outerType, innerType, wrapperName) {
          var functionName = innerType.displayName || innerType.name || '';
          return outerType.displayName || (functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName);
        }

        function getContextName(type) {
          return type.displayName || 'Context';
        }

        function getComponentName(type) {
          if (type == null) {
            // Host root, text node or just invalid type.
            return null;
          }

          {
            if (typeof type.tag === 'number') {
              error('Received an unexpected object in getComponentName(). ' + 'This is likely a bug in React. Please file an issue.');
            }
          }

          if (typeof type === 'function') {
            return type.displayName || type.name || null;
          }

          if (typeof type === 'string') {
            return type;
          }

          switch (type) {
            case exports.Fragment:
              return 'Fragment';

            case REACT_PORTAL_TYPE:
              return 'Portal';

            case exports.Profiler:
              return 'Profiler';

            case exports.StrictMode:
              return 'StrictMode';

            case exports.Suspense:
              return 'Suspense';

            case REACT_SUSPENSE_LIST_TYPE:
              return 'SuspenseList';
          }

          if (typeof type === 'object') {
            switch (type.$$typeof) {
              case REACT_CONTEXT_TYPE:
                var context = type;
                return getContextName(context) + '.Consumer';

              case REACT_PROVIDER_TYPE:
                var provider = type;
                return getContextName(provider._context) + '.Provider';

              case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type, type.render, 'ForwardRef');

              case REACT_MEMO_TYPE:
                return getComponentName(type.type);

              case REACT_BLOCK_TYPE:
                return getComponentName(type._render);

              case REACT_LAZY_TYPE:
                {
                  var lazyComponent = type;
                  var payload = lazyComponent._payload;
                  var init = lazyComponent._init;

                  try {
                    return getComponentName(init(payload));
                  } catch (x) {
                    return null;
                  }
                }
            }
          }

          return null;
        }

        var hasOwnProperty = Object.prototype.hasOwnProperty;
        var RESERVED_PROPS = {
          key: true,
          ref: true,
          __self: true,
          __source: true
        };
        var specialPropKeyWarningShown, specialPropRefWarningShown, didWarnAboutStringRefs;
        {
          didWarnAboutStringRefs = {};
        }

        function hasValidRef(config) {
          {
            if (hasOwnProperty.call(config, 'ref')) {
              var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;

              if (getter && getter.isReactWarning) {
                return false;
              }
            }
          }
          return config.ref !== undefined;
        }

        function hasValidKey(config) {
          {
            if (hasOwnProperty.call(config, 'key')) {
              var getter = Object.getOwnPropertyDescriptor(config, 'key').get;

              if (getter && getter.isReactWarning) {
                return false;
              }
            }
          }
          return config.key !== undefined;
        }

        function defineKeyPropWarningGetter(props, displayName) {
          var warnAboutAccessingKey = function warnAboutAccessingKey() {
            {
              if (!specialPropKeyWarningShown) {
                specialPropKeyWarningShown = true;
                error('%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
              }
            }
          };

          warnAboutAccessingKey.isReactWarning = true;
          Object.defineProperty(props, 'key', {
            get: warnAboutAccessingKey,
            configurable: true
          });
        }

        function defineRefPropWarningGetter(props, displayName) {
          var warnAboutAccessingRef = function warnAboutAccessingRef() {
            {
              if (!specialPropRefWarningShown) {
                specialPropRefWarningShown = true;
                error('%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
              }
            }
          };

          warnAboutAccessingRef.isReactWarning = true;
          Object.defineProperty(props, 'ref', {
            get: warnAboutAccessingRef,
            configurable: true
          });
        }

        function warnIfStringRefCannotBeAutoConverted(config) {
          {
            if (typeof config.ref === 'string' && ReactCurrentOwner.current && config.__self && ReactCurrentOwner.current.stateNode !== config.__self) {
              var componentName = getComponentName(ReactCurrentOwner.current.type);

              if (!didWarnAboutStringRefs[componentName]) {
                error('Component "%s" contains the string ref "%s". ' + 'Support for string refs will be removed in a future major release. ' + 'This case cannot be automatically converted to an arrow function. ' + 'We ask you to manually fix this case by using useRef() or createRef() instead. ' + 'Learn more about using refs safely here: ' + 'https://reactjs.org/link/strict-mode-string-ref', componentName, config.ref);
                didWarnAboutStringRefs[componentName] = true;
              }
            }
          }
        }
        /**
         * Factory method to create a new React element. This no longer adheres to
         * the class pattern, so do not use new to call it. Also, instanceof check
         * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
         * if something is a React Element.
         *
         * @param {*} type
         * @param {*} props
         * @param {*} key
         * @param {string|object} ref
         * @param {*} owner
         * @param {*} self A *temporary* helper to detect places where `this` is
         * different from the `owner` when React.createElement is called, so that we
         * can warn. We want to get rid of owner and replace string `ref`s with arrow
         * functions, and as long as `this` and owner are the same, there will be no
         * change in behavior.
         * @param {*} source An annotation object (added by a transpiler or otherwise)
         * indicating filename, line number, and/or other information.
         * @internal
         */


        var ReactElement = function ReactElement(type, key, ref, self, source, owner, props) {
          var element = {
            // This tag allows us to uniquely identify this as a React Element
            $$typeof: REACT_ELEMENT_TYPE,
            // Built-in properties that belong on the element
            type: type,
            key: key,
            ref: ref,
            props: props,
            // Record the component responsible for creating this element.
            _owner: owner
          };
          {
            // The validation flag is currently mutative. We put it on
            // an external backing store so that we can freeze the whole object.
            // This can be replaced with a WeakMap once they are implemented in
            // commonly used development environments.
            element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
            // the validation flag non-enumerable (where possible, which should
            // include every environment we run tests in), so the test framework
            // ignores it.

            Object.defineProperty(element._store, 'validated', {
              configurable: false,
              enumerable: false,
              writable: true,
              value: false
            }); // self and source are DEV only properties.

            Object.defineProperty(element, '_self', {
              configurable: false,
              enumerable: false,
              writable: false,
              value: self
            }); // Two elements created in two different places should be considered
            // equal for testing purposes and therefore we hide it from enumeration.

            Object.defineProperty(element, '_source', {
              configurable: false,
              enumerable: false,
              writable: false,
              value: source
            });

            if (Object.freeze) {
              Object.freeze(element.props);
              Object.freeze(element);
            }
          }
          return element;
        };
        /**
         * Create and return a new ReactElement of the given type.
         * See https://reactjs.org/docs/react-api.html#createelement
         */


        function createElement(type, config, children) {
          var propName; // Reserved names are extracted

          var props = {};
          var key = null;
          var ref = null;
          var self = null;
          var source = null;

          if (config != null) {
            if (hasValidRef(config)) {
              ref = config.ref;
              {
                warnIfStringRefCannotBeAutoConverted(config);
              }
            }

            if (hasValidKey(config)) {
              key = '' + config.key;
            }

            self = config.__self === undefined ? null : config.__self;
            source = config.__source === undefined ? null : config.__source; // Remaining properties are added to a new props object

            for (propName in config) {
              if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
                props[propName] = config[propName];
              }
            }
          } // Children can be more than one argument, and those are transferred onto
          // the newly allocated props object.


          var childrenLength = arguments.length - 2;

          if (childrenLength === 1) {
            props.children = children;
          } else if (childrenLength > 1) {
            var childArray = Array(childrenLength);

            for (var i = 0; i < childrenLength; i++) {
              childArray[i] = arguments[i + 2];
            }

            {
              if (Object.freeze) {
                Object.freeze(childArray);
              }
            }
            props.children = childArray;
          } // Resolve default props


          if (type && type.defaultProps) {
            var defaultProps = type.defaultProps;

            for (propName in defaultProps) {
              if (props[propName] === undefined) {
                props[propName] = defaultProps[propName];
              }
            }
          }

          {
            if (key || ref) {
              var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;

              if (key) {
                defineKeyPropWarningGetter(props, displayName);
              }

              if (ref) {
                defineRefPropWarningGetter(props, displayName);
              }
            }
          }
          return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
        }

        function cloneAndReplaceKey(oldElement, newKey) {
          var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
          return newElement;
        }
        /**
         * Clone and return a new ReactElement using element as the starting point.
         * See https://reactjs.org/docs/react-api.html#cloneelement
         */


        function cloneElement(element, config, children) {
          if (!!(element === null || element === undefined)) {
            {
              throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + element + ".");
            }
          }

          var propName; // Original props are copied

          var props = _assign({}, element.props); // Reserved names are extracted


          var key = element.key;
          var ref = element.ref; // Self is preserved since the owner is preserved.

          var self = element._self; // Source is preserved since cloneElement is unlikely to be targeted by a
          // transpiler, and the original source is probably a better indicator of the
          // true owner.

          var source = element._source; // Owner will be preserved, unless ref is overridden

          var owner = element._owner;

          if (config != null) {
            if (hasValidRef(config)) {
              // Silently steal the ref from the parent.
              ref = config.ref;
              owner = ReactCurrentOwner.current;
            }

            if (hasValidKey(config)) {
              key = '' + config.key;
            } // Remaining properties override existing props


            var defaultProps;

            if (element.type && element.type.defaultProps) {
              defaultProps = element.type.defaultProps;
            }

            for (propName in config) {
              if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
                if (config[propName] === undefined && defaultProps !== undefined) {
                  // Resolve default props
                  props[propName] = defaultProps[propName];
                } else {
                  props[propName] = config[propName];
                }
              }
            }
          } // Children can be more than one argument, and those are transferred onto
          // the newly allocated props object.


          var childrenLength = arguments.length - 2;

          if (childrenLength === 1) {
            props.children = children;
          } else if (childrenLength > 1) {
            var childArray = Array(childrenLength);

            for (var i = 0; i < childrenLength; i++) {
              childArray[i] = arguments[i + 2];
            }

            props.children = childArray;
          }

          return ReactElement(element.type, key, ref, self, source, owner, props);
        }
        /**
         * Verifies the object is a ReactElement.
         * See https://reactjs.org/docs/react-api.html#isvalidelement
         * @param {?object} object
         * @return {boolean} True if `object` is a ReactElement.
         * @final
         */


        function isValidElement(object) {
          return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
        }

        var SEPARATOR = '.';
        var SUBSEPARATOR = ':';
        /**
         * Escape and wrap key so it is safe to use as a reactid
         *
         * @param {string} key to be escaped.
         * @return {string} the escaped key.
         */

        function escape(key) {
          var escapeRegex = /[=:]/g;
          var escaperLookup = {
            '=': '=0',
            ':': '=2'
          };
          var escapedString = key.replace(escapeRegex, function (match) {
            return escaperLookup[match];
          });
          return '$' + escapedString;
        }
        /**
         * TODO: Test that a single child and an array with one item have the same key
         * pattern.
         */


        var didWarnAboutMaps = false;
        var userProvidedKeyEscapeRegex = /\/+/g;

        function escapeUserProvidedKey(text) {
          return text.replace(userProvidedKeyEscapeRegex, '$&/');
        }
        /**
         * Generate a key string that identifies a element within a set.
         *
         * @param {*} element A element that could contain a manual key.
         * @param {number} index Index that is used if a manual key is not provided.
         * @return {string}
         */


        function getElementKey(element, index) {
          // Do some typechecking here since we call this blindly. We want to ensure
          // that we don't block potential future ES APIs.
          if (typeof element === 'object' && element !== null && element.key != null) {
            // Explicit key
            return escape('' + element.key);
          } // Implicit key determined by the index in the set


          return index.toString(36);
        }

        function mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
          var type = typeof children;

          if (type === 'undefined' || type === 'boolean') {
            // All of the above are perceived as null.
            children = null;
          }

          var invokeCallback = false;

          if (children === null) {
            invokeCallback = true;
          } else {
            switch (type) {
              case 'string':
              case 'number':
                invokeCallback = true;
                break;

              case 'object':
                switch (children.$$typeof) {
                  case REACT_ELEMENT_TYPE:
                  case REACT_PORTAL_TYPE:
                    invokeCallback = true;
                }

            }
          }

          if (invokeCallback) {
            var _child = children;
            var mappedChild = callback(_child); // If it's the only child, treat the name as if it was wrapped in an array
            // so that it's consistent if the number of children grows:

            var childKey = nameSoFar === '' ? SEPARATOR + getElementKey(_child, 0) : nameSoFar;

            if (Array.isArray(mappedChild)) {
              var escapedChildKey = '';

              if (childKey != null) {
                escapedChildKey = escapeUserProvidedKey(childKey) + '/';
              }

              mapIntoArray(mappedChild, array, escapedChildKey, '', function (c) {
                return c;
              });
            } else if (mappedChild != null) {
              if (isValidElement(mappedChild)) {
                mappedChild = cloneAndReplaceKey(mappedChild, // Keep both the (mapped) and old keys if they differ, just as
                // traverseAllChildren used to do for objects as children
                escapedPrefix + ( // $FlowFixMe Flow incorrectly thinks React.Portal doesn't have a key
                mappedChild.key && (!_child || _child.key !== mappedChild.key) ? // $FlowFixMe Flow incorrectly thinks existing element's key can be a number
                escapeUserProvidedKey('' + mappedChild.key) + '/' : '') + childKey);
              }

              array.push(mappedChild);
            }

            return 1;
          }

          var child;
          var nextName;
          var subtreeCount = 0; // Count of children found in the current subtree.

          var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

          if (Array.isArray(children)) {
            for (var i = 0; i < children.length; i++) {
              child = children[i];
              nextName = nextNamePrefix + getElementKey(child, i);
              subtreeCount += mapIntoArray(child, array, escapedPrefix, nextName, callback);
            }
          } else {
            var iteratorFn = getIteratorFn(children);

            if (typeof iteratorFn === 'function') {
              var iterableChildren = children;
              {
                // Warn about using Maps as children
                if (iteratorFn === iterableChildren.entries) {
                  if (!didWarnAboutMaps) {
                    warn('Using Maps as children is not supported. ' + 'Use an array of keyed ReactElements instead.');
                  }

                  didWarnAboutMaps = true;
                }
              }
              var iterator = iteratorFn.call(iterableChildren);
              var step;
              var ii = 0;

              while (!(step = iterator.next()).done) {
                child = step.value;
                nextName = nextNamePrefix + getElementKey(child, ii++);
                subtreeCount += mapIntoArray(child, array, escapedPrefix, nextName, callback);
              }
            } else if (type === 'object') {
              var childrenString = '' + children;
              {
                {
                  throw Error("Objects are not valid as a React child (found: " + (childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString) + "). If you meant to render a collection of children, use an array instead.");
                }
              }
            }
          }

          return subtreeCount;
        }
        /**
         * Maps children that are typically specified as `props.children`.
         *
         * See https://reactjs.org/docs/react-api.html#reactchildrenmap
         *
         * The provided mapFunction(child, index) will be called for each
         * leaf child.
         *
         * @param {?*} children Children tree container.
         * @param {function(*, int)} func The map function.
         * @param {*} context Context for mapFunction.
         * @return {object} Object containing the ordered map of results.
         */


        function mapChildren(children, func, context) {
          if (children == null) {
            return children;
          }

          var result = [];
          var count = 0;
          mapIntoArray(children, result, '', '', function (child) {
            return func.call(context, child, count++);
          });
          return result;
        }
        /**
         * Count the number of children that are typically specified as
         * `props.children`.
         *
         * See https://reactjs.org/docs/react-api.html#reactchildrencount
         *
         * @param {?*} children Children tree container.
         * @return {number} The number of children.
         */


        function countChildren(children) {
          var n = 0;
          mapChildren(children, function () {
            n++; // Don't return anything
          });
          return n;
        }
        /**
         * Iterates through children that are typically specified as `props.children`.
         *
         * See https://reactjs.org/docs/react-api.html#reactchildrenforeach
         *
         * The provided forEachFunc(child, index) will be called for each
         * leaf child.
         *
         * @param {?*} children Children tree container.
         * @param {function(*, int)} forEachFunc
         * @param {*} forEachContext Context for forEachContext.
         */


        function forEachChildren(children, forEachFunc, forEachContext) {
          mapChildren(children, function () {
            forEachFunc.apply(this, arguments); // Don't return anything.
          }, forEachContext);
        }
        /**
         * Flatten a children object (typically specified as `props.children`) and
         * return an array with appropriately re-keyed children.
         *
         * See https://reactjs.org/docs/react-api.html#reactchildrentoarray
         */


        function toArray(children) {
          return mapChildren(children, function (child) {
            return child;
          }) || [];
        }
        /**
         * Returns the first child in a collection of children and verifies that there
         * is only one child in the collection.
         *
         * See https://reactjs.org/docs/react-api.html#reactchildrenonly
         *
         * The current implementation of this function assumes that a single child gets
         * passed without a wrapper, but the purpose of this helper function is to
         * abstract away the particular structure of children.
         *
         * @param {?object} children Child collection structure.
         * @return {ReactElement} The first and only `ReactElement` contained in the
         * structure.
         */


        function onlyChild(children) {
          if (!isValidElement(children)) {
            {
              throw Error("React.Children.only expected to receive a single React element child.");
            }
          }

          return children;
        }

        function createContext(defaultValue, calculateChangedBits) {
          if (calculateChangedBits === undefined) {
            calculateChangedBits = null;
          } else {
            {
              if (calculateChangedBits !== null && typeof calculateChangedBits !== 'function') {
                error('createContext: Expected the optional second argument to be a ' + 'function. Instead received: %s', calculateChangedBits);
              }
            }
          }

          var context = {
            $$typeof: REACT_CONTEXT_TYPE,
            _calculateChangedBits: calculateChangedBits,
            // As a workaround to support multiple concurrent renderers, we categorize
            // some renderers as primary and others as secondary. We only expect
            // there to be two concurrent renderers at most: React Native (primary) and
            // Fabric (secondary); React DOM (primary) and React ART (secondary).
            // Secondary renderers store their context values on separate fields.
            _currentValue: defaultValue,
            _currentValue2: defaultValue,
            // Used to track how many concurrent renderers this context currently
            // supports within in a single renderer. Such as parallel server rendering.
            _threadCount: 0,
            // These are circular
            Provider: null,
            Consumer: null
          };
          context.Provider = {
            $$typeof: REACT_PROVIDER_TYPE,
            _context: context
          };
          var hasWarnedAboutUsingNestedContextConsumers = false;
          var hasWarnedAboutUsingConsumerProvider = false;
          var hasWarnedAboutDisplayNameOnConsumer = false;
          {
            // A separate object, but proxies back to the original context object for
            // backwards compatibility. It has a different $$typeof, so we can properly
            // warn for the incorrect usage of Context as a Consumer.
            var Consumer = {
              $$typeof: REACT_CONTEXT_TYPE,
              _context: context,
              _calculateChangedBits: context._calculateChangedBits
            }; // $FlowFixMe: Flow complains about not setting a value, which is intentional here

            Object.defineProperties(Consumer, {
              Provider: {
                get: function get() {
                  if (!hasWarnedAboutUsingConsumerProvider) {
                    hasWarnedAboutUsingConsumerProvider = true;
                    error('Rendering <Context.Consumer.Provider> is not supported and will be removed in ' + 'a future major release. Did you mean to render <Context.Provider> instead?');
                  }

                  return context.Provider;
                },
                set: function set(_Provider) {
                  context.Provider = _Provider;
                }
              },
              _currentValue: {
                get: function get() {
                  return context._currentValue;
                },
                set: function set(_currentValue) {
                  context._currentValue = _currentValue;
                }
              },
              _currentValue2: {
                get: function get() {
                  return context._currentValue2;
                },
                set: function set(_currentValue2) {
                  context._currentValue2 = _currentValue2;
                }
              },
              _threadCount: {
                get: function get() {
                  return context._threadCount;
                },
                set: function set(_threadCount) {
                  context._threadCount = _threadCount;
                }
              },
              Consumer: {
                get: function get() {
                  if (!hasWarnedAboutUsingNestedContextConsumers) {
                    hasWarnedAboutUsingNestedContextConsumers = true;
                    error('Rendering <Context.Consumer.Consumer> is not supported and will be removed in ' + 'a future major release. Did you mean to render <Context.Consumer> instead?');
                  }

                  return context.Consumer;
                }
              },
              displayName: {
                get: function get() {
                  return context.displayName;
                },
                set: function set(displayName) {
                  if (!hasWarnedAboutDisplayNameOnConsumer) {
                    warn('Setting `displayName` on Context.Consumer has no effect. ' + "You should set it directly on the context with Context.displayName = '%s'.", displayName);
                    hasWarnedAboutDisplayNameOnConsumer = true;
                  }
                }
              }
            }); // $FlowFixMe: Flow complains about missing properties because it doesn't understand defineProperty

            context.Consumer = Consumer;
          }
          {
            context._currentRenderer = null;
            context._currentRenderer2 = null;
          }
          return context;
        }

        var Uninitialized = -1;
        var Pending = 0;
        var Resolved = 1;
        var Rejected = 2;

        function lazyInitializer(payload) {
          if (payload._status === Uninitialized) {
            var ctor = payload._result;
            var thenable = ctor(); // Transition to the next state.

            var pending = payload;
            pending._status = Pending;
            pending._result = thenable;
            thenable.then(function (moduleObject) {
              if (payload._status === Pending) {
                var defaultExport = moduleObject.default;
                {
                  if (defaultExport === undefined) {
                    error('lazy: Expected the result of a dynamic import() call. ' + 'Instead received: %s\n\nYour code should look like: \n  ' + // Break up imports to avoid accidentally parsing them as dependencies.
                    'const MyComponent = lazy(() => imp' + "ort('./MyComponent'))", moduleObject);
                  }
                } // Transition to the next state.

                var resolved = payload;
                resolved._status = Resolved;
                resolved._result = defaultExport;
              }
            }, function (error) {
              if (payload._status === Pending) {
                // Transition to the next state.
                var rejected = payload;
                rejected._status = Rejected;
                rejected._result = error;
              }
            });
          }

          if (payload._status === Resolved) {
            return payload._result;
          } else {
            throw payload._result;
          }
        }

        function lazy(ctor) {
          var payload = {
            // We use these fields to store the result.
            _status: -1,
            _result: ctor
          };
          var lazyType = {
            $$typeof: REACT_LAZY_TYPE,
            _payload: payload,
            _init: lazyInitializer
          };
          {
            // In production, this would just set it on the object.
            var defaultProps;
            var propTypes; // $FlowFixMe

            Object.defineProperties(lazyType, {
              defaultProps: {
                configurable: true,
                get: function get() {
                  return defaultProps;
                },
                set: function set(newDefaultProps) {
                  error('React.lazy(...): It is not supported to assign `defaultProps` to ' + 'a lazy component import. Either specify them where the component ' + 'is defined, or create a wrapping component around it.');
                  defaultProps = newDefaultProps; // Match production behavior more closely:
                  // $FlowFixMe

                  Object.defineProperty(lazyType, 'defaultProps', {
                    enumerable: true
                  });
                }
              },
              propTypes: {
                configurable: true,
                get: function get() {
                  return propTypes;
                },
                set: function set(newPropTypes) {
                  error('React.lazy(...): It is not supported to assign `propTypes` to ' + 'a lazy component import. Either specify them where the component ' + 'is defined, or create a wrapping component around it.');
                  propTypes = newPropTypes; // Match production behavior more closely:
                  // $FlowFixMe

                  Object.defineProperty(lazyType, 'propTypes', {
                    enumerable: true
                  });
                }
              }
            });
          }
          return lazyType;
        }

        function forwardRef(render) {
          {
            if (render != null && render.$$typeof === REACT_MEMO_TYPE) {
              error('forwardRef requires a render function but received a `memo` ' + 'component. Instead of forwardRef(memo(...)), use ' + 'memo(forwardRef(...)).');
            } else if (typeof render !== 'function') {
              error('forwardRef requires a render function but was given %s.', render === null ? 'null' : typeof render);
            } else {
              if (render.length !== 0 && render.length !== 2) {
                error('forwardRef render functions accept exactly two parameters: props and ref. %s', render.length === 1 ? 'Did you forget to use the ref parameter?' : 'Any additional parameter will be undefined.');
              }
            }

            if (render != null) {
              if (render.defaultProps != null || render.propTypes != null) {
                error('forwardRef render functions do not support propTypes or defaultProps. ' + 'Did you accidentally pass a React component?');
              }
            }
          }
          var elementType = {
            $$typeof: REACT_FORWARD_REF_TYPE,
            render: render
          };
          {
            var ownName;
            Object.defineProperty(elementType, 'displayName', {
              enumerable: false,
              configurable: true,
              get: function get() {
                return ownName;
              },
              set: function set(name) {
                ownName = name;

                if (render.displayName == null) {
                  render.displayName = name;
                }
              }
            });
          }
          return elementType;
        } // Filter certain DOM attributes (e.g. src, href) if their values are empty strings.


        var enableScopeAPI = false; // Experimental Create Event Handle API.

        function isValidElementType(type) {
          if (typeof type === 'string' || typeof type === 'function') {
            return true;
          } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).


          if (type === exports.Fragment || type === exports.Profiler || type === REACT_DEBUG_TRACING_MODE_TYPE || type === exports.StrictMode || type === exports.Suspense || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_LEGACY_HIDDEN_TYPE || enableScopeAPI) {
            return true;
          }

          if (typeof type === 'object' && type !== null) {
            if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_BLOCK_TYPE || type[0] === REACT_SERVER_BLOCK_TYPE) {
              return true;
            }
          }

          return false;
        }

        function memo(type, compare) {
          {
            if (!isValidElementType(type)) {
              error('memo: The first argument must be a component. Instead ' + 'received: %s', type === null ? 'null' : typeof type);
            }
          }
          var elementType = {
            $$typeof: REACT_MEMO_TYPE,
            type: type,
            compare: compare === undefined ? null : compare
          };
          {
            var ownName;
            Object.defineProperty(elementType, 'displayName', {
              enumerable: false,
              configurable: true,
              get: function get() {
                return ownName;
              },
              set: function set(name) {
                ownName = name;

                if (type.displayName == null) {
                  type.displayName = name;
                }
              }
            });
          }
          return elementType;
        }

        function resolveDispatcher() {
          var dispatcher = ReactCurrentDispatcher.current;

          if (!(dispatcher !== null)) {
            {
              throw Error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.");
            }
          }

          return dispatcher;
        }

        function useContext(Context, unstable_observedBits) {
          var dispatcher = resolveDispatcher();
          {
            if (unstable_observedBits !== undefined) {
              error('useContext() second argument is reserved for future ' + 'use in React. Passing it is not supported. ' + 'You passed: %s.%s', unstable_observedBits, typeof unstable_observedBits === 'number' && Array.isArray(arguments[2]) ? '\n\nDid you call array.map(useContext)? ' + 'Calling Hooks inside a loop is not supported. ' + 'Learn more at https://reactjs.org/link/rules-of-hooks' : '');
            } // TODO: add a more generic warning for invalid values.


            if (Context._context !== undefined) {
              var realContext = Context._context; // Don't deduplicate because this legitimately causes bugs
              // and nobody should be using this in existing code.

              if (realContext.Consumer === Context) {
                error('Calling useContext(Context.Consumer) is not supported, may cause bugs, and will be ' + 'removed in a future major release. Did you mean to call useContext(Context) instead?');
              } else if (realContext.Provider === Context) {
                error('Calling useContext(Context.Provider) is not supported. ' + 'Did you mean to call useContext(Context) instead?');
              }
            }
          }
          return dispatcher.useContext(Context, unstable_observedBits);
        }

        function useState(initialState) {
          var dispatcher = resolveDispatcher();
          return dispatcher.useState(initialState);
        }

        function useReducer(reducer, initialArg, init) {
          var dispatcher = resolveDispatcher();
          return dispatcher.useReducer(reducer, initialArg, init);
        }

        function useRef(initialValue) {
          var dispatcher = resolveDispatcher();
          return dispatcher.useRef(initialValue);
        }

        function useEffect(create, deps) {
          var dispatcher = resolveDispatcher();
          return dispatcher.useEffect(create, deps);
        }

        function useLayoutEffect(create, deps) {
          var dispatcher = resolveDispatcher();
          return dispatcher.useLayoutEffect(create, deps);
        }

        function useCallback(callback, deps) {
          var dispatcher = resolveDispatcher();
          return dispatcher.useCallback(callback, deps);
        }

        function useMemo(create, deps) {
          var dispatcher = resolveDispatcher();
          return dispatcher.useMemo(create, deps);
        }

        function useImperativeHandle(ref, create, deps) {
          var dispatcher = resolveDispatcher();
          return dispatcher.useImperativeHandle(ref, create, deps);
        }

        function useDebugValue(value, formatterFn) {
          {
            var dispatcher = resolveDispatcher();
            return dispatcher.useDebugValue(value, formatterFn);
          }
        } // Helpers to patch console.logs to avoid logging during side-effect free
        // replaying on render function. This currently only patches the object
        // lazily which won't cover if the log function was extracted eagerly.
        // We could also eagerly patch the method.


        var disabledDepth = 0;
        var prevLog;
        var prevInfo;
        var prevWarn;
        var prevError;
        var prevGroup;
        var prevGroupCollapsed;
        var prevGroupEnd;

        function disabledLog() {}

        disabledLog.__reactDisabledLog = true;

        function disableLogs() {
          {
            if (disabledDepth === 0) {
              /* eslint-disable react-internal/no-production-logging */
              prevLog = console.log;
              prevInfo = console.info;
              prevWarn = console.warn;
              prevError = console.error;
              prevGroup = console.group;
              prevGroupCollapsed = console.groupCollapsed;
              prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099

              var props = {
                configurable: true,
                enumerable: true,
                value: disabledLog,
                writable: true
              }; // $FlowFixMe Flow thinks console is immutable.

              Object.defineProperties(console, {
                info: props,
                log: props,
                warn: props,
                error: props,
                group: props,
                groupCollapsed: props,
                groupEnd: props
              });
              /* eslint-enable react-internal/no-production-logging */
            }

            disabledDepth++;
          }
        }

        function reenableLogs() {
          {
            disabledDepth--;

            if (disabledDepth === 0) {
              /* eslint-disable react-internal/no-production-logging */
              var props = {
                configurable: true,
                enumerable: true,
                writable: true
              }; // $FlowFixMe Flow thinks console is immutable.

              Object.defineProperties(console, {
                log: _assign({}, props, {
                  value: prevLog
                }),
                info: _assign({}, props, {
                  value: prevInfo
                }),
                warn: _assign({}, props, {
                  value: prevWarn
                }),
                error: _assign({}, props, {
                  value: prevError
                }),
                group: _assign({}, props, {
                  value: prevGroup
                }),
                groupCollapsed: _assign({}, props, {
                  value: prevGroupCollapsed
                }),
                groupEnd: _assign({}, props, {
                  value: prevGroupEnd
                })
              });
              /* eslint-enable react-internal/no-production-logging */
            }

            if (disabledDepth < 0) {
              error('disabledDepth fell below zero. ' + 'This is a bug in React. Please file an issue.');
            }
          }
        }

        var ReactCurrentDispatcher$1 = ReactSharedInternals.ReactCurrentDispatcher;
        var prefix;

        function describeBuiltInComponentFrame(name, source, ownerFn) {
          {
            if (prefix === undefined) {
              // Extract the VM specific prefix used by each line.
              try {
                throw Error();
              } catch (x) {
                var match = x.stack.trim().match(/\n( *(at )?)/);
                prefix = match && match[1] || '';
              }
            } // We use the prefix to ensure our stacks line up with native stack frames.


            return '\n' + prefix + name;
          }
        }

        var reentry = false;
        var componentFrameCache;
        {
          var PossiblyWeakMap = typeof WeakMap === 'function' ? WeakMap : Map;
          componentFrameCache = new PossiblyWeakMap();
        }

        function describeNativeComponentFrame(fn, construct) {
          // If something asked for a stack inside a fake render, it should get ignored.
          if (!fn || reentry) {
            return '';
          }

          {
            var frame = componentFrameCache.get(fn);

            if (frame !== undefined) {
              return frame;
            }
          }
          var control;
          reentry = true;
          var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.

          Error.prepareStackTrace = undefined;
          var previousDispatcher;
          {
            previousDispatcher = ReactCurrentDispatcher$1.current; // Set the dispatcher in DEV because this might be call in the render function
            // for warnings.

            ReactCurrentDispatcher$1.current = null;
            disableLogs();
          }

          try {
            // This should throw.
            if (construct) {
              // Something should be setting the props in the constructor.
              var Fake = function Fake() {
                throw Error();
              }; // $FlowFixMe


              Object.defineProperty(Fake.prototype, 'props', {
                set: function set() {
                  // We use a throwing setter instead of frozen or non-writable props
                  // because that won't throw in a non-strict mode function.
                  throw Error();
                }
              });

              if (typeof Reflect === 'object' && Reflect.construct) {
                // We construct a different control for this case to include any extra
                // frames added by the construct call.
                try {
                  Reflect.construct(Fake, []);
                } catch (x) {
                  control = x;
                }

                Reflect.construct(fn, [], Fake);
              } else {
                try {
                  Fake.call();
                } catch (x) {
                  control = x;
                }

                fn.call(Fake.prototype);
              }
            } else {
              try {
                throw Error();
              } catch (x) {
                control = x;
              }

              fn();
            }
          } catch (sample) {
            // This is inlined manually because closure doesn't do it for us.
            if (sample && control && typeof sample.stack === 'string') {
              // This extracts the first frame from the sample that isn't also in the control.
              // Skipping one frame that we assume is the frame that calls the two.
              var sampleLines = sample.stack.split('\n');
              var controlLines = control.stack.split('\n');
              var s = sampleLines.length - 1;
              var c = controlLines.length - 1;

              while (s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c]) {
                // We expect at least one stack frame to be shared.
                // Typically this will be the root most one. However, stack frames may be
                // cut off due to maximum stack limits. In this case, one maybe cut off
                // earlier than the other. We assume that the sample is longer or the same
                // and there for cut off earlier. So we should find the root most frame in
                // the sample somewhere in the control.
                c--;
              }

              for (; s >= 1 && c >= 0; s--, c--) {
                // Next we find the first one that isn't the same which should be the
                // frame that called our sample function and the control.
                if (sampleLines[s] !== controlLines[c]) {
                  // In V8, the first line is describing the message but other VMs don't.
                  // If we're about to return the first line, and the control is also on the same
                  // line, that's a pretty good indicator that our sample threw at same line as
                  // the control. I.e. before we entered the sample frame. So we ignore this result.
                  // This can happen if you passed a class to function component, or non-function.
                  if (s !== 1 || c !== 1) {
                    do {
                      s--;
                      c--; // We may still have similar intermediate frames from the construct call.
                      // The next one that isn't the same should be our match though.

                      if (c < 0 || sampleLines[s] !== controlLines[c]) {
                        // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                        var _frame = '\n' + sampleLines[s].replace(' at new ', ' at ');

                        {
                          if (typeof fn === 'function') {
                            componentFrameCache.set(fn, _frame);
                          }
                        } // Return the line we found.

                        return _frame;
                      }
                    } while (s >= 1 && c >= 0);
                  }

                  break;
                }
              }
            }
          } finally {
            reentry = false;
            {
              ReactCurrentDispatcher$1.current = previousDispatcher;
              reenableLogs();
            }
            Error.prepareStackTrace = previousPrepareStackTrace;
          } // Fallback to just using the name if we couldn't make it throw.


          var name = fn ? fn.displayName || fn.name : '';
          var syntheticFrame = name ? describeBuiltInComponentFrame(name) : '';
          {
            if (typeof fn === 'function') {
              componentFrameCache.set(fn, syntheticFrame);
            }
          }
          return syntheticFrame;
        }

        function describeFunctionComponentFrame(fn, source, ownerFn) {
          {
            return describeNativeComponentFrame(fn, false);
          }
        }

        function shouldConstruct(Component) {
          var prototype = Component.prototype;
          return !!(prototype && prototype.isReactComponent);
        }

        function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
          if (type == null) {
            return '';
          }

          if (typeof type === 'function') {
            {
              return describeNativeComponentFrame(type, shouldConstruct(type));
            }
          }

          if (typeof type === 'string') {
            return describeBuiltInComponentFrame(type);
          }

          switch (type) {
            case exports.Suspense:
              return describeBuiltInComponentFrame('Suspense');

            case REACT_SUSPENSE_LIST_TYPE:
              return describeBuiltInComponentFrame('SuspenseList');
          }

          if (typeof type === 'object') {
            switch (type.$$typeof) {
              case REACT_FORWARD_REF_TYPE:
                return describeFunctionComponentFrame(type.render);

              case REACT_MEMO_TYPE:
                // Memo may contain any component type so we recursively resolve it.
                return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);

              case REACT_BLOCK_TYPE:
                return describeFunctionComponentFrame(type._render);

              case REACT_LAZY_TYPE:
                {
                  var lazyComponent = type;
                  var payload = lazyComponent._payload;
                  var init = lazyComponent._init;

                  try {
                    // Lazy may contain any component type so we recursively resolve it.
                    return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                  } catch (x) {}
                }
            }
          }

          return '';
        }

        var loggedTypeFailures = {};
        var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;

        function setCurrentlyValidatingElement(element) {
          {
            if (element) {
              var owner = element._owner;
              var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
              ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
            } else {
              ReactDebugCurrentFrame$1.setExtraStackFrame(null);
            }
          }
        }

        function checkPropTypes(typeSpecs, values, location, componentName, element) {
          {
            // $FlowFixMe This is okay but Flow doesn't know it.
            var has = Function.call.bind(Object.prototype.hasOwnProperty);

            for (var typeSpecName in typeSpecs) {
              if (has(typeSpecs, typeSpecName)) {
                var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
                // fail the render phase where it didn't fail before. So we log it.
                // After these have been cleaned up, we'll let them throw.

                try {
                  // This is intentionally an invariant that gets caught. It's the same
                  // behavior as without this statement except with a better message.
                  if (typeof typeSpecs[typeSpecName] !== 'function') {
                    var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
                    err.name = 'Invariant Violation';
                    throw err;
                  }

                  error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
                } catch (ex) {
                  error$1 = ex;
                }

                if (error$1 && !(error$1 instanceof Error)) {
                  setCurrentlyValidatingElement(element);
                  error('%s: type specification of %s' + ' `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error$1);
                  setCurrentlyValidatingElement(null);
                }

                if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                  // Only monitor this failure once because there tends to be a lot of the
                  // same error.
                  loggedTypeFailures[error$1.message] = true;
                  setCurrentlyValidatingElement(element);
                  error('Failed %s type: %s', location, error$1.message);
                  setCurrentlyValidatingElement(null);
                }
              }
            }
          }
        }

        function setCurrentlyValidatingElement$1(element) {
          {
            if (element) {
              var owner = element._owner;
              var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
              setExtraStackFrame(stack);
            } else {
              setExtraStackFrame(null);
            }
          }
        }

        var propTypesMisspellWarningShown;
        {
          propTypesMisspellWarningShown = false;
        }

        function getDeclarationErrorAddendum() {
          if (ReactCurrentOwner.current) {
            var name = getComponentName(ReactCurrentOwner.current.type);

            if (name) {
              return '\n\nCheck the render method of `' + name + '`.';
            }
          }

          return '';
        }

        function getSourceInfoErrorAddendum(source) {
          if (source !== undefined) {
            var fileName = source.fileName.replace(/^.*[\\\/]/, '');
            var lineNumber = source.lineNumber;
            return '\n\nCheck your code at ' + fileName + ':' + lineNumber + '.';
          }

          return '';
        }

        function getSourceInfoErrorAddendumForProps(elementProps) {
          if (elementProps !== null && elementProps !== undefined) {
            return getSourceInfoErrorAddendum(elementProps.__source);
          }

          return '';
        }
        /**
         * Warn if there's no key explicitly set on dynamic arrays of children or
         * object keys are not valid. This allows us to keep track of children between
         * updates.
         */


        var ownerHasKeyUseWarning = {};

        function getCurrentComponentErrorInfo(parentType) {
          var info = getDeclarationErrorAddendum();

          if (!info) {
            var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;

            if (parentName) {
              info = "\n\nCheck the top-level render call using <" + parentName + ">.";
            }
          }

          return info;
        }
        /**
         * Warn if the element doesn't have an explicit key assigned to it.
         * This element is in an array. The array could grow and shrink or be
         * reordered. All children that haven't already been validated are required to
         * have a "key" property assigned to it. Error statuses are cached so a warning
         * will only be shown once.
         *
         * @internal
         * @param {ReactElement} element Element that requires a key.
         * @param {*} parentType element's parent's type.
         */


        function validateExplicitKey(element, parentType) {
          if (!element._store || element._store.validated || element.key != null) {
            return;
          }

          element._store.validated = true;
          var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);

          if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
            return;
          }

          ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
          // property, it may be the creator of the child that's responsible for
          // assigning it a key.

          var childOwner = '';

          if (element && element._owner && element._owner !== ReactCurrentOwner.current) {
            // Give the component that originally created this child.
            childOwner = " It was passed a child from " + getComponentName(element._owner.type) + ".";
          }

          {
            setCurrentlyValidatingElement$1(element);
            error('Each child in a list should have a unique "key" prop.' + '%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
            setCurrentlyValidatingElement$1(null);
          }
        }
        /**
         * Ensure that every element either is passed in a static location, in an
         * array with an explicit keys property defined, or in an object literal
         * with valid key property.
         *
         * @internal
         * @param {ReactNode} node Statically passed child of any type.
         * @param {*} parentType node's parent's type.
         */


        function validateChildKeys(node, parentType) {
          if (typeof node !== 'object') {
            return;
          }

          if (Array.isArray(node)) {
            for (var i = 0; i < node.length; i++) {
              var child = node[i];

              if (isValidElement(child)) {
                validateExplicitKey(child, parentType);
              }
            }
          } else if (isValidElement(node)) {
            // This element was passed in a valid location.
            if (node._store) {
              node._store.validated = true;
            }
          } else if (node) {
            var iteratorFn = getIteratorFn(node);

            if (typeof iteratorFn === 'function') {
              // Entry iterators used to provide implicit keys,
              // but now we print a separate warning for them later.
              if (iteratorFn !== node.entries) {
                var iterator = iteratorFn.call(node);
                var step;

                while (!(step = iterator.next()).done) {
                  if (isValidElement(step.value)) {
                    validateExplicitKey(step.value, parentType);
                  }
                }
              }
            }
          }
        }
        /**
         * Given an element, validate that its props follow the propTypes definition,
         * provided by the type.
         *
         * @param {ReactElement} element
         */


        function validatePropTypes(element) {
          {
            var type = element.type;

            if (type === null || type === undefined || typeof type === 'string') {
              return;
            }

            var propTypes;

            if (typeof type === 'function') {
              propTypes = type.propTypes;
            } else if (typeof type === 'object' && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
            // Inner props are checked in the reconciler.
            type.$$typeof === REACT_MEMO_TYPE)) {
              propTypes = type.propTypes;
            } else {
              return;
            }

            if (propTypes) {
              // Intentionally inside to avoid triggering lazy initializers:
              var name = getComponentName(type);
              checkPropTypes(propTypes, element.props, 'prop', name, element);
            } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
              propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:

              var _name = getComponentName(type);

              error('Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?', _name || 'Unknown');
            }

            if (typeof type.getDefaultProps === 'function' && !type.getDefaultProps.isReactClassApproved) {
              error('getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.');
            }
          }
        }
        /**
         * Given a fragment, validate that it can only be provided with fragment props
         * @param {ReactElement} fragment
         */


        function validateFragmentProps(fragment) {
          {
            var keys = Object.keys(fragment.props);

            for (var i = 0; i < keys.length; i++) {
              var key = keys[i];

              if (key !== 'children' && key !== 'key') {
                setCurrentlyValidatingElement$1(fragment);
                error('Invalid prop `%s` supplied to `React.Fragment`. ' + 'React.Fragment can only have `key` and `children` props.', key);
                setCurrentlyValidatingElement$1(null);
                break;
              }
            }

            if (fragment.ref !== null) {
              setCurrentlyValidatingElement$1(fragment);
              error('Invalid attribute `ref` supplied to `React.Fragment`.');
              setCurrentlyValidatingElement$1(null);
            }
          }
        }

        function createElementWithValidation(type, props, children) {
          var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
          // succeed and there will likely be errors in render.

          if (!validType) {
            var info = '';

            if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
              info += ' You likely forgot to export your component from the file ' + "it's defined in, or you might have mixed up default and named imports.";
            }

            var sourceInfo = getSourceInfoErrorAddendumForProps(props);

            if (sourceInfo) {
              info += sourceInfo;
            } else {
              info += getDeclarationErrorAddendum();
            }

            var typeString;

            if (type === null) {
              typeString = 'null';
            } else if (Array.isArray(type)) {
              typeString = 'array';
            } else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
              typeString = "<" + (getComponentName(type.type) || 'Unknown') + " />";
              info = ' Did you accidentally export a JSX literal instead of a component?';
            } else {
              typeString = typeof type;
            }

            {
              error('React.createElement: type is invalid -- expected a string (for ' + 'built-in components) or a class/function (for composite ' + 'components) but got: %s.%s', typeString, info);
            }
          }

          var element = createElement.apply(this, arguments); // The result can be nullish if a mock or a custom function is used.
          // TODO: Drop this when these are no longer allowed as the type argument.

          if (element == null) {
            return element;
          } // Skip key warning if the type isn't valid since our key validation logic
          // doesn't expect a non-string/function type and can throw confusing errors.
          // We don't want exception behavior to differ between dev and prod.
          // (Rendering will throw with a helpful message and as soon as the type is
          // fixed, the key warnings will appear.)


          if (validType) {
            for (var i = 2; i < arguments.length; i++) {
              validateChildKeys(arguments[i], type);
            }
          }

          if (type === exports.Fragment) {
            validateFragmentProps(element);
          } else {
            validatePropTypes(element);
          }

          return element;
        }

        var didWarnAboutDeprecatedCreateFactory = false;

        function createFactoryWithValidation(type) {
          var validatedFactory = createElementWithValidation.bind(null, type);
          validatedFactory.type = type;
          {
            if (!didWarnAboutDeprecatedCreateFactory) {
              didWarnAboutDeprecatedCreateFactory = true;
              warn('React.createFactory() is deprecated and will be removed in ' + 'a future major release. Consider using JSX ' + 'or use React.createElement() directly instead.');
            } // Legacy hook: remove it


            Object.defineProperty(validatedFactory, 'type', {
              enumerable: false,
              get: function get() {
                warn('Factory.type is deprecated. Access the class directly ' + 'before passing it to createFactory.');
                Object.defineProperty(this, 'type', {
                  value: type
                });
                return type;
              }
            });
          }
          return validatedFactory;
        }

        function cloneElementWithValidation(element, props, children) {
          var newElement = cloneElement.apply(this, arguments);

          for (var i = 2; i < arguments.length; i++) {
            validateChildKeys(arguments[i], newElement.type);
          }

          validatePropTypes(newElement);
          return newElement;
        }

        {
          try {
            var frozenObject = Object.freeze({});
            /* eslint-disable no-new */

            new Map([[frozenObject, null]]);
            new Set([frozenObject]);
            /* eslint-enable no-new */
          } catch (e) {}
        }
        var createElement$1 = createElementWithValidation;
        var cloneElement$1 = cloneElementWithValidation;
        var createFactory = createFactoryWithValidation;
        var Children = {
          map: mapChildren,
          forEach: forEachChildren,
          count: countChildren,
          toArray: toArray,
          only: onlyChild
        };
        exports.Children = Children;
        exports.Component = Component;
        exports.PureComponent = PureComponent;
        exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ReactSharedInternals;
        exports.cloneElement = cloneElement$1;
        exports.createContext = createContext;
        exports.createElement = createElement$1;
        exports.createFactory = createFactory;
        exports.createRef = createRef;
        exports.forwardRef = forwardRef;
        exports.isValidElement = isValidElement;
        exports.lazy = lazy;
        exports.memo = memo;
        exports.useCallback = useCallback;
        exports.useContext = useContext;
        exports.useDebugValue = useDebugValue;
        exports.useEffect = useEffect;
        exports.useImperativeHandle = useImperativeHandle;
        exports.useLayoutEffect = useLayoutEffect;
        exports.useMemo = useMemo;
        exports.useReducer = useReducer;
        exports.useRef = useRef;
        exports.useState = useState;
        exports.version = ReactVersion;
      })();
    }
  })(react_development);

  if (process.env.NODE_ENV === 'production') {
    react.exports = react_production_min;
  } else {
    react.exports = react_development;
  }

  var require$$0 = react.exports;
  /** @license React v17.0.2
   * react-jsx-runtime.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  var f = require$$0,
      g = 60103;
  reactJsxRuntime_production_min.Fragment = 60107;

  if ("function" === typeof Symbol && Symbol.for) {
    var h = Symbol.for;
    g = h("react.element");
    reactJsxRuntime_production_min.Fragment = h("react.fragment");
  }

  var m = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,
      n = Object.prototype.hasOwnProperty,
      p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
  };

  function q(c, a, k) {
    var b,
        d = {},
        e = null,
        l = null;
    void 0 !== k && (e = "" + k);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (l = a.ref);

    for (b in a) {
      n.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
    }

    if (c && c.defaultProps) for (b in a = c.defaultProps, a) {
      void 0 === d[b] && (d[b] = a[b]);
    }
    return {
      $$typeof: g,
      type: c,
      key: e,
      ref: l,
      props: d,
      _owner: m.current
    };
  }

  reactJsxRuntime_production_min.jsx = q;
  reactJsxRuntime_production_min.jsxs = q;
  var reactJsxRuntime_development = {};
  /** @license React v17.0.2
   * react-jsx-runtime.development.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  (function (exports) {
    if (process.env.NODE_ENV !== "production") {
      (function () {
        var React = require$$0;
        var _assign = objectAssign; // ATTENTION
        // When adding new symbols to this file,
        // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
        // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
        // nor polyfill, then a plain number is used for performance.

        var REACT_ELEMENT_TYPE = 0xeac7;
        var REACT_PORTAL_TYPE = 0xeaca;
        exports.Fragment = 0xeacb;
        var REACT_STRICT_MODE_TYPE = 0xeacc;
        var REACT_PROFILER_TYPE = 0xead2;
        var REACT_PROVIDER_TYPE = 0xeacd;
        var REACT_CONTEXT_TYPE = 0xeace;
        var REACT_FORWARD_REF_TYPE = 0xead0;
        var REACT_SUSPENSE_TYPE = 0xead1;
        var REACT_SUSPENSE_LIST_TYPE = 0xead8;
        var REACT_MEMO_TYPE = 0xead3;
        var REACT_LAZY_TYPE = 0xead4;
        var REACT_BLOCK_TYPE = 0xead9;
        var REACT_SERVER_BLOCK_TYPE = 0xeada;
        var REACT_FUNDAMENTAL_TYPE = 0xead5;
        var REACT_DEBUG_TRACING_MODE_TYPE = 0xeae1;
        var REACT_LEGACY_HIDDEN_TYPE = 0xeae3;

        if (typeof Symbol === 'function' && Symbol.for) {
          var symbolFor = Symbol.for;
          REACT_ELEMENT_TYPE = symbolFor('react.element');
          REACT_PORTAL_TYPE = symbolFor('react.portal');
          exports.Fragment = symbolFor('react.fragment');
          REACT_STRICT_MODE_TYPE = symbolFor('react.strict_mode');
          REACT_PROFILER_TYPE = symbolFor('react.profiler');
          REACT_PROVIDER_TYPE = symbolFor('react.provider');
          REACT_CONTEXT_TYPE = symbolFor('react.context');
          REACT_FORWARD_REF_TYPE = symbolFor('react.forward_ref');
          REACT_SUSPENSE_TYPE = symbolFor('react.suspense');
          REACT_SUSPENSE_LIST_TYPE = symbolFor('react.suspense_list');
          REACT_MEMO_TYPE = symbolFor('react.memo');
          REACT_LAZY_TYPE = symbolFor('react.lazy');
          REACT_BLOCK_TYPE = symbolFor('react.block');
          REACT_SERVER_BLOCK_TYPE = symbolFor('react.server.block');
          REACT_FUNDAMENTAL_TYPE = symbolFor('react.fundamental');
          symbolFor('react.scope');
          symbolFor('react.opaque.id');
          REACT_DEBUG_TRACING_MODE_TYPE = symbolFor('react.debug_trace_mode');
          symbolFor('react.offscreen');
          REACT_LEGACY_HIDDEN_TYPE = symbolFor('react.legacy_hidden');
        }

        var MAYBE_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
        var FAUX_ITERATOR_SYMBOL = '@@iterator';

        function getIteratorFn(maybeIterable) {
          if (maybeIterable === null || typeof maybeIterable !== 'object') {
            return null;
          }

          var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];

          if (typeof maybeIterator === 'function') {
            return maybeIterator;
          }

          return null;
        }

        var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;

        function error(format) {
          {
            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }

            printWarning('error', format, args);
          }
        }

        function printWarning(level, format, args) {
          // When changing this logic, you might want to also
          // update consoleWithStackDev.www.js as well.
          {
            var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
            var stack = ReactDebugCurrentFrame.getStackAddendum();

            if (stack !== '') {
              format += '%s';
              args = args.concat([stack]);
            }

            var argsWithFormat = args.map(function (item) {
              return '' + item;
            }); // Careful: RN currently depends on this prefix

            argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
            // breaks IE9: https://github.com/facebook/react/issues/13610
            // eslint-disable-next-line react-internal/no-production-logging

            Function.prototype.apply.call(console[level], console, argsWithFormat);
          }
        } // Filter certain DOM attributes (e.g. src, href) if their values are empty strings.


        var enableScopeAPI = false; // Experimental Create Event Handle API.

        function isValidElementType(type) {
          if (typeof type === 'string' || typeof type === 'function') {
            return true;
          } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).


          if (type === exports.Fragment || type === REACT_PROFILER_TYPE || type === REACT_DEBUG_TRACING_MODE_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_LEGACY_HIDDEN_TYPE || enableScopeAPI) {
            return true;
          }

          if (typeof type === 'object' && type !== null) {
            if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_BLOCK_TYPE || type[0] === REACT_SERVER_BLOCK_TYPE) {
              return true;
            }
          }

          return false;
        }

        function getWrappedName(outerType, innerType, wrapperName) {
          var functionName = innerType.displayName || innerType.name || '';
          return outerType.displayName || (functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName);
        }

        function getContextName(type) {
          return type.displayName || 'Context';
        }

        function getComponentName(type) {
          if (type == null) {
            // Host root, text node or just invalid type.
            return null;
          }

          {
            if (typeof type.tag === 'number') {
              error('Received an unexpected object in getComponentName(). ' + 'This is likely a bug in React. Please file an issue.');
            }
          }

          if (typeof type === 'function') {
            return type.displayName || type.name || null;
          }

          if (typeof type === 'string') {
            return type;
          }

          switch (type) {
            case exports.Fragment:
              return 'Fragment';

            case REACT_PORTAL_TYPE:
              return 'Portal';

            case REACT_PROFILER_TYPE:
              return 'Profiler';

            case REACT_STRICT_MODE_TYPE:
              return 'StrictMode';

            case REACT_SUSPENSE_TYPE:
              return 'Suspense';

            case REACT_SUSPENSE_LIST_TYPE:
              return 'SuspenseList';
          }

          if (typeof type === 'object') {
            switch (type.$$typeof) {
              case REACT_CONTEXT_TYPE:
                var context = type;
                return getContextName(context) + '.Consumer';

              case REACT_PROVIDER_TYPE:
                var provider = type;
                return getContextName(provider._context) + '.Provider';

              case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type, type.render, 'ForwardRef');

              case REACT_MEMO_TYPE:
                return getComponentName(type.type);

              case REACT_BLOCK_TYPE:
                return getComponentName(type._render);

              case REACT_LAZY_TYPE:
                {
                  var lazyComponent = type;
                  var payload = lazyComponent._payload;
                  var init = lazyComponent._init;

                  try {
                    return getComponentName(init(payload));
                  } catch (x) {
                    return null;
                  }
                }
            }
          }

          return null;
        } // Helpers to patch console.logs to avoid logging during side-effect free
        // replaying on render function. This currently only patches the object
        // lazily which won't cover if the log function was extracted eagerly.
        // We could also eagerly patch the method.


        var disabledDepth = 0;
        var prevLog;
        var prevInfo;
        var prevWarn;
        var prevError;
        var prevGroup;
        var prevGroupCollapsed;
        var prevGroupEnd;

        function disabledLog() {}

        disabledLog.__reactDisabledLog = true;

        function disableLogs() {
          {
            if (disabledDepth === 0) {
              /* eslint-disable react-internal/no-production-logging */
              prevLog = console.log;
              prevInfo = console.info;
              prevWarn = console.warn;
              prevError = console.error;
              prevGroup = console.group;
              prevGroupCollapsed = console.groupCollapsed;
              prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099

              var props = {
                configurable: true,
                enumerable: true,
                value: disabledLog,
                writable: true
              }; // $FlowFixMe Flow thinks console is immutable.

              Object.defineProperties(console, {
                info: props,
                log: props,
                warn: props,
                error: props,
                group: props,
                groupCollapsed: props,
                groupEnd: props
              });
              /* eslint-enable react-internal/no-production-logging */
            }

            disabledDepth++;
          }
        }

        function reenableLogs() {
          {
            disabledDepth--;

            if (disabledDepth === 0) {
              /* eslint-disable react-internal/no-production-logging */
              var props = {
                configurable: true,
                enumerable: true,
                writable: true
              }; // $FlowFixMe Flow thinks console is immutable.

              Object.defineProperties(console, {
                log: _assign({}, props, {
                  value: prevLog
                }),
                info: _assign({}, props, {
                  value: prevInfo
                }),
                warn: _assign({}, props, {
                  value: prevWarn
                }),
                error: _assign({}, props, {
                  value: prevError
                }),
                group: _assign({}, props, {
                  value: prevGroup
                }),
                groupCollapsed: _assign({}, props, {
                  value: prevGroupCollapsed
                }),
                groupEnd: _assign({}, props, {
                  value: prevGroupEnd
                })
              });
              /* eslint-enable react-internal/no-production-logging */
            }

            if (disabledDepth < 0) {
              error('disabledDepth fell below zero. ' + 'This is a bug in React. Please file an issue.');
            }
          }
        }

        var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
        var prefix;

        function describeBuiltInComponentFrame(name, source, ownerFn) {
          {
            if (prefix === undefined) {
              // Extract the VM specific prefix used by each line.
              try {
                throw Error();
              } catch (x) {
                var match = x.stack.trim().match(/\n( *(at )?)/);
                prefix = match && match[1] || '';
              }
            } // We use the prefix to ensure our stacks line up with native stack frames.


            return '\n' + prefix + name;
          }
        }

        var reentry = false;
        var componentFrameCache;
        {
          var PossiblyWeakMap = typeof WeakMap === 'function' ? WeakMap : Map;
          componentFrameCache = new PossiblyWeakMap();
        }

        function describeNativeComponentFrame(fn, construct) {
          // If something asked for a stack inside a fake render, it should get ignored.
          if (!fn || reentry) {
            return '';
          }

          {
            var frame = componentFrameCache.get(fn);

            if (frame !== undefined) {
              return frame;
            }
          }
          var control;
          reentry = true;
          var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.

          Error.prepareStackTrace = undefined;
          var previousDispatcher;
          {
            previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
            // for warnings.

            ReactCurrentDispatcher.current = null;
            disableLogs();
          }

          try {
            // This should throw.
            if (construct) {
              // Something should be setting the props in the constructor.
              var Fake = function Fake() {
                throw Error();
              }; // $FlowFixMe


              Object.defineProperty(Fake.prototype, 'props', {
                set: function set() {
                  // We use a throwing setter instead of frozen or non-writable props
                  // because that won't throw in a non-strict mode function.
                  throw Error();
                }
              });

              if (typeof Reflect === 'object' && Reflect.construct) {
                // We construct a different control for this case to include any extra
                // frames added by the construct call.
                try {
                  Reflect.construct(Fake, []);
                } catch (x) {
                  control = x;
                }

                Reflect.construct(fn, [], Fake);
              } else {
                try {
                  Fake.call();
                } catch (x) {
                  control = x;
                }

                fn.call(Fake.prototype);
              }
            } else {
              try {
                throw Error();
              } catch (x) {
                control = x;
              }

              fn();
            }
          } catch (sample) {
            // This is inlined manually because closure doesn't do it for us.
            if (sample && control && typeof sample.stack === 'string') {
              // This extracts the first frame from the sample that isn't also in the control.
              // Skipping one frame that we assume is the frame that calls the two.
              var sampleLines = sample.stack.split('\n');
              var controlLines = control.stack.split('\n');
              var s = sampleLines.length - 1;
              var c = controlLines.length - 1;

              while (s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c]) {
                // We expect at least one stack frame to be shared.
                // Typically this will be the root most one. However, stack frames may be
                // cut off due to maximum stack limits. In this case, one maybe cut off
                // earlier than the other. We assume that the sample is longer or the same
                // and there for cut off earlier. So we should find the root most frame in
                // the sample somewhere in the control.
                c--;
              }

              for (; s >= 1 && c >= 0; s--, c--) {
                // Next we find the first one that isn't the same which should be the
                // frame that called our sample function and the control.
                if (sampleLines[s] !== controlLines[c]) {
                  // In V8, the first line is describing the message but other VMs don't.
                  // If we're about to return the first line, and the control is also on the same
                  // line, that's a pretty good indicator that our sample threw at same line as
                  // the control. I.e. before we entered the sample frame. So we ignore this result.
                  // This can happen if you passed a class to function component, or non-function.
                  if (s !== 1 || c !== 1) {
                    do {
                      s--;
                      c--; // We may still have similar intermediate frames from the construct call.
                      // The next one that isn't the same should be our match though.

                      if (c < 0 || sampleLines[s] !== controlLines[c]) {
                        // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                        var _frame = '\n' + sampleLines[s].replace(' at new ', ' at ');

                        {
                          if (typeof fn === 'function') {
                            componentFrameCache.set(fn, _frame);
                          }
                        } // Return the line we found.

                        return _frame;
                      }
                    } while (s >= 1 && c >= 0);
                  }

                  break;
                }
              }
            }
          } finally {
            reentry = false;
            {
              ReactCurrentDispatcher.current = previousDispatcher;
              reenableLogs();
            }
            Error.prepareStackTrace = previousPrepareStackTrace;
          } // Fallback to just using the name if we couldn't make it throw.


          var name = fn ? fn.displayName || fn.name : '';
          var syntheticFrame = name ? describeBuiltInComponentFrame(name) : '';
          {
            if (typeof fn === 'function') {
              componentFrameCache.set(fn, syntheticFrame);
            }
          }
          return syntheticFrame;
        }

        function describeFunctionComponentFrame(fn, source, ownerFn) {
          {
            return describeNativeComponentFrame(fn, false);
          }
        }

        function shouldConstruct(Component) {
          var prototype = Component.prototype;
          return !!(prototype && prototype.isReactComponent);
        }

        function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
          if (type == null) {
            return '';
          }

          if (typeof type === 'function') {
            {
              return describeNativeComponentFrame(type, shouldConstruct(type));
            }
          }

          if (typeof type === 'string') {
            return describeBuiltInComponentFrame(type);
          }

          switch (type) {
            case REACT_SUSPENSE_TYPE:
              return describeBuiltInComponentFrame('Suspense');

            case REACT_SUSPENSE_LIST_TYPE:
              return describeBuiltInComponentFrame('SuspenseList');
          }

          if (typeof type === 'object') {
            switch (type.$$typeof) {
              case REACT_FORWARD_REF_TYPE:
                return describeFunctionComponentFrame(type.render);

              case REACT_MEMO_TYPE:
                // Memo may contain any component type so we recursively resolve it.
                return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);

              case REACT_BLOCK_TYPE:
                return describeFunctionComponentFrame(type._render);

              case REACT_LAZY_TYPE:
                {
                  var lazyComponent = type;
                  var payload = lazyComponent._payload;
                  var init = lazyComponent._init;

                  try {
                    // Lazy may contain any component type so we recursively resolve it.
                    return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                  } catch (x) {}
                }
            }
          }

          return '';
        }

        var loggedTypeFailures = {};
        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;

        function setCurrentlyValidatingElement(element) {
          {
            if (element) {
              var owner = element._owner;
              var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
              ReactDebugCurrentFrame.setExtraStackFrame(stack);
            } else {
              ReactDebugCurrentFrame.setExtraStackFrame(null);
            }
          }
        }

        function checkPropTypes(typeSpecs, values, location, componentName, element) {
          {
            // $FlowFixMe This is okay but Flow doesn't know it.
            var has = Function.call.bind(Object.prototype.hasOwnProperty);

            for (var typeSpecName in typeSpecs) {
              if (has(typeSpecs, typeSpecName)) {
                var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
                // fail the render phase where it didn't fail before. So we log it.
                // After these have been cleaned up, we'll let them throw.

                try {
                  // This is intentionally an invariant that gets caught. It's the same
                  // behavior as without this statement except with a better message.
                  if (typeof typeSpecs[typeSpecName] !== 'function') {
                    var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
                    err.name = 'Invariant Violation';
                    throw err;
                  }

                  error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
                } catch (ex) {
                  error$1 = ex;
                }

                if (error$1 && !(error$1 instanceof Error)) {
                  setCurrentlyValidatingElement(element);
                  error('%s: type specification of %s' + ' `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error$1);
                  setCurrentlyValidatingElement(null);
                }

                if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                  // Only monitor this failure once because there tends to be a lot of the
                  // same error.
                  loggedTypeFailures[error$1.message] = true;
                  setCurrentlyValidatingElement(element);
                  error('Failed %s type: %s', location, error$1.message);
                  setCurrentlyValidatingElement(null);
                }
              }
            }
          }
        }

        var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
        var hasOwnProperty = Object.prototype.hasOwnProperty;
        var RESERVED_PROPS = {
          key: true,
          ref: true,
          __self: true,
          __source: true
        };
        var specialPropKeyWarningShown;
        var specialPropRefWarningShown;
        var didWarnAboutStringRefs;
        {
          didWarnAboutStringRefs = {};
        }

        function hasValidRef(config) {
          {
            if (hasOwnProperty.call(config, 'ref')) {
              var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;

              if (getter && getter.isReactWarning) {
                return false;
              }
            }
          }
          return config.ref !== undefined;
        }

        function hasValidKey(config) {
          {
            if (hasOwnProperty.call(config, 'key')) {
              var getter = Object.getOwnPropertyDescriptor(config, 'key').get;

              if (getter && getter.isReactWarning) {
                return false;
              }
            }
          }
          return config.key !== undefined;
        }

        function warnIfStringRefCannotBeAutoConverted(config, self) {
          {
            if (typeof config.ref === 'string' && ReactCurrentOwner.current && self && ReactCurrentOwner.current.stateNode !== self) {
              var componentName = getComponentName(ReactCurrentOwner.current.type);

              if (!didWarnAboutStringRefs[componentName]) {
                error('Component "%s" contains the string ref "%s". ' + 'Support for string refs will be removed in a future major release. ' + 'This case cannot be automatically converted to an arrow function. ' + 'We ask you to manually fix this case by using useRef() or createRef() instead. ' + 'Learn more about using refs safely here: ' + 'https://reactjs.org/link/strict-mode-string-ref', getComponentName(ReactCurrentOwner.current.type), config.ref);
                didWarnAboutStringRefs[componentName] = true;
              }
            }
          }
        }

        function defineKeyPropWarningGetter(props, displayName) {
          {
            var warnAboutAccessingKey = function warnAboutAccessingKey() {
              if (!specialPropKeyWarningShown) {
                specialPropKeyWarningShown = true;
                error('%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
              }
            };

            warnAboutAccessingKey.isReactWarning = true;
            Object.defineProperty(props, 'key', {
              get: warnAboutAccessingKey,
              configurable: true
            });
          }
        }

        function defineRefPropWarningGetter(props, displayName) {
          {
            var warnAboutAccessingRef = function warnAboutAccessingRef() {
              if (!specialPropRefWarningShown) {
                specialPropRefWarningShown = true;
                error('%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
              }
            };

            warnAboutAccessingRef.isReactWarning = true;
            Object.defineProperty(props, 'ref', {
              get: warnAboutAccessingRef,
              configurable: true
            });
          }
        }
        /**
         * Factory method to create a new React element. This no longer adheres to
         * the class pattern, so do not use new to call it. Also, instanceof check
         * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
         * if something is a React Element.
         *
         * @param {*} type
         * @param {*} props
         * @param {*} key
         * @param {string|object} ref
         * @param {*} owner
         * @param {*} self A *temporary* helper to detect places where `this` is
         * different from the `owner` when React.createElement is called, so that we
         * can warn. We want to get rid of owner and replace string `ref`s with arrow
         * functions, and as long as `this` and owner are the same, there will be no
         * change in behavior.
         * @param {*} source An annotation object (added by a transpiler or otherwise)
         * indicating filename, line number, and/or other information.
         * @internal
         */


        var ReactElement = function ReactElement(type, key, ref, self, source, owner, props) {
          var element = {
            // This tag allows us to uniquely identify this as a React Element
            $$typeof: REACT_ELEMENT_TYPE,
            // Built-in properties that belong on the element
            type: type,
            key: key,
            ref: ref,
            props: props,
            // Record the component responsible for creating this element.
            _owner: owner
          };
          {
            // The validation flag is currently mutative. We put it on
            // an external backing store so that we can freeze the whole object.
            // This can be replaced with a WeakMap once they are implemented in
            // commonly used development environments.
            element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
            // the validation flag non-enumerable (where possible, which should
            // include every environment we run tests in), so the test framework
            // ignores it.

            Object.defineProperty(element._store, 'validated', {
              configurable: false,
              enumerable: false,
              writable: true,
              value: false
            }); // self and source are DEV only properties.

            Object.defineProperty(element, '_self', {
              configurable: false,
              enumerable: false,
              writable: false,
              value: self
            }); // Two elements created in two different places should be considered
            // equal for testing purposes and therefore we hide it from enumeration.

            Object.defineProperty(element, '_source', {
              configurable: false,
              enumerable: false,
              writable: false,
              value: source
            });

            if (Object.freeze) {
              Object.freeze(element.props);
              Object.freeze(element);
            }
          }
          return element;
        };
        /**
         * https://github.com/reactjs/rfcs/pull/107
         * @param {*} type
         * @param {object} props
         * @param {string} key
         */


        function jsxDEV(type, config, maybeKey, source, self) {
          {
            var propName; // Reserved names are extracted

            var props = {};
            var key = null;
            var ref = null; // Currently, key can be spread in as a prop. This causes a potential
            // issue if key is also explicitly declared (ie. <div {...props} key="Hi" />
            // or <div key="Hi" {...props} /> ). We want to deprecate key spread,
            // but as an intermediary step, we will use jsxDEV for everything except
            // <div {...props} key="Hi" />, because we aren't currently able to tell if
            // key is explicitly declared to be undefined or not.

            if (maybeKey !== undefined) {
              key = '' + maybeKey;
            }

            if (hasValidKey(config)) {
              key = '' + config.key;
            }

            if (hasValidRef(config)) {
              ref = config.ref;
              warnIfStringRefCannotBeAutoConverted(config, self);
            } // Remaining properties are added to a new props object


            for (propName in config) {
              if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
                props[propName] = config[propName];
              }
            } // Resolve default props


            if (type && type.defaultProps) {
              var defaultProps = type.defaultProps;

              for (propName in defaultProps) {
                if (props[propName] === undefined) {
                  props[propName] = defaultProps[propName];
                }
              }
            }

            if (key || ref) {
              var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;

              if (key) {
                defineKeyPropWarningGetter(props, displayName);
              }

              if (ref) {
                defineRefPropWarningGetter(props, displayName);
              }
            }

            return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
          }
        }

        var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
        var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;

        function setCurrentlyValidatingElement$1(element) {
          {
            if (element) {
              var owner = element._owner;
              var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
              ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
            } else {
              ReactDebugCurrentFrame$1.setExtraStackFrame(null);
            }
          }
        }

        var propTypesMisspellWarningShown;
        {
          propTypesMisspellWarningShown = false;
        }
        /**
         * Verifies the object is a ReactElement.
         * See https://reactjs.org/docs/react-api.html#isvalidelement
         * @param {?object} object
         * @return {boolean} True if `object` is a ReactElement.
         * @final
         */

        function isValidElement(object) {
          {
            return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
          }
        }

        function getDeclarationErrorAddendum() {
          {
            if (ReactCurrentOwner$1.current) {
              var name = getComponentName(ReactCurrentOwner$1.current.type);

              if (name) {
                return '\n\nCheck the render method of `' + name + '`.';
              }
            }

            return '';
          }
        }

        function getSourceInfoErrorAddendum(source) {
          {
            if (source !== undefined) {
              var fileName = source.fileName.replace(/^.*[\\\/]/, '');
              var lineNumber = source.lineNumber;
              return '\n\nCheck your code at ' + fileName + ':' + lineNumber + '.';
            }

            return '';
          }
        }
        /**
         * Warn if there's no key explicitly set on dynamic arrays of children or
         * object keys are not valid. This allows us to keep track of children between
         * updates.
         */


        var ownerHasKeyUseWarning = {};

        function getCurrentComponentErrorInfo(parentType) {
          {
            var info = getDeclarationErrorAddendum();

            if (!info) {
              var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;

              if (parentName) {
                info = "\n\nCheck the top-level render call using <" + parentName + ">.";
              }
            }

            return info;
          }
        }
        /**
         * Warn if the element doesn't have an explicit key assigned to it.
         * This element is in an array. The array could grow and shrink or be
         * reordered. All children that haven't already been validated are required to
         * have a "key" property assigned to it. Error statuses are cached so a warning
         * will only be shown once.
         *
         * @internal
         * @param {ReactElement} element Element that requires a key.
         * @param {*} parentType element's parent's type.
         */


        function validateExplicitKey(element, parentType) {
          {
            if (!element._store || element._store.validated || element.key != null) {
              return;
            }

            element._store.validated = true;
            var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);

            if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
              return;
            }

            ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
            // property, it may be the creator of the child that's responsible for
            // assigning it a key.

            var childOwner = '';

            if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) {
              // Give the component that originally created this child.
              childOwner = " It was passed a child from " + getComponentName(element._owner.type) + ".";
            }

            setCurrentlyValidatingElement$1(element);
            error('Each child in a list should have a unique "key" prop.' + '%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
            setCurrentlyValidatingElement$1(null);
          }
        }
        /**
         * Ensure that every element either is passed in a static location, in an
         * array with an explicit keys property defined, or in an object literal
         * with valid key property.
         *
         * @internal
         * @param {ReactNode} node Statically passed child of any type.
         * @param {*} parentType node's parent's type.
         */


        function validateChildKeys(node, parentType) {
          {
            if (typeof node !== 'object') {
              return;
            }

            if (Array.isArray(node)) {
              for (var i = 0; i < node.length; i++) {
                var child = node[i];

                if (isValidElement(child)) {
                  validateExplicitKey(child, parentType);
                }
              }
            } else if (isValidElement(node)) {
              // This element was passed in a valid location.
              if (node._store) {
                node._store.validated = true;
              }
            } else if (node) {
              var iteratorFn = getIteratorFn(node);

              if (typeof iteratorFn === 'function') {
                // Entry iterators used to provide implicit keys,
                // but now we print a separate warning for them later.
                if (iteratorFn !== node.entries) {
                  var iterator = iteratorFn.call(node);
                  var step;

                  while (!(step = iterator.next()).done) {
                    if (isValidElement(step.value)) {
                      validateExplicitKey(step.value, parentType);
                    }
                  }
                }
              }
            }
          }
        }
        /**
         * Given an element, validate that its props follow the propTypes definition,
         * provided by the type.
         *
         * @param {ReactElement} element
         */


        function validatePropTypes(element) {
          {
            var type = element.type;

            if (type === null || type === undefined || typeof type === 'string') {
              return;
            }

            var propTypes;

            if (typeof type === 'function') {
              propTypes = type.propTypes;
            } else if (typeof type === 'object' && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
            // Inner props are checked in the reconciler.
            type.$$typeof === REACT_MEMO_TYPE)) {
              propTypes = type.propTypes;
            } else {
              return;
            }

            if (propTypes) {
              // Intentionally inside to avoid triggering lazy initializers:
              var name = getComponentName(type);
              checkPropTypes(propTypes, element.props, 'prop', name, element);
            } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
              propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:

              var _name = getComponentName(type);

              error('Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?', _name || 'Unknown');
            }

            if (typeof type.getDefaultProps === 'function' && !type.getDefaultProps.isReactClassApproved) {
              error('getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.');
            }
          }
        }
        /**
         * Given a fragment, validate that it can only be provided with fragment props
         * @param {ReactElement} fragment
         */


        function validateFragmentProps(fragment) {
          {
            var keys = Object.keys(fragment.props);

            for (var i = 0; i < keys.length; i++) {
              var key = keys[i];

              if (key !== 'children' && key !== 'key') {
                setCurrentlyValidatingElement$1(fragment);
                error('Invalid prop `%s` supplied to `React.Fragment`. ' + 'React.Fragment can only have `key` and `children` props.', key);
                setCurrentlyValidatingElement$1(null);
                break;
              }
            }

            if (fragment.ref !== null) {
              setCurrentlyValidatingElement$1(fragment);
              error('Invalid attribute `ref` supplied to `React.Fragment`.');
              setCurrentlyValidatingElement$1(null);
            }
          }
        }

        function jsxWithValidation(type, props, key, isStaticChildren, source, self) {
          {
            var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
            // succeed and there will likely be errors in render.

            if (!validType) {
              var info = '';

              if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
                info += ' You likely forgot to export your component from the file ' + "it's defined in, or you might have mixed up default and named imports.";
              }

              var sourceInfo = getSourceInfoErrorAddendum(source);

              if (sourceInfo) {
                info += sourceInfo;
              } else {
                info += getDeclarationErrorAddendum();
              }

              var typeString;

              if (type === null) {
                typeString = 'null';
              } else if (Array.isArray(type)) {
                typeString = 'array';
              } else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
                typeString = "<" + (getComponentName(type.type) || 'Unknown') + " />";
                info = ' Did you accidentally export a JSX literal instead of a component?';
              } else {
                typeString = typeof type;
              }

              error('React.jsx: type is invalid -- expected a string (for ' + 'built-in components) or a class/function (for composite ' + 'components) but got: %s.%s', typeString, info);
            }

            var element = jsxDEV(type, props, key, source, self); // The result can be nullish if a mock or a custom function is used.
            // TODO: Drop this when these are no longer allowed as the type argument.

            if (element == null) {
              return element;
            } // Skip key warning if the type isn't valid since our key validation logic
            // doesn't expect a non-string/function type and can throw confusing errors.
            // We don't want exception behavior to differ between dev and prod.
            // (Rendering will throw with a helpful message and as soon as the type is
            // fixed, the key warnings will appear.)


            if (validType) {
              var children = props.children;

              if (children !== undefined) {
                if (isStaticChildren) {
                  if (Array.isArray(children)) {
                    for (var i = 0; i < children.length; i++) {
                      validateChildKeys(children[i], type);
                    }

                    if (Object.freeze) {
                      Object.freeze(children);
                    }
                  } else {
                    error('React.jsx: Static children should always be an array. ' + 'You are likely explicitly calling React.jsxs or React.jsxDEV. ' + 'Use the Babel transform instead.');
                  }
                } else {
                  validateChildKeys(children, type);
                }
              }
            }

            if (type === exports.Fragment) {
              validateFragmentProps(element);
            } else {
              validatePropTypes(element);
            }

            return element;
          }
        } // These two functions exist to still get child warnings in dev
        // even with the prod transform. This means that jsxDEV is purely
        // opt-in behavior for better messages but that we won't stop
        // giving you warnings if you use production apis.


        function jsxWithValidationStatic(type, props, key) {
          {
            return jsxWithValidation(type, props, key, true);
          }
        }

        function jsxWithValidationDynamic(type, props, key) {
          {
            return jsxWithValidation(type, props, key, false);
          }
        }

        var jsx = jsxWithValidationDynamic; // we may want to special case jsxs internally to take advantage of static children.
        // for now we can ship identical prod functions

        var jsxs = jsxWithValidationStatic;
        exports.jsx = jsx;
        exports.jsxs = jsxs;
      })();
    }
  })(reactJsxRuntime_development);

  if (process.env.NODE_ENV === 'production') {
    jsxRuntime.exports = reactJsxRuntime_production_min;
  } else {
    jsxRuntime.exports = reactJsxRuntime_development;
  }

  var require$$2 = jsxRuntime.exports;
  var _interopRequireDefault = interopRequireDefault.exports;
  Object.defineProperty(Menu$1, "__esModule", {
    value: true
  });
  var default_1 = Menu$1.default = void 0;

  var _createSvgIcon = _interopRequireDefault(createSvgIcon);

  var _jsxRuntime = require$$2;

  var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
  }), 'Menu');

  default_1 = Menu$1.default = _default;

  var MenuIcon = function MenuIcon(props) {
    var className = props.className,
        otherProps = __rest$1(props, ["className"]);

    var dataAttributes = generateComponentDataAttributes('MenuIcon', className);
    return React__namespace.createElement(default_1, _assign2({}, dataAttributes, otherProps));
  };

  var NativeSelect = React__namespace.forwardRef(function (props, ref) {
    var className = props.className,
        disabled = props.disabled,
        error = props.error,
        fullWidth = props.fullWidth,
        helperText = props.helperText,
        id = props.id,
        label = props.label,
        labelId = props.labelId,
        name = props.name,
        onChange = props.onChange,
        required = props.required,
        value = props.value,
        otherProps = __rest$1(props, ["className", "disabled", "error", "fullWidth", "helperText", "id", "label", "labelId", "name", "onChange", "required", "value"]);

    var dataAttributes = generateComponentDataAttributes('NativeSelect', className);
    return React__namespace.createElement(FormControl, _assign2({}, error && {
      error: error
    }, fullWidth && {
      fullWidth: fullWidth
    }, disabled && {
      disabled: disabled
    }), React__namespace.createElement(InputLabel, _assign2({}, labelId && {
      id: labelId
    }, {
      htmlFor: id
    }), label), React__namespace.createElement(BaseNativeSelect, _assign2({}, dataAttributes, error && {
      error: error
    }, fullWidth && {
      fullWidth: fullWidth
    }, required && {
      required: required
    }, {
      onChange: onChange,
      inputProps: {
        id: id,
        name: name
      },
      value: value,
      ref: ref
    }, otherProps)), React__namespace.createElement(FormHelperText, null, helperText));
  });
  var Select = React__namespace.forwardRef(function (props, ref) {
    var className = props.className,
        otherProps = __rest$1(props, ["className"]);

    var dataAttributes = generateComponentDataAttributes('Select', className);
    return React__namespace.createElement(BaseNativeSelect, _assign2({}, dataAttributes, {
      inputRef: ref
    }, otherProps));
  });

  var TextField = function TextField(props) {
    var className = props.className,
        otherProps = __rest$1(props, ["className"]);

    var dataAttributes = generateComponentDataAttributes('TextField', className);
    return React__namespace.createElement(BaseTextField, _assign2({}, dataAttributes, otherProps));
  };

  var defaultProps$8 = {
    variant: 'standard'
  };
  TextField.defaultProps = defaultProps$8;
  var TextField$1 = React__namespace.forwardRef(function (props, ref) {
    return React__namespace.createElement(TextField, _assign2({
      inputRef: ref
    }, props));
  });

  var InputAdornment = function InputAdornment(props) {
    var className = props.className,
        otherProps = __rest$1(props, ["className"]);

    var dataAttributes = generateComponentDataAttributes('InputAdornment', className);
    return React__namespace.createElement(InputAdornment$2, _assign2({}, dataAttributes, otherProps));
  };

  function _extends$5() {
    _extends$5 = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends$5.apply(this, arguments);
  }

  function _objectWithoutPropertiesLoose$2(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }

  var MuiPickersAdapterContext = /*#__PURE__*/React__namespace.createContext(null);

  if (process.env.NODE_ENV !== 'production') {
    MuiPickersAdapterContext.displayName = 'MuiPickersAdapterContext';
  }
  /**
   * @ignore - do not document.
   */


  function LocalizationProvider$1(props) {
    var children = props.children,
        Utils = props.dateAdapter,
        dateFormats = props.dateFormats,
        dateLibInstance = props.dateLibInstance,
        locale = props.locale;
    var utils = React__namespace.useMemo(function () {
      return new Utils({
        locale: locale,
        formats: dateFormats,
        instance: dateLibInstance
      });
    }, [Utils, locale, dateFormats, dateLibInstance]);
    var defaultDates = React__namespace.useMemo(function () {
      return {
        minDate: utils.date('1900-01-01T00:00:00.000'),
        maxDate: utils.date('2099-12-31T00:00:00.000')
      };
    }, [utils]);
    var contextValue = React__namespace.useMemo(function () {
      return {
        utils: utils,
        defaultDates: defaultDates
      };
    }, [defaultDates, utils]);
    return /*#__PURE__*/jsxRuntime$1.jsx(MuiPickersAdapterContext.Provider, {
      value: contextValue,
      children: children
    });
  }

  process.env.NODE_ENV !== "production" ? void 0 : void 0;

  function useLocalizationContext() {
    var localization = React__namespace.useContext(MuiPickersAdapterContext);

    if (localization === null) {
      throw new Error(process.env.NODE_ENV !== "production" ? "Can not find utils in context. It looks like you forgot to wrap your component in LocalizationProvider, or pass dateAdapter prop directly." : formatMuiErrorMessage(13));
    }

    return localization;
  }

  function useUtils() {
    return useLocalizationContext().utils;
  }

  function useDefaultDates() {
    return useLocalizationContext().defaultDates;
  }

  function useNow() {
    var utils = useUtils();
    var now = React__namespace.useRef(utils.date());
    return now.current;
  }

  var _excluded$f = ["openTo", "views", "minDate", "maxDate"];

  var isYearOnlyView = function isYearOnlyView(views) {
    return views.length === 1 && views[0] === 'year';
  };

  var isYearAndMonthViews = function isYearAndMonthViews(views) {
    return views.length === 2 && views.indexOf('month') !== -1 && views.indexOf('year') !== -1;
  };

  var getFormatAndMaskByViews = function getFormatAndMaskByViews(views, utils) {
    if (isYearOnlyView(views)) {
      return {
        mask: '____',
        inputFormat: utils.formats.year
      };
    }

    if (isYearAndMonthViews(views)) {
      return {
        disableMaskedInput: true,
        inputFormat: utils.formats.monthAndYear
      };
    }

    return {
      mask: '__/__/____',
      inputFormat: utils.formats.keyboardDate
    };
  };

  function useDatePickerDefaultizedProps(_ref, name) {
    var _ref$openTo = _ref.openTo,
        openTo = _ref$openTo === void 0 ? 'day' : _ref$openTo,
        _ref$views = _ref.views,
        views = _ref$views === void 0 ? ['year', 'day'] : _ref$views,
        minDateProp = _ref.minDate,
        maxDateProp = _ref.maxDate,
        other = _objectWithoutPropertiesLoose$2(_ref, _excluded$f);

    var utils = useUtils();
    var defaultDates = useDefaultDates();
    var minDate = minDateProp != null ? minDateProp : defaultDates.minDate;
    var maxDate = maxDateProp != null ? maxDateProp : defaultDates.maxDate; // This is technically unsound if the type parameters appear in optional props.
    // Optional props can be filled by `useThemeProps` with types that don't match the type parameters.

    return useThemeProps({
      props: _extends$5({
        views: views,
        openTo: openTo,
        minDate: minDate,
        maxDate: maxDate
      }, getFormatAndMaskByViews(views, utils), other),
      name: name
    });
  }

  var PenIcon = createSvgIcon$1( /*#__PURE__*/jsxRuntime$1.jsx("path", {
    d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
  }), 'Pen');
  var CalendarIcon = createSvgIcon$1( /*#__PURE__*/jsxRuntime$1.jsx("path", {
    d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
  }), 'Calendar');
  var ClockIcon = createSvgIcon$1( /*#__PURE__*/jsxRuntime$1.jsxs(React__namespace.Fragment, {
    children: [/*#__PURE__*/jsxRuntime$1.jsx("path", {
      d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
    }), /*#__PURE__*/jsxRuntime$1.jsx("path", {
      d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
    })]
  }), 'Clock');

  var _ClockIcon, _CalendarIcon, _PenIcon;

  var classes$6 = generateUtilityClasses('PrivatePickersToolbar', ['root', 'dateTitleContainer']);
  var PickersToolbarRoot = styled$1('div', {
    skipSx: true
  })(function (_ref394) {
    var theme = _ref394.theme,
        ownerState = _ref394.ownerState;
    return _extends$5({
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      padding: theme.spacing(2, 3)
    }, ownerState.isLandscape && {
      height: 'auto',
      maxWidth: 160,
      padding: 16,
      justifyContent: 'flex-start',
      flexWrap: 'wrap'
    });
  });
  var PickersToolbarGrid = styled$1(BaseGrid, {
    skipSx: true
  })({
    flex: 1
  });

  var getViewTypeIcon = function getViewTypeIcon(viewType) {
    return viewType === 'clock' ? _ClockIcon || (_ClockIcon = /*#__PURE__*/jsxRuntime$1.jsx(ClockIcon, {
      color: "inherit"
    })) : _CalendarIcon || (_CalendarIcon = /*#__PURE__*/jsxRuntime$1.jsx(CalendarIcon, {
      color: "inherit"
    }));
  };

  function defaultGetKeyboardInputSwitchingButtonText(isKeyboardInputOpen, viewType) {
    return isKeyboardInputOpen ? "text input view is open, go to ".concat(viewType, " view") : "".concat(viewType, " view is open, go to text input view");
  }

  var PickersToolbar = /*#__PURE__*/React__namespace.forwardRef(function PickersToolbar(props, ref) {
    var children = props.children,
        className = props.className,
        _props$getMobileKeybo = props.getMobileKeyboardInputViewButtonText,
        getMobileKeyboardInputViewButtonText = _props$getMobileKeybo === void 0 ? defaultGetKeyboardInputSwitchingButtonText : _props$getMobileKeybo,
        isLandscape = props.isLandscape,
        isMobileKeyboardViewOpen = props.isMobileKeyboardViewOpen,
        _props$landscapeDirec = props.landscapeDirection,
        landscapeDirection = _props$landscapeDirec === void 0 ? 'column' : _props$landscapeDirec,
        penIconClassName = props.penIconClassName,
        toggleMobileKeyboardView = props.toggleMobileKeyboardView,
        toolbarTitle = props.toolbarTitle,
        _props$viewType = props.viewType,
        viewType = _props$viewType === void 0 ? 'calendar' : _props$viewType;
    var ownerState = props;
    return /*#__PURE__*/jsxRuntime$1.jsxs(PickersToolbarRoot, {
      ref: ref,
      className: clsx(classes$6.root, className),
      ownerState: ownerState,
      children: [/*#__PURE__*/jsxRuntime$1.jsx(Typography$2, {
        color: "text.secondary",
        variant: "overline",
        children: toolbarTitle
      }), /*#__PURE__*/jsxRuntime$1.jsxs(PickersToolbarGrid, {
        container: true,
        justifyContent: "space-between",
        className: classes$6.dateTitleContainer,
        direction: isLandscape ? landscapeDirection : 'row',
        alignItems: isLandscape ? 'flex-start' : 'flex-end',
        children: [children, /*#__PURE__*/jsxRuntime$1.jsx(IconButton$2, {
          onClick: toggleMobileKeyboardView,
          className: penIconClassName,
          color: "inherit",
          "aria-label": getMobileKeyboardInputViewButtonText(isMobileKeyboardViewOpen, viewType),
          children: isMobileKeyboardViewOpen ? getViewTypeIcon(viewType) : _PenIcon || (_PenIcon = /*#__PURE__*/jsxRuntime$1.jsx(PenIcon, {
            color: "inherit"
          }))
        })]
      })]
    });
  });
  var PickersToolbar$1 = PickersToolbar;
  var _excluded$e = ["date", "isLandscape", "isMobileKeyboardViewOpen", "onChange", "toggleMobileKeyboardView", "toolbarFormat", "toolbarPlaceholder", "toolbarTitle", "views"];
  var classes$5 = generateUtilityClasses('PrivateDatePickerToolbar', ['penIcon']);
  var DatePickerToolbarRoot = styled$1(PickersToolbar$1, {
    skipSx: true
  })(_defineProperty({}, "& .".concat(classes$5.penIcon), {
    position: 'relative',
    top: 4
  }));
  var DatePickerToolbarTitle = styled$1(Typography$2, {
    skipSx: true
  })(function (_ref395) {
    var ownerState = _ref395.ownerState;
    return _extends$5({}, ownerState.isLandscape && {
      margin: 'auto 16px auto auto'
    });
  });
  /**
   * @ignore - internal component.
   */

  var DatePickerToolbar = /*#__PURE__*/React__namespace.forwardRef(function DatePickerToolbar(props, ref) {
    var date = props.date,
        isLandscape = props.isLandscape,
        isMobileKeyboardViewOpen = props.isMobileKeyboardViewOpen,
        toggleMobileKeyboardView = props.toggleMobileKeyboardView,
        toolbarFormat = props.toolbarFormat,
        _props$toolbarPlaceho = props.toolbarPlaceholder,
        toolbarPlaceholder = _props$toolbarPlaceho === void 0 ? '––' : _props$toolbarPlaceho,
        _props$toolbarTitle = props.toolbarTitle,
        toolbarTitle = _props$toolbarTitle === void 0 ? 'Select date' : _props$toolbarTitle,
        views = props.views,
        other = _objectWithoutPropertiesLoose$2(props, _excluded$e);

    var utils = useUtils();
    var dateText = React__namespace.useMemo(function () {
      if (!date) {
        return toolbarPlaceholder;
      }

      if (toolbarFormat) {
        return utils.formatByString(date, toolbarFormat);
      }

      if (isYearOnlyView(views)) {
        return utils.format(date, 'year');
      }

      if (isYearAndMonthViews(views)) {
        return utils.format(date, 'month');
      } // Little localization hack (Google is doing the same for android native pickers):
      // For english localization it is convenient to include weekday into the date "Mon, Jun 1".
      // For other locales using strings like "June 1", without weekday.


      return /en/.test(utils.getCurrentLocaleCode()) ? utils.format(date, 'normalDateWithWeekday') : utils.format(date, 'normalDate');
    }, [date, toolbarFormat, toolbarPlaceholder, utils, views]);
    var ownerState = props;
    return /*#__PURE__*/jsxRuntime$1.jsx(DatePickerToolbarRoot, _extends$5({
      ref: ref,
      toolbarTitle: toolbarTitle,
      isMobileKeyboardViewOpen: isMobileKeyboardViewOpen,
      toggleMobileKeyboardView: toggleMobileKeyboardView,
      isLandscape: isLandscape,
      penIconClassName: classes$5.penIcon,
      ownerState: ownerState
    }, other, {
      children: /*#__PURE__*/jsxRuntime$1.jsx(DatePickerToolbarTitle, {
        variant: "h4",
        align: isLandscape ? 'left' : 'center',
        ownerState: ownerState,
        children: dateText
      })
    }));
  });
  var DatePickerToolbar$1 = DatePickerToolbar;
  /**
   * TODO consider getting rid from wrapper variant
   * @ignore - internal component.
   */

  var WrapperVariantContext = /*#__PURE__*/React__namespace.createContext(null);
  var _excluded$d = ["onClick", "onTouchStart"];
  var PickersPopperRoot = styled$1(BasePopper, {
    skipSx: true
  })(function (_ref396) {
    var theme = _ref396.theme;
    return {
      zIndex: theme.zIndex.modal
    };
  });
  var PickersPopperPaper = styled$1(BasePaper, {
    skipSx: true
  })(function (_ref397) {
    var ownerState = _ref397.ownerState;
    return _extends$5({
      transformOrigin: 'top center',
      outline: 0
    }, ownerState.placement === 'top' && {
      transformOrigin: 'bottom center'
    });
  });

  function clickedRootScrollbar(event, doc) {
    return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
  }
  /**
   * Based on @mui/material/ClickAwayListener without the customization.
   * We can probably strip away even more since children won't be portaled.
   * @param onClickAway
   * @param onClick
   * @param onTouchStart
   */


  function useClickAwayListener(active, onClickAway) {
    var movedRef = React__namespace.useRef(false);
    var syntheticEventRef = React__namespace.useRef(false);
    var nodeRef = React__namespace.useRef(null);
    var activatedRef = React__namespace.useRef(false);
    React__namespace.useEffect(function () {
      if (!active) {
        return undefined;
      } // Ensure that this hook is not "activated" synchronously.
      // https://github.com/facebook/react/issues/20074


      function armClickAwayListener() {
        activatedRef.current = true;
      }

      document.addEventListener('mousedown', armClickAwayListener, true);
      document.addEventListener('touchstart', armClickAwayListener, true);
      return function () {
        document.removeEventListener('mousedown', armClickAwayListener, true);
        document.removeEventListener('touchstart', armClickAwayListener, true);
        activatedRef.current = false;
      };
    }, [active]); // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviors like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.

    var handleClickAway = useEventCallback(function (event) {
      if (!activatedRef.current) {
        return;
      } // Given developers can stop the propagation of the synthetic event,
      // we can only be confident with a positive value.


      var insideReactTree = syntheticEventRef.current;
      syntheticEventRef.current = false;
      var doc = ownerDocument(nodeRef.current); // 1. IE11 support, which trigger the handleClickAway even after the unbind
      // 2. The child might render null.
      // 3. Behave like a blur listener.

      if (!nodeRef.current || // is a TouchEvent?
      'clientX' in event && clickedRootScrollbar(event, doc)) {
        return;
      } // Do not act if user performed touchmove


      if (movedRef.current) {
        movedRef.current = false;
        return;
      }

      var insideDOM; // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js

      if (event.composedPath) {
        insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
      } else {
        insideDOM = !doc.documentElement.contains(event.target) || nodeRef.current.contains(event.target);
      }

      if (!insideDOM && !insideReactTree) {
        onClickAway(event);
      }
    }); // Keep track of mouse/touch events that bubbled up through the portal.

    var handleSynthetic = function handleSynthetic() {
      syntheticEventRef.current = true;
    };

    React__namespace.useEffect(function () {
      if (active) {
        var doc = ownerDocument(nodeRef.current);

        var handleTouchMove = function handleTouchMove() {
          movedRef.current = true;
        };

        doc.addEventListener('touchstart', handleClickAway);
        doc.addEventListener('touchmove', handleTouchMove);
        return function () {
          doc.removeEventListener('touchstart', handleClickAway);
          doc.removeEventListener('touchmove', handleTouchMove);
        };
      }

      return undefined;
    }, [active, handleClickAway]);
    React__namespace.useEffect(function () {
      // TODO This behavior is not tested automatically
      // It's unclear whether this is due to different update semantics in test (batched in act() vs discrete on click).
      // Or if this is a timing related issues due to different Transition components
      // Once we get rid of all the manual scheduling (e.g. setTimeout(update, 0)) we can revisit this code+test.
      if (active) {
        var doc = ownerDocument(nodeRef.current);
        doc.addEventListener('click', handleClickAway);
        return function () {
          doc.removeEventListener('click', handleClickAway); // cleanup `handleClickAway`

          syntheticEventRef.current = false;
        };
      }

      return undefined;
    }, [active, handleClickAway]);
    return [nodeRef, handleSynthetic, handleSynthetic];
  }

  var PickersPopper = function PickersPopper(props) {
    var anchorEl = props.anchorEl,
        _children5 = props.children,
        _props$containerRef = props.containerRef,
        containerRef = _props$containerRef === void 0 ? null : _props$containerRef,
        onClose = props.onClose,
        open = props.open,
        PopperProps = props.PopperProps,
        role = props.role,
        _props$TransitionComp13 = props.TransitionComponent,
        TransitionComponent = _props$TransitionComp13 === void 0 ? Grow$1 : _props$TransitionComp13,
        TrapFocusProps = props.TrapFocusProps,
        _props$PaperProps5 = props.PaperProps,
        PaperProps = _props$PaperProps5 === void 0 ? {} : _props$PaperProps5;
    React__namespace.useEffect(function () {
      function handleKeyDown(nativeEvent) {
        // IE11, Edge (prior to using Bink?) use 'Esc'
        if (nativeEvent.key === 'Escape' || nativeEvent.key === 'Esc') {
          onClose();
        }
      }

      document.addEventListener('keydown', handleKeyDown);
      return function () {
        document.removeEventListener('keydown', handleKeyDown);
      };
    }, [onClose]);
    var lastFocusedElementRef = React__namespace.useRef(null);
    React__namespace.useEffect(function () {
      if (role === 'tooltip') {
        return;
      }

      if (open) {
        lastFocusedElementRef.current = document.activeElement;
      } else if (lastFocusedElementRef.current && lastFocusedElementRef.current instanceof HTMLElement) {
        lastFocusedElementRef.current.focus();
      }
    }, [open, role]);

    var _useClickAwayListener = useClickAwayListener(open, onClose),
        _useClickAwayListener2 = _slicedToArray(_useClickAwayListener, 3),
        clickAwayRef = _useClickAwayListener2[0],
        onPaperClick = _useClickAwayListener2[1],
        onPaperTouchStart = _useClickAwayListener2[2];

    var paperRef = React__namespace.useRef(null);
    var handleRef = useForkRef(paperRef, containerRef);
    var handlePaperRef = useForkRef(handleRef, clickAwayRef);
    var ownerState = props;

    var onPaperClickProp = PaperProps.onClick,
        onPaperTouchStartProp = PaperProps.onTouchStart,
        otherPaperProps = _objectWithoutPropertiesLoose$2(PaperProps, _excluded$d);

    return /*#__PURE__*/jsxRuntime$1.jsx(PickersPopperRoot, _extends$5({
      transition: true,
      role: role,
      open: open,
      anchorEl: anchorEl,
      ownerState: ownerState
    }, PopperProps, {
      children: function children(_ref398) {
        var TransitionProps = _ref398.TransitionProps,
            placement = _ref398.placement;
        return /*#__PURE__*/jsxRuntime$1.jsx(Unstable_TrapFocus, _extends$5({
          open: open,
          disableAutoFocus: true,
          disableEnforceFocus: role === 'tooltip',
          isEnabled: function isEnabled() {
            return true;
          }
        }, TrapFocusProps, {
          children: /*#__PURE__*/jsxRuntime$1.jsx(TransitionComponent, _extends$5({}, TransitionProps, {
            children: /*#__PURE__*/jsxRuntime$1.jsx(PickersPopperPaper, _extends$5({
              tabIndex: -1,
              elevation: 8,
              ref: handlePaperRef,
              onClick: function onClick(event) {
                onPaperClick(event);

                if (onPaperClickProp) {
                  onPaperClickProp(event);
                }
              },
              onTouchStart: function onTouchStart(event) {
                onPaperTouchStart(event);

                if (onPaperTouchStartProp) {
                  onPaperTouchStartProp(event);
                }
              },
              ownerState: _extends$5({}, ownerState, {
                placement: placement
              })
            }, otherPaperProps, {
              children: _children5
            }))
          }))
        }));
      }
    }));
  };

  var PickersPopper$1 = PickersPopper;

  function DesktopWrapper(props) {
    var children = props.children,
        DateInputProps = props.DateInputProps,
        KeyboardDateInputComponent = props.KeyboardDateInputComponent,
        onDismiss = props.onDismiss,
        open = props.open,
        PopperProps = props.PopperProps,
        PaperProps = props.PaperProps,
        TransitionComponent = props.TransitionComponent;
    var ownInputRef = React__namespace.useRef(null);
    var inputRef = useForkRef(DateInputProps.inputRef, ownInputRef);
    return /*#__PURE__*/jsxRuntime$1.jsxs(WrapperVariantContext.Provider, {
      value: "desktop",
      children: [/*#__PURE__*/jsxRuntime$1.jsx(KeyboardDateInputComponent, _extends$5({}, DateInputProps, {
        inputRef: inputRef
      })), /*#__PURE__*/jsxRuntime$1.jsx(PickersPopper$1, {
        role: "dialog",
        open: open,
        anchorEl: ownInputRef.current,
        TransitionComponent: TransitionComponent,
        PopperProps: PopperProps,
        PaperProps: PaperProps,
        onClose: onDismiss,
        children: children
      })]
    });
  }
  /* Use it instead of .includes method for IE support */


  function arrayIncludes(array, itemOrItems) {
    if (Array.isArray(itemOrItems)) {
      return itemOrItems.every(function (item) {
        return array.indexOf(item) !== -1;
      });
    }

    return array.indexOf(itemOrItems) !== -1;
  }

  var onSpaceOrEnter = function onSpaceOrEnter(innerFn, onFocus) {
    return function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        innerFn(); // prevent any side effects

        event.preventDefault();
        event.stopPropagation();
      }

      if (onFocus) {
        onFocus(event);
      }
    };
  };
  /* Quick untyped helper to improve function composition readability */


  var pipe = function pipe() {
    for (var _len26 = arguments.length, fns = new Array(_len26), _key27 = 0; _key27 < _len26; _key27++) {
      fns[_key27] = arguments[_key27];
    }

    return fns.reduceRight(function (prevFn, nextFn) {
      return function () {
        return nextFn(prevFn.apply(void 0, arguments));
      };
    }, function (value) {
      return value;
    });
  };

  function createDelegatedEventHandler(fn, onEvent) {
    return function (event) {
      fn(event);

      if (onEvent) {
        onEvent(event);
      }
    };
  }

  function useViews(_ref399) {
    var onChange = _ref399.onChange,
        onViewChange = _ref399.onViewChange,
        openTo = _ref399.openTo,
        view = _ref399.view,
        views = _ref399.views;

    var _views, _views2;

    var _useControlled17 = useControlled({
      name: 'Picker',
      state: 'view',
      controlled: view,
      default: openTo && arrayIncludes(views, openTo) ? openTo : views[0]
    }),
        _useControlled18 = _slicedToArray(_useControlled17, 2),
        openView = _useControlled18[0],
        setOpenView = _useControlled18[1];

    var previousView = (_views = views[views.indexOf(openView) - 1]) != null ? _views : null;
    var nextView = (_views2 = views[views.indexOf(openView) + 1]) != null ? _views2 : null;
    var changeView = React__namespace.useCallback(function (newView) {
      setOpenView(newView);

      if (onViewChange) {
        onViewChange(newView);
      }
    }, [setOpenView, onViewChange]);
    var openNext = React__namespace.useCallback(function () {
      if (nextView) {
        changeView(nextView);
      }
    }, [nextView, changeView]);
    var handleChangeAndOpenNext = React__namespace.useCallback(function (date, currentViewSelectionState) {
      var isSelectionFinishedOnCurrentView = currentViewSelectionState === 'finish';
      var globalSelectionState = isSelectionFinishedOnCurrentView && Boolean(nextView) ? 'partial' : currentViewSelectionState;
      onChange(date, globalSelectionState);

      if (isSelectionFinishedOnCurrentView) {
        openNext();
      }
    }, [nextView, onChange, openNext]);
    return {
      handleChangeAndOpenNext: handleChangeAndOpenNext,
      nextView: nextView,
      previousView: previousView,
      openNext: openNext,
      openView: openView,
      setOpenView: changeView
    };
  }

  var CLOCK_WIDTH = 220;
  var CLOCK_HOUR_WIDTH = 36;
  var clockCenter = {
    x: CLOCK_WIDTH / 2,
    y: CLOCK_WIDTH / 2
  };
  var baseClockPoint = {
    x: clockCenter.x,
    y: 0
  };
  var cx = baseClockPoint.x - clockCenter.x;
  var cy = baseClockPoint.y - clockCenter.y;

  var rad2deg = function rad2deg(rad) {
    return rad * (180 / Math.PI);
  };

  var getAngleValue = function getAngleValue(step, offsetX, offsetY) {
    var x = offsetX - clockCenter.x;
    var y = offsetY - clockCenter.y;
    var atan = Math.atan2(cx, cy) - Math.atan2(x, y);
    var deg = rad2deg(atan);
    deg = Math.round(deg / step) * step;
    deg %= 360;
    var value = Math.floor(deg / step) || 0;
    var delta = Math.pow(x, 2) + Math.pow(y, 2);
    var distance = Math.sqrt(delta);
    return {
      value: value,
      distance: distance
    };
  };

  var getMinutes = function getMinutes(offsetX, offsetY) {
    var step = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var angleStep = step * 6;

    var _getAngleValue = getAngleValue(angleStep, offsetX, offsetY),
        value = _getAngleValue.value;

    value = value * step % 60;
    return value;
  };

  var getHours$1 = function getHours$1(offsetX, offsetY, ampm) {
    var _getAngleValue2 = getAngleValue(30, offsetX, offsetY),
        value = _getAngleValue2.value,
        distance = _getAngleValue2.distance;

    var hour = value || 12;

    if (!ampm) {
      if (distance < CLOCK_WIDTH / 2 - CLOCK_HOUR_WIDTH) {
        hour += 12;
        hour %= 24;
      }
    } else {
      hour %= 12;
    }

    return hour;
  };

  var _excluded$c = ["className", "hasSelected", "isInner", "type", "value"];
  var ClockPointerRoot = styled$1('div', {
    skipSx: true
  })(function (_ref400) {
    var theme = _ref400.theme,
        ownerState = _ref400.ownerState;
    return _extends$5({
      width: 2,
      backgroundColor: theme.palette.primary.main,
      position: 'absolute',
      left: 'calc(50% - 1px)',
      bottom: '50%',
      transformOrigin: 'center bottom 0px'
    }, ownerState.toAnimateTransform && {
      transition: theme.transitions.create(['transform', 'height'])
    });
  });
  var ClockPointerThumb = styled$1('div', {
    skipSx: true
  })(function (_ref401) {
    var theme = _ref401.theme,
        ownerState = _ref401.ownerState;
    return _extends$5({
      width: 4,
      height: 4,
      backgroundColor: theme.palette.primary.contrastText,
      borderRadius: '50%',
      position: 'absolute',
      top: -21,
      left: "calc(50% - ".concat(CLOCK_HOUR_WIDTH / 2, "px)"),
      border: "".concat((CLOCK_HOUR_WIDTH - 4) / 2, "px solid ").concat(theme.palette.primary.main),
      boxSizing: 'content-box'
    }, ownerState.hasSelected && {
      backgroundColor: theme.palette.primary.main
    });
  });
  /**
   * @ignore - internal component.
   */

  var ClockPointer = /*#__PURE__*/function (_React__namespace$Com2) {
    _inherits(ClockPointer, _React__namespace$Com2);

    var _super2 = _createSuper(ClockPointer);

    function ClockPointer() {
      var _this9;

      _classCallCheck(this, ClockPointer);

      for (var _len27 = arguments.length, args = new Array(_len27), _key28 = 0; _key28 < _len27; _key28++) {
        args[_key28] = arguments[_key28];
      }

      _this9 = _super2.call.apply(_super2, [this].concat(args));
      _this9.state = {
        toAnimateTransform: false,
        previousType: undefined
      };
      return _this9;
    }

    _createClass2(ClockPointer, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            className = _this$props.className,
            isInner = _this$props.isInner,
            type = _this$props.type,
            value = _this$props.value,
            other = _objectWithoutPropertiesLoose$2(_this$props, _excluded$c);

        var ownerState = _extends$5({}, this.props, this.state);

        var getAngleStyle = function getAngleStyle() {
          var max = type === 'hours' ? 12 : 60;
          var angle = 360 / max * value;

          if (type === 'hours' && value > 12) {
            angle -= 360; // round up angle to max 360 degrees
          }

          return {
            height: Math.round((isInner ? 0.26 : 0.4) * CLOCK_WIDTH),
            transform: "rotateZ(".concat(angle, "deg)")
          };
        };

        return /*#__PURE__*/jsxRuntime$1.jsx(ClockPointerRoot, _extends$5({
          style: getAngleStyle(),
          className: className,
          ownerState: ownerState
        }, other, {
          children: /*#__PURE__*/jsxRuntime$1.jsx(ClockPointerThumb, {
            ownerState: ownerState
          })
        }));
      }
    }]);

    return ClockPointer;
  }(React__namespace.Component);

  ClockPointer.getDerivedStateFromProps = function (nextProps, state) {
    if (nextProps.type !== state.previousType) {
      return {
        toAnimateTransform: true,
        previousType: nextProps.type
      };
    }

    return {
      toAnimateTransform: false,
      previousType: nextProps.type
    };
  };

  var ClockPointer$1 = ClockPointer;

  var _ClockPin, _Typography, _Typography2;

  var ClockRoot = styled$1('div', {
    skipSx: true
  })(function (_ref402) {
    var theme = _ref402.theme;
    return {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      margin: theme.spacing(2)
    };
  });
  var ClockClock = styled$1('div', {
    skipSx: true
  })({
    backgroundColor: 'rgba(0,0,0,.07)',
    borderRadius: '50%',
    height: 220,
    width: 220,
    flexShrink: 0,
    position: 'relative',
    pointerEvents: 'none'
  });
  var ClockSquareMask = styled$1('div', {
    skipSx: true
  })({
    width: '100%',
    height: '100%',
    position: 'absolute',
    pointerEvents: 'auto',
    outline: 0,
    // Disable scroll capabilities.
    touchAction: 'none',
    userSelect: 'none',
    '@media (pointer: fine)': {
      cursor: 'pointer',
      borderRadius: '50%'
    },
    '&:active': {
      cursor: 'move'
    }
  });
  var ClockPin = styled$1('div', {
    skipSx: true
  })(function (_ref403) {
    var theme = _ref403.theme;
    return {
      width: 6,
      height: 6,
      borderRadius: '50%',
      backgroundColor: theme.palette.primary.main,
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)'
    };
  });
  var ClockAmButton = styled$1(IconButton$2, {
    skipSx: true
  })(function (_ref404) {
    var theme = _ref404.theme,
        ownerState = _ref404.ownerState;
    return _extends$5({
      zIndex: 1,
      position: 'absolute',
      bottom: ownerState.ampmInClock ? 64 : 8,
      left: 8
    }, ownerState.meridiemMode === 'am' && {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      '&:hover': {
        backgroundColor: theme.palette.primary.light
      }
    });
  });
  var ClockPmButton = styled$1(IconButton$2, {
    skipSx: true
  })(function (_ref405) {
    var theme = _ref405.theme,
        ownerState = _ref405.ownerState;
    return _extends$5({
      zIndex: 1,
      position: 'absolute',
      bottom: ownerState.ampmInClock ? 64 : 8,
      right: 8
    }, ownerState.meridiemMode === 'pm' && {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      '&:hover': {
        backgroundColor: theme.palette.primary.light
      }
    });
  });
  /**
   * @ignore - internal component.
   */

  function Clock(props) {
    var ampm = props.ampm,
        ampmInClock = props.ampmInClock,
        autoFocus = props.autoFocus,
        children = props.children,
        date = props.date,
        getClockLabelText = props.getClockLabelText,
        handleMeridiemChange = props.handleMeridiemChange,
        isTimeDisabled = props.isTimeDisabled,
        meridiemMode = props.meridiemMode,
        _props$minutesStep = props.minutesStep,
        minutesStep = _props$minutesStep === void 0 ? 1 : _props$minutesStep,
        onChange = props.onChange,
        selectedId = props.selectedId,
        type = props.type,
        value = props.value;
    var ownerState = props;
    var utils = useUtils();
    var wrapperVariant = React__namespace.useContext(WrapperVariantContext);
    var isMoving = React__namespace.useRef(false);
    var isSelectedTimeDisabled = isTimeDisabled(value, type);
    var isPointerInner = !ampm && type === 'hours' && (value < 1 || value > 12);

    var handleValueChange = function handleValueChange(newValue, isFinish) {
      if (isTimeDisabled(newValue, type)) {
        return;
      }

      onChange(newValue, isFinish);
    };

    var setTime = function setTime(event, isFinish) {
      var offsetX = event.offsetX,
          offsetY = event.offsetY;

      if (offsetX === undefined) {
        var rect = event.target.getBoundingClientRect();
        offsetX = event.changedTouches[0].clientX - rect.left;
        offsetY = event.changedTouches[0].clientY - rect.top;
      }

      var newSelectedValue = type === 'seconds' || type === 'minutes' ? getMinutes(offsetX, offsetY, minutesStep) : getHours$1(offsetX, offsetY, Boolean(ampm));
      handleValueChange(newSelectedValue, isFinish);
    };

    var handleTouchMove = function handleTouchMove(event) {
      isMoving.current = true;
      setTime(event, 'shallow');
    };

    var handleTouchEnd = function handleTouchEnd(event) {
      if (isMoving.current) {
        setTime(event, 'finish');
        isMoving.current = false;
      }
    };

    var handleMouseMove = function handleMouseMove(event) {
      // event.buttons & PRIMARY_MOUSE_BUTTON
      if (event.buttons > 0) {
        setTime(event.nativeEvent, 'shallow');
      }
    };

    var handleMouseUp = function handleMouseUp(event) {
      if (isMoving.current) {
        isMoving.current = false;
      }

      setTime(event.nativeEvent, 'finish');
    };

    var hasSelected = React__namespace.useMemo(function () {
      if (type === 'hours') {
        return true;
      }

      return value % 5 === 0;
    }, [type, value]);
    var keyboardControlStep = type === 'minutes' ? minutesStep : 1;
    var listboxRef = React__namespace.useRef(null); // Since this is rendered when a Popper is opened we can't use passive effects.
    // Focusing in passive effects in Popper causes scroll jump.

    useEnhancedEffect$1(function () {
      if (autoFocus) {
        // The ref not being resolved would be a bug in MUI.
        listboxRef.current.focus();
      }
    }, [autoFocus]);

    var handleKeyDown = function handleKeyDown(event) {
      // TODO: Why this early exit?
      if (isMoving.current) {
        return;
      }

      switch (event.key) {
        case 'Home':
          // annulate both hours and minutes
          handleValueChange(0, 'partial');
          event.preventDefault();
          break;

        case 'End':
          handleValueChange(type === 'minutes' ? 59 : 23, 'partial');
          event.preventDefault();
          break;

        case 'ArrowUp':
          handleValueChange(value + keyboardControlStep, 'partial');
          event.preventDefault();
          break;

        case 'ArrowDown':
          handleValueChange(value - keyboardControlStep, 'partial');
          event.preventDefault();
          break;
      }
    };

    return /*#__PURE__*/jsxRuntime$1.jsxs(ClockRoot, {
      children: [/*#__PURE__*/jsxRuntime$1.jsxs(ClockClock, {
        children: [/*#__PURE__*/jsxRuntime$1.jsx(ClockSquareMask, {
          onTouchMove: handleTouchMove,
          onTouchEnd: handleTouchEnd,
          onMouseUp: handleMouseUp,
          onMouseMove: handleMouseMove
        }), !isSelectedTimeDisabled && /*#__PURE__*/jsxRuntime$1.jsxs(React__namespace.Fragment, {
          children: [_ClockPin || (_ClockPin = /*#__PURE__*/jsxRuntime$1.jsx(ClockPin, {})), date && /*#__PURE__*/jsxRuntime$1.jsx(ClockPointer$1, {
            type: type,
            value: value,
            isInner: isPointerInner,
            hasSelected: hasSelected
          })]
        }), /*#__PURE__*/jsxRuntime$1.jsx("div", {
          "aria-activedescendant": selectedId,
          "aria-label": getClockLabelText(type, date, utils),
          ref: listboxRef,
          role: "listbox",
          onKeyDown: handleKeyDown,
          tabIndex: 0,
          children: children
        })]
      }), ampm && (wrapperVariant === 'desktop' || ampmInClock) && /*#__PURE__*/jsxRuntime$1.jsxs(React__namespace.Fragment, {
        children: [/*#__PURE__*/jsxRuntime$1.jsx(ClockAmButton, {
          onClick: function onClick() {
            return handleMeridiemChange('am');
          },
          disabled: meridiemMode === null,
          ownerState: ownerState,
          children: _Typography || (_Typography = /*#__PURE__*/jsxRuntime$1.jsx(Typography$2, {
            variant: "caption",
            children: "AM"
          }))
        }), /*#__PURE__*/jsxRuntime$1.jsx(ClockPmButton, {
          disabled: meridiemMode === null,
          onClick: function onClick() {
            return handleMeridiemChange('pm');
          },
          ownerState: ownerState,
          children: _Typography2 || (_Typography2 = /*#__PURE__*/jsxRuntime$1.jsx(Typography$2, {
            variant: "caption",
            children: "PM"
          }))
        })]
      })]
    });
  }

  var _excluded$b = ["className", "disabled", "index", "inner", "label", "selected"];
  var classes$4 = generateUtilityClasses('PrivateClockNumber', ['selected', 'disabled']);
  var ClockNumberRoot = styled$1('span', {
    skipSx: true
  })(function (_ref406) {
    var _extends$;

    var theme = _ref406.theme,
        ownerState = _ref406.ownerState;
    return _extends$5((_extends$ = {
      height: CLOCK_HOUR_WIDTH,
      width: CLOCK_HOUR_WIDTH,
      position: 'absolute',
      left: "calc((100% - ".concat(CLOCK_HOUR_WIDTH, "px) / 2)"),
      display: 'inline-flex',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: '50%',
      color: theme.palette.text.primary,
      '&:focused': {
        backgroundColor: theme.palette.background.paper
      }
    }, _defineProperty(_extends$, "&.".concat(classes$4.selected), {
      color: theme.palette.primary.contrastText
    }), _defineProperty(_extends$, "&.".concat(classes$4.disabled), {
      pointerEvents: 'none',
      color: theme.palette.text.disabled
    }), _extends$), ownerState.inner && _extends$5({}, theme.typography.body2, {
      color: theme.palette.text.secondary
    }));
  });
  /**
   * @ignore - internal component.
   */

  function ClockNumber(props) {
    var className = props.className,
        disabled = props.disabled,
        index = props.index,
        inner = props.inner,
        label = props.label,
        selected = props.selected,
        other = _objectWithoutPropertiesLoose$2(props, _excluded$b);

    var ownerState = props;
    var angle = index % 12 / 12 * Math.PI * 2 - Math.PI / 2;
    var length = (CLOCK_WIDTH - CLOCK_HOUR_WIDTH - 2) / 2 * (inner ? 0.65 : 1);
    var x = Math.round(Math.cos(angle) * length);
    var y = Math.round(Math.sin(angle) * length);
    return /*#__PURE__*/jsxRuntime$1.jsx(ClockNumberRoot, _extends$5({
      className: clsx(className, selected && classes$4.selected, disabled && classes$4.disabled),
      "aria-disabled": disabled ? true : undefined,
      "aria-selected": selected ? true : undefined,
      role: "option",
      style: {
        transform: "translate(".concat(x, "px, ").concat(y + (CLOCK_WIDTH - CLOCK_HOUR_WIDTH) / 2, "px")
      },
      ownerState: ownerState
    }, other, {
      children: label
    }));
  }
  /**
   * @ignore - internal component.
   */


  var getHourNumbers = function getHourNumbers(_ref407) {
    var ampm = _ref407.ampm,
        date = _ref407.date,
        getClockNumberText = _ref407.getClockNumberText,
        isDisabled = _ref407.isDisabled,
        selectedId = _ref407.selectedId,
        utils = _ref407.utils;
    var currentHours = date ? utils.getHours(date) : null;
    var hourNumbers = [];
    var startHour = ampm ? 1 : 0;
    var endHour = ampm ? 12 : 23;

    var isSelected = function isSelected(hour) {
      if (currentHours === null) {
        return false;
      }

      if (ampm) {
        if (hour === 12) {
          return currentHours === 12 || currentHours === 0;
        }

        return currentHours === hour || currentHours - 12 === hour;
      }

      return currentHours === hour;
    };

    for (var hour = startHour; hour <= endHour; hour += 1) {
      var label = hour.toString();

      if (hour === 0) {
        label = '00';
      }

      var inner = !ampm && (hour === 0 || hour > 12);
      label = utils.formatNumber(label);
      var selected = isSelected(hour);
      hourNumbers.push( /*#__PURE__*/jsxRuntime$1.jsx(ClockNumber, {
        id: selected ? selectedId : undefined,
        index: hour,
        inner: inner,
        selected: selected,
        disabled: isDisabled(hour),
        label: label,
        "aria-label": getClockNumberText(label)
      }, hour));
    }

    return hourNumbers;
  };

  var getMinutesNumbers = function getMinutesNumbers(_ref408) {
    var utils = _ref408.utils,
        value = _ref408.value,
        isDisabled = _ref408.isDisabled,
        getClockNumberText = _ref408.getClockNumberText,
        selectedId = _ref408.selectedId;
    var f = utils.formatNumber;
    return [[5, f('05')], [10, f('10')], [15, f('15')], [20, f('20')], [25, f('25')], [30, f('30')], [35, f('35')], [40, f('40')], [45, f('45')], [50, f('50')], [55, f('55')], [0, f('00')]].map(function (_ref409, index) {
      var _ref410 = _slicedToArray(_ref409, 2),
          numberValue = _ref410[0],
          label = _ref410[1];

      var selected = numberValue === value;
      return /*#__PURE__*/jsxRuntime$1.jsx(ClockNumber, {
        label: label,
        id: selected ? selectedId : undefined,
        index: index + 1,
        inner: false,
        disabled: isDisabled(numberValue),
        selected: selected,
        "aria-label": getClockNumberText(label)
      }, numberValue);
    });
  };

  var ArrowLeftIcon = createSvgIcon$1( /*#__PURE__*/jsxRuntime$1.jsx("path", {
    d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
  }), 'ArrowLeft');
  var ArrowRightIcon = createSvgIcon$1( /*#__PURE__*/jsxRuntime$1.jsx("path", {
    d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
  }), 'ArrowRight');
  var _excluded$a = ["children", "className", "components", "componentsProps", "isLeftDisabled", "isLeftHidden", "isRightDisabled", "isRightHidden", "leftArrowButtonText", "onLeftClick", "onRightClick", "rightArrowButtonText"];
  var PickersArrowSwitcherRoot = styled$1('div')({
    display: 'flex'
  });
  var PickersArrowSwitcherSpacer = styled$1('div', {
    skipSx: true
  })(function (_ref411) {
    var theme = _ref411.theme;
    return {
      width: theme.spacing(3)
    };
  });
  var PickersArrowSwitcherButton = styled$1(IconButton$2, {
    skipSx: true
  })(function (_ref412) {
    var ownerState = _ref412.ownerState;
    return _extends$5({}, ownerState.hidden && {
      visibility: 'hidden'
    });
  });
  var PickersArrowSwitcher = /*#__PURE__*/React__namespace.forwardRef(function PickersArrowSwitcher(props, ref) {
    var children = props.children,
        className = props.className,
        _props$components12 = props.components,
        components = _props$components12 === void 0 ? {} : _props$components12,
        _props$componentsProp12 = props.componentsProps,
        componentsProps = _props$componentsProp12 === void 0 ? {} : _props$componentsProp12,
        isLeftDisabled = props.isLeftDisabled,
        isLeftHidden = props.isLeftHidden,
        isRightDisabled = props.isRightDisabled,
        isRightHidden = props.isRightHidden,
        leftArrowButtonText = props.leftArrowButtonText,
        onLeftClick = props.onLeftClick,
        onRightClick = props.onRightClick,
        rightArrowButtonText = props.rightArrowButtonText,
        other = _objectWithoutPropertiesLoose$2(props, _excluded$a);

    var theme = useTheme();
    var isRtl = theme.direction === 'rtl';
    var leftArrowButtonProps = componentsProps.leftArrowButton || {};
    var LeftArrowIcon = components.LeftArrowIcon || ArrowLeftIcon;
    var rightArrowButtonProps = componentsProps.rightArrowButton || {};
    var RightArrowIcon = components.RightArrowIcon || ArrowRightIcon;
    var ownerState = props;
    return /*#__PURE__*/jsxRuntime$1.jsxs(PickersArrowSwitcherRoot, _extends$5({
      ref: ref,
      className: className,
      ownerState: ownerState
    }, other, {
      children: [/*#__PURE__*/jsxRuntime$1.jsx(PickersArrowSwitcherButton, _extends$5({
        as: components.LeftArrowButton,
        size: "small",
        "aria-label": leftArrowButtonText,
        title: leftArrowButtonText,
        disabled: isLeftDisabled,
        edge: "end",
        onClick: onLeftClick
      }, leftArrowButtonProps, {
        className: leftArrowButtonProps.className,
        ownerState: _extends$5({}, ownerState, leftArrowButtonProps, {
          hidden: isLeftHidden
        }),
        children: isRtl ? /*#__PURE__*/jsxRuntime$1.jsx(RightArrowIcon, {}) : /*#__PURE__*/jsxRuntime$1.jsx(LeftArrowIcon, {})
      })), children ? /*#__PURE__*/jsxRuntime$1.jsx(Typography$2, {
        variant: "subtitle1",
        component: "span",
        children: children
      }) : /*#__PURE__*/jsxRuntime$1.jsx(PickersArrowSwitcherSpacer, {
        ownerState: ownerState
      }), /*#__PURE__*/jsxRuntime$1.jsx(PickersArrowSwitcherButton, _extends$5({
        as: components.RightArrowButton,
        size: "small",
        "aria-label": rightArrowButtonText,
        title: rightArrowButtonText,
        edge: "start",
        disabled: isRightDisabled,
        onClick: onRightClick
      }, rightArrowButtonProps, {
        className: rightArrowButtonProps.className,
        ownerState: _extends$5({}, ownerState, rightArrowButtonProps, {
          hidden: isRightHidden
        }),
        children: isRtl ? /*#__PURE__*/jsxRuntime$1.jsx(LeftArrowIcon, {}) : /*#__PURE__*/jsxRuntime$1.jsx(RightArrowIcon, {})
      }))]
    }));
  });
  var PickersArrowSwitcher$1 = PickersArrowSwitcher;

  var getMeridiem = function getMeridiem(date, utils) {
    if (!date) {
      return null;
    }

    return utils.getHours(date) >= 12 ? 'pm' : 'am';
  };

  var convertValueToMeridiem = function convertValueToMeridiem(value, meridiem, ampm) {
    if (ampm) {
      var currentMeridiem = value >= 12 ? 'pm' : 'am';

      if (currentMeridiem !== meridiem) {
        return meridiem === 'am' ? value - 12 : value + 12;
      }
    }

    return value;
  };

  var convertToMeridiem = function convertToMeridiem(time, meridiem, ampm, utils) {
    var newHoursAmount = convertValueToMeridiem(utils.getHours(time), meridiem, ampm);
    return utils.setHours(time, newHoursAmount);
  };

  function getSecondsInDay(date, utils) {
    return utils.getHours(date) * 3600 + utils.getMinutes(date) * 60 + utils.getSeconds(date);
  }

  var createIsAfterIgnoreDatePart = function createIsAfterIgnoreDatePart(disableIgnoringDatePartForTimeValidation, utils) {
    return function (dateLeft, dateRight) {
      if (disableIgnoringDatePartForTimeValidation) {
        return utils.isAfter(dateLeft, dateRight);
      }

      return getSecondsInDay(dateLeft, utils) > getSecondsInDay(dateRight, utils);
    };
  };

  function useNextMonthDisabled(month, _ref413) {
    var disableFuture = _ref413.disableFuture,
        maxDate = _ref413.maxDate;
    var utils = useUtils();
    return React__namespace.useMemo(function () {
      var now = utils.date();
      var lastEnabledMonth = utils.startOfMonth(disableFuture && utils.isBefore(now, maxDate) ? now : maxDate);
      return !utils.isAfter(lastEnabledMonth, month);
    }, [disableFuture, maxDate, month, utils]);
  }

  function usePreviousMonthDisabled(month, _ref414) {
    var disablePast = _ref414.disablePast,
        minDate = _ref414.minDate;
    var utils = useUtils();
    return React__namespace.useMemo(function () {
      var now = utils.date();
      var firstEnabledMonth = utils.startOfMonth(disablePast && utils.isAfter(now, minDate) ? now : minDate);
      return !utils.isBefore(firstEnabledMonth, month);
    }, [disablePast, minDate, month, utils]);
  }

  function useMeridiemMode(date, ampm, onChange) {
    var utils = useUtils();
    var meridiemMode = getMeridiem(date, utils);
    var handleMeridiemChange = React__namespace.useCallback(function (mode) {
      var timeWithMeridiem = convertToMeridiem(date, mode, Boolean(ampm), utils);
      onChange(timeWithMeridiem, 'partial');
    }, [ampm, date, onChange, utils]);
    return {
      meridiemMode: meridiemMode,
      handleMeridiemChange: handleMeridiemChange
    };
  }

  function getClockPickerUtilityClass(slot) {
    return generateUtilityClass('MuiClockPicker', slot);
  }

  generateUtilityClasses('MuiClockPicker', ['arrowSwitcher']);

  var useUtilityClasses$5 = function useUtilityClasses$5(ownerState) {
    var classes = ownerState.classes;
    var slots = {
      arrowSwitcher: ['arrowSwitcher']
    };
    return composeClasses(slots, getClockPickerUtilityClass, classes);
  };

  var ClockPickerArrowSwitcher = styled$1(PickersArrowSwitcher$1, {
    name: 'MuiClockPicker',
    slot: 'ArrowSwticher',
    overridesResolver: function overridesResolver(props, styles) {
      return styles.arrowSwitcher;
    }
  })({
    position: 'absolute',
    right: 12,
    top: 15
  });

  var defaultGetClockLabelText = function defaultGetClockLabelText(view, time, adapter) {
    return "Select ".concat(view, ". ").concat(time === null ? 'No time selected' : "Selected time is ".concat(adapter.format(time, 'fullTime')));
  };

  var defaultGetMinutesClockNumberText = function defaultGetMinutesClockNumberText(minutes) {
    return "".concat(minutes, " minutes");
  };

  var defaultGetHoursClockNumberText = function defaultGetHoursClockNumberText(hours) {
    return "".concat(hours, " hours");
  };

  var defaultGetSecondsClockNumberText = function defaultGetSecondsClockNumberText(seconds) {
    return "".concat(seconds, " seconds");
  };
  /**
   *
   * API:
   *
   * - [ClockPicker API](https://mui.com/api/clock-picker/)
   */


  function ClockPicker(inProps) {
    var props = useThemeProps({
      props: inProps,
      name: 'MuiClockPicker'
    });
    var _props$ampm = props.ampm,
        ampm = _props$ampm === void 0 ? false : _props$ampm,
        _props$ampmInClock = props.ampmInClock,
        ampmInClock = _props$ampmInClock === void 0 ? false : _props$ampmInClock,
        autoFocus = props.autoFocus,
        components = props.components,
        componentsProps = props.componentsProps,
        date = props.date,
        _props$disableIgnorin = props.disableIgnoringDatePartForTimeValidation,
        disableIgnoringDatePartForTimeValidation = _props$disableIgnorin === void 0 ? false : _props$disableIgnorin,
        _props$getClockLabelT = props.getClockLabelText,
        getClockLabelText = _props$getClockLabelT === void 0 ? defaultGetClockLabelText : _props$getClockLabelT,
        _props$getHoursClockN = props.getHoursClockNumberText,
        getHoursClockNumberText = _props$getHoursClockN === void 0 ? defaultGetHoursClockNumberText : _props$getHoursClockN,
        _props$getMinutesCloc = props.getMinutesClockNumberText,
        getMinutesClockNumberText = _props$getMinutesCloc === void 0 ? defaultGetMinutesClockNumberText : _props$getMinutesCloc,
        _props$getSecondsCloc = props.getSecondsClockNumberText,
        getSecondsClockNumberText = _props$getSecondsCloc === void 0 ? defaultGetSecondsClockNumberText : _props$getSecondsCloc,
        _props$leftArrowButto = props.leftArrowButtonText,
        leftArrowButtonText = _props$leftArrowButto === void 0 ? 'open previous view' : _props$leftArrowButto,
        maxTime = props.maxTime,
        minTime = props.minTime,
        _props$minutesStep2 = props.minutesStep,
        minutesStep = _props$minutesStep2 === void 0 ? 1 : _props$minutesStep2,
        nextViewAvailable = props.nextViewAvailable,
        onChange = props.onChange,
        openNextView = props.openNextView,
        openPreviousView = props.openPreviousView,
        previousViewAvailable = props.previousViewAvailable,
        _props$rightArrowButt = props.rightArrowButtonText,
        rightArrowButtonText = _props$rightArrowButt === void 0 ? 'open next view' : _props$rightArrowButt,
        shouldDisableTime = props.shouldDisableTime,
        showViewSwitcher = props.showViewSwitcher,
        view = props.view;
    var now = useNow();
    var utils = useUtils();
    var midnight = utils.setSeconds(utils.setMinutes(utils.setHours(now, 0), 0), 0);
    var dateOrMidnight = date || midnight;

    var _useMeridiemMode = useMeridiemMode(dateOrMidnight, ampm, onChange),
        meridiemMode = _useMeridiemMode.meridiemMode,
        handleMeridiemChange = _useMeridiemMode.handleMeridiemChange;

    var isTimeDisabled = React__namespace.useCallback(function (rawValue, viewType) {
      if (date === null) {
        return false;
      }

      var validateTimeValue = function validateTimeValue(getRequestedTimePoint) {
        var isAfterComparingFn = createIsAfterIgnoreDatePart(disableIgnoringDatePartForTimeValidation, utils);
        return Boolean(minTime && isAfterComparingFn(minTime, getRequestedTimePoint('end')) || maxTime && isAfterComparingFn(getRequestedTimePoint('start'), maxTime) || shouldDisableTime && shouldDisableTime(rawValue, viewType));
      };

      switch (viewType) {
        case 'hours':
          {
            var hoursWithMeridiem = convertValueToMeridiem(rawValue, meridiemMode, ampm);
            return validateTimeValue(function (when) {
              return pipe(function (currentDate) {
                return utils.setHours(currentDate, hoursWithMeridiem);
              }, function (dateWithHours) {
                return utils.setMinutes(dateWithHours, when === 'start' ? 0 : 59);
              }, function (dateWithMinutes) {
                return utils.setSeconds(dateWithMinutes, when === 'start' ? 0 : 59);
              })(date);
            });
          }

        case 'minutes':
          return validateTimeValue(function (when) {
            return pipe(function (currentDate) {
              return utils.setMinutes(currentDate, rawValue);
            }, function (dateWithMinutes) {
              return utils.setSeconds(dateWithMinutes, when === 'start' ? 0 : 59);
            })(date);
          });

        case 'seconds':
          return validateTimeValue(function () {
            return utils.setSeconds(date, rawValue);
          });

        default:
          throw new Error('not supported');
      }
    }, [ampm, date, disableIgnoringDatePartForTimeValidation, maxTime, meridiemMode, minTime, shouldDisableTime, utils]);
    var selectedId = useId();
    var viewProps = React__namespace.useMemo(function () {
      switch (view) {
        case 'hours':
          {
            var handleHoursChange = function handleHoursChange(value, isFinish) {
              var valueWithMeridiem = convertValueToMeridiem(value, meridiemMode, ampm);
              onChange(utils.setHours(dateOrMidnight, valueWithMeridiem), isFinish);
            };

            return {
              onChange: handleHoursChange,
              value: utils.getHours(dateOrMidnight),
              children: getHourNumbers({
                date: date,
                utils: utils,
                ampm: ampm,
                onChange: handleHoursChange,
                getClockNumberText: getHoursClockNumberText,
                isDisabled: function isDisabled(value) {
                  return isTimeDisabled(value, 'hours');
                },
                selectedId: selectedId
              })
            };
          }

        case 'minutes':
          {
            var minutesValue = utils.getMinutes(dateOrMidnight);

            var handleMinutesChange = function handleMinutesChange(value, isFinish) {
              onChange(utils.setMinutes(dateOrMidnight, value), isFinish);
            };

            return {
              value: minutesValue,
              onChange: handleMinutesChange,
              children: getMinutesNumbers({
                utils: utils,
                value: minutesValue,
                onChange: handleMinutesChange,
                getClockNumberText: getMinutesClockNumberText,
                isDisabled: function isDisabled(value) {
                  return isTimeDisabled(value, 'minutes');
                },
                selectedId: selectedId
              })
            };
          }

        case 'seconds':
          {
            var secondsValue = utils.getSeconds(dateOrMidnight);

            var handleSecondsChange = function handleSecondsChange(value, isFinish) {
              onChange(utils.setSeconds(dateOrMidnight, value), isFinish);
            };

            return {
              value: secondsValue,
              onChange: handleSecondsChange,
              children: getMinutesNumbers({
                utils: utils,
                value: secondsValue,
                onChange: handleSecondsChange,
                getClockNumberText: getSecondsClockNumberText,
                isDisabled: function isDisabled(value) {
                  return isTimeDisabled(value, 'seconds');
                },
                selectedId: selectedId
              })
            };
          }

        default:
          throw new Error('You must provide the type for ClockView');
      }
    }, [view, utils, date, ampm, getHoursClockNumberText, getMinutesClockNumberText, getSecondsClockNumberText, meridiemMode, onChange, dateOrMidnight, isTimeDisabled, selectedId]);
    var ownerState = props;
    var classes = useUtilityClasses$5(ownerState);
    return /*#__PURE__*/jsxRuntime$1.jsxs(React__namespace.Fragment, {
      children: [showViewSwitcher && /*#__PURE__*/jsxRuntime$1.jsx(ClockPickerArrowSwitcher, {
        className: classes.arrowSwitcher,
        leftArrowButtonText: leftArrowButtonText,
        rightArrowButtonText: rightArrowButtonText,
        components: components,
        componentsProps: componentsProps,
        onLeftClick: openPreviousView,
        onRightClick: openNextView,
        isLeftDisabled: previousViewAvailable,
        isRightDisabled: nextViewAvailable,
        ownerState: ownerState
      }), /*#__PURE__*/jsxRuntime$1.jsx(Clock, _extends$5({
        autoFocus: autoFocus,
        date: date,
        ampmInClock: ampmInClock,
        type: view,
        ampm: ampm,
        getClockLabelText: getClockLabelText,
        minutesStep: minutesStep,
        isTimeDisabled: isTimeDisabled,
        meridiemMode: meridiemMode,
        handleMeridiemChange: handleMeridiemChange,
        selectedId: selectedId
      }, viewProps))]
    });
  }

  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var _excluded$9 = ["disabled", "onSelect", "selected", "value"];
  var classes$3 = generateUtilityClasses('PrivatePickersMonth', ['root', 'selected']);
  var PickersMonthRoot = styled$1(Typography$2, {
    skipSx: true
  })(function (_ref415) {
    var theme = _ref415.theme;
    return _extends$5({
      flex: '1 0 33.33%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: 'unset',
      backgroundColor: 'transparent',
      border: 0,
      outline: 0
    }, theme.typography.subtitle1, _defineProperty({
      margin: '8px 0',
      height: 36,
      borderRadius: 18,
      cursor: 'pointer',
      '&:focus, &:hover': {
        backgroundColor: alpha(theme.palette.action.active, theme.palette.action.hoverOpacity)
      },
      '&:disabled': {
        pointerEvents: 'none',
        color: theme.palette.text.secondary
      }
    }, "&.".concat(classes$3.selected), {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
      '&:focus, &:hover': {
        backgroundColor: theme.palette.primary.dark
      }
    }));
  });
  /**
   * @ignore - do not document.
   */

  var PickersMonth = function PickersMonth(props) {
    var disabled = props.disabled,
        onSelect = props.onSelect,
        selected = props.selected,
        value = props.value,
        other = _objectWithoutPropertiesLoose$2(props, _excluded$9);

    var handleSelection = function handleSelection() {
      onSelect(value);
    };

    return /*#__PURE__*/jsxRuntime$1.jsx(PickersMonthRoot, _extends$5({
      component: "button",
      className: clsx(classes$3.root, selected && classes$3.selected),
      tabIndex: disabled ? -1 : 0,
      onClick: handleSelection,
      onKeyDown: onSpaceOrEnter(handleSelection),
      color: selected ? 'primary' : undefined,
      variant: selected ? 'h5' : 'subtitle1',
      disabled: disabled
    }, other));
  };

  var PickersMonth$1 = PickersMonth;
  var _excluded$8 = ["className", "date", "disabled", "disableFuture", "disablePast", "maxDate", "minDate", "onChange", "onMonthChange", "readOnly"];

  function getMonthPickerUtilityClass(slot) {
    return generateUtilityClass('MuiMonthPicker', slot);
  }

  generateUtilityClasses('MuiMonthPicker', ['root']);

  var useUtilityClasses$4 = function useUtilityClasses$4(ownerState) {
    var classes = ownerState.classes;
    var slots = {
      root: ['root']
    };
    return composeClasses(slots, getMonthPickerUtilityClass, classes);
  };

  var MonthPickerRoot = styled$1('div', {
    name: 'MuiMonthPicker',
    slot: 'Root',
    overridesResolver: function overridesResolver(props, styles) {
      return styles.root;
    }
  })({
    width: 310,
    display: 'flex',
    flexWrap: 'wrap',
    alignContent: 'stretch',
    margin: '0 4px'
  });
  var MonthPicker = /*#__PURE__*/React__namespace.forwardRef(function MonthPicker(inProps, ref) {
    var props = useThemeProps({
      props: inProps,
      name: 'MuiMonthPicker'
    });

    var className = props.className,
        date = props.date,
        disabled = props.disabled,
        disableFuture = props.disableFuture,
        disablePast = props.disablePast,
        maxDate = props.maxDate,
        minDate = props.minDate,
        onChange = props.onChange,
        onMonthChange = props.onMonthChange,
        readOnly = props.readOnly,
        other = _objectWithoutPropertiesLoose$2(props, _excluded$8);

    var ownerState = props;
    var classes = useUtilityClasses$4(ownerState);
    var utils = useUtils();
    var now = useNow();
    var currentMonth = utils.getMonth(date || now);

    var shouldDisableMonth = function shouldDisableMonth(month) {
      var firstEnabledMonth = utils.startOfMonth(disablePast && utils.isAfter(now, minDate) ? now : minDate);
      var lastEnabledMonth = utils.startOfMonth(disableFuture && utils.isBefore(now, maxDate) ? now : maxDate);
      var isBeforeFirstEnabled = utils.isBefore(month, firstEnabledMonth);
      var isAfterLastEnabled = utils.isAfter(month, lastEnabledMonth);
      return isBeforeFirstEnabled || isAfterLastEnabled;
    };

    var onMonthSelect = function onMonthSelect(month) {
      if (readOnly) {
        return;
      }

      var newDate = utils.setMonth(date || now, month);
      onChange(newDate, 'finish');

      if (onMonthChange) {
        onMonthChange(newDate);
      }
    };

    return /*#__PURE__*/jsxRuntime$1.jsx(MonthPickerRoot, _extends$5({
      ref: ref,
      className: clsx(classes.root, className),
      ownerState: ownerState
    }, other, {
      children: utils.getMonthArray(date || now).map(function (month) {
        var monthNumber = utils.getMonth(month);
        var monthText = utils.format(month, 'monthShort');
        return /*#__PURE__*/jsxRuntime$1.jsx(PickersMonth$1, {
          value: monthNumber,
          selected: monthNumber === currentMonth,
          onSelect: onMonthSelect,
          disabled: disabled || shouldDisableMonth(month),
          children: monthText
        }, monthText);
      })
    }));
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  /**
   *
   * Demos:
   *
   * - [Date Picker](https://mui.com/components/date-picker/)
   *
   * API:
   *
   * - [MonthPicker API](https://mui.com/api/month-picker/)
   */

  var MonthPicker$1 = MonthPicker;

  var findClosestEnabledDate = function findClosestEnabledDate(_ref416) {
    var date = _ref416.date,
        disableFuture = _ref416.disableFuture,
        disablePast = _ref416.disablePast,
        maxDate = _ref416.maxDate,
        minDate = _ref416.minDate,
        shouldDisableDate = _ref416.shouldDisableDate,
        utils = _ref416.utils;
    var today = utils.startOfDay(utils.date());

    if (disablePast && utils.isBefore(minDate, today)) {
      minDate = today;
    }

    if (disableFuture && utils.isAfter(maxDate, today)) {
      maxDate = today;
    }

    var forward = date;
    var backward = date;

    if (utils.isBefore(date, minDate)) {
      forward = utils.date(minDate);
      backward = null;
    }

    if (utils.isAfter(date, maxDate)) {
      if (backward) {
        backward = utils.date(maxDate);
      }

      forward = null;
    }

    while (forward || backward) {
      if (forward && utils.isAfter(forward, maxDate)) {
        forward = null;
      }

      if (backward && utils.isBefore(backward, minDate)) {
        backward = null;
      }

      if (forward) {
        if (!shouldDisableDate(forward)) {
          return forward;
        }

        forward = utils.addDays(forward, 1);
      }

      if (backward) {
        if (!shouldDisableDate(backward)) {
          return backward;
        }

        backward = utils.addDays(backward, -1);
      }
    }

    return today;
  };

  function parsePickerInputValue(utils, value) {
    var parsedValue = utils.date(value);
    return utils.isValid(parsedValue) ? parsedValue : null;
  }

  var validateDate$1 = function validateDate$1(utils, value, _ref417) {
    var disablePast = _ref417.disablePast,
        disableFuture = _ref417.disableFuture,
        minDate = _ref417.minDate,
        maxDate = _ref417.maxDate,
        shouldDisableDate = _ref417.shouldDisableDate;
    var now = utils.date();
    var date = utils.date(value);

    if (date === null) {
      return null;
    }

    switch (true) {
      case !utils.isValid(value):
        return 'invalidDate';

      case Boolean(shouldDisableDate && shouldDisableDate(date)):
        return 'shouldDisableDate';

      case Boolean(disableFuture && utils.isAfterDay(date, now)):
        return 'disableFuture';

      case Boolean(disablePast && utils.isBeforeDay(date, now)):
        return 'disablePast';

      case Boolean(minDate && utils.isBeforeDay(date, minDate)):
        return 'minDate';

      case Boolean(maxDate && utils.isAfterDay(date, maxDate)):
        return 'maxDate';

      default:
        return null;
    }
  };

  var createCalendarStateReducer = function createCalendarStateReducer(reduceAnimations, disableSwitchToMonthOnDayFocus, utils) {
    return function (state, action) {
      switch (action.type) {
        case 'changeMonth':
          return _extends$5({}, state, {
            slideDirection: action.direction,
            currentMonth: action.newMonth,
            isMonthSwitchingAnimating: !reduceAnimations
          });

        case 'finishMonthSwitchingAnimation':
          return _extends$5({}, state, {
            isMonthSwitchingAnimating: false
          });

        case 'changeFocusedDay':
          {
            if (state.focusedDay !== null && utils.isSameDay(action.focusedDay, state.focusedDay)) {
              return state;
            }

            var needMonthSwitch = Boolean(action.focusedDay) && !disableSwitchToMonthOnDayFocus && !utils.isSameMonth(state.currentMonth, action.focusedDay);
            return _extends$5({}, state, {
              focusedDay: action.focusedDay,
              isMonthSwitchingAnimating: needMonthSwitch && !reduceAnimations,
              currentMonth: needMonthSwitch ? utils.startOfMonth(action.focusedDay) : state.currentMonth,
              slideDirection: utils.isAfterDay(action.focusedDay, state.currentMonth) ? 'left' : 'right'
            });
          }

        default:
          throw new Error('missing support');
      }
    };
  };

  function useCalendarState(_ref418) {
    var date = _ref418.date,
        defaultCalendarMonth = _ref418.defaultCalendarMonth,
        disableFuture = _ref418.disableFuture,
        disablePast = _ref418.disablePast,
        _ref418$disableSwitch = _ref418.disableSwitchToMonthOnDayFocus,
        disableSwitchToMonthOnDayFocus = _ref418$disableSwitch === void 0 ? false : _ref418$disableSwitch,
        maxDate = _ref418.maxDate,
        minDate = _ref418.minDate,
        onMonthChange = _ref418.onMonthChange,
        reduceAnimations = _ref418.reduceAnimations,
        shouldDisableDate = _ref418.shouldDisableDate;

    var _ref;

    var now = useNow();
    var utils = useUtils();
    var reducerFn = React__namespace.useRef(createCalendarStateReducer(Boolean(reduceAnimations), disableSwitchToMonthOnDayFocus, utils)).current;

    var _React__namespace$use141 = React__namespace.useReducer(reducerFn, {
      isMonthSwitchingAnimating: false,
      focusedDay: date || now,
      currentMonth: utils.startOfMonth((_ref = date != null ? date : defaultCalendarMonth) != null ? _ref : now),
      slideDirection: 'left'
    }),
        _React__namespace$use142 = _slicedToArray(_React__namespace$use141, 2),
        calendarState = _React__namespace$use142[0],
        dispatch = _React__namespace$use142[1];

    var handleChangeMonth = React__namespace.useCallback(function (payload) {
      dispatch(_extends$5({
        type: 'changeMonth'
      }, payload));

      if (onMonthChange) {
        onMonthChange(payload.newMonth);
      }
    }, [onMonthChange]);
    var changeMonth = React__namespace.useCallback(function (newDate) {
      var newDateRequested = newDate != null ? newDate : now;

      if (utils.isSameMonth(newDateRequested, calendarState.currentMonth)) {
        return;
      }

      handleChangeMonth({
        newMonth: utils.startOfMonth(newDateRequested),
        direction: utils.isAfterDay(newDateRequested, calendarState.currentMonth) ? 'left' : 'right'
      });
    }, [calendarState.currentMonth, handleChangeMonth, now, utils]);
    var isDateDisabled = React__namespace.useCallback(function (day) {
      return validateDate$1(utils, day, {
        disablePast: disablePast,
        disableFuture: disableFuture,
        minDate: minDate,
        maxDate: maxDate,
        shouldDisableDate: shouldDisableDate
      }) !== null;
    }, [disableFuture, disablePast, maxDate, minDate, shouldDisableDate, utils]);
    var onMonthSwitchingAnimationEnd = React__namespace.useCallback(function () {
      dispatch({
        type: 'finishMonthSwitchingAnimation'
      });
    }, []);
    var changeFocusedDay = React__namespace.useCallback(function (newFocusedDate) {
      if (!isDateDisabled(newFocusedDate)) {
        dispatch({
          type: 'changeFocusedDay',
          focusedDay: newFocusedDate
        });
      }
    }, [isDateDisabled]);
    return {
      calendarState: calendarState,
      changeMonth: changeMonth,
      changeFocusedDay: changeFocusedDay,
      isDateDisabled: isDateDisabled,
      onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd,
      handleChangeMonth: handleChangeMonth
    };
  }

  var classes$2 = generateUtilityClasses('PrivatePickersFadeTransitionGroup', ['root']);
  var animationDuration = 500;
  var PickersFadeTransitionGroupRoot = styled$1(TransitionGroup$1, {
    skipSx: true
  })({
    display: 'block',
    position: 'relative'
  });
  /**
   * @ignore - do not document.
   */

  var PickersFadeTransitionGroup = function PickersFadeTransitionGroup(_ref419) {
    var children = _ref419.children,
        className = _ref419.className,
        reduceAnimations = _ref419.reduceAnimations,
        transKey = _ref419.transKey;

    if (reduceAnimations) {
      return children;
    }

    return /*#__PURE__*/jsxRuntime$1.jsx(PickersFadeTransitionGroupRoot, {
      className: clsx(classes$2.root, className),
      children: /*#__PURE__*/jsxRuntime$1.jsx(Fade$1, {
        appear: false,
        mountOnEnter: true,
        unmountOnExit: true,
        timeout: {
          appear: animationDuration,
          enter: animationDuration / 2,
          exit: 0
        },
        children: children
      }, transKey)
    });
  };

  var FadeTransitionGroup = PickersFadeTransitionGroup;
  var DAY_SIZE = 36;
  var DAY_MARGIN = 2;
  var DIALOG_WIDTH = 320;
  var VIEW_HEIGHT = 358;
  var _excluded$7 = ["allowSameDateSelection", "autoFocus", "className", "day", "disabled", "disableHighlightToday", "disableMargin", "hidden", "isAnimating", "onClick", "onDayFocus", "onDaySelect", "onFocus", "onKeyDown", "outsideCurrentMonth", "selected", "showDaysOutsideCurrentMonth", "children", "today"];

  function getPickersDayUtilityClass(slot) {
    return generateUtilityClass('MuiPickersDay', slot);
  }

  var pickersDayClasses = generateUtilityClasses('MuiPickersDay', ['root', 'dayWithMargin', 'dayOutsideMonth', 'hiddenDaySpacingFiller', 'today', 'selected', 'disabled']);

  var useUtilityClasses$3 = function useUtilityClasses$3(ownerState) {
    var selected = ownerState.selected,
        disableMargin = ownerState.disableMargin,
        disableHighlightToday = ownerState.disableHighlightToday,
        today = ownerState.today,
        outsideCurrentMonth = ownerState.outsideCurrentMonth,
        showDaysOutsideCurrentMonth = ownerState.showDaysOutsideCurrentMonth,
        classes = ownerState.classes;
    var slots = {
      root: ['root', selected && 'selected', !disableMargin && 'dayWithMargin', !disableHighlightToday && today && 'today', outsideCurrentMonth && showDaysOutsideCurrentMonth && 'dayOutsideMonth'],
      hiddenDaySpacingFiller: ['hiddenDaySpacingFiller']
    };
    return composeClasses(slots, getPickersDayUtilityClass, classes);
  };

  var styleArg = function styleArg(_ref420) {
    var _extends$11;

    var theme = _ref420.theme,
        ownerState = _ref420.ownerState;
    return _extends$5({}, theme.typography.caption, (_extends$11 = {
      width: DAY_SIZE,
      height: DAY_SIZE,
      borderRadius: '50%',
      padding: 0,
      // background required here to prevent collides with the other days when animating with transition group
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.text.primary,
      '&:hover': {
        backgroundColor: alpha(theme.palette.action.active, theme.palette.action.hoverOpacity)
      },
      '&:focus': _defineProperty({
        backgroundColor: alpha(theme.palette.action.active, theme.palette.action.hoverOpacity)
      }, "&.".concat(pickersDayClasses.selected), {
        willChange: 'background-color',
        backgroundColor: theme.palette.primary.dark
      })
    }, _defineProperty(_extends$11, "&.".concat(pickersDayClasses.selected), {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
      fontWeight: theme.typography.fontWeightMedium,
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.short
      }),
      '&:hover': {
        willChange: 'background-color',
        backgroundColor: theme.palette.primary.dark
      }
    }), _defineProperty(_extends$11, "&.".concat(pickersDayClasses.disabled), {
      color: theme.palette.text.disabled
    }), _extends$11), !ownerState.disableMargin && {
      margin: "0 ".concat(DAY_MARGIN, "px")
    }, ownerState.outsideCurrentMonth && ownerState.showDaysOutsideCurrentMonth && {
      color: theme.palette.text.secondary
    }, !ownerState.disableHighlightToday && ownerState.today && _defineProperty({}, "&:not(.".concat(pickersDayClasses.selected, ")"), {
      border: "1px solid ".concat(theme.palette.text.secondary)
    }));
  };

  var overridesResolver = function overridesResolver(props, styles) {
    var ownerState = props.ownerState;
    return [styles.root, !ownerState.disableMargin && styles.dayWithMargin, !ownerState.disableHighlightToday && ownerState.today && styles.today, !ownerState.outsideCurrentMonth && ownerState.showDaysOutsideCurrentMonth && styles.dayOutsideMonth, ownerState.outsideCurrentMonth && !ownerState.showDaysOutsideCurrentMonth && styles.hiddenDaySpacingFiller];
  };

  var PickersDayRoot = styled$1(ButtonBase$1, {
    name: 'MuiPickersDay',
    slot: 'Root',
    overridesResolver: overridesResolver
  })(styleArg);
  var PickersDayFiller = styled$1('div', {
    name: 'MuiPickersDay',
    slot: 'Root',
    overridesResolver: overridesResolver
  })(function (_ref422) {
    var theme = _ref422.theme,
        ownerState = _ref422.ownerState;
    return _extends$5({}, styleArg({
      theme: theme,
      ownerState: ownerState
    }), {
      visibility: 'hidden'
    });
  });

  var noop = function noop() {};

  var PickersDay = /*#__PURE__*/React__namespace.forwardRef(function PickersDay(inProps, forwardedRef) {
    var props = useThemeProps({
      props: inProps,
      name: 'MuiPickersDay'
    });

    var _props$allowSameDateS = props.allowSameDateSelection,
        allowSameDateSelection = _props$allowSameDateS === void 0 ? false : _props$allowSameDateS,
        _props$autoFocus5 = props.autoFocus,
        autoFocus = _props$autoFocus5 === void 0 ? false : _props$autoFocus5,
        className = props.className,
        day = props.day,
        _props$disabled10 = props.disabled,
        disabled = _props$disabled10 === void 0 ? false : _props$disabled10,
        _props$disableHighlig = props.disableHighlightToday,
        disableHighlightToday = _props$disableHighlig === void 0 ? false : _props$disableHighlig,
        _props$disableMargin = props.disableMargin,
        disableMargin = _props$disableMargin === void 0 ? false : _props$disableMargin,
        isAnimating = props.isAnimating,
        onClick = props.onClick,
        _props$onDayFocus = props.onDayFocus,
        onDayFocus = _props$onDayFocus === void 0 ? noop : _props$onDayFocus,
        onDaySelect = props.onDaySelect,
        onFocus = props.onFocus,
        onKeyDown = props.onKeyDown,
        outsideCurrentMonth = props.outsideCurrentMonth,
        _props$selected2 = props.selected,
        selected = _props$selected2 === void 0 ? false : _props$selected2,
        _props$showDaysOutsid = props.showDaysOutsideCurrentMonth,
        showDaysOutsideCurrentMonth = _props$showDaysOutsid === void 0 ? false : _props$showDaysOutsid,
        children = props.children,
        _props$today = props.today,
        isToday = _props$today === void 0 ? false : _props$today,
        other = _objectWithoutPropertiesLoose$2(props, _excluded$7);

    var ownerState = _extends$5({}, props, {
      allowSameDateSelection: allowSameDateSelection,
      autoFocus: autoFocus,
      disabled: disabled,
      disableHighlightToday: disableHighlightToday,
      disableMargin: disableMargin,
      selected: selected,
      showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
      today: isToday
    });

    var classes = useUtilityClasses$3(ownerState);
    var utils = useUtils();
    var ref = React__namespace.useRef(null);
    var handleRef = useForkRef(ref, forwardedRef); // Since this is rendered when a Popper is opened we can't use passive effects.
    // Focusing in passive effects in Popper causes scroll jump.

    useEnhancedEffect$1(function () {
      if (autoFocus && !disabled && !isAnimating && !outsideCurrentMonth) {
        // ref.current being null would be a bug in MUI
        ref.current.focus();
      }
    }, [autoFocus, disabled, isAnimating, outsideCurrentMonth]);

    var handleFocus = function handleFocus(event) {
      if (onDayFocus) {
        onDayFocus(day);
      }

      if (onFocus) {
        onFocus(event);
      }
    };

    var handleClick = function handleClick(event) {
      if (!allowSameDateSelection && selected) {
        return;
      }

      if (!disabled) {
        onDaySelect(day, 'finish');
      }

      if (onClick) {
        onClick(event);
      }
    };

    var theme = useTheme();

    function handleKeyDown(event) {
      if (onKeyDown !== undefined) {
        onKeyDown(event);
      }

      switch (event.key) {
        case 'ArrowUp':
          onDayFocus(utils.addDays(day, -7));
          event.preventDefault();
          break;

        case 'ArrowDown':
          onDayFocus(utils.addDays(day, 7));
          event.preventDefault();
          break;

        case 'ArrowLeft':
          onDayFocus(utils.addDays(day, theme.direction === 'ltr' ? -1 : 1));
          event.preventDefault();
          break;

        case 'ArrowRight':
          onDayFocus(utils.addDays(day, theme.direction === 'ltr' ? 1 : -1));
          event.preventDefault();
          break;

        case 'Home':
          onDayFocus(utils.startOfWeek(day));
          event.preventDefault();
          break;

        case 'End':
          onDayFocus(utils.endOfWeek(day));
          event.preventDefault();
          break;

        case 'PageUp':
          onDayFocus(utils.getNextMonth(day));
          event.preventDefault();
          break;

        case 'PageDown':
          onDayFocus(utils.getPreviousMonth(day));
          event.preventDefault();
          break;
      }
    }

    if (outsideCurrentMonth && !showDaysOutsideCurrentMonth) {
      return /*#__PURE__*/jsxRuntime$1.jsx(PickersDayFiller, {
        className: clsx(classes.root, classes.hiddenDaySpacingFiller, className),
        ownerState: ownerState
      });
    }

    return /*#__PURE__*/jsxRuntime$1.jsx(PickersDayRoot, _extends$5({
      className: clsx(classes.root, className),
      ownerState: ownerState,
      ref: handleRef,
      centerRipple: true,
      disabled: disabled,
      "aria-label": !children ? utils.format(day, 'fullDate') : undefined,
      tabIndex: selected ? 0 : -1,
      onFocus: handleFocus,
      onKeyDown: handleKeyDown,
      onClick: handleClick
    }, other, {
      children: !children ? utils.format(day, 'dayOfMonth') : children
    }));
  });

  var areDayPropsEqual = function areDayPropsEqual(prevProps, nextProps) {
    return prevProps.autoFocus === nextProps.autoFocus && prevProps.isAnimating === nextProps.isAnimating && prevProps.today === nextProps.today && prevProps.disabled === nextProps.disabled && prevProps.selected === nextProps.selected && prevProps.disableMargin === nextProps.disableMargin && prevProps.showDaysOutsideCurrentMonth === nextProps.showDaysOutsideCurrentMonth && prevProps.disableHighlightToday === nextProps.disableHighlightToday && prevProps.className === nextProps.className && prevProps.outsideCurrentMonth === nextProps.outsideCurrentMonth && prevProps.onDayFocus === nextProps.onDayFocus && prevProps.onDaySelect === nextProps.onDaySelect;
  };

  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  /**
   *
   * Demos:
   *
   * - [Date Picker](https://mui.com/components/date-picker/)
   *
   * API:
   *
   * - [PickersDay API](https://mui.com/api/pickers-day/)
   */

  var PickersDay$1 = /*#__PURE__*/React__namespace.memo(PickersDay, areDayPropsEqual);
  var _excluded$6 = ["children", "className", "reduceAnimations", "slideDirection", "transKey"];
  var classes$1 = generateUtilityClasses('PrivatePickersSlideTransition', ['root', 'slideEnter-left', 'slideEnter-right', 'slideEnterActive', 'slideEnterActive', 'slideExit', 'slideExitActiveLeft-left', 'slideExitActiveLeft-right']);
  var slideAnimationDuration = 350;
  var PickersSlideTransitionRoot = styled$1(TransitionGroup$1, {
    skipSx: true
  })(function (_ref423) {
    var _ref424;

    var theme = _ref423.theme;
    var slideTransition = theme.transitions.create('transform', {
      duration: slideAnimationDuration,
      easing: 'cubic-bezier(0.35, 0.8, 0.4, 1)'
    });
    return _ref424 = {
      display: 'block',
      position: 'relative',
      overflowX: 'hidden',
      '& > *': {
        position: 'absolute',
        top: 0,
        right: 0,
        left: 0
      }
    }, _defineProperty(_ref424, "& .".concat(classes$1['slideEnter-left']), {
      willChange: 'transform',
      transform: 'translate(100%)',
      zIndex: 1
    }), _defineProperty(_ref424, "& .".concat(classes$1['slideEnter-right']), {
      willChange: 'transform',
      transform: 'translate(-100%)',
      zIndex: 1
    }), _defineProperty(_ref424, "& .".concat(classes$1.slideEnterActive), {
      transform: 'translate(0%)',
      transition: slideTransition
    }), _defineProperty(_ref424, "& .".concat(classes$1.slideExit), {
      transform: 'translate(0%)'
    }), _defineProperty(_ref424, "& .".concat(classes$1['slideExitActiveLeft-left']), {
      willChange: 'transform',
      transform: 'translate(-100%)',
      transition: slideTransition,
      zIndex: 0
    }), _defineProperty(_ref424, "& .".concat(classes$1['slideExitActiveLeft-right']), {
      willChange: 'transform',
      transform: 'translate(100%)',
      transition: slideTransition,
      zIndex: 0
    }), _ref424;
  });
  /**
   * @ignore - do not document.
   */

  var PickersSlideTransition = function PickersSlideTransition(_ref) {
    var children = _ref.children,
        className = _ref.className,
        reduceAnimations = _ref.reduceAnimations,
        slideDirection = _ref.slideDirection,
        transKey = _ref.transKey,
        other = _objectWithoutPropertiesLoose$2(_ref, _excluded$6);

    if (reduceAnimations) {
      return /*#__PURE__*/jsxRuntime$1.jsx("div", {
        className: clsx(classes$1.root, className),
        children: children
      });
    }

    var transitionClasses = {
      exit: classes$1.slideExit,
      enterActive: classes$1.slideEnterActive,
      enter: classes$1["slideEnter-".concat(slideDirection)],
      exitActive: classes$1["slideExitActiveLeft-".concat(slideDirection)]
    };
    return /*#__PURE__*/jsxRuntime$1.jsx(PickersSlideTransitionRoot, {
      className: clsx(classes$1.root, className),
      childFactory: function childFactory(element) {
        return /*#__PURE__*/React__namespace.cloneElement(element, {
          classNames: transitionClasses
        });
      },
      children: /*#__PURE__*/jsxRuntime$1.jsx(CSSTransition$1, _extends$5({
        mountOnEnter: true,
        unmountOnExit: true,
        timeout: slideAnimationDuration,
        classNames: transitionClasses
      }, other, {
        children: children
      }), transKey)
    });
  };

  var SlideTransition = PickersSlideTransition;

  var _span$1;

  var weeksContainerHeight = (DAY_SIZE + DAY_MARGIN * 4) * 6;
  var PickersCalendarDayHeader = styled$1('div', {
    skipSx: true
  })({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  });
  var PickersCalendarWeekDayLabel = styled$1(Typography$2, {
    skipSx: true
  })(function (_ref425) {
    var theme = _ref425.theme;
    return {
      width: 36,
      height: 40,
      margin: '0 2px',
      textAlign: 'center',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      color: theme.palette.text.secondary
    };
  });
  var PickersCalendarLoadingContainer = styled$1('div', {
    skipSx: true
  })({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: weeksContainerHeight
  });
  var PickersCalendarSlideTransition = styled$1(SlideTransition, {
    skipSx: true
  })({
    minHeight: weeksContainerHeight
  });
  var PickersCalendarWeekContainer = styled$1('div', {
    skipSx: true
  })({
    overflow: 'hidden'
  });
  var PickersCalendarWeek = styled$1('div', {
    skipSx: true
  })({
    margin: "".concat(DAY_MARGIN, "px 0"),
    display: 'flex',
    justifyContent: 'center'
  });
  /**
   * @ignore - do not document.
   */

  function PickersCalendar(props) {
    var allowSameDateSelection = props.allowSameDateSelection,
        autoFocus = props.autoFocus,
        changeFocusedDay = props.onFocusedDayChange,
        className = props.className,
        currentMonth = props.currentMonth,
        date = props.date,
        disabled = props.disabled,
        disableHighlightToday = props.disableHighlightToday,
        focusedDay = props.focusedDay,
        isDateDisabled = props.isDateDisabled,
        isMonthSwitchingAnimating = props.isMonthSwitchingAnimating,
        loading = props.loading,
        onChange = props.onChange,
        onMonthSwitchingAnimationEnd = props.onMonthSwitchingAnimationEnd,
        readOnly = props.readOnly,
        reduceAnimations = props.reduceAnimations,
        renderDay = props.renderDay,
        _props$renderLoading = props.renderLoading,
        renderLoading = _props$renderLoading === void 0 ? function () {
      return _span$1 || (_span$1 = /*#__PURE__*/jsxRuntime$1.jsx("span", {
        children: "..."
      }));
    } : _props$renderLoading,
        showDaysOutsideCurrentMonth = props.showDaysOutsideCurrentMonth,
        slideDirection = props.slideDirection,
        TransitionProps = props.TransitionProps;
    var now = useNow();
    var utils = useUtils();
    var handleDaySelect = React__namespace.useCallback(function (day) {
      var isFinish = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'finish';

      if (readOnly) {
        return;
      } // TODO possibly buggy line figure out and add tests


      var finalDate = Array.isArray(date) ? day : utils.mergeDateAndTime(day, date || now);
      onChange(finalDate, isFinish);
    }, [date, now, onChange, readOnly, utils]);
    var currentMonthNumber = utils.getMonth(currentMonth);
    var selectedDates = (Array.isArray(date) ? date : [date]).filter(Boolean).map(function (selectedDateItem) {
      return selectedDateItem && utils.startOfDay(selectedDateItem);
    }); // need a new ref whenever the `key` of the transition changes: http://reactcommunity.org/react-transition-group/transition/#Transition-prop-nodeRef.

    var transitionKey = currentMonthNumber; // eslint-disable-next-line react-hooks/exhaustive-deps

    var slideNodeRef = React__namespace.useMemo(function () {
      return /*#__PURE__*/React__namespace.createRef();
    }, [transitionKey]);
    return /*#__PURE__*/jsxRuntime$1.jsxs(React__namespace.Fragment, {
      children: [/*#__PURE__*/jsxRuntime$1.jsx(PickersCalendarDayHeader, {
        children: utils.getWeekdays().map(function (day, i) {
          return /*#__PURE__*/jsxRuntime$1.jsx(PickersCalendarWeekDayLabel, {
            "aria-hidden": true,
            variant: "caption",
            children: day.charAt(0).toUpperCase()
          }, day + i.toString());
        })
      }), loading ? /*#__PURE__*/jsxRuntime$1.jsx(PickersCalendarLoadingContainer, {
        children: renderLoading()
      }) : /*#__PURE__*/jsxRuntime$1.jsx(PickersCalendarSlideTransition, _extends$5({
        transKey: transitionKey,
        onExited: onMonthSwitchingAnimationEnd,
        reduceAnimations: reduceAnimations,
        slideDirection: slideDirection,
        className: className
      }, TransitionProps, {
        nodeRef: slideNodeRef,
        children: /*#__PURE__*/jsxRuntime$1.jsx(PickersCalendarWeekContainer, {
          ref: slideNodeRef,
          role: "grid",
          children: utils.getWeekArray(currentMonth).map(function (week) {
            return /*#__PURE__*/jsxRuntime$1.jsx(PickersCalendarWeek, {
              role: "row",
              children: week.map(function (day) {
                var pickersDayProps = {
                  key: day == null ? void 0 : day.toString(),
                  day: day,
                  isAnimating: isMonthSwitchingAnimating,
                  disabled: disabled || isDateDisabled(day),
                  allowSameDateSelection: allowSameDateSelection,
                  autoFocus: autoFocus && focusedDay !== null && utils.isSameDay(day, focusedDay),
                  today: utils.isSameDay(day, now),
                  outsideCurrentMonth: utils.getMonth(day) !== currentMonthNumber,
                  selected: selectedDates.some(function (selectedDate) {
                    return selectedDate && utils.isSameDay(selectedDate, day);
                  }),
                  disableHighlightToday: disableHighlightToday,
                  showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
                  onDayFocus: changeFocusedDay,
                  onDaySelect: handleDaySelect
                };
                return renderDay ? renderDay(day, selectedDates, pickersDayProps) : /*#__PURE__*/jsxRuntime$1.jsx("div", {
                  role: "cell",
                  children: /*#__PURE__*/jsxRuntime$1.jsx(PickersDay$1, _extends$5({}, pickersDayProps))
                }, pickersDayProps.key);
              })
            }, "week-".concat(week[0]));
          })
        })
      }))]
    });
  }

  var ArrowDropDownIcon = createSvgIcon$1( /*#__PURE__*/jsxRuntime$1.jsx("path", {
    d: "M7 10l5 5 5-5z"
  }), 'ArrowDropDown');
  var PickersCalendarHeaderRoot = styled$1('div', {
    skipSx: true
  })({
    display: 'flex',
    alignItems: 'center',
    marginTop: 16,
    marginBottom: 8,
    paddingLeft: 24,
    paddingRight: 12,
    // prevent jumping in safari
    maxHeight: 30,
    minHeight: 30
  });
  var PickersCalendarHeaderLabel = styled$1('div', {
    skipSx: true
  })(function (_ref426) {
    var theme = _ref426.theme;
    return _extends$5({
      display: 'flex',
      maxHeight: 30,
      overflow: 'hidden',
      alignItems: 'center',
      cursor: 'pointer',
      marginRight: 'auto'
    }, theme.typography.body1, {
      fontWeight: theme.typography.fontWeightMedium
    });
  });
  var PickersCalendarHeaderLabelItem = styled$1('div', {
    skipSx: true
  })({
    marginRight: 6
  });
  var PickersCalendarHeaderSwitchViewButton = styled$1(IconButton$2, {
    skipSx: true
  })({
    marginRight: 'auto'
  });
  var PickersCalendarHeaderSwitchView = styled$1(ArrowDropDownIcon, {
    skipSx: true
  })(function (_ref427) {
    var theme = _ref427.theme,
        ownerState = _ref427.ownerState;
    return _extends$5({
      willChange: 'transform',
      transition: theme.transitions.create('transform'),
      transform: 'rotate(0deg)'
    }, ownerState.openView === 'year' && {
      transform: 'rotate(180deg)'
    });
  });

  function getSwitchingViewAriaText(view) {
    return view === 'year' ? 'year view is open, switch to calendar view' : 'calendar view is open, switch to year view';
  }
  /**
   * @ignore - do not document.
   */


  function PickersCalendarHeader(props) {
    var _props$components13 = props.components,
        components = _props$components13 === void 0 ? {} : _props$components13,
        _props$componentsProp13 = props.componentsProps,
        componentsProps = _props$componentsProp13 === void 0 ? {} : _props$componentsProp13,
        month = props.currentMonth,
        disabled = props.disabled,
        disableFuture = props.disableFuture,
        disablePast = props.disablePast,
        _props$getViewSwitchi = props.getViewSwitchingButtonText,
        getViewSwitchingButtonText = _props$getViewSwitchi === void 0 ? getSwitchingViewAriaText : _props$getViewSwitchi,
        _props$leftArrowButto2 = props.leftArrowButtonText,
        leftArrowButtonText = _props$leftArrowButto2 === void 0 ? 'Previous month' : _props$leftArrowButto2,
        maxDate = props.maxDate,
        minDate = props.minDate,
        onMonthChange = props.onMonthChange,
        onViewChange = props.onViewChange,
        currentView = props.openView,
        reduceAnimations = props.reduceAnimations,
        _props$rightArrowButt2 = props.rightArrowButtonText,
        rightArrowButtonText = _props$rightArrowButt2 === void 0 ? 'Next month' : _props$rightArrowButt2,
        views = props.views;
    var utils = useUtils();
    var switchViewButtonProps = componentsProps.switchViewButton || {};

    var selectNextMonth = function selectNextMonth() {
      return onMonthChange(utils.getNextMonth(month), 'left');
    };

    var selectPreviousMonth = function selectPreviousMonth() {
      return onMonthChange(utils.getPreviousMonth(month), 'right');
    };

    var isNextMonthDisabled = useNextMonthDisabled(month, {
      disableFuture: disableFuture || disabled,
      maxDate: maxDate
    });
    var isPreviousMonthDisabled = usePreviousMonthDisabled(month, {
      disablePast: disablePast || disabled,
      minDate: minDate
    });

    var handleToggleView = function handleToggleView() {
      if (views.length === 1 || !onViewChange || disabled) {
        return;
      }

      if (views.length === 2) {
        onViewChange(views.find(function (view) {
          return view !== currentView;
        }) || views[0]);
      } else {
        // switching only between first 2
        var nextIndexToOpen = views.indexOf(currentView) !== 0 ? 0 : 1;
        onViewChange(views[nextIndexToOpen]);
      }
    }; // No need to display more information


    if (views.length === 1 && views[0] === 'year') {
      return null;
    }

    var ownerState = props;
    return /*#__PURE__*/jsxRuntime$1.jsxs(PickersCalendarHeaderRoot, {
      ownerState: ownerState,
      children: [/*#__PURE__*/jsxRuntime$1.jsxs(PickersCalendarHeaderLabel, {
        role: "presentation",
        onClick: handleToggleView,
        ownerState: ownerState,
        children: [/*#__PURE__*/jsxRuntime$1.jsx(FadeTransitionGroup, {
          reduceAnimations: reduceAnimations,
          transKey: utils.format(month, 'month'),
          children: /*#__PURE__*/jsxRuntime$1.jsx(PickersCalendarHeaderLabelItem, {
            "aria-live": "polite",
            ownerState: ownerState,
            children: utils.format(month, 'month')
          })
        }), /*#__PURE__*/jsxRuntime$1.jsx(FadeTransitionGroup, {
          reduceAnimations: reduceAnimations,
          transKey: utils.format(month, 'year'),
          children: /*#__PURE__*/jsxRuntime$1.jsx(PickersCalendarHeaderLabelItem, {
            "aria-live": "polite",
            ownerState: ownerState,
            children: utils.format(month, 'year')
          })
        }), views.length > 1 && !disabled && /*#__PURE__*/jsxRuntime$1.jsx(PickersCalendarHeaderSwitchViewButton, _extends$5({
          size: "small",
          as: components.SwitchViewButton,
          "aria-label": getViewSwitchingButtonText(currentView)
        }, switchViewButtonProps, {
          children: /*#__PURE__*/jsxRuntime$1.jsx(PickersCalendarHeaderSwitchView, {
            as: components.SwitchViewIcon,
            ownerState: ownerState
          })
        }))]
      }), /*#__PURE__*/jsxRuntime$1.jsx(Fade$1, {
        in: currentView === 'day',
        children: /*#__PURE__*/jsxRuntime$1.jsx(PickersArrowSwitcher$1, {
          leftArrowButtonText: leftArrowButtonText,
          rightArrowButtonText: rightArrowButtonText,
          components: components,
          componentsProps: componentsProps,
          onLeftClick: selectPreviousMonth,
          onRightClick: selectNextMonth,
          isLeftDisabled: isPreviousMonthDisabled,
          isRightDisabled: isNextMonthDisabled
        })
      })]
    });
  }

  function getPickersYearUtilityClass(slot) {
    return generateUtilityClass('PrivatePickersYear', slot);
  }

  var pickersYearClasses = generateUtilityClasses('PrivatePickersYear', ['root', 'modeMobile', 'modeDesktop', 'yearButton', 'disabled', 'selected']);

  var useUtilityClasses$2 = function useUtilityClasses$2(ownerState) {
    var wrapperVariant = ownerState.wrapperVariant,
        disabled = ownerState.disabled,
        selected = ownerState.selected,
        classes = ownerState.classes;
    var slots = {
      root: ['root', wrapperVariant && "mode".concat(capitalize$1(wrapperVariant))],
      yearButton: ['yearButton', disabled && 'disabled', selected && 'selected']
    };
    return composeClasses(slots, getPickersYearUtilityClass, classes);
  };

  var PickersYearRoot = styled$1('div', {
    skipSx: true
  })(function (_ref428) {
    var ownerState = _ref428.ownerState;
    return _extends$5({
      flexBasis: '33.3%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }, (ownerState == null ? void 0 : ownerState.wrapperVariant) === 'desktop' && {
      flexBasis: '25%'
    });
  });
  var PickersYearButton = styled$1('button', {
    skipSx: true
  })(function (_ref429) {
    var _extends$12;

    var theme = _ref429.theme;
    return _extends$5({
      color: 'unset',
      backgroundColor: 'transparent',
      border: 0,
      outline: 0
    }, theme.typography.subtitle1, (_extends$12 = {
      margin: '8px 0',
      height: 36,
      width: 72,
      borderRadius: 18,
      cursor: 'pointer',
      '&:focus, &:hover': {
        backgroundColor: alpha(theme.palette.action.active, theme.palette.action.hoverOpacity)
      }
    }, _defineProperty(_extends$12, "&.".concat(pickersYearClasses.disabled), {
      color: theme.palette.text.secondary
    }), _defineProperty(_extends$12, "&.".concat(pickersYearClasses.selected), {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
      '&:focus, &:hover': {
        backgroundColor: theme.palette.primary.dark
      }
    }), _extends$12));
  });
  /**
   * @ignore - internal component.
   */

  var PickersYear = /*#__PURE__*/React__namespace.forwardRef(function PickersYear(props, forwardedRef) {
    var autoFocus = props.autoFocus,
        className = props.className,
        children = props.children,
        disabled = props.disabled,
        _onClick = props.onClick,
        _onKeyDown = props.onKeyDown,
        selected = props.selected,
        value = props.value;
    var ref = React__namespace.useRef(null);
    var refHandle = useForkRef(ref, forwardedRef);
    var wrapperVariant = React__namespace.useContext(WrapperVariantContext);

    var ownerState = _extends$5({}, props, {
      wrapperVariant: wrapperVariant
    });

    var classes = useUtilityClasses$2(ownerState); // TODO: Can we just forward this to the button?

    React__namespace.useEffect(function () {
      if (autoFocus) {
        // `ref.current` being `null` would be a bug in MUIu
        ref.current.focus();
      }
    }, [autoFocus]);
    return /*#__PURE__*/jsxRuntime$1.jsx(PickersYearRoot, {
      className: clsx(classes.root, className),
      ownerState: ownerState,
      children: /*#__PURE__*/jsxRuntime$1.jsx(PickersYearButton, {
        ref: refHandle,
        disabled: disabled,
        type: "button",
        tabIndex: selected ? 0 : -1,
        onClick: function onClick(event) {
          return _onClick(event, value);
        },
        onKeyDown: function onKeyDown(event) {
          return _onKeyDown(event, value);
        },
        className: classes.yearButton,
        ownerState: ownerState,
        children: children
      })
    });
  });
  var PickersYear$1 = PickersYear;

  function getYearPickerUtilityClass(slot) {
    return generateUtilityClass('MuiYearPicker', slot);
  }

  generateUtilityClasses('MuiYearPicker', ['root']);

  var useUtilityClasses$1 = function useUtilityClasses$1(ownerState) {
    var classes = ownerState.classes;
    var slots = {
      root: ['root']
    };
    return composeClasses(slots, getYearPickerUtilityClass, classes);
  };

  var YearPickerRoot = styled$1('div', {
    name: 'MuiYearPicker',
    slot: 'Root',
    overridesResolver: function overridesResolver(props, styles) {
      return styles.root;
    }
  })({
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    overflowY: 'auto',
    height: '100%',
    margin: '0 4px'
  });
  var YearPicker = /*#__PURE__*/React__namespace.forwardRef(function YearPicker(inProps, ref) {
    var props = useThemeProps({
      props: inProps,
      name: 'MuiYearPicker'
    });
    var autoFocus = props.autoFocus,
        className = props.className,
        date = props.date,
        disabled = props.disabled,
        disableFuture = props.disableFuture,
        disablePast = props.disablePast,
        isDateDisabled = props.isDateDisabled,
        maxDate = props.maxDate,
        minDate = props.minDate,
        onChange = props.onChange,
        onFocusedDayChange = props.onFocusedDayChange,
        onYearChange = props.onYearChange,
        readOnly = props.readOnly,
        shouldDisableYear = props.shouldDisableYear;
    var ownerState = props;
    var classes = useUtilityClasses$1(ownerState);
    var now = useNow();
    var theme = useTheme();
    var utils = useUtils();
    var selectedDate = date || now;
    var currentYear = utils.getYear(selectedDate);
    var wrapperVariant = React__namespace.useContext(WrapperVariantContext);
    var selectedYearRef = React__namespace.useRef(null);

    var _React__namespace$use143 = React__namespace.useState(currentYear),
        _React__namespace$use144 = _slicedToArray(_React__namespace$use143, 2),
        focusedYear = _React__namespace$use144[0],
        setFocusedYear = _React__namespace$use144[1];

    var handleYearSelection = function handleYearSelection(event, year) {
      var isFinish = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'finish';

      if (readOnly) {
        return;
      }

      var submitDate = function submitDate(newDate) {
        onChange(newDate, isFinish);

        if (onFocusedDayChange) {
          onFocusedDayChange(newDate || now);
        }

        if (onYearChange) {
          onYearChange(newDate);
        }
      };

      var newDate = utils.setYear(selectedDate, year);

      if (isDateDisabled(newDate)) {
        var closestEnabledDate = findClosestEnabledDate({
          utils: utils,
          date: newDate,
          minDate: minDate,
          maxDate: maxDate,
          disablePast: Boolean(disablePast),
          disableFuture: Boolean(disableFuture),
          shouldDisableDate: isDateDisabled
        });
        submitDate(closestEnabledDate || now);
      } else {
        submitDate(newDate);
      }
    };

    var focusYear = React__namespace.useCallback(function (year) {
      if (!isDateDisabled(utils.setYear(selectedDate, year))) {
        setFocusedYear(year);
      }
    }, [selectedDate, isDateDisabled, utils]);
    var yearsInRow = wrapperVariant === 'desktop' ? 4 : 3;

    var handleKeyDown = function handleKeyDown(event, year) {
      switch (event.key) {
        case 'ArrowUp':
          focusYear(year - yearsInRow);
          event.preventDefault();
          break;

        case 'ArrowDown':
          focusYear(year + yearsInRow);
          event.preventDefault();
          break;

        case 'ArrowLeft':
          focusYear(year + (theme.direction === 'ltr' ? -1 : 1));
          event.preventDefault();
          break;

        case 'ArrowRight':
          focusYear(year + (theme.direction === 'ltr' ? 1 : -1));
          event.preventDefault();
          break;
      }
    };

    return /*#__PURE__*/jsxRuntime$1.jsx(YearPickerRoot, {
      ref: ref,
      className: clsx(classes.root, className),
      ownerState: ownerState,
      children: utils.getYearRange(minDate, maxDate).map(function (year) {
        var yearNumber = utils.getYear(year);
        var selected = yearNumber === currentYear;
        return /*#__PURE__*/jsxRuntime$1.jsx(PickersYear$1, {
          selected: selected,
          value: yearNumber,
          onClick: handleYearSelection,
          onKeyDown: handleKeyDown,
          autoFocus: autoFocus && yearNumber === focusedYear,
          ref: selected ? selectedYearRef : undefined,
          disabled: disabled || disablePast && utils.isBeforeYear(year, now) || disableFuture && utils.isAfterYear(year, now) || shouldDisableYear && shouldDisableYear(year),
          children: utils.format(year, 'year')
        }, utils.format(year, 'year'));
      })
    });
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  /**
   *
   * Demos:
   *
   * - [Date Picker](https://mui.com/components/date-picker/)
   *
   * API:
   *
   * - [YearPicker API](https://mui.com/api/year-picker/)
   */

  var YearPicker$1 = YearPicker;
  var PickerView = styled$1('div')({
    overflowX: 'hidden',
    width: DIALOG_WIDTH,
    maxHeight: VIEW_HEIGHT,
    display: 'flex',
    flexDirection: 'column',
    margin: '0 auto'
  });
  var PickerView$1 = PickerView;

  var _span;

  var _excluded$5 = ["autoFocus", "onViewChange", "date", "disableFuture", "disablePast", "defaultCalendarMonth", "loading", "maxDate", "minDate", "onChange", "onMonthChange", "reduceAnimations", "renderLoading", "shouldDisableDate", "shouldDisableYear", "view", "views", "openTo", "className"];

  function getCalendarPickerUtilityClass(slot) {
    return generateUtilityClass('MuiCalendarPicker', slot);
  }

  generateUtilityClasses('MuiCalendarPicker', ['root', 'viewTransitionContainer']);

  var useUtilityClasses = function useUtilityClasses(ownerState) {
    var classes = ownerState.classes;
    var slots = {
      root: ['root'],
      viewTransitionContainer: ['viewTransitionContainer']
    };
    return composeClasses(slots, getCalendarPickerUtilityClass, classes);
  };

  var CalendarPickerRoot = styled$1(PickerView$1, {
    name: 'MuiCalendarPicker',
    slot: 'Root',
    overridesResolver: function overridesResolver(props, styles) {
      return styles.root;
    }
  })({
    display: 'flex',
    flexDirection: 'column'
  });
  var CalendarPickerViewTransitionContainer = styled$1(FadeTransitionGroup, {
    name: 'MuiCalendarPicker',
    slot: 'ViewTransitionContainer',
    overridesResolver: function overridesResolver(props, styles) {
      return styles.viewTransitionContainer;
    }
  })({
    overflowY: 'auto'
  });
  var defaultReduceAnimations = typeof navigator !== 'undefined' && /(android)/i.test(navigator.userAgent);
  var CalendarPicker = /*#__PURE__*/React__namespace.forwardRef(function CalendarPicker(inProps, ref) {
    var props = useThemeProps({
      props: inProps,
      name: 'MuiCalendarPicker'
    });

    var autoFocus = props.autoFocus,
        onViewChange = props.onViewChange,
        date = props.date,
        _props$disableFuture = props.disableFuture,
        disableFuture = _props$disableFuture === void 0 ? false : _props$disableFuture,
        _props$disablePast = props.disablePast,
        disablePast = _props$disablePast === void 0 ? false : _props$disablePast,
        defaultCalendarMonth = props.defaultCalendarMonth,
        _props$loading2 = props.loading,
        loading = _props$loading2 === void 0 ? false : _props$loading2,
        maxDateProp = props.maxDate,
        minDateProp = props.minDate,
        onChange = props.onChange,
        onMonthChange = props.onMonthChange,
        _props$reduceAnimatio = props.reduceAnimations,
        reduceAnimations = _props$reduceAnimatio === void 0 ? defaultReduceAnimations : _props$reduceAnimatio,
        _props$renderLoading2 = props.renderLoading,
        renderLoading = _props$renderLoading2 === void 0 ? function () {
      return _span || (_span = /*#__PURE__*/jsxRuntime$1.jsx("span", {
        children: "..."
      }));
    } : _props$renderLoading2,
        shouldDisableDate = props.shouldDisableDate,
        shouldDisableYear = props.shouldDisableYear,
        view = props.view,
        _props$views = props.views,
        views = _props$views === void 0 ? ['year', 'day'] : _props$views,
        _props$openTo = props.openTo,
        openTo = _props$openTo === void 0 ? 'day' : _props$openTo,
        className = props.className,
        other = _objectWithoutPropertiesLoose$2(props, _excluded$5);

    var utils = useUtils();
    var defaultDates = useDefaultDates();
    var minDate = minDateProp != null ? minDateProp : defaultDates.minDate;
    var maxDate = maxDateProp != null ? maxDateProp : defaultDates.maxDate;

    var _useViews = useViews({
      view: view,
      views: views,
      openTo: openTo,
      onChange: onChange,
      onViewChange: onViewChange
    }),
        openView = _useViews.openView,
        setOpenView = _useViews.setOpenView;

    var _useCalendarState = useCalendarState({
      date: date,
      defaultCalendarMonth: defaultCalendarMonth,
      reduceAnimations: reduceAnimations,
      onMonthChange: onMonthChange,
      minDate: minDate,
      maxDate: maxDate,
      shouldDisableDate: shouldDisableDate,
      disablePast: disablePast,
      disableFuture: disableFuture
    }),
        calendarState = _useCalendarState.calendarState,
        changeFocusedDay = _useCalendarState.changeFocusedDay,
        changeMonth = _useCalendarState.changeMonth,
        isDateDisabled = _useCalendarState.isDateDisabled,
        handleChangeMonth = _useCalendarState.handleChangeMonth,
        onMonthSwitchingAnimationEnd = _useCalendarState.onMonthSwitchingAnimationEnd;

    React__namespace.useEffect(function () {
      if (date && isDateDisabled(date)) {
        var closestEnabledDate = findClosestEnabledDate({
          utils: utils,
          date: date,
          minDate: minDate,
          maxDate: maxDate,
          disablePast: disablePast,
          disableFuture: disableFuture,
          shouldDisableDate: isDateDisabled
        });
        onChange(closestEnabledDate, 'partial');
      } // This call is too expensive to run it on each prop change.
      // So just ensure that we are not rendering disabled as selected on mount.

    }, []); // eslint-disable-line

    React__namespace.useEffect(function () {
      if (date) {
        changeMonth(date);
      }
    }, [date]); // eslint-disable-line

    var ownerState = props;
    var classes = useUtilityClasses(ownerState);
    var monthPickerProps = {
      className: className,
      date: date,
      disabled: other.disabled,
      disablePast: disablePast,
      disableFuture: disableFuture,
      onChange: onChange,
      minDate: minDate,
      maxDate: maxDate,
      onMonthChange: onMonthChange,
      readOnly: other.readOnly
    };
    return /*#__PURE__*/jsxRuntime$1.jsxs(CalendarPickerRoot, {
      ref: ref,
      className: clsx(classes.root, className),
      ownerState: ownerState,
      children: [/*#__PURE__*/jsxRuntime$1.jsx(PickersCalendarHeader, _extends$5({}, other, {
        views: views,
        openView: openView,
        currentMonth: calendarState.currentMonth,
        onViewChange: setOpenView,
        onMonthChange: function onMonthChange(newMonth, direction) {
          return handleChangeMonth({
            newMonth: newMonth,
            direction: direction
          });
        },
        minDate: minDate,
        maxDate: maxDate,
        disablePast: disablePast,
        disableFuture: disableFuture,
        reduceAnimations: reduceAnimations
      })), /*#__PURE__*/jsxRuntime$1.jsx(CalendarPickerViewTransitionContainer, {
        reduceAnimations: reduceAnimations,
        className: classes.viewTransitionContainer,
        transKey: openView,
        ownerState: ownerState,
        children: /*#__PURE__*/jsxRuntime$1.jsxs("div", {
          children: [openView === 'year' && /*#__PURE__*/jsxRuntime$1.jsx(YearPicker$1, _extends$5({}, other, {
            autoFocus: autoFocus,
            date: date,
            onChange: onChange,
            minDate: minDate,
            maxDate: maxDate,
            disableFuture: disableFuture,
            disablePast: disablePast,
            isDateDisabled: isDateDisabled,
            shouldDisableYear: shouldDisableYear,
            onFocusedDayChange: changeFocusedDay
          })), openView === 'month' && /*#__PURE__*/jsxRuntime$1.jsx(MonthPicker$1, _extends$5({}, monthPickerProps)), openView === 'day' && /*#__PURE__*/jsxRuntime$1.jsx(PickersCalendar, _extends$5({}, other, calendarState, {
            autoFocus: autoFocus,
            onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd,
            onFocusedDayChange: changeFocusedDay,
            reduceAnimations: reduceAnimations,
            date: date,
            onChange: onChange,
            isDateDisabled: isDateDisabled,
            loading: loading,
            renderLoading: renderLoading
          }))]
        })
      })]
    });
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  /**
   *
   * Demos:
   *
   * - [Date Picker](https://mui.com/components/date-picker/)
   *
   * API:
   *
   * - [CalendarPicker API](https://mui.com/api/calendar-picker/)
   */

  var CalendarPicker$1 = CalendarPicker;

  var useRifm = function useRifm(props) {
    var _React$useReducer = React.useReducer(function (c) {
      return c + 1;
    }, 0),
        _React$useReducer2 = _slicedToArray(_React$useReducer, 2),
        refresh = _React$useReducer2[1];

    var valueRef = React.useRef(null);
    var replace = props.replace,
        append = props.append;
    var userValue = replace ? replace(props.format(props.value)) : props.format(props.value); // state of delete button see comments below about inputType support

    var isDeleleteButtonDownRef = React.useRef(false);

    var onChange = function onChange(evt) {
      if (process.env.NODE_ENV !== 'production') {
        if (evt.target.type === 'number') {
          console.error('Rifm does not support input type=number, use type=tel instead.');
          return;
        }

        if (evt.target.type === 'date') {
          console.error('Rifm does not support input type=date.');
          return;
        }
      }

      var eventValue = evt.target.value;
      valueRef.current = [eventValue, // eventValue
      evt.target, // input
      eventValue.length > userValue.length, // isSizeIncreaseOperation
      isDeleleteButtonDownRef.current, // isDeleleteButtonDown
      userValue === props.format(eventValue) // isNoOperation
      ];

      if (process.env.NODE_ENV !== 'production') {
        var formattedEventValue = props.format(eventValue);

        if (eventValue !== formattedEventValue && eventValue.toLowerCase() === formattedEventValue.toLowerCase()) {
          console.warn('Case enforcement does not work with format. Please use replace={value => value.toLowerCase()} instead');
        }
      } // The main trick is to update underlying input with non formatted value (= eventValue)
      // that allows us to calculate right cursor position after formatting (see getCursorPosition)
      // then we format new value and call props.onChange with masked/formatted value
      // and finally we are able to set cursor position into right place


      refresh();
    }; // React prints warn on server in non production mode about useLayoutEffect usage
    // in both cases it's noop


    if (process.env.NODE_ENV === 'production' || typeof window !== 'undefined') {
      React.useLayoutEffect(function () {
        if (valueRef.current == null) return;

        var _valueRef$current = _slicedToArray(valueRef.current, 5),
            eventValue = _valueRef$current[0],
            input = _valueRef$current[1],
            isSizeIncreaseOperation = _valueRef$current[2],
            isDeleleteButtonDown = _valueRef$current[3],
            // No operation means that value itself hasn't been changed, BTW cursor, selection etc can be changed
        isNoOperation = _valueRef$current[4];

        valueRef.current = null; // this usually occurs on deleting special symbols like ' here 123'123.00
        // in case of isDeleleteButtonDown cursor should move differently vs backspace

        var deleteWasNoOp = isDeleleteButtonDown && isNoOperation;
        var valueAfterSelectionStart = eventValue.slice(input.selectionStart);
        var acceptedCharIndexAfterDelete = valueAfterSelectionStart.search(props.accept || /\d/g);
        var charsToSkipAfterDelete = acceptedCharIndexAfterDelete !== -1 ? acceptedCharIndexAfterDelete : 0; // Create string from only accepted symbols

        var clean = function clean(str) {
          return (str.match(props.accept || /\d/g) || []).join('');
        };

        var valueBeforeSelectionStart = clean(eventValue.substr(0, input.selectionStart)); // trying to find cursor position in formatted value having knowledge about valueBeforeSelectionStart
        // This works because we assume that format doesn't change the order of accepted symbols.
        // Imagine we have formatter which adds ' symbol between numbers, and by default we refuse all non numeric symbols
        // for example we had input = 1'2|'4 (| means cursor position) then user entered '3' symbol
        // inputValue = 1'23'|4 so valueBeforeSelectionStart = 123 and formatted value = 1'2'3'4
        // calling getCursorPosition("1'2'3'4") will give us position after 3, 1'2'3|'4
        // so for formatting just this function to determine cursor position after formatting is enough
        // with masking we need to do some additional checks see `mask` below

        var getCursorPosition = function getCursorPosition(val) {
          var start = 0;
          var cleanPos = 0;

          for (var i = 0; i !== valueBeforeSelectionStart.length; ++i) {
            var newPos = val.indexOf(valueBeforeSelectionStart[i], start) + 1;
            var newCleanPos = clean(val).indexOf(valueBeforeSelectionStart[i], cleanPos) + 1; // this skips position change if accepted symbols order was broken
            // For example fixes edge case with fixed point numbers:
            // You have '0|.00', then press 1, it becomes 01|.00 and after format 1.00, this breaks our assumption
            // that order of accepted symbols is not changed after format,
            // so here we don't update start position if other accepted symbols was inbetween current and new position

            if (newCleanPos - cleanPos > 1) {
              newPos = start;
              newCleanPos = cleanPos;
            }

            cleanPos = Math.max(newCleanPos, cleanPos);
            start = Math.max(start, newPos);
          }

          return start;
        }; // Masking part, for masks if size of mask is above some value
        // we need to replace symbols instead of do nothing as like in format


        if (props.mask === true && isSizeIncreaseOperation && !isNoOperation) {
          var _start = getCursorPosition(eventValue);

          var _c4 = clean(eventValue.substr(_start))[0];
          _start = eventValue.indexOf(_c4, _start);
          eventValue = "".concat(eventValue.substr(0, _start)).concat(eventValue.substr(_start + 1));
        }

        var formattedValue = props.format(eventValue);

        if (append != null && // cursor at the end
        input.selectionStart === eventValue.length && !isNoOperation) {
          if (isSizeIncreaseOperation) {
            formattedValue = append(formattedValue);
          } else {
            // If after delete last char is special character and we use append
            // delete it too
            // was: "12-3|" backspace pressed, then should be "12|"
            if (clean(formattedValue.slice(-1)) === '') {
              formattedValue = formattedValue.slice(0, -1);
            }
          }
        }

        var replacedValue = replace ? replace(formattedValue) : formattedValue;

        if (userValue === replacedValue) {
          // if nothing changed for formatted value, just refresh so userValue will be used at render
          refresh();
        } else {
          props.onChange(replacedValue);
        }

        return function () {
          var start = getCursorPosition(formattedValue); // Visually improves working with masked values,
          // like cursor jumping over refused symbols
          // as an example date mask: was "5|1-24-3" then user pressed "6"
          // it becomes "56-|12-43" with this code, and "56|-12-43" without

          if (props.mask != null && (isSizeIncreaseOperation || isDeleleteButtonDown && !deleteWasNoOp)) {
            while (formattedValue[start] && clean(formattedValue[start]) === '') {
              start += 1;
            }
          }

          input.selectionStart = input.selectionEnd = start + (deleteWasNoOp ? 1 + charsToSkipAfterDelete : 0);
        };
      });
    }

    React.useEffect(function () {
      // until https://developer.mozilla.org/en-US/docs/Web/API/InputEvent/inputType will be supported
      // by all major browsers (now supported by: +chrome, +safari, ?edge, !firefox)
      // there is no way I found to distinguish in onChange
      // backspace or delete was called in some situations
      // firefox track https://bugzilla.mozilla.org/show_bug.cgi?id=1447239
      var handleKeyDown = function handleKeyDown(evt) {
        if (evt.code === 'Delete') {
          isDeleleteButtonDownRef.current = true;
        }
      };

      var handleKeyUp = function handleKeyUp(evt) {
        if (evt.code === 'Delete') {
          isDeleleteButtonDownRef.current = false;
        }
      };

      document.addEventListener('keydown', handleKeyDown);
      document.addEventListener('keyup', handleKeyUp);
      return function () {
        document.removeEventListener('keydown', handleKeyDown);
        document.removeEventListener('keyup', handleKeyUp);
      };
    }, []);
    return {
      value: valueRef.current != null ? valueRef.current[0] : userValue,
      onChange: onChange
    };
  };

  function getTextFieldAriaText(rawValue, utils) {
    // TODO: should `isValid` narrow `TDate | null` to `NonNullable<TDate>`?
    // Either we allow `TDate | null` to be valid and guard against calling `formatByString` with `null`.
    // Or we ensure `formatByString` is callable with `null`.
    return rawValue && utils.isValid(utils.date(rawValue)) ? "Choose date, selected date is ".concat(utils.format(utils.date(rawValue), 'fullDate')) : 'Choose date';
  }

  var getDisplayDate = function getDisplayDate(utils, value, inputFormat) {
    var date = utils.date(value);
    var isEmpty = value === null;

    if (isEmpty) {
      return '';
    }

    return utils.isValid(date) ? utils.formatByString( // TODO: should `isValid` narrow `TDate | null` to `NonNullable<TDate>`?
    // Either we allow `TDate | null` to be valid and guard against calling `formatByString` with `null`.
    // Or we ensure `formatByString` is callable with `null`.
    date, inputFormat) : '';
  };

  var MASK_USER_INPUT_SYMBOL = '_';
  var staticDateWith2DigitTokens = '2019-11-21T22:30:00.000';
  var staticDateWith1DigitTokens = '2019-01-01T09:00:00.000';

  function checkMaskIsValidForCurrentFormat(mask, format, acceptRegex, utils) {
    var formattedDateWith1Digit = utils.formatByString(utils.date(staticDateWith1DigitTokens), format);
    var inferredFormatPatternWith1Digits = formattedDateWith1Digit.replace(acceptRegex, MASK_USER_INPUT_SYMBOL);
    var inferredFormatPatternWith2Digits = utils.formatByString(utils.date(staticDateWith2DigitTokens), format).replace(acceptRegex, '_');
    var isMaskValid = inferredFormatPatternWith2Digits === mask && inferredFormatPatternWith1Digits === mask;

    if (!isMaskValid && utils.lib !== 'luxon' && process.env.NODE_ENV !== 'production') {
      console.warn("The mask \"".concat(mask, "\" you passed is not valid for the format used ").concat(format, ". Falling down to uncontrolled not-masked input."));
    }

    return isMaskValid;
  }

  var maskedDateFormatter = function maskedDateFormatter(mask, acceptRegexp) {
    return function (value) {
      return value.split('').map(function (char, i) {
        acceptRegexp.lastIndex = 0;

        if (i > mask.length - 1) {
          return '';
        }

        var maskChar = mask[i];
        var nextMaskChar = mask[i + 1];
        var acceptedChar = acceptRegexp.test(char) ? char : '';
        var formattedChar = maskChar === MASK_USER_INPUT_SYMBOL ? acceptedChar : maskChar + acceptedChar;

        if (i === value.length - 1 && nextMaskChar && nextMaskChar !== MASK_USER_INPUT_SYMBOL) {
          // when cursor at the end of mask part (e.g. month) prerender next symbol "21" -> "21/"
          return formattedChar ? formattedChar + nextMaskChar : '';
        }

        return formattedChar;
      }).join('');
    };
  };

  function useMaskedInput(_ref430) {
    var _ref430$acceptRegex = _ref430.acceptRegex,
        acceptRegex = _ref430$acceptRegex === void 0 ? /[\d]/gi : _ref430$acceptRegex,
        disabled = _ref430.disabled,
        disableMaskedInput = _ref430.disableMaskedInput,
        ignoreInvalidInputs = _ref430.ignoreInvalidInputs,
        inputFormat = _ref430.inputFormat,
        inputProps = _ref430.inputProps,
        label = _ref430.label,
        mask = _ref430.mask,
        onChange = _ref430.onChange,
        rawValue = _ref430.rawValue,
        readOnly = _ref430.readOnly,
        rifmFormatter = _ref430.rifmFormatter,
        TextFieldProps = _ref430.TextFieldProps,
        validationError = _ref430.validationError;
    var utils = useUtils();

    var _React__namespace$use145 = React__namespace.useState(false),
        _React__namespace$use146 = _slicedToArray(_React__namespace$use145, 2),
        isFocused = _React__namespace$use146[0],
        setIsFocused = _React__namespace$use146[1];

    var formatHelperText = utils.getFormatHelperText(inputFormat);
    var shouldUseMaskedInput = React__namespace.useMemo(function () {
      // formatting of dates is a quite slow thing, so do not make useless .format calls
      if (!mask || disableMaskedInput) {
        return false;
      }

      return checkMaskIsValidForCurrentFormat(mask, inputFormat, acceptRegex, utils);
    }, [acceptRegex, disableMaskedInput, inputFormat, mask, utils]);
    var formatter = React__namespace.useMemo(function () {
      return shouldUseMaskedInput && mask ? maskedDateFormatter(mask, acceptRegex) : function (st) {
        return st;
      };
    }, [acceptRegex, mask, shouldUseMaskedInput]); // TODO: Implement with controlled vs unctrolled `rawValue`

    var currentInputValue = getDisplayDate(utils, rawValue, inputFormat);

    var _React__namespace$use147 = React__namespace.useState(currentInputValue),
        _React__namespace$use148 = _slicedToArray(_React__namespace$use147, 2),
        innerInputValue = _React__namespace$use148[0],
        setInnerInputValue = _React__namespace$use148[1];

    var previousInputValueRef = React__namespace.useRef(currentInputValue);
    React__namespace.useEffect(function () {
      previousInputValueRef.current = currentInputValue;
    }, [currentInputValue]);
    var notTyping = !isFocused;
    var valueChanged = previousInputValueRef.current !== currentInputValue; // Update the input value only if the value changed outside of typing

    if (notTyping && valueChanged && (rawValue === null || utils.isValid(rawValue))) {
      if (currentInputValue !== innerInputValue) {
        setInnerInputValue(currentInputValue);
      }
    }

    var handleChange = function handleChange(text) {
      var finalString = text === '' || text === mask ? '' : text;
      setInnerInputValue(finalString);
      var date = finalString === null ? null : utils.parse(finalString, inputFormat);

      if (ignoreInvalidInputs && !utils.isValid(date)) {
        return;
      }

      onChange(date, finalString || undefined);
    };

    var rifmProps = useRifm({
      value: innerInputValue,
      onChange: handleChange,
      format: rifmFormatter || formatter
    });
    var inputStateArgs = shouldUseMaskedInput ? rifmProps : {
      value: innerInputValue,
      onChange: function onChange(event) {
        handleChange(event.currentTarget.value);
      }
    };
    return _extends$5({
      label: label,
      disabled: disabled,
      error: validationError,
      inputProps: _extends$5({}, inputStateArgs, {
        disabled: disabled,
        placeholder: formatHelperText,
        readOnly: readOnly,
        type: shouldUseMaskedInput ? 'tel' : 'text'
      }, inputProps, {
        onFocus: createDelegatedEventHandler(function () {
          setIsFocused(true);
        }, inputProps == null ? void 0 : inputProps.onFocus),
        onBlur: createDelegatedEventHandler(function () {
          setIsFocused(false);
        }, inputProps == null ? void 0 : inputProps.onBlur)
      })
    }, TextFieldProps);
  }

  var _excluded$4 = ["components", "disableOpenPicker", "getOpenDialogAriaText", "InputAdornmentProps", "InputProps", "inputRef", "openPicker", "OpenPickerButtonProps", "renderInput"];
  var KeyboardDateInput = /*#__PURE__*/React__namespace.forwardRef(function KeyboardDateInput(props, ref) {
    var _props$components14 = props.components,
        components = _props$components14 === void 0 ? {} : _props$components14,
        disableOpenPicker = props.disableOpenPicker,
        _props$getOpenDialogA = props.getOpenDialogAriaText,
        getOpenDialogAriaText = _props$getOpenDialogA === void 0 ? getTextFieldAriaText : _props$getOpenDialogA,
        InputAdornmentProps = props.InputAdornmentProps,
        InputProps = props.InputProps,
        inputRef = props.inputRef,
        openPicker = props.openPicker,
        OpenPickerButtonProps = props.OpenPickerButtonProps,
        renderInput = props.renderInput,
        other = _objectWithoutPropertiesLoose$2(props, _excluded$4);

    var utils = useUtils();
    var textFieldProps = useMaskedInput(other);
    var adornmentPosition = (InputAdornmentProps == null ? void 0 : InputAdornmentProps.position) || 'end';
    var OpenPickerIcon = components.OpenPickerIcon || CalendarIcon;
    return renderInput(_extends$5({
      ref: ref,
      inputRef: inputRef
    }, textFieldProps, {
      InputProps: _extends$5({}, InputProps, _defineProperty({}, "".concat(adornmentPosition, "Adornment"), disableOpenPicker ? undefined : /*#__PURE__*/jsxRuntime$1.jsx(InputAdornment$2, _extends$5({
        position: adornmentPosition
      }, InputAdornmentProps, {
        children: /*#__PURE__*/jsxRuntime$1.jsx(IconButton$2, _extends$5({
          edge: adornmentPosition,
          disabled: other.disabled || other.readOnly,
          "aria-label": getOpenDialogAriaText(other.rawValue, utils)
        }, OpenPickerButtonProps, {
          onClick: openPicker,
          children: /*#__PURE__*/jsxRuntime$1.jsx(OpenPickerIcon, {})
        }))
      }))))
    }));
  });
  process.env.NODE_ENV !== "production" ? KeyboardDateInput.propTypes = {
    acceptRegex: PropTypes.instanceOf(RegExp),
    getOpenDialogAriaText: PropTypes.func,
    mask: PropTypes.string,
    OpenPickerButtonProps: PropTypes.object,
    renderInput: PropTypes.func.isRequired,
    rifmFormatter: PropTypes.func
  } : void 0;

  function getOrientation() {
    if (typeof window === 'undefined') {
      return 'portrait';
    }

    if (window.screen && window.screen.orientation && window.screen.orientation.angle) {
      return Math.abs(window.screen.orientation.angle) === 90 ? 'landscape' : 'portrait';
    } // Support IOS safari


    if (window.orientation) {
      return Math.abs(Number(window.orientation)) === 90 ? 'landscape' : 'portrait';
    }

    return 'portrait';
  }

  function useIsLandscape(views, customOrientation) {
    var _React__namespace$use149 = React__namespace.useState(getOrientation),
        _React__namespace$use150 = _slicedToArray(_React__namespace$use149, 2),
        orientation = _React__namespace$use150[0],
        setOrientation = _React__namespace$use150[1];

    useEnhancedEffect$1(function () {
      var eventHandler = function eventHandler() {
        setOrientation(getOrientation());
      };

      window.addEventListener('orientationchange', eventHandler);
      return function () {
        window.removeEventListener('orientationchange', eventHandler);
      };
    }, []);

    if (arrayIncludes(views, ['hours', 'minutes', 'seconds'])) {
      // could not display 13:34:44 in landscape mode
      return false;
    }

    var orientationToUse = customOrientation || orientation;
    return orientationToUse === 'landscape';
  }

  var _excluded$3 = ["autoFocus", "className", "date", "DateInputProps", "isMobileKeyboardViewOpen", "onDateChange", "onViewChange", "openTo", "orientation", "showToolbar", "toggleMobileKeyboardView", "ToolbarComponent", "toolbarFormat", "toolbarPlaceholder", "toolbarTitle", "views"];
  var MobileKeyboardInputView = styled$1('div')({
    padding: '16px 24px'
  });
  var PickerRoot = styled$1('div', {
    skipSx: true
  })(function (_ref431) {
    var ownerState = _ref431.ownerState;
    return _extends$5({
      display: 'flex',
      flexDirection: 'column'
    }, ownerState.isLandscape && {
      flexDirection: 'row'
    });
  });
  var MobileKeyboardTextFieldProps = {
    fullWidth: true
  };

  var isDatePickerView = function isDatePickerView(view) {
    return view === 'year' || view === 'month' || view === 'day';
  };

  var isTimePickerView = function isTimePickerView(view) {
    return view === 'hours' || view === 'minutes' || view === 'seconds';
  };

  function Picker(props) {
    var autoFocus = props.autoFocus,
        date = props.date,
        DateInputProps = props.DateInputProps,
        isMobileKeyboardViewOpen = props.isMobileKeyboardViewOpen,
        onDateChange = props.onDateChange,
        onViewChange = props.onViewChange,
        openTo = props.openTo,
        orientation = props.orientation,
        showToolbar = props.showToolbar,
        toggleMobileKeyboardView = props.toggleMobileKeyboardView,
        _props$ToolbarCompone = props.ToolbarComponent,
        ToolbarComponent = _props$ToolbarCompone === void 0 ? function () {
      return null;
    } : _props$ToolbarCompone,
        toolbarFormat = props.toolbarFormat,
        toolbarPlaceholder = props.toolbarPlaceholder,
        toolbarTitle = props.toolbarTitle,
        views = props.views,
        other = _objectWithoutPropertiesLoose$2(props, _excluded$3);

    var isLandscape = useIsLandscape(views, orientation);
    var wrapperVariant = React__namespace.useContext(WrapperVariantContext);
    var toShowToolbar = typeof showToolbar === 'undefined' ? wrapperVariant !== 'desktop' : showToolbar;
    var handleDateChange = React__namespace.useCallback(function (newDate, selectionState) {
      onDateChange(newDate, wrapperVariant, selectionState);
    }, [onDateChange, wrapperVariant]);
    var handleViewChange = React__namespace.useCallback(function (newView) {
      if (isMobileKeyboardViewOpen) {
        toggleMobileKeyboardView();
      }

      if (onViewChange) {
        onViewChange(newView);
      }
    }, [isMobileKeyboardViewOpen, onViewChange, toggleMobileKeyboardView]);

    var _useViews2 = useViews({
      view: undefined,
      views: views,
      openTo: openTo,
      onChange: handleDateChange,
      onViewChange: handleViewChange
    }),
        openView = _useViews2.openView,
        nextView = _useViews2.nextView,
        previousView = _useViews2.previousView,
        setOpenView = _useViews2.setOpenView,
        handleChangeAndOpenNext = _useViews2.handleChangeAndOpenNext;

    return /*#__PURE__*/jsxRuntime$1.jsxs(PickerRoot, {
      ownerState: {
        isLandscape: isLandscape
      },
      children: [toShowToolbar && /*#__PURE__*/jsxRuntime$1.jsx(ToolbarComponent, _extends$5({}, other, {
        views: views,
        isLandscape: isLandscape,
        date: date,
        onChange: handleDateChange,
        setOpenView: setOpenView,
        openView: openView,
        toolbarTitle: toolbarTitle,
        toolbarFormat: toolbarFormat,
        toolbarPlaceholder: toolbarPlaceholder,
        isMobileKeyboardViewOpen: isMobileKeyboardViewOpen,
        toggleMobileKeyboardView: toggleMobileKeyboardView
      })), /*#__PURE__*/jsxRuntime$1.jsx(PickerView$1, {
        children: isMobileKeyboardViewOpen ? /*#__PURE__*/jsxRuntime$1.jsx(MobileKeyboardInputView, {
          children: /*#__PURE__*/jsxRuntime$1.jsx(KeyboardDateInput, _extends$5({}, DateInputProps, {
            ignoreInvalidInputs: true,
            disableOpenPicker: true,
            TextFieldProps: MobileKeyboardTextFieldProps
          }))
        }) : /*#__PURE__*/jsxRuntime$1.jsxs(React__namespace.Fragment, {
          children: [isDatePickerView(openView) && /*#__PURE__*/jsxRuntime$1.jsx(CalendarPicker$1, _extends$5({
            autoFocus: autoFocus,
            date: date,
            onViewChange: setOpenView,
            onChange: handleChangeAndOpenNext,
            view: openView // Unclear why the predicate `isDatePickerView` does not imply the casted type
            ,
            views: views.filter(isDatePickerView)
          }, other)), isTimePickerView(openView) && /*#__PURE__*/jsxRuntime$1.jsx(ClockPicker, _extends$5({}, other, {
            autoFocus: autoFocus,
            date: date,
            view: openView,
            onChange: handleChangeAndOpenNext,
            openNextView: function openNextView() {
              return setOpenView(nextView);
            },
            openPreviousView: function openPreviousView() {
              return setOpenView(previousView);
            },
            nextViewAvailable: !nextView,
            previousViewAvailable: !previousView || isDatePickerView(previousView),
            showViewSwitcher: wrapperVariant === 'desktop'
          }))]
        })
      })]
    });
  }

  function isSameDateOrTimeError(a, b) {
    return a === b;
  }

  function useValidation(props, validate) {
    var isSameError = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : isSameDateOrTimeError;
    var value = props.value,
        onError = props.onError;
    var utils = useUtils();
    var previousValidationErrorRef = React__namespace.useRef(null);
    var validationError = validate(utils, value, props);
    React__namespace.useEffect(function () {
      if (onError && !isSameError(validationError, previousValidationErrorRef.current)) {
        onError(validationError, value);
      }

      previousValidationErrorRef.current = validationError;
    }, [isSameError, onError, previousValidationErrorRef, validationError, value]);
    return validationError;
  }

  function useDateValidation(props) {
    return useValidation(props, validateDate$1, isSameDateOrTimeError);
  }

  function useOpenState(_ref432) {
    var open = _ref432.open,
        onOpen = _ref432.onOpen,
        onClose = _ref432.onClose;
    var isControllingOpenProp = React__namespace.useRef(typeof open === 'boolean').current;

    var _React__namespace$use151 = React__namespace.useState(false),
        _React__namespace$use152 = _slicedToArray(_React__namespace$use151, 2),
        openState = _React__namespace$use152[0],
        setIsOpenState = _React__namespace$use152[1]; // It is required to update inner state in useEffect in order to avoid situation when
    // Our component is not mounted yet, but `open` state is set to `true` (e.g. initially opened)


    React__namespace.useEffect(function () {
      if (isControllingOpenProp) {
        if (typeof open !== 'boolean') {
          throw new Error('You must not mix controlling and uncontrolled mode for `open` prop');
        }

        setIsOpenState(open);
      }
    }, [isControllingOpenProp, open]);
    var setIsOpen = React__namespace.useCallback(function (newIsOpen) {
      if (!isControllingOpenProp) {
        setIsOpenState(newIsOpen);
      }

      if (newIsOpen && onOpen) {
        onOpen();
      }

      if (!newIsOpen && onClose) {
        onClose();
      }
    }, [isControllingOpenProp, onOpen, onClose]);
    return {
      isOpen: openState,
      setIsOpen: setIsOpen
    };
  }

  function usePickerState(props, valueManager) {
    var disableCloseOnSelect = props.disableCloseOnSelect,
        onAccept = props.onAccept,
        onChange = props.onChange,
        value = props.value;
    var utils = useUtils();

    var _useOpenState = useOpenState(props),
        isOpen = _useOpenState.isOpen,
        setIsOpen = _useOpenState.setIsOpen;

    function initDraftableDate(date) {
      return {
        committed: date,
        draft: date
      };
    }

    var parsedDateValue = valueManager.parseInput(utils, value);

    var _React__namespace$use153 = React__namespace.useReducer(function (state, action) {
      switch (action.type) {
        case 'reset':
          return initDraftableDate(action.payload);

        case 'update':
          return _extends$5({}, state, {
            draft: action.payload
          });

        default:
          return state;
      }
    }, parsedDateValue, initDraftableDate),
        _React__namespace$use154 = _slicedToArray(_React__namespace$use153, 2),
        draftState = _React__namespace$use154[0],
        dispatch = _React__namespace$use154[1];

    if (!valueManager.areValuesEqual(utils, draftState.committed, parsedDateValue)) {
      dispatch({
        type: 'reset',
        payload: parsedDateValue
      });
    } // Mobile keyboard view is a special case.
    // When it's open picker should work like closed, cause we are just showing text field


    var _React__namespace$use155 = React__namespace.useState(false),
        _React__namespace$use156 = _slicedToArray(_React__namespace$use155, 2),
        isMobileKeyboardViewOpen = _React__namespace$use156[0],
        setMobileKeyboardViewOpen = _React__namespace$use156[1];

    var acceptDate = React__namespace.useCallback(function (acceptedDate, needClosePicker) {
      onChange(acceptedDate);

      if (needClosePicker) {
        setIsOpen(false);

        if (onAccept) {
          onAccept(acceptedDate);
        }
      }
    }, [onAccept, onChange, setIsOpen]);
    var wrapperProps = React__namespace.useMemo(function () {
      return {
        open: isOpen,
        onClear: function onClear() {
          return acceptDate(valueManager.emptyValue, true);
        },
        onAccept: function onAccept() {
          return acceptDate(draftState.draft, true);
        },
        onDismiss: function onDismiss() {
          return setIsOpen(false);
        },
        onSetToday: function onSetToday() {
          var now = utils.date();
          dispatch({
            type: 'update',
            payload: now
          });
          acceptDate(now, !disableCloseOnSelect);
        }
      };
    }, [acceptDate, disableCloseOnSelect, isOpen, utils, draftState.draft, setIsOpen, valueManager.emptyValue]);
    var pickerProps = React__namespace.useMemo(function () {
      return {
        date: draftState.draft,
        isMobileKeyboardViewOpen: isMobileKeyboardViewOpen,
        toggleMobileKeyboardView: function toggleMobileKeyboardView() {
          return setMobileKeyboardViewOpen(!isMobileKeyboardViewOpen);
        },
        onDateChange: function onDateChange(newDate, wrapperVariant) {
          var selectionState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'partial';
          dispatch({
            type: 'update',
            payload: newDate
          });

          if (selectionState === 'partial') {
            acceptDate(newDate, false);
          }

          if (selectionState === 'finish') {
            var shouldCloseOnSelect = !(disableCloseOnSelect != null ? disableCloseOnSelect : wrapperVariant === 'mobile');
            acceptDate(newDate, shouldCloseOnSelect);
          } // if selectionState === "shallow" do nothing (we already update the draft state)

        }
      };
    }, [acceptDate, disableCloseOnSelect, isMobileKeyboardViewOpen, draftState.draft]);
    var inputProps = React__namespace.useMemo(function () {
      return {
        onChange: onChange,
        open: isOpen,
        rawValue: value,
        openPicker: function openPicker() {
          return setIsOpen(true);
        }
      };
    }, [onChange, isOpen, value, setIsOpen]);
    var pickerState = {
      pickerProps: pickerProps,
      inputProps: inputProps,
      wrapperProps: wrapperProps
    };
    React__namespace.useDebugValue(pickerState, function () {
      return {
        MuiPickerState: {
          pickerDraft: draftState,
          other: pickerState
        }
      };
    });
    return pickerState;
  }

  var _excluded$2 = ["onChange", "PopperProps", "PaperProps", "ToolbarComponent", "TransitionComponent", "value"];
  var valueManager = {
    emptyValue: null,
    parseInput: parsePickerInputValue,
    areValuesEqual: function areValuesEqual(utils, a, b) {
      return utils.isEqual(a, b);
    }
  };
  /**
   *
   * Demos:
   *
   * - [Date Picker](https://mui.com/components/date-picker/)
   *
   * API:
   *
   * - [DesktopDatePicker API](https://mui.com/api/desktop-date-picker/)
   */

  var DesktopDatePicker = /*#__PURE__*/React__namespace.forwardRef(function DesktopDatePicker(inProps, ref) {
    // TODO: TDate needs to be instantiated at every usage.
    var props = useDatePickerDefaultizedProps(inProps, 'MuiDesktopDatePicker');
    var validationError = useDateValidation(props) !== null;

    var _usePickerState = usePickerState(props, valueManager),
        pickerProps = _usePickerState.pickerProps,
        inputProps = _usePickerState.inputProps,
        wrapperProps = _usePickerState.wrapperProps;

    var PopperProps = props.PopperProps,
        PaperProps = props.PaperProps,
        _props$ToolbarCompone2 = props.ToolbarComponent,
        ToolbarComponent = _props$ToolbarCompone2 === void 0 ? DatePickerToolbar$1 : _props$ToolbarCompone2,
        TransitionComponent = props.TransitionComponent,
        other = _objectWithoutPropertiesLoose$2(props, _excluded$2);

    var AllDateInputProps = _extends$5({}, inputProps, other, {
      ref: ref,
      validationError: validationError
    });

    return /*#__PURE__*/jsxRuntime$1.jsx(DesktopWrapper, _extends$5({}, wrapperProps, {
      DateInputProps: AllDateInputProps,
      KeyboardDateInputComponent: KeyboardDateInput,
      PopperProps: PopperProps,
      PaperProps: PaperProps,
      TransitionComponent: TransitionComponent,
      children: /*#__PURE__*/jsxRuntime$1.jsx(Picker, _extends$5({}, pickerProps, {
        autoFocus: true,
        toolbarTitle: props.label || props.toolbarTitle,
        ToolbarComponent: ToolbarComponent,
        DateInputProps: AllDateInputProps
      }, other))
    }));
  });
  process.env.NODE_ENV !== "production" ? void 0 : void 0;
  var BaseDesktopDatePicker = DesktopDatePicker;

  function toInteger(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
      return NaN;
    }

    var number = Number(dirtyNumber);

    if (isNaN(number)) {
      return number;
    }

    return number < 0 ? Math.ceil(number) : Math.floor(number);
  }

  function requiredArgs(required, args) {
    if (args.length < required) {
      throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
    }
  }
  /**
   * @name toDate
   * @category Common Helpers
   * @summary Convert the given argument to an instance of Date.
   *
   * @description
   * Convert the given argument to an instance of Date.
   *
   * If the argument is an instance of Date, the function returns its clone.
   *
   * If the argument is a number, it is treated as a timestamp.
   *
   * If the argument is none of the above, the function returns Invalid Date.
   *
   * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
   *
   * @param {Date|Number} argument - the value to convert
   * @returns {Date} the parsed date in the local time zone
   * @throws {TypeError} 1 argument required
   *
   * @example
   * // Clone the date:
   * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
   * //=> Tue Feb 11 2014 11:30:30
   *
   * @example
   * // Convert the timestamp to date:
   * const result = toDate(1392098430000)
   * //=> Tue Feb 11 2014 11:30:30
   */


  function toDate(argument) {
    requiredArgs(1, arguments);
    var argStr = Object.prototype.toString.call(argument); // Clone the date

    if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') {
      // Prevent the date to lose the milliseconds when passed to new Date() in IE10
      return new Date(argument.getTime());
    } else if (typeof argument === 'number' || argStr === '[object Number]') {
      return new Date(argument);
    } else {
      if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
        // eslint-disable-next-line no-console
        console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console

        console.warn(new Error().stack);
      }

      return new Date(NaN);
    }
  }
  /**
   * @name addDays
   * @category Day Helpers
   * @summary Add the specified number of days to the given date.
   *
   * @description
   * Add the specified number of days to the given date.
   *
   * ### v2.0.0 breaking changes:
   *
   * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
   *
   * @param {Date|Number} date - the date to be changed
   * @param {Number} amount - the amount of days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
   * @returns {Date} - the new date with the days added
   * @throws {TypeError} - 2 arguments required
   *
   * @example
   * // Add 10 days to 1 September 2014:
   * const result = addDays(new Date(2014, 8, 1), 10)
   * //=> Thu Sep 11 2014 00:00:00
   */


  function addDays(dirtyDate, dirtyAmount) {
    requiredArgs(2, arguments);
    var date = toDate(dirtyDate);
    var amount = toInteger(dirtyAmount);

    if (isNaN(amount)) {
      return new Date(NaN);
    }

    if (!amount) {
      // If 0 days, no-op to avoid changing times in the hour before end of DST
      return date;
    }

    date.setDate(date.getDate() + amount);
    return date;
  }
  /**
   * @name addMilliseconds
   * @category Millisecond Helpers
   * @summary Add the specified number of milliseconds to the given date.
   *
   * @description
   * Add the specified number of milliseconds to the given date.
   *
   * ### v2.0.0 breaking changes:
   *
   * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
   *
   * @param {Date|Number} date - the date to be changed
   * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
   * @returns {Date} the new date with the milliseconds added
   * @throws {TypeError} 2 arguments required
   *
   * @example
   * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
   * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
   * //=> Thu Jul 10 2014 12:45:30.750
   */


  function addMilliseconds(dirtyDate, dirtyAmount) {
    requiredArgs(2, arguments);
    var timestamp = toDate(dirtyDate).getTime();
    var amount = toInteger(dirtyAmount);
    return new Date(timestamp + amount);
  }
  /**
   * @name addSeconds
   * @category Second Helpers
   * @summary Add the specified number of seconds to the given date.
   *
   * @description
   * Add the specified number of seconds to the given date.
   *
   * ### v2.0.0 breaking changes:
   *
   * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
   *
   * @param {Date|Number} date - the date to be changed
   * @param {Number} amount - the amount of seconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
   * @returns {Date} the new date with the seconds added
   * @throws {TypeError} 2 arguments required
   *
   * @example
   * // Add 30 seconds to 10 July 2014 12:45:00:
   * const result = addSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
   * //=> Thu Jul 10 2014 12:45:30
   */


  function addSeconds(dirtyDate, dirtyAmount) {
    requiredArgs(2, arguments);
    var amount = toInteger(dirtyAmount);
    return addMilliseconds(dirtyDate, amount * 1000);
  }

  var MILLISECONDS_IN_MINUTE$2 = 60000;
  /**
   * @name addMinutes
   * @category Minute Helpers
   * @summary Add the specified number of minutes to the given date.
   *
   * @description
   * Add the specified number of minutes to the given date.
   *
   * ### v2.0.0 breaking changes:
   *
   * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
   *
   * @param {Date|Number} date - the date to be changed
   * @param {Number} amount - the amount of minutes to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
   * @returns {Date} the new date with the minutes added
   * @throws {TypeError} 2 arguments required
   *
   * @example
   * // Add 30 minutes to 10 July 2014 12:00:00:
   * const result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
   * //=> Thu Jul 10 2014 12:30:00
   */

  function addMinutes(dirtyDate, dirtyAmount) {
    requiredArgs(2, arguments);
    var amount = toInteger(dirtyAmount);
    return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_MINUTE$2);
  }

  var MILLISECONDS_IN_HOUR$2 = 3600000;
  /**
   * @name addHours
   * @category Hour Helpers
   * @summary Add the specified number of hours to the given date.
   *
   * @description
   * Add the specified number of hours to the given date.
   *
   * ### v2.0.0 breaking changes:
   *
   * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
   *
   * @param {Date|Number} date - the date to be changed
   * @param {Number} amount - the amount of hours to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
   * @returns {Date} the new date with the hours added
   * @throws {TypeError} 2 arguments required
   *
   * @example
   * // Add 2 hours to 10 July 2014 23:00:00:
   * const result = addHours(new Date(2014, 6, 10, 23, 0), 2)
   * //=> Fri Jul 11 2014 01:00:00
   */

  function addHours(dirtyDate, dirtyAmount) {
    requiredArgs(2, arguments);
    var amount = toInteger(dirtyAmount);
    return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_HOUR$2);
  }
  /**
   * @name addWeeks
   * @category Week Helpers
   * @summary Add the specified number of weeks to the given date.
   *
   * @description
   * Add the specified number of week to the given date.
   *
   * ### v2.0.0 breaking changes:
   *
   * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
   *
   * @param {Date|Number} date - the date to be changed
   * @param {Number} amount - the amount of weeks to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
   * @returns {Date} the new date with the weeks added
   * @throws {TypeError} 2 arguments required
   *
   * @example
   * // Add 4 weeks to 1 September 2014:
   * const result = addWeeks(new Date(2014, 8, 1), 4)
   * //=> Mon Sep 29 2014 00:00:00
   */


  function addWeeks(dirtyDate, dirtyAmount) {
    requiredArgs(2, arguments);
    var amount = toInteger(dirtyAmount);
    var days = amount * 7;
    return addDays(dirtyDate, days);
  }
  /**
   * @name addMonths
   * @category Month Helpers
   * @summary Add the specified number of months to the given date.
   *
   * @description
   * Add the specified number of months to the given date.
   *
   * ### v2.0.0 breaking changes:
   *
   * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
   *
   * @param {Date|Number} date - the date to be changed
   * @param {Number} amount - the amount of months to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
   * @returns {Date} the new date with the months added
   * @throws {TypeError} 2 arguments required
   *
   * @example
   * // Add 5 months to 1 September 2014:
   * const result = addMonths(new Date(2014, 8, 1), 5)
   * //=> Sun Feb 01 2015 00:00:00
   */


  function addMonths(dirtyDate, dirtyAmount) {
    requiredArgs(2, arguments);
    var date = toDate(dirtyDate);
    var amount = toInteger(dirtyAmount);

    if (isNaN(amount)) {
      return new Date(NaN);
    }

    if (!amount) {
      // If 0 months, no-op to avoid changing times in the hour before end of DST
      return date;
    }

    var dayOfMonth = date.getDate(); // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.

    var endOfDesiredMonth = new Date(date.getTime());
    endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
    var daysInMonth = endOfDesiredMonth.getDate();

    if (dayOfMonth >= daysInMonth) {
      // If we're already at the end of the month, then this is the correct date
      // and we're done.
      return endOfDesiredMonth;
    } else {
      // Otherwise, we now know that setting the original day-of-month value won't
      // cause an overflow, so set the desired day-of-month. Note that we can't
      // just set the date of `endOfDesiredMonth` because that object may have had
      // its time changed in the unusual case where where a DST transition was on
      // the last day of the month and its local time was in the hour skipped or
      // repeated next to a DST transition.  So we use `date` instead which is
      // guaranteed to still have the original time.
      date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
      return date;
    }
  }
  /**
   * @name addYears
   * @category Year Helpers
   * @summary Add the specified number of years to the given date.
   *
   * @description
   * Add the specified number of years to the given date.
   *
   * ### v2.0.0 breaking changes:
   *
   * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
   *
   * @param {Date|Number} date - the date to be changed
   * @param {Number} amount - the amount of years to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
   * @returns {Date} the new date with the years added
   * @throws {TypeError} 2 arguments required
   *
   * @example
   * // Add 5 years to 1 September 2014:
   * const result = addYears(new Date(2014, 8, 1), 5)
   * //=> Sun Sep 01 2019 00:00:00
   */


  function addYears(dirtyDate, dirtyAmount) {
    requiredArgs(2, arguments);
    var amount = toInteger(dirtyAmount);
    return addMonths(dirtyDate, amount * 12);
  }
  /**
   * @name differenceInCalendarYears
   * @category Year Helpers
   * @summary Get the number of calendar years between the given dates.
   *
   * @description
   * Get the number of calendar years between the given dates.
   *
   * ### v2.0.0 breaking changes:
   *
   * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
   *
   * @param {Date|Number} dateLeft - the later date
   * @param {Date|Number} dateRight - the earlier date
   * @returns {Number} the number of calendar years
   * @throws {TypeError} 2 arguments required
   *
   * @example
   * // How many calendar years are between 31 December 2013 and 11 February 2015?
   * const result = differenceInCalendarYears(
   *   new Date(2015, 1, 11),
   *   new Date(2013, 11, 31)
   * )
   * //=> 2
   */


  function differenceInCalendarYears(dirtyDateLeft, dirtyDateRight) {
    requiredArgs(2, arguments);
    var dateLeft = toDate(dirtyDateLeft);
    var dateRight = toDate(dirtyDateRight);
    return dateLeft.getFullYear() - dateRight.getFullYear();
  }
  /**
   * @name compareAsc
   * @category Common Helpers
   * @summary Compare the two dates and return -1, 0 or 1.
   *
   * @description
   * Compare the two dates and return 1 if the first date is after the second,
   * -1 if the first date is before the second or 0 if dates are equal.
   *
   * ### v2.0.0 breaking changes:
   *
   * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
   *
   * @param {Date|Number} dateLeft - the first date to compare
   * @param {Date|Number} dateRight - the second date to compare
   * @returns {Number} the result of the comparison
   * @throws {TypeError} 2 arguments required
   *
   * @example
   * // Compare 11 February 1987 and 10 July 1989:
   * const result = compareAsc(new Date(1987, 1, 11), new Date(1989, 6, 10))
   * //=> -1
   *
   * @example
   * // Sort the array of dates:
   * const result = [
   *   new Date(1995, 6, 2),
   *   new Date(1987, 1, 11),
   *   new Date(1989, 6, 10)
   * ].sort(compareAsc)
   * //=> [
   * //   Wed Feb 11 1987 00:00:00,
   * //   Mon Jul 10 1989 00:00:00,
   * //   Sun Jul 02 1995 00:00:00
   * // ]
   */


  function compareAsc(dirtyDateLeft, dirtyDateRight) {
    requiredArgs(2, arguments);
    var dateLeft = toDate(dirtyDateLeft);
    var dateRight = toDate(dirtyDateRight);
    var diff = dateLeft.getTime() - dateRight.getTime();

    if (diff < 0) {
      return -1;
    } else if (diff > 0) {
      return 1; // Return 0 if diff is 0; return NaN if diff is NaN
    } else {
      return diff;
    }
  }
  /**
   * @name differenceInYears
   * @category Year Helpers
   * @summary Get the number of full years between the given dates.
   *
   * @description
   * Get the number of full years between the given dates.
   *
   * ### v2.0.0 breaking changes:
   *
   * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
   *
   * @param {Date|Number} dateLeft - the later date
   * @param {Date|Number} dateRight - the earlier date
   * @returns {Number} the number of full years
   * @throws {TypeError} 2 arguments required
   *
   * @example
   * // How many full years are between 31 December 2013 and 11 February 2015?
   * const result = differenceInYears(new Date(2015, 1, 11), new Date(2013, 11, 31))
   * //=> 1
   */


  function differenceInYears(dirtyDateLeft, dirtyDateRight) {
    requiredArgs(2, arguments);
    var dateLeft = toDate(dirtyDateLeft);
    var dateRight = toDate(dirtyDateRight);
    var sign = compareAsc(dateLeft, dateRight);
    var difference = Math.abs(differenceInCalendarYears(dateLeft, dateRight)); // Set both dates to a valid leap year for accurate comparison when dealing
    // with leap days

    dateLeft.setFullYear(1584);
    dateRight.setFullYear(1584); // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
    // If so, result must be decreased by 1 in absolute value

    var isLastYearNotFull = compareAsc(dateLeft, dateRight) === -sign;
    var result = sign * (difference - Number(isLastYearNotFull)); // Prevent negative zero

    return result === 0 ? 0 : result;
  }
  /**
   * @name differenceInCalendarMonths
   * @category Month Helpers
   * @summary Get the number of calendar months between the given dates.
   *
   * @description
   * Get the number of calendar months between the given dates.
   *
   * ### v2.0.0 breaking changes:
   *
   * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
   *
   * @param {Date|Number} dateLeft - the later date
   * @param {Date|Number} dateRight - the earlier date
   * @returns {Number} the number of calendar months
   * @throws {TypeError} 2 arguments required
   *
   * @example
   * // How many calendar months are between 31 January 2014 and 1 September 2014?
   * var result = differenceInCalendarMonths(
   *   new Date(2014, 8, 1),
   *   new Date(2014, 0, 31)
   * )
   * //=> 8
   */


  function differenceInCalendarMonths(dirtyDateLeft, dirtyDateRight) {
    requiredArgs(2, arguments);
    var dateLeft = toDate(dirtyDateLeft);
    var dateRight = toDate(dirtyDateRight);
    var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
    var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
  }
  /**
   * @name endOfDay
   * @category Day Helpers
   * @summary Return the end of a day for the given date.
   *
   * @description
   * Return the end of a day for the given date.
   * The result will be in the local timezone.
   *
   * ### v2.0.0 breaking changes:
   *
   * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
   *
   * @param {Date|Number} date - the original date
   * @returns {Date} the end of a day
   * @throws {TypeError} 1 argument required
   *
   * @example
   * // The end of a day for 2 September 2014 11:55:00:
   * const result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
   * //=> Tue Sep 02 2014 23:59:59.999
   */


  function endOfDay(dirtyDate) {
    requiredArgs(1, arguments);
    var date = toDate(dirtyDate);
    date.setHours(23, 59, 59, 999);
    return date;
  }
  /**
   * @name endOfMonth
   * @category Month Helpers
   * @summary Return the end of a month for the given date.
   *
   * @description
   * Return the end of a month for the given date.
   * The result will be in the local timezone.
   *
   * ### v2.0.0 breaking changes:
   *
   * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
   *
   * @param {Date|Number} date - the original date
   * @returns {Date} the end of a month
   * @throws {TypeError} 1 argument required
   *
   * @example
   * // The end of a month for 2 September 2014 11:55:00:
   * const result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
   * //=> Tue Sep 30 2014 23:59:59.999
   */


  function endOfMonth(dirtyDate) {
    requiredArgs(1, arguments);
    var date = toDate(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(23, 59, 59, 999);
    return date;
  }
  /**
   * @name isLastDayOfMonth
   * @category Month Helpers
   * @summary Is the given date the last day of a month?
   *
   * @description
   * Is the given date the last day of a month?
   *
   * ### v2.0.0 breaking changes:
   *
   * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
   *
   * @param {Date|Number} date - the date to check
   * @returns {Boolean} the date is the last day of a month
   * @throws {TypeError} 1 argument required
   *
   * @example
   * // Is 28 February 2014 the last day of a month?
   * var result = isLastDayOfMonth(new Date(2014, 1, 28))
   * //=> true
   */


  function isLastDayOfMonth(dirtyDate) {
    requiredArgs(1, arguments);
    var date = toDate(dirtyDate);
    return endOfDay(date).getTime() === endOfMonth(date).getTime();
  }
  /**
   * @name differenceInMonths
   * @category Month Helpers
   * @summary Get the number of full months between the given dates.
   *
   * @description
   * Get the number of full months between the given dates using trunc as a default rounding method.
   *
   * ### v2.0.0 breaking changes:
   *
   * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
   *
   * @param {Date|Number} dateLeft - the later date
   * @param {Date|Number} dateRight - the earlier date
   * @returns {Number} the number of full months
   * @throws {TypeError} 2 arguments required
   *
   * @example
   * // How many full months are between 31 January 2014 and 1 September 2014?
   * const result = differenceInMonths(new Date(2014, 8, 1), new Date(2014, 0, 31))
   * //=> 7
   */


  function differenceInMonths(dirtyDateLeft, dirtyDateRight) {
    requiredArgs(2, arguments);
    var dateLeft = toDate(dirtyDateLeft);
    var dateRight = toDate(dirtyDateRight);
    var sign = compareAsc(dateLeft, dateRight);
    var difference = Math.abs(differenceInCalendarMonths(dateLeft, dateRight));
    var result; // Check for the difference of less than month

    if (difference < 1) {
      result = 0;
    } else {
      if (dateLeft.getMonth() === 1 && dateLeft.getDate() > 27) {
        // This will check if the date is end of Feb and assign a higher end of month date
        // to compare it with Jan
        dateLeft.setDate(30);
      }

      dateLeft.setMonth(dateLeft.getMonth() - sign * difference); // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
      // If so, result must be decreased by 1 in absolute value

      var isLastMonthNotFull = compareAsc(dateLeft, dateRight) === -sign; // Check for cases of one full calendar month

      if (isLastDayOfMonth(toDate(dirtyDateLeft)) && difference === 1 && compareAsc(dirtyDateLeft, dateRight) === 1) {
        isLastMonthNotFull = false;
      }

      result = sign * (difference - Number(isLastMonthNotFull));
    } // Prevent negative zero


    return result === 0 ? 0 : result;
  }

  var roundingMap = {
    ceil: Math.ceil,
    round: Math.round,
    floor: Math.floor,
    trunc: function trunc(value) {
      return value < 0 ? Math.ceil(value) : Math.floor(value);
    } // Math.trunc is not supported by IE

  };
  var defaultRoundingMethod = 'trunc';

  function getRoundingMethod(method) {
    return method ? roundingMap[method] : roundingMap[defaultRoundingMethod];
  }
  /**
   * @name differenceInQuarters
   * @category Quarter Helpers
   * @summary Get the number of quarters between the given dates.
   *
   * @description
   * Get the number of quarters between the given dates.
   *
   * ### v2.0.0 breaking changes:
   *
   * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
   *
   * @param {Date|Number} dateLeft - the later date
   * @param {Date|Number} dateRight - the earlier date
   * @param {Object} [options] - an object with options.
   * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
   * @returns {Number} the number of full quarters
   * @throws {TypeError} 2 arguments required
   *
   * @example
   * // How many full quarters are between 31 December 2013 and 2 July 2014?
   * const result = differenceInQuarters(new Date(2014, 6, 2), new Date(2013, 11, 31))
   * //=> 2
   */


  function differenceInQuarters(dateLeft, dateRight, options) {
    requiredArgs(2, arguments);
    var diff = differenceInMonths(dateLeft, dateRight) / 3;
    return getRoundingMethod(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
  }
  /**
   * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
   * They usually appear for dates that denote time before the timezones were introduced
   * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
   * and GMT+01:00:00 after that date)
   *
   * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
   * which would lead to incorrect calculations.
   *
   * This function returns the timezone offset in milliseconds that takes seconds in account.
   */


  function getTimezoneOffsetInMilliseconds(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
  }
  /**
   * @name startOfDay
   * @category Day Helpers
   * @summary Return the start of a day for the given date.
   *
   * @description
   * Return the start of a day for the given date.
   * The result will be in the local timezone.
   *
   * ### v2.0.0 breaking changes:
   *
   * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
   *
   * @param {Date|Number} date - the original date
   * @returns {Date} the start of a day
   * @throws {TypeError} 1 argument required
   *
   * @example
   * // The start of a day for 2 September 2014 11:55:00:
   * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
   * //=> Tue Sep 02 2014 00:00:00
   */


  function startOfDay(dirtyDate) {
    requiredArgs(1, arguments);
    var date = toDate(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  var MILLISECONDS_IN_DAY$1 = 86400000;
  /**
   * @name differenceInCalendarDays
   * @category Day Helpers
   * @summary Get the number of calendar days between the given dates.
   *
   * @description
   * Get the number of calendar days between the given dates. This means that the times are removed
   * from the dates and then the difference in days is calculated.
   *
   * ### v2.0.0 breaking changes:
   *
   * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
   *
   * @param {Date|Number} dateLeft - the later date
   * @param {Date|Number} dateRight - the earlier date
   * @returns {Number} the number of calendar days
   * @throws {TypeError} 2 arguments required
   *
   * @example
   * // How many calendar days are between
   * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
   * const result = differenceInCalendarDays(
   *   new Date(2012, 6, 2, 0, 0),
   *   new Date(2011, 6, 2, 23, 0)
   * )
   * //=> 366
   * // How many calendar days are between
   * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
   * const result = differenceInCalendarDays(
   *   new Date(2011, 6, 3, 0, 1),
   *   new Date(2011, 6, 2, 23, 59)
   * )
   * //=> 1
   */

  function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
    requiredArgs(2, arguments);
    var startOfDayLeft = startOfDay(dirtyDateLeft);
    var startOfDayRight = startOfDay(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - getTimezoneOffsetInMilliseconds(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - getTimezoneOffsetInMilliseconds(startOfDayRight); // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)

    return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY$1);
  } // for accurate equality comparisons of UTC timestamps that end up
  // having the same representation in local time, e.g. one hour before
  // DST ends vs. the instant that DST ends.


  function compareLocalAsc(dateLeft, dateRight) {
    var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();

    if (diff < 0) {
      return -1;
    } else if (diff > 0) {
      return 1; // Return 0 if diff is 0; return NaN if diff is NaN
    } else {
      return diff;
    }
  }
  /**
   * @name differenceInDays
   * @category Day Helpers
   * @summary Get the number of full days between the given dates.
   *
   * @description
   * Get the number of full day periods between two dates. Fractional days are
   * truncated towards zero.
   *
   * One "full day" is the distance between a local time in one day to the same
   * local time on the next or previous day. A full day can sometimes be less than
   * or more than 24 hours if a daylight savings change happens between two dates.
   *
   * To ignore DST and only measure exact 24-hour periods, use this instead:
   * `Math.floor(differenceInHours(dateLeft, dateRight)/24)|0`.
   *
   *
   * ### v2.0.0 breaking changes:
   *
   * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
   *
   * @param {Date|Number} dateLeft - the later date
   * @param {Date|Number} dateRight - the earlier date
   * @returns {Number} the number of full days according to the local timezone
   * @throws {TypeError} 2 arguments required
   *
   * @example
   * // How many full days are between
   * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
   * const result = differenceInDays(
   *   new Date(2012, 6, 2, 0, 0),
   *   new Date(2011, 6, 2, 23, 0)
   * )
   * //=> 365
   * // How many full days are between
   * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
   * const result = differenceInDays(
   *   new Date(2011, 6, 3, 0, 1),
   *   new Date(2011, 6, 2, 23, 59)
   * )
   * //=> 0
   * // How many full days are between
   * // 1 March 2020 0:00 and 1 June 2020 0:00 ?
   * // Note: because local time is used, the
   * // result will always be 92 days, even in
   * // time zones where DST starts and the
   * // period has only 92*24-1 hours.
   * const result = differenceInDays(
   *   new Date(2020, 5, 1),
   *   new Date(2020, 2, 1)
   * )
  //=> 92
   */


  function differenceInDays(dirtyDateLeft, dirtyDateRight) {
    requiredArgs(2, arguments);
    var dateLeft = toDate(dirtyDateLeft);
    var dateRight = toDate(dirtyDateRight);
    var sign = compareLocalAsc(dateLeft, dateRight);
    var difference = Math.abs(differenceInCalendarDays(dateLeft, dateRight));
    dateLeft.setDate(dateLeft.getDate() - sign * difference); // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value

    var isLastDayNotFull = Number(compareLocalAsc(dateLeft, dateRight) === -sign);
    var result = sign * (difference - isLastDayNotFull); // Prevent negative zero

    return result === 0 ? 0 : result;
  }
  /**
   * @name differenceInWeeks
   * @category Week Helpers
   * @summary Get the number of full weeks between the given dates.
   *
   * @description
   * Get the number of full weeks between two dates. Fractional weeks are
   * truncated towards zero by default.
   *
   * One "full week" is the distance between a local time in one day to the same
   * local time 7 days earlier or later. A full week can sometimes be less than
   * or more than 7*24 hours if a daylight savings change happens between two dates.
   *
   * To ignore DST and only measure exact 7*24-hour periods, use this instead:
   * `Math.floor(differenceInHours(dateLeft, dateRight)/(7*24))|0`.
   *
   *
   * ### v2.0.0 breaking changes:
   *
   * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
   *
   * @param {Date|Number} dateLeft - the later date
   * @param {Date|Number} dateRight - the earlier date
   * @param {Object} [options] - an object with options.
   * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
   * @returns {Number} the number of full weeks
   * @throws {TypeError} 2 arguments required
   *
   * @example
   * // How many full weeks are between 5 July 2014 and 20 July 2014?
   * const result = differenceInWeeks(new Date(2014, 6, 20), new Date(2014, 6, 5))
   * //=> 2
   *
   * // How many full weeks are between
   * // 1 March 2020 0:00 and 6 June 2020 0:00 ?
   * // Note: because local time is used, the
   * // result will always be 8 weeks (54 days),
   * // even if DST starts and the period has
   * // only 54*24-1 hours.
   * const result = differenceInWeeks(
   *   new Date(2020, 5, 1),
   *   new Date(2020, 2, 6)
   * )
   * //=> 8
   */


  function differenceInWeeks(dateLeft, dateRight, options) {
    requiredArgs(2, arguments);
    var diff = differenceInDays(dateLeft, dateRight) / 7;
    return getRoundingMethod(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
  }
  /**
   * Days in 1 week.
   *
   * @name daysInWeek
   * @constant
   * @type {number}
   * @default
   */

  /**
   * Milliseconds in 1 minute
   *
   * @name millisecondsInMinute
   * @constant
   * @type {number}
   * @default
   */


  var millisecondsInMinute = 60000;
  /**
   * Milliseconds in 1 hour
   *
   * @name millisecondsInHour
   * @constant
   * @type {number}
   * @default
   */

  var millisecondsInHour = 3600000;
  /**
   * @name differenceInMilliseconds
   * @category Millisecond Helpers
   * @summary Get the number of milliseconds between the given dates.
   *
   * @description
   * Get the number of milliseconds between the given dates.
   *
   * ### v2.0.0 breaking changes:
   *
   * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
   *
   * @param {Date|Number} dateLeft - the later date
   * @param {Date|Number} dateRight - the earlier date
   * @returns {Number} the number of milliseconds
   * @throws {TypeError} 2 arguments required
   *
   * @example
   * // How many milliseconds are between
   * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
   * const result = differenceInMilliseconds(
   *   new Date(2014, 6, 2, 12, 30, 21, 700),
   *   new Date(2014, 6, 2, 12, 30, 20, 600)
   * )
   * //=> 1100
   */

  function differenceInMilliseconds(dateLeft, dateRight) {
    requiredArgs(2, arguments);
    return toDate(dateLeft).getTime() - toDate(dateRight).getTime();
  }
  /**
   * @name differenceInHours
   * @category Hour Helpers
   * @summary Get the number of hours between the given dates.
   *
   * @description
   * Get the number of hours between the given dates.
   *
   * ### v2.0.0 breaking changes:
   *
   * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
   *
   * @param {Date|Number} dateLeft - the later date
   * @param {Date|Number} dateRight - the earlier date
   * @param {Object} [options] - an object with options.
   * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
   * @returns {Number} the number of hours
   * @throws {TypeError} 2 arguments required
   *
   * @example
   * // How many hours are between 2 July 2014 06:50:00 and 2 July 2014 19:00:00?
   * const result = differenceInHours(
   *   new Date(2014, 6, 2, 19, 0),
   *   new Date(2014, 6, 2, 6, 50)
   * )
   * //=> 12
   */


  function differenceInHours(dateLeft, dateRight, options) {
    requiredArgs(2, arguments);
    var diff = differenceInMilliseconds(dateLeft, dateRight) / millisecondsInHour;
    return getRoundingMethod(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
  }
  /**
   * @name differenceInMinutes
   * @category Minute Helpers
   * @summary Get the number of minutes between the given dates.
   *
   * @description
   * Get the signed number of full (rounded towards 0) minutes between the given dates.
   *
   * ### v2.0.0 breaking changes:
   *
   * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
   *
   * @param {Date|Number} dateLeft - the later date
   * @param {Date|Number} dateRight - the earlier date
   * @param {Object} [options] - an object with options.
   * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
   * @returns {Number} the number of minutes
   * @throws {TypeError} 2 arguments required
   *
   * @example
   * // How many minutes are between 2 July 2014 12:07:59 and 2 July 2014 12:20:00?
   * const result = differenceInMinutes(
   *   new Date(2014, 6, 2, 12, 20, 0),
   *   new Date(2014, 6, 2, 12, 7, 59)
   * )
   * //=> 12
   *
   * @example
   * // How many minutes are between 10:01:59 and 10:00:00
   * const result = differenceInMinutes(
   *   new Date(2000, 0, 1, 10, 0, 0),
   *   new Date(2000, 0, 1, 10, 1, 59)
   * )
   * //=> -1
   */


  function differenceInMinutes(dateLeft, dateRight, options) {
    requiredArgs(2, arguments);
    var diff = differenceInMilliseconds(dateLeft, dateRight) / millisecondsInMinute;
    return getRoundingMethod(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
  }
  /**
   * @name differenceInSeconds
   * @category Second Helpers
   * @summary Get the number of seconds between the given dates.
   *
   * @description
   * Get the number of seconds between the given dates.
   *
   * ### v2.0.0 breaking changes:
   *
   * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
   *
   * @param {Date|Number} dateLeft - the later date
   * @param {Date|Number} dateRight - the earlier date
   * @param {Object} [options] - an object with options.
   * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
   * @returns {Number} the number of seconds
   * @throws {TypeError} 2 arguments required
   *
   * @example
   * // How many seconds are between
   * // 2 July 2014 12:30:07.999 and 2 July 2014 12:30:20.000?
   * const result = differenceInSeconds(
   *   new Date(2014, 6, 2, 12, 30, 20, 0),
   *   new Date(2014, 6, 2, 12, 30, 7, 999)
   * )
   * //=> 12
   */


  function differenceInSeconds(dateLeft, dateRight, options) {
    requiredArgs(2, arguments);
    var diff = differenceInMilliseconds(dateLeft, dateRight) / 1000;
    return getRoundingMethod(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
  }
  /**
   * @name eachDayOfInterval
   * @category Interval Helpers
   * @summary Return the array of dates within the specified time interval.
   *
   * @description
   * Return the array of dates within the specified time interval.
   *
   * ### v2.0.0 breaking changes:
   *
   * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
   *
   * - The function was renamed from `eachDay` to `eachDayOfInterval`.
   *   This change was made to mirror the use of the word "interval" in standard ISO 8601:2004 terminology:
   *
   *   ```
   *   2.1.3
   *   time interval
   *   part of the time axis limited by two instants
   *   ```
   *
   *   Also, this function now accepts an object with `start` and `end` properties
   *   instead of two arguments as an interval.
   *   This function now throws `RangeError` if the start of the interval is after its end
   *   or if any date in the interval is `Invalid Date`.
   *
   *   ```javascript
   *   // Before v2.0.0
   *
   *   eachDay(new Date(2014, 0, 10), new Date(2014, 0, 20))
   *
   *   // v2.0.0 onward
   *
   *   eachDayOfInterval(
   *     { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) }
   *   )
   *   ```
   *
   * @param {Interval} interval - the interval. See [Interval]{@link https://date-fns.org/docs/Interval}
   * @param {Object} [options] - an object with options.
   * @param {Number} [options.step=1] - the step to increment by. The value should be more than 1.
   * @returns {Date[]} the array with starts of days from the day of the interval start to the day of the interval end
   * @throws {TypeError} 1 argument required
   * @throws {RangeError} `options.step` must be a number greater than 1
   * @throws {RangeError} The start of an interval cannot be after its end
   * @throws {RangeError} Date in interval cannot be `Invalid Date`
   *
   * @example
   * // Each day between 6 October 2014 and 10 October 2014:
   * const result = eachDayOfInterval({
   *   start: new Date(2014, 9, 6),
   *   end: new Date(2014, 9, 10)
   * })
   * //=> [
   * //   Mon Oct 06 2014 00:00:00,
   * //   Tue Oct 07 2014 00:00:00,
   * //   Wed Oct 08 2014 00:00:00,
   * //   Thu Oct 09 2014 00:00:00,
   * //   Fri Oct 10 2014 00:00:00
   * // ]
   */


  function eachDayOfInterval(dirtyInterval, options) {
    requiredArgs(1, arguments);
    var interval = dirtyInterval || {};
    var startDate = toDate(interval.start);
    var endDate = toDate(interval.end);
    var endTime = endDate.getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`

    if (!(startDate.getTime() <= endTime)) {
      throw new RangeError('Invalid interval');
    }

    var dates = [];
    var currentDate = startDate;
    currentDate.setHours(0, 0, 0, 0);
    var step = options && 'step' in options ? Number(options.step) : 1;
    if (step < 1 || isNaN(step)) throw new RangeError('`options.step` must be a number greater than 1');

    while (currentDate.getTime() <= endTime) {
      dates.push(toDate(currentDate));
      currentDate.setDate(currentDate.getDate() + step);
      currentDate.setHours(0, 0, 0, 0);
    }

    return dates;
  }
  /**
   * @name endOfWeek
   * @category Week Helpers
   * @summary Return the end of a week for the given date.
   *
   * @description
   * Return the end of a week for the given date.
   * The result will be in the local timezone.
   *
   * ### v2.0.0 breaking changes:
   *
   * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
   *
   * @param {Date|Number} date - the original date
   * @param {Object} [options] - an object with options.
   * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
   * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
   * @returns {Date} the end of a week
   * @throws {TypeError} 1 argument required
   * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
   *
   * @example
   * // The end of a week for 2 September 2014 11:55:00:
   * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
   * //=> Sat Sep 06 2014 23:59:59.999
   *
   * @example
   * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
   * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
   * //=> Sun Sep 07 2014 23:59:59.999
   */


  function endOfWeek(dirtyDate, dirtyOptions) {
    requiredArgs(1, arguments);
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
      throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    }

    var date = toDate(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    date.setDate(date.getDate() + diff);
    date.setHours(23, 59, 59, 999);
    return date;
  }
  /**
   * @name endOfYear
   * @category Year Helpers
   * @summary Return the end of a year for the given date.
   *
   * @description
   * Return the end of a year for the given date.
   * The result will be in the local timezone.
   *
   * ### v2.0.0 breaking changes:
   *
   * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
   *
   * @param {Date|Number} date - the original date
   * @returns {Date} the end of a year
   * @throws {TypeError} 1 argument required
   *
   * @example
   * // The end of a year for 2 September 2014 11:55:00:
   * var result = endOfYear(new Date(2014, 8, 2, 11, 55, 00))
   * //=> Wed Dec 31 2014 23:59:59.999
   */


  function endOfYear(dirtyDate) {
    requiredArgs(1, arguments);
    var date = toDate(dirtyDate);
    var year = date.getFullYear();
    date.setFullYear(year + 1, 0, 0);
    date.setHours(23, 59, 59, 999);
    return date;
  }
  /**
   * @name isDate
   * @category Common Helpers
   * @summary Is the given value a date?
   *
   * @description
   * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
   *
   * ### v2.0.0 breaking changes:
   *
   * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
   *
   * @param {*} value - the value to check
   * @returns {boolean} true if the given value is a date
   * @throws {TypeError} 1 arguments required
   *
   * @example
   * // For a valid date:
   * const result = isDate(new Date())
   * //=> true
   *
   * @example
   * // For an invalid date:
   * const result = isDate(new Date(NaN))
   * //=> true
   *
   * @example
   * // For some value:
   * const result = isDate('2014-02-31')
   * //=> false
   *
   * @example
   * // For an object:
   * const result = isDate({})
   * //=> false
   */


  function isDate(value) {
    requiredArgs(1, arguments);
    return value instanceof Date || typeof value === 'object' && Object.prototype.toString.call(value) === '[object Date]';
  }
  /**
   * @name isValid
   * @category Common Helpers
   * @summary Is the given date valid?
   *
   * @description
   * Returns false if argument is Invalid Date and true otherwise.
   * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
   * Invalid Date is a Date, whose time value is NaN.
   *
   * Time value of Date: http://es5.github.io/#x15.9.1.1
   *
   * ### v2.0.0 breaking changes:
   *
   * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
   *
   * - Now `isValid` doesn't throw an exception
   *   if the first argument is not an instance of Date.
   *   Instead, argument is converted beforehand using `toDate`.
   *
   *   Examples:
   *
   *   | `isValid` argument        | Before v2.0.0 | v2.0.0 onward |
   *   |---------------------------|---------------|---------------|
   *   | `new Date()`              | `true`        | `true`        |
   *   | `new Date('2016-01-01')`  | `true`        | `true`        |
   *   | `new Date('')`            | `false`       | `false`       |
   *   | `new Date(1488370835081)` | `true`        | `true`        |
   *   | `new Date(NaN)`           | `false`       | `false`       |
   *   | `'2016-01-01'`            | `TypeError`   | `false`       |
   *   | `''`                      | `TypeError`   | `false`       |
   *   | `1488370835081`           | `TypeError`   | `true`        |
   *   | `NaN`                     | `TypeError`   | `false`       |
   *
   *   We introduce this change to make *date-fns* consistent with ECMAScript behavior
   *   that try to coerce arguments to the expected type
   *   (which is also the case with other *date-fns* functions).
   *
   * @param {*} date - the date to check
   * @returns {Boolean} the date is valid
   * @throws {TypeError} 1 argument required
   *
   * @example
   * // For the valid date:
   * const result = isValid(new Date(2014, 1, 31))
   * //=> true
   *
   * @example
   * // For the value, convertable into a date:
   * const result = isValid(1393804800000)
   * //=> true
   *
   * @example
   * // For the invalid date:
   * const result = isValid(new Date(''))
   * //=> false
   */


  function isValid(dirtyDate) {
    requiredArgs(1, arguments);

    if (!isDate(dirtyDate) && typeof dirtyDate !== 'number') {
      return false;
    }

    var date = toDate(dirtyDate);
    return !isNaN(Number(date));
  }

  var formatDistanceLocale = {
    lessThanXSeconds: {
      one: 'less than a second',
      other: 'less than {{count}} seconds'
    },
    xSeconds: {
      one: '1 second',
      other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
      one: 'less than a minute',
      other: 'less than {{count}} minutes'
    },
    xMinutes: {
      one: '1 minute',
      other: '{{count}} minutes'
    },
    aboutXHours: {
      one: 'about 1 hour',
      other: 'about {{count}} hours'
    },
    xHours: {
      one: '1 hour',
      other: '{{count}} hours'
    },
    xDays: {
      one: '1 day',
      other: '{{count}} days'
    },
    aboutXWeeks: {
      one: 'about 1 week',
      other: 'about {{count}} weeks'
    },
    xWeeks: {
      one: '1 week',
      other: '{{count}} weeks'
    },
    aboutXMonths: {
      one: 'about 1 month',
      other: 'about {{count}} months'
    },
    xMonths: {
      one: '1 month',
      other: '{{count}} months'
    },
    aboutXYears: {
      one: 'about 1 year',
      other: 'about {{count}} years'
    },
    xYears: {
      one: '1 year',
      other: '{{count}} years'
    },
    overXYears: {
      one: 'over 1 year',
      other: 'over {{count}} years'
    },
    almostXYears: {
      one: 'almost 1 year',
      other: 'almost {{count}} years'
    }
  };

  var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];

    if (typeof tokenValue === 'string') {
      result = tokenValue;
    } else if (count === 1) {
      result = tokenValue.one;
    } else {
      result = tokenValue.other.replace('{{count}}', count.toString());
    }

    if (options !== null && options !== void 0 && options.addSuffix) {
      if (options.comparison && options.comparison > 0) {
        return 'in ' + result;
      } else {
        return result + ' ago';
      }
    }

    return result;
  };

  var formatDistance$1 = formatDistance;

  function buildFormatLongFn(args) {
    return function () {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}; // TODO: Remove String()

      var width = options.width ? String(options.width) : args.defaultWidth;
      var format = args.formats[width] || args.formats[args.defaultWidth];
      return format;
    };
  }

  var dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
  };
  var timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
  };
  var dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
  };
  var formatLong = {
    date: buildFormatLongFn({
      formats: dateFormats,
      defaultWidth: 'full'
    }),
    time: buildFormatLongFn({
      formats: timeFormats,
      defaultWidth: 'full'
    }),
    dateTime: buildFormatLongFn({
      formats: dateTimeFormats,
      defaultWidth: 'full'
    })
  };
  var formatLong$1 = formatLong;
  var formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
  };

  var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
  };

  var formatRelative$1 = formatRelative;

  function buildLocalizeFn(args) {
    return function (dirtyIndex, dirtyOptions) {
      var options = dirtyOptions || {};
      var context = options.context ? String(options.context) : 'standalone';
      var valuesArray;

      if (context === 'formatting' && args.formattingValues) {
        var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
        var width = options.width ? String(options.width) : defaultWidth;
        valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
      } else {
        var _defaultWidth = args.defaultWidth;

        var _width = options.width ? String(options.width) : args.defaultWidth;

        valuesArray = args.values[_width] || args.values[_defaultWidth];
      }

      var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex; // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!

      return valuesArray[index];
    };
  }

  var eraValues = {
    narrow: ['B', 'A'],
    abbreviated: ['BC', 'AD'],
    wide: ['Before Christ', 'Anno Domini']
  };
  var quarterValues = {
    narrow: ['1', '2', '3', '4'],
    abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
    wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
  }; // Note: in English, the names of days of the week and months are capitalized.
  // If you are making a new locale based on this one, check if the same is true for the language you're working on.
  // Generally, formatted dates should look like they are in the middle of a sentence,
  // e.g. in Spanish language the weekdays and months should be in the lowercase.

  var monthValues = {
    narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
    abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
  };
  var dayValues = {
    narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
    short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
    abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
  };
  var dayPeriodValues = {
    narrow: {
      am: 'a',
      pm: 'p',
      midnight: 'mi',
      noon: 'n',
      morning: 'morning',
      afternoon: 'afternoon',
      evening: 'evening',
      night: 'night'
    },
    abbreviated: {
      am: 'AM',
      pm: 'PM',
      midnight: 'midnight',
      noon: 'noon',
      morning: 'morning',
      afternoon: 'afternoon',
      evening: 'evening',
      night: 'night'
    },
    wide: {
      am: 'a.m.',
      pm: 'p.m.',
      midnight: 'midnight',
      noon: 'noon',
      morning: 'morning',
      afternoon: 'afternoon',
      evening: 'evening',
      night: 'night'
    }
  };
  var formattingDayPeriodValues = {
    narrow: {
      am: 'a',
      pm: 'p',
      midnight: 'mi',
      noon: 'n',
      morning: 'in the morning',
      afternoon: 'in the afternoon',
      evening: 'in the evening',
      night: 'at night'
    },
    abbreviated: {
      am: 'AM',
      pm: 'PM',
      midnight: 'midnight',
      noon: 'noon',
      morning: 'in the morning',
      afternoon: 'in the afternoon',
      evening: 'in the evening',
      night: 'at night'
    },
    wide: {
      am: 'a.m.',
      pm: 'p.m.',
      midnight: 'midnight',
      noon: 'noon',
      morning: 'in the morning',
      afternoon: 'in the afternoon',
      evening: 'in the evening',
      night: 'at night'
    }
  };

  var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.

    var rem100 = number % 100;

    if (rem100 > 20 || rem100 < 10) {
      switch (rem100 % 10) {
        case 1:
          return number + 'st';

        case 2:
          return number + 'nd';

        case 3:
          return number + 'rd';
      }
    }

    return number + 'th';
  };

  var localize = {
    ordinalNumber: ordinalNumber,
    era: buildLocalizeFn({
      values: eraValues,
      defaultWidth: 'wide'
    }),
    quarter: buildLocalizeFn({
      values: quarterValues,
      defaultWidth: 'wide',
      argumentCallback: function argumentCallback(quarter) {
        return quarter - 1;
      }
    }),
    month: buildLocalizeFn({
      values: monthValues,
      defaultWidth: 'wide'
    }),
    day: buildLocalizeFn({
      values: dayValues,
      defaultWidth: 'wide'
    }),
    dayPeriod: buildLocalizeFn({
      values: dayPeriodValues,
      defaultWidth: 'wide',
      formattingValues: formattingDayPeriodValues,
      defaultFormattingWidth: 'wide'
    })
  };
  var localize$1 = localize;

  function buildMatchFn(args) {
    return function (string) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var width = options.width;
      var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
      var matchResult = string.match(matchPattern);

      if (!matchResult) {
        return null;
      }

      var matchedString = matchResult[0];
      var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
      var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
        return pattern.test(matchedString);
      }) : findKey(parsePatterns, function (pattern) {
        return pattern.test(matchedString);
      });
      var value;
      value = args.valueCallback ? args.valueCallback(key) : key;
      value = options.valueCallback ? options.valueCallback(value) : value;
      var rest = string.slice(matchedString.length);
      return {
        value: value,
        rest: rest
      };
    };
  }

  function findKey(object, predicate) {
    for (var key in object) {
      if (object.hasOwnProperty(key) && predicate(object[key])) {
        return key;
      }
    }

    return undefined;
  }

  function findIndex(array, predicate) {
    for (var key = 0; key < array.length; key++) {
      if (predicate(array[key])) {
        return key;
      }
    }

    return undefined;
  }

  function buildMatchPatternFn(args) {
    return function (string) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var matchResult = string.match(args.matchPattern);
      if (!matchResult) return null;
      var matchedString = matchResult[0];
      var parseResult = string.match(args.parsePattern);
      if (!parseResult) return null;
      var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
      value = options.valueCallback ? options.valueCallback(value) : value;
      var rest = string.slice(matchedString.length);
      return {
        value: value,
        rest: rest
      };
    };
  }

  var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
  var parseOrdinalNumberPattern = /\d+/i;
  var matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
  };
  var parseEraPatterns = {
    any: [/^b/i, /^(a|c)/i]
  };
  var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
  };
  var parseQuarterPatterns = {
    any: [/1/i, /2/i, /3/i, /4/i]
  };
  var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
  };
  var parseMonthPatterns = {
    narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
  };
  var matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
  };
  var parseDayPatterns = {
    narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
    any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
  };
  var matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
  };
  var parseDayPeriodPatterns = {
    any: {
      am: /^a/i,
      pm: /^p/i,
      midnight: /^mi/i,
      noon: /^no/i,
      morning: /morning/i,
      afternoon: /afternoon/i,
      evening: /evening/i,
      night: /night/i
    }
  };
  var match = {
    ordinalNumber: buildMatchPatternFn({
      matchPattern: matchOrdinalNumberPattern,
      parsePattern: parseOrdinalNumberPattern,
      valueCallback: function valueCallback(value) {
        return parseInt(value, 10);
      }
    }),
    era: buildMatchFn({
      matchPatterns: matchEraPatterns,
      defaultMatchWidth: 'wide',
      parsePatterns: parseEraPatterns,
      defaultParseWidth: 'any'
    }),
    quarter: buildMatchFn({
      matchPatterns: matchQuarterPatterns,
      defaultMatchWidth: 'wide',
      parsePatterns: parseQuarterPatterns,
      defaultParseWidth: 'any',
      valueCallback: function valueCallback(index) {
        return index + 1;
      }
    }),
    month: buildMatchFn({
      matchPatterns: matchMonthPatterns,
      defaultMatchWidth: 'wide',
      parsePatterns: parseMonthPatterns,
      defaultParseWidth: 'any'
    }),
    day: buildMatchFn({
      matchPatterns: matchDayPatterns,
      defaultMatchWidth: 'wide',
      parsePatterns: parseDayPatterns,
      defaultParseWidth: 'any'
    }),
    dayPeriod: buildMatchFn({
      matchPatterns: matchDayPeriodPatterns,
      defaultMatchWidth: 'any',
      parsePatterns: parseDayPeriodPatterns,
      defaultParseWidth: 'any'
    })
  };
  var match$1 = match;
  /**
   * @type {Locale}
   * @category Locales
   * @summary English locale (United States).
   * @language English
   * @iso-639-2 eng
   * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
   * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
   */

  var locale = {
    code: 'en-US',
    formatDistance: formatDistance$1,
    formatLong: formatLong$1,
    formatRelative: formatRelative$1,
    localize: localize$1,
    match: match$1,
    options: {
      weekStartsOn: 0
      /* Sunday */
      ,
      firstWeekContainsDate: 1
    }
  };
  var defaultLocale = locale;
  /**
   * @name subMilliseconds
   * @category Millisecond Helpers
   * @summary Subtract the specified number of milliseconds from the given date.
   *
   * @description
   * Subtract the specified number of milliseconds from the given date.
   *
   * ### v2.0.0 breaking changes:
   *
   * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
   *
   * @param {Date|Number} date - the date to be changed
   * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
   * @returns {Date} the new date with the milliseconds subtracted
   * @throws {TypeError} 2 arguments required
   *
   * @example
   * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
   * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
   * //=> Thu Jul 10 2014 12:45:29.250
   */

  function subMilliseconds(dirtyDate, dirtyAmount) {
    requiredArgs(2, arguments);
    var amount = toInteger(dirtyAmount);
    return addMilliseconds(dirtyDate, -amount);
  }

  function addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();

    while (output.length < targetLength) {
      output = '0' + output;
    }

    return sign + output;
  }
  /*
   * |     | Unit                           |     | Unit                           |
   * |-----|--------------------------------|-----|--------------------------------|
   * |  a  | AM, PM                         |  A* |                                |
   * |  d  | Day of month                   |  D  |                                |
   * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
   * |  m  | Minute                         |  M  | Month                          |
   * |  s  | Second                         |  S  | Fraction of second             |
   * |  y  | Year (abs)                     |  Y  |                                |
   *
   * Letters marked by * are not implemented but reserved by Unicode standard.
   */


  var formatters$2 = {
    // Year
    y: function y(date, token) {
      // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
      // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
      // |----------|-------|----|-------|-------|-------|
      // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
      // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
      // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
      // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
      // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
      var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return addLeadingZeros(token === 'yy' ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
      var month = date.getUTCMonth();
      return token === 'M' ? String(month + 1) : addLeadingZeros(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
      return addLeadingZeros(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
      var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';

      switch (token) {
        case 'a':
        case 'aa':
          return dayPeriodEnumValue.toUpperCase();

        case 'aaa':
          return dayPeriodEnumValue;

        case 'aaaaa':
          return dayPeriodEnumValue[0];

        case 'aaaa':
        default:
          return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
      }
    },
    // Hour [1-12]
    h: function h(date, token) {
      return addLeadingZeros(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
      return addLeadingZeros(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
      return addLeadingZeros(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
      return addLeadingZeros(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
      var numberOfDigits = token.length;
      var milliseconds = date.getUTCMilliseconds();
      var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
      return addLeadingZeros(fractionalSeconds, token.length);
    }
  };
  var lightFormatters = formatters$2;
  var MILLISECONDS_IN_DAY = 86400000; // This function will be a part of public API when UTC function will be implemented.
  // See issue: https://github.com/date-fns/date-fns/issues/376

  function getUTCDayOfYear(dirtyDate) {
    requiredArgs(1, arguments);
    var date = toDate(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
  } // See issue: https://github.com/date-fns/date-fns/issues/376


  function startOfUTCISOWeek(dirtyDate) {
    requiredArgs(1, arguments);
    var weekStartsOn = 1;
    var date = toDate(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
  } // See issue: https://github.com/date-fns/date-fns/issues/376


  function getUTCISOWeekYear(dirtyDate) {
    requiredArgs(1, arguments);
    var date = toDate(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);

    if (date.getTime() >= startOfNextYear.getTime()) {
      return year + 1;
    } else if (date.getTime() >= startOfThisYear.getTime()) {
      return year;
    } else {
      return year - 1;
    }
  } // See issue: https://github.com/date-fns/date-fns/issues/376


  function startOfUTCISOWeekYear(dirtyDate) {
    requiredArgs(1, arguments);
    var year = getUTCISOWeekYear(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = startOfUTCISOWeek(fourthOfJanuary);
    return date;
  }

  var MILLISECONDS_IN_WEEK$1 = 604800000; // This function will be a part of public API when UTC function will be implemented.
  // See issue: https://github.com/date-fns/date-fns/issues/376

  function getUTCISOWeek(dirtyDate) {
    requiredArgs(1, arguments);
    var date = toDate(dirtyDate);
    var diff = startOfUTCISOWeek(date).getTime() - startOfUTCISOWeekYear(date).getTime(); // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)

    return Math.round(diff / MILLISECONDS_IN_WEEK$1) + 1;
  } // See issue: https://github.com/date-fns/date-fns/issues/376


  function startOfUTCWeek(dirtyDate, dirtyOptions) {
    requiredArgs(1, arguments);
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
      throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    }

    var date = toDate(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
  } // See issue: https://github.com/date-fns/date-fns/issues/376


  function getUTCWeekYear(dirtyDate, dirtyOptions) {
    requiredArgs(1, arguments);
    var date = toDate(dirtyDate);
    var year = date.getUTCFullYear();
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
      throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    }

    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, dirtyOptions);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, dirtyOptions);

    if (date.getTime() >= startOfNextYear.getTime()) {
      return year + 1;
    } else if (date.getTime() >= startOfThisYear.getTime()) {
      return year;
    } else {
      return year - 1;
    }
  } // See issue: https://github.com/date-fns/date-fns/issues/376


  function startOfUTCWeekYear(dirtyDate, dirtyOptions) {
    requiredArgs(1, arguments);
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate);
    var year = getUTCWeekYear(dirtyDate, dirtyOptions);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = startOfUTCWeek(firstWeek, dirtyOptions);
    return date;
  }

  var MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
  // See issue: https://github.com/date-fns/date-fns/issues/376

  function getUTCWeek(dirtyDate, options) {
    requiredArgs(1, arguments);
    var date = toDate(dirtyDate);
    var diff = startOfUTCWeek(date, options).getTime() - startOfUTCWeekYear(date, options).getTime(); // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)

    return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
  }

  var dayPeriodEnum = {
    am: 'am',
    pm: 'pm',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  };
  /*
   * |     | Unit                           |     | Unit                           |
   * |-----|--------------------------------|-----|--------------------------------|
   * |  a  | AM, PM                         |  A* | Milliseconds in day            |
   * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
   * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
   * |  d  | Day of month                   |  D  | Day of year                    |
   * |  e  | Local day of week              |  E  | Day of week                    |
   * |  f  |                                |  F* | Day of week in month           |
   * |  g* | Modified Julian day            |  G  | Era                            |
   * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
   * |  i! | ISO day of week                |  I! | ISO week of year               |
   * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
   * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
   * |  l* | (deprecated)                   |  L  | Stand-alone month              |
   * |  m  | Minute                         |  M  | Month                          |
   * |  n  |                                |  N  |                                |
   * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
   * |  p! | Long localized time            |  P! | Long localized date            |
   * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
   * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
   * |  s  | Second                         |  S  | Fraction of second             |
   * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
   * |  u  | Extended year                  |  U* | Cyclic year                    |
   * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
   * |  w  | Local week of year             |  W* | Week of month                  |
   * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
   * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
   * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
   *
   * Letters marked by * are not implemented but reserved by Unicode standard.
   *
   * Letters marked by ! are non-standard, but implemented by date-fns:
   * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
   * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
   *   i.e. 7 for Sunday, 1 for Monday, etc.
   * - `I` is ISO week of year, as opposed to `w` which is local week of year.
   * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
   *   `R` is supposed to be used in conjunction with `I` and `i`
   *   for universal ISO week-numbering date, whereas
   *   `Y` is supposed to be used in conjunction with `w` and `e`
   *   for week-numbering date specific to the locale.
   * - `P` is long localized date format
   * - `p` is long localized time format
   */

  var formatters = {
    // Era
    G: function G(date, token, localize) {
      var era = date.getUTCFullYear() > 0 ? 1 : 0;

      switch (token) {
        // AD, BC
        case 'G':
        case 'GG':
        case 'GGG':
          return localize.era(era, {
            width: 'abbreviated'
          });
        // A, B

        case 'GGGGG':
          return localize.era(era, {
            width: 'narrow'
          });
        // Anno Domini, Before Christ

        case 'GGGG':
        default:
          return localize.era(era, {
            width: 'wide'
          });
      }
    },
    // Year
    y: function y(date, token, localize) {
      // Ordinal number
      if (token === 'yo') {
        var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return localize.ordinalNumber(year, {
          unit: 'year'
        });
      }

      return lightFormatters.y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
      var signedWeekYear = getUTCWeekYear(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)

      var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year

      if (token === 'YY') {
        var twoDigitYear = weekYear % 100;
        return addLeadingZeros(twoDigitYear, 2);
      } // Ordinal number


      if (token === 'Yo') {
        return localize.ordinalNumber(weekYear, {
          unit: 'year'
        });
      } // Padding


      return addLeadingZeros(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
      var isoWeekYear = getUTCISOWeekYear(date); // Padding

      return addLeadingZeros(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
      var year = date.getUTCFullYear();
      return addLeadingZeros(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
      var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

      switch (token) {
        // 1, 2, 3, 4
        case 'Q':
          return String(quarter);
        // 01, 02, 03, 04

        case 'QQ':
          return addLeadingZeros(quarter, 2);
        // 1st, 2nd, 3rd, 4th

        case 'Qo':
          return localize.ordinalNumber(quarter, {
            unit: 'quarter'
          });
        // Q1, Q2, Q3, Q4

        case 'QQQ':
          return localize.quarter(quarter, {
            width: 'abbreviated',
            context: 'formatting'
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)

        case 'QQQQQ':
          return localize.quarter(quarter, {
            width: 'narrow',
            context: 'formatting'
          });
        // 1st quarter, 2nd quarter, ...

        case 'QQQQ':
        default:
          return localize.quarter(quarter, {
            width: 'wide',
            context: 'formatting'
          });
      }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
      var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

      switch (token) {
        // 1, 2, 3, 4
        case 'q':
          return String(quarter);
        // 01, 02, 03, 04

        case 'qq':
          return addLeadingZeros(quarter, 2);
        // 1st, 2nd, 3rd, 4th

        case 'qo':
          return localize.ordinalNumber(quarter, {
            unit: 'quarter'
          });
        // Q1, Q2, Q3, Q4

        case 'qqq':
          return localize.quarter(quarter, {
            width: 'abbreviated',
            context: 'standalone'
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)

        case 'qqqqq':
          return localize.quarter(quarter, {
            width: 'narrow',
            context: 'standalone'
          });
        // 1st quarter, 2nd quarter, ...

        case 'qqqq':
        default:
          return localize.quarter(quarter, {
            width: 'wide',
            context: 'standalone'
          });
      }
    },
    // Month
    M: function M(date, token, localize) {
      var month = date.getUTCMonth();

      switch (token) {
        case 'M':
        case 'MM':
          return lightFormatters.M(date, token);
        // 1st, 2nd, ..., 12th

        case 'Mo':
          return localize.ordinalNumber(month + 1, {
            unit: 'month'
          });
        // Jan, Feb, ..., Dec

        case 'MMM':
          return localize.month(month, {
            width: 'abbreviated',
            context: 'formatting'
          });
        // J, F, ..., D

        case 'MMMMM':
          return localize.month(month, {
            width: 'narrow',
            context: 'formatting'
          });
        // January, February, ..., December

        case 'MMMM':
        default:
          return localize.month(month, {
            width: 'wide',
            context: 'formatting'
          });
      }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
      var month = date.getUTCMonth();

      switch (token) {
        // 1, 2, ..., 12
        case 'L':
          return String(month + 1);
        // 01, 02, ..., 12

        case 'LL':
          return addLeadingZeros(month + 1, 2);
        // 1st, 2nd, ..., 12th

        case 'Lo':
          return localize.ordinalNumber(month + 1, {
            unit: 'month'
          });
        // Jan, Feb, ..., Dec

        case 'LLL':
          return localize.month(month, {
            width: 'abbreviated',
            context: 'standalone'
          });
        // J, F, ..., D

        case 'LLLLL':
          return localize.month(month, {
            width: 'narrow',
            context: 'standalone'
          });
        // January, February, ..., December

        case 'LLLL':
        default:
          return localize.month(month, {
            width: 'wide',
            context: 'standalone'
          });
      }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
      var week = getUTCWeek(date, options);

      if (token === 'wo') {
        return localize.ordinalNumber(week, {
          unit: 'week'
        });
      }

      return addLeadingZeros(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
      var isoWeek = getUTCISOWeek(date);

      if (token === 'Io') {
        return localize.ordinalNumber(isoWeek, {
          unit: 'week'
        });
      }

      return addLeadingZeros(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
      if (token === 'do') {
        return localize.ordinalNumber(date.getUTCDate(), {
          unit: 'date'
        });
      }

      return lightFormatters.d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
      var dayOfYear = getUTCDayOfYear(date);

      if (token === 'Do') {
        return localize.ordinalNumber(dayOfYear, {
          unit: 'dayOfYear'
        });
      }

      return addLeadingZeros(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
      var dayOfWeek = date.getUTCDay();

      switch (token) {
        // Tue
        case 'E':
        case 'EE':
        case 'EEE':
          return localize.day(dayOfWeek, {
            width: 'abbreviated',
            context: 'formatting'
          });
        // T

        case 'EEEEE':
          return localize.day(dayOfWeek, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tu

        case 'EEEEEE':
          return localize.day(dayOfWeek, {
            width: 'short',
            context: 'formatting'
          });
        // Tuesday

        case 'EEEE':
        default:
          return localize.day(dayOfWeek, {
            width: 'wide',
            context: 'formatting'
          });
      }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
      var dayOfWeek = date.getUTCDay();
      var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

      switch (token) {
        // Numerical value (Nth day of week with current locale or weekStartsOn)
        case 'e':
          return String(localDayOfWeek);
        // Padded numerical value

        case 'ee':
          return addLeadingZeros(localDayOfWeek, 2);
        // 1st, 2nd, ..., 7th

        case 'eo':
          return localize.ordinalNumber(localDayOfWeek, {
            unit: 'day'
          });

        case 'eee':
          return localize.day(dayOfWeek, {
            width: 'abbreviated',
            context: 'formatting'
          });
        // T

        case 'eeeee':
          return localize.day(dayOfWeek, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tu

        case 'eeeeee':
          return localize.day(dayOfWeek, {
            width: 'short',
            context: 'formatting'
          });
        // Tuesday

        case 'eeee':
        default:
          return localize.day(dayOfWeek, {
            width: 'wide',
            context: 'formatting'
          });
      }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
      var dayOfWeek = date.getUTCDay();
      var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

      switch (token) {
        // Numerical value (same as in `e`)
        case 'c':
          return String(localDayOfWeek);
        // Padded numerical value

        case 'cc':
          return addLeadingZeros(localDayOfWeek, token.length);
        // 1st, 2nd, ..., 7th

        case 'co':
          return localize.ordinalNumber(localDayOfWeek, {
            unit: 'day'
          });

        case 'ccc':
          return localize.day(dayOfWeek, {
            width: 'abbreviated',
            context: 'standalone'
          });
        // T

        case 'ccccc':
          return localize.day(dayOfWeek, {
            width: 'narrow',
            context: 'standalone'
          });
        // Tu

        case 'cccccc':
          return localize.day(dayOfWeek, {
            width: 'short',
            context: 'standalone'
          });
        // Tuesday

        case 'cccc':
        default:
          return localize.day(dayOfWeek, {
            width: 'wide',
            context: 'standalone'
          });
      }
    },
    // ISO day of week
    i: function i(date, token, localize) {
      var dayOfWeek = date.getUTCDay();
      var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;

      switch (token) {
        // 2
        case 'i':
          return String(isoDayOfWeek);
        // 02

        case 'ii':
          return addLeadingZeros(isoDayOfWeek, token.length);
        // 2nd

        case 'io':
          return localize.ordinalNumber(isoDayOfWeek, {
            unit: 'day'
          });
        // Tue

        case 'iii':
          return localize.day(dayOfWeek, {
            width: 'abbreviated',
            context: 'formatting'
          });
        // T

        case 'iiiii':
          return localize.day(dayOfWeek, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tu

        case 'iiiiii':
          return localize.day(dayOfWeek, {
            width: 'short',
            context: 'formatting'
          });
        // Tuesday

        case 'iiii':
        default:
          return localize.day(dayOfWeek, {
            width: 'wide',
            context: 'formatting'
          });
      }
    },
    // AM or PM
    a: function a(date, token, localize) {
      var hours = date.getUTCHours();
      var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';

      switch (token) {
        case 'a':
        case 'aa':
          return localize.dayPeriod(dayPeriodEnumValue, {
            width: 'abbreviated',
            context: 'formatting'
          });

        case 'aaa':
          return localize.dayPeriod(dayPeriodEnumValue, {
            width: 'abbreviated',
            context: 'formatting'
          }).toLowerCase();

        case 'aaaaa':
          return localize.dayPeriod(dayPeriodEnumValue, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'aaaa':
        default:
          return localize.dayPeriod(dayPeriodEnumValue, {
            width: 'wide',
            context: 'formatting'
          });
      }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
      var hours = date.getUTCHours();
      var dayPeriodEnumValue;

      if (hours === 12) {
        dayPeriodEnumValue = dayPeriodEnum.noon;
      } else if (hours === 0) {
        dayPeriodEnumValue = dayPeriodEnum.midnight;
      } else {
        dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
      }

      switch (token) {
        case 'b':
        case 'bb':
          return localize.dayPeriod(dayPeriodEnumValue, {
            width: 'abbreviated',
            context: 'formatting'
          });

        case 'bbb':
          return localize.dayPeriod(dayPeriodEnumValue, {
            width: 'abbreviated',
            context: 'formatting'
          }).toLowerCase();

        case 'bbbbb':
          return localize.dayPeriod(dayPeriodEnumValue, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'bbbb':
        default:
          return localize.dayPeriod(dayPeriodEnumValue, {
            width: 'wide',
            context: 'formatting'
          });
      }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
      var hours = date.getUTCHours();
      var dayPeriodEnumValue;

      if (hours >= 17) {
        dayPeriodEnumValue = dayPeriodEnum.evening;
      } else if (hours >= 12) {
        dayPeriodEnumValue = dayPeriodEnum.afternoon;
      } else if (hours >= 4) {
        dayPeriodEnumValue = dayPeriodEnum.morning;
      } else {
        dayPeriodEnumValue = dayPeriodEnum.night;
      }

      switch (token) {
        case 'B':
        case 'BB':
        case 'BBB':
          return localize.dayPeriod(dayPeriodEnumValue, {
            width: 'abbreviated',
            context: 'formatting'
          });

        case 'BBBBB':
          return localize.dayPeriod(dayPeriodEnumValue, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'BBBB':
        default:
          return localize.dayPeriod(dayPeriodEnumValue, {
            width: 'wide',
            context: 'formatting'
          });
      }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
      if (token === 'ho') {
        var hours = date.getUTCHours() % 12;
        if (hours === 0) hours = 12;
        return localize.ordinalNumber(hours, {
          unit: 'hour'
        });
      }

      return lightFormatters.h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
      if (token === 'Ho') {
        return localize.ordinalNumber(date.getUTCHours(), {
          unit: 'hour'
        });
      }

      return lightFormatters.H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
      var hours = date.getUTCHours() % 12;

      if (token === 'Ko') {
        return localize.ordinalNumber(hours, {
          unit: 'hour'
        });
      }

      return addLeadingZeros(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
      var hours = date.getUTCHours();
      if (hours === 0) hours = 24;

      if (token === 'ko') {
        return localize.ordinalNumber(hours, {
          unit: 'hour'
        });
      }

      return addLeadingZeros(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
      if (token === 'mo') {
        return localize.ordinalNumber(date.getUTCMinutes(), {
          unit: 'minute'
        });
      }

      return lightFormatters.m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
      if (token === 'so') {
        return localize.ordinalNumber(date.getUTCSeconds(), {
          unit: 'second'
        });
      }

      return lightFormatters.s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
      return lightFormatters.S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
      var originalDate = options._originalDate || date;
      var timezoneOffset = originalDate.getTimezoneOffset();

      if (timezoneOffset === 0) {
        return 'Z';
      }

      switch (token) {
        // Hours and optional minutes
        case 'X':
          return formatTimezoneWithOptionalMinutes(timezoneOffset);
        // Hours, minutes and optional seconds without `:` delimiter
        // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
        // so this token always has the same output as `XX`

        case 'XXXX':
        case 'XX':
          // Hours and minutes without `:` delimiter
          return formatTimezone(timezoneOffset);
        // Hours, minutes and optional seconds with `:` delimiter
        // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
        // so this token always has the same output as `XXX`

        case 'XXXXX':
        case 'XXX': // Hours and minutes with `:` delimiter

        default:
          return formatTimezone(timezoneOffset, ':');
      }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
      var originalDate = options._originalDate || date;
      var timezoneOffset = originalDate.getTimezoneOffset();

      switch (token) {
        // Hours and optional minutes
        case 'x':
          return formatTimezoneWithOptionalMinutes(timezoneOffset);
        // Hours, minutes and optional seconds without `:` delimiter
        // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
        // so this token always has the same output as `xx`

        case 'xxxx':
        case 'xx':
          // Hours and minutes without `:` delimiter
          return formatTimezone(timezoneOffset);
        // Hours, minutes and optional seconds with `:` delimiter
        // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
        // so this token always has the same output as `xxx`

        case 'xxxxx':
        case 'xxx': // Hours and minutes with `:` delimiter

        default:
          return formatTimezone(timezoneOffset, ':');
      }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
      var originalDate = options._originalDate || date;
      var timezoneOffset = originalDate.getTimezoneOffset();

      switch (token) {
        // Short
        case 'O':
        case 'OO':
        case 'OOO':
          return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
        // Long

        case 'OOOO':
        default:
          return 'GMT' + formatTimezone(timezoneOffset, ':');
      }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
      var originalDate = options._originalDate || date;
      var timezoneOffset = originalDate.getTimezoneOffset();

      switch (token) {
        // Short
        case 'z':
        case 'zz':
        case 'zzz':
          return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
        // Long

        case 'zzzz':
        default:
          return 'GMT' + formatTimezone(timezoneOffset, ':');
      }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
      var originalDate = options._originalDate || date;
      var timestamp = Math.floor(originalDate.getTime() / 1000);
      return addLeadingZeros(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
      var originalDate = options._originalDate || date;
      var timestamp = originalDate.getTime();
      return addLeadingZeros(timestamp, token.length);
    }
  };

  function formatTimezoneShort(offset, delimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;

    if (minutes === 0) {
      return sign + String(hours);
    }

    return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
  }

  function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
      var sign = offset > 0 ? '-' : '+';
      return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
    }

    return formatTimezone(offset, dirtyDelimiter);
  }

  function formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
    var minutes = addLeadingZeros(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
  }

  var formatters$1 = formatters;

  function dateLongFormatter(pattern, formatLong) {
    switch (pattern) {
      case 'P':
        return formatLong.date({
          width: 'short'
        });

      case 'PP':
        return formatLong.date({
          width: 'medium'
        });

      case 'PPP':
        return formatLong.date({
          width: 'long'
        });

      case 'PPPP':
      default:
        return formatLong.date({
          width: 'full'
        });
    }
  }

  function timeLongFormatter(pattern, formatLong) {
    switch (pattern) {
      case 'p':
        return formatLong.time({
          width: 'short'
        });

      case 'pp':
        return formatLong.time({
          width: 'medium'
        });

      case 'ppp':
        return formatLong.time({
          width: 'long'
        });

      case 'pppp':
      default:
        return formatLong.time({
          width: 'full'
        });
    }
  }

  function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];

    if (!timePattern) {
      return dateLongFormatter(pattern, formatLong);
    }

    var dateTimeFormat;

    switch (datePattern) {
      case 'P':
        dateTimeFormat = formatLong.dateTime({
          width: 'short'
        });
        break;

      case 'PP':
        dateTimeFormat = formatLong.dateTime({
          width: 'medium'
        });
        break;

      case 'PPP':
        dateTimeFormat = formatLong.dateTime({
          width: 'long'
        });
        break;

      case 'PPPP':
      default:
        dateTimeFormat = formatLong.dateTime({
          width: 'full'
        });
        break;
    }

    return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
  }

  var longFormatters$2 = {
    p: timeLongFormatter,
    P: dateTimeLongFormatter
  };
  var longFormatters$3 = longFormatters$2;
  var protectedDayOfYearTokens = ['D', 'DD'];
  var protectedWeekYearTokens = ['YY', 'YYYY'];

  function isProtectedDayOfYearToken(token) {
    return protectedDayOfYearTokens.indexOf(token) !== -1;
  }

  function isProtectedWeekYearToken(token) {
    return protectedWeekYearTokens.indexOf(token) !== -1;
  }

  function throwProtectedError(token, format, input) {
    if (token === 'YYYY') {
      throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
    } else if (token === 'YY') {
      throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
    } else if (token === 'D') {
      throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
    } else if (token === 'DD') {
      throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
    }
  } // - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
  //   (one of the certain letters followed by `o`)
  // - (\w)\1* matches any sequences of the same letter
  // - '' matches two quote characters in a row
  // - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
  //   except a single quote symbol, which ends the sequence.
  //   Two quote characters do not end the sequence.
  //   If there is no matching single quote
  //   then the sequence will continue until the end of the string.
  // - . matches any single character unmatched by previous parts of the RegExps


  var formattingTokensRegExp$1 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
  // sequences of symbols P, p, and the combinations like `PPPPPPPppppp`

  var longFormattingTokensRegExp$1 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
  var escapedStringRegExp$1 = /^'([^]*?)'?$/;
  var doubleQuoteRegExp$1 = /''/g;
  var unescapedLatinCharacterRegExp$1 = /[a-zA-Z]/;
  /**
   * @name format
   * @category Common Helpers
   * @summary Format the date.
   *
   * @description
   * Return the formatted date string in the given format. The result may vary by locale.
   *
   * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
   * > See: https://git.io/fxCyr
   *
   * The characters wrapped between two single quotes characters (') are escaped.
   * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
   * (see the last example)
   *
   * Format of the string is based on Unicode Technical Standard #35:
   * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
   * with a few additions (see note 7 below the table).
   *
   * Accepted patterns:
   * | Unit                            | Pattern | Result examples                   | Notes |
   * |---------------------------------|---------|-----------------------------------|-------|
   * | Era                             | G..GGG  | AD, BC                            |       |
   * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
   * |                                 | GGGGG   | A, B                              |       |
   * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
   * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
   * |                                 | yy      | 44, 01, 00, 17                    | 5     |
   * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
   * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
   * |                                 | yyyyy   | ...                               | 3,5   |
   * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
   * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
   * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
   * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
   * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
   * |                                 | YYYYY   | ...                               | 3,5   |
   * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
   * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
   * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
   * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
   * |                                 | RRRRR   | ...                               | 3,5,7 |
   * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
   * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
   * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
   * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
   * |                                 | uuuuu   | ...                               | 3,5   |
   * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
   * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
   * |                                 | QQ      | 01, 02, 03, 04                    |       |
   * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
   * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
   * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
   * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
   * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
   * |                                 | qq      | 01, 02, 03, 04                    |       |
   * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
   * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
   * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
   * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
   * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
   * |                                 | MM      | 01, 02, ..., 12                   |       |
   * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
   * |                                 | MMMM    | January, February, ..., December  | 2     |
   * |                                 | MMMMM   | J, F, ..., D                      |       |
   * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
   * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
   * |                                 | LL      | 01, 02, ..., 12                   |       |
   * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
   * |                                 | LLLL    | January, February, ..., December  | 2     |
   * |                                 | LLLLL   | J, F, ..., D                      |       |
   * | Local week of year              | w       | 1, 2, ..., 53                     |       |
   * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
   * |                                 | ww      | 01, 02, ..., 53                   |       |
   * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
   * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
   * |                                 | II      | 01, 02, ..., 53                   | 7     |
   * | Day of month                    | d       | 1, 2, ..., 31                     |       |
   * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
   * |                                 | dd      | 01, 02, ..., 31                   |       |
   * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
   * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
   * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
   * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
   * |                                 | DDDD    | ...                               | 3     |
   * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
   * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
   * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
   * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
   * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
   * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
   * |                                 | ii      | 01, 02, ..., 07                   | 7     |
   * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
   * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
   * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
   * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
   * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
   * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
   * |                                 | ee      | 02, 03, ..., 01                   |       |
   * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
   * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
   * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
   * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
   * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
   * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
   * |                                 | cc      | 02, 03, ..., 01                   |       |
   * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
   * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
   * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
   * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
   * | AM, PM                          | a..aa   | AM, PM                            |       |
   * |                                 | aaa     | am, pm                            |       |
   * |                                 | aaaa    | a.m., p.m.                        | 2     |
   * |                                 | aaaaa   | a, p                              |       |
   * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
   * |                                 | bbb     | am, pm, noon, midnight            |       |
   * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
   * |                                 | bbbbb   | a, p, n, mi                       |       |
   * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
   * |                                 | BBBB    | at night, in the morning, ...     | 2     |
   * |                                 | BBBBB   | at night, in the morning, ...     |       |
   * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
   * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
   * |                                 | hh      | 01, 02, ..., 11, 12               |       |
   * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
   * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
   * |                                 | HH      | 00, 01, 02, ..., 23               |       |
   * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
   * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
   * |                                 | KK      | 01, 02, ..., 11, 00               |       |
   * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
   * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
   * |                                 | kk      | 24, 01, 02, ..., 23               |       |
   * | Minute                          | m       | 0, 1, ..., 59                     |       |
   * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
   * |                                 | mm      | 00, 01, ..., 59                   |       |
   * | Second                          | s       | 0, 1, ..., 59                     |       |
   * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
   * |                                 | ss      | 00, 01, ..., 59                   |       |
   * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
   * |                                 | SS      | 00, 01, ..., 99                   |       |
   * |                                 | SSS     | 000, 001, ..., 999                |       |
   * |                                 | SSSS    | ...                               | 3     |
   * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
   * |                                 | XX      | -0800, +0530, Z                   |       |
   * |                                 | XXX     | -08:00, +05:30, Z                 |       |
   * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
   * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
   * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
   * |                                 | xx      | -0800, +0530, +0000               |       |
   * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
   * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
   * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
   * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
   * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
   * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
   * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
   * | Seconds timestamp               | t       | 512969520                         | 7     |
   * |                                 | tt      | ...                               | 3,7   |
   * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
   * |                                 | TT      | ...                               | 3,7   |
   * | Long localized date             | P       | 04/29/1453                        | 7     |
   * |                                 | PP      | Apr 29, 1453                      | 7     |
   * |                                 | PPP     | April 29th, 1453                  | 7     |
   * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
   * | Long localized time             | p       | 12:00 AM                          | 7     |
   * |                                 | pp      | 12:00:00 AM                       | 7     |
   * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
   * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
   * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
   * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
   * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
   * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
   * Notes:
   * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
   *    are the same as "stand-alone" units, but are different in some languages.
   *    "Formatting" units are declined according to the rules of the language
   *    in the context of a date. "Stand-alone" units are always nominative singular:
   *
   *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
   *
   *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
   *
   * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
   *    the single quote characters (see below).
   *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
   *    the output will be the same as default pattern for this unit, usually
   *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
   *    are marked with "2" in the last column of the table.
   *
   *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
   *
   *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
   *
   *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
   *
   *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
   *
   *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
   *
   * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
   *    The output will be padded with zeros to match the length of the pattern.
   *
   *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
   *
   * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
   *    These tokens represent the shortest form of the quarter.
   *
   * 5. The main difference between `y` and `u` patterns are B.C. years:
   *
   *    | Year | `y` | `u` |
   *    |------|-----|-----|
   *    | AC 1 |   1 |   1 |
   *    | BC 1 |   1 |   0 |
   *    | BC 2 |   2 |  -1 |
   *
   *    Also `yy` always returns the last two digits of a year,
   *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
   *
   *    | Year | `yy` | `uu` |
   *    |------|------|------|
   *    | 1    |   01 |   01 |
   *    | 14   |   14 |   14 |
   *    | 376  |   76 |  376 |
   *    | 1453 |   53 | 1453 |
   *
   *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
   *    except local week-numbering years are dependent on `options.weekStartsOn`
   *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
   *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
   *
   * 6. Specific non-location timezones are currently unavailable in `date-fns`,
   *    so right now these tokens fall back to GMT timezones.
   *
   * 7. These patterns are not in the Unicode Technical Standard #35:
   *    - `i`: ISO day of week
   *    - `I`: ISO week of year
   *    - `R`: ISO week-numbering year
   *    - `t`: seconds timestamp
   *    - `T`: milliseconds timestamp
   *    - `o`: ordinal number modifier
   *    - `P`: long localized date
   *    - `p`: long localized time
   *
   * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
   *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
   *
   * 9. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
   *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
   *
   * ### v2.0.0 breaking changes:
   *
   * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
   *
   * - The second argument is now required for the sake of explicitness.
   *
   *   ```javascript
   *   // Before v2.0.0
   *   format(new Date(2016, 0, 1))
   *
   *   // v2.0.0 onward
   *   format(new Date(2016, 0, 1), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
   *   ```
   *
   * - New format string API for `format` function
   *   which is based on [Unicode Technical Standard #35](https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table).
   *   See [this post](https://blog.date-fns.org/post/unicode-tokens-in-date-fns-v2-sreatyki91jg) for more details.
   *
   * - Characters are now escaped using single quote symbols (`'`) instead of square brackets.
   *
   * @param {Date|Number} date - the original date
   * @param {String} format - the string of tokens
   * @param {Object} [options] - an object with options.
   * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
   * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
   * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
   * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
   *   see: https://git.io/fxCyr
   * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
   *   see: https://git.io/fxCyr
   * @returns {String} the formatted date string
   * @throws {TypeError} 2 arguments required
   * @throws {RangeError} `date` must not be Invalid Date
   * @throws {RangeError} `options.locale` must contain `localize` property
   * @throws {RangeError} `options.locale` must contain `formatLong` property
   * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
   * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
   * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
   * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
   * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
   * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
   * @throws {RangeError} format string contains an unescaped latin alphabet character
   *
   * @example
   * // Represent 11 February 2014 in middle-endian format:
   * var result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
   * //=> '02/11/2014'
   *
   * @example
   * // Represent 2 July 2014 in Esperanto:
   * import { eoLocale } from 'date-fns/locale/eo'
   * var result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
   *   locale: eoLocale
   * })
   * //=> '2-a de julio 2014'
   *
   * @example
   * // Escape string by single quote characters:
   * var result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
   * //=> "3 o'clock"
   */

  function format(dirtyDate, dirtyFormatStr, dirtyOptions) {
    requiredArgs(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var locale = options.locale || defaultLocale;
    var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
      throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    }

    var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
      throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    }

    if (!locale.localize) {
      throw new RangeError('locale must contain localize property');
    }

    if (!locale.formatLong) {
      throw new RangeError('locale must contain formatLong property');
    }

    var originalDate = toDate(dirtyDate);

    if (!isValid(originalDate)) {
      throw new RangeError('Invalid time value');
    } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376


    var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
    var utcDate = subMilliseconds(originalDate, timezoneOffset);
    var formatterOptions = {
      firstWeekContainsDate: firstWeekContainsDate,
      weekStartsOn: weekStartsOn,
      locale: locale,
      _originalDate: originalDate
    };
    var result = formatStr.match(longFormattingTokensRegExp$1).map(function (substring) {
      var firstCharacter = substring[0];

      if (firstCharacter === 'p' || firstCharacter === 'P') {
        var longFormatter = longFormatters$3[firstCharacter];
        return longFormatter(substring, locale.formatLong, formatterOptions);
      }

      return substring;
    }).join('').match(formattingTokensRegExp$1).map(function (substring) {
      // Replace two single quote characters with one single quote character
      if (substring === "''") {
        return "'";
      }

      var firstCharacter = substring[0];

      if (firstCharacter === "'") {
        return cleanEscapedString$1(substring);
      }

      var formatter = formatters$1[firstCharacter];

      if (formatter) {
        if (!options.useAdditionalWeekYearTokens && isProtectedWeekYearToken(substring)) {
          throwProtectedError(substring, dirtyFormatStr, dirtyDate);
        }

        if (!options.useAdditionalDayOfYearTokens && isProtectedDayOfYearToken(substring)) {
          throwProtectedError(substring, dirtyFormatStr, dirtyDate);
        }

        return formatter(utcDate, substring, locale.localize, formatterOptions);
      }

      if (firstCharacter.match(unescapedLatinCharacterRegExp$1)) {
        throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
      }

      return substring;
    }).join('');
    return result;
  }

  function cleanEscapedString$1(input) {
    return input.match(escapedStringRegExp$1)[1].replace(doubleQuoteRegExp$1, "'");
  }
  /**
   * @name getHours
   * @category Hour Helpers
   * @summary Get the hours of the given date.
   *
   * @description
   * Get the hours of the given date.
   *
   * ### v2.0.0 breaking changes:
   *
   * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
   *
   * @param {Date|Number} date - the given date
   * @returns {Number} the hours
   * @throws {TypeError} 1 argument required
   *
   * @example
   * // Get the hours of 29 February 2012 11:45:00:
   * const result = getHours(new Date(2012, 1, 29, 11, 45))
   * //=> 11
   */


  function getHours(dirtyDate) {
    requiredArgs(1, arguments);
    var date = toDate(dirtyDate);
    var hours = date.getHours();
    return hours;
  }
  /**
   * @name getSeconds
   * @category Second Helpers
   * @summary Get the seconds of the given date.
   *
   * @description
   * Get the seconds of the given date.
   *
   * ### v2.0.0 breaking changes:
   *
   * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
   *
   * @param {Date|Number} date - the given date
   * @returns {Number} the seconds
   * @throws {TypeError} 1 argument required
   *
   * @example
   * // Get the seconds of 29 February 2012 11:45:05.123:
   * const result = getSeconds(new Date(2012, 1, 29, 11, 45, 5, 123))
   * //=> 5
   */


  function getSeconds(dirtyDate) {
    requiredArgs(1, arguments);
    var date = toDate(dirtyDate);
    var seconds = date.getSeconds();
    return seconds;
  }
  /**
   * @name getYear
   * @category Year Helpers
   * @summary Get the year of the given date.
   *
   * @description
   * Get the year of the given date.
   *
   * ### v2.0.0 breaking changes:
   *
   * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
   *
   * @param {Date|Number} date - the given date
   * @returns {Number} the year
   * @throws {TypeError} 1 argument required
   *
   * @example
   * // Which year is 2 July 2014?
   * const result = getYear(new Date(2014, 6, 2))
   * //=> 2014
   */


  function getYear(dirtyDate) {
    requiredArgs(1, arguments);
    return toDate(dirtyDate).getFullYear();
  }
  /**
   * @name isAfter
   * @category Common Helpers
   * @summary Is the first date after the second one?
   *
   * @description
   * Is the first date after the second one?
   *
   * ### v2.0.0 breaking changes:
   *
   * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
   *
   * @param {Date|Number} date - the date that should be after the other one to return true
   * @param {Date|Number} dateToCompare - the date to compare with
   * @returns {Boolean} the first date is after the second date
   * @throws {TypeError} 2 arguments required
   *
   * @example
   * // Is 10 July 1989 after 11 February 1987?
   * var result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
   * //=> true
   */


  function isAfter(dirtyDate, dirtyDateToCompare) {
    requiredArgs(2, arguments);
    var date = toDate(dirtyDate);
    var dateToCompare = toDate(dirtyDateToCompare);
    return date.getTime() > dateToCompare.getTime();
  }
  /**
   * @name isBefore
   * @category Common Helpers
   * @summary Is the first date before the second one?
   *
   * @description
   * Is the first date before the second one?
   *
   * ### v2.0.0 breaking changes:
   *
   * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
   *
   * @param {Date|Number} date - the date that should be before the other one to return true
   * @param {Date|Number} dateToCompare - the date to compare with
   * @returns {Boolean} the first date is before the second date
   * @throws {TypeError} 2 arguments required
   *
   * @example
   * // Is 10 July 1989 before 11 February 1987?
   * var result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
   * //=> false
   */


  function isBefore(dirtyDate, dirtyDateToCompare) {
    requiredArgs(2, arguments);
    var date = toDate(dirtyDate);
    var dateToCompare = toDate(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
  }
  /**
   * @name isEqual
   * @category Common Helpers
   * @summary Are the given dates equal?
   *
   * @description
   * Are the given dates equal?
   *
   * ### v2.0.0 breaking changes:
   *
   * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
   *
   * @param {Date|Number} dateLeft - the first date to compare
   * @param {Date|Number} dateRight - the second date to compare
   * @returns {Boolean} the dates are equal
   * @throws {TypeError} 2 arguments required
   *
   * @example
   * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
   * var result = isEqual(
   *   new Date(2014, 6, 2, 6, 30, 45, 0),
   *   new Date(2014, 6, 2, 6, 30, 45, 500)
   * )
   * //=> false
   */


  function isEqual(dirtyLeftDate, dirtyRightDate) {
    requiredArgs(2, arguments);
    var dateLeft = toDate(dirtyLeftDate);
    var dateRight = toDate(dirtyRightDate);
    return dateLeft.getTime() === dateRight.getTime();
  }
  /**
   * @name isSameDay
   * @category Day Helpers
   * @summary Are the given dates in the same day?
   *
   * @description
   * Are the given dates in the same day?
   *
   * ### v2.0.0 breaking changes:
   *
   * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
   *
   * @param {Date|Number} dateLeft - the first date to check
   * @param {Date|Number} dateRight - the second date to check
   * @returns {Boolean} the dates are in the same day
   * @throws {TypeError} 2 arguments required
   *
   * @example
   * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
   * var result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
   * //=> true
   */


  function isSameDay(dirtyDateLeft, dirtyDateRight) {
    requiredArgs(2, arguments);
    var dateLeftStartOfDay = startOfDay(dirtyDateLeft);
    var dateRightStartOfDay = startOfDay(dirtyDateRight);
    return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
  }
  /**
   * @name isSameYear
   * @category Year Helpers
   * @summary Are the given dates in the same year?
   *
   * @description
   * Are the given dates in the same year?
   *
   * ### v2.0.0 breaking changes:
   *
   * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
   *
   * @param {Date|Number} dateLeft - the first date to check
   * @param {Date|Number} dateRight - the second date to check
   * @returns {Boolean} the dates are in the same year
   * @throws {TypeError} 2 arguments required
   *
   * @example
   * // Are 2 September 2014 and 25 September 2014 in the same year?
   * var result = isSameYear(new Date(2014, 8, 2), new Date(2014, 8, 25))
   * //=> true
   */


  function isSameYear(dirtyDateLeft, dirtyDateRight) {
    requiredArgs(2, arguments);
    var dateLeft = toDate(dirtyDateLeft);
    var dateRight = toDate(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear();
  }
  /**
   * @name isSameMonth
   * @category Month Helpers
   * @summary Are the given dates in the same month?
   *
   * @description
   * Are the given dates in the same month?
   *
   * ### v2.0.0 breaking changes:
   *
   * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
   *
   * @param {Date|Number} dateLeft - the first date to check
   * @param {Date|Number} dateRight - the second date to check
   * @returns {Boolean} the dates are in the same month
   * @throws {TypeError} 2 arguments required
   *
   * @example
   * // Are 2 September 2014 and 25 September 2014 in the same month?
   * var result = isSameMonth(new Date(2014, 8, 2), new Date(2014, 8, 25))
   * //=> true
   *
   * @example
   * // Are 2 September 2014 and 25 September 2015 in the same month?
   * var result = isSameMonth(new Date(2014, 8, 2), new Date(2015, 8, 25))
   * //=> false
   */


  function isSameMonth(dirtyDateLeft, dirtyDateRight) {
    requiredArgs(2, arguments);
    var dateLeft = toDate(dirtyDateLeft);
    var dateRight = toDate(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
  }
  /**
   * @name startOfHour
   * @category Hour Helpers
   * @summary Return the start of an hour for the given date.
   *
   * @description
   * Return the start of an hour for the given date.
   * The result will be in the local timezone.
   *
   * ### v2.0.0 breaking changes:
   *
   * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
   *
   * @param {Date|Number} date - the original date
   * @returns {Date} the start of an hour
   * @throws {TypeError} 1 argument required
   *
   * @example
   * // The start of an hour for 2 September 2014 11:55:00:
   * const result = startOfHour(new Date(2014, 8, 2, 11, 55))
   * //=> Tue Sep 02 2014 11:00:00
   */


  function startOfHour(dirtyDate) {
    requiredArgs(1, arguments);
    var date = toDate(dirtyDate);
    date.setMinutes(0, 0, 0);
    return date;
  }
  /**
   * @name isSameHour
   * @category Hour Helpers
   * @summary Are the given dates in the same hour?
   *
   * @description
   * Are the given dates in the same hour?
   *
   * ### v2.0.0 breaking changes:
   *
   * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
   *
   * @param {Date|Number} dateLeft - the first date to check
   * @param {Date|Number} dateRight - the second date to check
   * @returns {Boolean} the dates are in the same hour
   * @throws {TypeError} 2 arguments required
   *
   * @example
   * // Are 4 September 2014 06:00:00 and 4 September 06:30:00 in the same hour?
   * var result = isSameHour(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 6, 30))
   * //=> true
   */


  function isSameHour(dirtyDateLeft, dirtyDateRight) {
    requiredArgs(2, arguments);
    var dateLeftStartOfHour = startOfHour(dirtyDateLeft);
    var dateRightStartOfHour = startOfHour(dirtyDateRight);
    return dateLeftStartOfHour.getTime() === dateRightStartOfHour.getTime();
  }

  function assign(target, dirtyObject) {
    if (target == null) {
      throw new TypeError('assign requires that input parameter not be null or undefined');
    }

    dirtyObject = dirtyObject || {};

    for (var property in dirtyObject) {
      if (Object.prototype.hasOwnProperty.call(dirtyObject, property)) {
        target[property] = dirtyObject[property];
      }
    }

    return target;
  } // See issue: https://github.com/date-fns/date-fns/issues/376


  function setUTCDay(dirtyDate, dirtyDay, dirtyOptions) {
    requiredArgs(2, arguments);
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
      throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    }

    var date = toDate(dirtyDate);
    var day = toInteger(dirtyDay);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
  } // See issue: https://github.com/date-fns/date-fns/issues/376


  function setUTCISODay(dirtyDate, dirtyDay) {
    requiredArgs(2, arguments);
    var day = toInteger(dirtyDay);

    if (day % 7 === 0) {
      day = day - 7;
    }

    var weekStartsOn = 1;
    var date = toDate(dirtyDate);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
  } // See issue: https://github.com/date-fns/date-fns/issues/376


  function setUTCISOWeek(dirtyDate, dirtyISOWeek) {
    requiredArgs(2, arguments);
    var date = toDate(dirtyDate);
    var isoWeek = toInteger(dirtyISOWeek);
    var diff = getUTCISOWeek(date) - isoWeek;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
  } // See issue: https://github.com/date-fns/date-fns/issues/376


  function setUTCWeek(dirtyDate, dirtyWeek, options) {
    requiredArgs(2, arguments);
    var date = toDate(dirtyDate);
    var week = toInteger(dirtyWeek);
    var diff = getUTCWeek(date, options) - week;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
  }

  var MILLISECONDS_IN_HOUR$1 = 3600000;
  var MILLISECONDS_IN_MINUTE$1 = 60000;
  var MILLISECONDS_IN_SECOND = 1000;
  var numericPatterns = {
    month: /^(1[0-2]|0?\d)/,
    // 0 to 12
    date: /^(3[0-1]|[0-2]?\d)/,
    // 0 to 31
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    // 0 to 366
    week: /^(5[0-3]|[0-4]?\d)/,
    // 0 to 53
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    // 0 to 23
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    // 0 to 24
    hour11h: /^(1[0-1]|0?\d)/,
    // 0 to 11
    hour12h: /^(1[0-2]|0?\d)/,
    // 0 to 12
    minute: /^[0-5]?\d/,
    // 0 to 59
    second: /^[0-5]?\d/,
    // 0 to 59
    singleDigit: /^\d/,
    // 0 to 9
    twoDigits: /^\d{1,2}/,
    // 0 to 99
    threeDigits: /^\d{1,3}/,
    // 0 to 999
    fourDigits: /^\d{1,4}/,
    // 0 to 9999
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    // 0 to 9, -0 to -9
    twoDigitsSigned: /^-?\d{1,2}/,
    // 0 to 99, -0 to -99
    threeDigitsSigned: /^-?\d{1,3}/,
    // 0 to 999, -0 to -999
    fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999

  };
  var timezonePatterns = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
  };

  function parseNumericPattern(pattern, string, valueCallback) {
    var matchResult = string.match(pattern);

    if (!matchResult) {
      return null;
    }

    var value = parseInt(matchResult[0], 10);
    return {
      value: valueCallback ? valueCallback(value) : value,
      rest: string.slice(matchResult[0].length)
    };
  }

  function parseTimezonePattern(pattern, string) {
    var matchResult = string.match(pattern);

    if (!matchResult) {
      return null;
    } // Input is 'Z'


    if (matchResult[0] === 'Z') {
      return {
        value: 0,
        rest: string.slice(1)
      };
    }

    var sign = matchResult[1] === '+' ? 1 : -1;
    var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
      value: sign * (hours * MILLISECONDS_IN_HOUR$1 + minutes * MILLISECONDS_IN_MINUTE$1 + seconds * MILLISECONDS_IN_SECOND),
      rest: string.slice(matchResult[0].length)
    };
  }

  function parseAnyDigitsSigned(string, valueCallback) {
    return parseNumericPattern(numericPatterns.anyDigitsSigned, string, valueCallback);
  }

  function parseNDigits(n, string, valueCallback) {
    switch (n) {
      case 1:
        return parseNumericPattern(numericPatterns.singleDigit, string, valueCallback);

      case 2:
        return parseNumericPattern(numericPatterns.twoDigits, string, valueCallback);

      case 3:
        return parseNumericPattern(numericPatterns.threeDigits, string, valueCallback);

      case 4:
        return parseNumericPattern(numericPatterns.fourDigits, string, valueCallback);

      default:
        return parseNumericPattern(new RegExp('^\\d{1,' + n + '}'), string, valueCallback);
    }
  }

  function parseNDigitsSigned(n, string, valueCallback) {
    switch (n) {
      case 1:
        return parseNumericPattern(numericPatterns.singleDigitSigned, string, valueCallback);

      case 2:
        return parseNumericPattern(numericPatterns.twoDigitsSigned, string, valueCallback);

      case 3:
        return parseNumericPattern(numericPatterns.threeDigitsSigned, string, valueCallback);

      case 4:
        return parseNumericPattern(numericPatterns.fourDigitsSigned, string, valueCallback);

      default:
        return parseNumericPattern(new RegExp('^-?\\d{1,' + n + '}'), string, valueCallback);
    }
  }

  function dayPeriodEnumToHours(enumValue) {
    switch (enumValue) {
      case 'morning':
        return 4;

      case 'evening':
        return 17;

      case 'pm':
      case 'noon':
      case 'afternoon':
        return 12;

      case 'am':
      case 'midnight':
      case 'night':
      default:
        return 0;
    }
  }

  function normalizeTwoDigitYear(twoDigitYear, currentYear) {
    var isCommonEra = currentYear > 0; // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC

    var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    var result;

    if (absCurrentYear <= 50) {
      result = twoDigitYear || 100;
    } else {
      var rangeEnd = absCurrentYear + 50;
      var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
      var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
      result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }

    return isCommonEra ? result : 1 - result;
  }

  var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  var DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]; // User for validation

  function isLeapYearIndex$1(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
  }
  /*
   * |     | Unit                           |     | Unit                           |
   * |-----|--------------------------------|-----|--------------------------------|
   * |  a  | AM, PM                         |  A* | Milliseconds in day            |
   * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
   * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
   * |  d  | Day of month                   |  D  | Day of year                    |
   * |  e  | Local day of week              |  E  | Day of week                    |
   * |  f  |                                |  F* | Day of week in month           |
   * |  g* | Modified Julian day            |  G  | Era                            |
   * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
   * |  i! | ISO day of week                |  I! | ISO week of year               |
   * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
   * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
   * |  l* | (deprecated)                   |  L  | Stand-alone month              |
   * |  m  | Minute                         |  M  | Month                          |
   * |  n  |                                |  N  |                                |
   * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
   * |  p  |                                |  P  |                                |
   * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
   * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
   * |  s  | Second                         |  S  | Fraction of second             |
   * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
   * |  u  | Extended year                  |  U* | Cyclic year                    |
   * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
   * |  w  | Local week of year             |  W* | Week of month                  |
   * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
   * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
   * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
   *
   * Letters marked by * are not implemented but reserved by Unicode standard.
   *
   * Letters marked by ! are non-standard, but implemented by date-fns:
   * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
   * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
   *   i.e. 7 for Sunday, 1 for Monday, etc.
   * - `I` is ISO week of year, as opposed to `w` which is local week of year.
   * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
   *   `R` is supposed to be used in conjunction with `I` and `i`
   *   for universal ISO week-numbering date, whereas
   *   `Y` is supposed to be used in conjunction with `w` and `e`
   *   for week-numbering date specific to the locale.
   */


  var parsers = {
    // Era
    G: {
      priority: 140,
      parse: function parse(string, token, match, _options) {
        switch (token) {
          // AD, BC
          case 'G':
          case 'GG':
          case 'GGG':
            return match.era(string, {
              width: 'abbreviated'
            }) || match.era(string, {
              width: 'narrow'
            });
          // A, B

          case 'GGGGG':
            return match.era(string, {
              width: 'narrow'
            });
          // Anno Domini, Before Christ

          case 'GGGG':
          default:
            return match.era(string, {
              width: 'wide'
            }) || match.era(string, {
              width: 'abbreviated'
            }) || match.era(string, {
              width: 'narrow'
            });
        }
      },
      set: function set(date, flags, value, _options) {
        flags.era = value;
        date.setUTCFullYear(value, 0, 1);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      },
      incompatibleTokens: ['R', 'u', 't', 'T']
    },
    // Year
    y: {
      // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
      // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
      // |----------|-------|----|-------|-------|-------|
      // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
      // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
      // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
      // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
      // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
      priority: 130,
      parse: function parse(string, token, match, _options) {
        var valueCallback = function valueCallback(year) {
          return {
            year: year,
            isTwoDigitYear: token === 'yy'
          };
        };

        switch (token) {
          case 'y':
            return parseNDigits(4, string, valueCallback);

          case 'yo':
            return match.ordinalNumber(string, {
              unit: 'year',
              valueCallback: valueCallback
            });

          default:
            return parseNDigits(token.length, string, valueCallback);
        }
      },
      validate: function validate(_date, value, _options) {
        return value.isTwoDigitYear || value.year > 0;
      },
      set: function set(date, flags, value, _options) {
        var currentYear = date.getUTCFullYear();

        if (value.isTwoDigitYear) {
          var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
          date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
          date.setUTCHours(0, 0, 0, 0);
          return date;
        }

        var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
        date.setUTCFullYear(year, 0, 1);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      },
      incompatibleTokens: ['Y', 'R', 'u', 'w', 'I', 'i', 'e', 'c', 't', 'T']
    },
    // Local week-numbering year
    Y: {
      priority: 130,
      parse: function parse(string, token, match, _options) {
        var valueCallback = function valueCallback(year) {
          return {
            year: year,
            isTwoDigitYear: token === 'YY'
          };
        };

        switch (token) {
          case 'Y':
            return parseNDigits(4, string, valueCallback);

          case 'Yo':
            return match.ordinalNumber(string, {
              unit: 'year',
              valueCallback: valueCallback
            });

          default:
            return parseNDigits(token.length, string, valueCallback);
        }
      },
      validate: function validate(_date, value, _options) {
        return value.isTwoDigitYear || value.year > 0;
      },
      set: function set(date, flags, value, options) {
        var currentYear = getUTCWeekYear(date, options);

        if (value.isTwoDigitYear) {
          var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
          date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
          date.setUTCHours(0, 0, 0, 0);
          return startOfUTCWeek(date, options);
        }

        var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
        date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
        date.setUTCHours(0, 0, 0, 0);
        return startOfUTCWeek(date, options);
      },
      incompatibleTokens: ['y', 'R', 'u', 'Q', 'q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']
    },
    // ISO week-numbering year
    R: {
      priority: 130,
      parse: function parse(string, token, _match, _options) {
        if (token === 'R') {
          return parseNDigitsSigned(4, string);
        }

        return parseNDigitsSigned(token.length, string);
      },
      set: function set(_date, _flags, value, _options) {
        var firstWeekOfYear = new Date(0);
        firstWeekOfYear.setUTCFullYear(value, 0, 4);
        firstWeekOfYear.setUTCHours(0, 0, 0, 0);
        return startOfUTCISOWeek(firstWeekOfYear);
      },
      incompatibleTokens: ['G', 'y', 'Y', 'u', 'Q', 'q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']
    },
    // Extended year
    u: {
      priority: 130,
      parse: function parse(string, token, _match, _options) {
        if (token === 'u') {
          return parseNDigitsSigned(4, string);
        }

        return parseNDigitsSigned(token.length, string);
      },
      set: function set(date, _flags, value, _options) {
        date.setUTCFullYear(value, 0, 1);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      },
      incompatibleTokens: ['G', 'y', 'Y', 'R', 'w', 'I', 'i', 'e', 'c', 't', 'T']
    },
    // Quarter
    Q: {
      priority: 120,
      parse: function parse(string, token, match, _options) {
        switch (token) {
          // 1, 2, 3, 4
          case 'Q':
          case 'QQ':
            // 01, 02, 03, 04
            return parseNDigits(token.length, string);
          // 1st, 2nd, 3rd, 4th

          case 'Qo':
            return match.ordinalNumber(string, {
              unit: 'quarter'
            });
          // Q1, Q2, Q3, Q4

          case 'QQQ':
            return match.quarter(string, {
              width: 'abbreviated',
              context: 'formatting'
            }) || match.quarter(string, {
              width: 'narrow',
              context: 'formatting'
            });
          // 1, 2, 3, 4 (narrow quarter; could be not numerical)

          case 'QQQQQ':
            return match.quarter(string, {
              width: 'narrow',
              context: 'formatting'
            });
          // 1st quarter, 2nd quarter, ...

          case 'QQQQ':
          default:
            return match.quarter(string, {
              width: 'wide',
              context: 'formatting'
            }) || match.quarter(string, {
              width: 'abbreviated',
              context: 'formatting'
            }) || match.quarter(string, {
              width: 'narrow',
              context: 'formatting'
            });
        }
      },
      validate: function validate(_date, value, _options) {
        return value >= 1 && value <= 4;
      },
      set: function set(date, _flags, value, _options) {
        date.setUTCMonth((value - 1) * 3, 1);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      },
      incompatibleTokens: ['Y', 'R', 'q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']
    },
    // Stand-alone quarter
    q: {
      priority: 120,
      parse: function parse(string, token, match, _options) {
        switch (token) {
          // 1, 2, 3, 4
          case 'q':
          case 'qq':
            // 01, 02, 03, 04
            return parseNDigits(token.length, string);
          // 1st, 2nd, 3rd, 4th

          case 'qo':
            return match.ordinalNumber(string, {
              unit: 'quarter'
            });
          // Q1, Q2, Q3, Q4

          case 'qqq':
            return match.quarter(string, {
              width: 'abbreviated',
              context: 'standalone'
            }) || match.quarter(string, {
              width: 'narrow',
              context: 'standalone'
            });
          // 1, 2, 3, 4 (narrow quarter; could be not numerical)

          case 'qqqqq':
            return match.quarter(string, {
              width: 'narrow',
              context: 'standalone'
            });
          // 1st quarter, 2nd quarter, ...

          case 'qqqq':
          default:
            return match.quarter(string, {
              width: 'wide',
              context: 'standalone'
            }) || match.quarter(string, {
              width: 'abbreviated',
              context: 'standalone'
            }) || match.quarter(string, {
              width: 'narrow',
              context: 'standalone'
            });
        }
      },
      validate: function validate(_date, value, _options) {
        return value >= 1 && value <= 4;
      },
      set: function set(date, _flags, value, _options) {
        date.setUTCMonth((value - 1) * 3, 1);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      },
      incompatibleTokens: ['Y', 'R', 'Q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']
    },
    // Month
    M: {
      priority: 110,
      parse: function parse(string, token, match, _options) {
        var valueCallback = function valueCallback(value) {
          return value - 1;
        };

        switch (token) {
          // 1, 2, ..., 12
          case 'M':
            return parseNumericPattern(numericPatterns.month, string, valueCallback);
          // 01, 02, ..., 12

          case 'MM':
            return parseNDigits(2, string, valueCallback);
          // 1st, 2nd, ..., 12th

          case 'Mo':
            return match.ordinalNumber(string, {
              unit: 'month',
              valueCallback: valueCallback
            });
          // Jan, Feb, ..., Dec

          case 'MMM':
            return match.month(string, {
              width: 'abbreviated',
              context: 'formatting'
            }) || match.month(string, {
              width: 'narrow',
              context: 'formatting'
            });
          // J, F, ..., D

          case 'MMMMM':
            return match.month(string, {
              width: 'narrow',
              context: 'formatting'
            });
          // January, February, ..., December

          case 'MMMM':
          default:
            return match.month(string, {
              width: 'wide',
              context: 'formatting'
            }) || match.month(string, {
              width: 'abbreviated',
              context: 'formatting'
            }) || match.month(string, {
              width: 'narrow',
              context: 'formatting'
            });
        }
      },
      validate: function validate(_date, value, _options) {
        return value >= 0 && value <= 11;
      },
      set: function set(date, _flags, value, _options) {
        date.setUTCMonth(value, 1);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      },
      incompatibleTokens: ['Y', 'R', 'q', 'Q', 'L', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
    },
    // Stand-alone month
    L: {
      priority: 110,
      parse: function parse(string, token, match, _options) {
        var valueCallback = function valueCallback(value) {
          return value - 1;
        };

        switch (token) {
          // 1, 2, ..., 12
          case 'L':
            return parseNumericPattern(numericPatterns.month, string, valueCallback);
          // 01, 02, ..., 12

          case 'LL':
            return parseNDigits(2, string, valueCallback);
          // 1st, 2nd, ..., 12th

          case 'Lo':
            return match.ordinalNumber(string, {
              unit: 'month',
              valueCallback: valueCallback
            });
          // Jan, Feb, ..., Dec

          case 'LLL':
            return match.month(string, {
              width: 'abbreviated',
              context: 'standalone'
            }) || match.month(string, {
              width: 'narrow',
              context: 'standalone'
            });
          // J, F, ..., D

          case 'LLLLL':
            return match.month(string, {
              width: 'narrow',
              context: 'standalone'
            });
          // January, February, ..., December

          case 'LLLL':
          default:
            return match.month(string, {
              width: 'wide',
              context: 'standalone'
            }) || match.month(string, {
              width: 'abbreviated',
              context: 'standalone'
            }) || match.month(string, {
              width: 'narrow',
              context: 'standalone'
            });
        }
      },
      validate: function validate(_date, value, _options) {
        return value >= 0 && value <= 11;
      },
      set: function set(date, _flags, value, _options) {
        date.setUTCMonth(value, 1);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      },
      incompatibleTokens: ['Y', 'R', 'q', 'Q', 'M', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
    },
    // Local week of year
    w: {
      priority: 100,
      parse: function parse(string, token, match, _options) {
        switch (token) {
          case 'w':
            return parseNumericPattern(numericPatterns.week, string);

          case 'wo':
            return match.ordinalNumber(string, {
              unit: 'week'
            });

          default:
            return parseNDigits(token.length, string);
        }
      },
      validate: function validate(_date, value, _options) {
        return value >= 1 && value <= 53;
      },
      set: function set(date, _flags, value, options) {
        return startOfUTCWeek(setUTCWeek(date, value, options), options);
      },
      incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']
    },
    // ISO week of year
    I: {
      priority: 100,
      parse: function parse(string, token, match, _options) {
        switch (token) {
          case 'I':
            return parseNumericPattern(numericPatterns.week, string);

          case 'Io':
            return match.ordinalNumber(string, {
              unit: 'week'
            });

          default:
            return parseNDigits(token.length, string);
        }
      },
      validate: function validate(_date, value, _options) {
        return value >= 1 && value <= 53;
      },
      set: function set(date, _flags, value, options) {
        return startOfUTCISOWeek(setUTCISOWeek(date, value, options), options);
      },
      incompatibleTokens: ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']
    },
    // Day of the month
    d: {
      priority: 90,
      subPriority: 1,
      parse: function parse(string, token, match, _options) {
        switch (token) {
          case 'd':
            return parseNumericPattern(numericPatterns.date, string);

          case 'do':
            return match.ordinalNumber(string, {
              unit: 'date'
            });

          default:
            return parseNDigits(token.length, string);
        }
      },
      validate: function validate(date, value, _options) {
        var year = date.getUTCFullYear();
        var isLeapYear = isLeapYearIndex$1(year);
        var month = date.getUTCMonth();

        if (isLeapYear) {
          return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
        } else {
          return value >= 1 && value <= DAYS_IN_MONTH[month];
        }
      },
      set: function set(date, _flags, value, _options) {
        date.setUTCDate(value);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      },
      incompatibleTokens: ['Y', 'R', 'q', 'Q', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
    },
    // Day of year
    D: {
      priority: 90,
      subPriority: 1,
      parse: function parse(string, token, match, _options) {
        switch (token) {
          case 'D':
          case 'DD':
            return parseNumericPattern(numericPatterns.dayOfYear, string);

          case 'Do':
            return match.ordinalNumber(string, {
              unit: 'date'
            });

          default:
            return parseNDigits(token.length, string);
        }
      },
      validate: function validate(date, value, _options) {
        var year = date.getUTCFullYear();
        var isLeapYear = isLeapYearIndex$1(year);

        if (isLeapYear) {
          return value >= 1 && value <= 366;
        } else {
          return value >= 1 && value <= 365;
        }
      },
      set: function set(date, _flags, value, _options) {
        date.setUTCMonth(0, value);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      },
      incompatibleTokens: ['Y', 'R', 'q', 'Q', 'M', 'L', 'w', 'I', 'd', 'E', 'i', 'e', 'c', 't', 'T']
    },
    // Day of week
    E: {
      priority: 90,
      parse: function parse(string, token, match, _options) {
        switch (token) {
          // Tue
          case 'E':
          case 'EE':
          case 'EEE':
            return match.day(string, {
              width: 'abbreviated',
              context: 'formatting'
            }) || match.day(string, {
              width: 'short',
              context: 'formatting'
            }) || match.day(string, {
              width: 'narrow',
              context: 'formatting'
            });
          // T

          case 'EEEEE':
            return match.day(string, {
              width: 'narrow',
              context: 'formatting'
            });
          // Tu

          case 'EEEEEE':
            return match.day(string, {
              width: 'short',
              context: 'formatting'
            }) || match.day(string, {
              width: 'narrow',
              context: 'formatting'
            });
          // Tuesday

          case 'EEEE':
          default:
            return match.day(string, {
              width: 'wide',
              context: 'formatting'
            }) || match.day(string, {
              width: 'abbreviated',
              context: 'formatting'
            }) || match.day(string, {
              width: 'short',
              context: 'formatting'
            }) || match.day(string, {
              width: 'narrow',
              context: 'formatting'
            });
        }
      },
      validate: function validate(_date, value, _options) {
        return value >= 0 && value <= 6;
      },
      set: function set(date, _flags, value, options) {
        date = setUTCDay(date, value, options);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      },
      incompatibleTokens: ['D', 'i', 'e', 'c', 't', 'T']
    },
    // Local day of week
    e: {
      priority: 90,
      parse: function parse(string, token, match, options) {
        var valueCallback = function valueCallback(value) {
          var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
          return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
        };

        switch (token) {
          // 3
          case 'e':
          case 'ee':
            // 03
            return parseNDigits(token.length, string, valueCallback);
          // 3rd

          case 'eo':
            return match.ordinalNumber(string, {
              unit: 'day',
              valueCallback: valueCallback
            });
          // Tue

          case 'eee':
            return match.day(string, {
              width: 'abbreviated',
              context: 'formatting'
            }) || match.day(string, {
              width: 'short',
              context: 'formatting'
            }) || match.day(string, {
              width: 'narrow',
              context: 'formatting'
            });
          // T

          case 'eeeee':
            return match.day(string, {
              width: 'narrow',
              context: 'formatting'
            });
          // Tu

          case 'eeeeee':
            return match.day(string, {
              width: 'short',
              context: 'formatting'
            }) || match.day(string, {
              width: 'narrow',
              context: 'formatting'
            });
          // Tuesday

          case 'eeee':
          default:
            return match.day(string, {
              width: 'wide',
              context: 'formatting'
            }) || match.day(string, {
              width: 'abbreviated',
              context: 'formatting'
            }) || match.day(string, {
              width: 'short',
              context: 'formatting'
            }) || match.day(string, {
              width: 'narrow',
              context: 'formatting'
            });
        }
      },
      validate: function validate(_date, value, _options) {
        return value >= 0 && value <= 6;
      },
      set: function set(date, _flags, value, options) {
        date = setUTCDay(date, value, options);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      },
      incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'c', 't', 'T']
    },
    // Stand-alone local day of week
    c: {
      priority: 90,
      parse: function parse(string, token, match, options) {
        var valueCallback = function valueCallback(value) {
          var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
          return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
        };

        switch (token) {
          // 3
          case 'c':
          case 'cc':
            // 03
            return parseNDigits(token.length, string, valueCallback);
          // 3rd

          case 'co':
            return match.ordinalNumber(string, {
              unit: 'day',
              valueCallback: valueCallback
            });
          // Tue

          case 'ccc':
            return match.day(string, {
              width: 'abbreviated',
              context: 'standalone'
            }) || match.day(string, {
              width: 'short',
              context: 'standalone'
            }) || match.day(string, {
              width: 'narrow',
              context: 'standalone'
            });
          // T

          case 'ccccc':
            return match.day(string, {
              width: 'narrow',
              context: 'standalone'
            });
          // Tu

          case 'cccccc':
            return match.day(string, {
              width: 'short',
              context: 'standalone'
            }) || match.day(string, {
              width: 'narrow',
              context: 'standalone'
            });
          // Tuesday

          case 'cccc':
          default:
            return match.day(string, {
              width: 'wide',
              context: 'standalone'
            }) || match.day(string, {
              width: 'abbreviated',
              context: 'standalone'
            }) || match.day(string, {
              width: 'short',
              context: 'standalone'
            }) || match.day(string, {
              width: 'narrow',
              context: 'standalone'
            });
        }
      },
      validate: function validate(_date, value, _options) {
        return value >= 0 && value <= 6;
      },
      set: function set(date, _flags, value, options) {
        date = setUTCDay(date, value, options);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      },
      incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'e', 't', 'T']
    },
    // ISO day of week
    i: {
      priority: 90,
      parse: function parse(string, token, match, _options) {
        var valueCallback = function valueCallback(value) {
          if (value === 0) {
            return 7;
          }

          return value;
        };

        switch (token) {
          // 2
          case 'i':
          case 'ii':
            // 02
            return parseNDigits(token.length, string);
          // 2nd

          case 'io':
            return match.ordinalNumber(string, {
              unit: 'day'
            });
          // Tue

          case 'iii':
            return match.day(string, {
              width: 'abbreviated',
              context: 'formatting',
              valueCallback: valueCallback
            }) || match.day(string, {
              width: 'short',
              context: 'formatting',
              valueCallback: valueCallback
            }) || match.day(string, {
              width: 'narrow',
              context: 'formatting',
              valueCallback: valueCallback
            });
          // T

          case 'iiiii':
            return match.day(string, {
              width: 'narrow',
              context: 'formatting',
              valueCallback: valueCallback
            });
          // Tu

          case 'iiiiii':
            return match.day(string, {
              width: 'short',
              context: 'formatting',
              valueCallback: valueCallback
            }) || match.day(string, {
              width: 'narrow',
              context: 'formatting',
              valueCallback: valueCallback
            });
          // Tuesday

          case 'iiii':
          default:
            return match.day(string, {
              width: 'wide',
              context: 'formatting',
              valueCallback: valueCallback
            }) || match.day(string, {
              width: 'abbreviated',
              context: 'formatting',
              valueCallback: valueCallback
            }) || match.day(string, {
              width: 'short',
              context: 'formatting',
              valueCallback: valueCallback
            }) || match.day(string, {
              width: 'narrow',
              context: 'formatting',
              valueCallback: valueCallback
            });
        }
      },
      validate: function validate(_date, value, _options) {
        return value >= 1 && value <= 7;
      },
      set: function set(date, _flags, value, options) {
        date = setUTCISODay(date, value, options);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      },
      incompatibleTokens: ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'E', 'e', 'c', 't', 'T']
    },
    // AM or PM
    a: {
      priority: 80,
      parse: function parse(string, token, match, _options) {
        switch (token) {
          case 'a':
          case 'aa':
          case 'aaa':
            return match.dayPeriod(string, {
              width: 'abbreviated',
              context: 'formatting'
            }) || match.dayPeriod(string, {
              width: 'narrow',
              context: 'formatting'
            });

          case 'aaaaa':
            return match.dayPeriod(string, {
              width: 'narrow',
              context: 'formatting'
            });

          case 'aaaa':
          default:
            return match.dayPeriod(string, {
              width: 'wide',
              context: 'formatting'
            }) || match.dayPeriod(string, {
              width: 'abbreviated',
              context: 'formatting'
            }) || match.dayPeriod(string, {
              width: 'narrow',
              context: 'formatting'
            });
        }
      },
      set: function set(date, _flags, value, _options) {
        date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
        return date;
      },
      incompatibleTokens: ['b', 'B', 'H', 'K', 'k', 't', 'T']
    },
    // AM, PM, midnight
    b: {
      priority: 80,
      parse: function parse(string, token, match, _options) {
        switch (token) {
          case 'b':
          case 'bb':
          case 'bbb':
            return match.dayPeriod(string, {
              width: 'abbreviated',
              context: 'formatting'
            }) || match.dayPeriod(string, {
              width: 'narrow',
              context: 'formatting'
            });

          case 'bbbbb':
            return match.dayPeriod(string, {
              width: 'narrow',
              context: 'formatting'
            });

          case 'bbbb':
          default:
            return match.dayPeriod(string, {
              width: 'wide',
              context: 'formatting'
            }) || match.dayPeriod(string, {
              width: 'abbreviated',
              context: 'formatting'
            }) || match.dayPeriod(string, {
              width: 'narrow',
              context: 'formatting'
            });
        }
      },
      set: function set(date, _flags, value, _options) {
        date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
        return date;
      },
      incompatibleTokens: ['a', 'B', 'H', 'K', 'k', 't', 'T']
    },
    // in the morning, in the afternoon, in the evening, at night
    B: {
      priority: 80,
      parse: function parse(string, token, match, _options) {
        switch (token) {
          case 'B':
          case 'BB':
          case 'BBB':
            return match.dayPeriod(string, {
              width: 'abbreviated',
              context: 'formatting'
            }) || match.dayPeriod(string, {
              width: 'narrow',
              context: 'formatting'
            });

          case 'BBBBB':
            return match.dayPeriod(string, {
              width: 'narrow',
              context: 'formatting'
            });

          case 'BBBB':
          default:
            return match.dayPeriod(string, {
              width: 'wide',
              context: 'formatting'
            }) || match.dayPeriod(string, {
              width: 'abbreviated',
              context: 'formatting'
            }) || match.dayPeriod(string, {
              width: 'narrow',
              context: 'formatting'
            });
        }
      },
      set: function set(date, _flags, value, _options) {
        date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
        return date;
      },
      incompatibleTokens: ['a', 'b', 't', 'T']
    },
    // Hour [1-12]
    h: {
      priority: 70,
      parse: function parse(string, token, match, _options) {
        switch (token) {
          case 'h':
            return parseNumericPattern(numericPatterns.hour12h, string);

          case 'ho':
            return match.ordinalNumber(string, {
              unit: 'hour'
            });

          default:
            return parseNDigits(token.length, string);
        }
      },
      validate: function validate(_date, value, _options) {
        return value >= 1 && value <= 12;
      },
      set: function set(date, _flags, value, _options) {
        var isPM = date.getUTCHours() >= 12;

        if (isPM && value < 12) {
          date.setUTCHours(value + 12, 0, 0, 0);
        } else if (!isPM && value === 12) {
          date.setUTCHours(0, 0, 0, 0);
        } else {
          date.setUTCHours(value, 0, 0, 0);
        }

        return date;
      },
      incompatibleTokens: ['H', 'K', 'k', 't', 'T']
    },
    // Hour [0-23]
    H: {
      priority: 70,
      parse: function parse(string, token, match, _options) {
        switch (token) {
          case 'H':
            return parseNumericPattern(numericPatterns.hour23h, string);

          case 'Ho':
            return match.ordinalNumber(string, {
              unit: 'hour'
            });

          default:
            return parseNDigits(token.length, string);
        }
      },
      validate: function validate(_date, value, _options) {
        return value >= 0 && value <= 23;
      },
      set: function set(date, _flags, value, _options) {
        date.setUTCHours(value, 0, 0, 0);
        return date;
      },
      incompatibleTokens: ['a', 'b', 'h', 'K', 'k', 't', 'T']
    },
    // Hour [0-11]
    K: {
      priority: 70,
      parse: function parse(string, token, match, _options) {
        switch (token) {
          case 'K':
            return parseNumericPattern(numericPatterns.hour11h, string);

          case 'Ko':
            return match.ordinalNumber(string, {
              unit: 'hour'
            });

          default:
            return parseNDigits(token.length, string);
        }
      },
      validate: function validate(_date, value, _options) {
        return value >= 0 && value <= 11;
      },
      set: function set(date, _flags, value, _options) {
        var isPM = date.getUTCHours() >= 12;

        if (isPM && value < 12) {
          date.setUTCHours(value + 12, 0, 0, 0);
        } else {
          date.setUTCHours(value, 0, 0, 0);
        }

        return date;
      },
      incompatibleTokens: ['a', 'b', 'h', 'H', 'k', 't', 'T']
    },
    // Hour [1-24]
    k: {
      priority: 70,
      parse: function parse(string, token, match, _options) {
        switch (token) {
          case 'k':
            return parseNumericPattern(numericPatterns.hour24h, string);

          case 'ko':
            return match.ordinalNumber(string, {
              unit: 'hour'
            });

          default:
            return parseNDigits(token.length, string);
        }
      },
      validate: function validate(_date, value, _options) {
        return value >= 1 && value <= 24;
      },
      set: function set(date, _flags, value, _options) {
        var hours = value <= 24 ? value % 24 : value;
        date.setUTCHours(hours, 0, 0, 0);
        return date;
      },
      incompatibleTokens: ['a', 'b', 'h', 'H', 'K', 't', 'T']
    },
    // Minute
    m: {
      priority: 60,
      parse: function parse(string, token, match, _options) {
        switch (token) {
          case 'm':
            return parseNumericPattern(numericPatterns.minute, string);

          case 'mo':
            return match.ordinalNumber(string, {
              unit: 'minute'
            });

          default:
            return parseNDigits(token.length, string);
        }
      },
      validate: function validate(_date, value, _options) {
        return value >= 0 && value <= 59;
      },
      set: function set(date, _flags, value, _options) {
        date.setUTCMinutes(value, 0, 0);
        return date;
      },
      incompatibleTokens: ['t', 'T']
    },
    // Second
    s: {
      priority: 50,
      parse: function parse(string, token, match, _options) {
        switch (token) {
          case 's':
            return parseNumericPattern(numericPatterns.second, string);

          case 'so':
            return match.ordinalNumber(string, {
              unit: 'second'
            });

          default:
            return parseNDigits(token.length, string);
        }
      },
      validate: function validate(_date, value, _options) {
        return value >= 0 && value <= 59;
      },
      set: function set(date, _flags, value, _options) {
        date.setUTCSeconds(value, 0);
        return date;
      },
      incompatibleTokens: ['t', 'T']
    },
    // Fraction of second
    S: {
      priority: 30,
      parse: function parse(string, token, _match, _options) {
        var valueCallback = function valueCallback(value) {
          return Math.floor(value * Math.pow(10, -token.length + 3));
        };

        return parseNDigits(token.length, string, valueCallback);
      },
      set: function set(date, _flags, value, _options) {
        date.setUTCMilliseconds(value);
        return date;
      },
      incompatibleTokens: ['t', 'T']
    },
    // Timezone (ISO-8601. +00:00 is `'Z'`)
    X: {
      priority: 10,
      parse: function parse(string, token, _match, _options) {
        switch (token) {
          case 'X':
            return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, string);

          case 'XX':
            return parseTimezonePattern(timezonePatterns.basic, string);

          case 'XXXX':
            return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, string);

          case 'XXXXX':
            return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, string);

          case 'XXX':
          default:
            return parseTimezonePattern(timezonePatterns.extended, string);
        }
      },
      set: function set(date, flags, value, _options) {
        if (flags.timestampIsSet) {
          return date;
        }

        return new Date(date.getTime() - value);
      },
      incompatibleTokens: ['t', 'T', 'x']
    },
    // Timezone (ISO-8601)
    x: {
      priority: 10,
      parse: function parse(string, token, _match, _options) {
        switch (token) {
          case 'x':
            return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, string);

          case 'xx':
            return parseTimezonePattern(timezonePatterns.basic, string);

          case 'xxxx':
            return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, string);

          case 'xxxxx':
            return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, string);

          case 'xxx':
          default:
            return parseTimezonePattern(timezonePatterns.extended, string);
        }
      },
      set: function set(date, flags, value, _options) {
        if (flags.timestampIsSet) {
          return date;
        }

        return new Date(date.getTime() - value);
      },
      incompatibleTokens: ['t', 'T', 'X']
    },
    // Seconds timestamp
    t: {
      priority: 40,
      parse: function parse(string, _token, _match, _options) {
        return parseAnyDigitsSigned(string);
      },
      set: function set(_date, _flags, value, _options) {
        return [new Date(value * 1000), {
          timestampIsSet: true
        }];
      },
      incompatibleTokens: '*'
    },
    // Milliseconds timestamp
    T: {
      priority: 20,
      parse: function parse(string, _token, _match, _options) {
        return parseAnyDigitsSigned(string);
      },
      set: function set(_date, _flags, value, _options) {
        return [new Date(value), {
          timestampIsSet: true
        }];
      },
      incompatibleTokens: '*'
    }
  };
  var parsers$1 = parsers;
  var TIMEZONE_UNIT_PRIORITY = 10; // This RegExp consists of three parts separated by `|`:
  // - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
  //   (one of the certain letters followed by `o`)
  // - (\w)\1* matches any sequences of the same letter
  // - '' matches two quote characters in a row
  // - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
  //   except a single quote symbol, which ends the sequence.
  //   Two quote characters do not end the sequence.
  //   If there is no matching single quote
  //   then the sequence will continue until the end of the string.
  // - . matches any single character unmatched by previous parts of the RegExps

  var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
  // sequences of symbols P, p, and the combinations like `PPPPPPPppppp`

  var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
  var escapedStringRegExp = /^'([^]*?)'?$/;
  var doubleQuoteRegExp = /''/g;
  var notWhitespaceRegExp = /\S/;
  var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
  /**
   * @name parse
   * @category Common Helpers
   * @summary Parse the date.
   *
   * @description
   * Return the date parsed from string using the given format string.
   *
   * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
   * > See: https://git.io/fxCyr
   *
   * The characters in the format string wrapped between two single quotes characters (') are escaped.
   * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
   *
   * Format of the format string is based on Unicode Technical Standard #35:
   * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
   * with a few additions (see note 5 below the table).
   *
   * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
   * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
   *
   * ```javascript
   * parse('23 AM', 'HH a', new Date())
   * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
   * ```
   *
   * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
   *
   * Accepted format string patterns:
   * | Unit                            |Prior| Pattern | Result examples                   | Notes |
   * |---------------------------------|-----|---------|-----------------------------------|-------|
   * | Era                             | 140 | G..GGG  | AD, BC                            |       |
   * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
   * |                                 |     | GGGGG   | A, B                              |       |
   * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
   * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
   * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
   * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
   * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
   * |                                 |     | yyyyy   | ...                               | 2,4   |
   * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
   * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
   * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
   * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
   * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
   * |                                 |     | YYYYY   | ...                               | 2,4   |
   * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
   * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
   * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
   * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
   * |                                 |     | RRRRR   | ...                               | 2,4,5 |
   * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
   * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
   * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
   * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
   * |                                 |     | uuuuu   | ...                               | 2,4   |
   * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
   * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
   * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
   * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
   * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
   * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
   * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
   * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
   * |                                 |     | qq      | 01, 02, 03, 04                    |       |
   * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
   * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
   * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
   * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
   * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
   * |                                 |     | MM      | 01, 02, ..., 12                   |       |
   * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
   * |                                 |     | MMMM    | January, February, ..., December  | 2     |
   * |                                 |     | MMMMM   | J, F, ..., D                      |       |
   * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
   * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
   * |                                 |     | LL      | 01, 02, ..., 12                   |       |
   * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
   * |                                 |     | LLLL    | January, February, ..., December  | 2     |
   * |                                 |     | LLLLL   | J, F, ..., D                      |       |
   * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
   * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
   * |                                 |     | ww      | 01, 02, ..., 53                   |       |
   * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
   * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
   * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
   * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
   * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
   * |                                 |     | dd      | 01, 02, ..., 31                   |       |
   * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
   * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
   * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
   * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
   * |                                 |     | DDDD    | ...                               | 2     |
   * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
   * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
   * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
   * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
   * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
   * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
   * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
   * |                                 |     | iii     | Mon, Tue, Wed, ..., Sun           | 5     |
   * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
   * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
   * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
   * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
   * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
   * |                                 |     | ee      | 02, 03, ..., 01                   |       |
   * |                                 |     | eee     | Mon, Tue, Wed, ..., Sun           |       |
   * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
   * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
   * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
   * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
   * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
   * |                                 |     | cc      | 02, 03, ..., 01                   |       |
   * |                                 |     | ccc     | Mon, Tue, Wed, ..., Sun           |       |
   * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
   * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
   * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
   * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
   * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
   * |                                 |     | aaaaa   | a, p                              |       |
   * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
   * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
   * |                                 |     | bbbbb   | a, p, n, mi                       |       |
   * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
   * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
   * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
   * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
   * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
   * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
   * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
   * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
   * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
   * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
   * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
   * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
   * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
   * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
   * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
   * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
   * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
   * |                                 |     | mm      | 00, 01, ..., 59                   |       |
   * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
   * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
   * |                                 |     | ss      | 00, 01, ..., 59                   |       |
   * | Seconds timestamp               |  40 | t       | 512969520                         |       |
   * |                                 |     | tt      | ...                               | 2     |
   * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
   * |                                 |     | SS      | 00, 01, ..., 99                   |       |
   * |                                 |     | SSS     | 000, 0001, ..., 999               |       |
   * |                                 |     | SSSS    | ...                               | 2     |
   * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
   * |                                 |     | TT      | ...                               | 2     |
   * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
   * |                                 |     | XX      | -0800, +0530, Z                   |       |
   * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
   * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
   * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
   * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
   * |                                 |     | xx      | -0800, +0530, +0000               |       |
   * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
   * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
   * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
   * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
   * |                                 |     | PP      | May 29, 1453                      |       |
   * |                                 |     | PPP     | May 29th, 1453                    |       |
   * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
   * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
   * |                                 |     | pp      | 12:00:00 AM                       |       |
   * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
   * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
   * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
   * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
   * Notes:
   * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
   *    are the same as "stand-alone" units, but are different in some languages.
   *    "Formatting" units are declined according to the rules of the language
   *    in the context of a date. "Stand-alone" units are always nominative singular.
   *    In `format` function, they will produce different result:
   *
   *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
   *
   *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
   *
   *    `parse` will try to match both formatting and stand-alone units interchangably.
   *
   * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
   *    the single quote characters (see below).
   *    If the sequence is longer than listed in table:
   *    - for numerical units (`yyyyyyyy`) `parse` will try to match a number
   *      as wide as the sequence
   *    - for text units (`MMMMMMMM`) `parse` will try to match the widest variation of the unit.
   *      These variations are marked with "2" in the last column of the table.
   *
   * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
   *    These tokens represent the shortest form of the quarter.
   *
   * 4. The main difference between `y` and `u` patterns are B.C. years:
   *
   *    | Year | `y` | `u` |
   *    |------|-----|-----|
   *    | AC 1 |   1 |   1 |
   *    | BC 1 |   1 |   0 |
   *    | BC 2 |   2 |  -1 |
   *
   *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
   *
   *    `parse('50', 'yy', new Date(2018, 0, 1)) //=> Sat Jan 01 2050 00:00:00`
   *
   *    `parse('75', 'yy', new Date(2018, 0, 1)) //=> Wed Jan 01 1975 00:00:00`
   *
   *    while `uu` will just assign the year as is:
   *
   *    `parse('50', 'uu', new Date(2018, 0, 1)) //=> Sat Jan 01 0050 00:00:00`
   *
   *    `parse('75', 'uu', new Date(2018, 0, 1)) //=> Tue Jan 01 0075 00:00:00`
   *
   *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
   *    except local week-numbering years are dependent on `options.weekStartsOn`
   *    and `options.firstWeekContainsDate` (compare [setISOWeekYear]{@link https://date-fns.org/docs/setISOWeekYear}
   *    and [setWeekYear]{@link https://date-fns.org/docs/setWeekYear}).
   *
   * 5. These patterns are not in the Unicode Technical Standard #35:
   *    - `i`: ISO day of week
   *    - `I`: ISO week of year
   *    - `R`: ISO week-numbering year
   *    - `o`: ordinal number modifier
   *    - `P`: long localized date
   *    - `p`: long localized time
   *
   * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
   *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
   *
   * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
   *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
   *
   * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
   *    on the given locale.
   *
   *    using `en-US` locale: `P` => `MM/dd/yyyy`
   *    using `en-US` locale: `p` => `hh:mm a`
   *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
   *    using `pt-BR` locale: `p` => `HH:mm`
   *
   * Values will be assigned to the date in the descending order of its unit's priority.
   * Units of an equal priority overwrite each other in the order of appearance.
   *
   * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
   * the values will be taken from 3rd argument `referenceDate` which works as a context of parsing.
   *
   * `referenceDate` must be passed for correct work of the function.
   * If you're not sure which `referenceDate` to supply, create a new instance of Date:
   * `parse('02/11/2014', 'MM/dd/yyyy', new Date())`
   * In this case parsing will be done in the context of the current date.
   * If `referenceDate` is `Invalid Date` or a value not convertible to valid `Date`,
   * then `Invalid Date` will be returned.
   *
   * The result may vary by locale.
   *
   * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
   *
   * If parsing failed, `Invalid Date` will be returned.
   * Invalid Date is a Date, whose time value is NaN.
   * Time value of Date: http://es5.github.io/#x15.9.1.1
   *
   * ### v2.0.0 breaking changes:
   *
   * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
   *
   * - Old `parse` was renamed to `toDate`.
   *   Now `parse` is a new function which parses a string using a provided format.
   *
   *   ```javascript
   *   // Before v2.0.0
   *   parse('2016-01-01')
   *
   *   // v2.0.0 onward (toDate no longer accepts a string)
   *   toDate(1392098430000) // Unix to timestamp
   *   toDate(new Date(2014, 1, 11, 11, 30, 30)) // Cloning the date
   *   parse('2016-01-01', 'yyyy-MM-dd', new Date())
   *   ```
   *
   * @param {String} dateString - the string to parse
   * @param {String} formatString - the string of tokens
   * @param {Date|Number} referenceDate - defines values missing from the parsed dateString
   * @param {Object} [options] - an object with options.
   * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
   * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
   * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
   * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
   *   see: https://git.io/fxCyr
   * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
   *   see: https://git.io/fxCyr
   * @returns {Date} the parsed date
   * @throws {TypeError} 3 arguments required
   * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
   * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
   * @throws {RangeError} `options.locale` must contain `match` property
   * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
   * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
   * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
   * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
   * @throws {RangeError} format string contains an unescaped latin alphabet character
   *
   * @example
   * // Parse 11 February 2014 from middle-endian format:
   * var result = parse('02/11/2014', 'MM/dd/yyyy', new Date())
   * //=> Tue Feb 11 2014 00:00:00
   *
   * @example
   * // Parse 28th of February in Esperanto locale in the context of 2010 year:
   * import eo from 'date-fns/locale/eo'
   * var result = parse('28-a de februaro', "do 'de' MMMM", new Date(2010, 0, 1), {
   *   locale: eo
   * })
   * //=> Sun Feb 28 2010 00:00:00
   */

  function parse(dirtyDateString, dirtyFormatString, dirtyReferenceDate, dirtyOptions) {
    requiredArgs(3, arguments);
    var dateString = String(dirtyDateString);
    var formatString = String(dirtyFormatString);
    var options = dirtyOptions || {};
    var locale = options.locale || defaultLocale;

    if (!locale.match) {
      throw new RangeError('locale must contain match property');
    }

    var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
      throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    }

    var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
      throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    }

    if (formatString === '') {
      if (dateString === '') {
        return toDate(dirtyReferenceDate);
      } else {
        return new Date(NaN);
      }
    }

    var subFnOptions = {
      firstWeekContainsDate: firstWeekContainsDate,
      weekStartsOn: weekStartsOn,
      locale: locale
    }; // If timezone isn't specified, it will be set to the system timezone

    var setters = [{
      priority: TIMEZONE_UNIT_PRIORITY,
      subPriority: -1,
      set: dateToSystemTimezone,
      index: 0
    }];
    var i;
    var tokens = formatString.match(longFormattingTokensRegExp).map(function (substring) {
      var firstCharacter = substring[0];

      if (firstCharacter === 'p' || firstCharacter === 'P') {
        var longFormatter = longFormatters$3[firstCharacter];
        return longFormatter(substring, locale.formatLong, subFnOptions);
      }

      return substring;
    }).join('').match(formattingTokensRegExp);
    var usedTokens = [];

    for (i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (!options.useAdditionalWeekYearTokens && isProtectedWeekYearToken(token)) {
        throwProtectedError(token, formatString, dirtyDateString);
      }

      if (!options.useAdditionalDayOfYearTokens && isProtectedDayOfYearToken(token)) {
        throwProtectedError(token, formatString, dirtyDateString);
      }

      var firstCharacter = token[0];
      var parser = parsers$1[firstCharacter];

      if (parser) {
        var incompatibleTokens = parser.incompatibleTokens;

        if (Array.isArray(incompatibleTokens)) {
          var incompatibleToken = void 0;

          for (var _i = 0; _i < usedTokens.length; _i++) {
            var usedToken = usedTokens[_i].token;

            if (incompatibleTokens.indexOf(usedToken) !== -1 || usedToken === firstCharacter) {
              incompatibleToken = usedTokens[_i];
              break;
            }
          }

          if (incompatibleToken) {
            throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
          }
        } else if (parser.incompatibleTokens === '*' && usedTokens.length) {
          throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
        }

        usedTokens.push({
          token: firstCharacter,
          fullToken: token
        });
        var parseResult = parser.parse(dateString, token, locale.match, subFnOptions);

        if (!parseResult) {
          return new Date(NaN);
        }

        setters.push({
          priority: parser.priority,
          subPriority: parser.subPriority || 0,
          set: parser.set,
          validate: parser.validate,
          value: parseResult.value,
          index: setters.length
        });
        dateString = parseResult.rest;
      } else {
        if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
          throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        } // Replace two single quote characters with one single quote character


        if (token === "''") {
          token = "'";
        } else if (firstCharacter === "'") {
          token = cleanEscapedString(token);
        } // Cut token from string, or, if string doesn't match the token, return Invalid Date


        if (dateString.indexOf(token) === 0) {
          dateString = dateString.slice(token.length);
        } else {
          return new Date(NaN);
        }
      }
    } // Check if the remaining input contains something other than whitespace


    if (dateString.length > 0 && notWhitespaceRegExp.test(dateString)) {
      return new Date(NaN);
    }

    var uniquePrioritySetters = setters.map(function (setter) {
      return setter.priority;
    }).sort(function (a, b) {
      return b - a;
    }).filter(function (priority, index, array) {
      return array.indexOf(priority) === index;
    }).map(function (priority) {
      return setters.filter(function (setter) {
        return setter.priority === priority;
      }).sort(function (a, b) {
        return b.subPriority - a.subPriority;
      });
    }).map(function (setterArray) {
      return setterArray[0];
    });
    var date = toDate(dirtyReferenceDate);

    if (isNaN(date)) {
      return new Date(NaN);
    } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/37


    var utcDate = subMilliseconds(date, getTimezoneOffsetInMilliseconds(date));
    var flags = {};

    for (i = 0; i < uniquePrioritySetters.length; i++) {
      var setter = uniquePrioritySetters[i];

      if (setter.validate && !setter.validate(utcDate, setter.value, subFnOptions)) {
        return new Date(NaN);
      }

      var result = setter.set(utcDate, flags, setter.value, subFnOptions); // Result is tuple (date, flags)

      if (result[0]) {
        utcDate = result[0];
        assign(flags, result[1]); // Result is date
      } else {
        utcDate = result;
      }
    }

    return utcDate;
  }

  function dateToSystemTimezone(date, flags) {
    if (flags.timestampIsSet) {
      return date;
    }

    var convertedDate = new Date(0);
    convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
    convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
    return convertedDate;
  }

  function cleanEscapedString(input) {
    return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
  }
  /**
   * @name setHours
   * @category Hour Helpers
   * @summary Set the hours to the given date.
   *
   * @description
   * Set the hours to the given date.
   *
   * ### v2.0.0 breaking changes:
   *
   * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
   *
   * @param {Date|Number} date - the date to be changed
   * @param {Number} hours - the hours of the new date
   * @returns {Date} the new date with the hours set
   * @throws {TypeError} 2 arguments required
   *
   * @example
   * // Set 4 hours to 1 September 2014 11:30:00:
   * var result = setHours(new Date(2014, 8, 1, 11, 30), 4)
   * //=> Mon Sep 01 2014 04:30:00
   */


  function setHours(dirtyDate, dirtyHours) {
    requiredArgs(2, arguments);
    var date = toDate(dirtyDate);
    var hours = toInteger(dirtyHours);
    date.setHours(hours);
    return date;
  }
  /**
   * @name setMinutes
   * @category Minute Helpers
   * @summary Set the minutes to the given date.
   *
   * @description
   * Set the minutes to the given date.
   *
   * ### v2.0.0 breaking changes:
   *
   * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
   *
   * @param {Date|Number} date - the date to be changed
   * @param {Number} minutes - the minutes of the new date
   * @returns {Date} the new date with the minutes set
   * @throws {TypeError} 2 arguments required
   *
   * @example
   * // Set 45 minutes to 1 September 2014 11:30:40:
   * const result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
   * //=> Mon Sep 01 2014 11:45:40
   */


  function setMinutes(dirtyDate, dirtyMinutes) {
    requiredArgs(2, arguments);
    var date = toDate(dirtyDate);
    var minutes = toInteger(dirtyMinutes);
    date.setMinutes(minutes);
    return date;
  }
  /**
   * @name getDaysInMonth
   * @category Month Helpers
   * @summary Get the number of days in a month of the given date.
   *
   * @description
   * Get the number of days in a month of the given date.
   *
   * ### v2.0.0 breaking changes:
   *
   * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
   *
   * @param {Date|Number} date - the given date
   * @returns {Number} the number of days in a month
   * @throws {TypeError} 1 argument required
   *
   * @example
   * // How many days are in February 2000?
   * const result = getDaysInMonth(new Date(2000, 1))
   * //=> 29
   */


  function getDaysInMonth(dirtyDate) {
    requiredArgs(1, arguments);
    var date = toDate(dirtyDate);
    var year = date.getFullYear();
    var monthIndex = date.getMonth();
    var lastDayOfMonth = new Date(0);
    lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
    lastDayOfMonth.setHours(0, 0, 0, 0);
    return lastDayOfMonth.getDate();
  }
  /**
   * @name setMonth
   * @category Month Helpers
   * @summary Set the month to the given date.
   *
   * @description
   * Set the month to the given date.
   *
   * ### v2.0.0 breaking changes:
   *
   * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
   *
   * @param {Date|Number} date - the date to be changed
   * @param {Number} month - the month of the new date
   * @returns {Date} the new date with the month set
   * @throws {TypeError} 2 arguments required
   *
   * @example
   * // Set February to 1 September 2014:
   * const result = setMonth(new Date(2014, 8, 1), 1)
   * //=> Sat Feb 01 2014 00:00:00
   */


  function setMonth(dirtyDate, dirtyMonth) {
    requiredArgs(2, arguments);
    var date = toDate(dirtyDate);
    var month = toInteger(dirtyMonth);
    var year = date.getFullYear();
    var day = date.getDate();
    var dateWithDesiredMonth = new Date(0);
    dateWithDesiredMonth.setFullYear(year, month, 15);
    dateWithDesiredMonth.setHours(0, 0, 0, 0);
    var daysInMonth = getDaysInMonth(dateWithDesiredMonth); // Set the last day of the new month
    // if the original date was the last day of the longer month

    date.setMonth(month, Math.min(day, daysInMonth));
    return date;
  }
  /**
   * @name getDay
   * @category Weekday Helpers
   * @summary Get the day of the week of the given date.
   *
   * @description
   * Get the day of the week of the given date.
   *
   * ### v2.0.0 breaking changes:
   *
   * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
   *
   * @param {Date|Number} date - the given date
   * @returns {0|1|2|3|4|5|6} the day of week, 0 represents Sunday
   * @throws {TypeError} 1 argument required
   *
   * @example
   * // Which day of the week is 29 February 2012?
   * const result = getDay(new Date(2012, 1, 29))
   * //=> 3
   */


  function getDay(dirtyDate) {
    requiredArgs(1, arguments);
    var date = toDate(dirtyDate);
    var day = date.getDay();
    return day;
  }
  /**
   * @name setSeconds
   * @category Second Helpers
   * @summary Set the seconds to the given date.
   *
   * @description
   * Set the seconds to the given date.
   *
   * ### v2.0.0 breaking changes:
   *
   * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
   *
   * @param {Date|Number} date - the date to be changed
   * @param {Number} seconds - the seconds of the new date
   * @returns {Date} the new date with the seconds set
   * @throws {TypeError} 2 arguments required
   *
   * @example
   * // Set 45 seconds to 1 September 2014 11:30:40:
   * const result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
   * //=> Mon Sep 01 2014 11:30:45
   */


  function setSeconds(dirtyDate, dirtySeconds) {
    requiredArgs(2, arguments);
    var date = toDate(dirtyDate);
    var seconds = toInteger(dirtySeconds);
    date.setSeconds(seconds);
    return date;
  }
  /**
   * @name setYear
   * @category Year Helpers
   * @summary Set the year to the given date.
   *
   * @description
   * Set the year to the given date.
   *
   * ### v2.0.0 breaking changes:
   *
   * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
   *
   * @param {Date|Number} date - the date to be changed
   * @param {Number} year - the year of the new date
   * @returns {Date} the new date with the year set
   * @throws {TypeError} 2 arguments required
   *
   * @example
   * // Set year 2013 to 1 September 2014:
   * const result = setYear(new Date(2014, 8, 1), 2013)
   * //=> Sun Sep 01 2013 00:00:00
   */


  function setYear(dirtyDate, dirtyYear) {
    requiredArgs(2, arguments);
    var date = toDate(dirtyDate);
    var year = toInteger(dirtyYear); // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date

    if (isNaN(date.getTime())) {
      return new Date(NaN);
    }

    date.setFullYear(year);
    return date;
  }
  /**
   * @name startOfMonth
   * @category Month Helpers
   * @summary Return the start of a month for the given date.
   *
   * @description
   * Return the start of a month for the given date.
   * The result will be in the local timezone.
   *
   * ### v2.0.0 breaking changes:
   *
   * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
   *
   * @param {Date|Number} date - the original date
   * @returns {Date} the start of a month
   * @throws {TypeError} 1 argument required
   *
   * @example
   * // The start of a month for 2 September 2014 11:55:00:
   * const result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
   * //=> Mon Sep 01 2014 00:00:00
   */


  function startOfMonth(dirtyDate) {
    requiredArgs(1, arguments);
    var date = toDate(dirtyDate);
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
    return date;
  }
  /**
   * @name startOfWeek
   * @category Week Helpers
   * @summary Return the start of a week for the given date.
   *
   * @description
   * Return the start of a week for the given date.
   * The result will be in the local timezone.
   *
   * ### v2.0.0 breaking changes:
   *
   * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
   *
   * @param {Date|Number} date - the original date
   * @param {Object} [options] - an object with options.
   * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
   * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
   * @returns {Date} the start of a week
   * @throws {TypeError} 1 argument required
   * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
   *
   * @example
   * // The start of a week for 2 September 2014 11:55:00:
   * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
   * //=> Sun Aug 31 2014 00:00:00
   *
   * @example
   * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
   * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
   * //=> Mon Sep 01 2014 00:00:00
   */


  function startOfWeek(dirtyDate, dirtyOptions) {
    requiredArgs(1, arguments);
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
      throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    }

    var date = toDate(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setDate(date.getDate() - diff);
    date.setHours(0, 0, 0, 0);
    return date;
  }
  /**
   * @name startOfYear
   * @category Year Helpers
   * @summary Return the start of a year for the given date.
   *
   * @description
   * Return the start of a year for the given date.
   * The result will be in the local timezone.
   *
   * ### v2.0.0 breaking changes:
   *
   * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
   *
   * @param {Date|Number} date - the original date
   * @returns {Date} the start of a year
   * @throws {TypeError} 1 argument required
   *
   * @example
   * // The start of a year for 2 September 2014 11:55:00:
   * const result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
   * //=> Wed Jan 01 2014 00:00:00
   */


  function startOfYear(dirtyDate) {
    requiredArgs(1, arguments);
    var cleanDate = toDate(dirtyDate);
    var date = new Date(0);
    date.setFullYear(cleanDate.getFullYear(), 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  var MILLISECONDS_IN_HOUR = 3600000;
  var MILLISECONDS_IN_MINUTE = 60000;
  var DEFAULT_ADDITIONAL_DIGITS = 2;
  var patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
  };
  var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
  var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
  var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
  /**
   * @name parseISO
   * @category Common Helpers
   * @summary Parse ISO string
   *
   * @description
   * Parse the given string in ISO 8601 format and return an instance of Date.
   *
   * Function accepts complete ISO 8601 formats as well as partial implementations.
   * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
   *
   * If the argument isn't a string, the function cannot parse the string or
   * the values are invalid, it returns Invalid Date.
   *
   * ### v2.0.0 breaking changes:
   *
   * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
   *
   * - The previous `parse` implementation was renamed to `parseISO`.
   *
   *   ```javascript
   *   // Before v2.0.0
   *   parse('2016-01-01')
   *
   *   // v2.0.0 onward
   *   parseISO('2016-01-01')
   *   ```
   *
   * - `parseISO` now validates separate date and time values in ISO-8601 strings
   *   and returns `Invalid Date` if the date is invalid.
   *
   *   ```javascript
   *   parseISO('2018-13-32')
   *   //=> Invalid Date
   *   ```
   *
   * - `parseISO` now doesn't fall back to `new Date` constructor
   *   if it fails to parse a string argument. Instead, it returns `Invalid Date`.
   *
   * @param {String} argument - the value to convert
   * @param {Object} [options] - an object with options.
   * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
   * @returns {Date} the parsed date in the local time zone
   * @throws {TypeError} 1 argument required
   * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
   *
   * @example
   * // Convert string '2014-02-11T11:30:30' to date:
   * var result = parseISO('2014-02-11T11:30:30')
   * //=> Tue Feb 11 2014 11:30:30
   *
   * @example
   * // Convert string '+02014101' to date,
   * // if the additional number of digits in the extended year format is 1:
   * var result = parseISO('+02014101', { additionalDigits: 1 })
   * //=> Fri Apr 11 2014 00:00:00
   */

  function parseISO(argument, dirtyOptions) {
    requiredArgs(1, arguments);
    var options = dirtyOptions || {};
    var additionalDigits = options.additionalDigits == null ? DEFAULT_ADDITIONAL_DIGITS : toInteger(options.additionalDigits);

    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
      throw new RangeError('additionalDigits must be 0, 1 or 2');
    }

    if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) {
      return new Date(NaN);
    }

    var dateStrings = splitDateString(argument);
    var date;

    if (dateStrings.date) {
      var parseYearResult = parseYear(dateStrings.date, additionalDigits);
      date = parseDate(parseYearResult.restDateString, parseYearResult.year);
    }

    if (isNaN(date) || !date) {
      return new Date(NaN);
    }

    var timestamp = date.getTime();
    var time = 0;
    var offset;

    if (dateStrings.time) {
      time = parseTime(dateStrings.time);

      if (isNaN(time) || time === null) {
        return new Date(NaN);
      }
    }

    if (dateStrings.timezone) {
      offset = parseTimezone(dateStrings.timezone);

      if (isNaN(offset)) {
        return new Date(NaN);
      }
    } else {
      var dirtyDate = new Date(timestamp + time); // js parsed string assuming it's in UTC timezone
      // but we need it to be parsed in our timezone
      // so we use utc values to build date in our timezone.
      // Year values from 0 to 99 map to the years 1900 to 1999
      // so set year explicitly with setFullYear.

      var result = new Date(0);
      result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
      result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
      return result;
    }

    return new Date(timestamp + time + offset);
  }

  function splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split(patterns.dateTimeDelimiter);
    var timeString; // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].

    if (array.length > 2) {
      return dateStrings;
    }

    if (/:/.test(array[0])) {
      dateStrings.date = null;
      timeString = array[0];
    } else {
      dateStrings.date = array[0];
      timeString = array[1];

      if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
        dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
        timeString = dateString.substr(dateStrings.date.length, dateString.length);
      }
    }

    if (timeString) {
      var token = patterns.timezone.exec(timeString);

      if (token) {
        dateStrings.time = timeString.replace(token[1], '');
        dateStrings.timezone = token[1];
      } else {
        dateStrings.time = timeString;
      }
    }

    return dateStrings;
  }

  function parseYear(dateString, additionalDigits) {
    var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
    var captures = dateString.match(regex); // Invalid ISO-formatted year

    if (!captures) return {
      year: null
    };
    var year = captures[1] && parseInt(captures[1]);
    var century = captures[2] && parseInt(captures[2]);
    return {
      year: century == null ? year : century * 100,
      restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
  }

  function parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return null;
    var captures = dateString.match(dateRegex); // Invalid ISO-formatted string

    if (!captures) return null;
    var isWeekDate = !!captures[4];
    var dayOfYear = parseDateUnit(captures[1]);
    var month = parseDateUnit(captures[2]) - 1;
    var day = parseDateUnit(captures[3]);
    var week = parseDateUnit(captures[4]);
    var dayOfWeek = parseDateUnit(captures[5]) - 1;

    if (isWeekDate) {
      if (!validateWeekDate(year, week, dayOfWeek)) {
        return new Date(NaN);
      }

      return dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
      var date = new Date(0);

      if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) {
        return new Date(NaN);
      }

      date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
      return date;
    }
  }

  function parseDateUnit(value) {
    return value ? parseInt(value) : 1;
  }

  function parseTime(timeString) {
    var captures = timeString.match(timeRegex);
    if (!captures) return null; // Invalid ISO-formatted time

    var hours = parseTimeUnit(captures[1]);
    var minutes = parseTimeUnit(captures[2]);
    var seconds = parseTimeUnit(captures[3]);

    if (!validateTime(hours, minutes, seconds)) {
      return NaN;
    }

    return hours * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE + seconds * 1000;
  }

  function parseTimeUnit(value) {
    return value && parseFloat(value.replace(',', '.')) || 0;
  }

  function parseTimezone(timezoneString) {
    if (timezoneString === 'Z') return 0;
    var captures = timezoneString.match(timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === '+' ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;

    if (!validateTimezone(hours, minutes)) {
      return NaN;
    }

    return sign * (hours * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE);
  }

  function dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
  } // Validation functions
  // February is null to handle the leap year (using ||)


  var daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

  function isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100;
  }

  function validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28));
  }

  function validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
  }

  function validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
  }

  function validateTime(hours, minutes, seconds) {
    if (hours === 24) {
      return minutes === 0 && seconds === 0;
    }

    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
  }

  function validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
  }
  /**
   * @name formatISO
   * @category Common Helpers
   * @summary Format the date according to the ISO 8601 standard (https://support.sas.com/documentation/cdl/en/lrdict/64316/HTML/default/viewer.htm#a003169814.htm).
   *
   * @description
   * Return the formatted date string in ISO 8601 format. Options may be passed to control the parts and notations of the date.
   *
   * @param {Date|Number} date - the original date
   * @param {Object} [options] - an object with options.
   * @param {'extended'|'basic'} [options.format='extended'] - if 'basic', hide delimiters between date and time values.
   * @param {'complete'|'date'|'time'} [options.representation='complete'] - format date, time with local time zone, or both.
   * @returns {String} the formatted date string (in local time zone)
   * @throws {TypeError} 1 argument required
   * @throws {RangeError} `date` must not be Invalid Date
   * @throws {RangeError} `options.format` must be 'extended' or 'basic'
   * @throws {RangeError} `options.represenation` must be 'date', 'time' or 'complete'
   *
   * @example
   * // Represent 18 September 2019 in ISO 8601 format (local time zone is UTC):
   * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52))
   * //=> '2019-09-18T19:00:52Z'
   *
   * @example
   * // Represent 18 September 2019 in ISO 8601, short format (local time zone is UTC):
   * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { format: 'basic' })
   * //=> '20190918T190052'
   *
   * @example
   * // Represent 18 September 2019 in ISO 8601 format, date only:
   * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { representation: 'date' })
   * //=> '2019-09-18'
   *
   * @example
   * // Represent 18 September 2019 in ISO 8601 format, time only (local time zone is UTC):
   * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { representation: 'time' })
   * //=> '19:00:52Z'
   */


  function formatISO(date, options) {
    requiredArgs(1, arguments);
    var originalDate = toDate(date);

    if (isNaN(originalDate.getTime())) {
      throw new RangeError('Invalid time value');
    }

    var format = !(options !== null && options !== void 0 && options.format) ? 'extended' : String(options.format);
    var representation = !(options !== null && options !== void 0 && options.representation) ? 'complete' : String(options.representation);

    if (format !== 'extended' && format !== 'basic') {
      throw new RangeError("format must be 'extended' or 'basic'");
    }

    if (representation !== 'date' && representation !== 'time' && representation !== 'complete') {
      throw new RangeError("representation must be 'date', 'time', or 'complete'");
    }

    var result = '';
    var tzOffset = '';
    var dateDelimiter = format === 'extended' ? '-' : '';
    var timeDelimiter = format === 'extended' ? ':' : ''; // Representation is either 'date' or 'complete'

    if (representation !== 'time') {
      var day = addLeadingZeros(originalDate.getDate(), 2);
      var month = addLeadingZeros(originalDate.getMonth() + 1, 2);
      var year = addLeadingZeros(originalDate.getFullYear(), 4); // yyyyMMdd or yyyy-MM-dd.

      result = "".concat(year).concat(dateDelimiter).concat(month).concat(dateDelimiter).concat(day);
    } // Representation is either 'time' or 'complete'


    if (representation !== 'date') {
      // Add the timezone.
      var offset = originalDate.getTimezoneOffset();

      if (offset !== 0) {
        var absoluteOffset = Math.abs(offset);
        var hourOffset = addLeadingZeros(Math.floor(absoluteOffset / 60), 2);
        var minuteOffset = addLeadingZeros(absoluteOffset % 60, 2); // If less than 0, the sign is +, because it is ahead of time.

        var sign = offset < 0 ? '+' : '-';
        tzOffset = "".concat(sign).concat(hourOffset, ":").concat(minuteOffset);
      } else {
        tzOffset = 'Z';
      }

      var hour = addLeadingZeros(originalDate.getHours(), 2);
      var minute = addLeadingZeros(originalDate.getMinutes(), 2);
      var second = addLeadingZeros(originalDate.getSeconds(), 2); // If there's also date, separate it with time with 'T'

      var separator = result === '' ? '' : 'T'; // Creates a time string consisting of hour, minute, and second, separated by delimiters, if defined.

      var time = [hour, minute, second].join(timeDelimiter); // HHmmss or HH:mm:ss.

      result = "".concat(result).concat(separator).concat(time).concat(tzOffset);
    }

    return result;
  }
  /**
   * @name isWithinInterval
   * @category Interval Helpers
   * @summary Is the given date within the interval?
   *
   * @description
   * Is the given date within the interval? (Including start and end.)
   *
   * ### v2.0.0 breaking changes:
   *
   * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
   *
   * - The function was renamed from `isWithinRange` to `isWithinInterval`.
   *   This change was made to mirror the use of the word "interval" in standard ISO 8601:2004 terminology:
   *
   *   ```
   *   2.1.3
   *   time interval
   *   part of the time axis limited by two instants
   *   ```
   *
   *   Also, this function now accepts an object with `start` and `end` properties
   *   instead of two arguments as an interval.
   *   This function now throws `RangeError` if the start of the interval is after its end
   *   or if any date in the interval is `Invalid Date`.
   *
   *   ```javascript
   *   // Before v2.0.0
   *
   *   isWithinRange(
   *     new Date(2014, 0, 3),
   *     new Date(2014, 0, 1), new Date(2014, 0, 7)
   *   )
   *
   *   // v2.0.0 onward
   *
   *   isWithinInterval(
   *     new Date(2014, 0, 3),
   *     { start: new Date(2014, 0, 1), end: new Date(2014, 0, 7) }
   *   )
   *   ```
   *
   * @param {Date|Number} date - the date to check
   * @param {Interval} interval - the interval to check
   * @returns {Boolean} the date is within the interval
   * @throws {TypeError} 2 arguments required
   * @throws {RangeError} The start of an interval cannot be after its end
   * @throws {RangeError} Date in interval cannot be `Invalid Date`
   *
   * @example
   * // For the date within the interval:
   * isWithinInterval(new Date(2014, 0, 3), {
   *   start: new Date(2014, 0, 1),
   *   end: new Date(2014, 0, 7)
   * })
   * //=> true
   *
   * @example
   * // For the date outside of the interval:
   * isWithinInterval(new Date(2014, 0, 10), {
   *   start: new Date(2014, 0, 1),
   *   end: new Date(2014, 0, 7)
   * })
   * //=> false
   *
   * @example
   * // For date equal to interval start:
   * isWithinInterval(date, { start, end: date }) // => true
   *
   * @example
   * // For date equal to interval end:
   * isWithinInterval(date, { start: date, end }) // => true
   */


  function isWithinInterval(dirtyDate, interval) {
    requiredArgs(2, arguments);
    var time = toDate(dirtyDate).getTime();
    var startTime = toDate(interval.start).getTime();
    var endTime = toDate(interval.end).getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`

    if (!(startTime <= endTime)) {
      throw new RangeError('Invalid interval');
    }

    return time >= startTime && time <= endTime;
  }

  var longFormatters$1 = {
    exports: {}
  };

  (function (module, exports) {
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = void 0;

    function dateLongFormatter(pattern, formatLong) {
      switch (pattern) {
        case 'P':
          return formatLong.date({
            width: 'short'
          });

        case 'PP':
          return formatLong.date({
            width: 'medium'
          });

        case 'PPP':
          return formatLong.date({
            width: 'long'
          });

        case 'PPPP':
        default:
          return formatLong.date({
            width: 'full'
          });
      }
    }

    function timeLongFormatter(pattern, formatLong) {
      switch (pattern) {
        case 'p':
          return formatLong.time({
            width: 'short'
          });

        case 'pp':
          return formatLong.time({
            width: 'medium'
          });

        case 'ppp':
          return formatLong.time({
            width: 'long'
          });

        case 'pppp':
        default:
          return formatLong.time({
            width: 'full'
          });
      }
    }

    function dateTimeLongFormatter(pattern, formatLong) {
      var matchResult = pattern.match(/(P+)(p+)?/) || [];
      var datePattern = matchResult[1];
      var timePattern = matchResult[2];

      if (!timePattern) {
        return dateLongFormatter(pattern, formatLong);
      }

      var dateTimeFormat;

      switch (datePattern) {
        case 'P':
          dateTimeFormat = formatLong.dateTime({
            width: 'short'
          });
          break;

        case 'PP':
          dateTimeFormat = formatLong.dateTime({
            width: 'medium'
          });
          break;

        case 'PPP':
          dateTimeFormat = formatLong.dateTime({
            width: 'long'
          });
          break;

        case 'PPPP':
        default:
          dateTimeFormat = formatLong.dateTime({
            width: 'full'
          });
          break;
      }

      return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
    }

    var longFormatters = {
      p: timeLongFormatter,
      P: dateTimeLongFormatter
    };
    var _default = longFormatters;
    exports.default = _default;
    module.exports = exports.default;
  })(longFormatters$1, longFormatters$1.exports);

  var longFormatters = /*@__PURE__*/getDefaultExportFromCjs(longFormatters$1.exports);
  var defaultFormats = {
    dayOfMonth: "d",
    fullDate: "PP",
    fullDateWithWeekday: "PPPP",
    fullDateTime: "PP p",
    fullDateTime12h: "PP hh:mm aaa",
    fullDateTime24h: "PP HH:mm",
    fullTime: "p",
    fullTime12h: "hh:mm aaa",
    fullTime24h: "HH:mm",
    hours12h: "hh",
    hours24h: "HH",
    keyboardDate: "P",
    keyboardDateTime: "P p",
    keyboardDateTime12h: "P hh:mm aaa",
    keyboardDateTime24h: "P HH:mm",
    minutes: "mm",
    month: "LLLL",
    monthAndDate: "MMMM d",
    monthAndYear: "LLLL yyyy",
    monthShort: "MMM",
    weekday: "EEEE",
    weekdayShort: "EEE",
    normalDate: "d MMMM",
    normalDateWithWeekday: "EEE, MMM d",
    seconds: "ss",
    shortDate: "MMM d",
    year: "yyyy"
  };

  var DateFnsUtils =
  /** @class */
  function () {
    function DateFnsUtils(_a) {
      var _this = this;

      var _b = _a === void 0 ? {} : _a,
          locale = _b.locale,
          formats = _b.formats;

      this.lib = "date-fns"; // Note: date-fns input types are more lenient than this adapter, so we need to expose our more
      // strict signature and delegate to the more lenient signature. Otherwise, we have downstream type errors upon usage.

      this.is12HourCycleInCurrentLocale = function () {
        if (_this.locale) {
          return /a/.test(_this.locale.formatLong.time());
        } // By default date-fns is using en-US locale with am/pm enabled


        return true;
      };

      this.getFormatHelperText = function (format) {
        // @see https://github.com/date-fns/date-fns/blob/master/src/format/index.js#L31
        var longFormatRegexp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
        var locale = _this.locale || defaultLocale;
        return format.match(longFormatRegexp).map(function (token) {
          var firstCharacter = token[0];

          if (firstCharacter === "p" || firstCharacter === "P") {
            var longFormatter = longFormatters[firstCharacter];
            return longFormatter(token, locale.formatLong, {});
          }

          return token;
        }).join("").replace(/(aaa|aa|a)/g, "(a|p)m").toLocaleLowerCase();
      };

      this.parseISO = function (isoString) {
        return parseISO(isoString);
      };

      this.toISO = function (value) {
        return formatISO(value, {
          format: "extended"
        });
      };

      this.getCurrentLocaleCode = function () {
        var _a;

        return ((_a = _this.locale) === null || _a === void 0 ? void 0 : _a.code) || "en-US";
      };

      this.addSeconds = function (value, count) {
        return addSeconds(value, count);
      };

      this.addMinutes = function (value, count) {
        return addMinutes(value, count);
      };

      this.addHours = function (value, count) {
        return addHours(value, count);
      };

      this.addDays = function (value, count) {
        return addDays(value, count);
      };

      this.addWeeks = function (value, count) {
        return addWeeks(value, count);
      };

      this.addMonths = function (value, count) {
        return addMonths(value, count);
      };

      this.isValid = function (value) {
        return isValid(_this.date(value));
      };

      this.getDiff = function (value, comparing, unit) {
        switch (unit) {
          case "years":
            return differenceInYears(value, _this.date(comparing));

          case "quarters":
            return differenceInQuarters(value, _this.date(comparing));

          case "months":
            return differenceInMonths(value, _this.date(comparing));

          case "weeks":
            return differenceInWeeks(value, _this.date(comparing));

          case "days":
            return differenceInDays(value, _this.date(comparing));

          case "hours":
            return differenceInHours(value, _this.date(comparing));

          case "minutes":
            return differenceInMinutes(value, _this.date(comparing));

          case "seconds":
            return differenceInSeconds(value, _this.date(comparing));

          default:
            {
              return differenceInMilliseconds(value, _this.date(comparing));
            }
        }
      };

      this.isAfter = function (value, comparing) {
        return isAfter(value, comparing);
      };

      this.isBefore = function (value, comparing) {
        return isBefore(value, comparing);
      };

      this.startOfDay = function (value) {
        return startOfDay(value);
      };

      this.endOfDay = function (value) {
        return endOfDay(value);
      };

      this.getHours = function (value) {
        return getHours(value);
      };

      this.setHours = function (value, count) {
        return setHours(value, count);
      };

      this.setMinutes = function (value, count) {
        return setMinutes(value, count);
      };

      this.getSeconds = function (value) {
        return getSeconds(value);
      };

      this.setSeconds = function (value, count) {
        return setSeconds(value, count);
      };

      this.isSameDay = function (value, comparing) {
        return isSameDay(value, comparing);
      };

      this.isSameMonth = function (value, comparing) {
        return isSameMonth(value, comparing);
      };

      this.isSameYear = function (value, comparing) {
        return isSameYear(value, comparing);
      };

      this.isSameHour = function (value, comparing) {
        return isSameHour(value, comparing);
      };

      this.startOfMonth = function (value) {
        return startOfMonth(value);
      };

      this.endOfMonth = function (value) {
        return endOfMonth(value);
      };

      this.startOfWeek = function (value) {
        return startOfWeek(value, {
          locale: _this.locale
        });
      };

      this.endOfWeek = function (value) {
        return endOfWeek(value, {
          locale: _this.locale
        });
      };

      this.getYear = function (value) {
        return getYear(value);
      };

      this.setYear = function (value, count) {
        return setYear(value, count);
      };

      this.date = function (value) {
        if (typeof value === "undefined") {
          return new Date();
        }

        if (value === null) {
          return null;
        }

        return new Date(value);
      };

      this.toJsDate = function (value) {
        return value;
      };

      this.parse = function (value, formatString) {
        if (value === "") {
          return null;
        }

        return parse(value, formatString, new Date(), {
          locale: _this.locale
        });
      };

      this.format = function (date, formatKey) {
        return _this.formatByString(date, _this.formats[formatKey]);
      };

      this.formatByString = function (date, formatString) {
        return format(date, formatString, {
          locale: _this.locale
        });
      };

      this.isEqual = function (date, comparing) {
        if (date === null && comparing === null) {
          return true;
        }

        return isEqual(date, comparing);
      };

      this.isNull = function (date) {
        return date === null;
      };

      this.isAfterDay = function (date, value) {
        return isAfter(date, endOfDay(value));
      };

      this.isBeforeDay = function (date, value) {
        return isBefore(date, startOfDay(value));
      };

      this.isBeforeYear = function (date, value) {
        return isBefore(date, startOfYear(value));
      };

      this.isAfterYear = function (date, value) {
        return isAfter(date, endOfYear(value));
      };

      this.isWithinRange = function (date, _a) {
        var start = _a[0],
            end = _a[1];
        return isWithinInterval(date, {
          start: start,
          end: end
        });
      };

      this.formatNumber = function (numberToFormat) {
        return numberToFormat;
      };

      this.getMinutes = function (date) {
        return date.getMinutes();
      };

      this.getMonth = function (date) {
        return date.getMonth();
      };

      this.getDaysInMonth = function (date) {
        return getDaysInMonth(date);
      };

      this.setMonth = function (date, count) {
        return setMonth(date, count);
      };

      this.getMeridiemText = function (ampm) {
        return ampm === "am" ? "AM" : "PM";
      };

      this.getNextMonth = function (date) {
        return addMonths(date, 1);
      };

      this.getPreviousMonth = function (date) {
        return addMonths(date, -1);
      };

      this.getMonthArray = function (date) {
        var firstMonth = startOfYear(date);
        var monthArray = [firstMonth];

        while (monthArray.length < 12) {
          var prevMonth = monthArray[monthArray.length - 1];
          monthArray.push(_this.getNextMonth(prevMonth));
        }

        return monthArray;
      };

      this.mergeDateAndTime = function (date, time) {
        return _this.setSeconds(_this.setMinutes(_this.setHours(date, _this.getHours(time)), _this.getMinutes(time)), _this.getSeconds(time));
      };

      this.getWeekdays = function () {
        var now = new Date();
        return eachDayOfInterval({
          start: startOfWeek(now, {
            locale: _this.locale
          }),
          end: endOfWeek(now, {
            locale: _this.locale
          })
        }).map(function (day) {
          return _this.formatByString(day, "EEEEEE");
        });
      };

      this.getWeekArray = function (date) {
        var start = startOfWeek(startOfMonth(date), {
          locale: _this.locale
        });
        var end = endOfWeek(endOfMonth(date), {
          locale: _this.locale
        });
        var count = 0;
        var current = start;
        var nestedWeeks = [];
        var lastDay = null;

        while (isBefore(current, end)) {
          var weekNumber = Math.floor(count / 7);
          nestedWeeks[weekNumber] = nestedWeeks[weekNumber] || [];
          var day = getDay(current);

          if (lastDay !== day) {
            lastDay = day;
            nestedWeeks[weekNumber].push(current);
            count += 1;
          }

          current = addDays(current, 1);
        }

        return nestedWeeks;
      };

      this.getYearRange = function (start, end) {
        var startDate = startOfYear(start);
        var endDate = endOfYear(end);
        var years = [];
        var current = startDate;

        while (isBefore(current, endDate)) {
          years.push(current);
          current = addYears(current, 1);
        }

        return years;
      };

      this.locale = locale;
      this.formats = Object.assign({}, defaultFormats, formats);
    }

    return DateFnsUtils;
  }();

  var AdapterDateFns = DateFnsUtils;

  var LocalizationProvider = function LocalizationProvider(props) {
    var children = props.children;
    return React__default["default"].createElement(LocalizationProvider$1, {
      dateAdapter: AdapterDateFns
    }, children);
  };

  var DatePicker = React__namespace.forwardRef(function (props, ref) {
    var className = props.className,
        dataTestId = props["data-testid"],
        error = props.error,
        fullWidth = props.fullWidth,
        helperText = props.helperText,
        id = props.id,
        label = props.label,
        name = props.name,
        onBlur = props.onBlur,
        onChange = props.onChange,
        required = props.required,
        value = props.value,
        otherProps = __rest$1(props, ["className", 'data-testid', "error", "fullWidth", "helperText", "id", "label", "name", "onBlur", "onChange", "required", "value"]);

    var dataAttributes = generateComponentDataAttributes('DatePicker', className); // DesktopDatePicker most closely resembles existing version and ability to type text in as a date
    // Otherwise unit tests will need to be updated whicha type date values
    // https://stackoverflow.com/questions/69575959/mui-v5-react-unit-test-not-triggering-the-date-picker-handler

    return React__namespace.createElement(LocalizationProvider, null, React__namespace.createElement(BaseDesktopDatePicker, _assign2({
      inputFormat: "dd/MM/yyyy",
      label: label,
      onChange: onChange,
      ref: ref,
      renderInput: function renderInput(params) {
        return React__namespace.createElement(TextField$1, _assign2({
          name: name,
          helperText: helperText,
          fullWidth: true,
          required: true
        }, id && {
          id: id
        }, fullWidth && {
          fullWidth: fullWidth
        }, required && {
          required: required
        }, params, dataAttributes, dataTestId && {
          'data-testid': dataTestId
        }, {
          onBlur: onBlur,
          error: error
        }));
      },
      value: value
    }, otherProps)));
  });

  var Container = function Container(props) {
    var className = props.className,
        otherProps = __rest$1(props, ["className"]);

    var dataAttributes = generateComponentDataAttributes('Container', className);
    return React__namespace.createElement(BaseContainer, _assign2({}, dataAttributes, otherProps));
  };

  var Grid = function Grid(props) {
    var className = props.className,
        otherProps = __rest$1(props, ["className"]);

    var dataAttributes = generateComponentDataAttributes('Grid', className);
    return React__namespace.createElement(BaseGrid, _assign2({}, dataAttributes, otherProps));
  };

  var Hidden = function Hidden(props) {
    var children = props.children,
        lgDown = props.lgDown,
        lgUp = props.lgUp,
        mdDown = props.mdDown,
        mdUp = props.mdUp,
        smDown = props.smDown,
        smUp = props.smUp,
        xsDown = props.xsDown,
        xsUp = props.xsUp,
        xlDown = props.xlDown,
        xlUp = props.xlUp;
    var hidden = useMediaQuery(function (theme) {
      if (xsDown) {
        return theme.breakpoints.down('xs');
      }

      if (xsUp) {
        return theme.breakpoints.up('xs');
      }

      if (smDown) {
        return theme.breakpoints.down('sm');
      }

      if (smUp) {
        return theme.breakpoints.up('sm');
      }

      if (mdDown) {
        return theme.breakpoints.down('md');
      }

      if (mdUp) {
        return theme.breakpoints.up('md');
      }

      if (lgDown) {
        return theme.breakpoints.down('lg');
      }

      if (lgUp) {
        return theme.breakpoints.up('lg');
      }

      if (xlDown) {
        return theme.breakpoints.down('xl');
      }

      if (xlUp) {
        return theme.breakpoints.up('xl');
      }

      throw new Error('Hidden: No prop found to match on break point to set as hidden');
    }, {
      noSsr: true
    });
    return React__namespace.createElement(React__namespace.Fragment, null, hidden ? null : children);
  };

  var Area = function Area(_a) {
    var children = _a.children,
        className = _a.className,
        part = _a.part,
        id = _a.id,
        props = __rest$1(_a, ["children", "className", "part", "id"]);

    return React__default["default"].createElement("div", _assign2({
      className: classNames('area', className),
      "data-part": part,
      key: id
    }, props), children);
  };

  var defaultProps$7 = {
    children: [],
    className: '',
    part: '',
    id: ''
  };
  Area.defaultProps = defaultProps$7;
  var css_248z$7 = ".index-module_flex__0nRKD,\n.index-module_flex-left__q5URa,\n.index-module_flex-right__RjqoT {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap; }\n\n.index-module_flex-left__q5URa > div,\n.index-module_flex-right__RjqoT > div {\n  flex: 0 0 auto; }\n\n.index-module_flex-left__q5URa:not(.index-module_flex-right__RjqoT) > div:first-child,\n.index-module_flex-right__RjqoT:not(.index-module_flex-right__RjqoT) > div:first-child {\n  flex: 1 1 0; }\n\n.index-module_flex-left__q5URa:not(.index-module_flex-left__q5URa) > div:last-child,\n.index-module_flex-right__RjqoT:not(.index-module_flex-left__q5URa) > div:last-child {\n  flex: 1 1 0; }\n\n.index-module_float-left__zajkM {\n  justify-content: flex-start; }\n\n.index-module_float-right__mPkK6 {\n  justify-content: flex-end; }\n\n.index-module_float-left__zajkM,\n.index-module_float-right__mPkK6 {\n  display: flex;\n  flex-wrap: wrap;\n  /* &:not(.narrow) {\n    margin: -($padding-grid / 2);\n\n    > .area {\n      padding: ($padding-grid / 2);\n    }\n  }\n\n  &.narrow {\n    margin: -($padding-grid / 4);\n\n    > .area {\n      padding: ($padding-grid / 4);\n    }\n  } */ }\n\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGV4Lm1vZHVsZS5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBOzs7RUFHRSxhQUFhO0VBQ2IsbUJBQW1CO0VBQ25CLGVBQWUsRUFBRTs7QUFFbkI7O0VBRUUsY0FBYyxFQUFFOztBQUVsQjs7RUFFRSxXQUFXLEVBQUU7O0FBRWY7O0VBRUUsV0FBVyxFQUFFOztBQUVmO0VBQ0UsMkJBQTJCLEVBQUU7O0FBRS9CO0VBQ0UseUJBQXlCLEVBQUU7O0FBRTdCOztFQUVFLGFBQWE7RUFDYixlQUFlO0VBQ2Y7Ozs7Ozs7Ozs7Ozs7O0tBY0csRUFBRSIsImZpbGUiOiJpbmRleC5tb2R1bGUuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIi5mbGV4LFxuLmZsZXgtbGVmdCxcbi5mbGV4LXJpZ2h0IHtcbiAgZGlzcGxheTogZmxleDtcbiAgZmxleC1kaXJlY3Rpb246IHJvdztcbiAgZmxleC13cmFwOiB3cmFwOyB9XG5cbi5mbGV4LWxlZnQgPiBkaXYsXG4uZmxleC1yaWdodCA+IGRpdiB7XG4gIGZsZXg6IDAgMCBhdXRvOyB9XG5cbi5mbGV4LWxlZnQ6bm90KC5mbGV4LXJpZ2h0KSA+IGRpdjpmaXJzdC1jaGlsZCxcbi5mbGV4LXJpZ2h0Om5vdCguZmxleC1yaWdodCkgPiBkaXY6Zmlyc3QtY2hpbGQge1xuICBmbGV4OiAxIDEgMDsgfVxuXG4uZmxleC1sZWZ0Om5vdCguZmxleC1sZWZ0KSA+IGRpdjpsYXN0LWNoaWxkLFxuLmZsZXgtcmlnaHQ6bm90KC5mbGV4LWxlZnQpID4gZGl2Omxhc3QtY2hpbGQge1xuICBmbGV4OiAxIDEgMDsgfVxuXG4uZmxvYXQtbGVmdCB7XG4gIGp1c3RpZnktY29udGVudDogZmxleC1zdGFydDsgfVxuXG4uZmxvYXQtcmlnaHQge1xuICBqdXN0aWZ5LWNvbnRlbnQ6IGZsZXgtZW5kOyB9XG5cbi5mbG9hdC1sZWZ0LFxuLmZsb2F0LXJpZ2h0IHtcbiAgZGlzcGxheTogZmxleDtcbiAgZmxleC13cmFwOiB3cmFwO1xuICAvKiAmOm5vdCgubmFycm93KSB7XG4gICAgbWFyZ2luOiAtKCRwYWRkaW5nLWdyaWQgLyAyKTtcblxuICAgID4gLmFyZWEge1xuICAgICAgcGFkZGluZzogKCRwYWRkaW5nLWdyaWQgLyAyKTtcbiAgICB9XG4gIH1cblxuICAmLm5hcnJvdyB7XG4gICAgbWFyZ2luOiAtKCRwYWRkaW5nLWdyaWQgLyA0KTtcblxuICAgID4gLmFyZWEge1xuICAgICAgcGFkZGluZzogKCRwYWRkaW5nLWdyaWQgLyA0KTtcbiAgICB9XG4gIH0gKi8gfVxuIl19 */";
  var styles$3 = {
    "flex": "index-module_flex__0nRKD",
    "flex-left": "index-module_flex-left__q5URa",
    "flex-right": "index-module_flex-right__RjqoT",
    "float-left": "index-module_float-left__zajkM",
    "float-right": "index-module_float-right__mPkK6"
  };
  styleInject(css_248z$7);

  function renderChildren(_a, templateName) {
    var children = _a.children;
    var rows = React__namespace.Children.map(children, function (child, index) {
      if (child === null) {
        return null;
      }

      return React__namespace.createElement(Area, {
        id: templateName && templateName + index
      }, child);
    });
    return React__namespace.createElement(React__namespace.Fragment, null, rows);
  }

  var getAlignItemsFlex = function getAlignItemsFlex(align) {
    switch (align) {
      case 'top':
        return 'flex-start';

      case 'bottom':
        return 'flex-end';

      case 'middle':
        return 'center';

      case 'stretch':
        return 'stretch';

      default:
        return null;
    }
  };

  var Layouts = function Layouts(props) {
    var alignContent = props.alignContent,
        className = props.className,
        style = props.style,
        template = props.template,
        otherProps = __rest$1(props, ["alignContent", "className", "style", "template"]);

    var templateName = (template || 'default').toLowerCase();
    var dataAttributes = generateComponentDataAttributes('Layouts', className, styles$3[templateName]);
    var alignItems = getAlignItemsFlex(alignContent);

    var wrapperStyle = _assign2(_assign2({}, style), {
      alignItems: 'normal'
    });

    var content = renderChildren(_assign2({}, props), templateName);

    if (alignItems) {
      wrapperStyle.alignItems = alignItems;
    }

    return React__namespace.createElement("div", _assign2({}, dataAttributes, {
      style: wrapperStyle
    }, otherProps), content);
  };

  var defaultProps$6 = {
    alignContent: '',
    children: [],
    className: '',
    style: {},
    template: 'default'
  };
  Layouts.defaultProps = defaultProps$6;
  var css_248z$6 = "[data-spacing=\"1\"].index-module_section__OYirV {\n  padding-top: calc(1 * var(--padding-grid));\n  padding-bottom: calc(1 * var(--padding-grid)); }\n  [data-spacing=\"1\"].index-module_section__OYirV .index-module_two-background-color__3JykT {\n    margin-top: calc(-1 * var(--padding-grid));\n    margin-bottom: calc(-1 * var(--padding-grid)); }\n\n[data-spacing=\"2\"].index-module_section__OYirV {\n  padding-top: calc(2 * var(--padding-grid));\n  padding-bottom: calc(2 * var(--padding-grid)); }\n  [data-spacing=\"2\"].index-module_section__OYirV .index-module_two-background-color__3JykT {\n    margin-top: calc(-2 * var(--padding-grid));\n    margin-bottom: calc(-2 * var(--padding-grid)); }\n\n[data-spacing=\"3\"].index-module_section__OYirV {\n  padding-top: calc(3 * var(--padding-grid));\n  padding-bottom: calc(3 * var(--padding-grid)); }\n  [data-spacing=\"3\"].index-module_section__OYirV .index-module_two-background-color__3JykT {\n    margin-top: calc(-3 * var(--padding-grid));\n    margin-bottom: calc(-3 * var(--padding-grid)); }\n\n[data-spacing=\"4\"].index-module_section__OYirV {\n  padding-top: calc(4 * var(--padding-grid));\n  padding-bottom: calc(4 * var(--padding-grid)); }\n  [data-spacing=\"4\"].index-module_section__OYirV .index-module_two-background-color__3JykT {\n    margin-top: calc(-4 * var(--padding-grid));\n    margin-bottom: calc(-4 * var(--padding-grid)); }\n\n[data-spacing=\"5\"].index-module_section__OYirV {\n  padding-top: calc(5 * var(--padding-grid));\n  padding-bottom: calc(5 * var(--padding-grid)); }\n  [data-spacing=\"5\"].index-module_section__OYirV .index-module_two-background-color__3JykT {\n    margin-top: calc(-5 * var(--padding-grid));\n    margin-bottom: calc(-5 * var(--padding-grid)); }\n\n[data-spacing=\"6\"].index-module_section__OYirV {\n  padding-top: calc(6 * var(--padding-grid));\n  padding-bottom: calc(6 * var(--padding-grid)); }\n  [data-spacing=\"6\"].index-module_section__OYirV .index-module_two-background-color__3JykT {\n    margin-top: calc(-6 * var(--padding-grid));\n    margin-bottom: calc(-6 * var(--padding-grid)); }\n\n[data-spacing=\"7\"].index-module_section__OYirV {\n  padding-top: calc(7 * var(--padding-grid));\n  padding-bottom: calc(7 * var(--padding-grid)); }\n  [data-spacing=\"7\"].index-module_section__OYirV .index-module_two-background-color__3JykT {\n    margin-top: calc(-7 * var(--padding-grid));\n    margin-bottom: calc(-7 * var(--padding-grid)); }\n\n[data-spacing=\"8\"].index-module_section__OYirV {\n  padding-top: calc(8 * var(--padding-grid));\n  padding-bottom: calc(8 * var(--padding-grid)); }\n  [data-spacing=\"8\"].index-module_section__OYirV .index-module_two-background-color__3JykT {\n    margin-top: calc(-8 * var(--padding-grid));\n    margin-bottom: calc(-8 * var(--padding-grid)); }\n\n[data-spacing=\"9\"].index-module_section__OYirV {\n  padding-top: calc(9 * var(--padding-grid));\n  padding-bottom: calc(9 * var(--padding-grid)); }\n  [data-spacing=\"9\"].index-module_section__OYirV .index-module_two-background-color__3JykT {\n    margin-top: calc(-9 * var(--padding-grid));\n    margin-bottom: calc(-9 * var(--padding-grid)); }\n\n[data-spacing=\"10\"].index-module_section__OYirV {\n  padding-top: calc(10 * var(--padding-grid));\n  padding-bottom: calc(10 * var(--padding-grid)); }\n  [data-spacing=\"10\"].index-module_section__OYirV .index-module_two-background-color__3JykT {\n    margin-top: calc(-10 * var(--padding-grid));\n    margin-bottom: calc(-10 * var(--padding-grid)); }\n\n[data-spacing=\"11\"].index-module_section__OYirV {\n  padding-top: calc(11 * var(--padding-grid));\n  padding-bottom: calc(11 * var(--padding-grid)); }\n  [data-spacing=\"11\"].index-module_section__OYirV .index-module_two-background-color__3JykT {\n    margin-top: calc(-11 * var(--padding-grid));\n    margin-bottom: calc(-11 * var(--padding-grid)); }\n\n[data-spacing=\"12\"].index-module_section__OYirV {\n  padding-top: calc(12 * var(--padding-grid));\n  padding-bottom: calc(12 * var(--padding-grid)); }\n  [data-spacing=\"12\"].index-module_section__OYirV .index-module_two-background-color__3JykT {\n    margin-top: calc(-12 * var(--padding-grid));\n    margin-bottom: calc(-12 * var(--padding-grid)); }\n\n[data-spacing=\"13\"].index-module_section__OYirV {\n  padding-top: calc(13 * var(--padding-grid));\n  padding-bottom: calc(13 * var(--padding-grid)); }\n  [data-spacing=\"13\"].index-module_section__OYirV .index-module_two-background-color__3JykT {\n    margin-top: calc(-13 * var(--padding-grid));\n    margin-bottom: calc(-13 * var(--padding-grid)); }\n\n[data-spacing=\"14\"].index-module_section__OYirV {\n  padding-top: calc(14 * var(--padding-grid));\n  padding-bottom: calc(14 * var(--padding-grid)); }\n  [data-spacing=\"14\"].index-module_section__OYirV .index-module_two-background-color__3JykT {\n    margin-top: calc(-14 * var(--padding-grid));\n    margin-bottom: calc(-14 * var(--padding-grid)); }\n\n[data-spacing=\"15\"].index-module_section__OYirV {\n  padding-top: calc(15 * var(--padding-grid));\n  padding-bottom: calc(15 * var(--padding-grid)); }\n  [data-spacing=\"15\"].index-module_section__OYirV .index-module_two-background-color__3JykT {\n    margin-top: calc(-15 * var(--padding-grid));\n    margin-bottom: calc(-15 * var(--padding-grid)); }\n\n[data-spacing=\"16\"].index-module_section__OYirV {\n  padding-top: calc(16 * var(--padding-grid));\n  padding-bottom: calc(16 * var(--padding-grid)); }\n  [data-spacing=\"16\"].index-module_section__OYirV .index-module_two-background-color__3JykT {\n    margin-top: calc(-16 * var(--padding-grid));\n    margin-bottom: calc(-16 * var(--padding-grid)); }\n\n[data-spacing=\"17\"].index-module_section__OYirV {\n  padding-top: calc(17 * var(--padding-grid));\n  padding-bottom: calc(17 * var(--padding-grid)); }\n  [data-spacing=\"17\"].index-module_section__OYirV .index-module_two-background-color__3JykT {\n    margin-top: calc(-17 * var(--padding-grid));\n    margin-bottom: calc(-17 * var(--padding-grid)); }\n\n[data-spacing=\"18\"].index-module_section__OYirV {\n  padding-top: calc(18 * var(--padding-grid));\n  padding-bottom: calc(18 * var(--padding-grid)); }\n  [data-spacing=\"18\"].index-module_section__OYirV .index-module_two-background-color__3JykT {\n    margin-top: calc(-18 * var(--padding-grid));\n    margin-bottom: calc(-18 * var(--padding-grid)); }\n\n[data-spacing=\"19\"].index-module_section__OYirV {\n  padding-top: calc(19 * var(--padding-grid));\n  padding-bottom: calc(19 * var(--padding-grid)); }\n  [data-spacing=\"19\"].index-module_section__OYirV .index-module_two-background-color__3JykT {\n    margin-top: calc(-19 * var(--padding-grid));\n    margin-bottom: calc(-19 * var(--padding-grid)); }\n\n[data-spacing=\"20\"].index-module_section__OYirV {\n  padding-top: calc(20 * var(--padding-grid));\n  padding-bottom: calc(20 * var(--padding-grid)); }\n  [data-spacing=\"20\"].index-module_section__OYirV .index-module_two-background-color__3JykT {\n    margin-top: calc(-20 * var(--padding-grid));\n    margin-bottom: calc(-20 * var(--padding-grid)); }\n\n[data-spacing=\"21\"].index-module_section__OYirV {\n  padding-top: calc(21 * var(--padding-grid));\n  padding-bottom: calc(21 * var(--padding-grid)); }\n  [data-spacing=\"21\"].index-module_section__OYirV .index-module_two-background-color__3JykT {\n    margin-top: calc(-21 * var(--padding-grid));\n    margin-bottom: calc(-21 * var(--padding-grid)); }\n\n[data-spacing=\"22\"].index-module_section__OYirV {\n  padding-top: calc(22 * var(--padding-grid));\n  padding-bottom: calc(22 * var(--padding-grid)); }\n  [data-spacing=\"22\"].index-module_section__OYirV .index-module_two-background-color__3JykT {\n    margin-top: calc(-22 * var(--padding-grid));\n    margin-bottom: calc(-22 * var(--padding-grid)); }\n\n[data-spacing=\"23\"].index-module_section__OYirV {\n  padding-top: calc(23 * var(--padding-grid));\n  padding-bottom: calc(23 * var(--padding-grid)); }\n  [data-spacing=\"23\"].index-module_section__OYirV .index-module_two-background-color__3JykT {\n    margin-top: calc(-23 * var(--padding-grid));\n    margin-bottom: calc(-23 * var(--padding-grid)); }\n\n[data-spacing=\"24\"].index-module_section__OYirV {\n  padding-top: calc(24 * var(--padding-grid));\n  padding-bottom: calc(24 * var(--padding-grid)); }\n  [data-spacing=\"24\"].index-module_section__OYirV .index-module_two-background-color__3JykT {\n    margin-top: calc(-24 * var(--padding-grid));\n    margin-bottom: calc(-24 * var(--padding-grid)); }\n\n.index-module_has-overlay__SFtFf {\n  position: relative; }\n  .index-module_has-overlay__SFtFf .index-module_content__t2Sp0 {\n    position: relative;\n    z-index: 1; }\n\n.index-module_overlay__zyHTn {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border-radius: inherit; }\n\n.index-module_container-item__Z2Xcc {\n  padding: calc(var(--padding-xl-horizontal) * 6); }\n  @media (--mq-max-md) {\n    .index-module_container-item__Z2Xcc {\n      padding: calc(var(--padding-base-horizontal) * 2); } }\n\n/*# sourceMappingURL=data:application/json;base64,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 */";
  var styles$2 = {
    "section": "index-module_section__OYirV",
    "two-background-color": "index-module_two-background-color__3JykT",
    "has-overlay": "index-module_has-overlay__SFtFf",
    "content": "index-module_content__t2Sp0",
    "overlay": "index-module_overlay__zyHTn",
    "container-item": "index-module_container-item__Z2Xcc"
  };
  styleInject(css_248z$6);

  var Section = function Section(props) {
    var alignContent = props.alignContent,
        background = props.background,
        bgColor = props.bgColor,
        bgColor2 = props.bgColor2,
        bgPosition = props.bgPosition,
        bgSize = props.bgSize,
        bgRepeat = props.bgRepeat,
        bgImage = props.bgImage,
        color = props.color,
        spacing = props.spacing,
        variant = props.variant,
        otherProps = __rest$1(props, ["alignContent", "background", "bgColor", "bgColor2", "bgPosition", "bgSize", "bgRepeat", "bgImage", "color", "spacing", "variant"]);

    var sectionStyle = {
      backgroundColor: bgColor,
      backgroundPosition: bgPosition,
      backgroundSize: bgSize,
      backgroundRepeat: bgRepeat,
      backgroundImage: bgImage ? "url(" + bgImage + ")" : background,
      color: color,
      textAlign: alignContent
    };
    var Wrapper = React__namespace.useMemo(function () {
      return React__namespace.createElement("div", {
        className: styles$2.content
      }, otherProps.children);
    }, [otherProps.children]);
    var Children = React__namespace.useMemo(function () {
      var childrenCount = React__namespace.Children.count(Wrapper.props.children);

      if (variant === 'contained') {
        return React__namespace.createElement(Container, null, Wrapper);
      }

      if (variant === 'two_background_color' && (childrenCount === 2 || childrenCount === 1)) {
        return React__namespace.createElement(Grid, {
          container: true,
          className: styles$2['two-background-color'],
          "data-testid": "two-background-color"
        }, React__namespace.createElement(Grid, {
          item: true,
          sm: 12,
          md: 6,
          className: styles$2['container-item']
        }, childrenCount === 2 ? Wrapper.props.children[0] : Wrapper.props.children), React__namespace.createElement(Grid, {
          item: true,
          sm: 12,
          md: 6,
          sx: {
            backgroundColor: bgColor2
          },
          className: styles$2['container-item']
        }, childrenCount === 2 && Wrapper.props.children[1]));
      }

      if (variant === 'image_content' && childrenCount === 2) {
        return React__namespace.createElement(Grid, {
          container: true,
          "data-testid": "image-content"
        }, React__namespace.createElement(Grid, {
          item: true,
          xs: 12,
          md: 3,
          sm: 6
        }, Wrapper.props.children[0]), React__namespace.createElement(Grid, {
          item: true,
          xs: 12,
          md: 9,
          sm: 6
        }, Wrapper.props.children[1]));
      }

      return React__namespace.createElement(React__namespace.Fragment, null, Wrapper);
    }, [Wrapper, variant, bgColor2]);

    var shouldShowOverlay = function shouldShowOverlay() {
      return otherProps.showOverlay && React__namespace.createElement("div", {
        "data-testid": "overlay",
        className: styles$2.overlay,
        style: {
          backgroundColor: otherProps.overlayColor,
          opacity: otherProps.overlayOpacity
        }
      });
    };

    return React__namespace.createElement("section", {
      "data-testid": "section",
      "data-component-name": "Section",
      "data-component-library": "content",
      "data-spacing": spacing,
      style: sectionStyle || {},
      className: classNames('ds-generic-react-Section', styles$2.section, otherProps.showOverlay ? styles$2['has-overlay'] : null, otherProps.className)
    }, shouldShowOverlay(), Children);
  };

  var defaultProps$5 = {
    children: null,
    color: 'primary',
    variant: 'contained',
    spacing: 2,
    overlayOpacity: '0.9',
    overlayColor: '#bdbdbd'
  };
  Section.defaultProps = defaultProps$5;

  var Stack = function Stack(props) {
    var className = props.className,
        otherProps = __rest$1(props, ["className"]);

    var dataAttributes = generateComponentDataAttributes('Box', className);
    return React__default["default"].createElement(BaseStack, _assign2({}, dataAttributes, otherProps));
  };

  var Drawer = function Drawer(props) {
    var className = props.className,
        otherProps = __rest$1(props, ["className"]);

    var dataAttributes = generateComponentDataAttributes('Drawer', className);
    return React__namespace.createElement(BaseDrawer, _assign2({}, dataAttributes, otherProps));
  };

  var Link = function Link(props) {
    var className = props.className,
        otherProps = __rest$1(props, ["className"]);

    var dataAttributes = generateComponentDataAttributes('Link', className);
    return React__namespace.createElement(BaseLink, _assign2({}, dataAttributes, otherProps));
  };

  var defaultProps$4 = {
    underline: 'hover'
  };
  Link.defaultProps = defaultProps$4;
  var Menu = React__namespace.forwardRef(function (props, _ref433) {
    var className = props.className,
        otherProps = __rest$1(props, ["className"]);

    var dataAttributes = generateComponentDataAttributes('Menu', className);
    return React__namespace.createElement(BaseMenu, _assign2({}, dataAttributes, {
      ref: function ref() {
        return _ref433;
      }
    }, otherProps));
  });
  var defaultProps$3 = {
    disableAutoFocusItem: true
  };
  Menu.defaultProps = defaultProps$3;
  var MenuItem = React__namespace.forwardRef(function (props, _ref434) {
    var className = props.className,
        otherProps = __rest$1(props, ["className"]);

    var dataAttributes = generateComponentDataAttributes('MenuItem', className);
    return React__namespace.createElement(BaseMenuItem, _assign2({}, dataAttributes, {
      ref: function ref() {
        return _ref434;
      }
    }, otherProps));
  });
  var defaultProps$2 = {
    disableGutters: false
  };
  MenuItem.defaultProps = defaultProps$2;
  var MenuList = React__namespace.forwardRef(function (props, _ref435) {
    var className = props.className,
        otherProps = __rest$1(props, ["className"]);

    var dataAttributes = generateComponentDataAttributes('MenuList', className);
    return React__namespace.createElement(BaseMenuList, _assign2({}, dataAttributes, {
      ref: function ref() {
        return _ref435;
      }
    }, otherProps));
  });
  var Stepper = React__namespace.forwardRef(function (props, _ref436) {
    var className = props.className,
        otherProps = __rest$1(props, ["className"]);

    var dataAttributes = generateComponentDataAttributes('Stepper', className);
    return React__namespace.createElement(BaseStepper, _assign2({}, dataAttributes, {
      ref: function ref() {
        return _ref436;
      }
    }, otherProps));
  });
  var Step = React__namespace.forwardRef(function (props, ref) {
    var className = props.className,
        otherProps = __rest$1(props, ["className"]);

    var dataAttributes = generateComponentDataAttributes('Step', className);
    return React__namespace.createElement(BaseStep, _assign2({}, dataAttributes, {
      ref: ref
    }, otherProps));
  });
  var css_248z$5 = ".MuiStepButton-root .Mui-active {\n  color: var(--color--primary--main);\n  font-weight: 700; }\n  .MuiStepButton-root .Mui-active.Mui-completed {\n    font-weight: 700; }\n\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGV4LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSxrQ0FBa0M7RUFDbEMsZ0JBQWdCLEVBQUU7RUFDbEI7SUFDRSxnQkFBZ0IsRUFBRSIsImZpbGUiOiJpbmRleC5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLk11aVN0ZXBCdXR0b24tcm9vdCAuTXVpLWFjdGl2ZSB7XG4gIGNvbG9yOiB2YXIoLS1jb2xvci0tcHJpbWFyeS0tbWFpbik7XG4gIGZvbnQtd2VpZ2h0OiA3MDA7IH1cbiAgLk11aVN0ZXBCdXR0b24tcm9vdCAuTXVpLWFjdGl2ZS5NdWktY29tcGxldGVkIHtcbiAgICBmb250LXdlaWdodDogNzAwOyB9XG4iXX0= */";
  styleInject(css_248z$5);

  var StepButton = function StepButton(props) {
    var children = props.children,
        className = props.className,
        otherProps = __rest$1(props, ["children", "className"]);

    var dataAttributes = generateComponentDataAttributes('StepButton', className);
    return React__namespace.createElement(BaseStepButton, _assign2({}, dataAttributes, otherProps), children);
  };

  var StepConnector = React__namespace.forwardRef(function (props, ref) {
    var className = props.className,
        otherProps = __rest$1(props, ["className"]);

    var dataAttributes = generateComponentDataAttributes('StepConnector', className);
    return React__namespace.createElement(BaseStepConnector, _assign2({}, dataAttributes, {
      ref: ref
    }, otherProps));
  });
  var StepContent = React__namespace.forwardRef(function (props, ref) {
    var className = props.className,
        otherProps = __rest$1(props, ["className"]);

    var dataAttributes = generateComponentDataAttributes('StepContent', className);
    return React__namespace.createElement(BaseStepContent, _assign2({}, dataAttributes, {
      ref: ref
    }, otherProps));
  });
  var StepIcon = React__namespace.forwardRef(function (props, ref) {
    var className = props.className,
        otherProps = __rest$1(props, ["className"]);

    var dataAttributes = generateComponentDataAttributes('StepIcon', className);
    return React__namespace.createElement(BaseStepIcon, _assign2({}, dataAttributes, {
      ref: ref
    }, otherProps));
  });
  var StepLabel = React__namespace.forwardRef(function (props, ref) {
    var className = props.className,
        children = props.children,
        otherProps = __rest$1(props, ["className", "children"]);

    var dataAttributes = generateComponentDataAttributes('StepLabel', className);
    return React__namespace.createElement(BaseStepLabel, _assign2({}, dataAttributes, {
      ref: ref
    }, otherProps), children);
  });

  var Accordion = function Accordion(props) {
    var className = props.className,
        otherProps = __rest$1(props, ["className"]);

    var dataAttributes = generateComponentDataAttributes('Accordion', className);
    return React__namespace.createElement(BaseAccordion, _assign2({}, dataAttributes, otherProps));
  };

  var AccordionActions = function AccordionActions(props) {
    var className = props.className,
        otherProps = __rest$1(props, ["className"]);

    var dataAttributes = generateComponentDataAttributes('AccordionActions', className);
    return React__namespace.createElement(BaseAccordionActions, _assign2({}, dataAttributes, otherProps));
  };

  var defaultProps$1 = {
    disableSpacing: false
  };
  AccordionActions.defaultProps = defaultProps$1;

  var AccordionDetails = function AccordionDetails(props) {
    var className = props.className,
        otherProps = __rest$1(props, ["className"]);

    var dataAttributes = generateComponentDataAttributes('AccordionDetails', className);
    return React__namespace.createElement(BaseAccordionDetails, _assign2({}, dataAttributes, otherProps));
  };

  var AccordionSummary = function AccordionSummary(props) {
    var className = props.className,
        otherProps = __rest$1(props, ["className"]);

    var dataAttributes = generateComponentDataAttributes('AccordionSummary', className);
    return React__namespace.createElement(BaseAccordionSummary, _assign2({}, dataAttributes, otherProps));
  };

  var AppBar = function AppBar(props) {
    var className = props.className,
        otherProps = __rest$1(props, ["className"]);

    var dataAttributes = generateComponentDataAttributes('AppBar', className);
    return React__namespace.createElement(BaseAppBar, _assign2({}, dataAttributes, otherProps));
  };

  var Card = function Card(props) {
    var className = props.className,
        otherProps = __rest$1(props, ["className"]);

    var dataAttributes = generateComponentDataAttributes('Card', className);
    return React__namespace.createElement(BaseCard, _assign2({}, dataAttributes, otherProps));
  };

  var CardActionArea = function CardActionArea(props) {
    var className = props.className,
        otherProps = __rest$1(props, ["className"]);

    var dataAttributes = generateComponentDataAttributes('CardActionArea', className);
    return React__namespace.createElement(BaseCardActionArea, _assign2({}, dataAttributes, otherProps));
  };

  var CardActions = function CardActions(props) {
    var className = props.className,
        otherProps = __rest$1(props, ["className"]);

    var dataAttributes = generateComponentDataAttributes('CardActions', className);
    return React__namespace.createElement(BaseCardActions, _assign2({}, dataAttributes, otherProps));
  };

  var CardContent = function CardContent(props) {
    var className = props.className,
        otherProps = __rest$1(props, ["className"]);

    var dataAttributes = generateComponentDataAttributes('CardContent', className);
    return React__namespace.createElement(BaseCardContent, _assign2({}, dataAttributes, otherProps));
  };

  var CardHeader = function CardHeader(props) {
    var className = props.className,
        otherProps = __rest$1(props, ["className"]);

    var dataAttributes = generateComponentDataAttributes('CardHeader', className);
    return React__namespace.createElement(BaseCardHeader, _assign2({}, dataAttributes, otherProps));
  };

  var CardMedia = function CardMedia(props) {
    var className = props.className,
        otherProps = __rest$1(props, ["className"]);

    var dataAttributes = generateComponentDataAttributes('CardMedia', className);
    return React__namespace.createElement(BaseCardMedia, _assign2({}, dataAttributes, otherProps));
  };
  /**
   * SSR Window 3.0.0
   * Better handling for window object in SSR environment
   * https://github.com/nolimits4web/ssr-window
   *
   * Copyright 2020, Vladimir Kharlampidi
   *
   * Licensed under MIT
   *
   * Released on: November 9, 2020
   */

  /* eslint-disable no-param-reassign */


  function isObject$2(obj) {
    return obj !== null && typeof obj === 'object' && 'constructor' in obj && obj.constructor === Object;
  }

  function extend$2(target, src) {
    if (target === void 0) {
      target = {};
    }

    if (src === void 0) {
      src = {};
    }

    Object.keys(src).forEach(function (key) {
      if (typeof target[key] === 'undefined') target[key] = src[key];else if (isObject$2(src[key]) && isObject$2(target[key]) && Object.keys(src[key]).length > 0) {
        extend$2(target[key], src[key]);
      }
    });
  }

  var ssrDocument = {
    body: {},
    addEventListener: function addEventListener() {},
    removeEventListener: function removeEventListener() {},
    activeElement: {
      blur: function blur() {},
      nodeName: ''
    },
    querySelector: function querySelector() {
      return null;
    },
    querySelectorAll: function querySelectorAll() {
      return [];
    },
    getElementById: function getElementById() {
      return null;
    },
    createEvent: function createEvent() {
      return {
        initEvent: function initEvent() {}
      };
    },
    createElement: function createElement() {
      return {
        children: [],
        childNodes: [],
        style: {},
        setAttribute: function setAttribute() {},
        getElementsByTagName: function getElementsByTagName() {
          return [];
        }
      };
    },
    createElementNS: function createElementNS() {
      return {};
    },
    importNode: function importNode() {
      return null;
    },
    location: {
      hash: '',
      host: '',
      hostname: '',
      href: '',
      origin: '',
      pathname: '',
      protocol: '',
      search: ''
    }
  };

  function getDocument() {
    var doc = typeof document !== 'undefined' ? document : {};
    extend$2(doc, ssrDocument);
    return doc;
  }

  var ssrWindow = {
    document: ssrDocument,
    navigator: {
      userAgent: ''
    },
    location: {
      hash: '',
      host: '',
      hostname: '',
      href: '',
      origin: '',
      pathname: '',
      protocol: '',
      search: ''
    },
    history: {
      replaceState: function replaceState() {},
      pushState: function pushState() {},
      go: function go() {},
      back: function back() {}
    },
    CustomEvent: function CustomEvent() {
      return this;
    },
    addEventListener: function addEventListener() {},
    removeEventListener: function removeEventListener() {},
    getComputedStyle: function getComputedStyle() {
      return {
        getPropertyValue: function getPropertyValue() {
          return '';
        }
      };
    },
    Image: function Image() {},
    Date: function Date() {},
    screen: {},
    setTimeout: function setTimeout() {},
    clearTimeout: function clearTimeout() {},
    matchMedia: function matchMedia() {
      return {};
    },
    requestAnimationFrame: function requestAnimationFrame(callback) {
      if (typeof setTimeout === 'undefined') {
        callback();
        return null;
      }

      return setTimeout(callback, 0);
    },
    cancelAnimationFrame: function cancelAnimationFrame(id) {
      if (typeof setTimeout === 'undefined') {
        return;
      }

      clearTimeout(id);
    }
  };

  function getWindow() {
    var win = typeof window !== 'undefined' ? window : {};
    extend$2(win, ssrWindow);
    return win;
  }
  /**
   * Dom7 3.0.0
   * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
   * https://framework7.io/docs/dom7.html
   *
   * Copyright 2020, Vladimir Kharlampidi
   *
   * Licensed under MIT
   *
   * Released on: November 9, 2020
   */


  function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  function _construct(Parent, args, Class) {
    if (_isNativeReflectConstruct()) {
      _construct = Reflect.construct;
    } else {
      _construct = function _construct(Parent, args, Class) {
        var a = [null];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) _setPrototypeOf(instance, Class.prototype);
        return instance;
      };
    }

    return _construct.apply(null, arguments);
  }

  function _isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
  }

  function _wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;

    _wrapNativeSuper = function _wrapNativeSuper(Class) {
      if (Class === null || !_isNativeFunction(Class)) return Class;

      if (typeof Class !== "function") {
        throw new TypeError("Super expression must either be null or a function");
      }

      if (typeof _cache !== "undefined") {
        if (_cache.has(Class)) return _cache.get(Class);

        _cache.set(Class, Wrapper);
      }

      function Wrapper() {
        return _construct(Class, arguments, _getPrototypeOf(this).constructor);
      }

      Wrapper.prototype = Object.create(Class.prototype, {
        constructor: {
          value: Wrapper,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      return _setPrototypeOf(Wrapper, Class);
    };

    return _wrapNativeSuper(Class);
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }
  /* eslint-disable no-proto */


  function makeReactive(obj) {
    var proto = obj.__proto__;
    Object.defineProperty(obj, '__proto__', {
      get: function get() {
        return proto;
      },
      set: function set(value) {
        proto.__proto__ = value;
      }
    });
  }

  var Dom7 = /*#__PURE__*/function (_Array) {
    _inheritsLoose(Dom7, _Array);

    function Dom7(items) {
      var _this;

      _this = _Array.call.apply(_Array, [this].concat(items)) || this;
      makeReactive(_assertThisInitialized(_this));
      return _this;
    }

    return Dom7;
  }( /*#__PURE__*/_wrapNativeSuper(Array));

  function arrayFlat(arr) {
    if (arr === void 0) {
      arr = [];
    }

    var res = [];
    arr.forEach(function (el) {
      if (Array.isArray(el)) {
        res.push.apply(res, arrayFlat(el));
      } else {
        res.push(el);
      }
    });
    return res;
  }

  function arrayFilter(arr, callback) {
    return Array.prototype.filter.call(arr, callback);
  }

  function arrayUnique(arr) {
    var uniqueArray = [];

    for (var i = 0; i < arr.length; i += 1) {
      if (uniqueArray.indexOf(arr[i]) === -1) uniqueArray.push(arr[i]);
    }

    return uniqueArray;
  }

  function qsa(selector, context) {
    if (typeof selector !== 'string') {
      return [selector];
    }

    var a = [];
    var res = context.querySelectorAll(selector);

    for (var i = 0; i < res.length; i += 1) {
      a.push(res[i]);
    }

    return a;
  }

  function $(selector, context) {
    var window = getWindow();
    var document = getDocument();
    var arr = [];

    if (!context && selector instanceof Dom7) {
      return selector;
    }

    if (!selector) {
      return new Dom7(arr);
    }

    if (typeof selector === 'string') {
      var html = selector.trim();

      if (html.indexOf('<') >= 0 && html.indexOf('>') >= 0) {
        var toCreate = 'div';
        if (html.indexOf('<li') === 0) toCreate = 'ul';
        if (html.indexOf('<tr') === 0) toCreate = 'tbody';
        if (html.indexOf('<td') === 0 || html.indexOf('<th') === 0) toCreate = 'tr';
        if (html.indexOf('<tbody') === 0) toCreate = 'table';
        if (html.indexOf('<option') === 0) toCreate = 'select';
        var tempParent = document.createElement(toCreate);
        tempParent.innerHTML = html;

        for (var i = 0; i < tempParent.childNodes.length; i += 1) {
          arr.push(tempParent.childNodes[i]);
        }
      } else {
        arr = qsa(selector.trim(), context || document);
      } // arr = qsa(selector, document);

    } else if (selector.nodeType || selector === window || selector === document) {
      arr.push(selector);
    } else if (Array.isArray(selector)) {
      if (selector instanceof Dom7) return selector;
      arr = selector;
    }

    return new Dom7(arrayUnique(arr));
  }

  $.fn = Dom7.prototype;

  function addClass() {
    for (var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++) {
      classes[_key] = arguments[_key];
    }

    var classNames = arrayFlat(classes.map(function (c) {
      return c.split(' ');
    }));
    this.forEach(function (el) {
      var _el$classList;

      (_el$classList = el.classList).add.apply(_el$classList, classNames);
    });
    return this;
  }

  function removeClass() {
    for (var _len2 = arguments.length, classes = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      classes[_key2] = arguments[_key2];
    }

    var classNames = arrayFlat(classes.map(function (c) {
      return c.split(' ');
    }));
    this.forEach(function (el) {
      var _el$classList2;

      (_el$classList2 = el.classList).remove.apply(_el$classList2, classNames);
    });
    return this;
  }

  function toggleClass() {
    for (var _len3 = arguments.length, classes = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      classes[_key3] = arguments[_key3];
    }

    var classNames = arrayFlat(classes.map(function (c) {
      return c.split(' ');
    }));
    this.forEach(function (el) {
      classNames.forEach(function (className) {
        el.classList.toggle(className);
      });
    });
  }

  function hasClass() {
    for (var _len4 = arguments.length, classes = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      classes[_key4] = arguments[_key4];
    }

    var classNames = arrayFlat(classes.map(function (c) {
      return c.split(' ');
    }));
    return arrayFilter(this, function (el) {
      return classNames.filter(function (className) {
        return el.classList.contains(className);
      }).length > 0;
    }).length > 0;
  }

  function attr(attrs, value) {
    if (arguments.length === 1 && typeof attrs === 'string') {
      // Get attr
      if (this[0]) return this[0].getAttribute(attrs);
      return undefined;
    } // Set attrs


    for (var i = 0; i < this.length; i += 1) {
      if (arguments.length === 2) {
        // String
        this[i].setAttribute(attrs, value);
      } else {
        // Object
        for (var attrName in attrs) {
          this[i][attrName] = attrs[attrName];
          this[i].setAttribute(attrName, attrs[attrName]);
        }
      }
    }

    return this;
  }

  function removeAttr(attr) {
    for (var i = 0; i < this.length; i += 1) {
      this[i].removeAttribute(attr);
    }

    return this;
  }

  function transform(transform) {
    for (var i = 0; i < this.length; i += 1) {
      this[i].style.transform = transform;
    }

    return this;
  }

  function transition$1(duration) {
    for (var i = 0; i < this.length; i += 1) {
      this[i].style.transitionDuration = typeof duration !== 'string' ? duration + "ms" : duration;
    }

    return this;
  }

  function on() {
    for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }

    var eventType = args[0],
        targetSelector = args[1],
        listener = args[2],
        capture = args[3];

    if (typeof args[1] === 'function') {
      eventType = args[0];
      listener = args[1];
      capture = args[2];
      targetSelector = undefined;
    }

    if (!capture) capture = false;

    function handleLiveEvent(e) {
      var target = e.target;
      if (!target) return;
      var eventData = e.target.dom7EventData || [];

      if (eventData.indexOf(e) < 0) {
        eventData.unshift(e);
      }

      if ($(target).is(targetSelector)) listener.apply(target, eventData);else {
        var _parents = $(target).parents(); // eslint-disable-line


        for (var k = 0; k < _parents.length; k += 1) {
          if ($(_parents[k]).is(targetSelector)) listener.apply(_parents[k], eventData);
        }
      }
    }

    function handleEvent(e) {
      var eventData = e && e.target ? e.target.dom7EventData || [] : [];

      if (eventData.indexOf(e) < 0) {
        eventData.unshift(e);
      }

      listener.apply(this, eventData);
    }

    var events = eventType.split(' ');
    var j;

    for (var i = 0; i < this.length; i += 1) {
      var el = this[i];

      if (!targetSelector) {
        for (j = 0; j < events.length; j += 1) {
          var event = events[j];
          if (!el.dom7Listeners) el.dom7Listeners = {};
          if (!el.dom7Listeners[event]) el.dom7Listeners[event] = [];
          el.dom7Listeners[event].push({
            listener: listener,
            proxyListener: handleEvent
          });
          el.addEventListener(event, handleEvent, capture);
        }
      } else {
        // Live events
        for (j = 0; j < events.length; j += 1) {
          var _event = events[j];
          if (!el.dom7LiveListeners) el.dom7LiveListeners = {};
          if (!el.dom7LiveListeners[_event]) el.dom7LiveListeners[_event] = [];

          el.dom7LiveListeners[_event].push({
            listener: listener,
            proxyListener: handleLiveEvent
          });

          el.addEventListener(_event, handleLiveEvent, capture);
        }
      }
    }

    return this;
  }

  function off() {
    for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
      args[_key6] = arguments[_key6];
    }

    var eventType = args[0],
        targetSelector = args[1],
        listener = args[2],
        capture = args[3];

    if (typeof args[1] === 'function') {
      eventType = args[0];
      listener = args[1];
      capture = args[2];
      targetSelector = undefined;
    }

    if (!capture) capture = false;
    var events = eventType.split(' ');

    for (var i = 0; i < events.length; i += 1) {
      var event = events[i];

      for (var j = 0; j < this.length; j += 1) {
        var el = this[j];
        var handlers = void 0;

        if (!targetSelector && el.dom7Listeners) {
          handlers = el.dom7Listeners[event];
        } else if (targetSelector && el.dom7LiveListeners) {
          handlers = el.dom7LiveListeners[event];
        }

        if (handlers && handlers.length) {
          for (var k = handlers.length - 1; k >= 0; k -= 1) {
            var handler = handlers[k];

            if (listener && handler.listener === listener) {
              el.removeEventListener(event, handler.proxyListener, capture);
              handlers.splice(k, 1);
            } else if (listener && handler.listener && handler.listener.dom7proxy && handler.listener.dom7proxy === listener) {
              el.removeEventListener(event, handler.proxyListener, capture);
              handlers.splice(k, 1);
            } else if (!listener) {
              el.removeEventListener(event, handler.proxyListener, capture);
              handlers.splice(k, 1);
            }
          }
        }
      }
    }

    return this;
  }

  function trigger() {
    var window = getWindow();

    for (var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
      args[_key9] = arguments[_key9];
    }

    var events = args[0].split(' ');
    var eventData = args[1];

    for (var i = 0; i < events.length; i += 1) {
      var event = events[i];

      for (var j = 0; j < this.length; j += 1) {
        var el = this[j];

        if (window.CustomEvent) {
          var evt = new window.CustomEvent(event, {
            detail: eventData,
            bubbles: true,
            cancelable: true
          });
          el.dom7EventData = args.filter(function (data, dataIndex) {
            return dataIndex > 0;
          });
          el.dispatchEvent(evt);
          el.dom7EventData = [];
          delete el.dom7EventData;
        }
      }
    }

    return this;
  }

  function transitionEnd$1(callback) {
    var dom = this;

    function fireCallBack(e) {
      if (e.target !== this) return;
      callback.call(this, e);
      dom.off('transitionend', fireCallBack);
    }

    if (callback) {
      dom.on('transitionend', fireCallBack);
    }

    return this;
  }

  function outerWidth(includeMargins) {
    if (this.length > 0) {
      if (includeMargins) {
        var _styles = this.styles();

        return this[0].offsetWidth + parseFloat(_styles.getPropertyValue('margin-right')) + parseFloat(_styles.getPropertyValue('margin-left'));
      }

      return this[0].offsetWidth;
    }

    return null;
  }

  function outerHeight(includeMargins) {
    if (this.length > 0) {
      if (includeMargins) {
        var _styles2 = this.styles();

        return this[0].offsetHeight + parseFloat(_styles2.getPropertyValue('margin-top')) + parseFloat(_styles2.getPropertyValue('margin-bottom'));
      }

      return this[0].offsetHeight;
    }

    return null;
  }

  function offset() {
    if (this.length > 0) {
      var window = getWindow();
      var document = getDocument();
      var el = this[0];
      var box = el.getBoundingClientRect();
      var body = document.body;
      var clientTop = el.clientTop || body.clientTop || 0;
      var clientLeft = el.clientLeft || body.clientLeft || 0;
      var scrollTop = el === window ? window.scrollY : el.scrollTop;
      var scrollLeft = el === window ? window.scrollX : el.scrollLeft;
      return {
        top: box.top + scrollTop - clientTop,
        left: box.left + scrollLeft - clientLeft
      };
    }

    return null;
  }

  function styles$1() {
    var window = getWindow();
    if (this[0]) return window.getComputedStyle(this[0], null);
    return {};
  }

  function css(props, value) {
    var window = getWindow();
    var i;

    if (arguments.length === 1) {
      if (typeof props === 'string') {
        // .css('width')
        if (this[0]) return window.getComputedStyle(this[0], null).getPropertyValue(props);
      } else {
        // .css({ width: '100px' })
        for (i = 0; i < this.length; i += 1) {
          for (var _prop in props) {
            this[i].style[_prop] = props[_prop];
          }
        }

        return this;
      }
    }

    if (arguments.length === 2 && typeof props === 'string') {
      // .css('width', '100px')
      for (i = 0; i < this.length; i += 1) {
        this[i].style[props] = value;
      }

      return this;
    }

    return this;
  }

  function each(callback) {
    if (!callback) return this;
    this.forEach(function (el, index) {
      callback.apply(el, [el, index]);
    });
    return this;
  }

  function filter(callback) {
    var result = arrayFilter(this, callback);
    return $(result);
  }

  function html(html) {
    if (typeof html === 'undefined') {
      return this[0] ? this[0].innerHTML : null;
    }

    for (var i = 0; i < this.length; i += 1) {
      this[i].innerHTML = html;
    }

    return this;
  }

  function text(text) {
    if (typeof text === 'undefined') {
      return this[0] ? this[0].textContent.trim() : null;
    }

    for (var i = 0; i < this.length; i += 1) {
      this[i].textContent = text;
    }

    return this;
  }

  function is(selector) {
    var window = getWindow();
    var document = getDocument();
    var el = this[0];
    var compareWith;
    var i;
    if (!el || typeof selector === 'undefined') return false;

    if (typeof selector === 'string') {
      if (el.matches) return el.matches(selector);
      if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
      if (el.msMatchesSelector) return el.msMatchesSelector(selector);
      compareWith = $(selector);

      for (i = 0; i < compareWith.length; i += 1) {
        if (compareWith[i] === el) return true;
      }

      return false;
    }

    if (selector === document) {
      return el === document;
    }

    if (selector === window) {
      return el === window;
    }

    if (selector.nodeType || selector instanceof Dom7) {
      compareWith = selector.nodeType ? [selector] : selector;

      for (i = 0; i < compareWith.length; i += 1) {
        if (compareWith[i] === el) return true;
      }

      return false;
    }

    return false;
  }

  function index() {
    var child = this[0];
    var i;

    if (child) {
      i = 0; // eslint-disable-next-line

      while ((child = child.previousSibling) !== null) {
        if (child.nodeType === 1) i += 1;
      }

      return i;
    }

    return undefined;
  }

  function eq(index) {
    if (typeof index === 'undefined') return this;
    var length = this.length;

    if (index > length - 1) {
      return $([]);
    }

    if (index < 0) {
      var returnIndex = length + index;
      if (returnIndex < 0) return $([]);
      return $([this[returnIndex]]);
    }

    return $([this[index]]);
  }

  function append() {
    var newChild;
    var document = getDocument();

    for (var k = 0; k < arguments.length; k += 1) {
      newChild = k < 0 || arguments.length <= k ? undefined : arguments[k];

      for (var i = 0; i < this.length; i += 1) {
        if (typeof newChild === 'string') {
          var tempDiv = document.createElement('div');
          tempDiv.innerHTML = newChild;

          while (tempDiv.firstChild) {
            this[i].appendChild(tempDiv.firstChild);
          }
        } else if (newChild instanceof Dom7) {
          for (var j = 0; j < newChild.length; j += 1) {
            this[i].appendChild(newChild[j]);
          }
        } else {
          this[i].appendChild(newChild);
        }
      }
    }

    return this;
  }

  function prepend(newChild) {
    var document = getDocument();
    var i;
    var j;

    for (i = 0; i < this.length; i += 1) {
      if (typeof newChild === 'string') {
        var tempDiv = document.createElement('div');
        tempDiv.innerHTML = newChild;

        for (j = tempDiv.childNodes.length - 1; j >= 0; j -= 1) {
          this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
        }
      } else if (newChild instanceof Dom7) {
        for (j = 0; j < newChild.length; j += 1) {
          this[i].insertBefore(newChild[j], this[i].childNodes[0]);
        }
      } else {
        this[i].insertBefore(newChild, this[i].childNodes[0]);
      }
    }

    return this;
  }

  function next(selector) {
    if (this.length > 0) {
      if (selector) {
        if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) {
          return $([this[0].nextElementSibling]);
        }

        return $([]);
      }

      if (this[0].nextElementSibling) return $([this[0].nextElementSibling]);
      return $([]);
    }

    return $([]);
  }

  function nextAll(selector) {
    var nextEls = [];
    var el = this[0];
    if (!el) return $([]);

    while (el.nextElementSibling) {
      var _next = el.nextElementSibling; // eslint-disable-line

      if (selector) {
        if ($(_next).is(selector)) nextEls.push(_next);
      } else nextEls.push(_next);

      el = _next;
    }

    return $(nextEls);
  }

  function prev(selector) {
    if (this.length > 0) {
      var el = this[0];

      if (selector) {
        if (el.previousElementSibling && $(el.previousElementSibling).is(selector)) {
          return $([el.previousElementSibling]);
        }

        return $([]);
      }

      if (el.previousElementSibling) return $([el.previousElementSibling]);
      return $([]);
    }

    return $([]);
  }

  function prevAll(selector) {
    var prevEls = [];
    var el = this[0];
    if (!el) return $([]);

    while (el.previousElementSibling) {
      var _prev = el.previousElementSibling; // eslint-disable-line

      if (selector) {
        if ($(_prev).is(selector)) prevEls.push(_prev);
      } else prevEls.push(_prev);

      el = _prev;
    }

    return $(prevEls);
  }

  function parent(selector) {
    var parents = []; // eslint-disable-line

    for (var i = 0; i < this.length; i += 1) {
      if (this[i].parentNode !== null) {
        if (selector) {
          if ($(this[i].parentNode).is(selector)) parents.push(this[i].parentNode);
        } else {
          parents.push(this[i].parentNode);
        }
      }
    }

    return $(parents);
  }

  function parents(selector) {
    var parents = []; // eslint-disable-line

    for (var i = 0; i < this.length; i += 1) {
      var _parent = this[i].parentNode; // eslint-disable-line

      while (_parent) {
        if (selector) {
          if ($(_parent).is(selector)) parents.push(_parent);
        } else {
          parents.push(_parent);
        }

        _parent = _parent.parentNode;
      }
    }

    return $(parents);
  }

  function closest(selector) {
    var closest = this; // eslint-disable-line

    if (typeof selector === 'undefined') {
      return $([]);
    }

    if (!closest.is(selector)) {
      closest = closest.parents(selector).eq(0);
    }

    return closest;
  }

  function find(selector) {
    var foundElements = [];

    for (var i = 0; i < this.length; i += 1) {
      var found = this[i].querySelectorAll(selector);

      for (var j = 0; j < found.length; j += 1) {
        foundElements.push(found[j]);
      }
    }

    return $(foundElements);
  }

  function children(selector) {
    var children = []; // eslint-disable-line

    for (var i = 0; i < this.length; i += 1) {
      var childNodes = this[i].children;

      for (var j = 0; j < childNodes.length; j += 1) {
        if (!selector || $(childNodes[j]).is(selector)) {
          children.push(childNodes[j]);
        }
      }
    }

    return $(children);
  }

  function remove() {
    for (var i = 0; i < this.length; i += 1) {
      if (this[i].parentNode) this[i].parentNode.removeChild(this[i]);
    }

    return this;
  }

  var Methods = {
    addClass: addClass,
    removeClass: removeClass,
    hasClass: hasClass,
    toggleClass: toggleClass,
    attr: attr,
    removeAttr: removeAttr,
    transform: transform,
    transition: transition$1,
    on: on,
    off: off,
    trigger: trigger,
    transitionEnd: transitionEnd$1,
    outerWidth: outerWidth,
    outerHeight: outerHeight,
    styles: styles$1,
    offset: offset,
    css: css,
    each: each,
    html: html,
    text: text,
    is: is,
    index: index,
    eq: eq,
    append: append,
    prepend: prepend,
    next: next,
    nextAll: nextAll,
    prev: prev,
    prevAll: prevAll,
    parent: parent,
    parents: parents,
    closest: closest,
    find: find,
    children: children,
    filter: filter,
    remove: remove
  };
  Object.keys(Methods).forEach(function (methodName) {
    Object.defineProperty($.fn, methodName, {
      value: Methods[methodName],
      writable: true
    });
  });

  function deleteProps(obj) {
    var object = obj;
    Object.keys(object).forEach(function (key) {
      try {
        object[key] = null;
      } catch (e) {// no getter for object
      }

      try {
        delete object[key];
      } catch (e) {// something got wrong
      }
    });
  }

  function nextTick(callback, delay) {
    if (delay === void 0) {
      delay = 0;
    }

    return setTimeout(callback, delay);
  }

  function now() {
    return Date.now();
  }

  function getComputedStyle$1(el) {
    var window = getWindow();
    var style;

    if (window.getComputedStyle) {
      style = window.getComputedStyle(el, null);
    }

    if (!style && el.currentStyle) {
      style = el.currentStyle;
    }

    if (!style) {
      style = el.style;
    }

    return style;
  }

  function getTranslate(el, axis) {
    if (axis === void 0) {
      axis = 'x';
    }

    var window = getWindow();
    var matrix;
    var curTransform;
    var transformMatrix;
    var curStyle = getComputedStyle$1(el);

    if (window.WebKitCSSMatrix) {
      curTransform = curStyle.transform || curStyle.webkitTransform;

      if (curTransform.split(',').length > 6) {
        curTransform = curTransform.split(', ').map(function (a) {
          return a.replace(',', '.');
        }).join(', ');
      } // Some old versions of Webkit choke when 'none' is passed; pass
      // empty string instead in this case


      transformMatrix = new window.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
    } else {
      transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
      matrix = transformMatrix.toString().split(',');
    }

    if (axis === 'x') {
      // Latest Chrome and webkits Fix
      if (window.WebKitCSSMatrix) curTransform = transformMatrix.m41; // Crazy IE10 Matrix
      else if (matrix.length === 16) curTransform = parseFloat(matrix[12]); // Normal Browsers
      else curTransform = parseFloat(matrix[4]);
    }

    if (axis === 'y') {
      // Latest Chrome and webkits Fix
      if (window.WebKitCSSMatrix) curTransform = transformMatrix.m42; // Crazy IE10 Matrix
      else if (matrix.length === 16) curTransform = parseFloat(matrix[13]); // Normal Browsers
      else curTransform = parseFloat(matrix[5]);
    }

    return curTransform || 0;
  }

  function isObject$1(o) {
    return typeof o === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
  }

  function isNode(node) {
    // eslint-disable-next-line
    if (typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined') {
      return node instanceof HTMLElement;
    }

    return node && (node.nodeType === 1 || node.nodeType === 11);
  }

  function extend$1() {
    var to = Object(arguments.length <= 0 ? undefined : arguments[0]);
    var noExtend = ['__proto__', 'constructor', 'prototype'];

    for (var i = 1; i < arguments.length; i += 1) {
      var nextSource = i < 0 || arguments.length <= i ? undefined : arguments[i];

      if (nextSource !== undefined && nextSource !== null && !isNode(nextSource)) {
        var keysArray = Object.keys(Object(nextSource)).filter(function (key) {
          return noExtend.indexOf(key) < 0;
        });

        for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
          var nextKey = keysArray[nextIndex];
          var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);

          if (desc !== undefined && desc.enumerable) {
            if (isObject$1(to[nextKey]) && isObject$1(nextSource[nextKey])) {
              if (nextSource[nextKey].__swiper__) {
                to[nextKey] = nextSource[nextKey];
              } else {
                extend$1(to[nextKey], nextSource[nextKey]);
              }
            } else if (!isObject$1(to[nextKey]) && isObject$1(nextSource[nextKey])) {
              to[nextKey] = {};

              if (nextSource[nextKey].__swiper__) {
                to[nextKey] = nextSource[nextKey];
              } else {
                extend$1(to[nextKey], nextSource[nextKey]);
              }
            } else {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
    }

    return to;
  }

  function bindModuleMethods(instance, obj) {
    Object.keys(obj).forEach(function (key) {
      if (isObject$1(obj[key])) {
        Object.keys(obj[key]).forEach(function (subKey) {
          if (typeof obj[key][subKey] === 'function') {
            obj[key][subKey] = obj[key][subKey].bind(instance);
          }
        });
      }

      instance[key] = obj[key];
    });
  }

  function classesToSelector(classes) {
    if (classes === void 0) {
      classes = '';
    }

    return "." + classes.trim().replace(/([\.:!\/])/g, '\\$1') // eslint-disable-line
    .replace(/ /g, '.');
  }

  function createElementIfNotDefined($container, params, createElements, checkProps) {
    var document = getDocument();

    if (createElements) {
      Object.keys(checkProps).forEach(function (key) {
        if (!params[key] && params.auto === true) {
          var element = document.createElement('div');
          element.className = checkProps[key];
          $container.append(element);
          params[key] = element;
        }
      });
    }

    return params;
  }

  var support;

  function calcSupport() {
    var window = getWindow();
    var document = getDocument();
    return {
      touch: !!('ontouchstart' in window || window.DocumentTouch && document instanceof window.DocumentTouch),
      pointerEvents: !!window.PointerEvent && 'maxTouchPoints' in window.navigator && window.navigator.maxTouchPoints >= 0,
      observer: function checkObserver() {
        return 'MutationObserver' in window || 'WebkitMutationObserver' in window;
      }(),
      passiveListener: function checkPassiveListener() {
        var supportsPassive = false;

        try {
          var opts = Object.defineProperty({}, 'passive', {
            // eslint-disable-next-line
            get: function get() {
              supportsPassive = true;
            }
          });
          window.addEventListener('testPassiveListener', null, opts);
        } catch (e) {// No support
        }

        return supportsPassive;
      }(),
      gestures: function checkGestures() {
        return 'ongesturestart' in window;
      }()
    };
  }

  function getSupport() {
    if (!support) {
      support = calcSupport();
    }

    return support;
  }

  var device;

  function calcDevice(_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
        userAgent = _ref.userAgent;

    var support = getSupport();
    var window = getWindow();
    var platform = window.navigator.platform;
    var ua = userAgent || window.navigator.userAgent;
    var device = {
      ios: false,
      android: false
    };
    var screenWidth = window.screen.width;
    var screenHeight = window.screen.height;
    var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line

    var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
    var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
    var iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
    var windows = platform === 'Win32';
    var macos = platform === 'MacIntel'; // iPadOs 13 fix

    var iPadScreens = ['1024x1366', '1366x1024', '834x1194', '1194x834', '834x1112', '1112x834', '768x1024', '1024x768', '820x1180', '1180x820', '810x1080', '1080x810'];

    if (!ipad && macos && support.touch && iPadScreens.indexOf(screenWidth + "x" + screenHeight) >= 0) {
      ipad = ua.match(/(Version)\/([\d.]+)/);
      if (!ipad) ipad = [0, 1, '13_0_0'];
      macos = false;
    } // Android


    if (android && !windows) {
      device.os = 'android';
      device.android = true;
    }

    if (ipad || iphone || ipod) {
      device.os = 'ios';
      device.ios = true;
    } // Export object


    return device;
  }

  function getDevice(overrides) {
    if (overrides === void 0) {
      overrides = {};
    }

    if (!device) {
      device = calcDevice(overrides);
    }

    return device;
  }

  var browser;

  function calcBrowser() {
    var window = getWindow();

    function isSafari() {
      var ua = window.navigator.userAgent.toLowerCase();
      return ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
    }

    return {
      isEdge: !!window.navigator.userAgent.match(/Edge/g),
      isSafari: isSafari(),
      isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent)
    };
  }

  function getBrowser() {
    if (!browser) {
      browser = calcBrowser();
    }

    return browser;
  }

  var supportsResizeObserver = function supportsResizeObserver() {
    var window = getWindow();
    return typeof window.ResizeObserver !== 'undefined';
  };

  var Resize = {
    name: 'resize',
    create: function create() {
      var swiper = this;
      extend$1(swiper, {
        resize: {
          observer: null,
          createObserver: function createObserver() {
            if (!swiper || swiper.destroyed || !swiper.initialized) return;
            swiper.resize.observer = new ResizeObserver(function (entries) {
              var width = swiper.width,
                  height = swiper.height;
              var newWidth = width;
              var newHeight = height;
              entries.forEach(function (_ref) {
                var contentBoxSize = _ref.contentBoxSize,
                    contentRect = _ref.contentRect,
                    target = _ref.target;
                if (target && target !== swiper.el) return;
                newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
                newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
              });

              if (newWidth !== width || newHeight !== height) {
                swiper.resize.resizeHandler();
              }
            });
            swiper.resize.observer.observe(swiper.el);
          },
          removeObserver: function removeObserver() {
            if (swiper.resize.observer && swiper.resize.observer.unobserve && swiper.el) {
              swiper.resize.observer.unobserve(swiper.el);
              swiper.resize.observer = null;
            }
          },
          resizeHandler: function resizeHandler() {
            if (!swiper || swiper.destroyed || !swiper.initialized) return;
            swiper.emit('beforeResize');
            swiper.emit('resize');
          },
          orientationChangeHandler: function orientationChangeHandler() {
            if (!swiper || swiper.destroyed || !swiper.initialized) return;
            swiper.emit('orientationchange');
          }
        }
      });
    },
    on: {
      init: function init(swiper) {
        var window = getWindow();

        if (swiper.params.resizeObserver && supportsResizeObserver()) {
          swiper.resize.createObserver();
          return;
        } // Emit resize


        window.addEventListener('resize', swiper.resize.resizeHandler); // Emit orientationchange

        window.addEventListener('orientationchange', swiper.resize.orientationChangeHandler);
      },
      destroy: function destroy(swiper) {
        var window = getWindow();
        swiper.resize.removeObserver();
        window.removeEventListener('resize', swiper.resize.resizeHandler);
        window.removeEventListener('orientationchange', swiper.resize.orientationChangeHandler);
      }
    }
  };

  function _extends$4() {
    _extends$4 = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends$4.apply(this, arguments);
  }

  var Observer = {
    attach: function attach(target, options) {
      if (options === void 0) {
        options = {};
      }

      var window = getWindow();
      var swiper = this;
      var ObserverFunc = window.MutationObserver || window.WebkitMutationObserver;
      var observer = new ObserverFunc(function (mutations) {
        // The observerUpdate event should only be triggered
        // once despite the number of mutations.  Additional
        // triggers are redundant and are very costly
        if (mutations.length === 1) {
          swiper.emit('observerUpdate', mutations[0]);
          return;
        }

        var observerUpdate = function observerUpdate() {
          swiper.emit('observerUpdate', mutations[0]);
        };

        if (window.requestAnimationFrame) {
          window.requestAnimationFrame(observerUpdate);
        } else {
          window.setTimeout(observerUpdate, 0);
        }
      });
      observer.observe(target, {
        attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
        childList: typeof options.childList === 'undefined' ? true : options.childList,
        characterData: typeof options.characterData === 'undefined' ? true : options.characterData
      });
      swiper.observer.observers.push(observer);
    },
    init: function init() {
      var swiper = this;
      if (!swiper.support.observer || !swiper.params.observer) return;

      if (swiper.params.observeParents) {
        var containerParents = swiper.$el.parents();

        for (var i = 0; i < containerParents.length; i += 1) {
          swiper.observer.attach(containerParents[i]);
        }
      } // Observe container


      swiper.observer.attach(swiper.$el[0], {
        childList: swiper.params.observeSlideChildren
      }); // Observe wrapper

      swiper.observer.attach(swiper.$wrapperEl[0], {
        attributes: false
      });
    },
    destroy: function destroy() {
      var swiper = this;
      swiper.observer.observers.forEach(function (observer) {
        observer.disconnect();
      });
      swiper.observer.observers = [];
    }
  };
  var Observer$1 = {
    name: 'observer',
    params: {
      observer: false,
      observeParents: false,
      observeSlideChildren: false
    },
    create: function create() {
      var swiper = this;
      bindModuleMethods(swiper, {
        observer: _extends$4({}, Observer, {
          observers: []
        })
      });
    },
    on: {
      init: function init(swiper) {
        swiper.observer.init();
      },
      destroy: function destroy(swiper) {
        swiper.observer.destroy();
      }
    }
  };
  var modular = {
    useParams: function useParams(instanceParams) {
      var instance = this;
      if (!instance.modules) return;
      Object.keys(instance.modules).forEach(function (moduleName) {
        var module = instance.modules[moduleName]; // Extend params

        if (module.params) {
          extend$1(instanceParams, module.params);
        }
      });
    },
    useModules: function useModules(modulesParams) {
      if (modulesParams === void 0) {
        modulesParams = {};
      }

      var instance = this;
      if (!instance.modules) return;
      Object.keys(instance.modules).forEach(function (moduleName) {
        var module = instance.modules[moduleName];
        var moduleParams = modulesParams[moduleName] || {}; // Add event listeners

        if (module.on && instance.on) {
          Object.keys(module.on).forEach(function (moduleEventName) {
            instance.on(moduleEventName, module.on[moduleEventName]);
          });
        } // Module create callback


        if (module.create) {
          module.create.bind(instance)(moduleParams);
        }
      });
    }
  };
  /* eslint-disable no-underscore-dangle */

  var eventsEmitter = {
    on: function on(events, handler, priority) {
      var self = this;
      if (typeof handler !== 'function') return self;
      var method = priority ? 'unshift' : 'push';
      events.split(' ').forEach(function (event) {
        if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
        self.eventsListeners[event][method](handler);
      });
      return self;
    },
    once: function once(events, handler, priority) {
      var self = this;
      if (typeof handler !== 'function') return self;

      function onceHandler() {
        self.off(events, onceHandler);

        if (onceHandler.__emitterProxy) {
          delete onceHandler.__emitterProxy;
        }

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        handler.apply(self, args);
      }

      onceHandler.__emitterProxy = handler;
      return self.on(events, onceHandler, priority);
    },
    onAny: function onAny(handler, priority) {
      var self = this;
      if (typeof handler !== 'function') return self;
      var method = priority ? 'unshift' : 'push';

      if (self.eventsAnyListeners.indexOf(handler) < 0) {
        self.eventsAnyListeners[method](handler);
      }

      return self;
    },
    offAny: function offAny(handler) {
      var self = this;
      if (!self.eventsAnyListeners) return self;
      var index = self.eventsAnyListeners.indexOf(handler);

      if (index >= 0) {
        self.eventsAnyListeners.splice(index, 1);
      }

      return self;
    },
    off: function off(events, handler) {
      var self = this;
      if (!self.eventsListeners) return self;
      events.split(' ').forEach(function (event) {
        if (typeof handler === 'undefined') {
          self.eventsListeners[event] = [];
        } else if (self.eventsListeners[event]) {
          self.eventsListeners[event].forEach(function (eventHandler, index) {
            if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) {
              self.eventsListeners[event].splice(index, 1);
            }
          });
        }
      });
      return self;
    },
    emit: function emit() {
      var self = this;
      if (!self.eventsListeners) return self;
      var events;
      var data;
      var context;

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      if (typeof args[0] === 'string' || Array.isArray(args[0])) {
        events = args[0];
        data = args.slice(1, args.length);
        context = self;
      } else {
        events = args[0].events;
        data = args[0].data;
        context = args[0].context || self;
      }

      data.unshift(context);
      var eventsArray = Array.isArray(events) ? events : events.split(' ');
      eventsArray.forEach(function (event) {
        if (self.eventsAnyListeners && self.eventsAnyListeners.length) {
          self.eventsAnyListeners.forEach(function (eventHandler) {
            eventHandler.apply(context, [event].concat(data));
          });
        }

        if (self.eventsListeners && self.eventsListeners[event]) {
          self.eventsListeners[event].forEach(function (eventHandler) {
            eventHandler.apply(context, data);
          });
        }
      });
      return self;
    }
  };

  function updateSize() {
    var swiper = this;
    var width;
    var height;
    var $el = swiper.$el;

    if (typeof swiper.params.width !== 'undefined' && swiper.params.width !== null) {
      width = swiper.params.width;
    } else {
      width = $el[0].clientWidth;
    }

    if (typeof swiper.params.height !== 'undefined' && swiper.params.height !== null) {
      height = swiper.params.height;
    } else {
      height = $el[0].clientHeight;
    }

    if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) {
      return;
    } // Subtract paddings


    width = width - parseInt($el.css('padding-left') || 0, 10) - parseInt($el.css('padding-right') || 0, 10);
    height = height - parseInt($el.css('padding-top') || 0, 10) - parseInt($el.css('padding-bottom') || 0, 10);
    if (Number.isNaN(width)) width = 0;
    if (Number.isNaN(height)) height = 0;
    extend$1(swiper, {
      width: width,
      height: height,
      size: swiper.isHorizontal() ? width : height
    });
  }

  function updateSlides() {
    var swiper = this;

    function getDirectionLabel(property) {
      if (swiper.isHorizontal()) {
        return property;
      } // prettier-ignore


      return {
        'width': 'height',
        'margin-top': 'margin-left',
        'margin-bottom ': 'margin-right',
        'margin-left': 'margin-top',
        'margin-right': 'margin-bottom',
        'padding-left': 'padding-top',
        'padding-right': 'padding-bottom',
        'marginRight': 'marginBottom'
      }[property];
    }

    function getDirectionPropertyValue(node, label) {
      return parseFloat(node.getPropertyValue(getDirectionLabel(label)) || 0);
    }

    var params = swiper.params;
    var $wrapperEl = swiper.$wrapperEl,
        swiperSize = swiper.size,
        rtl = swiper.rtlTranslate,
        wrongRTL = swiper.wrongRTL;
    var isVirtual = swiper.virtual && params.virtual.enabled;
    var previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
    var slides = $wrapperEl.children("." + swiper.params.slideClass);
    var slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
    var snapGrid = [];
    var slidesGrid = [];
    var slidesSizesGrid = [];
    var offsetBefore = params.slidesOffsetBefore;

    if (typeof offsetBefore === 'function') {
      offsetBefore = params.slidesOffsetBefore.call(swiper);
    }

    var offsetAfter = params.slidesOffsetAfter;

    if (typeof offsetAfter === 'function') {
      offsetAfter = params.slidesOffsetAfter.call(swiper);
    }

    var previousSnapGridLength = swiper.snapGrid.length;
    var previousSlidesGridLength = swiper.slidesGrid.length;
    var spaceBetween = params.spaceBetween;
    var slidePosition = -offsetBefore;
    var prevSlideSize = 0;
    var index = 0;

    if (typeof swiperSize === 'undefined') {
      return;
    }

    if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
      spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
    }

    swiper.virtualSize = -spaceBetween; // reset margins

    if (rtl) slides.css({
      marginLeft: '',
      marginBottom: '',
      marginTop: ''
    });else slides.css({
      marginRight: '',
      marginBottom: '',
      marginTop: ''
    });
    var slidesNumberEvenToRows;

    if (params.slidesPerColumn > 1) {
      if (Math.floor(slidesLength / params.slidesPerColumn) === slidesLength / swiper.params.slidesPerColumn) {
        slidesNumberEvenToRows = slidesLength;
      } else {
        slidesNumberEvenToRows = Math.ceil(slidesLength / params.slidesPerColumn) * params.slidesPerColumn;
      }

      if (params.slidesPerView !== 'auto' && params.slidesPerColumnFill === 'row') {
        slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, params.slidesPerView * params.slidesPerColumn);
      }
    } // Calc slides


    var slideSize;
    var slidesPerColumn = params.slidesPerColumn;
    var slidesPerRow = slidesNumberEvenToRows / slidesPerColumn;
    var numFullColumns = Math.floor(slidesLength / params.slidesPerColumn);

    for (var i = 0; i < slidesLength; i += 1) {
      slideSize = 0;
      var slide = slides.eq(i);

      if (params.slidesPerColumn > 1) {
        // Set slides order
        var newSlideOrderIndex = void 0;
        var column = void 0;
        var row = void 0;

        if (params.slidesPerColumnFill === 'row' && params.slidesPerGroup > 1) {
          var groupIndex = Math.floor(i / (params.slidesPerGroup * params.slidesPerColumn));
          var slideIndexInGroup = i - params.slidesPerColumn * params.slidesPerGroup * groupIndex;
          var columnsInGroup = groupIndex === 0 ? params.slidesPerGroup : Math.min(Math.ceil((slidesLength - groupIndex * slidesPerColumn * params.slidesPerGroup) / slidesPerColumn), params.slidesPerGroup);
          row = Math.floor(slideIndexInGroup / columnsInGroup);
          column = slideIndexInGroup - row * columnsInGroup + groupIndex * params.slidesPerGroup;
          newSlideOrderIndex = column + row * slidesNumberEvenToRows / slidesPerColumn;
          slide.css({
            '-webkit-box-ordinal-group': newSlideOrderIndex,
            '-moz-box-ordinal-group': newSlideOrderIndex,
            '-ms-flex-order': newSlideOrderIndex,
            '-webkit-order': newSlideOrderIndex,
            order: newSlideOrderIndex
          });
        } else if (params.slidesPerColumnFill === 'column') {
          column = Math.floor(i / slidesPerColumn);
          row = i - column * slidesPerColumn;

          if (column > numFullColumns || column === numFullColumns && row === slidesPerColumn - 1) {
            row += 1;

            if (row >= slidesPerColumn) {
              row = 0;
              column += 1;
            }
          }
        } else {
          row = Math.floor(i / slidesPerRow);
          column = i - row * slidesPerRow;
        }

        slide.css(getDirectionLabel('margin-top'), row !== 0 ? params.spaceBetween && params.spaceBetween + "px" : '');
      }

      if (slide.css('display') === 'none') continue; // eslint-disable-line

      if (params.slidesPerView === 'auto') {
        var slideStyles = getComputedStyle(slide[0]);
        var currentTransform = slide[0].style.transform;
        var currentWebKitTransform = slide[0].style.webkitTransform;

        if (currentTransform) {
          slide[0].style.transform = 'none';
        }

        if (currentWebKitTransform) {
          slide[0].style.webkitTransform = 'none';
        }

        if (params.roundLengths) {
          slideSize = swiper.isHorizontal() ? slide.outerWidth(true) : slide.outerHeight(true);
        } else {
          // eslint-disable-next-line
          var width = getDirectionPropertyValue(slideStyles, 'width');
          var paddingLeft = getDirectionPropertyValue(slideStyles, 'padding-left');
          var paddingRight = getDirectionPropertyValue(slideStyles, 'padding-right');
          var marginLeft = getDirectionPropertyValue(slideStyles, 'margin-left');
          var marginRight = getDirectionPropertyValue(slideStyles, 'margin-right');
          var boxSizing = slideStyles.getPropertyValue('box-sizing');

          if (boxSizing && boxSizing === 'border-box') {
            slideSize = width + marginLeft + marginRight;
          } else {
            var _slide$ = slide[0],
                clientWidth = _slide$.clientWidth,
                offsetWidth = _slide$.offsetWidth;
            slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
          }
        }

        if (currentTransform) {
          slide[0].style.transform = currentTransform;
        }

        if (currentWebKitTransform) {
          slide[0].style.webkitTransform = currentWebKitTransform;
        }

        if (params.roundLengths) slideSize = Math.floor(slideSize);
      } else {
        slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
        if (params.roundLengths) slideSize = Math.floor(slideSize);

        if (slides[i]) {
          slides[i].style[getDirectionLabel('width')] = slideSize + "px";
        }
      }

      if (slides[i]) {
        slides[i].swiperSlideSize = slideSize;
      }

      slidesSizesGrid.push(slideSize);

      if (params.centeredSlides) {
        slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
        if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
        if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
        if (Math.abs(slidePosition) < 1 / 1000) slidePosition = 0;
        if (params.roundLengths) slidePosition = Math.floor(slidePosition);
        if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
        slidesGrid.push(slidePosition);
      } else {
        if (params.roundLengths) slidePosition = Math.floor(slidePosition);
        if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
        slidesGrid.push(slidePosition);
        slidePosition = slidePosition + slideSize + spaceBetween;
      }

      swiper.virtualSize += slideSize + spaceBetween;
      prevSlideSize = slideSize;
      index += 1;
    }

    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
    var newSlidesGrid;

    if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) {
      $wrapperEl.css({
        width: swiper.virtualSize + params.spaceBetween + "px"
      });
    }

    if (params.setWrapperSize) {
      var _$wrapperEl$css;

      $wrapperEl.css((_$wrapperEl$css = {}, _$wrapperEl$css[getDirectionLabel('width')] = swiper.virtualSize + params.spaceBetween + "px", _$wrapperEl$css));
    }

    if (params.slidesPerColumn > 1) {
      var _$wrapperEl$css2;

      swiper.virtualSize = (slideSize + params.spaceBetween) * slidesNumberEvenToRows;
      swiper.virtualSize = Math.ceil(swiper.virtualSize / params.slidesPerColumn) - params.spaceBetween;
      $wrapperEl.css((_$wrapperEl$css2 = {}, _$wrapperEl$css2[getDirectionLabel('width')] = swiper.virtualSize + params.spaceBetween + "px", _$wrapperEl$css2));

      if (params.centeredSlides) {
        newSlidesGrid = [];

        for (var _i = 0; _i < snapGrid.length; _i += 1) {
          var slidesGridItem = snapGrid[_i];
          if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
          if (snapGrid[_i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
        }

        snapGrid = newSlidesGrid;
      }
    } // Remove last grid elements depending on width


    if (!params.centeredSlides) {
      newSlidesGrid = [];

      for (var _i2 = 0; _i2 < snapGrid.length; _i2 += 1) {
        var _slidesGridItem = snapGrid[_i2];
        if (params.roundLengths) _slidesGridItem = Math.floor(_slidesGridItem);

        if (snapGrid[_i2] <= swiper.virtualSize - swiperSize) {
          newSlidesGrid.push(_slidesGridItem);
        }
      }

      snapGrid = newSlidesGrid;

      if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
        snapGrid.push(swiper.virtualSize - swiperSize);
      }
    }

    if (snapGrid.length === 0) snapGrid = [0];

    if (params.spaceBetween !== 0) {
      var _slides$filter$css;

      var key = swiper.isHorizontal() && rtl ? 'marginLeft' : getDirectionLabel('marginRight');
      slides.filter(function (_, slideIndex) {
        if (!params.cssMode) return true;

        if (slideIndex === slides.length - 1) {
          return false;
        }

        return true;
      }).css((_slides$filter$css = {}, _slides$filter$css[key] = spaceBetween + "px", _slides$filter$css));
    }

    if (params.centeredSlides && params.centeredSlidesBounds) {
      var allSlidesSize = 0;
      slidesSizesGrid.forEach(function (slideSizeValue) {
        allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
      });
      allSlidesSize -= params.spaceBetween;
      var maxSnap = allSlidesSize - swiperSize;
      snapGrid = snapGrid.map(function (snap) {
        if (snap < 0) return -offsetBefore;
        if (snap > maxSnap) return maxSnap + offsetAfter;
        return snap;
      });
    }

    if (params.centerInsufficientSlides) {
      var _allSlidesSize = 0;
      slidesSizesGrid.forEach(function (slideSizeValue) {
        _allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
      });
      _allSlidesSize -= params.spaceBetween;

      if (_allSlidesSize < swiperSize) {
        var allSlidesOffset = (swiperSize - _allSlidesSize) / 2;
        snapGrid.forEach(function (snap, snapIndex) {
          snapGrid[snapIndex] = snap - allSlidesOffset;
        });
        slidesGrid.forEach(function (snap, snapIndex) {
          slidesGrid[snapIndex] = snap + allSlidesOffset;
        });
      }
    }

    extend$1(swiper, {
      slides: slides,
      snapGrid: snapGrid,
      slidesGrid: slidesGrid,
      slidesSizesGrid: slidesSizesGrid
    });

    if (slidesLength !== previousSlidesLength) {
      swiper.emit('slidesLengthChange');
    }

    if (snapGrid.length !== previousSnapGridLength) {
      if (swiper.params.watchOverflow) swiper.checkOverflow();
      swiper.emit('snapGridLengthChange');
    }

    if (slidesGrid.length !== previousSlidesGridLength) {
      swiper.emit('slidesGridLengthChange');
    }

    if (params.watchSlidesProgress || params.watchSlidesVisibility) {
      swiper.updateSlidesOffset();
    }
  }

  function updateAutoHeight(speed) {
    var swiper = this;
    var activeSlides = [];
    var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    var newHeight = 0;
    var i;

    if (typeof speed === 'number') {
      swiper.setTransition(speed);
    } else if (speed === true) {
      swiper.setTransition(swiper.params.speed);
    }

    var getSlideByIndex = function getSlideByIndex(index) {
      if (isVirtual) {
        return swiper.slides.filter(function (el) {
          return parseInt(el.getAttribute('data-swiper-slide-index'), 10) === index;
        })[0];
      }

      return swiper.slides.eq(index)[0];
    }; // Find slides currently in view


    if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
      if (swiper.params.centeredSlides) {
        swiper.visibleSlides.each(function (slide) {
          activeSlides.push(slide);
        });
      } else {
        for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
          var index = swiper.activeIndex + i;
          if (index > swiper.slides.length && !isVirtual) break;
          activeSlides.push(getSlideByIndex(index));
        }
      }
    } else {
      activeSlides.push(getSlideByIndex(swiper.activeIndex));
    } // Find new height from highest slide in view


    for (i = 0; i < activeSlides.length; i += 1) {
      if (typeof activeSlides[i] !== 'undefined') {
        var height = activeSlides[i].offsetHeight;
        newHeight = height > newHeight ? height : newHeight;
      }
    } // Update Height


    if (newHeight) swiper.$wrapperEl.css('height', newHeight + "px");
  }

  function updateSlidesOffset() {
    var swiper = this;
    var slides = swiper.slides;

    for (var i = 0; i < slides.length; i += 1) {
      slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
    }
  }

  function updateSlidesProgress(translate) {
    if (translate === void 0) {
      translate = this && this.translate || 0;
    }

    var swiper = this;
    var params = swiper.params;
    var slides = swiper.slides,
        rtl = swiper.rtlTranslate;
    if (slides.length === 0) return;
    if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();
    var offsetCenter = -translate;
    if (rtl) offsetCenter = translate; // Visible Slides

    slides.removeClass(params.slideVisibleClass);
    swiper.visibleSlidesIndexes = [];
    swiper.visibleSlides = [];

    for (var i = 0; i < slides.length; i += 1) {
      var slide = slides[i];
      var slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slide.swiperSlideOffset) / (slide.swiperSlideSize + params.spaceBetween);

      if (params.watchSlidesVisibility || params.centeredSlides && params.autoHeight) {
        var slideBefore = -(offsetCenter - slide.swiperSlideOffset);
        var slideAfter = slideBefore + swiper.slidesSizesGrid[i];
        var isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;

        if (isVisible) {
          swiper.visibleSlides.push(slide);
          swiper.visibleSlidesIndexes.push(i);
          slides.eq(i).addClass(params.slideVisibleClass);
        }
      }

      slide.progress = rtl ? -slideProgress : slideProgress;
    }

    swiper.visibleSlides = $(swiper.visibleSlides);
  }

  function updateProgress(translate) {
    var swiper = this;

    if (typeof translate === 'undefined') {
      var multiplier = swiper.rtlTranslate ? -1 : 1; // eslint-disable-next-line

      translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
    }

    var params = swiper.params;
    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    var progress = swiper.progress,
        isBeginning = swiper.isBeginning,
        isEnd = swiper.isEnd;
    var wasBeginning = isBeginning;
    var wasEnd = isEnd;

    if (translatesDiff === 0) {
      progress = 0;
      isBeginning = true;
      isEnd = true;
    } else {
      progress = (translate - swiper.minTranslate()) / translatesDiff;
      isBeginning = progress <= 0;
      isEnd = progress >= 1;
    }

    extend$1(swiper, {
      progress: progress,
      isBeginning: isBeginning,
      isEnd: isEnd
    });
    if (params.watchSlidesProgress || params.watchSlidesVisibility || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);

    if (isBeginning && !wasBeginning) {
      swiper.emit('reachBeginning toEdge');
    }

    if (isEnd && !wasEnd) {
      swiper.emit('reachEnd toEdge');
    }

    if (wasBeginning && !isBeginning || wasEnd && !isEnd) {
      swiper.emit('fromEdge');
    }

    swiper.emit('progress', progress);
  }

  function updateSlidesClasses() {
    var swiper = this;
    var slides = swiper.slides,
        params = swiper.params,
        $wrapperEl = swiper.$wrapperEl,
        activeIndex = swiper.activeIndex,
        realIndex = swiper.realIndex;
    var isVirtual = swiper.virtual && params.virtual.enabled;
    slides.removeClass(params.slideActiveClass + " " + params.slideNextClass + " " + params.slidePrevClass + " " + params.slideDuplicateActiveClass + " " + params.slideDuplicateNextClass + " " + params.slideDuplicatePrevClass);
    var activeSlide;

    if (isVirtual) {
      activeSlide = swiper.$wrapperEl.find("." + params.slideClass + "[data-swiper-slide-index=\"" + activeIndex + "\"]");
    } else {
      activeSlide = slides.eq(activeIndex);
    } // Active classes


    activeSlide.addClass(params.slideActiveClass);

    if (params.loop) {
      // Duplicate to all looped slides
      if (activeSlide.hasClass(params.slideDuplicateClass)) {
        $wrapperEl.children("." + params.slideClass + ":not(." + params.slideDuplicateClass + ")[data-swiper-slide-index=\"" + realIndex + "\"]").addClass(params.slideDuplicateActiveClass);
      } else {
        $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + "[data-swiper-slide-index=\"" + realIndex + "\"]").addClass(params.slideDuplicateActiveClass);
      }
    } // Next Slide


    var nextSlide = activeSlide.nextAll("." + params.slideClass).eq(0).addClass(params.slideNextClass);

    if (params.loop && nextSlide.length === 0) {
      nextSlide = slides.eq(0);
      nextSlide.addClass(params.slideNextClass);
    } // Prev Slide


    var prevSlide = activeSlide.prevAll("." + params.slideClass).eq(0).addClass(params.slidePrevClass);

    if (params.loop && prevSlide.length === 0) {
      prevSlide = slides.eq(-1);
      prevSlide.addClass(params.slidePrevClass);
    }

    if (params.loop) {
      // Duplicate to all looped slides
      if (nextSlide.hasClass(params.slideDuplicateClass)) {
        $wrapperEl.children("." + params.slideClass + ":not(." + params.slideDuplicateClass + ")[data-swiper-slide-index=\"" + nextSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicateNextClass);
      } else {
        $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + "[data-swiper-slide-index=\"" + nextSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicateNextClass);
      }

      if (prevSlide.hasClass(params.slideDuplicateClass)) {
        $wrapperEl.children("." + params.slideClass + ":not(." + params.slideDuplicateClass + ")[data-swiper-slide-index=\"" + prevSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicatePrevClass);
      } else {
        $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + "[data-swiper-slide-index=\"" + prevSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicatePrevClass);
      }
    }

    swiper.emitSlidesClasses();
  }

  function updateActiveIndex(newActiveIndex) {
    var swiper = this;
    var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    var slidesGrid = swiper.slidesGrid,
        snapGrid = swiper.snapGrid,
        params = swiper.params,
        previousIndex = swiper.activeIndex,
        previousRealIndex = swiper.realIndex,
        previousSnapIndex = swiper.snapIndex;
    var activeIndex = newActiveIndex;
    var snapIndex;

    if (typeof activeIndex === 'undefined') {
      for (var i = 0; i < slidesGrid.length; i += 1) {
        if (typeof slidesGrid[i + 1] !== 'undefined') {
          if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) {
            activeIndex = i;
          } else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) {
            activeIndex = i + 1;
          }
        } else if (translate >= slidesGrid[i]) {
          activeIndex = i;
        }
      } // Normalize slideIndex


      if (params.normalizeSlideIndex) {
        if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
      }
    }

    if (snapGrid.indexOf(translate) >= 0) {
      snapIndex = snapGrid.indexOf(translate);
    } else {
      var skip = Math.min(params.slidesPerGroupSkip, activeIndex);
      snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
    }

    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;

    if (activeIndex === previousIndex) {
      if (snapIndex !== previousSnapIndex) {
        swiper.snapIndex = snapIndex;
        swiper.emit('snapIndexChange');
      }

      return;
    } // Get real index


    var realIndex = parseInt(swiper.slides.eq(activeIndex).attr('data-swiper-slide-index') || activeIndex, 10);
    extend$1(swiper, {
      snapIndex: snapIndex,
      realIndex: realIndex,
      previousIndex: previousIndex,
      activeIndex: activeIndex
    });
    swiper.emit('activeIndexChange');
    swiper.emit('snapIndexChange');

    if (previousRealIndex !== realIndex) {
      swiper.emit('realIndexChange');
    }

    if (swiper.initialized || swiper.params.runCallbacksOnInit) {
      swiper.emit('slideChange');
    }
  }

  function updateClickedSlide(e) {
    var swiper = this;
    var params = swiper.params;
    var slide = $(e.target).closest("." + params.slideClass)[0];
    var slideFound = false;
    var slideIndex;

    if (slide) {
      for (var i = 0; i < swiper.slides.length; i += 1) {
        if (swiper.slides[i] === slide) {
          slideFound = true;
          slideIndex = i;
          break;
        }
      }
    }

    if (slide && slideFound) {
      swiper.clickedSlide = slide;

      if (swiper.virtual && swiper.params.virtual.enabled) {
        swiper.clickedIndex = parseInt($(slide).attr('data-swiper-slide-index'), 10);
      } else {
        swiper.clickedIndex = slideIndex;
      }
    } else {
      swiper.clickedSlide = undefined;
      swiper.clickedIndex = undefined;
      return;
    }

    if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) {
      swiper.slideToClickedSlide();
    }
  }

  var update = {
    updateSize: updateSize,
    updateSlides: updateSlides,
    updateAutoHeight: updateAutoHeight,
    updateSlidesOffset: updateSlidesOffset,
    updateSlidesProgress: updateSlidesProgress,
    updateProgress: updateProgress,
    updateSlidesClasses: updateSlidesClasses,
    updateActiveIndex: updateActiveIndex,
    updateClickedSlide: updateClickedSlide
  };

  function getSwiperTranslate(axis) {
    if (axis === void 0) {
      axis = this.isHorizontal() ? 'x' : 'y';
    }

    var swiper = this;
    var params = swiper.params,
        rtl = swiper.rtlTranslate,
        translate = swiper.translate,
        $wrapperEl = swiper.$wrapperEl;

    if (params.virtualTranslate) {
      return rtl ? -translate : translate;
    }

    if (params.cssMode) {
      return translate;
    }

    var currentTranslate = getTranslate($wrapperEl[0], axis);
    if (rtl) currentTranslate = -currentTranslate;
    return currentTranslate || 0;
  }

  function setTranslate(translate, byController) {
    var swiper = this;
    var rtl = swiper.rtlTranslate,
        params = swiper.params,
        $wrapperEl = swiper.$wrapperEl,
        wrapperEl = swiper.wrapperEl,
        progress = swiper.progress;
    var x = 0;
    var y = 0;
    var z = 0;

    if (swiper.isHorizontal()) {
      x = rtl ? -translate : translate;
    } else {
      y = translate;
    }

    if (params.roundLengths) {
      x = Math.floor(x);
      y = Math.floor(y);
    }

    if (params.cssMode) {
      wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
    } else if (!params.virtualTranslate) {
      $wrapperEl.transform("translate3d(" + x + "px, " + y + "px, " + z + "px)");
    }

    swiper.previousTranslate = swiper.translate;
    swiper.translate = swiper.isHorizontal() ? x : y; // Check if we need to update progress

    var newProgress;
    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();

    if (translatesDiff === 0) {
      newProgress = 0;
    } else {
      newProgress = (translate - swiper.minTranslate()) / translatesDiff;
    }

    if (newProgress !== progress) {
      swiper.updateProgress(translate);
    }

    swiper.emit('setTranslate', swiper.translate, byController);
  }

  function minTranslate() {
    return -this.snapGrid[0];
  }

  function maxTranslate() {
    return -this.snapGrid[this.snapGrid.length - 1];
  }

  function translateTo(translate, speed, runCallbacks, translateBounds, internal) {
    if (translate === void 0) {
      translate = 0;
    }

    if (speed === void 0) {
      speed = this.params.speed;
    }

    if (runCallbacks === void 0) {
      runCallbacks = true;
    }

    if (translateBounds === void 0) {
      translateBounds = true;
    }

    var swiper = this;
    var params = swiper.params,
        wrapperEl = swiper.wrapperEl;

    if (swiper.animating && params.preventInteractionOnTransition) {
      return false;
    }

    var minTranslate = swiper.minTranslate();
    var maxTranslate = swiper.maxTranslate();
    var newTranslate;
    if (translateBounds && translate > minTranslate) newTranslate = minTranslate;else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;else newTranslate = translate; // Update progress

    swiper.updateProgress(newTranslate);

    if (params.cssMode) {
      var isH = swiper.isHorizontal();

      if (speed === 0) {
        wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
      } else {
        // eslint-disable-next-line
        if (wrapperEl.scrollTo) {
          var _wrapperEl$scrollTo;

          wrapperEl.scrollTo((_wrapperEl$scrollTo = {}, _wrapperEl$scrollTo[isH ? 'left' : 'top'] = -newTranslate, _wrapperEl$scrollTo.behavior = 'smooth', _wrapperEl$scrollTo));
        } else {
          wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
        }
      }

      return true;
    }

    if (speed === 0) {
      swiper.setTransition(0);
      swiper.setTranslate(newTranslate);

      if (runCallbacks) {
        swiper.emit('beforeTransitionStart', speed, internal);
        swiper.emit('transitionEnd');
      }
    } else {
      swiper.setTransition(speed);
      swiper.setTranslate(newTranslate);

      if (runCallbacks) {
        swiper.emit('beforeTransitionStart', speed, internal);
        swiper.emit('transitionStart');
      }

      if (!swiper.animating) {
        swiper.animating = true;

        if (!swiper.onTranslateToWrapperTransitionEnd) {
          swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
            if (!swiper || swiper.destroyed) return;
            if (e.target !== this) return;
            swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
            swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
            swiper.onTranslateToWrapperTransitionEnd = null;
            delete swiper.onTranslateToWrapperTransitionEnd;

            if (runCallbacks) {
              swiper.emit('transitionEnd');
            }
          };
        }

        swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
        swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
      }
    }

    return true;
  }

  var translate = {
    getTranslate: getSwiperTranslate,
    setTranslate: setTranslate,
    minTranslate: minTranslate,
    maxTranslate: maxTranslate,
    translateTo: translateTo
  };

  function setTransition(duration, byController) {
    var swiper = this;

    if (!swiper.params.cssMode) {
      swiper.$wrapperEl.transition(duration);
    }

    swiper.emit('setTransition', duration, byController);
  }

  function transitionStart(runCallbacks, direction) {
    if (runCallbacks === void 0) {
      runCallbacks = true;
    }

    var swiper = this;
    var activeIndex = swiper.activeIndex,
        params = swiper.params,
        previousIndex = swiper.previousIndex;
    if (params.cssMode) return;

    if (params.autoHeight) {
      swiper.updateAutoHeight();
    }

    var dir = direction;

    if (!dir) {
      if (activeIndex > previousIndex) dir = 'next';else if (activeIndex < previousIndex) dir = 'prev';else dir = 'reset';
    }

    swiper.emit('transitionStart');

    if (runCallbacks && activeIndex !== previousIndex) {
      if (dir === 'reset') {
        swiper.emit('slideResetTransitionStart');
        return;
      }

      swiper.emit('slideChangeTransitionStart');

      if (dir === 'next') {
        swiper.emit('slideNextTransitionStart');
      } else {
        swiper.emit('slidePrevTransitionStart');
      }
    }
  }

  function transitionEnd(runCallbacks, direction) {
    if (runCallbacks === void 0) {
      runCallbacks = true;
    }

    var swiper = this;
    var activeIndex = swiper.activeIndex,
        previousIndex = swiper.previousIndex,
        params = swiper.params;
    swiper.animating = false;
    if (params.cssMode) return;
    swiper.setTransition(0);
    var dir = direction;

    if (!dir) {
      if (activeIndex > previousIndex) dir = 'next';else if (activeIndex < previousIndex) dir = 'prev';else dir = 'reset';
    }

    swiper.emit('transitionEnd');

    if (runCallbacks && activeIndex !== previousIndex) {
      if (dir === 'reset') {
        swiper.emit('slideResetTransitionEnd');
        return;
      }

      swiper.emit('slideChangeTransitionEnd');

      if (dir === 'next') {
        swiper.emit('slideNextTransitionEnd');
      } else {
        swiper.emit('slidePrevTransitionEnd');
      }
    }
  }

  var transition = {
    setTransition: setTransition,
    transitionStart: transitionStart,
    transitionEnd: transitionEnd
  };

  function slideTo(index, speed, runCallbacks, internal, initial) {
    if (index === void 0) {
      index = 0;
    }

    if (speed === void 0) {
      speed = this.params.speed;
    }

    if (runCallbacks === void 0) {
      runCallbacks = true;
    }

    if (typeof index !== 'number' && typeof index !== 'string') {
      throw new Error("The 'index' argument cannot have type other than 'number' or 'string'. [" + typeof index + "] given.");
    }

    if (typeof index === 'string') {
      /**
       * The `index` argument converted from `string` to `number`.
       * @type {number}
       */
      var indexAsNumber = parseInt(index, 10);
      /**
       * Determines whether the `index` argument is a valid `number`
       * after being converted from the `string` type.
       * @type {boolean}
       */

      var isValidNumber = isFinite(indexAsNumber);

      if (!isValidNumber) {
        throw new Error("The passed-in 'index' (string) couldn't be converted to 'number'. [" + index + "] given.");
      } // Knowing that the converted `index` is a valid number,
      // we can update the original argument's value.


      index = indexAsNumber;
    }

    var swiper = this;
    var slideIndex = index;
    if (slideIndex < 0) slideIndex = 0;
    var params = swiper.params,
        snapGrid = swiper.snapGrid,
        slidesGrid = swiper.slidesGrid,
        previousIndex = swiper.previousIndex,
        activeIndex = swiper.activeIndex,
        rtl = swiper.rtlTranslate,
        wrapperEl = swiper.wrapperEl,
        enabled = swiper.enabled;

    if (swiper.animating && params.preventInteractionOnTransition || !enabled && !internal && !initial) {
      return false;
    }

    var skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
    var snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;

    if ((activeIndex || params.initialSlide || 0) === (previousIndex || 0) && runCallbacks) {
      swiper.emit('beforeSlideChangeStart');
    }

    var translate = -snapGrid[snapIndex]; // Update progress

    swiper.updateProgress(translate); // Normalize slideIndex

    if (params.normalizeSlideIndex) {
      for (var i = 0; i < slidesGrid.length; i += 1) {
        var normalizedTranslate = -Math.floor(translate * 100);
        var normalizedGird = Math.floor(slidesGrid[i] * 100);
        var normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);

        if (typeof slidesGrid[i + 1] !== 'undefined') {
          if (normalizedTranslate >= normalizedGird && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGird) / 2) {
            slideIndex = i;
          } else if (normalizedTranslate >= normalizedGird && normalizedTranslate < normalizedGridNext) {
            slideIndex = i + 1;
          }
        } else if (normalizedTranslate >= normalizedGird) {
          slideIndex = i;
        }
      }
    } // Directions locks


    if (swiper.initialized && slideIndex !== activeIndex) {
      if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) {
        return false;
      }

      if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
        if ((activeIndex || 0) !== slideIndex) return false;
      }
    }

    var direction;
    if (slideIndex > activeIndex) direction = 'next';else if (slideIndex < activeIndex) direction = 'prev';else direction = 'reset'; // Update Index

    if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
      swiper.updateActiveIndex(slideIndex); // Update Height

      if (params.autoHeight) {
        swiper.updateAutoHeight();
      }

      swiper.updateSlidesClasses();

      if (params.effect !== 'slide') {
        swiper.setTranslate(translate);
      }

      if (direction !== 'reset') {
        swiper.transitionStart(runCallbacks, direction);
        swiper.transitionEnd(runCallbacks, direction);
      }

      return false;
    }

    if (params.cssMode) {
      var isH = swiper.isHorizontal();
      var t = -translate;

      if (rtl) {
        t = wrapperEl.scrollWidth - wrapperEl.offsetWidth - t;
      }

      if (speed === 0) {
        wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
      } else {
        // eslint-disable-next-line
        if (wrapperEl.scrollTo) {
          var _wrapperEl$scrollTo;

          wrapperEl.scrollTo((_wrapperEl$scrollTo = {}, _wrapperEl$scrollTo[isH ? 'left' : 'top'] = t, _wrapperEl$scrollTo.behavior = 'smooth', _wrapperEl$scrollTo));
        } else {
          wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
        }
      }

      return true;
    }

    if (speed === 0) {
      swiper.setTransition(0);
      swiper.setTranslate(translate);
      swiper.updateActiveIndex(slideIndex);
      swiper.updateSlidesClasses();
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.transitionStart(runCallbacks, direction);
      swiper.transitionEnd(runCallbacks, direction);
    } else {
      swiper.setTransition(speed);
      swiper.setTranslate(translate);
      swiper.updateActiveIndex(slideIndex);
      swiper.updateSlidesClasses();
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.transitionStart(runCallbacks, direction);

      if (!swiper.animating) {
        swiper.animating = true;

        if (!swiper.onSlideToWrapperTransitionEnd) {
          swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
            if (!swiper || swiper.destroyed) return;
            if (e.target !== this) return;
            swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
            swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
            swiper.onSlideToWrapperTransitionEnd = null;
            delete swiper.onSlideToWrapperTransitionEnd;
            swiper.transitionEnd(runCallbacks, direction);
          };
        }

        swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
        swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
      }
    }

    return true;
  }

  function slideToLoop(index, speed, runCallbacks, internal) {
    if (index === void 0) {
      index = 0;
    }

    if (speed === void 0) {
      speed = this.params.speed;
    }

    if (runCallbacks === void 0) {
      runCallbacks = true;
    }

    var swiper = this;
    var newIndex = index;

    if (swiper.params.loop) {
      newIndex += swiper.loopedSlides;
    }

    return swiper.slideTo(newIndex, speed, runCallbacks, internal);
  }
  /* eslint no-unused-vars: "off" */


  function slideNext(speed, runCallbacks, internal) {
    if (speed === void 0) {
      speed = this.params.speed;
    }

    if (runCallbacks === void 0) {
      runCallbacks = true;
    }

    var swiper = this;
    var params = swiper.params,
        animating = swiper.animating,
        enabled = swiper.enabled;
    if (!enabled) return swiper;
    var increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup;

    if (params.loop) {
      if (animating && params.loopPreventsSlide) return false;
      swiper.loopFix(); // eslint-disable-next-line

      swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
    }

    return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
  }
  /* eslint no-unused-vars: "off" */


  function slidePrev(speed, runCallbacks, internal) {
    if (speed === void 0) {
      speed = this.params.speed;
    }

    if (runCallbacks === void 0) {
      runCallbacks = true;
    }

    var swiper = this;
    var params = swiper.params,
        animating = swiper.animating,
        snapGrid = swiper.snapGrid,
        slidesGrid = swiper.slidesGrid,
        rtlTranslate = swiper.rtlTranslate,
        enabled = swiper.enabled;
    if (!enabled) return swiper;

    if (params.loop) {
      if (animating && params.loopPreventsSlide) return false;
      swiper.loopFix(); // eslint-disable-next-line

      swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
    }

    var translate = rtlTranslate ? swiper.translate : -swiper.translate;

    function normalize(val) {
      if (val < 0) return -Math.floor(Math.abs(val));
      return Math.floor(val);
    }

    var normalizedTranslate = normalize(translate);
    var normalizedSnapGrid = snapGrid.map(function (val) {
      return normalize(val);
    });
    var prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];

    if (typeof prevSnap === 'undefined' && params.cssMode) {
      snapGrid.forEach(function (snap) {
        if (!prevSnap && normalizedTranslate >= snap) prevSnap = snap;
      });
    }

    var prevIndex;

    if (typeof prevSnap !== 'undefined') {
      prevIndex = slidesGrid.indexOf(prevSnap);
      if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
    }

    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
  }
  /* eslint no-unused-vars: "off" */


  function slideReset(speed, runCallbacks, internal) {
    if (speed === void 0) {
      speed = this.params.speed;
    }

    if (runCallbacks === void 0) {
      runCallbacks = true;
    }

    var swiper = this;
    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
  }
  /* eslint no-unused-vars: "off" */


  function slideToClosest(speed, runCallbacks, internal, threshold) {
    if (speed === void 0) {
      speed = this.params.speed;
    }

    if (runCallbacks === void 0) {
      runCallbacks = true;
    }

    if (threshold === void 0) {
      threshold = 0.5;
    }

    var swiper = this;
    var index = swiper.activeIndex;
    var skip = Math.min(swiper.params.slidesPerGroupSkip, index);
    var snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
    var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;

    if (translate >= swiper.snapGrid[snapIndex]) {
      // The current translate is on or after the current snap index, so the choice
      // is between the current index and the one after it.
      var currentSnap = swiper.snapGrid[snapIndex];
      var nextSnap = swiper.snapGrid[snapIndex + 1];

      if (translate - currentSnap > (nextSnap - currentSnap) * threshold) {
        index += swiper.params.slidesPerGroup;
      }
    } else {
      // The current translate is before the current snap index, so the choice
      // is between the current index and the one before it.
      var prevSnap = swiper.snapGrid[snapIndex - 1];
      var _currentSnap = swiper.snapGrid[snapIndex];

      if (translate - prevSnap <= (_currentSnap - prevSnap) * threshold) {
        index -= swiper.params.slidesPerGroup;
      }
    }

    index = Math.max(index, 0);
    index = Math.min(index, swiper.slidesGrid.length - 1);
    return swiper.slideTo(index, speed, runCallbacks, internal);
  }

  function slideToClickedSlide() {
    var swiper = this;
    var params = swiper.params,
        $wrapperEl = swiper.$wrapperEl;
    var slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
    var slideToIndex = swiper.clickedIndex;
    var realIndex;

    if (params.loop) {
      if (swiper.animating) return;
      realIndex = parseInt($(swiper.clickedSlide).attr('data-swiper-slide-index'), 10);

      if (params.centeredSlides) {
        if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
          swiper.loopFix();
          slideToIndex = $wrapperEl.children("." + params.slideClass + "[data-swiper-slide-index=\"" + realIndex + "\"]:not(." + params.slideDuplicateClass + ")").eq(0).index();
          nextTick(function () {
            swiper.slideTo(slideToIndex);
          });
        } else {
          swiper.slideTo(slideToIndex);
        }
      } else if (slideToIndex > swiper.slides.length - slidesPerView) {
        swiper.loopFix();
        slideToIndex = $wrapperEl.children("." + params.slideClass + "[data-swiper-slide-index=\"" + realIndex + "\"]:not(." + params.slideDuplicateClass + ")").eq(0).index();
        nextTick(function () {
          swiper.slideTo(slideToIndex);
        });
      } else {
        swiper.slideTo(slideToIndex);
      }
    } else {
      swiper.slideTo(slideToIndex);
    }
  }

  var slide = {
    slideTo: slideTo,
    slideToLoop: slideToLoop,
    slideNext: slideNext,
    slidePrev: slidePrev,
    slideReset: slideReset,
    slideToClosest: slideToClosest,
    slideToClickedSlide: slideToClickedSlide
  };

  function loopCreate() {
    var swiper = this;
    var document = getDocument();
    var params = swiper.params,
        $wrapperEl = swiper.$wrapperEl; // Remove duplicated slides

    $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass).remove();
    var slides = $wrapperEl.children("." + params.slideClass);

    if (params.loopFillGroupWithBlank) {
      var blankSlidesNum = params.slidesPerGroup - slides.length % params.slidesPerGroup;

      if (blankSlidesNum !== params.slidesPerGroup) {
        for (var i = 0; i < blankSlidesNum; i += 1) {
          var blankNode = $(document.createElement('div')).addClass(params.slideClass + " " + params.slideBlankClass);
          $wrapperEl.append(blankNode);
        }

        slides = $wrapperEl.children("." + params.slideClass);
      }
    }

    if (params.slidesPerView === 'auto' && !params.loopedSlides) params.loopedSlides = slides.length;
    swiper.loopedSlides = Math.ceil(parseFloat(params.loopedSlides || params.slidesPerView, 10));
    swiper.loopedSlides += params.loopAdditionalSlides;

    if (swiper.loopedSlides > slides.length) {
      swiper.loopedSlides = slides.length;
    }

    var prependSlides = [];
    var appendSlides = [];
    slides.each(function (el, index) {
      var slide = $(el);

      if (index < swiper.loopedSlides) {
        appendSlides.push(el);
      }

      if (index < slides.length && index >= slides.length - swiper.loopedSlides) {
        prependSlides.push(el);
      }

      slide.attr('data-swiper-slide-index', index);
    });

    for (var _i = 0; _i < appendSlides.length; _i += 1) {
      $wrapperEl.append($(appendSlides[_i].cloneNode(true)).addClass(params.slideDuplicateClass));
    }

    for (var _i2 = prependSlides.length - 1; _i2 >= 0; _i2 -= 1) {
      $wrapperEl.prepend($(prependSlides[_i2].cloneNode(true)).addClass(params.slideDuplicateClass));
    }
  }

  function loopFix() {
    var swiper = this;
    swiper.emit('beforeLoopFix');
    var activeIndex = swiper.activeIndex,
        slides = swiper.slides,
        loopedSlides = swiper.loopedSlides,
        allowSlidePrev = swiper.allowSlidePrev,
        allowSlideNext = swiper.allowSlideNext,
        snapGrid = swiper.snapGrid,
        rtl = swiper.rtlTranslate;
    var newIndex;
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;
    var snapTranslate = -snapGrid[activeIndex];
    var diff = snapTranslate - swiper.getTranslate(); // Fix For Negative Oversliding

    if (activeIndex < loopedSlides) {
      newIndex = slides.length - loopedSlides * 3 + activeIndex;
      newIndex += loopedSlides;
      var slideChanged = swiper.slideTo(newIndex, 0, false, true);

      if (slideChanged && diff !== 0) {
        swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
      }
    } else if (activeIndex >= slides.length - loopedSlides) {
      // Fix For Positive Oversliding
      newIndex = -slides.length + activeIndex + loopedSlides;
      newIndex += loopedSlides;

      var _slideChanged = swiper.slideTo(newIndex, 0, false, true);

      if (_slideChanged && diff !== 0) {
        swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
      }
    }

    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    swiper.emit('loopFix');
  }

  function loopDestroy() {
    var swiper = this;
    var $wrapperEl = swiper.$wrapperEl,
        params = swiper.params,
        slides = swiper.slides;
    $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + ",." + params.slideClass + "." + params.slideBlankClass).remove();
    slides.removeAttr('data-swiper-slide-index');
  }

  var loop = {
    loopCreate: loopCreate,
    loopFix: loopFix,
    loopDestroy: loopDestroy
  };

  function setGrabCursor(moving) {
    var swiper = this;
    if (swiper.support.touch || !swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    var el = swiper.el;
    el.style.cursor = 'move';
    el.style.cursor = moving ? '-webkit-grabbing' : '-webkit-grab';
    el.style.cursor = moving ? '-moz-grabbin' : '-moz-grab';
    el.style.cursor = moving ? 'grabbing' : 'grab';
  }

  function unsetGrabCursor() {
    var swiper = this;

    if (swiper.support.touch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) {
      return;
    }

    swiper.el.style.cursor = '';
  }

  var grabCursor = {
    setGrabCursor: setGrabCursor,
    unsetGrabCursor: unsetGrabCursor
  };

  function appendSlide(slides) {
    var swiper = this;
    var $wrapperEl = swiper.$wrapperEl,
        params = swiper.params;

    if (params.loop) {
      swiper.loopDestroy();
    }

    if (typeof slides === 'object' && 'length' in slides) {
      for (var i = 0; i < slides.length; i += 1) {
        if (slides[i]) $wrapperEl.append(slides[i]);
      }
    } else {
      $wrapperEl.append(slides);
    }

    if (params.loop) {
      swiper.loopCreate();
    }

    if (!(params.observer && swiper.support.observer)) {
      swiper.update();
    }
  }

  function prependSlide(slides) {
    var swiper = this;
    var params = swiper.params,
        $wrapperEl = swiper.$wrapperEl,
        activeIndex = swiper.activeIndex;

    if (params.loop) {
      swiper.loopDestroy();
    }

    var newActiveIndex = activeIndex + 1;

    if (typeof slides === 'object' && 'length' in slides) {
      for (var i = 0; i < slides.length; i += 1) {
        if (slides[i]) $wrapperEl.prepend(slides[i]);
      }

      newActiveIndex = activeIndex + slides.length;
    } else {
      $wrapperEl.prepend(slides);
    }

    if (params.loop) {
      swiper.loopCreate();
    }

    if (!(params.observer && swiper.support.observer)) {
      swiper.update();
    }

    swiper.slideTo(newActiveIndex, 0, false);
  }

  function addSlide(index, slides) {
    var swiper = this;
    var $wrapperEl = swiper.$wrapperEl,
        params = swiper.params,
        activeIndex = swiper.activeIndex;
    var activeIndexBuffer = activeIndex;

    if (params.loop) {
      activeIndexBuffer -= swiper.loopedSlides;
      swiper.loopDestroy();
      swiper.slides = $wrapperEl.children("." + params.slideClass);
    }

    var baseLength = swiper.slides.length;

    if (index <= 0) {
      swiper.prependSlide(slides);
      return;
    }

    if (index >= baseLength) {
      swiper.appendSlide(slides);
      return;
    }

    var newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
    var slidesBuffer = [];

    for (var i = baseLength - 1; i >= index; i -= 1) {
      var currentSlide = swiper.slides.eq(i);
      currentSlide.remove();
      slidesBuffer.unshift(currentSlide);
    }

    if (typeof slides === 'object' && 'length' in slides) {
      for (var _i = 0; _i < slides.length; _i += 1) {
        if (slides[_i]) $wrapperEl.append(slides[_i]);
      }

      newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
    } else {
      $wrapperEl.append(slides);
    }

    for (var _i2 = 0; _i2 < slidesBuffer.length; _i2 += 1) {
      $wrapperEl.append(slidesBuffer[_i2]);
    }

    if (params.loop) {
      swiper.loopCreate();
    }

    if (!(params.observer && swiper.support.observer)) {
      swiper.update();
    }

    if (params.loop) {
      swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    } else {
      swiper.slideTo(newActiveIndex, 0, false);
    }
  }

  function removeSlide(slidesIndexes) {
    var swiper = this;
    var params = swiper.params,
        $wrapperEl = swiper.$wrapperEl,
        activeIndex = swiper.activeIndex;
    var activeIndexBuffer = activeIndex;

    if (params.loop) {
      activeIndexBuffer -= swiper.loopedSlides;
      swiper.loopDestroy();
      swiper.slides = $wrapperEl.children("." + params.slideClass);
    }

    var newActiveIndex = activeIndexBuffer;
    var indexToRemove;

    if (typeof slidesIndexes === 'object' && 'length' in slidesIndexes) {
      for (var i = 0; i < slidesIndexes.length; i += 1) {
        indexToRemove = slidesIndexes[i];
        if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
        if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
      }

      newActiveIndex = Math.max(newActiveIndex, 0);
    } else {
      indexToRemove = slidesIndexes;
      if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
      if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
      newActiveIndex = Math.max(newActiveIndex, 0);
    }

    if (params.loop) {
      swiper.loopCreate();
    }

    if (!(params.observer && swiper.support.observer)) {
      swiper.update();
    }

    if (params.loop) {
      swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    } else {
      swiper.slideTo(newActiveIndex, 0, false);
    }
  }

  function removeAllSlides() {
    var swiper = this;
    var slidesIndexes = [];

    for (var i = 0; i < swiper.slides.length; i += 1) {
      slidesIndexes.push(i);
    }

    swiper.removeSlide(slidesIndexes);
  }

  var manipulation = {
    appendSlide: appendSlide,
    prependSlide: prependSlide,
    addSlide: addSlide,
    removeSlide: removeSlide,
    removeAllSlides: removeAllSlides
  };

  function closestElement(selector, base) {
    if (base === void 0) {
      base = this;
    }

    function __closestFrom(el) {
      if (!el || el === getDocument() || el === getWindow()) return null;
      if (el.assignedSlot) el = el.assignedSlot;
      var found = el.closest(selector);
      return found || __closestFrom(el.getRootNode().host);
    }

    return __closestFrom(base);
  }

  function onTouchStart(event) {
    var swiper = this;
    var document = getDocument();
    var window = getWindow();
    var data = swiper.touchEventsData;
    var params = swiper.params,
        touches = swiper.touches,
        enabled = swiper.enabled;
    if (!enabled) return;

    if (swiper.animating && params.preventInteractionOnTransition) {
      return;
    }

    var e = event;
    if (e.originalEvent) e = e.originalEvent;
    var $targetEl = $(e.target);

    if (params.touchEventsTarget === 'wrapper') {
      if (!$targetEl.closest(swiper.wrapperEl).length) return;
    }

    data.isTouchEvent = e.type === 'touchstart';
    if (!data.isTouchEvent && 'which' in e && e.which === 3) return;
    if (!data.isTouchEvent && 'button' in e && e.button > 0) return;
    if (data.isTouched && data.isMoved) return; // change target el for shadow root component

    var swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== '';

    if (swipingClassHasValue && e.target && e.target.shadowRoot && event.path && event.path[0]) {
      $targetEl = $(event.path[0]);
    }

    var noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : "." + params.noSwipingClass;
    var isTargetShadow = !!(e.target && e.target.shadowRoot); // use closestElement for shadow root element to get the actual closest for nested shadow root element

    if (params.noSwiping && (isTargetShadow ? closestElement(noSwipingSelector, e.target) : $targetEl.closest(noSwipingSelector)[0])) {
      swiper.allowClick = true;
      return;
    }

    if (params.swipeHandler) {
      if (!$targetEl.closest(params.swipeHandler)[0]) return;
    }

    touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
    touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
    var startX = touches.currentX;
    var startY = touches.currentY; // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore

    var edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
    var edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;

    if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window.innerWidth - edgeSwipeThreshold)) {
      if (edgeSwipeDetection === 'prevent') {
        event.preventDefault();
      } else {
        return;
      }
    }

    extend$1(data, {
      isTouched: true,
      isMoved: false,
      allowTouchCallbacks: true,
      isScrolling: undefined,
      startMoving: undefined
    });
    touches.startX = startX;
    touches.startY = startY;
    data.touchStartTime = now();
    swiper.allowClick = true;
    swiper.updateSize();
    swiper.swipeDirection = undefined;
    if (params.threshold > 0) data.allowThresholdMove = false;

    if (e.type !== 'touchstart') {
      var preventDefault = true;
      if ($targetEl.is(data.focusableElements)) preventDefault = false;

      if (document.activeElement && $(document.activeElement).is(data.focusableElements) && document.activeElement !== $targetEl[0]) {
        document.activeElement.blur();
      }

      var shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;

      if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !$targetEl[0].isContentEditable) {
        e.preventDefault();
      }
    }

    swiper.emit('touchStart', e);
  }

  function onTouchMove(event) {
    var document = getDocument();
    var swiper = this;
    var data = swiper.touchEventsData;
    var params = swiper.params,
        touches = swiper.touches,
        rtl = swiper.rtlTranslate,
        enabled = swiper.enabled;
    if (!enabled) return;
    var e = event;
    if (e.originalEvent) e = e.originalEvent;

    if (!data.isTouched) {
      if (data.startMoving && data.isScrolling) {
        swiper.emit('touchMoveOpposite', e);
      }

      return;
    }

    if (data.isTouchEvent && e.type !== 'touchmove') return;
    var targetTouch = e.type === 'touchmove' && e.targetTouches && (e.targetTouches[0] || e.changedTouches[0]);
    var pageX = e.type === 'touchmove' ? targetTouch.pageX : e.pageX;
    var pageY = e.type === 'touchmove' ? targetTouch.pageY : e.pageY;

    if (e.preventedByNestedSwiper) {
      touches.startX = pageX;
      touches.startY = pageY;
      return;
    }

    if (!swiper.allowTouchMove) {
      // isMoved = true;
      swiper.allowClick = false;

      if (data.isTouched) {
        extend$1(touches, {
          startX: pageX,
          startY: pageY,
          currentX: pageX,
          currentY: pageY
        });
        data.touchStartTime = now();
      }

      return;
    }

    if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
      if (swiper.isVertical()) {
        // Vertical
        if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
          data.isTouched = false;
          data.isMoved = false;
          return;
        }
      } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) {
        return;
      }
    }

    if (data.isTouchEvent && document.activeElement) {
      if (e.target === document.activeElement && $(e.target).is(data.focusableElements)) {
        data.isMoved = true;
        swiper.allowClick = false;
        return;
      }
    }

    if (data.allowTouchCallbacks) {
      swiper.emit('touchMove', e);
    }

    if (e.targetTouches && e.targetTouches.length > 1) return;
    touches.currentX = pageX;
    touches.currentY = pageY;
    var diffX = touches.currentX - touches.startX;
    var diffY = touches.currentY - touches.startY;
    if (swiper.params.threshold && Math.sqrt(Math.pow(diffX, 2) + Math.pow(diffY, 2)) < swiper.params.threshold) return;

    if (typeof data.isScrolling === 'undefined') {
      var touchAngle;

      if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) {
        data.isScrolling = false;
      } else {
        // eslint-disable-next-line
        if (diffX * diffX + diffY * diffY >= 25) {
          touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
          data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
        }
      }
    }

    if (data.isScrolling) {
      swiper.emit('touchMoveOpposite', e);
    }

    if (typeof data.startMoving === 'undefined') {
      if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
        data.startMoving = true;
      }
    }

    if (data.isScrolling) {
      data.isTouched = false;
      return;
    }

    if (!data.startMoving) {
      return;
    }

    swiper.allowClick = false;

    if (!params.cssMode && e.cancelable) {
      e.preventDefault();
    }

    if (params.touchMoveStopPropagation && !params.nested) {
      e.stopPropagation();
    }

    if (!data.isMoved) {
      if (params.loop) {
        swiper.loopFix();
      }

      data.startTranslate = swiper.getTranslate();
      swiper.setTransition(0);

      if (swiper.animating) {
        swiper.$wrapperEl.trigger('webkitTransitionEnd transitionend');
      }

      data.allowMomentumBounce = false; // Grab Cursor

      if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
        swiper.setGrabCursor(true);
      }

      swiper.emit('sliderFirstMove', e);
    }

    swiper.emit('sliderMove', e);
    data.isMoved = true;
    var diff = swiper.isHorizontal() ? diffX : diffY;
    touches.diff = diff;
    diff *= params.touchRatio;
    if (rtl) diff = -diff;
    swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
    data.currentTranslate = diff + data.startTranslate;
    var disableParentSwiper = true;
    var resistanceRatio = params.resistanceRatio;

    if (params.touchReleaseOnEdges) {
      resistanceRatio = 0;
    }

    if (diff > 0 && data.currentTranslate > swiper.minTranslate()) {
      disableParentSwiper = false;
      if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + Math.pow(-swiper.minTranslate() + data.startTranslate + diff, resistanceRatio);
    } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
      disableParentSwiper = false;
      if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - Math.pow(swiper.maxTranslate() - data.startTranslate - diff, resistanceRatio);
    }

    if (disableParentSwiper) {
      e.preventedByNestedSwiper = true;
    } // Directions locks


    if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) {
      data.currentTranslate = data.startTranslate;
    }

    if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) {
      data.currentTranslate = data.startTranslate;
    }

    if (!swiper.allowSlidePrev && !swiper.allowSlideNext) {
      data.currentTranslate = data.startTranslate;
    } // Threshold


    if (params.threshold > 0) {
      if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
        if (!data.allowThresholdMove) {
          data.allowThresholdMove = true;
          touches.startX = touches.currentX;
          touches.startY = touches.currentY;
          data.currentTranslate = data.startTranslate;
          touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
          return;
        }
      } else {
        data.currentTranslate = data.startTranslate;
        return;
      }
    }

    if (!params.followFinger || params.cssMode) return; // Update active index in free mode

    if (params.freeMode || params.watchSlidesProgress || params.watchSlidesVisibility) {
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }

    if (params.freeMode) {
      // Velocity
      if (data.velocities.length === 0) {
        data.velocities.push({
          position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
          time: data.touchStartTime
        });
      }

      data.velocities.push({
        position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
        time: now()
      });
    } // Update progress


    swiper.updateProgress(data.currentTranslate); // Update translate

    swiper.setTranslate(data.currentTranslate);
  }

  function onTouchEnd(event) {
    var swiper = this;
    var data = swiper.touchEventsData;
    var params = swiper.params,
        touches = swiper.touches,
        rtl = swiper.rtlTranslate,
        $wrapperEl = swiper.$wrapperEl,
        slidesGrid = swiper.slidesGrid,
        snapGrid = swiper.snapGrid,
        enabled = swiper.enabled;
    if (!enabled) return;
    var e = event;
    if (e.originalEvent) e = e.originalEvent;

    if (data.allowTouchCallbacks) {
      swiper.emit('touchEnd', e);
    }

    data.allowTouchCallbacks = false;

    if (!data.isTouched) {
      if (data.isMoved && params.grabCursor) {
        swiper.setGrabCursor(false);
      }

      data.isMoved = false;
      data.startMoving = false;
      return;
    } // Return Grab Cursor


    if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
      swiper.setGrabCursor(false);
    } // Time diff


    var touchEndTime = now();
    var timeDiff = touchEndTime - data.touchStartTime; // Tap, doubleTap, Click

    if (swiper.allowClick) {
      swiper.updateClickedSlide(e);
      swiper.emit('tap click', e);

      if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) {
        swiper.emit('doubleTap doubleClick', e);
      }
    }

    data.lastClickTime = now();
    nextTick(function () {
      if (!swiper.destroyed) swiper.allowClick = true;
    });

    if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
      data.isTouched = false;
      data.isMoved = false;
      data.startMoving = false;
      return;
    }

    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    var currentPos;

    if (params.followFinger) {
      currentPos = rtl ? swiper.translate : -swiper.translate;
    } else {
      currentPos = -data.currentTranslate;
    }

    if (params.cssMode) {
      return;
    }

    if (params.freeMode) {
      if (currentPos < -swiper.minTranslate()) {
        swiper.slideTo(swiper.activeIndex);
        return;
      }

      if (currentPos > -swiper.maxTranslate()) {
        if (swiper.slides.length < snapGrid.length) {
          swiper.slideTo(snapGrid.length - 1);
        } else {
          swiper.slideTo(swiper.slides.length - 1);
        }

        return;
      }

      if (params.freeModeMomentum) {
        if (data.velocities.length > 1) {
          var lastMoveEvent = data.velocities.pop();
          var velocityEvent = data.velocities.pop();
          var distance = lastMoveEvent.position - velocityEvent.position;
          var time = lastMoveEvent.time - velocityEvent.time;
          swiper.velocity = distance / time;
          swiper.velocity /= 2;

          if (Math.abs(swiper.velocity) < params.freeModeMinimumVelocity) {
            swiper.velocity = 0;
          } // this implies that the user stopped moving a finger then released.
          // There would be no events with distance zero, so the last event is stale.


          if (time > 150 || now() - lastMoveEvent.time > 300) {
            swiper.velocity = 0;
          }
        } else {
          swiper.velocity = 0;
        }

        swiper.velocity *= params.freeModeMomentumVelocityRatio;
        data.velocities.length = 0;
        var momentumDuration = 1000 * params.freeModeMomentumRatio;
        var momentumDistance = swiper.velocity * momentumDuration;
        var newPosition = swiper.translate + momentumDistance;
        if (rtl) newPosition = -newPosition;
        var doBounce = false;
        var afterBouncePosition;
        var bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeModeMomentumBounceRatio;
        var needsLoopFix;

        if (newPosition < swiper.maxTranslate()) {
          if (params.freeModeMomentumBounce) {
            if (newPosition + swiper.maxTranslate() < -bounceAmount) {
              newPosition = swiper.maxTranslate() - bounceAmount;
            }

            afterBouncePosition = swiper.maxTranslate();
            doBounce = true;
            data.allowMomentumBounce = true;
          } else {
            newPosition = swiper.maxTranslate();
          }

          if (params.loop && params.centeredSlides) needsLoopFix = true;
        } else if (newPosition > swiper.minTranslate()) {
          if (params.freeModeMomentumBounce) {
            if (newPosition - swiper.minTranslate() > bounceAmount) {
              newPosition = swiper.minTranslate() + bounceAmount;
            }

            afterBouncePosition = swiper.minTranslate();
            doBounce = true;
            data.allowMomentumBounce = true;
          } else {
            newPosition = swiper.minTranslate();
          }

          if (params.loop && params.centeredSlides) needsLoopFix = true;
        } else if (params.freeModeSticky) {
          var nextSlide;

          for (var j = 0; j < snapGrid.length; j += 1) {
            if (snapGrid[j] > -newPosition) {
              nextSlide = j;
              break;
            }
          }

          if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') {
            newPosition = snapGrid[nextSlide];
          } else {
            newPosition = snapGrid[nextSlide - 1];
          }

          newPosition = -newPosition;
        }

        if (needsLoopFix) {
          swiper.once('transitionEnd', function () {
            swiper.loopFix();
          });
        } // Fix duration


        if (swiper.velocity !== 0) {
          if (rtl) {
            momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
          } else {
            momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
          }

          if (params.freeModeSticky) {
            // If freeModeSticky is active and the user ends a swipe with a slow-velocity
            // event, then durations can be 20+ seconds to slide one (or zero!) slides.
            // It's easy to see this when simulating touch with mouse events. To fix this,
            // limit single-slide swipes to the default slide duration. This also has the
            // nice side effect of matching slide speed if the user stopped moving before
            // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
            // For faster swipes, also apply limits (albeit higher ones).
            var moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
            var currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];

            if (moveDistance < currentSlideSize) {
              momentumDuration = params.speed;
            } else if (moveDistance < 2 * currentSlideSize) {
              momentumDuration = params.speed * 1.5;
            } else {
              momentumDuration = params.speed * 2.5;
            }
          }
        } else if (params.freeModeSticky) {
          swiper.slideToClosest();
          return;
        }

        if (params.freeModeMomentumBounce && doBounce) {
          swiper.updateProgress(afterBouncePosition);
          swiper.setTransition(momentumDuration);
          swiper.setTranslate(newPosition);
          swiper.transitionStart(true, swiper.swipeDirection);
          swiper.animating = true;
          $wrapperEl.transitionEnd(function () {
            if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
            swiper.emit('momentumBounce');
            swiper.setTransition(params.speed);
            setTimeout(function () {
              swiper.setTranslate(afterBouncePosition);
              $wrapperEl.transitionEnd(function () {
                if (!swiper || swiper.destroyed) return;
                swiper.transitionEnd();
              });
            }, 0);
          });
        } else if (swiper.velocity) {
          swiper.updateProgress(newPosition);
          swiper.setTransition(momentumDuration);
          swiper.setTranslate(newPosition);
          swiper.transitionStart(true, swiper.swipeDirection);

          if (!swiper.animating) {
            swiper.animating = true;
            $wrapperEl.transitionEnd(function () {
              if (!swiper || swiper.destroyed) return;
              swiper.transitionEnd();
            });
          }
        } else {
          swiper.emit('_freeModeNoMomentumRelease');
          swiper.updateProgress(newPosition);
        }

        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
      } else if (params.freeModeSticky) {
        swiper.slideToClosest();
        return;
      } else if (params.freeMode) {
        swiper.emit('_freeModeNoMomentumRelease');
      }

      if (!params.freeModeMomentum || timeDiff >= params.longSwipesMs) {
        swiper.updateProgress();
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
      }

      return;
    } // Find current slide


    var stopIndex = 0;
    var groupSize = swiper.slidesSizesGrid[0];

    for (var i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup) {
      var _increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;

      if (typeof slidesGrid[i + _increment] !== 'undefined') {
        if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + _increment]) {
          stopIndex = i;
          groupSize = slidesGrid[i + _increment] - slidesGrid[i];
        }
      } else if (currentPos >= slidesGrid[i]) {
        stopIndex = i;
        groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
      }
    } // Find current slide size


    var ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
    var increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;

    if (timeDiff > params.longSwipesMs) {
      // Long touches
      if (!params.longSwipes) {
        swiper.slideTo(swiper.activeIndex);
        return;
      }

      if (swiper.swipeDirection === 'next') {
        if (ratio >= params.longSwipesRatio) swiper.slideTo(stopIndex + increment);else swiper.slideTo(stopIndex);
      }

      if (swiper.swipeDirection === 'prev') {
        if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + increment);else swiper.slideTo(stopIndex);
      }
    } else {
      // Short swipes
      if (!params.shortSwipes) {
        swiper.slideTo(swiper.activeIndex);
        return;
      }

      var isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);

      if (!isNavButtonTarget) {
        if (swiper.swipeDirection === 'next') {
          swiper.slideTo(stopIndex + increment);
        }

        if (swiper.swipeDirection === 'prev') {
          swiper.slideTo(stopIndex);
        }
      } else if (e.target === swiper.navigation.nextEl) {
        swiper.slideTo(stopIndex + increment);
      } else {
        swiper.slideTo(stopIndex);
      }
    }
  }

  function onResize() {
    var swiper = this;
    var params = swiper.params,
        el = swiper.el;
    if (el && el.offsetWidth === 0) return; // Breakpoints

    if (params.breakpoints) {
      swiper.setBreakpoint();
    } // Save locks


    var allowSlideNext = swiper.allowSlideNext,
        allowSlidePrev = swiper.allowSlidePrev,
        snapGrid = swiper.snapGrid; // Disable locks on resize

    swiper.allowSlideNext = true;
    swiper.allowSlidePrev = true;
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateSlidesClasses();

    if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides) {
      swiper.slideTo(swiper.slides.length - 1, 0, false, true);
    } else {
      swiper.slideTo(swiper.activeIndex, 0, false, true);
    }

    if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
      swiper.autoplay.run();
    } // Return locks after resize


    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;

    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
      swiper.checkOverflow();
    }
  }

  function onClick(e) {
    var swiper = this;
    if (!swiper.enabled) return;

    if (!swiper.allowClick) {
      if (swiper.params.preventClicks) e.preventDefault();

      if (swiper.params.preventClicksPropagation && swiper.animating) {
        e.stopPropagation();
        e.stopImmediatePropagation();
      }
    }
  }

  function onScroll() {
    var swiper = this;
    var wrapperEl = swiper.wrapperEl,
        rtlTranslate = swiper.rtlTranslate,
        enabled = swiper.enabled;
    if (!enabled) return;
    swiper.previousTranslate = swiper.translate;

    if (swiper.isHorizontal()) {
      if (rtlTranslate) {
        swiper.translate = wrapperEl.scrollWidth - wrapperEl.offsetWidth - wrapperEl.scrollLeft;
      } else {
        swiper.translate = -wrapperEl.scrollLeft;
      }
    } else {
      swiper.translate = -wrapperEl.scrollTop;
    } // eslint-disable-next-line


    if (swiper.translate === -0) swiper.translate = 0;
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
    var newProgress;
    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();

    if (translatesDiff === 0) {
      newProgress = 0;
    } else {
      newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
    }

    if (newProgress !== swiper.progress) {
      swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
    }

    swiper.emit('setTranslate', swiper.translate, false);
  }

  var dummyEventAttached = false;

  function dummyEventListener() {}

  function attachEvents() {
    var swiper = this;
    var document = getDocument();
    var params = swiper.params,
        touchEvents = swiper.touchEvents,
        el = swiper.el,
        wrapperEl = swiper.wrapperEl,
        device = swiper.device,
        support = swiper.support;
    swiper.onTouchStart = onTouchStart.bind(swiper);
    swiper.onTouchMove = onTouchMove.bind(swiper);
    swiper.onTouchEnd = onTouchEnd.bind(swiper);

    if (params.cssMode) {
      swiper.onScroll = onScroll.bind(swiper);
    }

    swiper.onClick = onClick.bind(swiper);
    var capture = !!params.nested; // Touch Events

    if (!support.touch && support.pointerEvents) {
      el.addEventListener(touchEvents.start, swiper.onTouchStart, false);
      document.addEventListener(touchEvents.move, swiper.onTouchMove, capture);
      document.addEventListener(touchEvents.end, swiper.onTouchEnd, false);
    } else {
      if (support.touch) {
        var passiveListener = touchEvents.start === 'touchstart' && support.passiveListener && params.passiveListeners ? {
          passive: true,
          capture: false
        } : false;
        el.addEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
        el.addEventListener(touchEvents.move, swiper.onTouchMove, support.passiveListener ? {
          passive: false,
          capture: capture
        } : capture);
        el.addEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);

        if (touchEvents.cancel) {
          el.addEventListener(touchEvents.cancel, swiper.onTouchEnd, passiveListener);
        }

        if (!dummyEventAttached) {
          document.addEventListener('touchstart', dummyEventListener);
          dummyEventAttached = true;
        }
      }

      if (params.simulateTouch && !device.ios && !device.android || params.simulateTouch && !support.touch && device.ios) {
        el.addEventListener('mousedown', swiper.onTouchStart, false);
        document.addEventListener('mousemove', swiper.onTouchMove, capture);
        document.addEventListener('mouseup', swiper.onTouchEnd, false);
      }
    } // Prevent Links Clicks


    if (params.preventClicks || params.preventClicksPropagation) {
      el.addEventListener('click', swiper.onClick, true);
    }

    if (params.cssMode) {
      wrapperEl.addEventListener('scroll', swiper.onScroll);
    } // Resize handler


    if (params.updateOnWindowResize) {
      swiper.on(device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', onResize, true);
    } else {
      swiper.on('observerUpdate', onResize, true);
    }
  }

  function detachEvents() {
    var swiper = this;
    var document = getDocument();
    var params = swiper.params,
        touchEvents = swiper.touchEvents,
        el = swiper.el,
        wrapperEl = swiper.wrapperEl,
        device = swiper.device,
        support = swiper.support;
    var capture = !!params.nested; // Touch Events

    if (!support.touch && support.pointerEvents) {
      el.removeEventListener(touchEvents.start, swiper.onTouchStart, false);
      document.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
      document.removeEventListener(touchEvents.end, swiper.onTouchEnd, false);
    } else {
      if (support.touch) {
        var passiveListener = touchEvents.start === 'onTouchStart' && support.passiveListener && params.passiveListeners ? {
          passive: true,
          capture: false
        } : false;
        el.removeEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
        el.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
        el.removeEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);

        if (touchEvents.cancel) {
          el.removeEventListener(touchEvents.cancel, swiper.onTouchEnd, passiveListener);
        }
      }

      if (params.simulateTouch && !device.ios && !device.android || params.simulateTouch && !support.touch && device.ios) {
        el.removeEventListener('mousedown', swiper.onTouchStart, false);
        document.removeEventListener('mousemove', swiper.onTouchMove, capture);
        document.removeEventListener('mouseup', swiper.onTouchEnd, false);
      }
    } // Prevent Links Clicks


    if (params.preventClicks || params.preventClicksPropagation) {
      el.removeEventListener('click', swiper.onClick, true);
    }

    if (params.cssMode) {
      wrapperEl.removeEventListener('scroll', swiper.onScroll);
    } // Resize handler


    swiper.off(device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', onResize);
  }

  var events = {
    attachEvents: attachEvents,
    detachEvents: detachEvents
  };

  function setBreakpoint() {
    var swiper = this;
    var activeIndex = swiper.activeIndex,
        initialized = swiper.initialized,
        _swiper$loopedSlides = swiper.loopedSlides,
        loopedSlides = _swiper$loopedSlides === void 0 ? 0 : _swiper$loopedSlides,
        params = swiper.params,
        $el = swiper.$el;
    var breakpoints = params.breakpoints;
    if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return; // Get breakpoint for window width and update parameters

    var breakpoint = swiper.getBreakpoint(breakpoints, swiper.params.breakpointsBase, swiper.el);
    if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
    var breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;

    if (breakpointOnlyParams) {
      ['slidesPerView', 'spaceBetween', 'slidesPerGroup', 'slidesPerGroupSkip', 'slidesPerColumn'].forEach(function (param) {
        var paramValue = breakpointOnlyParams[param];
        if (typeof paramValue === 'undefined') return;

        if (param === 'slidesPerView' && (paramValue === 'AUTO' || paramValue === 'auto')) {
          breakpointOnlyParams[param] = 'auto';
        } else if (param === 'slidesPerView') {
          breakpointOnlyParams[param] = parseFloat(paramValue);
        } else {
          breakpointOnlyParams[param] = parseInt(paramValue, 10);
        }
      });
    }

    var breakpointParams = breakpointOnlyParams || swiper.originalParams;
    var wasMultiRow = params.slidesPerColumn > 1;
    var isMultiRow = breakpointParams.slidesPerColumn > 1;
    var wasEnabled = params.enabled;

    if (wasMultiRow && !isMultiRow) {
      $el.removeClass(params.containerModifierClass + "multirow " + params.containerModifierClass + "multirow-column");
      swiper.emitContainerClasses();
    } else if (!wasMultiRow && isMultiRow) {
      $el.addClass(params.containerModifierClass + "multirow");

      if (breakpointParams.slidesPerColumnFill && breakpointParams.slidesPerColumnFill === 'column' || !breakpointParams.slidesPerColumnFill && params.slidesPerColumnFill === 'column') {
        $el.addClass(params.containerModifierClass + "multirow-column");
      }

      swiper.emitContainerClasses();
    }

    var directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
    var needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);

    if (directionChanged && initialized) {
      swiper.changeDirection();
    }

    extend$1(swiper.params, breakpointParams);
    var isEnabled = swiper.params.enabled;
    extend$1(swiper, {
      allowTouchMove: swiper.params.allowTouchMove,
      allowSlideNext: swiper.params.allowSlideNext,
      allowSlidePrev: swiper.params.allowSlidePrev
    });

    if (wasEnabled && !isEnabled) {
      swiper.disable();
    } else if (!wasEnabled && isEnabled) {
      swiper.enable();
    }

    swiper.currentBreakpoint = breakpoint;
    swiper.emit('_beforeBreakpoint', breakpointParams);

    if (needsReLoop && initialized) {
      swiper.loopDestroy();
      swiper.loopCreate();
      swiper.updateSlides();
      swiper.slideTo(activeIndex - loopedSlides + swiper.loopedSlides, 0, false);
    }

    swiper.emit('breakpoint', breakpointParams);
  }

  function getBreakpoint(breakpoints, base, containerEl) {
    if (base === void 0) {
      base = 'window';
    }

    if (!breakpoints || base === 'container' && !containerEl) return undefined;
    var breakpoint = false;
    var window = getWindow();
    var currentHeight = base === 'window' ? window.innerHeight : containerEl.clientHeight;
    var points = Object.keys(breakpoints).map(function (point) {
      if (typeof point === 'string' && point.indexOf('@') === 0) {
        var minRatio = parseFloat(point.substr(1));
        var value = currentHeight * minRatio;
        return {
          value: value,
          point: point
        };
      }

      return {
        value: point,
        point: point
      };
    });
    points.sort(function (a, b) {
      return parseInt(a.value, 10) - parseInt(b.value, 10);
    });

    for (var i = 0; i < points.length; i += 1) {
      var _points$i = points[i],
          point = _points$i.point,
          value = _points$i.value;

      if (base === 'window') {
        if (window.matchMedia("(min-width: " + value + "px)").matches) {
          breakpoint = point;
        }
      } else if (value <= containerEl.clientWidth) {
        breakpoint = point;
      }
    }

    return breakpoint || 'max';
  }

  var breakpoints = {
    setBreakpoint: setBreakpoint,
    getBreakpoint: getBreakpoint
  };

  function prepareClasses(entries, prefix) {
    var resultClasses = [];
    entries.forEach(function (item) {
      if (typeof item === 'object') {
        Object.keys(item).forEach(function (classNames) {
          if (item[classNames]) {
            resultClasses.push(prefix + classNames);
          }
        });
      } else if (typeof item === 'string') {
        resultClasses.push(prefix + item);
      }
    });
    return resultClasses;
  }

  function addClasses() {
    var swiper = this;
    var classNames = swiper.classNames,
        params = swiper.params,
        rtl = swiper.rtl,
        $el = swiper.$el,
        device = swiper.device,
        support = swiper.support; // prettier-ignore

    var suffixes = prepareClasses(['initialized', params.direction, {
      'pointer-events': support.pointerEvents && !support.touch
    }, {
      'free-mode': params.freeMode
    }, {
      'autoheight': params.autoHeight
    }, {
      'rtl': rtl
    }, {
      'multirow': params.slidesPerColumn > 1
    }, {
      'multirow-column': params.slidesPerColumn > 1 && params.slidesPerColumnFill === 'column'
    }, {
      'android': device.android
    }, {
      'ios': device.ios
    }, {
      'css-mode': params.cssMode
    }], params.containerModifierClass);
    classNames.push.apply(classNames, suffixes);
    $el.addClass([].concat(classNames).join(' '));
    swiper.emitContainerClasses();
  }

  function removeClasses() {
    var swiper = this;
    var $el = swiper.$el,
        classNames = swiper.classNames;
    $el.removeClass(classNames.join(' '));
    swiper.emitContainerClasses();
  }

  var classes = {
    addClasses: addClasses,
    removeClasses: removeClasses
  };

  function loadImage(imageEl, src, srcset, sizes, checkForComplete, callback) {
    var window = getWindow();
    var image;

    function onReady() {
      if (callback) callback();
    }

    var isPicture = $(imageEl).parent('picture')[0];

    if (!isPicture && (!imageEl.complete || !checkForComplete)) {
      if (src) {
        image = new window.Image();
        image.onload = onReady;
        image.onerror = onReady;

        if (sizes) {
          image.sizes = sizes;
        }

        if (srcset) {
          image.srcset = srcset;
        }

        if (src) {
          image.src = src;
        }
      } else {
        onReady();
      }
    } else {
      // image already loaded...
      onReady();
    }
  }

  function preloadImages() {
    var swiper = this;
    swiper.imagesToLoad = swiper.$el.find('img');

    function onReady() {
      if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper.destroyed) return;
      if (swiper.imagesLoaded !== undefined) swiper.imagesLoaded += 1;

      if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
        if (swiper.params.updateOnImagesReady) swiper.update();
        swiper.emit('imagesReady');
      }
    }

    for (var i = 0; i < swiper.imagesToLoad.length; i += 1) {
      var imageEl = swiper.imagesToLoad[i];
      swiper.loadImage(imageEl, imageEl.currentSrc || imageEl.getAttribute('src'), imageEl.srcset || imageEl.getAttribute('srcset'), imageEl.sizes || imageEl.getAttribute('sizes'), true, onReady);
    }
  }

  var images = {
    loadImage: loadImage,
    preloadImages: preloadImages
  };

  function checkOverflow() {
    var swiper = this;
    var params = swiper.params;
    var wasLocked = swiper.isLocked;
    var lastSlidePosition = swiper.slides.length > 0 && params.slidesOffsetBefore + params.spaceBetween * (swiper.slides.length - 1) + swiper.slides[0].offsetWidth * swiper.slides.length;

    if (params.slidesOffsetBefore && params.slidesOffsetAfter && lastSlidePosition) {
      swiper.isLocked = lastSlidePosition <= swiper.size;
    } else {
      swiper.isLocked = swiper.snapGrid.length === 1;
    }

    swiper.allowSlideNext = !swiper.isLocked;
    swiper.allowSlidePrev = !swiper.isLocked; // events

    if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? 'lock' : 'unlock');

    if (wasLocked && wasLocked !== swiper.isLocked) {
      swiper.isEnd = false;
      if (swiper.navigation) swiper.navigation.update();
    }
  }

  var checkOverflow$1 = {
    checkOverflow: checkOverflow
  };
  var defaults = {
    init: true,
    direction: 'horizontal',
    touchEventsTarget: 'container',
    initialSlide: 0,
    speed: 300,
    cssMode: false,
    updateOnWindowResize: true,
    resizeObserver: false,
    nested: false,
    createElements: false,
    enabled: true,
    focusableElements: 'input, select, option, textarea, button, video, label',
    // Overrides
    width: null,
    height: null,
    //
    preventInteractionOnTransition: false,
    // ssr
    userAgent: null,
    url: null,
    // To support iOS's swipe-to-go-back gesture (when being used in-app).
    edgeSwipeDetection: false,
    edgeSwipeThreshold: 20,
    // Free mode
    freeMode: false,
    freeModeMomentum: true,
    freeModeMomentumRatio: 1,
    freeModeMomentumBounce: true,
    freeModeMomentumBounceRatio: 1,
    freeModeMomentumVelocityRatio: 1,
    freeModeSticky: false,
    freeModeMinimumVelocity: 0.02,
    // Autoheight
    autoHeight: false,
    // Set wrapper width
    setWrapperSize: false,
    // Virtual Translate
    virtualTranslate: false,
    // Effects
    effect: 'slide',
    // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
    // Breakpoints
    breakpoints: undefined,
    breakpointsBase: 'window',
    // Slides grid
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerColumn: 1,
    slidesPerColumnFill: 'column',
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    centeredSlides: false,
    centeredSlidesBounds: false,
    slidesOffsetBefore: 0,
    // in px
    slidesOffsetAfter: 0,
    // in px
    normalizeSlideIndex: true,
    centerInsufficientSlides: false,
    // Disable swiper and hide navigation when container not overflow
    watchOverflow: false,
    // Round length
    roundLengths: false,
    // Touches
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: true,
    shortSwipes: true,
    longSwipes: true,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: true,
    allowTouchMove: true,
    threshold: 0,
    touchMoveStopPropagation: false,
    touchStartPreventDefault: true,
    touchStartForcePreventDefault: false,
    touchReleaseOnEdges: false,
    // Unique Navigation Elements
    uniqueNavElements: true,
    // Resistance
    resistance: true,
    resistanceRatio: 0.85,
    // Progress
    watchSlidesProgress: false,
    watchSlidesVisibility: false,
    // Cursor
    grabCursor: false,
    // Clicks
    preventClicks: true,
    preventClicksPropagation: true,
    slideToClickedSlide: false,
    // Images
    preloadImages: true,
    updateOnImagesReady: true,
    // loop
    loop: false,
    loopAdditionalSlides: 0,
    loopedSlides: null,
    loopFillGroupWithBlank: false,
    loopPreventsSlide: true,
    // Swiping/no swiping
    allowSlidePrev: true,
    allowSlideNext: true,
    swipeHandler: null,
    // '.swipe-handler',
    noSwiping: true,
    noSwipingClass: 'swiper-no-swiping',
    noSwipingSelector: null,
    // Passive Listeners
    passiveListeners: true,
    // NS
    containerModifierClass: 'swiper-container-',
    // NEW
    slideClass: 'swiper-slide',
    slideBlankClass: 'swiper-slide-invisible-blank',
    slideActiveClass: 'swiper-slide-active',
    slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
    slideVisibleClass: 'swiper-slide-visible',
    slideDuplicateClass: 'swiper-slide-duplicate',
    slideNextClass: 'swiper-slide-next',
    slideDuplicateNextClass: 'swiper-slide-duplicate-next',
    slidePrevClass: 'swiper-slide-prev',
    slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
    wrapperClass: 'swiper-wrapper',
    // Callbacks
    runCallbacksOnInit: true,
    // Internals
    _emitClasses: false
  };

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  var prototypes = {
    modular: modular,
    eventsEmitter: eventsEmitter,
    update: update,
    translate: translate,
    transition: transition,
    slide: slide,
    loop: loop,
    grabCursor: grabCursor,
    manipulation: manipulation,
    events: events,
    breakpoints: breakpoints,
    checkOverflow: checkOverflow$1,
    classes: classes,
    images: images
  };
  var extendedDefaults = {};

  var Swiper$1 = /*#__PURE__*/function () {
    function Swiper() {
      var el;
      var params;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === 'Object') {
        params = args[0];
      } else {
        el = args[0];
        params = args[1];
      }

      if (!params) params = {};
      params = extend$1({}, params);
      if (el && !params.el) params.el = el;

      if (params.el && $(params.el).length > 1) {
        var swipers = [];
        $(params.el).each(function (containerEl) {
          var newParams = extend$1({}, params, {
            el: containerEl
          });
          swipers.push(new Swiper(newParams));
        });
        return swipers;
      } // Swiper Instance


      var swiper = this;
      swiper.__swiper__ = true;
      swiper.support = getSupport();
      swiper.device = getDevice({
        userAgent: params.userAgent
      });
      swiper.browser = getBrowser();
      swiper.eventsListeners = {};
      swiper.eventsAnyListeners = [];

      if (typeof swiper.modules === 'undefined') {
        swiper.modules = {};
      }

      Object.keys(swiper.modules).forEach(function (moduleName) {
        var module = swiper.modules[moduleName];

        if (module.params) {
          var moduleParamName = Object.keys(module.params)[0];
          var moduleParams = module.params[moduleParamName];
          if (typeof moduleParams !== 'object' || moduleParams === null) return;

          if (['navigation', 'pagination', 'scrollbar'].indexOf(moduleParamName) >= 0 && params[moduleParamName] === true) {
            params[moduleParamName] = {
              auto: true
            };
          }

          if (!(moduleParamName in params && 'enabled' in moduleParams)) return;

          if (params[moduleParamName] === true) {
            params[moduleParamName] = {
              enabled: true
            };
          }

          if (typeof params[moduleParamName] === 'object' && !('enabled' in params[moduleParamName])) {
            params[moduleParamName].enabled = true;
          }

          if (!params[moduleParamName]) params[moduleParamName] = {
            enabled: false
          };
        }
      }); // Extend defaults with modules params

      var swiperParams = extend$1({}, defaults);
      swiper.useParams(swiperParams); // Extend defaults with passed params

      swiper.params = extend$1({}, swiperParams, extendedDefaults, params);
      swiper.originalParams = extend$1({}, swiper.params);
      swiper.passedParams = extend$1({}, params); // add event listeners

      if (swiper.params && swiper.params.on) {
        Object.keys(swiper.params.on).forEach(function (eventName) {
          swiper.on(eventName, swiper.params.on[eventName]);
        });
      }

      if (swiper.params && swiper.params.onAny) {
        swiper.onAny(swiper.params.onAny);
      } // Save Dom lib


      swiper.$ = $; // Extend Swiper

      extend$1(swiper, {
        enabled: swiper.params.enabled,
        el: el,
        // Classes
        classNames: [],
        // Slides
        slides: $(),
        slidesGrid: [],
        snapGrid: [],
        slidesSizesGrid: [],
        // isDirection
        isHorizontal: function isHorizontal() {
          return swiper.params.direction === 'horizontal';
        },
        isVertical: function isVertical() {
          return swiper.params.direction === 'vertical';
        },
        // Indexes
        activeIndex: 0,
        realIndex: 0,
        //
        isBeginning: true,
        isEnd: false,
        // Props
        translate: 0,
        previousTranslate: 0,
        progress: 0,
        velocity: 0,
        animating: false,
        // Locks
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev,
        // Touch Events
        touchEvents: function touchEvents() {
          var touch = ['touchstart', 'touchmove', 'touchend', 'touchcancel'];
          var desktop = ['mousedown', 'mousemove', 'mouseup'];

          if (swiper.support.pointerEvents) {
            desktop = ['pointerdown', 'pointermove', 'pointerup'];
          }

          swiper.touchEventsTouch = {
            start: touch[0],
            move: touch[1],
            end: touch[2],
            cancel: touch[3]
          };
          swiper.touchEventsDesktop = {
            start: desktop[0],
            move: desktop[1],
            end: desktop[2]
          };
          return swiper.support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
        }(),
        touchEventsData: {
          isTouched: undefined,
          isMoved: undefined,
          allowTouchCallbacks: undefined,
          touchStartTime: undefined,
          isScrolling: undefined,
          currentTranslate: undefined,
          startTranslate: undefined,
          allowThresholdMove: undefined,
          // Form elements to match
          focusableElements: swiper.params.focusableElements,
          // Last click time
          lastClickTime: now(),
          clickTimeout: undefined,
          // Velocities
          velocities: [],
          allowMomentumBounce: undefined,
          isTouchEvent: undefined,
          startMoving: undefined
        },
        // Clicks
        allowClick: true,
        // Touches
        allowTouchMove: swiper.params.allowTouchMove,
        touches: {
          startX: 0,
          startY: 0,
          currentX: 0,
          currentY: 0,
          diff: 0
        },
        // Images
        imagesToLoad: [],
        imagesLoaded: 0
      }); // Install Modules

      swiper.useModules();
      swiper.emit('_swiper'); // Init

      if (swiper.params.init) {
        swiper.init();
      } // Return app instance


      return swiper;
    }

    var _proto = Swiper.prototype;

    _proto.enable = function enable() {
      var swiper = this;
      if (swiper.enabled) return;
      swiper.enabled = true;

      if (swiper.params.grabCursor) {
        swiper.setGrabCursor();
      }

      swiper.emit('enable');
    };

    _proto.disable = function disable() {
      var swiper = this;
      if (!swiper.enabled) return;
      swiper.enabled = false;

      if (swiper.params.grabCursor) {
        swiper.unsetGrabCursor();
      }

      swiper.emit('disable');
    };

    _proto.setProgress = function setProgress(progress, speed) {
      var swiper = this;
      progress = Math.min(Math.max(progress, 0), 1);
      var min = swiper.minTranslate();
      var max = swiper.maxTranslate();
      var current = (max - min) * progress + min;
      swiper.translateTo(current, typeof speed === 'undefined' ? 0 : speed);
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    };

    _proto.emitContainerClasses = function emitContainerClasses() {
      var swiper = this;
      if (!swiper.params._emitClasses || !swiper.el) return;
      var classes = swiper.el.className.split(' ').filter(function (className) {
        return className.indexOf('swiper-container') === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
      });
      swiper.emit('_containerClasses', classes.join(' '));
    };

    _proto.getSlideClasses = function getSlideClasses(slideEl) {
      var swiper = this;
      return slideEl.className.split(' ').filter(function (className) {
        return className.indexOf('swiper-slide') === 0 || className.indexOf(swiper.params.slideClass) === 0;
      }).join(' ');
    };

    _proto.emitSlidesClasses = function emitSlidesClasses() {
      var swiper = this;
      if (!swiper.params._emitClasses || !swiper.el) return;
      var updates = [];
      swiper.slides.each(function (slideEl) {
        var classNames = swiper.getSlideClasses(slideEl);
        updates.push({
          slideEl: slideEl,
          classNames: classNames
        });
        swiper.emit('_slideClass', slideEl, classNames);
      });
      swiper.emit('_slideClasses', updates);
    };

    _proto.slidesPerViewDynamic = function slidesPerViewDynamic() {
      var swiper = this;
      var params = swiper.params,
          slides = swiper.slides,
          slidesGrid = swiper.slidesGrid,
          swiperSize = swiper.size,
          activeIndex = swiper.activeIndex;
      var spv = 1;

      if (params.centeredSlides) {
        var slideSize = slides[activeIndex].swiperSlideSize;
        var breakLoop;

        for (var i = activeIndex + 1; i < slides.length; i += 1) {
          if (slides[i] && !breakLoop) {
            slideSize += slides[i].swiperSlideSize;
            spv += 1;
            if (slideSize > swiperSize) breakLoop = true;
          }
        }

        for (var _i = activeIndex - 1; _i >= 0; _i -= 1) {
          if (slides[_i] && !breakLoop) {
            slideSize += slides[_i].swiperSlideSize;
            spv += 1;
            if (slideSize > swiperSize) breakLoop = true;
          }
        }
      } else {
        for (var _i2 = activeIndex + 1; _i2 < slides.length; _i2 += 1) {
          if (slidesGrid[_i2] - slidesGrid[activeIndex] < swiperSize) {
            spv += 1;
          }
        }
      }

      return spv;
    };

    _proto.update = function update() {
      var swiper = this;
      if (!swiper || swiper.destroyed) return;
      var snapGrid = swiper.snapGrid,
          params = swiper.params; // Breakpoints

      if (params.breakpoints) {
        swiper.setBreakpoint();
      }

      swiper.updateSize();
      swiper.updateSlides();
      swiper.updateProgress();
      swiper.updateSlidesClasses();

      function setTranslate() {
        var translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
        var newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
        swiper.setTranslate(newTranslate);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
      }

      var translated;

      if (swiper.params.freeMode) {
        setTranslate();

        if (swiper.params.autoHeight) {
          swiper.updateAutoHeight();
        }
      } else {
        if ((swiper.params.slidesPerView === 'auto' || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
          translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
        } else {
          translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
        }

        if (!translated) {
          setTranslate();
        }
      }

      if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
        swiper.checkOverflow();
      }

      swiper.emit('update');
    };

    _proto.changeDirection = function changeDirection(newDirection, needUpdate) {
      if (needUpdate === void 0) {
        needUpdate = true;
      }

      var swiper = this;
      var currentDirection = swiper.params.direction;

      if (!newDirection) {
        // eslint-disable-next-line
        newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
      }

      if (newDirection === currentDirection || newDirection !== 'horizontal' && newDirection !== 'vertical') {
        return swiper;
      }

      swiper.$el.removeClass("" + swiper.params.containerModifierClass + currentDirection).addClass("" + swiper.params.containerModifierClass + newDirection);
      swiper.emitContainerClasses();
      swiper.params.direction = newDirection;
      swiper.slides.each(function (slideEl) {
        if (newDirection === 'vertical') {
          slideEl.style.width = '';
        } else {
          slideEl.style.height = '';
        }
      });
      swiper.emit('changeDirection');
      if (needUpdate) swiper.update();
      return swiper;
    };

    _proto.mount = function mount(el) {
      var swiper = this;
      if (swiper.mounted) return true; // Find el

      var $el = $(el || swiper.params.el);
      el = $el[0];

      if (!el) {
        return false;
      }

      el.swiper = swiper;

      var getWrapperSelector = function getWrapperSelector() {
        return "." + (swiper.params.wrapperClass || '').trim().split(' ').join('.');
      };

      var getWrapper = function getWrapper() {
        if (el && el.shadowRoot && el.shadowRoot.querySelector) {
          var res = $(el.shadowRoot.querySelector(getWrapperSelector())); // Children needs to return slot items

          res.children = function (options) {
            return $el.children(options);
          };

          return res;
        }

        return $el.children(getWrapperSelector());
      }; // Find Wrapper


      var $wrapperEl = getWrapper();

      if ($wrapperEl.length === 0 && swiper.params.createElements) {
        var document = getDocument();
        var wrapper = document.createElement('div');
        $wrapperEl = $(wrapper);
        wrapper.className = swiper.params.wrapperClass;
        $el.append(wrapper);
        $el.children("." + swiper.params.slideClass).each(function (slideEl) {
          $wrapperEl.append(slideEl);
        });
      }

      extend$1(swiper, {
        $el: $el,
        el: el,
        $wrapperEl: $wrapperEl,
        wrapperEl: $wrapperEl[0],
        mounted: true,
        // RTL
        rtl: el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl',
        rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
        wrongRTL: $wrapperEl.css('display') === '-webkit-box'
      });
      return true;
    };

    _proto.init = function init(el) {
      var swiper = this;
      if (swiper.initialized) return swiper;
      var mounted = swiper.mount(el);
      if (mounted === false) return swiper;
      swiper.emit('beforeInit'); // Set breakpoint

      if (swiper.params.breakpoints) {
        swiper.setBreakpoint();
      } // Add Classes


      swiper.addClasses(); // Create loop

      if (swiper.params.loop) {
        swiper.loopCreate();
      } // Update size


      swiper.updateSize(); // Update slides

      swiper.updateSlides();

      if (swiper.params.watchOverflow) {
        swiper.checkOverflow();
      } // Set Grab Cursor


      if (swiper.params.grabCursor && swiper.enabled) {
        swiper.setGrabCursor();
      }

      if (swiper.params.preloadImages) {
        swiper.preloadImages();
      } // Slide To Initial Slide


      if (swiper.params.loop) {
        swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit, false, true);
      } else {
        swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
      } // Attach events


      swiper.attachEvents(); // Init Flag

      swiper.initialized = true; // Emit

      swiper.emit('init');
      swiper.emit('afterInit');
      return swiper;
    };

    _proto.destroy = function destroy(deleteInstance, cleanStyles) {
      if (deleteInstance === void 0) {
        deleteInstance = true;
      }

      if (cleanStyles === void 0) {
        cleanStyles = true;
      }

      var swiper = this;
      var params = swiper.params,
          $el = swiper.$el,
          $wrapperEl = swiper.$wrapperEl,
          slides = swiper.slides;

      if (typeof swiper.params === 'undefined' || swiper.destroyed) {
        return null;
      }

      swiper.emit('beforeDestroy'); // Init Flag

      swiper.initialized = false; // Detach events

      swiper.detachEvents(); // Destroy loop

      if (params.loop) {
        swiper.loopDestroy();
      } // Cleanup styles


      if (cleanStyles) {
        swiper.removeClasses();
        $el.removeAttr('style');
        $wrapperEl.removeAttr('style');

        if (slides && slides.length) {
          slides.removeClass([params.slideVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass].join(' ')).removeAttr('style').removeAttr('data-swiper-slide-index');
        }
      }

      swiper.emit('destroy'); // Detach emitter events

      Object.keys(swiper.eventsListeners).forEach(function (eventName) {
        swiper.off(eventName);
      });

      if (deleteInstance !== false) {
        swiper.$el[0].swiper = null;
        deleteProps(swiper);
      }

      swiper.destroyed = true;
      return null;
    };

    Swiper.extendDefaults = function extendDefaults(newDefaults) {
      extend$1(extendedDefaults, newDefaults);
    };

    Swiper.installModule = function installModule(module) {
      if (!Swiper.prototype.modules) Swiper.prototype.modules = {};
      var name = module.name || Object.keys(Swiper.prototype.modules).length + "_" + now();
      Swiper.prototype.modules[name] = module;
    };

    Swiper.use = function use(module) {
      if (Array.isArray(module)) {
        module.forEach(function (m) {
          return Swiper.installModule(m);
        });
        return Swiper;
      }

      Swiper.installModule(module);
      return Swiper;
    };

    _createClass(Swiper, null, [{
      key: "extendedDefaults",
      get: function get() {
        return extendedDefaults;
      }
    }, {
      key: "defaults",
      get: function get() {
        return defaults;
      }
    }]);

    return Swiper;
  }();

  Object.keys(prototypes).forEach(function (prototypeGroup) {
    Object.keys(prototypes[prototypeGroup]).forEach(function (protoMethod) {
      Swiper$1.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
    });
  });
  Swiper$1.use([Resize, Observer$1]);
  var SwiperCore = Swiper$1;

  function _extends$3() {
    _extends$3 = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends$3.apply(this, arguments);
  }

  var Navigation = {
    toggleEl: function toggleEl($el, disabled) {
      $el[disabled ? 'addClass' : 'removeClass'](this.params.navigation.disabledClass);
      if ($el[0] && $el[0].tagName === 'BUTTON') $el[0].disabled = disabled;
    },
    update: function update() {
      // Update Navigation Buttons
      var swiper = this;
      var params = swiper.params.navigation;
      var toggleEl = swiper.navigation.toggleEl;
      if (swiper.params.loop) return;
      var _swiper$navigation = swiper.navigation,
          $nextEl = _swiper$navigation.$nextEl,
          $prevEl = _swiper$navigation.$prevEl;

      if ($prevEl && $prevEl.length > 0) {
        if (swiper.isBeginning) {
          toggleEl($prevEl, true);
        } else {
          toggleEl($prevEl, false);
        }

        if (swiper.params.watchOverflow && swiper.enabled) {
          $prevEl[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
        }
      }

      if ($nextEl && $nextEl.length > 0) {
        if (swiper.isEnd) {
          toggleEl($nextEl, true);
        } else {
          toggleEl($nextEl, false);
        }

        if (swiper.params.watchOverflow && swiper.enabled) {
          $nextEl[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
        }
      }
    },
    onPrevClick: function onPrevClick(e) {
      var swiper = this;
      e.preventDefault();
      if (swiper.isBeginning && !swiper.params.loop) return;
      swiper.slidePrev();
    },
    onNextClick: function onNextClick(e) {
      var swiper = this;
      e.preventDefault();
      if (swiper.isEnd && !swiper.params.loop) return;
      swiper.slideNext();
    },
    init: function init() {
      var swiper = this;
      var params = swiper.params.navigation;
      swiper.params.navigation = createElementIfNotDefined(swiper.$el, swiper.params.navigation, swiper.params.createElements, {
        nextEl: 'swiper-button-next',
        prevEl: 'swiper-button-prev'
      });
      if (!(params.nextEl || params.prevEl)) return;
      var $nextEl;
      var $prevEl;

      if (params.nextEl) {
        $nextEl = $(params.nextEl);

        if (swiper.params.uniqueNavElements && typeof params.nextEl === 'string' && $nextEl.length > 1 && swiper.$el.find(params.nextEl).length === 1) {
          $nextEl = swiper.$el.find(params.nextEl);
        }
      }

      if (params.prevEl) {
        $prevEl = $(params.prevEl);

        if (swiper.params.uniqueNavElements && typeof params.prevEl === 'string' && $prevEl.length > 1 && swiper.$el.find(params.prevEl).length === 1) {
          $prevEl = swiper.$el.find(params.prevEl);
        }
      }

      if ($nextEl && $nextEl.length > 0) {
        $nextEl.on('click', swiper.navigation.onNextClick);
      }

      if ($prevEl && $prevEl.length > 0) {
        $prevEl.on('click', swiper.navigation.onPrevClick);
      }

      extend$1(swiper.navigation, {
        $nextEl: $nextEl,
        nextEl: $nextEl && $nextEl[0],
        $prevEl: $prevEl,
        prevEl: $prevEl && $prevEl[0]
      });

      if (!swiper.enabled) {
        if ($nextEl) $nextEl.addClass(params.lockClass);
        if ($prevEl) $prevEl.addClass(params.lockClass);
      }
    },
    destroy: function destroy() {
      var swiper = this;
      var _swiper$navigation2 = swiper.navigation,
          $nextEl = _swiper$navigation2.$nextEl,
          $prevEl = _swiper$navigation2.$prevEl;

      if ($nextEl && $nextEl.length) {
        $nextEl.off('click', swiper.navigation.onNextClick);
        $nextEl.removeClass(swiper.params.navigation.disabledClass);
      }

      if ($prevEl && $prevEl.length) {
        $prevEl.off('click', swiper.navigation.onPrevClick);
        $prevEl.removeClass(swiper.params.navigation.disabledClass);
      }
    }
  };
  var Navigation$1 = {
    name: 'navigation',
    params: {
      navigation: {
        nextEl: null,
        prevEl: null,
        hideOnClick: false,
        disabledClass: 'swiper-button-disabled',
        hiddenClass: 'swiper-button-hidden',
        lockClass: 'swiper-button-lock'
      }
    },
    create: function create() {
      var swiper = this;
      bindModuleMethods(swiper, {
        navigation: _extends$3({}, Navigation)
      });
    },
    on: {
      init: function init(swiper) {
        swiper.navigation.init();
        swiper.navigation.update();
      },
      toEdge: function toEdge(swiper) {
        swiper.navigation.update();
      },
      fromEdge: function fromEdge(swiper) {
        swiper.navigation.update();
      },
      destroy: function destroy(swiper) {
        swiper.navigation.destroy();
      },
      'enable disable': function enableDisable(swiper) {
        var _swiper$navigation3 = swiper.navigation,
            $nextEl = _swiper$navigation3.$nextEl,
            $prevEl = _swiper$navigation3.$prevEl;

        if ($nextEl) {
          $nextEl[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.navigation.lockClass);
        }

        if ($prevEl) {
          $prevEl[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.navigation.lockClass);
        }
      },
      click: function click(swiper, e) {
        var _swiper$navigation4 = swiper.navigation,
            $nextEl = _swiper$navigation4.$nextEl,
            $prevEl = _swiper$navigation4.$prevEl;
        var targetEl = e.target;

        if (swiper.params.navigation.hideOnClick && !$(targetEl).is($prevEl) && !$(targetEl).is($nextEl)) {
          if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
          var isHidden;

          if ($nextEl) {
            isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
          } else if ($prevEl) {
            isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
          }

          if (isHidden === true) {
            swiper.emit('navigationShow');
          } else {
            swiper.emit('navigationHide');
          }

          if ($nextEl) {
            $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
          }

          if ($prevEl) {
            $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
          }
        }
      }
    }
  };

  function _extends$2() {
    _extends$2 = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends$2.apply(this, arguments);
  }

  var Pagination = {
    update: function update() {
      // Render || Update Pagination bullets/items
      var swiper = this;
      var rtl = swiper.rtl;
      var params = swiper.params.pagination;
      if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
      var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
      var $el = swiper.pagination.$el; // Current/Total

      var current;
      var total = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;

      if (swiper.params.loop) {
        current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);

        if (current > slidesLength - 1 - swiper.loopedSlides * 2) {
          current -= slidesLength - swiper.loopedSlides * 2;
        }

        if (current > total - 1) current -= total;
        if (current < 0 && swiper.params.paginationType !== 'bullets') current = total + current;
      } else if (typeof swiper.snapIndex !== 'undefined') {
        current = swiper.snapIndex;
      } else {
        current = swiper.activeIndex || 0;
      } // Types


      if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
        var bullets = swiper.pagination.bullets;
        var firstIndex;
        var lastIndex;
        var midIndex;

        if (params.dynamicBullets) {
          swiper.pagination.bulletSize = bullets.eq(0)[swiper.isHorizontal() ? 'outerWidth' : 'outerHeight'](true);
          $el.css(swiper.isHorizontal() ? 'width' : 'height', swiper.pagination.bulletSize * (params.dynamicMainBullets + 4) + "px");

          if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
            swiper.pagination.dynamicBulletIndex += current - swiper.previousIndex;

            if (swiper.pagination.dynamicBulletIndex > params.dynamicMainBullets - 1) {
              swiper.pagination.dynamicBulletIndex = params.dynamicMainBullets - 1;
            } else if (swiper.pagination.dynamicBulletIndex < 0) {
              swiper.pagination.dynamicBulletIndex = 0;
            }
          }

          firstIndex = current - swiper.pagination.dynamicBulletIndex;
          lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
          midIndex = (lastIndex + firstIndex) / 2;
        }

        bullets.removeClass(params.bulletActiveClass + " " + params.bulletActiveClass + "-next " + params.bulletActiveClass + "-next-next " + params.bulletActiveClass + "-prev " + params.bulletActiveClass + "-prev-prev " + params.bulletActiveClass + "-main");

        if ($el.length > 1) {
          bullets.each(function (bullet) {
            var $bullet = $(bullet);
            var bulletIndex = $bullet.index();

            if (bulletIndex === current) {
              $bullet.addClass(params.bulletActiveClass);
            }

            if (params.dynamicBullets) {
              if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
                $bullet.addClass(params.bulletActiveClass + "-main");
              }

              if (bulletIndex === firstIndex) {
                $bullet.prev().addClass(params.bulletActiveClass + "-prev").prev().addClass(params.bulletActiveClass + "-prev-prev");
              }

              if (bulletIndex === lastIndex) {
                $bullet.next().addClass(params.bulletActiveClass + "-next").next().addClass(params.bulletActiveClass + "-next-next");
              }
            }
          });
        } else {
          var $bullet = bullets.eq(current);
          var bulletIndex = $bullet.index();
          $bullet.addClass(params.bulletActiveClass);

          if (params.dynamicBullets) {
            var $firstDisplayedBullet = bullets.eq(firstIndex);
            var $lastDisplayedBullet = bullets.eq(lastIndex);

            for (var i = firstIndex; i <= lastIndex; i += 1) {
              bullets.eq(i).addClass(params.bulletActiveClass + "-main");
            }

            if (swiper.params.loop) {
              if (bulletIndex >= bullets.length - params.dynamicMainBullets) {
                for (var _i = params.dynamicMainBullets; _i >= 0; _i -= 1) {
                  bullets.eq(bullets.length - _i).addClass(params.bulletActiveClass + "-main");
                }

                bullets.eq(bullets.length - params.dynamicMainBullets - 1).addClass(params.bulletActiveClass + "-prev");
              } else {
                $firstDisplayedBullet.prev().addClass(params.bulletActiveClass + "-prev").prev().addClass(params.bulletActiveClass + "-prev-prev");
                $lastDisplayedBullet.next().addClass(params.bulletActiveClass + "-next").next().addClass(params.bulletActiveClass + "-next-next");
              }
            } else {
              $firstDisplayedBullet.prev().addClass(params.bulletActiveClass + "-prev").prev().addClass(params.bulletActiveClass + "-prev-prev");
              $lastDisplayedBullet.next().addClass(params.bulletActiveClass + "-next").next().addClass(params.bulletActiveClass + "-next-next");
            }
          }
        }

        if (params.dynamicBullets) {
          var dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
          var bulletsOffset = (swiper.pagination.bulletSize * dynamicBulletsLength - swiper.pagination.bulletSize) / 2 - midIndex * swiper.pagination.bulletSize;
          var offsetProp = rtl ? 'right' : 'left';
          bullets.css(swiper.isHorizontal() ? offsetProp : 'top', bulletsOffset + "px");
        }
      }

      if (params.type === 'fraction') {
        $el.find(classesToSelector(params.currentClass)).text(params.formatFractionCurrent(current + 1));
        $el.find(classesToSelector(params.totalClass)).text(params.formatFractionTotal(total));
      }

      if (params.type === 'progressbar') {
        var progressbarDirection;

        if (params.progressbarOpposite) {
          progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
        } else {
          progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
        }

        var scale = (current + 1) / total;
        var scaleX = 1;
        var scaleY = 1;

        if (progressbarDirection === 'horizontal') {
          scaleX = scale;
        } else {
          scaleY = scale;
        }

        $el.find(classesToSelector(params.progressbarFillClass)).transform("translate3d(0,0,0) scaleX(" + scaleX + ") scaleY(" + scaleY + ")").transition(swiper.params.speed);
      }

      if (params.type === 'custom' && params.renderCustom) {
        $el.html(params.renderCustom(swiper, current + 1, total));
        swiper.emit('paginationRender', $el[0]);
      } else {
        swiper.emit('paginationUpdate', $el[0]);
      }

      if (swiper.params.watchOverflow && swiper.enabled) {
        $el[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
      }
    },
    render: function render() {
      // Render Container
      var swiper = this;
      var params = swiper.params.pagination;
      if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
      var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
      var $el = swiper.pagination.$el;
      var paginationHTML = '';

      if (params.type === 'bullets') {
        var numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;

        if (swiper.params.freeMode && !swiper.params.loop && numberOfBullets > slidesLength) {
          numberOfBullets = slidesLength;
        }

        for (var i = 0; i < numberOfBullets; i += 1) {
          if (params.renderBullet) {
            paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
          } else {
            paginationHTML += "<" + params.bulletElement + " class=\"" + params.bulletClass + "\"></" + params.bulletElement + ">";
          }
        }

        $el.html(paginationHTML);
        swiper.pagination.bullets = $el.find(classesToSelector(params.bulletClass));
      }

      if (params.type === 'fraction') {
        if (params.renderFraction) {
          paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
        } else {
          paginationHTML = "<span class=\"" + params.currentClass + "\"></span>" + ' / ' + ("<span class=\"" + params.totalClass + "\"></span>");
        }

        $el.html(paginationHTML);
      }

      if (params.type === 'progressbar') {
        if (params.renderProgressbar) {
          paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
        } else {
          paginationHTML = "<span class=\"" + params.progressbarFillClass + "\"></span>";
        }

        $el.html(paginationHTML);
      }

      if (params.type !== 'custom') {
        swiper.emit('paginationRender', swiper.pagination.$el[0]);
      }
    },
    init: function init() {
      var swiper = this;
      swiper.params.pagination = createElementIfNotDefined(swiper.$el, swiper.params.pagination, swiper.params.createElements, {
        el: 'swiper-pagination'
      });
      var params = swiper.params.pagination;
      if (!params.el) return;
      var $el = $(params.el);
      if ($el.length === 0) return;

      if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1) {
        $el = swiper.$el.find(params.el);
      }

      if (params.type === 'bullets' && params.clickable) {
        $el.addClass(params.clickableClass);
      }

      $el.addClass(params.modifierClass + params.type);

      if (params.type === 'bullets' && params.dynamicBullets) {
        $el.addClass("" + params.modifierClass + params.type + "-dynamic");
        swiper.pagination.dynamicBulletIndex = 0;

        if (params.dynamicMainBullets < 1) {
          params.dynamicMainBullets = 1;
        }
      }

      if (params.type === 'progressbar' && params.progressbarOpposite) {
        $el.addClass(params.progressbarOppositeClass);
      }

      if (params.clickable) {
        $el.on('click', classesToSelector(params.bulletClass), function onClick(e) {
          e.preventDefault();
          var index = $(this).index() * swiper.params.slidesPerGroup;
          if (swiper.params.loop) index += swiper.loopedSlides;
          swiper.slideTo(index);
        });
      }

      extend$1(swiper.pagination, {
        $el: $el,
        el: $el[0]
      });

      if (!swiper.enabled) {
        $el.addClass(params.lockClass);
      }
    },
    destroy: function destroy() {
      var swiper = this;
      var params = swiper.params.pagination;
      if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
      var $el = swiper.pagination.$el;
      $el.removeClass(params.hiddenClass);
      $el.removeClass(params.modifierClass + params.type);
      if (swiper.pagination.bullets) swiper.pagination.bullets.removeClass(params.bulletActiveClass);

      if (params.clickable) {
        $el.off('click', classesToSelector(params.bulletClass));
      }
    }
  };
  var Pagination$1 = {
    name: 'pagination',
    params: {
      pagination: {
        el: null,
        bulletElement: 'span',
        clickable: false,
        hideOnClick: false,
        renderBullet: null,
        renderProgressbar: null,
        renderFraction: null,
        renderCustom: null,
        progressbarOpposite: false,
        type: 'bullets',
        // 'bullets' or 'progressbar' or 'fraction' or 'custom'
        dynamicBullets: false,
        dynamicMainBullets: 1,
        formatFractionCurrent: function formatFractionCurrent(number) {
          return number;
        },
        formatFractionTotal: function formatFractionTotal(number) {
          return number;
        },
        bulletClass: 'swiper-pagination-bullet',
        bulletActiveClass: 'swiper-pagination-bullet-active',
        modifierClass: 'swiper-pagination-',
        // NEW
        currentClass: 'swiper-pagination-current',
        totalClass: 'swiper-pagination-total',
        hiddenClass: 'swiper-pagination-hidden',
        progressbarFillClass: 'swiper-pagination-progressbar-fill',
        progressbarOppositeClass: 'swiper-pagination-progressbar-opposite',
        clickableClass: 'swiper-pagination-clickable',
        // NEW
        lockClass: 'swiper-pagination-lock'
      }
    },
    create: function create() {
      var swiper = this;
      bindModuleMethods(swiper, {
        pagination: _extends$2({
          dynamicBulletIndex: 0
        }, Pagination)
      });
    },
    on: {
      init: function init(swiper) {
        swiper.pagination.init();
        swiper.pagination.render();
        swiper.pagination.update();
      },
      activeIndexChange: function activeIndexChange(swiper) {
        if (swiper.params.loop) {
          swiper.pagination.update();
        } else if (typeof swiper.snapIndex === 'undefined') {
          swiper.pagination.update();
        }
      },
      snapIndexChange: function snapIndexChange(swiper) {
        if (!swiper.params.loop) {
          swiper.pagination.update();
        }
      },
      slidesLengthChange: function slidesLengthChange(swiper) {
        if (swiper.params.loop) {
          swiper.pagination.render();
          swiper.pagination.update();
        }
      },
      snapGridLengthChange: function snapGridLengthChange(swiper) {
        if (!swiper.params.loop) {
          swiper.pagination.render();
          swiper.pagination.update();
        }
      },
      destroy: function destroy(swiper) {
        swiper.pagination.destroy();
      },
      'enable disable': function enableDisable(swiper) {
        var $el = swiper.pagination.$el;

        if ($el) {
          $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.pagination.lockClass);
        }
      },
      click: function click(swiper, e) {
        var targetEl = e.target;

        if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && swiper.pagination.$el.length > 0 && !$(targetEl).hasClass(swiper.params.pagination.bulletClass)) {
          if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
          var isHidden = swiper.pagination.$el.hasClass(swiper.params.pagination.hiddenClass);

          if (isHidden === true) {
            swiper.emit('paginationShow');
          } else {
            swiper.emit('paginationHide');
          }

          swiper.pagination.$el.toggleClass(swiper.params.pagination.hiddenClass);
        }
      }
    }
  };

  function isObject(o) {
    return typeof o === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
  }

  function extend(target, src) {
    var noExtend = ['__proto__', 'constructor', 'prototype'];
    Object.keys(src).filter(function (key) {
      return noExtend.indexOf(key) < 0;
    }).forEach(function (key) {
      if (typeof target[key] === 'undefined') target[key] = src[key];else if (isObject(src[key]) && isObject(target[key]) && Object.keys(src[key]).length > 0) {
        if (src[key].__swiper__) target[key] = src[key];else extend(target[key], src[key]);
      } else {
        target[key] = src[key];
      }
    });
  }

  function needsNavigation(params) {
    if (params === void 0) {
      params = {};
    }

    return params.navigation && typeof params.navigation.nextEl === 'undefined' && typeof params.navigation.prevEl === 'undefined';
  }

  function needsPagination(params) {
    if (params === void 0) {
      params = {};
    }

    return params.pagination && typeof params.pagination.el === 'undefined';
  }

  function needsScrollbar(params) {
    if (params === void 0) {
      params = {};
    }

    return params.scrollbar && typeof params.scrollbar.el === 'undefined';
  }

  function uniqueClasses(classNames) {
    if (classNames === void 0) {
      classNames = '';
    }

    var classes = classNames.split(' ').map(function (c) {
      return c.trim();
    }).filter(function (c) {
      return !!c;
    });
    var unique = [];
    classes.forEach(function (c) {
      if (unique.indexOf(c) < 0) unique.push(c);
    });
    return unique.join(' ');
  }
  /* underscore in name -> watch for changes */


  var paramsList = ['init', '_direction', 'touchEventsTarget', 'initialSlide', '_speed', 'cssMode', 'updateOnWindowResize', 'resizeObserver', 'nested', 'focusableElements', '_enabled', '_width', '_height', 'preventInteractionOnTransition', 'userAgent', 'url', '_edgeSwipeDetection', '_edgeSwipeThreshold', '_freeMode', '_freeModeMomentum', '_freeModeMomentumRatio', '_freeModeMomentumBounce', '_freeModeMomentumBounceRatio', '_freeModeMomentumVelocityRatio', '_freeModeSticky', '_freeModeMinimumVelocity', '_autoHeight', 'setWrapperSize', 'virtualTranslate', '_effect', 'breakpoints', '_spaceBetween', '_slidesPerView', '_slidesPerColumn', '_slidesPerColumnFill', '_slidesPerGroup', '_slidesPerGroupSkip', '_centeredSlides', '_centeredSlidesBounds', '_slidesOffsetBefore', '_slidesOffsetAfter', 'normalizeSlideIndex', '_centerInsufficientSlides', '_watchOverflow', 'roundLengths', 'touchRatio', 'touchAngle', 'simulateTouch', '_shortSwipes', '_longSwipes', 'longSwipesRatio', 'longSwipesMs', '_followFinger', 'allowTouchMove', '_threshold', 'touchMoveStopPropagation', 'touchStartPreventDefault', 'touchStartForcePreventDefault', 'touchReleaseOnEdges', 'uniqueNavElements', '_resistance', '_resistanceRatio', '_watchSlidesProgress', '_watchSlidesVisibility', '_grabCursor', 'preventClicks', 'preventClicksPropagation', '_slideToClickedSlide', '_preloadImages', 'updateOnImagesReady', '_loop', '_loopAdditionalSlides', '_loopedSlides', '_loopFillGroupWithBlank', 'loopPreventsSlide', '_allowSlidePrev', '_allowSlideNext', '_swipeHandler', '_noSwiping', 'noSwipingClass', 'noSwipingSelector', 'passiveListeners', 'containerModifierClass', 'slideClass', 'slideBlankClass', 'slideActiveClass', 'slideDuplicateActiveClass', 'slideVisibleClass', 'slideDuplicateClass', 'slideNextClass', 'slideDuplicateNextClass', 'slidePrevClass', 'slideDuplicatePrevClass', 'wrapperClass', 'runCallbacksOnInit', 'observer', 'observeParents', 'observeSlideChildren', // modules
  'a11y', 'autoplay', '_controller', 'coverflowEffect', 'cubeEffect', 'fadeEffect', 'flipEffect', 'hashNavigation', 'history', 'keyboard', 'lazy', 'mousewheel', '_navigation', '_pagination', 'parallax', '_scrollbar', '_thumbs', 'virtual', 'zoom']; // eslint-disable-next-line

  function getParams(obj) {
    if (obj === void 0) {
      obj = {};
    }

    var params = {
      on: {}
    };
    var events = {};
    var passedParams = {};
    extend(params, SwiperCore.defaults);
    extend(params, SwiperCore.extendedDefaults);
    params._emitClasses = true;
    params.init = false;
    var rest = {};
    var allowedParams = paramsList.map(function (key) {
      return key.replace(/_/, '');
    });
    Object.keys(obj).forEach(function (key) {
      if (allowedParams.indexOf(key) >= 0) {
        if (isObject(obj[key])) {
          params[key] = {};
          passedParams[key] = {};
          extend(params[key], obj[key]);
          extend(passedParams[key], obj[key]);
        } else {
          params[key] = obj[key];
          passedParams[key] = obj[key];
        }
      } else if (key.search(/on[A-Z]/) === 0 && typeof obj[key] === 'function') {
        events["" + key[2].toLowerCase() + key.substr(3)] = obj[key];
      } else {
        rest[key] = obj[key];
      }
    });
    ['navigation', 'pagination', 'scrollbar'].forEach(function (key) {
      if (params[key] === true) params[key] = {};
      if (params[key] === false) delete params[key];
    });
    return {
      params: params,
      passedParams: passedParams,
      rest: rest,
      events: events
    };
  } // eslint-disable-next-line


  function initSwiper(swiperParams) {
    return new SwiperCore(swiperParams);
  }

  function mountSwiper(_ref, swiperParams) {
    var el = _ref.el,
        nextEl = _ref.nextEl,
        prevEl = _ref.prevEl,
        paginationEl = _ref.paginationEl,
        scrollbarEl = _ref.scrollbarEl,
        swiper = _ref.swiper;

    if (needsNavigation(swiperParams) && nextEl && prevEl) {
      swiper.params.navigation.nextEl = nextEl;
      swiper.originalParams.navigation.nextEl = nextEl;
      swiper.params.navigation.prevEl = prevEl;
      swiper.originalParams.navigation.prevEl = prevEl;
    }

    if (needsPagination(swiperParams) && paginationEl) {
      swiper.params.pagination.el = paginationEl;
      swiper.originalParams.pagination.el = paginationEl;
    }

    if (needsScrollbar(swiperParams) && scrollbarEl) {
      swiper.params.scrollbar.el = scrollbarEl;
      swiper.originalParams.scrollbar.el = scrollbarEl;
    }

    swiper.init(el);
  }

  function calcLoopedSlides(slides, swiperParams) {
    var slidesPerViewParams = swiperParams.slidesPerView;

    if (swiperParams.breakpoints) {
      var breakpoint = SwiperCore.prototype.getBreakpoint(swiperParams.breakpoints);
      var breakpointOnlyParams = breakpoint in swiperParams.breakpoints ? swiperParams.breakpoints[breakpoint] : undefined;

      if (breakpointOnlyParams && breakpointOnlyParams.slidesPerView) {
        slidesPerViewParams = breakpointOnlyParams.slidesPerView;
      }
    }

    var loopedSlides = Math.ceil(parseFloat(swiperParams.loopedSlides || slidesPerViewParams, 10));
    loopedSlides += swiperParams.loopAdditionalSlides;

    if (loopedSlides > slides.length) {
      loopedSlides = slides.length;
    }

    return loopedSlides;
  }

  function renderLoop(swiper, slides, swiperParams) {
    var modifiedSlides = slides.map(function (child, index) {
      return /*#__PURE__*/React__default["default"].cloneElement(child, {
        swiper: swiper,
        'data-swiper-slide-index': index
      });
    });

    function duplicateSlide(child, index, position) {
      return /*#__PURE__*/React__default["default"].cloneElement(child, {
        key: child.key + "-duplicate-" + index + "-" + position,
        className: (child.props.className || '') + " " + swiperParams.slideDuplicateClass
      });
    }

    if (swiperParams.loopFillGroupWithBlank) {
      var blankSlidesNum = swiperParams.slidesPerGroup - modifiedSlides.length % swiperParams.slidesPerGroup;

      if (blankSlidesNum !== swiperParams.slidesPerGroup) {
        for (var i = 0; i < blankSlidesNum; i += 1) {
          var blankSlide = /*#__PURE__*/React__default["default"].createElement("div", {
            className: swiperParams.slideClass + " " + swiperParams.slideBlankClass
          });
          modifiedSlides.push(blankSlide);
        }
      }
    }

    if (swiperParams.slidesPerView === 'auto' && !swiperParams.loopedSlides) {
      swiperParams.loopedSlides = modifiedSlides.length;
    }

    var loopedSlides = calcLoopedSlides(modifiedSlides, swiperParams);
    var prependSlides = [];
    var appendSlides = [];
    modifiedSlides.forEach(function (child, index) {
      if (index < loopedSlides) {
        appendSlides.push(duplicateSlide(child, index, 'prepend'));
      }

      if (index < modifiedSlides.length && index >= modifiedSlides.length - loopedSlides) {
        prependSlides.push(duplicateSlide(child, index, 'append'));
      }
    });

    if (swiper) {
      swiper.loopedSlides = loopedSlides;
    }

    return [].concat(prependSlides, modifiedSlides, appendSlides);
  }

  function getChangedParams(swiperParams, oldParams, children, oldChildren) {
    var keys = [];
    if (!oldParams) return keys;

    var addKey = function addKey(key) {
      if (keys.indexOf(key) < 0) keys.push(key);
    };

    var oldChildrenKeys = oldChildren.map(function (child) {
      return child.key;
    });
    var childrenKeys = children.map(function (child) {
      return child.key;
    });
    if (oldChildrenKeys.join('') !== childrenKeys.join('')) addKey('children');
    if (oldChildren.length !== children.length) addKey('children');
    var watchParams = paramsList.filter(function (key) {
      return key[0] === '_';
    }).map(function (key) {
      return key.replace(/_/, '');
    });
    watchParams.forEach(function (key) {
      if (key in swiperParams && key in oldParams) {
        if (isObject(swiperParams[key]) && isObject(oldParams[key])) {
          var newKeys = Object.keys(swiperParams[key]);
          var oldKeys = Object.keys(oldParams[key]);

          if (newKeys.length !== oldKeys.length) {
            addKey(key);
          } else {
            newKeys.forEach(function (newKey) {
              if (swiperParams[key][newKey] !== oldParams[key][newKey]) {
                addKey(key);
              }
            });
            oldKeys.forEach(function (oldKey) {
              if (swiperParams[key][oldKey] !== oldParams[key][oldKey]) addKey(key);
            });
          }
        } else if (swiperParams[key] !== oldParams[key]) {
          addKey(key);
        }
      }
    });
    return keys;
  }

  function processChildren(c) {
    var slides = [];
    React__default["default"].Children.toArray(c).forEach(function (child) {
      if (child.type && child.type.displayName === 'SwiperSlide') {
        slides.push(child);
      } else if (child.props && child.props.children) {
        processChildren(child.props.children).forEach(function (slide) {
          return slides.push(slide);
        });
      }
    });
    return slides;
  }

  function getChildren(c) {
    var slides = [];
    var slots = {
      'container-start': [],
      'container-end': [],
      'wrapper-start': [],
      'wrapper-end': []
    };
    React__default["default"].Children.toArray(c).forEach(function (child) {
      if (child.type && child.type.displayName === 'SwiperSlide') {
        slides.push(child);
      } else if (child.props && child.props.slot && slots[child.props.slot]) {
        slots[child.props.slot].push(child);
      } else if (child.props && child.props.children) {
        var foundSlides = processChildren(child.props.children);

        if (foundSlides.length > 0) {
          foundSlides.forEach(function (slide) {
            return slides.push(slide);
          });
        } else {
          slots['container-end'].push(child);
        }
      } else {
        slots['container-end'].push(child);
      }
    });
    return {
      slides: slides,
      slots: slots
    };
  }

  function updateSwiper(_ref) {
    var swiper = _ref.swiper,
        slides = _ref.slides,
        passedParams = _ref.passedParams,
        changedParams = _ref.changedParams,
        nextEl = _ref.nextEl,
        prevEl = _ref.prevEl,
        scrollbarEl = _ref.scrollbarEl,
        paginationEl = _ref.paginationEl;
    var updateParams = changedParams.filter(function (key) {
      return key !== 'children' && key !== 'direction';
    });
    var currentParams = swiper.params,
        pagination = swiper.pagination,
        navigation = swiper.navigation,
        scrollbar = swiper.scrollbar,
        virtual = swiper.virtual,
        thumbs = swiper.thumbs;
    var needThumbsInit;
    var needControllerInit;
    var needPaginationInit;
    var needScrollbarInit;
    var needNavigationInit;

    if (changedParams.includes('thumbs') && passedParams.thumbs && passedParams.thumbs.swiper && currentParams.thumbs && !currentParams.thumbs.swiper) {
      needThumbsInit = true;
    }

    if (changedParams.includes('controller') && passedParams.controller && passedParams.controller.control && currentParams.controller && !currentParams.controller.control) {
      needControllerInit = true;
    }

    if (changedParams.includes('pagination') && passedParams.pagination && (passedParams.pagination.el || paginationEl) && (currentParams.pagination || currentParams.pagination === false) && pagination && !pagination.el) {
      needPaginationInit = true;
    }

    if (changedParams.includes('scrollbar') && passedParams.scrollbar && (passedParams.scrollbar.el || scrollbarEl) && (currentParams.scrollbar || currentParams.scrollbar === false) && scrollbar && !scrollbar.el) {
      needScrollbarInit = true;
    }

    if (changedParams.includes('navigation') && passedParams.navigation && (passedParams.navigation.prevEl || prevEl) && (passedParams.navigation.nextEl || nextEl) && (currentParams.navigation || currentParams.navigation === false) && navigation && !navigation.prevEl && !navigation.nextEl) {
      needNavigationInit = true;
    }

    var destroyModule = function destroyModule(mod) {
      if (!swiper[mod]) return;
      swiper[mod].destroy();

      if (mod === 'navigation') {
        currentParams[mod].prevEl = undefined;
        currentParams[mod].nextEl = undefined;
        swiper[mod].prevEl = undefined;
        swiper[mod].nextEl = undefined;
      } else {
        currentParams[mod].el = undefined;
        swiper[mod].el = undefined;
      }
    };

    updateParams.forEach(function (key) {
      if (isObject(currentParams[key]) && isObject(passedParams[key])) {
        extend(currentParams[key], passedParams[key]);
      } else {
        var newValue = passedParams[key];

        if ((newValue === true || newValue === false) && (key === 'navigation' || key === 'pagination' || key === 'scrollbar')) {
          if (newValue === false) {
            destroyModule(key);
          }
        } else {
          currentParams[key] = passedParams[key];
        }
      }
    });

    if (changedParams.includes('children') && virtual && currentParams.virtual.enabled) {
      virtual.slides = slides;
      virtual.update(true);
    } else if (changedParams.includes('children') && swiper.lazy && swiper.params.lazy.enabled) {
      swiper.lazy.load();
    }

    if (needThumbsInit) {
      var initialized = thumbs.init();
      if (initialized) thumbs.update(true);
    }

    if (needControllerInit) {
      swiper.controller.control = currentParams.controller.control;
    }

    if (needPaginationInit) {
      if (paginationEl) currentParams.pagination.el = paginationEl;
      pagination.init();
      pagination.render();
      pagination.update();
    }

    if (needScrollbarInit) {
      if (scrollbarEl) currentParams.scrollbar.el = scrollbarEl;
      scrollbar.init();
      scrollbar.updateSize();
      scrollbar.setTranslate();
    }

    if (needNavigationInit) {
      if (nextEl) currentParams.navigation.nextEl = nextEl;
      if (prevEl) currentParams.navigation.prevEl = prevEl;
      navigation.init();
      navigation.update();
    }

    if (changedParams.includes('allowSlideNext')) {
      swiper.allowSlideNext = passedParams.allowSlideNext;
    }

    if (changedParams.includes('allowSlidePrev')) {
      swiper.allowSlidePrev = passedParams.allowSlidePrev;
    }

    if (changedParams.includes('direction')) {
      swiper.changeDirection(passedParams.direction, false);
    }

    swiper.update();
  }

  function updateOnVirtualData(swiper) {
    if (!swiper || swiper.destroyed || !swiper.params.virtual || swiper.params.virtual && !swiper.params.virtual.enabled) return;
    swiper.updateSlides();
    swiper.updateProgress();
    swiper.updateSlidesClasses();

    if (swiper.lazy && swiper.params.lazy.enabled) {
      swiper.lazy.load();
    }

    if (swiper.parallax && swiper.params.parallax && swiper.params.parallax.enabled) {
      swiper.parallax.setTranslate();
    }
  }

  function renderVirtual(swiper, slides, virtualData) {
    var _ref;

    if (!virtualData) return null;
    var style = swiper.isHorizontal() ? (_ref = {}, _ref[swiper.rtlTranslate ? 'right' : 'left'] = virtualData.offset + "px", _ref) : {
      top: virtualData.offset + "px"
    };
    return slides.filter(function (child, index) {
      return index >= virtualData.from && index <= virtualData.to;
    }).map(function (child) {
      return /*#__PURE__*/React__default["default"].cloneElement(child, {
        swiper: swiper,
        style: style
      });
    });
  }

  function useIsomorphicLayoutEffect(callback, deps) {
    // eslint-disable-next-line
    if (typeof window === 'undefined') return React.useEffect(callback, deps);
    return React.useLayoutEffect(callback, deps);
  }

  var _excluded$1 = ["className", "tag", "wrapperTag", "children", "onSwiper"];

  function _extends$1() {
    _extends$1 = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends$1.apply(this, arguments);
  }

  function _objectWithoutPropertiesLoose$1(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }

  var Swiper = /*#__PURE__*/React.forwardRef(function (_temp, externalElRef) {
    var _ref = _temp === void 0 ? {} : _temp,
        className = _ref.className,
        _ref$tag = _ref.tag,
        Tag = _ref$tag === void 0 ? 'div' : _ref$tag,
        _ref$wrapperTag = _ref.wrapperTag,
        WrapperTag = _ref$wrapperTag === void 0 ? 'div' : _ref$wrapperTag,
        children = _ref.children,
        onSwiper = _ref.onSwiper,
        rest = _objectWithoutPropertiesLoose$1(_ref, _excluded$1);

    var eventsAssigned = false;

    var _useState = React.useState('swiper-container'),
        containerClasses = _useState[0],
        setContainerClasses = _useState[1];

    var _useState2 = React.useState(null),
        virtualData = _useState2[0],
        setVirtualData = _useState2[1];

    var _useState3 = React.useState(false),
        breakpointChanged = _useState3[0],
        setBreakpointChanged = _useState3[1];

    var initializedRef = React.useRef(false);
    var swiperElRef = React.useRef(null);
    var swiperRef = React.useRef(null);
    var oldPassedParamsRef = React.useRef(null);
    var oldSlides = React.useRef(null);
    var nextElRef = React.useRef(null);
    var prevElRef = React.useRef(null);
    var paginationElRef = React.useRef(null);
    var scrollbarElRef = React.useRef(null);

    var _getParams = getParams(rest),
        swiperParams = _getParams.params,
        passedParams = _getParams.passedParams,
        restProps = _getParams.rest,
        events = _getParams.events;

    var _getChildren = getChildren(children),
        slides = _getChildren.slides,
        slots = _getChildren.slots;

    var onBeforeBreakpoint = function onBeforeBreakpoint() {
      setBreakpointChanged(!breakpointChanged);
    };

    Object.assign(swiperParams.on, {
      _containerClasses: function _containerClasses(swiper, classes) {
        setContainerClasses(classes);
      }
    });

    if (!swiperElRef.current) {
      // init swiper
      Object.assign(swiperParams.on, events);
      eventsAssigned = true;
      swiperRef.current = initSwiper(swiperParams);

      swiperRef.current.loopCreate = function () {};

      swiperRef.current.loopDestroy = function () {};

      if (swiperParams.loop) {
        swiperRef.current.loopedSlides = calcLoopedSlides(slides, swiperParams);
      }

      if (swiperRef.current.virtual && swiperRef.current.params.virtual.enabled) {
        swiperRef.current.virtual.slides = slides;
        var extendWith = {
          cache: false,
          renderExternal: setVirtualData,
          renderExternalUpdate: false
        };
        extend(swiperRef.current.params.virtual, extendWith);
        extend(swiperRef.current.originalParams.virtual, extendWith);
      }
    } // Listen for breakpoints change


    if (swiperRef.current) {
      swiperRef.current.on('_beforeBreakpoint', onBeforeBreakpoint);
    }

    var attachEvents = function attachEvents() {
      if (eventsAssigned || !events || !swiperRef.current) return;
      Object.keys(events).forEach(function (eventName) {
        swiperRef.current.on(eventName, events[eventName]);
      });
    };

    var detachEvents = function detachEvents() {
      if (!events || !swiperRef.current) return;
      Object.keys(events).forEach(function (eventName) {
        swiperRef.current.off(eventName, events[eventName]);
      });
    };

    React.useEffect(function () {
      return function () {
        if (swiperRef.current) swiperRef.current.off('_beforeBreakpoint', onBeforeBreakpoint);
      };
    }); // set initialized flag

    React.useEffect(function () {
      if (!initializedRef.current && swiperRef.current) {
        swiperRef.current.emitSlidesClasses();
        initializedRef.current = true;
      }
    }); // mount swiper

    useIsomorphicLayoutEffect(function () {
      if (externalElRef) {
        externalElRef.current = swiperElRef.current;
      }

      if (!swiperElRef.current) return;
      mountSwiper({
        el: swiperElRef.current,
        nextEl: nextElRef.current,
        prevEl: prevElRef.current,
        paginationEl: paginationElRef.current,
        scrollbarEl: scrollbarElRef.current,
        swiper: swiperRef.current
      }, swiperParams);
      if (onSwiper) onSwiper(swiperRef.current); // eslint-disable-next-line

      return function () {
        if (swiperRef.current && !swiperRef.current.destroyed) {
          swiperRef.current.destroy(true, false);
        }
      };
    }, []); // watch for params change

    useIsomorphicLayoutEffect(function () {
      attachEvents();
      var changedParams = getChangedParams(passedParams, oldPassedParamsRef.current, slides, oldSlides.current);
      oldPassedParamsRef.current = passedParams;
      oldSlides.current = slides;

      if (changedParams.length && swiperRef.current && !swiperRef.current.destroyed) {
        updateSwiper({
          swiper: swiperRef.current,
          slides: slides,
          passedParams: passedParams,
          changedParams: changedParams,
          nextEl: nextElRef.current,
          prevEl: prevElRef.current,
          scrollbarEl: scrollbarElRef.current,
          paginationEl: paginationElRef.current
        });
      }

      return function () {
        detachEvents();
      };
    }); // update on virtual update

    useIsomorphicLayoutEffect(function () {
      updateOnVirtualData(swiperRef.current);
    }, [virtualData]); // bypass swiper instance to slides

    function renderSlides() {
      if (swiperParams.virtual) {
        return renderVirtual(swiperRef.current, slides, virtualData);
      }

      if (!swiperParams.loop || swiperRef.current && swiperRef.current.destroyed) {
        return slides.map(function (child) {
          return /*#__PURE__*/React__default["default"].cloneElement(child, {
            swiper: swiperRef.current
          });
        });
      }

      return renderLoop(swiperRef.current, slides, swiperParams);
    }

    return /*#__PURE__*/React__default["default"].createElement(Tag, _extends$1({
      ref: swiperElRef,
      className: uniqueClasses("" + containerClasses + (className ? " " + className : ''))
    }, restProps), slots['container-start'], needsNavigation(swiperParams) && /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("div", {
      ref: prevElRef,
      className: "swiper-button-prev"
    }), /*#__PURE__*/React__default["default"].createElement("div", {
      ref: nextElRef,
      className: "swiper-button-next"
    })), needsScrollbar(swiperParams) && /*#__PURE__*/React__default["default"].createElement("div", {
      ref: scrollbarElRef,
      className: "swiper-scrollbar"
    }), needsPagination(swiperParams) && /*#__PURE__*/React__default["default"].createElement("div", {
      ref: paginationElRef,
      className: "swiper-pagination"
    }), /*#__PURE__*/React__default["default"].createElement(WrapperTag, {
      className: "swiper-wrapper"
    }, slots['wrapper-start'], renderSlides(), slots['wrapper-end']), slots['container-end']);
  });
  Swiper.displayName = 'Swiper';
  var _excluded = ["tag", "children", "className", "swiper", "zoom", "virtualIndex"];

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }

  var SwiperSlide = /*#__PURE__*/React.forwardRef(function (_temp, externalRef) {
    var _ref = _temp === void 0 ? {} : _temp,
        _ref$tag = _ref.tag,
        Tag = _ref$tag === void 0 ? 'div' : _ref$tag,
        children = _ref.children,
        _ref$className = _ref.className,
        className = _ref$className === void 0 ? '' : _ref$className,
        swiper = _ref.swiper,
        zoom = _ref.zoom,
        virtualIndex = _ref.virtualIndex,
        rest = _objectWithoutPropertiesLoose(_ref, _excluded);

    var slideElRef = React.useRef(null);

    var _useState = React.useState('swiper-slide'),
        slideClasses = _useState[0],
        setSlideClasses = _useState[1];

    function updateClasses(swiper, el, classNames) {
      if (el === slideElRef.current) {
        setSlideClasses(classNames);
      }
    }

    useIsomorphicLayoutEffect(function () {
      if (externalRef) {
        externalRef.current = slideElRef.current;
      }

      if (!slideElRef.current || !swiper) {
        return;
      }

      if (swiper.destroyed) {
        if (slideClasses !== 'swiper-slide') {
          setSlideClasses('swiper-slide');
        }

        return;
      }

      swiper.on('_slideClass', updateClasses); // eslint-disable-next-line

      return function () {
        if (!swiper) return;
        swiper.off('_slideClass', updateClasses);
      };
    });
    useIsomorphicLayoutEffect(function () {
      if (swiper && slideElRef.current) {
        setSlideClasses(swiper.getSlideClasses(slideElRef.current));
      }
    }, [swiper]);
    var slideData;

    if (typeof children === 'function') {
      slideData = {
        isActive: slideClasses.indexOf('swiper-slide-active') >= 0 || slideClasses.indexOf('swiper-slide-duplicate-active') >= 0,
        isVisible: slideClasses.indexOf('swiper-slide-visible') >= 0,
        isDuplicate: slideClasses.indexOf('swiper-slide-duplicate') >= 0,
        isPrev: slideClasses.indexOf('swiper-slide-prev') >= 0 || slideClasses.indexOf('swiper-slide-duplicate-prev') >= 0,
        isNext: slideClasses.indexOf('swiper-slide-next') >= 0 || slideClasses.indexOf('swiper-slide-duplicate-next') >= 0
      };
    }

    var renderChildren = function renderChildren() {
      return typeof children === 'function' ? children(slideData) : children;
    };

    return /*#__PURE__*/React__default["default"].createElement(Tag, _extends({
      ref: slideElRef,
      className: uniqueClasses("" + slideClasses + (className ? " " + className : '')),
      "data-swiper-slide-index": virtualIndex
    }, rest), zoom ? /*#__PURE__*/React__default["default"].createElement("div", {
      className: "swiper-zoom-container",
      "data-swiper-zoom": typeof zoom === 'number' ? zoom : undefined
    }, renderChildren()) : renderChildren());
  });
  SwiperSlide.displayName = 'SwiperSlide';
  var css_248z$4 = "/**\n * Swiper 6.8.4\n * Most modern mobile touch slider and framework with hardware accelerated transitions\n * https://swiperjs.com\n *\n * Copyright 2014-2021 Vladimir Kharlampidi\n *\n * Released under the MIT License\n *\n * Released on: August 23, 2021\n */\n\n@font-face{font-family:swiper-icons;src:url('data:application/font-woff;charset=utf-8;base64, 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') format('woff');font-weight:400;font-style:normal}:root{--swiper-theme-color:#007aff}.swiper-container{margin-left:auto;margin-right:auto;position:relative;overflow:hidden;list-style:none;padding:0;z-index:1}.swiper-container-vertical>.swiper-wrapper{flex-direction:column}.swiper-wrapper{position:relative;width:100%;height:100%;z-index:1;display:flex;transition-property:transform;box-sizing:content-box}.swiper-container-android .swiper-slide,.swiper-wrapper{transform:translate3d(0px,0,0)}.swiper-container-multirow>.swiper-wrapper{flex-wrap:wrap}.swiper-container-multirow-column>.swiper-wrapper{flex-wrap:wrap;flex-direction:column}.swiper-container-free-mode>.swiper-wrapper{transition-timing-function:ease-out;margin:0 auto}.swiper-container-pointer-events{touch-action:pan-y}.swiper-container-pointer-events.swiper-container-vertical{touch-action:pan-x}.swiper-slide{flex-shrink:0;width:100%;height:100%;position:relative;transition-property:transform}.swiper-slide-invisible-blank{visibility:hidden}.swiper-container-autoheight,.swiper-container-autoheight .swiper-slide{height:auto}.swiper-container-autoheight .swiper-wrapper{align-items:flex-start;transition-property:transform,height}.swiper-container-3d{perspective:1200px}.swiper-container-3d .swiper-cube-shadow,.swiper-container-3d .swiper-slide,.swiper-container-3d .swiper-slide-shadow-bottom,.swiper-container-3d .swiper-slide-shadow-left,.swiper-container-3d .swiper-slide-shadow-right,.swiper-container-3d .swiper-slide-shadow-top,.swiper-container-3d .swiper-wrapper{transform-style:preserve-3d}.swiper-container-3d .swiper-slide-shadow-bottom,.swiper-container-3d .swiper-slide-shadow-left,.swiper-container-3d .swiper-slide-shadow-right,.swiper-container-3d .swiper-slide-shadow-top{position:absolute;left:0;top:0;width:100%;height:100%;pointer-events:none;z-index:10}.swiper-container-3d .swiper-slide-shadow-left{background-image:linear-gradient(to left,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-container-3d .swiper-slide-shadow-right{background-image:linear-gradient(to right,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-container-3d .swiper-slide-shadow-top{background-image:linear-gradient(to top,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-container-3d .swiper-slide-shadow-bottom{background-image:linear-gradient(to bottom,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-container-css-mode>.swiper-wrapper{overflow:auto;scrollbar-width:none;-ms-overflow-style:none}.swiper-container-css-mode>.swiper-wrapper::-webkit-scrollbar{display:none}.swiper-container-css-mode>.swiper-wrapper>.swiper-slide{scroll-snap-align:start start}.swiper-container-horizontal.swiper-container-css-mode>.swiper-wrapper{scroll-snap-type:x mandatory}.swiper-container-vertical.swiper-container-css-mode>.swiper-wrapper{scroll-snap-type:y mandatory}:root{--swiper-navigation-size:44px}.swiper-button-next,.swiper-button-prev{position:absolute;top:50%;width:calc(var(--swiper-navigation-size)/ 44 * 27);height:var(--swiper-navigation-size);margin-top:calc(0px - (var(--swiper-navigation-size)/ 2));z-index:10;cursor:pointer;display:flex;align-items:center;justify-content:center;color:var(--swiper-navigation-color,var(--swiper-theme-color))}.swiper-button-next.swiper-button-disabled,.swiper-button-prev.swiper-button-disabled{opacity:.35;cursor:auto;pointer-events:none}.swiper-button-next:after,.swiper-button-prev:after{font-family:swiper-icons;font-size:var(--swiper-navigation-size);text-transform:none!important;letter-spacing:0;text-transform:none;font-variant:initial;line-height:1}.swiper-button-prev,.swiper-container-rtl .swiper-button-next{left:10px;right:auto}.swiper-button-prev:after,.swiper-container-rtl .swiper-button-next:after{content:'prev'}.swiper-button-next,.swiper-container-rtl .swiper-button-prev{right:10px;left:auto}.swiper-button-next:after,.swiper-container-rtl .swiper-button-prev:after{content:'next'}.swiper-button-next.swiper-button-white,.swiper-button-prev.swiper-button-white{--swiper-navigation-color:#ffffff}.swiper-button-next.swiper-button-black,.swiper-button-prev.swiper-button-black{--swiper-navigation-color:#000000}.swiper-button-lock{display:none}.swiper-pagination{position:absolute;text-align:center;transition:.3s opacity;transform:translate3d(0,0,0);z-index:10}.swiper-pagination.swiper-pagination-hidden{opacity:0}.swiper-container-horizontal>.swiper-pagination-bullets,.swiper-pagination-custom,.swiper-pagination-fraction{bottom:10px;left:0;width:100%}.swiper-pagination-bullets-dynamic{overflow:hidden;font-size:0}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transform:scale(.33);position:relative}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active{transform:scale(1)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main{transform:scale(1)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev{transform:scale(.66)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev{transform:scale(.33)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next{transform:scale(.66)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next{transform:scale(.33)}.swiper-pagination-bullet{width:8px;height:8px;display:inline-block;border-radius:50%;background:#000;opacity:.2}button.swiper-pagination-bullet{border:none;margin:0;padding:0;box-shadow:none;-webkit-appearance:none;appearance:none}.swiper-pagination-clickable .swiper-pagination-bullet{cursor:pointer}.swiper-pagination-bullet:only-child{display:none!important}.swiper-pagination-bullet-active{opacity:1;background:var(--swiper-pagination-color,var(--swiper-theme-color))}.swiper-container-vertical>.swiper-pagination-bullets{right:10px;top:50%;transform:translate3d(0px,-50%,0)}.swiper-container-vertical>.swiper-pagination-bullets .swiper-pagination-bullet{margin:6px 0;display:block}.swiper-container-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic{top:50%;transform:translateY(-50%);width:8px}.swiper-container-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{display:inline-block;transition:.2s transform,.2s top}.swiper-container-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet{margin:0 4px}.swiper-container-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic{left:50%;transform:translateX(-50%);white-space:nowrap}.swiper-container-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transition:.2s transform,.2s left}.swiper-container-horizontal.swiper-container-rtl>.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transition:.2s transform,.2s right}.swiper-pagination-progressbar{background:rgba(0,0,0,.25);position:absolute}.swiper-pagination-progressbar .swiper-pagination-progressbar-fill{background:var(--swiper-pagination-color,var(--swiper-theme-color));position:absolute;left:0;top:0;width:100%;height:100%;transform:scale(0);transform-origin:left top}.swiper-container-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill{transform-origin:right top}.swiper-container-horizontal>.swiper-pagination-progressbar,.swiper-container-vertical>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite{width:100%;height:4px;left:0;top:0}.swiper-container-horizontal>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite,.swiper-container-vertical>.swiper-pagination-progressbar{width:4px;height:100%;left:0;top:0}.swiper-pagination-white{--swiper-pagination-color:#ffffff}.swiper-pagination-black{--swiper-pagination-color:#000000}.swiper-pagination-lock{display:none}.swiper-scrollbar{border-radius:10px;position:relative;-ms-touch-action:none;background:rgba(0,0,0,.1)}.swiper-container-horizontal>.swiper-scrollbar{position:absolute;left:1%;bottom:3px;z-index:50;height:5px;width:98%}.swiper-container-vertical>.swiper-scrollbar{position:absolute;right:3px;top:1%;z-index:50;width:5px;height:98%}.swiper-scrollbar-drag{height:100%;width:100%;position:relative;background:rgba(0,0,0,.5);border-radius:10px;left:0;top:0}.swiper-scrollbar-cursor-drag{cursor:move}.swiper-scrollbar-lock{display:none}.swiper-zoom-container{width:100%;height:100%;display:flex;justify-content:center;align-items:center;text-align:center}.swiper-zoom-container>canvas,.swiper-zoom-container>img,.swiper-zoom-container>svg{max-width:100%;max-height:100%;object-fit:contain}.swiper-slide-zoomed{cursor:move}.swiper-lazy-preloader{width:42px;height:42px;position:absolute;left:50%;top:50%;margin-left:-21px;margin-top:-21px;z-index:10;transform-origin:50%;animation:swiper-preloader-spin 1s infinite linear;box-sizing:border-box;border:4px solid var(--swiper-preloader-color,var(--swiper-theme-color));border-radius:50%;border-top-color:transparent}.swiper-lazy-preloader-white{--swiper-preloader-color:#fff}.swiper-lazy-preloader-black{--swiper-preloader-color:#000}@keyframes swiper-preloader-spin{100%{transform:rotate(360deg)}}.swiper-container .swiper-notification{position:absolute;left:0;top:0;pointer-events:none;opacity:0;z-index:-1000}.swiper-container-fade.swiper-container-free-mode .swiper-slide{transition-timing-function:ease-out}.swiper-container-fade .swiper-slide{pointer-events:none;transition-property:opacity}.swiper-container-fade .swiper-slide .swiper-slide{pointer-events:none}.swiper-container-fade .swiper-slide-active,.swiper-container-fade .swiper-slide-active .swiper-slide-active{pointer-events:auto}.swiper-container-cube{overflow:visible}.swiper-container-cube .swiper-slide{pointer-events:none;-webkit-backface-visibility:hidden;backface-visibility:hidden;z-index:1;visibility:hidden;transform-origin:0 0;width:100%;height:100%}.swiper-container-cube .swiper-slide .swiper-slide{pointer-events:none}.swiper-container-cube.swiper-container-rtl .swiper-slide{transform-origin:100% 0}.swiper-container-cube .swiper-slide-active,.swiper-container-cube .swiper-slide-active .swiper-slide-active{pointer-events:auto}.swiper-container-cube .swiper-slide-active,.swiper-container-cube .swiper-slide-next,.swiper-container-cube .swiper-slide-next+.swiper-slide,.swiper-container-cube .swiper-slide-prev{pointer-events:auto;visibility:visible}.swiper-container-cube .swiper-slide-shadow-bottom,.swiper-container-cube .swiper-slide-shadow-left,.swiper-container-cube .swiper-slide-shadow-right,.swiper-container-cube .swiper-slide-shadow-top{z-index:0;-webkit-backface-visibility:hidden;backface-visibility:hidden}.swiper-container-cube .swiper-cube-shadow{position:absolute;left:0;bottom:0px;width:100%;height:100%;opacity:.6;z-index:0}.swiper-container-cube .swiper-cube-shadow:before{content:'';background:#000;position:absolute;left:0;top:0;bottom:0;right:0;filter:blur(50px)}.swiper-container-flip{overflow:visible}.swiper-container-flip .swiper-slide{pointer-events:none;-webkit-backface-visibility:hidden;backface-visibility:hidden;z-index:1}.swiper-container-flip .swiper-slide .swiper-slide{pointer-events:none}.swiper-container-flip .swiper-slide-active,.swiper-container-flip .swiper-slide-active .swiper-slide-active{pointer-events:auto}.swiper-container-flip .swiper-slide-shadow-bottom,.swiper-container-flip .swiper-slide-shadow-left,.swiper-container-flip .swiper-slide-shadow-right,.swiper-container-flip .swiper-slide-shadow-top{z-index:0;-webkit-backface-visibility:hidden;backface-visibility:hidden}\n/*# sourceMappingURL=data:application/json;base64,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 */";
  styleInject(css_248z$4);
  var css_248z$3 = "/**\n * Swiper 6.8.4\n * Most modern mobile touch slider and framework with hardware accelerated transitions\n * https://swiperjs.com\n *\n * Copyright 2014-2021 Vladimir Kharlampidi\n *\n * Released under the MIT License\n *\n * Released on: August 23, 2021\n */\n\n@font-face{font-family:swiper-icons;src:url('data:application/font-woff;charset=utf-8;base64, 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') format('woff');font-weight:400;font-style:normal}:root{--swiper-theme-color:#007aff}.swiper-container{margin-left:auto;margin-right:auto;position:relative;overflow:hidden;list-style:none;padding:0;z-index:1}.swiper-container-vertical>.swiper-wrapper{flex-direction:column}.swiper-wrapper{position:relative;width:100%;height:100%;z-index:1;display:flex;transition-property:transform;box-sizing:content-box}.swiper-container-android .swiper-slide,.swiper-wrapper{transform:translate3d(0px,0,0)}.swiper-container-multirow>.swiper-wrapper{flex-wrap:wrap}.swiper-container-multirow-column>.swiper-wrapper{flex-wrap:wrap;flex-direction:column}.swiper-container-free-mode>.swiper-wrapper{transition-timing-function:ease-out;margin:0 auto}.swiper-container-pointer-events{touch-action:pan-y}.swiper-container-pointer-events.swiper-container-vertical{touch-action:pan-x}.swiper-slide{flex-shrink:0;width:100%;height:100%;position:relative;transition-property:transform}.swiper-slide-invisible-blank{visibility:hidden}.swiper-container-autoheight,.swiper-container-autoheight .swiper-slide{height:auto}.swiper-container-autoheight .swiper-wrapper{align-items:flex-start;transition-property:transform,height}.swiper-container-3d{perspective:1200px}.swiper-container-3d .swiper-cube-shadow,.swiper-container-3d .swiper-slide,.swiper-container-3d .swiper-slide-shadow-bottom,.swiper-container-3d .swiper-slide-shadow-left,.swiper-container-3d .swiper-slide-shadow-right,.swiper-container-3d .swiper-slide-shadow-top,.swiper-container-3d .swiper-wrapper{transform-style:preserve-3d}.swiper-container-3d .swiper-slide-shadow-bottom,.swiper-container-3d .swiper-slide-shadow-left,.swiper-container-3d .swiper-slide-shadow-right,.swiper-container-3d .swiper-slide-shadow-top{position:absolute;left:0;top:0;width:100%;height:100%;pointer-events:none;z-index:10}.swiper-container-3d .swiper-slide-shadow-left{background-image:linear-gradient(to left,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-container-3d .swiper-slide-shadow-right{background-image:linear-gradient(to right,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-container-3d .swiper-slide-shadow-top{background-image:linear-gradient(to top,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-container-3d .swiper-slide-shadow-bottom{background-image:linear-gradient(to bottom,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-container-css-mode>.swiper-wrapper{overflow:auto;scrollbar-width:none;-ms-overflow-style:none}.swiper-container-css-mode>.swiper-wrapper::-webkit-scrollbar{display:none}.swiper-container-css-mode>.swiper-wrapper>.swiper-slide{scroll-snap-align:start start}.swiper-container-horizontal.swiper-container-css-mode>.swiper-wrapper{scroll-snap-type:x mandatory}.swiper-container-vertical.swiper-container-css-mode>.swiper-wrapper{scroll-snap-type:y mandatory}\n/*# sourceMappingURL=data:application/json;base64,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 */";
  styleInject(css_248z$3);
  var css_248z$2 = ".index-module_swiper-container__g0Jzp {\n  width: 100%;\n  height: 100%; }\n\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGV4Lm1vZHVsZS5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsV0FBVztFQUNYLFlBQVksRUFBRSIsImZpbGUiOiJpbmRleC5tb2R1bGUuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIi5zd2lwZXItY29udGFpbmVyIHtcbiAgd2lkdGg6IDEwMCU7XG4gIGhlaWdodDogMTAwJTsgfVxuIl19 */";
  var styles = {
    "swiper-container": "index-module_swiper-container__g0Jzp"
  };
  styleInject(css_248z$2); // install Swiper modules

  SwiperCore.use([Navigation$1, Pagination$1]);

  var Carousel = function Carousel(props) {
    var className = props.className,
        children = props.children,
        otherProps = __rest$1(props, ["className", "children"]);

    var dataAttributes = generateComponentDataAttributes('Carousel', className, styles['swiper-container']);
    return React__default["default"].createElement(Swiper, _assign2({}, dataAttributes, otherProps), children && React__default["default"].Children.map(children, function (child) {
      return React__default["default"].createElement(SwiperSlide, _assign2({}, child.props), React__default["default"].cloneElement(child));
    }));
  };

  var defaultProps = {
    autoHeight: false,
    centeredSlides: false,
    centeredSlidesBounds: false,
    direction: 'horizontal',
    effect: 'slide',
    enabled: true,
    grabCursor: false,
    initialSlide: 0,
    loop: false,
    loopedSlides: 0,
    slidesOffsetAfter: 0,
    slidesOffsetBefore: 0,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerView: 1,
    spaceBetween: 0
  };
  Carousel.defaultProps = defaultProps;

  var Slide = function Slide(props) {
    var children = props.children;
    return React__namespace.createElement(React__namespace.Fragment, null, children && React__namespace.Children.map(children, function (child) {
      return React__namespace.createElement(React__namespace.Fragment, null, child);
    }));
  };

  var useScrollTrigger = function useScrollTrigger(options) {
    if (options === void 0) {
      options = {};
    }

    return useScrollTrigger$1(options);
  };

  var ElevationScroll = function ElevationScroll(_a) {
    var children = _a.children,
        elevation = _a.elevation,
        disableHysteresis = _a.disableHysteresis,
        threshold = _a.threshold,
        providedTrigger = _a.trigger;
    var defaultTrigger = useScrollTrigger({
      disableHysteresis: disableHysteresis,
      threshold: threshold
    });
    var trigger = providedTrigger || defaultTrigger;
    return React__namespace.cloneElement(children, {
      elevation: trigger ? elevation : 0
    });
  };

  var Paper = function Paper(props) {
    var className = props.className,
        otherProps = __rest$1(props, ["className"]);

    var dataAttributes = generateComponentDataAttributes('Paper', className);
    return React__default["default"].createElement(BasePaper, _assign2({}, dataAttributes, otherProps));
  };

  var Toolbar = function Toolbar(props) {
    var className = props.className,
        otherProps = __rest$1(props, ["className"]);

    var dataAttributes = generateComponentDataAttributes('Toolbar', className);
    return React__namespace.createElement(BaseToolbar, _assign2({}, dataAttributes, otherProps));
  };

  var CSSBaseline = function CSSBaseline(props) {
    return React__namespace.createElement(CssBaseline, _assign2({}, props));
  };

  var Popover = function Popover(props) {
    var className = props.className,
        otherProps = __rest$1(props, ["className"]);

    var dataAttributes = generateComponentDataAttributes('Popover', className);
    return React__namespace.createElement(BasePopover, _assign2({}, dataAttributes, otherProps));
  };

  var Popper = function Popper(props) {
    return React__namespace.createElement(BasePopper, _assign2({}, props));
  };

  var StylesProvider = function StylesProvider(props) {
    var children = props.children,
        otherProps = __rest$1(props, ["children"]);

    return React__default["default"].createElement(StyledEngineProvider, _assign2({
      injectFirst: true
    }, otherProps), children);
  };

  var css_248z$1 = "/* OVERRIDES */\n/* Colors\n------------------------------------------------------------------------------------------------ */\n/*\n  Why import 'theme/variables' after the theme overrides?\n  Because the first variable with !default is used. The second variable with the same name with !default will not change the value.\n*/\n@import url(\"https://fonts.googleapis.com/css2?family=Nunito:wght@400;700&display=swap\");\n/**\n * Convert a hex color to an RGB string\n *\n * @param {string} - Hex color\n * @returns {string} - RGB string of the hex color\n */\n/**\n * The material-ui-color package, needs CssBasline implement to fix a few defaults, box-sizing\n * being one of them. We don't necessarily want that, so create a small global style here to fix\n * the padding on the sliders pushing out the layout. Needs to be a global so we can target the\n * sliders that are in the Popover\n */\n/* stylelint-disable selector-class-pattern */\n@import url(\"https://fonts.googleapis.com/css2?family=Nunito:wght@400;700&display=swap\");\n.muicc-colorbox-sliders {\n  box-sizing: border-box; }\n\n/* stylelint-enable selector-class-pattern */\n/**\n * Convert a hex color to an RGB string\n *\n * @param {string} - Hex color\n * @returns {string} - RGB string of the hex color\n */\n/**\n * The material-ui-color package, needs CssBasline implement to fix a few defaults, box-sizing\n * being one of them. We don't necessarily want that, so create a small global style here to fix\n * the padding on the sliders pushing out the layout. Needs to be a global so we can target the\n * sliders that are in the Popover\n */\n/* stylelint-disable selector-class-pattern */\n.muicc-colorbox-sliders {\n  box-sizing: border-box; }\n\n/* stylelint-enable selector-class-pattern */\n/* SCSS VARIABLES */\n/* Colors\n------------------------------------------------------------------------------------------------ */\n:root {\n  --color--common--black: #000;\n  --color--common--white: #fff;\n  --color--primary--main: #3dd467;\n  --color--primary--light: #67dd88;\n  --color--primary--dark: #28b650;\n  --color--primary--contrast-text: #000;\n  --color--primary--main--rgb: 61,212,103;\n  --color--primary--light--rgb: 103,221,136;\n  --color--primary--dark--rgb: 40,182,80;\n  --color--secondary--main: #00b98a;\n  --color--secondary--light: #00ecb0;\n  --color--secondary--dark: #008664;\n  --color--secondary--contrast-text: #000;\n  --color--secondary--main--rgb: 0,185,138;\n  --color--secondary--light--rgb: 0,236,176;\n  --color--secondary--dark--rgb: 0,236,176;\n  --color--error--main: #eb4d5c;\n  --color--error--light: #f07b86;\n  --color--error--dark: #e61f32;\n  --color--error--contrast-text: #fff;\n  --color--error--main--rgb: 235,77,92;\n  --color--error--light--rgb: 240,123,134;\n  --color--error--dark--rgb: 240,123,134;\n  --color--warning--main: #ff9800;\n  --color--warning--light: #ffad33;\n  --color--warning--dark: #cc7a00;\n  --color--warning--contrast-text: rgba(0, 0, 0, 0.87);\n  --color--warning--main--rgb: 255,152,0;\n  --color--warning--light--rgb: 255,173,51;\n  --color--warning--dark--rgb: 255,173,51;\n  --color--info--main: #2196f3;\n  --color--info--light: #51adf6;\n  --color--info--dark: #0c7cd5;\n  --color--info--contrast-text: #fff;\n  --color--info--main--rgb: 33,150,243;\n  --color--info--light--rgb: 81,173,246;\n  --color--info--dark--rgb: 81,173,246;\n  --color--success--main: #4caf50;\n  --color--success--light: #6ec071;\n  --color--success--dark: #3d8b40;\n  --color--success--contrast-text: rgba(0, 0, 0, 0.87);\n  --color--success--main--rgb: 76,175,80;\n  --color--success--light--rgb: 110,192,113;\n  --color--success--dark--rgb: 110,192,113;\n  --color--grey--50: #fafafa;\n  --color--grey--100: #f5f5f5;\n  --color--grey--200: #eee;\n  --color--grey--300: #e0e0e0;\n  --color--grey--400: #bdbdbd;\n  --color--grey--500: #9e9e9e;\n  --color--grey--600: #757575;\n  --color--grey--700: #616161;\n  --color--grey--800: #424242;\n  --color--grey--900: #212121;\n  --color--grey--A100: #d5d5d5;\n  --color--grey--A200: #aaa;\n  --color--grey--A400: #303030;\n  --color--grey--A700: #616161;\n  --color--text--primary: #fff;\n  --color--text--secondary: rgba(255, 255, 255, 0.7);\n  --color--text--disabled: rgba(255, 255, 255, 0.5);\n  --color--text--hint: rgba(0, 0, 0, 0.38);\n  --color--divider: rgba(255, 255, 255, 0.12);\n  --color--background--paper: #191823;\n  --color--background--default: #13111b;\n  --color--action--active: #fff;\n  --color--action--hover: rgba(255, 255, 255, 0.08);\n  --color--action--selected: rgba(255, 255, 255, 0.16);\n  --color--action--disabled: rgba(255, 255, 255, 0.3);\n  --color--action--disabledBackground: rgba(255, 255, 255, 0.12);\n  --color--action--focus: rgba(0, 0, 0, 0.12); }\n\n/* CSS IN JS */\n\n/* Typography\n------------------------------------------------------------------------------------------------ */\n:root {\n  --font--family--h1: Nunito, Roboto, Helvetica, Arial, sans-serif;\n  --font--weight--h1: 300;\n  --font--size--h1: 6rem;\n  --font--lineHeight--h1: 1.167;\n  --font--letterSpacing--h1: -0.01562em;\n  --font--family--h2: Nunito, Roboto, Helvetica, Arial, sans-serif;\n  --font--weight--h2: 300;\n  --font--size--h2: 3.75rem;\n  --font--lineHeight--h2: 1.2;\n  --font--letterSpacing--h2: -0.00833em;\n  --font--family--h3: Nunito, Roboto, Helvetica, Arial, sans-serif;\n  --font--weight--h3: 400;\n  --font--size--h3: 3rem;\n  --font--lineHeight--h3: 1.167;\n  --font--letterSpacing--h3: 0;\n  --font--family--h4: Nunito, Roboto, Helvetica, Arial, sans-serif;\n  --font--weight--h4: 400;\n  --font--size--h4: 2.125rem;\n  --font--lineHeight--h4: 1.235;\n  --font--letterSpacing--h4: 0.00735em;\n  --font--family--h5: Nunito, Roboto, Helvetica, Arial, sans-serif;\n  --font--weight--h5: 400;\n  --font--size--h5: 1.5rem;\n  --font--lineHeight--h5: 1.334;\n  --font--letterSpacing--h5: 0;\n  --font--family--h6: Nunito, Roboto, Helvetica, Arial, sans-serif;\n  --font--weight--h6: 500;\n  --font--size--h6: 1.25rem;\n  --font--lineHeight--h6: 1.6;\n  --font--letterSpacing--h6: 0.0075em;\n  --font--family--subtitle1: Nunito, Roboto, Helvetica, Arial, sans-serif;\n  --font--weight--subtitle1: 400;\n  --font--size--subtitle1: 1rem;\n  --font--lineHeight--subtitle1: 1.75;\n  --font--letterSpacing--subtitle1: 0.00938em;\n  --font--family--subtitle2: Nunito, Roboto, Helvetica, Arial, sans-serif;\n  --font--weight--subtitle2: 500;\n  --font--size--subtitle2: 0.875rem;\n  --font--lineHeight--subtitle2: 1.57;\n  --font--letterSpacing--subtitle2: 0.00714em;\n  --font--family--body1: Nunito, Roboto, Helvetica, Arial, sans-serif;\n  --font--weight--body1: 400;\n  --font--size--body1: 1rem;\n  --font--lineHeight--body1: 1.5;\n  --font--letterSpacing--body1: 0.00938em;\n  --font--family--body2: Nunito, Roboto, Helvetica, Arial, sans-serif;\n  --font--weight--body2: 400;\n  --font--size--body2: 0.875rem;\n  --font--lineHeight--body2: 1.43;\n  --font--letterSpacing--body2: 0.01071em;\n  --font--family--button: Nunito, Roboto, Helvetica, Arial, sans-serif;\n  --font--weight--button: 700;\n  --font--size--button: 0.875rem;\n  --font--lineHeight--button: 1.75;\n  --font--letterSpacing--button: 0.02857em;\n  --font--textTransform--button: capitalize;\n  --font--family--caption: Nunito, Roboto, Helvetica, Arial, sans-serif;\n  --font--weight--caption: 400;\n  --font--size--caption: 0.75rem;\n  --font--lineHeight--caption: 1.66;\n  --font--letterSpacing--caption: 0.03333em;\n  --font--family--overline: Nunito, Roboto, Helvetica, Arial, sans-serif;\n  --font--weight--overline: 400;\n  --font--size--overline: 0.75rem;\n  --font--lineHeight--overline: 2.66;\n  --font--letterSpacing--overline: 0.08333em;\n  --font--textTransform--overline: uppercase; }\n\n/* CSS IN JS */\n\n/* CSS VARIABLES */\n:root {\n  --padding-grid: 8px; }\n\n/* CSS IN JS */\n\n/* SCSS VARIABLES */\n/* Colors\n------------------------------------------------------------------------------------------------ */\n/* Breakpoints\n------------------------------------------------------------------------------------------------ */\n/* Padding/Margins\n------------------------------------------------------------------------------------------------ */\n/* Border\n------------------------------------------------------------------------------------------------ */\n/* CSS VARIABLES */\n:root {\n  --color--button: rgba(0, 0, 0, 0.87);\n  /* Breakpoints\n  ------------------------------------------------------------------------------------------------ */\n  --breakpoints-xs: 0;\n  --breakpoints-sm: 600px;\n  --breakpoints-md: 960px;\n  --breakpoints-lg: 1280px;\n  --breakpoints-xl: 1920px;\n  /* Padding/Margins\n  ------------------------------------------------------------------------------------------------ */\n  --padding-grid: 8px;\n  --padding-base-vertical: 7px;\n  --padding-base-horizontal: 13px;\n  --padding-large-vertical: 10px;\n  --padding-large-horizontal: 19px;\n  --padding-small-vertical: 5px;\n  --padding-small-horizontal: 8px;\n  --padding-xs-vertical: 1px;\n  --padding-xs-horizontal: 5px;\n  --padding-xl-vertical: 15px;\n  --padding-xl-horizontal: 23px;\n  --padding-button-xl-text: 10px 14px;\n  --padding-button-xl-outlined: 9px 27px;\n  --padding-button-xl-contained: 10px 28px;\n  /* Border\n  ------------------------------------------------------------------------------------------------ */\n  --border-radius-base: 4px;\n  --border-radius-large: 6px;\n  --border-radius-small: 3px; }\n\n/* CSS IN JS */\n\n/* CSS VARIABLES */\n.DarkThemeContainer-module_dark__qR6Eb {\n  --color--primary--contrast-text: #000;\n  --color--secondary--contrast-text: #000;\n  --color--text--primary: #fff;\n  --color--text--secondary: rgba(255, 255, 255, 0.7);\n  --color--text--disabled: rgba(255, 255, 255, 0.5);\n  --color--divider: rgba(255, 255, 255, 0.12);\n  --color--background--paper: #191823;\n  --color--background--default: #13111b;\n  --color--action--active: #fff;\n  --color--action--hover: rgba(255, 255, 255, 0.08);\n  --color--action--selected: rgba(255, 255, 255, 0.16);\n  --color--action--disabled: rgba(255, 255, 255, 0.3);\n  --color--action--disabledBackground: rgba(255, 255, 255, 0.12);\n  --color--button: rgba(0, 0, 0, 0.87); }\n\n/* CSS IN JS */\n\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkRhcmtUaGVtZUNvbnRhaW5lci5tb2R1bGUuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxjQUFjO0FBQ2Q7a0dBQ2tHO0FBQ2xHOzs7Q0FHQztBQUNELHdGQUF3RjtBQUN4Rjs7Ozs7RUFLRTtBQUNGOzs7OztFQUtFO0FBQ0YsNkNBQTZDO0FBQzdDLHdGQUF3RjtBQUN4RjtFQUNFLHNCQUFzQixFQUFFOztBQUUxQiw0Q0FBNEM7QUFDNUM7Ozs7O0VBS0U7QUFDRjs7Ozs7RUFLRTtBQUNGLDZDQUE2QztBQUM3QztFQUNFLHNCQUFzQixFQUFFOztBQUUxQiw0Q0FBNEM7QUFDNUMsbUJBQW1CO0FBQ25CO2tHQUNrRztBQUNsRztFQUNFLDRCQUE0QjtFQUM1Qiw0QkFBNEI7RUFDNUIsK0JBQStCO0VBQy9CLGdDQUFnQztFQUNoQywrQkFBK0I7RUFDL0IscUNBQXFDO0VBQ3JDLHVDQUF1QztFQUN2Qyx5Q0FBeUM7RUFDekMsc0NBQXNDO0VBQ3RDLGlDQUFpQztFQUNqQyxrQ0FBa0M7RUFDbEMsaUNBQWlDO0VBQ2pDLHVDQUF1QztFQUN2Qyx3Q0FBd0M7RUFDeEMseUNBQXlDO0VBQ3pDLHdDQUF3QztFQUN4Qyw2QkFBNkI7RUFDN0IsOEJBQThCO0VBQzlCLDZCQUE2QjtFQUM3QixtQ0FBbUM7RUFDbkMsb0NBQW9DO0VBQ3BDLHVDQUF1QztFQUN2QyxzQ0FBc0M7RUFDdEMsK0JBQStCO0VBQy9CLGdDQUFnQztFQUNoQywrQkFBK0I7RUFDL0Isb0RBQW9EO0VBQ3BELHNDQUFzQztFQUN0Qyx3Q0FBd0M7RUFDeEMsdUNBQXVDO0VBQ3ZDLDRCQUE0QjtFQUM1Qiw2QkFBNkI7RUFDN0IsNEJBQTRCO0VBQzVCLGtDQUFrQztFQUNsQyxvQ0FBb0M7RUFDcEMscUNBQXFDO0VBQ3JDLG9DQUFvQztFQUNwQywrQkFBK0I7RUFDL0IsZ0NBQWdDO0VBQ2hDLCtCQUErQjtFQUMvQixvREFBb0Q7RUFDcEQsc0NBQXNDO0VBQ3RDLHlDQUF5QztFQUN6Qyx3Q0FBd0M7RUFDeEMsMEJBQTBCO0VBQzFCLDJCQUEyQjtFQUMzQix3QkFBd0I7RUFDeEIsMkJBQTJCO0VBQzNCLDJCQUEyQjtFQUMzQiwyQkFBMkI7RUFDM0IsMkJBQTJCO0VBQzNCLDJCQUEyQjtFQUMzQiwyQkFBMkI7RUFDM0IsMkJBQTJCO0VBQzNCLDRCQUE0QjtFQUM1Qix5QkFBeUI7RUFDekIsNEJBQTRCO0VBQzVCLDRCQUE0QjtFQUM1Qiw0QkFBNEI7RUFDNUIsa0RBQWtEO0VBQ2xELGlEQUFpRDtFQUNqRCx3Q0FBd0M7RUFDeEMsMkNBQTJDO0VBQzNDLG1DQUFtQztFQUNuQyxxQ0FBcUM7RUFDckMsNkJBQTZCO0VBQzdCLGlEQUFpRDtFQUNqRCxvREFBb0Q7RUFDcEQsbURBQW1EO0VBQ25ELDhEQUE4RDtFQUM5RCwyQ0FBMkMsRUFBRTs7QUFFL0MsY0FBYzs7QUF3RGQ7a0dBQ2tHO0FBQ2xHO0VBQ0UsZ0VBQWdFO0VBQ2hFLHVCQUF1QjtFQUN2QixzQkFBc0I7RUFDdEIsNkJBQTZCO0VBQzdCLHFDQUFxQztFQUNyQyxnRUFBZ0U7RUFDaEUsdUJBQXVCO0VBQ3ZCLHlCQUF5QjtFQUN6QiwyQkFBMkI7RUFDM0IscUNBQXFDO0VBQ3JDLGdFQUFnRTtFQUNoRSx1QkFBdUI7RUFDdkIsc0JBQXNCO0VBQ3RCLDZCQUE2QjtFQUM3Qiw0QkFBNEI7RUFDNUIsZ0VBQWdFO0VBQ2hFLHVCQUF1QjtFQUN2QiwwQkFBMEI7RUFDMUIsNkJBQTZCO0VBQzdCLG9DQUFvQztFQUNwQyxnRUFBZ0U7RUFDaEUsdUJBQXVCO0VBQ3ZCLHdCQUF3QjtFQUN4Qiw2QkFBNkI7RUFDN0IsNEJBQTRCO0VBQzVCLGdFQUFnRTtFQUNoRSx1QkFBdUI7RUFDdkIseUJBQXlCO0VBQ3pCLDJCQUEyQjtFQUMzQixtQ0FBbUM7RUFDbkMsdUVBQXVFO0VBQ3ZFLDhCQUE4QjtFQUM5Qiw2QkFBNkI7RUFDN0IsbUNBQW1DO0VBQ25DLDJDQUEyQztFQUMzQyx1RUFBdUU7RUFDdkUsOEJBQThCO0VBQzlCLGlDQUFpQztFQUNqQyxtQ0FBbUM7RUFDbkMsMkNBQTJDO0VBQzNDLG1FQUFtRTtFQUNuRSwwQkFBMEI7RUFDMUIseUJBQXlCO0VBQ3pCLDhCQUE4QjtFQUM5Qix1Q0FBdUM7RUFDdkMsbUVBQW1FO0VBQ25FLDBCQUEwQjtFQUMxQiw2QkFBNkI7RUFDN0IsK0JBQStCO0VBQy9CLHVDQUF1QztFQUN2QyxvRUFBb0U7RUFDcEUsMkJBQTJCO0VBQzNCLDhCQUE4QjtFQUM5QixnQ0FBZ0M7RUFDaEMsd0NBQXdDO0VBQ3hDLHlDQUF5QztFQUN6QyxxRUFBcUU7RUFDckUsNEJBQTRCO0VBQzVCLDhCQUE4QjtFQUM5QixpQ0FBaUM7RUFDakMseUNBQXlDO0VBQ3pDLHNFQUFzRTtFQUN0RSw2QkFBNkI7RUFDN0IsK0JBQStCO0VBQy9CLGtDQUFrQztFQUNsQywwQ0FBMEM7RUFDMUMsMENBQTBDLEVBQUU7O0FBRTlDLGNBQWM7O0FBc0VkLGtCQUFrQjtBQUNsQjtFQUNFLG1CQUFtQixFQUFFOztBQUV2QixjQUFjOztBQUlkLG1CQUFtQjtBQUNuQjtrR0FDa0c7QUFDbEc7a0dBQ2tHO0FBQ2xHO2tHQUNrRztBQUNsRztrR0FDa0c7QUFDbEcsa0JBQWtCO0FBQ2xCO0VBQ0Usb0NBQW9DO0VBQ3BDO29HQUNrRztFQUNsRyxtQkFBbUI7RUFDbkIsdUJBQXVCO0VBQ3ZCLHVCQUF1QjtFQUN2Qix3QkFBd0I7RUFDeEIsd0JBQXdCO0VBQ3hCO29HQUNrRztFQUNsRyxtQkFBbUI7RUFDbkIsNEJBQTRCO0VBQzVCLCtCQUErQjtFQUMvQiw4QkFBOEI7RUFDOUIsZ0NBQWdDO0VBQ2hDLDZCQUE2QjtFQUM3QiwrQkFBK0I7RUFDL0IsMEJBQTBCO0VBQzFCLDRCQUE0QjtFQUM1QiwyQkFBMkI7RUFDM0IsNkJBQTZCO0VBQzdCLG1DQUFtQztFQUNuQyxzQ0FBc0M7RUFDdEMsd0NBQXdDO0VBQ3hDO29HQUNrRztFQUNsRyx5QkFBeUI7RUFDekIsMEJBQTBCO0VBQzFCLDBCQUEwQixFQUFFOztBQUU5QixjQUFjOztBQXFCZCxrQkFBa0I7QUFDbEI7RUFDRSxxQ0FBcUM7RUFDckMsdUNBQXVDO0VBQ3ZDLDRCQUE0QjtFQUM1QixrREFBa0Q7RUFDbEQsaURBQWlEO0VBQ2pELDJDQUEyQztFQUMzQyxtQ0FBbUM7RUFDbkMscUNBQXFDO0VBQ3JDLDZCQUE2QjtFQUM3QixpREFBaUQ7RUFDakQsb0RBQW9EO0VBQ3BELG1EQUFtRDtFQUNuRCw4REFBOEQ7RUFDOUQsb0NBQW9DLEVBQUU7O0FBRXhDLGNBQWMiLCJmaWxlIjoiRGFya1RoZW1lQ29udGFpbmVyLm1vZHVsZS5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLyogT1ZFUlJJREVTICovXG4vKiBDb2xvcnNcbi0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLSAqL1xuLypcbiAgV2h5IGltcG9ydCAndGhlbWUvdmFyaWFibGVzJyBhZnRlciB0aGUgdGhlbWUgb3ZlcnJpZGVzP1xuICBCZWNhdXNlIHRoZSBmaXJzdCB2YXJpYWJsZSB3aXRoICFkZWZhdWx0IGlzIHVzZWQuIFRoZSBzZWNvbmQgdmFyaWFibGUgd2l0aCB0aGUgc2FtZSBuYW1lIHdpdGggIWRlZmF1bHQgd2lsbCBub3QgY2hhbmdlIHRoZSB2YWx1ZS5cbiovXG5AaW1wb3J0IHVybChcImh0dHBzOi8vZm9udHMuZ29vZ2xlYXBpcy5jb20vY3NzMj9mYW1pbHk9TnVuaXRvOndnaHRANDAwOzcwMCZkaXNwbGF5PXN3YXBcIik7XG4vKipcbiAqIENvbnZlcnQgYSBoZXggY29sb3IgdG8gYW4gUkdCIHN0cmluZ1xuICpcbiAqIEBwYXJhbSB7c3RyaW5nfSAtIEhleCBjb2xvclxuICogQHJldHVybnMge3N0cmluZ30gLSBSR0Igc3RyaW5nIG9mIHRoZSBoZXggY29sb3JcbiAqL1xuLyoqXG4gKiBUaGUgbWF0ZXJpYWwtdWktY29sb3IgcGFja2FnZSwgbmVlZHMgQ3NzQmFzbGluZSBpbXBsZW1lbnQgdG8gZml4IGEgZmV3IGRlZmF1bHRzLCBib3gtc2l6aW5nXG4gKiBiZWluZyBvbmUgb2YgdGhlbS4gV2UgZG9uJ3QgbmVjZXNzYXJpbHkgd2FudCB0aGF0LCBzbyBjcmVhdGUgYSBzbWFsbCBnbG9iYWwgc3R5bGUgaGVyZSB0byBmaXhcbiAqIHRoZSBwYWRkaW5nIG9uIHRoZSBzbGlkZXJzIHB1c2hpbmcgb3V0IHRoZSBsYXlvdXQuIE5lZWRzIHRvIGJlIGEgZ2xvYmFsIHNvIHdlIGNhbiB0YXJnZXQgdGhlXG4gKiBzbGlkZXJzIHRoYXQgYXJlIGluIHRoZSBQb3BvdmVyXG4gKi9cbi8qIHN0eWxlbGludC1kaXNhYmxlIHNlbGVjdG9yLWNsYXNzLXBhdHRlcm4gKi9cbkBpbXBvcnQgdXJsKFwiaHR0cHM6Ly9mb250cy5nb29nbGVhcGlzLmNvbS9jc3MyP2ZhbWlseT1OdW5pdG86d2dodEA0MDA7NzAwJmRpc3BsYXk9c3dhcFwiKTtcbjpnbG9iYWwoLm11aWNjLWNvbG9yYm94LXNsaWRlcnMpIHtcbiAgYm94LXNpemluZzogYm9yZGVyLWJveDsgfVxuXG4vKiBzdHlsZWxpbnQtZW5hYmxlIHNlbGVjdG9yLWNsYXNzLXBhdHRlcm4gKi9cbi8qKlxuICogQ29udmVydCBhIGhleCBjb2xvciB0byBhbiBSR0Igc3RyaW5nXG4gKlxuICogQHBhcmFtIHtzdHJpbmd9IC0gSGV4IGNvbG9yXG4gKiBAcmV0dXJucyB7c3RyaW5nfSAtIFJHQiBzdHJpbmcgb2YgdGhlIGhleCBjb2xvclxuICovXG4vKipcbiAqIFRoZSBtYXRlcmlhbC11aS1jb2xvciBwYWNrYWdlLCBuZWVkcyBDc3NCYXNsaW5lIGltcGxlbWVudCB0byBmaXggYSBmZXcgZGVmYXVsdHMsIGJveC1zaXppbmdcbiAqIGJlaW5nIG9uZSBvZiB0aGVtLiBXZSBkb24ndCBuZWNlc3NhcmlseSB3YW50IHRoYXQsIHNvIGNyZWF0ZSBhIHNtYWxsIGdsb2JhbCBzdHlsZSBoZXJlIHRvIGZpeFxuICogdGhlIHBhZGRpbmcgb24gdGhlIHNsaWRlcnMgcHVzaGluZyBvdXQgdGhlIGxheW91dC4gTmVlZHMgdG8gYmUgYSBnbG9iYWwgc28gd2UgY2FuIHRhcmdldCB0aGVcbiAqIHNsaWRlcnMgdGhhdCBhcmUgaW4gdGhlIFBvcG92ZXJcbiAqL1xuLyogc3R5bGVsaW50LWRpc2FibGUgc2VsZWN0b3ItY2xhc3MtcGF0dGVybiAqL1xuOmdsb2JhbCgubXVpY2MtY29sb3Jib3gtc2xpZGVycykge1xuICBib3gtc2l6aW5nOiBib3JkZXItYm94OyB9XG5cbi8qIHN0eWxlbGludC1lbmFibGUgc2VsZWN0b3ItY2xhc3MtcGF0dGVybiAqL1xuLyogU0NTUyBWQVJJQUJMRVMgKi9cbi8qIENvbG9yc1xuLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tICovXG46cm9vdCB7XG4gIC0tY29sb3ItLWNvbW1vbi0tYmxhY2s6ICMwMDA7XG4gIC0tY29sb3ItLWNvbW1vbi0td2hpdGU6ICNmZmY7XG4gIC0tY29sb3ItLXByaW1hcnktLW1haW46ICMzZGQ0Njc7XG4gIC0tY29sb3ItLXByaW1hcnktLWxpZ2h0OiAjNjdkZDg4O1xuICAtLWNvbG9yLS1wcmltYXJ5LS1kYXJrOiAjMjhiNjUwO1xuICAtLWNvbG9yLS1wcmltYXJ5LS1jb250cmFzdC10ZXh0OiAjMDAwO1xuICAtLWNvbG9yLS1wcmltYXJ5LS1tYWluLS1yZ2I6IDYxLDIxMiwxMDM7XG4gIC0tY29sb3ItLXByaW1hcnktLWxpZ2h0LS1yZ2I6IDEwMywyMjEsMTM2O1xuICAtLWNvbG9yLS1wcmltYXJ5LS1kYXJrLS1yZ2I6IDQwLDE4Miw4MDtcbiAgLS1jb2xvci0tc2Vjb25kYXJ5LS1tYWluOiAjMDBiOThhO1xuICAtLWNvbG9yLS1zZWNvbmRhcnktLWxpZ2h0OiAjMDBlY2IwO1xuICAtLWNvbG9yLS1zZWNvbmRhcnktLWRhcms6ICMwMDg2NjQ7XG4gIC0tY29sb3ItLXNlY29uZGFyeS0tY29udHJhc3QtdGV4dDogIzAwMDtcbiAgLS1jb2xvci0tc2Vjb25kYXJ5LS1tYWluLS1yZ2I6IDAsMTg1LDEzODtcbiAgLS1jb2xvci0tc2Vjb25kYXJ5LS1saWdodC0tcmdiOiAwLDIzNiwxNzY7XG4gIC0tY29sb3ItLXNlY29uZGFyeS0tZGFyay0tcmdiOiAwLDIzNiwxNzY7XG4gIC0tY29sb3ItLWVycm9yLS1tYWluOiAjZWI0ZDVjO1xuICAtLWNvbG9yLS1lcnJvci0tbGlnaHQ6ICNmMDdiODY7XG4gIC0tY29sb3ItLWVycm9yLS1kYXJrOiAjZTYxZjMyO1xuICAtLWNvbG9yLS1lcnJvci0tY29udHJhc3QtdGV4dDogI2ZmZjtcbiAgLS1jb2xvci0tZXJyb3ItLW1haW4tLXJnYjogMjM1LDc3LDkyO1xuICAtLWNvbG9yLS1lcnJvci0tbGlnaHQtLXJnYjogMjQwLDEyMywxMzQ7XG4gIC0tY29sb3ItLWVycm9yLS1kYXJrLS1yZ2I6IDI0MCwxMjMsMTM0O1xuICAtLWNvbG9yLS13YXJuaW5nLS1tYWluOiAjZmY5ODAwO1xuICAtLWNvbG9yLS13YXJuaW5nLS1saWdodDogI2ZmYWQzMztcbiAgLS1jb2xvci0td2FybmluZy0tZGFyazogI2NjN2EwMDtcbiAgLS1jb2xvci0td2FybmluZy0tY29udHJhc3QtdGV4dDogcmdiYSgwLCAwLCAwLCAwLjg3KTtcbiAgLS1jb2xvci0td2FybmluZy0tbWFpbi0tcmdiOiAyNTUsMTUyLDA7XG4gIC0tY29sb3ItLXdhcm5pbmctLWxpZ2h0LS1yZ2I6IDI1NSwxNzMsNTE7XG4gIC0tY29sb3ItLXdhcm5pbmctLWRhcmstLXJnYjogMjU1LDE3Myw1MTtcbiAgLS1jb2xvci0taW5mby0tbWFpbjogIzIxOTZmMztcbiAgLS1jb2xvci0taW5mby0tbGlnaHQ6ICM1MWFkZjY7XG4gIC0tY29sb3ItLWluZm8tLWRhcms6ICMwYzdjZDU7XG4gIC0tY29sb3ItLWluZm8tLWNvbnRyYXN0LXRleHQ6ICNmZmY7XG4gIC0tY29sb3ItLWluZm8tLW1haW4tLXJnYjogMzMsMTUwLDI0MztcbiAgLS1jb2xvci0taW5mby0tbGlnaHQtLXJnYjogODEsMTczLDI0NjtcbiAgLS1jb2xvci0taW5mby0tZGFyay0tcmdiOiA4MSwxNzMsMjQ2O1xuICAtLWNvbG9yLS1zdWNjZXNzLS1tYWluOiAjNGNhZjUwO1xuICAtLWNvbG9yLS1zdWNjZXNzLS1saWdodDogIzZlYzA3MTtcbiAgLS1jb2xvci0tc3VjY2Vzcy0tZGFyazogIzNkOGI0MDtcbiAgLS1jb2xvci0tc3VjY2Vzcy0tY29udHJhc3QtdGV4dDogcmdiYSgwLCAwLCAwLCAwLjg3KTtcbiAgLS1jb2xvci0tc3VjY2Vzcy0tbWFpbi0tcmdiOiA3NiwxNzUsODA7XG4gIC0tY29sb3ItLXN1Y2Nlc3MtLWxpZ2h0LS1yZ2I6IDExMCwxOTIsMTEzO1xuICAtLWNvbG9yLS1zdWNjZXNzLS1kYXJrLS1yZ2I6IDExMCwxOTIsMTEzO1xuICAtLWNvbG9yLS1ncmV5LS01MDogI2ZhZmFmYTtcbiAgLS1jb2xvci0tZ3JleS0tMTAwOiAjZjVmNWY1O1xuICAtLWNvbG9yLS1ncmV5LS0yMDA6ICNlZWU7XG4gIC0tY29sb3ItLWdyZXktLTMwMDogI2UwZTBlMDtcbiAgLS1jb2xvci0tZ3JleS0tNDAwOiAjYmRiZGJkO1xuICAtLWNvbG9yLS1ncmV5LS01MDA6ICM5ZTllOWU7XG4gIC0tY29sb3ItLWdyZXktLTYwMDogIzc1NzU3NTtcbiAgLS1jb2xvci0tZ3JleS0tNzAwOiAjNjE2MTYxO1xuICAtLWNvbG9yLS1ncmV5LS04MDA6ICM0MjQyNDI7XG4gIC0tY29sb3ItLWdyZXktLTkwMDogIzIxMjEyMTtcbiAgLS1jb2xvci0tZ3JleS0tQTEwMDogI2Q1ZDVkNTtcbiAgLS1jb2xvci0tZ3JleS0tQTIwMDogI2FhYTtcbiAgLS1jb2xvci0tZ3JleS0tQTQwMDogIzMwMzAzMDtcbiAgLS1jb2xvci0tZ3JleS0tQTcwMDogIzYxNjE2MTtcbiAgLS1jb2xvci0tdGV4dC0tcHJpbWFyeTogI2ZmZjtcbiAgLS1jb2xvci0tdGV4dC0tc2Vjb25kYXJ5OiByZ2JhKDI1NSwgMjU1LCAyNTUsIDAuNyk7XG4gIC0tY29sb3ItLXRleHQtLWRpc2FibGVkOiByZ2JhKDI1NSwgMjU1LCAyNTUsIDAuNSk7XG4gIC0tY29sb3ItLXRleHQtLWhpbnQ6IHJnYmEoMCwgMCwgMCwgMC4zOCk7XG4gIC0tY29sb3ItLWRpdmlkZXI6IHJnYmEoMjU1LCAyNTUsIDI1NSwgMC4xMik7XG4gIC0tY29sb3ItLWJhY2tncm91bmQtLXBhcGVyOiAjMTkxODIzO1xuICAtLWNvbG9yLS1iYWNrZ3JvdW5kLS1kZWZhdWx0OiAjMTMxMTFiO1xuICAtLWNvbG9yLS1hY3Rpb24tLWFjdGl2ZTogI2ZmZjtcbiAgLS1jb2xvci0tYWN0aW9uLS1ob3ZlcjogcmdiYSgyNTUsIDI1NSwgMjU1LCAwLjA4KTtcbiAgLS1jb2xvci0tYWN0aW9uLS1zZWxlY3RlZDogcmdiYSgyNTUsIDI1NSwgMjU1LCAwLjE2KTtcbiAgLS1jb2xvci0tYWN0aW9uLS1kaXNhYmxlZDogcmdiYSgyNTUsIDI1NSwgMjU1LCAwLjMpO1xuICAtLWNvbG9yLS1hY3Rpb24tLWRpc2FibGVkQmFja2dyb3VuZDogcmdiYSgyNTUsIDI1NSwgMjU1LCAwLjEyKTtcbiAgLS1jb2xvci0tYWN0aW9uLS1mb2N1czogcmdiYSgwLCAwLCAwLCAwLjEyKTsgfVxuXG4vKiBDU1MgSU4gSlMgKi9cbjpleHBvcnQge1xuICBjb2xvckNvbW1vbkJsYWNrOiAjMDAwO1xuICBjb2xvckNvbW1vbldoaXRlOiAjZmZmO1xuICBjb2xvclByaW1hcnlMaWdodDogIzY3ZGQ4ODtcbiAgY29sb3JQcmltYXJ5TWFpbjogIzNkZDQ2NztcbiAgY29sb3JQcmltYXJ5RGFyazogIzI4YjY1MDtcbiAgY29sb3JQcmltYXJ5Q29udHJhc3RUZXh0OiAjMDAwO1xuICBjb2xvclNlY29uZGFyeUxpZ2h0OiAjMDBlY2IwO1xuICBjb2xvclNlY29uZGFyeU1haW46ICMwMGI5OGE7XG4gIGNvbG9yU2Vjb25kYXJ5RGFyazogIzAwODY2NDtcbiAgY29sb3JTZWNvbmRhcnlDb250cmFzdFRleHQ6ICMwMDA7XG4gIGNvbG9yRXJyb3JMaWdodDogI2YwN2I4NjtcbiAgY29sb3JFcnJvck1haW46ICNlYjRkNWM7XG4gIGNvbG9yRXJyb3JEYXJrOiAjZTYxZjMyO1xuICBjb2xvckVycm9yQ29udHJhc3RUZXh0OiAjZmZmO1xuICBjb2xvcldhcm5pbmdMaWdodDogI2ZmYWQzMztcbiAgY29sb3JXYXJuaW5nTWFpbjogI2ZmOTgwMDtcbiAgY29sb3JXYXJuaW5nRGFyazogI2NjN2EwMDtcbiAgY29sb3JXYXJuaW5nQ29udHJhc3RUZXh0OiByZ2JhKDAsIDAsIDAsIDAuODcpO1xuICBjb2xvckluZm9MaWdodDogIzUxYWRmNjtcbiAgY29sb3JJbmZvTWFpbjogIzIxOTZmMztcbiAgY29sb3JJbmZvRGFyazogIzBjN2NkNTtcbiAgY29sb3JJbmZvQ29udHJhc3RUZXh0OiAjZmZmO1xuICBjb2xvclN1Y2Nlc3NMaWdodDogIzZlYzA3MTtcbiAgY29sb3JTdWNjZXNzTWFpbjogIzRjYWY1MDtcbiAgY29sb3JTdWNjZXNzRGFyazogIzNkOGI0MDtcbiAgY29sb3JTdWNjZXNzQ29udHJhc3RUZXh0OiByZ2JhKDAsIDAsIDAsIDAuODcpO1xuICBjb2xvckdyZXk1MDogI2ZhZmFmYTtcbiAgY29sb3JHcmV5MTAwOiAjZjVmNWY1O1xuICBjb2xvckdyZXkyMDA6ICNlZWU7XG4gIGNvbG9yR3JleTMwMDogI2UwZTBlMDtcbiAgY29sb3JHcmV5NDAwOiAjYmRiZGJkO1xuICBjb2xvckdyZXk1MDA6ICM5ZTllOWU7XG4gIGNvbG9yR3JleTYwMDogIzc1NzU3NTtcbiAgY29sb3JHcmV5NzAwOiAjNjE2MTYxO1xuICBjb2xvckdyZXk4MDA6ICM0MjQyNDI7XG4gIGNvbG9yR3JleTkwMDogIzIxMjEyMTtcbiAgY29sb3JHcmV5QTEwMDogI2Q1ZDVkNTtcbiAgY29sb3JHcmV5QTIwMDogI2FhYTtcbiAgY29sb3JHcmV5QTQwMDogIzMwMzAzMDtcbiAgY29sb3JHcmV5QTcwMDogIzYxNjE2MTtcbiAgY29sb3JUZXh0UHJpbWFyeTogI2ZmZjtcbiAgY29sb3JUZXh0U2Vjb25kYXJ5OiByZ2JhKDI1NSwgMjU1LCAyNTUsIDAuNyk7XG4gIGNvbG9yVGV4dERpc2FibGVkOiByZ2JhKDI1NSwgMjU1LCAyNTUsIDAuNSk7XG4gIGNvbG9yVGV4dEhpbnQ6IHJnYmEoMCwgMCwgMCwgMC4zOCk7XG4gIGNvbG9yRGl2aWRlcjogcmdiYSgyNTUsIDI1NSwgMjU1LCAwLjEyKTtcbiAgY29sb3JCYWNrZ3JvdW5kUGFwZXI6ICMxOTE4MjM7XG4gIGNvbG9yQmFja2dyb3VuZERlZmF1bHQ6ICMxMzExMWI7XG4gIGNvbG9yQWN0aW9uQWN0aXZlOiAjZmZmO1xuICBjb2xvckFjdGlvbkhvdmVyOiByZ2JhKDI1NSwgMjU1LCAyNTUsIDAuMDgpO1xuICBjb2xvckFjdGlvblNlbGVjdGVkOiByZ2JhKDI1NSwgMjU1LCAyNTUsIDAuMTYpO1xuICBjb2xvckFjdGlvbkRpc2FibGVkOiByZ2JhKDI1NSwgMjU1LCAyNTUsIDAuMyk7XG4gIGNvbG9yQWN0aW9uRGlzYWJsZWRCYWNrZ3JvdW5kOiByZ2JhKDI1NSwgMjU1LCAyNTUsIDAuMTIpO1xuICBjb2xvckFjdGlvbkZvY3VzOiByZ2JhKDAsIDAsIDAsIDAuMTIpOyB9XG5cbi8qIFR5cG9ncmFwaHlcbi0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLSAqL1xuOnJvb3Qge1xuICAtLWZvbnQtLWZhbWlseS0taDE6IE51bml0bywgUm9ib3RvLCBIZWx2ZXRpY2EsIEFyaWFsLCBzYW5zLXNlcmlmO1xuICAtLWZvbnQtLXdlaWdodC0taDE6IDMwMDtcbiAgLS1mb250LS1zaXplLS1oMTogNnJlbTtcbiAgLS1mb250LS1saW5lSGVpZ2h0LS1oMTogMS4xNjc7XG4gIC0tZm9udC0tbGV0dGVyU3BhY2luZy0taDE6IC0wLjAxNTYyZW07XG4gIC0tZm9udC0tZmFtaWx5LS1oMjogTnVuaXRvLCBSb2JvdG8sIEhlbHZldGljYSwgQXJpYWwsIHNhbnMtc2VyaWY7XG4gIC0tZm9udC0td2VpZ2h0LS1oMjogMzAwO1xuICAtLWZvbnQtLXNpemUtLWgyOiAzLjc1cmVtO1xuICAtLWZvbnQtLWxpbmVIZWlnaHQtLWgyOiAxLjI7XG4gIC0tZm9udC0tbGV0dGVyU3BhY2luZy0taDI6IC0wLjAwODMzZW07XG4gIC0tZm9udC0tZmFtaWx5LS1oMzogTnVuaXRvLCBSb2JvdG8sIEhlbHZldGljYSwgQXJpYWwsIHNhbnMtc2VyaWY7XG4gIC0tZm9udC0td2VpZ2h0LS1oMzogNDAwO1xuICAtLWZvbnQtLXNpemUtLWgzOiAzcmVtO1xuICAtLWZvbnQtLWxpbmVIZWlnaHQtLWgzOiAxLjE2NztcbiAgLS1mb250LS1sZXR0ZXJTcGFjaW5nLS1oMzogMDtcbiAgLS1mb250LS1mYW1pbHktLWg0OiBOdW5pdG8sIFJvYm90bywgSGVsdmV0aWNhLCBBcmlhbCwgc2Fucy1zZXJpZjtcbiAgLS1mb250LS13ZWlnaHQtLWg0OiA0MDA7XG4gIC0tZm9udC0tc2l6ZS0taDQ6IDIuMTI1cmVtO1xuICAtLWZvbnQtLWxpbmVIZWlnaHQtLWg0OiAxLjIzNTtcbiAgLS1mb250LS1sZXR0ZXJTcGFjaW5nLS1oNDogMC4wMDczNWVtO1xuICAtLWZvbnQtLWZhbWlseS0taDU6IE51bml0bywgUm9ib3RvLCBIZWx2ZXRpY2EsIEFyaWFsLCBzYW5zLXNlcmlmO1xuICAtLWZvbnQtLXdlaWdodC0taDU6IDQwMDtcbiAgLS1mb250LS1zaXplLS1oNTogMS41cmVtO1xuICAtLWZvbnQtLWxpbmVIZWlnaHQtLWg1OiAxLjMzNDtcbiAgLS1mb250LS1sZXR0ZXJTcGFjaW5nLS1oNTogMDtcbiAgLS1mb250LS1mYW1pbHktLWg2OiBOdW5pdG8sIFJvYm90bywgSGVsdmV0aWNhLCBBcmlhbCwgc2Fucy1zZXJpZjtcbiAgLS1mb250LS13ZWlnaHQtLWg2OiA1MDA7XG4gIC0tZm9udC0tc2l6ZS0taDY6IDEuMjVyZW07XG4gIC0tZm9udC0tbGluZUhlaWdodC0taDY6IDEuNjtcbiAgLS1mb250LS1sZXR0ZXJTcGFjaW5nLS1oNjogMC4wMDc1ZW07XG4gIC0tZm9udC0tZmFtaWx5LS1zdWJ0aXRsZTE6IE51bml0bywgUm9ib3RvLCBIZWx2ZXRpY2EsIEFyaWFsLCBzYW5zLXNlcmlmO1xuICAtLWZvbnQtLXdlaWdodC0tc3VidGl0bGUxOiA0MDA7XG4gIC0tZm9udC0tc2l6ZS0tc3VidGl0bGUxOiAxcmVtO1xuICAtLWZvbnQtLWxpbmVIZWlnaHQtLXN1YnRpdGxlMTogMS43NTtcbiAgLS1mb250LS1sZXR0ZXJTcGFjaW5nLS1zdWJ0aXRsZTE6IDAuMDA5MzhlbTtcbiAgLS1mb250LS1mYW1pbHktLXN1YnRpdGxlMjogTnVuaXRvLCBSb2JvdG8sIEhlbHZldGljYSwgQXJpYWwsIHNhbnMtc2VyaWY7XG4gIC0tZm9udC0td2VpZ2h0LS1zdWJ0aXRsZTI6IDUwMDtcbiAgLS1mb250LS1zaXplLS1zdWJ0aXRsZTI6IDAuODc1cmVtO1xuICAtLWZvbnQtLWxpbmVIZWlnaHQtLXN1YnRpdGxlMjogMS41NztcbiAgLS1mb250LS1sZXR0ZXJTcGFjaW5nLS1zdWJ0aXRsZTI6IDAuMDA3MTRlbTtcbiAgLS1mb250LS1mYW1pbHktLWJvZHkxOiBOdW5pdG8sIFJvYm90bywgSGVsdmV0aWNhLCBBcmlhbCwgc2Fucy1zZXJpZjtcbiAgLS1mb250LS13ZWlnaHQtLWJvZHkxOiA0MDA7XG4gIC0tZm9udC0tc2l6ZS0tYm9keTE6IDFyZW07XG4gIC0tZm9udC0tbGluZUhlaWdodC0tYm9keTE6IDEuNTtcbiAgLS1mb250LS1sZXR0ZXJTcGFjaW5nLS1ib2R5MTogMC4wMDkzOGVtO1xuICAtLWZvbnQtLWZhbWlseS0tYm9keTI6IE51bml0bywgUm9ib3RvLCBIZWx2ZXRpY2EsIEFyaWFsLCBzYW5zLXNlcmlmO1xuICAtLWZvbnQtLXdlaWdodC0tYm9keTI6IDQwMDtcbiAgLS1mb250LS1zaXplLS1ib2R5MjogMC44NzVyZW07XG4gIC0tZm9udC0tbGluZUhlaWdodC0tYm9keTI6IDEuNDM7XG4gIC0tZm9udC0tbGV0dGVyU3BhY2luZy0tYm9keTI6IDAuMDEwNzFlbTtcbiAgLS1mb250LS1mYW1pbHktLWJ1dHRvbjogTnVuaXRvLCBSb2JvdG8sIEhlbHZldGljYSwgQXJpYWwsIHNhbnMtc2VyaWY7XG4gIC0tZm9udC0td2VpZ2h0LS1idXR0b246IDcwMDtcbiAgLS1mb250LS1zaXplLS1idXR0b246IDAuODc1cmVtO1xuICAtLWZvbnQtLWxpbmVIZWlnaHQtLWJ1dHRvbjogMS43NTtcbiAgLS1mb250LS1sZXR0ZXJTcGFjaW5nLS1idXR0b246IDAuMDI4NTdlbTtcbiAgLS1mb250LS10ZXh0VHJhbnNmb3JtLS1idXR0b246IGNhcGl0YWxpemU7XG4gIC0tZm9udC0tZmFtaWx5LS1jYXB0aW9uOiBOdW5pdG8sIFJvYm90bywgSGVsdmV0aWNhLCBBcmlhbCwgc2Fucy1zZXJpZjtcbiAgLS1mb250LS13ZWlnaHQtLWNhcHRpb246IDQwMDtcbiAgLS1mb250LS1zaXplLS1jYXB0aW9uOiAwLjc1cmVtO1xuICAtLWZvbnQtLWxpbmVIZWlnaHQtLWNhcHRpb246IDEuNjY7XG4gIC0tZm9udC0tbGV0dGVyU3BhY2luZy0tY2FwdGlvbjogMC4wMzMzM2VtO1xuICAtLWZvbnQtLWZhbWlseS0tb3ZlcmxpbmU6IE51bml0bywgUm9ib3RvLCBIZWx2ZXRpY2EsIEFyaWFsLCBzYW5zLXNlcmlmO1xuICAtLWZvbnQtLXdlaWdodC0tb3ZlcmxpbmU6IDQwMDtcbiAgLS1mb250LS1zaXplLS1vdmVybGluZTogMC43NXJlbTtcbiAgLS1mb250LS1saW5lSGVpZ2h0LS1vdmVybGluZTogMi42NjtcbiAgLS1mb250LS1sZXR0ZXJTcGFjaW5nLS1vdmVybGluZTogMC4wODMzM2VtO1xuICAtLWZvbnQtLXRleHRUcmFuc2Zvcm0tLW92ZXJsaW5lOiB1cHBlcmNhc2U7IH1cblxuLyogQ1NTIElOIEpTICovXG46ZXhwb3J0IHtcbiAgZm9udEZhbWlseUgxOiBcIk51bml0b1wiLCBcIlJvYm90b1wiLCBcIkhlbHZldGljYVwiLCBcIkFyaWFsXCIsIFwic2Fucy1zZXJpZlwiO1xuICBmb250V2VpZ2h0SDE6IDMwMDtcbiAgZm9udFNpemVIMTogNnJlbTtcbiAgZm9udExpbmVIZWlnaHRIMTogMS4xNjc7XG4gIGZvbnRMZXR0ZXJTcGFjaW5nSDE6IC0wLjAxNTYyZW07XG4gIGZvbnRGYW1pbHlIMjogXCJOdW5pdG9cIiwgXCJSb2JvdG9cIiwgXCJIZWx2ZXRpY2FcIiwgXCJBcmlhbFwiLCBcInNhbnMtc2VyaWZcIjtcbiAgZm9udFdlaWdodEgyOiAzMDA7XG4gIGZvbnRTaXplSDI6IDMuNzVyZW07XG4gIGZvbnRMaW5lSGVpZ2h0SDI6IDEuMjtcbiAgZm9udExldHRlclNwYWNpbmdIMjogLTAuMDA4MzNlbTtcbiAgZm9udEZhbWlseUgzOiBcIk51bml0b1wiLCBcIlJvYm90b1wiLCBcIkhlbHZldGljYVwiLCBcIkFyaWFsXCIsIFwic2Fucy1zZXJpZlwiO1xuICBmb250V2VpZ2h0SDM6IDQwMDtcbiAgZm9udFNpemVIMzogM3JlbTtcbiAgZm9udExpbmVIZWlnaHRIMzogMS4xNjc7XG4gIGZvbnRMZXR0ZXJTcGFjaW5nSDM6IDA7XG4gIGZvbnRGYW1pbHlINDogXCJOdW5pdG9cIiwgXCJSb2JvdG9cIiwgXCJIZWx2ZXRpY2FcIiwgXCJBcmlhbFwiLCBcInNhbnMtc2VyaWZcIjtcbiAgZm9udFdlaWdodEg0OiA0MDA7XG4gIGZvbnRTaXplSDQ6IDIuMTI1cmVtO1xuICBmb250TGluZUhlaWdodEg0OiAxLjIzNTtcbiAgZm9udExldHRlclNwYWNpbmdINDogMC4wMDczNWVtO1xuICBmb250RmFtaWx5SDU6IFwiTnVuaXRvXCIsIFwiUm9ib3RvXCIsIFwiSGVsdmV0aWNhXCIsIFwiQXJpYWxcIiwgXCJzYW5zLXNlcmlmXCI7XG4gIGZvbnRXZWlnaHRINTogNDAwO1xuICBmb250U2l6ZUg1OiAxLjVyZW07XG4gIGZvbnRMaW5lSGVpZ2h0SDU6IDEuMzM0O1xuICBmb250TGV0dGVyU3BhY2luZ0g1OiAwO1xuICBmb250RmFtaWx5SDY6IFwiTnVuaXRvXCIsIFwiUm9ib3RvXCIsIFwiSGVsdmV0aWNhXCIsIFwiQXJpYWxcIiwgXCJzYW5zLXNlcmlmXCI7XG4gIGZvbnRXZWlnaHRINjogNTAwO1xuICBmb250U2l6ZUg2OiAxLjI1cmVtO1xuICBmb250TGluZUhlaWdodEg2OiAxLjY7XG4gIGZvbnRMZXR0ZXJTcGFjaW5nSDY6IDAuMDA3NWVtO1xuICBmb250RmFtaWx5U3VidGl0bGUxOiBcIk51bml0b1wiLCBcIlJvYm90b1wiLCBcIkhlbHZldGljYVwiLCBcIkFyaWFsXCIsIFwic2Fucy1zZXJpZlwiO1xuICBmb250V2VpZ2h0U3VidGl0bGUxOiA0MDA7XG4gIGZvbnRTaXplU3VidGl0bGUxOiAxcmVtO1xuICBmb250TGluZUhlaWdodFN1YnRpdGxlMTogMS43NTtcbiAgZm9udExldHRlclNwYWNpbmdTdWJ0aXRsZTE6IDAuMDA5MzhlbTtcbiAgZm9udEZhbWlseVN1YnRpdGxlMjogXCJOdW5pdG9cIiwgXCJSb2JvdG9cIiwgXCJIZWx2ZXRpY2FcIiwgXCJBcmlhbFwiLCBcInNhbnMtc2VyaWZcIjtcbiAgZm9udFdlaWdodFN1YnRpdGxlMjogNTAwO1xuICBmb250U2l6ZVN1YnRpdGxlMjogMC44NzVyZW07XG4gIGZvbnRMaW5lSGVpZ2h0U3VidGl0bGUyOiAxLjU3O1xuICBmb250TGV0dGVyU3BhY2luZ1N1YnRpdGxlMjogMC4wMDcxNGVtO1xuICBmb250RmFtaWx5Qm9keTE6IFwiTnVuaXRvXCIsIFwiUm9ib3RvXCIsIFwiSGVsdmV0aWNhXCIsIFwiQXJpYWxcIiwgXCJzYW5zLXNlcmlmXCI7XG4gIGZvbnRXZWlnaHRCb2R5MTogNDAwO1xuICBmb250U2l6ZUJvZHkxOiAxcmVtO1xuICBmb250TGluZUhlaWdodEJvZHkxOiAxLjU7XG4gIGZvbnRMZXR0ZXJTcGFjaW5nQm9keTE6IDAuMDA5MzhlbTtcbiAgZm9udEZhbWlseUJvZHkyOiBcIk51bml0b1wiLCBcIlJvYm90b1wiLCBcIkhlbHZldGljYVwiLCBcIkFyaWFsXCIsIFwic2Fucy1zZXJpZlwiO1xuICBmb250V2VpZ2h0Qm9keTI6IDQwMDtcbiAgZm9udFNpemVCb2R5MjogMC44NzVyZW07XG4gIGZvbnRMaW5lSGVpZ2h0Qm9keTI6IDEuNDM7XG4gIGZvbnRMZXR0ZXJTcGFjaW5nQm9keTI6IDAuMDEwNzFlbTtcbiAgZm9udEZhbWlseUJ1dHRvbjogXCJOdW5pdG9cIiwgXCJSb2JvdG9cIiwgXCJIZWx2ZXRpY2FcIiwgXCJBcmlhbFwiLCBcInNhbnMtc2VyaWZcIjtcbiAgZm9udFdlaWdodEJ1dHRvbjogNzAwO1xuICBmb250U2l6ZUJ1dHRvbjogMC44NzVyZW07XG4gIGZvbnRMaW5lSGVpZ2h0QnV0dG9uOiAxLjc1O1xuICBmb250TGV0dGVyU3BhY2luZ0J1dHRvbjogMC4wMjg1N2VtO1xuICBmb250VGV4dFRyYW5zZm9ybUJ1dHRvbjogY2FwaXRhbGl6ZTtcbiAgZm9udEZhbWlseUNhcHRpb246IFwiTnVuaXRvXCIsIFwiUm9ib3RvXCIsIFwiSGVsdmV0aWNhXCIsIFwiQXJpYWxcIiwgXCJzYW5zLXNlcmlmXCI7XG4gIGZvbnRXZWlnaHRDYXB0aW9uOiA0MDA7XG4gIGZvbnRTaXplQ2FwdGlvbjogMC43NXJlbTtcbiAgZm9udExpbmVIZWlnaHRDYXB0aW9uOiAxLjY2O1xuICBmb250TGV0dGVyU3BhY2luZ0NhcHRpb246IDAuMDMzMzNlbTtcbiAgZm9udEZhbWlseU92ZXJsaW5lOiBcIk51bml0b1wiLCBcIlJvYm90b1wiLCBcIkhlbHZldGljYVwiLCBcIkFyaWFsXCIsIFwic2Fucy1zZXJpZlwiO1xuICBmb250V2VpZ2h0T3ZlcmxpbmU6IDQwMDtcbiAgZm9udFNpemVPdmVybGluZTogMC43NXJlbTtcbiAgZm9udExpbmVIZWlnaHRPdmVybGluZTogMi42NjtcbiAgZm9udExldHRlclNwYWNpbmdPdmVybGluZTogMC4wODMzM2VtO1xuICBmb250VGV4dFRyYW5zZm9ybU92ZXJsaW5lOiB1cHBlcmNhc2U7IH1cblxuLyogQ1NTIFZBUklBQkxFUyAqL1xuOnJvb3Qge1xuICAtLXBhZGRpbmctZ3JpZDogOHB4OyB9XG5cbi8qIENTUyBJTiBKUyAqL1xuOmV4cG9ydCB7XG4gIHBhZGRpbmdHcmlkOiA4cHg7IH1cblxuLyogU0NTUyBWQVJJQUJMRVMgKi9cbi8qIENvbG9yc1xuLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tICovXG4vKiBCcmVha3BvaW50c1xuLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tICovXG4vKiBQYWRkaW5nL01hcmdpbnNcbi0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLSAqL1xuLyogQm9yZGVyXG4tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0gKi9cbi8qIENTUyBWQVJJQUJMRVMgKi9cbjpyb290IHtcbiAgLS1jb2xvci0tYnV0dG9uOiByZ2JhKDAsIDAsIDAsIDAuODcpO1xuICAvKiBCcmVha3BvaW50c1xuICAtLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0gKi9cbiAgLS1icmVha3BvaW50cy14czogMDtcbiAgLS1icmVha3BvaW50cy1zbTogNjAwcHg7XG4gIC0tYnJlYWtwb2ludHMtbWQ6IDk2MHB4O1xuICAtLWJyZWFrcG9pbnRzLWxnOiAxMjgwcHg7XG4gIC0tYnJlYWtwb2ludHMteGw6IDE5MjBweDtcbiAgLyogUGFkZGluZy9NYXJnaW5zXG4gIC0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLSAqL1xuICAtLXBhZGRpbmctZ3JpZDogOHB4O1xuICAtLXBhZGRpbmctYmFzZS12ZXJ0aWNhbDogN3B4O1xuICAtLXBhZGRpbmctYmFzZS1ob3Jpem9udGFsOiAxM3B4O1xuICAtLXBhZGRpbmctbGFyZ2UtdmVydGljYWw6IDEwcHg7XG4gIC0tcGFkZGluZy1sYXJnZS1ob3Jpem9udGFsOiAxOXB4O1xuICAtLXBhZGRpbmctc21hbGwtdmVydGljYWw6IDVweDtcbiAgLS1wYWRkaW5nLXNtYWxsLWhvcml6b250YWw6IDhweDtcbiAgLS1wYWRkaW5nLXhzLXZlcnRpY2FsOiAxcHg7XG4gIC0tcGFkZGluZy14cy1ob3Jpem9udGFsOiA1cHg7XG4gIC0tcGFkZGluZy14bC12ZXJ0aWNhbDogMTVweDtcbiAgLS1wYWRkaW5nLXhsLWhvcml6b250YWw6IDIzcHg7XG4gIC0tcGFkZGluZy1idXR0b24teGwtdGV4dDogMTBweCAxNHB4O1xuICAtLXBhZGRpbmctYnV0dG9uLXhsLW91dGxpbmVkOiA5cHggMjdweDtcbiAgLS1wYWRkaW5nLWJ1dHRvbi14bC1jb250YWluZWQ6IDEwcHggMjhweDtcbiAgLyogQm9yZGVyXG4gIC0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLSAqL1xuICAtLWJvcmRlci1yYWRpdXMtYmFzZTogNHB4O1xuICAtLWJvcmRlci1yYWRpdXMtbGFyZ2U6IDZweDtcbiAgLS1ib3JkZXItcmFkaXVzLXNtYWxsOiAzcHg7IH1cblxuLyogQ1NTIElOIEpTICovXG46ZXhwb3J0IHtcbiAgYnJlYWtwb2ludHNYczogMDtcbiAgYnJlYWtwb2ludHNTbTogNjAwcHg7XG4gIGJyZWFrcG9pbnRzTWQ6IDk2MHB4O1xuICBicmVha3BvaW50c0xnOiAxMjgwcHg7XG4gIGJyZWFrcG9pbnRzWGw6IDE5MjBweDtcbiAgcGFkZGluZ0Jhc2VWZXJ0aWNhbDogN3B4O1xuICBwYWRkaW5nQmFzZUhvcml6b250YWw6IDEzcHg7XG4gIHBhZGRpbmdMYXJnZVZlcnRpY2FsOiAxMHB4O1xuICBwYWRkaW5nTGFyZ2VIb3Jpem9udGFsOiAxOXB4O1xuICBwYWRkaW5nU21hbGxWZXJ0aWNhbDogNXB4O1xuICBwYWRkaW5nU21hbGxIb3Jpem9udGFsOiA4cHg7XG4gIHBhZGRpbmdYc1ZlcnRpY2FsOiAxcHg7XG4gIHBhZGRpbmdYc0hvcml6b250YWw6IDVweDtcbiAgcGFkZGluZ1hsVmVydGljYWw6IDE1cHg7XG4gIHBhZGRpbmdYbEhvcml6b250YWw6IDIzcHg7XG4gIHBhZGRpbmdCdXR0b25YbFRleHQ6IDEwcHggMTRweDtcbiAgcGFkZGluZ0J1dHRvblhsT3V0bGluZWQ6IDlweCAyN3B4O1xuICBwYWRkaW5nQnV0dG9uWGxDb250YWluZWQ6IDEwcHggMjhweDsgfVxuXG4vKiBDU1MgVkFSSUFCTEVTICovXG4uZGFyayB7XG4gIC0tY29sb3ItLXByaW1hcnktLWNvbnRyYXN0LXRleHQ6ICMwMDA7XG4gIC0tY29sb3ItLXNlY29uZGFyeS0tY29udHJhc3QtdGV4dDogIzAwMDtcbiAgLS1jb2xvci0tdGV4dC0tcHJpbWFyeTogI2ZmZjtcbiAgLS1jb2xvci0tdGV4dC0tc2Vjb25kYXJ5OiByZ2JhKDI1NSwgMjU1LCAyNTUsIDAuNyk7XG4gIC0tY29sb3ItLXRleHQtLWRpc2FibGVkOiByZ2JhKDI1NSwgMjU1LCAyNTUsIDAuNSk7XG4gIC0tY29sb3ItLWRpdmlkZXI6IHJnYmEoMjU1LCAyNTUsIDI1NSwgMC4xMik7XG4gIC0tY29sb3ItLWJhY2tncm91bmQtLXBhcGVyOiAjMTkxODIzO1xuICAtLWNvbG9yLS1iYWNrZ3JvdW5kLS1kZWZhdWx0OiAjMTMxMTFiO1xuICAtLWNvbG9yLS1hY3Rpb24tLWFjdGl2ZTogI2ZmZjtcbiAgLS1jb2xvci0tYWN0aW9uLS1ob3ZlcjogcmdiYSgyNTUsIDI1NSwgMjU1LCAwLjA4KTtcbiAgLS1jb2xvci0tYWN0aW9uLS1zZWxlY3RlZDogcmdiYSgyNTUsIDI1NSwgMjU1LCAwLjE2KTtcbiAgLS1jb2xvci0tYWN0aW9uLS1kaXNhYmxlZDogcmdiYSgyNTUsIDI1NSwgMjU1LCAwLjMpO1xuICAtLWNvbG9yLS1hY3Rpb24tLWRpc2FibGVkQmFja2dyb3VuZDogcmdiYSgyNTUsIDI1NSwgMjU1LCAwLjEyKTtcbiAgLS1jb2xvci0tYnV0dG9uOiByZ2JhKDAsIDAsIDAsIDAuODcpOyB9XG5cbi8qIENTUyBJTiBKUyAqL1xuOmV4cG9ydCB7XG4gIGNvbG9yUHJpbWFyeUNvbnRyYXN0VGV4dDogIzAwMDtcbiAgY29sb3JTZWNvbmRhcnlDb250cmFzdFRleHQ6ICMwMDA7XG4gIGNvbG9yVGV4dFByaW1hcnk6ICNmZmY7XG4gIGNvbG9yVGV4dFNlY29uZGFyeTogcmdiYSgyNTUsIDI1NSwgMjU1LCAwLjcpO1xuICBjb2xvclRleHREaXNhYmxlZDogcmdiYSgyNTUsIDI1NSwgMjU1LCAwLjUpO1xuICBjb2xvckRpdmlkZXI6IHJnYmEoMjU1LCAyNTUsIDI1NSwgMC4xMik7XG4gIGNvbG9yQmFja2dyb3VuZFBhcGVyOiAjMTkxODIzO1xuICBjb2xvckJhY2tncm91bmREZWZhdWx0OiAjMTMxMTFiO1xuICBjb2xvckFjdGlvbkFjdGl2ZTogI2ZmZjtcbiAgY29sb3JBY3Rpb25Ib3ZlcjogcmdiYSgyNTUsIDI1NSwgMjU1LCAwLjA4KTtcbiAgY29sb3JBY3Rpb25TZWxlY3RlZDogcmdiYSgyNTUsIDI1NSwgMjU1LCAwLjE2KTtcbiAgY29sb3JBY3Rpb25EaXNhYmxlZDogcmdiYSgyNTUsIDI1NSwgMjU1LCAwLjMpO1xuICBjb2xvckFjdGlvbkRpc2FibGVkQmFja2dyb3VuZDogcmdiYSgyNTUsIDI1NSwgMjU1LCAwLjEyKTsgfVxuIl19 */";
  var darkTheme = {
    "colorCommonBlack": "#000",
    "colorCommonWhite": "#fff",
    "colorPrimaryLight": "#67dd88",
    "colorPrimaryMain": "#3dd467",
    "colorPrimaryDark": "#28b650",
    "colorPrimaryContrastText": "#000",
    "colorSecondaryLight": "#00ecb0",
    "colorSecondaryMain": "#00b98a",
    "colorSecondaryDark": "#008664",
    "colorSecondaryContrastText": "#000",
    "colorErrorLight": "#f07b86",
    "colorErrorMain": "#eb4d5c",
    "colorErrorDark": "#e61f32",
    "colorErrorContrastText": "#fff",
    "colorWarningLight": "#ffad33",
    "colorWarningMain": "#ff9800",
    "colorWarningDark": "#cc7a00",
    "colorWarningContrastText": "rgba(0, 0, 0, 0.87)",
    "colorInfoLight": "#51adf6",
    "colorInfoMain": "#2196f3",
    "colorInfoDark": "#0c7cd5",
    "colorInfoContrastText": "#fff",
    "colorSuccessLight": "#6ec071",
    "colorSuccessMain": "#4caf50",
    "colorSuccessDark": "#3d8b40",
    "colorSuccessContrastText": "rgba(0, 0, 0, 0.87)",
    "colorGrey50": "#fafafa",
    "colorGrey100": "#f5f5f5",
    "colorGrey200": "#eee",
    "colorGrey300": "#e0e0e0",
    "colorGrey400": "#bdbdbd",
    "colorGrey500": "#9e9e9e",
    "colorGrey600": "#757575",
    "colorGrey700": "#616161",
    "colorGrey800": "#424242",
    "colorGrey900": "#212121",
    "colorGreyA100": "#d5d5d5",
    "colorGreyA200": "#aaa",
    "colorGreyA400": "#303030",
    "colorGreyA700": "#616161",
    "colorTextPrimary": "#fff",
    "colorTextSecondary": "rgba(255, 255, 255, 0.7)",
    "colorTextDisabled": "rgba(255, 255, 255, 0.5)",
    "colorTextHint": "rgba(0, 0, 0, 0.38)",
    "colorDivider": "rgba(255, 255, 255, 0.12)",
    "colorBackgroundPaper": "#191823",
    "colorBackgroundDefault": "#13111b",
    "colorActionActive": "#fff",
    "colorActionHover": "rgba(255, 255, 255, 0.08)",
    "colorActionSelected": "rgba(255, 255, 255, 0.16)",
    "colorActionDisabled": "rgba(255, 255, 255, 0.3)",
    "colorActionDisabledBackground": "rgba(255, 255, 255, 0.12)",
    "colorActionFocus": "rgba(0, 0, 0, 0.12)",
    "fontFamilyH1": "\"Nunito\", \"Roboto\", \"Helvetica\", \"Arial\", \"sans-serif\"",
    "fontWeightH1": "300",
    "fontSizeH1": "6rem",
    "fontLineHeightH1": "1.167",
    "fontLetterSpacingH1": "-0.01562em",
    "fontFamilyH2": "\"Nunito\", \"Roboto\", \"Helvetica\", \"Arial\", \"sans-serif\"",
    "fontWeightH2": "300",
    "fontSizeH2": "3.75rem",
    "fontLineHeightH2": "1.2",
    "fontLetterSpacingH2": "-0.00833em",
    "fontFamilyH3": "\"Nunito\", \"Roboto\", \"Helvetica\", \"Arial\", \"sans-serif\"",
    "fontWeightH3": "400",
    "fontSizeH3": "3rem",
    "fontLineHeightH3": "1.167",
    "fontLetterSpacingH3": "0",
    "fontFamilyH4": "\"Nunito\", \"Roboto\", \"Helvetica\", \"Arial\", \"sans-serif\"",
    "fontWeightH4": "400",
    "fontSizeH4": "2.125rem",
    "fontLineHeightH4": "1.235",
    "fontLetterSpacingH4": "0.00735em",
    "fontFamilyH5": "\"Nunito\", \"Roboto\", \"Helvetica\", \"Arial\", \"sans-serif\"",
    "fontWeightH5": "400",
    "fontSizeH5": "1.5rem",
    "fontLineHeightH5": "1.334",
    "fontLetterSpacingH5": "0",
    "fontFamilyH6": "\"Nunito\", \"Roboto\", \"Helvetica\", \"Arial\", \"sans-serif\"",
    "fontWeightH6": "500",
    "fontSizeH6": "1.25rem",
    "fontLineHeightH6": "1.6",
    "fontLetterSpacingH6": "0.0075em",
    "fontFamilySubtitle1": "\"Nunito\", \"Roboto\", \"Helvetica\", \"Arial\", \"sans-serif\"",
    "fontWeightSubtitle1": "400",
    "fontSizeSubtitle1": "1rem",
    "fontLineHeightSubtitle1": "1.75",
    "fontLetterSpacingSubtitle1": "0.00938em",
    "fontFamilySubtitle2": "\"Nunito\", \"Roboto\", \"Helvetica\", \"Arial\", \"sans-serif\"",
    "fontWeightSubtitle2": "500",
    "fontSizeSubtitle2": "0.875rem",
    "fontLineHeightSubtitle2": "1.57",
    "fontLetterSpacingSubtitle2": "0.00714em",
    "fontFamilyBody1": "\"Nunito\", \"Roboto\", \"Helvetica\", \"Arial\", \"sans-serif\"",
    "fontWeightBody1": "400",
    "fontSizeBody1": "1rem",
    "fontLineHeightBody1": "1.5",
    "fontLetterSpacingBody1": "0.00938em",
    "fontFamilyBody2": "\"Nunito\", \"Roboto\", \"Helvetica\", \"Arial\", \"sans-serif\"",
    "fontWeightBody2": "400",
    "fontSizeBody2": "0.875rem",
    "fontLineHeightBody2": "1.43",
    "fontLetterSpacingBody2": "0.01071em",
    "fontFamilyButton": "\"Nunito\", \"Roboto\", \"Helvetica\", \"Arial\", \"sans-serif\"",
    "fontWeightButton": "700",
    "fontSizeButton": "0.875rem",
    "fontLineHeightButton": "1.75",
    "fontLetterSpacingButton": "0.02857em",
    "fontTextTransformButton": "capitalize",
    "fontFamilyCaption": "\"Nunito\", \"Roboto\", \"Helvetica\", \"Arial\", \"sans-serif\"",
    "fontWeightCaption": "400",
    "fontSizeCaption": "0.75rem",
    "fontLineHeightCaption": "1.66",
    "fontLetterSpacingCaption": "0.03333em",
    "fontFamilyOverline": "\"Nunito\", \"Roboto\", \"Helvetica\", \"Arial\", \"sans-serif\"",
    "fontWeightOverline": "400",
    "fontSizeOverline": "0.75rem",
    "fontLineHeightOverline": "2.66",
    "fontLetterSpacingOverline": "0.08333em",
    "fontTextTransformOverline": "uppercase",
    "paddingGrid": "8px",
    "breakpointsXs": "0",
    "breakpointsSm": "600px",
    "breakpointsMd": "960px",
    "breakpointsLg": "1280px",
    "breakpointsXl": "1920px",
    "paddingBaseVertical": "7px",
    "paddingBaseHorizontal": "13px",
    "paddingLargeVertical": "10px",
    "paddingLargeHorizontal": "19px",
    "paddingSmallVertical": "5px",
    "paddingSmallHorizontal": "8px",
    "paddingXsVertical": "1px",
    "paddingXsHorizontal": "5px",
    "paddingXlVertical": "15px",
    "paddingXlHorizontal": "23px",
    "paddingButtonXlText": "10px 14px",
    "paddingButtonXlOutlined": "9px 27px",
    "paddingButtonXlContained": "10px 28px",
    "dark": "DarkThemeContainer-module_dark__qR6Eb"
  };
  styleInject(css_248z$1);

  var DarkThemeContainer = function DarkThemeContainer(props) {
    var children = props.children;
    return React__default["default"].createElement("div", {
      className: classNames('dsThemeContainer', 'dsDarkThemeContainer', darkTheme.dark)
    }, children({
      themeVariables: darkTheme
    }));
  };

  var css_248z = "@import url(\"https://fonts.googleapis.com/css2?family=Nunito:wght@400;700&display=swap\");\n/**\n * Convert a hex color to an RGB string\n *\n * @param {string} - Hex color\n * @returns {string} - RGB string of the hex color\n */\n/**\n * The material-ui-color package, needs CssBasline implement to fix a few defaults, box-sizing\n * being one of them. We don't necessarily want that, so create a small global style here to fix\n * the padding on the sliders pushing out the layout. Needs to be a global so we can target the\n * sliders that are in the Popover\n */\n/* stylelint-disable selector-class-pattern */\n@import url(\"https://fonts.googleapis.com/css2?family=Nunito:wght@400;700&display=swap\");\n.muicc-colorbox-sliders {\n  box-sizing: border-box; }\n\n/* stylelint-enable selector-class-pattern */\n/**\n * Convert a hex color to an RGB string\n *\n * @param {string} - Hex color\n * @returns {string} - RGB string of the hex color\n */\n/**\n * The material-ui-color package, needs CssBasline implement to fix a few defaults, box-sizing\n * being one of them. We don't necessarily want that, so create a small global style here to fix\n * the padding on the sliders pushing out the layout. Needs to be a global so we can target the\n * sliders that are in the Popover\n */\n/* stylelint-disable selector-class-pattern */\n.muicc-colorbox-sliders {\n  box-sizing: border-box; }\n\n/* stylelint-enable selector-class-pattern */\n/* SCSS VARIABLES */\n/* Colors\n------------------------------------------------------------------------------------------------ */\n:root {\n  --color--common--black: #000;\n  --color--common--white: #fff;\n  --color--primary--main: #3dd467;\n  --color--primary--light: #67dd88;\n  --color--primary--dark: #28b650;\n  --color--primary--contrast-text: #fff;\n  --color--primary--main--rgb: 61,212,103;\n  --color--primary--light--rgb: 103,221,136;\n  --color--primary--dark--rgb: 40,182,80;\n  --color--secondary--main: #00b98a;\n  --color--secondary--light: #00ecb0;\n  --color--secondary--dark: #008664;\n  --color--secondary--contrast-text: #fff;\n  --color--secondary--main--rgb: 0,185,138;\n  --color--secondary--light--rgb: 0,236,176;\n  --color--secondary--dark--rgb: 0,236,176;\n  --color--error--main: #eb4d5c;\n  --color--error--light: #f07b86;\n  --color--error--dark: #e61f32;\n  --color--error--contrast-text: #fff;\n  --color--error--main--rgb: 235,77,92;\n  --color--error--light--rgb: 240,123,134;\n  --color--error--dark--rgb: 240,123,134;\n  --color--warning--main: #ff9800;\n  --color--warning--light: #ffad33;\n  --color--warning--dark: #cc7a00;\n  --color--warning--contrast-text: rgba(0, 0, 0, 0.87);\n  --color--warning--main--rgb: 255,152,0;\n  --color--warning--light--rgb: 255,173,51;\n  --color--warning--dark--rgb: 255,173,51;\n  --color--info--main: #2196f3;\n  --color--info--light: #51adf6;\n  --color--info--dark: #0c7cd5;\n  --color--info--contrast-text: #fff;\n  --color--info--main--rgb: 33,150,243;\n  --color--info--light--rgb: 81,173,246;\n  --color--info--dark--rgb: 81,173,246;\n  --color--success--main: #4caf50;\n  --color--success--light: #6ec071;\n  --color--success--dark: #3d8b40;\n  --color--success--contrast-text: rgba(0, 0, 0, 0.87);\n  --color--success--main--rgb: 76,175,80;\n  --color--success--light--rgb: 110,192,113;\n  --color--success--dark--rgb: 110,192,113;\n  --color--grey--50: #fafafa;\n  --color--grey--100: #f5f5f5;\n  --color--grey--200: #eee;\n  --color--grey--300: #e0e0e0;\n  --color--grey--400: #bdbdbd;\n  --color--grey--500: #9e9e9e;\n  --color--grey--600: #757575;\n  --color--grey--700: #616161;\n  --color--grey--800: #424242;\n  --color--grey--900: #212121;\n  --color--grey--A100: #d5d5d5;\n  --color--grey--A200: #aaa;\n  --color--grey--A400: #303030;\n  --color--grey--A700: #616161;\n  --color--text--primary: rgba(0, 0, 0, 0.87);\n  --color--text--secondary: rgba(0, 0, 0, 0.54);\n  --color--text--disabled: rgba(0, 0, 0, 0.38);\n  --color--text--hint: rgba(0, 0, 0, 0.38);\n  --color--divider: rgba(0, 0, 0, 0.12);\n  --color--background--paper: #fff;\n  --color--background--default: #fafafa;\n  --color--action--active: rgba(0, 0, 0, 0.54);\n  --color--action--hover: rgba(0, 0, 0, 0.04);\n  --color--action--selected: rgba(0, 0, 0, 0.08);\n  --color--action--disabled: rgba(0, 0, 0, 0.26);\n  --color--action--disabledBackground: rgba(0, 0, 0, 0.12);\n  --color--action--focus: rgba(0, 0, 0, 0.12); }\n\n/* CSS IN JS */\n\n/* Typography\n------------------------------------------------------------------------------------------------ */\n:root {\n  --font--family--h1: Nunito, Roboto, Helvetica, Arial, sans-serif;\n  --font--weight--h1: 300;\n  --font--size--h1: 6rem;\n  --font--lineHeight--h1: 1.167;\n  --font--letterSpacing--h1: -0.01562em;\n  --font--family--h2: Nunito, Roboto, Helvetica, Arial, sans-serif;\n  --font--weight--h2: 300;\n  --font--size--h2: 3.75rem;\n  --font--lineHeight--h2: 1.2;\n  --font--letterSpacing--h2: -0.00833em;\n  --font--family--h3: Nunito, Roboto, Helvetica, Arial, sans-serif;\n  --font--weight--h3: 400;\n  --font--size--h3: 3rem;\n  --font--lineHeight--h3: 1.167;\n  --font--letterSpacing--h3: 0;\n  --font--family--h4: Nunito, Roboto, Helvetica, Arial, sans-serif;\n  --font--weight--h4: 400;\n  --font--size--h4: 2.125rem;\n  --font--lineHeight--h4: 1.235;\n  --font--letterSpacing--h4: 0.00735em;\n  --font--family--h5: Nunito, Roboto, Helvetica, Arial, sans-serif;\n  --font--weight--h5: 400;\n  --font--size--h5: 1.5rem;\n  --font--lineHeight--h5: 1.334;\n  --font--letterSpacing--h5: 0;\n  --font--family--h6: Nunito, Roboto, Helvetica, Arial, sans-serif;\n  --font--weight--h6: 500;\n  --font--size--h6: 1.25rem;\n  --font--lineHeight--h6: 1.6;\n  --font--letterSpacing--h6: 0.0075em;\n  --font--family--subtitle1: Nunito, Roboto, Helvetica, Arial, sans-serif;\n  --font--weight--subtitle1: 400;\n  --font--size--subtitle1: 1rem;\n  --font--lineHeight--subtitle1: 1.75;\n  --font--letterSpacing--subtitle1: 0.00938em;\n  --font--family--subtitle2: Nunito, Roboto, Helvetica, Arial, sans-serif;\n  --font--weight--subtitle2: 500;\n  --font--size--subtitle2: 0.875rem;\n  --font--lineHeight--subtitle2: 1.57;\n  --font--letterSpacing--subtitle2: 0.00714em;\n  --font--family--body1: Nunito, Roboto, Helvetica, Arial, sans-serif;\n  --font--weight--body1: 400;\n  --font--size--body1: 1rem;\n  --font--lineHeight--body1: 1.5;\n  --font--letterSpacing--body1: 0.00938em;\n  --font--family--body2: Nunito, Roboto, Helvetica, Arial, sans-serif;\n  --font--weight--body2: 400;\n  --font--size--body2: 0.875rem;\n  --font--lineHeight--body2: 1.43;\n  --font--letterSpacing--body2: 0.01071em;\n  --font--family--button: Nunito, Roboto, Helvetica, Arial, sans-serif;\n  --font--weight--button: 700;\n  --font--size--button: 0.875rem;\n  --font--lineHeight--button: 1.75;\n  --font--letterSpacing--button: 0.02857em;\n  --font--textTransform--button: capitalize;\n  --font--family--caption: Nunito, Roboto, Helvetica, Arial, sans-serif;\n  --font--weight--caption: 400;\n  --font--size--caption: 0.75rem;\n  --font--lineHeight--caption: 1.66;\n  --font--letterSpacing--caption: 0.03333em;\n  --font--family--overline: Nunito, Roboto, Helvetica, Arial, sans-serif;\n  --font--weight--overline: 400;\n  --font--size--overline: 0.75rem;\n  --font--lineHeight--overline: 2.66;\n  --font--letterSpacing--overline: 0.08333em;\n  --font--textTransform--overline: uppercase; }\n\n/* CSS IN JS */\n\n/* CSS VARIABLES */\n:root {\n  --padding-grid: 8px; }\n\n/* CSS IN JS */\n\n/* SCSS VARIABLES */\n/* Colors\n------------------------------------------------------------------------------------------------ */\n/* Breakpoints\n------------------------------------------------------------------------------------------------ */\n/* Padding/Margins\n------------------------------------------------------------------------------------------------ */\n/* Border\n------------------------------------------------------------------------------------------------ */\n/* CSS VARIABLES */\n:root {\n  --color--button: #fff;\n  /* Breakpoints\n  ------------------------------------------------------------------------------------------------ */\n  --breakpoints-xs: 0;\n  --breakpoints-sm: 600px;\n  --breakpoints-md: 960px;\n  --breakpoints-lg: 1280px;\n  --breakpoints-xl: 1920px;\n  /* Padding/Margins\n  ------------------------------------------------------------------------------------------------ */\n  --padding-grid: 8px;\n  --padding-base-vertical: 7px;\n  --padding-base-horizontal: 13px;\n  --padding-large-vertical: 10px;\n  --padding-large-horizontal: 19px;\n  --padding-small-vertical: 5px;\n  --padding-small-horizontal: 8px;\n  --padding-xs-vertical: 1px;\n  --padding-xs-horizontal: 5px;\n  --padding-xl-vertical: 15px;\n  --padding-xl-horizontal: 23px;\n  --padding-button-xl-text: 10px 14px;\n  --padding-button-xl-outlined: 9px 27px;\n  --padding-button-xl-contained: 10px 28px;\n  /* Border\n  ------------------------------------------------------------------------------------------------ */\n  --border-radius-base: 4px;\n  --border-radius-large: 6px;\n  --border-radius-small: 3px; }\n\n/* CSS IN JS */\n\n/*# sourceMappingURL=data:application/json;base64,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 */";
  var lightTheme = {
    "colorCommonBlack": "#000",
    "colorCommonWhite": "#fff",
    "colorPrimaryLight": "#67dd88",
    "colorPrimaryMain": "#3dd467",
    "colorPrimaryDark": "#28b650",
    "colorPrimaryContrastText": "#fff",
    "colorSecondaryLight": "#00ecb0",
    "colorSecondaryMain": "#00b98a",
    "colorSecondaryDark": "#008664",
    "colorSecondaryContrastText": "#fff",
    "colorErrorLight": "#f07b86",
    "colorErrorMain": "#eb4d5c",
    "colorErrorDark": "#e61f32",
    "colorErrorContrastText": "#fff",
    "colorWarningLight": "#ffad33",
    "colorWarningMain": "#ff9800",
    "colorWarningDark": "#cc7a00",
    "colorWarningContrastText": "rgba(0, 0, 0, 0.87)",
    "colorInfoLight": "#51adf6",
    "colorInfoMain": "#2196f3",
    "colorInfoDark": "#0c7cd5",
    "colorInfoContrastText": "#fff",
    "colorSuccessLight": "#6ec071",
    "colorSuccessMain": "#4caf50",
    "colorSuccessDark": "#3d8b40",
    "colorSuccessContrastText": "rgba(0, 0, 0, 0.87)",
    "colorGrey50": "#fafafa",
    "colorGrey100": "#f5f5f5",
    "colorGrey200": "#eee",
    "colorGrey300": "#e0e0e0",
    "colorGrey400": "#bdbdbd",
    "colorGrey500": "#9e9e9e",
    "colorGrey600": "#757575",
    "colorGrey700": "#616161",
    "colorGrey800": "#424242",
    "colorGrey900": "#212121",
    "colorGreyA100": "#d5d5d5",
    "colorGreyA200": "#aaa",
    "colorGreyA400": "#303030",
    "colorGreyA700": "#616161",
    "colorTextPrimary": "rgba(0, 0, 0, 0.87)",
    "colorTextSecondary": "rgba(0, 0, 0, 0.54)",
    "colorTextDisabled": "rgba(0, 0, 0, 0.38)",
    "colorTextHint": "rgba(0, 0, 0, 0.38)",
    "colorDivider": "rgba(0, 0, 0, 0.12)",
    "colorBackgroundPaper": "#fff",
    "colorBackgroundDefault": "#fafafa",
    "colorActionActive": "rgba(0, 0, 0, 0.54)",
    "colorActionHover": "rgba(0, 0, 0, 0.04)",
    "colorActionSelected": "rgba(0, 0, 0, 0.08)",
    "colorActionDisabled": "rgba(0, 0, 0, 0.26)",
    "colorActionDisabledBackground": "rgba(0, 0, 0, 0.12)",
    "colorActionFocus": "rgba(0, 0, 0, 0.12)",
    "fontFamilyH1": "\"Nunito\", \"Roboto\", \"Helvetica\", \"Arial\", \"sans-serif\"",
    "fontWeightH1": "300",
    "fontSizeH1": "6rem",
    "fontLineHeightH1": "1.167",
    "fontLetterSpacingH1": "-0.01562em",
    "fontFamilyH2": "\"Nunito\", \"Roboto\", \"Helvetica\", \"Arial\", \"sans-serif\"",
    "fontWeightH2": "300",
    "fontSizeH2": "3.75rem",
    "fontLineHeightH2": "1.2",
    "fontLetterSpacingH2": "-0.00833em",
    "fontFamilyH3": "\"Nunito\", \"Roboto\", \"Helvetica\", \"Arial\", \"sans-serif\"",
    "fontWeightH3": "400",
    "fontSizeH3": "3rem",
    "fontLineHeightH3": "1.167",
    "fontLetterSpacingH3": "0",
    "fontFamilyH4": "\"Nunito\", \"Roboto\", \"Helvetica\", \"Arial\", \"sans-serif\"",
    "fontWeightH4": "400",
    "fontSizeH4": "2.125rem",
    "fontLineHeightH4": "1.235",
    "fontLetterSpacingH4": "0.00735em",
    "fontFamilyH5": "\"Nunito\", \"Roboto\", \"Helvetica\", \"Arial\", \"sans-serif\"",
    "fontWeightH5": "400",
    "fontSizeH5": "1.5rem",
    "fontLineHeightH5": "1.334",
    "fontLetterSpacingH5": "0",
    "fontFamilyH6": "\"Nunito\", \"Roboto\", \"Helvetica\", \"Arial\", \"sans-serif\"",
    "fontWeightH6": "500",
    "fontSizeH6": "1.25rem",
    "fontLineHeightH6": "1.6",
    "fontLetterSpacingH6": "0.0075em",
    "fontFamilySubtitle1": "\"Nunito\", \"Roboto\", \"Helvetica\", \"Arial\", \"sans-serif\"",
    "fontWeightSubtitle1": "400",
    "fontSizeSubtitle1": "1rem",
    "fontLineHeightSubtitle1": "1.75",
    "fontLetterSpacingSubtitle1": "0.00938em",
    "fontFamilySubtitle2": "\"Nunito\", \"Roboto\", \"Helvetica\", \"Arial\", \"sans-serif\"",
    "fontWeightSubtitle2": "500",
    "fontSizeSubtitle2": "0.875rem",
    "fontLineHeightSubtitle2": "1.57",
    "fontLetterSpacingSubtitle2": "0.00714em",
    "fontFamilyBody1": "\"Nunito\", \"Roboto\", \"Helvetica\", \"Arial\", \"sans-serif\"",
    "fontWeightBody1": "400",
    "fontSizeBody1": "1rem",
    "fontLineHeightBody1": "1.5",
    "fontLetterSpacingBody1": "0.00938em",
    "fontFamilyBody2": "\"Nunito\", \"Roboto\", \"Helvetica\", \"Arial\", \"sans-serif\"",
    "fontWeightBody2": "400",
    "fontSizeBody2": "0.875rem",
    "fontLineHeightBody2": "1.43",
    "fontLetterSpacingBody2": "0.01071em",
    "fontFamilyButton": "\"Nunito\", \"Roboto\", \"Helvetica\", \"Arial\", \"sans-serif\"",
    "fontWeightButton": "700",
    "fontSizeButton": "0.875rem",
    "fontLineHeightButton": "1.75",
    "fontLetterSpacingButton": "0.02857em",
    "fontTextTransformButton": "capitalize",
    "fontFamilyCaption": "\"Nunito\", \"Roboto\", \"Helvetica\", \"Arial\", \"sans-serif\"",
    "fontWeightCaption": "400",
    "fontSizeCaption": "0.75rem",
    "fontLineHeightCaption": "1.66",
    "fontLetterSpacingCaption": "0.03333em",
    "fontFamilyOverline": "\"Nunito\", \"Roboto\", \"Helvetica\", \"Arial\", \"sans-serif\"",
    "fontWeightOverline": "400",
    "fontSizeOverline": "0.75rem",
    "fontLineHeightOverline": "2.66",
    "fontLetterSpacingOverline": "0.08333em",
    "fontTextTransformOverline": "uppercase",
    "paddingGrid": "8px",
    "breakpointsXs": "0",
    "breakpointsSm": "600px",
    "breakpointsMd": "960px",
    "breakpointsLg": "1280px",
    "breakpointsXl": "1920px",
    "paddingBaseVertical": "7px",
    "paddingBaseHorizontal": "13px",
    "paddingLargeVertical": "10px",
    "paddingLargeHorizontal": "19px",
    "paddingSmallVertical": "5px",
    "paddingSmallHorizontal": "8px",
    "paddingXsVertical": "1px",
    "paddingXsHorizontal": "5px",
    "paddingXlVertical": "15px",
    "paddingXlHorizontal": "23px",
    "paddingButtonXlText": "10px 14px",
    "paddingButtonXlOutlined": "9px 27px",
    "paddingButtonXlContained": "10px 28px"
  };
  styleInject(css_248z);

  var LightThemeContainer = function LightThemeContainer(props) {
    var children = props.children;
    return React__default["default"].createElement("div", {
      className: classNames('dsThemeContainer', 'dsLightThemeContainer'),
      "data-component-library": "generic",
      "data-component-name": "LightThemeContainer"
    }, children({
      themeVariables: lightTheme
    }));
  };

  function mapToPalette(cssVariables, isDarkMode) {
    return {
      common: {
        black: cssVariables.colorCommonBlack,
        white: cssVariables.colorCommonWhite
      },
      mode: isDarkMode ? 'dark' : 'light',
      primary: {
        light: cssVariables.colorPrimaryLight,
        main: cssVariables.colorPrimaryMain,
        dark: cssVariables.colorPrimaryDark,
        contrastText: cssVariables.colorPrimaryContrastText
      },
      secondary: {
        light: cssVariables.colorSecondaryLight,
        main: cssVariables.colorSecondaryMain,
        dark: cssVariables.colorSecondaryDark,
        contrastText: cssVariables.colorSecondaryContrastText
      },
      error: {
        light: cssVariables.colorErrorLight,
        main: cssVariables.colorErrorMain,
        dark: cssVariables.colorErrorDark,
        contrastText: cssVariables.colorErrorContrastText
      },
      warning: {
        light: cssVariables.colorWarningLight,
        main: cssVariables.colorWarningMain,
        dark: cssVariables.colorWarningDark,
        contrastText: cssVariables.colorWarningContrastText
      },
      info: {
        light: cssVariables.colorInfoLight,
        main: cssVariables.colorInfoMain,
        dark: cssVariables.colorInfoDark,
        contrastText: cssVariables.colorInfoContrastText
      },
      success: {
        light: cssVariables.colorSuccessLight,
        main: cssVariables.colorSuccessMain,
        dark: cssVariables.colorSuccessDark,
        contrastText: cssVariables.colorSuccessContrastText
      },
      grey: {
        50: cssVariables.colorGrey50,
        100: cssVariables.colorGrey100,
        200: cssVariables.colorGrey200,
        300: cssVariables.colorGrey300,
        400: cssVariables.colorGrey400,
        500: cssVariables.colorGrey500,
        600: cssVariables.colorGrey600,
        700: cssVariables.colorGrey700,
        800: cssVariables.colorGrey800,
        900: cssVariables.colorGrey900,
        A100: cssVariables.colorGreyA100,
        A200: cssVariables.colorGreyA200,
        A400: cssVariables.colorGreyA400,
        A700: cssVariables.colorGreyA700
      },
      text: {
        primary: cssVariables.colorTextPrimary,
        secondary: cssVariables.colorTextSecondary,
        disabled: cssVariables.colorTextDisabled
      },
      divider: cssVariables.colorDivider,
      background: {
        paper: cssVariables.colorBackgroundPaper,
        default: cssVariables.colorBackgroundDefault
      },
      action: {
        active: cssVariables.colorActionActive,
        hover: cssVariables.colorActionHover,
        selected: cssVariables.colorActionSelected,
        disabled: cssVariables.colorActionDisabled,
        disabledBackground: cssVariables.colorActionDisabledBackground,
        focus: cssVariables.colorActionFocus
      }
    };
  }

  function mapToTypography(cssVariables) {
    return {
      h1: {
        fontFamily: cssVariables.fontFamilyH1,
        fontWeight: cssVariables.fontWeightH1,
        fontSize: cssVariables.fontSizeH1,
        lineHeight: cssVariables.fontLineHeightH1,
        letterSpacing: cssVariables.fontLetterSpacingH1
      },
      h2: {
        fontFamily: cssVariables.fontFamilyH2,
        fontWeight: cssVariables.fontWeightH2,
        fontSize: cssVariables.fontSizeH2,
        lineHeight: cssVariables.fontLineHeightH2,
        letterSpacing: cssVariables.fontLetterSpacingH2
      },
      h3: {
        fontFamily: cssVariables.fontFamilyH3,
        fontWeight: cssVariables.fontWeightH3,
        fontSize: cssVariables.fontSizeH3,
        lineHeight: cssVariables.fontLineHeightH3,
        letterSpacing: cssVariables.fontLetterSpacingH3
      },
      h4: {
        fontFamily: cssVariables.fontFamilyH4,
        fontWeight: cssVariables.fontWeightH4,
        fontSize: cssVariables.fontSizeH4,
        lineHeight: cssVariables.fontLineHeightH4,
        letterSpacing: cssVariables.fontLetterSpacingH4
      },
      h5: {
        fontFamily: cssVariables.fontFamilyH5,
        fontWeight: cssVariables.fontWeightH5,
        fontSize: cssVariables.fontSizeH5,
        lineHeight: cssVariables.fontLineHeightH5,
        letterSpacing: cssVariables.fontLetterSpacingH5
      },
      h6: {
        fontFamily: cssVariables.fontFamilyH6,
        fontWeight: cssVariables.fontWeightH6,
        fontSize: cssVariables.fontSizeH6,
        lineHeight: cssVariables.fontLineHeightH6,
        letterSpacing: cssVariables.fontLetterSpacingH6
      },
      subtitle1: {
        fontFamily: cssVariables.fontFamilySubtitle1,
        fontWeight: cssVariables.fontWeightSubtitle1,
        fontSize: cssVariables.fontSizeSubtitle1,
        lineHeight: cssVariables.fontLineHeightSubtitle1,
        letterSpacing: cssVariables.fontLetterSpacingSubtitle1
      },
      subtitle2: {
        fontFamily: cssVariables.fontFamilySubtitle2,
        fontWeight: cssVariables.fontWeightSubtitle2,
        fontSize: cssVariables.fontSizeSubtitle2,
        lineHeight: cssVariables.fontLineHeightSubtitle2,
        letterSpacing: cssVariables.fontLetterSpacingSubtitle2
      },
      body1: {
        fontFamily: cssVariables.fontFamilyBody1,
        fontWeight: cssVariables.fontWeightBody1,
        fontSize: cssVariables.fontSizeBody1,
        lineHeight: cssVariables.fontLineHeightBody1,
        letterSpacing: cssVariables.fontLetterSpacingBody1
      },
      body2: {
        fontFamily: cssVariables.fontFamilyBody2,
        fontWeight: cssVariables.fontWeightBody2,
        fontSize: cssVariables.fontSizeBody2,
        lineHeight: cssVariables.fontLineHeightBody2,
        letterSpacing: cssVariables.fontLetterSpacingBody2
      },
      button: {
        fontFamily: cssVariables.fontFamilyButton,
        fontWeight: cssVariables.fontWeightButton,
        fontSize: cssVariables.fontSizeButton,
        lineHeight: cssVariables.fontLineHeightButton,
        letterSpacing: cssVariables.fontLetterSpacingButton,
        textTransform: cssVariables.fontTextTransformButton
      },
      caption: {
        fontFamily: cssVariables.fontFamilyCaption,
        fontWeight: cssVariables.fontWeightCaption,
        fontSize: cssVariables.fontSizeCaption,
        lineHeight: cssVariables.fontLineHeightCaption,
        letterSpacing: cssVariables.fontLetterSpacingCaption
      },
      overline: {
        fontFamily: cssVariables.fontFamilyOverline,
        fontWeight: cssVariables.fontWeightOverline,
        fontSize: cssVariables.fontSizeOverline,
        lineHeight: cssVariables.fontLineHeightOverline,
        letterSpacing: cssVariables.fontLetterSpacingOverline,
        textTransform: cssVariables.fontTextTransformOverline
      }
    };
  }

  function mapToSpacing(spacingVariable) {
    return Number(spacingVariable.replace('px', ''));
  }

  var ThemeWrapper = function ThemeWrapper(props) {
    var children = props.children,
        deprecatedProps = props.deprecatedProps,
        isDarkMode = props.isDarkMode,
        cssVariableOverrides = props.cssVariableOverrides; // Separate into components to only import the relevant SCSS file

    var ThemeTypeComponent = isDarkMode ? DarkThemeContainer : LightThemeContainer;
    return React__default["default"].createElement(ThemeTypeComponent, null, function (_a) {
      var themeVariables = _a.themeVariables;

      var cssVariables = _assign2(_assign2({}, themeVariables), cssVariableOverrides);

      var palette = mapToPalette(cssVariables, isDarkMode);
      var typography = mapToTypography(cssVariables);

      var typographyHtmlElements = _$1.pick(typography, ['h1', 'h2', 'h3', 'h4', 'h5', 'h6']);

      var spacing = cssVariables.paddingGrid ? mapToSpacing(cssVariables.paddingGrid) : null;
      var customComponentOverrides = (deprecatedProps === null || deprecatedProps === void 0 ? void 0 : deprecatedProps.getMuiComponentOverrides) ? deprecatedProps === null || deprecatedProps === void 0 ? void 0 : deprecatedProps.getMuiComponentOverrides({
        palette: palette,
        typography: typography,
        spacing: spacing
      }) : {};
      var muiTheme = createTheme(_assign2(_assign2(_assign2({
        palette: palette,
        typography: typography
      }, spacing && {
        spacing: spacing
      }), (deprecatedProps === null || deprecatedProps === void 0 ? void 0 : deprecatedProps.breakpoints) && {
        breakpoints: deprecatedProps === null || deprecatedProps === void 0 ? void 0 : deprecatedProps.breakpoints
      }), {
        components: _assign2(_assign2({}, customComponentOverrides), {
          MuiCssBaseline: {
            styleOverrides: _assign2({
              body: typography.body2
            }, typographyHtmlElements)
          }
        })
      }));
      return React__default["default"].createElement(ThemeProvider, {
        theme: muiTheme
      }, React__default["default"].createElement(StylesProvider, null, React__default["default"].createElement(CSSBaseline, null), children));
    });
  };

  ThemeWrapper.defaultProps = {
    isDarkMode: false,
    cssVariableOverrides: {}
  };
  exports.Accordion = Accordion;
  exports.AccordionActions = AccordionActions;
  exports.AccordionDetails = AccordionDetails;
  exports.AccordionSummary = AccordionSummary;
  exports.Alert = Alert;
  exports.AppBar = AppBar;
  exports.Autocomplete = Autocomplete;
  exports.Button = Button;
  exports.ButtonGroup = ButtonGroup;
  exports.Card = Card;
  exports.CardActionArea = CardActionArea;
  exports.CardActions = CardActions;
  exports.CardContent = CardContent;
  exports.CardHeader = CardHeader;
  exports.CardMedia = CardMedia;
  exports.Carousel = Carousel;
  exports.Checkbox = Checkbox;
  exports.Chip = Chip;
  exports.CircularProgress = Progress;
  exports.ClickAwayListener = ClickAwayListener;
  exports.Container = Container;
  exports.Controller = Controller;
  exports.CreateTheme = createTheme;
  exports.CssBaseline = CSSBaseline;
  exports.DataGrid = DataGrid;
  exports.DatePicker = DatePicker;
  exports.Dialog = Dialog;
  exports.DialogActions = DialogActions;
  exports.DialogContent = DialogContent;
  exports.DialogContentText = DialogContentText;
  exports.DialogTitle = DialogTitle;
  exports.Drawer = Drawer;
  exports.ElevationScroll = ElevationScroll;
  exports.FormControl = FormControl;
  exports.FormControlLabel = FormControlLabel;
  exports.FormGroup = FormGroup;
  exports.FormHelperText = FormHelperText;
  exports.FormLabel = FormLabel;
  exports.Grid = Grid;
  exports.Grow = Grow$1;
  exports.Hidden = Hidden;
  exports.IconButton = IconButton;
  exports.InputAdornment = InputAdornment;
  exports.InputLabel = InputLabel;
  exports.Layouts = Layouts;
  exports.Link = Link;
  exports.LocalizationProvider = LocalizationProvider;
  exports.Menu = Menu;
  exports.MenuIcon = MenuIcon;
  exports.MenuItem = MenuItem;
  exports.MenuList = MenuList;
  exports.NativeSelect = NativeSelect;
  exports.Paper = Paper;
  exports.Popover = Popover;
  exports.Popper = Popper;
  exports.Radio = Radio;
  exports.RadioGroup = RadioGroup;
  exports.Section = Section;
  exports.Select = Select;
  exports.Slide = Slide;
  exports.Snackbar = SnackBar;
  exports.Stack = Stack;
  exports.Step = Step;
  exports.StepButton = StepButton;
  exports.StepConnector = StepConnector;
  exports.StepContent = StepContent;
  exports.StepIcon = StepIcon;
  exports.StepLabel = StepLabel;
  exports.Stepper = Stepper;
  exports.StylesProvider = StylesProvider;
  exports.SvgIcon = SvgIcon;
  exports.Table = Table;
  exports.TableBody = TableBody;
  exports.TableCell = TableCell;
  exports.TableContainer = TableContainer;
  exports.TableHead = TableHead;
  exports.TableRow = TableRow;
  exports.TextField = TextField$1;
  exports.ThemeProvider = ThemeProvider;
  exports.ThemeWrapper = ThemeWrapper;
  exports.Toolbar = Toolbar;
  exports.Typography = Typography;
  exports.hookformResolver = hookformResolver;
  exports.schemaValidator = schemaValidator;
  exports.useForm = useForm;
  exports.useScrollTrigger = useScrollTrigger;
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
});